(function() {
    'use strict';

    angular
        .module('triangular.layouts', [

        ]);
})();
'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @module triAngular
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .controller('TriangularStateController', TriangularStateController);

    /* @ngInject */
    function TriangularStateController($scope, $state, $log, $rootScope, $firebaseArray, $timeout, pageDimensionsService, $templateRequest, $compile, $element, $window, triLayout, triLoaderService) {
        var loadingQueue = [];
        var vm = this;


        vm.activateHover = activateHover;
        vm.removeHover  = removeHover;
        vm.showLoader = triLoaderService.isActive();

        // we need to use the scope here because otherwise the expression in md-is-locked-open doesnt work
        $scope.layout = triLayout.layout; //eslint-disable-line

        ////////////////
        var timer = undefined;
        function activateHover() {
            if(triLayout.layout.sideMenuSize === 'icon' && !timer) {
                timer = $timeout(function(){
                    $element.find('.triangular-sidenav-left').addClass('hover');
                    $timeout(function(){
                        $window.dispatchEvent(new Event('resize'));
                    }, 300);
                }, 300)

            }
            // if(triLayout.layout.sideMenuSize === 'icon') {
            //     $element.find('.triangular-sidenav-left').addClass('hover');
            //     // $timeout(function(){
            //     //     $window.dispatchEvent(new Event('resize'));
            //     // },300);
            // }
           // timer = $timeout(function(){

           //  }, 500);

        }

        function injectFooterUpdateContent(viewName) {
            var contentView = $element.find('.triangular-content');
            if (viewName === '@triangular' && angular.isDefined(triLayout.layout.footerTemplateUrl)) {
                // add footer to the content view
                $templateRequest(triLayout.layout.footerTemplateUrl)
                .then(function(template) {
                    // compile template with current scope and add to the content
                    var linkFn = $compile(template);
                    var content = linkFn($scope);
                    $timeout(function() {
                        contentView.append(content);
                    });
                });
            }
        }

        function loaderEvent(event, isActive) {
            // $log.info('loaderEvent!');
            vm.showLoader = isActive;
        }

        function stateChangeStart() {
            triLoaderService.setLoaderActive(true);
        }

        function removeHover () {
            if(triLayout.layout.sideMenuSize === 'icon') {
                // $timeout.cancel(timer);
                $element.find('.triangular-sidenav-left').removeClass('hover');
                $timeout.cancel(timer);
                timer = undefined;
                $timeout(function(){
                    $window.dispatchEvent(new Event('resize'));
                }, 300);
            }

        }

        function viewContentLoading($event, viewName) {
            // a view is loading so add it to the queue
            // so we know when to turn off the loader
            loadingQueue.push(viewName);
            triLoaderService.setLoaderActive(true);
        }

        function viewContentLoaded($event, viewName) {

            if(angular.isDefined(triLayout.layout.footer) && triLayout.layout.footer === true) {
                // inject footer into content
                injectFooterUpdateContent(viewName);
            }

            // Customized for Adminja
            var originalQueueLength = loadingQueue.length;
            // $log.info(originalQueueLength);
            // view content has loaded so remove it from queue
            var index = loadingQueue.indexOf(viewName);
            if(-1 !== index) {
                loadingQueue.splice(index, 1);
            }
            // is the loadingQueue empty?
            if(loadingQueue.length === 0) {
                if(!$state.includes('triangular.workspaces.information') && !$state.includes('triangular.workspaces.overview') && !$state.includes('triangular.tasks-page') && !$state.includes('triangular.today'))
                triLoaderService.setLoaderActive(false);
            }// if loadingQueue == 0
        }



        // watches

        // register listeners for loader
        $scope.$on('loader', loaderEvent);

        // watch for ui router state change
        $scope.$on('$stateChangeStart', stateChangeStart);

        // watch for view content loading
        $scope.$on('$viewContentLoading', viewContentLoading);

        // watch for view content loaded
        $scope.$on('$viewContentLoaded', viewContentLoaded);

        // Embedly
        // The following ensures that embedly cards rendering AFTER our page load, trigger a columns resize after they are loaded and rendered.
        if(embedly){
            embedly('on', 'card.rendered', function(iframe){
            $timeout(function(){
                pageDimensionsService.resizeColumns();
            }, 100);
            });
        }


    }
})();

'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @module triAngular
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .controller('DefaultLayoutController', DefaultLayoutController);

    /* @ngInject */
    function DefaultLayoutController($scope, $element, $timeout, $window, triLayout) {
        // we need to use the scope here because otherwise the expression in md-is-locked-open doesnt work
        $scope.layout = triLayout.layout; //eslint-disable-line
        var vm = this;

        vm.activateHover = activateHover;
        vm.removeHover  = removeHover;

        ////////////////

        function activateHover() {
            timer = $timeout(function(){
                if(triLayout.layout.sideMenuSize === 'icon') {
                    $element.find('.admin-sidebar-left').addClass('hover');
                    // $timeout(function(){
                    //     $window.dispatchEvent(new Event('resize'));
                    // },300);
                }
            }, 2000);

        }

        function removeHover () {
            $timeout.cancel(timer);
            if(triLayout.layout.sideMenuSize === 'icon') {
                $element.find('.admin-sidebar-left').removeClass('hover');
                // $timeout(function(){
                //     $window.dispatchEvent(new Event('resize'));
                // },300);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.layouts')
        .directive('triDefaultContent', triDefaultContent);

    /* @ngInject */
    function triDefaultContent ($rootScope, $compile, $templateRequest, triLayout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            link: link,
            replace: true,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element) {
            // scroll page to the top when content is loaded (stops pages keeping scroll position even when they have changed url)
            $scope.$on('$stateChangeStart', scrollToTop);

            // when content view has loaded add footer if needed and send mdContentLoaded event
            // $scope.$on('$viewContentLoaded', injectFooterUpdateContent);

            ////////////////////////

            function scrollToTop() {
                $element.scrollTop(0);
            }

            function injectFooterUpdateContent() {
                // var contentView = $element.find('#admin-panel-content-view');
                // var footerElem = contentView.find('#footer');
                // if (footerElem.length === 0) {
                //     // add footer to the content view
                //     $templateRequest(triLayout.layout.footerTemplateUrl)
                //     .then(function(template) {
                //         // compile template with current scope and add to the content
                //         var linkFn = $compile(template);
                //         var content = linkFn($scope);
                //         contentView.append(content);
                //     });

                // }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components', [
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWizard', TriWizard);

    /* @ngInject */
    function TriWizard() {
        // Usage: <div tri-wizard> (put some forms in here) </div>
        //
        // Creates: Nothing
        //
        var directive = {
            bindToController: true,
            controller: WizardController,
            controllerAs: 'triWizard',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function WizardController($scope, $timeout, $log, $mdToast) {
        var vm = this;

        var forms = [];
        var totalErrors = 0;
        var fixedErrors = 0;

        vm.currentStep = 0;
        vm.getForm = getForm;
        vm.isFormValid = isFormValid;
        vm.nextStep = nextStep;
        vm.nextStepDisabled = nextStepDisabled;
        vm.prevStep = prevStep;
        vm.prevStepDisabled = prevStepDisabled;
        vm.progress = 0;
        vm.registerForm = registerForm;
        vm.updateProgress = updateProgress;
        vm.registerUser = registerUser;
        vm.saveUserProfile = saveUserProfile;
        vm.registrationError = undefined;
        vm.showError = false;

        //////////////// Customized for Adminja ////////////////

        function getForm(index) {
            return forms[index];
        }

        function nextStep() {
            // $log.info('nextStep');
            vm.currentStep = vm.currentStep + 1;
        }

        function registerUser(user){
            // $log.info('register clicked');

            // do registration


            firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(_userData, error) {
                // console.log("User " + _userData.uid + " created successfully", _userData);

                // get set to store our own userData
                var usersRef = firebase.database().ref('users');

                user.uid = _userData.uid;

                var newUserRecord = {
                    email: user.email,
                    uid: _userData.uid
                }

                newUserRecord.profile = {};
                newUserRecord.profile.avatar = "";
                newUserRecord.profile.firstName = "";
                newUserRecord.profile.lastName = "";

                // save our basic users record
                usersRef.child(_userData.uid).set(newUserRecord);


            }).then(function(authData) {
                $mdToast.showSimple('New Account Created.');

                // proceed to next pane of wizard
                nextStep();

                // return firebase.auth().signInWithEmailAndPassword(vm.user.email, vm.user.password);
                // console.log("Logged in as: ", authData.uid);
                // $state.go('triangular.account-page.profile');

            }).catch(function(error) {
                // console.log("Error: ", error);
                // vm.errorMessage = error.message;
                // vm.showError = true;
                $mdToast.show(
                      $mdToast.simple()
                        .textContent(error.message)
                        .position('top center')
                        .hideDelay(3000)
                    );
                user.email = "";
                user.password = "";
                user.passwordConfirm = "";
            });


    }

        function saveUserProfile(user){
            // $log.info('saveUserProfile');
            var newUser = angular.copy(user);

            if (newUser.profile.dob){
                newUser.profile.dob = newUser.profile.dob.toISOString();
            }

            var usersRef = firebase.database().ref('users');

            // save our user profile
            usersRef.child(newUser.uid + '/profile').set(newUser.profile);
            $mdToast.showSimple('User Profile Updated');

            // proceed to next pane of wizard
            nextStep();


        }

        function nextStepDisabled() {
            // get current active form
            var form = $scope.triWizard.getForm(vm.currentStep);
            var formInvalid = true;
            if(angular.isDefined(form) && angular.isDefined(form.$invalid)) {
                formInvalid = form.$invalid;
            }
            return formInvalid;
        }

        function isFormValid(step) {
            if(angular.isDefined(forms[step])) {
                return forms[step].$valid;
            }
        }

        function prevStep() {
            vm.currentStep = vm.currentStep - 1;
        }

        function prevStepDisabled() {
            return vm.currentStep === 0;
        }

        function registerForm(form) {
            forms.push(form);
        }

        function updateProgress() {
            var errors = calculateErrors();
            fixedErrors = totalErrors - errors;

            // calculate percentage process for completing the wizard
            vm.progress = Math.floor((fixedErrors / totalErrors) * 100);
        }

        function calculateErrors() {
            var errorCount = 0;
            for (var form = forms.length - 1; form >= 0; form--) {
                if(angular.isDefined(forms[form].$error)) {
                    for(var error in forms[form].$error) {
                        errorCount += forms[form].$error[error].length;
                    }
                }
            }
            return errorCount;
        }


        // init

        // wait until this tri wizard is ready (all forms registered)
        // then calculate the total errors
        $timeout(function() {
            totalErrors = calculateErrors();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWizardForm', WizardFormProgress);

    /* @ngInject */
    function WizardFormProgress() {
        // Usage:
        //  <div tri-wizard>
        //      <form tri-wizard-form>
        //      </form>
        //  </div>
        //
        var directive = {
            require: ['form', '^triWizard'],
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, require) {
            var ngFormCtrl = require[0];
            var triWizardCtrl = require[1];

            // register this form with the parent triWizard directive
            triWizardCtrl.registerForm(ngFormCtrl);

            // watch for form input changes and update the wizard progress
            element.on('input', function() {
                triWizardCtrl.updateProgress();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triWidget', widget);

    /* @ngInject */
    function widget ($mdTheming) {
        // Usage:
        //
        // ```html
        // <widget title="'Nice Title'" subtitle="'Subtitle'" avatar="http://myavatar.jpg" title-position="top|bottom|left|right" content-padding overlay-title>content here</widget>
        // ```

        // Creates:
        //
        // Widget for use in dashboards
        var directive = {
            restrict: 'E',
            templateUrl: 'app/triangular/components/widget/widget.tmpl.html',
            transclude: true,
            replace: true,
            scope: {
                title: '@',
                subtitle: '@',
                avatar: '@'
            },
            bindToController: true,
            controller: Controller,
            controllerAs: 'vm',
            link: link
        };
        return directive;

        function link($scope, $element, attrs) {
            // set the value of the widget layout attribute
            $scope.vm.widgetLayout = attrs.titlePosition === 'left' || attrs.titlePosition === 'right' ? 'row' : 'column';
            // set the layout attribute for the widget content
            $scope.vm.contentLayout = angular.isUndefined(attrs.contentLayout) ? 'column' : attrs.contentLayout;
            // set if the layout-padding attribute will be added
            $scope.vm.contentPadding = angular.isDefined(attrs.contentPadding);
            // set the content align
            $scope.vm.contentLayoutAlign = angular.isUndefined(attrs.contentLayoutAlign) ? '' : attrs.contentLayoutAlign;
            // set the order of the title and content based on title position
            $scope.vm.titleOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 2 : 1;
            $scope.vm.contentOrder = attrs.titlePosition === 'right' || attrs.titlePosition === 'bottom' ? 1 : 2;
            // set if we overlay the title on top of the widget content
            $scope.vm.overlayTitle = angular.isUndefined(attrs.overlayTitle) ? undefined : true;

            $mdTheming($element);

            if(angular.isDefined(attrs.class)) {
                $element.addClass(attrs.class);
            }

            if(angular.isDefined(attrs.backgroundImage)) {
                $element.css('background-image', 'url(' + attrs.backgroundImage + ')');
            }

            $scope.menuClick = function($event) {
                if(angular.isUndefined($scope.menu.menuClick)) {
                    $scope.menu.menuClick($event);
                }
            };

            // remove title attribute to stop popup on hover
            $element.attr('title', '');
        }
    }

    /* @ngInject */
    function Controller () {
        var vm = this;
        vm.menu = null;
        vm.loading = false;

        this.setMenu = function(menu) {
            vm.menu = menu;
        };

        this.setLoading = function(loading) {
            vm.loading = loading;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triTable', triTable);

    /* @ngInject */
    function triTable($filter) {
        var directive = {
            restrict: 'E',
            scope: {
                columns: '=',
                contents: '=',
                filters: '='
            },
            link: link,
            templateUrl: 'app/triangular/components/table/table-directive.tmpl.html'
        };
        return directive;

        function link($scope, $element, attrs) {
            var sortableColumns = [];
            var activeSortColumn = null;
            var activeSortOrder = false;

            // init page size if not set to default
            $scope.pageSize = angular.isUndefined(attrs.pageSize) ? 0 : attrs.pageSize;

            // init page if not set to default
            $scope.page = angular.isUndefined(attrs.page) ? 0 : attrs.page;

            // make an array of all sortable columns
            angular.forEach($scope.columns, function(column) {
                if(column.sortable) {
                    sortableColumns.push(column.field);
                }
            });

            $scope.refresh = function(resetPage) {
                if(resetPage === true) {
                    $scope.page = 0;
                }
                $scope.contents = $filter('orderBy')($scope.contents, activeSortColumn, activeSortOrder);
            };

            // if we have sortable columns sort by first by default
            if(sortableColumns.length > 0) {
                // sort first column by default
                activeSortOrder = false;
                activeSortColumn = sortableColumns[0];
                $scope.refresh();
            }

            $scope.sortClick = function(field) {
                if(sortableColumns.indexOf(field) !== -1) {
                    if(field === activeSortColumn) {
                        activeSortOrder = !activeSortOrder;
                    }
                    activeSortColumn = field;
                    $scope.refresh();
                }
            };

            $scope.showSortOrder = function(field, orderDown) {
                return field === activeSortColumn && activeSortOrder === orderDown;
            };

            $scope.headerClass = function(field) {
                var classes = [];
                if(sortableColumns.indexOf(field) !== -1) {
                    classes.push('sortable');
                }
                if(field === activeSortColumn) {
                    classes.push('sorted');
                }
                return classes;
            };

            $scope.cellContents = function(column, content) {
                if(angular.isDefined(column.filter)) {
                    return $filter(column.filter)(content[column.field]);
                }
                else {
                    return content[column.field];
                }
            };

            $scope.totalItems = function() {
                return $scope.contents.length;
            };

            $scope.numberOfPages = function() {
                return Math.ceil($scope.contents.length / $scope.pageSize);
            };

            $scope.pageStart = function() {
                return ($scope.page * $scope.pageSize) + 1;
            };

            $scope.pageEnd = function() {
                var end = (($scope.page + 1) * $scope.pageSize);
                if(end > $scope.contents.length) {
                    end = $scope.contents.length;
                }
                return end;
            };

            $scope.goToPage = function (page) {
                $scope.page = page;
            };
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .filter('startFrom', startFrom);

    function startFrom() {
        return filterFilter;

        ////////////////

        function filterFilter(input, start) {
            start = +start;
            return input.slice(start);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .filter('tableImage', tableImage);

    function tableImage($sce) {
        return filterFilter;

        ////////////////

        function filterFilter(value) {
            return $sce.trustAsHtml('<div style=\"background-image: url(\'' + value + '\')\"/>');
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('DefaultToolbarController', DefaultToolbarController);

    /* @ngInject */
    function DefaultToolbarController($scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout) {
        var vm = this;
        vm.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        vm.emailNew = false;
        vm.languages = triSettings.languages;
        vm.openSideNav = openSideNav;
        vm.hideMenuButton = hideMenuButton;
        vm.switchLanguage = switchLanguage;
        vm.toggleNotificationsTab = toggleNotificationsTab;
        vm.isFullScreen = false;
        vm.fullScreenIcon = 'zmdi zmdi-fullscreen';
        vm.toggleFullScreen = toggleFullScreen;

        // initToolbar();

        ////////////////

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            return triLayout.layout.sideMenuSize !== 'hidden' && $mdMedia('gt-sm');
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            vm.openSideNav('notifications');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }

        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('NotificationsPanelController', NotificationsPanelController);

    /* @ngInject */
    function NotificationsPanelController($scope, $http, $mdSidenav, $state, API_CONFIG) {
        var vm = this;
        // sets the current active tab
        vm.close = close;
        vm.currentTab = 0;
        vm.notificationGroups = [{
            name: 'Twitter',
            notifications: [{
                title: 'Mention from oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            },{
                title: 'Followed by Oxygenna',
                icon: 'fa fa-twitter',
                iconColor: '#55acee',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Server',
            notifications: [{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            },{
                title: 'Slow Response Time',
                icon: 'zmdi zmdi-alert-triangle',
                iconColor: 'rgb(255, 152, 0)',
                date: moment().startOf('hour')
            },{
                title: 'Server Down',
                icon: 'zmdi zmdi-alert-circle',
                iconColor: 'rgb(244, 67, 54)',
                date: moment().startOf('hour')
            }]
        },{
            name: 'Sales',
            notifications: [{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Lambda WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Lambda WordPress $60',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            },{
                title: 'Triangular Admin $21',
                icon: 'zmdi zmdi-shopping-cart',
                iconColor: 'rgb(76, 175, 80)',
                date: moment().startOf('hour')
            }]
        }];
        vm.openMail = openMail;
        vm.settingsGroups = [{
            name: 'Account Settings',
            settings: [{
                title: 'Show my location',
                icon: 'zmdi zmdi-pin',
                enabled: true
            },{
                title: 'Show my avatar',
                icon: 'zmdi zmdi-face',
                enabled: false
            },{
                title: 'Send me notifications',
                icon: 'zmdi zmdi-notifications-active',
                enabled: true
            }]
        },{
            name: 'Chat Settings',
            settings: [{
                title: 'Show my username',
                icon: 'zmdi zmdi-account',
                enabled: true
            },{
                title: 'Make my profile public',
                icon: 'zmdi zmdi-account-box',
                enabled: false
            },{
                title: 'Allow cloud backups',
                icon: 'zmdi zmdi-cloud-upload',
                enabled: true
            }]
        }];

        vm.statisticsGroups = [{
            name: 'User Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        },{
            name: 'Server Statistics',
            stats: [{
                title: 'Storage Space (120/160 Gb)',
                mdClass: 'md-primary',
                value: 60
            },{
                title: 'Bandwidth Usage (10/100 Gb)',
                mdClass: 'md-accent',
                value: 10
            },{
                title: 'Memory Usage (1/8 Gb)',
                mdClass: 'md-warn',
                value: 100
            }]
        }];

        ////////////////

        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('triSwitchNotificationTab', function($event, tab) {
            vm.currentTab = tab;
        });

        // fetch some dummy emails from the API
        $http({
            method: 'GET',
            url: API_CONFIG.url + 'email/inbox'
        }).success(function(data) {
            vm.emails = data.slice(1,20);
        });

        function openMail() {
            $state.go('triangular-no-scroll.email.inbox');
            vm.close();
        }

        function close() {
            $mdSidenav('notifications').close();
        }
    }
})();

(function () {
    'use strict';

    angular.module('triangular.components')
            .controller('menuSearchController', menuSearchController);

        /* @ngInject */
	  function menuSearchController($scope, $rootScope) {

	  	$scope.search = function(query){
	  		$rootScope.menuQuery = query.toLowerCase();
	  		$rootScope.$emit('runMenuQuery');
	  	}

	  	$scope.resetSearch = function(){
	  		$scope.query = ""
	  		$rootScope.$emit('resetMenuQuery');
	  	}

	  }// menuSearchController


})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .provider('triMenu', menuProvider);


    /* @ngInject */
    function menuProvider() {
        // Provider
        var menuArray = [];

        this.addMenu = addMenu;
        this.removeMenu = removeMenu;
        this.removeAllMenu = removeAllMenu;

        function addMenu(item) {
            menuArray.push(item);
        }

        function getMenu(id) {
            return findMenu(menuArray, id);
        }

        function removeMenu(state, params) {
            findAndDestroyMenu(menuArray, state, params);
        }

        function removeAllMenu() {
            for (var i = menuArray.length - 1; i >= 0 ; i--) {
                menuArray.splice(i, 1);
            }
        }

        function findMenu(menu, id) {
            var found;
            if (menu instanceof Array) {
                for (var i = 0; i < menu.length; i++) {
                    if(menu[i].id === id) {
                        found = menu[i];
                        break;
                    }
                    else if(angular.isDefined(menu[i].children)) {
                        found = findMenu(menu[i].children, id);
                        if(angular.isDefined(found)) {
                            break;
                        }
                    }
                }
            }
            return found;
        }

        function findAndDestroyMenu(menu, state, params, isChildren) {
            if (menu instanceof Array) {
                for (var i = menu.length - 1; i >= 0 ; i--) {
                    if(menu[i].state === state && angular.equals(menu[i].params, params)) {
                        menu.splice(i, 1);
                        if (!isNaN(isChildren) && !menuArray[isChildren].children.length) {
                            menuArray.splice(isChildren, 1);
                        }
                        break;
                    }
                    else if(angular.isDefined(menu[i].children)) {
                        findAndDestroyMenu(menu[i].children, state, params, i);
                    }
                }
            }
        }

        // Service
        this.$get = function() {
            return {
                menu: menuArray,
                addMenu: addMenu,
                getMenu: getMenu,
                removeMenu: removeMenu,
                removeAllMenu: removeAllMenu
            };
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triMenu', triMenuDirective);

    /* @ngInject */
    function triMenuDirective($location, $mdTheming, triTheming) {
        var directive = {
            restrict: 'E',
            template: '<md-content><tri-menu-item permission permission-only="item.permission" ng-repeat="item in triMenuController.menu | orderBy:\'priority\'" item="::item"></tri-menu-item></md-content>',
            scope: {},
            controller: triMenuController,
            controllerAs: 'triMenuController',
            link: link
        };
        return directive;

        function link($scope, $element) {
            $mdTheming($element);
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line

            var menuColor = triTheming.getThemeHue($mdTheme.$mdTheme, 'primary', 'default');
            var menuColorRGBA = triTheming.rgba(menuColor.value);
            $element.css({ 'background-color': menuColorRGBA });
            $element.children('md-content').css({ 'background-color': menuColorRGBA });
        }
    }

    /* @ngInject */
    function triMenuController(triMenu, $scope) {
        var triMenuController = this;
        // get the menu and order it
        triMenuController.menu = triMenu.menu;


    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triMenuItem', triMenuItemDirective);

    /* @ngInject */
    function triMenuItemDirective() {
        var directive = {
            restrict: 'E',
            require: '^triMenu',
            scope: {
                item: '='
            },
            // replace: true,
            template: '<div ng-include="::triMenuItem.item.template"></div>',
            controller: triMenuItemController,
            controllerAs: 'triMenuItem',
            bindToController: true
        };
        return directive;
    }

    /* @ngInject */
    function triMenuItemController($log, $rootScope, $scope, $injector, userDataService, $mdSidenav, $state, $filter, $window, $location, triBreadcrumbsService) {
        var triMenuItem = this;
        // load a template for this directive based on the type ( link | dropdown )
        triMenuItem.item.template = 'app/triangular/components/menu/menu-item-' + triMenuItem.item.type + '.tmpl.html';
        triMenuItem.item.idName = menuIdName(triMenuItem.item);
        switch(triMenuItem.item.type) {
            case 'highlighted-dropdown':
            case 'dropdown':
                // if we have kids reorder them by priority
                triMenuItem.item.children = $filter('orderBy')(triMenuItem.item.children, 'priority');
                triMenuItem.toggleDropdownMenu = toggleDropdownMenu;
                // add a check for open event
                $scope.$on('toggleDropdownMenu', function(event, item, open) {
                    // if this is the item we are looking for
                    if(triMenuItem.item === item) {
                        triMenuItem.item.open = open;
                    }
                    else {
                        triMenuItem.item.open = false;
                    }
                });
                // this event is emitted up the tree to open parent menus
                $scope.$on('openParents', function() {
                    // openParents event so open the parent item
                    triMenuItem.item.open = true;
                    // also add this to the breadcrumbs
                    triBreadcrumbsService.addCrumb(triMenuItem.item);
                });
                break;
            case 'link':
            case 'guide-link':
                triMenuItem.openLink = openLink;

                // on init check if this is current menu
                checkItemActive($state.current.name, $state.params);

                $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                    checkItemActive(toState.name, toParams);
                });
                break;
             // Added for Adminja!!!!
             case 'help':
                triMenuItem.openLink = openLink;
                $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                    checkItemActive(triMenuItem.item);
                });
                break;

             case 'link-w-no-params':
                 triMenuItem.openLink = openLink;

                 // on init check if this is current menu
                 checkItemActive($state.current.name, $state.params);

                 $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                     checkItemActive(toState.name, toParams);
                 });
                 break;
             // Added for Adminja!!!!
            case 'client':
            case 'va':
                 triMenuItem.openLink = openLink;

                 // on init check if this is current menu
                 triMenuItem.item.active = ($state.params.clientID == triMenuItem.item.clientid);

                // add the "hide" node...which we will use later to toggle menu items off if they
                // don't match search query
                 triMenuItem.item.hide = false;


                 if (triMenuItem.item.active){
                     triBreadcrumbsService.reset();
                     triBreadcrumbsService.addCrumb(triMenuItem.item);
                 }

                 $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
                     checkItemActive(triMenuItem.item);
                 });
                 $rootScope.$on('runMenuQuery', function() {
                   checkItemMatchesQuery(triMenuItem.item);
                 });

                 $rootScope.$on('resetMenuQuery', function() {
                    triMenuItem.item.hide = false;
                 });
                 break;

        }

        function checkItemMatchesQuery(thisItem){
            var lowerCaseName = thisItem.name.toLowerCase();
                if (lowerCaseName.indexOf($rootScope.menuQuery) == -1){
                     thisItem.hide = true;
                } else {
                    thisItem.hide = false;
                }
        }

        function menuIdName(item){
          var idName = item.name.replace(/\s+/g, '-').toLowerCase();
          return idName
        }


        function checkItemActive() {
            // Customized for Adminja!!!!!
            // If we are checking against a client item, we need to look for the clientID
                if (triMenuItem.item.type == 'client' || triMenuItem.item.type == 'va'){
                    if ($state.params.clientID == triMenuItem.item.clientid){
                        triMenuItem.item.active = true;
                    } else {
                        triMenuItem.item.active = false;
                    }

                } else if(triMenuItem.item.type == 'guide-link'){
                    if ($state.params.guideID == triMenuItem.item.guideid){
                        triMenuItem.item.active = true;
                    } else {
                        triMenuItem.item.active = false;
                    }

                } else if(triMenuItem.item.type == 'help'){
                    // help triggers a 3rd party script and should always show "inactive".
                    triMenuItem.item.active = false;
                } else {
                    // first check if the state is the same
                    triMenuItem.item.active = $state.includes(triMenuItem.item.state, triMenuItem.item.params);
                }

            // if we are now the active item reset the breadcrumbs and open all parent dropdown items
            if(triMenuItem.item.active) {
                triBreadcrumbsService.reset();
                triBreadcrumbsService.addCrumb(triMenuItem.item);
                $scope.$emit('openParents');
            }
        }

        function toggleDropdownMenu() {
            $scope.$parent.$parent.$broadcast('toggleDropdownMenu', triMenuItem.item, !triMenuItem.item.open);
        }

        function openLink() {
            if (triMenuItem.item.type == 'client' || triMenuItem.item.type == 'va'){
                 var view = "workspaces/" + triMenuItem.item.clientid;
                 $location.path(view);

            } else if( triMenuItem.item.type == 'guide-link'){
                var view = "guides/" + triMenuItem.item.guideid;
                $location.path(view);

            } else if (triMenuItem.item.type == 'link-w-no-params'){
                 // this state should transition WITHOUT parent's clientID
                 // so we are removing it
                $state.go(triMenuItem.item.state, {clientID: undefined});
                triMenuItem.item.active = true;
            }

            else if(triMenuItem.item.type == 'help'){
                var myCustomData = {
                    email: userDataService.user.email
                };

                // groove.widget('setCustomer', myCustomData);
                // groove.widget.setContact(myCustomData)

                // groove.widget.open()
                // // //heap.track('Shortcut - Get Help');
                userpilot.track('Shortcut - Guides & Resources');
                userpilot.trigger("Sr3G26T");
            }

            else if(angular.isDefined(triMenuItem.item.click)) {
                $injector.invoke(triMenuItem.item.click);
            }

            else {
                var params = angular.isUndefined(triMenuItem.item.params) ? {} : triMenuItem.item.params;
                if(angular.isDefined(triMenuItem.item.openInNewTab) && triMenuItem.item.openInNewTab === true) {
                    var url = $state.href(triMenuItem.item.state, params);
                    $window.open(url, '_blank');
                }
                else {
                    $state.go(triMenuItem.item.state, params);
                }
            }
            triMenuItem.item.active = true;
            $mdSidenav('left').close();
        }

        function help(){
           // $log.info('Open Groove Widget');

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('FooterController', FooterController);

    /* @ngInject */
    function FooterController(triSettings, triLayout) {
        var vm = this;
        vm.name = triSettings.name;
        vm.copyright = triSettings.copyright;
        vm.layout = triLayout.layout;
        vm.version = triSettings.version;
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.components')
        .directive('triLoader', TriLoader);

    /* @ngInject */
    function TriLoader () {
        var directive = {
            bindToController: true,
            controller: TriLoaderController,
            controllerAs: 'vm',
            templateUrl: 'app/layouts/loader/loader.tmpl.html',
            // adminja customized
            // template: '<div style="background-color: rgba(255,255,255,.8);" flex class="loader padding-100" ng-show="vm.isActive()" layout="column" layout-fill layout-align="center center"><h3 class="md-headline"></h3><md-progress-linear md-mode="indeterminate"></md-progress-linear></div>',
            restrict: 'E',
            replace: true
        };
        return directive;

        function link($scope) {
            var loadingListener = $rootScope.$on('$viewContentLoading', function() {
                $scope.vm.setLoaderActive(true);
            });

            var loadedListener = $rootScope.$on('$viewContentLoaded', function() {
                $scope.vm.setLoaderActive(false);
            });

            $scope.$on('$destroy', removeListeners);

            function removeListeners() {
                loadingListener();
                loadedListener();
            }
        }

    }

    /* @ngInject */
    function TriLoaderController ($rootScope, $log, triLoaderService, triSettings) {
        console.log('loaderDirective');
        var vm = this;
        vm.status = triLoaderService.status;
        vm.setLoaderActive = triLoaderService.setLoaderActive;
        vm.triSettings = triSettings;
        vm.isActive = triLoaderService.isActive;

        // console.log(loadingMessages);
    }

})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .factory('triLoaderService', LoaderService);

    /* @ngInject */
    function LoaderService($rootScope) {
        var active = false;

        return {
            isActive: isActive,
            setLoaderActive: setLoaderActive
        };

        ////////////////

        function isActive() {
            return active;
        }

        function setLoaderActive(setActive) {
            active = setActive;
            $rootScope.$broadcast('loader', active);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .factory('triBreadcrumbsService', BreadcrumbsService);

    /* @ngInject */
    function BreadcrumbsService($rootScope) {
        var crumbs = [];

        return {
            breadcrumbs: {
                crumbs: crumbs
            },
            addCrumb: addCrumb,
            reset: reset
        };

        ////////////////

        function addCrumb(item) {
            this.breadcrumbs.crumbs.unshift(item);
            $rootScope.$emit('changeTitle');
        }

        function reset() {
            this.breadcrumbs.crumbs = [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.themes', [

        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.themes')
        .provider('triTheming', themingProvider);

    /* @ngInject */
    function themingProvider($mdThemingProvider) {
        var themes = {};

        return {
            theme: function(name) {
                if(angular.isDefined(themes[name])) {
                    return themes[name];
                }

                var theme = new Theme(name);

                themes[name] = theme;

                return themes[name];

            },
            $get: function() {
                return {
                    getTheme: function(themeName) {
                        return themes[themeName];
                    },
                    getThemeHue: function(themeName, intentName, hue) {
                        if(angular.isDefined($mdThemingProvider._THEMES[themeName]) && angular.isDefined($mdThemingProvider._THEMES[themeName].colors[intentName])) {
                            var palette = $mdThemingProvider._THEMES[themeName].colors[intentName];
                            if(angular.isDefined($mdThemingProvider._PALETTES[palette.name]) && angular.isDefined($mdThemingProvider._PALETTES[palette.name][palette.hues[hue]])) {
                                return $mdThemingProvider._PALETTES[palette.name][palette.hues[hue]];
                            }
                        }
                    },
                    getPalette: function(name) {
                        return $mdThemingProvider._PALETTES[name];
                    },
                    getPaletteColor: function(paletteName, hue) {
                        if(angular.isDefined($mdThemingProvider._PALETTES[paletteName]) && angular.isDefined($mdThemingProvider._PALETTES[paletteName][hue])) {
                            return $mdThemingProvider._PALETTES[paletteName][hue];
                        }
                    },
                    rgba: $mdThemingProvider._rgba,
                    palettes: $mdThemingProvider._PALETTES,
                    themes: $mdThemingProvider._THEMES,
                    parseRules: $mdThemingProvider._parseRules
                };
            }
        };
    }

    function Theme(name) {
        var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
        var self = this;
        self.name = name;
        self.colors = {};
        self.isDark = false;

        THEME_COLOR_TYPES.forEach(function(colorType) {
            self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
                self.colors[colorType] = {
                    name: paletteName,
                    hues: {}
                };
                if(angular.isDefined(hues)) {
                    self.colors[colorType].hues = hues;
                }
                return self;
            };
        });

        self.dark = function(isDark) {
            // default setting when dark() is called is true
            self.isDark = angular.isUndefined(isDark) ? true : isDark;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.themes')
        .provider('triSkins', skinsProvider)
        .run(addSkinToScope);

    /* @ngInject */
    function skinsProvider($mdThemingProvider, triThemingProvider) {
        var skins = {};
        var currentSkin = null;
        var useSkinCookie = false;

        return {
            skin: function(id, name) {
                if(angular.isDefined(skins[id])) {
                    return skins[id];
                }

                var skin = new Skin(id, name, $mdThemingProvider, triThemingProvider);

                skins[id] = skin;

                return skins[id];
            },
            setSkin: function(id) {
                if(angular.isUndefined(skins[id])) {
                    return;
                }

                // set skin to selected skin
                currentSkin = skins[id];

                // override the skin if cookie is enabled and has been set
                if(useSkinCookie) {
                    // we need to check cookies to see if skin has been saved so inject it
                    var $cookies;
                    angular.injector(['ngCookies']).invoke(['$cookies', function(cookies) {
                        $cookies = cookies;
                    }]);
                    // if we have a cookie set then override the currentSkin
                    var triangularSkin = $cookies.get('triangular-skin');
                    if(angular.isDefined(triangularSkin)) {
                        var cookieTheme = angular.fromJson(triangularSkin);
                        currentSkin = angular.isDefined(skins[cookieTheme.skin]) ? skins[cookieTheme.skin] : skins[0];
                    }
                }

                // make material load the themes needed for the skin
                currentSkin.loadThemes();

                return currentSkin;
            },
            useSkinCookie: function(skinCookie) {
                useSkinCookie = skinCookie;
            },
            $get: function() {
                return {
                    getCurrent: function() {
                        return currentSkin;
                    },
                    getSkins: function() {
                        return skins;
                    }
                };
            }
        };
    }

    /* @ngInject */
    function Skin(id, name, $mdThemingProvider, triThemingProvider) {
        // Added for Adminja: 'status' theme
        var THEMABLE_ELEMENTS = ['sidebar', 'logo', 'toolbar', 'content', 'status'];
        var self = this;
        self.id = id;
        self.name = name;
        self.elements = {};

        THEMABLE_ELEMENTS.forEach(function(element) {
            self[element + 'Theme'] = function setElementTheme(themeName) {
                self.elements[element] = themeName;
                return self;
            };
        });

        self.loadThemes = function() {
            // go through each element
            for (var element in self.elements) {
                // register theme with mdThemingProvider (will load css in the header)
                var theme = triThemingProvider.theme(self.elements[element]);

                $mdThemingProvider.theme(theme.name)
                .primaryPalette(theme.colors.primary.name, theme.colors.primary.hues)
                .accentPalette(theme.colors.accent.name, theme.colors.accent.hues)
                .warnPalette(theme.colors.warn.name, theme.colors.warn.hues)
                .dark(theme.isDark);

                if(angular.isDefined(theme.colors.background)) {
                    $mdThemingProvider
                    .theme(theme.name)
                    .backgroundPalette(theme.colors.background.name, theme.colors.background.hues);
                }
            }

            $mdThemingProvider.setDefaultTheme(self.elements.content);
        };
    }

    /* @ngInject */
    function addSkinToScope($rootScope, triSkins) {
        $rootScope.triSkin = triSkins.getCurrent();
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular', [
            'ngMaterial',
            'triangular.layouts', 'triangular.components', 'triangular.themes', 'triangular.directives', 'triangular.router',
            // 'triangular.profiler',
            // uncomment above to activate the speed profiler
            'ui.router'
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $window, $state, $filter, $timeout, $injector, triRoute, triBreadcrumbsService) {
        var breadcrumbs = triBreadcrumbsService.breadcrumbs;

        // change title when language changes - when a menu item is clicked - on app init
        var menuTitleHandler = $rootScope.$on('changeTitle', function(){
            setFullTitle();
        });

        $rootScope.$on('$destroy', function(){
            menuTitleHandler();
        });

        function setFullTitle() {
            $timeout(function(){
                var title = triRoute.title;
                angular.forEach(breadcrumbs.crumbs, function(crumb){
                    var name = crumb.name;
                    if($injector.has('translateFilter')) {
                        name = $filter('translate')(crumb.name);
                    }
                    title +=' ' + triRoute.separator + ' ' + name;
                });
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular')

        .provider('triRoute', routeProvider);

    /* @ngInject */
    function routeProvider($locationProvider) {
        // Provider
        var settings = {
            docTitle: '',
            separator: ''
        };

        this.setTitle = setTitle;
        this.setSeparator = setSeparator;
        this.$get = routeHelper;

        function setTitle(title) {
            settings.docTitle = title;
        }

        function setSeparator(separator) {
            settings.separator = separator;
        }

        // Service
        function routeHelper() {
            return {
                title: settings.docTitle,
                separator: settings.separator
            };
        }
        // if we want to jump through hoops and do away with # in our urls
        // $locationProvider.html5Mode(true);
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular.router', [

        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.profiler', [
            'digestHud'
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.profiler')
        .config(profilerConfig);

    /* @ngInject */
    function profilerConfig(digestHudProvider) {
        digestHudProvider.enable();

        // Optional configuration settings:
        digestHudProvider.setHudPosition('top right'); // setup hud position on the page: top right, bottom left, etc. corner
        digestHudProvider.numTopWatches = 20;  // number of items to display in detailed table
        digestHudProvider.numDigestStats = 25;  // number of most recent digests to use f
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .run(layoutRunner)
        .provider('triLayout', layoutProvider);

    /* @ngInject */
    function layoutProvider() {
        var layoutDefaults = {
            toolbarSize: 'default',
            toolbarShrink: true,
            toolbarClass: '',
            contentClass: '',
            innerContentClass: '',
            sideMenuSize: 'icon',
            showToolbar: true,
            footer: true,
            contentTemplateUrl: 'app/triangular/layouts/default/default-content.tmpl.html',
            sidebarLeftTemplateUrl: 'app/layouts/leftsidenav/leftsidenav.tmpl.html',
            sidebarLeftController: 'MenuController',
            sidebarRightTemplateUrl: 'app/triangular/components/notifications-panel/notifications-panel.tmpl.html',
            sidebarRightController: 'NotificationsPanelController',
            toolbarTemplateUrl: 'app/triangular/components/toolbars/toolbar.tmpl.html',
            toolbarController: 'DefaultToolbarController',
            footerTemplateUrl: 'app/triangular/components/footer/footer.tmpl.html'
        };
        var resetableOptions = ['toolbarSize', 'toolbarShrink', 'toolbarClass', 'contentClass', 'innerContentClass',  'showToolbar', 'footer', 'contentTemplateUrl', 'sidebarLeftTemplateUrl', 'sidebarLeftController', 'sidebarRightTemplateUrl', 'sidebarRightController', 'toolbarTemplateUrl', 'toolbarController', 'footerTemplateUrl', 'loaderTemplateUrl', 'loaderController'];
        var layout = {};

        this.getDefaultOption = getDefaultOption;
        this.setDefaultOption = setDefaultOption;

        function getDefaultOption(name) {
            return layoutDefaults[name];
        }

        function setDefaultOption(name, value) {
            layoutDefaults[name] = value;
        }

        // init

        angular.extend(layout, layoutDefaults);

        // Service
        this.$get = function() {
            function setOption(name, value) {
                layout[name] = value;
            }

            function updateLayoutFromState(event, toState) {
                // reset classes
                angular.forEach(resetableOptions, function(option){
                    layout[option] = layoutDefaults[option];
                });
                var layoutOverrides = angular.isDefined(toState.data) && angular.isDefined(toState.data.layout) ? toState.data.layout : {};
                angular.extend(layout, layout, layoutOverrides);
            }

            return {
                layout: layout,
                setOption: setOption,
                updateLayoutFromState: updateLayoutFromState
            };
        };
    }

    /* @ngInject */
    function layoutRunner($rootScope, triLayout) {
        // check for $stateChangeStart and update the layouts if we have data.layout set
        // if nothing set reset to defaults for every state
        var destroyOn = $rootScope.$on('$stateChangeStart', triLayout.updateLayoutFromState);
        $rootScope.$on('$destroy', removeWatch);

        /////////////

        function removeWatch() {
            destroyOn();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.directives', [
        ]);
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('themeBackground', themeBackground);

    /* @ngInject */
    function themeBackground($mdTheming, triTheming) {
        // Usage:
        // ```html
        // <div md-theme="cyan" theme-background="primary|accent|warn|background:default|hue-1|hue-2|hue-3">Coloured content</div>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            $mdTheming($element);

            // make sure we have access to the theme - causes an eslint but nothing we can do about AM naming
            var $mdTheme = $element.controller('mdTheme'); //eslint-disable-line
            if(angular.isDefined($mdTheme)) {
                var intent = attrs.themeBackground;
                var hue = 'default';

                // check if we have a hue provided
                if(intent.indexOf(':') !== -1) {
                    var splitIntent = attrs.themeBackground.split(':');
                    intent = splitIntent[0];
                    hue = splitIntent[1];
                }
                // get the color and apply it to the element
                var color = triTheming.getThemeHue($mdTheme.$mdTheme, intent, hue);
                if(angular.isDefined(color)) {
                    $element.css({
                        'background-color': triTheming.rgba(color.value),
                        'border-color': triTheming.rgba(color.value),
                        'color': triTheming.rgba(color.contrast)
                    });
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('triSamePassword', samePassword);

    /* @ngInject */
    function samePassword() {
        // Usage:
        //
        // ```html
        // <form name="signup">
        //     <input name="password" type="password" ng-model="user.password" same-password="signup.confirm" />
        //     <input name="confirm" type="password" ng-model="user.confirm" same-password="signup.confirm" />
        // </form>
        // ```
        // Creates:
        //
        // `samePassword` is a directive with the purpose to validate a password input based on the value of another input.
        // When both input values are the same the inputs will be set to valid

        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: link,
            scope: {
                triSamePassword: '='
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$viewChangeListeners.push(function() {
                ngModel.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
                scope.triSamePassword.$setValidity('samePassword', scope.triSamePassword.$modelValue === ngModel.$modelValue);
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('paletteBackground', paletteBackground);

    /* @ngInject */
    function paletteBackground(triTheming) {
        // Usage:
        // ```html
        // <div palette-background="green:500">Coloured content</div>
        // ```
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs) {
            var splitColor = attrs.paletteBackground.split(':');
            var color = triTheming.getPaletteColor(splitColor[0], splitColor[1]);

            if(angular.isDefined(color)) {
                $element.css({
                    'background-color': triTheming.rgba(color.value),
                    'border-color': triTheming.rgba(color.value),
                    'color': triTheming.rgba(color.contrast)
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('triangular.directives')
        .directive('countupto', countupto);

    /* @ngInject */
    function countupto($timeout) {
        // Usage:
        //
        // ```html
        // <h1 countupto="100"></h1>
        // ```
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                'countupto': '=',
                'options': '='
            }
        };
        return directive;

        function link($scope, $element, attrs) {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            };

            var numAnim;

            // override default options?
            if ($scope.options) {
                for(var option in options) {
                    if(angular.isDefined($scope.options[option])) {
                        options[option] = $scope.options[option];
                    }
                }
            }

            attrs.from = angular.isUndefined(attrs.from) ? 0 : parseInt(attrs.from);
            attrs.decimals = angular.isUndefined(attrs.decimals) ? 2 : parseFloat(attrs.decimals);
            attrs.duration = angular.isUndefined(attrs.duration) ? 5 : parseFloat(attrs.duration);

            $timeout(function() {
                numAnim = new CountUp($element[0], attrs.from, $scope.countupto, attrs.decimals, attrs.duration, options);
                numAnim.start();

                $scope.$watch('countupto', function(value, oldValue) {
                    if (angular.isDefined(value) && value != oldValue) {
                        numAnim.update(value);
                    }
                });

            }, 500);            
        }
    }

})();
/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi Pieviläinen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */
/* global module, define */

;(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory()
  } else if (typeof define === 'function' && define.amd) {
    define([], factory)
  } else {
    root.RRule = factory(root)
    root.RRuleSet = root.RRule.RRuleSet
    root.rrulestr = root.RRule.rrulestr
  }
}(typeof window === 'object' ? window : this, function (root) {
  // =============================================================================
  // Date utilities
  // =============================================================================

  /**
   * General date-related utilities.
   * Also handles several incompatibilities between JavaScript and Python
   *
   */
  var dateutil = {
    MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

    /**
     * Number of milliseconds of one day
     */
    ONE_DAY: 1000 * 60 * 60 * 24,

    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.MAXYEAR>
     */
    MAXYEAR: 9999,

    /**
     * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
     * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
     * therefore we use 1-Jan-1970 instead
     */
    ORDINAL_BASE: new Date(1970, 0, 1),

    /**
     * Python: MO-SU: 0 - 6
     * JS: SU-SAT 0 - 6
     */
    PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],

    /**
     * py_date.timetuple()[7]
     */
    getYearDay: function (date) {
      var dateNoTime = new Date(
        date.getFullYear(), date.getMonth(), date.getDate())
      return Math.ceil(
        (dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1
    },

    isLeapYear: function (year) {
      if (year instanceof Date) year = year.getFullYear()
      return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
    },

    /**
     * @return {Number} the date's timezone offset in ms
     */
    tzOffset: function (date) {
      return date.getTimezoneOffset() * 60 * 1000
    },

    /**
     * @see: <http://www.mcfedries.com/JavaScript/DaysBetween.asp>
     */
    daysBetween: function (date1, date2) {
      // The number of milliseconds in one day
      // Convert both dates to milliseconds
      var date1_ms = date1.getTime() - dateutil.tzOffset(date1)
      var date2_ms = date2.getTime() - dateutil.tzOffset(date2)
      // Calculate the difference in milliseconds
      var difference_ms = Math.abs(date1_ms - date2_ms)
      // Convert back to days and return
      return Math.round(difference_ms / dateutil.ONE_DAY)
    },

    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.date.toordinal>
     */
    toOrdinal: function (date) {
      return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
    },

    /**
     * @see - <http://docs.python.org/library/datetime.html#datetime.date.fromordinal>
     */
    fromOrdinal: function (ordinal) {
      var millisecsFromBase = ordinal * dateutil.ONE_DAY
      return new Date(dateutil.ORDINAL_BASE.getTime() -
        dateutil.tzOffset(dateutil.ORDINAL_BASE) +
        millisecsFromBase +
        dateutil.tzOffset(new Date(millisecsFromBase)))
    },

    /**
     * @see: <http://docs.python.org/library/calendar.html#calendar.monthrange>
     */
    monthRange: function (year, month) {
      var date = new Date(year, month, 1)
      return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
    },

    getMonthDays: function (date) {
      var month = date.getMonth()
      return month === 1 && dateutil.isLeapYear(date)
        ? 29 : dateutil.MONTH_DAYS[month]
    },

    /**
     * @return {Number} python-like weekday
     */
    getWeekday: function (date) {
      return dateutil.PY_WEEKDAYS[date.getDay()]
    },

    /**
     * @see: <http://docs.python.org/library/datetime.html#datetime.datetime.combine>
     */
    combine: function (date, time) {
      time = time || date
      return new Date(
        date.getFullYear(), date.getMonth(), date.getDate(),
        time.getHours(), time.getMinutes(), time.getSeconds(),
        time.getMilliseconds())
    },

    clone: function (date) {
      var dolly = new Date(date.getTime())
      return dolly
    },

    cloneDates: function (dates) {
      var clones = []
      for (var i = 0; i < dates.length; i++) {
        clones.push(dateutil.clone(dates[i]))
      }
      return clones
    },

    /**
     * Sorts an array of Date or dateutil.Time objects
     */
    sort: function (dates) {
      dates.sort(function (a, b) {
        return a.getTime() - b.getTime()
      })
    },

    timeToUntilString: function (time) {
      var comp
      var date = new Date(time)
      var comps = [
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate(),
        'T',
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        'Z'
      ]

      for (var i = 0; i < comps.length; i++) {
        comp = comps[i]
        if (!/[TZ]/.test(comp) && comp < 10) comps[i] = '0' + String(comp)
      }
      return comps.join('')
    },

    untilStringToDate: function (until) {
      var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z)?$/
      var bits = re.exec(until)
      if (!bits) throw new Error('Invalid UNTIL value: ' + until)
      return new Date(Date.UTC(
        bits[1],
        bits[2] - 1,
        bits[3],
        bits[5] || 0,
        bits[6] || 0,
        bits[7] || 0))
    }
  }

  dateutil.Time = function (hour, minute, second, millisecond) {
    this.hour = hour
    this.minute = minute
    this.second = second
    this.millisecond = millisecond || 0
  }

  dateutil.Time.prototype = {
    constructor: dateutil.Time,
    getHours: function () {
      return this.hour
    },
    getMinutes: function () {
      return this.minute
    },
    getSeconds: function () {
      return this.second
    },
    getMilliseconds: function () {
      return this.millisecond
    },
    getTime: function () {
      return ((this.hour * 60 * 60) + (this.minute * 60) + this.second) * 1000 +
        this.millisecond
    }
  }

  // =============================================================================
  // Helper functions
  // =============================================================================

  /**
   * Simplified version of python's range()
   */
  var range = function (start, end) {
    if (arguments.length === 1) {
      end = start
      start = 0
    }
    var rang = []
    for (var i = start; i < end; i++) rang.push(i)
    return rang
  }

  var repeat = function (value, times) {
    var i = 0
    var array = []

    if (value instanceof Array) {
      for (; i < times; i++) array[i] = [].concat(value)
    } else {
      for (; i < times; i++) array[i] = value
    }
    return array
  }

  /**
   * Python like split
   */
  var split = function (str, sep, num) {
    var splits = str.split(sep)
    return num
      ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits
  }

  /**
   * closure/goog/math/math.js:modulo
   * Copyright 2006 The Closure Library Authors.
   * The % operator in JavaScript returns the remainder of a / b, but differs from
   * some other languages in that the result will have the same sign as the
   * dividend. For example, -1 % 8 == -1, whereas in some other languages
   * (such as Python) the result would be 7. This function emulates the more
   * correct modulo behavior, which is useful for certain applications such as
   * calculating an offset index in a circular list.
   *
   * @param {number} a The dividend.
   * @param {number} b The divisor.
   * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
   *     or b < x <= 0, depending on the sign of b).
   */
  var pymod = function (a, b) {
    var r = a % b
    // If r and b differ in sign, add b to wrap the result to the correct sign.
    return (r * b < 0) ? r + b : r
  }

  /**
   * @see: <http://docs.python.org/library/functions.html#divmod>
   */
  var divmod = function (a, b) {
    return {div: Math.floor(a / b), mod: pymod(a, b)}
  }

  /**
   * Python-like boolean
   * @return {Boolean} value of an object/primitive, taking into account
   * the fact that in Python an empty list's/tuple's
   * boolean value is False, whereas in JS it's true
   */
  var plb = function (obj) {
    return (obj instanceof Array && obj.length === 0)
      ? false : Boolean(obj)
  }

  /**
   * Return true if a value is in an array
   */
  var contains = function (arr, val) {
    return arr.indexOf(val) !== -1
  }

  // =============================================================================
  // Date masks
  // =============================================================================

  // Every mask is 7 days longer to handle cross-year weekly periods.

  var M365MASK = [].concat(
    repeat(1, 31), repeat(2, 28), repeat(3, 31),
    repeat(4, 30), repeat(5, 31), repeat(6, 30),
    repeat(7, 31), repeat(8, 31), repeat(9, 30),
    repeat(10, 31), repeat(11, 30), repeat(12, 31),
    repeat(1, 7))

  var M366MASK = [].concat(
    repeat(1, 31), repeat(2, 29), repeat(3, 31),
    repeat(4, 30), repeat(5, 31), repeat(6, 30),
    repeat(7, 31), repeat(8, 31), repeat(9, 30),
    repeat(10, 31), repeat(11, 30), repeat(12, 31),
    repeat(1, 7))

  var M28 = range(1, 29)
  var M29 = range(1, 30)
  var M30 = range(1, 31)
  var M31 = range(1, 32)

  var MDAY366MASK = [].concat(
    M31, M29, M31,
    M30, M31, M30,
    M31, M31, M30,
    M31, M30, M31,
    M31.slice(0, 7))

  var MDAY365MASK = [].concat(
    M31, M28, M31,
    M30, M31, M30,
    M31, M31, M30,
    M31, M30, M31,
    M31.slice(0, 7))

  M28 = range(-28, 0)
  M29 = range(-29, 0)
  M30 = range(-30, 0)
  M31 = range(-31, 0)

  var NMDAY366MASK = [].concat(
    M31, M29, M31,
    M30, M31, M30,
    M31, M31, M30,
    M31, M30, M31,
    M31.slice(0, 7))

  var NMDAY365MASK = [].concat(
    M31, M28, M31,
    M30, M31, M30,
    M31, M31, M30,
    M31, M30, M31,
    M31.slice(0, 7))

  var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
  var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365]

  var WDAYMASK = (function () {
    for (var wdaymask = [], i = 0; i < 55; i++) wdaymask = wdaymask.concat(range(7))
    return wdaymask
  }())

  // =============================================================================
  // Weekday
  // =============================================================================

  var Weekday = function (weekday, n) {
    if (n === 0) throw new Error("Can't create weekday with n == 0")
    this.weekday = weekday
    this.n = n
  }

  Weekday.prototype = {
    constructor: Weekday,
    // __call__ - Cannot call the object directly, do it through
    // e.g. RRule.TH.nth(-1) instead,
    nth: function (n) {
      return this.n === n ? this : new Weekday(this.weekday, n)
    },

    // __eq__
    equals: function (other) {
      return this.weekday === other.weekday && this.n === other.n
    },

    // __repr__
    toString: function () {
      var s = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'][this.weekday]
      if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s
      return s
    },

    getJsWeekday: function () {
      return this.weekday === 6 ? 0 : this.weekday + 1
    }

  }

  // =============================================================================
  // RRule
  // =============================================================================

  /**
   *
   * @param {Object?} options - see <http://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
   *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
   * @constructor
   */
  var RRule = function (options, noCache) {
    options = options || {}
    // RFC string
    this._string = null
    this._cache = noCache ? null : {
      all: false,
      before: [],
      after: [],
      between: []
    }

    // used by toString()
    this.origOptions = {}

    var invalid = []
    var keys = Object.keys(options)
    var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

    // Shallow copy for origOptions and check for invalid
    keys.forEach(function (key) {
      this.origOptions[key] = options[key]
      if (!contains(defaultKeys, key)) invalid.push(key)
    }, this)

    if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

    if (!RRule.FREQUENCIES[options.freq] && options.byeaster === null) {
      throw new Error('Invalid frequency: ' + String(options.freq))
    }

    // Merge in default options
    defaultKeys.forEach(function (key) {
      if (!contains(keys, key)) options[key] = RRule.DEFAULT_OPTIONS[key]
    })

    var opts = this.options = options

    if (opts.byeaster !== null) opts.freq = RRule.YEARLY
    if (!opts.dtstart) opts.dtstart = new Date()

    var millisecondModulo = opts.dtstart.getTime() % 1000
    if (opts.wkst === null) {
      opts.wkst = RRule.MO.weekday
    } else if (typeof opts.wkst === 'number') {
      // cool, just keep it like that
    } else {
      opts.wkst = opts.wkst.weekday
    }

    if (opts.bysetpos !== null) {
      if (typeof opts.bysetpos === 'number') opts.bysetpos = [opts.bysetpos]

      for (var i = 0; i < opts.bysetpos.length; i++) {
        var v = opts.bysetpos[i]
        if (v === 0 || !(v >= -366 && v <= 366)) {
          throw new Error('bysetpos must be between 1 and 366,' +
            ' or between -366 and -1')
        }
      }
    }

    if (!(plb(opts.byweekno) || plb(opts.byyearday) || plb(opts.bymonthday) ||
      opts.byweekday !== null || opts.byeaster !== null)) {
      switch (opts.freq) {
        case RRule.YEARLY:
          if (!opts.bymonth) opts.bymonth = opts.dtstart.getMonth() + 1
          opts.bymonthday = opts.dtstart.getDate()
          break
        case RRule.MONTHLY:
          opts.bymonthday = opts.dtstart.getDate()
          break
        case RRule.WEEKLY:
          opts.byweekday = dateutil.getWeekday(opts.dtstart)
          break
      }
    }

    // bymonth
    if (opts.bymonth !== null && !(opts.bymonth instanceof Array)) {
      opts.bymonth = [opts.bymonth]
    }
    // byyearday
    if (opts.byyearday !== null && !(opts.byyearday instanceof Array)) {
      opts.byyearday = [opts.byyearday]
    }

    // bymonthday
    if (opts.bymonthday === null) {
      opts.bymonthday = []
      opts.bynmonthday = []
    } else if (opts.bymonthday instanceof Array) {
      var bymonthday = []
      var bynmonthday = []

      for (i = 0; i < opts.bymonthday.length; i++) {
        v = opts.bymonthday[i]
        if (v > 0) {
          bymonthday.push(v)
        } else if (v < 0) {
          bynmonthday.push(v)
        }
      }
      opts.bymonthday = bymonthday
      opts.bynmonthday = bynmonthday
    } else {
      if (opts.bymonthday < 0) {
        opts.bynmonthday = [opts.bymonthday]
        opts.bymonthday = []
      } else {
        opts.bynmonthday = []
        opts.bymonthday = [opts.bymonthday]
      }
    }

    // byweekno
    if (opts.byweekno !== null && !(opts.byweekno instanceof Array)) {
      opts.byweekno = [opts.byweekno]
    }

    // byweekday / bynweekday
    if (opts.byweekday === null) {
      opts.bynweekday = null
    } else if (typeof opts.byweekday === 'number') {
      opts.byweekday = [opts.byweekday]
      opts.bynweekday = null
    } else if (opts.byweekday instanceof Weekday) {
      if (!opts.byweekday.n || opts.freq > RRule.MONTHLY) {
        opts.byweekday = [opts.byweekday.weekday]
        opts.bynweekday = null
      } else {
        opts.bynweekday = [
          [opts.byweekday.weekday, opts.byweekday.n]
        ]
        opts.byweekday = null
      }
    } else {
      var byweekday = []
      var bynweekday = []

      for (i = 0; i < opts.byweekday.length; i++) {
        var wday = opts.byweekday[i]

        if (typeof wday === 'number') {
          byweekday.push(wday)
        } else if (!wday.n || opts.freq > RRule.MONTHLY) {
          byweekday.push(wday.weekday)
        } else {
          bynweekday.push([wday.weekday, wday.n])
        }
      }
      opts.byweekday = plb(byweekday) ? byweekday : null
      opts.bynweekday = plb(bynweekday) ? bynweekday : null
    }

    // byhour
    if (opts.byhour === null) {
      opts.byhour = (opts.freq < RRule.HOURLY) ? [opts.dtstart.getHours()] : null
    } else if (typeof opts.byhour === 'number') {
      opts.byhour = [opts.byhour]
    }

    // byminute
    if (opts.byminute === null) {
      opts.byminute = (opts.freq < RRule.MINUTELY)
        ? [opts.dtstart.getMinutes()] : null
    } else if (typeof opts.byminute === 'number') {
      opts.byminute = [opts.byminute]
    }

    // bysecond
    if (opts.bysecond === null) {
      opts.bysecond = (opts.freq < RRule.SECONDLY)
        ? [opts.dtstart.getSeconds()] : null
    } else if (typeof opts.bysecond === 'number') {
      opts.bysecond = [opts.bysecond]
    }

    if (opts.freq >= RRule.HOURLY) {
      this.timeset = null
    } else {
      this.timeset = []
      for (i = 0; i < opts.byhour.length; i++) {
        var hour = opts.byhour[i]
        for (var j = 0; j < opts.byminute.length; j++) {
          var minute = opts.byminute[j]
          for (var k = 0; k < opts.bysecond.length; k++) {
            var second = opts.bysecond[k]
            // python:
            // datetime.time(hour, minute, second,
            // tzinfo=self._tzinfo))
            this.timeset.push(new dateutil.Time(hour, minute, second, millisecondModulo))
          }
        }
      }
      dateutil.sort(this.timeset)
    }
  }

  // RRule class 'constants'

  RRule.FREQUENCIES = [
    'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY',
    'HOURLY', 'MINUTELY', 'SECONDLY'
  ]

  RRule.YEARLY = 0
  RRule.MONTHLY = 1
  RRule.WEEKLY = 2
  RRule.DAILY = 3
  RRule.HOURLY = 4
  RRule.MINUTELY = 5
  RRule.SECONDLY = 6

  RRule.MO = new Weekday(0)
  RRule.TU = new Weekday(1)
  RRule.WE = new Weekday(2)
  RRule.TH = new Weekday(3)
  RRule.FR = new Weekday(4)
  RRule.SA = new Weekday(5)
  RRule.SU = new Weekday(6)

  RRule.DEFAULT_OPTIONS = {
    freq: null,
    dtstart: null,
    interval: 1,
    wkst: RRule.MO,
    count: null,
    until: null,
    bysetpos: null,
    bymonth: null,
    bymonthday: null,
    bynmonthday: null,
    byyearday: null,
    byweekno: null,
    byweekday: null,
    bynweekday: null,
    byhour: null,
    byminute: null,
    bysecond: null,
    byeaster: null
  }

  RRule.parseText = function (text, language) {
    return getnlp().parseText(text, language)
  }

  RRule.fromText = function (text, language) {
    return getnlp().fromText(text, language)
  }

  RRule.optionsToString = function (options) {
    var key, value, strValues
    var pairs = []
    var keys = Object.keys(options)
    var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

    for (var i = 0; i < keys.length; i++) {
      if (!contains(defaultKeys, keys[i])) continue

      key = keys[i].toUpperCase()
      value = options[keys[i]]
      strValues = []

      if (value === null || value instanceof Array && !value.length) continue

      switch (key) {
        case 'FREQ':
          value = RRule.FREQUENCIES[options.freq]
          break
        case 'WKST':
          value = value.toString()
          break
        case 'BYWEEKDAY':
          /*
          NOTE: BYWEEKDAY is a special case.
          RRule() deconstructs the rule.options.byweekday array
          into an array of Weekday arguments.
          On the other hand, rule.origOptions is an array of Weekdays.
          We need to handle both cases here.
          It might be worth change RRule to keep the Weekdays.

          Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)

          */
          key = 'BYDAY'
          if (!(value instanceof Array)) value = [value]

          for (var wday, j = 0; j < value.length; j++) {
            wday = value[j]
            if (wday instanceof Weekday) {
              // good
            } else if (wday instanceof Array) {
              wday = new Weekday(wday[0], wday[1])
            } else {
              wday = new Weekday(wday)
            }
            strValues[j] = wday.toString()
          }
          value = strValues
          break
        case 'DTSTART':
        case 'UNTIL':
          value = dateutil.timeToUntilString(value)
          break
        default:
          if (value instanceof Array) {
            for (j = 0; j < value.length; j++) strValues[j] = String(value[j])
            value = strValues
          } else {
            value = String(value)
          }

      }
      pairs.push([key, value])
    }

    var strings = []
    for (i = 0; i < pairs.length; i++) {
      var attr = pairs[i]
      strings.push(attr[0] + '=' + attr[1].toString())
    }
    return strings.join(';')
  }

  RRule.prototype = {
    constructor: RRule,

    /**
     * @param {Function} iterator - optional function that will be called
     *                   on each date that is added. It can return false
     *                   to stop the iteration.
     * @return Array containing all recurrences.
     */
    all: function (iterator) {
      if (iterator) {
        return this._iter(new CallbackIterResult('all', {}, iterator))
      } else {
        var result = this._cacheGet('all')
        if (result === false) {
          result = this._iter(new IterResult('all', {}))
          this._cacheAdd('all', result)
        }
        return result
      }
    },

    /**
     * Returns all the occurrences of the rrule between after and before.
     * The inc keyword defines what happens if after and/or before are
     * themselves occurrences. With inc == True, they will be included in the
     * list, if they are found in the recurrence set.
     * @return Array
     */
    between: function (after, before, inc, iterator) {
      var args = {
        before: before,
        after: after,
        inc: inc
      }

      if (iterator) {
        return this._iter(new CallbackIterResult('between', args, iterator))
      }
      var result = this._cacheGet('between', args)
      if (result === false) {
        result = this._iter(new IterResult('between', args))
        this._cacheAdd('between', result, args)
      }
      return result
    },

    /**
     * Returns the last recurrence before the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     * @return Date or null
     */
    before: function (dt, inc) {
      var args = {dt: dt, inc: inc}
      var result = this._cacheGet('before', args)
      if (result === false) {
        result = this._iter(new IterResult('before', args))
        this._cacheAdd('before', result, args)
      }
      return result
    },

    /**
     * Returns the first recurrence after the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     * @return Date or null
     */
    after: function (dt, inc) {
      var args = {dt: dt, inc: inc}
      var result = this._cacheGet('after', args)
      if (result === false) {
        result = this._iter(new IterResult('after', args))
        this._cacheAdd('after', result, args)
      }
      return result
    },

    /**
     * Returns the number of recurrences in this set. It will have go trough
     * the whole recurrence, if this hasn't been done before.
     */
    count: function () {
      return this.all().length
    },

    /**
     * Converts the rrule into its string representation
     * @see <http://www.ietf.org/rfc/rfc2445.txt>
     * @return String
     */
    toString: function () {
      return RRule.optionsToString(this.origOptions)
    },

    /**
    * Will convert all rules described in nlp:ToText
    * to text.
    */
    toText: function (gettext, language) {
      return getnlp().toText(this, gettext, language)
    },

    isFullyConvertibleToText: function () {
      return getnlp().isFullyConvertible(this)
    },

    /**
     * @param {String} what - all/before/after/between
     * @param {Array,Date} value - an array of dates, one date, or null
     * @param {Object?} args - _iter arguments
     */
    _cacheAdd: function (what, value, args) {
      if (!this._cache) return

      if (value) {
        value = (value instanceof Date)
          ? dateutil.clone(value) : dateutil.cloneDates(value)
      }

      if (what === 'all') {
        this._cache.all = value
      } else {
        args._value = value
        this._cache[what].push(args)
      }
    },

    /**
     * @return false - not in the cache
     *         null  - cached, but zero occurrences (before/after)
     *         Date  - cached (before/after)
     *         []    - cached, but zero occurrences (all/between)
     *         [Date1, DateN] - cached (all/between)
     */
    _cacheGet: function (what, args) {
      if (!this._cache) return false

      var cached = false
      var argsKeys = args ? Object.keys(args) : []
      var findCacheDiff = function (item) {
        for (var key, i = 0; i < argsKeys.length; i++) {
          key = argsKeys[i]
          if (String(args[key]) !== String(item[key])) return true
        }
        return false
      }

      if (what === 'all') {
        cached = this._cache.all
      } else {
        // Let's see whether we've already called the
        // 'what' method with the same 'args'
        for (var item, i = 0; i < this._cache[what].length; i++) {
          item = this._cache[what][i]
          if (argsKeys.length && findCacheDiff(item)) continue
          cached = item._value
          break
        }
      }

      if (!cached && this._cache.all) {
        // Not in the cache, but we already know all the occurrences,
        // so we can find the correct dates from the cached ones.
        var iterResult = new IterResult(what, args)
        for (i = 0; i < this._cache.all.length; i++) {
          if (!iterResult.accept(this._cache.all[i])) break
        }
        cached = iterResult.getValue()
        this._cacheAdd(what, cached, args)
      }

      return cached instanceof Array
        ? dateutil.cloneDates(cached)
        : (cached instanceof Date ? dateutil.clone(cached) : cached)
    },

    /**
     * @return a RRule instance with the same freq and options
     *          as this one (cache is not cloned)
     */
    clone: function () {
      return new RRule(this.origOptions)
    },

    _iter: function (iterResult) {
      /* Since JavaScript doesn't have the python's yield operator (<1.7),
         we use the IterResult object that tells us when to stop iterating.

      */

      var dtstart = this.options.dtstart
      var dtstartMillisecondModulo = this.options.dtstart % 1000

      var year = dtstart.getFullYear()
      var month = dtstart.getMonth() + 1
      var day = dtstart.getDate()
      var hour = dtstart.getHours()
      var minute = dtstart.getMinutes()
      var second = dtstart.getSeconds()
      var weekday = dateutil.getWeekday(dtstart)

      // Some local variables to speed things up a bit
      var freq = this.options.freq
      var interval = this.options.interval
      var wkst = this.options.wkst
      var until = this.options.until
      var bymonth = this.options.bymonth
      var byweekno = this.options.byweekno
      var byyearday = this.options.byyearday
      var byweekday = this.options.byweekday
      var byeaster = this.options.byeaster
      var bymonthday = this.options.bymonthday
      var bynmonthday = this.options.bynmonthday
      var bysetpos = this.options.bysetpos
      var byhour = this.options.byhour
      var byminute = this.options.byminute
      var bysecond = this.options.bysecond

      var ii = new Iterinfo(this)
      ii.rebuild(year, month)

      var getdayset = {}
      getdayset[RRule.YEARLY] = ii.ydayset
      getdayset[RRule.MONTHLY] = ii.mdayset
      getdayset[RRule.WEEKLY] = ii.wdayset
      getdayset[RRule.DAILY] = ii.ddayset
      getdayset[RRule.HOURLY] = ii.ddayset
      getdayset[RRule.MINUTELY] = ii.ddayset
      getdayset[RRule.SECONDLY] = ii.ddayset

      getdayset = getdayset[freq]

      var timeset
      if (freq < RRule.HOURLY) {
        timeset = this.timeset
      } else {
        var gettimeset = {}
        gettimeset[RRule.HOURLY] = ii.htimeset
        gettimeset[RRule.MINUTELY] = ii.mtimeset
        gettimeset[RRule.SECONDLY] = ii.stimeset
        gettimeset = gettimeset[freq]
        if ((freq >= RRule.HOURLY && plb(byhour) && !contains(byhour, hour)) ||
          (freq >= RRule.MINUTELY && plb(byminute) && !contains(byminute, minute)) ||
          (freq >= RRule.SECONDLY && plb(bysecond) && !contains(bysecond, minute))) {
          timeset = []
        } else {
          timeset = gettimeset.call(ii, hour, minute, second, dtstartMillisecondModulo)
        }
      }

      var total = 0
      var count = this.options.count
      var i, j, k, dm, div, mod, tmp, pos, dayset, start, end, fixday, filtered

      while (true) {
        // Get dayset with the right frequency
        tmp = getdayset.call(ii, year, month, day)
        dayset = tmp[0]
        start = tmp[1]
        end = tmp[2]

        // Do the "hard" work ;-)
        filtered = false
        for (j = start; j < end; j++) {
          i = dayset[j]

          filtered = (plb(bymonth) && !contains(bymonth, ii.mmask[i])) ||
            (plb(byweekno) && !ii.wnomask[i]) ||
            (plb(byweekday) && !contains(byweekday, ii.wdaymask[i])) ||
            (plb(ii.nwdaymask) && !ii.nwdaymask[i]) ||
            (byeaster !== null && !contains(ii.eastermask, i)) ||
            ((plb(bymonthday) || plb(bynmonthday)) &&
              !contains(bymonthday, ii.mdaymask[i]) &&
              !contains(bynmonthday, ii.nmdaymask[i])) ||
            (plb(byyearday) &&
              ((i < ii.yearlen &&
                !contains(byyearday, i + 1) &&
                !contains(byyearday, -ii.yearlen + i)) ||
              (i >= ii.yearlen &&
                !contains(byyearday, i + 1 - ii.yearlen) &&
                !contains(byyearday, -ii.nextyearlen + i - ii.yearlen))))

          if (filtered) dayset[i] = null
        }

        // Output results
        if (plb(bysetpos) && plb(timeset)) {
          var daypos, timepos
          var poslist = []

          for (i, j = 0; j < bysetpos.length; j++) {
            pos = bysetpos[j]

            if (pos < 0) {
              daypos = Math.floor(pos / timeset.length)
              timepos = pymod(pos, timeset.length)
            } else {
              daypos = Math.floor((pos - 1) / timeset.length)
              timepos = pymod((pos - 1), timeset.length)
            }

            try {
              tmp = []
              for (k = start; k < end; k++) {
                var val = dayset[k]
                if (val === null) continue
                tmp.push(val)
              }
              if (daypos < 0) {
                // we're trying to emulate python's aList[-n]
                i = tmp.slice(daypos)[0]
              } else {
                i = tmp[daypos]
              }

              var time = timeset[timepos]
              var date = dateutil.fromOrdinal(ii.yearordinal + i)
              var res = dateutil.combine(date, time)
              // XXX: can this ever be in the array?
              // - compare the actual date instead?
              if (!contains(poslist, res)) poslist.push(res)
            } catch (e) {}
          }

          dateutil.sort(poslist)
          for (j = 0; j < poslist.length; j++) {
            res = poslist[j]
            if (until && res > until) {
              this._len = total
              return iterResult.getValue()
            } else if (res >= dtstart) {
              ++total
              if (!iterResult.accept(res)) return iterResult.getValue()
              if (count) {
                --count
                if (!count) {
                  this._len = total
                  return iterResult.getValue()
                }
              }
            }
          }
        } else {
          for (j = start; j < end; j++) {
            i = dayset[j]
            if (i !== null) {
              date = dateutil.fromOrdinal(ii.yearordinal + i)
              for (k = 0; k < timeset.length; k++) {
                time = timeset[k]
                res = dateutil.combine(date, time)
                if (until && res > until) {
                  this._len = total
                  return iterResult.getValue()
                } else if (res >= dtstart) {
                  ++total
                  if (!iterResult.accept(res)) return iterResult.getValue()
                  if (count) {
                    --count
                    if (!count) {
                      this._len = total
                      return iterResult.getValue()
                    }
                  }
                }
              }
            }
          }
        }

        // Handle frequency and interval
        fixday = false
        if (freq === RRule.YEARLY) {
          year += interval
          if (year > dateutil.MAXYEAR) {
            this._len = total
            return iterResult.getValue()
          }
          ii.rebuild(year, month)
        } else if (freq === RRule.MONTHLY) {
          month += interval
          if (month > 12) {
            div = Math.floor(month / 12)
            mod = pymod(month, 12)
            month = mod
            year += div
            if (month === 0) {
              month = 12
              --year
            }
            if (year > dateutil.MAXYEAR) {
              this._len = total
              return iterResult.getValue()
            }
          }
          ii.rebuild(year, month)
        } else if (freq === RRule.WEEKLY) {
          if (wkst > weekday) {
            day += -(weekday + 1 + (6 - wkst)) + interval * 7
          } else {
            day += -(weekday - wkst) + interval * 7
          }
          weekday = wkst
          fixday = true
        } else if (freq === RRule.DAILY) {
          day += interval
          fixday = true
        } else if (freq === RRule.HOURLY) {
          if (filtered) {
            // Jump to one iteration before next day
            hour += Math.floor((23 - hour) / interval) * interval
          }
          while (true) {
            hour += interval
            dm = divmod(hour, 24)
            div = dm.div
            mod = dm.mod
            if (div) {
              hour = mod
              day += div
              fixday = true
            }
            if (!plb(byhour) || contains(byhour, hour)) break
          }
          timeset = gettimeset.call(ii, hour, minute, second)
        } else if (freq === RRule.MINUTELY) {
          if (filtered) {
            // Jump to one iteration before next day
            minute += Math.floor(
              (1439 - (hour * 60 + minute)) / interval) * interval
          }

          while (true) {
            minute += interval
            dm = divmod(minute, 60)
            div = dm.div
            mod = dm.mod
            if (div) {
              minute = mod
              hour += div
              dm = divmod(hour, 24)
              div = dm.div
              mod = dm.mod
              if (div) {
                hour = mod
                day += div
                fixday = true
                filtered = false
              }
            }
            if ((!plb(byhour) || contains(byhour, hour)) &&
              (!plb(byminute) || contains(byminute, minute))) {
              break
            }
          }
          timeset = gettimeset.call(ii, hour, minute, second)
        } else if (freq === RRule.SECONDLY) {
          if (filtered) {
            // Jump to one iteration before next day
            second += Math.floor(
                (86399 - (hour * 3600 + minute * 60 + second)) / interval) * interval
          }
          while (true) {
            second += interval
            dm = divmod(second, 60)
            div = dm.div
            mod = dm.mod
            if (div) {
              second = mod
              minute += div
              dm = divmod(minute, 60)
              div = dm.div
              mod = dm.mod
              if (div) {
                minute = mod
                hour += div
                dm = divmod(hour, 24)
                div = dm.div
                mod = dm.mod
                if (div) {
                  hour = mod
                  day += div
                  fixday = true
                }
              }
            }
            if ((!plb(byhour) || contains(byhour, hour)) &&
              (!plb(byminute) || contains(byminute, minute)) &&
              (!plb(bysecond) || contains(bysecond, second))) {
              break
            }
          }
          timeset = gettimeset.call(ii, hour, minute, second)
        }

        if (fixday && day > 28) {
          var daysinmonth = dateutil.monthRange(year, month - 1)[1]
          if (day > daysinmonth) {
            while (day > daysinmonth) {
              day -= daysinmonth
              ++month
              if (month === 13) {
                month = 1
                ++year
                if (year > dateutil.MAXYEAR) {
                  this._len = total
                  return iterResult.getValue()
                }
              }
              daysinmonth = dateutil.monthRange(year, month - 1)[1]
            }
            ii.rebuild(year, month)
          }
        }
      }
    }

  }

  RRule.parseString = function (rfcString) {
    rfcString = rfcString.replace(/^\s+|\s+$/, '')
    if (!rfcString.length) return null

    var i, j, key, value, attr
    var attrs = rfcString.split(';')
    var options = {}

    for (i = 0; i < attrs.length; i++) {
      attr = attrs[i].split('=')
      key = attr[0]
      value = attr[1]
      switch (key) {
        case 'FREQ':
          options.freq = RRule[value]
          break
        case 'WKST':
          options.wkst = RRule[value]
          break
        case 'COUNT':
        case 'INTERVAL':
        case 'BYSETPOS':
        case 'BYMONTH':
        case 'BYMONTHDAY':
        case 'BYYEARDAY':
        case 'BYWEEKNO':
        case 'BYHOUR':
        case 'BYMINUTE':
        case 'BYSECOND':
          if (value.indexOf(',') !== -1) {
            value = value.split(',')
            for (j = 0; j < value.length; j++) {
              if (/^[+-]?\d+$/.test(value[j])) value[j] = Number(value[j])
            }
          } else if (/^[+-]?\d+$/.test(value)) {
            value = Number(value)
          }
          key = key.toLowerCase()
          options[key] = value
          break
        case 'BYDAY': // => byweekday
          var n, wday, day
          var days = value.split(',')

          options.byweekday = []
          for (j = 0; j < days.length; j++) {
            day = days[j]
            if (day.length === 2) { // MO, TU, ...
              wday = RRule[day] // wday instanceof Weekday
              options.byweekday.push(wday)
            } else { // -1MO, +3FR, 1SO, ...
              day = day.match(/^([+-]?\d)([A-Z]{2})$/)
              n = Number(day[1])
              wday = day[2]
              wday = RRule[wday].weekday
              options.byweekday.push(new Weekday(wday, n))
            }
          }
          break
        case 'DTSTART':
          options.dtstart = dateutil.untilStringToDate(value)
          break
        case 'UNTIL':
          options.until = dateutil.untilStringToDate(value)
          break
        case 'BYEASTER':
          options.byeaster = Number(value)
          break
        default:
          throw new Error("Unknown RRULE property '" + key + "'")
      }
    }
    return options
  }

  RRule.fromString = function (string) {
    return new RRule(RRule.parseString(string))
  }

  // =============================================================================
  // Iterinfo
  // =============================================================================

  var Iterinfo = function (rrule) {
    this.rrule = rrule
    this.lastyear = null
    this.lastmonth = null
    this.yearlen = null
    this.nextyearlen = null
    this.yearordinal = null
    this.yearweekday = null
    this.mmask = null
    this.mrange = null
    this.mdaymask = null
    this.nmdaymask = null
    this.wdaymask = null
    this.wnomask = null
    this.nwdaymask = null
    this.eastermask = null
  }

  Iterinfo.prototype.easter = function (y, offset) {
    offset = offset || 0

    var a = y % 19
    var b = Math.floor(y / 100)
    var c = y % 100
    var d = Math.floor(b / 4)
    var e = b % 4
    var f = Math.floor((b + 8) / 25)
    var g = Math.floor((b - f + 1) / 3)
    var h = Math.floor(19 * a + b - d - g + 15) % 30
    var i = Math.floor(c / 4)
    var k = c % 4
    var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7
    var m = Math.floor((a + 11 * h + 22 * l) / 451)
    var month = Math.floor((h + l - 7 * m + 114) / 31)
    var day = (h + l - 7 * m + 114) % 31 + 1
    var date = Date.UTC(y, month - 1, day + offset)
    var yearStart = Date.UTC(y, 0, 1)

    return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))]
  }

  Iterinfo.prototype.rebuild = function (year, month) {
    var rr = this.rrule

    if (year !== this.lastyear) {
      this.yearlen = dateutil.isLeapYear(year) ? 366 : 365
      this.nextyearlen = dateutil.isLeapYear(year + 1) ? 366 : 365
      var firstyday = new Date(year, 0, 1)

      this.yearordinal = dateutil.toOrdinal(firstyday)
      this.yearweekday = dateutil.getWeekday(firstyday)

      var wday = dateutil.getWeekday(new Date(year, 0, 1))

      if (this.yearlen === 365) {
        this.mmask = [].concat(M365MASK)
        this.mdaymask = [].concat(MDAY365MASK)
        this.nmdaymask = [].concat(NMDAY365MASK)
        this.wdaymask = WDAYMASK.slice(wday)
        this.mrange = [].concat(M365RANGE)
      } else {
        this.mmask = [].concat(M366MASK)
        this.mdaymask = [].concat(MDAY366MASK)
        this.nmdaymask = [].concat(NMDAY366MASK)
        this.wdaymask = WDAYMASK.slice(wday)
        this.mrange = [].concat(M366RANGE)
      }

      if (!plb(rr.options.byweekno)) {
        this.wnomask = null
      } else {
        this.wnomask = repeat(0, this.yearlen + 7)
        var no1wkst, firstwkst, wyearlen
        no1wkst = firstwkst = pymod(7 - this.yearweekday + rr.options.wkst, 7)
        if (no1wkst >= 4) {
          no1wkst = 0
          // Number of days in the year, plus the days we got
          // from last year.
          wyearlen = this.yearlen + pymod(this.yearweekday - rr.options.wkst, 7)
        } else {
          // Number of days in the year, minus the days we
          // left in last year.
          wyearlen = this.yearlen - no1wkst
        }
        var div = Math.floor(wyearlen / 7)
        var mod = pymod(wyearlen, 7)
        var numweeks = Math.floor(div + (mod / 4))
        for (var n, i, j = 0; j < rr.options.byweekno.length; j++) {
          n = rr.options.byweekno[j]
          if (n < 0) {
            n += numweeks + 1
          } if (!(n > 0 && n <= numweeks)) {
            continue
          } if (n > 1) {
            i = no1wkst + (n - 1) * 7
            if (no1wkst !== firstwkst) {
              i -= 7 - firstwkst
            }
          } else {
            i = no1wkst
          }
          for (var k = 0; k < 7; k++) {
            this.wnomask[i] = 1
            i++
            if (this.wdaymask[i] === rr.options.wkst) break
          }
        }

        if (contains(rr.options.byweekno, 1)) {
          // Check week number 1 of next year as well
          // orig-TODO : Check -numweeks for next year.
          i = no1wkst + numweeks * 7
          if (no1wkst !== firstwkst) i -= 7 - firstwkst
          if (i < this.yearlen) {
            // If week starts in next year, we
            // don't care about it.
            for (j = 0; j < 7; j++) {
              this.wnomask[i] = 1
              i += 1
              if (this.wdaymask[i] === rr.options.wkst) break
            }
          }
        }

        if (no1wkst) {
          // Check last week number of last year as
          // well. If no1wkst is 0, either the year
          // started on week start, or week number 1
          // got days from last year, so there are no
          // days from last year's last week number in
          // this year.
          var lnumweeks
          if (!contains(rr.options.byweekno, -1)) {
            var lyearweekday = dateutil.getWeekday(new Date(year - 1, 0, 1))
            var lno1wkst = pymod(7 - lyearweekday + rr.options.wkst, 7)
            var lyearlen = dateutil.isLeapYear(year - 1) ? 366 : 365
            if (lno1wkst >= 4) {
              lno1wkst = 0
              lnumweeks = Math.floor(52 +
                pymod(lyearlen + pymod(lyearweekday - rr.options.wkst, 7), 7) / 4)
            } else {
              lnumweeks = Math.floor(52 + pymod(this.yearlen - no1wkst, 7) / 4)
            }
          } else {
            lnumweeks = -1
          }
          if (contains(rr.options.byweekno, lnumweeks)) {
            for (i = 0; i < no1wkst; i++) this.wnomask[i] = 1
          }
        }
      }
    }

    if (plb(rr.options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
      var ranges = []
      if (rr.options.freq === RRule.YEARLY) {
        if (plb(rr.options.bymonth)) {
          for (j = 0; j < rr.options.bymonth.length; j++) {
            month = rr.options.bymonth[j]
            ranges.push(this.mrange.slice(month - 1, month + 1))
          }
        } else {
          ranges = [[0, this.yearlen]]
        }
      } else if (rr.options.freq === RRule.MONTHLY) {
        ranges = [this.mrange.slice(month - 1, month + 1)]
      }
      if (plb(ranges)) {
        // Weekly frequency won't get here, so we may not
        // care about cross-year weekly periods.
        this.nwdaymask = repeat(0, this.yearlen)

        for (j = 0; j < ranges.length; j++) {
          var rang = ranges[j]
          var first = rang[0]
          var last = rang[1]
          last -= 1
          for (k = 0; k < rr.options.bynweekday.length; k++) {
            wday = rr.options.bynweekday[k][0]
            n = rr.options.bynweekday[k][1]
            if (n < 0) {
              i = last + (n + 1) * 7
              i -= pymod(this.wdaymask[i] - wday, 7)
            } else {
              i = first + (n - 1) * 7
              i += pymod(7 - this.wdaymask[i] + wday, 7)
            }
            if (first <= i && i <= last) this.nwdaymask[i] = 1
          }
        }
      }

      this.lastyear = year
      this.lastmonth = month
    }

    if (rr.options.byeaster !== null) {
      this.eastermask = this.easter(year, rr.options.byeaster)
    }
  }

  Iterinfo.prototype.ydayset = function (year, month, day) {
    return [range(this.yearlen), 0, this.yearlen]
  }

  Iterinfo.prototype.mdayset = function (year, month, day) {
    var set = repeat(null, this.yearlen)
    var start = this.mrange[month - 1]
    var end = this.mrange[month]
    for (var i = start; i < end; i++) set[i] = i
    return [set, start, end]
  }

  Iterinfo.prototype.wdayset = function (year, month, day) {
    // We need to handle cross-year weeks here.
    var set = repeat(null, this.yearlen + 7)
    var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
    var start = i
    for (var j = 0; j < 7; j++) {
      set[i] = i
      ++i
      if (this.wdaymask[i] === this.rrule.options.wkst) break
    }
    return [set, start, i]
  }

  Iterinfo.prototype.ddayset = function (year, month, day) {
    var set = repeat(null, this.yearlen)
    var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
    set[i] = i
    return [set, i, i + 1]
  }

  Iterinfo.prototype.htimeset = function (hour, minute, second, millisecond) {
    var set = []
    var rr = this.rrule
    for (var i = 0; i < rr.options.byminute.length; i++) {
      minute = rr.options.byminute[i]
      for (var j = 0; j < rr.options.bysecond.length; j++) {
        second = rr.options.bysecond[j]
        set.push(new dateutil.Time(hour, minute, second, millisecond))
      }
    }
    dateutil.sort(set)
    return set
  }

  Iterinfo.prototype.mtimeset = function (hour, minute, second, millisecond) {
    var set = []
    var rr = this.rrule
    for (var j = 0; j < rr.options.bysecond.length; j++) {
      second = rr.options.bysecond[j]
      set.push(new dateutil.Time(hour, minute, second, millisecond))
    }
    dateutil.sort(set)
    return set
  }

  Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
    return [new dateutil.Time(hour, minute, second, millisecond)]
  }

  // =============================================================================
  // Results
  // =============================================================================

  /**
   * This class helps us to emulate python's generators, sorta.
   */
  var IterResult = function (method, args) {
    this.init(method, args)
  }

  IterResult.prototype = {
    constructor: IterResult,
    init: function (method, args) {
      this.method = method
      this.args = args
      this.minDate = null
      this.maxDate = null
      this._result = []

      if (method === 'between') {
        this.maxDate = args.inc
          ? args.before : new Date(args.before.getTime() - 1)
        this.minDate = args.inc
          ? args.after : new Date(args.after.getTime() + 1)
      } else if (method === 'before') {
        this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1)
      } else if (method === 'after') {
        this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1)
      }
    },

    /**
     * Possibly adds a date into the result.
     *
     * @param {Date} date - the date isn't necessarly added to the result
     *                      list (if it is too late/too early)
     * @return {Boolean} true if it makes sense to continue the iteration
     *                   false if we're done.
     */
    accept: function (date) {
      var tooEarly = this.minDate && date < this.minDate
      var tooLate = this.maxDate && date > this.maxDate

      if (this.method === 'between') {
        if (tooEarly) return true
        if (tooLate) return false
      } else if (this.method === 'before') {
        if (tooLate) return false
      } else if (this.method === 'after') {
        if (tooEarly) return true
        this.add(date)
        return false
      }

      return this.add(date)
    },

    /**
     *
     * @param {Date} date that is part of the result.
     * @return {Boolean} whether we are interested in more values.
     */
    add: function (date) {
      this._result.push(date)
      return true
    },

    /**
     * 'before' and 'after' return only one date, whereas 'all'
     * and 'between' an array.
     * @return {Date,Array?}
     */
    getValue: function () {
      var res = this._result
      switch (this.method) {
        case 'all':
        case 'between':
          return res
        case 'before':
        case 'after':
          return res.length ? res[res.length - 1] : null
      }
    },

    clone: function () {
      return new IterResult(this.method, this.args)
    }
  }

  /**
   * IterResult subclass that calls a callback function on each add,
   * and stops iterating when the callback returns false.
   */
  var CallbackIterResult = function (method, args, iterator) {
    var allowedMethods = ['all', 'between']
    if (!contains(allowedMethods, method)) {
      throw new Error('Invalid method "' + method +
        '". Only all and between works with iterator.')
    }
    this.add = function (date) {
      if (iterator(date, this._result.length)) {
        this._result.push(date)
        return true
      }
      return false
    }

    this.init(method, args)
  }
  CallbackIterResult.prototype = IterResult.prototype

  /**
   *
   * @param {Boolean?} noCache
   *  The same stratagy as RRule on cache, default to false
   * @constructor
   */

  var RRuleSet = function (noCache) {
    // Let RRuleSet cacheable
    this._cache = noCache ? null : {
      all: false,
      before: [],
      after: [],
      between: []
    }
    this._rrule = []
    this._rdate = []
    this._exrule = []
    this._exdate = []
  }

  RRuleSet.prototype = {
    constructor: RRuleSet,

    /**
    * @param {RRule}
    */
    rrule: function (rrule) {
      if (!(rrule instanceof RRule)) {
        throw new TypeError(String(rrule) + ' is not RRule instance')
      }
      if (!contains(this._rrule.map(String), String(rrule))) {
        this._rrule.push(rrule)
      }
    },

    /**
    * @param {Date}
    */
    rdate: function (date) {
      if (!(date instanceof Date)) {
        throw new TypeError(String(date) + ' is not Date instance')
      }
      if (!contains(this._rdate.map(Number), Number(date))) {
        this._rdate.push(date)
        dateutil.sort(this._rdate)
      }
    },

    /**
    * @param {RRule}
    */
    exrule: function (rrule) {
      if (!(rrule instanceof RRule)) {
        throw new TypeError(String(rrule) + ' is not RRule instance')
      }
      if (!contains(this._exrule.map(String), String(rrule))) {
        this._exrule.push(rrule)
      }
    },

    /**
    * @param {Date}
    */
    exdate: function (date) {
      if (!(date instanceof Date)) {
        throw new TypeError(String(date) + ' is not Date instance')
      }
      if (!contains(this._exdate.map(Number), Number(date))) {
        this._exdate.push(date)
        dateutil.sort(this._exdate)
      }
    },

    valueOf: function () {
      var result = []
      if (this._rrule.length) {
        this._rrule.forEach(function (rrule) {
          result.push('RRULE:' + rrule)
        })
      }
      if (this._rdate.length) {
        result.push('RDATE:' + this._rdate.map(function (rdate) {
          return dateutil.timeToUntilString(rdate)
        }).join(','))
      }
      if (this._exrule.length) {
        this._exrule.forEach(function (exrule) {
          result.push('EXRULE:' + exrule)
        })
      }
      if (this._exdate.length) {
        result.push('EXDATE:' + this._exdate.map(function (exdate) {
          return dateutil.timeToUntilString(exdate)
        }).join(','))
      }
      return result
    },

    /**
    * to generate recurrence field sush as:
    *   ["RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU;DTSTART=19970902T010000Z","RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH;DTSTART=19970902T010000Z"]
    */
    toString: function () {
      return JSON.stringify(this.valueOf())
    },

    _iter: function (iterResult) {
      var _exdateHash = {}
      var _exrule = this._exrule
      var _accept = iterResult.accept

      function evalExdate (after, before) {
        _exrule.forEach(function (rrule) {
          rrule.between(after, before, true).forEach(function (date) {
            _exdateHash[Number(date)] = true
          })
        })
      }

      this._exdate.forEach(function (date) {
        _exdateHash[Number(date)] = true
      })

      iterResult.accept = function (date) {
        var dt = Number(date)
        if (!_exdateHash[dt]) {
          evalExdate(new Date(dt - 1), new Date(dt + 1))
          if (!_exdateHash[dt]) {
            _exdateHash[dt] = true
            return _accept.call(this, date)
          }
        }
        return true
      }

      if (iterResult.method === 'between') {
        evalExdate(iterResult.args.after, iterResult.args.before)
        iterResult.accept = function (date) {
          var dt = Number(date)
          if (!_exdateHash[dt]) {
            _exdateHash[dt] = true
            return _accept.call(this, date)
          }
          return true
        }
      }

      for (var i = 0; i < this._rdate.length; i++) {
        if (!iterResult.accept(new Date(this._rdate[i]))) break
      }

      this._rrule.forEach(function (rrule) {
        rrule._iter(iterResult)
      })

      var res = iterResult._result
      dateutil.sort(res)
      switch (iterResult.method) {
        case 'all':
        case 'between':
          return res
        case 'before':
          return (res.length && res[res.length - 1]) || null
        case 'after':
          return (res.length && res[0]) || null
        default:
          return null
      }
    },

    /**
    * Create a new RRuleSet Object completely base on current instance
    */
    clone: function () {
      var rrs = new RRuleSet(!!this._cache)
      var i
      for (i = 0; i < this._rrule.length; i++) {
        rrs.rrule(this._rrule[i].clone())
      }
      for (i = 0; i < this._rdate.length; i++) {
        rrs.rdate(new Date(this._rdate[i]))
      }
      for (i = 0; i < this._exrule.length; i++) {
        rrs.exrule(this._exrule[i].clone())
      }
      for (i = 0; i < this._exdate.length; i++) {
        rrs.exdate(new Date(this._exdate[i]))
      }
      return rrs
    }
  }

  /**
   * Inherts method from RRule
   *  add Read interface and set RRuleSet cacheable
   */
  var RRuleSetMethods = ['all', 'between', 'before', 'after', 'count', '_cacheAdd', '_cacheGet']
  RRuleSetMethods.forEach(function (method) {
    RRuleSet.prototype[method] = RRule.prototype[method]
  })

  /**
   * RRuleStr
   *  To parse a set of rrule strings
   */

  var RRuleStr = function () {}

  RRuleStr.DEFAULT_OPTIONS = {
    dtstart: null,
    cache: false,
    unfold: false,
    forceset: false,
    compatible: false,
    ignoretz: false,
    tzinfos: null
  }

  RRuleStr._freq_map = {
    'YEARLY': RRule.YEARLY,
    'MONTHLY': RRule.MONTHLY,
    'WEEKLY': RRule.WEEKLY,
    'DAILY': RRule.DAILY,
    'HOURLY': RRule.HOURLY,
    'MINUTELY': RRule.MINUTELY,
    'SECONDLY': RRule.SECONDLY
  }

  RRuleStr._weekday_map = {
    'MO': 0,
    'TU': 1,
    'WE': 2,
    'TH': 3,
    'FR': 4,
    'SA': 5,
    'SU': 6
  }

  RRuleStr.prototype = {
    constructor: RRuleStr,

    _handle_int: function (rrkwargs, name, value, options) {
      rrkwargs[name.toLowerCase()] = parseInt(value, 10)
    },

    _handle_int_list: function (rrkwargs, name, value, options) {
      rrkwargs[name.toLowerCase()] = value.split(',').map(function (x) {
        return parseInt(x, 10)
      })
    },

    _handle_FREQ: function (rrkwargs, name, value, options) {
      rrkwargs['freq'] = RRuleStr._freq_map[value]
    },

    _handle_UNTIL: function (rrkwargs, name, value, options) {
      try {
        rrkwargs['until'] = dateutil.untilStringToDate(value)
      } catch (error) {
        throw new Error('invalid until date')
      }
    },

    _handle_WKST: function (rrkwargs, name, value, options) {
      rrkwargs['wkst'] = RRuleStr._weekday_map[value]
    },

    _handle_BYWEEKDAY: function (rrkwargs, name, value, options) {
      // Two ways to specify this: +1MO or MO(+1)
      var splt, i, j, n, w, wday
      var l = []
      var wdays = value.split(',')

      for (i = 0; i < wdays.length; i++) {
        wday = wdays[i]
        if (wday.indexOf('(') > -1) {
          // If it's of the form TH(+1), etc.
          splt = wday.split('(')
          w = splt[0]
          n = parseInt(splt.slice(1, -1), 10)
        } else {
          // # If it's of the form +1MO
          for (j = 0; j < wday.length; j++) {
            if ('+-0123456789'.indexOf(wday[j]) === -1) break
          }
          n = wday.slice(0, j) || null
          w = wday.slice(j)

          if (n) n = parseInt(n, 10)
        }

        var weekday = new Weekday(RRuleStr._weekday_map[w], n)
        l.push(weekday)
      }
      rrkwargs['byweekday'] = l
    },

    _parseRfcRRule: function (line, options) {
      options = options || {}
      options.dtstart = options.dtstart || null
      options.cache = options.cache || false
      options.ignoretz = options.ignoretz || false
      options.tzinfos = options.tzinfos || null

      var name, value, parts
      if (line.indexOf(':') !== -1) {
        parts = line.split(':')
        name = parts[0]
        value = parts[1]

        if (name !== 'RRULE') throw new Error('unknown parameter name')
      } else {
        value = line
      }

      var i
      var rrkwargs = {}
      var pairs = value.split(';')

      for (i = 0; i < pairs.length; i++) {
        parts = pairs[i].split('=')
        name = parts[0].toUpperCase()
        value = parts[1].toUpperCase()

        try {
          this['_handle_' + name](rrkwargs, name, value, {
            ignoretz: options.ignoretz,
            tzinfos: options.tzinfos
          })
        } catch (error) {
          throw new Error("unknown parameter '" + name + "':" + value)
        }
      }
      rrkwargs.dtstart = rrkwargs.dtstart || options.dtstart
      return new RRule(rrkwargs, !options.cache)
    },

    _parseRfc: function (s, options) {
      if (options.compatible) {
        options.forceset = true
        options.unfold = true
      }

      s = s && s.toUpperCase().trim()
      if (!s) throw new Error('Invalid empty string')

      var i = 0
      var line, lines

      // More info about 'unfold' option
      // Go head to http://www.ietf.org/rfc/rfc2445.txt
      if (options.unfold) {
        lines = s.split('\n')
        while (i < lines.length) {
          // TODO
          line = lines[i] = lines[i].replace(/\s+$/g, '')
          if (!line) {
            lines.splice(i, 1)
          } else if (i > 0 && line[0] === ' ') {
            lines[i - 1] += line.slice(1)
            lines.splice(i, 1)
          } else {
            i += 1
          }
        }
      } else {
        lines = s.split(/\s/)
      }

      var rrulevals = []
      var rdatevals = []
      var exrulevals = []
      var exdatevals = []
      var name, value, parts, parms, parm, dtstart, rset, j, k, datestrs, datestr

      if (!options.forceset && lines.length === 1 && (s.indexOf(':') === -1 ||
        s.indexOf('RRULE:') === 0)) {
        return this._parseRfcRRule(lines[0], {
          cache: options.cache,
          dtstart: options.dtstart,
          ignoretz: options.ignoretz,
          tzinfos: options.tzinfos
        })
      } else {
        for (i = 0; i < lines.length; i++) {
          line = lines[i]
          if (!line) continue
          if (line.indexOf(':') === -1) {
            name = 'RRULE'
            value = line
          } else {
            parts = split(line, ':', 1)
            name = parts[0]
            value = parts[1]
          }
          parms = name.split(';')
          if (!parms) throw new Error('empty property name')
          name = parms[0]
          parms = parms.slice(1)

          if (name === 'RRULE') {
            for (j = 0; j < parms.length; j++) {
              parm = parms[j]
              throw new Error('unsupported RRULE parm: ' + parm)
            }
            rrulevals.push(value)
          } else if (name === 'RDATE') {
            for (j = 0; j < parms.length; j++) {
              parm = parms[j]
              if (parm !== 'VALUE=DATE-TIME') {
                throw new Error('unsupported RDATE parm: ' + parm)
              }
            }
            rdatevals.push(value)
          } else if (name === 'EXRULE') {
            for (j = 0; j < parms.length; j++) {
              parm = parms[j]
              throw new Error('unsupported EXRULE parm: ' + parm)
            }
            exrulevals.push(value)
          } else if (name === 'EXDATE') {
            for (j = 0; j < parms.length; j++) {
              parm = parms[j]
              if (parm !== 'VALUE=DATE-TIME') {
                throw new Error('unsupported RDATE parm: ' + parm)
              }
            }
            exdatevals.push(value)
          } else if (name === 'DTSTART') {
            dtstart = dateutil.untilStringToDate(value)
          } else {
            throw new Error('unsupported property: ' + name)
          }
        }

        if (options.forceset || rrulevals.length > 1 || rdatevals.length ||
          exrulevals.length || exdatevals.length) {
          rset = new RRuleSet(!options.cache)
          for (j = 0; j < rrulevals.length; j++) {
            rset.rrule(this._parseRfcRRule(rrulevals[j], {
              dtstart: options.dtstart || dtstart,
              ignoretz: options.ignoretz,
              tzinfos: options.tzinfos
            }))
          }
          for (j = 0; j < rdatevals.length; j++) {
            datestrs = rdatevals[j].split(',')
            for (k = 0; k < datestrs.length; k++) {
              datestr = datestrs[k]
              rset.rdate(dateutil.untilStringToDate(datestr))
            }
          }
          for (j = 0; j < exrulevals.length; j++) {
            rset.exrule(this._parseRfcRRule(exrulevals[j], {
              dtstart: options.dtstart || dtstart,
              ignoretz: options.ignoretz,
              tzinfos: options.tzinfos
            }))
          }
          for (j = 0; j < exdatevals.length; j++) {
            datestrs = exdatevals[j].split(',')
            for (k = 0; k < datestrs.length; k++) {
              datestr = datestrs[k]
              rset.exdate(dateutil.untilStringToDate(datestr))
            }
          }

          if (options.campatiable && options.dtstart) rset.rdate(dtstart)
          return rset
        } else {
          return this._parseRfcRRule(rrulevals[0], {
            dtstart: options.dtstart || dtstart,
            cache: options.cache,
            ignoretz: options.ignoretz,
            tzinfos: options.tzinfos
          })
        }
      }
    },

    parse: function (s, options) {
      options = options || {}

      var invalid = []
      var keys = Object.keys(options)
      var defaultKeys = Object.keys(RRuleStr.DEFAULT_OPTIONS)

      keys.forEach(function (key) {
        if (!contains(defaultKeys, key)) invalid.push(key)
      }, this)

      if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

      // Merge in default options
      defaultKeys.forEach(function (key) {
        if (!contains(keys, key)) options[key] = RRuleStr.DEFAULT_OPTIONS[key]
      })

      return this._parseRfc(s, options)
    }
  }

  RRuleStr.prototype._handle_DTSTART = function (rrkwargs, name, value, options) {
    rrkwargs[name.toLowerCase()] = dateutil.untilStringToDate(value)
  }

  RRuleStr.prototype._handle_BYDAY = RRuleStr.prototype._handle_BYWEEKDAY
  RRuleStr.prototype._handle_INTERVAL = RRuleStr.prototype._handle_int
  RRuleStr.prototype._handle_COUNT = RRuleStr.prototype._handle_int

  ;[
    '_handle_BYSETPOS', '_handle_BYMONTH', '_handle_BYMONTHDAY',
    '_handle_BYYEARDAY', '_handle_BYEASTER', '_handle_BYWEEKNO',
    '_handle_BYHOUR', '_handle_BYMINUTE', '_handle_BYSECOND'
  ].forEach(function (method) {
    RRuleStr.prototype[method] = RRuleStr.prototype._handle_int_list
  })

  // =============================================================================
  // Export
  // =============================================================================

  // Only one RRuleStr instance for all rrule string parsing work.
  var rruleStr = new RRuleStr()
  var rrulestr = function () {
    return rruleStr.parse.apply(rruleStr, arguments)
  }

  RRule.RRule = RRule
  RRule.RRuleSet = RRuleSet
  RRule.rrulestr = rrulestr
  return RRule

  function getnlp () {
    // Lazy, runtime import to avoid circular refs.
    if (!getnlp._nlp) {
      if (root && root._getRRuleNLP) {
        getnlp._nlp = root._getRRuleNLP(RRule)
      } else if (typeof require === 'function') {
        getnlp._nlp = require('./nlp')(RRule)
      } else {
        throw new Error('You need to include rrule/nlp.js for fromText/toText to work.')
      }
    }
    return getnlp._nlp
  }
}));

/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */

/**
 *
 * Implementation of RRule.fromText() and RRule::toText().
 *
 *
 * On the client side, this file needs to be included
 * when those functions are used.
 *
 */
/* global module, define */

;(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory()
  } else if (typeof define === 'function' && define.amd) {
    define([], factory)
  } else {
    root._getRRuleNLP = factory()
  }
}(typeof window === 'object' ? window : this, function () {
  // =============================================================================
  // Helper functions
  // =============================================================================

  /**
   * Return true if a value is in an array
   */
  var contains = function (arr, val) {
    return arr.indexOf(val) !== -1
  }

  return function (RRule) {
    // =============================================================================
    // ToText
    // =============================================================================

    /**
     *
     * @param {RRule} rrule
     * Optional:
     * @param {Function} gettext function
     * @param {Object} language definition
     * @constructor
     */
    var ToText = function (rrule, gettext, language) {
      this.text = ''
      this.language = language || ENGLISH
      this.gettext = gettext || function (id) {
        return id
      }

      this.rrule = rrule
      this.freq = rrule.options.freq
      this.options = rrule.options
      this.origOptions = rrule.origOptions

      if (this.origOptions.bymonthday) {
        var bymonthday = [].concat(this.options.bymonthday)
        var bynmonthday = [].concat(this.options.bynmonthday)

        bymonthday.sort()
        bynmonthday.sort()
        bynmonthday.reverse()
        // 1, 2, 3, .., -5, -4, -3, ..
        this.bymonthday = bymonthday.concat(bynmonthday)
        if (!this.bymonthday.length) this.bymonthday = null
      }

      if (this.origOptions.byweekday) {
        var byweekday = !(this.origOptions.byweekday instanceof Array)
          ? [this.origOptions.byweekday] : this.origOptions.byweekday
        var days = String(byweekday)

        this.byweekday = {
          allWeeks: byweekday.filter(function (weekday) {
            return !Boolean(weekday.n)
          }),
          someWeeks: byweekday.filter(function (weekday) {
            return Boolean(weekday.n)
          }),
          isWeekdays: (
            days.indexOf('MO') !== -1 &&
            days.indexOf('TU') !== -1 &&
            days.indexOf('WE') !== -1 &&
            days.indexOf('TH') !== -1 &&
            days.indexOf('FR') !== -1 &&
            days.indexOf('SA') === -1 &&
            days.indexOf('SU') === -1
          )
        }

        var sortWeekDays = function (a, b) {
          return a.weekday - b.weekday
        }

        this.byweekday.allWeeks.sort(sortWeekDays)
        this.byweekday.someWeeks.sort(sortWeekDays)

        if (!this.byweekday.allWeeks.length) this.byweekday.allWeeks = null
        if (!this.byweekday.someWeeks.length) this.byweekday.someWeeks = null
      } else {
        this.byweekday = null
      }
    }

    var common = [
      'count', 'until', 'interval',
      'byweekday', 'bymonthday', 'bymonth'
    ]
    ToText.IMPLEMENTED = []
    ToText.IMPLEMENTED[RRule.HOURLY] = common
    ToText.IMPLEMENTED[RRule.DAILY] = ['byhour'].concat(common)
    ToText.IMPLEMENTED[RRule.WEEKLY] = common
    ToText.IMPLEMENTED[RRule.MONTHLY] = common
    ToText.IMPLEMENTED[RRule.YEARLY] = ['byweekno', 'byyearday'].concat(common)

    /**
     * Test whether the rrule can be fully converted to text.
     * @param {RRule} rrule
     * @return {Boolean}
     */
    ToText.isFullyConvertible = function (rrule) {
      var canConvert = true

      if (!(rrule.options.freq in ToText.IMPLEMENTED)) return false
      if (rrule.origOptions.until && rrule.origOptions.count) return false

      for (var key in rrule.origOptions) {
        if (contains(['dtstart', 'wkst', 'freq'], key)) return true
        if (!contains(ToText.IMPLEMENTED[rrule.options.freq], key)) return false
      }

      return canConvert
    }

    ToText.prototype = {
      constructor: ToText,

      isFullyConvertible: function () {
        return ToText.isFullyConvertible(this.rrule)
      },

      /**
       * Perform the conversion. Only some of the frequencies are supported.
       * If some of the rrule's options aren't supported, they'll
       * be omitted from the output an "(~ approximate)" will be appended.
       * @return {*}
       */
      toString: function () {
        var gettext = this.gettext

        if (!(this.options.freq in ToText.IMPLEMENTED)) {
          return gettext('RRule error: Unable to fully convert this rrule to text')
        }

        this.text = [gettext('every')]
        this[RRule.FREQUENCIES[this.options.freq]]()

        if (this.options.until) {
          this.add(gettext('until'))
          var until = this.options.until
          this.add(this.language.monthNames[until.getMonth()])
            .add(until.getDate() + ',')
            .add(until.getFullYear())
        } else if (this.options.count) {
          this.add(gettext('for'))
            .add(this.options.count)
            .add(this.plural(this.options.count)
              ? gettext('times') : gettext('time'))
        }

        if (!this.isFullyConvertible()) this.add(gettext('(~ approximate)'))

        return this.text.join('')
      },

      HOURLY: function () {
        var gettext = this.gettext

        if (this.options.interval !== 1) this.add(this.options.interval)

        this.add(this.plural(this.options.interval)
          ? gettext('hours') : gettext('hour'))
      },

      DAILY: function () {
        var gettext = this.gettext

        if (this.options.interval !== 1) this.add(this.options.interval)

        if (this.byweekday && this.byweekday.isWeekdays) {
          this.add(this.plural(this.options.interval)
            ? gettext('weekdays') : gettext('weekday'))
        } else {
          this.add(this.plural(this.options.interval)
            ? gettext('days') : gettext('day'))
        }

        if (this.origOptions.bymonth) {
          this.add(gettext('in'))
          this._bymonth()
        }

        if (this.bymonthday) {
          this._bymonthday()
        } else if (this.byweekday) {
          this._byweekday()
        } else if (this.origOptions.byhour) {
          this._byhour()
        }
      },

      WEEKLY: function () {
        var gettext = this.gettext

        if (this.options.interval !== 1) {
          this.add(this.options.interval)
            .add(this.plural(this.options.interval)
              ? gettext('weeks') : gettext('week'))
        }

        if (this.byweekday && this.byweekday.isWeekdays) {
          if (this.options.interval === 1) {
            this.add(this.plural(this.options.interval)
              ? gettext('weekdays') : gettext('weekday'))
          } else {
            this.add(gettext('on')).add(gettext('weekdays'))
          }
        } else {
          if (this.options.interval === 1) this.add(gettext('week'))

          if (this.origOptions.bymonth) {
            this.add(gettext('in'))
            this._bymonth()
          }

          if (this.bymonthday) {
            this._bymonthday()
          } else if (this.byweekday) {
            this._byweekday()
          }
        }
      },

      MONTHLY: function () {
        var gettext = this.gettext

        if (this.origOptions.bymonth) {
          if (this.options.interval !== 1) {
            this.add(this.options.interval).add(gettext('months'))
            if (this.plural(this.options.interval)) this.add(gettext('in'))
          } else {
            // this.add(gettext('MONTH'))
          }
          this._bymonth()
        } else {
          if (this.options.interval !== 1) this.add(this.options.interval)
          this.add(this.plural(this.options.interval)
            ? gettext('months') : gettext('month'))
        }
        if (this.bymonthday) {
          this._bymonthday()
        } else if (this.byweekday && this.byweekday.isWeekdays) {
          this.add(gettext('on')).add(gettext('weekdays'))
        } else if (this.byweekday) {
          this._byweekday()
        }
      },

      YEARLY: function () {
        var gettext = this.gettext

        if (this.origOptions.bymonth) {
          if (this.options.interval !== 1) {
            this.add(this.options.interval)
            this.add(gettext('years'))
          } else {
            // this.add(gettext('YEAR'))
          }
          this._bymonth()
        } else {
          if (this.options.interval !== 1) this.add(this.options.interval)
          this.add(this.plural(this.options.interval)
            ? gettext('years') : gettext('year'))
        }

        if (this.bymonthday) {
          this._bymonthday()
        } else if (this.byweekday) {
          this._byweekday()
        }

        if (this.options.byyearday) {
          this.add(gettext('on the'))
            .add(this.list(this.options.byyearday, this.nth, gettext('and')))
            .add(gettext('day'))
        }

        if (this.options.byweekno) {
          this.add(gettext('in'))
            .add(this.plural(this.options.byweekno.length) ? gettext('weeks') : gettext('week'))
            .add(this.list(this.options.byweekno, null, gettext('and')))
        }
      },

      _bymonthday: function () {
        var gettext = this.gettext
        if (this.byweekday && this.byweekday.allWeeks) {
          this.add(gettext('on'))
            .add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext('or')))
            .add(gettext('the'))
            .add(this.list(this.bymonthday, this.nth, gettext('or')))
        } else {
          this.add(gettext('on the'))
            .add(this.list(this.bymonthday, this.nth, gettext('and')))
        }
      // this.add(gettext('DAY'))
      },

      _byweekday: function () {
        var gettext = this.gettext
        if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) {
          this.add(gettext('on'))
            .add(this.list(this.byweekday.allWeeks, this.weekdaytext))
        }

        if (this.byweekday.someWeeks) {
          if (this.byweekday.allWeeks) this.add(gettext('and'))

          this.add(gettext('on the'))
            .add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext('and')))
        }
      },

      _byhour: function () {
        var gettext = this.gettext

        this.add(gettext('at'))
          .add(this.list(this.origOptions.byhour, null, gettext('and')))
      },

      _bymonth: function () {
        this.add(this.list(this.options.bymonth, this.monthtext, this.gettext('and')))
      },

      nth: function (n) {
        var nth, npos
        var gettext = this.gettext

        if (n === -1) return gettext('last')

        npos = Math.abs(n)
        switch (npos) {
          case 1:
          case 21:
          case 31:
            nth = npos + gettext('st')
            break
          case 2:
          case 22:
            nth = npos + gettext('nd')
            break
          case 3:
          case 23:
            nth = npos + gettext('rd')
            break
          default:
            nth = npos + gettext('th')
        }

        return n < 0 ? nth + ' ' + gettext('last') : nth
      },

      monthtext: function (m) {
        return this.language.monthNames[m - 1]
      },

      weekdaytext: function (wday) {
        var weekday = typeof wday === 'number' ? wday : wday.getJsWeekday()
        return (wday.n ? this.nth(wday.n) + ' ' : '') +
          this.language.dayNames[weekday]
      },

      plural: function (n) {
        return n % 100 !== 1
      },

      add: function (s) {
        this.text.push(' ')
        this.text.push(s)
        return this
      },

      list: function (arr, callback, finalDelim, delim) {
        var delimJoin = function (array, delimiter, finalDelimiter) {
          var list = ''

          for (var i = 0; i < array.length; i++) {
            if (i !== 0) {
              if (i === array.length - 1) {
                list += ' ' + finalDelimiter + ' '
              } else {
                list += delimiter + ' '
              }
            }
            list += array[i]
          }
          return list
        }

        delim = delim || ','
        callback = callback || function (o) {
          return o
        }
        var self = this
        var realCallback = function (arg) {
          return callback.call(self, arg)
        }

        if (finalDelim) {
          return delimJoin(arr.map(realCallback), delim, finalDelim)
        } else {
          return arr.map(realCallback).join(delim + ' ')
        }
      }
    }

    // =============================================================================
    // fromText
    // =============================================================================
    /**
     * Will be able to convert some of the below described rules from
     * text format to a rule object.
     *
     *
     * RULES
     *
     * Every ([n])
     *       day(s)
     *     | [weekday], ..., (and) [weekday]
     *     | weekday(s)
     *     | week(s)
     *     | month(s)
     *     | [month], ..., (and) [month]
     *     | year(s)
     *
     *
     * Plus 0, 1, or multiple of these:
     *
     * on [weekday], ..., (or) [weekday] the [monthday], [monthday], ... (or) [monthday]
     *
     * on [weekday], ..., (and) [weekday]
     *
     * on the [monthday], [monthday], ... (and) [monthday] (day of the month)
     *
     * on the [nth-weekday], ..., (and) [nth-weekday] (of the month/year)
     *
     *
     * Plus 0 or 1 of these:
     *
     * for [n] time(s)
     *
     * until [date]
     *
     * Plus (.)
     *
     *
     * Definitely no supported for parsing:
     *
     * (for year):
     *     in week(s) [n], ..., (and) [n]
     *
     *     on the [yearday], ..., (and) [n] day of the year
     *     on day [yearday], ..., (and) [n]
     *
     *
     * NON-TERMINALS
     *
     * [n]: 1, 2 ..., one, two, three ..
     * [month]: January, February, March, April, May, ... December
     * [weekday]: Monday, ... Sunday
     * [nth-weekday]: first [weekday], 2nd [weekday], ... last [weekday], ...
     * [monthday]: first, 1., 2., 1st, 2nd, second, ... 31st, last day, 2nd last day, ..
     * [date]:
     *     [month] (0-31(,) ([year])),
     *     (the) 0-31.(1-12.([year])),
     *     (the) 0-31/(1-12/([year])),
     *     [weekday]
     *
     * [year]: 0000, 0001, ... 01, 02, ..
     *
     * Definitely not supported for parsing:
     *
     * [yearday]: first, 1., 2., 1st, 2nd, second, ... 366th, last day, 2nd last day, ..
     *
     * @param {String} text
     * @return {Object, Boolean} the rule, or null.
     */
    var fromText = function (text, language) {
      return new RRule(parseText(text, language))
    }

    var parseText = function (text, language) {
      var options = {}
      var ttr = new Parser((language || ENGLISH).tokens)

      if (!ttr.start(text)) return null

      S()
      return options

      function S () {
        // every [n]
        var n

        ttr.expect('every')
        if ((n = ttr.accept('number'))) options.interval = parseInt(n[0], 10)
        if (ttr.isDone()) throw new Error('Unexpected end')

        switch (ttr.symbol) {
          case 'day(s)':
            options.freq = RRule.DAILY
            if (ttr.nextSymbol()) {
              AT()
              F()
            }
            break

          // FIXME Note: every 2 weekdays != every two weeks on weekdays.
          // DAILY on weekdays is not a valid rule
          case 'weekday(s)':
            options.freq = RRule.WEEKLY
            options.byweekday = [
              RRule.MO,
              RRule.TU,
              RRule.WE,
              RRule.TH,
              RRule.FR
            ]
            ttr.nextSymbol()
            F()
            break

          case 'week(s)':
            options.freq = RRule.WEEKLY
            if (ttr.nextSymbol()) {
              ON()
              F()
            }
            break

          case 'hour(s)':
            options.freq = RRule.HOURLY
            if (ttr.nextSymbol()) {
              ON()
              F()
            }
            break

          case 'month(s)':
            options.freq = RRule.MONTHLY
            if (ttr.nextSymbol()) {
              ON()
              F()
            }
            break

          case 'year(s)':
            options.freq = RRule.YEARLY
            if (ttr.nextSymbol()) {
              ON()
              F()
            }
            break

          case 'monday':
          case 'tuesday':
          case 'wednesday':
          case 'thursday':
          case 'friday':
          case 'saturday':
          case 'sunday':
            options.freq = RRule.WEEKLY
            options.byweekday = [RRule[ttr.symbol.substr(0, 2).toUpperCase()]]

            if (!ttr.nextSymbol()) return

            // TODO check for duplicates
            while (ttr.accept('comma')) {
              if (ttr.isDone()) throw new Error('Unexpected end')

              var wkd
              if (!(wkd = decodeWKD())) {
                throw new Error('Unexpected symbol ' + ttr.symbol + ', expected weekday')
              }

              options.byweekday.push(RRule[wkd])
              ttr.nextSymbol()
            }
            MDAYs()
            F()
            break

          case 'january':
          case 'february':
          case 'march':
          case 'april':
          case 'may':
          case 'june':
          case 'july':
          case 'august':
          case 'september':
          case 'october':
          case 'november':
          case 'december':
            options.freq = RRule.YEARLY
            options.bymonth = [decodeM()]

            if (!ttr.nextSymbol()) return

            // TODO check for duplicates
            while (ttr.accept('comma')) {
              if (ttr.isDone()) throw new Error('Unexpected end')

              var m
              if (!(m = decodeM())) {
                throw new Error('Unexpected symbol ' + ttr.symbol + ', expected month')
              }

              options.bymonth.push(m)
              ttr.nextSymbol()
            }

            ON()
            F()
            break

          default:
            throw new Error('Unknown symbol')

        }
      }

      function ON () {
        var on = ttr.accept('on')
        var the = ttr.accept('the')
        if (!(on || the)) return

        do {
          var nth, wkd, m

          // nth <weekday> | <weekday>
          if ((nth = decodeNTH())) {
            // ttr.nextSymbol()

            if ((wkd = decodeWKD())) {
              ttr.nextSymbol()
              if (!options.byweekday) options.byweekday = []
              options.byweekday.push(RRule[wkd].nth(nth))
            } else {
              if (!options.bymonthday) options.bymonthday = []
              options.bymonthday.push(nth)
              ttr.accept('day(s)')
            }
            // <weekday>
          } else if ((wkd = decodeWKD())) {
            ttr.nextSymbol()
            if (!options.byweekday) options.byweekday = []
            options.byweekday.push(RRule[wkd])
          } else if (ttr.symbol === 'weekday(s)') {
            ttr.nextSymbol()
            if (!options.byweekday) options.byweekday = []
            options.byweekday.push(RRule.MO)
            options.byweekday.push(RRule.TU)
            options.byweekday.push(RRule.WE)
            options.byweekday.push(RRule.TH)
            options.byweekday.push(RRule.FR)
          } else if (ttr.symbol === 'week(s)') {
            ttr.nextSymbol()
            var n
            if (!(n = ttr.accept('number'))) {
              throw new Error('Unexpected symbol ' + ttr.symbol + ', expected week number')
            }
            options.byweekno = [n[0]]
            while (ttr.accept('comma')) {
              if (!(n = ttr.accept('number'))) {
                throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday')
              }
              options.byweekno.push(n[0])
            }
          } else if ((m = decodeM())) {
            ttr.nextSymbol()
            if (!options.bymonth) options.bymonth = []
            options.bymonth.push(m)
          } else {
            return
          }
        } while (ttr.accept('comma') || ttr.accept('the') || ttr.accept('on'))
      }

      function AT () {
        var at = ttr.accept('at')
        if (!at) return

        do {
          var n
          if (!(n = ttr.accept('number'))) {
            throw new Error('Unexpected symbol ' + ttr.symbol + ', expected hour')
          }
          options.byhour = [n[0]]
          while (ttr.accept('comma')) {
            if (!(n = ttr.accept('number'))) {
              throw new Error('Unexpected symbol ' + ttr.symbol + '; expected hour')
            }
            options.byhour.push(n[0])
          }
        } while (ttr.accept('comma') || ttr.accept('at'))
      }

      function decodeM () {
        switch (ttr.symbol) {
          case 'january':
            return 1
          case 'february':
            return 2
          case 'march':
            return 3
          case 'april':
            return 4
          case 'may':
            return 5
          case 'june':
            return 6
          case 'july':
            return 7
          case 'august':
            return 8
          case 'september':
            return 9
          case 'october':
            return 10
          case 'november':
            return 11
          case 'december':
            return 12
          default:
            return false
        }
      }

      function decodeWKD () {
        switch (ttr.symbol) {
          case 'monday':
          case 'tuesday':
          case 'wednesday':
          case 'thursday':
          case 'friday':
          case 'saturday':
          case 'sunday':
            return ttr.symbol.substr(0, 2).toUpperCase()
          default:
            return false
        }
      }

      function decodeNTH () {
        switch (ttr.symbol) {
          case 'last':
            ttr.nextSymbol()
            return -1
          case 'first':
            ttr.nextSymbol()
            return 1
          case 'second':
            ttr.nextSymbol()
            return ttr.accept('last') ? -2 : 2
          case 'third':
            ttr.nextSymbol()
            return ttr.accept('last') ? -3 : 3
          case 'nth':
            var v = parseInt(ttr.value[1], 10)
            if (v < -366 || v > 366) throw new Error('Nth out of range: ' + v)

            ttr.nextSymbol()
            return ttr.accept('last') ? -v : v

          default:
            return false
        }
      }

      function MDAYs () {
        ttr.accept('on')
        ttr.accept('the')

        var nth
        if (!(nth = decodeNTH())) return

        options.bymonthday = [nth]
        ttr.nextSymbol()

        while (ttr.accept('comma')) {
          if (!(nth = decodeNTH())) {
            throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday')
          }

          options.bymonthday.push(nth)
          ttr.nextSymbol()
        }
      }

      function F () {
        if (ttr.symbol === 'until') {
          var date = Date.parse(ttr.text)

          if (!date) throw new Error('Cannot parse until date:' + ttr.text)
          options.until = new Date(date)
        } else if (ttr.accept('for')) {
          options.count = ttr.value[0]
          ttr.expect('number')
          // ttr.expect('times')
        }
      }
    }

    // =============================================================================
    // Parser
    // =============================================================================

    var Parser = function (rules) {
      this.rules = rules
    }

    Parser.prototype.start = function (text) {
      this.text = text
      this.done = false
      return this.nextSymbol()
    }

    Parser.prototype.isDone = function () {
      return this.done && this.symbol == null
    }

    Parser.prototype.nextSymbol = function () {
      var best, bestSymbol
      var p = this

      this.symbol = null
      this.value = null
      do {
        if (this.done) return false

        var match, rule
        best = null
        for (var name in this.rules) {
          rule = this.rules[name]
          if ((match = rule.exec(p.text))) {
            if (best == null || match[0].length > best[0].length) {
              best = match
              bestSymbol = name
            }
          }
        }

        if (best != null) {
          this.text = this.text.substr(best[0].length)

          if (this.text === '') this.done = true
        }

        if (best == null) {
          this.done = true
          this.symbol = null
          this.value = null
          return
        }
      } while (bestSymbol === 'SKIP')

      this.symbol = bestSymbol
      this.value = best
      return true
    }

    Parser.prototype.accept = function (name) {
      if (this.symbol === name) {
        if (this.value) {
          var v = this.value
          this.nextSymbol()
          return v
        }

        this.nextSymbol()
        return true
      }

      return false
    }

    Parser.prototype.expect = function (name) {
      if (this.accept(name)) return true

      throw new Error('expected ' + name + ' but found ' + this.symbol)
    }

    // =============================================================================
    // i18n
    // =============================================================================

    var ENGLISH = {
      dayNames: [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday',
        'Thursday', 'Friday', 'Saturday'
      ],
      monthNames: [
        'January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October',
        'November', 'December'
      ],
      tokens: {
        'SKIP': /^[ \r\n\t]+|^\.$/,
        'number': /^[1-9][0-9]*/,
        'numberAsText': /^(one|two|three)/i,
        'every': /^every/i,
        'day(s)': /^days?/i,
        'weekday(s)': /^weekdays?/i,
        'week(s)': /^weeks?/i,
        'hour(s)': /^hours?/i,
        'month(s)': /^months?/i,
        'year(s)': /^years?/i,
        'on': /^(on|in)/i,
        'at': /^(at)/i,
        'the': /^the/i,
        'first': /^first/i,
        'second': /^second/i,
        'third': /^third/i,
        'nth': /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
        'last': /^last/i,
        'for': /^for/i,
        'time(s)': /^times?/i,
        'until': /^(un)?til/i,
        'monday': /^mo(n(day)?)?/i,
        'tuesday': /^tu(e(s(day)?)?)?/i,
        'wednesday': /^we(d(n(esday)?)?)?/i,
        'thursday': /^th(u(r(sday)?)?)?/i,
        'friday': /^fr(i(day)?)?/i,
        'saturday': /^sa(t(urday)?)?/i,
        'sunday': /^su(n(day)?)?/i,
        'january': /^jan(uary)?/i,
        'february': /^feb(ruary)?/i,
        'march': /^mar(ch)?/i,
        'april': /^apr(il)?/i,
        'may': /^may/i,
        'june': /^june?/i,
        'july': /^july?/i,
        'august': /^aug(ust)?/i,
        'september': /^sep(t(ember)?)?/i,
        'october': /^oct(ober)?/i,
        'november': /^nov(ember)?/i,
        'december': /^dec(ember)?/i,
        'comma': /^(,\s*|(and|or)\s*)+/i
      }
    }

    // =============================================================================
    // Export
    // =============================================================================

    return {
      fromText: fromText,
      parseText: parseText,
      isFullyConvertible: ToText.isFullyConvertible,
      toText: function (rrule, gettext, language) {
        return new ToText(rrule, gettext, language).toString()
      }
    }
  }
}));

"use strict";function ngClassOnMobileConfig(){}function ngClassOnMobile(a){function b(b,c,d){a.isAMobileDevice()&&setTimeout(function(){b.classToAdd&&(b.classesToAdd=b.classToAdd.split(", ").map(function(a){return a.trim()}),b.classesToAdd.forEach(function(a){c.addClass(a)})),b.classToRemove&&(b.classesToRemove=b.classToRemove.split(", ").map(function(a){return a.trim()}),b.classesToRemove.forEach(function(a){c.removeClass(a)})),b.removeCssInline&&c.removeAttr("style")},b.delayToApply||0)}var c={restrict:"A",link:b,scope:{classToAdd:"@",classToRemove:"@",delayToApply:"=",removeCssInline:"="}};return c}function deviceCheckService(a){var b=a.navigator.userAgent,c=a.navigator.vendor,d=a.opera,e=function(){var a=!1;return function(b){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(b)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(b.substr(0,4)))&&(a=!0)}(b||c||d),a};return{isAMobileDevice:e}}var ngClassOnMobileModule=angular.module("ngClassOnMobile",["ngAnimate"]);ngClassOnMobileModule.config(ngClassOnMobileConfig),angular.module("ngClassOnMobile",[]),angular.module("ngClassOnMobile").directive("ngClassOnMobile",ngClassOnMobile),ngClassOnMobile.$inject=["ngClassOnMobile.deviceCheckService"],angular.module("ngClassOnMobile").service("ngClassOnMobile.deviceCheckService",deviceCheckService),deviceCheckService.$inject=["$window"];
"use strict";!function(){angular.module("lk-color-chooser",[]).provider("lkColorSettings",function(){this.colors=[],this.$get=function(){return{colors:this.colors}},this.configure=function(o){var l;for(l in o)this[l]=o[l]}}).directive("lkColorChooser",["lkColorSettings","$timeout",function(o){return{restrict:"EA",template:'<ul class="lk-color-chooser"><lk-color ng-repeat="color in colors track by $index" color="color" ng-class="{\'selected\': selectedColor == color}"></lk-color></ul>',replace:!0,scope:{colors:"=?",selectedColor:"="},controller:["$scope","$timeout",function(o,l){this.setSelectedColor=function(r){l(function(){o.selectedColor=r})}}],link:function(l){l.colors||(l.colors=o.colors)}}}]).directive("lkColor",function(){return{restrict:"EA",require:"^lkColorChooser",template:'<li class="lk-color-chooser__color" ng-style="{\'background-color\': color }">&nbsp;</li>',replace:!0,scope:{color:"="},link:function(o,l,r,c){l.on("click",function(){c.setSelectedColor(o.color)})}}})}();
(function() {
    'use strict';

    angular
        .module('app.permission', [
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .controller('PermissionController', PermissionController);

    /* @ngInject */
    function PermissionController($state, $window, $cookies, RoleStore, PermissionStore, UserService, users) {
        var vm = this;
        vm.userList = users.data;
        vm.roleList = [];
        vm.permissionList = [];
        vm.allRoles = RoleStore.getStore();
        vm.allPermissions = PermissionStore.getStore();

        vm.loginClick = loginClick;
        vm.selectUser = selectUser;

        ////////////////

        function init() {
            var currentUser = UserService.getCurrentUser();
            angular.forEach(users.data, function(user) {
                if(user.username === currentUser.username) {
                    selectUser(user);
                }
            });
        }

        function loginClick() {
            // store username in a cookie so we can load after reload
            $cookies.put('tri-user', vm.selectedUser.username);
            $window.location.reload();
        }

        function selectUser(user) {
            vm.selectedUser = user;
            vm.roleList = [];
            vm.permissionList = [];
            // find first role and select that
            angular.forEach(vm.allRoles, function(role) {
                if(-1 !== vm.selectedUser.roles.indexOf(role.roleName)) {
                    // add this users roles to the list
                    vm.roleList.push(role);
                    angular.forEach(role.permissionNames, function(permission) {
                        vm.permissionList.push(permission);
                    });
                }
            });
        }

        // init

        init();
    }
})();

(function() {
	'use strict';

	angular
		.module('appDirectives',['appServices', 'lk-color-chooser']);


	angular
		.module('appDirectives')
		.directive('ngEnter', function () {
		    return function (scope, element, attrs) {
		        element.bind("keydown keypress", function (event) {
		            if(event.which === 13 && event.ctrlKey) {
		                scope.$apply(function (){
		                    scope.$eval(attrs.ngEnter);
		                });
		                event.preventDefault();
		            }
		        });
		    };
		})
		.directive('isolateForm', [function () {
		    return {
		        restrict: 'A',
		        require: '?form',
		        link: function (scope, elm, attrs, ctrl) {
		            if (!ctrl) {
		                return;
		            }

		            // Do a copy of the controller
		            var ctrlCopy = {};
		            angular.copy(ctrl, ctrlCopy);

		            // Get the parent of the form
		            var parent = elm.parent().controller('form');
		            // Remove parent link to the controller
		            parent.$removeControl(ctrl);

		            // Replace form controller with a "isolated form"
		            var isolatedFormCtrl = {
		                $setValidity: function (validationToken, isValid, control) {
		                    ctrlCopy.$setValidity(validationToken, isValid, control);
		                    parent.$setValidity(validationToken, true, ctrl);
		                },
		                $setDirty: function () {
		                    elm.removeClass('ng-pristine').addClass('ng-dirty');
		                    ctrl.$dirty = true;
		                    ctrl.$pristine = false;
		                },
		            };
		            angular.extend(ctrl, isolatedFormCtrl);
		        }
		    };
		}]);;
})();

(function() {
	'use strict';

	angular
		.module('appDirectives')
		.directive('todayPanel', todayPanel)
		.directive('allTodayPanel', allTodayPanel);

	function todayPanel() {
		var directive = {
			restrict: 'E',
			scope: {
				client: '=',
				tasks: '=',
				days: '='
				},
			// client: '=',
			controller: todayPanelController,
			controllerAs: 'vm',
			replace: true,
			preserveScope: true,
			bindToController: true,
			templateUrl: 'app/app-directives/today-panel/today-panel.tmpl.html'

		};
		return directive;
	};

	function allTodayPanel() {
		var directive = {
			restrict: 'E',
			scope: {
				tasks: '=',
				days: '=',
				limitto: '='
				},
			// client: '=',
			controller: todayPanelController,
			controllerAs: 'vm',
			replace: true,
			preserveScope: true,
			bindToController: true,
			templateUrl: 'app/app-directives/today-panel/all-today-panel.tmpl.html'

		};
		return directive;
	};

	///////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////
	/// todayPanelController


	/* @ngInject*/
	function todayPanelController(dragulaService, $log, userDataService, teamDataService, taskDataService, pageDimensionsService, $rootScope, $stateParams, $state, $scope, $timeout) {

		// $log.info($scope);
		// Once agaain, vm. can't be used. we have to use $scope.
		var vm = this;

			vm.user = userDataService.user;
			$scope.showClientName = true;
			// Set our client ID, exposed to our directives
			if ($stateParams.clientID){
				vm.clientID = $stateParams.clientID;
				$scope.showClientName = false;
			}

			if(!_.has(vm,'limitto')){
				vm.limitto = 100;
			}

			vm.state = $state;
			vm.now = moment().toISOString();
			vm.verticalTaskPanels = vm.user.profile.settings.verticalTaskPanels;
			// set our drag/drop direction accordingly
			if(vm.user.profile.settings.verticalTaskPanels){
			        vm.taskDragDirection = "vertical"
			    } else {
			        vm.taskDragDirection = "horizontal"
			    }

			// if we are on the dashboard, we need to FORCE vertical panels
			if ($state.is('triangular.dashboard')) {
			    vm.verticalTaskPanels = true;
			}

			vm.suppressResize = false;
			// For some reason we are needing to be VERY specific about this truthy checking
			if (vm.verticalTaskPanels === true){
			    vm.suppressResize = true;
			}
			// Bind our vm.collapseCards to our setting
			$timeout(function(){
			    vm.collapseCards = vm.user.profile.settings.collapseCards;
			}, 200);


			$scope.$watch("vm.user.profile.settings.collapseCards", function(newValue, oldValue){
			  $timeout(function(){
			    vm.collapseCards = vm.user.profile.settings.collapseCards;
			    // resize our columns
			    if (!vm.verticalTaskPanels){
			          pageDimensionsService.resizeColumns();
			    } else {
			          pageDimensionsService.resizeColumns('vertical');
			    }
			}, 200);
			});




		// we need this filter to be able to show appropriate items in today and waiting panels.
		$scope.todayFilter = function (task) {
			if(!task.private || $scope.getUserRole(task.client) != 'member'){
		    		return task.panel === 'due' || task.panel === 'today' || task.duedate <= vm.now || task.focus === 'today';
		    	} else {
		    		return false
		    	}
		};

		// define our filtered variable here (much faster than doing it in ng-repeat)
		$scope.$watch(function () {
		    $scope.filteredTasks = $scope.$eval("vm.tasks | toArray  : false | filter: {'status' : 'open'} | filter: todayFilter | filter: userFilter | filter: snoozeFilter |  orderBy:['todayorder']");
		});

		$scope.laterFilter = function (task) {
		    // $log.info(task.duedate + ' - ' + $scope.today);
		    // return !task.duedate || task.duedate > vm.now;
		    return true
		};

		$scope.snoozeFilter = function(task){
		      if(task.snooze){
		          return false
		      } else {
		          return true
		      }
		     }

	     $scope.getUserRole = function(clientID){
		    // Set defaults

		       // Check to see if current user is admin or member so we can restrict who can see the 'admins only' toggle
		       var teamSize = _.keys(teamDataService.clientTeams[clientID]).length;

		       // if we have a team, check for permissions to edit otherwise, allow it
		       if(teamSize > 0 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
		           return teamDataService.clientTeams[clientID][$rootScope.userID].role;
		       } else {
		           // no team. This is a solo account. Set all to true.
		           return 'member'
		       }

		    }// getUserRole

		    $scope.userFilter = function(task){
		        if(!task.private || $scope.getUserRole(task.client) != 'member'){
		            if(_.has(teamDataService, 'filteredMember')){
		                if(task.assignee == teamDataService.filteredMember){
		                    return true
		                } else { return false}
		            } else {
		                return true
		            }
		        }
		    }// userFilter

		// if we already have a Dragula bag by this name (we shouldn't but sometimes we do), destroy it
		if (dragulaService.find($scope, 'drag-today-task')){
			dragulaService.destroy($scope, 'drag-today-task');
		}

	      // Dragula Setup
	       dragulaService.options($scope, 'drag-today-task', {
	                 moves: function (el, container, handle) {
	                 	return true
	                   return handle.classList.contains('task-handle');
	                 },
	                 accepts: function(el, target, source, sibling) {
	                  if (target === source){
	                    return true
	                  }
	                },
	                 direction: 'vertical'
	               });

	       ///////////
	       // Task Drop Listener
	       $scope.$on('drag-today-task.drop', function(event, item, target, source, sibling){
	           // $log.info('drag-today-task.drop');
	           // $log.info(item);
	           var itemID = item[0].attributes.taskid.nodeValue,
	               parentPanelID = item[0].attributes.taskpanel.nodeValue,
	               clientID = item[0].attributes.client.nodeValue,
	               targetPanelID = target[0].attributes.panelid.nodeValue,
	               newOrder = undefined;

	               // $log.info(targetPanelID);

	               // $log.info(target);
	               // $log(itemID, parentPanelID, clientID, targetPanelID);

	                // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
	                if (sibling != undefined){
	                   // this check is to make sure other tasks that don't have an order set don't throw an error
	                   if (!sibling[0].attributes.order.nodeValue){
	                       newOrder = undefined;
	                   } else {
	                       // sibling has an order, figure our ours from there
	                       newOrder = sibling[0].attributes.order.nodeValue;
	                   }
	                }

	                 // just moving within the same panel
	                 sortTasks(target[0], clientID);
	                 // resize our columns
	                 if (!vm.suppressResize){
	                 $timeout(function(){
	                   pageDimensionsService.resizeColumns();
	                   //heap.track('Tasks Reordered');
		              userDataService.trackEvent('reorder-task');
	                 }, 500);
	            }

	       });// $on.drag-task.drop


		$scope.newTask = function(clientID, panel){
		    // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
		    $scope.editedItem = taskDataService.newTask(clientID, panel);
		    // Set our dialogTitle
		    $scope.dialogTitle = "New";
		  // console.log($scope.editedItem);
		    taskDataService.taskDialog($scope.editedItem);
		}

		function sortTasks(panel){
		    var panelID = panel.attributes.panelid.nodeValue;
		    // debugger
		    // $log.info('sortTasks');

		    // // Isolate this panel thanks to it's panelid attribute
		    var sortingPanel = panel;
		    // $(sortingPanel).css('background-color', 'yellow');
		    // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
		    var sortedTasks = $(sortingPanel).find('app-item');


		    // // Update each item in firebase by ID
		    _.each(sortedTasks, function(task, index){
		        var newOrder = parseInt(index) + 1,
		            taskID = task.getAttribute('taskid'),
		            clientID = task.getAttribute('client'),
		            assignee = task.getAttribute('assignee');;

		            // // set our DB references
		            var tasksRef = firebase.database().ref('tasks/');
		            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

		            // Update the database
		             var updates = {};
		             // store our canonical object
		             updates['tasks/' + taskID + '/info/todayorder'] = newOrder;
		             // store our reference in the client's store
		             updates['clients/' + clientID + '/tasks/' + taskID + '/todayorder'] = newOrder;
		             updates['users/' + assignee + '/tasks/' + taskID + '/todayorder'] = newOrder;
		             // Execute our update
		             return firebase.database().ref().update(updates)
		             .then(function(){
		                // $log.info('sorted');
		             });
		    })
		}// sortTasks







	}
})();

///////////////////////////////////////////
// Setup all directives related to the client object
// timer
// newClient Button
// future: clientSummary

(function (aj) {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timer', [timer])
            .controller('timerController', [timerController])
            .filter('hhmmss', function () {
                return function (time) {
                    var thisTime = time || 0;
                    var sec_num = parseInt(thisTime, 10); // don't forget the second param
                    var hours = Math.floor(sec_num / 3600);
                    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                    var seconds = sec_num - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }

                    var thisTime = hours + ':' + minutes + ':' + seconds;
                    return thisTime;
                }
            })
            ;


    // Our Timer Directive
    /* @ngInject */
    function timer(timeDataService, $interval, timerDataService, userDataService, taskDataService,clientDataService, $log, $mdDialog, _clientData) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/app-directives/timer-directives/timer.tmpl.html',
            controller: timerController,
            controllerAs: 'vm',
            bindToController: false

        };
        return directive;
    };// End Directive



    /* @ngInject */
    function timerController($rootScope, timeDataService, userDataService,
                            clientDataService, $log, $scope, taskDataService,
                            $timeout, localStorageService, timerDataService, $mdDialog, $mdToast, $q) {

       var vm = this;
       var needsReset = false;
       vm.timerDataService = timerDataService;  //ensure service bound to controller

       ///////////////////////////////////
        // Setup our timers from service. $timeout required to ensure view gets it after next $digest
        $timeout(function(){
            //obtain current clients from service
            vm.clients = $scope.$resolve.clientDataService.clients;
            vm.userTimers = timerDataService.timerData.timers;
        },0); // $timeout

        var selectReady = false
        $timeout(function(){
            selectReady = true;
            // to address pre-"onchange" triggers to our client select dropdown
        }, 0)

        //

        vm.toggleTimerGui = function(){
           return timerDataService.toggleTimerGui()
        }
        // vm.clients = clientDataService.getQuickClients();
        // vm.userTimers = timerDataService.timerData.timers;
        vm.resetTimer = function(){
            if (_.has(timerDataService.timerData, 'activeTimer.active')){
                timerDataService.resetTimer();
                // timerDataService.deactivateActiveTimer(timerDataService.timerData.activeTimer);
            }
        }
        vm.newTimer = function(client, taskID){

            // $log.info('newTimer triggered');
            // $log.info(vm.timerDataService.timerData.activeClient.uid);
            // newTimer is triggered whenever we reset our client drop-down
            // so we need to only execute if there's a valid client passed
            if (client.uid)  {

                // $log.info('newTimer executing');
                 // get a fresh timer object for this client/task
                 // * vm.newTimer is called when client md-select auto selects it's client. Thus we need
                 // to check her and avoid getting a new timer unnecessarily
                 //
                 // if there's no activeTimer OR if the client is different from activeTimer's client
                 if (!timerDataService.timerData.activeTimer.client || client.uid != timerDataService.timerData.activeTimer.client.uid){
                     // if we have an activeTimer - deactivate it
                     if (_.has(timerDataService.timerData, 'activeTimer.active')){
                         timerDataService.deactivateActiveTimer(timerDataService.timerData.activeTimer);
                     }
                     vm.selectedClient = clientDataService.clientBrief(client.uid);
                     // Set our new active timer
                    timerDataService.timerData.activeTimer = timerDataService.newTimer(client, taskID);
                }
            } // if client.length
        } // newtimer

        vm.startTimer = function(timer){
            timerDataService.startTimer(timerDataService.timerData.activeTimer);
        }

        vm.pauseTimer = function(timer){
            timerDataService.pauseTimer(timerDataService.timerData.activeTimer);
        }

        vm.resumeTimer = function(timer){
            timerDataService.resumeTimer(timerDataService.timerData.activeTimer);
        }

        vm.stopTimer = function(timer){
            timerDataService.stopTimer(timerDataService.timerData.activeTimer);
            vm.selectedClient = "";
        }

        vm.discardTimer = function(timer){

            needsReset = false;

            if(timer.active){
                needsReset = true;
            }

           vm.showConfirm = true;


        }

        vm.confirmDiscardTimer = function(timer){
                $timeout(function(){
                    timerDataService.discardTimer(timer.uid);
                    if(needsReset){
                        timerDataService.resetTimer();
                    }
                }, 0);
                vm.showConfirm=false;
        }

        vm.cancelDiscard = function(timer){
           needsReset = false;
           vm.showConfirm = false;
        }

        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

        vm.viewTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (thisTask) {
                        taskDataService.taskDialog(thisTask);
                    });
        }

        // determines if timer should display alert tht we are reaching end of task budget
        vm.budgetStatus = function (timer) {
            // only calc if we have a budget
            if(_.has(timer, 'task.budget')){
                if (timer.task.budget > 0){
                    // budget is in minute
                    // logged is in minutes
                    // approxAccrued is in seconds
                    var accrued = Math.round(timer.approxAccrued), // in seconds
                        logged = timer.task.logged * 60, // in seconds,
                        budget = (timer.task.budget) * 60, // convert budget to seconds
                        elapsed = logged + accrued,
                        percentOfBudget = elapsed/budget;

                    if (percentOfBudget < .9){
                        // percent of budget used is less than 90
                        return 'under-budget'

                    } else if (percentOfBudget > .9 && percentOfBudget < 1){
                        // percent of budget used is greater than 90%
                        return 'close-to-budget'

                    } else {
                        // we are OVER, so 'close' isn't what we want to set
                        return 'over-budget'

                    }
                }
            } else {
                // we don't have a budget for this task. no color coding.
                return ''
            }
        }



        vm.shortTaskName = function(text){
            var truncated = _.truncate(text, {
            'omission': '...',
            'length': 25
            });
            return truncated
        }

    }
    ; //end timerController

})();

///////////////////////////////////////////
// Setup all directives related to the client object
// timer
// newClient Button
// future: clientSummary

(function (aj) {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timerList', [timerList])
            .controller('timerListController', [timerListController]);


    /* @ngInject */
    function timerList(timeDataService, timerDataService, userDataService, clientDataService, $log, $mdDialog) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/app-directives/timer-directives/timer-list.tmpl.html',
            controller: timerListController,
            controllerAs: 'vm',
            bindToController: true,
        };
        return directive;
    }
    ;


    /* @ngInject */
    function timerListController($rootScope, timeDataService, userDataService,
                            clientDataService, $log, $scope, taskDataService,
                            $timeout, localStorageService, timerDataService, $mdDialog, $mdToast, $q) {

       var vm = this;
       vm.refreshing= false;
       vm.timerDataService = timerDataService;  //ensure service bound to controller
       vm.inputOptions = { updateOn: 'default blur',
                                debounce: {
                                  default: 300,
                                  blur: 0
                                }
                           };
       ///////////////////////////////////
        // Setup our timers from service. $timeout required to ensure view gets it after next $digest
        vm.refreshTimers = function(){
            vm.refreshing = true;
            vm.userTimers = {};
            $timeout(function(){
                vm.clients = clientDataService.clients;
                vm.userTimers = timerDataService.timerData.timers;
            }, 2000);
            vm.refreshing = false;
        }

        // wrapping in timeout to ensure view on sidebar load
        $timeout(function(){vm.refreshTimers();},0);

    }
    ; //end timerListController

})();

///////////////////////////////////////////
// Setup all directives related to the client object
// timer
// newClient Button
// future: clientSummary

(function (aj) {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timerCard', [timerCard])
            .controller('timerCardController', [timerCardController])
            .filter('hhmmss', function () {
                return function (time) {
                    var thisTime = time || 0;
                    var sec_num = parseInt(thisTime, 10); // don't forget the second param
                    var hours = Math.floor(sec_num / 3600);
                    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                    var seconds = sec_num - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }

                    var thisTime = hours + ':' + minutes + ':' + seconds;
                    return thisTime;
                }
            })
            ;


    // Our Timer Directive
    /* @ngInject */
    function timerCard(timeDataService, $interval, timerDataService, userDataService, taskDataService,clientDataService, $log, $mdDialog, _clientData) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/app-directives/timer-directives/timer-card.tmpl.html',
            controller: timerCardController,
            controllerAs: 'vm',
            bindToController: false
        };
        return directive;
    };// End Directive



    /* @ngInject */
    function timerCardController($rootScope, timeDataService, userDataService,
                            clientDataService, $log, $scope, taskDataService,
                            $timeout, localStorageService, timerDataService, $mdDialog, $mdToast, $q) {

       var vm = this;
       var needsReset = false; // variable used by two functions, both triggered by ng-click
       vm.timerDataService = timerDataService;  //ensure service bound to controller

       vm.userTimer = $scope.userTimer;
       vm.viewTask = function (taskID) {
           return taskDataService.getTask(taskID)
                   .then(function (thisTask) {
                       taskDataService.taskDialog(thisTask);
                   });
       }

       vm.firstLine = function (taskDescription) {
           var firstLineText = taskDescription.split('\n')[0];
           return firstLineText
       }

       vm.pauseTimer = function(timer){
           timerDataService.pauseTimer(timer);
       }

       vm.resumeTimer = function(timer){
           timerDataService.resumeTimer(timerDataService.timerData.activeTimer);
       }

       vm.resumeSavedTimer = function(timer){
           //resume time and set vars on promise callback/then only if needed.
           timerDataService.resumeSavedTimer(timer);
       }

       vm.stopTimer = function(timer){
           timerDataService.stopTimer(timer);
       }

       vm.discardTimer = function(timer){

           // will we need to reset the active timer as well?
           needsReset = false;

           if(timer.active){
               needsReset = true;
           }
           $timeout(function(){
               vm.showConfirm = true;
           },0);
           // Hide discard button and display confirm button

           // var confirm = $mdDialog.confirm()
           //         .title('Discard '+ timer.client.name +'\'s timer?')
           //         .textContent('')
           //         .ariaLabel('Discard this timer? Y//N')
           //         .ok('Discard')
           //         .cancel('Cancel');

           // $mdDialog.show(confirm).then(function () {
           //     $timeout(function(){
           //         timerDataService.discardTimer(timer.uid);
           //         if(needsReset){
           //             timerDataService.resetTimer();
           //         }
           //     }, 0);
           // });

       }// vm.discardTimer

       vm.confirmDiscardTimer = function(timer){
               $timeout(function(){
                   timerDataService.discardTimer(timer.uid);
                   if(needsReset){
                       timerDataService.resetTimer();
                   }
               }, 0);
       }

       vm.cancelDiscard = function(timer){
          needsReset = false;
          vm.showConfirm = false;
       }

       vm.cancelDialog = function () {
           $mdDialog.cancel();
       };

       vm.viewTask = function (taskID) {
           return taskDataService.getTask(taskID)
                   .then(function (thisTask) {
                       taskDataService.taskDialog(thisTask);
                   });
       }

       vm.updateDescription = function(timer){
           // $log.info('updateDescription');

           // just update the node we want without the service
           if(_.has(timer, 'description')){
              $timeout(function(){
                  timer.saving = true;
              },0);

               var updates = {};
               // // store data in the Users -> timers
               updates['/users/' + timer.userID + '/timers/' + timer.uid + '/description'] = timer.description;
               // Commit our updates
              return firebase.database().ref().update(updates)
              .then(function(){
                 $timeout(function(){
                     timer.saving = false;
                     timer.saved = true;
                     // $('.timer-description').blur();
                 },0);

                 $timeout(function(){
                     timer.saved = false;
                 },1500);
              });
           }// if has description

       }

    }
    ; //end timerCardController

})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('timeEntry', timeEntry);


    function timeEntry() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: timeEntryController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            link: linkFunc,
            // Populate the template via ng-include
            templateUrl: 'app/app-directives/time-entry/time-entry.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {



    }// linkFunc


    /* @ngInject */
    function timeEntryController($log, hotkeys, $timeout, $mdToast, userDataService, timeDataService, $rootScope, taskDataService, $scope, $firebaseArray, localStorageService, $mdDialog, clientDataService) {
        // $log.info('timeEntryController');
        var vm = this;
        vm.settings = $rootScope.userSettings;
        var timeRef = firebase.database().ref('/time');
        vm.fbConfig = fbConfig;
        vm.userType = $rootScope.admin;
        vm.loadMenu = function(entry){
            timeDataService.getTimeUserMenu(entry)
            .then(function(menu){
                vm.entryMenu = menu;
                vm.menuLoaded = true;
            });
        }// vm.loadMenu

        vm.lock = function(entry){
            timeRef.child(entry.uid).child('locked').set(true);
        };

        vm.unlock = function(entry){
          timeRef.child(entry.uid).child('locked').set(false);
        }



        vm.requireWorkDescription = false;
        // This value should actually be pulled from the client OWNER's setting (or Team Settings...which we aren't storing yet)
        vm.requireWorkDescription = vm.settings.requireWorkDescription;
        vm.entry = $scope.entry;
        vm.editMode = false;


         // determine if user is clientUser for this workspace
        vm.isClientUser = false;

        if(_.has(vm.entry, 'client')){
         if(_.has($rootScope, 'VAWorkspaces')){
             if(_.has($rootScope.VAWorkspaces, vm.entry.client)){
                     vm.isClientUser = true;
             }
         }
        }


        vm.openTime = function(entry){
            if(!vm.isClientUser){
                timeDataService.timeDialog(entry, 'Modify');
            }
        }

        $scope.editTime = function (entry) {

            // check to make sure no other edits are open
            // alert if that's the case and ignore edit request
            if ($('.time-edit-inline').length) {
                // $log.info('Already editing');
                $mdToast.show(
                        $mdToast.simple()
                        .textContent('Already editing a time log. Please complete your operation first.')
                        .position('top right')
                        .hideDelay(2000)
                        );
                return
            }

            vm.editEntry = angular.copy(entry);
            vm.editEntry.logDate = new Date(vm.editEntry.logDate);

            // store the original log total so we can compare and update totals correctly
            vm.editEntry.oldLogged = angular.copy(vm.editEntry.logged);
            // take total logged minutes and split into hours and minutes for our form

            vm.editEntry.hours = Math.floor(vm.editEntry.logged / 60);
            vm.editEntry.minutes = vm.editEntry.logged % 60;

            vm.editMode = true;
            vm.editStatus = 'editing';

            // Set focus
            $timeout(function () {
                angular.element("input[name='hours']").focus();
            }, 300);


        }
        $scope.cancelEdit = function (entry) {
            vm.editMode = false;
        }
        $scope.startDelete = function (entry) {
            vm.editStatus = 'startdelete';
        }
        $scope.cancelDelete = function (entry) {
            vm.editStatus = 'editing';
        }
        $scope.openTask = function (taskID) {
            return taskDataService.getTask(taskID)
                    .then(function (task) {
                        var taskInfo = angular.copy(task.info),
                                // fake a "task" shell so our dual purpose dialog
                                // works without worse hacks
                                editedItem = {uid: taskID};
                        editedItem.info = taskInfo;

                        // convert our due date into a date object for md-date-picker
                        if (editedItem.info.duedate) {
                            editedItem.info.duedate = new Date(editedItem.info.duedate);
                        }

                        // send it to our dialog
                        taskDataService.taskDialog(editedItem, 0);
                    })

        }
        $scope.deleteEntry = function (entry) {

            vm.editStatus = 'deleting';
            $timeout(function(){
                return timeDataService.deleteEntry(entry)
                        .then(function (response) {
                            $mdToast.show(
                                    $mdToast.simple()
                                    .textContent('Time Log Deleted')
                                    .position('top right')
                                    .hideDelay(2000)
                                    );
                            vm.editStatus = 'deleted';
                            vm.editMode = false;
                            $scope.$emit('updateReport');
                        });
            },0);
        }

        $scope.updateTime = function (entry) {
            vm.editStatus = 'saving';
            return timeDataService.updateEntry(entry)
                    .then(function () {

                        /* Get client data by client ID */
                        _.each(clientDataService.clients, function(client){
                            if(client.uid == entry.client){
                                $log.info('found');
                                if (client.profile.plan.type == 'retainer') {
                                    /* update client's Retainer_totals */
                                    // timeDataService.reCreateTotals(client);

                                    // /* Update Retainer view */

                                    // $scope.$emit('ratingUpdated', vm.RetainerMonths);

                                    // $scope.$emit('retainerWeeks', vm.RetainerWeeks);
                                }
                            }
                        });



                        vm.editStatus = 'saved';
                        vm.editMode = false;
                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Time Log Updatedd.')
                                .position('top right')
                                .hideDelay(2000)
                                );
                    });

        }// updateTime
    } // timeEntryController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('teamMemberCard', teamMemberCard);


     function teamMemberCard() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: teamMemberCardController,
         scope: {
           member: '=',
           displaytype: '@',
           team: '@',
           clientid: '@',
           editallowed: '@'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
            if(scope.vm.displaytype == 'card'){
                return 'app/app-directives/team-member/team-member-card.tmpl.html';
            } else if(scope.vm.displaytype == 'client-list'){
                return 'app/app-directives/team-member/team-member-client-list-item.tmpl.html';
            } else {
                // default to card view
                return 'app/app-directives/team-member/team-member-card.tmpl.html';
            }

       };

     }// linkFunc

    /* @ngInject */
    function teamMemberCardController($rootScope, $timeout, $scope, $log, clientDataService, userDataService, teamDataService) {
        var vm = this;

        vm.settings = $rootScope.userSettings;
        vm.teamDataService = teamDataService;
        vm.userID = $rootScope.userID;
        if(vm.member.status != 'pending'){
          populateUserInfo();
        }


            function populateUserInfo(){
              var userRef = firebase.database().ref('userList').child(vm.member.uid);
              userRef.on('value', function(snapshot){
                  vm.user = snapshot.val();
                  if(_.has(vm.user,'fullName')){
                    var splitName = vm.user.fullName.split(' ');
                    vm.member.firstName = splitName[0];
                    vm.member.lastName = splitName[1]
                  }
              });
            }



            vm.clientAccess = 'none';
            // if we are displaying with access radio buttons...we also need to have
            // our access values exposed
            if(vm.displaytype == 'client-list'){

                if(_.has(vm.member, 'clients')){

                    vm.clientAccess = vm.member.clients[vm.clientid];
                    // if that failed, set it to 'none'
                    if(!vm.clientAccess){
                        vm.clientAccess = 'none'
                    }

                }
                if(vm.member.role == 'owner'){
                    vm.clientAccess = 'admin'
                }
            }

            // Determine if this member's access can be edited by this user
            if (vm.editallowed == 'true'){
               vm.disableEdit = false;
           } else if (vm.editallowed == 'false'){
               vm.disableEdit = true;
           }
           if(vm.member.status != 'active'){
               vm.disableEdit = true;
           }
           if(vm.member.role == 'owner'){
               vm.disableEdit = true;
           }


            // this is a pending member and there's no user for them
            // just prep the basics for display
            // vm.invited = moment(vm.member.invited).format('MMM DD, YYYY');
            vm.expires = moment(vm.member.expires).format('MMM DD, YYYY');




        vm.selectTeamMember = function(member){

          if(vm.teamDataService.selectedTeam.members[vm.userID].isTeamAdmin || vm.teamDataService.selectedTeam.ownerID == vm.userID){
            vm.teamDataService.selectUser(vm.user);
            vm.teamDataService.selectTeamMember(member);
          }
        }

        vm.isMemberSelected = function(){
            if(vm.teamDataService.selectedMember){
                if(vm.teamDataService.selectedMember.uid == vm.member.uid){
                    return true
                }
            }
        }

        vm.setMemberAccess = function(member, access){
            return teamDataService.setMemberAccess(member, vm.clientid, vm.team, access)
            .then(function(){
                $timeout(function(){
                    clientDataService.setupUserAndClientMenu(true);
                },0);
            })
        }



    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('teamMemberDetail', teamMemberDetail);


     function teamMemberDetail() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: teamMemberDetailController,
         scope: {
           member: '=member',
           user: '=user',
           team: '=team'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/team-member-detail/team-member-detail.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function teamMemberDetailController($rootScope, $firebaseArray, $firebaseObject, $state, hotkeys, $scope, $log, $mdDialog, $timeout, userDataService, teamDataService, clientDataService) {
        var vm = this;

        // vm.member is implicit in the directive
        vm.userID = $rootScope.userID;
        vm.originalMember = angular.fromJson(angular.toJson(vm.member));
        // var tempClients = clientDataService.getQuickClients();

        vm.settings = $rootScope.userSettings;
        vm.updateCurrency = updateCurrency;
        vm.currencies = $rootScope.currencies;
        vm.userOrder = 'userOrders.user' + vm.userID;


       // Get all clients for this team
       var loading = true;
        $timeout(function(){
          vm.membersClients = [];
          // get the owner's client list
          if(vm.team){
            var ownerClients = firebase.database().ref().child('/users/' + vm.team.ownerID + '/clients');
            $firebaseArray(ownerClients)
            .$loaded(
              function (clients) {
                // get and check each client to see if owner OWNS it (and it should be included)
                // if owned by this team owner, include it
                _.each(clients, function(client){
                  var clientRef = firebase.database().ref('clients/' + client.$id);
                  return $firebaseObject(clientRef)
                  .$loaded(
                      function(client) {
                        if(client.owner == vm.team.ownerID){
                             vm.membersClients.push(client);
                           } else {
                           }
                      });
                });
                loading = false;
                // if currency not set, set it to USD
                $timeout(function(){
                  if(!_.has(vm.member, 'currencyLabel')){
                    vm.updateCurrency('USD')
                  }
                },0)
              });
          } else {
            alert('Oops! We had a problem loading your Team data. Please refresh your browser and try again. Please notify help@getadminja.com if this keeps happening.');
          }
        }, 0);



        vm.memberColors = $rootScope.clientColors;
        vm.colorPicker = false;

        vm.togglePicker = function(){
            if (vm.colorPicker){
                vm.colorPicker = false;
            } else{
                vm.colorPicker = true;
            }
        }
        // monitor color changes and change pristine to false
        vm.colorChange = function (form) {
            form.$setDirty();
            $timeout(function(){
                vm.togglePicker();
            }, 250);

        };
        // vm.becameMember = moment(vm.member.becameMember).format('MMM d, YYYY');
        // vm.invited = moment(vm.member.invited).format('MMM d, YYYY');

        vm.cancelMemberSelect = function(){
          delete teamDataService.selectedMember
        }


        vm.cancelNote = function(){
          delete vm.member.notes;
          vm.editMode = false;
          vm.memberForm.$pristine = true;
          // restore member to our last saved copy
          vm.member = angular.fromJson(angular.toJson(vm.originalMember));
        };

        vm.isSelected = function(){
            // if(vm.clientBillingService.selectedPeriod){
            //     if(vm.clientBillingService.selectedPeriod.uid == vm.period.uid){
            //         return true
            //     }
            // }
        };

        vm.toggleTeamAdmin = function(member){

          if(member.isTeamAdmin){
            var confirm = $mdDialog.confirm()
                      .title('Are you sure you want to make ' + member.email + ' an Administrator for your entire team?')
                      .htmlContent('<p>They will be able to invite and remove team members, as well as manage their permissions.</p>')
                      .ariaLabel('Make Admin')
                      .targetEvent(event)
                      .ok('Do It')
                      .cancel('Never mind');

                $mdDialog.show(confirm).then(function() {
                  vm.setAsTeamAdmin(member);
                }, function() {
                  // restore original value
                    member.isTeamAdmin = false;
                    // make sure form isn't dirty
                    vm.memberForm.$pristine = true;
                    vm.memberForm.$dirty = false;
                });
          } else {
            var confirm = $mdDialog.confirm()
                      .title('Are you sure you want to limit ' + member.email + '\'s Administrative permission?')
                      .htmlContent('<p>They will no longer be able to invite new team members, manage their permissions or remove them from your team.</p>')
                      .ariaLabel('Remove Admin Permission')
                      .targetEvent(event)
                      .ok('Do It')
                      .cancel('Never mind');

                $mdDialog.show(confirm).then(function() {
                  vm.removeAsTeamAdmin(member);
                }, function() {
                  // restore the value
                    member.isTeamAdmin = true;
                    // make sure form isn't dirty
                    vm.memberForm.$pristine = true;
                    vm.memberForm.$dirty = false;
                });
          }
        }

        vm.setAsTeamAdmin = function(member){
          var updates = {};
          _.each(vm.membersClients, function(client){
            updates['/clients/' + client.uid + '/access/teamAdmins/' + member.uid] = true;
          });
          return firebase.database().ref().update(updates)
          .then(function(){
            userDataService.trackEvent('added-team-admin');
            vm.updateMember(member)
          })
        }//setAsTeamMember

        vm.removeAsTeamAdmin = function(member){
          var updates = {};
          _.each(vm.membersClients, function(client){
            updates['/clients/' + client.uid + '/access/teamAdmins/' + member.uid] = null;
          });
          return firebase.database().ref().update(updates)
          .then(function(){
            userDataService.trackEvent('removed-team-admin');
            vm.updateMember(member)
          })
        }//setAsTeamMember

        vm.changeMemberStatus = function(member){
          //using our fallback because for some reason we aren't getting a user with getLoggedInUser here. Pffft.
          teamDataService.changeMemberStatus(member, $rootScope.userID);
          vm.memberForm.$pristine = true;
        };

        vm.removeMember = function(member,event){
          // confirm they want to delete
          var confirm = $mdDialog.confirm()
                    .title('Are you sure you want to remove ' + member.email + '?')
                    .htmlContent('<p>This member will be removed from your team.<br>Any time they have logged will remain untouched.</p>')
                    .ariaLabel('Remove Member')
                    .targetEvent(event)
                    .ok('Remove')
                    .cancel('cancel');

              $mdDialog.show(confirm).then(function() {
                teamDataService.removeMember(member, vm.team.ownerID);
                userDataService.trackEvent('remove-team-member');
                // deselect our member detail
                $timeout(function(){teamDataService.deselectMember();}, 500);
              }, function() {
              });

        }

        vm.openClient = function(clientUID){
            // $log.info('vm.openClient: ' + client);
            $state.go("triangular.workspaces.information(clientID: clientUID)")
            // return clientDataService.getClient(clientID)
            // .then(function(thisClient){
            //     // $log.info(thisClient);
            //     return clientDataService.clientDialog(thisClient);
            // })
        }

        vm.saveMemberNote = function(member){
          teamDataService.saveMemberNote(member, $rootScope.userID);
          vm.memberForm.$pristine = true;
          vm.memberForm.$dirty = false;
        }

        vm.updateMember = function(member){
          vm.memberForm.$pristine = true;
          vm.memberForm.$dirty = false;
          vm.editMode = false;
          teamDataService.updateMember(member)
          // the following was temporarily implemented when updating a member was wiping out the First/Last names on other member cards.
          // Apparently, it was just a bug in my browser tab and it isn't ACTUALLY a problem.
          // But since it took forever to figure out, leaving this in case we need to employ it at a future date.
          // .then(function(){
          //   // need to reselect the team and then the user
          //   $timeout(function(){
          //     teamDataService.selectTeam(vm.team);
          //   },0)
          //   .then(function(){
          //     $timeout(function(){
          //       teamDataService.selectTeamMember(vm.member);
          //     }, 0)
          //   })

          // });
          // store latest saved in originalMember
          vm.originalMember = angular.fromJson(angular.toJson(vm.member));
        }

        vm.editMemberNote = function(){
          vm.memberForm.$pristine = false;
          vm.memberForm.$dirty = true;
        }

        vm.revokeInvite = function(member){
            userDataService.trackEvent('revoke-team-invitation');
            teamDataService.revokeInvite(member);
            teamDataService.deselectMember();
        };

        vm.resendInvite = function(member, team){
            var memberCopy = _.clone(member);
            userDataService.trackEvent('resend-team-invitation');
            teamDataService.revokeInvite(memberCopy);
            teamDataService.inviteMember(memberCopy.email, team);
            teamDataService.selectedMember = null;
        };

        function updateCurrency(currencyLabel){
          _.each(vm.currencies, function(currency){
            if(currency.code == currencyLabel){
              $timeout(function(){
                vm.member.currency = currency.symbol;
                vm.member.currencyLabel = currency.code;
              })
            }
          })
        }


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('teamCard', teamCard);


     function teamCard() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: teamCardController,
         scope: {
           team: '='
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {

       scope.getTemplateUrl = function() {

        // if needsSetup use the setup team template
        if(scope.vm.team.needsSetup){
            return 'app/app-directives/team/setup-team-card.tmpl.html';
        } else {
            return 'app/app-directives/team/team-card.tmpl.html';
        }

       };

     }// linkFunc

    /* @ngInject */
    function teamCardController($rootScope, $timeout, $scope, $log, $mdDialog, clientDataService, userDataService, teamDataService) {
        var vm = this;

        // return userDataService.getLoggedInUser()
        // .then(function(user){
        //   vm.user = user});

        vm.user = userDataService.user;
        vm.settings = $rootScope.userSettings;
        vm.teamDataService = teamDataService;
        vm.userID = $rootScope.userID;

        vm.userType = $rootScope.admin;
        vm.fbConfig = fbConfig;

        vm.userCount = _.size(vm.team.members);

        // Get team member counts
        vm.activeMembers = 0;
        vm.disabledMembers = 0;
        _.each(vm.team.members, function(member){
            if(member.status == 'active'){
                vm.activeMembers ++;
            } else {
                vm.disabledMembers ++
            }
        });


        vm.editTeam = function(team){

        }

        vm.selectTeam = function(team){
            vm.teamDataService.selectTeam(vm.team);
        }

        vm.isTeamSelected = function(){
            if(vm.teamDataService.selectedTeam){
                if(vm.teamDataService.selectedTeam.ownerID == vm.team.ownerID){
                    return true
                }
            }
        }

        vm.upgrade = function(){
            // $state.go('authentication.profile', {selectedTab: 3});
            $mdDialog.show({
                controller: 'subscriptionDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/gateService/subscription-dialog.tmpl.html',
                locals: {
                  thisTitle: 'Upgrade Options',
                  message: 'Upgrade your account to support adding team members'
                },
                focusOnOpen: true,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }


        vm.editTeam = function(team){
            $mdDialog.show({
                controller: 'teamEditDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/teamDataService/dialog-edit-team.tmpl.html',
                locals:{
                    team: team
                },
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });
        }

        vm.setupTeam = function(team){
            // $log.info('setup team');
            $mdDialog.show({
                controller: 'teamEditDialogController', // see below
                controllerAs: 'vm',
                locals:{
                    team: team
                },
                // bindToController: true,
                templateUrl: 'app/app-services/teamDataService/dialog-edit-team.tmpl.html',
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });

        }

    }// controller



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskTime', taskTime);


  function taskTime() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskTimeController,
      scope: {
        task: '@task',
        client: '@client',
        local: '@local'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-time/task-time.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskTimeController($log, hotkeys, timeDataService, userDataService, teamDataService, $rootScope, taskDataService, $scope, $firebaseArray,  localStorageService, $mdDialog) {
    // $log.info('taskTimeController');

    var vm = this,
        taskID = vm.task,
        clientID = vm.client;
        vm.newNote = undefined;
        vm.notes = [];
        vm.totalLogged = 0;
        vm.userID = $rootScope.userID;

        // Check to see if current user is admin or member so we can restrict which time entries they can see here
        if(_.has(teamDataService, 'clientTeams')){
          if(_.keys(teamDataService.clientTeams).length > 0){
            if(_.has(teamDataService.clientTeams[vm.client], $rootScope.userID)){
              vm.role = teamDataService.clientTeams[vm.client][$rootScope.userID].role;
            } else {
              // not part of a team - we own this one.
              vm.role = 'admin'
            }

          // we are on a team
         } else {
          // we are not on a team
          vm.role = 'admin'
         }
        } // assign role to memeber for this client




        // Restrict non-admins from seeing other's time
        $scope.timeEntryFilter = function(entry){
          if (vm.role == 'admin' || vm.role == 'owner'){
            return true
          } else if (entry.creator == vm.userID) {
            return true
          } else {
            return false
          }
        }

        // // Setup our hotkeys
        // hotkeys.bindTo($scope)
        //     // inhibit enter from submitting
        //     .add({
        //       combo: 'enter',
        //       callback: function(event) {
        //         event.preventDefault();
        //         // $log.info('enter blocked');
        //       }
        //     })
        //     .add({
        //       combo: 'ctrl+enter',
        //       allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        //       description: 'Save/Update Note',
        //       callback: function(event) {
        //         // $log.info('ctrl+enter');
        //         event.preventDefault();
        //         // $log.info($scope.clientDialogForm);
        //         var pristine = $scope.vm.taskNoteForm.$pristine,
        //             invalid = $scope.vm.taskNoteForm.$invalid;

        //             if (!pristine && !invalid){
        //                 $scope.addTaskNote($scope.vm.newNote);
        //             }
        //         }
        //     });



          var timeRef = firebase.database().ref().child('/tasks/' + taskID + '/time');
          $firebaseArray(timeRef)
          .$loaded(function(data){
            // $log.info(data);
            // only overwrite notes if there's something there.
            if (data){
              vm.timeLogs = data;
                // calculate our totalLogged
                _.each(vm.timeLogs, function(entry){
                  vm.totalLogged += entry.logged;
                });
              }

            });


            $scope.cancelDialog = function(){
                $mdDialog.hide();
            }



    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('appItem', appItem);


    function appItem() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: appItemController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            link: linkFunc,
            // Populate the template via ng-include
            template: '<div ng-include="getTemplateUrl()"></div>'
        };
        return directive;
    }
    ;

    // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        scope.getTemplateUrl = function () {
            return 'app/app-directives/task-item/app-item-task.tmpl.html';
        };
    }


    ///////////////////////////////////////////////////////////
    /// appItemController

    /* @ngInject */
    function appItemController($q, gateService, $mdMenu, teamDataService, clientDataService, $log,  $mdToast, userDataService, $rootScope, $scope, taskDataService, taskTemplateDataService, $timeout, timeDataService, $filter, timerDataService, localStorageService, $window) {
        var vm = this;
        vm.userType = $rootScope.admin;
        vm.userDataService = userDataService;
        vm.user =userDataService.user;
        vm.settings = $rootScope.userSettings;
        vm.fbConfig = fbConfig;
        // setup minDate for any calendar controls
        var d = new Date();
         vm.minDate = d;

         vm.canUseTimer = gateService.gateData.canUseTimer;

         vm.today = new Date();

         // determine if user is clientUser for this workspace
            vm.isClientUser = false;
            if(_.has($rootScope, 'VAWorkspaces')){
                if(_.has($rootScope.VAWorkspaces, $scope.item.client)){
                        vm.isClientUser = true;
                }
            }
         // Isolate the team for this client
         // if(_.has(teamDataService.clientTeam, $scope.item.client)){
         //    vm.teamList = teamDataService.clientTeams[$scope.item.client];
         // } else {
         //    // let's wait a couple secs and check again
         //    vm.teamList = teamDataService.clientTeams[$scope.item.client];
         //    // $timeout(function(){

         //    // }, 2000);
         // }

         // get our snooze duration if we have one
         if(_.has($scope.item, 'snooze')){

            var now = moment(),
                then = moment($scope.item.snooze),
                difference = moment.duration(now.diff(then)),
                minutes = difference.minutes(),
                duration =  moment.duration({"minutes": minutes}).humanize();
                if(minutes > -50){
                    vm.snoozeExpiry = 'for ' + duration;
                } else {
                    vm.snoozeExpiry = 'for an hour or more'
                }
         };


         vm.isImage = function(file){
           var validExtensions = [
               'jpg',
               'gif',
               'png',
               'bmp',
               'JPG',
               'BMP',
               'GIF',
               'PNG',
               'jpeg',
               'JPEG'
               ],
             extension = file.fileName.split('.').pop();

           // if this file's extension is valid, return true
           if (_.includes(validExtensions,extension)){
             return true
           } else {
             return false
           }
         }// isImage

         vm.pickDueDate = function(date){
            var thisDate;

            switch(date) {
                case '0':
                    thisDate = 'none';
                    break;
                case '1d':
                    thisDate = moment().add(1, 'day').startOf('day').add(8,'hours').toISOString();
                    break;
                case '2d':
                    thisDate = moment().add(2, 'day').startOf('day').add(8,'hours').toISOString();
                    break;
                case '3d':
                    thisDate = moment().add(3, 'day').startOf('day').add(8,'hours').toISOString();
                    break;
                case '7d':
                    thisDate = moment().add(7, 'day').startOf('day').add(8,'hours').toISOString();
                    break;
                default:
                     thisDate = moment(date).startOf('day').add(8,'hours').toISOString();
                     break;
                }

            setDueDate(thisDate);
            $mdMenu.hide();
            $mdMenu.hide();
         }

         function setDueDate(date){
            // $log.info('Set Due date to: ' + date);
            taskDataService.setDueDate(date, $scope.item);
         }// set Due Date

         vm.processTaskLink = function(url, target, $event){
            $event.stopPropagation();
            if(url.startsWith('http')){
                if(target){
                    $window.open(url, '_blank');
                } else {
                    $window.location.href = url;
                }
            } else {
                // it's not a link. Should trigger an experience
                userpilot.trigger(url);
            }
         }//vm.processTaskLink


        vm.isTimerRunning = function (task) {
            // Doing double-checking here to avoid all possible conflicts in how we are using task cards
            if(_.has(timerDataService, 'timerData.activeTimer.on') && _.has(timerDataService, 'timerData.activeTimer.task')){
                if (timerDataService.timerData.activeTimer.on && timerDataService.timerData.activeTimer.task.uid == task.refID){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }

        vm.hasOpenTimers = function(task){
            if(_.find(timerDataService.timerData.timers, function(o) {
                // make certain this timer has a task before we check and throw an error
                if(_.has(o, 'task')){
                    return o.task.uid == task.refID;
                }
            })){
                return true
            }
        }

        vm.assigneeName = function(assignee){
            // $log.info('looking up:' + assignee);
            _.each(teamDataService.clientTeams[$scope.item.client], function(member){
                if(member.uid == assignee){
                    return member.profile.fullName
                }
            })
        }



        vm.assigneeAvatar = function(assignee){
            // $log.info('looking up:' + assignee);
            _.each(teamDataService.teamList, function(member){
                if(member.uid == assignee){
                    return member.profile.fullName
                }
            })
        }

        // the following value is used to show time logged in individual task cards
        // while the timer is running.
        // if it's not running, we are just showing total logged time.

        $scope.getColor = function (clientID) {
            return clientDataService.clientColor(clientID)
        }

        $scope.clientName = function (clientID) {
            return clientDataService.clientName(clientID)
        }

        $scope.startTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('startTimer Clicked on Task');
            timerDataService.newTaskTimer(task);

        }

        $scope.logTime = function (task, $event) {
            $event.stopPropagation();
           var newTimeEntry = timeDataService.newLogEntry(task.client, task.refID);
           timeDataService.timeDialog(newTimeEntry, 'Log');
        }

        $scope.pauseTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('$scope.pauseTimer', task);
            timerDataService.pauseTaskTimer(task);
        }

        $scope.resumeTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('$scope.resumeTimer', task);
            timerDataService.resumeSavedTaskTimer(task);
        }

        // // startTimer
        $scope.toggleToday = function (task, $event) {
            // $log.info('toggleToday - directive');
            $event.stopPropagation();
            taskDataService.toggleToday(task);

        };

        $scope.snoozeTask = function(task, minutes, $event){
            $event.stopPropagation();
            taskDataService.snoozeTask(task, minutes);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Task has been snoozed',
                        message: 'It will reappear in '  + moment.duration({"minutes": minutes}).humanize() ,
                        color: 'green'
                    }
                }));// mdToast
        }// snoozeTask

        $scope.unSnoozeTask = function(task, $event){
            $event.stopPropagation();
            taskDataService.unSnoozeTask(task)
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: 'Task has been un-Snoozed',
                            message: '' ,
                            color: 'green'
                        }
                    }));// mdToast
        }// unsnoozeTask

        // general moveTask
        $scope.moveTask = function (item, panel) {
            // $log.info('toggleToday - directive');
            taskDataService.moveTask(item, panel);

        };

        // change completed status
        $scope.toggleCompleted = function (item, $event) {
            $event.stopPropagation();
            // if we have open timers, alert to close them first
            if (!vm.hasOpenTimers(item)){
                if (item.status != 'closed') {
                    item.showComplete = true;
                } else {
                    item.showComplete = false;
                }
                // console.log('apptItemDirective: toggleCompleted for: ' + item);
                $timeout(function () {
                    taskDataService.toggleComplete(item);
                }, 250); // 1/2 second delay so user received visual indicator of closed task before it disappears

            } else {
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: 'Task has open timers!',
                            message: 'You have open timers for this task. Complete or discard them before completing the task.' ,
                            color: 'orange'
                        }
                    }));// mdToast
            }

        };

        // Edit a task
        $scope.editTask = function (item, targetTab, $event) {
            $event.stopPropagation();

                // $log.info('editTask');
                // item.highlight=true;
                // Show task was clicked
                // item.clicked = true;
                // // Remove visual after timer delay
                // $timeout(function(){
                //     item.clicked = false;
                // },1000);

                return taskDataService.getTask(item.refID)
                .then(function(editedItem){

                    // convert our due date into a date object for md-date-picker
                    if (editedItem.info.duedate) {
                        editedItem.info.duedate = new Date(editedItem.info.duedate);
                    }
                    // send it to our dialog
                    taskDataService.taskDialog(editedItem, targetTab);
                    // item.clicked = false;
                })

        }; // End editTask

        // Edit a task
        $scope.editTaskTemplate = function (item,$event) {
            $event.stopPropagation();
            // $log.info('editTask');
            // item.highlight=true;
            // Show task was clicked
            item.clicked = true;
            // // Remove visual after timer delay
            // $timeout(function(){
            //     item.clicked = false;
            // },1000);

            return taskTemplateDataService.getTaskTemplate(item.parentTemplate)
            .then(function(editedItem){

                // // convert our due date into a date object for md-date-picker
                // if (editedItem.info.duedate) {
                //     editedItem.info.duedate = new Date(editedItem.info.duedate);
                // }
                // send it to our dialog
                taskTemplateDataService.taskTemplateDialog(editedItem, 0);
                item.clicked = false;
            })
            // var taskInfo = angular.copy(item),
            //         // fake a "task" shell so our dual purpose dialog
            //         // works without worse hacks
            //         editedItem = {uid: item.refID};
            // editedItem.info = taskInfo;
        }; // End editTask

        // Copy a task
        $scope.copyTask = function (item, $event) {
            $event.stopPropagation();
            // setup our editedItem
            var editedItem = {};

            // Get full task from server (not the .info version in item)
            return taskDataService.getTask(item.refID)
            .then(function(originalTask){
                // make a copy
                var taskCopy = angular.fromJson(angular.toJson(originalTask));
                delete taskCopy.info.closedDate;
                delete taskCopy.info.userCompleted;
                delete taskCopy.info.clientCompleted;
                delete taskCopy.info.acountCompleted;
                taskCopy.info.status = 'open';
                // if has snooze, remove it
                if(_.has(taskCopy.snooze)){
                    delete taskCopy.snooze;
                }
                // Take out the firebase-assigned properties
                ajUTILITIES.removePropertiesWith(taskCopy);

                // set flag so we know we are dealing with a clone
                taskCopy.clone = true;

                // Remove this task's unique history
                delete taskCopy.uid;
                delete taskCopy.info.refID;
                delete taskCopy.activity;
                taskCopy.info.order = 1000;
                delete taskCopy.info.allOrder;
                delete taskCopy.info.todayOrder;
                taskCopy.info.numnotes = 0;
                delete taskCopy.notes;
                delete taskCopy.time;
                taskCopy.info.logged = 0;

                // if no budget, make sure it's set to zero
                if(!_.has(taskCopy, 'info.budget')){
                    taskCopy.info.budget = 0;
                }

                // If there's a duedate, convert it into a date object
                if(_.has(taskCopy.info, 'duedate')){
                    // $log.info(taskCopy.info.duedate);
                    taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                }

                // send it to dialog for modification and saving
                taskDataService.taskDialog(taskCopy);
            });


        }; // End copyTask


        $scope.restoreArchivedTask = function(item, $event){
            var updates = {};
            var userID = $rootScope.userID;
            if(_.has(item, 'assignee')){
                userID = item.assignee;
            }
            item.archived = false;
            // update canonical
            updates['/tasks/' + item.refID + '/info/archived'] = false;
            // add to assignee
            // updates['/users/' + userID + '/tasks/' + item.refID] = item;
            // add to client
            updates['/clients/' + item.client + '/tasks/' + item.refID] = item;
             return firebase.database().ref().update(updates)
            .then(function(){
                $rootScope.$emit('loadArchived', item.client);
              return 'success'
            }, function(error){
              return error
            });
        }

        // Turn a task into a template
        $scope.makeRecurring = function (item, $event) {
            $event.stopPropagation();
            // setup our editedItem
            var editedItem = {};

            // Get full task from server (not the .info version in item)
            return taskDataService.getTask(item.refID)
            .then(function(originalTask){
                // make a copy
                var taskCopy = angular.fromJson(angular.toJson(originalTask));

                // Take out the firebase-assigned properties
                ajUTILITIES.removePropertiesWith(taskCopy);

                // set flag so we know we are dealing with a clone
                taskCopy.clone = true;

                // Remove this task's unique history
                delete taskCopy.uid;
                delete taskCopy.info.refID;
                delete taskCopy.activity;
                taskCopy.info.order = 1000;
                delete taskCopy.info.allOrder;
                delete taskCopy.info.todayOrder;
                taskCopy.info.numnotes = 0;
                taskCopy.info.logged = 0;
                delete taskCopy.notes;
                delete taskCopy.time;
                delete taskCopy.info.start;

                // if no budget, make sure it's set to zero
                if(!_.has(taskCopy, 'info.budget')){
                    taskCopy.info.budget = 0;
                }

                // If there's a duedate, convert it into a date object
                if(_.has(taskCopy.info, 'duedate')){
                    // $log.info(taskCopy.info.duedate);
                    taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                }

                // send to taskData who will get a new template, merge, and create the template.
                return taskDataService.makeRecurring(taskCopy)

                // // send it to dialog for modification and saving
                // taskDataService.taskDialog(taskCopy);
            });


        }; // End copyTask


        // Turn a task into a template
        $scope.makeTemplate = function (item, $event) {
            $event.stopPropagation();
            // setup our editedItem
            var editedItem = {};

            // Get full task from server (not the .info version in item)
            return taskDataService.getTask(item.refID)
            .then(function(originalTask){
                // make a copy
                var taskCopy = angular.fromJson(angular.toJson(originalTask));

                // Take out the firebase-assigned properties
                ajUTILITIES.removePropertiesWith(taskCopy);

                // set flag so we know we are dealing with a clone
                taskCopy.clone = true;

                // Remove this task's unique history
                delete taskCopy.uid;
                delete taskCopy.info.refID;
                delete taskCopy.activity;
                taskCopy.info.order = 1000;
                delete taskCopy.info.allOrder;
                delete taskCopy.info.todayOrder;
                taskCopy.info.numnotes = 0;
                delete taskCopy.notes;
                delete taskCopy.time;
                delete taskCopy.info.start;

                // if no budget, make sure it's set to zero
                if(!_.has(taskCopy, 'info.budget')){
                    taskCopy.info.budget = 0;
                }

                // If there's a duedate, convert it into a date object
                if(_.has(taskCopy.info, 'duedate')){
                    // $log.info(taskCopy.info.duedate);
                    taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                }

                // send to taskData who will get a new template, merge, and create the template.
                return taskDataService.makeTemplate(taskCopy)
                .then(function(){
                    // alert('template created');

                })

                // // send it to dialog for modification and saving
                // taskDataService.taskDialog(taskCopy);
            });


        }; // End copyTask

        // change completed status
        $scope.deleteTask = function (task, $event) {
            $event.stopPropagation();
            var taskname = task.description;
            // console.log('toggleCompleted for: ' + task.taskname);
            taskDataService.removeTask(task);
        };

        $scope.canFocus = function (task) {
            return true
            // if (!task.duedate) {
            //     // if there's not a duedate on a task, then the focus control should always appear
            //     return true
            // } else {

            //     var today = moment(),
            //             dueDate = moment(task.duedate),
            //             difference = dueDate.diff(today, 'hours');
            //     if (difference >= 23) {
            //         return true
            //     }
            // }

        }// canFocus


        $scope.taskProgress = function(logged, budget){
            var progress = (logged/budget)*100;
            progress = progress.toFixed(0);
            progress = Number(progress);
            return progress
        }


        $scope.isClose = function (logged, budget) {
            var progress = logged/budget;
            if (budget > 0 && progress > .75 && progress <= 1) {
                return true
            }
        }


        $scope.isOver = function (logged, budget) {
            var progress = logged/budget;
            if (budget > 0 && progress > 1) {
                return true
            }
        }

        $scope.isNear = function (due, status) {
            var today = moment(),
                    dueDate = moment(due),
                    difference = dueDate.diff(today, 'hours');
            if (difference < 48 && difference > 0 && status == 'open') {
                return true
            }
        }

        $scope.difference = function(due, status){
            var today = moment(),
            dueDate = moment(due),
            difference = dueDate.diff(today, 'hours');
            return difference
        }

        $scope.isDue = function (due, status) {
            var today = moment(),
                    dueDate = moment(due),
                    difference = dueDate.diff(today, 'hours');
            if (difference < 1 && status == 'open') {
                return true
            }
        }

        // The following functions handle splitting our task description into
        // first line, and the rest
        // so we can bold the first line on display (up to first linebreak)
        // but still keep it stored as a plain string with no formatting.

        $scope.firstLine = function (taskDescription) {
            var firstLineText = taskDescription.split('\n')[0];
            return firstLineText
        }

        $scope.restLines = function (taskDescription) {
            // break the textblock into an array of lines
            var restLinesText = taskDescription.split('\n');
            // remove one line, starting at the first position
            restLinesText.splice(0, 1);
            // join the array back into a single string
            var newText = restLinesText.join('\n');
            return newText
        }




    } //end appItemController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskTemplateCard', taskTemplateCard);


  function taskTemplateCard() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskTemplateCardController,
      scope: {
        template: '=template'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-template-card/task-template-card.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskTemplateCardController($log, $rootScope, rrule, taskTemplateDataService, taskDataService, clientDataService, $scope, $firebaseArray, $mdDialog) {
    // $log.info('taskTemplateCardController');
    // $log.info(this);
    var vm = this,
        // vm.template is already here for us
        taskID = vm.task,
        clientID = vm.client;
        vm.userType = $rootScope.admin;
        vm.fbConfig = fbConfig;

        // Only figure out our rules if we have them.
        if (vm.template.isRecurring && _.has(vm.template, 'schedule.repeatRule')){
          vm.rule = RRule.fromString(vm.template.schedule.repeatRule);
          vm.ruleInEnglish = vm.rule.toText();

          // Make sure we are displaying next date correctly
          // vm.displayNextCreateDate = vm.template.schedule.nextCreateDate;
          // var nextCreateDate = moment().unix(vm.template.schedule.nextCreateDate);
          vm.displayNextDueDate = moment(vm.template.schedule.nextDueDate).format('dddd, MMM DD, YYYY');
        } else {
          vm.rule = "";
          vm.ruleInEnglish = "No recurring schedule defined.";
        }

        // $log.info(vm);

        vm.isImage = function(file){
          var validExtensions = [
              'jpg',
              'gif',
              'png',
              'bmp',
              'JPG',
              'BMP',
              'GIF',
              'PNG',
              'jpeg',
              'JPEG'
              ],
            extension = file.fileName.split('.').pop();

          // if this file's extension is valid, return true
          if (_.includes(validExtensions,extension)){
            return true
          } else {
            return false
          }
        }// isImage


        vm.editTemplate = function(template){
          // $log.info('editing');
          // $log.info(template);
          return taskTemplateDataService.getTaskTemplate(template.uid)
          .then(function(thisTemplate){
            taskTemplateDataService.taskTemplateDialog(thisTemplate);
          });
        }

        $scope.deleteTemplate = function(template){
          // var taskname = item.taskname;
          // console.log('toggleCompleted for: ' + item.taskname);
          return taskTemplateDataService.deleteTaskTemplate(template);

        }// $scope.delete
        $scope.clone = function(template){
          return taskTemplateDataService.getTaskTemplate(template.uid)
          .then(function(thisTemplate){
            var clone = ajUTILITIES.removePropertiesWith(thisTemplate);;
            // remove any template-only values
            delete clone.type;
            delete clone.schedule;
            delete clone.isRecurring;
            delete clone.uid;
            delete clone.info.refID;
            // delete clone.$id;
            // delete clone.$priority;
            // delete clone.$key;
            clone.focus = 'someday';
            clone.info.panel = 'Later';
            clone.info.order = 1;
            clone.created = moment().unix();
            taskDataService.taskDialog(clone);
          });

        }

      $scope.getColor = function (clientID) {
          return clientDataService.clientColor(clientID)
      }

      $scope.clientName = function (clientID) {
          return clientDataService.clientName(clientID)
      }
      $scope.firstLine = function (taskDescription) {
          var firstLineText = taskDescription.split('\n')[0];
          return firstLineText
      }

      $scope.restLines = function (taskDescription) {
          // break the textblock into an array of lines
          var restLinesText = taskDescription.split('\n');
          // remove one line, starting at the first position
          restLinesText.splice(0, 1);
          // join the array back into a single string
          var newText = restLinesText.join('\n');
          return newText
      }
          // var timeRef = firebase.database().ref().child('/tasks/' + taskID + '/time');
          // $firebaseArray(timeRef)
          // .$loaded(function(data){
          //   // only overwrite notes if there's something there.
          //   if (data){
          //     vm.timeLogs = data;

          //       // calculate our totalLogged
          //       _.each(vm.timeLogs, function(entry){
          //         vm.totalLogged += entry.logged;
          //       });
          //     }

          //   });



    }// taskTemplateCardController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskNotes', taskNotes);

    /* @ngInject */
  function taskNotes($rootScope) {

    var directive = {
      restrict: 'E',
      replace: false,
      controller: taskNotesController,
      scope: {
        task: '@task',
        client: '@client'
      },
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


    scope.getTemplateUrl = function() {
        return 'app/app-directives/task-notes/task-notes.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function taskNotesController($log, hotkeys, $timeout, $rootScope, teamDataService, taskDataService, noteDataService, userDataService, $scope, $firebaseArray,  localStorageService, $mdDialog) {
    // $log.info('taskNotesController');



    $scope.vm.thisClient = angular.fromJson($scope.vm.client);

    $scope.vm.thisTask = angular.fromJson($scope.vm.task);

    var taskID = $scope.vm.thisTask.uid,
        clientID = $scope.vm.thisClient.uid;
        $scope.vm.newNote = undefined;
        $scope.vm.notes = [];

        init();

        function init(){
          getTeamList();

        }// init
        function getTeamList(){
            $timeout(function(){
                // repopulate $rootScope.currentTeamList
                $scope.vm.teamList = teamDataService.clientTeams[clientID];
                // assign $rootScope.currentTeamList
                $scope.vm.teamListLoading = false;
            },0);
        }

        // Setup our hotkeys
        hotkeys.bindTo($scope)
            // inhibit enter from submitting
            // .add({
            //   combo: 'enter',
            //   callback: function(event) {
            //     event.preventDefault();
            //     // $log.info('enter blocked');
            //   }
            // })
            // .add({
            //   combo: 'ctrl+enter',
            //   allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            //   description: 'Save/Update Note',
            //   callback: function(event) {
            //     $log.info(event);
            //     // $log.info('ctrl+enter');
            //     event.preventDefault();
            //     // $log.info($scope.taskNoteForm);
            //     var pristine = $scope.$scope.vm.taskNoteForm.$pristine,
            //         invalid = $scope.$scope.vm.taskNoteForm.$invalid;

            //         if (!$pristine && !invalid){
            //             $scope.addTaskNote($scope.$scope.vm.newNote);
            //         }
            //     }
            // });

        // $log.info('About to load tasks for taskID:' + taskID);
          var notesRef = firebase.database().ref().child('/tasks/' + taskID + '/notes');
          $firebaseArray(notesRef)
          .$loaded(function(data){
            // only overwrite notes if there's something there.
            if (data){
              $scope.vm.notes = data;
              $scope.vm.numnotes = $scope.vm.notes.length;
            }
          })


          $scope.vm.clearNote = function(){
            $scope.vm.newNote = undefined;
          }
            $scope.vm.cancelDialog = function(){
                $mdDialog.hide();
            }


           $scope.vm.addTaskNote = function(newNote) {
               $scope.vm.numnotes = $scope.vm.numnotes + 1;
               noteDataService.saveNote(newNote, $scope.vm.thisTask, clientID, $scope.vm.numnotes, $scope.vm.teamList)
               .then(function(response){
                newNote.body = "";
                newNote.notifyClient = false;
                  //heap.track('New Task Note Saved');
                   taskDataService.setupNotes();
               });

           }; // addTaskNote



    }


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskMenu', taskMenu);


  function taskMenu() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: taskMenuController,
      scope: {
        selectedTask: '=selectedtask',
        x: '=x',
        y: '=y',
        boardData: '=board',
        role: '=role'
      },
      controllerAs: 'vm',
      bindToController: true,
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/task-board/task-menu.tmpl.html'
    };
    return directive;
  };

  // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
  function linkFunc(scope, element, attr) {
    // block user from scrolling board when menu is open
    $('.adminja-board-container').css('overflow-x', 'hidden');
    // block user from rearranging tasks while menu is open
    $('.board-column-content').addClass('drag-disabled');
    // block vertical scrolling while menu is open
    $('.board-column-content-wrapper').removeClass('small-scrollbar');
    $('.board-column-content-wrapper').css('overflow-y', 'hidden');
  } // linkFunc

  /* @ngInject */
  function taskMenuController($timeout, $rootScope, $scope, firebase, $log, $mdToast, $mdDialog, clientDataService, timerDataService, userDataService, timeDataService, taskDataService, taskTemplateDataService, hotkeys) {
    $log.info('taskMenuController');

    var vm = this;
    vm.fbConfig = fbConfig;
    vm.userType = $rootScope.admin;
    vm.user = userDataService.user;
    vm.settings = $rootScope.userSettings;
    vm.init = init;
    vm.editTask = editTask;
    vm.pickDueDate = pickDueDate;
    vm.cloneTask = cloneTask;
    vm.makeRecurring = makeRecurring;
    vm.makeTemplate = makeTemplate;
    vm.deleteTask = deleteTask;
    vm.today = new Date();
    vm.setPriority = setPriority;
    vm.canDelete = canDelete;

    function init(){
      // $log.info('taskMenu Init');

    }//init


    function pickDueDate(date, menu){
      var thisDate;

      switch(date) {
          case '0':
              thisDate = 'none';
              break;
          case '1d':
              thisDate = moment().add(1, 'day').startOf('day').add(8,'hours').toISOString();
              break;
          case '2d':
              thisDate = moment().add(2, 'day').startOf('day').add(8,'hours').toISOString();
              break;
          case '3d':
              thisDate = moment().add(3, 'day').startOf('day').add(8,'hours').toISOString();
              break;
          case '7d':
              thisDate = moment().add(7, 'day').startOf('day').add(8,'hours').toISOString();
              break;
          default:
               thisDate = moment(date).startOf('day').add(8,'hours').toISOString();
               break;
          }

      setDueDate(thisDate);
      $timeout(function(){
        vm.taskMenuOpen = false;
        vm.selectedTask = null;
      });
    }//pickDueDate

    function canDelete(taskData){
      // $log.info('can we delete?');
      if(!timerDataService.hasTimer(taskData)){
        // $log.info('yes');
        return true
      } else {
        // $log.info('no');
        return false
      }
    }//canDelete

    function setDueDate(date){
       // $log.info('Set Due date to: ' + date);
       taskDataService.setDueDate(date, vm.selectedTask);
    }// set Due Date

    function setPriority(priority){
      taskDataService.setPriorityFlag(priority, vm.selectedTask)

        $timeout(function(){
          vm.taskMenuOpen = false;
          vm.selectedTask = null;
        }, 100);

    }//setPriority

    function editTask (item, targetTab, $event) {
        $event.stopPropagation();

            // $log.info('editTask');
            // item.highlight=true;
            // Show task was clicked
            // item.clicked = true;
            // // Remove visual after timer delay
            // $timeout(function(){
            //     item.clicked = false;
            // },1000);

            return taskDataService.getTask(item.uid)
            .then(function(editedItem){

                // convert our due date into a date object for md-date-picker
                if (_.has(editedItem.info, 'duedate')) {
                    editedItem.info.duedate = new Date(editedItem.info.duedate);
                }
                // send it to our dialog
                taskDataService.taskDialog(editedItem, targetTab);
                vm.selectedTask = null;
                // item.clicked = false;
            })

    }; // End editTask


    function cloneTask(item,$event) {
             $event.stopPropagation();
             // setup our editedItem
             var editedItem = {};

             // Get full task from server (not the .info version in item)
             return taskDataService.getTask(item.uid)
             .then(function(originalTask){
                 // make a copy
                 var taskCopy = angular.fromJson(angular.toJson(originalTask));
                 delete taskCopy.info.closedDate;
                 delete taskCopy.info.userCompleted;
                 delete taskCopy.info.clientCompleted;
                 delete taskCopy.info.acountCompleted;
                 taskCopy.info.status = 'open';
                 // if has snooze, remove it
                 if(_.has(taskCopy.snooze)){
                     delete taskCopy.snooze;
                 }
                 // Take out the firebase-assigned properties
                 ajUTILITIES.removePropertiesWith(taskCopy);

                 // set flag so we know we are dealing with a clone
                 taskCopy.clone = true;

                 // Remove this task's unique history
                 delete taskCopy.uid;
                 delete taskCopy.info.refID;
                 delete taskCopy.activity;
                 taskCopy.info.order = taskCopy.info.order + .5;
                 taskCopy.info.allOrder = taskCopy.info.allOrder + .5;
                 delete taskCopy.info.todayOrder;
                 taskCopy.info.numnotes = 0;
                 delete taskCopy.notes;
                 delete taskCopy.time;
                 taskCopy.info.logged = 0;

                 // if no budget, make sure it's set to zero
                 if(!_.has(taskCopy, 'info.budget')){
                     taskCopy.info.budget = 0;
                 }

                 // If there's a duedate, convert it into a date object
                 if(_.has(taskCopy.info, 'duedate')){
                     // $log.info(taskCopy.info.duedate);
                     taskCopy.info.duedate = new Date(taskCopy.info.duedate);
                 }

                 // send it to dialog for modification and saving
                 taskDataService.taskDialog(taskCopy, 0, true);

                 $timeout(function(){
                   vm.selectedTask = null;
                 })
               });
    }; // End cloneTask

    function makeTemplate(item, $event){
      $event.stopPropagation();
      // setup our editedItem
      var editedItem = {};

      // Get full task from server (not the .info version in item)
      return taskDataService.getTask(item.uid)
      .then(function(originalTask){
          // make a copy
          var taskCopy = angular.fromJson(angular.toJson(originalTask));

          // Take out the firebase-assigned properties
          ajUTILITIES.removePropertiesWith(taskCopy);

          // set flag so we know we are dealing with a clone
          taskCopy.clone = true;

          // Remove this task's unique history
          delete taskCopy.uid;
          delete taskCopy.info.refID;
          delete taskCopy.activity;
          taskCopy.info.order = 1000;
          delete taskCopy.info.allOrder;
          delete taskCopy.info.todayOrder;
          taskCopy.info.numnotes = 0;
          delete taskCopy.notes;
          delete taskCopy.time;
          delete taskCopy.info.start;

          // if no budget, make sure it's set to zero
          if(!_.has(taskCopy, 'info.budget')){
              taskCopy.info.budget = 0;
          }

          // If there's a duedate, convert it into a date object
          if(_.has(taskCopy.info, 'duedate')){
              // $log.info(taskCopy.info.duedate);
              taskCopy.info.duedate = new Date(taskCopy.info.duedate);
          }

          // send to taskData who will get a new template, merge, and create the template.
          return taskDataService.makeTemplate(taskCopy)
          .then(function(){
              // alert('template created');
              $timeout(function(){
                vm.selectedTask = null;
              })

          })
        });
    }// makeTemplate

    function makeRecurring(item, $event){
          $event.stopPropagation();
          // setup our editedItem
          var editedItem = {};

          // Get full task from server (not the .info version in item)
          return taskDataService.getTask(item.uid)
          .then(function(originalTask){
              // make a copy
              var taskCopy = angular.fromJson(angular.toJson(originalTask));

              // Take out the firebase-assigned properties
              ajUTILITIES.removePropertiesWith(taskCopy);

              // set flag so we know we are dealing with a clone
              taskCopy.clone = true;

              // Remove this task's unique history
              delete taskCopy.uid;
              delete taskCopy.info.refID;
              delete taskCopy.activity;
              taskCopy.info.order = 1000;
              delete taskCopy.info.allOrder;
              delete taskCopy.info.todayOrder;
              taskCopy.info.numnotes = 0;
              taskCopy.info.logged = 0;
              delete taskCopy.notes;
              delete taskCopy.time;
              delete taskCopy.info.start;

              // if no budget, make sure it's set to zero
              if(!_.has(taskCopy, 'info.budget')){
                  taskCopy.info.budget = 0;
              }

              // If there's a duedate, convert it into a date object
              if(_.has(taskCopy.info, 'duedate')){
                  // $log.info(taskCopy.info.duedate);
                  taskCopy.info.duedate = new Date(taskCopy.info.duedate);
              }

              // send to taskData who will get a new template, merge, and create the template.
              taskDataService.makeRecurring(taskCopy)

              $timeout(function(){
                vm.selectedTask = null;
              })
          });

    }//makeRecurring


    // change completed status
    function deleteTask(task, $event) {
        $event.stopPropagation();
        taskDataService.removeTask(task);
        $timeout(function(){
          vm.selectedTask = null;
        })
    };



    $scope.$on('$destroy', function() {
            $('.adminja-board-container').css('overflow-x', 'scroll');
            $('.board-column-content').removeClass('drag-disabled');
            $('.board-column-content-wrapper').addClass('small-scrollbar');
            $('.board-column-content-wrapper').css('overflow-y', 'scroll');
         });

    }// taskMenuController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('taskBoard', taskBoard);


  function taskBoard() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: taskBoardController,
      scope: {
        boardID: '=boardid',
        thisClient: '=client'
      },
      controllerAs: 'vm',
      bindToController: true,
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/task-board/task-board.tmpl.html'
    };
    return directive;
  };

  // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
  function linkFunc(scope, element, attr) {} // linkFunc

  /* @ngInject */
  function taskBoardController($timeout, $rootScope, $mdSidenav, $templateCache, $scope, firebase, $log, triLoaderService, $mdToast, $mdDialog, taskDataService, clientDataService, userDataService, timeDataService, taskTemplateDataService, timerDataService, teamDataService, hotkeys, kanbanService) {
    $log.info('taskBoardController');
    triLoaderService.setLoaderActive(true);
    // Setup scope
    var vm = this;
    var recurringErrorMessage = "This recurring task did not get upgraded properly. Please notify help@getadminja.com and we will fix it asap."
    vm.triLoaderService = triLoaderService;
    vm.fbConfig = fbConfig;
    vm.userType = $rootScope.admin;
    vm.listCount = 0;
    vm.user = userDataService.user;
    vm.colors = $rootScope.boardColors;
    vm.settings = $rootScope.userSettings;
    vm.forms = {};
    vm.priorityFilter = 'none';
    vm.userFilter = 'all';
    vm.searchTerm = '';
    vm.sortBy = 'order';
    // Scope Functions
    vm.init = init;
    vm.quickTask = quickTask;
    vm.newList = newList;
    vm.scrollEnd = scrollEnd;
    vm.filterItems = filterItems;
    vm.sortItems = sortItems;
    vm.deleteList = deleteList;
    vm.closeListMenu = closeListMenu;
    vm.closeTaskMenu = closeTaskMenu;
    vm.toggleSidePanel = toggleSidePanel;
    vm.updateList = updateList;
    vm.saveList = saveList;
    vm.selectListColor = selectListColor;
    vm.selectBoardColor = selectBoardColor;
    vm.undoUpgrade = undoUpgrade;
    vm.listMenuNewTask = listMenuNewTask;
    vm.batchTasks = batchTasks;
    vm.newTaskFromTemplate = newTaskFromTemplate;
    vm.updateBoard = updateBoard;
    vm.resetTaskSearch = resetTaskSearch;
    vm.duplicateList = duplicateList;
    vm.markAllComplete = markAllComplete;
    vm.toggleElementVisibility = toggleElementVisibility;
    vm.cleanupMuuri = cleanupMuuri;
    vm.undoAllUpgrades = undoAllUpgrades;

    // taskBoard Variables
    // declare our grid variables so they available to all functions
    var columnGrids = [],
      boardElement,
      boardGrid,
      boardRef,
      dragContainer = document.querySelector('.drag-container'),
      boardContainer = document.querySelector('.adminja-board-container'),
      itemDrag = {},
      columnDrag = {},
      resizeTimer,
      changedWatchers = {},
      addedWatchers = {},
      removedWatchers = {},
      boardLayout;

      vm.setupComplete = false;

      // Persistent listener
      // Set our resize listener
     window.addEventListener('resize', windowResize, false);

         function windowResize(e){
           clearTimeout(resizeTimer);
           resizeTimer = setTimeout(function() {
             resizeBoard();
           }, 1000);
         }//windowResize



      // get our userRole defined
      vm.userRole = 'owner';

      if(_.has(teamDataService, 'clientTeams')){
        setRole();
        init();
      } else {
        $timeout(function(){
          setRole()
        },1000)
        .then(function(){
          init();
        })
      }


    /////////////////////////////
    // Main Functions
    function init() {
      vm.boardData = undefined;
      columnGrids = [];
      boardGrid = undefined;
      boardElement = undefined;
      vm.setupComplete = false;
      // Get the initial board data & init our taskBoard
      boardRef = firebase.database().ref('taskBoards').child(vm.boardID);
      boardRef.once('value', function(snapshot) {
        vm.boardData = snapshot.val();
        // sort the lists so we don't need to rely on muuri to sort them initially
        vm.boardData.lists = _.sortBy(vm.boardData.lists,
          [function(o) { return o.order; }]);
        // Make sure our board dimensions are set
        resizeBoard();
        if(_.has(kanbanService, 'taskTemplate')){
          boardLayout = {
                      horizontal: true,
                      fillGaps: true,
                    }
          if(_.has(vm.settings, 'verticalTaskPanels')){
              if(vm.settings.verticalTaskPanels){
                  boardLayout = {
                     horizontal: false,
                     fillGaps: false,
                  }
              }
          }
          // Set our initial board and column heights
          resizeBoard();

          // Instantiate the main board grid so we can drag those
          initializeMainBoard();

          // add our lists to the board
          _.each(vm.boardData.lists, function(list) {

            // make sure user is allowed to see list
            var shouldDisplay = false;
            if(vm.userRole != 'client'){
              shouldDisplay = true;
            } else {
              // this is a client user. make sure the list is enabled
              if(list.clientEnabled){
                shouldDisplay = true;
              }
            }
            if(shouldDisplay){
                addList(list);
            }
          });

          // Setup our Listeners
          boardElement = document.querySelector('.board');
          boardContainer = document.querySelector('.adminja-board-container');
          setupListeners();

          hotkeys.add({
            combo: 'esc',
            description: 'Escape',
            allowIn: ['TEXTAREA'],
            callback: function(event, hotkey) {
              event.preventDefault();
              $log.info('escape');
              if(vm.taskMenuOpen){
                closeTaskMenu();
              }
              if(vm.taskFormVisible && vm.taskFormParentGrid){
                closeQuickTaskForm();
              }
            }
          });
          hotkeys.add({
              combo: 'ctrl+enter',
              allowIn: ['TEXTAREA'],
              description: 'Save Task',
              callback: function (event) {
                  $log.info('ctrl+enter');
                  event.preventDefault();
                  if(vm.taskFormVisible){
                    saveQuickTask();
                  }
              }
          });
          hotkeys.add({
              combo: 'ctrl+alt+f',
              description: 'Find and Filter',
              callback: function (event) {
                  $log.info('Find & Filter');
                  vm.toggleSidePanel('board');
              }
          });


          // Get our team members for team filter list
          if(_.has(teamDataService.clientTeams, vm.thisClient.uid)){
              vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
          }
          setupWatchers();
          // make sure we have proper dimensions so horizontal scroll appears if necessary
          $timeout(function() {
            _.each(columnGrids, function(grid){
              grid.refreshItems().layout();
            });
            boardGrid.refreshItems().layout();
            triLoaderService.setLoaderActive(false);
            $timeout(function(){
              resizeBoard();
            }, 1000)
            .then(function(){
              if(_.has(vm.boardData, 'isMigration')){
                if(vm.boardData.isMigration){
                  updateColumnSort();
                  firebase.database().ref('/taskBoards/' + vm.boardData.uid + '/isMigration').set(null);
                }
              }
              boardGrid.sort('order', {layout: 'instant'});
              vm.setupComplete = true;
              $timeout(function(){
                vm.listCount = _.size(boardGrid.getItems());
              },0)
            })
          }, 500)

        } else {
          return kanbanService.init()
          .then(function(){
            init();
          })
        }
      });

    } //init

    function updateColumnSort() {
      return new Promise(function(resolve, reject) {
        var columns = boardGrid.getItems(),
          updates = {};
        _.each(columns, function(column) {
          var columnElem = column.getElement(),
            columnItemContainer = columnElem.querySelector('.board-column-content'),
            index = boardGrid.getItems().indexOf(column),
            uid = columnElem.getAttribute('data-id');
            if(uid && uid != 'undefined'){
              var order = index;
              if(column.getElement().getAttribute('data-type') == 'closed'){
                order = 1000;
              }
              // Add to DB changes
              updates['/taskBoards/' + vm.boardID + '/lists/' + uid + '/order'] = order;
              updates['/clients/' + vm.thisClient.uid + '/taskBoards/' + vm.boardID + '/lists/' + uid + '/order'] = order;
            }
        });

        return firebase.database().ref().update(updates)
          .then(function() {
            boardGrid.synchronize();
            return resolve(resetDragData())
          })
          .catch(function(error) {
            throwError(error);
          })
      });
    } //updateColumnSort

    function addList(listData, suppressAnimation) {
      // $log.info('addList');
      if(_.has(listData, 'uid')){
        if(listData.uid != 'undefined'){
          // Create the column element.
          // sort each list's items so we don't need to rely on muuri to sort them initially
          listData.items = _.sortBy(listData.items,
            [function(o) { return o.order; }]);
          var wrapper = document.createElement('div');
          var columnHTML = kanbanService.newTaskListElement(listData, vm.boardData.settings, vm.userRole);
          wrapper.innerHTML = columnHTML;

          // Add the column to the DOM
          var columnElem = wrapper.children[0];

          if (!suppressAnimation) {
            initColumn(columnElem, listData); // init this column's grid
          } else {
            fastInitColumn(columnElem, listData)
          }
        }
      }// if list is valid

    } // addList

    function removeList(list) {
      _.each(boardGrid.getItems(), function(item) {
        var gridID = item.getElement().getAttribute('data-id');
        if (list.uid == gridID) {
          boardGrid.remove([item], { removeElements: true });
          // boardGrid.refreshItems();
          // boardGrid.layout();
        }
      });
    } //removeList

    function quickTask(parentElement, event) {
        $log.info('quickTask');
        hotkeys.add({
            combo: 'ctrl+enter',
            allowIn: ['TEXTAREA'],
            description: 'Save Task',
            callback: function (event) {
                $log.info('ctrl+enter');
                event.preventDefault();
                if(vm.taskFormVisible){
                  saveQuickTask();
                }
            }
        });
      $timeout(function(){
        var wrapper = document.createElement('div');
        var taskFormHTML = '<div class="quick-task-container board-item" data-id="new-task">' +
          '<form onsubmit="saveQuickTask()" class="quick-task-form">' +
            '<textarea class="quick-task-description" name="quicktaskdescription"></textarea>'+
            '<div class="quick-task-controls">'+
              '<p class="right"><a class="quick-task-save-button">Add</a></p>' +
              '<p class="right hotkey-label" style="padding-right: 1em;">ctrl + enter</p>'+
            '</div>' +
          '</form>'+
        '</div>';
        wrapper.innerHTML = taskFormHTML;

        // Add the column to the DOM
        vm.taskFormElement = wrapper.children[0];
        // get the parentID
        var parentID = parentElement.getAttribute('data-id');

          // find the parentGrid
          _.each(columnGrids, function(grid) {
            if (grid.getElement().getAttribute('data-id') == parentID) {
              vm.taskFormParentGrid = grid;
            }
          });

            vm.taskFormParentGrid.add([vm.taskFormElement], { index: 0 });
            vm.taskFormVisible = true;

            // auto-focus on the textarea
          $( ".quick-task-form .quick-task-description" ).focus();


      });
    }//quickTask

    function saveQuickTask(){
      return new Promise(function(resolve, reject){
        //Get quicktaskdescription so we can save it
        var taskDescription = $( ".quick-task-form .quick-task-description" ).val(),
          listID = vm.taskFormParentGrid.getElement().getAttribute('data-id');

        // only continue if we have description and list
        if(taskDescription.length > 0 && listID){
          // determine if we will need to scroll to position after saving
          var scrollAfter = false,
              boardWidth = $('.board').outerWidth(true), // widest
              contentWidth = $('.adminja-board-container').outerWidth(true),
              scrollPosition = $('.adminja-board-container').scrollLeft() + event.screenX; // where clicked
              // if new task triggered near end of board, we will need to scroll to it after this update due to muuri jumping
              if (scrollPosition >= (boardWidth - 50)) {
                scrollAfter = true;
              }
              closeQuickTaskForm();

              // Update the sort on existing items (starting at 2)
              var parentItems = vm.taskFormParentGrid.getItems(),
                updates = {},
                order = 1;

              _.each(parentItems, function(item) {
                var itemElement = item.getElement(),
                  itemID = itemElement.getAttribute('data-id')
                updates['/taskBoards/' + vm.boardID + '/lists/' + listID + '/items/' + itemID + '/order'] = order;
                // update the main task
                updates['/tasks/' + itemID + '/info/order'] = order;
                order++
              });
              return firebase.database().ref().update(updates)
                .then(function() {
                  // now add our task with order of 1
                  var newTask = taskDataService.newTask(vm.thisClient.uid, listID);
                  newTask.info.description = taskDescription;
                  newTask.info.order = 0;
                  return resolve(taskDataService.saveNew(newTask))
                })
                .catch(function(error) {
                  throwError(error);
                })
        }// if valid quickTask
        else {
          closeQuickTaskForm();
        }

      });
    }//saveQuickTask

    function deleteList(listID) {
      var updates = {};
      updates['/taskBoards/' + vm.boardID + '/lists/' + listID] = null;
      updates['/clients/' + vm.thisClient.uid + '/taskBoards/' + vm.boardID + '/lists/' + listID] = null;
      return firebase.database().ref().update(updates)
        .then(function() {
          // // $log.info('deleted list: ' + listID);
          // _.each(vm.boardData.lists, function(list, index){
          //   if(list.uid == listID){
          //     delete vm.boardData.lists[index]
          //   }
          // })
          updateColumnSort();
          vm.toggleSidePanel();
        })
    } //deleteLIst

    function newList(boardID) {
      $timeout(function() {
        vm.selectedList = {
          label: undefined,
          color: '#aba9a9',
          type: 'custom'
        }
      }).then(function() {
        vm.toggleSidePanel('list');
      })
    } //newList

    function saveList(list) {
      $log.info('saveList');
      var newKey = firebase.database().ref().child('taskBoards/' + vm.boardID + '/lists').push().key,
        newOrder = _.size(boardGrid.getItems()) - 1;
      list.order = newOrder;
      list.uid = newKey;
      $log.info(_.size(boardGrid.getItems()) + ' lists. This list will take position ' + newOrder);
      // make suer our current sort is stored
          var updates = {};
          updates['/taskBoards/' + vm.boardID + '/lists/' + newKey] = list;
          // add it to client's taskPanels so it's available in our dropdowns.
          updates['/clients/' + vm.thisClient.uid + '/taskBoards/' + vm.boardID + '/lists/' + newKey] = {
            uid: newKey,
            label: list.label,
            color: list.color,
            type: list.type,
            order: list.order
          };
          // $log.info(updates);
          return firebase.database().ref().update(updates)
            .then(function() {
              boardGrid.sort('order', {layout: 'instant'});
              updateColumnSort();
              vm.toggleSidePanel();
              $timeout(function() {
                vm.scrollEnd();
              }, 0);
            })
            .catch(function(error) {
              throwError(error);
            })

    } //saveList

    function updateList(list) {
      if(list.uid){
        if (!_.has(list, 'color')) {
          list.color = '#bbb';
        }
        var updates = {};
        updates['/taskBoards/' + vm.boardID + '/lists/' + list.uid + '/label'] = list.label;
        updates['/taskBoards/' + vm.boardID + '/lists/' + list.uid + '/color'] = list.color;
        // add it to client's taskPanels so it's available in our dropdowns.
        updates['/clients/' + vm.thisClient.uid + '/taskBoards/' + vm.boardID + '/lists/' + list.uid + '/label'] =  list.label;
        updates['/clients/' + vm.thisClient.uid + '/taskBoards/' + vm.boardID + '/lists/' + list.uid + '/color'] =  list.color;
        return firebase.database().ref().update(updates)
          .then(function() {
            // we aren't watching for list changes, just additions, removals, and task changes
            // Therefore: We should update the DOM to reflect the changes
              var listElement = $('.board-column[data-id=' + list.uid + ']');
              $(listElement).attr('data-order', list.order);
              $(listElement).find('.board-column-header').css('background-color', list.color);
              $(listElement).find('.board-column-title').text(list.label);
              boardGrid.refreshSortData();
              vm.toggleSidePanel();
          })
          .catch(function(error) {
            throwError(error);
          })
      } else {
        throwError('Oops! There was a problem. Please refresh your browser.')
      }
    } //updateList

    function toggleElementVisibility(){
      return updateBoard()
      .then(function(){
          cleanupMuuri();
         init();
        // re-init Grid
      })
    }//toggleElementVisibility

    function updateBoard(){
      return new Promise(function(resolve, reject){
        $timeout(function(){
          vm.boardUpdating = true;
        })
        .then(function(){
          var updates = {};
          updates['/taskBoards/' + vm.boardID + '/settings'] = vm.boardData.settings;
          updates['/clients/' + vm.boardData.workspace + '/taskBoards/' + vm.boardID + '/settings'] = vm.boardData.settings;
          return firebase.database().ref().update(updates)
            .then(function() {
              $log.info('board settings updated');
              return resolve(true);
              // location.reload()
            })
            .catch(function(error) {
              reject(throwError(error));
            })
        })
      })

    }//updateBoard

    function fastInitColumn(columnElem, listData) {
      var contentElem = columnElem.querySelector('.board-column-content');
      boardGrid.add([columnElem], { index: listData.order });
      instantiateColumn(contentElem, listData);
    } //fastInitColumn

    function initColumn(columnElem, listData) {
      var contentElem = columnElem.querySelector('.board-column-content');

      boardGrid.show(
        boardGrid.add([columnElem], {
          active: false,
          index: listData.order
        }), {
          onFinish: function(){
            // Instantiate grid
            instantiateColumn(contentElem, listData)
          }
        }
      )
    } // initColumn

    function instantiateColumn(contentElem, listData) {
      // $log.info('instantiate column grid!');
      var grid = new Muuri(contentElem, {
          items: '.board-item',
          layout: boardLayout,
          layoutDuration: 400,
          layoutOnResize: 200,
          layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          // layoutEasing: 'none',
          dragEnabled: true,
          dragSort: function() {
            return columnGrids;
          },
          dragSortPredicate: function(item) {
            var thisGrid = item.getGrid(),
              gridElem = thisGrid.getElement(),
              itemID = item.getElement().getAttribute('data-id'),
              defaultPredicate = Muuri.ItemDrag.defaultSortPredicate(item, {
                action: 'move',
                threshold: 20,
                delay: 250
              });
            // if list is drag-disabled && itemDrag.sourceGridID != listID
            // we need to be able to drag things in and out of closed list without dropping them.
            if (($(gridElem).closest('.board-column').hasClass('drag-disabled') && itemDrag.sourceGridID == $(gridElem).closest('.board-column').attr('data-id')) || itemID == 'new-task') {
              return false
            } else {
              return defaultPredicate
            }

          },
          dragSortInterval: 200,
          dragContainer: dragContainer,
          dragReleaseDuration: 1000,
          dragReleaseEasing: 'ease',
          dragSortHeuristics: {
            sortInterval: 0,
            minDragDistance: 10,
            minBounceBackAngle: 1
          },
          dragPlaceholder: {
            enabled: true,
            createElement: null,
            onCreate: null,
            onRemove: null
          },
          dragStartPredicate: {
            distance: 20,
            delay: 0
          },
          dragAutoScroll: {
            targets: function(item){
              return [
                window,
                {
                  element: boardContainer,
                  priority: 1,
                  axis: Muuri.AutoScroller.AXIS_X,
                },
                {
                  element: item.getGrid().getElement().parentNode,
                  priority: 1,
                  axis: Muuri.AutoScroller.AXIS_Y,
                },
              ];
            }
          },
          hideDuration: 0,
          showDuration: 0,
          sortData: {
            order: function(item, element) {
              return Number(element.getAttribute('data-order')) || '';
            },
            due: function(item, element) {
              return element.getAttribute('data-due') || '2050-01-01T00:00:00+0000';
            },
            priority: function(item, element) {
              return element.getAttribute('data-priority') || 1000;
            },
            title: function(item, element) {
              return element.getAttribute('data-title') || '';
            },
            assignee: function(item, element) {
              return element.getAttribute('data-assignee') || '';
            },
          }

        })
        .on('dragStart', function(item, event) {
          // Let's set fixed widht/height to the dragged item
          // so that it does not stretch unwillingly when
          // it's appended to the document body for the
          // duration of the drag.
          // disable text selection on drag (safari bug)
          if (window.getSelection) {window.getSelection().removeAllRanges();}
          else if (document.selection) {document.selection.empty();}

          item.getElement().style.width = item.getWidth() + 'px';
          item.getElement().style.height = item.getHeight() + 'px';

          // define some of our itemDrag properties
          itemDrag.itemID = item.getElement().getAttribute('data-id');
          // we don't want to do anything if new task form dragged
          if(itemDrag.itemID != 'new-task'){
            itemDrag.item = item;
            itemDrag.sourceGrid = item.getGrid();
            itemDrag.sourceGridID = itemDrag.sourceGrid.getElement().getAttribute('data-id');
            itemDrag.sourceIndex = itemDrag.sourceGrid.getItems().indexOf(item);
            itemDrag.sourceScroll = $(itemDrag.sourceGrid.getElement()).closest('.board-column-content-wrapper').scrollTop();
            // Get the item's data
              _.each(vm.thisClient.tasks, function(listItem) {
                if (listItem.uid == itemDrag.itemID) {
                  itemDrag.itemData = listItem;
                }
              })
          }
        })
        // .on('layoutStart', function () {
        //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
        // })
        .on('receive', function(data) {
          // add targetGrid information to itemDrag
          itemDrag.targetGrid = data.toGrid;
          itemDrag.targetGridID = data.toGrid._element.getAttribute('data-id');
          itemDrag.targetScroll = $(itemDrag.targetGrid.getElement()).closest('.board-column-content-wrapper').scrollTop();
          itemDrag.sourceGrid.refreshItems().layout();
          itemDrag.targetGrid.refreshItems().layout();
          boardGrid.refreshItems().layout();
        })
        .on('dragReleaseEnd', function(item) {
          if(itemDrag.itemID != 'new-task'){
            // If item has been moved, add targetIndex to itemDrag object
            if (itemDrag.targetGrid) {
              itemDrag.targetIndex = itemDrag.targetGrid.getItems().indexOf(item);
              if (itemDrag.targetGridID == 'excluded') {
                itemDrag.targetGrid.send(itemDrag.targetIndex, itemDrag.sourceGrid, itemDrag.sourceIndex);
                return resetDragData()
              }
            }
            // Process the new task position
            return updateTaskDrop(itemDrag)
              .then(function() {
                // restore the scroll position of source and target
                  $('.board-column-content[data-id='+itemDrag.sourceGridID+']').closest('.board-column-content-wrapper').scrollTop(itemDrag.sourceScroll);
                  if(itemDrag.targetGrid){
                    $('.board-column-content[data-id=' + itemDrag.targetGridID + ']').closest('.board-column-content-wrapper').scrollTop(itemDrag.targetScroll);
                  }

                  resetDragData();
              })
          }
        });


      columnGrids.push(grid);

      // setup change listeners for this board
      var listRef = firebase.database().ref('taskBoards/' + vm.boardID + '/lists/' + listData.uid + '/items');
      changedWatchers[listData.uid] = listRef.on('child_changed', function(snapshot){
        // $log.info('taskWatch: task changed. ListID: ' + listData.uid);
        var newTask = snapshot.val();
        // $log.info(newTask.status);
        updateTask(newTask, grid);
      })

      addedWatchers[listData.uid] = listRef.on('child_added', function(snapshot){
        // $log.info('taskWatch: task added. ListID: ' + listData.uid);
        var newTask = snapshot.val();
        // we want to add all new tasks EXCEPT tasks that were dragged into closed (they have open status and need toggled)
        if(listData.uid == vm.boardData.closedList && newTask.status != 'closed'){
          return taskDataService.toggleStatus(newTask);
        } else if(!itemDrag.item) {
          addNewTask(grid, newTask, newTask.order, vm.boardData.settings);
          // update boardData
        }

        // add/update data in boardData;
        _.each(vm.boardData.lists, function(list){
          if(list.uid == listData.uid){
            var found = false;
            // we don't want to add it if it's already there (just a double-check)
            _.each(list.items, function(item){
              if(item.uid == newTask.uid){
                found = true;
              }
            });
            if(!found){
              if(!_.has(list, 'items')){
                list.items = [];
              }

              list.items.push(newTask);
            }
          }
        });

      })
      removedWatchers[listData.uid] = listRef.on('child_removed', function(snapshot){
        // $log.info('taskWatch: task removed. ListID: ' + listData.uid);
        var removedTask = snapshot.val();
        _.each(columnGrids, function(grid){
          if(grid.getElement().getAttribute('data-id') == removedTask.list){
            _.each(grid.getItems(), function(item){
              if(item.getElement().getAttribute('data-id') == removedTask.uid){
                grid.remove([item], {removeElements: true});
              }
            })

          }
        })

        // remove task from boardData
        _.each(vm.boardData.lists, function(list){
          if(list.uid == listData.uid){
            // filter removedTask from array
            list.items = list.items.filter(function( obj ) {
                return obj.uid !== removedTask.uid;
            });
          }
        });
      })
      resizeBoard();
    } //instantiateColumn

    function updateTask(taskData, grid){
      // $log.info('updateTask');

      // Update the model (regardless if we need to refresh the task)
      _.each(vm.boardData.lists, function(list){
        if(list.uid == taskData.list){
          if(!_.has(list, 'items')){
            list.items = {};
          }
            list.items[taskData.uid] = taskData;
          }
      });

      var listID = grid.getElement().getAttribute('data-id');

      if(vm.setupComplete){
        var shouldUpdate = true;
        // was this the result of a drag operation?
        if(itemDrag.item){
          // if it wasn't dragged out of sourceGrid, we shouldn't update
          if(!itemDrag.targetGridID){
              shouldUpdate = false;
            }
          // if it was dragged out of sourceGrid BUT ended up back in sourceGrid, we shouldn't update
          if(itemDrag.targetGridID){
            if(itemDrag.targetGridID == itemDrag.sourceGridID){
              shouldUpdate = false;
            }
          }
        }


        if(shouldUpdate){
          // utility to monitor ordering before refreshing
          // _.each(grid.getItems(), function(item){
          //   if(item.getElement().getAttribute('data-id') == taskData.uid){
          //     return getTaskData(item.getElement().getAttribute('data-id'))
          //     .then(function(taskData){
          //       var itemIndex = grid.getItems().indexOf(item);
          //       $log.info(taskData.description + ': stored: ' + taskData.order + ' index: ' + itemIndex);
          //     });
          //   }
          // });

          _.each(grid.getItems(), function(item){
              var itemIndex = grid.getItems().indexOf(item);
              if(item.getElement().getAttribute('data-id') == taskData.uid){
                  var index = grid.getItems().indexOf(item);
                  grid.remove([item], { removeElements: true });
                  addTask(grid, taskData, itemIndex, vm.boardData.settings, vm.userRole)
              }
          })
        }
      }// if setupComplete

    }//updateTask

    function addNewTask(grid, taskData,index, settings){
      // $log.info('addNewTask');
      // Update the model
      if(vm.setupComplete && !itemDrag.item){
          // update model
          _.each(vm.boardData.lists, function(list){
            if(list.uid == taskData.list){
                if(!_.has(list, 'items')){
                  list.items = {};
                }
                // if refreshing while browser is not focused setupComplete can be false when child_added kicks in, duplicating our cards.
                // here we are going to make sure we aren't adding a duplicate card
                var found = false;
                _.each(grid.getItems(), function(item){
                    if(item.getElement().getAttribute('data-id') == taskData.uid){
                      found = true;
                    }
                });
                // if card doesnt already exist, go ahead and add it
                if(!found){
                  list.items[taskData.uid] = taskData;
                  addTask(grid, taskData, index, settings);

                  // refresh task's grid
                  _.each(columnGrids, function(grid){
                    if(grid.getElement().getAttribute('data-id') == taskData.list){
                      grid.refreshItems();
                      grid.refreshSortData();
                      grid.layout();
                    }
                  })
                  boardGrid.refreshItems();
                  boardGrid.layout();
                }
              }
          });


        }
    }//addNewTask

    function addTask(grid, taskData, index, settings, userRole){
      // $log.info('addTask');
      var wrapper = document.createElement('div');
      var taskHTML = kanbanService.newTaskElement(taskData, settings, userRole);
      wrapper.innerHTML = taskHTML;
      var taskElement = wrapper.firstChild
      var newItem = grid.add([taskElement], { active: true, index: index, layout: true});
      grid.refreshSortData();
    }// addTask

    function updateTaskDrop(itemDrag) {

      return new Promise(function(resolve, reject) {
        var updates = {};
        // $log.info('Dropped from ' + itemDrag.sourceGridID + ' to ' + itemDrag.targetGridID);

        // if there's no target grid, we just need to update the order
        if (!itemDrag.targetGrid) {
          // $log.info('just reordered');
          // We only re-ordered the item in it's sourceGrid
          // prepare the order-change updates for all items in sourceGrid
          // First, check to make sure itemDrag contains sourceGrid. If not, catch and handle:
          if(itemDrag.sourceGrid){
            var sourceItems = itemDrag.sourceGrid.getItems();
            _.each(sourceItems, function(item) {
              var itemID = item.getElement().getAttribute('data-id'),
                index = sourceItems.indexOf(item);
                updates['/taskBoards/' + vm.boardID + '/lists/' + itemDrag.sourceGridID + '/items/' + itemID + '/order'] = index;
                updates['/clients/' + vm.boardData.workspace + '/tasks/' + itemID + '/order'] = index;
                // updates['/users/' + itemDrag.itemData.assignee + '/tasks/' + itemID + '/order'] = index;
                updates['/tasks/' + itemID + '/info/order'] = index;
            })
          }  else {
            $log.error('itemDrag SourceGrid missing!');
            // $log.info(itemDrag);
          }
        } else {
          //we have a failure in getting itemDrag.itemData on every derag.

          // Item has been moved to a different grid
          // $log.info('moving');
          // remove from sourcelist
          updates['/taskBoards/' + vm.boardID + '/lists/' + itemDrag.sourceGridID + '/items/' + itemDrag.itemID] = null;
          // store it's new list ini the item data
          itemDrag.itemData.list = itemDrag.targetGridID;

          // prepare updates for all items in targetGrid
          var movedItemIndex = itemDrag.targetGrid.getItems().indexOf(itemDrag.item);
          // $log.info('movedItemIndex: ' + movedItemIndex);


          // now update sort on the remaining items
          _.each(itemDrag.targetGrid.getItems(), function(targetItem) {
            var itemID = targetItem.getElement().getAttribute('data-id'), originalItemOrder = targetItem.getElement().getAttribute('data-order'),
                itemIndex = itemDrag.targetGrid.getItems().indexOf(targetItem);
            if (itemID != itemDrag.itemID) {
              // This is a sibling of the item we moved. Just update it's order.
              updates['/taskBoards/' + vm.boardID + '/lists/' + itemDrag.targetGridID + '/items/' + itemID + '/order'] = itemIndex;
              updates['/clients/' + vm.boardData.workspace + '/tasks/' + itemID + '/order'] = itemIndex;
              // updates['/users/' + itemDrag.itemData.assignee + '/tasks/' + itemID + '/order'] = itemIndex;
              updates['/tasks/' + itemID +  '/info/order'] = itemIndex;
            } else {
              // This is the item we moved. It needs added to the target list with the proper index
              itemDrag.itemData.order = itemIndex;
              updates['/taskBoards/' + vm.boardID + '/lists/' + itemDrag.targetGridID + '/items/' + itemDrag.itemID] = itemDrag.itemData;
              updates['/clients/' + vm.boardData.workspace + '/tasks/' + itemDrag.itemID + '/order'] = itemIndex;
              updates['/clients/' + vm.boardData.workspace + '/tasks/' + itemDrag.itemID + '/list'] = itemDrag.targetGridID;
              // updates['/users/' + itemDrag.itemData.assignee + '/tasks/' + itemDrag.itemID + '/order'] = itemIndex;
              // updates['/users/' + itemDrag.itemData.assignee + '/tasks/' + itemDrag.itemID + '/list'] = itemDrag.targetGridID;
              updates['/tasks/' + itemDrag.itemID +  '/info/order'] = itemIndex;
              updates['/tasks/' + itemDrag.itemID +  '/info/list'] = itemDrag.targetGridID;
            }
            // $log.info('position ' + originalItemOrder + ' moved to ' + itemIndex);

          })
        }
        // Update the database
        return firebase.database().ref().update(updates)
          .then(function() {
            // Refresh and synchronize our grids
            boardGrid.refreshItems().layout();
            // boardGrid.synchronize();

            filterItems();
            return resolve(true)
          })
          .catch(function(error) {
            throwError(error);
          })
      })
    } //updateTaskDrop

    function markAllComplete(listID){
      var skipped = 0;
      _.each(vm.thisClient.tasks, function(task){
        // make certain we aren't closing a task with open timers.
          if(task.list == listID && task.status != 'closed'){
            if(!timerDataService.hasTimer(task)){
              // $log.info('toggling');
              return taskDataService.toggleStatus(task)
            } else {
              skipped ++
            }
          }

      });
      userDataService.trackEvent('mark-all-tasks-complete');
      $mdSidenav('board-panel')
        .toggle()
      if(skipped > 0){
        alert('Some tasks have been skipped because they have open timers.')
      }
    }//markAllComplete

    function duplicateList(list, tasks){
        // $log.info('duplicateList');
        var targetWorkspaceID = vm.thisClient.uid;

        // throw up dialog
        $mdDialog
            .show({
                templateUrl: "app/app-services/taskPanelDataService/duplicate-list-picker.tmpl.html",
                clickOutsideToClose: true,
                bindToController: true,
                locals: {
                    clients: clientDataService.clients,
                    thisClient: vm.thisClient
                },
                perserveScope: true,
                controllerAs: 'vm',
                controller: 'duplicateListController'
            })
            .then(function(targetWorkspaceID) {
                return taskDataService.cloneTaskList(list,vm.thisClient.uid, targetWorkspaceID)
                .then(function(results){
                    // $log.info(results);
                    $mdToast.showSimple('Task list duplicated!');
                    $timeout(function() {
                      if(targetWorkspaceID == vm.thisClient.uid){
                        updateColumnSort();
                        vm.scrollEnd();
                      }
                      vm.toggleSidePanel();
                    }, 0);
                })
                .catch(function(error){
                    $log.info('error cloning task list');
                    $log.info(error);
                })

            });
    }//duplicateList

    function toggleStatus(taskData){
      // make certain we aren't closing a task with open timers.
      if(!timerDataService.hasTimer(taskData)){
          return taskDataService.toggleStatus(taskData);
        } else {
            alert("You have open timers for this task. Please commit or discard them first.")
        }

    }//toggleStatus

    function moveToggledTask(updatedTask){
      var moveData = {},
          item,
          targetGridID,
          targetGrid,
          sourceGridID,
          sourceGrid,
          targetGridIndex,
          sourceGridIndex,
          itemIndex;

      if(updatedTask.status == 'closed'){
          targetGridID = vm.boardData.closedList;
          sourceGridID = updatedTask.list;
        } else {
          targetGridID = vm.boardData.defaultList;
          sourceGridID = vm.boardData.closedList;
        }

        _.each(columnGrids, function(grid){
          if(grid.getElement().getAttribute('data-id') == targetGridID){
            targetGrid = grid;
            targetGridIndex = boardGrid.getItems().indexOf(targetGrid);
          }
          if(grid.getElement().getAttribute('data-id') == sourceGridID){
            sourceGrid = grid;
            sourceGridIndex = boardGrid.getItems().indexOf(sourceGrid);
            _.each(sourceGrid.getItems(), function(thisItem){
              if(thisItem.getElement().getAttribute('data-id') == updatedTask.uid){
                item = thisItem;
                itemIndex = sourceGrid.getItems().indexOf(item);
              }
            });//each items in sourcegrid
          }
        });// each grid

        sourceGrid.send(itemIndex, targetGrid, 0);

        moveData = {
          item: item,
          itemData: updatedTask,
          itemID: updatedTask.uid,
          sourceGrid: sourceGrid,
          sourceGridID: sourceGridID,
          targetGrid: targetGrid,
          targetGridID: targetGridID,
          targetIndex: 0
        }


        return updateTaskDrop(moveData)
        .then(function(){
          $log.info('Task Moved after Toggle');;
        })
        .catch(function(error){
          $log.error(error);
          throwError(error)
        });
    }//moveToggledTask

    function initializeMainBoard(){
      Muuri.defaultPacker.destroy();
      Muuri.defaultPacker = new Muuri.Packer(0);
      boardGrid = new Muuri('.board', {
          layout: {
            horizontal: true,
          },
          layoutOnInit: false,
          layoutOnResize: 200,
          layoutDuration: 300,
          layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          dragEnabled: true,
          dragContainer: dragContainer,
          dragSort: columnGrids,
          dragAxis: 'x',
          dragSortInterval: 0,
          dragHandle: '.board-column-title',
          dragStartPredicate: function(item, event) {
            // Prevent first (new tasks) column from being dragged.
            if(item.getElement().getAttribute('data-type') != 'custom'){
              return false
            }
            // if (boardGrid.getItems()[0] === item) {
            //   return false;
            // }
            return Muuri.ItemDrag.defaultStartPredicate(item, event);
          },
          dragReleaseDuration: 400,
          dragReleaseEasing: 'ease',
          dragAutoScroll: {
            sortDuringScroll: true,
            targets: function(item){
              return [
                { element: window, priority: 0 },
                { element: item.getGrid().getElement().parentNode, priority: 1 },
              ];
            }
          },
          itemDraggingClass: 'column-dragging',
          sortData: {
            order: function(item, element) {
              return parseFloat(element.getAttribute('data-order'));
            },
          }
        })
        .on('dragStart', function(item, event) {
          // disable text selection on drag (safari bug)
          if (window.getSelection) {window.getSelection().removeAllRanges();}
          else if (document.selection) {document.selection.empty();}
          columnDrag.columnID = item.getElement().getAttribute('data-id');
          columnDrag.startIndex = boardGrid.getItems().indexOf(item);
          // Let's set fixed widht/height to the dragged item so that it does not stretch unwillingly when it's appended to the document body for the duration of the drag.
          item.getElement().style.width = item.getWidth() + 'px';
          item.getElement().style.height = item.getHeight() + 'px';
        })
        .on('dragEnd', function(item, event) {
          columnDrag.targetIndex = boardGrid.getItems().indexOf(item);

          // Let's remove the fixed width/height from the dragged item now that it is back in a grid column and can freely adjust to it's surroundings.
          item.getElement().style.width = '';
          item.getElement().style.height = '';
          var closedListIndex;

          // get current index of closedGrid so we can reject the move if dragged to right of it
          _.each(boardGrid.getItems(), function(grid) {
            if (grid.getElement().getAttribute('data-type') == 'closed') {
              closedListIndex = boardGrid.getItems().indexOf(grid);
            }
          });

          closedListIndex = closedListIndex +1;

          if (columnDrag.targetIndex == 0) {
            // we don't allow drop to the left of "New Tasks" in position 0.
            boardGrid.move(0, columnDrag.startIndex);
          } else if (columnDrag.targetIndex >= closedListIndex){
            // we don't allow drop to the right of "Completed Tasks"
            boardGrid.move(columnDrag.targetIndex, columnDrag.startIndex);
          } else {
            // update the sort order in the DB
            return updateColumnSort()
              .then(function() {
                // Just in case, let's refresh the dimensions of all items
                // in case dragging the item caused some other items to
                // be different size.
                // boardGrid.refreshItems();
              })
          }
        })
      // .on('layoutStart', function () {
      //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
      // })
    }//initializeMainBoard

    function filterItems(onFinish) {
        var priorityFilter = vm.priorityFilter,
              userFilter = vm.userFilter,
              searchFieldValue = vm.searchTerm.toLowerCase();

        _.each(columnGrids, function(grid) {
          grid.filter(function(item){
              var element = item.getElement();
              // we should be checking against content of .firstline and .restlines
              // concatenate contents of both and then search against it
              var firstline = $(element).find('.firstline').text(),
                  restlines = $(element).find('.restlines').text(),
                  textToSearch = firstline;
                  if(restlines){
                    textToSearch = textToSearch + restlines
                  }

              var isSearchMatch = !searchFieldValue || (textToSearch).toLowerCase().indexOf(searchFieldValue) > -1;


              var isPriorityMatch = false;
              if(priorityFilter == 'none'){
                isPriorityMatch = true;
              } else {
                if(priorityFilter == element.getAttribute('data-priority') ){
                  isPriorityMatch = true;
                }
              }

              var isUserMatch = false;
              if(userFilter == 'all'){
                isUserMatch = true;
                } else {
                  if (userFilter == element.getAttribute('data-assignee')){
                    isUserMatch = true;
                  }
                }

              return isSearchMatch && isPriorityMatch && isUserMatch;
            }, {  }
          );
        })
    } //filterItems

    function sortItems(sortBy) {
      // refresh in case itesm have been dragged around recently
      _.each(columnGrids, function(grid) {
        grid.refreshItems();
        grid.refreshSortData();
      })
      _.each(columnGrids, function(grid) {
        if(grid){
          updateDragState(grid, sortBy);
          grid.sort(
            sortBy === 'due' ? 'due order' : sortBy === 'priority' ? 'priority title' : sortBy === 'assignee' ? 'assignee order' : 'order'
          );
        }
      });
    } // sortItems


    function archiveClosedTasks(){
      // $log.info('archiveClosedTasks');
      vm.targetListID = vm.boardData.closedList;
      var updates = {};
      _.each(columnGrids, function(grid) {
        if (grid.getElement().getAttribute('data-id') == vm.targetListID) {
          var items = grid.getItems();

          if(_.size(items) > 0){
            var confirm = $mdDialog.confirm()
                     .title('Archive all closed tasks?')
                     // .htmlContent('Your Workspace, Team and Task limits will be adjusted to the new plan. <br>If you are already over any of the new limits, you may lose access to some data.<br><strong>Note:</strong> It may take up to 5 minutes for your account to update. You WILL need to refresh your browser after the change is complete.')
                     .ariaLabel('Archive all completed tasks?')
                     .ok('Do it')
                     .cancel('Nevermind');

               $mdDialog.show(confirm).then(function() {
                  _.each(items, function(item){
                    var taskID = item.getElement().getAttribute('data-id');
                        // $log.info('working on ' + taskID);
                        _.each(vm.thisClient.tasks, function(task){
                          if(task.uid == taskID){
                            if(_.has(task, 'closedDate') && _.has(task, 'uid')){
                                updates['/tasks/' + task.uid + '/info/archived/'] = true;
                                updates['/clients/' + task.client + '/tasks/' + task.uid] = null;
                                // updates['/users/' + task.assignee + '/tasks/' + task.uid] = null;
                                updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid] = null;
                                if(_.has(task, 'creator')){
                                    // updates['/users/' + task.creator + '/tasks/' + task.uid] = null;
                                }
                            }
                          }
                        });// each client.tasks
                    });// each grid.item
                    if(_.size(updates)>0){
                      // $log.info('Archiving ' + _.size(updates) + ' tasks.');
                        return firebase.database().ref().update(updates)
                        .then(function(){
                            // alert('Completed tasks have been archived.');
                          $log.info('Archive Complete');
                          // Force (true) Refresh our client menu
                          // clientDataService.setupUserAndClientMenu(true);
                        })
                    }
               }, function() {
                // plan change cancelled
                $mdDialog.cancel();
               });
          }// if items to remove
        }
      })


    }//archiveClosedTasks

    ///////////////////////////////////////////
    /// Utility Functions

    function setRole(){
      var teamSize = _.keys(teamDataService.clientTeams[vm.thisClient.uid]).length;
      // if we have a team, check for permissions to edit otherwise, allow it
      if(teamSize > 0 && _.has(teamDataService.clientTeams[vm.thisClient.uid], $rootScope.userID)){
          vm.userRole = teamDataService.clientTeams[vm.thisClient.uid][$rootScope.userID].role;
      }
      // check if clientUser and set userRole if so
      if(_.has($rootScope, 'VAWorkspaces')){
          if(_.has($rootScope.VAWorkspaces, vm.thisClient.uid)){
                  vm.userRole = 'client';
          }
      }
    }

    function listMenuNewTask(clientID, listID) {
                // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
                var newTask = taskDataService.newTask(clientID, listID);
                newTask.info.order = -1;
                taskDataService.taskDialog(newTask);
    }

    function batchTasks(clientID, listID){
        return taskDataService.batchDialog(clientID, listID, vm.boardID);
    }

    function newTaskFromTemplate(template, panel, board) {
                userDataService.trackEvent('new-task-from-template');
                return taskTemplateDataService.getTaskTemplate(template.uid)
                         .then(function(thisTemplate){
                           var clone = ajUTILITIES.removePropertiesWith(thisTemplate);;
                           // remove any template-only values
                           delete clone.type;
                           delete clone.schedule;
                           delete clone.isRecurring;
                           delete clone.uid;
                           delete clone.info.refID;
                           // delete clone.$id;
                           // delete clone.$priority;
                           // delete clone.$key;
                           if(panel != 'new'){
                            clone.info.panel = panel;
                           }

                           clone.info.order = 0;
                           clone.info.list = vm.selectedList.uid;
                           clone.info.board = vm.boardID;
                           clone.created = moment().unix();
                           taskDataService.taskDialog(clone, 0, true);
                         });
    }//newTaskFromTemplate

    function updateDragState(grid, sortBy) {
      var gridElem = grid.getElement();
      if (sortBy === 'order') {
        gridElem.classList.remove('drag-disabled');
      } else {
        gridElem.classList.add('drag-disabled');
      }
    } //updateDragState

    function resizeBoard() {
      var contentHeight = $('.task-board-wrapper').height() - 10,
        boardHeight = contentHeight - 10; // for padding above and below
      $('.adminja-board-container').height(contentHeight);
      $('.board').height(boardHeight)
      $('.board-column').css('height', 'auto');
      if(!vm.settings.verticalTaskPanels){
        $('.board-column-content').height(boardHeight - 60);
      }
      $('.board-column-content-wrapper').height(boardHeight - 50);
      // make sure our main md-content doesn't scroll vertically
      $('md-content.triangular-content').css('overflow-y', 'hidden');
      if(vm.setupComplete){
        _.each(columnGrids, function(grid){
          grid.refreshItems().layout()
        });
        boardGrid.refreshItems().layout();
      }
    } // resizeBoard

    function throwError(error) {
      $log.error(error);
      alert('There was a problem. Please refresh. /n' + error);
    } //throwError

    function closeListMenu() {
      $('#list-menu').css('display', 'none');
      $timeout(function() {
        vm.listMenuOpen = false;
      })
    } //closeListMenu

    function closeTaskMenu() {
      $('#task-menu').css('display', 'none')
      $timeout(function() {
        vm.taskMenuOpen = false;
        vm.selectedTask = null;

      })
    } //closeTaskMenu

    function openTaskMenu(item, e){
      var rect = e.target.getBoundingClientRect();
      vm.y = rect.top - 50;
      vm.x = rect.right - 225;
      var boardWidth = $('.triangular-content').outerWidth(true);
      var boardHeight = $('.triangular-content').outerHeight(true);

      // make sure none of the menu is offscreen horizontally
      if (vm.x > (boardWidth - 300)) {
        vm.x = boardWidth - 300;
      }


      // make sure none of the menu is offscreen vertically
        if(vm.y > (boardHeight - 400)){
          vm.y = boardHeight - 450;
        }



      // this triggers the menu directive to activate and position itself
      $timeout(function(){
        vm.selectedTask = item;
        vm.taskMenuOpen = true;
      },0)
    }//openTaskMenu


    function getTaskData(taskID){
      $log.info('getTaskData');
      // for simplicity's sake, we search through client/{clientID}/tasks to find the task data.
      // this saves us from first finding the proper list AND THEN task in boardData;
      return new Promise(function(resolve, reject){
        // relying on "found" to ensure we only trigger responce ONCE
        var found = false;
        _.each(vm.thisClient.tasks, function(task){
          if(task.uid == taskID & !found){
            $log.info('found');
            found = true;
            if(_.has(task, 'refID')){
              if(task.refID != task.uid){
                return reject(alert(recurringErrorMessage))
              } else {
                return resolve(task)
              }
            } else {
              return resolve(task)
            }

          }
        });

        return reject('task-not-found')
      })
    }//getTaskData

    function scrollEnd(fast) {
      // in a timeout so it fires after existing animations/calculations finished
      $timeout(function() {
        var boardWidth = $('.board').outerWidth(true);
        if (!fast) {
          $('.adminja-board-container').animate({ scrollLeft: boardWidth }, 400);
        } else {
          $('.adminja-board-container').animate({ scrollLeft: boardWidth }, 200);
        }

      })
    }

    function editTask(taskID, targetTab){
      $log.info('edit task ' + taskID);
      return taskDataService.getTask(taskID)
          .then(function(editedItem){
            $log.info(editedItem);
              // closed tasks are not editable
              if(_.has(editedItem, 'info.uid')){
                if(editedItem.info.status == 'open'){
                  // convert our due date into a date object for md-date-picker
                  if (_.has(editedItem, 'info.duedate')) {
                      editedItem.info.duedate = new Date(editedItem.info.duedate);
                  }
                  // send it to our dialog
                  taskDataService.taskDialog(editedItem, targetTab);
                }
              } else {
                alert(recurringErrorMessage)
              }

          })
    }

    function resetDragData() {
      itemDrag = {};
      columnDrag = {};
    } //resetDragData

    function toggleSidePanel(mode) {
      if(vm.taskMenuOpen){
        vm.closeTaskMenu();
      }
      $timeout(function() {
        vm.sidePanelMode = mode;

        $mdSidenav('board-panel')
          .toggle()
          .then(function() {
            // put focus on search
            $( "#searchQuery" ).focus();
            // if we are opening board settings, remove the backdrop
            if(vm.sidePanelMode == 'board'){
              $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:none;');
            } else {
              $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:block;');
            }
          });
      })
    } //toggleSidePanel

    function selectListColor() {
      if(vm.sidePanelMode == 'list'){
        vm.forms.listForm.$setDirty();
      }
    } //selectListColor

    function selectBoardColor(){
      $log.info('selectBoardColor');
      if(vm.sidePanelMode == 'board'){
        vm.forms.boardForm.$setDirty();
        updateBoard()
        .then(function(){
          vm.showColorPicker = false;
        });
      }
    }// selectBoardColor

    function undoUpgrade(){
      var updates = {};
      updates['/clients/' + vm.thisClient.uid + '/defaultTaskBoard'] = null;
      updates['/clients/' + vm.thisClient.uid + '/defaultDetailBoard'] = null;
      updates['/clients/' + vm.thisClient.uid + '/taskBoards/'] = null;
      updates['/clients/' + vm.thisClient.uid + '/detailBoards/'] = null;
      updates['/taskBoards/' + vm.thisClient.uid] = null;
      updates['/detailBoards/' + vm.thisClient.uid] = null;
      return firebase.database().ref().update(updates)
      .then(function(){
        $timeout(function(){
          vm.boardID = null;
        })
      })
    }//undoUpgrade

    function undoAllUpgrades(){
      var updates = {};
      _.each(clientDataService.clients, function(thisClient){
        updates['/clients/' + thisClient.uid + '/defaultTaskBoard'] = null;
        updates['/clients/' + thisClient.uid + '/defaultDetailBoard'] = null;
        updates['/clients/' + thisClient.uid + '/taskBoards/'] = null;
        updates['/clients/' + thisClient.uid + '/detailBoards/'] = null;
        updates['/taskBoards/' + thisClient.uid] = null;
        updates['/detailBoards/' + thisClient.uid] = null;
      })
      return firebase.database().ref().update(updates)
      .then(function(){
        alert("All Boards Removed")
      })
    }//undoAllUpgrades

    function closeQuickTaskForm(){
      if(vm.taskFormParentGrid && vm.taskFormVisible){
        vm.taskFormParentGrid.remove(vm.taskFormParentGrid.getItems(0), { removeElements: true });
        $timeout(function(){
          vm.taskFormVisible = false;
          vm.taskFormParentGrid = null;
        })
      }
    }//closeQuickTaskForm

    function resetTaskSearch(){
      $timeout(function(){
        vm.searchTerm = '';
      })
      .then(function(){
        vm.filterItems();
      })
    }//resetTaskSearch

    function setupWatchers(){
      boardRef.child('lists').on('child_changed', function(snapshot) {
        // $log.info('list changed');
        // var updatedList = snapshot.val();
        // $log.info(updatedList);
        // boardGrid.sort('order', {layout: 'instant'})

      });

      boardRef.child('lists').on('child_removed', function(snapshot) {
        // $log.info('list removed');
        var removedList = snapshot.val();
        if(removedList.uid){
          // update the grid
          removeList(removedList);
          // update the data
          _.each(vm.boardData.lists, function(list) {
            if (list.uid == removedList.uid) {
              list = null
            }
          })
          // return updateColumnSort()
          //   .then(function() {})
        }// if removedList.uid

      });

      boardRef.child('lists').on('child_added', function(snapshot) {
        // $log.info('child added!');
        // we only want this to fire AFTER our initial setup
        if (vm.boardData && vm.setupComplete) {
          // add to boardData
          vm.boardData.lists.push(snapshot.val());

          // add to grid
          addList(snapshot.val());
          boardGrid.refreshItems();
          boardGrid.sort('order', {layout: 'instant'});
          // Make sure it's put in it's proper position
          // boardGrid.sort('order', { layout: 'instant' });
        }
      });
    }//setupWatchers

    function setupListeners() {

      // Add column item.
      boardContainer.addEventListener('click', listeners, false)
      // clicks

      $scope.$on("$destroy", function() {
        cleanupMuuri();
      });
    } //setupListeners

    function fixRecurringTask(taskID, listID){
      $log.info('fixRecurringTask');
      $log.info('TaskID: ' + taskID + '  ListID: ' + listID);
      // search the list for the task by refID not UID
      var found = false, boardTask;
      _.each(vm.boardData.lists, function(list){
        if(list.uid == listID){
          _.each(list.items, function(item, key){
            if (item.uid == taskID){
              $log.info('found by uid');

              boardTask = item;
              found = true;
            }
            if (!found && item.refID == taskID){
              $log.info('found by refID');
              boardTask = item;
              found = true;
            }
          });
        }
      });
      if(found){
        boardTask.uid = boardTask.refID;
        boardTask.errorMessage = null;
        delete boardTask.errorMessage;
        var updates = {};
        // fix it on /Clients and /Tasks
        updates['/clients/' + boardTask.client + '/tasks/' + boardTask.refID + '/uid'] = boardTask.refID;
        updates['/tasks/' + boardTask.refID + '/info/uid'] = boardTask.refID;
        // remove the bad one from the board
        updates['/taskBoards/' + boardTask.client + '/lists/' + listID + '/items/' + boardTask.refID] = boardTask;
        updates['/taskBoards/' + boardTask.client + '/lists/' + listID + '/items/' + taskID] = null;
        $log.info(boardTask);
        $log.info(_.size(updates) + ' updates to make.');
        $log.info(updates);

        firebase.database().ref().update(updates)
        .then(function(results){
          location.reload();
        })
      } else {
        $log.info('Task not found');
      }
    }//fixRecurringTask

    function listeners(e){
            // while task form is visible, nothing else can be done
              var clickHandled = false;
              // quickTask
              if (e.target.matches('.board-column-quick-task')) {
                clickHandled = true;
                closeQuickTaskForm()
                if (!vm.listMenuOpen) {
                  var gridElem = e.target.closest('.board-column').querySelector('.board-column-content');
                  quickTask(gridElem, e);
                }
              } // if listMenu Not Open

              if(e.target.matches('.task-error-message')){
                clickHandled = true;
                var taskElem = e.target.closest('.board-item');
                vm.selectedTaskID = taskElem.getAttribute('data-id');
                vm.taskListID = taskElem.getAttribute('data-list');
                fixRecurringTask(vm.selectedTaskID, vm.taskListID)
              }

              if (e.target.matches('.view-attachment')) {
                $log.info('view-attachment');
                clickHandled = true;
                }

              if (e.target.matches('.task-menu-button')) {
                clickHandled = true;
                  closeTaskMenu();
                  closeQuickTaskForm()
                  var taskElem = e.target.closest('.board-item');
                  vm.selectedTaskID = taskElem.getAttribute('data-id');
                  vm.taskListID = taskElem.getAttribute('data-list');
                  $log.info('Get data for ' + vm.selectedTaskID);
                  // get our taskData and x/y position and open task menu
                  // in a timeout so it properly triggers our menu directive
                    return getTaskData(taskElem.getAttribute('data-id'))
                    .then(function(data){
                      openTaskMenu(data, e)
                    })
                    .catch(function(error){
                      throwError('Oops! Something went wrong. Please Refresh your browser.')
                      $log.error(error);
                    });
              } // taskMenuButton Clicked


              // listMenu
              if (e.target.matches('.board-column-menu')) {
                clickHandled = true;
                // close any other menus open
                vm.closeListMenu();
                closeQuickTaskForm()
                // Open menu on new target list
                $timeout(function() {
                    vm.targetListID = e.target.closest('.board-column').getAttribute('data-id');
                    _.each(vm.boardData.lists, function(list) {
                      if (list.uid == vm.targetListID) {
                        vm.selectedList = list;
                      }
                    })
                  })
                  .then(function() {
                    vm.sidePanelMode = 'list';
                    vm.toggleSidePanel(vm.sidePanelMode);
                  })
              }

              // Archive Completed Tasks
              if (e.target.matches('.board-column-archive-closed')) {
                clickHandled = true;
                closeQuickTaskForm()
                $log.info('archivedClosed');
                archiveClosedTasks();

              }

              // user button
              if(e.target.matches('.task-card-user-button')){
                clickHandled = true;
              }

              // clicked on existing quickTaskForm
              if(e.target.matches('.quick-task-container') || e.target.matches('.quick-task-form') || e.target.matches('.quick-task-description')){
                clickHandled = true;
                $log.info('selected quick task');
              }

              // save quickTask form
              if(e.target.matches('.quick-task-save-button')){
                $log.info('save quick task');
                clickHandled = true;
                saveQuickTask();
              }//saveQuickTask form

              // toggleStatus
              if(e.target.matches('.task-card-toggle-status')){
                $log.info('toggleStatus');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                // we just need to move the data to the right place.
                return getTaskData(taskID)
                .then(function(taskData){
                  toggleStatus(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if toggleStatus

              // openFlagMenu
              if(e.target.matches('.task-card-open-flag-menu')){
                clickHandled = true;
                closeQuickTaskForm()
                $log.info('open flag menu');
              }// if openFlagMenu

              // start timer
              if(e.target.matches('.task-card-start-timer')){
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');

                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.newTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });

              }// if start timer

              // pause timer
              if(e.target.matches('.task-card-pause-timer')){
                $log.info('pause timer');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');

                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.pauseTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if pause timer

              // resume timer
              if(e.target.matches('.task-card-resume-timer')){
                $log.info('resume timer');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.resumeSavedTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if resume timer


              // log time
              if(e.target.matches('.task-card-log-time')){
                  clickHandled = true;
                  closeQuickTaskForm()
                  var taskElem = e.target.closest('.board-item'),
                      taskID = taskElem.getAttribute('data-id');
                  return getTaskData(taskID)
                  .then(function(taskData){
                    var newTimeEntry = timeDataService.newLogEntry(taskData.client, taskData.refID);
                    timeDataService.timeDialog(newTimeEntry, 'Log');
                  })
                  .catch(function(error){
                    throwError(error)
                  });
              }// if log time

              // stop timer
              if(e.target.matches('.task-card-stop-timer')){
                clickHandled = true;
                closeQuickTaskForm()
                $log.info('stop timer');
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.stopTaskTimer(taskID)
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if stop timer

              // discard timer
              if(e.target.matches('.task-card-discard-timer')){
                $log.info('discard timer');
                closeQuickTaskForm()
                clickHandled = true;
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.discardTaskTimer(taskData)
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if discard timer


              if(e.target.matches('a')){
                $log.info('link clicked');
                clickHandled = true;
              }

              // EDIT TASK
              if(!clickHandled && !vm.taskMenuOpen){
                closeQuickTaskForm()
                var taskID = $(e.target).closest('.board-item').attr('data-id');
                // only edit if we isolated the id
                if(taskID){
                  editTask(taskID);
                }
              }

              // if no click handled AND a task menu is displayed, close the task menu
              if(!clickHandled && vm.taskMenuOpen){
                closeTaskMenu();
              }// if click wasn't handled
}//listeners

    function cleanupMuuri(){
      // $log.info('clean up muuri');
      window.removeEventListener('resize', windowResize, false);
      delete vm.selectedTask
      delete vm.selectedList
      delete vm.selectedClient
      vm.sidePanelMode = 'board'
      delete vm.boardData
      vm.setupComplete = false;
      boardContainer.removeEventListener('click', listeners, false);

      // clean up here
      _.each(columnGrids, function(grid) {
        var listID = grid.getElement().getAttribute('data-id');
        var listRef = firebase.database().ref('taskBoards/' + vm.boardID + '/lists/' + listID + '/items');
        listRef.off('child_changed', changedWatchers[listID]);
        listRef.off('child_added', addedWatchers[listID]);
        listRef.off('child_removed', removedWatchers[listID]);
        _.each(grid.getItems(), function(item){
          grid.remove([item], {removeElements: true});
        })
        grid.destroy(true);
      });

      if(boardGrid){
        _.each(boardGrid.getItems(), function(list){
          boardGrid.remove([list], {removeElements: true});
        })
        boardGrid.destroy(true);
        // cleanup watchers here?
      }

    }//cleanupMuuri


  } // taskBoardController



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('subscriptionManager', subscriptionManager);


     function subscriptionManager() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: subscriptionManagerController,
         scope: {
           user: '=user'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/subscription-manager/subscription-manager.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function subscriptionManagerController($rootScope, $window, triLoaderService, $state, $scope, $log, $http, $mdDialog, $timeout, $firebaseArray, $firebaseObject, userDataService, subscriptionService) {
        var vm = this;
        // we have vm.user inherently
        vm.user = userDataService.user;

        vm.functionsURL = $rootScope.functionsURL;
        vm.functionsKey = $rootScope.functionsKey;
        vm.chargebeeSettings = $rootScope.chargebeeSettings;
        // prepare for loading our plans
        vm.plans = [];
        var plansRef = firebase.database().ref().child('/plans');


        function init(user){
          // Load up our list of plans
          $timeout(function(){
            $firebaseArray(plansRef)
            .$loaded(
                function(plans) {
                    vm.plans = plans;
                    _.each(vm.plans, function(plan){
                      if (plan.planID == vm.user.plan.content__subscription__plan_id){
                        vm.currentPlan = plan;

                        vm.currentStatus = vm.user.plan.content__subscription__status;
                        vm.cardStatus = vm.user.plan.content__customer__card_status;
                        vm.trialEnd = vm.user.plan.content__subscription__trial_end;
                        if(_.has(vm.user.plan, 'content__subscription__activated_at')){
                          vm.activeStart = vm.user.plan.content__subscription__activated_at;
                        }

                        if(vm.currentStatus == 'in_trial'){
                          var today = moment();
                          vm.remainingTrial = moment(vm.trialEnd).diff(today, 'days');
                        }

                        if(vm.currentPlan.planID.indexOf('starter') != -1){
                          vm.paidPlan = false;
                        } else {
                          vm.paidPlan = true;
                        }

                      }// if planID matches
                    })//each
                });

            vm.userID = $rootScope.userID;
            // $log.info('User: ' + vm.userID);
          },200);

          vm.showAddonForm = false;

        }// init

        init(vm.user);

        vm.getWorkspaceLimit = function(workspaceLimit){
          // We have to store an actual # of workspaces and we store 1000 for "unlimited" workspaces
          // so here we check for and do that conversion
          if(workspaceLimit > 100){
            return 'Unlimited'
          } else {
            return workspaceLimit
          }
        }

        vm.toggleAddonForm = function(){
          // $log.info('toggleAddonForm');
          if(vm.showAddonForm){
            vm.showAddonForm = false;
          } else {
            vm.showAddonForm = true;
            if(_.has(vm.user.limits, 'additionalTeamMembers')){
              vm.numUsers = Number(vm.user.limits.team) + Number(vm.user.limits.additionalTeamMembers);
            } else {
              vm.numUsers = Number(vm.user.limits.team)
            }

          }
        }

        vm.total = function(base, addons){
            return Number(base) + Number(addons)
        }

        vm.addonCosts = function(additionalUsers){
          var result = additionalUsers * 10;
          return result.toFixed(2)
        }

        vm.adjustUsers = function(amount){
          var newAmount = vm.numUsers + amount;
          // make sure it's not lowered below the base # of users for this plan
          if(newAmount < vm.user.limits.team){
            return
          } else {
            vm.numUsers = vm.numUsers + amount;
          }
        }

        vm.changeAddOns = function(number){
          vm.showAddonForm = false;
          var chargebeeAPIUrl = $rootScope.functionsURL + '/checkout?key='+ $rootScope.functionsKey + '&user=' + vm.userID +  '&addtlusers=' + Number(number) + '&method=updateUsers';
          $http.get(chargebeeAPIUrl)
              .then(function(res) {
                vm.loading = false;
                var response = res.data;
                if (response == 'success'){
                  triLoaderService.setLoaderActive(false);
                  vm.showAddonForm = false;
                  $mdDialog.show(
                       $mdDialog.alert()
                         .parent(angular.element(document.querySelector('#popupContainer')))
                         .clickOutsideToClose(true)
                         .title('Team Limit Change')
                         .htmlContent('Your team member limit has been changed to ' + (Number(number) + Number(vm.currentPlan.team)) +'. <br>Please allow 2-3 minutes for processing and then refresh your browser.')
                         .ariaLabel('Team Limit Change')
                         .ok('Got it!')
                     );

                } else {
                  $log.info(response);
                  $mdDialog.show(
                       $mdDialog.alert()
                         .parent(angular.element(document.querySelector('#popupContainer')))
                         .clickOutsideToClose(true)
                         .title('There was a problem updating your subscription')
                         .textContent('Please refresh and try again. If you continue to have trouble, please let us know at help@getadminja.com.')
                         .ariaLabel('Subscription change failed')
                         .ok('Got it!')
                     );
                }
              });

        }//changeAddons


        vm.confirmChange = function(newPlanID, currentPlanID, status){
          var confirm = $mdDialog.confirm()
                   .title('Are you sure you want to change your subscription?')
                   .htmlContent('Your Workspace, Team and Task limits will be adjusted to the new plan. <br>If you are already over any of the new limits, you may lose access to some data.<br><strong>Note:</strong> It may take up to 5 minutes for your account to update. You WILL need to refresh your browser after the change is complete.')
                   .ariaLabel('Change subscription?')
                   .ok('Continue')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
               vm.changePlan(newPlanID, currentPlanID, status);
             }, function() {
              // plan change cancelled
             });
        }//vm.changePlan

        vm.changePlanWithCheckout = function(planID){
          $log.info('changePlanWithCheckout');
          var confirm = $mdDialog.confirm()
                   .title('You are about to change your subscription')
                   .textContent('You may be asked to provide or confirm your payment information. If you are currently in trial, you will not be charged until the end of your trial.')
                   .ariaLabel('Confirm Plan Change')
                   .ok('I\'m ready to change plans')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
              var checkoutURL = vm.functionsURL + "/checkout?key=" + vm.functionsKey + "&user=" + vm.userID + "&plan=" + planID + "&method=checkout";
               $window.location.href= checkoutURL;
             }, function() {
              // plan change cancelled
             });
        }//vm.changePlan

        vm.reactivatePlan = function(planID){
          var confirm = $mdDialog.confirm()
                   .title('You are about to reactivate your subscription')
                   .textContent('You will be asked to re-enter your payment information.')
                   .ariaLabel('Confirm Reactivation')
                   .ok('I\'m ready to reactivate')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
              var reactivateURL = vm.functionsURL + "/checkout?key=" + vm.functionsKey + "&user=" + vm.userID + "&plan=" + planID + "&method=checkout&reactivate=true";
               $window.location.href= reactivateURL;
             }, function() {
              // plan change cancelled
             });
        }//vm.changePlan

        vm.changePlan = function(newPlanID, currentPlanID, status, additionalUsers){
          // if on TEAM plan and with add ons, let them know they need to remove their team member add-ons first
          if(_.has(vm.user, 'limits.additionalTeamMembers') && !newPlanID.includes('team') ){
            if(vm.user.limits.additionalTeamMembers > 0){
              alert('You are on a team plan with additional users. Please remove the additional users first.');
              return
            }
          }

          // if current plan is starter and they are switching to paid, we should changeWithCheckout
          if( (currentPlanID.includes('starter') && !newPlanID.includes('starter')) || (status == 'cancelled')){
             vm.changePlanWithCheckout(newPlanID);
            return
          } else {
            // not coming from starter, not in paid trial...just change it
            var chargebeeAPIUrl = $rootScope.functionsURL + '/checkout?key='+ $rootScope.functionsKey + '&user=' + vm.userID + '&plan=' + newPlanID + '&method=update';
            $http.get(chargebeeAPIUrl)
                .then(function(res) {
                  vm.loading = false;
                  var response = res.data;
                  if (response == 'success'){
                    triLoaderService.setLoaderActive(false);
                    $mdDialog.show(
                         $mdDialog.alert()
                           .parent(angular.element(document.querySelector('#popupContainer')))
                           .clickOutsideToClose(true)
                           .title('Subscription change succeeded')
                           .textContent('Please click "continue" to reload your data. If your limits aren\'t restored or you receive a cancelled message, wait 1-2 minutes and refresh your browser.')
                           .ariaLabel('Subscription change succeeded')
                           .ok('Continue')
                       ).then(function(){
                        // triLoaderService.setLoaderActive(true);
                        $state.go('triangular.dashboard');
                       });

                  } else {
                    $log.info(response);
                    $mdDialog.show(
                         $mdDialog.alert()
                           .parent(angular.element(document.querySelector('#popupContainer')))
                           .clickOutsideToClose(true)
                           .title('There was a problem updating your subscription')
                           .textContent('Please refresh and try again. If you continue to have trouble, please let us know at help@getadminja.com.')
                           .ariaLabel('Subscription change failed')
                           .ok('Got it!')
                       );
                  }
                });
            }

          }// vm.changePlan


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('sidebarControls', sidebarControls);


    function sidebarControls() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: sidebarControlsController,
            controllerAs: 'vm',
            bindToController: true,
            // We need to prepare the proper template url in a link function
            // link: linkFunc,
            // Populate the template via ng-include
            templateUrl: 'app/app-directives/sidebar-controls/sidebar-controls.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
// function linkFunc(scope, element, attr) {


//   }


    /* @ngInject */
    function sidebarControlsController($document, gateService, $rootScope, $log, $mdToast, $state, $timeout, angularLoad, timerDataService, localStorageService, userDataService, $scope, $stateParams, timeDataService, $window) {
        var vm = this;
        vm.config = fbConfig;
        vm.assignedClients = $scope.$resolve.clientDataService.clients;
        vm.user = userDataService.user;
        vm.userType = $rootScope.admin;
        vm.fbConfig = fbConfig;

        // In a timeout to make sure the view gets the info
        // otherwise all sorts of things are unavailable
        $timeout(function(){
            vm.gates = gateService.gateData;
            $scope.canLogTime = vm.gates.canLogTime;
            $scope.canUseTimer = vm.gates.canUseTimer;
            $scope.notificationTabIndex = 2;
            if(vm.userType == 'client'){
                $scope.notificationTabIndex = 1;
            }
        },200);

        $scope.showTimerInSidebar = false;
        if(_.has(vm.user, 'profile.settings.showTimerInSidebar')){
              $scope.showTimerInSidebar = vm.user.profile.settings.showTimerInSidebar;
            }


        $rootScope.$watch('clientID', function () {
            $scope.clientID = $rootScope.clientID;
        }, true);

//        setTimeout(function () {
//            $scope.$apply(function () {
//                vm.clients = $rootScope.clientID;
//            });
//        }, 2000);


        // check to see if we have any toasts waiting that need displayed and display them
        $timeout(function(){
            checkForToasts();
        }, 3000);

        // vm.user.avatar = localStorageService.get('userAvatar');
        // vm.user.name = localStorageService.get('userName');

        vm.numTimers = function () {
            var length = 0;
            if(_.has(vm.user, 'timers')){
                length = _.size(vm.user.timers);
            }
            return length
        };

        vm.reminderCount = function () {
            var count = 0;
            if(_.has(vm.user, 'reminders')){
                _.each(vm.user.reminders, function(reminder){
                    if(reminder.status == 'triggered' && reminder.userStatus == 'active'){
                        count = count + 1;
                    }
                });

                return count
            }

        };

        vm.inboxCount = function () {
            var b = 0;

            if(_.has(vm, 'user')){
                if(_.has(vm.user, 'notifications')){
                 b = _.filter(vm.user.notifications, function(o) { if (!o.read) return o }).length;
                }
            }

            return b
        };


        vm.markAllRead = function(){
          // $log.info('markAllRead');
          var updates = {};
          _.each(vm.user.notifications, function(notification){
            updates['/users/'+ $rootScope.userID + '/notifications/' + notification.uid + '/read'] = true;
          });
          // $log.info('Marking notifications read:');
          // $log.info(updates);
          $timeout(function(){
            return firebase.database().ref().update(updates)
            }, 300);

        }// markAllRead

        vm.showTrialMessage = function(){
            if ($rootScope.trial && $rootScope.trial.type == 'starter'){
                // If it's a starter account, send them to upgrading instructions
                $state.go('authentication.profile');
            } else if ($rootScope.trial.status == 'expired' && $rootScope.trial.type == 'paid'){
                // if our trial is over and the PAID account has been cancelled due to no card (or other reason)
                // send them to the upgrade page to reactivate their account
                $state.go('authentication.profile');
            } else {
                // do nothing
            }
        }
        vm.logout = function () {
            $log.info('logout');
            userDataService.logout();
        }


        vm.getHelp = function () {
            // $log.info('Open Groove Widget');
            groove.widget.open()
        }

        vm.userProfile = function () {
            $state.go('authentication.profile');
        }

        vm.userDialog = function () {
            userDataService.userDialog('Complete your registration');
        }

        vm.newTime = function () {
            // $log.info('newTime');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID) {
                // $log.info('new time for client' + $stateParams.clientID);
                clientID = $stateParams.clientID;
            }

            vm.timeEntry = timeDataService.newLogEntry(clientID);
            // $log.info(vm.timeEntry);
            timeDataService.timeDialog(vm.timeEntry, "New");

        }

        vm.toggleFullScreen = function() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }

        // vm.user = userDataService.getLoggedInUser();
        // vm.assignedClients = vm.user.clients;
        // $log.info(vm.assignedClients);

        /////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////
      // We need Headway, a 3rd party library loaded .
        // $timeout(function(){
        //     angularLoad.loadScript('//cdn.headwayapp.co/widget.js').then(function() {
        //         // $log.info('headway loaded. initializing...');
        //       var config = {
        //           selector: ".changelog",
        //           account: "JVv4AJ"
        //         };
        //         Headway.init(config);
        //     });
        // }, 0);


        // This displays toasts as notifications come in. It doesn't process notifications that happened prior to this watch being set
        $scope.$watch('vm.user.notifications', function (newValue, oldValue, scope) {
            if(_.size(newValue) > _.size(oldValue)){

                // waggle our alert bell
                $('.notification-badge').addClass('shake');

                // convert these notification list objects to arrays for comparison
                var currentNotifications = _.values(newValue), oldNotifications = _.values(oldValue) ;
                var difference, thisNotification;

                // identify the new item by comparing to previous version
                difference = _.differenceBy(currentNotifications, oldNotifications, 'uid');
                thisNotification = difference[0];

                processToast(thisNotification)

                $timeout(function(){
                    $('.notification-badge').removeClass('shake');
                },2000);

            }
        });// watch notifications


        function sendExpiringToast(notification, color){
            $mdToast.show($mdToast.adminjaAlert(
               {
                   locals:{
                       title: notification.title,
                       message: notification.message,
                       color: color,
                       related: notification.related,
                       type: notification.type,
                       uid: notification.uid
                   }
               }));// mdToast

        }

        function sendStickyToast(notification, color){
            $mdToast.show($mdToast.adminjaStickyAlert(
               {
                   locals:{
                       title: notification.title,
                       message: notification.message,
                       color: color,
                       related: notification.related,
                       type: notification.type,
                       uid: notification.uid
                   }
               }));// mdToast

            $mdToast.visible = true;
        }


        function processToast(notification){
            var excludedStates = [
                'authentication.login',
                'authentication.registration',
                'authentication.lock'
            ]

            // only show if toasts are not disabled and if we aren't on an excludedState
            if(!_.includes(excludedStates,$state.current.name) && !vm.user.profile.settings.disableToasts){
                // if not a reminder, can just send an expiring notification
                var alertType = 'adminjaAlert', color = 'green';

                // $log.info(notification);

                switch(notification.type){
                    case 'invite':
                        break
                    case 'task':
                    case 'subtask':
                        color = "red";
                        break
                    case 'taskOverBudget':
                    case 'billing-period': // billing-period is the over-budget notification type
                    case 'reminder':
                        alertType = "adminjaStickyAlert";
                        color = "red";
                    case 'lead-reminder':
                        color = 'red';
                        break
                    default:
                        color = 'green';
                        alertType = 'adminjaAlert';
                }


                // only display toast if no toast currently showing
                // toasts suppressed here will get displayed after the current toast is dismissed
                if(!$mdToast.visible){
                    if(alertType == 'adminjaAlert'){
                        sendExpiringToast(notification, color);
                    } else {
                        sendStickyToast(notification, color);
                    }
                }//if toast not visible
            }
        }// processToast

        // Listen for check triggered by toasts themselves
        $rootScope.$on('checkForToasts', function(){
            checkForToasts();
        })

        function checkForToasts(){
            // ONLY rminders, tasks, and invites get sticky toasts and will be queued up if not logged into adminja when received.
            // other notifications (the kind that dismiss on their own) only toast when they happen and do not get queued for later toast
            if(_.has(vm.user, 'notifications')){
                _.each(vm.user.notifications, function(notification) {
                   if(!notification.read && (notification.type == 'reminder' || notification.type == 'billing-period' || notification.type == 'taskOverBudget')){
                      processToast(notification)
                      return
                   }// if
                });// each
            }// if has notifications
        }//checkForToasts

    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('settingsPanel', settingsPanel);


     function settingsPanel() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: settingsPanelController,
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/settings-panel/settings-panel.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function settingsPanelController($timeout, $rootScope, $mdDialog, $scope, $log, messagingService, userDataService) {
        // $log.info('settingsPanelController');
        var vm = this;
         vm.currency = "$";
         vm.user = userDataService.user;
         vm.settings = $rootScope.userSettings;

         // Set default date range if none present
         if(!_.has(vm.settings, 'reportRange')){
            vm.settings.reportRange = 'saved';
         }
         vm.updateCurrency = function(currency){
            _.each($rootScope.currencies, function(thisCurrency){
                if(currency == thisCurrency.code){
                    vm.updateSettings('currency', thisCurrency.symbol)
                    vm.updateSettings('currencyCode', thisCurrency.code)
                    userDataService.trackEvent('change-currency-setting');
                }
            });
         }//

         vm.updateSettings = function(setting, value){
             // $log.info('updateSettings');
             userDataService.changeUserSetting(setting, value);
             userDataService.getLoggedInUser();
         } // $scope.updateSettings

         vm.resetOnboarding = function(){
             return userDataService.resetOnboarding();
         }

         vm.requestNotificationPermission = function(){
             messagingService.requestPermission();
         }

         vm.resetProgress = function(){
            userpilot.reset();
               $mdDialog.show(
                    $mdDialog.alert()
                      .parent(angular.element(document.querySelector('#popupContainer')))
                      .clickOutsideToClose(true)
                      .title('Success!')
                      .textContent('Your onboarding checklists have been reset.')
                      .ariaLabel('Got it!')
                      .ok('Got it!')
                  );
         }

    }// controller

})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('reminders', reminders);

    function reminders() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: remindersController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                    status: '@',
                    options: '='
                },
            link: linkFunc,
            templateUrl: 'app/app-directives/reminders/reminders-menu.tmpl.html'
        };
        return directive;
    };



    function linkFunc(scope, element, attr) {


    }

    /* @ngInject */
    function remindersController($rootScope, $state, mdcDateTimeDialog, $scope, $log, $timeout, scheduleDataService) {

        var vm = this;
        vm.minDate = moment().toDate();
        // Make Functions Available to DOM
        vm.prepReminder = prepReminder;
        vm.createReminder = createReminder;
        vm.removeReminder = removeReminder;
        vm.setReminderTime = setReminderTime;
        vm.snoozeReminder = snoozeReminder;
        vm.reminderDate = reminderDate;
        vm.settings = $rootScope.userSettings;



        function prepReminder(input){
            var date = moment(input);

                // they chose a pre-configured date
                switch(input) {
                    case '-1hreport':
                        var due = moment().subtract(1, 'hour').toISOString();
                        vm.options.client = $state.params.clientID;
                        vm.options.repeat = true;
                        vm.options.repeatEvery = 7;
                        vm.options.type = 'weekly-client-report';
                        createReminder(vm.options, due);
                        break
                    case '-1h':
                        var due = moment().subtract(1, 'hour').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '1m':
                        var due = moment().add(1, 'minute').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '1h':
                        var due = moment().add(1, 'hour').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '1d':
                        var due = moment().add(1, 'day').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '2d':
                        var due = moment().add(2, 'day').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '3d':
                        var due = moment().add(3, 'day').toISOString();
                        createReminder(vm.options, due);
                        break
                    case '7d':
                        var due = moment().add(7, 'day').toISOString();
                        createReminder(vm.options, due);
                        break
                    default:
                        var due = moment(input).toISOString();
                        // they used the datepicker. Just set it
                        createReminder(vm.options, due);
                }
        }


        function createReminder(options,due){
            // $log.info('creating reminder:');

            // if reminder more than 2 hrs away, set to 8am
            var now = moment(),
            hoursDifference = moment(due).diff(now, 'hours');

            if(hoursDifference > 2){
                due = moment(due).startOf('day').add(8, 'hours').toISOString();
            }


            var newReminder = scheduleDataService.newSchedule($rootScope.userID, options, due);
            return scheduleDataService.saveNewSchedule(newReminder)
            .then(function(result){
                userDataService.trackEvent('reminder-added');
            });
        }

        function removeReminder(){
            var thisReminder = vm.options;

            return scheduleDataService.removeSchedule(thisReminder)
            .then(function(){
                userDataService.trackEvent('reminder-removed');
            });
        }

        function setReminderTime(){
            mdcDateTimeDialog.show({
               currentDate: moment(vm.options.when),
               time: true,
               date: false,
               shortTime: true,
               clickOutsideToClose: true,
               disableParentScroll: true,
               todayBtn: false
             }).then(function (date) {

               var thisDate = moment(date);
               vm.options.when = moment(thisDate).toISOString();
               return scheduleDataService.updateSchedule(vm.options)
               .then(function(result){
                userDataService.trackEvent('reminder-time-set');
               });
           });
        }// setReminderTime

        function snoozeReminder(reminder, minutes, $event){
            return scheduleDataService.snoozeSchedule(reminder.payload, minutes, $event);
        }

        function reminderDate(){
            if(_.has(vm.options, 'when')){
                return moment(vm.options.when).format(vm.settings.amDateFormat);
            } else {
                return false
            }
        }

    }// remindersController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('reminderCard', reminderCard);


     function reminderCard() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: reminderCardController,
         scope: {
           item: '=item'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/reminder-card/reminder-card.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function reminderCardController($rootScope, $mdSidenav, scheduleDataService, $scope, $injector, $sce, $state, $log, $mdToast, userDataService, taskDataService, profileDataService) {
        var vm = this;
        vm.scheduleService = scheduleDataService;
        vm.userSettings = $rootScope.userSettings;
        vm.snoozePersonalReminder = snoozeReminder;
        vm.sanitizeMe = function(text) {
            return $sce.trustAsHtml(text)
        };



        vm.importTask = function(message){
           inboxService.importTask(message);
        }

        function snoozeReminder(item, minutes, $event){
          $event.stopPropagation();
          // $log.info('snoozeReminder');
          // $log.info(item);
          // update "when" and status on lead
          return scheduleDataService.snoozePersonalReminder(item, minutes)
          .then(function(response){
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Your reminder has been snoozed',
                        message: 'You\'ll be notified again in '  + moment.duration({"minutes": minutes}).humanize() ,
                        color: 'green'
                    }
                }));// mdToast
            // vm.discardNotification(item);
          });
          return userDataService.count($rootScope.userID, 'snoozedReminders', 1)
        };// snoozeReminder


        vm.selectReminder = function(reminder){
          if(reminder.userStatus != 'closed'){
            scheduleDataService.selectSchedule(reminder);
          }
        }

        vm.toggleStatus = function(schedule, $event){
          $event.stopPropagation();
          return scheduleDataService.toggleUserStatus(schedule)
          .then(function(){
            if(schedule.userStatus == 'closed'){
              return userDataService.count($rootScope.userID, 'completedReminders', 1)
            }
            if(schedule.userStatus == 'active'){
              return userDataService.count($rootScope.userID, 'reopenedReminders', 1)
            }
          })
        }

        vm.importNote = function(message){
           inboxService.importNote(message);
        }

        vm.discardReminder = function(item){
          // $log.info('discardReminder', item);
          return scheduleDataService.removeSchedule(item)
          .then(function(){
            return userDataService.count($rootScope.userID, 'discardedReminders', 1)
          });
        }


        vm.showLongWhen = function(item){
          var a = moment(item.when);
          var b = moment();
          if (a.diff(b, 'hours') > 12){
              return true
          } else {
              return false
          }
        }



    }// reminderCardcontroller



})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('registrationWizard', registrationWizard);

    /* @ngInject */
    function registrationWizard() {
        // Usage: <div tri-wizard> (put some forms in here) </div>
        //
        // Creates: Nothing
        //
        var directive = {
            bindToController: true,
            controller: registrationWizardController,
            controllerAs: 'registrationWizard',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function registrationWizardController($scope, $timeout, $log, $mdToast) {
        var vm = this;

        var forms = [];
        var totalErrors = 0;
        var fixedErrors = 0;

        vm.currentStep = 0;
        vm.getForm = getForm;
        vm.isFormValid = isFormValid;
        vm.nextStep = nextStep;
        vm.nextStepDisabled = nextStepDisabled;
        vm.prevStep = prevStep;
        vm.prevStepDisabled = prevStepDisabled;
        vm.progress = 0;
        vm.registerForm = registerForm;
        vm.updateProgress = updateProgress;
        vm.registerUser = registerUser;
        vm.saveUserProfile = saveUserProfile;
        vm.registrationError = undefined;
        vm.showError = false;

        //////////////// Customized for Adminja ////////////////

        function getForm(index) {
            return forms[index];
        }

        function nextStep() {
            // $log.info('nextStep');
            vm.currentStep = vm.currentStep + 1;
        }

        function registerUser(user){
            // $log.info('register clicked');

            // do registration


            firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(function(_userData, error) {
                // console.log("User " + _userData.uid + " created successfully", _userData);

                // get set to store our own userData
                var usersRef = firebase.database().ref('users');

                user.uid = _userData.uid;

                var newUserRecord = {
                    email: user.email,
                    uid: _userData.uid
                }

                newUserRecord.profile = {};
                newUserRecord.profile.avatar = "";
                newUserRecord.profile.firstName = "";
                newUserRecord.profile.lastName = "";

                // save our basic users record
                usersRef.child(_userData.uid).set(newUserRecord);


            }).then(function(authData) {
                $mdToast.showSimple('New Account Created.');

                // proceed to next pane of wizard
                nextStep();

                // return firebase.auth().signInWithEmailAndPassword(vm.user.email, vm.user.password);
                // console.log("Logged in as: ", authData.uid);
                // $state.go('triangular.account-page.profile');

            }).catch(function(error) {
                // console.log("Error: ", error);
                // vm.errorMessage = error.message;
                // vm.showError = true;
                $mdToast.show(
                      $mdToast.simple()
                        .textContent(error.message)
                        .position('top center')
                        .hideDelay(3000)
                    );
                user.email = "";
                user.password = "";
                user.passwordConfirm = "";
            });


    }

        function saveUserProfile(user){
            // $log.info('saveUserProfile');
            var newUser = angular.copy(user);

            if (newUser.profile.dob){
                newUser.profile.dob = newUser.profile.dob.toISOString();
            }

            var usersRef = firebase.database().ref('users');

            // save our user profile
            usersRef.child(newUser.uid + '/profile').set(newUser.profile);
            $mdToast.showSimple('User Profile Updated');

            // proceed to next pane of wizard
            nextStep();


        }

        function nextStepDisabled() {
            // get current active form
            var form = $scope.registrationWizard.getForm(vm.currentStep);
            var formInvalid = true;
            if(angular.isDefined(form) && angular.isDefined(form.$invalid)) {
                formInvalid = form.$invalid;
            }
            return formInvalid;
        }

        function isFormValid(step) {
            if(angular.isDefined(forms[step])) {
                return forms[step].$valid;
            }
        }

        function prevStep() {
            vm.currentStep = vm.currentStep - 1;
        }

        function prevStepDisabled() {
            return vm.currentStep === 0;
        }

        function registerForm(form) {
            forms.push(form);
        }

        function updateProgress() {
            var errors = calculateErrors();
            fixedErrors = totalErrors - errors;

            // calculate percentage process for completing the wizard
            vm.progress = Math.floor((fixedErrors / totalErrors) * 100);
        }

        function calculateErrors() {
            var errorCount = 0;
            for (var form = forms.length - 1; form >= 0; form--) {
                if(angular.isDefined(forms[form].$error)) {
                    for(var error in forms[form].$error) {
                        errorCount += forms[form].$error[error].length;
                    }
                }
            }
            return errorCount;
        }


        // init

        // wait until this tri wizard is ready (all forms registered)
        // then calculate the total errors
        $timeout(function() {
            totalErrors = calculateErrors();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('registrationWizardForm', registrationWizardFormProgress);

    /* @ngInject */
    function registrationWizardFormProgress() {
        // Usage:
        //  <div tri-wizard>
        //      <form tri-wizard-form>
        //      </form>
        //  </div>
        //
        var directive = {
            require: ['form', '^registrationWizard'],
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, require) {
            var ngFormCtrl = require[0];
            var registrationWizardCtrl = require[1];

            // register this form with the parent triWizard directive
            registrationWizardCtrl.registerForm(ngFormCtrl);

            // watch for form input changes and update the wizard progress
            element.on('input', function() {
                registrationWizardCtrl.updateProgress();
            });
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('appDirectives')
		.directive('profilePanel', profilePanel)
		.directive('newProfilePanel', newProfilePanel);


	function newProfilePanel(){
			var directive = {
				restrict: 'E',
				replace: false,
				controller: profilePanelController,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: 'app/app-directives/profile-panel/new-profile-panel.tmpl.html'
			};
			return directive;
	}

	function profilePanel() {
		var directive = {
			restrict: 'E',
			panel: '=',
			replace: false,
			controller: profilePanelController,
			controllerAs: 'vm',
			bindToController: true,
			templateUrl: 'app/app-directives/profile-panel/profile-panel.tmpl.html'


		};
		return directive;
	};

	///////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////
	/// profilePanelController


/* @ngInject*/
	function profilePanelController(dragulaService, $log, pageDimensionsService, userDataService, $rootScope, $stateParams, $state, $scope, $timeout, $mdToast, profileDataService, panelDataService, teamDataService) {
		// Once agaain, vm. can't be used. we have to use $scope.
		// $log.info('profilePanelController');
		var vm = this;

		vm.settings = $rootScope.userSettings;

			// Set our client ID, exposed to our directives
			vm.clientID = $stateParams.clientID;
			vm.state = $state;

			// determine if user is clientUser for this workspace
			$scope.isClientUser = false;
			if(_.has($rootScope, 'VAWorkspaces')){
			    if(_.has($rootScope.VAWorkspaces, vm.clientID)){
			            $scope.isClientUser = true;
			    }
			}

		$scope.verticalProfilePanels = vm.settings.verticalProfilePanels;

		// trigger pageDimensionsService.resizeColumns(); to ensure initial resize
		$timeout(function(){
			pageDimensionsService.resizeColumns();
		}, 200);

		$scope.scrollFocus = function scrollFocus(event){
			// $log.info('scrollFocus - disabled');
			// var panel = $(event.target).closest('.app-item-container');
			// var scrollContainer = $(panel).closest('#scroll-h');
			// var scrollContainerWidth = $(scrollContainer).width();
			// // var offset = $(panel).offset().left - $(scrollContainer).offset().left
			// // $log.info(panel);
			// // // $(scrollContainer).css('background-color', 'pink');
			// // // $(panel).css('background-color', 'blue');
			// // scrollContainer.scrollLeft(offset);

			// var scrollTo = $(panel).offset().left; // retrieve its position relative to its parent
			// $log.info(scrollTo);
			//    //$('.scroller').scrollLeft(scrollTo); // simply update the scroll of the scroller
			//    $(scrollContainer).animate({'scrollLeft': scrollTo + 100}, 800); // use an animation to scroll to the destination
		}
			// ng-if="!detail.private || getUserRole(panel.client) != 'member'"
		$scope.userFilter = function(detail){
			if(detail){
				if(detail.private != true || $scope.getUserRole(detail.client) != 'member'){
				    return true
				    }
			}

		}// userFilter

		$scope.getUserRole = function(clientID){
			// Set defaults

			   // Check to see if current user is admin or member so we can restrict who can see the 'admins only' toggle
			if(_.has(teamDataService.clientTeams, clientID)){
				var teamSize = _.keys(teamDataService.clientTeams[clientID]).length;
			} else {
				var teamSize = 0
			}



			   // if we have a team, check for permissions to edit otherwise, allow it
			   if(teamSize > 0 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
			       return teamDataService.clientTeams[clientID][$rootScope.userID].role;
			   } else {
			       // no team. This is a solo account. Set all to true.
			       return 'member'
			   }

			}// vm.isAdmin


		$scope.showClientCard = function(label){
		  if(label == 'Client Details'){
		    return true
		  };
		}

		$scope.newPanel = function newPanel(){
			// $log.info('profilePanelController: newPanel');
			var panelCount = $('profile-panel').length;
			return panelDataService.newPanel(vm.clientID, panelCount);
		}

		$scope.addDetail = function addDetail(type, panel){
			// $log.info('profilePanelController: new detail', panel);
			var detail = profileDataService.newProfileDetail(type, panel, 'New');
			profileDataService.profileDetailDialog(detail, 'New ' + _.startCase(type));
			//heap.track('New Profile Card Started');
			userpilot.track('New Profile Card Started');
		};

		$scope.addNote = function addNote(panel, title){
			var detail = profileDataService.newProfileDetail('note', panel, title);
			return profileDataService.saveProfileDetail(detail)
			.then(function(){
				// put the note in edit mode and focus on the field
				$timeout(function(){
					pageDimensionsService.resizeColumns();
				}, 500);
			});
		};

		$scope.editPanel = function editPanel(panel){
			// $log.info('profilePanelController: editPanel');

			 return panelDataService.editPanel(panel);

		};

		$scope.deletePanel = function deletePanel(panel){
			if(panel.label != "Client Details"){
				panelDataService.deletePanel(panel);
			}
		}

		/////////////////////////////////////////////
		// Sort profile detail panels
		function sortDetails(panelID, clientID){
			// $log.error('Sorting Details');
			// Isolate this panel thanks to it's panelid attribute
			var sortingPanel = $('.app-item-container-items[panelid="' + panelID +'"]');
			// $(sortingPanel).css('background-color', 'yellow');
			// grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
			var sortedDetails = $(sortingPanel).find('.info-card');

			// set our DB reference
			var detailsRef = firebase.database().ref('clients/' + clientID + '/panels/' + panelID + '/details');
			// Update each item in firebase by ID
			_.each(sortedDetails, function(detail, index){
				var newOrder = (parseInt(index) + 1) * 10,
				    detailID = detail.getAttribute('uid');
				// Change the actual node's order value
				detail.attributes.order.value = newOrder;
				// update JUST the order value on the panel
				detailsRef.child(detailID).child('order').set(newOrder);
			});

			// check to make sure our DOM didn't get screwed up
			var targetPanel = $('.app-item-container-items[panelid="' + panelID + '"]'),
			numTargetChildren = $(targetPanel).find('.info-card').length;

			var expected = Number(numTargetChildren), // this was stored before we made changes
			    actual = Number($(targetPanel).find('.info-card').length); // this is the state after the changes

			 $log.info('Expected: ' + expected);
			 $log.info('Actual: ' + actual);
			// $log.info('expected:' + expected) ;
			// $log.info('actual: ' + actual);

			if(actual != expected){
			  $timeout(function(){// force a digest is necessary
			    alert('Oops! Please refresh Adminja to see the results of your drag and drop operation.')
			  },0)
			}

		}// sortDetails

		////////////////////////////////////////
		// move detail to a different panel
		var moveToPanel = function(detailID, parentPanelID, targetPanelID, clientID, newOrder){
			// get a canonical copy of our detail
			var detailRef = firebase.database().ref('clients/' + clientID + '/panels/' + parentPanelID + '/details/' + detailID);

			detailRef.once('value', function(snap)  {
				var detail = snap.val(),
				    newPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid);

				// change our panel and set our order to just before the dropped sibling
				detail.panel = targetPanelID;

				if (newOrder){detail.order = Number(newOrder);}

				// Set the record at the new location
			     newPath.set(detail, function(error) {
			          if( !error ) {
			          	// remove the original one if no error
			          	detailRef.remove();
			          	//heap.track('Profile Card Moved');
			          	userpilot.track('Profile Card Moved');
			          	$timeout(function(){
			          	  pageDimensionsService.resizeColumns();
			          	  sortDetails(targetPanelID, clientID);
			          	  sortDetails(parentPanelID, clientID);
			          	}, 250);
			          }
			          else if( typeof(console) !== 'undefined' && console.error ) {  console.error(error); }
			     });
		    });
		}



		/////////////////////////////////////////////
		// drag-profile-detail over function
		$scope.$on('drag-profile-detail.over', function (event, el, target, source) {
			// $log.info(target,source);
			if(target[0].$$hashKey != source[0].$$hashKey){
				pageDimensionsService.resizeColumns();
			}
		});

		/////////////////////////////////////////////
		// drag-profile-detail over function
		$scope.$on('drag-profile-detail.out', function (event, el, target, source) {
			// $log.info(target,source);
			if(target[0].$$hashKey != source[0].$$hashKey){
				pageDimensionsService.resizeColumns();
			}
		});

		$scope.$on('drag-profile-detail.cancel', function (event, el, target, source) {
			// $log.info(target,source);
			$timeout(function(){
			  $rootScope.draggingDetail = false;

			}, 100);
		});

		// /////////////////////////////////////////////
		// // drag-profile-detail drop function
		// $scope.$on('drag-profile-detail.drop', function (event, el, target, source, sibling) {
		// 	$log.info('Directive Drop');
		// 	$rootScope.draggingDetail = false;
		// 	// $log.info('sibling:', sibling);

		// 	// Gather all of the properties we will need to execute the move
		// 	 var  detailID = el[0].id,
		// 		 parentPanelID =  el[0].attributes.panel.value,
		// 		 clientID = el[0].attributes.client.value,
		// 		 targetPanelID = target[0].attributes.panelid.value,
		// 		 newOrder = undefined;

		// 	// var thisDetail = $scope.$parent.client.panels[targtPanelID].details[detailID];
		// 	var thisDetail = $scope.client.panels[targetPanelID].details[detailID];
		// 	// $log.info(thisDetail);

		// 	 // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
		// 	 if (sibling != undefined){
		// 	 	// newOrder = sibling[0].attributes.order.value;
		// 	 	if (!sibling[0].attributes.order.value) {
		// 	 		// sibling doesnt have a value. Put this at the top.
		// 	 	    newOrder = 0
		// 	 	} else {
		// 	 		// $log.info('Dropped before sibling: ' + siblingName + ' Order: ' + Number(sibling[0].attributes.order.value));
		// 	 	    // sibling has an order, put ours before it
		// 	 	    newOrder = Number(sibling[0].attributes.order.value) - 5;
		// 	 	    if(newOrder <1){ newOrder = 1};

		// 	 	}
		// 	 } else {
		// 	 	// no sibling...this should be on the end
		// 	 	newOrder = 1000;
		// 	 }

		// 	 if (parentPanelID == targetPanelID){
		// 		// just moving within the same panel
		// 		sortDetails(parentPanelID, clientID, thisDetail);
		// 		// resize our columns
		// 		$timeout(function(){
		// 		  pageDimensionsService.resizeColumns();
		// 		  //heap.track('Profile Card Reordered');
		// 		  userpilot.track('Profile Card Reordered');

		// 		}, 250);

		// 	 } else {
		// 	 	// moving betwixt panels
		// 	 	moveToPanel(detailID, parentPanelID, targetPanelID, clientID, newOrder, thisDetail);
		// 	 	// remove from DOM so we don't end up with a non-functional duplicate.
		// 	 	el.remove();
		// 	 	//heap.track('Profile Card Reordered');
		// 	 	userpilot.track('Profile Card Reordered');
		// 	 }
		// });// $on.drag-profile-detail.drop
	}
})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('profileDetailItem', profileDetailItem)
    .filter('escape', function() {
      return window.encodeURIComponent;
    });;


  function profileDetailItem() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: profileDetailItemController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/profile-detail-item/profile-detail-item.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {

      // discerns between click or text select intention.
      // sets $scope.clicked to true if it's a click so other functions can react.
        scope.time= Date.now();

         element.on("mousedown mouseup", function(e){
           if(e.type == "mousedown"){
             scope.time= Date.now();
             // console.log('selecting');
           }// if mousedown

           if(e.type == "mouseup"){
             if(Date.now() - scope.time> 300){
              scope.clicked = false;
               return false;
             }else{
               // console.log("clicked");
               scope.clicked = true;
             }// if select or click
           }// if mouseup
         });
}

  ///////////////////////////////////////////////////////////
  /// profileDetailItemController

  /* @ngInject */
  function profileDetailItemController($rootScope, $timeout, $log, $mdToast, $scope, $filter, profileDataService, pageDimensionsService, userDataService, clientDataService) {

    var vm = this;
    vm.detail = $scope.$parent.detail
    $scope.settings = $rootScope.userSettings;
    $scope.user = userDataService.user;

  //Make sure our note links don't open the card itself
  $timeout(function(){
    $('md-card.info-card  a').unbind().click(function(event){
      // $log.info('clicked');
      event.stopImmediatePropagation();
      // window.open($(this).href);
    });
  },200);

  $scope.froalaOptions = {
      toolbarButtons : ["bold", "italic", "underline", "|", "align", "formatOL", "formatUL", "insertLink"]
    }

  $scope.colors = $rootScope.noteColors;
  $scope.color = undefined;

$scope.finishEdit = function(detail){
  $timeout(function(){
    detail.editMode = false;
    detail.editColor = false;
    $scope.updateDetail(detail);
  }, 1000);
}



$scope.setColor= function(detail, color, event){
  if(event){
    event.stopImmediatePropagation();
  };
  // $log.info('setColor');
  detail.notecolor = color;

  $timeout(function(){
    $scope.updateDetail(detail);
  });
  // $scope.finishEdit(detail);
}

$scope.toggleEditMode = function(detail, event){
  // $log.info(detail);
  // if(event){
  //   event.stopImmediatePropagation();

  // };

  // if(detail.editMode == true){
  //   detail.editMode = false
  // } else {
  //   detail.editMode = true
  //   $timeout(function(){
  //     // focus on editable area
  //     angular.element('text-angular[name=' + detail.uid +']')
  //         .find('*[id*=taText]')
  //         .focus()
  //   },250);
  // }
}



$scope.prepAndEdit = function(detail, event){
  if(event){
    event.stopImmediatePropagation();
  };
  detail.note = "New Note";
  $scope.toggleEditMode(detail, event);
}

$scope.init = function(detail){
  detail.editMode = false;
  // if this is a new card, focus on it.
  // if it's a note card, put it in edit mode
  // only cards since this update will have timestamps. So we need to check first.
    if(_.has(detail, 'timestamp')){
          var now = moment();
          var difference = now.diff(detail.timestamp, 'seconds');
            if(difference < 5){
              // it's a new card!
              $timeout(function(){
                if(detail.type == "note"){
                  // put in edit mode (which will focus and put it in view)
                  $scope.toggleEditMode(detail);
                } else {
                  // just need to focus and put it in view
                  angular.element('.info-card[uid=' + detail.uid +']')
                      .focus()
                }
                });
            }
      };

}// init

  $scope.applyBackground = function(detail){
        if (detail.notecolor){
          return { 'background-color': detail.notecolor }
        } else { return null}
    };

    $scope.shortenFilename = function(text){
     return _.truncate(text, {
        'length': 36,
        'omission': '...'
      });


    }

    $scope.isImage = function(file){
      var validExtensions = [
          'jpg',
          'gif',
          'png',
          'bmp',
          'JPG',
          'BMP',
          'GIF',
          'PNG',
          'JPEG'
          ],
        extension = file.fileName.split('.').pop();

      // if this file's extension is valid, return true
      if (_.includes(validExtensions,extension)){
        return true
      } else {
        return false
      }
    }// isImage

    $scope.updateOnChange = function(detail){
      $timeout(function(){
        $scope.saving = true;
      },0)
      return profileDataService.updateProfileDetail(detail)
      .then(function(){
        // alert('updated');
        $timeout(function(){
                $scope.saving = false;
              },0)
      })
    }

    $scope.updateDetail = function(detail){
      // $log.info('updateDetail');
      // only if not rebuilding otherwise may lose it forever in that state
      if(!detail.rebuilding){
        detail.editMode = false;
        detail.editColor = false;
        $timeout(function(){
          $scope.saving = true;
        },0)
        return profileDataService.updateProfileDetail(detail)
        .then(function(){
          // alert('updated');
          $timeout(function(){
                  $scope.saving = false;
                },0)
        })
      }
    }



    $scope.editDetail = function(detail){
      // suppress click if we are seelcting text.
      var sel = document.getSelection().toString();
         if(!sel){
             if(!detail.editMode){
               // this directive will set clicked to true if this is a click event, false if it's a select event
               if($scope.clicked){
                   var newDetail = angular.copy(detail);
                   if (newDetail.dob){
                     newDetail.dob = new Date(newDetail.dob);
                   }
                   profileDataService.editProfileDetail(newDetail, 'Update');
                 }
             }
         }

    };

    $scope.copyDetail = function(detail){
      var newDetail = angular.copy(detail);
      // $log.info(newDetail);
      // Remove ID, Client, and Bucket so we will then be saving a new copy and be able to assign it elsewhere

      delete newDetail.uid;
      delete newDetail.client;
      delete newDetail.panel;
      profileDataService.editProfileDetail(newDetail, 'Clone');
    };

    $scope.removeDetail = function(item){
      profileDataService.deleteProfileDetail(item);

    };

    $scope.moveToPanel = function(detail, targetPanelID){
      //heap.track('Profile Card Moved');
      userDataService.trackEvent('move-detail-card');

      var originalPanelID = detail.panel,
          clientID = detail.client;

      // $log.info('moveToPanel');
      // $log.info(detail);
      // $log.info(targetPanelID);

      var originalPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + originalPanelID + '/details/' + detail.uid);
      var newPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid);

      moveFbRecord(originalPath, newPath);

      // update panel property
      detail.panel = targetPanelID;
      detail.order = 1000;
      newPath.set(detail);

      $timeout(function(){
        pageDimensionsService.resizeColumns();
      }, 0);

       function moveFbRecord(oldRef, newRef) {
        // $log.info('moveFbRecord');
        // $log.info(oldRef, newRef);
            oldRef.once('value', function(snap)  {
                 newRef.set( snap.val(), function(error) {
                      if( !error ) {  oldRef.remove(); }
                      else if( typeof(console) !== 'undefined' && console.error ) {  console.error(error); }
                 });
            });
       }

    };

  }

})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('printTimeReport', printTimeReport);


     function printTimeReport() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: printTimeReportController,
         scope: {
           report: '=report'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

     // Directive expects report to have the following properties
     // vm.report.clientName
     // vm.report.start
     // vm.report.end
     // vm.report.type
     // vm.report.allocated
     // vm.report.time

   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/print-time-report/print-time-report.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function printTimeReportController($mdDialog, $timeout, $rootScope, $mdToast, $scope, $log, teamDataService, timeDataService, clientBillingService, userDataService) {
        var vm = this;
        // Make sure our user object is ready
        $timeout(function(){
            vm.user = userDataService.user;
            vm.settings = $rootScope.userSettings;
            vm.showReport = true;
             // set our currency
             vm.currency = "$";
             vm.clientTeams = teamDataService.clientTeams;
            if (_.has(vm.settings, 'currency')){
                 vm.currency = vm.settings.currency;
             }

        }, 1000)
        // NOTE we have vm.report by default because it was passed in to "this" already
        // $log.info(vm.report);
        vm.showMember = true;
        vm.showClient = true;

        vm.groupBy = 'none';
        vm.payloadSize = angular.toJson(vm.report).length;
        vm.payloadKB = parseInt(vm.payloadSize/1024);
        vm.payloadMB = parseInt(vm.payloadSize/1024/1024);
        if(vm.payloadKB > 999){
            vm.payloadLabel = vm.payloadMB + 'MB';
        } else {
            vm.payloadLabel = vm.payloadKB + 'KB';
        }

        vm.groupOptions = [
        {
         name: 'No grouping',
          value: 'none',
          icon: 'zmdi zmdi-block'
      },

        { name: 'Group by task',
          value: 'task',
          icon: 'fa fa-check-square'
      },

          { name: 'Group by team member',
            value: 'creator',
            icon: 'fa fa-users'
        },
          { name: 'Group by category',
            value: 'rateLabel',
            icon: 'zmdi zmdi-format-list-numbered'
        },

        { name: 'Group by workspace',
          value: 'client',
          icon: 'fa fa-folder'
      }
        ]

        // Set default state for column selecet menu
        vm.columnVisibilityControl = 'none'

        vm.toggleMemberVisibility = function(){
            if(vm.showMember){
                vm.showMember = false;
            } else {
                vm.showMember = true;
            }

            $timeout(function(){vm.columnVisibilityControl = 'none';},0);
        }

        vm.toggleClientVisibility = function(){
            if(vm.showClient){
                vm.showClient = false;
            } else {
                vm.showClient = true;
            }

            $timeout(function(){vm.columnVisibilityControl = 'none';},0);
        }

        vm.groupFilter = function(entry, groupID){
            if(_.has(entry, vm.groupBy)){
                if (entry[vm.groupBy] == groupID){
                    return true
                }
            }
        }

        vm.groupByChanged = function(groupBy){
            // $log.info('groupBy: ' + groupBy);

            // start our loading animation if we are groiuping by task. It may take a few seconds.
            if(groupBy == 'task'){
                $timeout(function(){
                    vm.creatingGroups = true;
                }, 100);
            }
            var groupByLabel = undefined;

            if(groupBy == 'task'){
                groupByLabel = 'taskName';
                vm.groupDisplayLabel = 'Task';
            }
            if(groupBy == 'creator'){
                groupByLabel = 'creatorName'
                vm.groupDisplayLabel = 'Member';
            }
            if(groupBy == 'client'){
                groupByLabel = 'clientName'
                vm.groupDisplayLabel = 'Workspace ';
            }

            if(groupBy == 'rateLabel'){
                groupByLabel = 'rateLabel'
                vm.groupDisplayLabel = 'Category ';
            }
            vm.groups = vm.createGroups(groupBy, groupByLabel);

        }

        // Creates groups when grouping report by task/teamMember/Client
        vm.createGroups = function(groupBy, groupByLabel){
            var flags = {};
            var groups = [];

            vm.groupReportTime = angular.copy(vm.report.time);
            _.each(vm.groupReportTime, function(entry){
                // If entry doesn't have a groupBy - add it as 'none'
                if(!_.has(entry, groupBy)){
                    entry[groupBy] = "none";
                    entry[groupByLabel] = "No " + vm.groupDisplayLabel;
                }

                // if we don't already have a flag for this
                if (!flags[entry[groupBy]]) {
                    flags[entry[groupBy]] = true;
                    // if grouping by task, get the task info and attach it
                    if(groupBy == 'task'){
                        var taskRef = firebase.database().ref('tasks').child(entry[groupBy]);
                        taskRef.once('value', function(snapshot){
                            if(snapshot.exists()){
                                // Task exists? Let's add it's meta data to this group
                                var thisTask = snapshot.val();

                                flags[entry[groupBy]] = true;

                                // We have a bug where sometimes an entry doesn't have the taskName.
                                // So let's reapply it here (it also updates the label if the task has been edited)
                                // to make sure it's available for grouping labels
                                entry.taskName = thisTask.info.description;


                                var tempEntry = {
                                    id: entry[groupBy],
                                    label: entry[groupByLabel],
                                    created: moment(thisTask.created).toISOString(),
                                    displayCreated : moment(thisTask.created).format(vm.settings.shortDateFormat)
                                };

                                if(_.has(thisTask.info, 'duedate')){
                                    tempEntry.due = thisTask.info.duedate;
                                    tempEntry.displayDue = moment(tempEntry.due).format(vm.settings.shortDateFormat);
                                }
                                if(_.has(thisTask.info, 'closedDate')){
                                    tempEntry.completed = thisTask.info.closedDate;
                                    tempEntry.displayCompleted = moment(tempEntry.completed).format(vm.settings.shortDateFormat);

                                }





                                if(_.has(thisTask.info, 'budget')){
                                    tempEntry.budget = thisTask.info.budget
                                }
                                groups.push(tempEntry);
                            }  else {
                                // no task? Must have been deleted. Just push the label and ID
                                groups.push({
                                    id: entry[groupBy],
                                    label: entry[groupByLabel]
                                });
                            }// if snapshot exists

                        });
                    } else {
                        groups.push({
                            id: entry[groupBy],
                            label: entry[groupByLabel]
                        });
                    }


                }
            });
            if(groupBy == 'task'){
                $timeout(function(){
                    vm.creatingGroups = false;
                },1000);
            }

            return groups
        }// groupByChanged

        // Adds entries to appropriate grouops in vm.groups to be passed with report request
        function getGroupedTime(report){
            return $timeout(function(){
                _.each(vm.groups, function(group){
                    group.time = [];
                    group.total = 0;
                    _.each(vm.groupReportTime, function(entry){
                        if (entry[vm.groupBy] == group.id){
                            // We make a smaller version of the entry to pass with our report request.
                            // This cuts down the payload size by more than 1/2
                            // and Firebase functions won't trigger on changes larger than 1MB
                            var cleanEntry = {
                                description: entry.description,
                                logged: entry.logged,
                                logDate: entry.logDate,
                                rateLabel: entry.rateLabel,
                                creator: entry.creator,
                                month: moment(entry.logDate).format('M'),
                                day: moment(entry.logDate).format('DD'),
                                year: moment(entry.logDate).format('YYYY')
                            };
                            group.time.push(cleanEntry);
                            group.total = group.total + entry.logged;
                        };
                    })
                });
                // $log.info(vm.groups);
                report.groups = vm.groups;
            },0);// timeout
        }




        vm.groupTotal = function(groupID) {
            // this extra check makes sure we don't throw erros after closing the report
            if(_.has(vm, 'report')){
                var total = 0;
                // if it has a group, calculate them
                if(groupID != 'none'){
                    _.each(vm.report.time, function(entry){
                        if(entry[vm.groupBy] == groupID){
                            total = total + entry.logged;
                        }
                    });
                    return total
                } else {
                    // if doesn't have groupID, calculate them based on !_.has
                    _.each(vm.report.time, function(entry){
                        if(!_.has(entry, vm.groupBy)){
                            total = total + entry.logged;
                        };
                    });
                    return total
                }

            }

          };

        vm.entryRate = function(entry){
            if(_.has(entry, 'rate')){
                return entry.rate
            } else {
                return vm.report.rate
            }

        }

        vm.shouldShowRate = function(entry){
            if(entry){
                // if owner - display rates
                if(entry.creator == $rootScope.userID){
                    return true
                } else if(_.size(vm.clientTeams[entry.client]) > 1){
                    if(_.has(vm.clientTeams[entry.client][$rootScope.userID])){
                        // user is on the team
                        if(vm.clientTeams[entry.client][$rootScope.userID].role == 'member'){
                            return false
                        } else {
                            return true
                        }
                    }
                }
            }
        }// vm.shouldShowRate

        vm.used = function(){

            var used = 0;
            _.each(vm.report.time, function(entry){
                used = used + entry.logged;
            });

            return used
        }

        vm.remain = function(){
            return (vm.report.allocated * 60) - vm.used()
        }

        vm.lineItemTotal = function(entry){
            return vm.entryRate(entry) * (entry.logged/60);
            // if(_.has(entry, 'rateLabel')){
            //     return (entry.logged/60) * entry.rate;
            // } else {
            //     return (entry.logged/60) * vm.report.rate
            // }
        }

        vm.reportTotal = function(){
            var total = 0;
            _.each(vm.report.time, function(entry){
                total = total + (vm.entryRate(entry) * (entry.logged/60));
            });
            return total
        }

        vm.cancelReport = function(){
            delete vm.report
            $mdDialog.cancel();
        }

        // This function is probabl deprecated. Using browser to print locally.
        vm.printReport = function(report){
            var pdfConsent = false;
            if(userDataService.hasConsent('reports')){
                pdfConsent = true;
            } else {
                return userDataService.getConsent('reports', 'Can we send time log information to our PDF generator?','<p>In order to generate reports, we need permission to securely process your time log data with a third party.</p>' )
            };

            // $log.info('Report directive: printReport');
            report.user = vm.user.profile;


            // Pre-sort our time before sending it to the cloud
            report.time = _.sortBy(report.time, ['logDate']);

            if(report.type == 'hourly'){
                report.isHourly = true
            } else {report.isHourly = false}

            var thisTimeFormat = 'minutes';

            if(_.has(vm.settings, 'timeFormat')){
                if(vm.settings.timeFormat){
                    thisTimeFormat = 'decimal'
                }
            }

             var request = {
               link: 'pending',
               template: 'time-report',
               filename: report.filename
             };

             // if it has .allocated, convert to minutes so it can be handled more easily by our report template handlebars helper
             if(_.has(report, 'allocated')){
                report.allocated = report.allocated * 60;
             }


             // attach our pdf request node to our data
             report.pdf = request;

             report.timeStamp = moment().toISOString();
             report.timeFormat = thisTimeFormat;
             // $log.info(report);
             // Let the user know it's on it's way



             $mdToast.show($mdToast.adminjaAlert(
                 {
                     locals:{
                         title: 'Your report is on it\'s way!',
                         message: 'We\'ll notify you when it\'s ready.' ,
                         color: 'orange'
                     }
                 }));// mdToast

             return timeDataService.requestPDF(report);

        }// vm.printReport

        vm.emailReport = function(report){
            var emailConsent = false;
            if(userDataService.hasConsent('email')){
                emailConsent = true;
            } else {
                return userDataService.getConsent('email', 'Can we send invoices through our email service?','<p>In order to send this to your client, we need permission to securely send your invoice information to a third party.</p>' )
            };
            var pdfConsent = false;
            if(userDataService.hasConsent('reports')){
                pdfConsent = true;
            } else {
                return userDataService.getConsent('reports', 'Can we send time log information to our PDF generator?','<p>In order to generate reports, we need permission to securely process your time log data with a third party.</p>' )
            };

            // Pre-sort our time before sending it to the cloud
            report.time = _.sortBy(report.time, ['logDate']);
            report.displayStart = moment(report.start).format('MM/DD/YYYY');
            report.displayEnd = moment(report.end).format('MM/DD/YYYY');


            // if it has .allocated, convert to minutes so it can be handled more easily by our report template handlebars helper
            if(_.has(report, 'allocated')){
               report.allocatedMinutes = report.allocated * 60;
            }


            if(report.type == 'hourly'){
                report.isHourly = true
            } else {report.isHourly = false}

            var thisTimeFormat = 'minutes';

            if(_.has(vm.settings, 'timeFormat')){
                if(vm.settings.timeFormat){
                    thisTimeFormat = 'decimal'
                }
            }

             var request = {
               link: 'pending',
               template: 'time-report',
               filename: report.filename
             };


             // attach our pdf request node to our data
             report.pdf = request;
             report.timeStamp = moment().toISOString();
             report.timeFormat = thisTimeFormat;


             //if we are grouping our entries, we need to prepare and attach that data so handlebars can handle it
             if(vm.groupBy != 'none'){
                request.template = 'grouped-time-report';

                return getGroupedTime(report)
                .then(function(){
                    report.groupBy = vm.groupDisplayLabel;
                    report.time = null;
                    return timeDataService.emailPDF(report);
                })
             } else {
                return timeDataService.emailPDF(report);
             }



        }// vm.printReport




    }// controller


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('notificationCard', notificationCard);


     function notificationCard() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: notificationCardController,
         scope: {
           item: '=item',
           toast: '=toast'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/notification-card/notification-card.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function notificationCardController($rootScope, $mdSidenav, $timeout, scheduleDataService, userDataService, leadDataService, $scope, $injector, $sce, $state, $log, $mdToast, teamDataService, inboxService, taskDataService) {
        var vm = this;


        function markRead(item){
          // mark the notification read
          // $log.info('markRead');
          // $log.info(item.uid);
          firebase.database().ref('users').child($rootScope.userID).child('notifications').child(item.uid).child('read').set(true);
        }

        function resetToast(){
          $mdSidenav('right').close();
          $mdToast.hide();
          $mdToast.visible = false;
        }

        vm.dismissBillingNotification = function(item){
          markRead(item);
          resetToast();
        }

        vm.sanitizeMe = function(text) {
            return $sce.trustAsHtml(text)
        };

        vm.isOld = function(notification){
            var now = moment(),
                then = moment(notification.date);
                if (now.diff(then, 'days') > 15 && notification.read){
                    return true
                }

        }

        vm.importTask = function(message){
           inboxService.importTask(message);
        }



        vm.sendToast = function(item){
          var alertType = 'adminjaAlert';
          switch(item.type){
              case 'invite':
              case 'task':
              case 'reminder':
                  alertType = "adminjaStickyAlert";
                  break
              default:
                  alertType = 'adminjaAlert';
          }

          if(alertType == 'adminjaAlert'){
              $mdToast.show($mdToast.adminjaAlert(
                 {
                     locals:{
                         title: item.meta,
                         message: item.message,
                         color: 'orange',
                         related: item.related,
                         type: item.type
                     }
                 }));// mdToast
          } else {
            $mdToast.show($mdToast.adminjaStickyAlert(
               {
                   locals:{
                       title: item.meta,
                       message: item.message,
                       color: 'red',
                       related: item.related,
                       type: item.type
                   }
               }));// mdToast
          }

        }// sendToast

        vm.snoozeLeadReminder = function(item, minutes, $event){
          $event.stopPropagation();
          // update "when" and status on lead
          return scheduleDataService.snoozeSchedule(item.related, minutes)
          .then(function(response){
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Lead reminder has been snoozed',
                        message: 'You\'ll be notified again in '  + moment.duration({"minutes": minutes}).humanize() ,
                        color: 'green'
                    }
                }));// mdToast
            vm.discardNotification(item);
            resetToast();
          });
        };// snoozeLeadReminder

        function checkForToasts(){
          $timeout(function(){
            $rootScope.$emit('checkForToasts');
          },1000);

        }


        vm.dismissPersonalReminder = function(item){
          markRead(item);
          resetToast();
          checkForToasts();
        }


        vm.snoozeReminder = function(item, minutes, $event){
          $event.stopPropagation();
          markRead(item);
          resetToast();
          return scheduleDataService.snoozePersonalReminder(item, minutes);
          vm.discardNotification(item);
        };// snoozeReminder

        vm.markReminderComplete = function(item){
          var user = userDataService.user;
          if(_.has(user, 'reminders')){
            scheduleDataService.toggleUserStatus(user.reminders[item.related.scheduleID]);
            resetToast();
            vm.discardNotification(item);
          }
        };// markReminderComplete



        vm.snoozeTask = function(item, minutes, $event){
          $event.stopPropagation();
          resetToast();
          return taskDataService.getTask(item.related)
          .then(function(editedItem){
            taskDataService.snoozeTask(editedItem.info, minutes);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Task has been snoozed',
                        message: 'It will reappear in '  + moment.duration({"minutes": minutes}).humanize() ,
                        color: 'green'
                    }
                }));// mdToast

            vm.discardNotification(item);
          });
        };// snoozeTask

        vm.openBilling = function(item){
          resetToast();
          markRead(item);
          $state.go('triangular.workspaces.client-legacy-billing', {'clientID': item.related});
        }

        vm.openClient = function(item){
          resetToast();
          markRead(item);
          $state.go('triangular.workspaces.overview', {'clientID': item.related});
        }



        vm.openTask = function(item, tab){
           markRead(item);
           return taskDataService.getTask(item.related)
           .then(function(editedItem){
                // $log.info(editedItem);
               // convert our due date into a date object for md-date-picker
               if (_.has(editedItem, 'info.duedate')) {
                   editedItem.info.duedate = new Date(editedItem.info.duedate);
               }
               // send it to our dialog
               $mdSidenav('right').close();
               $mdToast.hide();
               $mdToast.visible = false;
               taskDataService.taskDialog(editedItem, tab);
           })
        }

        vm.openSubTask = function(item, tab){
          markRead(item);
           return taskDataService.getTask(item.related.parentTaskID)
           .then(function(editedItem){
                // $log.info(editedItem);
               // convert our due date into a date object for md-date-picker
               if (_.has(editedItem, 'info.duedate')) {
                   editedItem.info.duedate = new Date(editedItem.info.duedate);
               }

               resetToast();
               // send it to our dialog
               taskDataService.taskDialog(editedItem, tab);
           })
        }

        vm.openLead = function(item, tab, $event){
            $event.stopPropagation();
            var thisLead = leadDataService.getLead(item.related.leadBoard, item.related.leadID);
              // $log.info(thisLead);
              resetToast();
              return leadDataService.leadSheet(thisLead, tab, $event);
        }


        vm.showCue = function(cue){
          // Appcues.show(cue);
        }

        vm.importNote = function(message){
           inboxService.importNote(message);
        }

        vm.discardNotification = function(item){

           var updates = {};
           // we are using $index as a reference as not all notifications will have a .uid property
           if(_.has(item, 'uid')){
            updates['/users/' + $rootScope.userID + '/notifications/' + item.uid] = null;
           } else {
             updates['/users/' + $rootScope.userID + '/notifications/' + item.$key] = null;
           }
           return firebase.database().ref().update(updates)
           .then(function(){
             $mdToast.hide();
             $mdToast.visible = false;
          });

        }

        vm.acceptInvite = function(item){
          teamDataService.acceptInvite(item);
          resetToast();
          vm.discardNotification(item);
        }

        vm.declineInvite = function(item){
          teamDataService.declineInvite(item);
          vm.discardNotification(item);
          resetToast();
        }

        vm.refreshClients = function(){
          var clientDataService = $injector.get('clientDataService');
          return clientDataService.setupUserAndClientMenu(true);
        }

        vm.gotoClient = function(item){
          resetToast();
          $state.go("triangular.workspaces.tasks", {"clientID": item.related});
        }

        vm.toggleNotificationsTab = function(tab) {
          var user = userDataService.user;
          // It's possible that the notification was cleared before this is called.
          // we want to only mark the notification read if it still exists
          if(_.has(user, 'notifications')){
            if(_.has(user.notifications, vm.item.uid)){
              markRead(vm.item);
            }
          }
            resetToast();
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            $mdSidenav('right').toggle(tab);

        }

    }// notificationCardcontroller



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('noteEntry', noteEntry);


  function noteEntry() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: noteEntryController,
      controllerAs: 'vm',
      bindToController: true,
      // preserveScope: true,
      scope: {
        task: '@task',
        client: '@client'
      },
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/note-entry/note-entry.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {


  }// linkFunc


  /* @ngInject */
  function noteEntryController($log, hotkeys, teamDataService, $timeout, $mdToast, noteDataService, $rootScope, taskDataService, $scope, $firebaseArray, clientDataService, userDataService, localStorageService, $mdDialog) {
    // $log.info('noteEntryController');
    var thisClient = $scope.vm.client;
    // $log.info('thisClient:' + thisClient);
    var vm = this;
    vm.userID = $rootScope.userID;
    // Had trouble getting our note from $scope. Then we fitured out $parent
    // not sure why we can't pass client and task AND STILL have the
    // note scope passed along by default as before
    // but this seems to be an easy workaround
    vm.note = $scope.$parent.note;
    var thisTeam = teamDataService.clientTeams[thisClient];
    // $log.info('thisTeam:');
    // $log.info(thisTeam);
    // Find our team member
    _.each(thisTeam, function(member){
      if(member.uid == vm.note.author){
        vm.thisMember = member;
        // $log.info('thisMember:');
        // $log.info(vm.thisMember);
        if(_.has(vm.thisMember, 'color')){
          vm.bubbleBackground = ajUTILITIES.lightenDarkenColor(vm.thisMember.color, 200);
        } else {
          vm.bubbleBackground = ajUTILITIES.lightenDarkenColor('#666', 200);
        }
      }
    });

    // if no team member found, this must have been left by a clientUser
    if(!vm.thisMember){
      var userRef = firebase.database().ref('userList').child(vm.note.author);
      userRef.once('value', function(snapshot){
        vm.thisMember = snapshot.val();
      });
    }

    vm.editMode = false;



    $scope.editNote = function(entry){

      // check to make sure no other edits are open
      // alert if that's the case and ignore edit request
      // $log.info($('.inline-edit').length);
      if ($('.inline-edit').length > 0){
        // $log.info('Already editing');
        $mdToast.show(
             $mdToast.simple()
               .textContent('Already editing a Note. Please complete your operation first.')
               .position('top right')
               .hideDelay(2000)
           );
        return
      }

      vm.editMode = true;
      vm.editStatus = 'editing';
      vm.editNote = angular.copy(entry);

     // Set focus
    $timeout(function () {
        angular.element("textarea[name='editNotebody']").focus();
    }, 500);



    }// editNote

    $scope.cancelEdit = function(entry){
      vm.editMode = false;
    }

    $scope.startDelete = function(entry){
      vm.editStatus = 'startdelete';
    }

    $scope.cancelDelete = function(entry){
      vm.editStatus = 'editing';
    }


    $scope.deleteNote = function(entry, task, clientID){
      vm.editStatus = 'deleting';
      var taskCopy = angular.fromJson(task)
      taskCopy = ajUTILITIES.removePropertiesWith(taskCopy);

      return noteDataService.deleteNote(entry, taskCopy.uid, clientID)
      .then(function(response){
        vm.editStatus = 'deleted';
        $mdToast.show(
              $mdToast.simple()
                .textContent('Note Deleted')
                .position('top right')
                .hideDelay(2000)
            );
      });

    }

    $scope.updateNote = function(entry, task, clientID){

      var taskCopy = angular.fromJson(task)
      taskCopy = ajUTILITIES.removePropertiesWith(taskCopy);

      vm.editStatus = 'saving';
      return noteDataService.updateNote(entry, taskCopy.uid, clientID)
      .then(function(){
        vm.editStatus = 'saved';
        vm.editMode = false;
        $mdToast.show(
              $mdToast.simple()
                .textContent('Time Log Updated.')
                .position('top right')
                .hideDelay(2000)
            );
      });

    }// updateNote


    } // noteEntryController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('leadGroups', leadGroups);


    function leadGroups() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: leadGroupsController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {uid: '@uid', path: '@path', boarddata: '@boarddata'},
            link: linkFunc,
            templateUrl: 'app/app-directives/lead-groups/lead-groups.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }

    /* @ngInject */
    function leadGroupsController($rootScope, $scope, $mdDialog, $log, $timeout, dragulaService) {
     $log.info('leadSettings Directive');

     var vm = this;

     // Can't use VM here for bound data. Must use $scope.
     $scope.newCategory = { color: '#bbb'};
     $scope.forms = {};
     $scope.colors = $rootScope.clientColors;
     $scope.colorPicker = false;

     $timeout(function(){
         $scope.categories = angular.fromJson((vm.boarddata));
         $scope.setupComplete = true;
     }, 250);
     // $log.info($scope.categories);
     // _.each($scope.categories, function(category){
     //    $log.info(category);
     // })

     // set the groupClass for our template so we can isolate it with dragula
     $scope.groupClass = "client-category-manager-" + vm.path;
     // // Get our data
     // var boardRef = firebase.database().ref('leadBoards');
     // return boardRef.child(vm.uid).child(vm.path).once('value',
     //     function(snapshot){
     //         var exists = (snapshot.val() !== null);
     //         if(exists){
     //             $timeout(function(){
     //                 $scope.categories = snapshot.val();
     //                 $scope.setupComplete = true;
     //             }, 250);
     //         } else {
     //             alert('There was a problem requesting your custom Lead types. Please remove and re-setup your lead Types. Contact help@getadminja.com if you have any trouble.');
     //         }
     //     });

    // Lead and Contact Type Management

    $scope.toggleCategoryForm = function(show){
        $log.info('toggle form');
        if(show){
            $timeout(function(){
                $scope.showCategoryForm = true;
            },0)
            // focus on first field
        } else {
            $timeout(function(){
                $scope.showCategoryForm = false;
            },0)
        }
    }

$scope.togglePicker = function(){
    if($scope.colorPicker){
        $timeout(function(){
            $scope.colorPicker = false
            $scope.forms.categoryForm.$setDirty();
        },0);
    } else {
        $timeout(function(){
            $scope.colorPicker = true
        },0);
    }
}// togglePicker

    $scope.addCategory = function(category){
        // first make sure the nodes exist
        var newCatKey = firebase.database().ref().child('leadBoards/' + vm.uid + '/' + vm.path).push().key;
        category.uid = newCatKey;
        category.order = _.size($scope.categories) + 1;
        $scope.categories[newCatKey] = angular.copy(category);

        var updates = {};
        updates['/leadBoards/' + vm.uid + '/'  + vm.path + '/' + category.uid] = category;
        return firebase.database().ref().update(updates)
        .then(function(){
            $timeout(function(){
                $scope.newCategory = { color: '#bbb'};
                $scope.showCategoryForm = false;
                $scope.forms.categoryForm.$setDirty();
            }, 100);
        });
    } // addCategory

    $scope.updateCategory = function(category){
        $log.info('update category');
        $log.info(category);
        var updates = {};
        updates['/leadBoards/' + vm.uid + '/'  + vm.path + '/' + category.uid] = category;
        return firebase.database().ref().update(updates)
        .then(function(){
            $timeout(function(){
                $scope.categories[category.uid] = category;
                $scope.newCategory = { color: '#bbb'};
                $scope.showCategoryForm = false;
                $scope.forms.categoryForm.$setDirty();
            }, 100);
        });
    }// editCategory

    $scope.editCategory = function(category){
        $log.info('edit category');
        $scope.newCategory = angular.copy(category);
        $scope.showCategoryForm = true;
    }// editCategory


    $scope.removeCategory = function(category){
        $log.info('removeCategory');
         var confirm = $mdDialog.confirm()
                  .title('Remove this type?')
                  .htmlContent('Any contacts already assigned to these types will be moved to "pending."')
                  .ariaLabel('Are you sure?')
                  .ok('I understand')
                  .cancel('Never mind');

        $mdDialog.show(confirm).then(function() {
            var updates = {};
            updates['/leadBoards/' + vm.uid + '/'  + vm.path + '/' + category.uid] = null;
            return firebase.database().ref().update(updates)
            .then(function(){
                $timeout(function(){
                    delete $scope.categories[category.uid];
                }, 100);
            });

        }, function(){
            $mdDialog.cancel();
        })


    }// removeCategory

    // Task Dragging
    dragulaService.options($scope, 'drag-category', {
        moves: function (el, container, handle) {
                return !handle.classList.contains('drag-handle');
            // return handle.classList.contains('task-handle');
        },
        accepts: function (el, target, source, sibling) {
            // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

           return true

        },
        invalid: function(el, handle){
            // return var === 'condition'
            return false
        },
        direction: 'vertical',
        revertOnSpill: true
    });

    // declare our categoryBag so we can track drake.dragging
    var categoryBag = dragulaService.find($scope, 'drag-category');

    $scope.$on('drag-category.drop', function (event, item, target, source, sibling) {
        // Now we can do our work - prep the variables
        var itemID = item[0].attributes.catid.value,
                thisContainer = $('.'+$scope.groupClass),
                sortItems = Array.from(thisContainer.find('.category-item'));

        // Change sort order
        _.each(sortItems, function(category, index){
            var catID = category.attributes.catid.value,
            childCategoryObject = $scope.categories[catID];
            childCategoryObject.order = index + 1;
        });

        var updates = {};
        updates['/leadBoards/' + vm.uid + '/'  + vm.path] = $scope.categories;
        return firebase.database().ref().update(updates)
        .then(function(){
            // $timeout(function(){
            //     // $scope.newCategory = {};
            //     // $scope.showCategoryForm = false;
            //     // $scope.clientDialogForm.$setDirty();
            // }, 100);
        });

        $timeout(function(){
            $scope.forms.categoryForm.$setDirty();
        },0);

    });// drag-category.drop

    }// leadSettings Controller



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('leadCard', leadCard);


  function leadCard() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: leadCardController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/lead-card/lead-card.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {
      // discerns between click or text select intention.
      // sets $scope.clicked to true if it's a click so other functions can react.
        scope.time= Date.now();

         element.on("mousedown mouseup", function(e){
           if(e.type == "mousedown"){
             scope.time= Date.now();
             // console.log('selecting');
           }// if mousedown

           if(e.type == "mouseup"){
             if(Date.now() - scope.time> 300){
              scope.clicked = false;
               return false;
             }else{
               // console.log("clicked");
               scope.clicked = true;
             }// if select or click
           }// if mouseup
         });
}

  ///////////////////////////////////////////////////////////
  /// leadCardController

  /* @ngInject */
  function leadCardController($state, $timeout, $log, $mdDialog, $mdToast, $scope, $rootScope, pageDimensionsService, leadDataService, userDataService, gateService, teamDataService) {

    var vm = this;
    vm.userType = $rootScope.admin;
    vm.fbConfig = fbConfig;
    vm.openLead = openLead;
    vm.cloneLead = cloneLead;
    vm.deleteLead = deleteLead;
    vm.shortDescription = shortDescription;
    vm.contactTypes = leadDataService.leadBoard.contactTypes;
    vm.addTouchpoint = addTouchpoint;
    vm.visitWorkspace = visitWorkspace;
    vm.changeLeadStatus = changeLeadStatus;
    vm.createWorkspace = createWorkspace;
    vm.inviteUser = inviteUser;

    function shortDescription(text){

      var shortened = _.truncate(text, {
                    'length': 150,
                    'separator': '...'
                  });
      return shortened ? String(shortened).replace(/<[^>]+>/gm, '') : ''
    }// shortDescription


    vm.settings = $rootScope.userSettings;

    //Make sure our note links open in new window
    $timeout(function(){
      $('md-card.info-card a').click(function(e){
        e.preventDefault();
        window.open(this.href);
      });
    },20);

// Setup card variables
vm.numContacts = 0;
vm.lasContact = 'None';
if(_.has($scope.lead, 'contacts')){
  // vm.numContacts
  vm.numContacts = _.size($scope.lead.contacts);
  // vm.lastContact
  var lastDate = undefined;
  _.each($scope.lead.contacts, function(contact){
    if(lastDate == undefined){
      lastDate = contact.timeStamp;
    }
    if(contact.timeStamp > lastDate){
      lastDate = contact.timeStamp;
    }
  });// each contact
  vm.lastContact = lastDate;

  // Status color for lastContact
  var daysSinceLastContact = moment().diff(vm.lastContact, 'days');
  if(daysSinceLastContact < 7){
    vm.contactStatus = "";
  }
  if(daysSinceLastContact >=7 && daysSinceLastContact< 14){
    vm.contactStatus = 'close';
  }

  if(daysSinceLastContact >=14){
    vm.contactStatus = 'over';
  }
}// if has contacts


if(_.has($scope.lead, 'tasks')){
  vm.numTasks = _.size($scope.lead.tasks);

}

  function changeLeadStatus(lead,status){
    leadDataService.changeLeadStatus(lead, status)
    if(status == 'won' && !lead.promotedWorkspace){
      // ask if we should create a workspace too
       var confirm = $mdDialog.confirm()
                .title('Would you like to also create a Workspace for this Lead?')
                .htmlContent('')
                .ariaLabel('Create a workspace?')
                .ok('Do it')
                .cancel('No');

                $mdDialog.show(confirm).then(function() {
                  $log.info('said yes');
                  // said yes
                    $mdDialog.cancel();
                      return leadDataService.newWorkspace(lead);
                    }, function(){
                      $log.info('said no');
                      // said no
                      $mdDialog.cancel();
                    });
    }// if status == won

  }// changeLeadStatus

  function inviteUser(lead){
    $log.info(teamDataService.teamList);

      var teamSize = _.size(teamDataService.teamList),
      teamLimit = gateService.gateData.teamLimit;

      if(teamSize < teamLimit){
        var team = {
          ownerID : $rootScope.userID,
          ownerName : userDataService.user.profile.fullName,
          ownerEmail : userDataService.user.email
        }
        return teamDataService.inviteMember(lead.email, team)
        .then(function(){
          $mdToast.show($mdToast.adminjaAlert(
              {
                  locals:{
                      title: 'Invitation Sent!',
                      message: 'Your team invitation has been sent to ' + lead.email ,
                      color: 'green'
                  }
              }));// mdToast
        });
      } else {
        $mdToast.show($mdToast.adminjaAlert(
            {
                locals:{
                    title: 'Oops! You\'ve reached your team limit.',
                    message: 'We couldn\'t send ' + lead.email + ' an invitation.' ,
                    color: 'red'
                }
            }));// mdToast
      }


  }// inviteUser

  function createWorkspace(lead){
    return leadDataService.newWorkspace(lead);
  }

  function openLead(lead, targetTab, $event){
    $event.stopPropagation();
    var thisLead = leadDataService.getLead(lead.owner, lead.uid)
    return leadDataService.leadSheet(thisLead, targetTab)
  } // openLead

  function cloneLead(lead){
    // $log.info('controller.cloneLead');
    return leadDataService.cloneLead(lead);
  }// cloneLead

  function deleteLead(lead){
    // $log.info('controller.deleteLead');
    return leadDataService.deleteLead(lead);
  }


  function addTouchpoint(lead, $event, contactTypeID){
    $event.stopPropagation();
    return leadDataService.newContact(lead, contactTypeID)
  }

  function addReminder(lead, $event){
    $event.stopPropagation();
    return leadDataService.leadSheet(lead, 3)
  }


  function visitWorkspace(workspaceID, $event){
    $event.stopPropagation();
    $state.go("triangular.workspaces.tasks", {"clientID": workspaceID})
  }

  }// profileDetailItemController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('leadActivity', leadActivity);


  function leadActivity() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: leadActivityController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/lead-activity-item/lead-activity-item.tmpl.html'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {
      // discerns between click or text select intention.
      // sets $scope.clicked to true if it's a click so other functions can react.
        scope.time= Date.now();

         element.on("mousedown mouseup", function(e){
           if(e.type == "mousedown"){
             scope.time= Date.now();
             // console.log('selecting');
           }// if mousedown

           if(e.type == "mouseup"){
             if(Date.now() - scope.time> 300){
              scope.clicked = false;
               return false;
             }else{
               // console.log("clicked");
               scope.clicked = true;
             }// if select or click
           }// if mouseup
         });
}

  ///////////////////////////////////////////////////////////
  /// leadActivityController

  /* @ngInject */
  function leadActivityController($timeout, $sce, $log, $mdToast, $scope, $rootScope, pageDimensionsService, leadDataService, teamDataService) {

    var vm = this;
    vm.userType = $rootScope.admin;
    vm.settings = $rootScope.userSettings;
    vm.fbConfig = fbConfig;
    vm.contactTypes = leadDataService.leadBoard.contactTypes;
    vm.leadStages = leadDataService.leadBoard.leadTypes;
    vm.editActivity = editActivity;
    vm.deleteActivity = deleteActivity;


    function shortDescription(text){
      var shortened = _.truncate(text, {
                    'length': 150,
                    'separator': '...'
                  });
      return shortened
    }// shortDescription


    vm.getUser = function(contact){
      var thisUser = undefined;
      _.each(teamDataService.allMembers, function(member){
        if(member.uid == contact.owner){
          thisUser = member.fullName;
        }
      });
      return thisUser
    }
vm.getColor = function(contact){
  var color = 'purple';
  _.each(vm.contactTypes, function(type){
    if(type.uid == contact.type){
      color = type.color
    }
  });
  return color
}

vm.getType = function(contact){
  var thisType = undefined;
  if(contact.type == 'Lead Form'){
    thisType = "Online Lead Form Submitted";
  } else {
    _.each(vm.contactTypes, function(type){
      if(type.uid == contact.type){
        thisType = type.label;
      }
    });
  }

    return thisType

}


    //Make sure our note links open in new window
    $timeout(function(){
      $('md-list-item.info-card a').click(function(e){
        e.preventDefault();
        window.open(this.href);
      });
    },20);


  function editActivity(contact, $event){
    $event.stopPropagation();
    return leadDataService.editContact(contact)
  } // openLead


  function deleteActivity(contact, $event){
    $event.stopPropagation();
    return leadDataService.deleteContact(contact);
  }


  }// leadActivityController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('invoiceManager', invoiceManager);


     function invoiceManager() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: invoiceManagerController,
         scope: {
          clients: '=',
          workspace: '='
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<span ng-include="getTemplateUrl()"></span>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr, form) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/invoice-manager/invoice-manager.tmpl.html';
       };
     }// linkFunc


    /* @ngInject*/
    function invoiceManagerController($log, $scope, $sce, $mdDialog, triLoaderService, $timeout,uiGridConstants, clientBillingService, invoiceService, userDataService,  $rootScope, clientDataService, clientPackageService, $mdToast) {
        $log.info('invoiceManagerController');
        var vm = this;


        init();



        function init(){

        // Main Timeout Loop - making sure everything is on vm.
        $timeout(function(){
          vm.userType = $rootScope.admin;
          vm.selectInvoice = selectInvoice;
          vm.getInvoices = getInvoices;
          vm.rowSelectInvoice = rowSelectInvoice;
          vm.user = userDataService.user;
          vm.newPayment = newPayment;
          vm.changeMode = changeMode;
          vm.invoiceService = invoiceService;
          vm.fbConfig = fbConfig;
          vm.settings = $rootScope.userSettings;
          vm.clientPackageService = clientPackageService;
          vm.changeBillingModuleState = changeBillingModuleState;
          vm.showInvoiceGrid = false;
          vm.currency = "$";
          if (_.has(vm.settings, 'currency')){
               vm.currency = vm.settings.currency;
           }
           vm.allStart = vm.user.uid + moment().subtract(10, 'years').format('YYYY-MM-DD');
          vm.start = vm.user.uid + moment().startOf('year').format('YYYY-MM-DD');
          vm.end = vm.user.uid + moment().endOf('year').format('YYYY-MM-DD');
          vm.now = moment().toISOString();
          vm.thisYear = moment().format('YYYY');
          vm.invoiceCardLimit = 20;
          vm.editInvoice = editInvoice;
          vm.newInvoice = newInvoice;
          vm.showExperience = showExperience;

          // Prep our year list for invoice pulling
          vm.yearList = [];
          var startYear = Number(moment(vm.user.profile.startDate).format('YYYY')), endYear = Number(moment().format('YYYY'));
          for (var i = startYear; i <= endYear; i++) {
              var object = {
                label: i,
                year: Number(i),
                start: vm.user.uid + moment(i+'-01-01').startOf('year').toISOString(),
                end: vm.user.uid + moment(i+'-01-01').endOf('year').toISOString()
              }
              vm.yearList.push(object);
          }

          vm.yearList.push({
            label: 'All Time',
            year: 'all',
            start: vm.allStart,
            end: vm.end
          });

          // Set our initial viewYear to this year
          _.each(vm.yearList, function(year){
            if(year.year == moment().format('YYYY')){
              vm.viewYear = year;
            }
          });


          // Configure our Grid
          var dateCellTemplate = undefined;
          if(vm.settings.dateFormat == 'us'){
           dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
                              ' {{COL_FIELD | dateFormatFilter:\'MM/DD/YYYY\'}}' +
                              '</div>';
          }
          if(vm.settings.dateFormat == 'eu'){
           dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
                              ' {{COL_FIELD | dateFormatFilter:\'DD/MM/YYYY\'}}' +
                              '</div>';
          }

          var currencyCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
                   vm.settings.currency+'{{COL_FIELD | number: 2}}' +
                   '</div>';

          var paymentCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
                   vm.settings.currency+'{{COL_FIELD | number: 2}}' +
                   '<md-icon data-gtm-billing-click-enter-payment ng-click="grid.appScope.vm.newPayment(row.entity)" class="billing-invoice-icon" md-font-icon="zmdi zmdi-plus-circle" style="margin-left: 1em;"><md-tooltip md-delay="500">Add a Payment</md-tooltip></md-icon>' +
                   '</div>';

          var creditCellTemplate = '<div  class="text-right ngCellText ui-grid-cell-contents" title="{{COL_FIELD}}">' +
                   '<span ng-if="row.entity.credit > 0" style="color: green;">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
                   '</div>';
          var debitCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" title="{{COL_FIELD}}">' +
                   '<span ng-if="row.entity.debit > 0">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
                   '</div>';
          var lineItemCostCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
                   '<span ng-if="row.entity.type != \'Payment\'">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
                   '<span ng-if="row.entity.type == \'Payment\'">N/A</span>' +
                   '</div>';

          var uidCellTemplate = '<div class="ngCellText ui-grid-cell-contents center" title="View Invoice">' +
                   '<md-icon data-gtm-billing-report-view-invoice ng-click="grid.appScope.vm.rowSelectInvoice(row.entity.uid)" class="billing-invoice-icon" md-font-icon="fa fa-file-o"><md-tooltip md-delay="500">View Invoice</md-tooltip></md-icon>' +
                   '</div>';

          var statusCellTemplate = '<div class="ngCellText ui-grid-cell-contents center" title="Payment Status">' +
                   '<md-icon ng-if="row.entity.paymentStatus == \'paid\'" class="billing-invoice-icon" md-font-icon="fa fa-check" style="color: #96C089;"><md-tooltip md-delay="500">Paid in Full</md-tooltip></md-icon>' +
                   '<md-icon ng-if="row.entity.paymentStatus == \'pastDue\'" class="billing-invoice-icon" md-font-icon="zmdi zmdi-alert-circle" style="color: #EA8E8E;"><md-tooltip md-delay="500">Past Due!</md-tooltip></md-icon>' +
                   '</div>';

          var footerCurrencyCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
                   '<strong>' + vm.settings.currency+'{{col.getAggregationValue() | number : 2}}</strong>' +
                   '</div>';

          var paymentInfoTemplate = '<div layout="row" layout-align="center start" style="background-color: #FFF;">'+
                                      '<div class="billing-payment-details" layout="column" layout-align="start layout-fill">'+
                                          '<p  class="md-subhead margin-top-0 padding-top-10 padding-bottom-10 center">Payments Applied</p>'+
                                          '<div class="billing-payment-list-item" layout="row" layout-align="start center" ng-repeat="payment in row.entity.PaymentData |toArray: false track by $index">' +
                                                '<div flex="10">{{payment.date | dateFormatFilter:\'MM/DD/YYYY\'}}</div>'+
                                                '<div flex="70" style="padding-left: 4em;">{{payment.notes}}</div>'+
                                                '<div flex="10" style="text-align: right;">{{row.entity.currency}}{{payment.amount| number: 2}}</div> '+
                                          '</div>'+
                                          '<div layout="row" layout-align="start center"><div flex="80"><p class="right"><strong>Total received:&nbsp;&nbsp;</strong></p></div><div flex="10"><p class="right"><strong>{{row.entity.currency}}{{row.entity.Payments}}</strong></p></div>'+
                                      '</div>'+
                                    '</div>'

          // Different version of payment template for EU date format
          if(vm.settings.dateFormat == 'eu'){
            paymentInfoTemplate = '<div class="billing-payment-details"   layout="column" layout-align="start layout-fill"> <p palette-background="green:100" class="md-subhead margin-top-0 padding-top-10 padding-bottom-10 center">Payments received:</p>'+
                                        '<div class="billing-payment-list-item" layout="row" layout-align="start center" ng-repeat="payment in row.entity.PaymentData |toArray: false track by $index">' +
                                            '<div flex="10">{{payment.date | dateFormatFilter:\'DD/MM/YYYY\'}}</div>'+
                                            '<div flex="60" class="padding-left-20">{{payment.notes}}</div>'+
                                            '<div flex="10">{{vm.settings.currency}}{{payment.amount| number: 2}}</div> '+
                                    '</div></div>'
          }


          var invoiceDetailsTemplate = '<div class="invoice-details-container"><p class="md-subhead center">Invoice #{{row.entity.Number}}</p><div class="invoice-subgrid" ui-grid="row.entity.subGridOptions" ui-grid-auto-resize></div></div>';
          var emptyCellTemplate = '<div></div>';
          var qtyCellTemplate = '<div class="right">{{COL_FIELD}}</div>';


          vm.invoiceGridOptions = {
                        rowHeight:30,
                        enableFiltering: true,
                        enableGridMenu: true,
                        groupingShowCounts: true,
                        exporterMenuPdf: false,
                        excessRows: 20,
                        virtualizationThreshold: 100,
                        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                        exporterMenuExcel: false,
                        exporterCsvFilename: 'invoice-report.csv',
                        exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
                        exporterSuppressColumns: [ 'PaymentData', ' '],
                        enableRowSelection: false,
                        showColumnFooter: true,
                        gridMenuShowHideColumns: false,
                        columnDefs: [
                          { field: 'Number',
                            enableSorting: true,
                            type: 'number',
                            width: 100},
                          { field: 'Issued',
                            enableSorting: true,
                            cellTemplate: dateCellTemplate,
                            width: 150,
                            sort: {
                                direction: uiGridConstants.DESC
                            },
                          },
                          { field: 'Due',
                            enableSorting: true,
                            cellTemplate: dateCellTemplate,
                            width: 150
                          },
                          { field: 'Client',
                            enableSorting: true},
                          { field: 'Total',
                            enableSorting: true,
                            type: 'number',
                            cellTemplate: currencyCellTemplate,
                            width: 150,
                            aggregationHideLabel: true,
                            aggregationType: uiGridConstants.aggregationTypes.sum,
                            footerCellTemplate: footerCurrencyCellTemplate},
                          { field: 'Payments',
                            enableSorting: true,
                            type: 'number',
                            cellTemplate: paymentCellTemplate,
                            width: 150,
                            aggregationHideLabel: true,
                            aggregationType: uiGridConstants.aggregationTypes.sum,
                            footerCellTemplate: footerCurrencyCellTemplate},
                          { field: 'Balance',
                            enableSorting: true,
                            type: 'number',
                            cellTemplate: currencyCellTemplate,
                            width: 150,
                            aggregationHideLabel: true,
                            aggregationType: uiGridConstants.aggregationTypes.sum,
                            footerCellTemplate: footerCurrencyCellTemplate},
                          { field: 'Status',
                            enableSorting: true,
                            enableFiltering: false,
                            enableColumnMenu :false,
                            cellTemplate: statusCellTemplate,
                            width: 75},

                          { field: 'View',
                            enableSorting: false,
                            enableFiltering: false,
                            enableColumnMenu :false,
                            cellTemplate: uidCellTemplate,
                            width: 75}

                        ],
                         expandableRowTemplate: invoiceDetailsTemplate,
                         //This will be the height of the subgrid
                         expandableRowHeight: 230,
                         //Variables of object expandableScope will be available in the scope of the expanded subgrid
                         expandableRowScope: {
                            subGridVariable: 'subGridScopeVariable'
                          },
                        onRegisterApi: function( gridApi ) {
                          vm.invoiceGridAPI = gridApi;
                           vm.invoiceGridAPI.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
                              resizeGrid();
                               // if(oldHeight != newHeight) {
                                //  // alert('add code to resize height!')
                                //   vm.invoiceGridAPI.core.queueGridRefresh();
                               // }
                          });

                           vm.invoiceGridAPI.expandable.on.rowExpandedStateChanged($scope,function(row){
                            if (row.isExpanded) {
                               row.entity.subGridOptions = {
                                   minRowsToShow: 3,
                                   data: row.entity.lineItems,
                                   showColumnFooter: true,
                                   columnDefs: [
                                       { name: 'Date',
                                         field:'date',
                                         width: 150,
                                         cellTemplate: dateCellTemplate,
                                         sort: {direction: uiGridConstants.DESC} },

                                       { name: 'Type',
                                         field: 'type',
                                         width: 150 },

                                       { name: 'Description',
                                         field: 'description' },

                                       { name: 'Quantity',
                                         field: 'quantity',
                                         width: 150 },

                                       { name: 'Unit Cost',
                                         field: 'cost',
                                         width: 150,
                                         cellTemplate: lineItemCostCellTemplate},

                                       { name: 'Debit',
                                         field: 'debit',
                                         width: 150,
                                         cellTemplate: debitCellTemplate,
                                         aggregationHideLabel: true,
                                         aggregationType: uiGridConstants.aggregationTypes.sum,
                                         footerCellTemplate: footerCurrencyCellTemplate
                                         },

                                       { name: 'Credit',
                                         field: 'credit',
                                         width: 150,
                                         cellTemplate: creditCellTemplate,
                                         aggregationHideLabel: true,
                                         aggregationType: uiGridConstants.aggregationTypes.sum,
                                         footerCellTemplate: footerCurrencyCellTemplate
                                       }
                                   ]
                               };
                            }// if row expanded
                           });

                        }
                      };

          // setup a watcher to refresh the grid if payments are applied
          var unwatch = $rootScope.$on('paymentApplied',function() {
              triLoaderService.setLoaderActive(true);

            $timeout(function(){
              return getInvoices(vm.viewYear.start, vm.viewYear.end)
            }, 3000)
            .then(function(){
              triLoaderService.setLoaderActive(false);
            });


          });

            // load our initial gridData
            return getInvoices(vm.viewYear.start, vm.viewYear.end);
        },0)

    }// init


        function changeBillingModuleState(state){
          clientPackageService.changeBillingModuleState(state);
        }

        function changeMode(mode){
          invoiceService.changeInvoiceMode(mode)
        }

        function newPayment(invoiceRow){
          // find the actual invoice from vm.invoices
          var thisInvoice = _.find(vm.invoices, function(invoice){
            return invoice.uid == invoiceRow.uid;
          } )

          return invoiceService.newPayment(thisInvoice);
        }// newPayment

        function showExperience(experienceID){
          $log.info('show experience:' + experienceID);
                  userpilot.trigger(experienceID);
              }

        function getInvoices(start, end){
          vm.showInvoiceGrid = false;
          // $log.info('getInvoices for year ' + start);
          return clientBillingService.getInvoices(start, end)
          .then(function(results){
            if(!vm.workspace){
              vm.invoices = results;
            }  else {
              vm.invoices = [];
              _.each(results, function(thisInvoice){
                if(thisInvoice.info.client == vm.workspace.uid){
                  vm.invoices.push(thisInvoice);
                }
              })
            }
              vm.invoiceGridData = [];
              // get our total and past due balances
              vm.outstanding = 0;
              vm.pastDue = 0;
              vm.monthLabel = moment().startOf('month').format('MMMM YYYY');
              vm.invoiced = 0;
              vm.received=0;
              var monthStart = moment().startOf('month').startOf('day').toISOString(),
                  monthEnd = moment().endOf('month').endOf('day').toISOString();

              // Count and decorate with client names and payment totals
              _.each(vm.invoices, function(invoice, index){
                  // $log.info('Processing invoice #' + invoice.info.number);
                  vm.outstanding = Number(vm.outstanding) + Number(invoice.info.balance);
                  vm.dueDate = moment(invoice.info.due).toISOString();
                  vm.issueDate = moment(invoice.info.date).toISOString();

                  // if past Due, increment that counter
                  if(vm.now >= vm.dueDate){
                    vm.pastDue = Number(vm.pastDue) + Number(invoice.info.balance);
                  }

                    vm.invoiced = Number(vm.invoiced) + Number(invoice.info.total);

                  invoice.paymentsReceived = 0;
                  // add up payments
                  if(_.has(invoice.info, 'payments')){
                    _.each(invoice.info.payments, function(payment){
                      invoice.paymentsReceived = Number(invoice.paymentsReceived) + Number(payment.amount);
                      vm.received = Number(vm.received) + Number(payment.amount);

                    })// each payment

                  }

                  // put time entries and line items onto invoice (joined)
                  var lineItems = [];

                  if(_.has(invoice, 'lineItems')){
                    _.each(invoice.lineItems, function(item){
                      if(!_.has(item, 'amount') && _.has(item, 'cost')){
                        item.amount = item.cost;
                      }
                      var total = Number(item.quantity * item.amount).toFixed(2);
                      var newLineItem = {
                        cost: Number(item.amount),
                        quantity: Number(item.quantity),
                        type: 'Charge',
                        description: item.description,
                        date: item.date,
                        uid: item.uid,
                        debit: Number(total).toFixed(2),
                        credit: 0
                      }
                      lineItems.push(newLineItem);
                    });
                  }

                  if(_.has(invoice, 'time')){
                    _.each(invoice.time, function(entry){
                      var logged = Number(entry.logged/60).toFixed(2),
                          total = Number(logged * entry.rate).toFixed(2);

                      var entryAsLineItem = {
                        cost: Number(entry.rate),
                        quantity: Number(logged).toFixed(2),
                        type: 'Time',
                        description: entry.description,
                        date: entry.logDate,
                        uid: entry.uid,
                        debit: Number(total).toFixed(2),
                        credit: 0
                      }
                      lineItems.push(entryAsLineItem);
                    });
                  }
                  if(_.has(invoice.info, 'payments')){
                    _.each(invoice.info.payments, function(payment){

                      var paymentAsLineItem = {
                        uid: payment.uid,
                        date: payment.date,
                        description: payment.notes,
                        type: 'Payment',
                        quantity: 1,
                        cost: 'N/A',
                        credit: payment.amount,
                        debit: 0
                      }
                      lineItems.push(paymentAsLineItem)
                    })
                  }

                  if(_.has(invoice.info, 'calculateTax')){
                    if(invoice.info.calculateTax){
                      var taxAsLineItem = {
                        uid: 'tax' + invoice.uid,
                        date: invoice.info.date,
                        description:  invoice.info.taxLabel,
                        type: 'Charge',
                        quantity: invoice.info.taxPercentage + '% ',
                        cost: invoice.info.subTotal,
                        debit: Number(invoice.info.taxedAmount)
                      }
                      lineItems.push(taxAsLineItem);
                    }
                  }

                  var paymentStatus = 'ok';
                  if(invoice.info.balance > 0 && vm.now > invoice.info.due){
                    paymentStatus = 'pastDue'
                  }

                  if(invoice.info.balance <= 0 && invoice.info.total >0){
                    paymentStatus = 'paid'
                  }

                  // Push into vm.invoiceGridData
                  var row = {
                    Number: invoice.info.number,
                    Issued: invoice.info.date,
                    Due: invoice.info.due,
                    Client: invoice.info.recipient.name,
                    Total: Number(invoice.info.total).toFixed(2),
                    Payments: Number(invoice.paymentsReceived).toFixed(2),
                    Balance: Number(invoice.info.balance).toFixed(2),
                    uid: invoice.uid,
                    // PaymentData: invoice.info.payments,
                    currency: vm.settings.currency,
                    lineItems: lineItems,
                    paymentStatus: paymentStatus
                  }
                  vm.invoiceGridData.push(row);
              });// each invoice

          })
          .then(function(){
            $timeout(function(){
              vm.invoiceGridOptions.data = vm.invoiceGridData;
              vm.showInvoiceGrid = true;
            },0)
            // Adjust height of our grid
            $timeout(function(){
              resizeGrid();
            },0);// timeoutFunction to make sure vm is working properly
          });// return invoices chain

        }//getInvoices

          function resizeGrid(){
              var grid = $('.invoice-grid'),
                  pageHeight = $('md-content.triangular-content').height(),
                  toolbarHeight = $('.triangular-toolbar').height(),
                  billingStatsHeight = $('.billing-stats').height(),
                  recentInvoicesHeight = $('.billing-invoices-container').height(),
                  gridHeight = pageHeight - toolbarHeight - billingStatsHeight - recentInvoicesHeight - 50;

                  $(grid).css('height', gridHeight);
          }

        function invoiceViewController($scope, $rootScope, invoiceService){
          // $log.info('invoiceViewController');
          var vm = this;
          vm.userType = $rootScope.admin;
          // hide the remittance slip
          $timeout(function(){
            $('.remittance').hide();
          });

          vm.logPayment = function(){
            return invoiceService.newPayment(vm.invoice);

          }

          vm.close = function(){
            $mdDialog.cancel();
          }

          vm.writeOffInvoice = function(invoiceID){
            // $log.info('writeoff invoice and close:');
          }

          vm.downloadPDF = function(){
            var pdfConsent = false;
            if(userDataService.hasConsent('invoices')){
                pdfConsent = true;
            } else {
                return userDataService.getConsent('invoices', 'Can we send invoices to our PDF generator?','<p>In order to generate PDFs, we need permission to securely process your invoice information with a third party.</p>' )
            };
              invoiceService.selectedInvoice = vm.invoice;
              invoiceService.preparePDF(invoiceService.selectedInvoice, vm.user, vm.client)
              invoiceService.createPDF(invoiceService.selectedInvoice);
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Woot!',
                          message: 'Your PDF is being prepared. We will notify you here when it is ready.' ,
                          color: 'orange'
                      }
                  }));// mdToast
          }

        }// invoiceView Controller

        function rowSelectInvoice(invoiceID){
          // this function is called from within ui-grid click events
          // ui-grid's data doesn't include the full invoice
          // it acts as a bridge between ui-grid and getInvoiceHTML (below)
          // by looking up the invoice by UID and then passing it on to getInvoiceHTML

          // we are supporting 2 modes for this directive, global should show us the invoice rendered, if workspace specified however, we want to EDIT the invoice not view it


          var invoice = _.find(vm.invoices, function (invoice) {
                     return invoice.uid == invoiceID;
                 });
            selectInvoice(invoice);

        }

        function editInvoice(invoice){
          if(_.has(invoice, 'timeStamp')){
            vm.invoiceService.selectInvoice(invoice.uid);
          } else {
            vm.invoiceService.selectedInvoice = invoice;
          }
          vm.changeMode('edit');
        }//


        function newInvoice(){
          $log.info('newInvoice');
          $timeout(function(){
            triLoaderService.setLoaderActive(true);
          })
          return vm.invoiceService.newPackageInvoice(vm.user.uid, vm.workspace.uid, moment().toISOString())
          .then(function(response){
            var invoice = response.data;
            $timeout(function(){
              vm.invoiceService.setupHandlebars(invoice); // this doesn't do anything to invoice. Just readies handlebars. Probably not needed here after move to cloud
              triLoaderService.setLoaderActive(false);
              editInvoice(invoice);
            })
          })
        }

        function selectInvoice(invoice){
          $log.info('selectInvoice');
          if(vm.workspace){
            // was it created with the new system or legacy
            if(!_.has(invoice, 'info.billingPeriod')){
              editInvoice(invoice)
            } else {
              $mdDialog.show($mdDialog.alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('This Invoice cannot be managed here')
                  .textContent('This invoice was created with the old Billing Period manager. Switch to viewing Legacy Billing to manage it.')
                  .ariaLabel('Dismissed')
                  .ok('OK')
              );
            }
          } else {
            triLoaderService.setLoaderActive(true);
            var invoiceCopy = angular.fromJson(angular.toJson(invoice));
            invoiceCopy.time = _.sortBy(invoiceCopy.time, ['logDate']);
            invoiceCopy.lineItems = _.sortBy(invoiceCopy.lineItems, ['date']);

            // Add proper date to time and lineItems
            _.each(invoiceCopy.time, function(time){

              time.displayDate = moment(time.logDate).format('MMM D');

            });
            _.each(invoiceCopy.lineItems, function(item){

              item.displayDate = moment(item.date).format('MMM D');

            });
            invoiceCopy.logo = vm.user.profile.logo;
            invoiceCopy.currency = vm.settings.currency;

            // Get Client


            // vm.thisClient = _.find(vm.clients, function (client) {
            //            return client.uid == invoice.info.client;
            //        });


            return invoiceService.getInvoiceHTML(invoiceCopy)
            .then(function(renderedInvoice){
              $timeout(function(){
                triLoaderService.setLoaderActive(false);
              })
              .then(function(){
                var invoiceHTML = renderedInvoice;


                $mdDialog.show({
                        template:
                          '<md-dialog flex="100" style="padding-top: 1em;" class="invoice-viewer" aria-label="Invoice Viewer">' +
                          '  <md-dialog-content><div class="print-document-container" print-section>'+
                              invoiceHTML +
                          ' </div> </md-dialog-content>' +
                          '  <md-dialog-actions>' +
                          '    <md-button data-gtm-billing-click-enter-payment ng-if="vm.userType == \'admin\'" ng-click="vm.logPayment()" class="md-primary">' +
                          '      Enter Payment' +
                          '    </md-button>' +
                          // '    <md-button data-gtm-billing-request-pdf ng-if="vm.invoice.type != \'packageInvoice\'" ng-click="vm.downloadPDF()" class="md-primary">' +
                          // '      Request PDF' +
                          // '    </md-button>' +
                          '    <md-button data-gtm-billing-print-invoice print-btn class="md-primary">' +
                          '      Print' +
                          '    </md-button>' +
                          '    <md-button ng-click="vm.close()" class="md-primary">' +
                          '      Done' +
                          '    </md-button>' +
                          '  </md-dialog-actions>' +
                          '</md-dialog>',
                        locals: {
                          invoice: invoice,
                          user: vm.user,
                          client: vm.thisClient
                        },
                        escapeToClose: true,
                        clickOutsideToClose: true,
                        controller: invoiceViewController,
                        bindToController: true,
                        controllerAs: 'vm'
                     });
              })
            })// return invoiceService.getInvoiceHTML
          }// if we are editing or viewing an invoice
        }// selectInvoice

    } // invoiceManagerController



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('invoiceEditor', invoiceEditor);


     function invoiceEditor() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: invoiceEditorController,
         scope: {
          clients: '=',
          workspace: '='
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<span ng-include="getTemplateUrl()"></span>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService']; //
   function linkFunc(scope, element, attr, form) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/invoice-editor/invoice-editor.tmpl.html';
       };
     }// linkFunc


    /* @ngInject*/
    function invoiceEditorController($mdToast, $state, $log, $sce, hotkeys, $compile, timeDataService, $http, clientPackageService, $stateParams,  $window, $scope, triLoaderService, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, clientBillingService,  invoiceService){
      var vm = this;
      $log.info('invoiceEditor');
      $scope.workspaceID = $stateParams.clientID;
      vm.initializing = true;
      vm.getAvailableCharges = getAvailableCharges;
      vm.getAvailableTime = getAvailableTime;
      vm.timeEntryTotal = timeEntryTotal;
      vm.editCharge = editCharge;
      vm.openTime = openTime;
      vm.expose = expose;
      vm.setInvoiceMode = setInvoiceMode;
      vm.cancel = cancel;
      vm.clientPackageService = clientPackageService;
      vm.changeBillingModuleState = changeBillingModuleState;
      vm.clients = clientDataService.clients;
      vm.fbConfig = fbConfig;
      vm.user = userDataService.user;
      vm.userType = $rootScope.admin;
      vm.settings = $rootScope.userSettings;
      vm.currency = vm.settings.currency;
      vm.clientBillingService = clientBillingService;
      vm.invoiceService = invoiceService;
      vm.now = moment().toISOString();
      vm.timeOptionToggled = timeOptionToggled;
      vm.chargeOptionToggled = chargeOptionToggled;
      vm.changeGrouping = changeGrouping;
      vm.size = size;
      vm.addSelectedToInvoice = addSelectedToInvoice;
      vm.removeInvoiceItem = removeInvoiceItem;
      vm.editInvoiceItem = editInvoiceItem;
      vm.renderInvoice = renderInvoice;
      vm.editInvoiceField = editInvoiceField;
      vm.updateInvoice = updateInvoice;
      vm.deleteInvoice = deleteInvoice;
      vm.cancelEditInvoiceField = cancelEditInvoiceField;
      vm.getPackageCount = getPackageCount;
      vm.packageTypeLabel = packageTypeLabel;
      vm.addEntirePackageToInvoice = addEntirePackageToInvoice;
      vm.newPayment = newPayment;
      vm.numCandidates = numCandidates;
      vm.timeDetailsToggled = timeDetailsToggled;
      vm.emailInvoice = emailInvoice;
      vm.candidateCount = candidateCount;
      vm.changePaymentProcessor = changePaymentProcessor;
      vm.showExperience = showExperience;




      vm.groupingOptions = [
        {
          label: 'No Grouping',
          value: 'none'
        },
        {
          label: 'Package',
          value: 'package'
        },{
          label: 'Category',
          value: 'category'
        },
        {
          label: 'Task',
          value: 'task'
        },
        {
          label: 'Team Member',
          value: 'member'
        }
      ]


      // Make sure we automatically update the invoice if it's data changes.
      $scope.$watch('vm.invoiceService.selectedInvoice.info', function() {
        $log.info('invoice changed!');
        $timeout(function(){
          if(vm.invoiceService.selectedInvoice){
            return renderInvoice();
          } else {
            $log.info('Invoice Cleared');
          }
        }, 400);

      });



      init();

      function init(){
        vm.exposed = {};
        vm.selectedTime = {};
        vm.selectedCharges = {};
        vm.packageCounts = {};
        vm.client = _.find(vm.clients, function (client) {
            return client.uid == $state.params.clientID;
        });
        if(_.has(vm.workspace, 'packages')){
          _.each(vm.workspace.packages, function(thisPackage){
            vm.exposed[thisPackage.uid] = false;
          });
        }
        return vm.getAvailableTime(vm.workspace)
        .then(function(time){
          return vm.getAvailableCharges(vm.workspace)
          .then(function(charges){
            vm.initializing = false;
            vm.chargeCandidates = charges;
            vm.timeCandidates = time;

            // Setup payment Processor Selector Support
            vm.paymentProcessors = [
              {label: 'No Payment Link', value: 'none'}
            ];
            if(vm.user.profile.settings.paypalEnabled){
              vm.paymentProcessors.push({label: 'PayPal', value: 'paypal'})
            }
            if(vm.user.profile.settings.stripeEnabled){
              vm.paymentProcessors.push({label: 'Stripe', value: 'stripe'})
            }
            if(vm.user.profile.settings.urlEnabled){
              vm.paymentProcessors.push({label: 'Custom Payment Link', value: 'url'})
            }

            vm.selectedPaymentProcessor = 'none';
            if(vm.invoiceService.selectedInvoice.info.enablePaypal){
              vm.selectedPaymentProcessor = 'paypal';
            }
            if(vm.invoiceService.selectedInvoice.info.enableStripe){
              vm.selectedPaymentProcessor = 'stripe';
            }
            if(vm.invoiceService.selectedInvoice.info.enableURL){
              vm.selectedPaymentProcessor = 'url';
            }
            return vm.renderInvoice()
          });
        });
      }// init


      function changePaymentProcessor(processor){
        $log.info('changePaymentProcessor');
        $log.info(processor);
        if(processor == 'paypal'){
          vm.invoiceService.selectedInvoice.info.enablePaypal = true;
          vm.invoiceService.selectedInvoice.info.enableStripe = false;
          vm.invoiceService.selectedInvoice.info.enableURL = false;
          vm.invoiceService.selectedInvoice.info.paypalClient = vm.user.profile.settings.paypalClient;
          vm.invoiceService.selectedInvoice.info.stripeClient = null;
          vm.invoiceService.selectedInvoice.paymentLink = "https://www.adminja.co/#/payment-portal/" + vm.invoiceService.selectedInvoice.info.client + '/' + vm.invoiceService.selectedInvoice.uid;
        }

        if(processor == 'stripe'){
          vm.invoiceService.selectedInvoice.info.enablePaypal = false;
          vm.invoiceService.selectedInvoice.info.enableStripe = true;
          vm.invoiceService.selectedInvoice.info.enableURL = false;
          vm.invoiceService.selectedInvoice.info.stripeClient = vm.user.profile.settings.stripeClient;
          vm.invoiceService.selectedInvoice.info.paypalClient = null;
          vm.invoiceService.selectedInvoice.paymentLink = "https://www.adminja.co/#/payment-portal/" + vm.invoiceService.selectedInvoice.info.client + '/' + vm.invoiceService.selectedInvoice.uid;

        }

        if(processor == 'url'){
          vm.invoiceService.selectedInvoice.info.enableURL = true;
          vm.invoiceService.selectedInvoice.info.enablePaypal = false;
          vm.invoiceService.selectedInvoice.info.enableStripe = false;
          vm.invoiceService.selectedInvoice.info.paypalClient = null;
          vm.invoiceService.selectedInvoice.info.stripeClient = null;
          vm.invoiceService.selectedInvoice.paymentLink = vm.user.profile.paymentLink;
        }

        if(processor == 'none'){
          vm.invoiceService.selectedInvoice.info.enablePaypal = false;
          vm.invoiceService.selectedInvoice.info.enableURL = false;
          vm.invoiceService.selectedInvoice.info.enableStripe = false;
          vm.invoiceService.selectedInvoice.info.paypalClient = null;
          vm.invoiceService.selectedInvoice.info.stripeClient = null;
          vm.invoiceService.selectedInvoice.paymentLink = null;

        }
        userDataService.trackEvent('change-invoice-payment-processor');
        updateInvoice(vm.invoiceService.selectedInvoice);
      }

      function emailInvoice(invoice, $event){
        var confirm = $mdDialog.prompt()
              .title('Enter email addresses')
              .textContent('Separate multiple addresses with a comma.')
              .placeholder('name@domain.com')
              .ariaLabel('name@domain.com')
              .initialValue(invoice.info.recipient.email)
              .targetEvent($event)
              .ok('Send')
              .cancel('Cancel');

            $mdDialog.show(confirm).then(function (recipients) {
              $log.info('send invoice to: ' + recipients);
              $timeout(function(){
                triLoaderService.setLoaderActive(true);
              })
              return invoiceService.emailInvoice(invoice, recipients)
              .then(function(result){
                $timeout(function(){
                  triLoaderService.setLoaderActive(false);
                  $mdToast.show($mdToast.adminjaAlert(
                      {
                          locals:{
                              title: 'Woot!',
                              message: 'Your invoice is on it\'s way!' ,
                              color: 'green'
                          }
                      }));// mdToast
                })
              })
              .catch(function(error){
                throwError(error)
              })
            }, function () {
              $log.info('send invoice cancelled');
            });
      }//emailInvoice

      function numCandidates(){
        var results = 0;
        _.each(vm.client.packages, function(thisPackage){
          var thisCount = getPackageCount(thisPackage.uid);
          results = results + thisCount
        })
        return results
      }// hasCandidates


      function size(item){
        return _.size(item);
      }//size

      function cancel(){
        vm.invoiceService.selectedInvoice = null;
        vm.setInvoiceMode('manage');
      }

      function changeBillingModuleState(state){
        clientPackageService.changeBillingModuleState(state);
      }


      function deleteInvoice(invoice){
        $log.info('delete invoice!');
        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
          triLoaderService.setLoaderActive(true);
        })

        // determine if deletable
        var pass = true;
        if(_.has(invoice.info, 'payments')){
          _.each(invoice.info.payments, function(payment){
            if(_.has(payment,'locked')){
              if(payment.locked){
                pass = false;
              }
            }
          })
        }
        if(pass){
          return invoiceService.deletePackageInvoice(invoice)
          .then(function(){
            $timeout(function(){
              vm.invoiceService.selectedInvoice = null;
              vm.setInvoiceMode('manage');
              $timeout(function(){
                vm.invoiceService.invoiceSaving = false;
                triLoaderService.setLoaderActive(false);
              })
            })
          })
          .catch(function(error){
            $log.info('Error deleting invoice');
            throwError(error)
          });
        } else {
          $timeout(function(){
            vm.invoiceService.invoiceSaving = false;
            triLoaderService.setLoaderActive(false);
            vm.showDeleteConfirm = false;
          })
          // invoice has received payments via a payment processor. It cannot be deleted.
           var confirm = $mdDialog.confirm()
              .title('Invoice #' + invoice.info.number + ' Cannot Be Deleted')
              .htmlContent('This invoice has received payments from your client that cannot be removed.')
              .ariaLabel('Got It')
              .ok('Got it');

          $mdDialog.show(confirm).then(function() {

          })
        }

      }// deleteInvoice

      function updateInvoice(invoice){
        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
        })

          return invoiceService.updatePackageInvoice(invoice)
          .then(function(invoice){
              $timeout(function(){
                vm.invoiceService.invoiceSaving = false;
              })
          })
          .catch(function(error){
                    throwError(error)
          })

      }// updateInvoice

      function timeDetailsToggled(invoice){
        $log.info('timeDetailsToggled');
        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
        })

        vm.updateInvoice(invoice)
        .then(function(invoice){
            $log.info('Invoice Updated');
            $timeout(function(){
              vm.invoiceService.invoiceSaving = false;
            })
        })
         .catch(function(error){
              throwError(error)
        })
      }

      function changeGrouping(){
        $log.info('changeGrouping');
        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
        })

       return invoiceService.changeInvoiceGrouping(vm.invoiceService.selectedInvoice)
       .then(function(invoice){
              $log.info('Invoice Updated');
              $timeout(function(){
                vm.invoiceService.invoiceSaving = false;
              })
       })
       .catch(function(error){
            throwError(error)
      })
      }//

      function timeOptionToggled(item){
        if(vm.selectedTime[item.uid]){
          // if doesn't exist in array, add it.
          vm.selectedTime[item.uid] = null;

        } else {
          // if it does exist in array, remove it.
          vm.selectedTime[item.uid] = item;
        }
      }// vm.timeOptionToggled

      function chargeOptionToggled(item){
        if(vm.selectedCharges[item.uid]){
          // if doesn't exist in array, add it.
          vm.selectedCharges[item.uid] = null;

        } else {
          // if it does exist in array, remove it.
          vm.selectedCharges[item.uid] = item;
        }
      }// vm.timeOptionToggled

      function addSelectedToInvoice(invoice, time, charges){
        $log.info('addSelectedToInvoice');
        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
        })
       return invoiceService.addToInvoice(invoice, time, charges)
       .then(function(response){
          $log.info('Item(s) added');
          // $log.info(response);
          vm.selectedTime = {};
          vm.selectedCharges = {};
          // renderInvoice() //we are rendering automatically on $watch

            $timeout(function(){
              vm.invoiceService.invoiceSaving = false;
            })

       })
       .catch(function(error){
        $log.info('invoiceService could not update invoice');
        throwError(error);

      });// service.addToInvoice

      }//addSelectedToInvoice

      function addEntirePackageToInvoice(invoice, time, charges){

        $timeout(function(){
          vm.invoiceService.invoiceSaving = true;
        })

        var sendTime = {}, sendCharges = {};
        _.each(time, function(entry){
            if(!entry.exempt && !entry.invoiced && entry.uid){
              sendTime[entry.uid] = entry;
            }
        })
        _.each(charges, function(entry){
            if(!entry.invoiced && entry.uid){
              sendCharges[entry.uid] = entry;
            }
        })

        addSelectedToInvoice(invoice, sendTime, sendCharges)

      }//addEntirePackageToInvoice

      function removeInvoiceItem(event){
            $log.info('removeInvoiceItem');
            $timeout(function(){
              vm.invoiceService.invoiceSaving = true;
            })
             var item = $(event.target).closest('tr'),
                itemID = $(item).data('id'),
                itemType = $(item).data('type');
            // $log.info(itemID);
            // $log.info(itemType);
            if(itemType == 'time'){
              return invoiceService.removeTimeEntry(vm.invoiceService.selectedInvoice, itemID)
              .then(function(){
                // renderInvoice() // we are rendering automatically via a $watch
                $timeout(function(){
                  vm.invoiceService.invoiceSaving = false;
                })
              })
              .catch(function(error){
                  throwError(error)
              });
            }

            if(itemType == 'charge'){
              return invoiceService.removeChargeEntry(vm.invoiceService.selectedInvoice, itemID)
              .then(function(){
                // renderInvoice() // we are rendering automatically via a $watch
                $timeout(function(){
                  vm.invoiceService.invoiceSaving = false;
                })
              })
              .catch(function(error){
                  throwError(error)
              });
            }

            if(itemType == 'payment'){
               var confirm = $mdDialog.confirm()
                  .title('Permanently Delete this Payment?')
                  .htmlContent('This cannot be undone')
                  .ariaLabel('Are you sure?')
                  .ok('Do it')
                  .cancel('Never mind');

              $mdDialog.show(confirm).then(function() {
                  return invoiceService.removePayment(vm.invoiceService.selectedInvoice, itemID)
                  .then(function(){
                    // renderInvoice() // we are rendering automatically via a $watch
                  })
                  .catch(function(error){
                    $mdDialog.cancel();
                    throwError(error)
                  });
              })
            }


      }// removeInvoiceItem


      function newPayment(invoice){
        return invoiceService.newPayment(invoice);
      }// newPayment
      function cancelEditInvoiceField(event){
        $log.info('cancelEditField');
        renderInvoice();
      }

      function editInvoiceField(event){
        var item = $(event.target).closest('.editable-field'),
            field = $(item).data('field');
            // $log.info('editing: ' + field);
          var controlButtons = '<md-button ng-click="vm.cancelEditInvoiceField($event)">Cancel</md-button>'+
            '<md-button ng-click="vm.updateInvoice(vm.invoiceService.selectedInvoice)">Update</md-button>';

            if(field == 'details' && !vm.editingInline){
              // make sure our invoice number is a number
              vm.invoiceService.selectedInvoice.info.number = Number(vm.invoiceService.selectedInvoice.info.number);

              var detailsFields = '<md-input-container>'+
              '<label>Invoice Number</label>'+
              '<input ng-model="vm.invoiceService.selectedInvoice.info.number" type="number">' +
              '</md-input-container>'+
              '<md-input-container style="margin-top: 1em; margin-bottom: 0;">'+
              '<label>Invoice Date</label>'+
              '<md-datepicker ng-disabled="vm.isClientUser"  class="md-indigo-theme md-primary"  ng-model="vm.invoiceService.selectedInvoice.info.date" md-placeholder="" md-current-view="month"></md-datepicker>'+
              '</md-input-container>'+
              '<md-input-container style="margin-top: .5em; margin-bottom: 0;">'+
              '<label>Due</label>'+
              '<md-datepicker ng-disabled="vm.isClientUser"  class="hide-for-print md-indigo-theme md-primary"  ng-model="vm.invoiceService.selectedInvoice.info.due" md-placeholder="Due" md-current-view="month"></md-datepicker>'+
              '</md-input-container>';

              $('.editable-details').addClass('inline-edit-enabled');
              $('.editable-details').append(detailsFields);
              $('.editable-details').append(controlButtons);
              $('.editable-details .editable-replace').css('display', 'none');
              vm.editingInline = true;
            }

            if(field == 'company' && !vm.editingInline){
              var recipientFields = '<md-input-container>'+
              '<label>Recipient Name</label>'+
              '<input ng-model="vm.invoiceService.selectedInvoice.info.recipient.name" >' +
              '</md-input-container>'+
              '<md-input-container>'+
              '<label>Recipient Email</label>'+
              '<input ng-model="vm.invoiceService.selectedInvoice.info.recipient.email" type="email">' +
              '</md-input-container>'
              $('.editable-company').addClass('inline-edit-enabled');
              $('.editable-company').append(recipientFields);
              $('.editable-company').append(controlButtons)
              $('.editable-company .editable-replace').css('display', 'none');
              vm.editingInline = true;
            }


            $timeout(function(){
              $compile(angular.element('#branding'))($scope)
            })

      }

      function editInvoiceItem(event){
        $log.info('editInvoiceItem');
        var item = $(event.target).closest('tr'),
            itemID = $(item).data('id'),
            itemType = $(item).data('type');
            // $log.info(itemID);
            // $log.info(itemType);
            if(itemType == 'payment'){
              return invoiceService.editPayment(itemID);
            }

            if(itemType == 'time'){
              return invoiceService.editTimeEntry(itemID);
            }

            if(itemType == 'charge'){
              return invoiceService.editChargeEntry(itemID);
            }
      }// editInvoiceItem


      function setInvoiceMode(mode){
        invoiceService.changeInvoiceMode(mode);
        // if "none" - we should cleanup any invoice that's in an unsaved state
      }// newInvoice


      function renderInvoice(){
          $log.info('renderInvoice');
          return new Promise(function(resolve, reject){
            vm.editingInline = false;
            return invoiceService.getInvoiceHTML(vm.invoiceService.selectedInvoice)
            .then(function(renderedInvoice){
              var parser = new DOMParser();
              // parse our HTML into DOM nodes and extract just the body
              var invoiceBox = new DOMParser().parseFromString(renderedInvoice, 'text/html').body;
              // $log.info(doc.innerHTML);
              $timeout(function(){
                //store the body.innerHTML as our invoice
                vm.invoiceHTML = $sce.trustAsHtml(invoiceBox.innerHTML);
              }, 0)
              .then(function(){
                // loop through all items and attach edit controls
                $timeout(function(){
                  $compile(angular.element('#invoice-wrapper'))($scope)
                },0)
                  .then(function(){
                    decorateInvoice()
                    .then(function(){
                      return resolve(true);
                    });
                  });
              })
            });
          })

      }// newInvoice

      function decorateInvoice(){
        return new Promise(function(resolve, reject){

          var lineItemControls = '<div flex="nogrow" class="invoice-item-controls" layout="row" layout-align="start center" ng-if="!vm.invoiceService.selectedInvoice.sent" >'+
                                  '<md-icon flex="nogrow" ng-click="vm.removeInvoiceItem($event)"  md-font-icon="zmdi zmdi-close"></md-icon>'+
                              '</div>';
        var paymentControls = '<div flex="nogrow" class="invoice-item-controls payment-controls" layout="row" layout-align="start center" ng-if="!vm.invoiceService.selectedInvoice.sent" >'+
                                '<md-icon flex="nogrow" ng-click="vm.editInvoiceItem($event)" md-font-icon="zmdi zmdi-edit"></md-icon>'+
                                '<md-icon flex="nogrow" ng-click="vm.removeInvoiceItem($event)"  md-font-icon="zmdi zmdi-close"></md-icon>'+
                            '</div>';

          var editableFieldControls = '<div flex="nogrow" ng-click="vm.editInvoiceField($event)" class="invoice-item-controls" layout="row" layout-align="start center" ng-if="!vm.invoiceService.selectedInvoice.sent && !vm.editingInline" >'+
                                  '<md-icon  flex="nogrow"  md-font-icon="zmdi zmdi-edit"></md-icon>'+
                              '</div>';


          var termsControl = '<md-input-container>'+
          '             <textarea ng-disabled="vm.isClientUser"  ng-blur="vm.updateInvoice(vm.invoiceService.selectedInvoice)"  style="border-bottom: none; margin-top:0; background-color: #efefef; border-radius: 4px; padding: 1em;" rows="1" max-rows="4"  ng-model=\'vm.invoiceService.selectedInvoice.info.terms\' >'+
          '      </md-input-container>' ;

          var notesControl = '<md-input-container>'+
          '             <textarea ng-disabled="vm.isClientUser"  ng-blur="vm.updateInvoice(vm.invoiceService.selectedInvoice)" style="border-bottom: none; margin-top:0; background-color: #efefef; border-radius: 4px; padding: 1em;" rows="1" max-rows="4"  ng-model=\'vm.invoiceService.selectedInvoice.info.notes\' >'+
          '             </md-input-container>';


          if(_.has(vm.invoiceService.selectedInvoice, 'timeStamp')){
            // wow, believe it or not we are going to actually manipulate the DOM outside of angular.
            // but this is the BEST way to be able to use the same invoice template for rendering/sending in the cloud, and rendering/editing in app.
            $timeout(function(){
              var invoiceBox = $('.invoice-box');
              var paymentItems = $('.item-payment .controls');
              var chargeItems = $('.item-charge .controls');
              var timeItems = $('.item-time .controls');

              _.each(paymentItems, function(item){
                $(item).append(paymentControls)
              });

              _.each(chargeItems, function(item){
                $(item).append(lineItemControls)
              });

              _.each(timeItems, function(item){
                $(item).append(lineItemControls)
              });

              var editableItems = $('.editable-field');
              _.each(editableItems, function(item){
                $(item).append(editableFieldControls)
              });


              var termsBlock = $('.invoice-terms');
               $(termsBlock).append(termsControl);
               // remove default terms
               $('.invoice-terms span').css('display', 'none');

               var notesBlock = $('.invoice-notes');
               $(notesBlock).append(notesControl);
               // remove default notes
               $('.invoice-notes span').css('display', 'none');

               // // remove payment link block
               // $('.payment-link').css('display', 'none');

               // compile our appended directives
              $timeout(function(){
                $compile(angular.element('#invoice-view'))($scope)
              })
              .then(function(){
                return resolve(true);
              })
            })
          } else {
              // invoice hasn't been officially saved
              // so don't decorate yet
              return resolve(true);
          }

        })

      }// decorateInvoice

      function packageTypeLabel(type){
        switch(type) {
            case 'fixed':
                return 'Fixed Fee';
                break;
            case 'retainer':
                return 'Renewable Retainer';
                break;
            case 'hourly':
                return 'Renewable Hourly';
                break
            case 'balance':
                return 'Renewable Balance';
                break
            case 'refillable':
                return "Refillable Balance";
                break
            default: return 'Unknown'

        }// switch

      }// packageType

      function expose(id){
        $timeout(function(){
          if(vm.exposed[id]){
            vm.exposed[id] = false
          } else {
            vm.exposed[id] = true
          }

        })

      }// expose

      function getAvailableTime(workspace){
        return new Promise(function(resolve, reject){
          var timeCandidates = {};
          if(_.has(workspace, 'packages')){
            _.each(workspace.packages, function(thisPackage){
              timeDataService.getPackageTime(thisPackage.uid)
              .then(function(packageTime){
                timeCandidates[thisPackage.uid] = packageTime;
              });
              return resolve(timeCandidates)
            })
          } else {
            return resolve({})
          }

        })
      }//getAvailableTime

      function candidateCount(items){
        var count = 0;
        _.each(items, function(item){
          if(!item.invoiced && !item.exempt){
            count ++
          }
        })
        return count
      }// candidateCount

      function getAvailableCharges(workspace){
        return new Promise(function(resolve, reject){
          if(_.has(workspace, 'packages')){
            var chargeCandidates = {}, chargeCounts = {};
            _.each(workspace.packages, function(thisPackage){
              clientPackageService.getPackageCharges(thisPackage.uid)
              .then(function(charges){
                chargeCandidates[thisPackage.uid] = charges;
                chargeCounts[thisPackage.uid] = _.size(charges);
              });
            })
            $timeout(function(){
              vm.chargeCounts = chargeCounts;
              return resolve(chargeCandidates)
            }, 1000)
          } else {
            return resolve({})
          }

        })
      }//getAvailableCharges


      function getPackageCount(packageID){
        if(vm.timeCandidates && vm.chargeCandidates){
          var count = 0
          _.each(vm.timeCandidates[packageID], function(entry){
            if(!entry.exempt && !entry.invoiced && entry.packageType == 'hourly'){
              count ++
            }
          });
          _.each(vm.chargeCandidates[packageID], function(entry){
            if(!entry.invoiced){
              count ++
            }
          });
          return count
        } else {
          return 0
        }

      }//getPackageCounts

      function timeEntryTotal(entry){
          return entry.rate * (entry.logged/60)
      }

       function openTime(entry){
        if(!vm.isClientUser){
          timeDataService.timeDialog(entry, 'Modify');
        }
      }

      function editCharge(lineItem){
          clientPackageService.editLineItem(lineItem);
      }// addCharge

      function throwError(error){
        $timeout(function(){
          triLoaderService.setLoaderActive(false);
        })
        $log.info(error);
        $mdToast.show(
            $mdToast.adminjaAlert(
           {
               locals:{
                   title: 'Problem updating invoice',
                   message: 'There was a problem updating your invoice. Please refresh and try again.' ,
                   color: 'red'
               }
           }));
      }


      function showExperience(experienceID){
          userpilot.trigger(experienceID);
      }

    }// invoiceEditorController



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('filePicker', filePicker);


    function filePicker() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: filePickerController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {files: '=files', // our parent object's file array
                    form: '=form', // our parent object's form (for making it dirty)
                    counter: '=counter', // our parent object's file count
                    disabled: '=disabled', // status of our parent object (i.e. if uploads are allowed)
                    filepath: '=filepath' // storage path for files
                },
            link: linkFunc,
            templateUrl: 'app/app-directives/file-picker/file-picker.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }

    /* @ngInject */
    function filePickerController($rootScope, $scope, $log, $timeout) {
        var vm = this;
        vm.files = $scope.files;
        vm.form = $scope.form;
        vm.counter = $scope.counter;
        vm.updatePaths = $scope.updatepaths;
        vm.filePath = $scope.filepath;
        vm.disabled = $scope.disabled;




        // Dropbox File Functions
        // NOTE: All dropbox functions handled by the directive
        // See our customized version at /vendor-components/dropbox-picker.min.js

        // Utility function used to generate unique IDs for each image uploaded to storage
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }
          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

        // Google File Functions
        vm.onLoaded = function () {
           console.log('Google Picker loaded!');
         }

         vm.onPicked = function (docs) {
           angular.forEach(docs, function (file, index) {
            var fileObject = {
                fileName: file.name,
                url: file.url,
                thumbnail: file.url,
                source: 'googleDrive'
            }

            vm.files.push(fileObject);

            $timeout(function(){
                vm.form.$setDirty();
                vm.isUploading = false;
                vm.count = vm.count + 1;
            },0);
           });
         }

         vm.onCancel = function () {
           console.log('Google picker close/cancel!');
         }


         // UPload file directly to firebaseStorage
         $scope.uploadFile = function ($files) {
             // $log.info('upload file');
             // $log.info($files);

             if ($files !== null && $files.length > 0) {
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 _.each($files, function (file) {
                     var filename = file.name;
                     vm.isUploading = true;
                    var uniqueID = guid();
                     // $log.info('Saving '+filename);
                     // create imageRef and put the file
                     var fileRef = storageRef.child(vm.filePath + '/' + uniqueID+'-'+filename),
                             uploadTask = fileRef.put(file);

                     uploadTask.on('state_changed', function (snapshot) {
                         // $log.info('upload state changed');
                     }, function (error) {
                         // $log.warn('upload failed');
                         alert('upload failed. please refresh and try again.')
                     }, function (success) {
                         $log.info('upload success');
                         // $log.info(uploadTask.snapshot);
                         return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL){
                              console.log('File available at', downloadURL);
                               var thumbnailURL = uploadTask.snapshot.downloadURL;
                               // NOTE: We are putting thumbnail on here as FULL image so we have something to show immediately
                               // once a thumbnail has been generated, the views will utilize that instead of the recorded thumb below.
                               var fileObject = {
                                   fileName: filename,
                                   url: downloadURL,
                                   thumbnail: downloadURL,
                                   source: 'firebaseStorage',
                                   fullPath: fileRef.fullPath
                               }

                              vm.files.push(fileObject);

                               $timeout(function(){
                                   vm.form.$setDirty();
                                   vm.isUploading = false;
                                   vm.count = vm.count + 1;
                               },0);
                            });


                     }); // uploadTask.on
                 }); // ._each files
             } // if files

             //heap.track('File Uploaded');
             userpilot.track('File Uploaded');
         }; // vm.uploadAvatar


    }// filePickerController



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('gravatarImage', function () {
      /*
       * A simple Gravatar Directive
       * @example
       *   <gravatar-image email="test@email.com" size="50"></gravatar-image>
       */
      return {
        restrict: 'AE',
        replace: true,
        required: 'email',
        template: '<img ng-src="https://www.gravatar.com/avatar/{{hash}}?s={{size}}&d=identicon" />',
        link: function (scope, element, attrs) {
          attrs.$observe('email', function (value) {
            if(!value) { return; }

            // MD5 (Message-Digest Algorithm) by WebToolkit
            var md5=function(s){function L(k,d){return(k<<d)|(k>>>(32-d));}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H);}if(I|d){if(x&1073741824){return(x^3221225472^F^H);}else{return(x^1073741824^F^H);}}else{return(x^F^H);}}function r(d,F,k){return(d&F)|((~d)&k);}function q(d,F,k){return(d&k)|(F&(~k));}function p(d,F,k){return(d^F^k);}function n(d,F,k){return(F^(d|(~k)));}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F);}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F);}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F);}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F);}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++;}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa;}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2);}return k;}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x);}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128);}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128);}}}return d;}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g);}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase();};

            scope.hash = md5(value.toLowerCase());
            scope.size = attrs.size;

            if(angular.isUndefined(scope.size)) {
              scope.size = 60; // default to 60 pixels
            }
          });
        }
      };
    });


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('globalTimer', globalTimer);


  function globalTimer() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: globalTimerController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {

    scope.getTemplateUrl = function() {
        return 'app/app-directives/global-timer/global-timer.tmpl.html';
    };

  }


  /* @ngInject */
  function globalTimerController($rootScope, $scope) {
    var vm = this;


    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('fileAttachments', fileAttachments);


    function fileAttachments() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: fileAttachmentsController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {files: '=files', // our parent object's file array
                    form: '=form', // our parent object's form (for making it dirty)
                    counter: '=counter', // our parent object's file count
                    client: '=client', // clientID so we know uploaded file paths
                    path: '=path', // path that files should be saved (tasks/profile/etc.)
                    status: '=status' // status of our parent object (i.e. if uploads are allowed)
                },
            link: linkFunc,
            templateUrl: 'app/app-directives/file-attachments/file-attachments.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }

    /* @ngInject */
    function fileAttachmentsController(userDataService, $rootScope, $scope, $log, $timeout) {
        var vm = this;
        vm.files = $scope.files;
        vm.form = $scope.form;
        vm.counter = $scope.counter;
        vm.client = $scope.client;
        vm.path = $scope.path;
        // $log.info($scope);

        // Check for status
        vm.status = true;
        // If status is closed, override our default
        if (_.has($scope, 'status')){
            // if it's not closed, the status is true
            if ($scope.status == 'closed'){
                vm.status = false;
            }
        }


        // Dropbox File Functions
        // NOTE: All dropbox functions handled by the directive
        // See our customized version at /vendor-components/dropbox-picker.min.js

        // Utility function used to generate unique IDs for each image uploaded to storage
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }
          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

        // Google File Functions
        vm.onLoaded = function () {
           console.log('Google Picker loaded!');
         }

         vm.onPicked = function (docs) {
           angular.forEach(docs, function (file, index) {
            var fileObject = {
                fileName: file.name,
                url: file.url,
                thumbnail: file.url,
                source: 'googleDrive'
            }

            vm.files.push(fileObject);

            $timeout(function(){
                vm.form.$setDirty();
                vm.isUploading = false;
                vm.count = vm.count + 1;
                userDataService.trackEvent('cloud-file-attached');
            },0);
           });
         }

         vm.onCancel = function () {
           console.log('Google picker close/cancel!');
         }

         $scope.removeFile = function (chip) {
             // $log.info('removeFile');

             // If the file is stored in firebase Storage, we need to delete it
             if(chip.source != 'googleDrive' && chip.source != 'dropbox'){
                 // Create a reference to the file to delete
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 var fileRef = storageRef.child('clients/' + vm.client + '/'+ vm.path+'/' + chip.fileName);

                 // // Delete the file
                 fileRef.delete().then(function () {
                     // File deleted successfully
                     // $log.info('File ' + chip.fileName + ' deleted.');
                     // $mdToast.showSimple(chip.fileName + ' deleted.');
                 }).catch(function (error) {
                     // Uh-oh, an error occurred!
                     // $log.info('Oops! File ' + chip.fileName + ' NOT! deleted.');
                 });
             }
             userDataService.trackEvent('file-deleted');

         }

         // UPload file directly to firebaseStorage
         $scope.uploadFile = function ($files) {
             // $log.info('upload file');
             // $log.info($files);

             if ($files !== null && $files.length > 0) {
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 _.each($files, function (file) {
                     var filename = file.name;
                     vm.isUploading = true;
                    var uniqueID = guid();
                     // $log.info('Saving '+filename);
                     // create imageRef and put the file
                     var fileRef = storageRef.child('clients/' + vm.client + '/'+ vm.path +'/' + uniqueID+'-'+filename),
                             uploadTask = fileRef.put(file);

                     uploadTask.on('state_changed', function (snapshot) {
                         // $log.info('upload state changed');
                     }, function (error) {
                         // $log.warn('upload failed');
                     }, function (success) {


                         return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadUrl){
                             var thumbnailUrl = downloadUrl;
                            // NOTE: We are putting thumbnail on here as FULL image so we have something to show immediately
                            // once a thumbnail has been generated, the views will utilize that instead of the recorded thumb below.
                            // $log.info(uploadTask);
                            var fileObject = {
                                fileName: filename,
                                url: downloadUrl,
                                thumbnail: thumbnailUrl,
                                source: 'firebaseStorage',
                                fullPath: fileRef.fullPath
                            };

                           vm.files.push(fileObject);

                            $timeout(function(){
                                vm.form.$setDirty();
                                vm.isUploading = false;
                                vm.count = vm.count + 1;
                            },0);

                         });


                     }); // uploadTask.on
                 }); // ._each files
             } // if files
             userDataService.trackEvent('file-attached');
             //heap.track('File Uploaded');
             userpilot.track('File Uploaded');
         }; // vm.uploadAvatar


    }// fileAttachmentsController



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('fileAttachmentList', fileAttachmentList);


    function fileAttachmentList() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: fileAttachmentListController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {files: '=files', removeable: '=removeable', form: '=form'},
            link: linkFunc,
            templateUrl: 'app/app-directives/file-attachment-list/file-attachment-list.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }

    /* @ngInject */
    function fileAttachmentListController($rootScope, $scope, $log, $timeout) {
        var vm = this;

        vm.files = $scope.files;

        // $log.info($scope);


        // $scope.fileIcon = function(fileName){

        //     var extension = fileName.split('.').pop(),
        //         icon = undefined;
        //         extension = extension.toLowerCase();
        //         switch(extension) {
        //             case 'pdf':
        //                 icon = "fa fa-file-pdf-o";
        //                 break
        //             case 'docx':
        //                 icon = "fa fa-file-word-o";
        //                 break
        //             case 'doc':
        //                 icon = "fa fa-file-word-o";
        //                 break
        //             case 'ppt':
        //                 icon = "fa fa-file-powerpoint-o";
        //                 break
        //             case 'pptx':
        //                 icon = "fa fa-file-powerpoint-o";
        //                 break
        //             case 'xls':
        //                 icon = "fa fa-file-excel-o";
        //                 break
        //             case 'xlsx':
        //                 icon = "fa fa-file-excel-o";
        //                 break
        //             case 'zip':
        //                 icon = "fa fa-file-zip-o";
        //                 break
        //             case 'mp3':
        //                 icon = "fa fa-file-audio-o";
        //                 break
        //             case 'png':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             case 'jpg':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             case 'jpeg':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             case 'gif':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             case 'psd':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             case 'ai':
        //                 icon = "fa fa-file-image-o";
        //                 break
        //             default:
        //                 icon = "fa fa-file-o"
        //         }
        //     return icon
        // }

        $scope.shortenFilename = function(text){
         return _.truncate(text, {
            'length': 16,
            'omission': '...'
          });
         }

        $scope.isImage = function (file){
           var validExtensions = [
               'jpg',
               'gif',
               'png',
               'bmp',
               'JPG',
               'BMP',
               'GIF',
               'PNG',
               'jpeg',
               'JPEG'
               ],
             extension = file.fileName.split('.').pop();

           // if this file's extension is valid, return true
           if (_.includes(validExtensions,extension)){
             return true
           } else {
             return false
           }
         }// isImage

         $scope.removeFile = function (file, $event) {
             // $log.info('removeFile');
             $event.stopPropagation();
            // If the file is stored in firebase Storage, we need to delete it
             if(file.source != 'googleDrive' && file.source != 'dropbox'){
                 // Create a reference to the file to delete
                 var storage = firebase.storage(),
                         storageRef = storage.ref();
                 var fileRef = storageRef.child(file.fullPath);

                 // // Delete the file
                 fileRef.delete().then(function () {
                    _.remove($scope.files, {
                        fileName: file.fileName
                    });

                     // File deleted successfully
                     // $log.info('File ' + file.fileName + ' deleted.');
                     // $mdToast.showSimple(file.fileName + ' deleted.');
                 }).catch(function (error) {
                     // Uh-oh, an error occurred!
                     // $log.info('Oops! File ' + file.fileName + ' NOT! deleted.');
                 });
             } else {
                // Google Drive or Dropbox, just remove the reference
                _.remove($scope.files, {
                    fileName: file.fileName
                });
             }

             // if there's a form attached, set it to dirty
             if($scope.form){
                $timeout(function(){
                    $scope.form.$setDirty();
                },0);
             }
             //heap.track('Task File Deleted');
             userpilot.track('Task File Deleted');
         }



    }// fileAttachmentListController



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('detailMenu', detailMenu);


  function detailMenu() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: detailMenuController,
      scope: {
        selectedDetail: '=selecteddetail',
        x: '=x',
        y: '=y',
        boardData: '=board'
      },
      controllerAs: 'vm',
      bindToController: true,
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/detail-board/detail-menu.tmpl.html'
    };
    return directive;
  };

  // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
  function linkFunc(scope, element, attr) {
    // block user from scrolling board when menu is open
    $('.adminja-board-container').css('overflow-x', 'hidden');
    // block user from rearranging tasks while menu is open
    $('.board-column-content').addClass('drag-disabled');
    // block vertical scrolling while menu is open
    $('.board-column-content-wrapper').removeClass('small-scrollbar');
    $('.board-column-content-wrapper').css('overflow-y', 'hidden');
  } // linkFunc

  /* @ngInject */
  function detailMenuController($timeout, $rootScope, $scope, firebase, $log, $mdToast, $mdDialog, clientDataService, userDataService, profileDataService, hotkeys) {
    $log.info('detailMenuController');

    var vm = this;
    vm.fbConfig = fbConfig;
    vm.userType = $rootScope.admin;
    vm.user = userDataService.user;
    vm.settings = $rootScope.userSettings;
    vm.init = init;
    vm.editDetail = editDetail;
    vm.cloneDetail = cloneDetail;
    vm.deleteDetail = deleteDetail;
    vm.setColor = setColor;
    vm.today = new Date();
    vm.canDelete = canDelete;
    vm.colors = $rootScope.noteColors;
    vm.toggleColorPicker = toggleColorPicker;
    vm.showNoteColors = false;

    function init(){
      // $log.info('detailMenu Init');

    }//init

    function toggleColorPicker(){
      $timeout(function(){
        if(vm.showNoteColors){
          vm.showNoteColors = false;
        }  else {
          vm.showNoteColors = true;
        }
      })

    }//toggleColorPicker

    function canDelete(detail){
      if(detail){
        if(detail.owner == $rootScope.userID || detail.creator == $rootScope.userID){
          return true
        } else {
          return false
        }
      } else {
        return false
      }

    }//canDelete

    function setColor(color){
      vm.selectedDetail.notecolor = color;
        var updates = {};
        firebase.database().ref('/detailBoards/' + vm.boardData.uid + '/lists/' + vm.selectedDetail.list + '/items/' + vm.selectedDetail.uid + '/notecolor').set(color);
        $timeout(function(){
          vm.selectedDetail = null;
        },100)

    }//setColor

    function editDetail (item) {
        profileDataService.editProfileDetail(item, 'Update');
        vm.selectedDetail = null;
    }; // End editDetail


    function cloneDetail(item,$event) {
         var newDetail = angular.copy(item);
              // $log.info(newDetail);
              // Remove ID, Client, and Bucket so we will then be saving a new copy and be able to assign it elsewhere

              delete newDetail.uid;

              profileDataService.editProfileDetail(newDetail, 'Clone');
         $timeout(function(){
           vm.selectedDetail = null;
         })

    }; // End cloneDetail




    // change completed status
    function deleteDetail(detail, $event) {
        $event.stopPropagation();
        profileDataService.deleteProfileDetail(detail);
        $timeout(function(){
          vm.selectedDetail = null;
        })
    };



    $scope.$on('$destroy', function() {
            $('.adminja-board-container').css('overflow-x', 'scroll');
            $('.board-column-content').removeClass('drag-disabled');
            $('.board-column-content-wrapper').addClass('small-scrollbar');
            $('.board-column-content-wrapper').css('overflow-y', 'scroll');
         });

    }// detailMenuController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('detailListMenu', detailListMenu);


  function detailListMenu() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: detailListMenuController,
      scope: {
        selectedList: '=selectedlist',
        x: '=x',
        y: '=y',
        boardData: '=board'
      },
      controllerAs: 'vm',
      bindToController: true,
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/detail-board/detail-list-menu.tmpl.html'
    };
    return directive;
  };

  // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
  function linkFunc(scope, element, attr) {
    // block user from scrolling board when menu is open
    $('.adminja-board-container').css('overflow-x', 'hidden');
    // block user from rearranging tasks while menu is open
    $('.board-column-content').addClass('drag-disabled');
    // block vertical scrolling while menu is open
    $('.board-column-content-wrapper').removeClass('small-scrollbar');
    $('.board-column-content-wrapper').css('overflow-y', 'hidden');
  } // linkFunc

  /* @ngInject */
  function detailListMenuController($timeout, $rootScope, $scope, $log, $mdDialog, userDataService, clientDataService,  profileDataService, hotkeys) {
    $log.info('detailListMenuController');

    var vm = this;
    vm.fbConfig = fbConfig;
    vm.userType = $rootScope.admin;
    vm.user = userDataService.user;
    vm.settings = $rootScope.userSettings;
    vm.newDetail = newDetail;
    vm.init = init;


    function init(){
      // $log.info('detailListMenu Init');

    }//init



    function newDetail(list, type, event){
      var newDetail = profileDataService.newProfileDetail(type, list);
      profileDataService.editProfileDetail(newDetail);
      closeDetailListMenu()
    }//newDetail

    function closeDetailListMenu(){
      vm.selectedList = null;
    }

    $scope.$on('$destroy', function() {
            $('.adminja-board-container').css('overflow-x', 'scroll');
            $('.board-column-content').removeClass('drag-disabled');
            $('.board-column-content-wrapper').addClass('small-scrollbar');
            $('.board-column-content-wrapper').css('overflow-y', 'scroll');
         });

    }// detailListMenuController


})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('detailBoard', detailBoard);


  function detailBoard() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: detailBoardController,
      scope: {
        boardID: '=boardid',
        thisClient: '=client'
      },
      controllerAs: 'vm',
      bindToController: true,
      link: linkFunc,
      // Populate the template via ng-include
      templateUrl: 'app/app-directives/detail-board/detail-board.tmpl.html'
    };
    return directive;
  };

  // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
  function linkFunc(scope, element, attr) {} // linkFunc

  /* @ngInject */
  function detailBoardController($timeout, $rootScope, $mdSidenav, $templateCache, $scope, firebase, $log, triLoaderService, $mdToast, $mdDialog, taskDataService, clientDataService, userDataService, profileDataService, teamDataService, hotkeys, kanbanService) {
    $log.info('detailBoardController');
    triLoaderService.setLoaderActive(true);
    // Setup scope
    var vm = this;
    vm.triLoaderService = triLoaderService;
    vm.fbConfig = fbConfig;
    vm.userType = $rootScope.admin;
    vm.user = userDataService.user;
    vm.colors = $rootScope.boardColors;
    vm.settings = $rootScope.userSettings;
    vm.forms = {};
    vm.typeFilter = 'none';
    vm.userFilter = 'all';
    vm.searchTerm = '';
    vm.sortBy = 'order';
    // Scope Functions
    vm.init = init;
    vm.quickTask = quickTask;
    vm.newList = newList;
    vm.scrollEnd = scrollEnd;
    vm.filterItems = filterItems;
    vm.sortItems = sortItems;
    vm.deleteList = deleteList;
    vm.closeListMenu = closeListMenu;
    vm.closeDetailMenu = closeDetailMenu;
    vm.closeDetailListMenu = closeDetailListMenu;
    vm.toggleSidePanel = toggleSidePanel;
    vm.updateList = updateList;
    vm.saveList = saveList;
    vm.selectListColor = selectListColor;
    vm.selectBoardColor = selectBoardColor;
    vm.undoUpgrade = undoUpgrade;
    vm.listMenuNewTask = listMenuNewTask;
    vm.updateBoard = updateBoard;
    vm.resetTaskSearch = resetTaskSearch;
    vm.duplicateList = duplicateList;
    vm.cleanupMuuri = cleanupMuuri;
    vm.listCount = 0;
    vm.setupComplete = false;


    // detailBoard Variables
    // declare our grid variables so they available to all functions
    var columnGrids = [],
      boardElement,
      boardGrid,
      boardRef,
      dragContainer = document.querySelector('.drag-container'),
      boardContainer = document.querySelector('.adminja-board-container'),
      itemDrag = {},
      columnDrag = {},
      resizeTimer,
      changedWatchers = {},
      addedWatchers = {},
      removedWatchers = {},
      boardLayout;

      // Persistent listener
      // Set our resize listener
      window.addEventListener('resize', windowResize, false);

      function windowResize(e){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          resizeBoard();
        }, 1000);
      }//windowResize

      // get our userRole defined
      vm.userRole = 'owner';

      if(_.has(teamDataService, 'clientTeams')){
        setRole();
        init();
      } else {
        $timeout(function(){
          setRole()
        },1000)
        .then(function(){
          init();
        })
      }


    /////////////////////////////
    // Main Functions
    function init() {
      $log.info('init');
      vm.boardData = undefined;
      columnGrids = [];
      boardGrid = undefined;
      boardElement = undefined;
      vm.setupComplete = false;
      // Get the initial board data & init our detailBoard
      boardRef = firebase.database().ref('detailBoards').child(vm.boardID);
      boardRef.once('value', function(snapshot) {
        vm.boardData = snapshot.val();
        // sort the lists so we don't need to rely on muuri to sort them initially
        vm.boardData.lists = _.sortBy(vm.boardData.lists,
          [function(o) { return o.order; }]);
        // Make sure our board dimensions are set
        if(_.has(kanbanService, 'clientTemplate')){
          // Set our initial board and column heights
          resizeBoard();
          // board can be laid out vertically or horizontally
          boardLayout = {
                      horizontal: true,
                      fillGaps: true,
                    }
          if(_.has(vm.settings, 'verticalProfilePanels')){
              if(vm.settings.verticalProfilePanels){
                  boardLayout = {
                     horizontal: false,
                     fillGaps: false,
                  }
              }
          }

          // Instantiate the main board grid so we can drag those
          initializeMainBoard();

          // add our lists to the board
          _.each(vm.boardData.lists, function(list) {
                // make sure user is allowed to see list
                var shouldDisplay = false;
                if(vm.userRole != 'client'){
                  shouldDisplay = true;
                } else {
                  // this is a client user. make sure the list is enabled
                  if(list.clientEnabled){
                    shouldDisplay = true;
                  }
                }
                if(shouldDisplay){
                    addList(list);
                }
          });

          // Setup our Listeners
          boardElement = document.querySelector('.board');
          boardContainer = document.querySelector('.adminja-board-container');
          setupListeners();




          // Get our team members for team filter list
          if(_.has(teamDataService.clientTeams, vm.thisClient.uid)){
              vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
          }
          setupWatchers();

          // make sure we have proper dimensions so horizontal scroll appears if necessary
          $timeout(function() {
            _.each(columnGrids, function(grid){
              grid.refreshItems().layout()
            });

            boardGrid.refreshItems().layout();
            triLoaderService.setLoaderActive(false);
            $timeout(function(){
              resizeBoard();
            }, 1000)
            .then(function(){
              vm.setupComplete = true;
            })
          }, 1000)

        } else {
          return kanbanService.init()
          .then(function(){
            init();
          })
        }
      });

    } //init

    function updateColumnSort() {
      return new Promise(function(resolve, reject) {
        var columns = boardGrid.getItems(),
          updates = {};
        _.each(columns, function(column) {
          var columnElem = column.getElement(),
            columnItemContainer = columnElem.querySelector('.board-column-content'),
            index = boardGrid.getItems().indexOf(column),
            uid = columnElem.getAttribute('data-id');
            if(uid && uid != 'undefined'){
              var order = index;
              // Add to DB changes
              updates['/detailBoards/' + vm.boardID + '/lists/' + uid + '/order'] = order;
            }
        });

        return firebase.database().ref().update(updates)
          .then(function() {
            boardGrid.synchronize();
            return resolve(resetDragData())
          })
          .catch(function(error) {
            throwError(error);
          })
      });
    } //updateColumnSort

    function addList(listData, suppressAnimation) {
      // $log.info('addList');
      if(_.has(listData, 'uid')){
        if(listData.uid != 'undefined'){
          // Create the column element.
          // sort each list's items so we don't need to rely on muuri to sort them initially
          listData.items = _.sortBy(listData.items,
            [function(o) { return o.order; }]);
          var wrapper = document.createElement('div');
          var columnHTML = kanbanService.newDetailListElement(listData, vm.boardData.settings, vm.userRole);
          wrapper.innerHTML = columnHTML;

          // Add the column to the DOM
          var columnElem = wrapper.children[0];

          if (!suppressAnimation) {
            initColumn(columnElem, listData); // init this column's grid
          } else {
            fastInitColumn(columnElem, listData)
          }
        }
      }// if list is valid

    } // addList

    function removeList(list) {
      _.each(boardGrid.getItems(), function(item) {
        var gridID = item.getElement().getAttribute('data-id');
        if (list.uid == gridID) {
          boardGrid.remove([item], { removeElements: true });
          $timeout(function(){
            vm.listCount = _.size(boardGrid.getItems());
            // $log.info('Lists: ' + vm.listCount);
          }, 0);
        }
      });
    } //removeList

    function quickTask(parentElement, event) {
        // $log.info('quickTask');
      $timeout(function(){
        var wrapper = document.createElement('div');
        var taskFormHTML = '<div class="quick-task-container board-item" data-id="new-task">' +
          '<form onsubmit="saveQuickTask()" class="quick-task-form">' +
            '<textarea class="quick-task-description" name="quicktaskdescription"></textarea>'+
            '<div class="quick-task-controls">'+
              '<p class="right"><a class="quick-task-save-button">Add</a></p>' +
              // '<p class="right hotkey-label" style="padding-right: 1em;">ctrl + enter</p>'+
            '</div>' +
          '</form>'+
        '</div>';
        wrapper.innerHTML = taskFormHTML;

        // Add the column to the DOM
        vm.taskFormElement = wrapper.children[0];
        // get the parentID
        var parentID = parentElement.getAttribute('data-id');

          // find the parentGrid
          _.each(columnGrids, function(grid) {
            if (grid.getElement().getAttribute('data-id') == parentID) {
              vm.taskFormParentGrid = grid;
            }
          });

            vm.taskFormParentGrid.add([vm.taskFormElement], { index: 0 });
            vm.taskFormVisible = true;

            // auto-focus on the textarea
          $( ".quick-task-form .quick-task-description" ).focus();


      });
    }//quickTask

    function saveQuickTask(){
      return new Promise(function(resolve, reject){
        //Get quicktaskdescription so we can save it
        var taskDescription = $( ".quick-task-form .quick-task-description" ).val(),
          listID = vm.taskFormParentGrid.getElement().getAttribute('data-id');

        // only continue if we have description and list
        if(taskDescription.length > 0 && listID){
          // determine if we will need to scroll to position after saving
          var scrollAfter = false,
              boardWidth = $('.board').outerWidth(true), // widest
              contentWidth = $('.adminja-board-container').outerWidth(true),
              scrollPosition = $('.adminja-board-container').scrollLeft() + event.screenX; // where clicked
              // if new task triggered near end of board, we will need to scroll to it after this update due to muuri jumping
              if (scrollPosition >= (boardWidth - 50)) {
                scrollAfter = true;
              }
              closeQuickTaskForm();

              // Update the sort on existing items (starting at 2)
              var parentItems = vm.taskFormParentGrid.getItems(),
                updates = {},
                order = 1;

              _.each(parentItems, function(item) {
                var itemElement = item.getElement(),
                  itemID = itemElement.getAttribute('data-id')
                updates['/detailBoards/' + vm.boardID + '/lists/' + listID + '/items/' + itemID + '/order'] = order;
                order++
              });
              return firebase.database().ref().update(updates)
                .then(function() {
                  // now add our task with order of 1
                  var newTask = taskDataService.newTask(vm.thisClient.uid, listID);
                  newTask.info.description = taskDescription;
                  newTask.info.order = 0;
                  return resolve(taskDataService.saveNew(newTask))
                })
                .catch(function(error) {
                  throwError(error);
                })
        }// if valid quickTask
        else {
          closeQuickTaskForm();
        }

      });
    }//saveQuickTask

    function deleteList(listID) {
      var updates = {};
      updates['/detailBoards/' + vm.boardID + '/lists/' + listID] = null;
      return firebase.database().ref().update(updates)
        .then(function() {
          // // $log.info('deleted list: ' + listID);
          // _.each(vm.boardData.lists, function(list, index){
          //   if(list.uid == listID){
          //     delete vm.boardData.lists[index]
          //   }
          // })
          updateColumnSort();
          vm.toggleSidePanel();
        })
    } //deleteLIst

    function newList(boardID) {
      $timeout(function() {
        vm.selectedList = {
          label: undefined,
          color: '#aba9a9',
          type: 'custom'
        }
      }).then(function() {
        vm.toggleSidePanel('list');
      })
    } //newList

    function saveList(list) {
      // $log.info('saveList');
      var newKey = firebase.database().ref().child('detailBoards/' + vm.boardID + '/lists').push().key,
        newOrder = _.size(boardGrid.getItems()) + 1;
      list.order = newOrder;
      list.uid = newKey;
      // $log.info(_.size(boardGrid.getItems()) + ' lists. This list will take position ' + newOrder);
      // make suer our current sort is stored
          var updates = {};
          updates['/detailBoards/' + vm.boardID + '/lists/' + newKey] = list;
          updates['/clients/' + vm.boardData.workspace + '/detailBoards/' + vm.boardID + '/lists/' + newKey] = list;

          // $log.info(updates);
          return firebase.database().ref().update(updates)
            .then(function() {
              boardGrid.sort('order', {layout: 'instant'});
              updateColumnSort();
              vm.toggleSidePanel();
              $timeout(function() {
                vm.scrollEnd();
              }, 0);
            })
            .catch(function(error) {
              throwError(error);
            })

    } //saveList

    function updateList(list) {
      if(list.uid){
        if (!_.has(list, 'color')) {
          list.color = '#bbb';
        }
        var updates = {};
        updates['/detailBoards/' + vm.boardID + '/lists/' + list.uid + '/label'] = list.label;
        updates['/detailBoards/' + vm.boardID + '/lists/' + list.uid + '/color'] = list.color;
        updates['/clients/' + vm.boardData.workspace + '/detailBoards/' + vm.boardData.uid + '/lists/' + list.uid + '/label'] = list.label;
        updates['/clients/' + vm.boardData.workspace + '/detailBoards/' + vm.boardData.uid + '/lists/' + list.uid + '/color'] = list.color;
        return firebase.database().ref().update(updates)
          .then(function() {
            // we aren't watching for list changes, just additions, removals, and task changes
            // Therefore: We should update the DOM to reflect the changes
              var listElement = $('.board-column[data-id=' + list.uid + ']');
              $(listElement).attr('data-order', list.order);
              $(listElement).find('.board-column-header').css('background-color', list.color);
              $(listElement).find('.board-column-title').text(list.label);
              boardGrid.refreshSortData();
              vm.toggleSidePanel();
          })
          .catch(function(error) {
            throwError(error);
          })
      } else {
        throwError('Oops! There was a problem. Please refresh your browser.')
      }
    } //updateList

    function toggleElementVisibility(){
      return updateBoard()
      .then(function(){
          cleanupMuuri();
         init();
        // re-init Grid
      })
    }//toggleElementVisibility

    function updateBoard(){
      return new Promise(function(resolve, reject){
        $timeout(function(){
          vm.boardUpdating = true;
        })
        .then(function(){
          var updates = {};
          updates['/detailBoards/' + vm.boardID + '/settings'] = vm.boardData.settings;
          return firebase.database().ref().update(updates)
            .then(function() {
              // $log.info('board settings updated');
              return resolve(true);
              // location.reload()
            })
            .catch(function(error) {
              reject(throwError(error));
            })
        })
      })

    }//updateBoard

    function fastInitColumn(columnElem, listData) {
      var contentElem = columnElem.querySelector('.board-column-content');
      boardGrid.add([columnElem], { index: listData.order });
      instantiateColumn(contentElem, listData);
      $timeout(function(){
        vm.listCount = _.size(boardGrid.getItems());
        // $log.info('Lists: ' + vm.listCount);
      },0)
    } //fastInitColumn

    function initColumn(columnElem, listData) {
      var contentElem = columnElem.querySelector('.board-column-content');

      boardGrid.show(
        boardGrid.add([columnElem], {
          active: false,
          index: listData.order
        }), {
          onFinish: function(){
            // Instantiate grid
            instantiateColumn(contentElem, listData)
            $timeout(function(){
              vm.listCount = _.size(boardGrid.getItems());
              // $log.info('Lists: ' + vm.listCount);
            },0)
          }
        }
      )
    } // initColumn

    function instantiateColumn(contentElem, listData) {
      // $log.info('instantiate column grid!');
      var grid = new Muuri(contentElem, {
          items: '.board-item',
          layout: boardLayout,
         layoutOnInit: false,
         layoutOnResize: 200,
         layoutDuration: 300,
         layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          dragEnabled: true,
          dragSort: function() {
            return columnGrids;
          },
          dragSortPredicate: function(item) {
            var thisGrid = item.getGrid(),
              gridElem = thisGrid.getElement(),
              itemID = item.getElement().getAttribute('data-id'),
              defaultPredicate = Muuri.ItemDrag.defaultSortPredicate(item, {
                action: 'move',
                threshold: 50
              });

            if ($(gridElem).closest('.board-column').hasClass('drag-disabled') || itemID == 'new-note') {
              return false
            } else {
              return defaultPredicate
            }

          },
          dragSortInterval: 200,
          dragContainer: dragContainer,
          dragReleaseDuration: 1000,
          dragReleaseEasing: 'ease',
          dragSortHeuristics: {
            sortInterval: 0,
            minDragDistance: 10,
            minBounceBackAngle: 1
          },
          dragPlaceholder: {
            enabled: true,
            createElement: null,
            onCreate: null,
            onRemove: null
          },
          dragStartPredicate: {
            distance: 20,
            delay: 150
          },
          dragAutoScroll: {
            targets: function(item){
              return [
                window,
                {
                  element: boardContainer,
                  priority: 1,
                  axis: Muuri.AutoScroller.AXIS_X,
                },
                {
                  element: item.getGrid().getElement().parentNode,
                  priority: 1,
                  axis: Muuri.AutoScroller.AXIS_Y,
                },
              ];
            }
          },
          hideDuration: 0,
          showDuration: 0,
          sortData: {
            order: function(item, element) {
              return Number(element.getAttribute('data-order')) || '';
            },
            title: function(item, element) {
              return element.getAttribute('data-title') || '';
            }
          }

        })
        .on('dragStart', function(item, event) {
          // disable text selection on drag (safari bug)
          if (window.getSelection) {window.getSelection().removeAllRanges();}
          else if (document.selection) {document.selection.empty();}

          // Let's set fixed widht/height to the dragged item
          // so that it does not stretch unwillingly when
          // it's appended to the document body for the
          // duration of the drag.
          item.getElement().style.width = item.getWidth() + 'px';
          item.getElement().style.height = item.getHeight() + 'px';

          // define some of our itemDrag properties
          itemDrag.itemID = item.getElement().getAttribute('data-id');
          // we don't want to do anything if new task form dragged
          if(itemDrag.itemID != 'new-note'){
            itemDrag.item = item;
            itemDrag.sourceGrid = item.getGrid();
            itemDrag.sourceGridID = itemDrag.sourceGrid.getElement().getAttribute('data-id');
            itemDrag.sourceIndex = itemDrag.sourceGrid.getItems().indexOf(item);
            itemDrag.sourceScroll = $(itemDrag.sourceGrid.getElement()).closest('.board-column-content-wrapper').scrollTop();
            // Get the item's data
              _.each(vm.boardData.lists, function(list) {
                if(list.uid == itemDrag.sourceGridID){
                  _.each(list.items, function(detail){
                    if (detail.uid == itemDrag.itemID) {
                      itemDrag.itemData = detail;
                    }
                  })
                }
              })
          }
        })
        // .on('layoutStart', function () {
        //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
        // })
        .on('receive', function(data) {
          // add targetGrid information to itemDrag
          itemDrag.targetGrid = data.toGrid;
          itemDrag.targetGridID = data.toGrid._element.getAttribute('data-id');
          itemDrag.targetScroll = $(itemDrag.targetGrid.getElement()).closest('.board-column-content-wrapper').scrollTop();
          itemDrag.sourceGrid.refreshItems().layout();
          itemDrag.targetGrid.refreshItems().layout();
          boardGrid.refreshItems().layout();
        })
        .on('dragReleaseEnd', function(item) {
          if(itemDrag.itemID != 'new-task'){
            // If item has been moved, add targetIndex to itemDrag object
            if (itemDrag.targetGrid) {
              itemDrag.targetIndex = itemDrag.targetGrid.getItems().indexOf(item);
              if (itemDrag.targetGridID == 'excluded') {
                itemDrag.targetGrid.send(itemDrag.targetIndex, itemDrag.sourceGrid, itemDrag.sourceIndex);
                return resetDragData()
              }
            }
            // Process the new task position
            return updateDetailDrop(itemDrag)
              .then(function() {
                // restore the scroll position of source and target
                  $('.board-column-content[data-id='+itemDrag.sourceGridID+']').closest('.board-column-content-wrapper').scrollTop(itemDrag.sourceScroll);
                  if(itemDrag.targetGrid){
                    $('.board-column-content[data-id=' + itemDrag.targetGridID + ']').closest('.board-column-content-wrapper').scrollTop(itemDrag.targetScroll);
                  }

                  resetDragData();
              })
          }
        });


      columnGrids.push(grid);


      // setup change listeners for this board
      var listRef = firebase.database().ref('detailBoards/' + vm.boardID + '/lists/' + listData.uid + '/items');
      changedWatchers[listData.uid] = listRef.on('child_changed', function(snapshot){
        // $log.info('detailWatch: detail changed. ListID: ' + listData.uid);
        var newDetail = snapshot.val();
        updateDetail(newDetail, grid);
      })

      addedWatchers[listData.uid] = listRef.on('child_added', function(snapshot){
        // $log.info('detailWatch: detail added. ListID: ' + listData.uid);
        var newDetail = snapshot.val();
        // we want to add all new tasks EXCEPT tasks that were dragged into closed (they have open status and need toggled)
        if(!itemDrag.item) {
          addNewDetail(grid, newDetail, newDetail.order, vm.boardData.settings);
          // update boardData
        }

        // add/update data in boardData;
        _.each(vm.boardData.lists, function(list){
          if(list.uid == listData.uid){
            var found = false;
            // we don't want to add it if it's already there (just a double-check)
            _.each(list.items, function(item){
              if(item.uid == newDetail.uid){
                found = true;
              }
            });
            if(!found){
              if(!_.has(list, 'items')){
                list.items = [];
              }

              list.items.push(newDetail);
            }
          }
        });

      })
      removedWatchers[listData.uid] = listRef.on('child_removed', function(snapshot){
        // $log.info('detailWatch: detail removed. ListID: ' + listData.uid);
        var removedDetail = snapshot.val();
        _.each(columnGrids, function(grid){
          if(grid.getElement().getAttribute('data-id') == removedDetail.list){
            _.each(grid.getItems(), function(item){
              if(item.getElement().getAttribute('data-id') == removedDetail.uid){
                grid.remove([item], {removeElements: true});
                boardGrid.refreshItems().layout();
              }
            })

          }
        })

        // remove task from boardData
        _.each(vm.boardData.lists, function(list){
          if(list.uid == listData.uid){
            // filter removedDetail from array
            list.items = list.items.filter(function( obj ) {
                return obj.uid !== removedDetail.uid;
            });
          }
        });
      })
      resizeBoard();
    } //instantiateColumn

    function updateDetail(detailData, grid){
      // $log.info('updateDetail');

      // Update the model (regardless if we need to refresh the task)
      _.each(vm.boardData.lists, function(list){
        if(list.uid == detailData.list){
          if(!_.has(list, 'items')){
            list.items = {};
          }
          _.each(list.items, function(item){
            if(item.uid == detailData.uid){
              item = detailData;
            }
          })
          }
      });

      var listID = grid.getElement().getAttribute('data-id');

      if(vm.setupComplete){
        var shouldUpdate = true;
        // was this the result of a drag operation?
        if(itemDrag.item){
          // if it wasn't dragged out of sourceGrid, we shouldn't update
          if(!itemDrag.targetGridID){
              shouldUpdate = false;
            }
          // if it was dragged out of sourceGrid BUT ended up back in sourceGrid, we shouldn't update
          if(itemDrag.targetGridID){
            if(itemDrag.targetGridID == itemDrag.sourceGridID){
              shouldUpdate = false;
            }
          }
        }


        if(shouldUpdate){
          // utility to monitor ordering before refreshing
          // _.each(grid.getItems(), function(item){
          //   if(item.getElement().getAttribute('data-id') == detailData.uid){
          //     return getDetailData(item.getElement().getAttribute('data-id'))
          //     .then(function(detailData){
          //       var itemIndex = grid.getItems().indexOf(item);
          //       $log.info(detailData.description + ': stored: ' + detailData.order + ' index: ' + itemIndex);
          //     });
          //   }
          // });

          _.each(grid.getItems(), function(item){
              var itemIndex = grid.getItems().indexOf(item);
              if(item.getElement().getAttribute('data-id') == detailData.uid){
                  var index = grid.getItems().indexOf(item);
                  grid.remove([item], { removeElements: true });
                  addDetail(grid, detailData, itemIndex, vm.boardData.settings, vm.userRole)


              }
          })
        }
      }// if setupComplete

    }//updateDetail

    function addNewDetail(grid, detailData,index, settings){
      // $log.info('addNewDetail');
      // Update the model
      if(vm.setupComplete && !itemDrag.item){
          // update model
          _.each(vm.boardData.lists, function(list){
            if(list.uid == detailData.list){
                if(!_.has(list, 'items')){
                  list.items = {};
                }
                list.items[detailData.uid] = detailData;
              }
          });
          // if refreshing while browser is not focused setupComplete can be false when child_added kicks in, duplicating our cards.
          // here we are going to make sure we aren't adding a duplicate card
          var found = false;
          _.each(grid.getItems(), function(item){
              if(item.getElement().getAttribute('data-id') == detailData.uid){
                found = true;
              }
          });
          if(!found){
            addDetail(grid, detailData, index, settings);
            // refresh task's grid
            _.each(columnGrids, function(grid){
              if(grid.getElement().getAttribute('data-id') == detailData.list){
                grid.refreshItems();
                grid.refreshSortData();
                grid.layout();
              }
            })
          }

        }
    }//addNewDetail

    function addDetail(grid, detailData, index, settings, userRole){
      // $log.info('addDetail');
      var wrapper = document.createElement('div');
      var taskHTML = kanbanService.newDetailElement(detailData, settings, userRole);
      wrapper.innerHTML = taskHTML;
      var taskElement = wrapper.firstChild
      var newItem = grid.add([taskElement], { active: true, index: index, layout: true});
      grid.refreshItems().refreshSortData().layout();
      vm.detailListMenuOpen = false;
      $timeout(function(){
        boardGrid.refreshItems().layout();
        resizeBoard();
      }, 500)

    }// addDetail

    function updateDetailDrop(itemDrag) {

      return new Promise(function(resolve, reject) {
        var updates = {};
        // $log.info('Dropped from ' + itemDrag.sourceGridID + ' to ' + itemDrag.targetGridID);

        // if there's no target grid, we just need to update the order
        if (!itemDrag.targetGrid) {
          // $log.info('just reordered');
          // We only re-ordered the item in it's sourceGrid
          // prepare the order-change updates for all items in sourceGrid
          // First, check to make sure itemDrag contains sourceGrid. If not, catch and handle:
          if(itemDrag.sourceGrid){
            var sourceItems = itemDrag.sourceGrid.getItems();
            _.each(sourceItems, function(item) {
              var itemID = item.getElement().getAttribute('data-id'),
                index = sourceItems.indexOf(item);
                updates['/detailBoards/' + vm.boardID + '/lists/' + itemDrag.sourceGridID + '/items/' + itemID + '/order'] = index;
            })
          }  else {
            $log.error('itemDrag SourceGrid missing!');
            $log.info(itemDrag);
          }
        } else {
          //we have a failure in getting itemDrag.itemData on every derag.

          // Item has been moved to a different grid
          // $log.info('moving');
          // remove from sourcelist
          updates['/detailBoards/' + vm.boardID + '/lists/' + itemDrag.sourceGridID + '/items/' + itemDrag.itemID] = null;
          // store it's new list ini the item data
          itemDrag.itemData.list = itemDrag.targetGridID;

          // prepare updates for all items in targetGrid
          var movedItemIndex = itemDrag.targetGrid.getItems().indexOf(itemDrag.item);
          // $log.info('movedItemIndex: ' + movedItemIndex);


          // now update sort on the remaining items
          _.each(itemDrag.targetGrid.getItems(), function(targetItem) {
            var itemID = targetItem.getElement().getAttribute('data-id'), originalItemOrder = targetItem.getElement().getAttribute('data-order'),
                itemIndex = itemDrag.targetGrid.getItems().indexOf(targetItem);
            if (itemID != itemDrag.itemID) {
              // This is a sibling of the item we moved. Just update it's order.
              updates['/detailBoards/' + vm.boardID + '/lists/' + itemDrag.targetGridID + '/items/' + itemID + '/order'] = itemIndex;
            } else {
              // This is the item we moved. It needs added to the target list with the proper index
              itemDrag.itemData.order = itemIndex;
              updates['/detailBoards/' + vm.boardID + '/lists/' + itemDrag.targetGridID + '/items/' + itemDrag.itemID] = itemDrag.itemData;
            }
            // $log.info('position ' + originalItemOrder + ' moved to ' + itemIndex);

          })
        }
        // Update the database
        return firebase.database().ref().update(updates)
          .then(function() {
            // Refresh and synchronize our grids
            boardGrid.refreshItems().layout();
            // boardGrid.synchronize();


            filterItems();
            return resolve(true)
          })
          .catch(function(error) {
            throwError(error);
          })
      })
    } //updateDetailDrop



    function duplicateList(list, tasks){
        // $log.info('duplicateList');
        var targetWorkspaceID = vm.thisClient.uid;

        // throw up dialog
        $mdDialog
            .show({
                templateUrl: "app/app-services/taskPanelDataService/duplicate-list-picker.tmpl.html",
                clickOutsideToClose: true,
                bindToController: true,
                locals: {
                    clients: clientDataService.clients,
                    thisClient: vm.thisClient
                },
                perserveScope: true,
                controllerAs: 'vm',
                controller: 'duplicateListController'
            })
            .then(function(targetWorkspaceID) {
                return profileDataService.cloneDetailList(list,vm.thisClient.uid, targetWorkspaceID)
                .then(function(results){
                    // $log.info(results);
                    $mdToast.showSimple('Detail list duplicated!');
                    $timeout(function() {
                      if(targetWorkspaceID == vm.thisClient.uid){
                        updateColumnSort();
                        vm.scrollEnd();
                      }
                      vm.toggleSidePanel();
                    }, 0);
                })
                .catch(function(error){
                    $log.info('error cloning detail list');
                    $log.info(error);
                })

            });
    }//duplicateList



    function initializeMainBoard(){
      Muuri.defaultPacker.destroy();
      Muuri.defaultPacker = new Muuri.Packer(0);
      boardGrid = new Muuri('.board', {
          layout: {
            horizontal: true,
          },
          layoutOnInit: false,
          layoutOnResize: 200,
          layoutDuration: 300,
          layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          dragEnabled: true,
          dragContainer: dragContainer,
          dragSort: columnGrids,
          dragAxis: 'x',
          dragSortInterval: 0,
          dragHandle: '.board-column-title',
          dragStartPredicate: function(item, event) {
            // Prevent first (new tasks) column from being dragged.
            // if(item.getElement().getAttribute('data-type') != 'custom'){
            //   return false
            // }
            // if (boardGrid.getItems()[0] === item) {
            //   return false;
            // }
            return Muuri.ItemDrag.defaultStartPredicate(item, event);
          },
          dragReleaseDuration: 400,
          dragReleaseEasing: 'ease',
          dragAutoScroll: {
            sortDuringScroll: true,
            targets: function(item){
              return [
                { element: window, priority: 0 },
                { element: item.getGrid().getElement().parentNode, priority: 1 },
              ];
            }
          },
          itemDraggingClass: 'column-dragging',
          sortData: {
            order: function(item, element) {
              return parseFloat(element.getAttribute('data-order'));
            },
          }
        })
        .on('dragStart', function(item, event) {
          // disable text selection on drag (safari bug)
          if (window.getSelection) {window.getSelection().removeAllRanges();}
          else if (document.selection) {document.selection.empty();}

          columnDrag.columnID = item.getElement().getAttribute('data-id');
          columnDrag.startIndex = boardGrid.getItems().indexOf(item);
          // Let's set fixed widht/height to the dragged item so that it does not stretch unwillingly when it's appended to the document body for the duration of the drag.
          item.getElement().style.width = item.getWidth() + 'px';
          item.getElement().style.height = item.getHeight() + 'px';
        })
        .on('dragEnd', function(item, event) {
          columnDrag.targetIndex = boardGrid.getItems().indexOf(item);

          // Let's remove the fixed width/height from the dragged item now that it is back in a grid column and can freely adjust to it's surroundings.
          item.getElement().style.width = '';
          item.getElement().style.height = '';
            // update the sort order in the DB
            return updateColumnSort()
              .then(function() {
                // Just in case, let's refresh the dimensions of all items
                // in case dragging the item caused some other items to
                // be different size.
                // boardGrid.refreshItems();
              })

        })
      // .on('layoutStart', function () {
      //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
      // })
    }//initializeMainBoard

    function filterItems(onFinish) {
        var typeFilter = vm.typeFilter,
              searchFieldValue = vm.searchTerm.toLowerCase();

        _.each(columnGrids, function(grid) {
          grid.filter(function(item){
              var element = item.getElement();
              // we should be checking against content of .firstline and .restlines
              // concatenate contents of both and then search against it
              var textToSearch = $(element).find('.body').text();

              var isSearchMatch = !searchFieldValue || (textToSearch).toLowerCase().indexOf(searchFieldValue) > -1;


              var isTypeMatch = false;
              if(typeFilter == 'none'){
                isTypeMatch = true;
              } else {
                if(typeFilter == element.getAttribute('data-type') ){
                  isTypeMatch = true;
                }
              }


              return isSearchMatch && isTypeMatch;
            }
          );
        });
        boardGrid.refreshItems().layout();
    } //filterItems


    function sortItems(sortBy) {
      // refresh in case itesm have been dragged around recently
      _.each(columnGrids, function(grid) {
        grid.refreshItems();
        grid.refreshSortData();
      })
      _.each(columnGrids, function(grid) {
        if(grid){
          updateDragState(grid, sortBy);
          grid.sort(
            sortBy === 'due' ? 'due order' : sortBy === 'priority' ? 'priority title' : sortBy === 'assignee' ? 'assignee order' : 'order'
          );
        }
      });
    } // sortItems




    ///////////////////////////////////////////
    /// Utility Functions

    function setRole(){
      var teamSize = _.keys(teamDataService.clientTeams[vm.thisClient.uid]).length;
      // if we have a team, check for permissions to edit otherwise, allow it
      if(teamSize > 0 && _.has(teamDataService.clientTeams[vm.thisClient.uid], $rootScope.userID)){
          vm.userRole = teamDataService.clientTeams[vm.thisClient.uid][$rootScope.userID].role;
      }
      // check if clientUser and set userRole if so
      if(_.has($rootScope, 'VAWorkspaces')){
          if(_.has($rootScope.VAWorkspaces, vm.thisClient.uid)){
                  vm.userRole = 'client';
          }
      }
    }

    function listMenuNewTask(clientID, listID) {
                // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
                var newTask = taskDataService.newTask(clientID, listID);
                newTask.info.order = -1;
                taskDataService.taskDialog(newTask);
    }





    function updateDragState(grid, sortBy) {
      var gridElem = grid.getElement();
      if (sortBy === 'order') {
        gridElem.classList.remove('drag-disabled');
      } else {
        gridElem.classList.add('drag-disabled');
      }
    } //updateDragState

    function resizeBoard() {
      // $log.info('resizeBoard');
      var contentHeight = $('.detail-board-wrapper').height() - 10,
        boardHeight = contentHeight - 10; // for padding above and below
      $('.adminja-board-container').height(contentHeight);
      $('.board').height(boardHeight)
      $('.board-column').css('height', 'auto');// this might need to be 'auto'
      if(!vm.settings.verticalProfilePanels){
        $('.board-column-content').height(boardHeight - 60);
      }
      $('.board-column-content-wrapper').height(boardHeight -50);
      // make sure our main md-content doesn't scroll vertically
      $('md-content.triangular-content').css('overflow-y', 'hidden');
      if(vm.setupComplete){
        // $log.info('layoutGrid');
        _.each(columnGrids, function(grid){
          grid.refreshItems().layout()
        });
        boardGrid.refreshItems().layout();
      }
    } // resizeBoard

    function throwError(error) {
      $log.error(error);
      alert('There was a problem. Please refresh. /n' + error);
    } //throwError

    function closeListMenu() {
      $('#list-menu').css('display', 'none');
      $timeout(function() {
        vm.listMenuOpen = false;
      })
    } //closeListMenu

    function closeDetailMenu() {
      $('#detail-menu').css('display', 'none')
      $timeout(function() {
        vm.detailMenuOpen = false;
        vm.selectedDetail = null;

      })
    } //closeDetailMenu

    function closeDetailListMenu() {
      $('#detail-list-menu').css('display', 'none')
      $timeout(function() {
        vm.detailListMenuOpen = false;
        vm.activeList = null;

      })
    } //closeDetailListMenu

    function openDetailMenu(item, e){
      // $log.info('request detail menu for: ');
      // $log.info(item);
      var rect = e.target.getBoundingClientRect();
      vm.y = rect.top - 50;
      vm.x = rect.right - 225;
      var boardWidth = $('.triangular-content').outerWidth(true);
      var boardHeight = $('.triangular-content').outerHeight(true);

      // make sure none of the menu is offscreen horizontally
      if (vm.x > (boardWidth - 100)) {
        vm.x = boardWidth - 100;
      }


      // make sure none of the menu is offscreen vertically
        if(vm.y > (boardHeight - 150)){
          vm.y = boardHeight - 150;
        }



      // this triggers the menu directive to activate and position itself
      $timeout(function(){
        vm.selectedDetail = item;
        vm.detailMenuOpen = true;
      },0)
    }//openDetailMenu

    function openDetailListMenu(list, e){
      // $log.info('request detail menu for: ');
      // $log.info(item);
      var rect = e.target.getBoundingClientRect();
      vm.y = rect.top - 50;
      vm.x = rect.right - 225;
      var boardWidth = $('.triangular-content').outerWidth(true);
      var boardHeight = $('.triangular-content').outerHeight(true);

      // make sure none of the menu is offscreen horizontally
      if (vm.x > (boardWidth - 300)) {
        vm.x = boardWidth - 300;
      }


      // make sure none of the menu is offscreen vertically
        if(vm.y > (boardHeight - 400)){
          vm.y = boardHeight - 450;
        }



      // this triggers the menu directive to activate and position itself
      $timeout(function(){
        vm.activeList = list;
        vm.detailListMenuOpen = true;
      },0)
    }//openDetailListMenu


    function downloadDetail(detail){
      return new Promise(function(resolve, reject){
        firebase.database().ref('/detailBoards/' + detail.board + '/lists/' + detail.list + '/items/' + detail.uid).once('value', function(snapshot){
          var detailData = snapshot.val();
          return resolve(detailData);
        })
        .catch(function(error){
          $log.error(error);
          return reject(error)
        })
      })

    }//downloadDetail

    function getDetailData(detailID){
      // $log.info('getDetailData');
      // for simplicity's sake, we search through client/{clientID}/tasks to find the task data.
      // this saves us from first finding the proper list AND THEN task in boardData;
      return new Promise(function(resolve, reject){
        // relying on "found" to ensure we only trigger responce ONCE
        var found = false;
        _.each(vm.boardData.lists, function(list){
          _.each(list.items, function(detail){
              if(detail.uid == detailID & !found){
                // $log.info('found');
                found = true;
                return resolve(detail)
              }
          })

        });

        return reject('detail-not-found')
      })
    }//getDetailData

    function scrollEnd(fast) {
      // in a timeout so it fires after existing animations/calculations finished
      $timeout(function() {
        var boardWidth = $('.board').outerWidth(true);
        if (!fast) {
          $('.adminja-board-container').animate({ scrollLeft: boardWidth }, 400);
        } else {
          $('.adminja-board-container').animate({ scrollLeft: boardWidth }, 200);
        }

      })
    }

    function editDetail(detailID, targetTab){
      return getDetailData(detailID)
          .then(function(detail){
            return downloadDetail(detail)
            .then(function(detailData){
                profileDataService.editProfileDetail(detailData, 'Update');
            })
          })
    }// editDetail

    function resetDragData() {
      itemDrag = {};
      columnDrag = {};
    } //resetDragData

    function toggleSidePanel(mode) {
      if(vm.detailMenuOpen){
        vm.closeDetailMenu();
      }
      if(vm.detailListMenuOpen){
        vm.closeDetailListMenu();
      }
      $timeout(function() {
        vm.sidePanelMode = mode;

        $mdSidenav('board-panel')
          .toggle()
          .then(function() {
            // put focus on search
            $( "#searchQuery" ).focus();
            // if we are opening board settings, remove the backdrop
            if(vm.sidePanelMode == 'board'){
              $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:none;');
            } else {
              $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:block;');
            }
          });
      })
    } //toggleSidePanel

    function selectListColor() {
      if(vm.sidePanelMode == 'list'){
        vm.forms.listForm.$setDirty();
      }
    } //selectListColor

    function selectBoardColor(){
      $log.info('selectBoardColor');
      if(vm.sidePanelMode == 'board'){
        vm.forms.boardForm.$setDirty();
        updateBoard();
      }
    }// selectBoardColor

    function undoUpgrade(){
      var updates = {};
      updates['/clients/' + vm.boardID + '/defaultDetailBoard'] = null;
      updates['/detailBoards/' + vm.boardID] = null;
      return firebase.database().ref().update(updates)
      .then(function(){
        $timeout(function(){
          vm.boardID = null;
        })
      })
    }//undoUpgrade

    function closeQuickTaskForm(){
      if(vm.taskFormParentGrid && vm.taskFormVisible){
        vm.taskFormParentGrid.remove(vm.taskFormParentGrid.getItems(0), { removeElements: true });
        $timeout(function(){
          vm.taskFormVisible = false;
          vm.taskFormParentGrid = null;
        })
      }
    }//closeQuickTaskForm

    function resetTaskSearch(){
      $timeout(function(){
        vm.searchTerm = '';
      })
      .then(function(){
        vm.filterItems();
      })
    }//resetTaskSearch

    function setupWatchers(){
      boardRef.child('lists').on('child_changed', function(snapshot) {
        // $log.info('list changed');
        // var updatedList = snapshot.val();
        // $log.info(updatedList);
        // boardGrid.sort('order', {layout: 'instant'})

      });

      boardRef.child('lists').on('child_removed', function(snapshot) {
        // $log.info('list removed');
        var removedList = snapshot.val();
        if(removedList.uid){
          // update the grid
          removeList(removedList);
          // update the data

          _.each(vm.boardData.lists, function(list) {
            if (list.uid == removedList.uid) {
              list = null
            }
          })
          // return updateColumnSort()
          //   .then(function() {})
        }// if removedList.uid

      });

      boardRef.child('lists').on('child_added', function(snapshot) {
        // $log.info('child added!');
        // we only want this to fire AFTER our initial setup
        if (vm.boardData && vm.setupComplete) {
          // add to boardData
          vm.boardData.lists.push(snapshot.val());

          // add to grid
          addList(snapshot.val());
          boardGrid.refreshItems();
          boardGrid.sort('order', {layout: 'instant'});
          // Make sure it's put in it's proper position
          // boardGrid.sort('order', { layout: 'instant' });
        }
      });
    }//setupWatchers

    function setupListeners() {

      // Add column item.
      boardContainer.addEventListener('click', listeners, false)
      // clicks

      $scope.$on("$destroy", function() {
        cleanupMuuri();
      });

      hotkeys.add({
        combo: 'esc',
        description: 'Escape',
        allowIn: ['TEXTAREA'],
        callback: function(event, hotkey) {
          event.preventDefault();
          // $log.info('escape');
          if(vm.detailMenuOpen){
            closeDetailMenu();
          }
          if(vm.detailListMenuOpen){
            closeDetailListMenu();
          }
          if(vm.detailFormVisible && vm.detailFormParentGrid){
            closeQuickDetailForm();
          }
        }
      });
      hotkeys.add({
          combo: 'ctrl+enter',
          allowIn: ['TEXTAREA'],
          description: 'Save Task',
          callback: function (event) {
              $log.info('ctrl+enter');
              event.preventDefault();
              if(vm.taskFormVisible){
                saveQuickTask();
              }
          }
      });
      hotkeys.add({
          combo: 'ctrl+alt+f',
          description: 'Find and Filter',
          callback: function (event) {
              // $log.info('Find & Filter');
              vm.toggleSidePanel('board');
          }
      });

    } //setupListeners

    function listeners(e){

            // while task form is visible, nothing else can be done
              var clickHandled = false;
              // quickTask
              if (e.target.matches('.board-column-quick-task')) {
                clickHandled = true;
                closeQuickTaskForm()
                if (!vm.listMenuOpen) {
                  var gridElem = e.target.closest('.board-column').querySelector('.board-column-content');
                  quickTask(gridElem, e);
                }
              } // if listMenu Not Open



              if (e.target.matches('.view-attachment')) {
                $log.info('view-attachment');
                clickHandled = true;
                }

              if (e.target.matches('.detail-menu-button')) {
                clickHandled = true;
                  closeDetailMenu();
                  closeDetailListMenu();
                  closeQuickTaskForm()
                  var detailElem = e.target.closest('.board-item');
                  vm.selectedDetailID = detailElem.getAttribute('data-id');
                  vm.detailListID = detailElem.getAttribute('data-list');

                  // get our taskData and x/y position and open task menu
                  // in a timeout so it properly triggers our menu directive
                    return getDetailData(detailElem.getAttribute('data-id'))
                    .then(function(data){
                      openDetailMenu(data, e)
                    })
                    .catch(function(error){
                      throwError('Oops! Something went wrong. Please Refresh your browser.')
                      $log.error(error);
                    });
              } // taskMenuButton Clicked

              if (e.target.matches('.detail-list-menu-button')) {
                clickHandled = true;
                  closeDetailMenu();
                  closeDetailListMenu();
                  closeQuickTaskForm()

                  var thisList = e.target.closest('.board-column');

                  // sandbox - playing around with collapsing columns
                  // $(thisList).addClass('collapsed-list');
                  // $log.info($(thisList).style);
                  // thisList.style.webkitTransform += "rotate(90deg)";

                  vm.listMenuID = thisList.getAttribute('data-id');
                  _.each(vm.boardData.lists, function(list){
                    if(list.uid == vm.listMenuID){
                      openDetailListMenu(list, e);
                    }
                  });
              } // taskMenuButton Clicked


              // listMenu
              if (e.target.matches('.board-column-menu')) {
                clickHandled = true;
                // close any other menus open
                vm.closeListMenu();
                closeDetailListMenu();
                closeQuickTaskForm()
                // Open menu on new target list
                $timeout(function() {
                    vm.targetListID = e.target.closest('.board-column').getAttribute('data-id');
                    _.each(vm.boardData.lists, function(list) {
                      if (list.uid == vm.targetListID) {
                        vm.selectedList = list;
                      }
                    })
                  })
                  .then(function() {
                    vm.sidePanelMode = 'list';
                    vm.toggleSidePanel(vm.sidePanelMode);
                  })
              }



              // clicked on existing quickTaskForm
              if(e.target.matches('.quick-task-container') || e.target.matches('.quick-task-form') || e.target.matches('.quick-task-description')){
                clickHandled = true;
                $log.info('selected quick task');
              }

              // save quickTask form
              if(e.target.matches('.quick-task-save-button')){
                $log.info('save quick task');
                clickHandled = true;
                saveQuickTask();
              }//saveQuickTask form

              if(e.target.matches('a')){
                $log.info('link clicked');
                clickHandled = true;
              }


              // EDIT DETAIL
              if(!clickHandled && !vm.detailMenuOpen && !vm.detailListMenuOpen){
                closeQuickTaskForm()
                closeDetailListMenu();
                var detailID = $(e.target).closest('.board-item').attr('data-id'),
                    detailType = $(e.target).closest('.board-item').attr('data-type');
                // only edit if we isolated the id
                if(detailID && detailType != 'client-card'){
                  editDetail(detailID);
                } else if (detailID && detailType == 'client-card'){
                  // edit client
                  clientDataService.editClient(vm.thisClient.uid);
                }
              }

              // if no click handled AdetailID a task menu is displayed, close the task menu
              if(!clickHandled){
                closeDetailMenu();
                closeDetailListMenu();
              }// if click wasn't handled
}//listeners

    function cleanupMuuri(){
      $log.info('clean up muuri');
      window.removeEventListener('resize', windowResize, false);      delete vm.selectedTask
      delete vm.selectedList
      delete vm.selectedClient
      vm.sidePanelMode = 'board'
      delete vm.boardData
      vm.setupComplete = false;
      boardContainer.removeEventListener('click', listeners, false);

      // clean up here
      _.each(columnGrids, function(grid) {
        var listID = grid.getElement().getAttribute('data-id');
        var listRef = firebase.database().ref('detailBoards/' + vm.boardID + '/lists/' + listID + '/items');
        listRef.off('child_changed', changedWatchers[listID]);
        listRef.off('child_added', addedWatchers[listID]);
        listRef.off('child_removed', removedWatchers[listID]);
        _.each(grid.getItems(), function(item){
          grid.remove([item], {removeElements: true});
        })
        grid.destroy(true);
      });

      if(boardGrid){
        _.each(boardGrid.getItems(), function(list){
          boardGrid.remove([list], {removeElements: true});
        })
        boardGrid.destroy(true);
        // cleanup watchers here?
      }

    }//cleanupMuuri


  } // detailBoardController



})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('fabButton', fabButton);


  function fabButton() {
    var directive = {
      restrict: 'E',
      replace: false,
      controller: fabButtonController,
      controllerAs: 'vm',
      bindToController: true,
      // We need to prepare the proper template url in a link function
      link: linkFunc,
      // Populate the template via ng-include
      template: '<div ng-include="getTemplateUrl()"></div>'
    };
    return directive;
  };

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
function linkFunc(scope, element, attr) {

    scope.getTemplateUrl = function() {
        return 'app/app-directives/fab-button/fab-button.tmpl.html';
    };

  }// linkFunc


  /* @ngInject */
  function fabButtonController(hotkeys, $timeout, $mdDialog, $state, $mdSidenav, localStorageService, $log, $rootScope, $scope, taskDataService, clientDataService, userDataService, profileDataService, timeDataService, leadDataService, authFactory, $stateParams) {
    var vm = this;
            vm.fabDirection = "left";
            vm.fabAnimation = "md-scale";
            vm.fabStatus = false;
            vm.newTask = newTask;
            vm.newTime = newTime;
            vm.newReminder = newReminder;
            vm.newFabDetail = newFabDetail;
            vm.newFabSpace = newFabSpace;
            vm.launchDiagnostics = launchDiagnostics;
            vm.newLead = newLead;
            vm.newTouchpoint = newTouchpoint;
            vm.userType = $rootScope.admin;



            vm.hasSpaces = function(){
              if(_.find(clientDataService.clients, function(o) { return o.status == 'active' || o.status == 'personal';})){
                return true
              } else{
                return false
              };
            };
            // only show some buttons if we have active workspaces

            // Setup Hotkeys for functions below
            // Define our hotkeys
            hotkeys.add({
              combo: 'alt+ctrl+n',
              description: 'New Task',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newTask();
              }
            });

            hotkeys.add({
              combo: 'alt+ctrl+r',
              description: 'New Reminder',
              callback: function(event, hotkey) {
                event.preventDefault();
                newReminder()
              }
            });
            hotkeys.add({
              combo: 'alt+ctrl+b',
              description: 'Batch Enter Tasks',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                vm.batchTasks();
              }
            });

            hotkeys.add({
              combo: 'alt+ctrl+u',
              description: 'New URL Card',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabDetail('url');
              }
            });

            hotkeys.add({
              combo: 'alt+ctrl+o',
              description: 'New Note Card',
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                newFabDetail('note');
              }
            });


            // Hotkeys not available to clients
            if(vm.userType != 'client'){
              hotkeys.add({
                combo: 'alt+ctrl+t',
                description: 'New Time Log',
                callback: function(event, hotkey) {
                  event.preventDefault();
                  // $log.info(event);
                  newTime();
                }
              });

              hotkeys.add({
                combo: 'alt+ctrl+w',
                description: 'New Workspace',
                callback: function(event, hotkey) {
                  event.preventDefault();
                  // $log.info(event);
                  newFabSpace();
                }
              });

              hotkeys.add({
                combo: 'alt+ctrl+l',
                description: 'New Lead',
                callback: function(event, hotkey) {
                  event.preventDefault();
                  // $log.info(event);
                  newLead();
                }
              });

              hotkeys.add({
                combo: 'alt+ctrl+p',
                description: 'New Lead Activity',
                callback: function(event, hotkey) {
                  event.preventDefault();
                  // $log.info(event);
                  newTouchpoint();
                }
              });
            }// if not client user



            // hotkeys.add({
            //   combo: 'alt+ctrl+p',
            //   description: 'New Person Card',
            //   callback: function(event, hotkey) {
            //     event.preventDefault();
            //     // $log.info(event);
            //     newFabDetail('person');
            //   }
            // });


           function newFabSpace(){
                // trigger newClient dialog
                // $log.info('newClient got clicked!')
                var newClient = clientDataService.newClient();

                clientDataService.clientDialog(newClient, 'New Client Workspace');
                //heap.track('Shortcut - New Workspace');

                userDataService.trackEvent('shortcut-new-workspace');

            }





            function newFabDetail(type){
              var clientID = null;

               var newDetail = profileDataService.newProfileDetail(type, undefined, "New " + type);

               //heap.track('Shortcut - New Detail Card');
               userDataService.trackEvent('shortcut-new-detail');
               return profileDataService.profileDetailDialog(newDetail, "New " + type)

            }

          function launchDiagnostics(ev){
            // $log.info('launchDiagnostics');
            $state.go('triangular.diagnostics')
          }

          function newTouchpoint(){
            //heap.track('Shortcut - New Lead Contact');
            userDataService.trackEvent('shortcut-new-lead-contact');
            return leadDataService.newContact()
          }

          function newReminder(){
            $rootScope.$broadcast('triSwitchNotificationTab', 2);
            $mdSidenav('right').toggle(2);
          }// new Reminder

          function newTime(){
            // $log.info('newTime');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID){
             // $log.info('new time for client' + $stateParams.clientID);
             clientID = $stateParams.clientID;
            }

            $scope.timeEntry = timeDataService.newLogEntry(clientID);
            // $log.info($scope.timeEntry);
            timeDataService.timeDialog($scope.timeEntry, "New");
            //heap.track('Shortcut - New Time Entry');
            userDataService.trackEvent('shortcut-new-time-entry');

          }


          vm.getHelp = function () {
                     // $log.info('Open Groove Widget');
                     groove.widget.open()
                     //heap.track('Shortcut - Get Help');
                     userDataService.trackEvent('shortcut-help');
                 }

          vm.batchTasks = function(){
            // $log.info('batchTasks');
            var clientID = null;
            // if we are on a client page and passed a Client ID, prepopulate our client info
            if ($stateParams.clientID){
             // $log.info('new time for client' + $stateParams.clientID);
             clientID = $stateParams.clientID;
            }
            //heap.track('Shortcut - Batch Tasks');
            userDataService.trackEvent('shortcut-batch-tasks');
                     return taskDataService.batchDialog(clientID);
           }// batchTasks

          function newTask() {
                // console.log('newTask from Fab');
                var userID = localStorageService.get('userID');
                // $log.info(userID);

                 var clientID = null;

                  // if we are on a client page and passed a Client ID, prepopulate our client info
                  if ($stateParams.clientID){
                   // $log.info('new task for client' + $stateParams.clientID);
                   clientID = $stateParams.clientID;
                  }

                  $scope.editedItem = taskDataService.newTask(clientID, 'Later');
                  // $log.info($scope);
                  // Set our dialogTitle
                  $scope.dialogTitle = "New";
                  // console.log($scope.editedItem);
                  //heap.track('Shortcut - New Task');
                  userDataService.trackEvent('shortcut-new-task');
                  taskDataService.taskDialog($scope.editedItem);
            }// newTask

            function newLead(){
              var newLead = leadDataService.newLead();
              //heap.track('Shortcut - New Lead');
              userDataService.trackEvent('shortcut-new-lead');
              return leadDataService.leadSheet(newLead);
            }
    }


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientTeamMemberAccess', clientTeamMemberAccess);


     function clientTeamMemberAccess() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: clientTeamMemberAccessController,
         scope: {
           member: '=member',
           client: '=client',
           team: '=team'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-team-member-access/client-team-member-access.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientTeamMemberAccessController($rootScope, $timeout, $state, hotkeys, $scope, $log, userDataService, teamDataService, clientDataService) {
        var vm = this;

        vm.userID = $rootScope.userID;
        // vm.member & vm.client are implicit in the directive

        // determine the members access and set vm.access
        if(!_.has(vm.client.access.users, vm.member.uid)){
          vm.clientAccess = 'none'
        } else {
          vm.clientAccess = 'member'
        }
        // and override if we are admin
        if(_.has(vm.client.access.admins, vm.member.uid)){
          vm.clientAccess = 'admin'
        }



        vm.setMemberAccess = function(member, access){
            // $log.info('About to set member access for...');
            // $log.info('member', member);
            // $log.info('client', vm.clientid);
            // $log.info('team', vm.team);
            // $log.info('access', access);
            return teamDataService.setMemberAccess(member, vm.client.uid, vm.client.owner, access)
            .then(function(){
              userDataService.trackEvent('change-member-access');
              $timeout(function(){
                clientDataService.thisUsersWorkspaces(true);
                vm.member.role = access;
                return teamDataService.init();
            },0);
            });
        }


        vm.openClient = function(clientUID){
            // $log.info('vm.openClient: ' + client);
            $state.go("triangular.workspaces.information(clientID: clientUID)")
            // return clientDataService.getClient(clientID)
            // .then(function(thisClient){
            //     // $log.info(thisClient);
            //     return clientDataService.clientDialog(thisClient);
            // })
        }

        vm.isClientOwner = function(owner){
          if($rootScope.userID == owner){
            return true
          } else {
            return false
          }
        }


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientSummaryStrip', clientSummaryStrip);


    function clientSummaryStrip() {
        var directive = {
            restrict: 'E',
            replace: false,
            controller: clientSummaryStripController,
            controllerAs: 'vm',
            bindToController: false,
            scope: {thisClient: '=thisClient',
                    showProgress: '=showProgress',
                    showTaskStatus: '=showTaskStatus'},
            link: linkFunc,
            templateUrl: 'app/app-directives/client-summary-strip/client-summary-strip.tmpl.html'
        };
        return directive;
    }
    ;

// linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
    function linkFunc(scope, element, attr) {
        // $log.info(attr);
        // console.log('linkScope:', scope);

    }


    /* @ngInject */
    function clientSummaryStripController($rootScope, userDataService, teamDataService, $scope, $log, clientDataService) {
        var vm = this;
        vm.currency = "$";
        vm.user = userDataService.user;
        vm.settings = $rootScope.userSettings;

        // set our currency if user has selected one
       if (_.has(vm.settings, 'currency')){
            vm.currency = vm.settings.currency;
        }


        function isNan(value) {
            var n = Number(value);
            return n !== n;
        };

        function init() {
            // $log.info($scope.thisClient);
            var now = moment(),
                    thisMonth = parseInt(now.month() + 1),
                    thisYear = now.year();

            vm.thisClient = $scope.thisClient;
            vm.showProgress = $scope.showProgress;
            vm.showTaskStatus = $scope.showTaskStatus;
            var totalsPath = '';
            var currentRetainerPeriod = undefined;

            // $log.info(vm.type);
            vm.cost = 0;
            vm.plan = 0;
            vm.remain = 0;
            vm.rate = 0;
            vm.used = 0;
            vm.total = 0;


            // set default to avoid exceptions
            vm.type = "hourly";

            // use what's set if we have it
            if(_.has(vm.thisClient, 'profile.plan.type')){
                vm.type = vm.thisClient.profile.plan.type

            }

            if(_.has(vm.thisClient, 'profile.plan.recurrenceType')){
                vm.recurrenceType = vm.thisClient.profile.plan.recurrenceType;
            }

            // Check to see if we should be showing the rate
            // if vm.thisClient ensures we don't try to fire this after logging out resulting in an error
            if(_.has(vm.thisClient, 'access')){
                if(_.has(vm.thisClient.access.admins, $rootScope.userID)){
                    vm.showRate = true;
                } else {
                    vm.showRate = false;
                }
            }

            // if this is a clientUser - then showRate should be true
            // determine if user is clientUser for this workspace
            vm.isClientUser = false;
            if(_.has($rootScope, 'VAWorkspaces')){
                if(_.has($rootScope.VAWorkspaces, vm.thisClient.uid)){
                        vm.isClientUser = true;
                        vm.showRate = true;
                }
            }


            // go through billing periods and find the current one
            if(_.has(vm.thisClient, 'billing')){
                // $log.info('has billing');
                var now = moment().toISOString(),
                    oldNow = moment().format('YYYY-MM-DD');
                    // $log.info(now + ' vs ' + oldNow);
                _.each(vm.thisClient.billing, function(billingPeriod){
                    // We are supporting two versions of billing period dates.
                    // The old version (without timestamp)
                    // and the new version (with recurrenceType and a timestamp)
                    // So for the old version, we need to be comparing dates to moment(now).format('YYYY-MM-DD')
                    // and the new version with recurrenceType and reccurenceRules comparing to moment().toISOString()

                    if(_.has(vm.thisClient, 'profile.plan.recurrenceType')){
                        // New recurrenceRule version of renewals
                        if(billingPeriod.start <= now && billingPeriod.end >= now){
                            selectBillingPeriod(billingPeriod);
                        };
                    } else {
                        // Old YYYY-MM-DD month-based version of renewals
                        // $log.info('Comparing: ' + billingPeriod.start + ' - ' + billingPeriod.end + ' <> ' + oldNow);
                        if(billingPeriod.start <= oldNow && billingPeriod.end >= oldNow){
                            selectBillingPeriod(billingPeriod);
                        }

                    }// if recurrenceType

                });// each billingPeriod
            }// if has billing

            // if directive was tagged to show status as well
            // geet those values
            if(vm.showTaskStatus){
                vm.tasksDue = _.filter(vm.thisClient.tasks, function(o) { if (o.duedate <= moment().toISOString() && (o.status != 'closed')) return o }).length;
                vm.tasksFlagged = _.filter(vm.thisClient.tasks, function(o) { if (o.focus == 'today' && !o.status != 'closed') return o }).length;
                vm.tasksOpen = _.filter(vm.thisClient.tasks, function(o) { if (o.focus != 'today' && o.status != 'closed' && (!o.duedate ||  o.duedate > moment().toISOString())) return o }).length;
                vm.tasksTotal =_.filter(vm.thisClient.tasks, function(o) { if (o.status != 'closed') return o }).length;
            }

    }// init


    vm.setupThisWeeksStatus = function(period){
        var numDaysInPeriod = moment(period.end).diff(moment(period.start), 'days'),
            minutesAllocated = period.allocated * 60,
            expectedMinutesPerDay = minutesAllocated/numDaysInPeriod,
            expectedMinutesPerWeek = expectedMinutesPerDay * 7,
            startWeek = moment().startOf('week'),
            endWeek = moment().endOf('week'),
            clientStart = period.client + '-' + moment(startWeek).toISOString(),
            clientEnd = period.client + '-' + moment(endWeek).toISOString(),
            timeRef = firebase.database().ref('time');

            // Display expected immediately
            vm.expected = expectedMinutesPerWeek;

            // Get time and calculate actuals
            timeRef.orderByChild('clientDate').startAt(clientStart).endAt(clientEnd)
             .once('value', function(snapshot){
                if(snapshot.exists()){
                    var time = snapshot.val(), logged = 0;
                    _.each(time, function(entry){
                        logged = logged + entry.logged;
                    });
                    vm.actual = logged;
                    vm.weeklyStatusReady = true;
                } else {
                    // No time logged for this period
                    vm.actual = 0;
                    vm.weeklyStatusReady = true;
                }
             });


    }// setupThisWeeksStatus

    vm.progress = function (logged, allocated) {
        // Find and round percentage of allocated
        var progress = ((logged / 60) / allocated) * 100;
        progress = Math.round(progress, 2);

        // if we are getting NaN (i.e. rate is zero, return 0 not an error)
        if(isNan(progress)){
            progress = 0;
        }

        return progress

    }

        // Execute our calculations on run
        init();

        function selectBillingPeriod(billingPeriod){
            vm.selectedPeriod = billingPeriod;
            vm.rate = billingPeriod.rate;
            vm.used = billingPeriod.logged;
            vm.type = billingPeriod.type;
            vm.total = (vm.used/60) * vm.rate;

            // Countdown until next renewal
            var a = moment(), b = moment(billingPeriod.end);
            vm.renewsIn = b.diff(a, 'days') + 1;
            vm.remain=0;
            // $log.info('found period');
            // $log.info(billingPeriod.type);
            if(billingPeriod.type == 'retainer'){
                vm.plan = billingPeriod.allocated || 0;
                var allocated = Number(billingPeriod.allocated || 0),
                    logged= Number(billingPeriod.logged || 0);

                vm.remain = (allocated * 60)  - logged;
            }

            // if it's a retainer period, let's get our expected and actual weekly hours
            if(vm.selectedPeriod.type == 'retainer'){
                if(_.has(vm.settings, 'showWeeklyStatus')){
                    if(vm.settings.showWeeklyStatus){
                      vm.setupThisWeeksStatus(vm.selectedPeriod);
                    }
                }

            }

        }// selectBillingPeriod

        $scope.retainerStatus = function(logged, budget){
            var status = 'ok';
            if (budget > 0 && logged / budget > 0.70) {
                status = 'close'
            }
            if (budget > 0 && logged / budget >= 1) {
                status = 'over'
            }
            return status
        }



        // // Watch vm.months and update if changed
        // var unwatch = $scope.$watch('thisClient', function () {
        //     // console.log("logdata changed!");

        //     // re-execute our calculations
        //     init();

        // }, true);

        $scope.isNew = function(client){
            if(_.has(client, 'createdOn')){
                if(moment(client.createdOn).diff(moment()) < 5000){
                    return true
                }
            }
        }

        $scope.isPersonalSpace = function(){
            if(vm.thisClient.status == 'personal'){
                return true
            } else {
                return false
            }
        }

        $scope.showSummary = function(){
            if(_.has(vm.thisClient, 'profile.plan.nextCycle')){
                return true
            } else {
                return false
            }
        }

        $scope.openClient = function(client){
            return clientDataService.clientDialog(client);
        }


    }



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientPackage', clientPackage);


     function clientPackage() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: clientPackageController,
         scope: {
           package: '=package',
           client: '=client'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-package/client-package.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientPackageController($timeout, $rootScope, $scope, $log, $filter, $mdToast, $mdDialog, clientPackageService, clientBillingService, clientDataService, userDataService, timeDataService, $firebaseObject) {
        var vm = this;

         vm.currency = "$";
         vm.fbConfig = fbConfig;
         vm.userType = $rootScope.admin;
         vm.user = userDataService.user;
         vm.settings = $rootScope.userSettings;
         vm.packageService = clientPackageService;
         vm.showDetails = showDetails;
         vm.hideDetails = hideDetails;
         vm.detailsEnabled = false;
         vm.editPackage = editPackage;
         vm.calcProgress = calcProgress;
         vm.editTime = editTime;
         vm.addCharge = addCharge;
         vm.editCharge = editCharge;
         vm.timeEntryTotal = timeEntryTotal;
         vm.deletePackage = deletePackage;
         vm.closePackage = closePackage;
         vm.archivePackage = archivePackage;
         vm.reopenPackage = reopenPackage;
         vm.triggerRenewal = triggerRenewal;
         vm.activatePackage = activatePackage;
         vm.packageType = packageType;
         vm.refillPackage = refillPackage;
         vm.triggerRecalc = triggerRecalc;
         vm.setAsDefault = setAsDefault;

         // get our client
         _.each(clientDataService.clients, function(client){
            if(client.uid == vm.package.workspace){
                vm.client = client;
            }
         });

          // set our currency if user has selected one
         if (_.has(vm.settings, 'currency')){
              vm.currency = vm.settings.currency;
          }

         vm.clientBillingService = clientBillingService;


         init();

        function init(){

            // set the progressbar initial state so it animates when calculated
            $timeout(function(){
                if(vm.package.type == 'hourly'){
                    vm.progressBarPercent = 0;
                    // we set color to match background in our initial state
                    // to avoid seeing a brief flash of directive at 100% when it's instantiating
                    vm.progressBarColor = '#efefef';
                    vm.progressBarBackgroundColor = "#efefef";
                    vm.progressBarPercentLabel = "0%";
                }

                  if(vm.package.type != 'hourly'){
                      vm.progressBarPercent = 1;
                      vm.progressBarColor = 'rgb(76, 175, 80)';
                      vm.progressBarBackgroundColor = "#efefef";
                      vm.progressBarPercentLabel = "100%";

                  }

            },500)



            // if it's a renewable package, let's make sure it's sequence is up to date
            // if(_.has(vm.package,'timeStamp') && vm.package.renewable){
            //     $log.info('checking package');
            //     // Check to make sure package has sequence
            //     return clientPackageService.checkPackageSequence(vm.package)
            //     .then(function(result){
            //         $log.info(result);
            //     });
            // }


        }

        // This runs during setup and again whenever totalMinutes changes
         $scope.$watch('vm.package.totalMinutes', function(newVal, oldVal) {
                vm.detailsEnabled = false;
                calcProgress(vm.package);
        });

          $scope.$watch('vm.package.charges', function(newVal, oldVal) {
                 vm.detailsEnabled = false;
                 calcProgress(vm.package);
         });


          function packageType(type){
            switch(vm.package.type) {
                case 'fixed':
                    return 'Fixed Fee';
                    break;
                case 'retainer':
                    return 'Renewable Retainer';
                    break;
                case 'hourly':
                    return 'Renewable Hourly';
                    break
                case 'balance':
                    return 'Renewable Balance';
                    break
                case 'refillable':
                    return "Refillable Balance";
                    break
                default: return 'Unknown'

            }// switch

          }// packageType

        function setAsDefault(thisPackage){
            return clientPackageService.setAsDefault(thisPackage, vm.client.packages)
            .then(function(){
                 var confirm = $mdDialog.confirm()
                          .title( thisPackage.label + ' has been set as your default.')
                          .htmlContent('It will be selected by default when you are logging time.')
                          .ariaLabel('Got it')
                          .ok('Got It');

                $mdDialog.show(confirm).then(function() {

                });
            })
        }//setAsDefault


        function triggerRenewal(thisPackage){
          var updates = {};
          updates['/clientPackages/' + thisPackage.uid + '/triggerRenew'] = true;
          return firebase.database().ref().update(updates);
        }

        function triggerRecalc(thisPackage){
          var updates = {};
          updates['/clientPackages/' + thisPackage.uid + '/recalc'] = true;
          return firebase.database().ref().update(updates);
        }

        function closePackage(thisPackage){
            var message = "It will not be available to log time to going forward."
            if(thisPackage.renewable){
                message = "Premature closing will stop future package renewals until you create a new package or re-open and configure this one."
            }
             var confirm = $mdDialog.confirm()
                      .title('Manually force this package to close?')
                      .htmlContent('<p>'+message+'</p>')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                return vm.packageService.closePackage(thisPackage)
                .then(function(){
                    $mdDialog.cancel();
                })
            })
        }// closePackage

        function archivePackage(thisPackage){
             var confirm = $mdDialog.confirm()
                      .title('Archive and Hide this package?')
                      .htmlContent('<p><strong style="color: red;">Please make sure all open items have been invoiced first!</strong></p>')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                return vm.packageService.archivePackage(thisPackage)
                .then(function(){
                    $mdDialog.cancel();
                })
            })
        }// archivePackage

        function activatePackage(thisPackage){
             var confirm = $mdDialog.confirm()
                      .title('Pre-Activate this pending package for logging time and charges?')
                      .htmlContent('<p>Packages are meant to renew and activate on their own schedule. Please use this feature with caution.</p>')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                return vm.packageService.activatePackage(thisPackage)
                .then(function(){
                   $mdDialog.show($mdDialog.alert()
                       .parent(angular.element(document.querySelector('#popupContainer')))
                       .clickOutsideToClose(true)
                       .title('Package has been started.')
                       .textContent('Package has been started.')
                       .ariaLabel('Dismissed')
                       .ok('OK')
                   );
                });// reeturn reOpen
            });//
        }// activate

        function reopenPackage(thisPackage){
             var confirm = $mdDialog.confirm()
                      .title('Re-open this package for logging time and charges?')
                      .htmlContent('<p></p>')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                return vm.packageService.reopenPackage(thisPackage)
                .then(function(){
                    if(thisPackage.renewable){
                         var confirm = $mdDialog.confirm()
                                  .title('Package Re-opened')
                                  .htmlContent('<p>This package may have previously renewed. It is currently not set up to renew again. <br>Would you like to schedule renewals?</p>')
                                  .ariaLabel('Are you sure?')
                                  .ok('Setup Schedule')
                                  .cancel('Not now');
                        $mdDialog.show(confirm).then(function() {
                            $mdDialog.cancel();
                            // open package to edit
                            vm.editPackage(thisPackage);
                        });
                    } else {
                        $mdDialog.cancel();
                    }// if renewable
                });// reeturn reOpen
            });//
        }// reopenPackage


        function deletePackage(thisPackage, ev){
            var pass = true;

            if(Number(thisPackage.totalMinutes) != 0){
                pass = false
            }

            if(Number(thisPackage.charges) != 0){
                pass = false
            }

            if(pass){
                 var confirm = $mdDialog.confirm()
                          .title('Permanently delete this package?')
                          .htmlContent('<p>This may end this package cycle.</p>')
                          .ariaLabel('Are you sure?')
                          .ok('Do it')
                          .cancel('Never mind');

                $mdDialog.show(confirm).then(function() {
                    return vm.packageService.deletePackage(thisPackage)
                    .then(function(){
                        $mdDialog.cancel();
                    })
                })
            } else {
                $mdDialog.show(
                      $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Package already has Time and/or Charges')
                        .textContent('Please reassign or remove existing time and/or charges before deleting.')
                        .ariaLabel('Alert')
                        .ok('Got it!')
                        .targetEvent(ev)
                    );
            }
        }// deletePackage

        /// THe logic in this function is re-used (in slightly different format) on the dashboard.
        function calcProgress(thisPackage){
            if(thisPackage){
                // we delay this for animation
                $timeout(function(){
                    // $log.info('calcProgress');
                    // determine our progressBar Color
                    var percentUsed = Number(thisPackage.qualifiedMinutes) / Number(thisPackage.budgetedMinutes);
;

                    if(thisPackage.type != 'hourly'){
                        vm.progressBarPercent = 1 - percentUsed;
                        // we get Nan when dividing zeroes
                        if (isNaN(vm.progressBarPercent)) {
                            vm.progressBarPercent = 1;
                          }
                    }

                    if(thisPackage.type == 'hourly'){
                        vm.progressBarPercent = percentUsed;
                        // we get Nan when dividing zeroes
                        if (isNaN(vm.progressBarPercent)) {
                            vm.progressBarPercent = 0;
                          }
                    }


                    vm.progressBarPercentLabel = Number(vm.progressBarPercent * 100).toFixed(0) + '%';
                    vm.packageBalance = thisPackage.budgetedMinutes - thisPackage.qualifiedMinutes;

                    // Convoluted because we don't always have 'cost' and 'charges'
                    if(thisPackage.type != 'hourly'){
                        if(_.has(thisPackage, 'charges')){
                            vm.totalCost = Number(thisPackage.charges).toFixed(2);
                        }
                    } else {
                        vm.totalCost = Number(thisPackage.accrued) + Number(thisPackage.charges);
                    }

                    // we need to remove base cost from charges so charges displayed are "additional"

                    // Make sure we don't attempt to draw out a negative number or number greater than 100%
                    if(vm.progressBarPercent > 1){
                        vm.progressBarPercent = 1;
                    }

                    // adding timeout so color change AFTER animation has completed
                    $timeout(function(){
                        if(thisPackage.type != 'hourly'){
                            if(vm.progressBarPercent >= .34){
                               vm.progressBarColor = 'rgb(76, 175, 80)'
                            }

                            if(vm.progressBarPercent < .33){
                               vm.progressBarColor = '#f36d0a'
                            }

                            if(vm.progressBarPercent < .15){
                               vm.progressBarColor = '#f42323'
                            }

                            // we want an alert-colored background if we are over budget
                            if(vm.progressBarPercent <= 0){
                                // vm.progressBarPercent = 0
                                vm.progressBarBackgroundColor = '#FBD6D6';
                            } else {
                                vm.progressBarBackgroundColor = '#efefef';
                            }
                        }// retainer labels

                        if(thisPackage.type == 'hourly'){
                            if(vm.progressBarPercent >= .75){
                               vm.progressBarColor = 'rgb(76, 175, 80)'
                            }

                            if(vm.progressBarPercent < .75){
                               vm.progressBarColor = '#f36d0a'
                            }

                            if(vm.progressBarPercent < .15){
                               vm.progressBarColor = '#efefef'
                            }

                            if(vm.packageBalance < 0){
                                vm.packageBalance = 0;
                            }
                            // we want an alert-colored background if we are over budget
                            vm.progressBarBackgroundColor = '#efefef';
                        }// retainer labels

                    },500)

                }, 1000);
            }
        }// recalcProgressColor


        function editTime(entry){
            timeDataService.timeDialog(entry, 'Modify')
            .then(function(){
                $mdDialog.cancel();
            });
        }

        function timeEntryTotal(entry){
            return entry.rate * (entry.logged/60)
        }

        function editPackage(clientPackage){
            clientPackageService.editPackage(clientPackage);
        }// editPackage

        function refillPackage(clientPackage){
            clientPackageService.refillPackage(clientPackage);
        }// refillPackage

        function addCharge(clientPackage){
            clientPackageService.newLineItem(clientPackage);
        }// addCharge


        function editCharge(lineItem){
            clientPackageService.editLineItem(lineItem);
        }// addCharge

        function showDetails(clientPackage){
            vm.showLoader = true;
            return timeDataService.getPackageTime(clientPackage.uid)
            .then(function(time){
                $timeout(function(){
                    vm.packageTime = time;
                    vm.numberTimeEntries = _.size(vm.packageTime);
                })
                // Get Line Item Charges
                return clientPackageService.getPackageCharges(clientPackage.uid)
                .then(function(charges){
                    $timeout(function(){
                        vm.packageCharges = charges;
                        vm.numberLineItems = _.size(vm.packageCharges);
                        vm.showLoader = false;
                        vm.detailsEnabled = true;

                    },0)
                    .then(function(){
                        return vm.packageService.fetchPackageHistory(clientPackage)
                        .then(function(history){
                           $timeout(function(){
                            vm.packageHistory = history;
                            vm.numberHistoryItems = _.size(vm.packageHistory);
                            vm.showHistoryLoader = false;
                           })
                       })
                    })
                })
            });
        }// loadTime

        function hideDetails(){
            vm.packageTime = null;
            vm.detailsEnabled = false;
        }//closeTime

    }// clientPackageController



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientMemberListItem', clientMemberListItem);


     function clientMemberListItem() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: clientMemberListItemController,
         scope: {
           member: '=member'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-member-list-item/client-member-list-item.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientMemberListItemController($rootScope, $scope, $log, userDataService, teamDataService) {
        var vm = this;
        vm.teamDataService = teamDataService;

        // get the full userRecord for this team member. We need both
        var userRef = firebase.database().ref('users').child(vm.member.uid);
        userRef.once('value', function(snapshot){
            vm.user = snapshot.val();
        });

        vm.becameMember = moment(vm.member.becameMember).format('MMM d, YYYY');
        vm.invited = moment(vm.member.invited).format('MMM d, YYYY');

        vm.selectTeamMember = function(member){
            vm.teamDataService.selectUser(vm.user);
            vm.teamDataService.selectTeamMember(member);
        }

        vm.isMemberSelected = function(){
            if(vm.teamDataService.selectedMember){
                if(vm.teamDataService.selectedMember.uid == vm.member.uid){
                    return true
                }
            }
        }




    }// controller



})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('clientCard', [clientCard])
        .directive('newClientButton', [newClientButton])
        .controller('clientController', [clientController]);

        /* @ngInject */
        function clientCard(clientDataService, $log, $mdDialog) {
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/app-directives/client-directives/client-card.tmpl.html',
                controller: clientController,
                controllerAs: 'vm',
                // scope:{
                //     client: '='
                // },
                bindToController: false
            };
            return directive;
        };

        /* @ngInject */
        function newClientButton(clientDataService, $log, $mdDialog) {
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: 'app/app-directives/client-directives/new-client-button.tmpl.html',
                controller: clientController,
                controllerAs: 'vm',
                bindToController: true
            };
            return directive;
        };


    /* @ngInject */
    function clientController($state, $timeout, $rootScope,  gateService, $mdDialog, clientDataService, timeReportService, $log, $scope, teamDataService, userDataService) {
        var vm = this;
        $scope.userID = $rootScope.userID;
        $scope.fbConfig = fbConfig;
        $scope.userType = $rootScope.admin;
        $scope.user = userDataService.user;

        vm.settings = $rootScope.userSettings;
        // if($state.includes('triangular.workspaces.information')){
        //   $scope.hideClone = true;
        // }
        $scope.isOwner = function(client, userID){
          if (client.owner == userID){
            return true
          } else {
            return false
          }
        }

        $scope.isTeamAdmin = function(client, userID){
          if (client.owner == userID){
            return true
          } else {
            if(teamDataService.isTeamAdmin(userID, client.owner)){
              return true
            }
          }
        }

        $scope.setupPeriodsBilling = function(client){
          firebase.database().ref('/clients/' + client.uid + '/billingType').set('periods')
        }

        $scope.setupPackagesBilling = function(client){
         firebase.database().ref('/clients/' + client.uid + '/billingType').set('packages')
        }

        $scope.sendStatusReport = function(client){
          return clientDataService.sendStatusReport(client);
        }

        $scope.displayBirthday = function(client){
            var thisYear = moment().format('YYYY');
            var birthday = moment(client.profile.birthday.month + '/' + client.profile.birthday.day + '/' + thisYear, "MM-DD-YYYY");
            return moment(birthday).format('MMMM Do')
        }

        // Edit a task
        $scope.editClient = function(client) {
            // $log.info('editClient got clicked!')
            // $log.info(client);
            client.clicked = true;
            // Remove visual after timer delay
            $timeout(function(){
                client.clicked = false;
            },250);
            return clientDataService.editClient(client.uid);

        }; // End editClient

        $scope.viewClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            $state.go('triangular.workspaces.information', {clientID: client.uid});
        }

        $scope.cloneWorkspace = function(clientID, targetUserID, isDemo){
          /// XXX NOTE: This logic is duplicated on our list of archived clients (they don't use this directive)
          /// any changes made here likely need made there and vice versa
          var clientLimit = gateService.gateData.clientLimit;

          var numClients = 0, canClone = true;

          // Only check client count if adding for OWN account
          // team accounts have no limits anyways

          // if user owns the client and the client is new
          if(targetUserID == $rootScope.userID){
              // count up our active, non-demo , owned clients
              _.each(clientDataService.clients, function(client){
                  if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                      numClients = numClients + 1;
                  }
              });
              // $log.info('numClients: '+numClients);

              if(numClients == clientLimit || numClients > clientLimit){
                  canClone = false;
              }
          }

         if(canClone){

            var confirm = $mdDialog.confirm()
                  .title('Clone Workspace: Are you Sure?')
                  .htmlContent('<p style="color: orange; padding-bottom: 1em; margin:0;">You are about to Clone this workspace <strong></p> <ul><li>- Time, Comments and Billing Plans will not be copied.</li> <li>- All Tasks will be initially assigned to you.</li><li>- Recurring task counts will be reset to zero.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Do It')
                  .targetEvent(event)
                  .ok('Clone It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              return clientDataService.copyClient(clientID, targetUserID, isDemo)
              .then(function(newClient){
                var workspaceType = 'Client';
                if(newClient.status == 'personal'){
                  workspaceType = "Internal"
                }

                  return clientDataService.setupUserAndClientMenu(true)
                  .then(function(){
                    var confirm = $mdDialog.confirm()
                          .title('Workspace Cloned!')
                          .htmlContent('<p style="padding-bottom: 1em; margin:0;">You\'ll find it in the '+ workspaceType +' menu.</p>').ariaLabel('Clone Complete')
                          .targetEvent(event)
                          .ok('Got it')
                    $mdDialog.show(confirm).then(function(){
                      // $log.info('clone completed.');
                    })
                  });
              })
            });

         }// if canClone
         else {
          var confirm = $mdDialog.confirm()
                .title('Oops! You\'ve reached your workspace limit!')
                .htmlContent('<p style="padding-bottom: 1em; margin:0;">You can clone this Workspace if you increase your Workspace limit or archive some Workspaces.</p>').ariaLabel('Do It')
                .targetEvent(event)
                .ok('Clone It!')
                .cancel('Cancel');

          $mdDialog.show(confirm)
         }
        }// cloneWorkspace

        $scope.archiveClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: red; padding-bottom: 1em; margin:0;">You are about to Archive the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- Any active billing packages will be archived.</li><li>- Task Due Dates will be removed</li> <li>- Team members will be unassigned.</li><li>- Recurring tasks will be disabled.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Archive')
                  .targetEvent(event)
                  .ok('Archive It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             // Store the current status (active or personal) so we have it for later use

             return clientDataService.archiveClient(client)
             .then(function(){
              // if we were ON the workspace when archiving it, take us to manage/workspaces

                if($state.includes('triangular.workspaces.information')){
                  $state.go('triangular.workspaces-manager')
                }
             });
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });
        }

        $scope.getThumb = function(client){
              // $log.info('getting thumbnails');
              // $log.info(client.profile);
              // $log.info(client.profile.avatar);
              // firebase.database().ref('images').orderByChild(client.profile.avatar).equalTo(client.profile.avatar).once('value').then(function(snapshot) {
              //   var data = snapshot.val();
              //   _.each(data, function(item){
              //       if(item){
              //           return item.thumbnail;
              //       } else {
              //           return client.profile.avatar
              //       }
              //   }); //each
              // });// images.once

            }// getThumb

        $scope.nextRenewal = function(client){
            if(_.has(client, 'profile.plan.nextCycle')){
                return client.profile.plan.nextCycle
            } else {
                // Legacy client that doesn't have nextRenewal yet.
                // we have to calculate it
                    var CurrentDate = new Date();

                    CurrentDate = moment(CurrentDate).format("YYYY-MM-DD");

                    var now = moment(),
                            thisMonth = parseInt(now.month()) + 1,
                            thisYear = now.year();

                    var tmpDate = thisYear + "/" + thisMonth + "/" + client.profile.plan.retainerStart;

                    var RetainerDate = new Date(tmpDate);
                    RetainerDate = moment(RetainerDate).format("YYYY-MM-DD");

                    // Deterimine which month we should be getting our retainer renewal date from
                    if (moment(CurrentDate).unix() >= moment(RetainerDate).unix()) {
                        /* Current Period*/
                    } else {
                        /* Previous Period */
                        var now = new Date();
                        thisMonth = (now.getMonth() - 1) + 1;

                        if (thisMonth == 0) {
                            thisMonth = 12;
                            thisYear = parseInt(thisYear) - 1;
                        }

                    }

                   tmpDate = thisYear + "/" + thisMonth + "/" + client.profile.plan.retainerStart,
                   RetainerDate = new Date(tmpDate);

                    var nextRenewal = moment(RetainerDate).add(1,'months');

                return nextRenewal
            }

        }

        $scope.newClient = function(){
            clientDataService.clientDialog(clientDataService.newClient(), 'New Client Workspace');
        }

    } //end clientController


})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('clientAccessManager', clientAccessManager);


     function clientAccessManager() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: clientAccessManagerController,
         scope: {
           client: '=client'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/client-access-manager/client-access-manager.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function clientAccessManagerController($rootScope, $scope, $mdToast, gateService, teamDataService, $log,  $mdDialog, $timeout, userDataService) {
        var vm = this;
        vm.user = userDataService.user;
        vm.inviteClientUser = inviteClientUser;
        vm.removeClientUser = removeClientUser;
        vm.clientUserLimit =   gateService.gateData.clientUserLimit;
        vm.updateAccess = updateAccess;
        vm.updateListAccess = updateListAccess;
        vm.enableClientUser = enableClientUser;
        vm.suspendClientUser = suspendClientUser;
        vm.showTasks = true;

        function init(user){

          if(_.has(vm.client, 'clientUsers')){
            vm.clientUserCount = _.size(vm.client.clientUsers);
          } else {
            vm.clientUserCount = 0;
          }

          if(!_.has(vm.client, 'clientUserTabs')){
            vm.client.clientUserTabs = {
              details: true,
              billing: false,
              time: true,
              tasks: true
            }
            updateAccess();
          }

          vm.isClientUser = false;
          if(_.has($rootScope, 'VAWorkspaces')){
               if(_.has($rootScope.VAWorkspaces, vm.client.uid)){
                       vm.isClientUser = true;
               }
           }

          $timeout(function(){
            resetForm();
          },1000)

        }// init

        init(vm.user);

        function resetForm(){
          vm.newUser = {
            email: '',
            status: 'pending',
            clientID: vm.client.uid
          }
          vm.alertMessage = '';
          if(vm.clientAccessUserForm){
            vm.clientAccessUserForm.$setPristine();
          }
        }

        function inviteClientUser(workspace, user){
          var newUser=angular.copy(user), alreadyExists = false;

          // Create node if we dont' have it already
          if(!_.has(workspace, 'clientUsers')){
            workspace.clientUsers = {};
          }

          // make sure user isn't already invited
          _.each(workspace.clientUsers, function(thisUser){
            if(thisUser.email == user.email){
              alreadyExists = true;
            }
          });

          if(!alreadyExists){
            // Invite the user
            return teamDataService.inviteClientUser(newUser,workspace.uid)
            .then(function(invite){
              newUser.uid = invite.uid;
              var updates = {};
              updates['/clients/' + workspace.uid + '/clientUsers/' + newUser.uid] = newUser;
              return firebase.database().ref().update(updates)
              .then(function(){
                workspace.clientUsers[newUser.uid] = newUser;
                init();
                $mdToast.show(
                    $mdToast.simple()
                    .content('Client invitation sent.')
                    .position('top right')
                    .hideDelay(1000)
                );
              });
            });

          } else {
            $timeout(function(){
              vm.alertMessage = "That email is already taken."
            },0)
          }


        }// inviteClientUser

        function suspendClientUser(workspace, user){
          var updates = {};
          updates['/clients/' + workspace.uid + '/access/users/' + user.uid] = null
          updates['/users/' + user.uid + '/VAWorkspaces/' + workspace.uid] = null
          updates['/users/' + user.uid + '/clients/' + workspace.uid] = null
          updates['/clients/' + workspace.uid + '/clientUsers/' + user.uid + '/status/'] = 'suspended';
          return firebase.database().ref().update(updates)
          .then(function(){
            $timeout(function(){
              workspace.clientUsers[user.uid].status = 'suspended';
            },0)
            $log.info('clientUser suspended');
          })
        }

        function enableClientUser(workspace, user){
          var updates = {};
          updates['/clients/' + workspace.uid + '/access/users/' + user.uid] = true;
          updates['/users/' + user.uid + '/VAWorkspaces/' + workspace.uid] = true;
          updates['/users/' + user.uid + '/clients/' + workspace.uid] = true;
          updates['/clients/' + workspace.uid + '/clientUsers/' + user.uid + '/status/'] = 'active';
          return firebase.database().ref().update(updates)
          .then(function(){
            $timeout(function(){
              workspace.clientUsers[user.uid].status = 'active';
            },0)
            $log.info('clientUser enabled');
          })
        }

        function removeClientUser(workspace, user){
          // $log.info(workspace.clientUsers);
          if(_.has(workspace.clientUsers, user.uid)){
            var updates = {};
            updates['clients/'+workspace.uid+'/clientUsers/'+user.uid] = null;
            updates['clients/'+workspace.uid+'/access/users/' + user.uid] = null;
            updates['users/'+ user.uid + '/VAWorkspaces/' + workspace.uid] = null;
            updates['users/'+ user.uid + '/clients/' + workspace.uid] = null;
            updates['teamInvites/' + user.uid] = null;
            return firebase.database().ref().update(updates)
            .then(function(){
              //update our local copy
              $timeout(function(){
                delete workspace.clientUsers[user.uid];
                init();
              },0)
            });
          }
        }// removeClientUser


        function updateAccess(){
          var updates = {};
          updates['/clients/' + vm.client.uid + '/clientUserTabs'] = vm.client.clientUserTabs;
          return firebase.database().ref().update(updates)
          .then(function(){
            $mdToast.show(
                $mdToast.simple()
                .content('Tab access updated')
                .position('top right')
                .hideDelay(1000)
            );
          })
        }// updateAccess

        function updateListAccess(listType, listID, value){
          var updates = {}, listPath;
          if(listType == 'tasks'){
            listPath = '/taskBoards/' + vm.client.defaultTaskBoard + '/lists/' + listID;
          }
          if(listType == 'details'){
            listPath = '/detailBoards/' + vm.client.defaultDetailBoard + '/lists/' + listID;
          }
          updates['/clients/' + vm.client.uid + listPath + '/clientEnabled'] = value;
          updates[listPath + '/clientEnabled'] = value;
          return firebase.database().ref().update(updates)
          .then(function(){
            $mdToast.show(
                $mdToast.simple()
                .content('List access updated')
                .position('top right')
                .hideDelay(1000)
            );
          });
        }// updateAccess


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('billingPeriodCard', billingPeriodCard);


     function billingPeriodCard() {
       var directive = {
         restrict: 'E',
         replace: false,
         controller: billingPeriodCardController,
         scope: {
           period: '=period',
           client: '=client',
           index: '=index'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<div ng-include="getTemplateUrl()"></div>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr) {


       scope.getTemplateUrl = function() {
           return 'app/app-directives/billing-period/billing-period-card.tmpl.html';
       };

     }// linkFunc

    /* @ngInject */
    function billingPeriodCardController($timeout, $rootScope, $scope, $log, $filter, $mdToast, $mdDialog, clientBillingService, clientDataService, clientPackageService, userDataService, timeDataService, $firebaseObject) {
        var vm = this;

        // NOTE we have vm.period and vm.client by default because it was passed in to "this" already

         vm.currency = "$";
         vm.fbConfig = fbConfig;
         vm.userType = $rootScope.admin;
         vm.user = userDataService.user;
         vm.settings = $rootScope.userSettings;

         // set our currency if user has selected one
        if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
         }

        vm.clientBillingService = clientBillingService;


        vm.setupAsPackage = function(billingPeriod){
            return clientPackageService.newPackage(vm.client, false, billingPeriod)
        }//

        // Select and display specific period
        vm.selectPeriod = function(){
            vm.clientBillingService.selectPeriod(vm.period);
        }

        // Calculate appropriate color flag depending on status
        vm.clientColor = function(){
            return vm.client.profile.clientColor
        }// vm.clientColor



        vm.fixEndDate = function(period){
            $log.info(period);
            var updates = {};
            updates['/billingPeriods/' + period.uid + '/info/end'] = "2020-11-07T03:00:13.252Z";
            updates['/clients/' + period.client + '/billing/' + period.uid + '/end'] = "2020-11-07T03:00:13.252Z";

            return firebase.database().ref().update(updates)
            .then(function(){
              // $log.info('sorted');
              // Force (true) Refresh our client menu
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Adjustment complete',
                          message: 'End dates have been fixed for this period' ,
                          color: 'green'
                      }
                  }));// mdToast
            });
        }


        vm.deductOverage = function(period){
            var deductible = period.logged - (period.allocated * 60);

            // Get the client record
            var thisClient = null;
            _.each(clientDataService.clients, function(client){
                if(client.uid == period.client){
                    thisClient = client;
                }
            });

            if(thisClient){
                // Locate the current period
                var thisDate = moment().toISOString();

                var thisPeriod = null;
                _.each(thisClient.billing, function(period){
                    if(!thisPeriod && thisDate < period.end && thisDate >= period.start){
                        thisPeriod = period
                    }
                });

                if(thisPeriod){
                    var allocatedMinutes = thisPeriod.allocated * 60,
                        newAllocated = (allocatedMinutes - deductible)/60,
                        updates = {};
                        var currentNotes = "";
                        if(_.has(thisPeriod, 'notes')){
                            currentNotes = thisPeriod.notes;
                        }

                        var deductibleFormatted = $filter('userTimeFormat')(deductible);

                        var currentPeriodNotes =  currentNotes.concat('\n' + moment().format(vm.settings.shortDateFormat) + ': Deducted ' + deductibleFormatted + ' due to overage on the ' + moment(period.start).format(vm.settings.shortDateFormat) + ' - ' + moment(period.end).format(vm.settings.shortDateFormat) + ' billing period.');
                        // update the current billing period
                        updates['clients/' + thisPeriod.client + '/billing/' + thisPeriod.uid + '/allocated'] = newAllocated;
                        updates['clients/' + thisPeriod.client + '/billing/' + thisPeriod.uid + '/notes'] = currentPeriodNotes;
                        updates['billingPeriods/' + thisPeriod.uid + '/info/allocated'] = newAllocated;
                        updates['billingPeriods/' + thisPeriod.uid + '/info/notes'] = currentPeriodNotes;
                        // update the period with an overage
                        var previousNotes = "";
                        if(_.has(period, 'notes')){
                            previousNotes = period.notes;
                        }
                        var start = moment(thisPeriod.start).format(vm.settings.shortDateFormat),
                            end = moment(thisPeriod.end).format(vm.settings.shortDateFormat);

                        var previousPeriodNotes = previousNotes.concat('\n' + moment().format(vm.settings.shortDateFormat) + ': Overage of ' + deductibleFormatted + ' was deducted from the ' + start + ' - ' + end + ' billing period.');
                        updates['clients/' + period.client + '/billing/' + period.uid + '/overageDeductedFrom'] = thisPeriod.uid;
                        updates['billingPeriods/' + period.uid + '/info/overageDeductedFrom'] = thisPeriod.uid;
                        updates['clients/' + period.client + '/billing/' + period.uid + '/notes'] = previousPeriodNotes;
                        updates['billingPeriods/' + period.uid + '/info/notes'] = previousPeriodNotes;


                        return firebase.database().ref().update(updates)
                        .then(function(){
                          // $log.info('sorted');
                          // Force (true) Refresh our client menu
                          $mdToast.show($mdToast.adminjaAlert(
                              {
                                  locals:{
                                      title: 'Adjustment complete',
                                      message: 'Your overage has been deducted from the current billing period.' ,
                                      color: 'green'
                                  }
                              }));// mdToast
                        });

                } else {
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: 'Adjustment Failed',
                                message: 'You don\'t seem to have a current billing period. Please check your billing period dates and make sure you have a current billing period.' ,
                                color: 'red'
                            }
                        }));// mdToast
                }
            }

        }// deductOverage

        vm.rolloverUnused = function(period){
            var minutesUnder = (period.allocated * 60) - period.logged;

            // Get the client record
            var thisClient = null;
            _.each(clientDataService.clients, function(client){
                if(client.uid == period.client){
                    thisClient = client;
                }
            });

            if(thisClient){
                var currentPeriod = null;
                _.each(thisClient.billing, function(period){
                    if(period.uid == thisClient.profile.plan.currentPeriod){
                        currentPeriod = period;
                    }
                });

                if(currentPeriod){
                    var allocatedMinutes = currentPeriod.allocated * 60,
                        newAllocated = (allocatedMinutes + minutesUnder)/60,
                        updates = {};
                        var currentNotes = "";

                        if(_.has(currentPeriod, 'notes')){
                            currentNotes = currentPeriod.notes;
                        }

                        var addFormatted = $filter('userTimeFormat')(minutesUnder);

                        var currentPeriodNotes =  currentNotes.concat('\n' + moment().format(vm.settings.shortDateFormat) + ': Rolled over ' + addFormatted + ' unused hours from the ' + moment(period.start).format(vm.settings.shortDateFormat) + ' - ' + moment(period.end).format(vm.settings.shortDateFormat) + ' billing period.');
                        // update the current billing period
                        updates['clients/' + currentPeriod.client + '/billing/' + currentPeriod.uid + '/allocated'] = newAllocated;
                        updates['clients/' + currentPeriod.client + '/billing/' + currentPeriod.uid + '/notes'] = currentPeriodNotes;
                        updates['billingPeriods/' + currentPeriod.uid + '/info/allocated'] = newAllocated;
                        updates['billingPeriods/' + currentPeriod.uid + '/info/notes'] = currentPeriodNotes;
                        // update the period with an overage
                        var previousNotes = "";
                        if(_.has(period, 'notes')){
                            previousNotes = period.notes;
                        }
                        var start = moment(currentPeriod.start).format(vm.settings.shortDateFormat),
                            end = moment(currentPeriod.end).format(vm.settings.shortDateFormat);

                        var previousPeriodNotes = previousNotes.concat('\n' + moment().format(vm.settings.shortDateFormat) + ': Unused hours of ' + addFormatted + ' was added to the ' + start + ' - ' + end + ' billing period.');
                        updates['clients/' + period.client + '/billing/' + period.uid + '/remainingRolledOver'] = currentPeriod.uid;
                        updates['billingPeriods/' + period.uid + '/info/remainingRolledOver'] = currentPeriod.uid;
                        updates['clients/' + period.client + '/billing/' + period.uid + '/notes'] = previousPeriodNotes;
                        updates['billingPeriods/' + period.uid + '/info/notes'] = previousPeriodNotes;


                        return firebase.database().ref().update(updates)
                        .then(function(){
                          // $log.info('sorted');
                          // Force (true) Refresh our client menu
                          $mdToast.show($mdToast.adminjaAlert(
                              {
                                  locals:{
                                      title: 'Adjustment complete',
                                      message: 'Your unused time have been rolled over to the current billing period.' ,
                                      color: 'green'
                                  }
                              }));// mdToast
                        });

                } else {
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: 'Adjustment Failed',
                                message: 'You don\'t seem to have a current billing period. Please check your billing period dates and make sure you have a current billing period.' ,
                                color: 'red'
                            }
                        }));// mdToast
                }
            }// if this client

        }//rolloverUnused

        vm.deletePeriod = function(period){
            // $log.info(vm.client);
             var confirm = $mdDialog.confirm()
                      .title('Remove this Billing Period?')
                      .htmlContent('Don\'t forget to adjust your client\'s "Next Renewal" date.')
                      .ariaLabel('Remove, are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                 // get the period
                 var periodRef = firebase.database().ref('billingPeriods/'),
                     fannedRef = firebase.database().ref('clients/' + period.client + '/billing/');
                 var updates = {};
                 updates['/billingPeriods/' + period.uid] = null;
                 updates['/clients/' + period.client + '/billing/' + period.uid] = null;
                 // $log.info(updates);

                 // Check to see if any period needs to be "current"
                 var latest = { end: '"2010-12-00T00:00:00.000Z"'};
                 _.each(vm.client.billing, function(thisPeriod){
                    if(thisPeriod.end > latest.end && period.uid != thisPeriod.uid){
                        latest = thisPeriod;
                    }
                 });
                 // if we found the latest period, make it current
                 if(_.has(latest, 'uid')){
                    updates['/clients/' + period.client + '/profile/plan/currentPeriod'] = latest.uid;
                 }
                 return firebase.database().ref().update(updates)
                 .then(function(){

                 });

            }, function() {
                 // they chose the cancel option
                 $mdDialog.cancel();
            });
        }// delete period

        vm.recalcPeriod = function(period){
            // $log.info('recalcRequested');
            // ask if they really want to do this (to deter users from clicking it over and over again rapidly)
            var confirm = $mdDialog.confirm()
                     .title('Request a recalculation?')
                     .htmlContent('This may take from a few seconds up to a 2 minutes to complete.')
                     .ariaLabel('Request a recalc?')
                     .ok('Got it')
                     .cancel('Never mind');

           $mdDialog.show(confirm).then(function() {
                // get the period
                var periodRef = firebase.database().ref('/billingPeriods/' + period.uid);
                return $firebaseObject(periodRef)
                .$loaded(function(data){
                    // send it to retrigger
                    return timeDataService.triggerReCalc(data)
                    .then(function(){
                        $mdToast.show($mdToast.adminjaAlert(
                            {
                                locals:{
                                    title: 'Recalculation triggered',
                                    message: 'Your billing period is being recalculated.' ,
                                    color: 'orange'
                                }
                            }));// mdToast
                    });
                })
           }, function() {
                // they chose the cancel option
                $mdDialog.cancel();
           });

        }// recalcPeriod

        vm.isSelected = function(){
            if(vm.clientBillingService.selectedPeriod){
                if(vm.clientBillingService.selectedPeriod.uid == vm.period.uid){
                    return true
                }
            }
        }

        vm.earned = function(period){
            // if billing period is new and uses time categories for rates
            if(_.has(period, 'earned')){
                return period.earned.toFixed(2);
            } else {
            // if the billing period is old and there's just one rate for the period
                var earned = vm.used()/60 * period.rate
                return earned.toFixed(2);
            }
        }

        vm.setCurrentPeriod = function(periodID){
            var clientRef = firebase.database().ref('clients/' + vm.client.uid + '/profile/plan/currentPeriod');
            clientRef.set(periodID);
        }

        vm.used = function(){
            return Math.round(vm.period.logged)
        }

        // selects which class our "used" value should get (default, orange, red)
        vm.retainerStatusClass = function(){
            var used = vm.used()/60;
            if(vm.period.type == 'retainer' && vm.period.allocated > 0){
                if(vm.period.allocated < used){
                    return 'over'
                }
                if(used / vm.period.allocated > .75){
                    return 'almost'
                }
                if(used / vm.period.allocated < .75){
                    return 'under'
                }
            } else {
                return 'under'
            }// if type=retainer

        }// vm.statusClass


        vm.isCurrentPeriod = function(client, period){
            var now = moment().toISOString();
            if (period.start <= now && period.end >= now){
                return true
            } else {
                return false
            }
        }


    }// controller



})();

(function () {
    'use strict';

    angular
            .module('appDirectives')
            .directive('avatar', avatar);


     function avatar() {
       var directive = {
         restrict: 'E',
         replace: true,
         controller: avatarController,
         scope: {
           parent: '=parent',
           type: '@type',
           border: '=border',
           upload: '=upload',
           context: '@context'
         },
         controllerAs: 'vm',
         bindToController: true,
         // We need to prepare the proper template url in a link function
         link: linkFunc,
         // Populate the template via ng-include
         template: '<span ng-include="getTemplateUrl()"></span>'
       };
       return directive;
     };

   // linkFunc.$inject=['$scope', 'element', 'attr','toastService'];
   function linkFunc(scope, element, attr, form) {

       scope.getTemplateUrl = function() {
           return 'app/app-directives/avatar/avatar.tmpl.html';
       };
     }// linkFunc

    /* @ngInject */
    function avatarController($rootScope, $scope, $mdToast, $mdMenu, $log, $timeout, userDataService, teamDataService) {
        var vm = this;
        // $log.info('context: ' + vm.context);
        // Parent must have avatar
        // better if it has avatarThumb
        vm.iconColor = '#000';

        if(_.has(vm.parent, 'clientColor')){
          vm.workspaceColor = vm.parent.clientColor;
        } else {
          vm.workspaceColor = '#999';
        }

        if(vm.context){
          if(vm.context == 'light'){
            vm.iconColor = '#999';
          } else if (vm.context == 'dark'){
            vm.iconColor = '#fff';
          }
        }// if we have a context parameter

        // set default
        if(vm.type == 'default' || vm.type == 'personal'){
          vm.thumbnail = "https://www.adminja.co/assets/images/avatars/generic-default-avatar.png";
        } else {
          vm.thumbnail = "https://www.adminja.co/assets/images/avatars/generic-person-avatar.png";
        }

        // parent thumbnails might be undefined!
        if(_.has(vm.parent, 'thumbnail')){
          vm.thumbnail = vm.parent.thumbnail;
        } else if (_.has(vm.parent, 'avatar')){
          vm.thumbnail = vm.parent.avatar;
        }

        // just in case the parent thumbnail is undefined
        if(!vm.thumbnail){
          vm.thumbnail = "https://www.adminja.co/assets/images/avatars/generic-person-avatar.png";
        }

        // Setup our Avatar Menu
        vm.avatars = [
        ], vm.icons = [];

        var end=32, i= 1;
        while (i <= end) {
            var item = {
                label: 'Face ' + i,
                image: 'https://www.adminja.co/assets/images/avatars/avatar-' + i + '.png'}
            vm.avatars.push(item)
          i++;
        }

        end=70, i= 1;
        while (i <= end) {
            var item = {
                label: 'Icon ' + i,
                image: 'https://www.adminja.co/assets/images/avatars/icon-' + i + '.png'}
            vm.icons.push(item)
          i++;
        }

        vm.setAvatar = function(image){
          vm.parent.avatar = image;
          vm.parent.avatarThumb = image;
          // update our visible thumb
          vm.thumbnail = image;
          $scope.$emit('uploadComplete');

        }

        vm.uploadAvatar = function ($files) {
            // $log.info('upload file');
            // $log.info($files);
            if ($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                        storageRef = storage.ref();
                _.each($files, function (file) {
                    var filename = ref.currentUser.uid + '_' + file.name;
                    // $log.info('Saving '+filename);
                    // create imageRef and put the file
                    var imageRef = storageRef.child('avatars/' + filename),
                            uploadTask = imageRef.put(file);
                    vm.uploading = true;
                    uploadTask.on('state_changed', function (snapshot) {
                        // $log.info('upload state changed');
                    }, function (error) {
                        // $log.warn('upload failed');
                    }, function (success) {
                      return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadUrl){
                        $timeout(function(){
                          // update our local model
                          vm.parent.avatarPath = imageRef.fullPath;
                          vm.parent.avatar = downloadUrl;
                          vm.parent.avatarThumb = downloadUrl;
                          // update our visible thumb
                          vm.thumbnail = vm.parent.avatarThumb;
                          $scope.$emit('uploadComplete');
                          vm.uploading = false;
                          // $scope.clientDialogForm.$setDirty();
                        },200);

                        $mdToast.show(
                                $mdToast.simple()
                                .textContent('Photo uploaded. Thanks!')
                                .position('top right')
                                .hideDelay(1000)
                                );
                        //heap.track('Avatar Uploaded');
                        userDataService.trackEvent('upload-avatar');
                      });
                    }); // uploadTask.on
                }); // ._each files
            } // if files
        }; // vm.uploadAvatar



    }// controller



})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('ToolbarController', DefaultToolbarController);

    /* @ngInject */
    function DefaultToolbarController($log, $scope,$injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;
        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $scope.logout =logout;
        $scope.label = "All Tasks";

        if($scope.$state.current.name == 'triangular.today'){
            $scope.label = "Today's Tasks";
            // $scope.backgroundColor = "#C5C50D";
        }

        // if we are on dashboard, substitute a different crumb
        // if($state.includes('triangular.dashboard')){
        //     $scope.overRideBreadcrumb = "Dashboard"
        // }


        // Added for Adminja
        // function setAllTaskView(view){
        //     kanbanService.setAllTaskView(view);
        // }//setAllTaskView

        function logout(){
            firebase.auth().signOut().then(function() {
              // Sign-out successful.
              $state.go('authentication.login')
            }, function(error) {
              // An error happened.
            });
        }
        ////////////////

        function changeState(newState){
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('RightSidenavController', RightSidenavController);

    /* @ngInject */
    function RightSidenavController($mdToast, $mdUtil, mdcDateTimeDialog, $rootScope, Idle, hotkeys, scheduleDataService, teamDataService, $sce, inboxService, gateService, messagingService, profileDataService, $document, $stateParams, timeDataService, taskDataService, $timeout, userDataService, $log, $firebaseArray, $q, localStorageService, $scope, $http, $mdDialog, $mdSidenav, $state, API_CONFIG) {
        // $log.info('RightSidenavController');
        var vm = this;
        // In a timeout to make sure the view gets the info


        alert;

        $timeout(function(){
            $scope.user = userDataService.user;
            $scope.userSettings = $rootScope.userSettings;
            $scope.canImportEmail = gateService.gateData.canImportEmail;
            $scope.canUseTimer = gateService.gateData.canUseTimer;
            $scope.canLogTime = gateService.gateData.canLogTime;
            $scope.showTimer = gateService.gateData.canUseTimer;
            $scope.gateService = gateService;
            $scope.userType = $rootScope.admin;
            $scope.ready = true;
            $scope.hasCompletedReminders = false;
            clearOldNotifications($scope.user);
        },4000);



        resetReminder();

        function resetReminder(){
            scheduleDataService.deSelectSchedule();
            $scope.newReminder = {
                message: '',
                type: 'reminder',
                status: 'active',
                path: '/users/' + $rootScope.userID + '/reminders',
                payload:{
                    userID: $rootScope.userID,
                    path: '/users/' + $rootScope.userID + '/reminders',
                }
            }
            $scope.showLongWhen = false;
            $scope.minDate = moment().toDate();
        };


        function clearOldNotifications(user){
            if(_.has(user, 'notifications')){
                var expire = moment().subtract(30, 'day').toISOString(), updates = {};
                _.each(user.notifications, function(notification){
                    if(notification.date < expire){
                        updates['/users/' + user.uid + '/notifications/' + notification.uid] = null;
                    }
                });
                if(_.size(updates) > 0){
                    // $log.info(updates);
                    // $log.info('Removed ' + _.size(updates) + ' old notifications.');
                    return firebase.database().ref().update(updates)
                    .then(function () {
                        // $log.info('Cleaned up ' + _.size(updates) + ' old notifications.');
                    });
                } else {
                    // $log.info('No old notifications to clean.');
                }
            }
        }// clearOldNotifications

        $scope.prepReminder = function(input){
                switch(input) {
                    case '-1m':
                        $scope.newReminder.when = moment().subtract(1, 'minute').toISOString();
                        break
                    case '1m':
                        $scope.newReminder.when = moment().add(1, 'minute').toISOString();
                        break
                    case '5m':
                        $scope.newReminder.when = moment().add(5, 'minute').toISOString();
                        break
                    case '10m':
                        $scope.newReminder.when = moment().add(10, 'minute').toISOString();
                        break
                    case '15m':
                        $scope.newReminder.when = moment().add(15, 'minute').toISOString();
                        break
                    case '30m':
                        $scope.newReminder.when = moment().add(30, 'minute').toISOString();
                        break
                    case '1h':
                        $scope.newReminder.when = moment().add(1, 'hour').toISOString();
                        break
                    case '2h':
                        $scope.newReminder.when = moment().add(2, 'hour').toISOString();
                        break
                    case '4h':
                        $scope.newReminder.when = moment().add(4, 'hour').toISOString();
                        break
                    case '8h':
                        $scope.newReminder.when = moment().add(8, 'hour').toISOString();
                        break
                    case '1d':
                        $scope.newReminder.when = moment().startOf('day').add(9, 'hours').add(1, 'day').toISOString();
                        break
                    case '2d':
                        $scope.newReminder.when = moment().startOf('day').add(9, 'hours').add(2, 'day').toISOString();
                        break
                    case '3d':
                        $scope.newReminder.when = moment().startOf('day').add(9, 'hours').add(3, 'day').toISOString();
                        break
                    case '7d':
                        $scope.newReminder.when = moment().startOf('day').add(9, 'hours').add(7, 'day').toISOString();
                        break
                    default:
                        // they used the datepicker. Just set it
                        $scope.newReminder.when = moment(input).startOf('day').add(9, 'hours').toISOString();
                }

                var a = moment($scope.newReminder.when);
                var b = moment();
                if (a.diff(b, 'hours') > 12){
                    $scope.showLongWhen = true;
                } else {
                    $scope.showLongWhen = false;
                }
        }


        $scope.displayTimeDialog = function(reminder){
            mdcDateTimeDialog.show({
              currentDate: moment(reminder.when),
              time: true,
              date: false,
              shortTime: true,
              clickOutsideToClose: true,
              disableParentScroll: true,
              todayText: 'Now',
            }).then(function (date) {
                 reminder.when = moment(date).toDate();
        });
        }// displayTimeDialog

        $scope.saveNewReminder = function(reminder){
            // $scope.isSaving = true;
            var newSchedule = scheduleDataService.newSchedule($rootScope.userID, reminder, reminder.when);
            scheduleDataService.saveNewSchedule(newSchedule);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Reminder Added',
                        message: '' ,
                        color: 'green'
                    },
                    position: 'top right',
                    hideDelay: 250
                }));// mdToast
            return userDataService.count($rootScope.userID, 'reminders', 1)
            .then(function(){
                resetReminder();
            })

        }//saveNewReminder

        $scope.updateReminder = function(reminder){
            // if when is in the future, make sure it's active.
            if(_.has(reminder, 'when')){
                if(moment().toISOString() < moment(reminder.when).toISOString()){
                    reminder.status = 'active'
                } else {
                    reminder.status = 'triggered'
                }
            }

            scheduleDataService.updateReminder(reminder);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Reminder Updated',
                        message: '' ,
                        color: 'green'
                    },
                    position: 'top right',
                    hideDelay: 250
                }));// mdToast
            resetReminder();
            $timeout(function(){
                $scope.$apply();
            }, 100);
        }// updateReminder

        $scope.removeReminderWhen = function(reminder){
            delete reminder.when
        }


        $scope.cancelReminderEdit = function(){
            resetReminder();
        }

        $scope.clearComplete = function(){
            var promises = [];
            _.each($scope.user.reminders, function(reminder){
                if(reminder.userStatus =='closed' ){
                    return scheduleDataService.removeSchedule(reminder)
                    .then(function(){
                        return userDataService.count($rootScope.userID, 'discardedReminders', 1)
                    })
                }
            });

        }//clearComplete

        // Watch for selected reminders
        var unwatch = $rootScope.$on('selectedReminder', function(event, args){
            var selectedReminder = args.schedule;
            var editedReminder = angular.fromJson(angular.toJson(selectedReminder));

            // clear our "when" if already passed
            if(editedReminder.status == 'triggered'){
                delete editedReminder.when
            }

            $scope.newReminder = editedReminder;
            // determine if we should show short or long date
            var a = moment($scope.newReminder.when);
            var b = moment();
            if (a.diff(b, 'hours') > 12){
                $scope.showLongWhen = true;
            } else {
                $scope.showLongWhen = false;
            }

        });// watch for selected reminder





        $scope.sanitizeMe = function(text) {
            return $sce.trustAsHtml(text)
        };

        $scope.requestNotificationPermission = function(){
            messagingService.requestPermission();
        }
        var emailKey = undefined;

        $scope.updateSettings = function(setting, value){
            // $log.info('updateSettings');
            userDataService.changeUserSetting(setting, value);
            userDataService.getLoggedInUser();
        } // $scope.updateSettings

        $scope.setIdleTimeout = function(timeout){
            // $log.info('setting timeout: ' + timeout);
            Idle.setTimeout(Number(timeout));
        }
        $scope.resetOnboarding = function(){
            return userDataService.resetOnboarding();
        }



        $scope.changeOnboardingFlag = function(flag, value){
            return userDataService.changeOnboardingFlag(flag, value);
        }

        // For some reason, this functino won't work under 'vm'
        $scope.logManualTime = function(){
           // $log.info('newTime');
           var clientID = null;
           // if we are on a client page and passed a Client ID, prepopulate our client info
           if ($stateParams.clientID){
            // $log.info('new time for client' + $stateParams.clientID);
            clientID = $stateParams.clientID;
           }

           $scope.timeEntry = timeDataService.newLogEntry(clientID);
           // $log.info($scope.timeEntry);
           timeDataService.timeDialog($scope.timeEntry, "New");
        }




        $scope.discardAllNotifications = function(){
           var entryRef = firebase.database().ref('users/' + $scope.user.uid + '/notifications/');
          entryRef.set(null);
          // _.each(user.notifications, function(notification){

          // })
        }



        // sets the current active tab
        $scope.close = close;
        $scope.currentTab = 0;



        $scope.noGhostUser = function(){
            if(!localStorageService.get('ghostUser')){
                return true
            } else {
                return false
            }
        }
        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('triSwitchNotificationTab', function($event, tab) {
            $scope.currentTab = tab;
        });

        function close() {
            $mdSidenav('right').close();
        }
    }
})();

(function() {
        'use strict';
        angular
            .module('app', [
                // Triangular Modules
                'ui.router', 'permission',
                'triangular',
                'ngAnimate', 'ngCookies', 'ngMessages', 'ngMaterial',
                 'ui.calendar', 'angularMoment',  'md.data.table', angularDragula(angular), 'ngFileUpload',
                'froala',
                // 'googlechart',
                'chart.js',
                'hljs',
                'ngIdle',
                // ui-grid modules
                'ui.grid',
                'ui.grid.expandable',
                'ui.grid.exporter',
                'ui.grid.grouping',
                'ui.grid.resizeColumns',
                'ui.grid.autoResize',
                'angular-progress-arc',
                // 'seed-module',
                'app.translate',
                'app.permission',
                // dont need permissions?  if you want to turn off permissions
                // comment out or remove the 'app.permission', line above
                // also remove 'permission' from the first line of dependencies
                // https://github.com/Narzerus/angular-permission see here for why
                'calendar',
                // Other Third Party,
                'lk-color-chooser',
                'lk-google-picker',
                'dropbox-picker',
                'angular-embedly',
                'AngularPrint',
                'cfp.hotkeys',
                'lk-color-chooser',
                'firebase',
                'LocalStorageModule',
                'ngLodash',
                'ngSanitize',
                'angularLoad', // for loading and wrapping 3rd party JS (used for Chargebee API)
                'ngCsv', // for converting JSON into Bas64 CSV downloads
                'rt.debounce', // mainly for debouncing horizontal nav bounds checking but might come in handy on
                // 'xeditable',
                'angularInlineEdit',
                'angular-toArrayFilter',
                'ngMaterialDatePicker',
                // Adminja modules
                'time',
                'app.authentication',
                'appDirectives',
                'appServices',
                'adminDashboard',
                'adminSetup',
                'tasks',
                'leads',
                'billing',
                'clientManager',
                'adminTeam',
                // 'diagnostics',
                'appFilters',
                'adminToday',
                'manage',
                'ngClassOnMobile',
                'adminAwards',
                'training',
                'leads',
                'publicForm',
                'customForms',
                'paymentPortal'
                // ,'bry'
            ])

              // Disable debugging classes that slow us down a bit
              // https://blog.upstate.agency/improving-angular-performance-with-1-line-of-code-a1fb814a6476
              .config(['$compileProvider', function ($compileProvider) {
                $compileProvider.debugInfoEnabled(false);
              }])
              // whitelist youtube so we can embed urls
            .config(function($sceDelegateProvider) {
                $sceDelegateProvider.resourceUrlWhitelist([
                    // Allow same origin resource loads.
                    'self',
                    // Allow loading from our assets domain. **.
                    'https://www.youtube-nocookie.com/**'
                ]);
              })
              // configure google file picker

              .config(['lkGoogleSettingsProvider', function (lkGoogleSettingsProvider) {
                  // https://github.com/softmonkeyjapan/angular-google-picker
                  if(adminjaEnv == 'production'){
                    // console.log('using production GoogleDrive');
                    lkGoogleSettingsProvider.configure({
                      apiKey   : 'AIzaSyC3Fo2AjN-zJcTmkAQ4xvIHT2Wsp5Y_F8k',
                      clientId : '1012957704097-6gljved40d8lfp6tjmcm1194dtll5735.apps.googleusercontent.com',
                      scopes   : ['https://www.googleapis.com/auth/drive'],
                      locale   : 'en',
                      features : ['MULTISELECT_ENABLED']
                    })
                  } else {
                    // console.log('using staging GoogleDrive');
                    lkGoogleSettingsProvider.configure({
                      apiKey   : 'AIzaSyBCq7rCdf8-PSBffxXbC8VYlc3yif8iIt0',
                      clientId : '190033260049-spkn7rdilca4k5a8hmcbhfk8ra0psqac.apps.googleusercontent.com',
                      scopes   : ['https://www.googleapis.com/auth/drive'],
                      locale   : 'en',
                      features : ['MULTISELECT_ENABLED']
                    })
                  }
            }])


              // Adminja-themed toast template (not currently being used but storing in this comment for potential future use)
              // template:
              //   '<md-toast class="adminja-toast">' +
              //   '  <div  class="md-toast-content " style="background-color: #fff; color: #666; padding: 1em; border-top: 4px solid {{color}};">' +
              //       '<div layout="row" layout-align="start start">'+
              //         '<div layout="column" layout-align="center center">'+
              //           '<img src="/assets/images/brand/adminja-bug-small.png" width="30" height="30" style="margin: 0 1em 0 0;"> ' +
              //           '</div>'+
              //         '<div flex layout="column" layout-align="start start">'+
              //           '<h4 style="margin:0;"><strong>{{title}}</strong></h4>' +
              //           '<p style="margin:0;">{{message}}</p>'+
              //         '</div>' +
              //       '</div>' +
              //       '</div>'+
              //   '</md-toast>',


              .config(['$mdToastProvider', function($mdToastProvider){
                $mdToastProvider
                  .addPreset('adminjaAlert', {
                    options: ['$mdToast', '$mdTheming', function($mdToast, $mdTheming) {
                      return {
                        templateUrl: 'app/app-services/notificationService/adminja-toast.tmpl.html',
                        controllerAs: 'vm',
                        hideDelay   : 3000,
                        bindToController: true,
                        position: 'top right',
                        autoWrap: false,
                        controller: messageToastController
                      };
                    }]
                  });

                  $mdToastProvider
                    .addPreset('adminjaStickyAlert', {
                      options: ['$mdToast', '$mdTheming', function($mdToast, $mdTheming) {
                        return {
                          templateUrl: 'app/app-services/notificationService/adminja-toast.tmpl.html',
                          controllerAs: 'vm',
                          hideDelay   : 0,
                          bindToController: true,
                          position: 'top right',
                          autoWrap: false,
                          controller: messageToastController
                        };
                      }]
                    });
                  /* @ngInject */
                  function messageToastController($scope, $log, taskDataService, $mdToast, $rootScope, $mdSidenav, locals, scheduleDataService, userDataService){
                    $scope.notification = locals;
                    $scope.message = locals.message;
                    $scope.title = locals.title;
                    $scope.color = locals.color;
                    $scope.type = locals.type;
                    $scope.related = locals.related;
                    $scope.uid = locals.uid;

                    function checkForToasts(){
                     $rootScope.$emit('checkForToasts');
                    }

                    $scope.closeToast = function(){
                      // mark notification read
                      firebase.database().ref('users').child($rootScope.userID).child('notifications').child($scope.uid).child('read').set(true);
                      $mdToast.hide()
                      .then(function(){
                        $mdToast.visible = false;
                        checkForToasts();
                      });
                    }

                    $scope.openReminder = function(){
                      // mark notification read
                      firebase.database().ref('users').child($rootScope.userID).child('notifications').child($scope.uid).child('read').set(true);
                          return $mdToast.hide()
                          .then(function(){
                            $mdToast.visible = false;
                            $mdSidenav('right').close();
                            $rootScope.$broadcast('triSwitchNotificationTab', 2);
                            $mdSidenav('right').toggle(2);
                            checkForToasts();
                          });
                    }

                    $scope.openTask = function(taskID){
                      // mark notification read
                      firebase.database().ref('users').child($rootScope.userID).child('notifications').child($scope.uid).child('read').set(true);
                      // $log.info('Reveal Task:');
                      // $log.info(taskID);
                      return $mdToast.hide()
                      .then(function(){
                        return taskDataService.getTask(taskID)
                         .then(function(task){
                         // $log.info('Have task for ID:' + task.uid);
                         //    $log.info(task);

                             // convert our due date into a date object for md-date-picker
                             if (_.has(task, 'info.duedate')) {
                                 task.info.duedate = new Date(task.info.duedate);
                             }
                             // send it to our dialog
                             $mdSidenav('right').close();
                             taskDataService.taskDialog(task, 0);
                         });
                       });
                      }// openTask
                  }
              }])

              // configure dropbox file picker
              // https://github.com/geojacobm6/angular-dropbox-box-picker
              .config(['DropBoxSettingsProvider', function(DropBoxSettingsProvider) {
                    // Configure the options
                      DropBoxSettingsProvider.configure({
                          linkType: 'preview',//dropbox link type
                          multiselect: false,
                          extensions: ['images', 'audio', 'video', 'documents','text']
                        });
                  }])

            //Configure Hotkeys
            .config(function(hotkeysProvider) {
                hotkeysProvider.includeCheatSheet = true;
            })

            // Configure embedly
            .config(['embedlyServiceProvider', function(embedlyServiceProvider) {
                embedlyServiceProvider.setKey('25aeb3a109ff4ddfa40153bbeff5b244');
            }])

            .config(['IdleProvider', 'KeepaliveProvider', function(IdleProvider, KeepaliveProvider) {
              // configure Idle settings
              IdleProvider.idle(1800); // in seconds
              IdleProvider.timeout(3600); // in seconds
              KeepaliveProvider.interval(20); // in seconds
            }])
            // decorates firebaseArray and firebaseObject so they add connections to the global list for destruction on logout
            .config(decorateFirebase)


            // create a constant for languages so they can be added to both triangular & translate
            .constant('APP_LANGUAGES', [{
                name: 'LANGUAGES.CHINESE',
                key: 'zh'
            }, {
                name: 'LANGUAGES.ENGLISH',
                key: 'en'
            }, {
                name: 'LANGUAGES.FRENCH',
                key: 'fr'
            }, {
                name: 'LANGUAGES.PORTUGUESE',
                key: 'pt'
            }])

            // set a constant for the API we are connecting to
            .constant('API_CONFIG', {
                // 'url': 'http://triangular-api.oxygenna.com/'
            })

            /* @ngInject */
            .run(function($window, teamDataService, $q, $log, kanbanService, triLoaderService, $timeout, gateService, authFactory, timerDataService,$mdDateLocale, $rootScope, $state, $firebaseAuth, $stateParams, clientDataService, userDataService, messagingService, localStorageService, triMenu, leadDataService, $mdDialog, $mdToast){
              // Make sure we aren't throwing dozens of passive event listener warnings

              document.addEventListener('touchstart', function(){}, {passive: false})

              // Load up our login message and offline/online status
              var statusRef = firebase.database().ref('/appState/currentState');
              statusRef.on('value', function(snapshot){
                var adminjaStatus = snapshot.val();
                if(adminjaStatus.adminjaVersion != adminjaVersion){
                  alert('Your copy of Adminja is out of date. Please refresh your browser to download the latest version.');
                } else {
                  // alert('Adminja is up to date');
                }
              });


                $rootScope.adminjaEnv = adminjaEnv;
                // make sure we already have a dateformat setting BEFORE we pull our user.
                // ensures that no date appears unformated
                $rootScope.settings = {};
                $rootScope.settings.dateFormat = 'us',

                // Initialize Sentry. Ignore specific errors entirely.
                // https://stackoverflow.com/questions/61651440/prevent-sentry-io-from-logging-server-error-codes
                Sentry.init({
                  dsn: 'https://7f40008046d64e03b90c10c16964599f@o69409.ingest.sentry.io/152362',
                  maxBreadcrumbs: 50,
                  debug: false,
                  ignoreErrors: [
                  '[$rootScope:inprog] null already in progress',
                  'ResizeObserver loop limit exceeded'
                  ]
                });




                // Every ime the client Menu is built, we
                // want to refresh our clientTeams array AFTER it's done
                // Since we are trying to get service to talk to each other
                // Using events got us around lots of gnarly stuff
                // The initial event that triggers this is at the end of clientDataService.setupWorkspaceMenu
                $rootScope.$on('clientMenuBuilt', function(){
                    // $log.info('TeamDataService Initializing');
                    teamDataService.init();
                })


                authFactory.$onAuthStateChanged(function(authData){
                  // $log.info('authStateChanged', authData);
                  // if we are really logged in - set everything up
                  if(authData){
                    // $log.info('logged in');
                    // if we are logged in and we aren't on registration page
                    var pass = true

                    // Count this session
                    // apparently this gets triggered for some unauthenticated sessions despite if(authData) above?
                    if(_.has(authData, 'uid')){
                      userDataService.count(authData.uid, 'sessions', 1)
                    }

                    if(_.has($rootScope, 'toState')){
                        if ($rootScope.toState.name == 'authentication.registration' || $rootScope.toState.name == 'authentication.confirmation'){
                          pass = false
                        }
                    }


                    if (authData && pass){
                      $rootScope.emailVerified = false;

                      var signupDate = moment(authData.metadata.creationTime),
                          now = moment(),
                          timeSinceSignup = moment(now).diff(signupDate, 'hours');

                          // Check for confirmed email and throw dialog to do so if they haven't yet
                        if (authData.emailVerified) {
                           // console.log('User\'s Email has been verified');
                           $rootScope.emailVerified = true;
                         }
                         // only nag if it's been more than 1 day since signup
                         else if(timeSinceSignup > 24){
                           console.log('User\'s Email needs verified');
                           $rootScope.emailVerified = false;
                           $rootScope.emailVerificationTimeout = true;
                           // display md-dialog with button to request email
                           // ONLY if not registering (we don't want to throw this immediately after registration on top of the confirmation page)
                           if(!$rootScope.isRegistering){
                            var request = $mdDialog.confirm()
                                     .title('You\'re email address has not been confirmed.')
                                     .textContent('Please check your email and confirm your account by clicking the link.')
                                     .ariaLabel('Email Confirmation')
                                     .ok('Please send me the email again')
                                     .cancel('Return to Login');

                               $timeout(function(){
                                 $mdDialog.show(request).then(function() {
                                   // send the verification request
                                    authData.sendEmailVerification();
                                    // Let them know what's happened and what to do
                                    $mdDialog.show(
                                          $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(false)
                                            .title('Confirmation email sent')
                                            .textContent('Please check your email inbox for further instructions and then login again.')
                                            .ariaLabel('Confirmation Email Sent')
                                            .ok('Got it!')
                                        ).then(function(){
                                            if($state.current.name == 'authentication.login'){
                                              firebase.auth().signOut().then(function() {
                                                 location.reload();
                                               }, function(error) {
                                                 location.reload();
                                               });
                                            } else {
                                              firebase.auth().signOut().then(function() {
                                                 $state.go('authentication.login');
                                               }, function(error) {
                                                 $state.go('authentication.login');
                                               });

                                            }
                                        });

                                 }, function() {
                                   // They clicked cancel.
                                   firebase.auth().signOut().then(function() {
                                      location.reload();
                                    }, function(error) {
                                      location.reload();
                                    });
                                 });

                               }, 0);
                           }/// if not registering

                         }// Email confirmation check/prompt

                         // Add our uid to Sentry logs for troubleshooting
                        Sentry.configureScope(function(scope) {
                          scope.setUser({
                            "id": authData.uid
                          });
                        });



                        // Uncomment to test Sentry
                        // Sentry.captureException('test-error');

                    } // if authData
                    if(!authData){
                        // $log.info('Adminja: no user logged in');
                        // $log.info('Attempting to go to: ');
                        // $log.info($rootScope.toState);
                        if(_.has($rootScope, 'toState')){
                          if(_.has($rootScope.toState, 'name') && _.has($rootScope.toState, 'current')){
                              if($rootScope.toState.name != 'authentication.login' && $rootScope.toState.name != 'authentication.registration' && $rootScope.toState.current.name != 'authentication.confirmation'){
                                $log.info('Not trying to access authentication. Should Go to login.');
                                $state.go('authentication.login'); // go to login
                                timerDataService.clearTimerData();
                              }
                            } else {
                              // don't do this! People following invitation links will get a login screen instead.
                              // $state.go('authentication.login');
                            }
                          }
                    }

                    // store authData onto something that's not read only so we can use it to ghost users
                    var ourAuthData = angular.copy(authData);
                    // set this so it always shows
                    $rootScope.showNinjaMenu = true;

                    // If we have logged in as another user, switch to that user
                    if(localStorageService.get('ghostUser')){
                      var ghostUser = localStorageService.get('ghostUser');
                      ourAuthData.email = ghostUser.email;
                      ourAuthData.uid = ghostUser.uid;
                    }

                      $rootScope.userID = ourAuthData.uid;

                      // initialize our leadDataService
                      leadDataService.getLeadBoard($rootScope.userID);

                      // setup listener for rebuilding menu
                      $rootScope.$on('workspacesRefreshed', function(){
                        clientDataService.setupWorkspaceMenu();
                      })



                      // Initialize the timer service
                      timerDataService.init();

                        // Since it doesn't have a "module" of it's own, prep the "All Workspaces" nested main menu now
                        var allWorkspacesMenu = {
                             name: 'Global Views',
                             icon: 'fa fa-eye',
                             // svgicon: '/assets/images/icons/all-workspaces-alt2.svg',
                             type: 'dropdown',
                             state: 'triangular.allWorkspaces', // dummy state that just doesn't exist but this works for our purposes
                             priority: 3,
                             open: false,
                             children: []
                         }


                        var calendarMenu =  {
                            name: 'Task Calendar',
                            state: 'triangular.calendar',
                            type: 'link',
                            icon: 'zmdi zmdi-calendar-alt',
                            priority: 2.0
                        };


                      allWorkspacesMenu.children.push(calendarMenu);

                      var manageMenu = {
                           name: 'Manage',
                           icon: 'fa fa-gears',
                           // svgicon: '/assets/images/icons/all-workspaces-alt2.svg',
                           type: 'dropdown',
                           state: 'triangular.manage', // dummy state that just doesn't exist but this works for our purposes
                           priority: 11.0,
                           open: false,
                           children: []
                       }


                       var manageWorkspacesMenu =    {
                           name: 'Workspaces',
                           state: 'triangular.workspaces-manager',
                           icon: 'zmdi zmdi-folder-outline',
                           // svgicon: '/assets/images/icons/all-workspaces-alt2.svg',
                           type: 'link',
                           priority: 1
                         }

                         var manageTeamsMenu =    {
                            name: 'Teams',
                            state: 'triangular.manage-team',
                            icon: 'fa fa-users',
                            type: 'link',
                            priority: 2
                           }

                           var customFormsMenu = {
                              name: 'Forms',
                              icon: 'zmdi zmdi-format-subject',
                              type: 'link',
                              state: 'triangular.custom-forms',
                              priority: 3
                            };

                           var manageAccountMenu =    {
                              name: 'Account',
                              state: 'authentication.profile',
                              icon: 'fa fa-user',
                              type: 'link',
                              priority: 4
                             }

                           manageMenu.children.push(manageWorkspacesMenu);
                           manageMenu.children.push(manageTeamsMenu);
                           manageMenu.children.push(manageAccountMenu);
                           manageMenu.children.push(customFormsMenu);
                           triMenu.addMenu(manageMenu);



                           if(!$rootScope.helpMenu){
                               var helpMenu = {
                                    name: 'Guides & Resources',
                                    icon: 'fa fa-life-ring',
                                    type: 'help',
                                    state: 'triangular.help', // dummy state that just doesn't exist but this works for our purposes
                                    priority: 81,
                                    color: 'orange'
                                }

                                $rootScope.helpMenu = true;
                                triMenu.addMenu(helpMenu);
                           }

                     // Initialize MessagingService
                     // ONLY if we aren't logged in as a ghost user and ONLY if we aren't registering


                       if(firebase.messaging.isSupported() && !localStorageService.get('ghostUser') && !$state.is('authentication.registration')){
                        messagingService.init();

                        var messaging = firebase.messaging();
                           // in case a token is refreshed, let's get it.
                           messaging.onTokenRefresh(function() {
                             messageingService.refreshToken();
                           });
                        }// messaging.onMessage

                      }// if !ghostUser

                }); // onAuthStateChanged


                $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                    // $log.info('$stateChangeStart');
                    // Putting our state on rootscope so we can access all of it's values when checking for login redirects in our .run loop
                    // SEE: https://stackoverflow.com/questions/24895908/how-do-return-the-state-current-name-from-ui-router-statechange/27073618
                    // $log.debug(toState);
                    // $log.debug(fromState);
                    $rootScope.toState = toState;
                    userpilot.track('Visited: ' + toState.name);
                    // $log.debug('$stateChangeStart $stateParams');
                    // $log.debug($stateParams);

                    // Kill non-global dialogs if we navigate to a different route
                    $rootScope.$on('$routeChangeStart', function(event, next, current) {
                      $mdDialog.cancel();
                    });

                    // if asking for login, just go there.
                    var isLogin = toState.name === "authentication.login";
                    if(isLogin){
                       return; // no need to redirect
                    }


                    var isRegistration = toState.name === "authentication.registration";
                    if(isRegistration){
                      $log.info('asking for Registration. Passing through.');
                      $rootScope.disableMessaging = true;
                       return; // no need to redirect
                    } else {
                      delete $rootScope.disableMessaging;
                    }

                    // Otherwise, if logged in, go to route, if logged out, go to login
                   if($rootScope.userID){
                    // $log.info('we has a user. they can pass through');
                        return
                   } else {
                      // $log.info('Looking for authentication');
                      $state.go('authentication.login'); // go to login
                   }

                });

                // store last state's URL so Login can use to redirect back to desired URL after login
                $rootScope.$on('$locationChangeStart', function(event, current, previous){
                  // store previousURL so we can redirect to last known page on login
                  localStorageService.set('previousURL', previous);
                });
                $rootScope.$on('$locationChangeSuccess', function(event, current, previous) {
                    if($window.userpilot){
                      $window.userpilot.reload();
                    }

                    // if refresh flag has been set on a previous URL, let's refresh
                    if($rootScope.showRefresh){
                      $rootScope.showRefresh = false;
                      location.reload();
                    }

                      delete teamDataService.filteredMember;
                      delete teamDataService.filteredMemberName;

                   });

                $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){
                  if($window.userpilot){
                    $window.userpilot.reload();
                  }
                  userDataService.trackEvent('navigate-to-' + toState.name);
                    // Force appcues trigger after delay...to acommodate it's failure at fireing on locationchange success
                  // if the account is cancelled, and we aren't on login, we need to throw up our modal
                  if((!$rootScope.globalDialogUp && $rootScope.cancelled || $rootScope.paused) && toState.name != 'authentication.login' && toState.name != 'authentication.cancel' ){

                    if($rootScope.cancelled){
                      var thisTitle = "We're sorry. But your account has been cancelled.";
                    }
                    if($rootScope.paused){
                      var thisTitle = "Your Adminja account has been paused at your request.";
                    }
                    if($rootScope.cancelled){
                      var thisMessage = "It may be because you requested we close it, or your trial expired without a valid payment method."
                    }
                    if($rootScope.paused){
                      var thisMessage = "You will incur no additional charges."
                    }
                    // $state.go('authentication.profile', {selectedTab: 3});
                    $mdDialog.show({
                        controller: 'subscriptionDialogController', // see below
                        controllerAs: 'vm',
                        // bindToController: true,
                        templateUrl: 'app/app-services/gateService/subscription-dialog.tmpl.html',
                        locals: {
                          thisTitle: thisTitle,
                          message: thisMessage
                        },
                        focusOnOpen: true,
                        clickOutsideToClose: false,
                        fullscreen: true
                    });
                  }


                    // console.timeEnd('StateChange');
                    // Remove hover on the left sidebar after state change
                    // it was sticking open on mobile.
                    // $('.triangular-sidenav-left').removeClass('hover');
                    // debugger;
                    // triLoaderService.setLoaderActive(false);

                });

                // If any states yield an error - send it to console so we can see it
                $rootScope.$on('$stateChangeError',
                function(event, toState, toParams, fromState, fromParams, error){
                    $log.info('$stateChangeError');
                    // console.log('Event:');
                    // console.log('event', event);
                    // console.log('fromState:');
                    // console.log(fromState);
                    // console.log('toState:');
                    // console.log(toState);
                    // console.log('fromParams:');
                    // console.log(fromParams);
                    // console.log('toParams:');
                    // console.log(toParams);
                    console.log('Error:');
                    console.log('Error:', error);
                    $state.go('authentication.login');
                });


            // If any of our resolves trigger an error, send to login
                $rootScope.$on('$routeChangeError', function(event, next, previous, error){
                    console.log('$routeChangeError');
                    console.log(error);
                    if (error = "AUTH_REQUIRED"){
                        console.log('Error in Auth');
                        $state.go('authentication.login');
                    }
                });

                $rootScope.noteColors = ['#fff', '#fffde7', '#e8f5e9', '#e1f5fe', '#fce4ec', '#ede7f6']

                // this needs turned into an injectable service.
                $rootScope.clientColors  = [
                    // Desaturated
                    '#aba9a9',
                    '#888484',
                    '#787575',
                    '#595757',
                    '#4a4848',
                    '#3a3939',
                    '#2b2a2a',

                    // Yellow
                    '#fcfcd1',
                    '#f8f89c',
                    '#f0f020',
                    '#e2e20f',
                    '#c5c50d',
                    '#a9a90b',
                    '#8c8c09',

                    // Orange
                    '#ffdebd',
                    '#ffc285',
                    '#ff9e3d',
                    // '#ff8f1f',
                    // '#ff8000',
                    '#e07100',
                    '#c26100',
                    '#a35200',
                    '#854300',

                    // Red
                    '#f0b3be',
                    '#e5778b',
                    '#e05e75',
                    '#db445f',
                    '#bd2440',
                    '#8a1b2e',
                    '#850000',

                    // purple
                    '#e5c9fa',
                    '#d7adf7',
                    '#ca91f4',
                    '#bd75f1',
                    '#af59ee',
                    '#a23eec',
                    '#9422e9',

                    // Blue
                    '#bdbdff',
                    '#8585ff',
                    '#0000ff',
                    '#0000e0',
                    '#0000c2',
                    '#0000a3',
                    '#000085',

                    // Light BLue
                    '#badffc',
                    '#84c6f9',
                    '#40a6f6',
                    '#0a79d1',
                    '#0868b3',
                    '#075796',
                    '#064679',

                    //Cyan
                    '#a0e9e2',
                    '#72dfd4',
                    '#2cbfb1',
                    '#208d83',
                    '#1b746c',
                    '#155b55',
                    '#0f423e',

                    // Green
                    '#8eda8e',
                    '#63cc63',
                    '#2a812a',
                    '#226a22',
                    '#1b531b',
                    '#133c13',
                    '#0c250c',


                    // LIght Green
                    '#d7e5be',
                    '#c9dda8',
                    '#bcd492',
                    '#aecb7c',
                    '#a1c366',
                    '#94ba50',
                    '#84a943'
                    ];

                // boardColors contains a different set of greys
                $rootScope.boardColors = [
                    // Desaturated
                    '#eee',
                    '#ddd',
                    '#ccc',
                    '#bbb',
                    '#aaa',
                    '#999',
                    '#888',
                    // yellow
                    '#fcfcd1',
                    '#f8f89c',
                    '#f0f020',
                    '#e2e20f',
                    '#c5c50d',
                    '#a9a90b',
                    '#8c8c09',
                    // Orange
                    '#ffdebd',
                    '#ffc285',
                    '#ff9e3d',
                    // '#ff8f1f',
                    // '#ff8000',
                    '#e07100',
                    '#c26100',
                    '#a35200',
                    '#854300',

                    // Red
                    '#f0b3be',
                    '#e5778b',
                    '#e05e75',
                    '#db445f',
                    '#bd2440',
                    '#8a1b2e',
                    '#850000',

                    // purple
                    '#e5c9fa',
                    '#d7adf7',
                    '#ca91f4',
                    '#bd75f1',
                    '#af59ee',
                    '#a23eec',
                    '#9422e9',

                    // Blue
                    '#bdbdff',
                    '#8585ff',
                    '#0000ff',
                    '#0000e0',
                    '#0000c2',
                    '#0000a3',
                    '#000085',

                    // Light BLue
                    '#badffc',
                    '#84c6f9',
                    '#40a6f6',
                    '#0a79d1',
                    '#0868b3',
                    '#075796',
                    '#064679',

                    //Cyan
                    '#a0e9e2',
                    '#72dfd4',
                    '#2cbfb1',
                    '#208d83',
                    '#1b746c',
                    '#155b55',
                    '#0f423e',

                    // Green
                    '#8eda8e',
                    '#63cc63',
                    '#2a812a',
                    '#226a22',
                    '#1b531b',
                    '#133c13',
                    '#0c250c',


                    // LIght Green
                    '#d7e5be',
                    '#c9dda8',
                    '#bcd492',
                    '#aecb7c',
                    '#a1c366',
                    '#94ba50',
                    '#84a943'
                  ];

                $rootScope.countries = [
                    {"name": "Afghanistan", "code": "AF"},
                    {"name": "Åland Islands", "code": "AX"},
                    {"name": "Albania", "code": "AL"},
                    {"name": "Algeria", "code": "DZ"},
                    {"name": "American Samoa", "code": "AS"},
                    {"name": "AndorrA", "code": "AD"},
                    {"name": "Angola", "code": "AO"},
                    {"name": "Anguilla", "code": "AI"},
                    {"name": "Antarctica", "code": "AQ"},
                    {"name": "Antigua and Barbuda", "code": "AG"},
                    {"name": "Argentina", "code": "AR"},
                    {"name": "Armenia", "code": "AM"},
                    {"name": "Aruba", "code": "AW"},
                    {"name": "Australia", "code": "AU"},
                    {"name": "Austria", "code": "AT"},
                    {"name": "Azerbaijan", "code": "AZ"},
                    {"name": "Bahamas", "code": "BS"},
                    {"name": "Bahrain", "code": "BH"},
                    {"name": "Bangladesh", "code": "BD"},
                    {"name": "Barbados", "code": "BB"},
                    {"name": "Belarus", "code": "BY"},
                    {"name": "Belgium", "code": "BE"},
                    {"name": "Belize", "code": "BZ"},
                    {"name": "Benin", "code": "BJ"},
                    {"name": "Bermuda", "code": "BM"},
                    {"name": "Bhutan", "code": "BT"},
                    {"name": "Bolivia", "code": "BO"},
                    {"name": "Bosnia and Herzegovina", "code": "BA"},
                    {"name": "Botswana", "code": "BW"},
                    {"name": "Bouvet Island", "code": "BV"},
                    {"name": "Brazil", "code": "BR"},
                    {"name": "British Indian Ocean Territory", "code": "IO"},
                    {"name": "Brunei Darussalam", "code": "BN"},
                    {"name": "Bulgaria", "code": "BG"},
                    {"name": "Burkina Faso", "code": "BF"},
                    {"name": "Burundi", "code": "BI"},
                    {"name": "Cambodia", "code": "KH"},
                    {"name": "Cameroon", "code": "CM"},
                    {"name": "Canada", "code": "CA"},
                    {"name": "Cape Verde", "code": "CV"},
                    {"name": "Cayman Islands", "code": "KY"},
                    {"name": "Central African Republic", "code": "CF"},
                    {"name": "Chad", "code": "TD"},
                    {"name": "Chile", "code": "CL"},
                    {"name": "China", "code": "CN"},
                    {"name": "Christmas Island", "code": "CX"},
                    {"name": "Cocos (Keeling) Islands", "code": "CC"},
                    {"name": "Colombia", "code": "CO"},
                    {"name": "Comoros", "code": "KM"},
                    {"name": "Congo", "code": "CG"},
                    {"name": "Congo, The Democratic Republic of the", "code": "CD"},
                    {"name": "Cook Islands", "code": "CK"},
                    {"name": "Costa Rica", "code": "CR"},
                    {"name": "Cote D'Ivoire", "code": "CI"},
                    {"name": "Croatia", "code": "HR"},
                    {"name": "Cuba", "code": "CU"},
                    {"name": "Cyprus", "code": "CY"},
                    {"name": "Czech Republic", "code": "CZ"},
                    {"name": "Denmark", "code": "DK"},
                    {"name": "Djibouti", "code": "DJ"},
                    {"name": "Dominica", "code": "DM"},
                    {"name": "Dominican Republic", "code": "DO"},
                    {"name": "Ecuador", "code": "EC"},
                    {"name": "Egypt", "code": "EG"},
                    {"name": "El Salvador", "code": "SV"},
                    {"name": "Equatorial Guinea", "code": "GQ"},
                    {"name": "Eritrea", "code": "ER"},
                    {"name": "Estonia", "code": "EE"},
                    {"name": "Ethiopia", "code": "ET"},
                    {"name": "Falkland Islands (Malvinas)", "code": "FK"},
                    {"name": "Faroe Islands", "code": "FO"},
                    {"name": "Fiji", "code": "FJ"},
                    {"name": "Finland", "code": "FI"},
                    {"name": "France", "code": "FR"},
                    {"name": "French Guiana", "code": "GF"},
                    {"name": "French Polynesia", "code": "PF"},
                    {"name": "French Southern Territories", "code": "TF"},
                    {"name": "Gabon", "code": "GA"},
                    {"name": "Gambia", "code": "GM"},
                    {"name": "Georgia", "code": "GE"},
                    {"name": "Germany", "code": "DE"},
                    {"name": "Ghana", "code": "GH"},
                    {"name": "Gibraltar", "code": "GI"},
                    {"name": "Greece", "code": "GR"},
                    {"name": "Greenland", "code": "GL"},
                    {"name": "Grenada", "code": "GD"},
                    {"name": "Guadeloupe", "code": "GP"},
                    {"name": "Guam", "code": "GU"},
                    {"name": "Guatemala", "code": "GT"},
                    {"name": "Guernsey", "code": "GG"},
                    {"name": "Guinea", "code": "GN"},
                    {"name": "Guinea-Bissau", "code": "GW"},
                    {"name": "Guyana", "code": "GY"},
                    {"name": "Haiti", "code": "HT"},
                    {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
                    {"name": "Holy See (Vatican City State)", "code": "VA"},
                    {"name": "Honduras", "code": "HN"},
                    {"name": "Hong Kong", "code": "HK"},
                    {"name": "Hungary", "code": "HU"},
                    {"name": "Iceland", "code": "IS"},
                    {"name": "India", "code": "IN"},
                    {"name": "Indonesia", "code": "ID"},
                    {"name": "Iran, Islamic Republic Of", "code": "IR"},
                    {"name": "Iraq", "code": "IQ"},
                    {"name": "Ireland", "code": "IE"},
                    {"name": "Isle of Man", "code": "IM"},
                    {"name": "Israel", "code": "IL"},
                    {"name": "Italy", "code": "IT"},
                    {"name": "Jamaica", "code": "JM"},
                    {"name": "Japan", "code": "JP"},
                    {"name": "Jersey", "code": "JE"},
                    {"name": "Jordan", "code": "JO"},
                    {"name": "Kazakhstan", "code": "KZ"},
                    {"name": "Kenya", "code": "KE"},
                    {"name": "Kiribati", "code": "KI"},
                    {"name": "Korea, Democratic People'S Republic of", "code": "KP"},
                    {"name": "Korea, Republic of", "code": "KR"},
                    {"name": "Kuwait", "code": "KW"},
                    {"name": "Kyrgyzstan", "code": "KG"},
                    {"name": "Lao People'S Democratic Republic", "code": "LA"},
                    {"name": "Latvia", "code": "LV"},
                    {"name": "Lebanon", "code": "LB"},
                    {"name": "Lesotho", "code": "LS"},
                    {"name": "Liberia", "code": "LR"},
                    {"name": "Libyan Arab Jamahiriya", "code": "LY"},
                    {"name": "Liechtenstein", "code": "LI"},
                    {"name": "Lithuania", "code": "LT"},
                    {"name": "Luxembourg", "code": "LU"},
                    {"name": "Macao", "code": "MO"},
                    {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
                    {"name": "Madagascar", "code": "MG"},
                    {"name": "Malawi", "code": "MW"},
                    {"name": "Malaysia", "code": "MY"},
                    {"name": "Maldives", "code": "MV"},
                    {"name": "Mali", "code": "ML"},
                    {"name": "Malta", "code": "MT"},
                    {"name": "Marshall Islands", "code": "MH"},
                    {"name": "Martinique", "code": "MQ"},
                    {"name": "Mauritania", "code": "MR"},
                    {"name": "Mauritius", "code": "MU"},
                    {"name": "Mayotte", "code": "YT"},
                    {"name": "Mexico", "code": "MX"},
                    {"name": "Micronesia, Federated States of", "code": "FM"},
                    {"name": "Moldova, Republic of", "code": "MD"},
                    {"name": "Monaco", "code": "MC"},
                    {"name": "Mongolia", "code": "MN"},
                    {"name": "Montserrat", "code": "MS"},
                    {"name": "Morocco", "code": "MA"},
                    {"name": "Mozambique", "code": "MZ"},
                    {"name": "Myanmar", "code": "MM"},
                    {"name": "Namibia", "code": "NA"},
                    {"name": "Nauru", "code": "NR"},
                    {"name": "Nepal", "code": "NP"},
                    {"name": "Netherlands", "code": "NL"},
                    {"name": "Netherlands Antilles", "code": "AN"},
                    {"name": "New Caledonia", "code": "NC"},
                    {"name": "New Zealand", "code": "NZ"},
                    {"name": "Nicaragua", "code": "NI"},
                    {"name": "Niger", "code": "NE"},
                    {"name": "Nigeria", "code": "NG"},
                    {"name": "Niue", "code": "NU"},
                    {"name": "Norfolk Island", "code": "NF"},
                    {"name": "Northern Mariana Islands", "code": "MP"},
                    {"name": "Norway", "code": "NO"},
                    {"name": "Oman", "code": "OM"},
                    {"name": "Pakistan", "code": "PK"},
                    {"name": "Palau", "code": "PW"},
                    {"name": "Palestinian Territory, Occupied", "code": "PS"},
                    {"name": "Panama", "code": "PA"},
                    {"name": "Papua New Guinea", "code": "PG"},
                    {"name": "Paraguay", "code": "PY"},
                    {"name": "Peru", "code": "PE"},
                    {"name": "Philippines", "code": "PH"},
                    {"name": "Pitcairn", "code": "PN"},
                    {"name": "Poland", "code": "PL"},
                    {"name": "Portugal", "code": "PT"},
                    {"name": "Puerto Rico", "code": "PR"},
                    {"name": "Qatar", "code": "QA"},
                    {"name": "Reunion", "code": "RE"},
                    {"name": "Romania", "code": "RO"},
                    {"name": "Russian Federation", "code": "RU"},
                    {"name": "RWANDA", "code": "RW"},
                    {"name": "Saint Helena", "code": "SH"},
                    {"name": "Saint Kitts and Nevis", "code": "KN"},
                    {"name": "Saint Lucia", "code": "LC"},
                    {"name": "Saint Pierre and Miquelon", "code": "PM"},
                    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
                    {"name": "Samoa", "code": "WS"},
                    {"name": "San Marino", "code": "SM"},
                    {"name": "Sao Tome and Principe", "code": "ST"},
                    {"name": "Saudi Arabia", "code": "SA"},
                    {"name": "Senegal", "code": "SN"},
                    {"name": "Serbia and Montenegro", "code": "CS"},
                    {"name": "Seychelles", "code": "SC"},
                    {"name": "Sierra Leone", "code": "SL"},
                    {"name": "Singapore", "code": "SG"},
                    {"name": "Slovakia", "code": "SK"},
                    {"name": "Slovenia", "code": "SI"},
                    {"name": "Solomon Islands", "code": "SB"},
                    {"name": "Somalia", "code": "SO"},
                    {"name": "South Africa", "code": "ZA"},
                    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
                    {"name": "Spain", "code": "ES"},
                    {"name": "Sri Lanka", "code": "LK"},
                    {"name": "Sudan", "code": "SD"},
                    {"name": "Suriname", "code": "SR"},
                    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
                    {"name": "Swaziland", "code": "SZ"},
                    {"name": "Sweden", "code": "SE"},
                    {"name": "Switzerland", "code": "CH"},
                    {"name": "Syrian Arab Republic", "code": "SY"},
                    {"name": "Taiwan, Province of China", "code": "TW"},
                    {"name": "Tajikistan", "code": "TJ"},
                    {"name": "Tanzania, United Republic of", "code": "TZ"},
                    {"name": "Thailand", "code": "TH"},
                    {"name": "Timor-Leste", "code": "TL"},
                    {"name": "Togo", "code": "TG"},
                    {"name": "Tokelau", "code": "TK"},
                    {"name": "Tonga", "code": "TO"},
                    {"name": "Trinidad and Tobago", "code": "TT"},
                    {"name": "Tunisia", "code": "TN"},
                    {"name": "Turkey", "code": "TR"},
                    {"name": "Turkmenistan", "code": "TM"},
                    {"name": "Turks and Caicos Islands", "code": "TC"},
                    {"name": "Tuvalu", "code": "TV"},
                    {"name": "Uganda", "code": "UG"},
                    {"name": "Ukraine", "code": "UA"},
                    {"name": "United Arab Emirates", "code": "AE"},
                    {"name": "United Kingdom", "code": "GB"},
                    {"name": "United States", "code": "US"},
                    {"name": "United States Minor Outlying Islands", "code": "UM"},
                    {"name": "Uruguay", "code": "UY"},
                    {"name": "Uzbekistan", "code": "UZ"},
                    {"name": "Vanuatu", "code": "VU"},
                    {"name": "Venezuela", "code": "VE"},
                    {"name": "Viet Nam", "code": "VN"},
                    {"name": "Virgin Islands, British", "code": "VG"},
                    {"name": "Virgin Islands, U.S.", "code": "VI"},
                    {"name": "Wallis and Futuna", "code": "WF"},
                    {"name": "Western Sahara", "code": "EH"},
                    {"name": "Yemen", "code": "YE"},
                    {"name": "Zambia", "code": "ZM"},
                    {"name": "Zimbabwe", "code": "ZW"}
                    ];

                    $rootScope.currencies = [
                      {id: 1, symbol:"$",code:"USD",description:"US Dollar",paypal: true,stripe: true},
                      {id: 2, symbol:"$",code:"AUD",description:"Australian Dollar",paypal: true,stripe: true},
                      {id: 3, symbol:"$",code:"CAD",description:"Canadian Dollar",paypal: true,stripe: true},
                      {id: 4, symbol:"$",code:"NZD",description:"New Zealand Dollar",paypal: true,stripe: true},
                      {id: 5, symbol:"$",code:"MXN",description:"Mexican Peso",paypal: true,stripe: true},
                      {id: 6, symbol:"&pound;",code:"GBP",description:"Pound Sterling",paypal: true,stripe: true},
                      {id: 7, symbol:"&euro;",code:"EUR",description:"Euro",paypal: true,stripe: true},
                      {id: 8, symbol:"CHF",code:"CHF",description:"Swedish franc",paypal: true,stripe: true},
                      {id: 9, symbol:"Kr",code:"DKK",description:"Danish Kroner",paypal: true,stripe: true},
                      {id: 10, symbol:"R$",code:"BRL",description:"Brazilian Real",paypal: true,stripe: true},
                      {id: 11, symbol:"HK$",code:"HKD",description:"Hong Kong Dollar",paypal: true,stripe: true},
                      {id: 12, symbol:"&#x20B9;",code:"INR",description:"Rupee",paypal: false,stripe: false},
                      {id: 13, symbol:"&#x20a3;",code:"FF",description:"Franc",paypal: false,stripe: false},
                      {id: 14, symbol:"ZAR",code:"ZAR",description:"South African Rands",paypal: false,stripe: false},
                      {id: 15, symbol:"&#8358;",code:"NGN",description:"Nigerian Naira",paypal: false,stripe: false}
                      ]

                    $rootScope.loaderMessages = [
                      // 'Thank you for using Adminja, we appreciate it!',
                      // 'Are you ready to Adminja today?',
                      // 'Time to kick it up a level!',
                      'Get ready to drop kick this day!',
                      // 'Tasks happen, be an Adminja!',
                      // 'Please Adminja responsibly.',
                      'With great power...comes a great electricity bill.',
                      // 'After Tuesday even the calendar goes W T F',
                      'An apple day keeps anyone away if you throw it hard enough.',
                      'Life is short, eat the cake.',
                      'Cupcakes are muffins that believed in miracles.',
                      // 'We\'ll be back in just a minute, but if we\'re not.. Read this message again.',
                      // 'Deja Poo: The feeling that you\'ve heard this crap before.',
                      // 'Awesomeness: Just one of the services I offer.',
                      'We\'re not lazy. We\'re just on our energy saving mode.',
                      // 'Coffee kicking in 3...2...1...',
                      // 'We\'re all in this together!',
                      // 'You can do this!',
                      // 'You got this!',
                      // 'Let\'s Rock and Roll!',
                      'In case no one has told you lately, You are amazing!',
                      // 'We like you!',
                      'Remember to get up and stretch once in a while.',
                      'Take a minute and breathe...',
                      'Take a second and close your eyes. They need rest too...',
                      'Positive Mind. Positive Vibes. Positive Life.',
                      'Mistakes just mean you are trying.',
                      'Mistakes happen, eat a cupcake. ',
                      // 'Work Hard. Play Harder.',
                      // 'Work Hard. Dream Big.',
                      'May your day be as wonderful as you are!',
                      'Keep your head up and eye on the prize.',
                      'Life is beautiful. Enjoy the ride!',
                      'Today is a great day to have a great day!',
                      '"Live and Let Live" <br><span class="cite">-Scottish Proverb</span>',
                      '"Life is short. Live Passionately." <br><span class="cite">-Unknown</span>',
                      '"The trouble is you think you have time." <br><span class="cite">-Buddha</span>',
                      '"Whatever you are, be a good one." <br><span class="cite">-Abraham Lincoln</span>',
                      '"Be the change you wish to see in the world<br><span class="cite">- Gandhi</span>',
                      '"Life is ten percent what happens to you and ninety percent how you respond to it." <br><span class="cite">-Lou Holtz</span>',
                      '"Love the life you live, and live the life you love." <br><span class="cite">-Bob Marley</span>',
                      '"Try and fail, but never fail to try." <br><span class="cite">- Jared Leto</span>',
                      '"To succeed in life, you need two things: ignorance and confidence." <br><span class="cite">- Mark Twain</span>',
                      '"Too much of a good thing can be wonderful." <br><span class="cite">- Mae West</span>',
                      'A diamond is a lump of coal that did well under pressure.',
                      'One day...I\'m gonna make the onions cry.',
                      '"I failed my way to success" <br><span class="cite">- Thomas Edison</span>',
                      'Don\'t raise your voice, improve your argument.',
                      'You can\'t live a positive life with a negative mind.',
                      'Be who you want to be, not what others see.',
                      'Take risks and conquer your fears.',
                      'What would you attempt to do if you knew you could not fail?',
                      'You are enough.',
                      'You are beautiful.',
                      'Take a deep breath and enjoy your life',
                      'Every day is a new beginning.',
                      'If plan \'A\' didn\'t work, the alphabet has 25 more letters.',
                      'You have the power to make every day a bright day.',
                      'You can\'t make a rainbow without a little rain.',
                      'If opportunity doesn\'t knock, build a door.',
                      'The secret of getting ahead is getting started.',
                      'A goal without a plan is just a wish.',
                      'You are stronger than you think.',
                      'Don\'t regret the past, just learn from it.',
                      'Don\'t count the days. Make the days count.',
                      'If there is no struggle, there is no progress.',
                      'Lose an hour in the morning and spend all day looking for it.',
                      'To improve is to change. To be perfect is to change often.',
                      'If you are too busy to laugh, you are too busy.'

                    ];

                    var randomNumber = Math.floor(Math.random()* $rootScope.loaderMessages.length);
                      var selectedMessage =  $rootScope.loaderMessages[randomNumber];
                      // $rootScope.loaderMessage = selectedMessage;


                // this needs turned into an injectable service.

                // $rootScope.tags  = [
                //         {
                //             name: 'email'
                //         },
                //         {
                //             name: 'scheduling'
                //         },
                //         {
                //             name: 'reservations'
                //         },
                //         {
                //             name: 'shopping'
                //         },
                //         {
                //             name: 'social media'
                //         },
                //         {
                //             name: 'blog'
                //         }
                //     ];



                switch ($rootScope.adminjaEnv){
                  case 'production':
                    // $log.info('using chargeBee live');
                    // Chargebee Live Settings
                    $rootScope.chargebeeSettings={
                        checkoutURL: 'https://adminja.chargebee.com/hosted_pages/plans/',
                        site: 'adminja',
                        api_key: 'live_Ftcucu8ysV7C05ctwUIcdRj8WjTUl9fdSfcd',
                        customerPortalURL : "https://adminja.chargebeeportal.com"
                    }// Chargebee Live Settings

                    $rootScope.functionsURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net";
                    $rootScope.functionsKey = "hZPEbfkrPqyTimY4dbgE";
                    $rootScope.adminjaURL = "https://www.adminja.co";
                    $rootScope.froalaKey = "pe1G2wD1I2A1A1E7C7nDe1YRTYKd1Dd1f1JVVD1VJKKYLMPvC2B1F1G1B4D4E3B1B8C6==";
                  break;
                  case 'staging':
                    // Chargebee Test Settings
                    // $log.info('using chargeBee test');
                    $rootScope.chargebeeSettings={
                        checkoutURL: 'https://adminja-test.chargebee.com/hosted_pages/plans/',
                        site: 'adminja-test',
                        api_key: 'test_KGUZ0ycdqpizfSxWJylBcdcdsYXlKj5LHt',
                        customerPortalURL : "https://adminja-test.chargebeeportal.com"

                    }// Chargebee Test Settings
                    $rootScope.functionsURL = "https://us-central1-adminja-staging.cloudfunctions.net";
                    $rootScope.functionsKey = "hZPEbfkrPqyTimY4dbgE";
                    $rootScope.adminjaURL = "https://adminja-staging.firebaseapp.com";
                    $rootScope.froalaKey = "pe1G2wD1I2A1A1E7C7nDe1YRTYKd1Dd1f1JVVD1VJKKYLMPvC2B1F1G1B4D4E3B1B8C6==";
                  break;
                };



                    $rootScope.tutorials  = {
                        manageClients: '-KX2nOYyrfzCGLwoHLNe',
                        appPrimer: '-KhboHuMbrk1lmvfz3E6',
                        singleClientNudge: '-KY0SmWv9cg8PK0AGZBe',
                        manageClientProfile: '-KhbrX26R5JHLKtTsvu7',
                        manageClientTaskPanels: '-KYFgFMFvWvlr5t7iGos',
                        manageClientTasks: '-KY0bYzKQpr3AUktyJ4W',
                        timeTracking: '-KY0bYzKQpr3AUktyJ4W',
                        timer: '-KY0bYzKQpr3AUktyJ4W',
                        timerList: '-KY0bYzKQpr3AUktyJ4W',
                        // onboarding 2018
                        gotoWorkspace: '-L3o8VuHsqbSHuKVnaoY',
                        workspaceTabs: '-L41aoiNGJ583BxdBcFs'
                    }


            }); // end run block

          decorateFirebase.$inject = ['$provide'];
          function decorateFirebase($provide){
            // inject the $delegate dependency into our decorator method
                   firebaseDecorator.$inject = ['$delegate'];

                   // Whenever $firebaseArray's and $firebaseObjects are created,
                   // they'll now be tracked by window.openFirebaseConnections
                   $provide.decorator("$firebaseArray", firebaseDecorator);
                   $provide.decorator("$firebaseObject", firebaseDecorator);

                   function firebaseDecorator ($delegate) {
                       return function (ref) {
                           var list = $delegate(ref);
                           window.openFirebaseConnections.push(list);
                           return list;
                       };
                   }
          }


    }
)();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('LoaderController', LoaderController);

    /* @ngInject */
    function LoaderController(triSettings, $scope, $log, $rootScope) {
        // $log.info('loaderController');
        var vm = this;
        vm.triSettings = triSettings;

    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('LeftSidenavController', LeftSidenavController)
        .controller('onboardingController', onboardingController);


    /* @ngInject */
    function LeftSidenavController(triSettings, triLayout, $mdBottomSheet, userDataService, $log, $timeout, $mdUtil, $mdSidenav) {
        var vm = this;
        vm.layout = triLayout.layout;
        vm.user = userDataService.user;

        vm.sidebarInfo = {
            appName: triSettings.name,
            appLogo: triSettings.logo
        };

        // Functions
        vm.toggleIconMenu = toggleIconMenu;
        vm.closeSideNav = closeSideNav;
        vm.openOnboarding = openOnboarding;
        vm.onboardingProgress = onboardingProgress;




        function onboardingProgress(){
            // Should go through user's onboarding items and calculate % complete and return that
            var result = 80
            return result
        }

        function openOnboarding(event){

            $mdBottomSheet.show({
                  templateUrl: '/app/layouts/leftsidenav/onboardingBottomSheet.tmpl.html',
                  controller: 'onboardingController'
                }).then(function(event) {
                  // $scope.alert = clickedItem['name'] + ' clicked!';
                }).catch(function(error) {
                  // User clicked outside or hit escape
                });
        }// openOnboarding






        ////////////
        function toggleIconMenu() {
            if (vm.layout.sideMenuSize ==='icon'){
                // changing to full
                triLayout.setOption('sideMenuSize', 'full');
                userDataService.changeUserSetting('pinMenu', true);
            } else {
                // changing to icon
                triLayout.setOption('sideMenuSize', 'icon');
                userDataService.changeUserSetting('pinMenu', false);
            }

        }// toggleIconMenu

        function closeSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-md');
            }
        }

    }// leftSideNavCOntroller

    /* @ngInject */
    function onboardingController($log, $scope, $mdBottomSheet, userDataService, clientDataService){
        $log.info('onboardingController');
        $scope.user = userDataService.user;
        $scope.onboardingItems = [
           { name: 'Complete Your Profile', id: 'profile', icon: 'fa fa-user', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Customize Your Preferences', id: 'preferences' , icon: 'fa fa-gear', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Create a Workspace', id: 'workspace',  instructions: 'Please create a Workspace first', icon: 'zmdi zmdi-folder', flow: '-LPXF4FmSgoX03CI923h', complete: true},
           { name: 'Log Time', id: 'time', instructions: 'Please log some Time first', dependency: 'workspace' , icon: 'zmdi zmdi-time', flow: '-L43TIkB4ZzUDXv9JFpj', complete: true},
           { name: 'Use the Timer', id: 'timer', dependency: 'workspace' , icon: 'zmdi zmdi-timer', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Add a Task', id: 'task', instructions: 'Please create a Task first', dependency: 'workspace' , icon: 'fa fa-check-square-o', flow: '-L43TIkB4ZzUDXv9JFpj', complete: true},
           { name: 'Create a Task List', id: 'tasklist', dependency: 'workspace' , icon: 'fa fa-list-alt', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Schedule tasks with the Calendar', id: 'calendar', dependency: 'task' , icon: 'zmdi zmdi-calendar', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Create a Note List', id: 'notelist', dependency: 'workspace' , icon: 'fa fa-list-alt', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Create a Note', id: 'note', dependency: 'notelist' , icon: 'fa fa-file-text-o', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Email a Task to Adminja', id: 'email', dependency: 'workspace' , icon: 'zmdi zmdi-email', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Batch Create Tasks', id: 'batch', dependency: 'workspace' , icon: 'fa fa-tasks', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Prepare a Time Report', id: 'report', dependency: 'time' , icon: 'zmdi zmdi-print', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Send an Invoice', id: 'invoice', dependency: 'time' , icon: 'zmdi zmdi-receipt', flow: '-L43TIkB4ZzUDXv9JFpj'},
           { name: 'Setup a Team', id: 'team', dependency: 'workspace' , icon: 'fa fa-users', flow: '-L43TIkB4ZzUDXv9JFpj'},
         ];

         $scope.isDependencyResolved = function(selectedItem){
            if(_.has(selectedItem, 'dependency')){
                var dependency = _.find($scope.onboardingItems, function (item) {
                    return item.id == selectedItem.dependency;
                });

                if(dependency.complete){
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
         }//isDependencyResolved

         $scope.completeOnboarding = function(){

            _.each($scope.onboardingItems, function(item){
                item.complete = true;
            });
            // $log.info('updateSettings');
            userDataService.changeUserSetting('onboardingComplete', true);
            userDataService.getLoggedInUser();
            _dcq.push(["identify", {
                email: $scope.user.email,
                tags: ["onBoardingMarkedComplete"]
            }]);

            // // Let heap know who this is
            // heap.identify($scope.user.email);
            // heap.addUserProperties({
            //         'onBoardingMarkedComplete': moment().toISOString()
            //     });

            // if(Appcues){
            //    Appcues.identify($scope.user.uid, {
            //        'onboardingMarkedComplete': moment().toISOString()
            //    });
            //    }

         }// completeOnboarding

         $scope.startFlow = function(item) {
            // if(Appcues){
            //     Appcues.show(item.flow);
            //     $mdBottomSheet.hide();
            // } else {
            //     alert('Cannot show tutorial. Your browser is blocking a script.')
            // }

         };

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('AppFooterController', FooterController);

    /* @ngInject */
    function FooterController(triLayout, triSettings) {
        var vm = this;

        vm.layout = triLayout;
        vm.settings = triSettings;
    }
})();

(function(){
	'use strict';
	angular.module('appServices',['lk-color-chooser', 'firebase'])
})();

(function () {
    'use strict';
    angular.module('appServices')
            .service('userDataService', userDataService);

    /* @ngInject */
    function userDataService($mdToast, $mdDialog, Idle, $window, triLayout, triMenu, $state,  gateService, localStorageService, $q, presenceService, $mdDateLocale, $timeout, $log, $http, $rootScope, $firebaseArray, $firebaseAuth, $firebaseObject, authFactory) {
        var usersRef = firebase.database().ref('users');
        var user = undefined;
        var service = {
            getLoggedInUser: getLoggedInUser,
            getUserByID: getUserByID,
            updateUser: updateUser,
            clearUserData: clearUserData,
            userDialog: userDialog,
            saveNewUser: saveNewUser,
            getUser: getUser,
            logout: logout,
            changeUserSetting: changeUserSetting,
            changeOnboardingFlag: changeOnboardingFlag,
            resetOnboarding: resetOnboarding,
            getGate: getGate,
            getConsent: getConsent,
            hasConsent: hasConsent,
            changeConsent: changeConsent,
            count: count,
            getWeekCounts: getWeekCounts,
            getMonthCounts: getMonthCounts,
            trackEvent: trackEvent
        };

        return service;



        function getWeekCounts(start, end){
          var startWeek = moment(start).isoWeek(),
          // this adjustment is necessary - isoWeek seems to put everything back one
          startWeek = startWeek + 1,
          startWeekYear = moment(start).format('GGGG'),
          queryStart = startWeekYear + '-' + _.padStart(startWeek,2,'0'),
          endWeek = moment(end).isoWeek(),
          // this adjustment is necessary
          endWeek = endWeek + 1,
          endWeekYear = moment(end).format('GGGG'),
          queryEnd = endWeekYear + '-' + _.padStart(endWeek, 2, '0');



          return new Promise(function(resolve, reject){
            var weeksRef = firebase.database().ref('counts/'+ service.user.uid + '/weeks').orderByKey().startAt(queryStart).endAt(queryEnd);
            weeksRef.once('value', function(snapshot){
              var weeks = [];

              // Convert keys to date of week start instead of week number
              // This is the only way to match in charts because 'ww' is wildly incorrect.
              _.each(snapshot.val(), function(value, key){
                var split = key.split("-"),
                    thisYear = split[0],
                    // we have to readjust our week number back so it lines up with actual dates as the browser sees them when we generate a new key below
                    thisWeek = split[1] - 1;

                var newKey = moment().isoWeekYear(thisYear).isoWeek(thisWeek).startOf('week').format('YYYY-MM-DD');
                weeks[newKey] = value;
              });

              return resolve(weeks);
            })
          })
        }// getCounts

        function getMonthCounts(start, end){
          var startMonth = moment(start).format('MM'),
              startMonthYear = moment(start).format('GGGG'),
              queryStart = startMonthYear + '-' + startMonth,
              endMonth = moment(end).format('MM'),
              endMonthYear = moment(end).format('GGGG'),
              queryEnd = endMonthYear + '-' + endMonth;


          return new Promise(function(resolve, reject){
            var monthsRef = firebase.database().ref('counts/'+ service.user.uid + '/months').orderByKey().startAt(queryStart).endAt(queryEnd);

            monthsRef.once('value', function(snapshot){
              // Convert keys to date of week start instead of week number
              var months = snapshot.val();
              return resolve(months);
            })
          })
        }// getCounts

        /////////
        // getUser
        function getUser(){
            return service.user;
        }

        /////////
        // getUser
        function getGate(gate){
              return gateService.gateData[gate]
        }

        ///////////////////////////////////////////////////////////
        /// logout
        function logout() {

            // destroy all firebase refs
             angular.forEach($window.openFirebaseConnections, function (item) {
                 item.$destroy();
             });
            // remove Raven user context
             // Add our uid to Sentry logs for troubleshooting
            Sentry.configureScope(function(scope) {
              scope.setUser({
                "id": 'not-logged-in'
              });
            });
            // Reset Appcues
            // Appcues.reset();
            firebase.auth().signOut().then(function () {
                // Sign-out successful.
                clearUserData();
                $state.go('authentication.login')
            }, function (error) {
                // An error happened.
            });
        }
        // logout

        ///////////////////////////////////////////////////////////
        /// changeUserSetting
        function changeUserSetting(setting, value) {
            // $log.info('ChangeUserSetting: ' + setting, value);
                // Update it on $rootScope
                  $rootScope.userSettings[setting] = value;

                  var updates = {};
                  // store our canonical object - just update the PROFILE
                  updates['/users/' + service.user.uid + '/profile/settings/' + setting] = value;
                  return firebase.database().ref().update(updates)
                  .then(function(){
                    service.trackEvent('change-' + setting + '-setting');
                    service.trackEvent('updated-user-settings');
                  })

        }
        // changeUserSetting

        ///////////////////////////////////////////////////////////
        /// resetOnboarding
        function resetOnboarding() {
            // $log.info('resetOnboarding: ' + setting, value);
                  var updates = {};
                  // store our canonical object - just update the PROFILE
                  updates['/users/' + service.user.uid + '/profile/onboardingFlags/'] = null;
                  return firebase.database().ref().update(updates)

        }
        // resetOnboarding


        ///////////////////////////////////////////////////////////
        /// changeOnboardingFlag
        function changeOnboardingFlag(flag, value) {
            // $log.info('changeOnboardingFlag: ' + flag, value);
            var updates = {};
            // store our canonical object - just update the PROFILE
            updates['/users/' + service.user.uid + '/profile/onboardingFlags/' + flag] = value;
            return firebase.database().ref().update(updates)
        }
        // changeOnboardingFlag


        function getConsent(consentNode, title, description){
          // $log.info('getConsent');
          var disclaimer = "<p class='md-subhead center' style='margin-top:2em; font-size: 12px;'><strong>After granting permission, please try your action again.</strong></p>";
          // Throw up Dialog with info and checkbox to give consent and submit button
          var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent(description + disclaimer)
                .ariaLabel('Ask for consent')
                .ok('I agree')
                .cancel('I do not agree');

          $mdDialog.show(confirm).then(function() {
            setConsent(consentNode, description, true);
          }, function() {
            setConsent(consentNode, description, false);
          });

        }// getConsent

        function setConsent(consentNode, description, newValue){
          // $log.info('changeConsent');

          var payload = {
            entity: consentNode,
            timeStamp : moment().toISOString(),
            hasConsent: newValue,
            description: description
          }

          var updates = {};
          // store our canonical object - just update the PROFILE
          updates['/users/' + service.user.uid + '/consent/' + consentNode] = payload;
          return firebase.database().ref().update(updates)
          .then(function(){
           notifyConsentChange(consentNode, newValue)
          });;
        }


        function changeConsent(consentNode, newValue){
          // $log.info('changeConsent');

          var updates = {};
          // store our canonical object - just update the PROFILE
          updates['/users/' + service.user.uid + '/consent/' + consentNode + '/timeStamp'] = moment().toISOString();
          updates['/users/' + service.user.uid + '/consent/' + consentNode + '/hasConsent'] = newValue;
          return firebase.database().ref().update(updates)
          .then(function(){
            //heap.track('consent-' + consentNode + '-' + newValue);
            userDataService.trackEvent('consent-' + consentNode + '-' + newValue);

           notifyConsentChange(consentNode, newValue);
          });
        }

        function notifyConsentChange(consentNode, value){
          var label = 'removed',
              color = 'red',
              message = '';
          if(value){
            label = 'given';
            color = 'green';
            message = 'Please try the action again now.';
          }

          $mdToast.show($mdToast.adminjaAlert(
              {
                  locals:{
                      title: consentNode + ' consent ' + label,
                      message: message,
                      color: color
                  }
              }));// mdToast
        }


        function hasConsent(consentNode){
          if(_.has(service.user, 'consent.' + consentNode)){
            if (service.user.consent[consentNode].hasConsent){
              return true
            } else {
              return false
            }
          } else {
            return false
          }

        }// hasConsent

        ///////////////////////////////////////////////////////////
        /// userDialog
        function userDialog(title) {
              // we couldn't do an angular.copy here. Not sure why this variable is considered part of the window object
              // but we are doing a to and from JSON conversion to get the data into our dialog
              var userCopy = angular.toJson(service.user);
              userCopy = angular.fromJson(userCopy);

              // if we are an old user with no profile, add one to avoid errors.
              if (!userCopy.profile) {
                  userCopy.profile = [];
              }

              // if we already have an avatar, assign it to our profile avatar

              if (userCopy.profile.dob) {
                  userCopy.profile.dob = new Date(userCopy.profile.dob)
              }
              ;

              $mdDialog.show({
                  controller: userDialogController, // see below
                  controllerAs: 'vm',
                  templateUrl: 'app/app-services/userDataService/dialog-user-profile.tmpl.html',
                  locals: {user: userCopy, title: title},
                  bindToController: true,
                  fullScreen: true,
                  focusOnOpen: false,
                  clickOutsideToClose: false,
                  escapeToClose: false
              });

        }; // userDialog

        /* @ngInject */
        function userDialogController($scope, userDataService) {
            $log.info('userDialogController');

            var vm = this;
            vm.loading = true;
            vm.user.profile.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            $timeout(function(){init()})

            function init(){
              var endpoint = firebase.functions().httpsCallable('invoicing'),
                  request = {
                    action: 'getCountries'
                  }
              return endpoint(request)
              .then(function(results){
                vm.countries = results.data
                var request = {
                  action: 'getTimeZones'
                }
                return endpoint(request)
                .then(function(results){
                  $log.info(results);
                  $timeout(function(){
                    vm.timeZones = results.data;
                    vm.loading = false;
                  });
                })
                var timeZones = moment.tz.names(),
                    results = {}, count = 0;

                 _.each(timeZones, function(zone){
                  results[count] = {
                    id: count,
                    name: zone,
                    value: zone,
                    offset: moment().tz(zone).format('Z')
                  }
                  count ++
                 });
                 $timeout(function(){
                  vm.timeZones = results;
                  vm.loading = false;
                 })
              })
              .catch(function(error){
                $log.info(error);
              })



            }// init

            //this function used by userDialog which is ONLY used to add time zones and such for legacy users.
            vm.updateUser = function(user){
              delete user.profile.timeZoneUpdated;

              return firebase.database().ref().update(updates)
              .then(function(){
                return userDataService.updateUser(user).
                then(function(){
                  vm.cancelDialog()
                })
              })
            }

            vm.cancelDialog = function cancelDialog(dialog) {
                // I don't think I'm doing this properly (see fn above)
                // unbindDetail();
                $mdDialog.cancel();
            }



            // vm.uploadAvatar = function ($files, user) {
            //     // $log.info('upload file');
            //     // $log.info($files);

            //     if ($files !== null && $files.length > 0) {
            //         var storage = firebase.storage(),
            //                 storageRef = storage.ref();

            //         _.each($files, function (file) {
            //             var filename = user.uid + '_userAvatar.' + file.name;

            //             var imageRef = storageRef.child('avatars/' + filename);

            //             var uploadTask = imageRef.put(file);

            //             uploadTask.on('state_changed', function (snapshot) {
            //                 // observe state change for progress, pause, resume
            //                 // $log.info('upload state changed');

            //             }, function (error) {

            //                 // $log.warn('upload failed');
            //                 // Handle unsuccessful upload
            //             }, function (success) {
            //                 // $log.info('upload success');
            //                 // Handle successful uploads on complete
            //                 // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            //                 // Set the file url value in our model

            //                 // $timeout to force a $digest/$apply
            //                 $timeout(function () {
            //                     user.profile.avatar = uploadTask.snapshot.downloadURL;
            //                     vm.scope.userDialogForm.$pristine = false;
            //                 }, 0);

            //                 // $mdToast.showSimple('Profile photo uploaded. Thanks!');

            //             });// uploadTask.on
            //         });// ._each files
            //     } // if files
            // };// vm.uploadAvatar

        }// userDialogController

        ////////////////////
        // clear user

        function clearUserData() {
            triMenu.removeMenu('triangular.workspaces');
            triMenu.removeMenu('triangular.clients');
            triMenu.removeMenu('triangular.internal');
            triMenu.removeMenu('triangular.manage-team');
            triMenu.removeMenu('triangular.manage');
            delete service.user;
            delete $rootScope.userID;
            delete $rootScope.userName;
            delete $rootScope.currentTeamList;
            delete $rootScope.trial;
            delete $rootScope.userSettings;
            delete $rootScope.admin;
            delete $rootScope.emailVerified;
            delete $rootScope.activeClientID;
            delete $rootScope.VAWorkspaces;
            delete $rootScope.thisClient;
            delete $rootScope.showNinjaMenu;
            delete $rootScope.sessionCounted;
            delete $rootScope.thirdPartiesNotified;
            localStorageService.remove('userID');
            localStorageService.remove('userName');
            localStorageService.remove('ghostUser');
            gateService.clearGates();
        }


        //////////////////////////////////
        // Save User
        function saveNewUser(user) {
            // make a copy so we don't modify what's being shown and throw a DOB error
            var userCopy = angular.copy(user);

            user.dob = user.dob.toISOString();

            user.$save()
                    .then(function () {
                        $mdToast.showSimple('Profile Updated. Thanks!');
                        user.dob = new Date(user.dob);
                        userDataService.trackEvent('update-user-profile');
                    });

            // Redirect to Client Manager for next onramping step
        }

        //////////////////////////////////
        // Update User (TO KEEP LOG DATA SAFE, THIS ONLY UPDATES THE USER PROFILE NODE!!!)


        function updateUser(user){
          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var userCopy = angular.fromJson(angular.toJson(user));
          // $log.info('updateUser');
          // $log.info(userCopy);

            // Make sure we reset fullName in case our name has changed
            userCopy.profile.fullName = userCopy.profile.firstName + ' ' + userCopy.profile.lastName;
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/users/' + userCopy.uid + '/profile'] = userCopy.profile;

            return firebase.database().ref().update(updates)
            .then(function(){
              service.trackEvent('update-user-profile');
            })


        }// updateUser
        ///////////////////////////////////////////////////////////
        /// getUser by ID

        function getUserByID(userID) {
            // $log.info('getUserByID: ' + userID);
            var d = $q.defer();
            var userRef = firebase.database().ref('users/' + userID);
            user = $firebaseObject(userRef)
                    .$loaded(function (user) {
                        d.resolve(user);
                        // $log.info(user);
                        return d.promise;
                    });
        }
        ;// getUserByID



        //////////////////
        // getLoggedInUser
        // Needs no parameter, returns full user object and sets up gates and user.profile.settings);
        function getLoggedInUser(force){
          var ghostUser = undefined;
            return new Promise(function(resolve){

              // if we are on registration page, we DO NOT want to setup the user.
              if($state.current.name != 'authentication.registration'){


                // Should we send what we have or refresh it from scratch?
                if(service.user && !force){
                  resolve(service.user);
                } else {

                  $log.info('Initializing User');

                  var userRef = undefined;
                  // determine if we are getting logged in user's record or ghost record
                  if(localStorageService.get('ghostUser')){
                       ghostUser = localStorageService.get('ghostUser');
                       userRef = firebase.database().ref('users/' + ghostUser.uid);
                  } else {
                       userRef = firebase.database().ref('users/' + localStorageService.get('userID'));
                  }

                  $firebaseObject(userRef)
                  .$loaded(function(data){
                    user = data;
                    if(user && _.has(user, 'uid')){

                        // Store the raw settings immediately so dashboard has it...even though it may get updated during defineUserSettings below
                        $rootScope.userSettings = user.profile.settings;

                        // Force timezone to what user selected
                        var moment = $window.moment;
                        moment.tz.setDefault(user.profile.timeZone);

                        // check to make sure user isn't an orphan from an abandoned cart (see comments in registrationController)
                        // This can be removed after 2/6/2020 as we've moved to new registration as of 1/6/2020.
                        if(_.has(user, 'tempPlan')){
                          if(user.tempPlan == true){
                            return tempPlanWarning(user)
                          }
                        }

                        gateService.setupGates(user);

                        if(!localStorageService.get('ghostUser')){
                          // Identify user with third parties
                          if(!$rootScope.thirdPartiesNotified){
                            notifyThirdParties(user);
                          }
                        }

                        // Store the user on the service
                        service.user = user;
                        userSetup(user);
                        resolve(service.user);

                    } else {
                      alert('There was a problem logging you in. Please refresh and try again. If this persists, please contact help@getadminja.com.');
                      $state.go('authentication.login');
                    }// if user record returned


                  }, function(error){
                    // alert('There was a problem logging you in. Please refresh and try again. If this persists, please contact help@getadminja.com with the following error: \n' + error);
                    resolve(error);
                  });// userRef

                }// if already have service.user
              } else {
                resolve(false);
              }// if not on registration page

            });// promise
        }// getLoggedInUser


        function runExperienceQueue(user){
          $log.info('runExperienceQueue');
          if(_.has(user, 'experienceQueue')){
            var queue =  _.sortBy(user.experienceQueue, ['timeStamp']);
            if(_.size(queue) > 0){
              $log.info(queue[0].experienceID);
              $timeout(function(){
                userpilot.trigger(queue[0].experienceID);
              }, 3000)
              .then(function(){
                firebase.database().ref('/users/' + user.uid + '/experienceQueue/' + queue[0].uid).set(null)
              });
            }
          }
        }//runExperienceQueue

        //// simple sequences
        function userSetup(user){
            $rootScope.admin = user.type;
            // If we are ghosting...then we are admin and should get admin controls
            var ghostUser = undefined;
            if(localStorageService.get('ghostUser')){
              ghostUser = localStorageService.get('ghostUser');
             $rootScope.admin = 'admin';
            }

            if(_.has(user, 'VAWorkspaces')){
              $rootScope.VAWorkspaces = user.VAWorkspaces;
            }
            if(_.has(user, 'clients')){
              $rootScope.workspaces = user.clients;
            }
            // Check to see if session has expired.
            if(_.has(user, 'lastLogin') && !localStorageService.get('ghostUser')){
              var difference = moment().diff(user.lastSession, 'hours');

              // is session expired? If so, logout.
              if(difference > 72 && $state.current.name != 'authentication.login'){
                return logout()
              } else {
              // not expired: set lastSession
                firebase.database().ref('/users/' + user.uid + '/lastSession').set(moment().toISOString());
              }// if session expired
            } else if (!localStorageService.get('ghostUser')){
              // dont' have lastSession. Add it
              firebase.database().ref('/users/' + user.uid + '/lastSession').set(moment().toISOString());
            }// if _.has lastSession

            defineUserSettings(user);
            // Turn on presence monitoring
            presenceService.monitor(user.uid);
            // update our sessionCount
            if(!$rootScope.sessionCounted){
             var ref = firebase.database().ref('users/' + user.uid + '/sessionCount');
             ref.transaction(function(sessions) {
               // If node/clicks has never been set, currentRank will be `null`.
               $rootScope.sessionCounted = true;
               return (sessions || 0) + 1;
             });
            }// if session not counted

        }// userSetup

        function tempPlanWarning(user){
            $mdDialog.show({
                controller: 'needsCheckoutDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/userDataService/needs-checkout-dialog.tmpl.html',
                locals: {
                  thisTitle: "We're Sorry.",
                  message: "It looks like your registration isn't complete. <br>Please click the link below to complete your registration.",
                  user: user
                },
                focusOnOpen: true,
                clickOutsideToClose: false,
                fullscreen: true
            });
        }// tempPlanWarning


        // a bit lengthy but necessary to make sure we are updating our counts across systems
        function notifyThirdParties(user){
          // this is long, but simple and necessary since users wont all have all count nodes
          var activeClients = 0,
              archivedClients = 0,
              invitesSent = 0,
              invoicesCreated = 0,
              pdfsRequested = 0,
              profileCards = 0,
              taskBuckets = 0,
              recurringTasks = 0,
              tasksCreated = 0,
              tasksCompleted = 0,
              checklistItems = 0,
              taskComments = 0,
              tasksCompletedThisWeek = 0,
              tasksAddedThisWeek = 0,
              timeLogsAdded = 0,
              timeLogsThisWeek = 0,
              timeLogsThisMonth = 0,
              timeLogsThisYear= 0,
              minutesLoggedThisWeek = 0,
              minutesLoggedThisYear = 0,
              timersStarted =0,
              taskTemplates = 0,
              leadCards = 0,
              teamLimit = 0,
              sessionCount = 0,
              paypal = false,
              stripe = false,
              timeZone = false,
              currency = false,
              dailyStatus = false;

            if(_.has(user.profile.settings, 'paypalEnabled')){
              paypal = true;
            }

            if(_.has(user.profile.settings, 'paypalEnabled')){
              stripe = true;
            }

            if(_.has(user.profile, 'timeZone')){
              stripe = true;
            }

            if(_.has(user.profile.settings, 'currencyCode')){
              currency = true;
            }

            if(_.has(user.profile.settings, 'dailyStatusReportEnabled')){
              dailyStatus = true;
            }

            teamLimit = user.limits.team;
            if(_.has(user.limits, 'additionalTeamMembers')){
              // apparently, additionalTeamMembers sometimes stored as text?
              teamLimit = Number(teamLimit) + Number(user.limits.additionalTeamMembers);
            }
            sessionCount = user.sessionCount;

          if(_.has(user, 'counts')){

            if(_.has(user.counts, 'clients.active')){
              activeClients = user.counts.clients.active;
            } else {
              activeClients = _.size(user.clients);
            }

            if(_.has(user.counts, 'clients.archived')){
              archivedClients = user.counts.clients.archived;
            }
            if(_.has(user.counts, 'invites.sent')){
               invitesSent = user.counts.invites.sent;
            }
            if(_.has(user.counts, 'invoices.created')){
              invoicesCreated = user.counts.invoices.allTime;
            }
            if(_.has(user.counts, 'pdfs.allTime')){
              pdfsRequested = user.counts.pdfs.allTime;
            }
            if(_.has(user.counts, 'profileCards.allTime')){
              profileCards = user.counts.profileCards.allTime;
            }
            if(_.has(user.counts, 'taskGroups.allTime')){
              taskBuckets = user.counts.taskGroups.allTime;
            }
            if(_.has(user.counts, 'taskTemplates.recurringTasks')){
               recurringTasks = user.counts.taskTemplates.recurringTasks;
            }
            if(_.has(user.counts, 'taskTemplates.templateTasks')){
              taskTemplates = user.counts.taskTemplates.templateTasks;
            }
            if(_.has(user.counts, 'tasks.added.allTime')){
              tasksCreated = user.counts.tasks.added.allTime;
            }
            if(_.has(user.counts, 'tasks.completed.allTime')){
              tasksCompleted = user.counts.tasks.completed.allTime;
            }
            if(_.has(user.counts, 'tasks.checklistItems')){
              checklistItems = user.counts.tasks.checklistItems;
            }
            if(_.has(user.counts, '')){
               taskComments = user.counts.tasks.comments;
            }
            if(_.has(user.counts, 'tasks.completed.thisWeek')){
              tasksCompletedThisWeek = user.counts.tasks.completed.thisWeek;
            }
            if(_.has(user.counts, 'tasks.added.thisWeek')){
              tasksAddedThisWeek = user.counts.tasks.added.thisWeek;
            }
            if(_.has(user.counts, 'timeLogs.allTime')){
              timeLogsAdded = user.counts.timeLogs.allTime;
            }

            if(_.has(user.counts, 'timeLogs.thisWeek')){
               timeLogsThisWeek = user.counts.timeLogs.thisWeek;
            }
            if(_.has(user.counts, 'timeLogs.thisMonth')){
              timeLogsThisMonth = user.counts.timeLogs.thisMonth;
            }

            if(_.has(user.counts, 'timeLogs.weekTotal')){
               minutesLoggedThisWeek= user.counts.timeLogs.weekTotal
            }

            if(_.has(user.counts, 'timeLogs.yearTotal')){
              minutesLoggedThisYear = user.counts.timeLogs.yearTotal;
            }

            if(_.has(user.counts, 'timers.allTime')){
              timersStarted = user.counts.timers.allTime;
            }

            if(_.has(user.counts, 'leadCards.allTime')){
              leadCards = user.counts.leadCards.allTime;
            }

          }// if has user.counts

          var userPlanID = 'unknown';
          if(_.has(user, 'plan')){
            userPlanID = user.plan.content__subscription__plan_id;
          }



          // ID in heap
          // heap.identify(user.email);
          // heap.addUserProperties({
          //   'Name': user.profile.firstName + ' ' + user.profile.lastName,
          //   'userID': user.uid,
          //   'teamLimit': teamLimit,
          //   'Plan': userPlanID,
          //   'Status': user.plan.content__subscription__status,
          //   'lastSession': moment().toISOString(),
          //   'lastSession (unix)': moment().unix(),
          //   'Signup Date': moment(user.profile.startDate).format('MM/DD/YY'),
          //   'Signup Date (unix)': moment(user.profile.startDate).unix(),
          //   'startDate (unix)': moment(user.profile.startDate).unix(),
          //   'startDate': moment(user.profile.startDate).toISOString(),
          //   'clients' : activeClients,
          //   'tasks-completed': tasksCompleted,
          //   'time-logs-added': timeLogsAdded,
          //   'timers-started': timersStarted,
          //   'lead-cards': leadCards,
          //   'session-count': sessionCount
          // });

          // ID in Drip
          var dripObject = {
                  'email': user.email,
                  'user_id': user.uid,
                  'clients': activeClients,
                  'plan' : userPlanID,
                  'teamLimit': teamLimit,
                  'status' : user.plan.content__subscription__status,
                  'userID': user.uid,
                  'Name': user.profile.firstName + ' ' + user.profile.lastName,
                  'first_name': user.profile.firstName,
                  'last_name': user.profile.lastName,
                  'Signup_Date': moment(user.profile.startDate).toISOString(),
                  'Unix_Signup_Date': moment(user.profile.startDate).unix(),
                  'lastSession': moment().toISOString(),
                  'session-count': sessionCount
              }

          // if they've used capture, we want to "capture" that in drip!
          if(_.has(user, 'lastCaptureLogin')){
              dripObject.tags = ["Uses Capture Extension"]
            }

          _dcq.push(
            ["identify", dripObject]
            );
            $timeout(function(){
              _dcq.push([
                "track",
                "User session",{
                  success: function(response) {
                    // $log.info(response);
                 },// success
                  failure: function(response){
                    // $log.info(response);
                  }// failure
                }// callback argument
                ]);

            }, 0);


          // ID in Groove
          var grooveUser = {
             'Name': user.profile.firstName + ' ' + user.profile.lastName,
             'email': user.email,
             'first_name': user.profile.firstName,
             'last_name': user.profile.lastName,
             'userID': user.uid,
             'Plan': userPlanID,
             'Status': user.plan.content__subscription__status,
             'Signup Date': moment(user.profile.startDate).format('MM/DD/YY'),
             'Signup Date (unix)': moment(user.profile.startDate).unix(),
             'startDate (unix)': moment(user.profile.startDate).unix(),
             'startDate': moment(user.profile.startDate).toISOString(),
             'clients' : activeClients,
             // 'archived-clients' : archivedClients,
             'lead-cards': Number(leadCards),
             'team-limit': Number(teamLimit),
             'session-count': Number(sessionCount),
             'invites-sent': invitesSent,
             'invoices-created': invoicesCreated,
             'pdfs-requested': pdfsRequested,
             'profile-cards': profileCards,
             'task-buckets': taskBuckets,
             'recurring-tasks': recurringTasks,
             'task-templates': taskTemplates,
             'tasks-created': tasksCreated,
             'tasks-completed': tasksCompleted,
             // 'checklist-items': checklistItems,
             'task-comments': taskComments,
             'tasks-completed-this-week': tasksCompletedThisWeek,
             'tasks-added-this-week': tasksAddedThisWeek,
             'time-logs-added': timeLogsAdded,
             'time-logs-this-week': timeLogsThisWeek,
             'time-logs-this-month': timeLogsThisMonth,
             'minutes-logged-this-week': minutesLoggedThisWeek,
             'minutes-logged-this-year': minutesLoggedThisYear,
             'timers-started': timersStarted,
             'lastSession': moment().toISOString()
          };

          if(_.has(user, 'lastCaptureLogin')){
              grooveUser.usesCaptureExtension = true;
            }

          groove.widget.identifyContact('contact_email', user.email)
          groove.widget.setContact(grooveUser);
          // groove.widget('setCustomer', grooveUser);




          // Define our initial dataLayer
          dataLayer.push({
              user_id: user.uid,
              teams: _.size(user.teams),
              planID: userPlanID,
              status: user.plan.content__subscription__status
          });

          // some folks are blocking analytics causing login to fail. Only initialize if it exists.
          if(_.has(firebase, 'analytics')){
            // initialize analytics
            firebase.analytics();

            // Set userID
            // the SDK seems to be faulty here. ID'ing via this call does nothing.
            firebase.analytics().setUserId(user.uid);

            // ** NOTE: The user_id property below actually gets used as the official userID as far as analytics is concerned rather than as a user property. Don't remove or alter it.
            firebase.analytics().setUserProperties({user_id: user.uid, teams: _.size(user.teams), planID: userPlanID, status: user.plan.content__subscription__status });
          }


          var userPilotUser = {
            'Name': user.profile.firstName + ' ' + user.profile.lastName,
            'first_name': user.profile.firstName,
            'email': user.email,
            'last_name': user.profile.lastName,
            'userID': user.uid,
            'Plan': userPlanID,
            'Status': user.plan.content__subscription__status,
            'Signup Date': moment(user.profile.startDate).format('MM/DD/YY'),
            'created_at': moment(user.profile.startDate).unix(),
            // 'Signup Date (unix)': moment(user.profile.startDate).unix(),
            // 'startDate (unix)': moment(user.profile.startDate).unix(),
            'startDate': moment(user.profile.startDate).toISOString(),
            'clients' : activeClients,
            // 'invites-sent': invitesSent,
            // 'invoices-created': invoicesCreated,
            // 'pdfs-requested': pdfsRequested,
            // 'profile-cards': profileCards,
            // 'task-lists': taskBuckets,
            // 'recurring-tasks': recurringTasks,
            // 'task-templates': taskTemplates,
            // 'tasks-created': tasksCreated,
            // 'tasks-completed': tasksCompleted,
            // 'checklist-items': checklistItems,
            // 'task-comments': taskComments,
            // 'tasks-completed-this-week': tasksCompletedThisWeek,
            // 'tasks-added-this-week': tasksAddedThisWeek,
            // 'time-logs-added': timeLogsAdded,
            // 'time-logs-this-week': timeLogsThisWeek,
            // 'time-logs-this-month': timeLogsThisMonth,
            // 'minutes-logged-this-week': minutesLoggedThisWeek,
            // 'minutes-logged-this-year': minutesLoggedThisYear,
            // 'timers-started': timersStarted,
            'lastSession': moment().toISOString(),
            'lastSessionUnix': moment().unix(),
            // 'lead-cards': leadCards,
            'team-limit': Number(teamLimit),
            'session-count': sessionCount,
            'paypal': paypal,
            'stripe': stripe,
            'timeZone': timeZone,
            'currency' : currency,
            'dailyStatus': dailyStatus
          }
          // Call userpilot.identify()
          // $log.info('calling userPilot');
          userpilot.identify(user.uid, userPilotUser);
          runExperienceQueue(user);
          $rootScope.thirdPartiesNotified = true;
        }// notifyThirdParties

        function defineUserSettings(user){
          if(user){
              // Set sidemenu size based on user setting
              if(_.has(user,'profile.settings.pinMenu')){
                  if(user.profile.settings.pinMenu){
                      triLayout.setOption('sideMenuSize', 'full');
                  } else {
                      triLayout.setOption('sideMenuSize', 'icon');
                  }
              } else {
                  triLayout.setOption('sideMenuSize', 'full');
              }

              if(_.has(user,'profile.settings.idleTimeout')){
                // $log.info('setting custom timeout: ' + user.profile.settings.idleTimeout);
                Idle.setTimeout(Number(user.profile.settings.idleTimeout))
              } else {
                user.profile.settings.idleTimeout = 3600;
              };

              // if user is new and doesn't have settings, let's define the defaults we need
              if(!_.has(user, 'profile.settings')){

                  // make sure they at least have a profile node
                  if(!_.has(user, 'profile')){
                    user.profile = {};
                  }

                  user.profile.settings = {};
                  user.profile.settings.verticalProfilePanels = false;
                  user.profile.settings.verticalTaskPanels = false;
                  user.profile.settings.requireWorkDescription = false;
                  user.profile.settings.roundUpTo = 1;
                  user.profile.settings.hideCompletedPanel = false;
              } else {
                  // we have a settings node.
                  // but still, make sure critical properties get set on our user
                  if(!_.has(user, 'profile.settings.verticalProfilePanels')){
                      user.profile.settings.verticalProfilePanels = false;
                  }

                  if(!_.has(user, 'profile.settings.verticalTaskPanels')){
                      user.profile.settings.verticalTaskPanels = false;
                  }

                  if(!_.has(user, 'profile.settings.requireWorkDescription')){
                      user.profile.settings.requireWorkDescription = false;
                  }

                  if(!_.has(user, 'profile.settings.roundUpTo')){
                      user.profile.settings.roundUpTo = 1;
                  }

                  if(!_.has(user, 'profile.settings.hideCompletedPanel')){
                      user.profile.settings.hideCompletedPanel = false;
                  }

                  if(!_.has(user, 'profile.settings.hideGuide')){
                      user.profile.settings.hideGuide = false;
                  }

              }

              if(!_.has(user.profile.settings, 'startOfWorkday')){
                user.profile.settings.startOfWorkday = '08:00';
              }

              if(!_.has(user.profile.settings, 'endOfWorkday')){
                user.profile.settings.endOfWorkday = '17:00';
              }
              var dateFormat = 'us';
              // set default date format
              user.profile.settings.amDateFormat = 'MM/DD/YYYY';
              user.profile.settings.shortDateFormat = 'MMM D';
              user.profile.settings.shortOrdDateFormat = 'MMM Do';
              user.profile.settings.longDateFormat = 'MMMM D, YYYY';
              user.profile.settings.shortYearFormat = 'MM/D/YY';
              user.profile.settings.superShortDateFormat = 'M/D';
              user.profile.settings.shortDayOfWeekFormat = 'ddd, MMM D';
              user.profile.settings.time = 'hh:mm a';

              // Check user setting and change default datepicker format if set
              if (_.has(user, 'profile.settings.dateFormat')){
                  dateFormat = user.profile.settings.dateFormat;
              }

              if (dateFormat == 'eu'){
                $log.info('Switching to EU date formats');
                user.profile.settings.amDateFormat = 'DD/MM/YYYY';
                user.profile.settings.shortDateFormat = 'D MMM';
                user.profile.settings.shortOrdDateFormat = 'Do MMM';
                user.profile.settings.longDateFormat = 'D MMMM, YYYY';
                user.profile.settings.shortYearFormat = 'D/MM/YY';
                user.profile.settings.superShortDateFormat = 'D/M';
                user.profile.settings.shortDayOfWeekFormat = 'ddd, D MMM';
                user.profile.settings.time = 'hh:mm a';

                // $log.info('Changing dateFormat to eu');
                // Setup our datePicker format
                $mdDateLocale.formatDate = function(date) {
                  return date ? moment(date).format('DD/MM/YYYY') : null;
                };

                $mdDateLocale.parseDate = function(dateString) {
                  var m = moment(dateString, 'DD/MM/YYYY', true);
                  return m.isValid() ? m.toDate() : new Date(NaN);
                };

              }// if eu dateformat
              if(_.has(user, 'profile.settings.startOfWeek')){
                  $mdDateLocale.firstDayOfWeek = parseInt(user.profile.settings.startOfWeek);
              }
            }

            // check for timeZone. If not exist, set it
            // if(!_.has(user, 'profile.timeZone')){
            //   $log.info('No Timezone set. Asking for it.');
            //   service.userDialog();
            // }
          }//if user
          $rootScope.userSettings = user.profile.settings;


      }// defineUserSettings


      function count(userID, node, qty){
          var timeStamp = moment().toISOString();
          var payload = {
            userID: userID,
            node: node,
            qty: Number(qty),
            timeStamp: timeStamp
          }

          var doCount = firebase.functions().httpsCallable('count');

          return doCount(payload)
          .then(function(results){
            // Read result of the Cloud Function.
            // console.log(results);
            return results;

          })
          .catch(function(error){
              // alert(error);
              console.log(error);
              return
          });


      }// count

      function trackEvent(eventID, options){
        // we are capturing many click events in GTM already.
        // But this data isn't easily accessible to our marketing utilities below

        // track event in userPilot
        userpilot.track(eventID);

        // track event in Drip
        _dcq.push(["track", eventID]);

        if(!options){
          // track event in GTM
          dataLayer.push({'event': eventID});
        }
      }// trackEvent



})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('needsCheckoutDialogController', needsCheckoutDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// needsCheckoutDialogController

        /* @ngInject */
        function needsCheckoutDialogController($scope, $q, $rootScope, userDataService, firebase, $window, $mdDialog, $log, $timeout, $mdToast, thisTitle, message) {
            // $log.info('subscriptionDialogController');
            var vm = this;
            vm.user = userDataService.user;
            vm.title = thisTitle;
            vm.message = message;
            vm.completeCheckout = function(){
                // alert('go to checkout');
                 var userUrlParameters = "?subscription[id]="+ vm.user.uid + "&customer[cf_adminja_user_id]=" + vm.user.uid + "&billing_address[first_name]=" + vm.user.profile.firstName + "&billing_address[last_name]=" + vm.user.profile.lastName + "&customer[email]=" + vm.user.email;
                 // $log.info('userUrlParameters:' + userUrlParameters);
                 var checkoutURL = $rootScope.chargebeeSettings.checkoutURL + vm.user.originalPlan + userUrlParameters;

                 // Clear our _userData so our listeners aren't fired
                   firebase.auth().signOut();

                   // Go to our Chargebee Checkout page
                   $window.location.href = checkoutURL;

            }

        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('timeReportModalController', timeReportModalController);

            /* @ngInject */
function timeReportModalController($log, hotkeys, $mdDialog){
	var vm = this;
	hotkeys.add({
	  combo: 'esc',
	  description: 'Cancel report',
	  allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	  callback: function(event, hotkey) {
	    event.preventDefault();
	    // $log.info(event);
	    $mdDialog.cancel();
	  }
	})
	// vm.report already on the controller

}

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('timeDialogController', timeDialogController);


     ///////////////////////////////////////////////////////////
     ///////////////////////////////////////////////////////////
     /// timeDialogController

     /* @ngInject */
	function timeDialogController($scope, $log, $mdToast, mdcDateTimeDialog, $mdDialog, $timeout, timeDataService, taskDataService, timerDataService, $rootScope, timeReportService, hotkeys, $state, $stateParams, localStorageService, clientDataService, userDataService) {
	$log.debug('timeDialogController');

	var vm = this;
	vm.billingType = 'periods';
	vm.timeEntry = angular.copy(vm.previousEntry);
	vm.maxLength = 2;
	vm.formatHours = formatHours;
	vm.showPackageSelector = false;
	vm.formatMinutes = formatMinutes;
	vm.setClient = setClient;
	vm.increaseTime = increaseTime;
	vm.decreaseTime = decreaseTime;
	vm.settings = $rootScope.userSettings;
	vm.visitBilling = visitBilling;
	vm.setTask = setTask;
	vm.performanceLimit = 500;
	vm.user = userDataService.user;
	vm.roundUpTo = 15;
	if(_.has(vm.user.profile.settings, 'roundUpTo' )){
		vm.roundUpTo = vm.user.profile.settings.roundUpTo;
	}
	vm.maxDate = moment().add(3, 'days').toDate();
	vm.assignedClients = clientDataService.clients;
	vm.userType = $rootScope.admin;
	vm.fbConfig = fbConfig;
	vm.taskCandidates = undefined;
	vm.currency = "$";
	vm.packageNotAvailable = false;
	vm.changeClient = changeClient;

	$scope.setPackage = setPackage;

	init();

	function init(){
		if(_.has(userDataService.user.profile, 'settings.currency')){
		    vm.currency = userDataService.user.profile.settings.currency;
		}

		vm.requireWorkDescription = false;
		vm.requireWorkDescription = vm.user.profile.settings.requireWorkDescription;
		vm.inputOptions = { updateOn: 'default blur',
		                       debounce: {
		                         default: 1000,
		                         blur: 0
		                       }
		                  };

		// if we are editing an existing entry, take total logged minutes and split into hours and minutes for our form

		if(_.has(vm.timeEntry, 'uid')){
			vm.originalTimeEntry = angular.copy(vm.timeEntry);
			vm.originalTimeEntry = ajUTILITIES.removePropertiesWith(vm.originalTimeEntry);
			vm.timeEntry.hours = Math.floor(vm.timeEntry.logged / 60);
			vm.timeEntry.minutes = vm.timeEntry.logged % 60;
			vm.timeOfDay = moment(vm.timeEntry.logDate).startOf('minute').toDate();
			vm.formatHours(vm.timeEntry.hours);
			vm.formatMinutes(vm.timeEntry.minutes);
		} else {
			if(_.has(vm.timeEntry, 'timerID')){
				vm.formatHours(vm.timeEntry.hours);
				vm.formatMinutes(vm.timeEntry.minutes);
			} else {
				vm.timeEntry.minutes = '00';
				vm.timeEntry.hours = '00';
				vm.timeEntry.logged = 0;
			}

		  vm.timeOfDay = moment().startOf('minute').toDate();
		}
		// Set focus
		$timeout(function () {
		  // if this is based on a timer and we already have time info, focus on the description field
		  if(vm.timeEntry.hours > 0 || vm.timeEntry.minutes >0){
		      angular.element("textarea[name='description']").focus();
		      // otherwise, if there is a client already, focus on the minutes field
		  } else if (vm.timeEntry.client) {
		      // angular.element("input[name='minutes']").focus();
		  }

		  // if there's a task assigned, fill the description field
		  if(_.has(vm.timeEntry, 'task')){
		      vm.setTask(vm.timeEntry);
		  }

		}, 100);

		// setup our initial task drop down if we are starting from a timer
		// setup our initial task drop down.
		if (_.has(vm.timeEntry, 'client')) {
		  setClient(vm.timeEntry.client, true);
		} else if (typeof $stateParams.clientID !== 'undefined') {
		  setClient($stateParams.clientID, true);
		}


	}// init

	function formatHours(string){
		// $log.info('formatHours');
		if(string){
			var str = '' + string;
			while (str.length < 2) {
			    str = '0' + str;
			}

			vm.timeEntry.hours = str;
			calcTime();
		} else {
			vm.timeEntry.hours = "00";
			calcTime();
		}

	}

	function formatMinutes(string){
		// $log.info('formatMinutes');
		if(string){
			var str = '' + string;
			while (str.length < 2) {
			    str = '0' + str;
			}

			vm.timeEntry.minutes = str;
			calcTime();
		} else {
			vm.timeEntry.minutes = '00'
			calcTime();
		}

	}


	function increaseTime(amount){
		// $log.info('increaseTime');
		amount = Number(amount);
		vm.timeEntry.logged = Number(vm.timeEntry.logged) + amount;
		timeToHandM(vm.timeEntry.logged);
		$scope.forms.timeDialogForm.$setDirty();
	}

	function decreaseTime(amount){
		// $log.info('decreaseTime');
		amount = Number(amount);
		vm.timeEntry.logged = Number(vm.timeEntry.logged) - amount;
		timeToHandM(vm.timeEntry.logged);
		$scope.forms.timeDialogForm.$setDirty();
	}

	function timeToHandM(number){
		// $log.info('timeToHandM');
		// we'll need this later
		var isNegative = false;
		if (number < 0){
		  isNegative = true;
		}
		// convert string to a number
		number = Number(number);
		// convert to an integer so we aren't doing a floor/ceiling dance
		number = Math.abs(number);

		var hours = Math.floor( number / 60);
		hours = _.toString(hours);
		hours = _.padStart(hours, 2, '0');
		vm.timeEntry.hours = hours;
		// we don't pad our hours. They may go into 3 digits for some users.

		var minutes = number % 60;
		minutes = Math.abs(minutes);
		minutes = _.toString(minutes);
		minutes = _.padStart(minutes, 2, '0');
		if(!minutes){
			minutes = '00'
		}
		vm.timeEntry.minutes = minutes;
	}// timeToHandM

	function calcTime(){
		// $log.info('calcTime');
		// Fix our Log Amount
		var totalTime = 0;
		if (vm.timeEntry.hours) {
		    totalTime = totalTime + (vm.timeEntry.hours * 60);
		}
		if (vm.timeEntry.minutes) {
		    totalTime = totalTime + (vm.timeEntry.minutes * 1);
		}
		vm.timeEntry.logged = totalTime;
	}


	function visitBilling(clientID){
		$log.info('visitBilling');
		$log.info(clientID);
		$state.go("triangular.workspaces.client-billing", {"clientID": clientID});
		$mdDialog.cancel();
	}//

	function setTask(timeEntry) {
	  // $log.debug('setTask');
	  if(_.has(timeEntry, 'task')){
	  	return taskDataService.getTask(timeEntry.task)
	  	.then(function(task){
	  		if(task){
		  		timeEntry.taskName = task.info.description;
		          if(!timeEntry.description){
		              // trim it
		              timeEntry.description = _.truncate(task.info.description, {
	                       'length': 50,
	                       'separator': ' '
	                     });
		          }
	  		}
	  	})
	  }
	}// setTask



	function setClient(clientID, isInit) {
		vm.billingNeedsSetup = false;

		 vm.selectedPackage = null;
		  // $log.debug('setClient');


		  _.each(clientDataService.clients, function (client) {
		      if (client.uid == clientID) {
		      	vm.client = client;
		      }
		  });
	      if(vm.client){
	      		if(_.has(vm.client, 'billingType')){
	      			vm.billingType = vm.client.billingType
	      		}
	      		if(_.has(vm.client.access.admins, $rootScope.userID)){
	      		  vm.isClientAdmin = true;
	      		} else {
	      		  vm.isClientAdmin = false;
	      		}
	      	    // update the model populating our task drop down.
	      	    if(_.has(vm.client, 'tasks')){
	      	    	vm.taskCandidates = _.sortBy(vm.client.tasks, [function(o) { return o.description, o.assigneeName;}]);
	      	    }
	      	    vm.timeEntry.clientName = vm.client.profile.fullName;

	      		if(_.has(vm.timeEntry, 'packageID')){
	      			$log.info('setPackage in setClient');
	      			$scope.setPackage(vm.timeEntry.packageID, isInit)
	      		}

	      		if(vm.billingType == 'periods'){
	      			vm.timeEntry.rate = vm.client.profile.plan.rate;
	      		}


	      		// turn on our package selector to reinitialize it.
	      		$timeout(function(){
	      			// turn off our package selector for reinitializing after setting package
	      			vm.showPackageSelector = false;
	      		}).then(function(){
	      			$timeout(function(){

	      				// if this is a packages-based client workspace AND there are no active packages
	      				if(_.size(vm.client.packages) < 1 && vm.client.status != 'personal' && vm.billingType == 'packages'){
	      					vm.billingNeedsSetup = true;
	      				} else {
	      					if(!_.has(vm.timeEntry, 'packageID')){
		    					var foundDefault = false;
		    					_.each(vm.client.packages, function(thisPackage){
		    						if(thisPackage.status == 'open' && thisPackage.isDefault){
		    								$scope.setPackage(thisPackage.uid);
		    								foundDefault = true;
		    						}
		    					});
		    					if(!foundDefault){
		    						var foundFirst = false;
		    						_.each(vm.client.packages, function(thisPackage){
		    							if(!foundFirst && thisPackage.status == 'open'){
		    								$scope.setPackage(thisPackage.uid);
											foundFirst = true;
		    							}
		    						});
		    					}
	      					}// if doesn't have package ID already
	      				}
	      			})
	      		})

	      }

	}// setClient

	function changeClient(clientID, isInit) {
		vm.billingNeedsSetup = false;
		 vm.selectedPackage = null;
		  // $log.debug('setClient');


		  _.each(clientDataService.clients, function (client) {
		      if (client.uid == clientID) {
		      	vm.client = client;
		      }
		  });
	      if(vm.client){
	      		if(_.has(vm.client, 'billingType')){
	      			vm.billingType = vm.client.billingType
	      		}
	      		if(_.has(vm.client.access.admins, $rootScope.userID)){
	      		  vm.isClientAdmin = true;
	      		} else {
	      		  vm.isClientAdmin = false;
	      		}
	      	    // update the model populating our task drop down.
	      	    if(_.has(vm.client, 'tasks')){
	      	    	vm.taskCandidates = _.sortBy(vm.client.tasks, [function(o) { return o.description, o.assigneeName;}]);
	      	    }
	      	    vm.timeEntry.clientName = vm.client.profile.fullName;

	      		// if(_.has(vm.timeEntry, 'packageID')){
	      		// 	$log.info('setPackage in setClient');
	      		// 	$scope.setPackage(vm.timeEntry.packageID, isInit)
	      		// }

	      		if(vm.billingType == 'periods'){
	      			vm.timeEntry.rate = vm.client.profile.plan.rate;
	      		}


	      		// turn on our package selector to reinitialize it.
	      		$timeout(function(){
	      			// turn off our package selector for reinitializing after setting package
	      			vm.showPackageSelector = false;
	      		}).then(function(){
	      			$timeout(function(){

	      				// if this is a packages-based client workspace AND there are no active packages
	      				if(_.size(vm.client.packages) < 1 && vm.client.status != 'personal' && vm.billingType == 'packages'){
	      					vm.billingNeedsSetup = true;
	      				} else {
		    					var foundDefault = false;
		    					_.each(vm.client.packages, function(thisPackage){
		    						if(thisPackage.status == 'open' && thisPackage.isDefault){
		    								$scope.setPackage(thisPackage.uid);
		    								foundDefault = true;
		    						}
		    					});
		    					if(!foundDefault){
		    						var foundFirst = false;
		    						_.each(vm.client.packages, function(thisPackage){
		    							if(!foundFirst && thisPackage.status == 'open'){
		    								$scope.setPackage(thisPackage.uid);
											foundFirst = true;
		    							}
		    						});
		    					}
	      				}
	      			})
	      		})

	      }

	}// setClient


	function setPackage(packageID, isInit){
		$log.info('setPackage');
		$log.info(packageID);
		var packageChanged = false;
		// if entry is new or if package was changed, the default category should be used
		// otherwise set it to whatever category is stored on the entry
		var categoryID = 'defaultRate';

		// if package has changed
		if(vm.previousEntry.packageID != packageID){
			categoryID = 'defaultRate';
		}


		// $log.info('setPackage');
		var found = false;
		_.each(vm.client.packages, function(thisPackage){
			if(thisPackage.uid == packageID){
				found = true;
				// Change our GUI model
				// we need to re-initialize our category list. Just updating the values won't work.
				// so we delete the list (which removes the directive) and then redefine it (which initializes the directive with new values)
				// Without this the list was properly populated but the categoryID returned onChange was from the first-selected package's category list
				$timeout(function(){
					delete vm.timeCategories
				})
				$timeout(function(){
					vm.selectedPackage = thisPackage;
					vm.timeCategories = vm.selectedPackage.categories;
					vm.timeEntry.packageType = vm.selectedPackage.type;
					vm.timeEntry.packageID = vm.selectedPackage.uid;
					vm.timeEntry.packageLabel = vm.selectedPackage.label;
					$scope.setPackageRate(categoryID, isInit);
					vm.packageNotAvailable = false;
					vm.showPackageSelector = true;
				},250)

			}
		});

		if(!found){
			$timeout(function(){
				vm.packageNotAvailable = true;
			})
		}

	}// setPackage



	$scope.setPackageRate = function(categoryID, isInit){
		// $log.info('setPackageRate');

		if(isInit && vm.timeEntry.uid){
			categoryID = vm.timeEntry.category.uid;
		}

		if(categoryID){
			vm.selectedCategory = vm.timeCategories[categoryID];
			vm.timeEntry.category = vm.selectedCategory;
			vm.timeEntry.rate = vm.selectedCategory.rate;
			vm.timeEntry.rateLabel = vm.selectedCategory.label;
			vm.timeEntry.rateID = vm.selectedCategory.uid;
		}
	}//
//

	$scope.setRate = function(categoryID){
		// $log.info('set Rate for Period');
		if(_.has(vm, 'timeEntry')){
			if(categoryID == 'default'){
				vm.timeEntry.rate = vm.client.profile.plan.rate;
				vm.timeEntry.rateLabel = 'default';
			} else {
				var selectedCategory = _.find(vm.client.profile.categories.time, function(category){
					if(category.uid == categoryID){
						return true
					}
				});
				if(_.has(selectedCategory, 'rate')){
					vm.timeEntry.rate = selectedCategory.rate;
				}
				vm.timeEntry.rateLabel = selectedCategory.label;
				vm.timeEntry.rateID = selectedCategory.uid;
			}
		}
	}




	$scope.displayStartTimeDialog = function (startdate) {
	      mdcDateTimeDialog.show({
	        currentDate: moment(startdate),
	        time: true,
	        date: false,
	        shortTime: true,
	        clickOutsideToClose: true,
	        disableParentScroll: true,
	        todayText: 'Now',
	        minuteSteps: 1,
	        maxDate: moment(vm.timeEntry.logDate).add(48, 'hours')
	      }).then(function (date) {
	        var thisDate = moment(date);
	        vm.timeEntry.logDisplayTime = thisDate.format('h:mmA');
	        vm.timeEntry.logDate = thisDate.toDate();
	        $scope.forms.timeDialogForm.$setDirty();
	      }, function() {
	        console.log('Selection canceled');
	      });
	    };


	$scope.cancelDialog = function (timeEntry) {
	  // $log.debug('$scope.cancelDialog');
	  $mdDialog.cancel(timeEntry);
	};

	$scope.lockEntry = function(entry){
	  firebase.database().ref('/time').child(entry.uid).child('locked').set(true);
	};

	$scope.unlockEntry = function(entry){
	firebase.database().ref('/time').child(entry.uid).child('locked').set(false);
	}

	$scope.saveEntry = function (timeEntry, andNew) {
		vm.errorMessage = undefined;
		timeEntry.hours = Number(timeEntry.hours);
		timeEntry.minutes = Number(timeEntry.minutes);
		if(_.has(timeEntry, 'packageID')){
			timeEntry.packageLabel = vm.client.packages[timeEntry.packageID].label;
		}

		var billingType = 'periods'
		if(!_.has(vm.client, 'billingType')){
			billingType = vm.billingType
			if(billingType == 'periods'){
				if(!_.has(timeEntry, 'rate')){
					timeEntry.rate = vm.client.profile.plan.rate;
					timeEntry.rateLabel = 'default';
				}				}
		}



	  // $log.info('timeDialogController: saveEntry');
	  if (timeEntry.minutes > 0 || timeEntry.hours > 0){
	  	// $log.info(timeEntry);
	  	// we lose our timeEntry shen i's passed to saveEntry.
	  	// we don't know why. Making a copy here to use for next steps.
	  	var entryCopy = angular.copy(timeEntry);
	      return timeDataService.saveEntry(timeEntry)
	      .then(function(results){
	      	// $log.info('controller saved');
	      	      var message = "New Time Log Saved.";
	      	     $mdToast.show($mdToast.adminjaAlert(
	      	         {
	      	             locals:{
	      	                 title: 'New time log saved!',
	      	                 message: '' ,
	      	                 color: 'green'
	      	             }
	      	       }));// mdToast
	      	      // if a timer was attached to this entry, discard it. we are done now

	      	      if(_.has(entryCopy, 'timerID')){
	      	              timerDataService.discardTimer(entryCopy.timerID);

	      	      }
	      	      // if we have less than vm.performanceLimit in this report, update the report
	      	      // if it's exceptionally long, don't. They can refresh manually if they'd like
	      	      if(timeReportService.report.data.length < vm.performanceLimit){
	      		      $rootScope.$emit('updateTimeReport');
	      	      }

	      	      $mdDialog.cancel(timeEntry);

	      	      if(andNew){
	      	      	var clientID = entryCopy.client;
	      	      	var timeEntry = timeDataService.newLogEntry(clientID);
	      	      	// $log.info($scope.timeEntry);
	      	      	timeDataService.timeDialog(timeEntry, "New");
	      	      }
	      })
	      .catch(function(error){
	      	$log.info(error);
	      	$timeout(function(){
	      		vm.errorMessage = error;
	      	})
	      });

	  }

	}


	$scope.updateEntry = function (timeEntry, previousEntry) {
		// $log.info('controller: updateEntry');
		timeEntry.hours = Number(timeEntry.hours);
		timeEntry.minutes = Number(timeEntry.minutes);

		// if this is a package-based entry
		if(_.has(timeEntry, 'packageID')){
			// $log.info('Getting rate');
			timeEntry.packageLabel = vm.client.packages[timeEntry.packageID].label;
			if(!_.has(timeEntry, 'rate')){
				timeEntry.rate = vm.client.profile.plan.rate;
				timeEntry.rateLabel = 'default';
			}
		}

	  // if(moment(timeEntry.logDate).format('HHmm') != moment(vm.timeOfDay).format('HHmm')){
	  //     // $log.info('Before:');
	  //     // $log.info(moment(timeEntry.logDate).toISOString());
	  //     var newHour = moment(vm.timeOfDay).format('HH'),
	  //         newMinutes = moment(vm.timeOfDay).format('mm');
	  //     timeEntry.logDate = moment(timeEntry.logDate).hour(newHour).minutes(newMinutes);
	  //     // $log.info('After:');
	  //     // $log.info(moment(timeEntry.logDate).toISOString());
	  // }
	  // $log.info('sending to timeDataService.updateEntry...');
	  return timeDataService.updateEntry(timeEntry, previousEntry)
	          .then(function () {
	              $scope.cancelDialog();
                    // if we have less than vm.performanceLimit in this report, update the report
                    // if it's exceptionally long, don't. They can refresh manually if they'd like
                    if(timeReportService.report.data.length < vm.performanceLimit){
              	      $rootScope.$emit('updateTimeReport');
                    }
	              $mdToast.show($mdToast.adminjaAlert(
	                  {
	                      locals:{
	                          title: 'Time log updated!',
	                          message: '' ,
	                          color: 'green'
	                      }
	                }));// mdToast
	          });


	}// updateEntry

	vm.confirmDelete = false;
	$scope.startDelete = function(){
	  // $log.info('startDelete');
	  vm.confirmDelete = true;
	}

	$scope.cancelDelete = function(){
	  vm.confirmDelete = false;
	}

	$scope.deleteTime = function (entry) {
	  // $log.info('deleteTime');
	  // $log.info(entry);
	  $timeout(function(){
	      return timeDataService.deleteEntry(entry)
	              .then(function (response) {
	                 $mdToast.show($mdToast.adminjaAlert(
	                     {
	                         locals:{
	                             title: 'Time Log deleted',
	                             message: '' ,
	                             color: 'orange'
	                         }
	                   }));// mdToast
	                  $mdDialog.cancel(entry);
                        // if we have less than vm.performanceLimit in this report, update the report
                        // if it's exceptionally long, don't. They can refresh manually if they'd like
                        if(timeReportService.report.data.length < vm.performanceLimit){
                  	      $rootScope.$emit('updateTimeReport');
                        }
	              });
	  },0);
	}
	// We put the form on $scope.forms. so it's forced to attach to original instead of child scope
	// See name="forms.clientDialogForm" in dialog-client.html
	// https://stackoverflow.com/questions/22436501/simple-angularjs-form-is-undefined-in-scope
	$scope.forms = {};

	$scope.canLock = function(entry){
	  var admin = false, owner = false;
	  // find this client and check to see if user is admin
	  _.each(clientDataService.clients, function(client){
	      if(client.uid == entry.client){
	          if(client.access.admins[vm.user.uid]){
	              admin = true;
	          }
	          if(client.owner == vm.user.uid){
	              owner = true;
	          }
	      }
	  });

	  if(owner || admin){
	      return true
	  } else { return false}
	}

	// Setup Hotkeys for this dialog
	hotkeys.bindTo($scope)
	      // inhibit enter from submitting
	      .add({
	          combo: 'enter',
	          callback: function (event) {
	              event.preventDefault();
	              // $log.debug('enter blocked');
	          }
	      })
	      .add({
	          combo: 'ctrl+enter',
	          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
	          description: 'Save/Update Entry',
	          callback: function (event) {
	              // $log.debug('ctrl+enter');
	              event.preventDefault();
	              // $log.debug($scope.clientDialogForm);
	              var pristine = $scope.forms.timeDialogForm.$pristine,
	                      invalid = $scope.forms.timeDialogForm.$invalid;

	              if (!pristine && !invalid) {
	                  $scope.updateEntry($scope.vm.timeEntry);
	              }

	              if (!pristine && !invalid) {
	                  $scope.saveEntry($scope.vm.timeEntry);
	              }
	          }
	      });



	}
	; // end timeDialogController


})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('timeDataService', timeDataService);

    /* @ngInject */
    function timeDataService($rootScope, gateService, $mdToast, $q, $log, moment,  localStorageService, $http, pageDimensionsService, taskDataService, userDataService, clientDataService, $mdDialog, $timeout, $firebaseArray, $firebaseObject) {
        var service = {
            saveEntry: saveEntry,
            updateEntry: updateEntry,
            newLogEntry: newLogEntry,
            timeDialog: timeDialog,
            updateTotals: updateTotals,
            triggerReCalc: triggerReCalc,
            requestPDF: requestPDF,
            getEntry: getEntry,
            deleteEntry: deleteEntry,
            getTimeUserMenu: getTimeUserMenu,
            emailPDF : emailPDF,
            timeReportDialog: timeReportDialog,
            payrollReportDialog: payrollReportDialog,
            getPackageTime: getPackageTime
        };

        return service;

        var timers = [];

        function emailPDF(report){
            // if we need to do any additional prep to the report data, this is where we'd do it
            mailReportDialog(report)
        }


        function getPackageTime(packageID){
            return new Promise(function(resolve, reject){
                return $firebaseArray(firebase.database().ref('/time').orderByChild('packageID').equalTo(packageID))
                        .$loaded(function(packageTime){
                          return resolve(packageTime)
                        })
            })

        }// getPackageTime


        function mailReportDialog(report){
          $mdDialog.show({
              controller: 'emailTimeReportDialogController',
              controllerAs: 'vm', // see below
              templateUrl: 'app/app-services/timeDataService/emailReportDialog.html',
              parent: angular.element(document.body),
              locals: {
                  report: report
              },
              bindToController: true,
              focusOnOpen: false,
              multiple: true,
              clickOutsideToClose: true,
              fullscreen: true
          });
        }

        function timeReportDialog(report){
          $mdDialog.show({
              controller: 'timeReportModalController',
              controllerAs: 'vm', // see below
              templateUrl: 'app/app-services/timeDataService/timeReportModal.tmpl.html',
              parent: angular.element(document.body),
              locals: {
                  report: report
              },
              autoWrap: false,
              hasBackdrop: true,
              bindToController: true,
              clickOutsideToClose: true,
              fullscreen: true
          });
        }


        ///////////////////////////////////////////////////////////
        /// updateTotals
        // updates all log totals that a time entry might affect
        function updateTotals(timeEntry) {
                // $log.info('updateTotals');
            return new Promise(function(resolve, reject){
                // $log.info(timeEntry);

                // if assigned to a task, update that task's total
                if (_.has(timeEntry, 'task')) {
                    // $log.info('updating task totals');
                    return taskDataService.getTask(timeEntry.task)
                            .then(function (task) {
                                // $log.debug('have task, calculating...');
                                // $log.debug(task);
                                var total = 0;
                                _.each(task.time, function (entry) {
                                    total += entry.logged;
                                });

                                // $log.debug('total time:' + total);
                                // update single task property on /tasks and /clients/#/tasks/
                                var updates = {};

                                // store our canonical object
                                updates['/tasks/' + timeEntry.task + '/info/logged'] = total;

                                // if task is part of new muuri boards, update the board item
                                if(_.has(task.info, 'board')){
                                    updates['/taskBoards/' + task.info.board + '/lists/' + task.info.list + '/items/' + task.uid + '/logged'] = total;
                                }

                                // store our reference in the client
                                updates['/clients/' + timeEntry.client + "/tasks/" + timeEntry.task + '/logged'] = total;

                                // // store our reference in the user
                                // updates['/users/' + task.info.assignee + "/tasks/" + timeEntry.task + '/logged'] = total;

                                // Commit our updates
                                return firebase.database().ref().update(updates)
                                .then(function(){
                                    return resolve(true)
                                })
                            })
                            .then(function () {
                                // $log.info('updateTotals completed');
                                return resolve(true)
                            });

                } else {
                    return resolve(true)
                }// if timeEntry.task
            })


        }// updateTotals



        // Saves an empty 'deleteme' time log to a period to trigger that period's totals to be recalculated
        function triggerReCalc(period){
            // Create dummy time entry to trigger a calculation for this billingPeriod
            var newTimeKey = firebase.database().ref('/time').push().key,
                triggerEntry = {
                uid: newTimeKey,
                client: period.info.client,
                logDate: moment(period.info.start).add(1, 'day').toISOString(),
                flag: 'deleteMe',
                logged: 0
            };
            // Update the database with this period using the new key
            var updates = {};
            // Store our new time record
            updates['/time/' + newTimeKey] = triggerEntry;
            // Execute changes
            return firebase.database().ref().update(updates)
            .then(function(){
                // console.log('created period:' + results.billingPeriod.uid);
            });
        }




        ///////////////////////////////////////////////////////////
        /// getEntry
        // updates all log totals that a time entry might affect
        function getEntry(entryID) {
            // $log.info('getEntry');
            var entry = {},
                    d = $q.defer(),
                    entryRef = firebase.database().ref('time/' + entryID);
            return $firebaseObject(entryRef)
                    .$loaded(function (data) {
                        entry = data;
                        d.resolve(entry);
                        return d.promise;
                    })

        }//getEntry




        ///////////////////////////////////////////////////////////
        /// newLog
        // prepares a new empty log item
        function newLogEntry(clientID, taskID) {
            var userID = localStorageService.get('userID'),
                    logEntry = {
                        creator: userID,
                        creatorName: localStorageService.get('userName'),
                        client: clientID,
                        description: "",
                        timestamp: moment().toISOString(),
                        logDate: new Date()
                    }

            if (clientID) {
                logEntry.clientName = clientDataService.clientName(clientID);
                logEntry.clientColor = clientDataService.clientColor(clientID);
            }

            // $log.debug(logEntry);

            // if this is tied to a task
            if (taskID) {
                // store the task reference
                logEntry.task = taskID;
            }

            //heap.track('New Time entry started');
            userDataService.trackEvent('new-time-entry');
            // $log.debug('prepared entry', logEntry);
            return logEntry
        }// newLog


        ///////////////////////////////////////////////////////////
        // firstline utility for creating our task reference
        function firstLine(taskDescription) {
            var firstLineText = taskDescription.split('\n')[0];
            // $log.debug(firstLineText);
            return firstLineText
        }

        ///////////////////////////////////////////////////////////
        /// saveEntry
        function saveEntry(timeEntry, originalTimeEntry) {
            return new Promise(function(resolve, reject){
                 // $log.info('saveEntry');

                 // if our timeEntry was actually passed from an update (and thus has an $id)
                 // we need to clean it first
                 timeEntry = ajUTILITIES.removePropertiesWith(timeEntry);

                // IMPORTANT - we are validating requirement on the description field in the GUI via settings
                // BUT, for automatic CSV generation, we need a value here
                // SO, we are going to make sure it has one
                 if(!timeEntry.description){
                     timeEntry.description = "Time entry";
                 }

                 // Decorate with properties for API use
                 timeEntry.account = clientDataService.clientOwner(timeEntry.client);
                 timeEntry.accountCreated = timeEntry.account + moment(timeEntry.logDate).toISOString();
                 // If we are saving an entry for a personal workspace, rate will be undefined.
                 // but we need one.
                 if(!timeEntry.rate){
                     timeEntry.rate = 0;
                 }

                 var logDate = {};
                 logDate.longMonth = moment(timeEntry.logDate).format('MMMM');
                 logDate.day = moment(timeEntry.logDate).format('DD');
                 logDate.month = moment(timeEntry.logDate).format('M');
                 logDate.year = moment(timeEntry.logDate).format('YYYY');
                 logDate.week = moment(timeEntry.logDate).week();
                 // $log.debug(logDate); // 1)

                 timeEntry.longMonth = logDate.longMonth;
                 timeEntry.week = logDate.week;
                 timeEntry.year = logDate.year;
                 timeEntry.month = logDate.month;
                 timeEntry.day = logDate.day;

                 var textDate = moment(timeEntry.logDate).toISOString();
                 // The following two properties allow us to pull date range time on a user or client
                 timeEntry.userDate = timeEntry.creator + '-' + textDate;
                 timeEntry.clientDate = timeEntry.client + '-' + textDate;
                 timeEntry.packageDate = timeEntry.packageID + '-' + textDate;

                 if(_.has(userDataService.user, 'profile.avatar')){
                     timeEntry.creatorAvatar = userDataService.user.profile.avatar;
                 }


                 // // Set the time on our entry to noon (avoids potential DST issues)
                 // var noonLogDate = moment(timeEntry.logDate).clone().hour(12).minute(0).second(0);

                 // convert our logDate back to a string for Firebase
                 timeEntry.logDate = moment(timeEntry.logDate).toISOString();

                 // set single field for quicker firebaseArray querying by client/year
                 timeEntry.loadGroup = logDate.year + "_" + timeEntry.client;

                 // Fix our Log Amount
                 var totalTime = 0;
                 if (timeEntry.hours) {
                     totalTime = totalTime + (timeEntry.hours * 60);
                 }
                 if (timeEntry.minutes) {
                     totalTime = totalTime + (timeEntry.minutes * 1);
                 }
                 timeEntry.logged = totalTime;

                 // get client color for the entry
                 timeEntry.clientColor = clientDataService.clientColor(timeEntry.client);


                 // get unique ID for the new entry
                 var newEntryKey = firebase.database().ref().child('time').push().key;
                 timeEntry.uid = newEntryKey;

                 var updates = {};


                 // if we passed an original Time entry, that means the workspace was changed for this entry
                 // and we need to remove the original
                 // likewise, if not a workspace change, we can include task reference.
                 if(originalTimeEntry){
                     updates['/time/' + originalTimeEntry.uid] = null;
                     // also remove from task if it was assigned to one.
                     if(originalTimeEntry.task){
                         updates['/tasks/' + originalTimeEntry.task + '/time/' + originalTimeEntry.uid] = null;
                     }
                 } else if (_.has(timeEntry, 'task')) {
                     // Not changing workspaces? Then add to task if one exists.
                     updates['/tasks/' + timeEntry.task + '/time/' + newEntryKey] = timeEntry;
                 }


                 // store our canonical object
                 updates['/time/' + newEntryKey] = timeEntry;
                 // $log.info(timeEntry);
                 // Commit our updates
                 return firebase.database().ref().update(updates)
                         .then(function () {
                             // $log.info('saveEntry: updateTotals', timeEntry);
                             return updateTotals(timeEntry)
                             .then(function(){

                                //heap.track("Time Entry Saved");
                                 userDataService.trackEvent('save-time-entry');

                                 if (_.has(timeEntry, 'task')) {
                                 taskDataService.logTask(timeEntry.task, 'Time logged against task: ' + timeEntry.logged + ' minutes');
                                }

                                $rootScope.$emit('timeChanged', timeEntry);
                                return resolve(true)
                             })
                         })
                         .catch(function(error){
                            return reject(error)
                         });
            })// promise


        }// saveEntry

        ///////////////////////////////////////////////////////////
        /// updateEntry
        // prepares a new empty log item
        function updateEntry(timeEntry, originalTimeEntry) {
                $log.debug('updateEntry');
                if(originalTimeEntry){
                    $log.info('original passed');
                }
            return new Promise(function(resolve, reject){

                // if the client has been changed - we really need to save a new one and delete the original.
                // And this is handled in the saveEntry function if we provide the original as a parameter
                if(originalTimeEntry && timeEntry.client != originalTimeEntry.client){
                    $log.info('clientChanged');
                    return service.saveEntry(timeEntry, originalTimeEntry)
                    .then(function(){
                        return resolve(true)
                    });
                } else {
                    $log.info('client remained the same');
                    // // IMPORTANT - we are validating requirement on the description field in the GUI via settings
                    // // BUT, for automatic CSV generation, we need a value here
                    // // SO, we are going to make sure it has one
                    if(!timeEntry.description){
                        timeEntry.description = "Time entry";
                    }
                    // If we are saving an entry for a personal workspace, rate will be undefined.
                    // but we need one.
                    if(!timeEntry.rate){
                        timeEntry.rate = 0;
                    }
                    var newLogDate = moment(timeEntry.logDate).toISOString();
                    var saveEntry = angular.copy(timeEntry);
                    saveEntry.logDate = newLogDate;
                    // Split our logDate for easy reports
                    saveEntry.longMonth = moment(timeEntry.logDate).format('MMMM');
                    saveEntry.day = moment(timeEntry.logDate).format('DD');
                    saveEntry.month = moment(timeEntry.logDate).format('M');
                    saveEntry.year = moment(timeEntry.logDate).format('YYYY');
                    saveEntry.week = moment(timeEntry.logDate).week();
                    var updatedDate = moment().toISOString();
                    saveEntry.accountUpdated = clientDataService.clientOwner(timeEntry.client) + updatedDate
                    saveEntry.updated = updatedDate;
                    var textDate = moment(timeEntry.logDate).toISOString();
                    // The following two properties allow us to pull date range time on a user or client
                    saveEntry.userDate = saveEntry.creator + '-' + newLogDate;
                    saveEntry.clientDate = saveEntry.client + '-' + newLogDate;
                    saveEntry.packageDate = saveEntry.packageID + '-' + textDate;


                    // Set the time on our entry to noon (avoids potential DST issues)
                    // var noonLogDate = moment(saveEntry.logDate).clone().hour(12).minute(0).second(0);

                    // convert our logDate back to a string for Firebase
                    // saveEntry.logDate = moment(saveEntry.logDate).toISOString();


                    // set single field for quicker firebaseArray querying by client/year
                    saveEntry.loadGroup = saveEntry.year + "_" + saveEntry.client;

                    // Fix our Logged Amount based on vm.hours and vm.minutes fields
                    var totalTime = 0;
                    if (saveEntry.hours) {
                        totalTime = totalTime + (saveEntry.hours * 60);
                    }
                    if (saveEntry.minutes) {
                        totalTime = totalTime + (saveEntry.minutes * 1);
                    }
                    saveEntry.logged = totalTime;

                    // get client color for the entry
                    timeEntry.clientColor = clientDataService.clientColor(saveEntry.client);


                    // remove our temp variables used for collecting logtotal
                    delete saveEntry.hours;
                    delete saveEntry.minutes;

                    // Remove the stuff that firebase hates
                    delete saveEntry.$id;
                    delete saveEntry.$priority;

                    // this is where we will do our updating
                    var updates = {};

                    // $log.info('Final Entry: ', saveEntry);
                    // store our canonical object
                    updates['/time' + '/' + saveEntry.uid] = saveEntry;


                    // if there's an associated task, update that as well
                    if (saveEntry.task) {
                        // $log.info('has Task!');
                        // $log.info(saveEntry.task);
                        updates['tasks/' + saveEntry.task + '/time/' + saveEntry.uid] = saveEntry;
                    }

                    // If entry was moved to a different package, trigger a recalc on the package we are removing it from
                    if(_.has(saveEntry, 'packageID') && _.has(originalTimeEntry, 'packageID')){
                        if(saveEntry.packageID != originalTimeEntry.packageID){
                            updates['clientPackages/' + originalTimeEntry.packageID + '/recalc'] = true;
                        }
                    }


                    // // Make our updates
                    return firebase.database().ref().update(updates)
                    .then(function (response) {
                        $log.info('updates made');
                        // Call updateTotals to propagate our change to task and client
                        return updateTotals(saveEntry)
                        .then(function(){
                            $log.info('update totals done');
                            if(_.has(saveEntry, 'task')){
                                taskDataService.logTask(saveEntry.task, 'Time log modified');
                            }
                            $rootScope.$emit('timeChanged', saveEntry);
                            userDataService.trackEvent('update-time-entry');
                            return resolve(true)

                        })
                    })
                    .catch(function(error){
                        $log.info(error);
                        return reject(error);
                    });


                }

            })// promise

        }// updateEntry

        ///////////////////////////////////////////////////////////
        /// deleteEntry
        function deleteEntry(entry) {
            // $log.info(entry);
            var entryID = entry.uid;
            // var retainerMonth = entry.retainer_month;
            // $log.debug('deleteEntry');

            // Get our entry from the database (to make sure we are getting the correct dates and references)
            return getEntry(entryID)
                    .then(function (entry) {

                        // save our key properties so we can update our aggregates post-deletion
                        var oldEntry = {};
                        oldEntry.client = entry.client;
                        oldEntry.creator = entry.creator;
                        oldEntry.logged = entry.logged;
                        oldEntry.year = entry.year;
                        oldEntry.week = entry.week;
                        oldEntry.month = entry.month;
                        // oldEntry.retainer_month = retainerMonth;

                        // Prepare updates to remove from /time, /tasks/#id/time, and client/time
                        var updates = {}

                        // remove our log from client
                        updates['/clients/' + entry.client + "/time/" + entry.year + '/' + entry.month + '/' + entry.uid] = null;

                        // Remove our log from task
                        if (entry.task) {
                            updates['/tasks/' + entry.task + '/time/' + entry.uid] = null;
                            // store our taskID so we can retotal it later.
                            var taskID = entry.task;
                        }

                        // remove our canonical object
                        updates['/time/' + entry.uid] = null;

                        // Execute Updates

                        return firebase.database().ref().update(updates)
                                .then(function () {
                                    //heap.track('Time Log Deleted');
                                    //heap.track('userpilot Log Deleted');
                                    // Recalc task totals
                                    userDataService.trackEvent('delete-time-entry');
                                    if (taskID) {
                                        // $log.debug('attached to a task...let\'s recalc the task');
                                        taskDataService.reCalcTask(taskID);
                                        taskDataService.logTask(taskID, 'Time log deleted from task');

                                    }

                                    // Remove from clienttotals

                                    $rootScope.$emit('timeChanged', oldEntry);
                                //     clientDataService.getClient(oldEntry.client)
                                //             .then(function (clientData) {

                                //                 if (clientData.profile.plan.type == 'retainer') {

                                //                     /* Update Retainer view */
                                //                     var RetainerMonths = clientDataService.thisRetainerYear(clientData);
                                //                     $rootScope.$emit('timeChanged', RetainerMonths);

                                //                     $rootScope.$emit('timeChanged', RetainerWeeks);
                                //                 }
                                //             });

                                });
                    });
        }// deleteEntry


        ///////////////////////////////////////////////////////////
        /// requestPDF
        // Takes report data and requests a PDF for it from the cloud

        function requestPDF(report){
          // $log.info(report);
          // remove $id and $priority from our time entries so we can process
          _.each(report.time, function(entry){
            ajUTILITIES.removePropertiesWith(entry);
          })
          var pdfRef = firebase.database().ref('pdfRequests'),
              pdfKey = pdfRef.push().key;

          report.uid = pdfKey
          var updates = {};
          updates['pdfRequests/'+ pdfKey] = report;
          // $log.info(updates);
          return firebase.database().ref().update(updates)
                  .then(function () {
                      $log.info('Time report pdfRequest sent');
                  })
                  .catch(function(error){
                    $log.info('Didn\'t save PDF request.');
                    $log.info(error);
                  });
        }// requestPDF



        ///////////////////////////////////////////////////////////
        /// timeDialog
        // opens dialog with the prepared log entry

        function timeDialog(timeEntry, title) {
            // $log.debug('timeDialog');
            // $log.debug(timeEntry, title);

            // $log.debug($rootScope.user.gates);
            return userDataService.getLoggedInUser()
            .then(function (user) {
                // $log.debug(user);
                var canLogTime = true;

                if (!title) {
                    var title = "Edit"
                }

                // check to see if user has rights to edit this time entry
                // if user owns time and client - allow
                // if user owns time and is member on clients team and time is unlocked - allow
                // if user doesn't own time but is client owner or a client admin - allow
                var canEdit = false,
                    isAdmin = false,
                    isTimeOwner = false,
                    isClientOwner = false;


                if(timeEntry.creator == user.uid){
                    isTimeOwner = true;
                }

                // find this client and check to see if user is admin
                _.each(clientDataService.clients, function(client){
                    if(client.uid == timeEntry.client){
                        if(client.access.admins[user.uid]){
                            isAdmin = true;
                        }
                        if(client.owner == user.uid){
                            isClientOwner = true;
                        }
                    }
                });

                // if it's a client admin or it's the owner and it's unlocked, allow
                if(isAdmin || (isTimeOwner && !timeEntry.locked) || $rootScope.admin){
                    canEdit = true;
                }

                if(canEdit){
                    $mdDialog.show({
                        controller: 'timeDialogController',
                        controllerAs: 'vm', // see below
                        templateUrl: 'app/app-services/timeDataService/dialog-edit-time-entry.tmpl.html',
                        parent: angular.element(document.body),
                        locals: {
                            previousEntry: timeEntry,
                            assignedClients: clientDataService.clients,
                            title: title,
                            canLogTime: canLogTime
                        },
                        multiple: true,
                        bindToController: true,
                        focusOnOpen: false,
                        clickOutsideToClose: true,
                        fullscreen: true
                    });

                    // Set focus
                    $timeout(function () {
                        // if this is a new task, put the focus on the description field
                        if (!timeEntry.uid) {
                            angular.element("textarea[name='hours']").focus();
                        }
                    }, 100);
                }// if canEdit

                if(!canEdit && !isTimeOwner){
                    $mdDialog.show(
                         $mdDialog.alert()
                           .parent(angular.element(document.querySelector('#popupContainer')))
                           .clickOutsideToClose(true)
                           .title('This entry doesn\'t belong to you')
                           .textContent('We\'re sorry. You can only edit time that you\'ve logged yourself.')
                           .ok('Got it')
                       );
                }// if !canEdit

                if(!canEdit && isTimeOwner && timeEntry.locked){
                    $mdDialog.show(
                         $mdDialog.alert()
                           .parent(angular.element(document.querySelector('#popupContainer')))
                           .clickOutsideToClose(true)
                           .title('This entry has been locked by your administrator')
                           .textContent('Please ask them to unlock it in order to make changes.')
                           .ok('Got it')
                       );
                }

            });// getLoggedInUser
        }; //end timeDialog


        function payrollReportDialog(reportData, managedTeams) {
            $log.debug('payrollReport');
            $mdDialog.show({
                controller: 'payrollReportController',
                controllerAs: 'vm', // see below
                templateUrl: 'app/app-services/timeDataService/dialog-payroll-report.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    report: reportData,
                    teams: managedTeams
                },
                multiple: true,
                bindToController: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true
            });

        }; //end payrollReport

        function getTimeUserMenu(entry){
            return $timeout(function(){
                // get client
                // determine if user is admin or member
                var userType = 'member',
                    entryMenu = [];

                // find this client and check to see if user is admin
                _.each(clientDataService.clients, function(client){
                    if(client.uid == entry.client){
                        if(client.access.admins[$rootScope.userID]){
                            userType = 'admin'
                        }
                    }
                });

                var editButton = {
                        action: 'openTime',
                        param: entry,
                        label: 'Edit',
                        icon: 'fa fa-edit'
                    },
                    lockButton = {
                        action: 'lock',
                        param: entry,
                        label: 'Lock',
                        icon: 'fa fa-lock'
                    },
                    unLockButton = {
                        action: 'unlock',
                        param: entry,
                        label: 'Unlock',
                        icon: 'fa fa-unlock-alt'
                    },
                    memberLockButton = {
                        action: 'null',
                        param: entry,
                        label: 'This entry has been locked by your administrator.',
                        icon: 'fa fa-lock'
                    }

                if(userType == 'admin'){
                    entryMenu.push(editButton);

                    if(entry.locked){
                        entryMenu.push(unLockButton);
                    } else {
                        entryMenu.push(lockButton);
                    }
                }// if admin

                if(userType == 'member'){
                    if(!entry.locked){
                        entryMenu.push(editButton)
                    } else {
                        entryMenu.push(memberLockButton);
                    }
                } // if member

                return entryMenu
            },0)

        }// getTimeUserMenu


    } // end timeDataService


})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('payrollReportController', payrollReportController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// payrollReportController

        /* @ngInject */
        function payrollReportController($scope, $q, $mdDialog, $log, $rootScope, $timeout, CSV, $mdToast, clientDataService, teamDataService, gateService) {
            $log.info('payrollReportController');
            var vm = this;
            vm.gateService = gateService;
            vm.settings = $rootScope.userSettings;

             vm.currency = "$";
            if (_.has(vm.settings, 'currency')){
                 vm.currency = vm.settings.currency;
             }

            function init(){
              vm.results = {
                members: {},
                totalPayroll: 0,
                start: vm.locals.report.start,
                end: vm.locals.report.end
              };

              _.each(vm.locals.report.data, function(entry){
                // if no payrollRate for this entry, give it 0 to avoid errors

                // if member doesn't exist, add them to the members node
                if(!vm.results.members[entry.creator]){
                  // find the team member's node and get their info
                  _.each(vm.locals.teams, function(team){
                    if(team.ownerID == clientDataService.clientOwner(entry.client)){
                      _.each(team.members, function(member){
                        if(member.uid == entry.creator){
                          var payrollRate = 0;
                          if(_.has(member, 'payrollRate')){
                            payrollRate = Number(member.payrollRate);
                          }
                          var memberTotal = Number((entry.logged/60)*member.payrollRate),
                              currencyLabel = "USD",
                              currency = "$";

                          // Make sure we have default currency if none exist.
                          if(_.has(member, 'currencyLabel')){
                            currencyLabel = member.currencyLabel;
                            currency = member.currency
                          }

                          vm.results.members[entry.creator] = {
                            name: entry.creatorName,
                            email: member.email,
                            logged: Number(entry.logged),
                            payrollRate: payrollRate,
                            total: memberTotal,
                            currency: currency,
                            currencyLabel: currencyLabel
                          }


                          // vm.results.totalPayroll = Number(vm.results.totalPayroll) + memberTotal;
                          // $log.info('add ' + memberTotal + '=' + vm.results.totalPayroll);
                        }
                      });//each team member
                    }
                  });// each team

                } else {
                // already exists, just aggregate logged
                var memberLogged = Number(vm.results.members[entry.creator].logged) + Number(entry.logged),
                    memberTotal = Number((memberLogged/60)*vm.results.members[entry.creator].payrollRate);

                vm.results.members[entry.creator].logged = Number(memberLogged);
                vm.results.members[entry.creator].total = Number(memberTotal);
                // vm.results.totalPayroll = Number(vm.results.totalPayroll) + memberTotal;
                // $log.info('add ' + memberTotal + '=' + vm.results.totalPayroll);
                }

              });// each time entry.

              // calc our total
              _.each(vm.results.members, function(member){
                vm.results.totalPayroll = vm.results.totalPayroll + member.total;
              });
              $timeout(function(){
                vm.showReport = true;
              }, 0);
            }// init

            init();

            // download TXT
            vm.downloadTXT = function(data){
              var a = document.createElement("a"), payrollReport = '';
              _.each(data.members, function(member){
                var memberRecord = member.email + '\t' + member.total + '\t' + member.currencyLabel + '\t' + member.name + '\n';
                payrollReport = payrollReport + memberRecord;
              })


              a.href = 'data:text/plain;base64,' +  btoa(payrollReport);
              a.download = 'payroll-' + moment(vm.results.start).format('MM-DD-YY') + '-' + moment(vm.results.end).format('MM-DD-YY') + '.txt';
              a.click();
            }

            // Functionality for downloading CSVs
            vm.downloadCSVFile = function(data) {
              // $log.info('downloadCSV');
              // $log.info(data);
                       var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);

                       var downloader = document.createElement('a'),
                           filename = 'payroll-'+ moment(vm.results.start).format('MM-DD-YY') + '-' + moment(vm.results.end).format('MM-DD-YY')+ '.csv';

                       downloader.setAttribute('href', preppedData);
                       downloader.setAttribute('download', filename);
                       downloader.click();
            };

            vm.downloadCSV = function(results){
                // $log.info('prep downloadCSV');

                var cleanLogs = [];

                // Clean Up our logData (remove unnecessary things)
                _.each(results.members, function(member){
                    cleanLogs.push({
                      name: member.name,
                      email: member.email,
                      currency: member.currencyLabel,
                      rate: Number(member.payrollRate).toFixed(2).toString(),
                      logged: Number((Number(member.logged)/60).toFixed(2)).toString(),
                      total: Number(member.total).toFixed(2).toString()
                    });
                });

                // Set the header labels for our CSV file (note, we are accepting default alpha format)
                var csvOptions = {
                    'decimal-separator': '.',
                    'header': [
                        'Name',
                        'Email',
                        'Currency',
                        'Rate',
                        'Logged',
                        'Total'
                    ]
                }
                // $log.info(cleanLogs);

                // Convert our json to CSV and start the download
                CSV.stringify(cleanLogs, csvOptions).then(function(result){
                           vm.downloadCSVFile(result);
                       });
            }// downloadCSV


            vm.used = function(time){
                var used = 0;
                _.each(time, function(entry){
                    used = used + entry.logged;
                });

                return used
            }


            vm.cancelDialog = function(){
                $mdDialog.cancel();
            };
        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('emailTimeReportDialogController', emailTimeReportDialogController)
            .directive('multipleEmails', function () {
                    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

                    function validateAll(ctrl, validatorName, value) {
                        var validity = ctrl.$isEmpty(value) || value.split(',').every(
                            function (email) {
                                return EMAIL_REGEXP.test(email.trim());
                            }
                        );

                        ctrl.$setValidity(validatorName, validity);
                        return validity ? value : undefined;
                    }

                    return {
                        restrict: 'A',
                        require: 'ngModel',
                        link: function postLink(scope, elem, attrs, modelCtrl) {
                            function multipleEmailsValidator(value) {
                                return validateAll(modelCtrl, 'multipleEmails', value);
                            };

                            modelCtrl.$formatters.push(multipleEmailsValidator);
                            modelCtrl.$parsers.push(multipleEmailsValidator);
                        }
                    };
                });
;


function emailTimeReportDialogController($timeout, $mdDialog, $mdToast, $log, $scope, $rootScope, timeDataService, timeReportService, userDataService){
       // $log.info('emailTimeReportDialogController');
       var vm = this;
       vm.user = userDataService.user;
       // watch for our form to get setup and populate with client email if its a client-specific report
       $scope.$watch('vm.emailForm', function(form) {
           if(form && _.has(vm.report, 'clientID')) {
          	vm.recipientEmail = vm.report.clientEmail;
          	vm.emailForm.$setDirty();
          }
       });


       vm.cancel = function(){
       	$mdDialog.cancel();
       }// vm.cancel

       vm.sendPDF = function(email){
		// $log.info('send report pdf');
		$mdDialog.cancel();

		// put the email address on our report
       	vm.report.recipientEmail = email;
       	vm.report.pdf.recipientEmail = email;
       	vm.report.pdf.next = 'emailClient';
       	vm.report.pdf.senderEmail = vm.user.email;
       	vm.report.pdf.senderName = vm.user.profile.fullName;
       	vm.report.pdf.emailSubject = "New time report from " + vm.report.pdf.senderName;
       	vm.report.pdf.emailBody = 'Attached you\'ll find your time report from ' + vm.report.pdf.senderName+ '.\n';

       	// add our company logo to report if one is defined
       	if (_.has(vm.user, 'profile.logo')){
       	    vm.report.logo = vm.user.profile.logo
       	}
       	timeDataService.requestPDF(vm.report);
		$mdToast.show($mdToast.adminjaAlert(
		 {
		     locals:{
		         title: 'Woot!',
		         message: 'Your report is being prepared and will be emailed to ' + email +'.' ,
		         color: 'orange'
		     }
		}));// mdToast

  }// vm.sendPDF

   }// emailTimeReportDialogController


})();// af

(function () {
    'use strict';


    angular.module('appServices')
            .service('timerDataService', timerDataService);

    /* @ngInject */
    function timerDataService($log, moment,userDataService, clientDataService, $state, timeDataService, $mdDialog, $rootScope,
                $timeout, $interval, $firebaseArray, $firebaseObject, $q) {
        var service = {
            timerData: timerData,
            newTimer: newTimer,
            newTaskTimer: newTaskTimer,
            updateTimer: updateTimer,
            getTimer: getTimer,
            getTimers: getTimers,
            startTimer: startTimer,
            pauseTimer: pauseTimer,
            pauseTaskTimer: pauseTaskTimer,
            deactivateActiveTimer: deactivateActiveTimer,
            resumeTimer: resumeTimer,
            resumeSavedTimer: resumeSavedTimer,
            resumeSavedTaskTimer: resumeSavedTaskTimer,
            stopTimer: stopTimer,
            stopTaskTimer: stopTaskTimer,
            discardTimer: discardTimer,
            discardTaskTimer: discardTaskTimer,
            resetTimer: resetTimer,
            calcLogged: calcLogged,
            runTimer: runTimer,
            clearTimerData: clearTimerData,
            init: init,
            toggleTimerGui: toggleTimerGui,
            hasTimer: hasTimer
        };



        return service;

        // Initialize service.timerData object
        function init(){

            // Because our initial loading is based on authchanges and such,
            // this is sometimes called before userDataService.getLoggedInUser has completed.
            // So, if user isn't present, we'll just delay the init a few seconds.
            service.timerData = {};
            return getTimers();
            // if(_.has(service, 'user')){
            //     $timeout(function(){
            //          getTimers();
            //      }, 0);
            // } else {
            //     $timeout(function(){
            //         getTimers();
            //     }, 5000);
            // }
        }

        // global placeholder for our approxAccrued $interval so it can be cancelled anywhere in the service
        var timerCounter = undefined;

        /////////////
        // Toggle timer gui
        function toggleTimerGui(){
            if(service.showTimerGui){
                service.showTimerGui = false
            } else {
                service.showTimerGui = true
            }
            userDataService.changeUserSetting('showTimerGui', service.showTimerGui);
        }


        ////////////////////////////////////
        // newTaskTimer
        //
        // Uses existing methods to create, activate and start a new timer from a task card
        function newTaskTimer(task){
            // $log.info('newTaskTimer. Task:');
            // $log.info();
            deactivateActiveTimer();

            var targetClient = _.find(clientDataService.clients, function(o){return o.uid == task.client});
            var timer = newTimer(targetClient, task);

            // set our active client
            // only if there's no activeClient or if the activeClient is different from new timer's

            if (!_.has(service.timerData, 'activeClient')){
            // If we don't already have one, assign it
                service.timerData.activeClient = targetClient;
            } else if (service.timerData.activeClient.uid != targetClient.uid){
                // if we have activeClient and it's different from current client, assign it
                service.timerData.activeClient = targetClient;
            }

            //heap.track('New Task Timer Started');
            userDataService.trackEvent('start-new-timer');
            startTimer(timer, task);
        }// newTaskTimer

        //////////////////////////////////////////////////////
        // Calculates logged time off of timer events.
        // Recalculates entire timer on each pause or stop.
        function calcLogged(timer){
            // $log.info('calcLogged. Timer:');
            // $log.info(timer);
            var logged = 0;
            var start = undefined;

            // go through each timer.event and find start/stop times
            _.each(timer.events, function(timerEvent){
                // If it's a start event, store it's start time
                if(timerEvent.event == 'start'){
                    // store a start
                    start = timerEvent.when;
                }

                // If it's a stop event, compare to start time and add difference to logged
                // reset start time in prep for next event pair
                if (timerEvent.event == 'stop'){
                    // if it's a stop event, calculate against start
                    var end = timerEvent.when;
                    var difference = (end-start);
                    logged = Math.round(logged + (difference/1000));
                    start = undefined;
                }
            });
            // $log.info(logged + ' seconds logged.');
            // Update Accrued
            timer.accrued = logged;
            // Clear timer.lastStart so local elapsed will start fresh next time
            timer.lastStart =  undefined;
            // Save our changes
            updateTimer(timer);
        }

        ///////////////////////////////////////////////
        ///////////////getTimers////////////////////
        // Get all timer data of user
        function getTimers() {
            // $log.info('getTimers')
            return new Promise(function(resolve, reject){
                if(_.size(service.timerData.timers > 0)){
                    // we already have timers. returning
                    return resolve(service.timerData.timers)
                } else {
                    // we can't use the simpler user = userDataService.user here for some reason.
                    return userDataService.getLoggedInUser()
                    .then(function(user){
                        // set timer display based on user setting
                        service.showTimerGui = true;
                        if(_.has(user, 'profile.settings.showTimerGui')){
                            service.showTimerGui = user.profile.settings.showTimerGui;
                        }

                        // we dont have timers. getting and building our timerData object

                        // check for UID so it doesn't trigger during signups
                        if(_.has(user, 'uid')){
                                var timerRef = firebase.database().ref('users/' + user.uid + '/timers');
                                return $firebaseArray(timerRef)
                                .$loaded(function (data) {
                                    // Store our timers array on the service
                                    service.timerData.timers = data;

                                    //If there's an active timer, add it to timerData so directive picks it up on load/refresh
                                    var activeTimer  = _.find(service.timerData.timers, function (timer) {
                                        return timer.active == true;
                                    });

                                    // if we had a valid activeTimer - assign it
                                    // otherwise, make an empty one.
                                    if (_.size(activeTimer)){
                                        // make this our active timer immediately
                                        service.timerData.activeTimer = activeTimer;
                                        // set our active client so our md-select functions correctly
                                        service.timerData.activeClient = activeTimer.client;

                                        // if this timer was in an "on" state,
                                        // trigger our runTimer
                                        if (service.timerData.activeTimer.on){
                                        // grab localWhen from the last event and set it to lastStart so we can display it
                                            var lastEvent = _.last(service.timerData.activeTimer.events);
                                            service.timerData.activeTimer.lastStart = lastEvent.localWhen;
                                            // start runTimer
                                             runTimer();

                                        }// if activeTimer.on
                                    } else {
                                        service.timerData.activeTimer = {};
                                    }

                                    // return our timers
                                    return resolve(service.timerData.timers)
                            });
                        }// if userID

                });
                }
            })
        } // getTimers

        ///////////////////////////////////////////////
        /////////////// newwTimer ////////////////////
        // Creates a fresh timer object with client and taskID
        function newTimer(client, task){
            // $log.info('newTimer. client, task:');
            userDataService.trackEvent('new-timer');
            // this is duplicated in clientDataService.clientBrief
            // wasn't working well there so duplicated the code here to get it working
            var newClientBrief = {
                access: client.access,
                clientColor: client.profile.clientColor,
                email: client.profile.email,
                name: client.profile.fullName,
                order: client.order,
                owner: client.owner,
                status: client.status,
                uid: client.uid
            }

            if(_.has(client, 'profile.avatar')){
                newClientBrief.avatar = client.profile.avatar;
            }

            var timer = {};
            // $log.info('newTimer');
            // Task Data Prep (if present)
            if (task){
                var taskShadow={};
                taskShadow.logged = task.logged;
                taskShadow.title = task.description;
                taskShadow.uid = task.uid;
                taskShadow.client = task.client;
                if(_.has(task, 'budget')){
                    taskShadow.budget = task.budget;
                }
                // put it on our new timer
                timer.task = taskShadow;
            } // task data prep

            // add user info
            timer.userID = userDataService.user.uid;

            // Add client Info
            timer.client = newClientBrief;

            // Setup empty array to push events to
            timer.events = [];

            // Timer State Prep
            //-----------------
            // Set this timer to be active
            timer.active = true;
            // Set timer's state to on
            timer.on = false;
            // Give it zero time accrued
            timer.accrued = 0;

            // our ephemeral approxAccrued for displaying live count to our users
            // it will always be 0 as far as firebase is concerned.
            // we use it and throw it away in between firebase updates
            timer.approxAccrued = 0;

            // set it to our active timer
            service.timerData.activeTimer = timer;

            // set our active client for our md-select
            // but only if we need to
            // service.timerData.activeClient = timer.client;

            if (!_.has(service.timerData, 'activeClient')){
            // If we don't already have one, assign it
                service.timerData.activeClient = timer.client;
            } else if (!_.has(service.timerData, 'activeClient.uid') && service.timerData.activeClient.uid != timer.client.uid){
                // if we have activeClient and it's different from current client, assign it
                service.timerData.activeClient = timer.client;
            }


            return service.timerData.activeTimer
        }


        ///////////////////////////////////////////////
        ///////////////Start Timer////////////////////
        // Store and Start timer
        function startTimer(timer, task) {
            // If they are on a free plan (taking consideration extra workspace gifts) we need to limit # of timers open to 3
            // Note, we are only checking this for workspaces the user owns.
            // If the timer is for a delegated (aka paid team) workspace, we ALWAYS want to allow a new timer.
            var numClients = Number(userDataService.user.limits.clients),
                numTimers = _.size(service.timerData.timers);
            if(numClients < 5 && numTimers > 2 && timer.client.owner == userDataService.user.uid){
               var confirm = $mdDialog.confirm()
                         .title('Timer Limit Reached')
                         .htmlContent('<p>Your subscription plan has a 3 timer limit for your Workspaces.<br>Upgrade to a different plan and juggle up to 10 timers at once.</p>')
                         .ariaLabel('Timer Limit Reached')
                         .ok('View Plans')
                         .cancel('Ok');

                   return $mdDialog.show(confirm).then(function() {
                    // go to profile
                     $state.go('authentication.profile', {selectedTab: 5});
                   }, function() {

                   });
            }// if over timer limit


            // Store lastStart for accurate time elapsed display
            timer.lastStart =  moment().format('x');

            // add start event to this timer's events array
            timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': timer.lastStart});

            // Set timer to on
            timer.on = true;

            // get unique ID for the new timer
            var newEntryKey = firebase.database().ref().child('users/' + timer.userID + '/timers').push().key;
            timer.uid = newEntryKey;

            // make sure we have a clean, simple object
            var thisTimer = angular.fromJson(angular.toJson(timer));

            // declare our array of updates to make
            var updates = {};




            // store data in the Users -> timers
            updates['/users/' + thisTimer.userID + '/timers/' + newEntryKey] = thisTimer;


            // Commit our updates
            return firebase.database().ref().update(updates)
            .then(function(response){

                // IMPORTANT - go through timer array and BIND activeTimer to the one that we just added
                _.each(service.timerData.timers, function(timer){
                    // if we found our active timer...
                    if(timer.uid == newEntryKey){
                        // assign it to activeTimer
                        service.timerData.activeTimer = timer;
                    }
                })
            })
            .then(function(){
                // Start our runTimer to show elapsed in GUI
                    userDataService.trackEvent('start-timer');
                    // if there was a task on this timer, update it so it refreshes
                    // if timer is on a task, store timer info on the task itself
                    if(task){

                        // parse through clients/tasks to find this task and update it
                        _.each(clientDataService.clients, function(client){
                            if(client.uid == thisTimer.task.client){
                                _.each(client.tasks, function(task){
                                    if(task.uid == thisTimer.task.uid){
                                        var updates = {};
                                        updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid + '/timerUpdated'] = (moment().toISOString());
                                        updates['/clients/' + task.client + '/tasks/' + task.uid + '/timerUpdated'] =(moment().toISOString());
                                        return firebase.database().ref().update(updates)
                                        .then(function(){
                                            runTimer();
                                        })
                                    }
                                })
                            }
                        })
                    } else {
                        runTimer();

                    }// if task

            });

        }// startTimer


        function pauseTimer(timer) {
            timer.displayColor = 'rgba(0,0,0,.5)'
            // $log.info('pauseTimer. timer:');
            // $log.info(timer);
            // As a safety check, we call pause alot
            // only pause if it's running. we don't need unnecessary events logged
            if(timer.on){
                // Cancel our runTimer
                $interval.cancel(timerCounter);
                // add start event to this timer's events array
                timer.events.push({'event': 'stop', 'when': firebase.database.ServerValue.TIMESTAMP});
                // Turn off the timer
                timer.on = false;
                // Save our updated timer
                // //heap.track('Timer Paused');
                return updateTimer(timer)
                .then(function(){
                    // calculate our new "accrued" total and save it
                    calcLogged(timer);
                    userDataService.trackEvent('pause-timer');
                    // Adding this because we need to refresh our user
                    // he's losing .gates when timer is updated on timer start
                    // vm.user is already bound to the service, we are just refreshing that variable
                    // Nov 10, 2020 - disabling. This is heavy and we need to make sure we need it
                    // return userDataService.getLoggedInUser(true);
                });
            }
        }

        // Safely pause and/or deactivate timer and update only if necessary.
        // Result is a cleaned up timer, if there was one active
        // Pattern is probably inefficient, but easy to read
        function deactivateActiveTimer() {
            // $log.info('deactivateActiveTimer');
            var timer = service.timerData.activeTimer;
            var needsUpdate = false;
            if(timer){
                if (timer.on){
                    needsUpdate = true;
                    timer.on = false;
                    // Cancel our runTimer
                    $interval.cancel(timerCounter);
                    // add start event to this timer's events array
                    timer.events.push({'event': 'stop', 'when': firebase.database.ServerValue.TIMESTAMP});
                }

                if (timer.active){
                    needsUpdate = true;
                    timer.active = false;
                }

                if (needsUpdate){
                    return updateTimer(timer)
                    .then(function(){
                        calcLogged(timer);
                    });
                }
            }
        }// deactivateTimer

        function resumeTimer(timer) {
            // $log.info('resumeTimer', timer);
            // $log.info(timer);
          // add start event to this timer's events array
            timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': moment().format('x')});
            timer.on = true;
            timer.active = true;
            timer.lastStart =  moment().format('x');

            // Save our updated timer
           return updateTimer(timer)
           .then(function(){
                userDataService.trackEvent('resume-timer');
                // //heap.track('Timer Resumed');
                 runTimer();
           });

        }

        function hasTimer(task){
            // $log.info('hasTimer');
            // $log.info('looking for ' + task.uid);
            var found = false;
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.uid){
                              found = true;
                              // $log.info('found timer!');
                          }
                      }
                  });// each timer

            return found
        }//hasTimer


        function pauseTaskTimer(task){
            // $log.info('pauseTaskTimer', task);
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.uid){
                              // //heap.track('Timer Paused');
                              userDataService.trackEvent('pause-task-timer');
                              service.pauseTimer(timer);
                          }
                      }
                  });// each timer
        }


        function resumeSavedTaskTimer(task){
            // $log.info('resumeSavedTaskTimer', task);
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.uid){
                              service.resumeSavedTimer(timer);
                              userDataService.trackEvent('resume-task-timer');
                          }
                      }
                  });// each timer
        }


        function discardTaskTimer(task){
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == task.uid){
                            $log.info('found!');
                            var confirm = $mdDialog.confirm()
                                .title('Discard Timer?')
                                .textContent('Are you sure you want to discard this timer?')
                                .ariaLabel('Confirm')
                                .ok('Do it!')
                                .cancel('Cancel');
                            $mdDialog.show(confirm).then(function() {
                                  service.discardTimer(timer.uid);
                            })
                          }
                      }
                  });// each timer
        }//discardTaskTimer

        function resumeSavedTimer(timer){


            //
            // $log.info('resumeSavedTimer. timer:');
            // $log.info(timer);
            // If we have an activeTimer - pause and deactivate it
            if(_.has(service.timerData, 'activeTimer.active')){
                // make sure it's active and we are NOT resuming an active/paused timer (don't want to wipe it out before resuming)
                if (service.timerData.activeTimer.active && service.timerData.activeTimer.uid != timer.uid){
                    deactivateActiveTimer(service.timerData.activeTimer);
                }
            }
            // $log.info(service.timerData.activeClient);
             // Add Event
              timer.events.push({'event': 'start', 'when': firebase.database.ServerValue.TIMESTAMP, 'localWhen': moment().format('x')});

              // Set properties
              timer.on = true;
              timer.active = true;
              timer.lastStart =  moment().format('x');

              // reset accrued to actual
              timer.approxAccrued = timer.accrued;

              // make it our active timer
              service.timerData.activeTimer = timer;

              // Only set the activeClient if it's not set
              // or if it needs to be set to a DIFFERENT client
              // otherwise, the md-select will fail as it triggers a new timer.)
              if (!_.has(service.timerData, 'activeClient')){
                // $log.info('no activeClient. setting.');
                // no activeClient. Setting.
                service.timerData.activeClient = timer.client;
              } else if (_.has(service.timerData, 'activeClient.uid') && _.has(timer, 'client.uid')){
                if (service.timerData.activeClient.uid != timer.client.uid){
                    // $log.info('activeClient needs changing. setting.');
                    // activeClient nees to change. Setting.
                    service.timerData.activeClient = timer.client;
                }

              } else {
                // $log.info('*activeClient untouched.');
                // activeClient should stay the same. Doing nothing.
              }

              // Update in FB
              return updateTimer(service.timerData.activeTimer)
              .then(function(){
                    // //heap.track('Resume Timer');
                    userDataService.trackEvent('resume-saved-timer');
                    runTimer();
              });
        }

        function stopTaskTimer(taskID){
            _.each(service.timerData.timers, function(timer){
                      if (_.has(timer, 'task')){
                          if(timer.task.uid == taskID){
                              service.stopTimer(timer);
                          }
                      }
                  });// each timer
        }//stopTaskTimer

        function stopTimer (timer){
            // $log.info('stopTimer. timer:');
            // $log.info(timer);

            var roundUpTo = 1;
            if(_.has(userDataService, 'user')){
                if(_.has(userDataService.user, 'profile.settings.roundUpTo')){
                    roundUpTo = userDataService.user.profile.settings.roundUpTo;
                }
            };

            $q.when(pauseTimer(timer))
            .then(function(){
                // $log.info(timer);
                // get a fresh logEntry to work with
                var timeEntry = timeDataService.newLogEntry(timer.client.uid);
                // if our timer has an associated task, pass it on
                if(_.has(timer, 'task')){
                    timeEntry.task = timer.task.uid;
                    if(_.has(timer, 'task.title')){
                        timeEntry.taskName = timer.task.title;
                    } else {
                        timeEntry.taskName = "undefined";
                    }
                }
                // convert accrued into hours and minutes for our form
                var totalMinutes = timer.accrued/60;
                // round up total minutes to nearest roundUpTo
                totalMinutes = Math.ceil(totalMinutes/roundUpTo)*roundUpTo;

                var hours = Math.floor(totalMinutes / 60),
                minutes = (totalMinutes % 60);

                // Make sure we return 0 for no results
                timeEntry.hours = _.toString(Math.round(hours) || 0);
                timeEntry.minutes = _.toString(Math.round(minutes) || 0);
                timeEntry.timerID = timer.uid;

                // if we already provided a description for this. Prepopulate it
                if (_.has(timer, 'description')){
                    timeEntry.description = timer.description;
                }

                // $log.info(timeEntry);

                // Notify HEAP
                //heap.track('Timer Closed');
                userDataService.trackEvent('stop-timer');
                // Pass it to our time dialog form for user to complete
                timeDataService.timeDialog(timeEntry, "Log");
            });
        }

        function timerData () {
            return service.timerServiceData;
        }



        ///////////////////////////////////////////////
        ///////////////Update Timer////////////////////
        function updateTimer(timer) {
            // $log.info('updateTimer. timer:');
            var thisTimer = angular.fromJson(angular.toJson(timer));
            ajUTILITIES.removePropertiesWith(thisTimer);
            var updates = {};

            // if(_.has(timer, 'task')){
            //  traverse through clientData.tasks to find the task
            //  and trigger it to refresh
            //  updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid + '/timerUpdated'] = moment().toISOString();
            // }

            // // store data in the Users -> timers
            updates['/users/' + thisTimer.userID + '/timers/' + timer.uid] = thisTimer;

            // Commit our updates
           return firebase.database().ref().update(updates)
           .then(function(){
            // Update our task states
            if(_.has(thisTimer, 'task')){
                _.each(clientDataService.clients, function(client){
                    if(client.uid == thisTimer.task.client){
                        _.each(client.tasks, function(task){
                            if(task.uid == thisTimer.task.uid){
                                var updates = {};
                                updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid + '/timerUpdated'] = (moment().toISOString());
                                updates['/clients/' + task.client + '/tasks/' + task.uid + '/timerUpdated'] =(moment().toISOString());
                                return firebase.database().ref().update(updates)
                            }
                        })
                    }
                })

            }
           });
        } // updateTimer

        /////////////////////////////////////////////////////////
        //// Get Timer Data according to userID and TimerID ////

        function getTimer(userID, timerID) {
            // $log.info('getTimer. userID, timerID:');
            // $log.info(userID);
            // $log.info(timerID);
            var timerRef = firebase.database().ref('users/' + userID + '/timers/' + timerID);
            return $firebaseObject(timerRef)
                    .$loaded(function (timer) {
                        return timer;
                    });
        }// getTimer


        function resetTimer(){
            // $log.info('resetTimer');
            delete service.timerData.activeClient;
            service.timerData.activeTimer = { accrued: 0, approxAccrued: 0};
        }

        ///////////////////////////////////////////////
        ///////////////delete Timer////////////////////
        // Delete timer record from list
        // need to do this by ID so it's accessible to our timeDialog after time is officially submitted
        function discardTimer(timerID) {
            $log.info('discardTimer. timerID:');
            $log.info(timerID);
            _.each(service.timerData.timers, function(timer){
                // Find the timer by ID
                if(timer.uid == timerID){
                    // if timer is the Active one, remove it from active and reset our timer first
                    if (timer.active){
                        resetTimer();
                    }

                    var updates = {}
                    updates['/users/' + timer.userID + '/timers/' + timer.uid ] = null;
                    // Execute Updates
                    return firebase.database().ref().update(updates)
                    .then(function(){
                        if(_.has(timer, 'task')){
                            _.each(clientDataService.clients, function(client){
                                if(client.uid == timer.task.client){
                                    _.each(client.tasks, function(task){
                                        if(task.uid == timer.task.uid){
                                            var updates = {};
                                            updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid + '/timerUpdated'] = (moment().toISOString());
                                            updates['/clients/' + task.client + '/tasks/' + task.uid + '/timerUpdated'] =(moment().toISOString());
                                            return firebase.database().ref().update(updates)
                                        }
                                    })
                                }
                            })
                        }
                        //heap.track('Timer Discarded');
                        userDataService.trackEvent('discard-timer');
                    });
                }
            })

        }

        // runTimer
        //
        // runTimer's ONLY reason for existing is to provide a visual indicator of time elapsed.
        // it is not used to "count" time.
        //
        // runTimer relies on the local timeStamp (lastStart) for a timer's start/resume time to calculate and display total time elapsed (timer.approxAccrued).
        // When a timer is paused, the ACTUAL time elapsed (may be different by <1sec) is calculated based on server timestamps (for ensured accuracy.)
        // and is committed as the official timer.accrued.
        //
        // FYI: lastStart is logged with timer start events as "localWhen" and is also used to rebuild a running timer on page refresh or login from another browser


        function runTimer(){
             // $log.info('runTimer');
            // $log.info('runTimer');


            if(_.has(service, 'timerData.activeClient.profile.clientColor')){
                var color = _.trim(service.timerData.activeClient.profile.clientColor, '#');
                color = ajUTILITIES.lightenDarkenColor(color, +30);
                service.timerData.activeTimer.displayColor = '#' + color;
            }

            timerCounter = $interval(function() {
                // get local lastStart for timer
                if(_.has(service,'timerData.activeTimer.lastStart')){
                    // determine now
                    var rightNow = moment().format('x'),
                    lastStart = service.timerData.activeTimer.lastStart,
                    // calculate elapsed time
                    elapsed = Math.round((rightNow - lastStart)/1000),
                    // calculate approxAccrued
                    approxAccrued = service.timerData.activeTimer.accrued + elapsed;
                    // LOCALLY Update our bound display variable
                    service.timerData.activeTimer.approxAccrued = approxAccrued;
                    // $log.info('activeTimer accrued='+ service.timerData.activeTimer.approxAccrued)
                }
             }, 200, undefined, true);

            // Adding this because we need to refresh our user
            // he's losing .gates when timer is updated on timer start
            // vm.user is already bound to the service, we are just refreshing that variable
            // Nov 10, 2020 - disabling. This is heavy and we need to make sure we need it
            // return userDataService.getLoggedInUser(true);
        }

        function clearTimerData(){
            delete service.timerData.timerList;
            delete service.timerData.activeTimer;
        }

    } // end timerDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('timeReportService', timeReportService);

    /* @ngInject */
    function timeReportService($log, moment, taskDataService,
                userDataService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $interval, $firebaseArray, $firebaseObject, teamDataService) {
        var service = {
            report: [],
            getUsersTime: getUsersTime,
            getClientsTime: getClientsTime,
            getEveryClientsTime: getEveryClientsTime,
            setMonthList: setMonthList,
            setRetainerList: setRetainerList,
            setWeekList: setWeekList,
            returnClientsTime: returnClientsTime,
            setDateRangeFromSetting: setDateRangeFromSetting,
            init: init
        };

        init();
        return service;


        // Initialize service.timerData object
        function init(){
            var user = firebase.auth().currentUser;

            if (user){
                // define our state variable
                service.report.source = 'all'
                service.report.view = 'month';
                service.report.filter = "";
                service.report.start = moment().startOf('month').subtract(1, 'month').toDate();
                service.report.end = moment().endOf('month').toDate();

              service.report.data = {};
              service.report.loading = false;
              service.report.selectedClient = 'all';
              service.report.selectedMember = 'all';


            }
        }




        function setDateRangeFromSetting(rangeSetting){
          // $log.info('switch rangeSetting: ' + rangeSetting);
          switch(rangeSetting) {
            case 'saved':

              if(_.has($rootScope.userSettings, 'reportStart')){
                service.report.start = moment($rootScope.userSettings.reportStart).startOf('day').toISOString();
                service.report.end = moment($rootScope.userSettings.reportEnd).endOf('day').toISOString();
              } else {
                service.report.start = moment().startOf('week').startOf('day').toISOString();
                service.report.end = moment().endOf('day').toISOString();
              }
              break;

            case 'last7':

              service.report.start = moment().subtract(7, 'days').startOf('day').toISOString();
              service.report.end = moment().endOf('day').toISOString();
              break;

            case 'last14':

              service.report.start = moment().subtract(14, 'days').startOf('day').toISOString();
              service.report.end = moment().endOf('day').toISOString();
              break;

            case 'last30':

              service.report.start = moment().subtract(30, 'days').startOf('day').toISOString();
              service.report.end = moment().endOf('day').toISOString();
              break;

            case 'last90':

              service.report.start = moment().subtract(90, 'days').startOf('day').toISOString();
              service.report.end = moment().endOf('day').toISOString();
              break;

            case 'thisMonth':

              service.report.start = moment().startOf('month').startOf('day').toISOString();
              service.report.end = moment().endOf('month').endOf('day').toISOString();
              break;

            default:
            if(_.has($rootScope.userSettings, 'reportStart')){
              service.report.start = moment($rootScope.userSettings.reportStart).startOf('day').toISOString();
              service.report.end = moment($rootScope.userSettings.reportEnd).endOf('day').toISOString();
            } else {
              service.report.start = moment().startOf('week').startOf('day').toISOString();
              service.report.end = moment().endOf('day').toISOString();
            }
          }// set DateRange based on setting
        }

        // Returns all time logged by user (uid) between start and end.
        function getUsersTime(uid, end, start){


            // $log.info('getUsersTime');
            service.report.loading = true;
            return new Promise(function(resolve, reject){
             var thisStart = moment(start).startOf('day').toISOString(),
                 thisEnd = moment(end).endOf('day').toISOString(),
                 timeRef = firebase.database().ref('time');
                 // clear our data. it's causing problems
                 service.report.data = [];
                 $firebaseArray(timeRef.orderByChild("creator").equalTo(uid))
                   .$loaded(
                       function (data) {
                         var time = [];

                         _.each(data, function(entry){
                           var entryLogDate = entry.logDate;
                             if(entryLogDate >= thisStart && entryLogDate < thisEnd && !entry.flag){
                                 if(!_.has(entry, 'rateLabel')){
                                   entry.rateLabel = "default";
                                 }
                                 time.push(entry);
                             }
                         });
                         $timeout(function(){
                              service.report.data = time;
                              service.report.loading = false;
                         }, 200);
                      resolve(time);
                });
            });// return promise
        }// getUsersTime

        function getEveryClientsTime(clients, end, start){
           var time = [],
           reads = [],
           timeRef = firebase.database().ref('time');
           service.report.data = [];
           service.report.loading = true;

           _.each(clients, function(client){
            // $log.info('processing client:' + client.uid);

              var thisStart = client.uid + '-' + start,
                  thisEnd = client.uid + '-' + end,
                  promise = timeRef.orderByChild('clientDate').startAt(thisStart).endAt(thisEnd)
                  .once('value', function(snapshot){
                   var data = snapshot.val();
                   if(data){
                     // $log.info(data);
                     _.each(data, function(entry){
                       // $log.info('entry: ' + entry.uid);
                         var entryLogDate = entry.logDate;
                         if(!entry.flag && entry.creator){
                             // $log.info(entryLogDate + ' is in between ' + thisStart + ' and ' + thisEnd);// $log.info(entry);
                             if(!_.has(entry, 'rateLabel')){
                               entry.rateLabel = "default";
                             }
                             // check to make sure user SHOULD see this entry

                             if(entry.creator == $rootScope.userID){
                               if(service.report.selectedMember == "all"){
                                   time.push(entry);
                               } else if (service.report.selectedMember == entry.creator){
                                 time.push(entry);
                               }
                             }  else if (client.status == 'archived'){
                              // Only team admins and owners will have access to view the archived option. No other checks needed
                              time.push(entry)
                             } else
                             // not owned by user and client in't archived...make sure they have permission to see this time
                             {
                               if(_.has(teamDataService.clientTeams, client.uid)){
                                   if(_.has(teamDataService.clientTeams[client.uid], $rootScope.userID)){
                                    var role = 'member';
                                    if(teamDataService.clientTeams[client.uid][$rootScope.userID].role != 'member' || teamDataService.isTeamAdmin($rootScope.userID, client.owner)){
                                      role = 'admin';
                                    }
                                    if(role != 'member') {
                                     if(service.report.selectedMember == 'all'){
                                       time.push(entry);
                                     } else if (service.report.selectedMember == entry.creator){
                                       time.push(entry);
                                     }
                                    } // if role is not member
                                   } // if has role
                               }// if has team
                             }// if permission

                         }// if no flag
                     });// each entry
                   }
                  }); //timeRef

              reads.push(promise);
           });// each client

           return Promise.all(reads)
           .then(function(){
              $timeout(function(){
                   service.report.data = time;
                   service.report.loading = false;
                   return service.report.data;
              }, 0);
           });

        }// getEveryClientsTime



       function oldGetEveryClientsTime(clients, end, start){
          var time = [];
          service.report.data = [];

          _.each(clients, function(client){
           // $log.info('processing client:' + client.uid);
             service.report.loading = true;
             var thisStart = client.uid + '-' + start,
                 thisEnd = client.uid + '-' + end + '~',
                 timeRef = firebase.database().ref('time');
                 // $log.info('Start: ' + thisStart);
                 // $log.info('End: ' + thisEnd);

                 // This is only giving us entries from 10/10 onward. Why is that?
                timeRef.orderByChild('clientDate').startAt(thisStart).endAt(thisEnd)
                 .once('value', function(snapshot){
                  var data = snapshot.val();
                  if(data){

                    // $log.info(data);
                    _.each(data, function(entry){
                      // $log.info('entry: ' + entry.uid);
                        var entryLogDate = entry.logDate;
                        if(!entry.flag && entry.creator){
                            // $log.info(entryLogDate + ' is in between ' + thisStart + ' and ' + thisEnd);// $log.info(entry);
                            if(!_.has(entry, 'rateLabel')){
                              entry.rateLabel = "default";
                            }
                            // check to make sure user SHOULD see this entry
                            if(entry.creator == $rootScope.userID){
                              if(service.report.selectedMember == "all"){
                                  time.push(entry);

                              } else if (service.report.selectedMember == entry.creator){
                                time.push(entry);
                              }
                            }  else {
                              if(_.has(teamDataService.clientTeams, client.uid)){
                                  if(_.has(teamDataService.clientTeams[client.uid], $rootScope.userID)){
                                   if(teamDataService.clientTeams[client.uid][$rootScope.userID].role != 'member') {
                                    if(service.report.selectedMember == 'all'){
                                      time.push(entry);

                                    } else if (service.report.selectedMember == entry.creator){
                                      time.push(entry);
                                    }
                                   } // if role is not member
                                  } // if has role
                              }// if has team
                            }// if permission

                        }// if no flag
                    });// each entry
                  }
                 }); //timeRef
          });// each client


           $timeout(function(){
               // $log.info(time);
                service.report.data = time;
                service.report.loading = false;
           }, 200);

       }// getEveryClientsTime

        // Assigns all time logged for a client (uid) between start and end to service
        function getClientsTime(clientID, end, start){
          // $log.info('GetClientsTime: ' + start + ' - ' + end);
            service.report.loading = true;
            service.report.data.length = 0;
            var thisStart = clientID + '-' + moment(start).toISOString(),
                // extending end by 1 month so we are sure to include current retainer period if this is a retainer report
                thisEnd = clientID + '-' + moment(end).toISOString(),
                timeRef = firebase.database().ref('time'),
                time = [],
                thisTeam = undefined;

                if(_.has(teamDataService.clientTeams, clientID)){
                  thisTeam = teamDataService.clientTeams[clientID];
                }// if team
                timeRef.orderByChild('clientDate').startAt(thisStart).endAt(thisEnd)
                 .once('value', function(snapshot){
                  var data = snapshot.val();
                  if(data){
                    _.each(data, function(entry){
                        var entryLogDate = entry.logDate;
                        if(!entry.flag && entry.creator){
                            // $log.info(entryLogDate + ' is in between ' + thisStart + ' and ' + thisEnd);// $log.info(entry);
                            if(!_.has(entry, 'rateLabel')){
                              entry.rateLabel = "default";
                            }
                            // check to make sure user SHOULD see this entry
                            var pushed = false;
                            if(entry.creator == $rootScope.userID || _.has($rootScope.VAWorkspaces, clientID)){
                              if(service.report.selectedMember == 'all'){
                                pushed = true;
                                time.push(entry);
                              } else if (service.report.selectedMember == entry.creator){
                                pushed = true;
                                time.push(entry);
                              }
                            }  else {
                                if(_.has(thisTeam, $rootScope.userID)){
                                 if(thisTeam[$rootScope.userID].role != 'member') {
                                  if(service.report.selectedMember == 'all'){
                                    pushed = true;
                                    time.push(entry);
                                  } else if (service.report.selectedMember == entry.creator){
                                    pushed = true;
                                    time.push(entry);
                                  }
                                 } // if role is not member
                                } // if has role

                            }// if permission
                            if(!pushed && $rootScope.admin == 'admin'){
                              time.push(entry)
                            }
                        }// if no flag
                    });// each entry
                    $timeout(function(){
                        // $log.info(time);
                         service.report.data = time;
                         // $log.info(service.report.data);
                         service.report.loading = false;
                    }, 200);
                  }

                 }); //timeRef



        }// getClientsTime

        // Returns all time logged for a client (uid) between start and end to service
        // DOES NOT persist with service
        function returnClientsTime(uid, end, start){
            // $log.info('returnClientsTime');
            var thisStart = moment(start).startOf('day').toISOString(),
                // extending end by 1 month so we are sure to include current retainer period if this is a retainer report
                thisEnd = moment(end).endOf('day').add(1, 'month').toISOString(),
                timeRef = firebase.database().ref('time');
            service.report.data = [];
            $firebaseArray(timeRef.orderByChild("client").equalTo(uid))
              .$loaded(
                  function (data) {
                    var time = [];
                    _.each(data, function(entry){
                      var entryLogDate = entry.logDate;
                        if(entryLogDate >= thisStart && entryLogDate < thisEnd){
                            // make sure entry has a rateLabel node
                            if(!_.has(entry, 'rateLabel')){
                              entry.rateLabel = "default";
                            }
                            time.push(entry);

                        }
                    });
                    return time;
              });
        }// returnClientsTime

        // Returns an array of months (default 6 from end month unless start specified)
        function setMonthList(end, start){
            // $log.info('setMonthList');
            service.report.loading = true;
            var dateStart = moment(start);
            var dateEnd = moment(end);
            var months = [];

            //NOTE: Due to moment behavior, need to subtract 1 day from month end to get proper range.
            while (dateEnd > dateStart) {
                var month = {
                    name: moment(dateStart).format('MMMM YYYY'),
                    number: moment(dateStart).format('M'),
                    start: moment(dateStart).startOf('month').toISOString(),
                    end: moment(dateStart).endOf('month').toISOString(),
                    startLabel: moment(dateStart).format('MMMM D'),
                    endLabel: moment(dateStart).endOf('month').format('MMMM D, YYYY')
                }
                // $log.info('Month group:' + month.start + month.end);
               months.push(month);
               // dateStart.add(1,'month');
               dateStart = dateStart.add(1,'month').startOf('month');
            }
            // $log.info(months);
            $timeout(function(){
                 service.report.groups = months;
                service.report.loading = false;
            }, 200);
        }// setMonthList

        // Returns an array of months (default 6 from end month unless start specified and respecting Retainer monthly timeframes)
        function setRetainerList(uid, end, start){
            // var retainerStart = get retainerStart from client
            var retainerStart = undefined;
            var clientRef = firebase.database().ref('clients').child(uid);
            clientRef.once('value', function(snapshot){
              var client = snapshot.val();


              // get "retainerStart" day number from nextCycle
              if(_.has(client, 'profile.plan.nextCycle')){
                retainerStart = Number(moment(client.profile.plan.nextCycle).format('D'));
              } else {
                retainerStart = 1;
              }


              start = moment(start).date(retainerStart).startOf('day');
              // make sure we extend the end date a month to include the current retainer period
              end = moment(end).add(1,'month').date(retainerStart-1).endOf('day');

              var months = [],
                  dateStart = moment(start),
                  dateEnd = moment(end);

              while (dateEnd > dateStart){
                var month = {
                    name: moment(dateStart).format('MMMM'),
                    number: moment(dateStart).format('M'),
                    start: moment(dateStart).date(retainerStart).toISOString(),
                    end: moment(dateStart).add(1,'month').date(retainerStart-1).endOf('day').toISOString(),
                    startLabel : moment(dateStart).date(retainerStart).format('MMMM D'),
                    endLabel: moment(dateStart).add(1,'month').date(retainerStart-1).format('MMMM D, YYYY')
                }
                // $log.info('adding month to retainerList:', month);
                months.push(month);
                dateStart = dateStart.add(1, 'month').date(retainerStart);
                $timeout(function(){
                    service.report.groups = months;
                    service.report.loadig = false;
                }, 200);
              }
            });// clientRef.once

        }// setRetainerList

        // Returns an array of weeks (default just end month unless start specified)
        function setWeekList(end, start){
            // $log.info('setWeekList');
            service.report.loading = true;
           var dateStart = moment(start);
           var dateEnd = moment(end);
           var weeks = [];

           while (dateEnd > dateStart) {
               var week = {
                   name: 'Week ' + moment(dateStart).week(),
                   number: moment(dateStart).week(),
                   start: moment(dateStart).startOf('week').toISOString(),
                   end: moment(dateStart).endOf('week').toISOString(),
                   startLabel: moment(dateStart).startOf('week').format('MMMM D'),
                   endLabel: moment(dateStart).endOf('week').format('MMMM D, YYYY')
               }
              weeks.push(week);
              dateStart = dateStart.add(1,'week').startOf('week');
           }
           $timeout(function(){
                service.report.groups = weeks;
               service.report.loading = false;
           }, 200);


        }// setWeekList

    } // end timeReportService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('teamInviteDialogController', teamInviteDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// teamInviteDialogController

        /* @ngInject */
        function teamInviteDialogController($scope, $q, $mdDialog, $log, $timeout, $mdToast, teamDataService, gateService) {
            // $log.info('teamInviteDialogController');
            var vm = this;
            // team already defined when opening dialog
            // $log.info('teamInviteDialog');
            vm.owner = vm.locals.team.ownerID;
            vm.numMembers = vm.locals.numMembers;
            // Get our client limit
            vm.gateService = gateService;
            vm.teamLimit = vm.locals.limit;



            vm.saveInvite = function(email){
                // make sure member isn't already on our team
                var sendInvite = true;
                _.each(teamDataService.selectedTeam.members, function(member){
                    if(member.email == email){
                        sendInvite = false;
                    }
                });

            if(sendInvite){
                return teamDataService.inviteMember(email, vm.locals.team)
                .then(function(){
                  vm.inviteEmail = undefined;
                  vm.cancelDialog();
                  // delete teamDataService.selectedTeam;

                  $mdToast.show($mdToast.adminjaAlert(
                      {
                          locals:{
                              title: 'Invitation Sent',
                              message: 'Your invitation to ' + email + ' is on it\'s way!',
                              color: 'green'
                          }
                      }));
                })


            } else {
                vm.inviteEmail = null;
                alert('Sorry, a person with that email is already on your team!');
            }

    }// vm.saveInvite



            vm.cancelDialog = function(){
                $mdDialog.cancel();
            };
        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('teamEditDialogController', teamEditDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// teamEditDialogController

        /* @ngInject */
        function teamEditDialogController($scope, $q, team, $mdDialog, $log, $timeout, $mdToast, teamDataService, $rootScope, userDataService) {
            // $log.info('teamEditDialogController');

            var vm = this;
            vm.team = team;
            // team already defined when opening dialog
            // $log.info('teamInviteDialog');

            if(vm.team){
              vm.teamName = vm.team.name
            }

            vm.updateTeam = function(teamID, name){
              firebase.database().ref('teams').child(teamID).child('name').set(name)
              .then(function(){
                  $timeout(function(){
                    $rootScope.$emit('refreshTeams');
                  },250);
                  $mdDialog.cancel()
                  .then(function(){
                     var confirm = $mdDialog.confirm()
                              .title('Your Team has been updated')
                              .htmlContent('Please refresh your browser to see your changes.')
                              .ariaLabel('Got it')
                              .ok('Got It');

                    $mdDialog.show(confirm).then(function() {

                    });
                  });
                    // $rootScope.$emit('teamChange');
                });// then
            }//updateTeam

            vm.setupTeam = function(name){
              vm.setup = true;
              return teamDataService.initializeTeam(name)
              .then(function(){
                $timeout(function(){
                  $rootScope.$emit('refreshTeams');
                },1000);
                $mdDialog.cancel()
                .then(function(){
                  alert('Your Team, ' + name + ', has been set up. Please refresh to update your Teams list.')
                });
                  // $rootScope.$emit('teamChange');
              });// then
            }

            vm.cancelDialog = function(){
                $mdDialog.cancel();
            };
        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('teamDataService', teamDataService);

    /* @ngInject */
    function teamDataService($log, moment, $state, localStorageService, $mdToast,
                userDataService, gateService, clientDataService, notificationService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $interval,hotkeys, triLoaderService, triMenu, $firebaseArray, $firebaseObject, $q, $window) {

        var service = {
            getUsersTeam: getUsersTeam,
            getUsersTeams: getUsersTeams,
            getOwnersTeamList: getOwnersTeamList,
            getClientTeams: getClientTeams,
            getClientTeamList: getClientTeamList,
            selectTeamMember: selectTeamMember,
            selectTeam: selectTeam,
            getMemberName: getMemberName,
            selectUser: selectUser,
            inviteDialog: inviteDialog,
            inviteMember: inviteMember,
            inviteClientUser: inviteClientUser,
            revokeInvite: revokeInvite,
            resendInvite: resendInvite,
            acceptInvite: acceptInvite,
            declineInvite: declineInvite,
            initializeTeam: initializeTeam,
            hasAccess: hasAccess,
            canViewClient: canViewClient,
            isAdmin: isAdmin,
            isTeamAdmin: isTeamAdmin,
            getOwner: getOwner,
            setMemberAccess: setMemberAccess,
            changeMemberStatus: changeMemberStatus,
            removeMember: removeMember,
            saveMemberNote: saveMemberNote,
            updateMember: updateMember,
            deselectMember: deselectMember,
            deselectTeam: deselectTeam,
            init: init
        };

        return service;


        // Setup service.team and service.teams objects
        function init(){
          return new Promise(function(resolve, reject){
            // $log.error('XXX -setup Teams');
            var user = firebase.auth().currentUser;
            if (user){
                // the quietRebuild flag tells the function to replace the array
                // with new data. This is smoother than deleting it and then simply
                // running the functions with empty arrays.
                var quietRebuild = true;

                // get all other teams this member belongs to
                return getUsersTeams(quietRebuild)
                .then(function(){
                  return getOwnersTeamList(quietRebuild)
                })
                .then(function(){
                  return getClientTeams(quietRebuild);
                }).then(function(){
                  service.teamsSetup = true;

                  resolve(true);
                }); // returns service.teams
            } else {

              resolve(false);
            }
          });// return promise

        }// init()

        function deselectMember(){
            delete service.selectedMember;
            delete service.selectedUser;
        };




        // build an array of teams from assigned clients keyed by clientID for quick and easy access
        // in our drop downs and comments
        function getClientTeams(quietRebuild){
          // $log.error('XXX - getClientTeams');
          return new Promise(function(resolve, reject){
            // Run our chain of operations
            // var clientsRef = firebase.database().ref().child('/clients');

            var clientTeams = [];
            var allMembers = [];
            _.each(clientDataService.clients, function(client){
                    var thisTeam = {};
                    var ownersTeamRef = firebase.database().ref('teams/' + client.owner);
                    var teamRef = firebase.database().ref('clients/' + client.uid  +'/access/users');
                    var ownersTeam = undefined;
                    ownersTeamRef.once('value', function(snapshot){
                        // store the owners team so we can combine info there with our user info
                        ownersTeam = snapshot.val();
                    })
                    .then(function(){
                        // Get the team data
                        teamRef.once('value', function(snapshot){
                             var clientTeamInfo = snapshot.val();
                             // Cycle through all clients in client/uid/access/users
                             _.each(clientTeamInfo, function(value, key){
                                // Only process if member is assigned to this client
                                /////////////////////////////////
                                if(_.has(client.access.users, key)){
                                  var thisMember = {};

                                  // get the user info and put it on our member
                                  var userRef = firebase.database().ref('userList/' + key);
                                  userRef.once('value').then(function (snapshot) {
                                      // The first promise succeeded. Save snapshot for later.
                                     var user = snapshot.val();
                                     thisMember = user;
                                     // if(_.has(user, 'uid')){
                                     //      // Go through this user's teams and pull out colors
                                     //     // / attach properties to member
                                     //     thisMember = user
                                     // }// if user found
                                     if(_.has(ownersTeam, 'members')){
                                       // Get the teamOwners info and start our new member
                                       // go through our ownersTeam and pop in that info
                                      _.each(ownersTeam.members, function(member){
                                        if(member && thisMember){
                                          if (member.uid == thisMember.uid){
                                              if(_.has(member, 'clients')){
                                                  thisMember.clients = member.clients;
                                              }
                                              if(_.has(member,'color')){
                                                  thisMember.color = member.color;
                                              }


                                              // double check that user is assigned to this client
                                              if(_.has(member.clients, client.uid) || member.role == 'owner'){

                                               // if the MAIN team role is Owner, set the same for client. Otherwise,  grab the value
                                               if(member.role == 'owner'){
                                                 thisMember.role = 'owner';
                                               } else {
                                                 thisMember.role = member.clients[client.uid];
                                               }

                                               thisMember.status = member.status;

                                               thisTeam[key]=thisMember;
                                               // if(thisMember.uid == 'eK11YiLFJ9OFeJ06Uo8fW8h2qgt2'){
                                               //  $log.info(thisTeam);
                                               // }
                                               // PUt it on allMembers (if not already there)
                                               var found = false;
                                               _.each(allMembers, function(member){
                                                 if(member.uid == thisMember.uid){
                                                   found = true;
                                                 }
                                               });
                                               if(!found){
                                                 allMembers.push(thisMember);
                                               }
                                              }// if user really is assigned to this client
                                          }// if member.uid matches
                                        }

                                        });// each ownersTeam
                                        // put it on thisTeam
                                     }// if owner has a team
                                  });// userRef.once
                                }// only process if member is assigned to this client
                                /////////////////////////////////
                             });// each teammember
                        });// teamRef.once
                    })
                    clientTeams[client.uid] = thisTeam;
            });// each client

            // put the array of clientTeams on the service
            service.clientTeams = clientTeams;
            service.allMembers = allMembers;
            // $log.info('clientTeams Completed:');
            resolve(service.clientTeams);
          });// return promise


        }// getClientTeams

        function canViewClient(userID, clientID){
          var thisClientsTeam = service.clientTeams[clientID],
              thisUserAsMember = thisClientsTeam[userID];
            // Only check if we are dealing with a team member (i.e. solo accounts don't apply herer)
            if(_.has(thisUserAsMember, 'status')){
              // Only allow "active" members through
              if(thisUserAsMember.status == 'active'){
              return true
              } else {
                return false
              }
            } // if we are actually dealing with a team member
            else {
              // must be a solo account. allow it
              return true
            }
        }// canViewClient

        function getUsersTeam(quietRebuild) {
            // $log.error('XXX - getUsersTeam');
            return new Promise(function(resolve, reject){
              if(_.size(service.team > 0) && !quietRebuild ){
                  // we already have timers. returning
                  // return service.team
                  resolve(service.team)
              } else {
                // $log.info('refreshing teams');
                  // we can't use the simpler user = userDataService.user here for some reason.
                  // and hey, why not make sure we are 100% accurate?
                  return userDataService.getLoggedInUser()
                  .then(function(user){
                      // $log.info('user:');
                      // $log.info(user);
                      var teamRef = firebase.database().ref('teams').child(user.uid).child('members');
                      // Get the team data
                      $firebaseArray(teamRef)
                      .$loaded()
                      .then(function(members){
                        service.team = members;
                        // $log.info('completed getUsersTeam');
                        resolve(service.team);
                        // return service.team
                      })
                      .catch(function(error){
                        $log.error('Error getting team');
                        $log.error(error);
                        resolve(error)
                      });
                  });
              }
            });// return promise

        } // getUsersTeam

        // getUsersTeams - all of the TEAMS THIS USER IS ON//
        // quietRebuild flag forces a rebuild without deleting first (which causes a UI reset);
        function getUsersTeams(quietRebuild) {
            // $log.error('XXX - getUsersTeams');
            return new Promise(function(resolve, reject){
              if(_.size(service.teams > 0) && !quietRebuild){
                  // we already have teams. returning
                  resolve(service.teams)
              } else {
                  // we can't use the simpler user = userDataService.user here for some reason.
                  // and hey, why not make sure we are 100% accurate?
                  return userDataService.getLoggedInUser()
                  .then(function(user){
                    var tempTeams = [];


                    // if we DON'T have user.teams,
                    // create it so we have something to append the user's own team to for setup and upgrading
                    if(!_.has(user, 'teams')){
                      user.teams = {}
                    }

                    // add the user's own team to the array
                    user.teams[user.uid] = true;


                    // Get all of the team data
                    var count = 0;
                    _.each(user.teams, function(value, key){
                      if(value){
                        var teamRef = firebase.database().ref('/teams/'+key);
                        teamRef.once('value', function(snapshot){
                            if(snapshot.exists()){
                              var team = snapshot.val();
                              count = count + 1;

                              // if it doesn't have an ownerID - it's not setup yet and shouldn't be included
                              if(_.has(team, 'ownerID')){
                                   if(team.ownerID == user.uid){
                                    // if it's their own team, put it at the top
                                    team.order = 0;
                                   } else {
                                    // otherwise, order based on count
                                    team.order = count;
                                   }
                                    tempTeams.push(team);
                                } else {
                                  // teams not setup but we have a team node...probably for storing
                                  // archived clients (to support team admins)
                                  // prepare user's dummy team so the setup card can be displayed
                                  // No team found
                                  // if it's for the user's OWN team, add to the array as needsSetup
                                  if (key == user.uid){
                                    tempTeams.push({
                                      ownerID: key,
                                      needsSetup : true,
                                      teamLimit: user.limits.team
                                    })
                                  }
                              }// if valid team with ownerID

                            } else {
                              // teams not setup
                              // prepare user's dummy team so the setup card can be displayed
                              // No team found
                              // if it's for the user's OWN team, add to the array as needsSetup
                              if (key == user.uid){
                                tempTeams.push({
                                  ownerID: key,
                                  needsSetup : true,
                                  teamLimit: user.limits.team
                                })
                              }
                            }// if snapshot.exists()
                        });
                      }// if value
                    }); // each team
                    service.teams = tempTeams
                    resolve(service.teams)
                  });
              }
            });// return promise

        } // getUsersTeam


        // Get's an owners full teamlist (rather than for individual clients as above)
        function getOwnersTeamList(force){
          return new Promise(function(resolve, reject){
            if (_.size(service.teamList > 0) && !force){
                resolve(service.teamList)
            } else {
                // if we want to force a rebuild. we need to remove existing one by one,
                // not delete the whole node and rebuild
                // if(force){
                //     // we just want to refresh the array, not remove it and lose our bindings
                //     // $log.info('removing items from teamList for a refresh');
                //     service.teamList.length = 0;
                //     // $log.info(service.teamList);
                // } else {
                //     // starting fresh
                //     service.teamList = [];
                // }

                 var teamRef = firebase.database().ref('teams').child($rootScope.userID).child('members');
                // Get the team data
                 var teamList = [];
                teamRef.once('value', function(snapshot){
                 var team = snapshot.val();
                 _.each(team, function(member){
                   // make sure they are active
                  if(member.status != 'something'){
                   // get the user info and put it on our member
                   var userRef = firebase.database().ref('userList/' + member.uid);
                   userRef.once('value').then(function (snapshot) {
                       // The first promise succeeded. Save snapshot for later.
                      var user = snapshot.val();
                      if(_.has(user, 'uid')){
                          // / attach properties to member
                          member.email= user.email;
                          member.avatar=user.avatar;
                          member.fullName = user.fullName;
                          member.limits = user.limits;
                      }// if user found

                      teamList.push(member);

                   });// userRef.once
                 }// if active
                 });// each team member

                 var teamSize = 0;
                 teamSize = _.size(team);

                 if(teamSize > 0){
                   service.teamsSetup = true;
                 } else {
                   service.teamsSetup = false;
                 }


                 // Update this value in groove.
                 var grooveUser = {
                   'team-members': Number(teamSize)
                 };

                 // groove.widget('setCustomer', grooveUser);
                 groove.widget.setContact(grooveUser);

                 // $log.info(vm.teamList);
                 service.teamList = teamList;
                 resolve(service.teamList);
                });// teamsRef


            }
          });// return promise

        }// getOwnersTeamList

        // couldn't get this to work for populating drop downs.
        // had to move the code into each controller (duplicating it)
        // TODO - ask MO what I'm doing wrong (it's promises I'm sure.)
        function getClientTeamList(clientID){
            // we are having trouble returning this complicated object to our controllers.
            // using $rootScope as a workaround for now. Sorry best practices. :(
            $rootScope.currentTeamList = [];
           var clientRef = firebase.database().ref('clients/' + clientID + '/owner');
           return clientRef.once('value', function(snapshot){
               var ownerID = snapshot.val();
               var teamRef = firebase.database().ref('teams/' + ownerID  +'/members');
               // Get the team data
                var teamList = [];
               teamRef.once('value', function(snapshot){
                var team = snapshot.val();
                _.each(team, function(member){
                  // make sure they are active
                 if(member.status == 'active' && service.hasAccess(member, clientID)){
                  // get the user info and put it on our member
                  var userRef = firebase.database().ref('userList/' + member.uid);
                  userRef.once('value').then(function (snapshot) {
                      // The first promise succeeded. Save snapshot for later.
                     var user = snapshot.val();
                      // attach properties to member
                         member.fullName = user.fullName;
                         member.email = user.email;
                         member.avatar=user.avatar;
                         member.fullName = user.fullName;
                         member.limits = user.limits;
                         $rootScope.currentTeamList.push(member);
                  });// userRef.once
                }// if active
                });// each team member
                // $log.info(vm.teamList);
               });// teamsRef
           });// clientsRef

        }// getClientTeamList

        function hasAccess(member, clientID){
            var found = false;
            // If status == 'active' && this client is in member.client[clientID]
            if(member.status == 'active'){
              if(_.has(member, 'clients')){
                  if(member.clients[clientID]){
                      found = true;
                  }
              }// if has clients
            }

            if(member.role == 'owner'){
                found = true;
            }
            return found
        }// hasAccess

        function isAdmin(member, clientID){
          var thisTeamList = service.clientTeams[clientID];
            if (thisTeamList[member.uid].clients[clientID].role == 'admin'){
              return true
            } else {
              return false
            }
        } // isAdmin

        function isTeamAdmin(member, owner){
          var isAdmin = false;
          _.each(service.teams, function(team){
            if(team.ownerID == owner){
              if(_.has(team.members, member)){
                if(_.has(team.members[member], 'isTeamAdmin')){
                  if(team.members[member].isTeamAdmin){
                    isAdmin = true;
                  }
                }
              }
            }
          });

          return isAdmin
        }//isTeamAdmin

        function getOwner(clientID){
          // XXX Shouldn't we just loop through the clients in clientDataService instead of calling the database here?
            var clientRef = firebase.database().ref('clients/' + clientID + '/owner');
            return clientRef.once('value', function(snapshot){
                var ownerID = snapshot.val();
                return ownerID
            });
        } // isAdmin

        function getMemberName(memberID){

        }// getMemberName
        ////////////////////////////////////////////////
        // Functions mainly to facilitate state in member detail panel

        function selectTeamMember(member){
            delete service.selectedMember;
            $timeout(function(){
                service.selectedMember = member;
            },0);
        }

        // when displaying full team member detail, we need all of the
        // data at their user node.
        // this allows us to handle it via the service
        function selectUser(user){
            delete service.selectedUser;
            service.selectedUser = user;
        }

        function deselectTeam(){
          delete service.selectedTeam;
          delete service.selectedUser;
          delete service.selectedTeamLimit;
          delete service.selectedMember;
        }// deselectTeam

        function selectTeam(team){
          var thisTeam = team;
          $timeout(function(){
            deselectTeam()
          },0)
          .then(function(){
            var ownerLimits = firebase.database().ref().child('/userList/' + thisTeam.ownerID + '/limits');
            ownerLimits.once('value', function(snap){
              var limits = snap.val();
              service.selectedTeamLimit = limits.team;
              if(_.has(limits, 'additionalTeamMembers')){
                service.selectedTeamLimit = Number(limits.team) + Number(limits.additionalTeamMembers);
              }
            });// end get owner

            // We want our team to auto-update in the gui when changes are made.
            // So we are pulling live from the database instead of just
            // putting a team out of our manipulated array on the service.
            var teamRef = firebase.database().ref().child('/teams/' + thisTeam.ownerID);
            $firebaseObject(teamRef)
            .$loaded(function(team){
              service.selectedTeam = team;
            })

          });
        }

        function changeMemberStatus(member, teamID){
          var memberCopy = angular.fromJson(angular.toJson(member)),
              updates = {};

          updates['teams/' + teamID + '/members/' + memberCopy.uid + '/status/'] = memberCopy.status;

          // if we are disabling, also remove all client references
          if(memberCopy.status == 'disabled'){

            // Archiving this member - remove asisgnment from all clients as well
            if(_.has(memberCopy, 'clients')){
              _.each(memberCopy.clients, function(value, key){
                // remove client from user/clients
                updates['users/' + memberCopy.uid + '/clients/' + key] = null;
                // remove client from assignment in teams
                updates['teams/' + teamID + '/members/' + memberCopy.uid + '/clients/' + key] = null;
                // remove user from all client access
                updates['clients/' + key + '/access/users/' + memberCopy.uid] = null;
                updates['clients/' + key + '/access/admins/' + memberCopy.uid] = null;
              });
            }// if hasClients
          }// if disabling

          // make our changes
          return firebase.database().ref().update(updates)
                  .then(function () {
                    $timeout(function(){
                    clientDataService.setupWorkspaceMenu(true);
                  }, 1000)

                  });

        }// changeMemberStatus


        function removeMember(member, teamID){
          // first we disabled the member (removing all references from clients)
          var memberCopy = angular.fromJson(angular.toJson(member));
          memberCopy.status = 'disabled';
          return service.changeMemberStatus(memberCopy, teamID)
          .then(function(){
            // next we remove the member from our team
            var memberRef = firebase.database().ref('/teams/' + teamID + '/members/' + memberCopy.uid);
            memberRef.set(null);
            userDataService.count(teamID, 'removedTeamMember', 1, moment().toISOString())
          });
        }// removeMember

        function saveMemberNote(member, teamID){
            var memberRef = firebase.database().ref('/teams/' + teamID + '/members/' + member.uid);
            memberRef.child('notes').set(member.notes);
        }

        function updateMember(member){
            var memberCopy = _.clone(member);
            ajUTILITIES.removePropertiesWith(memberCopy);
            var updates = {};
            var owner = member.owner;

            if(member.role == 'owner'){
              owner = member.uid
            }
            updates['teams/'+ owner + '/members/' + member.uid] = memberCopy;

            return firebase.database().ref().update(updates)
                    .then(function () {
                        service.init();
                    });
        }

        function setMemberAccess(member, clientID, teamID, access){
            // triLoaderService.setLoaderActive(true);
            // Update the reference on the team
            var memberRef = firebase.database().ref('teams/' + teamID + '/members/' + member.uid + '/clients');

            var updates = {};
            if (access != 'none'){
                // add them to team list and add them to users list
                updates['teams/' + teamID + '/members/' + member.uid + '/clients/' + clientID] = access;
                updates['users/' + member.uid + '/clients/' + clientID] = true;
                updates['clients/' + clientID + '/access/users/' + member.uid] = true;
                updates['clients/' + clientID + '/userOrders/user' +member.uid] = 0;
                updates['clients/' + clientID + '/allOrders/user' +member.uid] = 0;

                // if admin, add to admin list
                if(access=='admin'){
                    updates['clients/' + clientID + '/access/admins/' + member.uid] = true;
                } else {
                    // otherwise, make sure removed from admin list
                    updates['clients/' + clientID + '/access/admins/' + member.uid] = null;
                }
            } else {
                // if 'none', remove from user's client list and remove user and admin access to this client
                updates['teams/' + teamID + '/members/' + member.uid + '/clients/' + clientID] = null;
                updates['users/' + member.uid + '/clients/' + clientID] = null;
                updates['clients/' + clientID + '/access/users/' + member.uid] = null;
                updates['clients/' + clientID + '/access/admins/' + member.uid] = null;
                updates['clients/' + clientID + '/userOrders/user' +member.uid] = null;
                updates['clients/' + clientID + '/allOrders/user' +member.uid] = null;
            }

            // make our changes
            return firebase.database().ref().update(updates)
                    .then(function () {

                        // I hate that I'm doing something with the GUI here but it's necessary
                        // Re-initialize our team

                        // $timeout(function(){
                        //     // clientDataService.setupWorkspaceMenu(true);
                        //     // triLoaderService.setLoaderActive(false);
                        // },1000);
                        service.init(true);

                        // $log.info('sorted');
                        _.each(clientDataService.clients, function(client){
                          if(client.uid == clientID){
                            var thisClient = client;
                            // $log.info(thisClient);
                            var customTitle = undefined, customMessage = undefined, sendMessage = false;

                            if(access == 'none'){
                                sendMessage = true;
                                customTitle = "Goodbye!";
                                customMessage= "You've been removed from " + thisClient.profile.fullName + "'s team";
                            }
                            if(access == 'member'){
                                sendMessage = true;
                                customTitle = "Welcome!";
                                customMessage= "You've been added to <a href='/#/workspaces/" + thisClient.uid + "'>" + thisClient.profile.fullName + "</a>'s team";
                            }
                            if(access == 'admin'){
                                sendMessage = true;
                                customTitle = "Congrats!";
                                customMessage= "You've been made an admin for <a href='/#/workspaces/" + thisClient.uid + "'>" + thisClient.profile.fullName + "</a>'s team";
                            }
                            // Bryan - fix this notificaiton with the right message/info
                            if (sendMessage){
                                var notification = {
                                    title: customTitle,
                                    message: customMessage,
                                    meta: 'Assignment Change',
                                    type: 'clientAssignment',
                                    assignee: member.uid,
                                    related: thisClient.uid
                                  }
                                notificationService.notify(notification);
                            }// if sendMessage
                            var action = '', thisColor = 'green';
                            if(access == 'none'){
                              action = ' has been removed from ';
                              thisColor = 'red';
                            }
                            if(access == 'member'){
                              action = ' has been added as a member for ';
                              thisColor = 'green';
                            }

                            if(access == 'admin'){
                              action = ' has been added as an admin for ';
                              thisColor = 'green';
                            }

                            $mdToast.show($mdToast.adminjaAlert(
                                {
                                    locals:{
                                        title: 'Team Member Access Changed',
                                        message: member.email + action + thisClient.profile.fullName + '\'s team',
                                        color: thisColor
                                    }
                                }));// mdToast

                          } // if found client
                        }); // each client
                    });

        }

        ///////////////////////////////////////////////////////////
        /// inviteDialog
        // opens team invitation dialog

        function inviteDialog(team, numMembers, limit) {

                $mdDialog.show({
                    controller: 'teamInviteDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/teamDataService/dialog-invite-team-member.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        team: team,
                        numMembers : numMembers,
                        limit: limit
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });

        }
        ; //end inviteDialog


        ///////////////////////////////////////////////////////////
        /// inviteMember
        // opens team invitation dialog

        function inviteMember(email, team) {
            var user = userDataService.user;
            // Create our invitation
            var newInviteKey = firebase.database().ref('teamInvites').push().key,
                invitation = {
                  'invitee': email,
                  'owner' : team.ownerID,
                  'ownerName' : team.ownerName,
                  'ownerEmail': team.ownerEmail,
                  'status': 'new',
                  'timeStamp' : moment().toISOString(),
                  'expire': moment().add(10, 'days').toISOString(),
                  'uid': newInviteKey
              }
            var updates = {};
            updates['teamInvites/' + newInviteKey ] = invitation;
            // Execute our update
            return firebase.database().ref().update(updates)
            .then(function(){
              //heap.track('Team Invitation Sent');
              userDataService.trackEvent('send-team-invite');
              service.init();
            })

        }
        ; //end inviteMember

        function inviteClientUser(user, workspaceID) {

            var owner = userDataService.user;
            // Create our invitation
            var newInviteKey = firebase.database().ref('teamInvites').push().key,
                invitation = {
                  'invitee': user.email,
                  'type': 'clientUser',
                  'owner' : owner.uid,
                  'workspace': workspaceID,
                  'ownerName' : owner.profile.fullName,
                  'ownerEmail': owner.email,
                  'status': 'new',
                  'timeStamp' : moment().toISOString(),
                  'expire': moment().add(10, 'days').toISOString(),
                  'uid': newInviteKey
              }
            var updates = {};
            updates['teamInvites/' + newInviteKey ] = invitation;
            // Execute our update
            return firebase.database().ref().update(updates)
            .then(function(){
              // $log.info('Invitation ' + newInviteKey + ' sent.');
              //heap.track('Client Invitation Sent');
              userDataService.trackEvent('send-client-invite');
              return userDataService.count(owner.uid, 'clientInvites', 1)
              .then(function(){
                // this invitation is going to get counted as a team invite as well.
                // let's remove that count preemptively here.
                return userDataService.count(owner.uid, 'teamInvites', -1)
                .then(function(){
                  return invitation
                })
              });

              // $timeout(function(){
              //    $rootScope.$emit('refreshTeams');
              //  },10000);
            })

        }
        ; //end inviteClientUser

        function revokeInvite(member){
            // change status to revoked
            var inviteRef = firebase.database().ref('teamInvites/' + member.invitationID);
            inviteRef.child('status').set('revoked');
            //heap.track('Team Invitation Revoked');
            userDataService.trackEvent('revoke-invite');
            // $timeout(function(){
            //    $rootScope.$emit('refreshTeams');
            //  },10000);
        }// revokeInvite

        function resendInvite(member){
            // change status to resend - adjust cloud function to reset date and re-notify
            var inviteRef = firebase.database().ref('teamInvites/' + invitation.uid);
            inviteRef.child('status').set('resend');
            //heap.track('Team Invitation Resent');
            userDataService.trackEvent('resend-team-invite');;
        }// resendInvite

        function acceptInvite(invitation, newUserID){
            // $log.info('teamDataService.acceptInvite');
            // $log.info(invitation);
            // if we are accepting from a notification, we should use the related chld for our inviteID
            // if we are accepting from an email or other, we should use the UID
            var inviteID = undefined;
            if(!_.has(invitation, 'related')){
              inviteID = invitation.uid
            } else {
              inviteID = invitation.related
            }
            var inviteRef = firebase.database().ref('teamInvites/' + inviteID);

            var updates = {};
            // if this is a new user, update the invite with the userID
            // and a flag to tell CFN to process it differently
            if(newUserID){
              updates['teamInvites/'+ inviteID + '/isNewUser'] = true;
              updates['teamInvites/'+ inviteID + '/inviteeUID'] = newUserID;
              // inviteRef.child('isNewUser').set(true);
              // inviteRef.child('inviteeUID').set(newUserID)
            }
            // Set our status to active and trigger cloud function to complete acceptance
            updates['teamInvites/'+ inviteID + '/status'] = 'active';
            updates['users/'+ newUserID + '/teams/' + invitation.owner] = true;
            // inviteRef.child('status').set('active');
            //heap.track('Team Invitation Accepted');
            firebase.database().ref().update(updates)
            .then(function(){
              userDataService.trackEvent('accept-invitation');
              if(!$state.includes('authentication.registration')){
                location.reload();
              }
            });
        }// acceptInvite

        function declineInvite(invitation){
            // $log.info('teamDataService.declineInvite');
            // if we are declining from a notification, we should use the related chld for our inviteID
            // if we are declining from an email or other, we should use the UID
            var inviteID = undefined;
            if(!_.has(invitation, 'related')){
              inviteID = invitation.uid
            } else {
              inviteID = invitation.related
            }
            var inviteRef = firebase.database().ref('teamInvites/' + inviteID);
            inviteRef.child('status').set('declined');
            //heap.track('Team Invitation Declined');
            userDataService.trackEvent('decline-invitation');
        }// acceptInvite

        function initializeTeam(name){
              return userDataService.getLoggedInUser()
              .then(function(user){
                 var ownerID = user.uid;

                 // Create our fresh team object
                 // NOTE - we may already have a team node containing archivedWorkspaces.
                 // we cant overwrite that so we are doing separate updates
                 var updates = {};

                 updates['/teams/' + user.uid + '/ownerEmail'] = user.email;
                 updates['/teams/' + user.uid + '/ownerID'] = user.uid;
                 updates['/teams/' + user.uid + '/ownerName'] = user.profile.fullName;
                 updates['/teams/' + user.uid + '/name'] = name;
                 // var newTeam = {
                 //     'ownerEmail': user.email,
                 //     'ownerID': user.uid,
                 //     'ownerName': user.profile.fullName,
                 //     'name': name
                 // }

                var members = {};

                 members[ownerID] = {
                     'becameMember': moment().toISOString(),
                     'color': "#0000e0",
                     'email': user.email,
                     'owner': user.uid,
                     'role': 'owner',
                     'status': 'active',
                     'uid': user.uid
                 }

                 updates['/teams/' + user.uid + '/members'] = members;
                 return firebase.database().ref().update(updates)
                 .then(function(){
                  userDataService.trackEvent('setup-team');
                 })

              });

        }// initializeTeam

    } // end teamDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('taskTemplateDataService', taskTemplateDataService);

    /* @ngInject */
    function taskTemplateDataService($mdToast, $q, $log, gateService, clientDataService, userDataService, localStorageService, $http, pageDimensionsService, $mdMedia, $mdDialog, $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            newTaskTemplate: newTaskTemplate,
            getClientTaskTemplates: getClientTaskTemplates,
            getTaskTemplate: getTaskTemplate,
            taskTemplateDialog: taskTemplateDialog,
            saveNewTaskTemplate: saveNewTaskTemplate,
            deleteTaskTemplate: deleteTaskTemplate,
            updateTaskTemplate: updateTaskTemplate
        };

        return service;



        //////////////////////////
        // New task
        function newTaskTemplate(clientID) {
            userDataService.trackEvent('new-task-template');
            // $log.info('taskTemplateDataService.newTaskTemplate');
            // $log.info('newTaskTemplate for client:' + clientID);
            // $log.info(clientID);
            var userID = userDataService.user.uid,
                task = {
                    type: 'template',
                    creator: userID,
                    isRecurring: false,
                    info: {
                        client: clientID,
                        assignee: userID,
                        logged: 0,
                        status: 'open',
                        budget: 0,
                        description: '',
                        numnotes: 0,
                        created: Date.now(),
                        originalClient: clientID
                    },
                    schedule: {
                        dueDays: 0
                    }
                }



            // $log.info(task);
            return task
        }

        ///////////////////////////
        // getClientTaskTemplates
        function getClientTaskTemplates(clientID) {
            var tasksRef = firebase.database().ref('taskTemplates/');
            return $firebaseArray(tasksRef.orderByChild('info/client').equalTo(clientID))
                    .$loaded(function (tasks) {
                        return tasks
                    });
        }; // end getClientTaskTemplates


        ///////////////////////////////////////////////////////////
        /// taskTemplateDialog
        // opens dialog with the prepared editedItem

        function taskTemplateDialog(editedItem, selectedTab) {
            return userDataService.getLoggedInUser()
            .then(function(user){
                var canLogTime = gateService.gateData.canLogTime;
                // $log.info('taskTemplateDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: taskTemplateDialog');
                var clientColor;
                var newNote; // just need to declare it so our in-dialog note form has a model to work from

                // if we already have a client assigned, pass along the color.
                // otherwise, pass an empty string.
                if (editedItem.info.client) {
                    // editing an existing task
                    // editing an existing task
                    var selectedClient = _.find(clientDataService.clients, function (client) {
                        return client.uid == editedItem.info.client;
                    });
                    if (_.has(selectedClient, 'profile.clientColor')) {
                        clientColor =  selectedClient.profile.clientColor;
                    }
                } else {
                    // creating a new task
                    clientColor = '#aaa'; // Not used. just to avoid an undefined error.
                }

                $mdDialog.show({
                    controller: 'taskDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-task.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        editedItem: editedItem,
                        assignedClients: $rootScope.quickClients,
                        clientColor: clientColor,
                        newNote: newNote,
                        tags: $rootScope.tags,
                        selectedTab: selectedTab,
                        canLogTime: canLogTime
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });

            });

        }; //end taskTemplateDialog

        ///////////////////////////////////////////////////////////
        /// getTaskTemplate
        function getTaskTemplate(taskID) {
            // $log.info('getTaskTemplate:' + taskID);
            var task = {},
            taskRef = firebase.database().ref('taskTemplates/' + taskID);
            return $firebaseObject(taskRef)
                    .$loaded(function (data) {
                        task = data
                        // $log.info(task);
                        return task
                    })
        }
        ; // end getTaskTemplate

        ///////////////////////////////////////////////////////////
        /// saveNewTaskTemplate
        function saveNewTaskTemplate(task) {
            $log.info(task);
            var newTaskTemplateKey = firebase.database().ref().child('taskTemplates/').push().key;
            var taskCopy = angular.copy(task),
                    firstNote = undefined;

            taskCopy = ajUTILITIES.removePropertiesWith(taskCopy);

            // if it wasn't assigned a list, put it in New Tasks
            if(!taskCopy.info.panel){
                taskCopy.info.panel = 'Later';
            }

            if(_.has(taskCopy, 'info.files')){
                _.each(taskCopy.info.files, function(file, index){
                    if(file.source == "firebaseStorage" && file.thumbnail == file.url){
                        // this is a new file. Give it a response path
                        file.responsePath = 'taskTemplates/' + newTaskTemplateKey + '/info/files/' + index ;
                        file.responsePath2 = 'clients/' + taskCopy.info.client + '/taskTemplates/' + newTaskTemplateKey + '/info/files/' + index ;
                    }
                });// each files
            }// if files
            if (taskCopy.duedate) {
                taskCopy.duedate = taskCopy.duedate.toISOString();
            }

            if(_.has(taskCopy, 'schedule.startOn')){
                // $log.info(taskCopy.schedule.startOn); // in unix
                // $log.info('Saving...has starton:' + moment.unix(taskCopy.schedule.startOn).toISOString()); // show us in ISO
                // taskCopy.schedule.startOn = moment(task.schedule.startOn).unix(); //
                // $log.info('starton converted to:' + moment.unix(taskCopy.schedule.startOn).toISOString());
            }

            // console.log('savetask');
            // $log.info(task);

            // put our $id as a property for easier retrieval
            taskCopy.uid = newTaskTemplateKey;
            taskCopy.info.refID = newTaskTemplateKey;

            // Store originalClient for reference
            taskCopy.info.originalClient = taskCopy.info.client;
            // add our task to the new key
            var updates = {};
            updates['/taskTemplates/' + newTaskTemplateKey] = taskCopy;
            updates['/clients/' + taskCopy.info.client + '/taskTemplates/' + newTaskTemplateKey] = taskCopy;
            var label = "Task Template";
            if(taskCopy.isRecurring){
                label = "Recurring Task";
            }
            taskCopy = ajUTILITIES.removePropertiesWith(taskCopy);
            // make the update
            return firebase.database().ref().update(updates)
                    .then(function () {
                        userDataService.trackEvent('save-task-template');
                        $mdToast.show($mdToast.adminjaAlert(
                            {
                                locals:{
                                    title: "New " + label + "  added!",
                                    message: 'You can edit it in this workspace\'s RECURRING tab.',
                                    color: 'green'
                                }
                            }));
                        //heap.track('New Task Template Saved');
                        userpilot.track('New Task Template Saved');
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                        }, 500);
                        // if(Appcues){
                        //     Appcues.identify(task.creator, {
                        //         hasTaskTemplates: true
                        //     });
                        // }


                        $rootScope.$broadcast('taskTemplateChanged');
                    });

        }
        ; // end saveNewTaskTemplate

        ///////////////////////////////////////////////////////////
        /// deleteTaskTemplate
        function deleteTaskTemplate(item) {
            // $log.info('deleteTaskTemplate');
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                    .title('PERMANENTLY delete this task template?')
                    .textContent(item.description)
                    .ariaLabel('Delete Task? Y//N')
                    .targetEvent(item)
                    .ok('Yes, Delete')
                    .cancel('Cancel');
            $mdDialog.show(confirm)
                    .then(function () {
                        // remove our client's reference
                        return firebase.database().ref().child('/clients/' + item.info.client + '/taskTemplates/' + item.uid).remove()
                        .then(function () {
                            // Locate the task record in our tasks array
                            return firebase.database().ref().child('/taskTemplates/' + item.uid).remove();
                        })
                        .then(function () {
                            $mdDialog.hide();
                            $mdToast.show($mdToast.adminjaAlert(
                                {
                                    locals:{
                                        title: "Task Template deleted.",
                                        message: '',
                                        color: 'red'
                                    }
                                }));

                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                            }, 500);
                        });
                    });

            //heap.track('Task Template Deleted');
            userDataService.trackEvent('delete-task-template');
        }
        ; // end deleteTaskTemplate

        ///////////////////////////////////////////////////////////
        /// updateTaskTemplate
        function updateTaskTemplate(task) {
            var taskCopy = angular.fromJson(angular.toJson(task));
            if(_.has(taskCopy, 'info.files')){
                _.each(taskCopy.info.files, function(file, index){
                    if(file.source == "firebaseStorage" && file.thumbnail == file.url){
                        // this is a new file. Give it a response path
                        file.responsePath = 'taskTemplates/' + taskCopy.uid + '/info/files/' + index ;
                        file.responsePath2 = 'clients/' + taskCopy.info.client + '/taskTemplates/' + task.uid + '/info/files/' + index ;
                    }
                });// each files
            }// if files
            // convert our date into a string for storing

            if (taskCopy.info.duedate) {
                taskCopy.info.duedate = moment(taskCopy.info.duedate).toISOString();
            }

            var updates = {};

            // // // remove things that firebase provides
            ajUTILITIES.removePropertiesWith(taskCopy);

            // // store our modified object
            updates['/taskTemplates/' + taskCopy.uid] = taskCopy;
            updates['/clients/' + taskCopy.info.client + '/taskTemplates/' + taskCopy.uid] = taskCopy;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        userDataService.trackEvent('update-task-template');
                        // Make sure our columns adjust to new/removed items
                        $timeout(function () {
                            pageDimensionsService.resizeColumns();
                        }, 500);
                    });

            //heap.track('Task Template Updated');
            userpilot.track('Task Template Updated');
        }
        ; //end updateTaskTemplate


    } // end taskTemplateDataService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('taskDialogController', taskDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// taskDialogController

        /* @ngInject */
        function taskDialogController($q, $scope, mdcDateTimeDialog, gateService, dragulaService, $mdDialog, $timeout, $log, $mdToast, rrule, $rootScope, hotkeys, localStorageService, userDataService, teamDataService, clientDataService, taskDataService, timeDataService, timerDataService) {
            // $log.info('taskDialogController');
            var vm = this;
            vm.userID = $rootScope.userID;
            vm.userType = $rootScope.admin;
            vm.user = userDataService.user;
            vm.settings = $rootScope.userSettings;
            // get start of day as simple hour number.
            vm.startOfDay = vm.settings.startOfWorkday.match(/(.*):/g).pop().replace(":","")
            vm.taskControls = true;
            vm.today = new Date();
            vm.canLogTime = true;
            vm.canEmailClient = true;
            vm.canUseChecklists = true;
            vm.showAssignmentField = false;
            vm.clients = clientDataService.clients;
            vm.showStartEditor = false;
            vm.dueStyle="";
            // vm.teamLimit = gateService.gateData.teamLimit;
            vm.filePath = 'tasks'
            vm.canLogTime = gateService.gateData.canLogTime;
            vm.canEmailClient = gateService.gateData.canEmailClient;
            vm.reminderOptions = _.memoize(reminderOptions);
            vm.hasReminder = hasReminder;
            vm.myReminderDue = myReminderDue;
            vm.myReminder = myReminder;
            vm.toggleFollow = toggleFollow;
            vm.canUseTimer = gateService.gateData.canUseTimer;
            vm.originalLocation = {client: vm.editedItem.info.client, board: vm.editedItem.info.board, list: vm.editedItem.info.list};

            // determine if user is clientUser for this workspace
           vm.isClientUser = false;

           if(_.has($rootScope, 'VAWorkspaces')){
               if(_.has($rootScope.VAWorkspaces, vm.editedItem.info.client)){
                       vm.isClientUser = true;
                       vm.showAssignmentField = true;
                       $log.info('client user!');
               }
           }

           // i

           // set vm.hasDueDate so we know whether or not to set time to startOfDay duedatechange
           if(_.has(vm.editedItem.info, 'duedate')){
                vm.hasDueDate = true;
           }

            if(_.has(vm.editedItem.info, 'following')){
                if(vm.editedItem.info.following[$rootScope.userID]){
                    vm.isFollowing = true;
                }
            }

            if(_.has(vm.editedItem.info, 'duedate')){
                vm.maxStartDate = moment(vm.editedItem.info.duedate).toDate();
                // if due or past due
                if(moment(vm.editedItem.info.duedate).toISOString() <= moment().toISOString()){
                    vm.dueStyle="color:red;"
                }
            }

            // if(vm.editedItem.type == 'template' && !_.has(vm.editedItem.schedule, 'time')){
            //     var now = moment();
            //     vm.editedItem.schedule.time = now;
            // }

            // If this task was already completed, it's panel has been set to "Later" to keep it off the board.
            // BUT we need to see this historically so we've stored it on originalPanel
            if(vm.editedItem.info.status == 'closed'){
                vm.editedItem.info.panel = vm.editedItem.info.originalPanel
            }


            vm.canUseChecklists = gateService.gateData.canUseChecklists;
            // set minDate so we can't select due dates prior to today
            vm.minDate = vm.today;
            // Prep for files
            vm.numFiles = 0;
            if (_.has(vm.editedItem, 'info.files')) {
                vm.numFiles = vm.editedItem.info.files.length;
            } else {
                vm.editedItem.info.files = [];
            }

            // If we are here from a copied task, set the form to dirty immediately
            if(vm.defaultDirty){
                $timeout(function(){
                    $scope.taskDialogForm.$setDirty();

                }, 200);
            }




        // Initialize
        init();

        function init(){
            getTeamList();
        }

        // Load our teamList for our assignee drop down from teamDataService.clientTeams
        // Then go through and determine:
        // A: If the assignment field should show
        // B: If the current user has the rights to change the assignment
        function getTeamList(){
            // $log.info('getTeamList');
            vm.teamListLoading = true;
            // If we don't check here, errors for solo accounts may get thrown.
            if(_.has(teamDataService, 'clientTeams')){
                if(_.has(teamDataService.clientTeams, vm.editedItem.info.client)){
                    vm.teamList = teamDataService.clientTeams[vm.editedItem.info.client];
                    vm.teamListSize = _.size(vm.teamList);
                    vm.teamListLoading = false;
                    // $log.info(vm.teamList);
                } else {
                    // Has teams but not for this client.
                }
            }


                // if it's the owner of the task, they can assign
                if(vm.editedItem.creator == $rootScope.userID){
                    vm.isTaskOwner = true;
                };

                vm.isAdmin = false;
                if(vm.teamList){
                    // $log.info('has teamlist');
                    // (teams exist w ithout team info if workspaces are archived cuz that's where we hold that info.)
                    // if there's no one in the team list, then this is the owner and no team members have been invited yet
                    if(_.size(vm.teamList) > 0){
                        // find this logged in member in the list
                        _.each(vm.teamList, function(member){
                            if(member.uid == $rootScope.userID){
                                vm.showAssignmentField = true;
                                // if it's the owner of the team, they can assign
                                if (member.role == 'owner'){
                                    vm.isAdmin = true;
                                }
                                // if they've been made admin on a client, they can assign for that client
                                if (_.has(member.clients, vm.editedItem.info.client)){
                                    if(member.clients[vm.editedItem.info.client] == 'admin'){
                                        vm.isAdmin = true;
                                    }
                                }
                            }// if member matches current user
                        });// each member
                    } else {
                        // no actual teamList for this client, this user is Admin
                        vm.isAdmin = true;
                    }
                } else {
                    $log.info('doesn\'t have teamlist');
                    // solo account. No assignment field.
                    vm.isAdmin = true;
                    vm.showAssignmentField = false;
                }


        }

        function toggleFollow(follow, task){
            if(!_.has(task.info, 'following')){
                task.info.following = {};
            }

            var updates = {};

            if(!follow){
                vm.isFollowing = true;
                task.info.following[$rootScope.userID] = true;
                firebase.database().ref('tasks').child(task.uid).child('info').child('following').child($rootScope.userID).set(true);
            } else {
                vm.isFollowing = false;
                task.info.following[$rootScope.userID] = false;
                firebase.database().ref('tasks').child(task.uid).child('info').child('following').child($rootScope.userID).set(null);
            }
        }// toggleFollow
        $scope.isDependencyComplete = function(item, index){
            var thisResult = true;
            // if forced order completion is enabled, only enable checkbox if item before it is complete
            if(vm.editedItem.orderedChecklist){
                thisResult = false;
                // first one doesn't have to wait for something else to be completed first
                if(index < 1){
                    thisResult = true;
                } else {
                    // check to see if previous item is incomplete
                    var prevIndex = Number(item.order)-1;
                    _.each(vm.editedItem.checklist, function(subtask){
                        // find the item PRIOR
                        if(subtask.order == prevIndex){
                            if(subtask.complete){
                                thisResult = true;
                            }
                        }// if we found previous subtask
                    });
                }// if not the first item
            }
            return thisResult
        }

        $scope.deleteTask = function(task){
            if(!timerDataService.hasTimer(task.info)){
                     return taskDataService.removeTask(task.info)
                     .then(function(){
                        $mdDialog.cancel();
                     });
                   } else {
                       alert("You have open timers for this task. Please commit or discard them first.")
                   }
        }//deleteTask


        vm.updateForcedOrder = function(task){
            $log.info('updateForcedOrder');
            // $log.info(task);
            var taskRef = firebase.database().ref('/tasks/' + task.uid);
            taskRef.child('orderedChecklist').set(task.orderedChecklist);
        }

        vm.getUserRole = function(clientID){
            // Set defaults
                var teamSize = 0;

                if(_.has(teamDataService, 'clientTeams')){
                    if(_.has(teamDataService.clientTeams, clientID)){
                        teamSize = _.keys(teamDataService.clientTeams[clientID]).length;
                        if(teamSize > 1 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
                            return teamDataService.clientTeams[clientID][$rootScope.userID].role;
                        } else {
                            // no team. This is a solo account. Set all to true.
                            return 'member'
                        }
                    } else {
                        // solo account, no team
                        return 'admin'
                    }
                }


            }// get User Role

        vm.panelCandidates = [];

        // Load up panel candidates

        vm.clientChange = function(clientID, selectDefaultList){
            _.each(clientDataService.clients, function(client){
                if(client.uid == clientID){
                    // Store client on scope so task and tasknotes have access
                    vm.thisClient = client;
                    // if this is a new task, set the list to "New Tasks"
                    if(!_.has(vm.editedItem, 'uid') && _.has(vm.thisClient, 'defaultTaskBoard') && !_.has(vm.editedItem.info, 'list')){
                        vm.editedItem.info.list = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].defaultList;
                    }

                    // set vm.activeLists for our list picker
                    if(_.has(vm.thisClient, 'defaultTaskBoard')){
                        vm.taskBoard = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard];
                        vm.activeLists = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].lists;
                        vm.editedItem.info.board = vm.thisClient.defaultTaskBoard;
                        if(selectDefaultList){
                            vm.editedItem.info.list = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].defaultList;
                        }
                    }

                    if(_.has(vm.thisClient, 'clientUsers')){
                        vm.hasClientUsers = true;
                    }
                    vm.isThisClientUser = false;
                    if(_.has(vm.thisClient, 'clientUsers')){
                        if(_.has(vm.thisClient.clientUsers, $rootScope.userID)){
                            vm.isThisClientUser = true;
                            vm.isClientUser = true;
                            vm.showAssignmentField = true;
                        }
                    }

                    // if doesn't have defaultTaskBoard - use panels, otherwise, load up the lists from the taskboard
                    if(!_.has(vm.thisClient, 'defaultTaskBoard')){
                        $timeout(function(){
                            // empty our panel array
                            vm.panelCandidates = [];
                            // unassign our panel
                           vm.editedItem.info.panel = 'Later';

                           // If not a clientuser, give them all lists
                           if(!vm.isThisClientUser){
                                vm.panelCandidates = client.taskpanels;

                            } else {
                                // if clientUser, the just have access to the lists they are enabled for
                                vm.panelCandidates = [];
                                _.each(client.taskpanels, function(list){
                                    if(list.clientEnabled){
                                        vm.panelCandidates.push(list);
                                    }
                                })
                            }
                            // reset our teamList for this client
                            getTeamList();
                        },0);
                    } else {
                        // if list based then we already have our panels
                        getTeamList();

                    }// if panels or lists

                }
            });
            // $log.info(vm.panelCandidates);
        } // clientChange


        vm.setPriority = function(priority, $event){
            var hasPriority = false;
            if(_.has(vm.editedItem.info, 'priority')){
                hasPriority = true;
            }

            if(priority != 'none'){
                vm.editedItem.info.priority = priority;
            } else {
                delete vm.editedItem.info.priority
            }
            $scope.taskDialogForm.$setDirty();
        }//setPriority

        var tempPanel;
        // execute clientChange to pre-select our option
        if(_.has(vm.editedItem, 'info.client')){
            // hacking this. rnning client change resets panel to "Later".
            // that's needed when the client is changed, but not on load.
            tempPanel = angular.copy(vm.editedItem.info.panel);
            vm.clientChange(vm.editedItem.info.client);

            // restore our panel selection
            $timeout(function(){
                vm.editedItem.info.panel = tempPanel;
            },50)
        }


        vm.duedates = {
            today: moment().hour(vm.startOfDay).minutes(0).toDate(),
            tomorrow: moment().add(1, 'day').hour(vm.startOfDay).minutes(0).toDate(),
            days3: moment().add(3, 'day').hour(vm.startOfDay).minutes(0).toDate(),
            days7: moment().add(7, 'day').hour(vm.startOfDay).minutes(0).toDate()
        }

        vm.setDueWith = function(day){

            if(day != 'none'){

                var hours, minutes;

                // if we already have a duedate set, grab it's hh/mm
                if(vm.editedItem.info.duedate){
                    hours = moment(vm.editedItem.info.duedate).format('HH'),
                       minutes = moment(vm.editedItem.info.duedate).format('mm');
                } else {
                    hours = vm.startOfDay;
                    minutes = '00'
                }
                vm.hasDueDate = true;

                // if our start and due dates were the same - then no distinct start has been set yet.
                // set the start to match duedate.
                var changeStartToo = false;
                if(moment(vm.editedItem.info.duedate).toISOString() == moment(vm.editedItem.info.startdate).toISOString()){
                    changeStartToo = true;
                }

                // change the duedate
                vm.editedItem.info.duedate = moment(day).hours(hours).minutes(minutes);

                userDataService.trackEvent('set-due-date');
                // if no unique start already, set the startdate to match
                if(changeStartToo){
                    vm.editedItem.info.startdate = vm.editedItem.info.duedate;
                }
                $scope.taskDialogForm.$setDirty();

            } else {
                if(vm.editedItem.info.duedate){
                    delete vm.editedItem.info.duedate;
                    delete vm.editedItem.info.startdate;
                    delete vm.editedItem.info.dueDisplayTime;
                    delete vm.editedItem.info.startDisplayTime;
                    $scope.taskDialogForm.$setDirty();
                    userDataService.trackEvent('remove-due-date');

                }
            }


        }

        vm.displayDueTimeDialog = function (dueDate) {


            //if we already have a time, use it.
            // otherwise use startofday for our time
            if(_.has(vm.editedItem.info, 'dueDisplayTime')){
               dueDate = moment(vm.editedItem.info.duedate);
            } else {
                dueDate = moment(dueDate).hour(vm.startOfDay).minutes(0);
            }

              mdcDateTimeDialog.show({
                currentDate: moment(dueDate),
                time: true,
                date: false,
                shortTime: true,
                clickOutsideToClose: true,
                disableParentScroll: true,
                todayText: 'Now',
              }).then(function (date) {

                var thisDate = moment(date);

                // if this is first time time is set, we need to also set the start time so it
                // shows in correct slot on calendar
                var changeStartToo = false;
                if(!vm.editedItem.info.dueDisplayTime){
                    vm.editedItem.info.startdate = thisDate.toDate();
                    vm.editedItem.info.startDisplayTime = thisDate.format('h:mmA');
                } else {
                    if(moment(vm.editedItem.info.duedate).toISOString() == moment(vm.editedItem.info.startdate).toISOString()){
                        changeStartToo = true;
                    }
                }

                // TODO - if due is not after start make it so
                vm.editedItem.info.dueDisplayTime = thisDate.format('h:mmA');
                vm.editedItem.info.duedate = thisDate.toDate();
                if(changeStartToo){
                    vm.editedItem.info.startdate = vm.editedItem.info.duedate;
                }
                vm.setDirty();
              }, function() {
                console.log('Selection canceled');
              });
            };

            vm.addStartDate = function(item){
                item.info.startdate = moment(item.info.duedate).toDate();
                vm.showStartEditor = true;
            }


            vm.changePanel = function(item){
                // $log.info(item);
            }

            vm.changeList = function(item){
                // $log.info(item);
            }

            vm.displayStartTimeDialog = function (startdate) {
                // TODO - if start after due, make it so
                  mdcDateTimeDialog.show({
                    currentDate: moment(startdate),
                    time: true,
                    date: false,
                    shortTime: true,
                    clickOutsideToClose: true,
                    disableParentScroll: true,
                    todayText: 'Now',
                    maxDate: moment(vm.editedItem.info.duedate)
                  }).then(function (date) {
                    var thisDate = moment(date);
                    vm.editedItem.info.startDisplayTime = thisDate.format('h:mmA');
                    vm.editedItem.info.startdate = thisDate.toDate();
                    vm.setDirty();
                  }, function() {
                    console.log('Selection canceled');
                  });
                };

                vm.displayTemplateTimeDialog = function (startOn) {

                      mdcDateTimeDialog.show({
                        currentDate: startOn,
                        time: true,
                        date: false,
                        shortTime: true,
                        clickOutsideToClose: true,
                        disableParentScroll: true,
                        todayText: 'Now'
                      }).then(function (date) {
                        vm.startOn = moment(date);

                        // vm.setDirty();
                      }, function() {

                      });
                    };

                vm.areDatesSame = function(date1, date2){
                    var difference = moment(date1).diff(date2, 'minutes');
                    if(difference == 0){
                        return true
                    }
                }

                vm.removeStartDate = function(){
                    vm.editedItem.info.startdate = moment(vm.editedItem.info.duedate).toDate();
                    vm.editedItem.info.startDisplayTime = moment(vm.editedItem.info.duedate).format('h:mmA');
                    vm.showStartEditor = false;
                    vm.setDirty()
                }


                vm.dueChanged = function(newDate, originalDate){
                    userDataService.trackEvent('change-due-date');
                    // Adjust the maxStartDate
                    if(!vm.hasDueDate){
                        // user.profile.settings.startOfWorkday
                        vm.editedItem.info.duedate = moment(vm.editedItem.info.duedate).hour(vm.startOfDay).minutes(0);

                        //dueDate = date @ UTC - offset - startHour

                    }

                    vm.hasDueDate = true;

                    // if we already have a duedate set, grab it's hh/mm
                    vm.maxStartDate = moment(vm.editedItem.info.duedate).toDate();
                    // Fix startdate if it now occurs AFTER the due date
                   if(_.has(vm.editedItem.info, 'startdate')){
                    if(moment(vm.editedItem.info.duedate).diff(vm.editedItem.info.startdate) < 0){
                        vm.editedItem.info.startdate = moment(vm.editedItem.info.duedate).toDate();
                    }

                }
                    vm.setDirty();
                }

        // Needed variables for tag autocomplete field
        vm.selectedItem = undefined;
        vm.searchText = "";


        // Recurring Task Handling
        vm.rulePreview = [];
        vm.startOnPrep = moment().startOf('day').add(6, 'hours');
        vm.startOn = moment.utc(vm.startOnPrep).toDate();
        // $log.info('vm.startOn=' + moment.utc(vm.startOn).format());

        if(_.has(vm.editedItem, 'schedule.startOn')){
            // setting our startOn time to start of day in local time zone
            // var temp = moment.utc(vm.editedItem.schedule.startOn);
            vm.startOn = moment(vm.editedItem.schedule.startOn).toDate();
        }

        vm.resetValidity = function(){
            vm.startOn = moment(vm.startOn).toISOString();
            vm.validRule = false;
            vm.rulePreview = [];
        }

        vm.setDirty = function(){
            $scope.taskDialogForm.$setDirty();
        }

        vm.showChecklists = function(item){
            // only show checklists A) if allowed. B) if there's a UID or there's already a checklist
            if(vm.canUseChecklists){
                if(_.has(item, 'uid')){
                    return true
                } else if (_.has(item,'checklist')){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }// if vm.canUseChecklists
        }

        vm.calcRule = function(ruleText){
            // $log.info('vm.calcRule');
            // Clear our preview array
            vm.rulePreview = [];

            // This rrule library is weird. Saving the rule to repopulate the field
            // after calcing
            var ruleCopy = angular.copy(ruleText);


    ///////////// Setup our Rule /////////////
    //
            // Setup our ruleOptions with our ruleText
            var ruleOptions = RRule.parseText(ruleText);

            // Careful construction of our dtstart object
            // to make sure our recurring rule starts at the right time
            var startYear = moment(vm.startOn).format('YYYY'),
                startMonth = moment(vm.startOn).format('MM'),
                startDay = moment(vm.startOn).format('DD'),
                startTime = moment(vm.startOn).format('HH'),
                startMinutes = moment(vm.startOn).format('mm');

            // Add our dtstart object to our ruleoptions
            ruleOptions.dtstart = new Date(startYear, startMonth - 1, startDay, startTime, startMinutes, 0);

            // Create our rule with the options we've put together
            var rule = new RRule(ruleOptions);

    ///////////// End Setup Rule /////////////

    ////////// Build preview array

            // set our preview limit
            var previewLimit = 6;

            // Reduce the limit to the actual count
            // If count is less than 6, let's not confuse our users.
            if(rule.options.count < 6){
                previewLimit = rule.options.count;
            }

            // pull only the next previewLimit occurences
            vm.ruleTemp = rule.all(function (date, i){return i < 6});

            vm.rulePreview = [];
            // Convert Dates to human readable
            _.each(vm.ruleTemp, function(scheduledDate){
                scheduledDate = moment(scheduledDate).format('dddd MMM DD, YYYY');
                vm.rulePreview.push(scheduledDate);
            });
    //
    //////// end preview array building ////

            // If we have successful preview...setup our schedule
            // Our "aha" moment on dealing with dates that take local timezones into account
            // (All tasks are due midnight in the user's locale)
            // came from this article:
            // http://blog.skylight.io/bringing-sanity-to-javascript-utc-dates-with-moment-js-and-ember-data/

            if(vm.rulePreview.length){
                // We've changed the form. Alter $Pristine
                $scope.taskDialogForm.$pristine = false;
                vm.validRule = true;

                // Setup our schedule
                var today = moment().startOf('day'), // make sure we are starting from our local midnight
                    // convert to global utc
                    today = moment.utc(today).toDate(),
                    // we are going to start our occurence building YESTERDAY to be sure to
                    // include today (if start date is on today)
                    yesterday = moment.utc(today).subtract(1,'day').toDate();
                    // next occurence is on rule match, at midnight, in this time zone

                    var nextDue = rule.after(yesterday),
                        nextRepeat = moment(nextDue).subtract(vm.editedItem.schedule.dueDays, 'days');

                // setup props for our repeating schedule
                // vm.editedItem.schedule = {};
                // Store our rule
                vm.editedItem.schedule.repeatRule = rule.toString();
                // Store the nextcreate date
                vm.editedItem.schedule.nextCreateDate = moment(nextRepeat).toISOString();
                // Store the nextdue date
                vm.editedItem.schedule.nextDueDate = moment(nextDue).toISOString(); // this will change later
                // Store run limit
                vm.editedItem.schedule.limit = rule.options.count;
                // Set run count to 0
                vm.editedItem.schedule.count = 0;
                // Set complete to false
                vm.editedItem.schedule.complete = false;
                // Store our offset (just in case we need it later)
                vm.editedItem.schedule.offset = (new Date()).getTimezoneOffset();
                // // convert our startOn to utc for storage
                vm.editedItem.schedule.startOn = moment.utc(ruleOptions.dtstart).toISOString();

                // we have good results. Put our rule back in the form.
                // we don't know why it's going empty on us but this gets around it
                vm.editedItem.schedule.ruleText = ruleCopy;
                $scope.taskDialogForm.$setDirty();
            } else {
                $mdToast.showSimple('Sorry, I couldn\'t Understand that rule.');
            }

        }// vm.calcRule;



        $scope.toggleToday = function (task) {
            // $log.info('dialogController: toggleToday');
            if (task.info.focus == 'today') {
                task.info.focus = 'someday';
            } else {
                task.info.focus = 'today';
            }
            $scope.taskDialogForm.$setDirty();
        }
        $scope.togglePrivate = function (task) {
            // $log.info('dialogController: toggleToday');
            if (task.info.private) {
                task.info.private = false;
            } else {
                task.info.private = true;
            }
            $scope.taskDialogForm.$setDirty();
        }

        $scope.toggleComplete = function (task) {
            if(!timerDataService.hasTimer(task.info)){
                     return taskDataService.toggleStatus(task.info);
                   } else {
                       alert("You have open timers for this task. Please commit or discard them first.")
                   }
            $scope.taskDialogForm.$setPristine();
        }

        $scope.setupTask = function () {
            vm.taskControls = true;
        }

        $scope.hideTaskControls = function () {
            vm.taskControls = false;
        }

        $scope.showTaskControls = function () {
            vm.taskControls = true;
        }

        $scope.setupNotes = function () {
            taskDataService.setupNotes();
        }

        $scope.cancelDialog = function (task) {
            $scope.editedItem = null;
            // unwatch();

            $mdDialog.cancel();
        } //cancelDialog


        $scope.saveUpdatedTask = function(task) {

            // $log.info('updateTask called for:');
            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            } else {
                // task.info.assignee is set.
                // let's get the rest of the info we need to display on our cards
                _.each(vm.teamList, function(member){
                    if(member.uid == task.info.assignee){
                        task.info.assigneeName = member.fullName;
                        task.info.assigneeAvatar = member.avatar;
                    }
                });
            }
            if(_.has(task.info, 'duedate')){
                task.info.duedate = moment(task.info.duedate).toISOString();
            }

            if(_.has(task.info, 'startdate')){
                task.info.startdate = moment(task.info.startdate).toISOString();
            }


                taskDataService.updateTask(task, vm.originalLocation);

            // remove editedItem
            $scope.editedItem = null;
            ////
            // unwatch();
            // Remove our Dialog
            $mdDialog.cancel();
            // remove highlight if it was added in previous step
            delete task.highlight;

        } // saveUpdatedTask


        $scope.saveNewTask = function (task, andNew) {
            // $log.info('save new task clicked');
            // $log.info(task);


            // remove .clone node if exists
            if(_.has(task, 'clone')){
                delete task.clone;
            }

            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            }
            else {
                _.each(vm.teamList, function(member){

                    if(member.uid == task.info.assignee){

                        task.info.assigneeName = member.fullName;
                        task.info.assigneeAvatar = member.avatar;
                    }
                });
            }

            // $log.info('saving to panelID ' + task.info.panel);
            // Save our task
            taskDataService.saveNew(task);

            // remove editedItem
            delete $scope.editedItem;

            // Remove our Dialog
            $mdDialog.cancel();

            // This is here and not in the task service because we don't want system-generated tasks to count
            // if(Appcues){
            //     Appcues.identify(task.creator, {
            //         hasTasks: true
            //     });
            // }

             _dcq.push(["identify", {
              email: userDataService.user.email,
              tags: ["Added first Task"]
            }]);

            if (andNew) {
                //make empty editedDetail object
                $scope.editedItem = newTask(task.info.client, task.info.panel);
                $scope.editedItem.info.status = task.info.status;
                $scope.editedItem.creator = task.creator;
                $scope.editedItem.info.focus = task.info.focus;

                // Set our dialogTitle
                $scope.dialogTitle = "New Task";

                // Trigger our next task
                // $log.info($scope.editedItem);
                taskDataService.taskDialog($scope.editedItem);
            }
            ;

        }; // saveNewTask


        $scope.snoozeTask = function(item, minutes){
            taskDataService.snoozeTask(item, minutes)
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Task has been snoozed',
                        message: 'It will reappear in ' +  moment.duration({"minutes": minutes}).humanize() ,
                        color: 'green'
                    }
                }));// mdToast
        }// snoozeTask

        $scope.unSnoozeTask = function(item){
            taskDataService.unSnoozeTask(item)
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: 'Task has been un-Snoozed',
                            message: '' ,
                            color: 'green'
                        }
                    }));// mdToast
        }// unsnoozeTask


        $scope.isClose = function (item) {
            if(item){
                var progress = item.logged/item.budget;
                if (item.budget > 0 && progress <=1 && progress > .75 ) {
                    return true
                }
            }
        }


        $scope.isOver = function (item) {
            if(item){
                var progress = item.logged/item.budget
                if (item.budget > 0 && progress > 1) {
                    return true
                }
            }
        }

        ////////////
        // Tag autocomplete query
        $scope.queryTags = function (query) {
            var d = $q.defer();
            var results = query ? $rootScope.tags.filter(createFilterFor(query)) : [];
            d.resolve(results)
            return d.promise;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(tag) {
                return (tag.name.indexOf(lowercaseQuery) != -1);
                ;
            };
        }


        $scope.tagSelected = function (tag) {
            // $log.info('tagSelected', tag)
        }

        $scope.transformChip = function (chip) {
            // $log.info('transformChip', chip)
            return chip
        }


        // Checklist functions
        vm.shouldShowForm = false;

        vm.showChecklistForm = function(){
           vm.shouldShowForm = true;
             $timeout(function () {
               document.getElementById("focusfield").focus();
           }, 250, false);


        }

        vm.closeChecklistForm = function(){
            delete vm.newChecklistItem

            // delete vm.newChecklistItem.uid;
            // delete vm.newChecklistItem.order;
           vm.shouldShowForm = false;
        }

        vm.manualSubmit = function(task){
            // Enter has been pressed while in the task description field
            if(_.has(task, 'uid') && $scope.vm.editedItem.info.description && $scope.vm.editedItem.info.client){
                // update task
                $scope.saveUpdatedTask($scope.vm.editedItem);
            } else if ($scope.vm.editedItem.info.description && $scope.vm.editedItem.info.client) {
                // add new task
                $scope.saveNewTask($scope.vm.editedItem);
            } else {
                return false
            }
        }


        // Called to add or UPDATE an existing checklistItem
        vm.addChecklistItem = function(item, task){

            // $log.info('add/update item:');
            // $log.info(item);
            // $log.info(task);
            if(_.has(item, 'uid')){
                userDataService.trackEvent('update-subtask');
                // We are editing this item's body only. Just update it directly
                var updates = {};

                if(task.type == 'template'){
                     updates['taskTemplates/' + task.uid + '/checklist/' + item.uid + '/body'] = item.body;
                } else {
                    updates['tasks/' + task.uid + '/checklist/' + item.uid + '/body'] = item.body;
                }

                return firebase.database().ref().update(updates)
                        .then(function () {
                            $timeout(function(){vm.newChecklistItem.body = "";
                                vm.closeChecklistForm();
                            },0);
                        });
            } else {
                userDataService.trackEvent('add-subtask');

                // new item, give it an order and save it.
                item.order = _.size(vm.editedItem.checklist) + 1;
                return taskDataService.addChecklistItem(item, task).then(function(result){
                    $timeout(function(){delete vm.newChecklistItem;},0);
                      $timeout(function () {
                        document.getElementById("focusfield").focus();
                    }, 250, false);
                });
            }
        }



        vm.deleteChecklistItem = function(item, task){
            // $log.info('vm.deleteChecklistItem');
            return taskDataService.deleteChecklistItem(item, task);
        }

        vm.updateChecklistItem = function(item,task){
            $timeout(function(){
                return taskDataService.updateChecklistItem(item, task);
            },200);
        }

        vm.editChecklistItem = function(item,task){

            var itemCopy = angular.fromJson(angular.toJson(item));
            // $log.info(itemCopy);
            vm.showChecklistForm();
            vm.newChecklistItem = itemCopy;
        }

        vm.cancelEditChecklistItem = function(){
            vm.newChecklistItem = "";
        }

        vm.makeChecklistItemCard = function(item, task){
            return taskDataService.deleteChecklistItem(item, task);
        }


        vm.budgetChanged = function(budget){
            // $log.info(budget);
            userDataService.trackEvent('set-task-budget');
        }

        vm.isTimerRunning = function (task) {
            // Doing double-checking here to avoid all possible conflicts in how we are using task cards
            if(_.has(timerDataService, 'timerData.activeTimer.on') && _.has(timerDataService, 'timerData.activeTimer.task')){
                if (timerDataService.timerData.activeTimer.on && timerDataService.timerData.activeTimer.task.uid == task.refID){
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }

        vm.hasOpenTimers = function(task){
            if(_.find(timerDataService.timerData.timers, function(o) {
                // make certain this timer has a task before we check and throw an error
                if(_.has(o, 'task')){
                    return o.task.uid == task.refID;
                }
            })){
                return true
            }
        }

        vm.startTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('startTimer Clicked on Task');
            timerDataService.newTaskTimer(task);

        }

        vm.pauseTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('vm.pauseTimer', task);
            timerDataService.pauseTaskTimer(task);
        }

        vm.resumeTimer = function (task, $event) {
            $event.stopPropagation();
            // $log.info('$scope.resumeTimer', task);
            timerDataService.resumeSavedTaskTimer(task);
        }

        vm.addTime = function(task){
            // $log.info('addTime');
            var timeEntry = timeDataService.newLogEntry(task.info.client, task.uid);
            // $log.info($scope.timeEntry);
            return timeDataService.timeDialog(timeEntry, "New");
        }

            // if we already have a Dragula bag by this name (we shouldn't but sometimes we do), destroy it
            if (dragulaService.find($scope, 'drag-checklist')){
                dragulaService.destroy($scope, 'drag-checklist');
            }

              // Dragula Setup
               dragulaService.options($scope, 'drag-checklist', {
                         moves: function (el, container, handle) {
                            // return true
                           return handle.classList.contains('handle');

                         },
                         accepts: function(el, target, source, sibling) {
                          return true
                          // if (target === source){
                          //   return true
                          // }
                        },
                        invalid: function(el, handle){
                            return false
                        },
                         direction: 'vertical',
                         revertOnSpill: true,
                         removeOnSpill: false
                       });

               ///////////
               // Task Drop Listener
               $scope.$on('drag-checklist.drop', function(event, item, target, source, sibling){
                   // $log.info('drag-checklist.drop');

                   // Get our items to sort
                    var sortingContainer = $('.task-checklist');
                    var sortedItems = Array.from(sortingContainer.find('.checklist-item'));

                    // var thisChecklist = angular.copy(vm.editedItem.checklist);
                    var thisChecklist = vm.editedItem.checklist;
                   // Change Sort Order

                   _.each(sortedItems, function(item, index){
                        var itemID = item.attributes.uid.value,
                        thisItem = thisChecklist[itemID],
                        originalOrder = thisItem.order;
                        thisItem.order = index + 1;
                   });
                   $scope.$apply();
                   var updates = {}
                   // $log.info(thisChecklist);
                   updates['/tasks/' + vm.editedItem.uid + '/checklist/'] = thisChecklist;
                   return firebase.database().ref().update(updates)
                   .then(function(){
                    // $log.info('sort changed');
                    userDataService.trackEvent('reorder-subtask');
                   })
               });// $on.drag-task.drop


               hotkeys.bindTo($scope)
                  // inhibit enter from submitting
                  .add({
                      combo: 'enter',
                      callback: function (event) {
                          event.preventDefault();
                          // $log.info('enter blocked');
                      }
                  })
                  .add({
                      combo: 'ctrl+enter',
                      allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                      description: 'Save/Update Client',
                      callback: function (event) {
                          // $log.info('ctrl+enter');
                          event.preventDefault();
                          // $log.info($scope.clientDialogForm);
                          var pristine = $scope.taskDialogForm.$pristine,
                                  invalid = $scope.taskDialogForm.$invalid,
                                  clientID = $scope.vm.editedItem.uid;

                          if (!pristine && !invalid && clientID) {
                              $scope.saveUpdatedTask($scope.vm.editedItem);
                          }

                          if (!pristine && !invalid && !clientID) {
                              $scope.saveNewTask($scope.vm.editedItem);
                          }
                      }
                  });
                  // .add({
                  //     combo: 'shift+ctrl+enter',
                  //     allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  //     description: 'Save and add New',
                  //     callback: function (event) {
                  //         // $log.info('shift+ctrl+enter');
                  //         event.preventDefault();
                  //         // $log.info($scope.clientDialogForm);
                  //         var pristine = $scope.taskDialogForm.$pristine,
                  //                 invalid = $scope.taskDialogForm.$invalid,
                  //                 clientID = $scope.vm.editedItem.uid;

                  //         if (!pristine && !invalid && clientID) {
                  //             $scope.saveUpdatedTask($scope.vm.editedItem);
                  //         }

                  //         if (!pristine && !invalid && !clientID) {
                  //             var andNew = true;
                  //             $scope.saveNewTask($scope.vm.editedItem, andNew);
                  //         }
                  //     }
                  // });


                  function htmlToPlaintext(text) {
                    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
                  }

                  // we use memoize here so the function isn't called to death and we don't throw
                  // digest errors
                  function reminderOptions(item, task) {

                          var options = {};
                          options.description = htmlToPlaintext(item.body);
                          options.message = "Task <b>" + task.info.description + '</b> has subtask that needs attention: '+ options.description;
                          options.type = "subtask";
                          options.path = '/tasks/' + task.uid + '/checklist/' + item.uid + '/reminders';
                          // options.payLoad contains info the cloud function can use

                          options.payload = {
                              taskID : item.uid,
                              parentTaskID : task.uid,
                              owner : $rootScope.userID
                          }

                          return options
                  }

                  function hasReminder(item){
                      var found = false;
                      if(_.has(item, 'reminders')){
                          _.each(item.reminders, function(reminder){
                              if(reminder.owner == $rootScope.userID && reminder.status != 'closed'){
                                  found = true;
                              }
                          });
                      }
                      if(found){
                          return true;
                      }
                  }// hasReminder

                  function myReminderDue(task){
                     var foundReminder = myReminder(task);
                     if(foundReminder){
                          return moment(foundReminder.when).format(vm.settings.amDateFormat);
                     }
                  }// hasReminder

                  function myReminder(task){
                      var found = false,
                          thisReminder = undefined;
                      if(_.has(task, 'reminders')){
                          _.each(task.reminders, function(reminder){
                              if(reminder.owner == $rootScope.userID){
                                  found = true;
                                  thisReminder = reminder;
                              }
                          });
                          if(found){
                              return thisReminder
                          }
                      }// if has reminders
                  }// thisReminder

        } // end taskDialogController

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('taskDataService', taskDataService);

    /* @ngInject */
    function taskDataService($mdToast, $q, $log, $window, scheduleDataService, gateService, clientDataService, taskTemplateDataService, userDataService,
         taskPanelDataService, localStorageService, $http, pageDimensionsService, notificationService, $mdMedia, $mdDialog,
        $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject) {
        var service = {
            newTask: newTask,
            getClientTasks: getClientTasks,
            getTask: getTask,
            taskDialog: taskDialog,
            batchDialog: batchDialog,
            toggleToday: toggleToday,
            toggleComplete: toggleComplete,
            setDueDate: setDueDate,
            setPriorityFlag: setPriorityFlag,
            saveNew: saveNew,
            removeTask: removeTask,
            updateTask: updateTask,
            cloneTask: cloneTask,
            cloneTaskList: cloneTaskList,
            logTask: logTask,
            setupNotes: setupNotes,
            moveTask: moveTask,
            snoozeTask: snoozeTask,
            unSnoozeTask: unSnoozeTask,
            makeTemplate: makeTemplate,
            makeRecurring: makeRecurring,
            reCalcTask: reCalcTask,
            quickUpdate: quickUpdate,
            addChecklistItem: addChecklistItem,
            updateChecklistItem: updateChecklistItem,
            deleteChecklistItem: deleteChecklistItem,
            makeChecklistItemCard: makeChecklistItemCard,
            getAllTasks: getAllTasks,
            toggleStatus: toggleStatus,
            upgradeTaskBoard: upgradeTaskBoard
        };

        var allClientsTasks = [];

        return service;

        function cloneTask(task, options){
            // $log.info('cloneTask');
            // $log.info(task);
            return new Promise(function(resolve, reject){
                return firebase.database().ref('/tasks/' + task.uid).once('value', function(snapshot){
                    if(snapshot.exists()){
                        var fullTask = snapshot.val();
                        var taskClone = newTask(options.client, options.list);

                        taskClone.info.description = fullTask.info.description;

                        if(_.has(fullTask.info, 'assignee')){
                            taskClone.info.assignee = fullTask.info.assignee;
                        }
                        if(_.has(fullTask.info, 'assigneeName')){
                            taskClone.info.assigneeName = fullTask.info.assigneeName;
                        }
                        if(_.has(fullTask.info, 'assigneeAvatar')){
                            taskClone.info.assigneeAvatar = fullTask.info.assigneeAvatar;
                        }

                        if(_.has(fullTask.info, 'budget')){
                            taskClone.info.budget = fullTask.info.budget;
                        }
                        if(_.has(fullTask.info, 'priority')){
                            taskClone.info.priority = fullTask.info.priority
                        }
                        if(_.has(fullTask.info, 'order')){
                            taskClone.info.order = fullTask.info.order
                        }
                        if(_.has(fullTask.info, 'allOrder')){
                            taskClone.info.allOrder = fullTask.info.allOrder;
                        }
                        if(_.has(fullTask.info, 'numChecklistItems')){
                            taskClone.info.numChecklistItems = fullTask.info.numChecklistItems;
                        }
                        if(_.has(fullTask.info, 'numnotes')){
                            taskClone.info.numnotes = fullTask.info.numnotes;
                        }


                        // we are not including files as files need to be stored on specific clients
                        // maybe will add file migration to new paths at a later date
                        // if(_.has(fullTask.info, 'files')){
                        //     taskClone.info.files = fullTask.info.files
                        // }

                        if(_.has(fullTask.info, 'linkLabel')){
                            taskClone.info.linkLabel = fullTask.info.linkLabel
                        }

                        if(_.has(fullTask.info, 'linkTarget')){
                            taskClone.info.linkTarget = fullTask.info.linkTarget
                        }

                        if(_.has(fullTask.info, 'linkURL')){
                            taskClone.info.linkURL = fullTask.info.linkURL
                        }

                        var newTaskKey = firebase.database().ref().child('tasks/').push().key;
                        // if files && we aren't' cloning to a different workspace
                        if(_.has(taskClone, 'info.files') && item.client == taskClone.info.client){
                            _.each(taskClone.info.files, function(file, index){
                                if(_.has(file, 'thumbnail')){
                                    if(file.source == "firebaseStorage" && file.thumbnail == file.url){
                                        // this is a new file. Give it a response path
                                        file.responsePath = 'tasks/' + newTaskKey + '/info/files/' + index;
                                        file.responsePath2 = 'clients/' + taskClone.info.client + '/tasks/' + newTaskKey + '/files/' + index;
                                    }
                                }// if has thumbnail
                            });// each files
                        }// if files
                        // put our $id as a property for easier retrieval

                        taskClone.uid = newTaskKey;
                        taskClone.info.refID = newTaskKey;
                        taskClone.info.uid = newTaskKey;
                        // $log.info('before saving');
                        // $log.info(taskClone);
                        // add our task to the new key
                        var updates = {};
                        updates['/tasks/' + newTaskKey] = taskClone;
                        updates['/clients/' + taskClone.info.client + '/tasks/' + newTaskKey] = taskClone.info;
                        // updates['/users/' + taskClone.info.assignee + '/tasks/' + newTaskKey] = taskClone.info;
                        updates['/taskBoards/'+ options.board + '/lists/' + options.list + '/items/' + newTaskKey] = taskClone.info;

                        // $log.info(updates);
                        // return
                        // make the update
                        return firebase.database().ref().update(updates)
                        .then(function(results) {
                            if(_.has(fullTask, 'checklist')){
                                var newChecklist = {};
                                _.each(fullTask.checklist, function(subtask){
                                    var newSubTask = angular.copy(subtask),
                                        newSubTaskKey = firebase.database().ref().child('tasks/' + taskClone.uid + '/checklist/').push().key;
                                    newSubTask.complete = false;
                                    newSubTask.uid = newSubTaskKey;
                                    newChecklist[newSubTask.uid] = newSubTask;
                                });
                                // $log.info('New Checklist');
                                // $log.info(newChecklist);
                                var updates = {};
                                updates['/tasks/' + taskClone.uid + '/checklist/' ] = newChecklist;
                                return firebase.database().ref().update(updates)
                                .then(function(){
                                    userDataService.trackEvent('clone-task-list');
                                    return resolve(true);
                                })
                                .catch(function(error){
                                    $log.info(error);
                                    return reject(error);
                                })
                            } else {
                                return resolve(true)
                            }
                        })
                        .catch(function(error){
                            $log.info(error);
                            return reject(error)
                        })


                    } else {
                        // no task at that ID? Silently fail.
                        return resolve(true);
                    }
                })
            })
        }//cloneTask


        function cloneTaskList(list, sourceWorkspaceID, targetWorkspaceID){
            $log.info('cloneTaskList');
            return new Promise(function(resolve, reject){
                _.each(clientDataService.clients, function(client){
                    if(client.uid == targetWorkspaceID){
                        var taskBoardID = client.defaultTaskBoard,
                            taskBoard = client.taskBoards[client.defaultTaskBoard],
                            order = _.size(client.taskBoards[client.defaultTaskBoard].lists),
                            newList = angular.copy(list);
                        delete newList.items;
                        newList.order = order - 1;
                        if(sourceWorkspaceID != targetWorkspaceID){
                            newList.order = 1;
                        }
                        newList.uid = firebase.database().ref('/taskBoards/' + taskBoardID + '/lists/').push().key;
                        if(sourceWorkspaceID == targetWorkspaceID){
                            newList.label = "Copy of " + newList.label;
                        }
                        var updates = {};
                        updates['/taskBoards/' + taskBoardID + '/lists/' + newList.uid] = newList;
                        updates['/clients/' + client.uid + '/taskBoards/' + client.defaultTaskBoard + '/lists/' + newList.uid] = newList;
                        return firebase.database().ref().update(updates)
                        .then(function(){
                            var taskPromises = [], options = {board: taskBoardID, client: client.uid, list: newList.uid};

                            _.each(list.items, function(item){
                                // prepare /task, /client/tasks/, /taskBoards/list/items/task updates for task
                                taskPromises.push(cloneTask(item, options));
                            });
                            return Promise.all(taskPromises)
                            .then(function(){
                                return resolve(true)
                            })
                            .catch(function(error){
                                $log.error(error);
                                return reject(error);
                            })
                        })
                    }
                })
            })// promise
        }//cloneTaskLIst

        function getAllTasks(clients){
            var allTasks = [];
            _.each(clients, function (client) {
                _.each(client.tasks, function(task){
                    if(task.status == 'open'){
                        allTasks.push(task);
                    }
                });// each task
            });// each client
            return allTasks
        }//getAllTasks

        function reCalcTask(taskID) {
            // $log.info('reCalcTask Totals');
            return getTask(taskID)
                    .then(function (task) {
                        // $log.info('recalcing task', task.info);
                        // $log.info(task.info.client);
                        var total = 0;
                        _.each(task.time, function (entry) {
                            total += entry.logged;
                        });

                        var updates = {};
                        updates['/tasks/' + taskID + '/info/logged'] = total;
                        updates['/clients/' + task.info.client + '/tasks/' + taskID + '/logged'] = total;
                        // updates['/users/' + task.info.assignee + '/tasks/' + taskID + '/logged'] = total;
                        // Commit our updates
                        return firebase.database().ref().update(updates)
                                .then(function () {
                                    // $log.info('reCalcTask completed');
                                });
                    });

        }

        function setDueDate(date, taskInfo){
            var updates = {};
            // if "none" is passed then we need to delete duedates.
            if(date == 'none'){
                date = null;
            }
            updates['/tasks/' + taskInfo.refID + '/info/duedate'] = date;
            updates['/clients/' + taskInfo.client + '/tasks/' + taskInfo.refID + '/duedate'] = date;
            // updates['/users/' + taskInfo.assignee + '/tasks/' + taskInfo.refID + '/duedate'] = date;
            if(_.has(taskInfo, 'board')){
                updates['/taskBoards/' + taskInfo.board + '/lists/' + taskInfo.list + '/items/' + taskInfo.uid + '/duedate'] = date;
            }
            // remove notified flag
            updates['/tasks/' + taskInfo.refID + '/notifications/notifyDue'] = false;
            return firebase.database().ref().update(updates)
                    .then(function () {
                        $mdToast.showSimple('Set or Changed Due Date');
                        userDataService.trackEvent('set-task-due-date');
                    });
        }


        function setPriorityFlag(priority, taskInfo){
            return new Promise(function(resolve, reject){
                var updates = {}, value;
                // if "none" is passed then we need to delete duedates.
                if(priority == 'none'){
                    priority = null;
                }
                var focus = 'later';
                // add/remove focus/today
                if(priority != null){
                    focus = 'today'
                }

                updates['/tasks/' + taskInfo.uid + '/info/priority'] = priority;
                updates['/clients/' + taskInfo.client + '/tasks/' + taskInfo.uid + '/priority'] = priority;
                // updates['/users/' + taskInfo.assignee + '/tasks/' + taskInfo.uid + '/priority'] = priority;
                updates['/tasks/' + taskInfo.uid + '/info/focus'] = focus;
                updates['/clients/' + taskInfo.client + '/tasks/' + taskInfo.uid + '/focus'] = focus;
                // updates['/users/' + taskInfo.assignee + '/tasks/' + taskInfo.uid + '/focus'] = focus;
                if(_.has(taskInfo, 'board')){
                    updates['/taskBoards/' + taskInfo.board + '/lists/' + taskInfo.list + '/items/' + taskInfo.uid + '/priority'] = priority;
                    updates['/taskBoards/' + taskInfo.board + '/lists/' + taskInfo.list + '/items/' + taskInfo.uid + '/focus'] = focus;
                }

                return firebase.database().ref().update(updates)
                        .then(function () {
                            logTask(taskInfo.uid, 'Set or changed Priority Flag');
                            userDataService.trackEvent('set-task-priority');
                            return resolve
                        });
            })

        }//setPriorityFlag


        function snoozeTask(task, minutes){
            var snoozeUntil = moment().add(minutes, 'minutes').toISOString();
            task.snooze = snoozeUntil;

            // make sure notify-due can bet triggered if it has a due date that's passed
            // we want to make sure they are notified
            var notifyFlagRef = firebase.database().ref('/tasks/' + task.uid + '/notifications/notifyDue');
            notifyFlagRef.set(false);
            userDataService.trackEvent('snooze-task');
            quickUpdate(task, "Your task has been snoozed for " + moment.duration({"minutes": minutes}).humanize());
        }

        function unSnoozeTask(task){
            delete task.snooze;
            //heap.track('Task unsnoozed');
            userDataService.trackEvent('unsnooze-task');
            quickUpdate(task, "Task unsnoozed");
        }

        function quickUpdate(task, message) {
            return new Promise(function(resolve, reject){
                // Save our changes down to FB
                // $log.info('quickUpdate', task);
                delete task.$id;
                delete task.$priority;
                delete task.showComplete;

                // Make sure our dates are converted to plain text isoStrings.

                if(_.has(task, 'duedate')){
                    task.duedate = moment(task.duedate).toISOString();
                }
                if(_.has(task, 'startdate')){
                    task.startdate = moment(task.startdate).toISOString();
                }

                var updates = {};
                if(_.has(task, 'list')){
                    updates['/taskBoards/' + task.board + '/lists/' + task.list + '/items/' + task.uid] = task;
                }
                updates['/tasks/' + task.uid + '/info'] = task;
                updates['/clients/' + task.client + '/tasks/' + task.uid] = task;
                // updates['/users/' + task.assignee + '/tasks/' + task.uid] = task;
                return firebase.database().ref().update(updates)
                        .then(function () {

                            // logTask(task.refID, message);

                            if (message) {
                                logTask(task.uid, message);
                                $rootScope.$emit('taskUpdated', task);
                            }

                            return resolve(true);
                        })
                        .catch(function(error){
                            $log.error('task quickUpdate failed.');
                            $log.error(error);
                            return reject(error)
                        });
            })

        }
        ///////////////////////
        // Move Task
        function moveTask(item, toPanel) {
            // $log.info('moveTask');
            var itemCopy = angular.fromJson(angular.toJson(item));
            item.panel = toPanel;
            quickUpdate(item, 'Task moved to ' + toPanel);
            //heap.track('Task Moved');
            userpilot.track('Task Moved');
        }


        //////////////////////////
        // New task
        function newTask(clientID, panel) {
            // $log.info('clientDataService.newTask');
            // $log.info('newTask for panel:' + panel);
            // $log.info('newTask for client:' + clientID);

            var userID = localStorageService.get('userID'),
                    task = {
                        creator: userID,
                        info: {
                            creator: userID,
                            assignee: userID,
                            logged: 0,
                            status: 'open',
                            budget: 0,
                            description: '',
                            numnotes: 0,
                            created: Date.now(),
                            order: 0,
                            allOrder: 0,
                            board: clientID
                        }
                    }


            if (clientID) {
                task.info.client = clientID;
            }

            switch (panel) {
                case undefined:
                    // no panel specified, it goes in Later with "someday" focus
                    task.info.focus = 'someday';
                    task.info.panel = 'Later';
                    break
                case 'today':
                    // today specified, set focus and default panel
                    task.info.panel = 'Later';
                    task.info.focus = 'today';
                    break
                case 'Later':
                    // Later specified, set focus and default panel
                    task.info.panel = 'Later';
                    task.info.focus = 'someday';
                    break
                default:
                    // Otherwise, assign the panel to match and set focus to "someday"
                    task.info.panel = panel;
                    task.info.list = panel;
                    task.info.focus = 'someday';
                    break
            }

            //heap.track('New Task Started');
            userpilot.track('New Task Started');

            // $log.info(task);
            return task
        }

        ///////////////////////////
        // getClientTasks
        function getClientTasks(clientID) {
            var tasksRef = firebase.database().ref('tasks/');

            return $firebaseArray(tasksRef.orderByChild('client').equalTo(clientID))
                    .$loaded(function (tasks) {
                        return tasks
                    });
        }
        ; // end getClientTasks

        function makeTemplate(task){
            var newTaskTemplate = taskTemplateDataService.newTaskTemplate(task.info.client);
            newTaskTemplate.info = task.info;
            newTaskTemplate.creator = $rootScope.userID;
            newTaskTemplate.assignee = $rootScope.userID;

            if(_.has(task, 'checklist')){
                newTaskTemplate.checklist = task.checklist;
            };
            logTask(task.uid, 'Used as starter for new Task Template');
            return taskTemplateDataService.saveNewTaskTemplate(newTaskTemplate)

        }


        function makeRecurring(task){
            var newTaskTemplate = taskTemplateDataService.newTaskTemplate(task.info.client);
            newTaskTemplate.info = task.info;
            newTaskTemplate.creator = $rootScope.userID;
            newTaskTemplate.assignee = $rootScope.userID;

            if(_.has(task, 'checklist')){
                newTaskTemplate.checklist = task.checklist;
            };
            logTask(task.uid, 'Used as starter for new Task Template');
            return taskTemplateDataService.taskTemplateDialog(newTaskTemplate, 6)

        }


        ////////////////////////////////
        // logTasks
        function logTask(taskID, event) {
            // log the event
            var log = {
                actor: localStorageService.get('userName'),
                actorID: localStorageService.get('userID'),
                event: event,
                timestamp: moment().toISOString()
            }

            var newLogKey = firebase.database().ref().child('tasks/' + taskID + '/activity/').push().key;
            var updates = {};
            // store our canonical object
            updates['/tasks/' + taskID + '/activity/' + newLogKey] = log;
            return firebase.database().ref().update(updates);
        } // logTask

        ///////////////////////////////////////////////////////////
        /// toggleToday
        function toggleToday(item) {
            // $log.info('toggleToday - taskDataService');
            var itemCopy = angular.fromJson(angular.toJson(item)),
                    message;

            // clean up our object for sending back to original FB reference
            // delete itemCopy.$id;
            // delete itemCopy.$priority;

            if (itemCopy.focus == 'today') {
                itemCopy.focus = 'someday';
                message = '"Today" flag removed';
                quickUpdate(itemCopy, message);

                userDataService.trackEvent('remove-task-flag');
            } else {
                itemCopy.focus = 'today';
                message = '"Today" flag set';
                quickUpdate(itemCopy, message);
                userDataService.trackEvent('set-task-flag');
            }

            //heap.track('Task Focus Toggled');
            userpilot.track('Task Focus Toggled');
        }
        ; // end toggleToday

        ///////////////////////////////////////////////////////////
        /// toggleComplete



        function toggleComplete(item) {

            // $log.info('taskDataService: toggleComplete', item);
            // debugger
            // $log.info(item.uid);

            var itemCopy = angular.fromJson(angular.toJson(item));
            var today = new Date();

            // if there's a snooze, remove it
            if(_.has(itemCopy, 'snooze')){
                delete itemCopy.snooze;
            }

            // clean up our object for sending back to original FB reference
            delete itemCopy.$id;
            delete itemCopy.$priority;
            delete itemCopy.$resolved;
            // store original panel
            itemCopy.originalPanel = itemCopy.panel;
            // Change actual panel to "Later" so it gets removed from board and put in "Completed" list
            // itemCopy.panel = 'Later';

            var event, message;

            // Change our status and setup our log and toast message
            if (itemCopy.status === 'open') {
                // we'll be compleeting it so change the panel to "Later"
                itemCopy.panel = 'Later';
                itemCopy.status = 'closed';
                itemCopy.focus = 'someday';
                // also set our item to closed so the user gets an
                // immediate indication
                item.status = 'closed';
                item.focus = 'someday';
                itemCopy.closedDate = moment().toISOString();
                // Add our completed stamps for easy querying later
                itemCopy.userCompleted = $rootScope.userID + '-' + moment().toISOString();
                itemCopy.completedBy = $rootScope.userID;
                itemCopy.clientCompleted = item.client + '-' + moment().toISOString();
                var thisClient = undefined;
                _.each(clientDataService.clients, function(client){
                    if(client.uid == item.client){
                        thisClient = client;
                    }
                });
                itemCopy.accountCompleted = thisClient.owner + '-' + moment().toISOString();
                event = "Task Closed";
                message = "completed";
                userDataService.trackEvent('complete-task');

            } else {
                itemCopy.status = 'open';
                // we can't assume original list still exists. So we restore it to "Later" (i.e. "New Tasks")
                itemCopy.panel = 'Later';
                // also set our item to open so the user gets an
                // immediate indication
                // item.status = 'open';
                itemCopy.userCompleted = null;
                itemCopy.clientCompleted = null;
                itemCopy.accountCompleted = null;
                event = "Task reopened";
                message = "reopened";
                // remove our completedStamp
                itemCopy.completedStamp = null;
                userDataService.trackEvent('reopen-task');

            }


            quickUpdate(itemCopy, event);


        }
        ; // end toggleComplete


        function toggleStatus(item) {
            return new Promise(function(resolve, reject){
                var options = {
                    targetListID: undefined,
                    sourceListID: undefined,
                    item: item
                }
                $log.info(item);
                if(!_.has(item, 'board')){
                    $log.info('no board warning');
                    var confirm = $mdDialog.confirm()
                             .title('Something went wrong')
                             .htmlContent('This Task is missing it\'s board detail and needs to be fixed first. We can fix it for you!')
                             .ariaLabel('Fix this task?')
                             .ok('Do It')
                             .cancel('Not Now');


                     $mdDialog.show(confirm).then(function() {
                        $log.info('Confirm Fix');
                        item.board = item.client;
                        options.targetListID = item.list;
                        return new Promise(function(resolve, reject){
                            var updates = {};
                            updates['/tasks/' + options.item.uid + '/info'] = options.item;
                            updates['/clients/' + options.item.client + '/tasks/' + options.item.uid] = options.item;
                            updates['/taskBoards/' + options.item.board + '/lists/' + options.targetListID + '/items/' + options.item.uid] = options.item;
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                return resolve('success')
                            })
                            .catch(function(error){
                                $log.error("Failed to update task status toggle")
                                $log.error(error)
                                return reject(error)
                            })
                        })

                     })
                }// if item doesn't have board

                if(_.has(item, 'board') && _.has(item, 'uid')){
                    if(item.status == 'open'){
                        options.sourceListID = item.list;
                        firebase.database().ref('/taskBoards/' + item.board + '/closedList').once('value', function(snap){
                            options.targetListID = snap.val();
                            options.item.status = 'closed';
                            options.item.order = 0;
                            options.item.list = options.targetListID;
                            options.item.closedDate = moment().toISOString();
                            // Add our completed stamps for easy querying later
                            options.item.userCompleted = $rootScope.userID + '-' + moment().toISOString();
                            options.item.completedBy = $rootScope.userID;
                            options.item.clientCompleted = item.client + '-' + moment().toISOString();
                            var thisClient = undefined;
                            _.each(clientDataService.clients, function(client){
                                if(client.uid == item.client){
                                    thisClient = client;
                                }
                            });
                            options.item.accountCompleted = thisClient.owner + '-' + moment().toISOString();
                            return executeToggle(options)
                            .then(function(){
                                userDataService.trackEvent('completed-task');
                                logTask(item.uid, 'Task Completed');
                                return resolve(true);
                            });
                        })
                    }// if open





                    if(item.status == 'closed'){
                        options.sourceListID = item.list;
                        firebase.database().ref('/taskBoards/' + item.board + '/defaultList').once('value', function(snap){
                            options.targetListID = snap.val();
                            options.item.status = 'open';
                            options.item.closedDate = null;
                            options.item.list = options.targetListID;
                            options.item.userCompleted = null;
                            options.item.clientCompleted = null;
                            options.item.accountCompleted = null;
                            return executeToggle(options)
                            .then(function(){
                                userDataService.trackEvent('reopened-task');
                                logTask(item.uid, 'Task Re-opened');
                                return resolve(true);
                            });
                        })
                    }// if closed

                    function executeToggle(options){
                        return new Promise(function(resolve, reject){
                            var updates = {};
                            updates['/tasks/' + options.item.uid + '/info'] = options.item;
                            updates['/clients/' + options.item.client + '/tasks/' + options.item.uid] = options.item;
                            updates['/taskBoards/' + options.item.board + '/lists/' + options.sourceListID + '/items/' + options.item.uid] = null;
                            updates['/taskBoards/' + options.item.board + '/lists/' + options.targetListID + '/items/' + options.item.uid] = options.item;
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                return resolve('success')
                            })
                            .catch(function(error){
                                $log.error("Failed to update task status toggle")
                                $log.error(error)
                                return reject(error)
                            })
                        })

                    }//executeToggle

                } else {
                    return resolve
                }
            })

            // return new Promise(function(resolve, reject){
            //     // $log.info('toggleStatus');
            //     var itemCopy = angular.fromJson(angular.toJson(item));
            //     var today = new Date();

            //     // if there's a snooze, remove it
            //     if(_.has(itemCopy, 'snooze')){
            //         delete itemCopy.snooze;
            //     }


            //     // store original panel
            //     itemCopy.listBeforeClosing = itemCopy.list;

            //     var event, message;

            //     // Change our status and setup our log and toast message
            //     if (itemCopy.status === 'open') {
            //         itemCopy.status = 'closed';
            //         itemCopy.focus = 'someday';
            //         item.status = 'closed';
            //         itemCopy.closedDate = moment().toISOString();
            //         // Add our completed stamps for easy querying later
            //         itemCopy.userCompleted = $rootScope.userID + '-' + moment().toISOString();
            //         itemCopy.completedBy = $rootScope.userID;
            //         itemCopy.clientCompleted = item.client + '-' + moment().toISOString();
            //         var thisClient = undefined;
            //         _.each(clientDataService.clients, function(client){
            //             if(client.uid == item.client){
            //                 thisClient = client;
            //             }
            //         });
            //         itemCopy.accountCompleted = thisClient.owner + '-' + moment().toISOString();

            //         event = "Task Closed";
            //         message = "completed";
            //         userDataService.trackEvent('complete-task');

            //     } else {
            //         itemCopy.status = 'open';
            //         // we can't assume original list still exists. So we restore it to "Later" (i.e. "New Tasks")
            //         itemCopy.list = itemCopy.listBeforeClosing;
            //         itemCopy.userCompleted = null;
            //         itemCopy.clientCompleted = null;
            //         itemCopy.accountCompleted = null;
            //         event = "Task reopened";
            //         message = "reopened";
            //         // remove our completedStamp
            //         itemCopy.completedStamp = null;
            //         userDataService.trackEvent('reopen-task');

            //     }
            //     return quickUpdate(itemCopy, event)
            //     .then(function(){
            //         return resolve(itemCopy);
            //     });
            // })




        }
        ; // end toggleStatus

        ///////////////////////////////////////////////////////////
        /// taskDialog
        // opens dialog with the prepared editedItem

        function taskDialog(editedItem, selectedTab, defaultDirty) {

            // $log.info('Original panel:' + editedItem.info.panel);

            return userDataService.getLoggedInUser()
            .then(function(user){
                var canLogTime = gateService.gateData.canLogTime;
                // $log.info('taskDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: taskDialog');
                var clientColor;
                var newNote; // just need to declare it so our in-dialog note form has a model to work from

                // if we already have a client assigned, pass along the color.
                // otherwise, pass an empty string.
                if (editedItem.info.client) {
                    // editing an existing task
                    var selectedClient = _.find(clientDataService.clients, function (client) {
                        return client.uid == editedItem.info.client;
                    });
                    if (_.has(selectedClient, 'clientColor')) {
                        clientColor =  selectedClient.clientColor;
                    }
                } else {
                    // creating a new task
                    clientColor = '#aaa'; // Not used. just to avoid an undefined error.
                }

                if(_.has(editedItem.info,'client')){
                    editedItem.info.originalClient = editedItem.info.client;
                }


                $mdDialog.show({
                    controller: 'taskDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-task.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        editedItem: editedItem,
                        assignedClients: clientDataService.clients,
                        clientColor: clientColor,
                        newNote: newNote,
                        tags: $rootScope.tags,
                        selectedTab: selectedTab,
                        canLogTime: canLogTime,
                        defaultDirty: defaultDirty
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    fullscreen: true
                });

                // Set focus
                $timeout(function () {
                    // if this is a new task, put the focus on the description field
                    if (!editedItem.uid) {
                        var taskDescription = angular.element("textarea[name='description']");
                        // if this is an empty field, just put the cursor there

                                if (taskDescription.createTextRange) {
                                    var part = taskDescription.createTextRange();
                                    part.move("character", 0);
                                    part.select();
                                } else if (taskDescription.setSelectionRange) {
                                    taskDescription.setSelectionRange(0, 0);
                                }
                                taskDescription.focus();
                        // if (!taskDescription[0].value) {
                        //     taskDescription.focus();
                        //     // taskDescription.setSelectionRange(0, 0);
                        //     // if we've been passed a value select the description for easy editing
                        // } else if (taskDescription[0].value) {
                        //     taskDescription.select();
                        // }


                    }
                }, 100);
            });



        }
        ; //end taskDialog

        ///////////////////////////////////////////////////////////
        /// getTask
        function getTask(taskID) {
            var task = {},
                    taskRef = firebase.database().ref('tasks/' + taskID);
            return $firebaseObject(taskRef)
                    .$loaded(function (data) {
                        task = data
                        return task
                    })
        }
        ; // end getTask

        ///////////////////////////////////////////////////////////
        /// saveNew
        function saveNew(task) {
            // attach the client name to the task so we have it for our notifications
            var thisClient = undefined
            _.each(clientDataService.clients, function(client){
                if(client.uid == task.info.client){
                    thisClient = client;
                    task.info.clientName = client.profile.fullName;
                    task.info.account = thisClient.owner;
                }
            });

            // $log.info(thisClient);

            // Determine if user is clientUser for this workspace and update assignment if so
            if(_.has($rootScope, 'VAWorkspaces')){
                // $log.info('hasVAWorkspaces');
                if(_.has($rootScope.VAWorkspaces, task.info.client)){
                    // $log.info('is clientUser');
                    // is clienUser for this workspace: Change assignment properties to workspace owner.
                    var userRef = firebase.database().ref('userList').child(thisClient.owner);
                    userRef.once('value').then(function(snap){
                        var user = snap.val();
                        task.info.assignee = thisClient.owner;
                        task.info.assigneeName = user.fullName;
                        task.info.assigneeAvatar = user.avatar;
                        switchOnTaskType(task);
                    })
                } else {
                    switchOnTaskType(task);
                }
            } else {
                switchOnTaskType(task);
            }

            function switchOnTaskType(task){
                // This service is called for saving tasks and task templates (because they share a GUI)
                // Hence we have to check for/against type and either save it here, or use taskTemplateServices to save
                if(_.has(task, 'type')){
                    if(task.type == 'template'){
                        // $log.info('Saving a task template');
                        // in $timeout so our view updates

                        taskTemplateDataService.saveNewTaskTemplate(task);


                    } else {

                        saveTaskFunction(task);
                    }
                } else {

                    saveTaskFunction(task);
                }
            }

            function saveTaskFunction(task){

                $log.info('saveTaskFunction');

                var taskCopy = angular.fromJson(angular.toJson(task)),
                    firstNote = undefined;
                    // $log.info('taskCopy');
                    // $log.info(taskCopy);

                delete taskCopy.originalClient;

                var newTaskKey = firebase.database().ref().child('tasks/').push().key;
                if(_.has(taskCopy, 'info.files')){
                    _.each(taskCopy.info.files, function(file, index){
                        if(_.has(file, 'thumbnail')){
                            if(file.source == "firebaseStorage" && file.thumbnail == file.url){
                                // this is a new file. Give it a response path
                                file.responsePath = 'tasks/' + newTaskKey + '/info/files/' + index;
                                file.responsePath2 = 'clients/' + taskCopy.info.client + '/tasks/' + newTaskKey + '/files/' + index;
                            }
                        }// if has thumbnail
                    });// each files
                }// if files

                if (_.has(taskCopy.info, 'duedate')) {
                    taskCopy.info.duedate = moment(taskCopy.info.duedate).toISOString();
                }
                if (_.has(taskCopy.info, 'startdate')) {
                    taskCopy.info.startdate = moment(taskCopy.info.startdate).toISOString();
                }

                // if we passed an initial 'note' for the task, pull it off so we can properly add it later
                if (taskCopy.note) {
                    firstNote = taskCopy.note;
                    delete taskCopy.note;
                }

                // put our $id as a property for easier retrieval
                taskCopy.uid = newTaskKey;
                taskCopy.info.refID = newTaskKey;
                taskCopy.info.uid = newTaskKey;

                taskCopy =  ajUTILITIES.removePropertiesWith(taskCopy);

                // add our task to the new key
                var updates = {};
                updates['/tasks/' + newTaskKey] = taskCopy;
                // create our board item
                if(_.has(taskCopy.info, 'list')){
                    var boardItem = taskCopy.info;
                    updates['/taskBoards/' + taskCopy.info.board + '/lists/' + taskCopy.info.list + '/items/' + taskCopy.uid] = boardItem;
                }
                // if it's legacy task, it needs to go on client and user

                updates['/clients/' + taskCopy.info.client + '/tasks/' + newTaskKey] = taskCopy.info;
                // updates['/users/' + taskCopy.info.assignee + '/tasks/' + newTaskKey] = taskCopy.info;
                if(_.has(taskCopy.info, 'list')){
                    updates['/taskBoards/' + taskCopy.info.client + '/lists/'+ taskCopy.info.list + '/items/' + newTaskKey] = taskCopy.info;
                }

                // $log.info(updates);
                // return
                // make the update
                return firebase.database().ref().update(updates)
                        .then(function () {
                            $rootScope.$emit('taskSaved', taskCopy.info);
                            userDataService.trackEvent('save-task');
                            // if we have a first note, add it to our new task
                            if (firstNote) {
                                // $log.info('we have a first note passed');
                                var newNoteKey = firebase.database().ref().child('tasks/' + newTaskKey + '/notes').push().key,
                                        noteObj = {};
                                noteObj.uid = newNoteKey;
                                noteObj.date = Date.now();
                                noteObj.author = localStorageService.get('userID');
                                noteObj.authorName = localStorageService.get('userName');
                                noteObj.body = firstNote;
                                // declare our updates
                                var updates = {};

                                // store our canonical object
                                updates['/tasks/' + newTaskKey + '/notes/' + newNoteKey] = noteObj;

                                // Save the note
                                return firebase.database().ref().update(updates)
                                        .then(function () {

                                            // $log.info('note added');
                                        })
                            } // firstNote

                        })
                        .then(function () {
                            // setup our first log entry

                            logTask(newTaskKey, 'Task Created');
                            // $mdToast.show(
                            //         $mdToast.simple()
                            //         .textContent('New Task Created')
                            //         .position('top right')
                            //         .hideDelay(2000)
                            //         );
                            //heap.track('New Task Saved');
                            userpilot.track("New Task Saved");
                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                            }, 500);

                        });

            }

        }
        ; // end saveNew

        ///////////////////////////////////////////////////////////
        /// removeTask
        function removeTask(item) {
            return new Promise(function(resolve, reject){
                // $log.info('removeTask');
                // $log.info(item);
                // Appending dialog to document.body to cover sidenav in docs app
                var confirm = $mdDialog.confirm()
                        .title('Delete Task: Are you sure?')
                        .textContent('This can\'t be undone.')
                        .ariaLabel('Delete Task? Y//N')
                        .targetEvent(item)
                        .multiple(true)
                        .ok('Yes, Delete')
                        .cancel('No');
                $mdDialog.show(confirm)
                        .then(function () {
                            var updates = {}, taskID;

                            if(_.has(item, 'board')){
                                taskID = item.uid;
                                updates['/taskBoards/' + item.board + '/lists/' + item.list + '/items/' + item.uid] = null;

                            } else {
                                taskID = item.refID;
                                // updates['/users/' + item.owner + '/tasks/' + taskID] = null;
                            }

                            updates['/clients/' + item.client + '/tasks/' + taskID] = null;
                            // updates['/users/' + item.assignee + '/tasks/' + taskID] = null;
                            updates['/tasks/' + taskID] = null;
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                $mdDialog.hide();
                               $timeout(function () {
                                   // pageDimensionsService.resizeColumns();
                                   $rootScope.$emit('taskRemoved');
                                   userpilot.track('Task Deleted');
                                   return resolve
                               }, 500);
                            })
                            .catch(function(error){
                                $log.error('error deleting task');
                                return reject(error)
                            });
                        });

            });//promise

        }
        ; // end removeTask

        ///////////////////////////////////////////////////////////
        /// updateTask
        function updateTask(task, originalLocation) {
            // Put client name on task so we have it handy for notifications.
            _.each(clientDataService.clients, function(client){
                if(client.uid == task.info.client){
                    task.info.clientName = client.profile.fullName;
                }
            });
            // if there are files, give them each a responsePath so our cloud function knows where to write the thumb url
            if(_.has(task, 'info.files')){
                _.each(task.info.files, function(file, index){
                    if(_.has(file, 'thumbnail')){
                        if(file.source == "firebaseStorage" && file.thumbnail == file.url){
                            // this is a new file. Give it a response path
                            file.responsePath = 'tasks/' + task.uid + '/info/files/' + index ;
                            file.responsePath2 = 'clients/' + task.info.client + '/tasks/' + task.uid + '/files/' + index ;
                        }
                    }// if has thumb
                });// each files
            }// if files

            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    taskTemplateDataService.updateTaskTemplate(task);
                } else {

                        updateTaskFunction(task, originalLocation)
                }
            } else {
                updateTaskFunction(task, originalLocation)
            }

            function updateTaskFunction(task, originalLocation){

                var taskCopy = angular.copy(task.info);

                // convert our date into a string for storing

                if (taskCopy.duedate) {
                    taskCopy.duedate = moment(taskCopy.duedate).toISOString();
                }

                var updates = {};

                // // // remove things that firebase provides
                // delete taskCopy.$id;
                // delete taskCopy.$priority;
                // delete taskCopy.$$state;
                // delete taskCopy.$$conf;
                // delete taskCopy.$$hashkey;

                // // store our modified object

                // If the client ID has changed, make sure to remove it from the original client (stored in originalClient when we opened a dialog)
                if(taskCopy.client != originalLocation.client){
                        $log.info("Moving to a different workspace!");
                        updates['/clients/' + originalLocation.client + '/tasks/' + taskCopy.uid] = null;
                        updates['/taskBoards/' + originalLocation.board + '/lists/' + originalLocation.list + '/items/' + taskCopy.uid] = null;
                        taskCopy.allOrder = 0;
                        taskCopy.order = 0;
                }

                if(taskCopy.client == originalLocation.client && taskCopy.list != originalLocation.list){
                    // it stayed on same client but moved to a different list
                    // remove it from the original list
                    updates['/taskBoards/' + taskCopy.board + '/lists/' + originalLocation.list + '/items/' + taskCopy.uid] = null;
                }

                // Regardless, we don't need or want originalClient stored in DB
                delete taskCopy.originalClient;



                if(_.has(taskCopy, 'board')){
                    updates['/tasks/' + taskCopy.uid + '/info'] = taskCopy;
                    updates['/taskBoards/' + taskCopy.board + '/lists/' + taskCopy.list + '/items/' + taskCopy.uid] = taskCopy;
                } else {
                    updates['/tasks/' + taskCopy.refID + '/info'] = taskCopy;
                }
                updates['/clients/' + taskCopy.client + '/tasks/' + taskCopy.uid] = taskCopy;
                // updates['/users/' + taskCopy.assignee + '/tasks/' + taskCopy.uid] = taskCopy;

                // $log.info('Target Panel: ' + taskCopy.panel);
                // $log.info(updates);


                return firebase.database().ref().update(updates)
                        .then(function () {
                            userDataService.trackEvent('update-task');
                            logTask(taskCopy.uid, 'Task updated');
                            // if current user is not the assignee, notify the assignee that there was a change
                            if($rootScope.userID != taskCopy.assignee){
                                var shortDescription =  _.truncate(taskCopy.description, {
                                                             'length': 25,
                                                             'separator': '...'
                                                           });
                                var notification = {
                                    title: "Task has been changed",
                                    message: '"'+ shortDescription + '" has been changed by ' + userDataService.user.email,
                                    meta: 'Assignment Change',
                                    type: 'task',
                                    assignee: taskCopy.assignee,
                                    related: taskCopy.uid
                                  }
                                notificationService.notify(notification);
                            }


                            // Make sure our columns adjust to new/removed items
                            $timeout(function () {
                                pageDimensionsService.resizeColumns();
                                $rootScope.$emit('taskUpdated', taskCopy);
                            }, 500);
                            //heap.track('Task Updated');
                            userpilot.track('Task Updated');
                            //  $mdToast.show(
                            //   $mdToast.simple()
                            //     .textContent('Task Updated')
                            //     .position('top right')
                            //     .hideDelay(2000)
                            // );
                        });



            }

        }
        ; //end updateTask


        function setupNotes() {
            // $log.info('setupNotes');
            $timeout(function () {
                var scroller = document.getElementById("noteList");
                scroller.scrollTop = scroller.scrollHeight;
                document.getElementById("newNoteBody").focus();
            }, 500, false);
        }



        ///////////////////////////////////////////////////////////
        /// batchDialog
        // opens dialog with the prepared editedItem

        function batchDialog(clientID, panel, board) {

            return userDataService.getLoggedInUser()
            .then(function(user){
                // $log.info('batchDialog');
                // $log.info(editedItem);
                // $log.info('taskData.service.js: batchDialog');
                var thisClient, thisPanel;

                if(clientID){
                    thisClient = clientID;

                    if(panel){
                        thisPanel = panel;
                    } else {
                        thisPanel = 'Later'
                    }
                } else {
                    // no client. just assign thisPanel
                    thisClient = undefined;
                    thisPanel = 'Later';
                }


                $mdDialog.show({
                    controller: 'batchDialogController',
                    controllerAs: 'vm', // see below
                    templateUrl: 'app/app-services/taskDataService/dialog-edit-batch.tmpl.html',
                    parent: angular.element(document.body),
                    locals: {
                        client: thisClient,
                        panel: thisPanel,
                        board: board
                    },
                    bindToController: true,
                    focusOnOpen: false,
                    clickOutsideToClose: true
                });


            });// getLoggedInUser

        }
        ; //end batchDialog

        function addChecklistItem(item, task){

            // $log.info('addChecklistItem');
            // $log.info(task);
            // $log.info(task.uid);

            // add our completed property
            item.complete = false;
            var updates = {};

            // Items are at a different path depending on whether we are editing task templates or tasks
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                   return addItemToTaskTemplate(item, task);
                } else {

                    return addItemToTask(item, task);

                }
            } else {

                return addItemToTask(item, task);
            }

            function addItemToTask(item, task){
                var newItemKey = firebase.database().ref().child('tasks/' + task.uid + '/checklist/').push().key;
                item.uid = newItemKey;
                item.order = _.size(task.checklist)+1;
                // store our canonical object
                updates['/tasks/' + task.uid + '/checklist/' + newItemKey] = item;
                updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist)+1;
                if(_.has(task.info, 'board')){
                    updates['/taskBoards/' + task.info.board + '/lists/' + task.info.list + '/items/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)+1;
                }
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)+1;
                // updates['/users/' + task.info.assignee + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)+1;
                logTask(task.uid, 'Added Checklist item. ');
                return firebase.database().ref().update(updates)
                .then(function(){
                    //heap.track('Subtask Added');
                    userpilot.track('Subtask Added');
                });
            }

            function addItemToTaskTemplate(item, task){
                // $log.info('addItemToTaskTemplate');
                var newItemKey = firebase.database().ref().child('taskTemplates/' + task.uid + '/checklist/').push().key;
                item.uid = newItemKey;
                // store our canonical object
                updates['/taskTemplates/' + task.uid + '/checklist/' + newItemKey] = item;
                updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numChecklistItems'] = _.size(task.checklist)+1;
                return firebase.database().ref().update(updates)
                .then(function(){
                    //heap.track('Subtask Added');
                    userpilot.track('Subtask Added');
                });
            }


        }// addChecklistItem

        function deleteChecklistItem(item, task){
            // $log.info('service.deleteChecklistItem');


            var updates = {};
            // Items are at a different path depending on whether we are editing task templates or tasks
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    // $log.info('Saving a task template');
                    updates['/taskTemplates/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                    updates['/taskTemplates/' + task.uid + '/checklist/' + item.uid] = null;
                    updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numChecklistItems'] = _.size(task.checklist)-1;

                } else {
                    updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                    updates['/tasks/' + task.uid + '/checklist/' + item.uid] = null;
                    updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
                    // updates['/users/' + task.info.assignee + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
                }
            } else {
                updates['/tasks/' + task.uid + '/info/numChecklistItems/' ] = _.size(task.checklist) -1;
                updates['/tasks/' + task.uid + '/checklist/' + item.uid] = null;
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
                // updates['/users/' + task.info.assignee + '/tasks/' + task.uid + '/numChecklistItems'] = _.size(task.checklist)-1;
            }
            logTask(task.uid, 'Deleted Checklist item. ');
            return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('Subtask Deleted');
                userpilot.track('Subtask Deleted');
            });

        }// deleteChecklistItem

        function updateChecklistItem(item, task){
            var updates = {};

            // remove reminders if subtask completed
            if(item.complete){
                if(_.has(item, 'reminders')){
                    _.each(item.reminders, function(reminder){
                        // remove it from our local representation we are about to save
                        delete item.reminders[reminder.uid];
                        // remove it from schedules
                        updates['/schedules/' + reminder.uid] = null;
                    });
                }
            }// if item.complete

            // Items are at a different path depending on whether we are editing task templates or tasks or an old task that doesn't have a 'type' (bad planning)
            if(_.has(task, 'type')){
                if(task.type == 'template'){
                    updates['/taskTemplates/' + task.uid + '/checklist/' + item.uid] = item;
                    // don't forget we are storing a copy of the template in the client
                    updates['/clients/' + task.info.client +'/taskTemplates/'+ task.uid + '/info/checklist/' + item.uid ] = item;
                    updates['/clients/' + task.info.client + '/taskTemplates/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                } else {
                    updates['/tasks/' + task.uid + '/checklist/' + item.uid] = item;
                    updates['/tasks/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                    updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
                    // updates['/users/' + task.info.assignee + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
                }
            } else {
                updates['/tasks/' + task.uid + '/checklist/' + item.uid] = item;
                updates['/tasks/' + task.uid + '/info/numCompleteItems'] = countCompletedItems(task);
                updates['/clients/' + task.info.client + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
                // updates['/users/' + task.info.assignee + '/tasks/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
            }


            if(_.has(task.info, 'board')){
                updates['/taskBoards/' + task.info.board + '/lists/' + task.info.list + '/items/' + task.uid + '/numCompleteItems'] = countCompletedItems(task);
            }

            logTask(task.uid, 'Updated Checklist item. ');
            return firebase.database().ref().update(updates);

        }// updateChecklistItem


        function makeChecklistItemCard(item, task){

                    // remove item from task
                    logTask(task.uid, 'Checklist item converted to task card. ');
                    service.deleteChecklistItem(item, task.uid);
                }// makeChecklistItemCard

        function countCompletedItems(task){
            var count = 0;
            _.each(task.checklist, function(item){
                if (item.complete){
                    count = count + 1;
                }
            });
            return count
        }

        function upgradeTaskBoard(client, index){
            return new Promise(function(resolve, reject){
                var options ={
                    migratedLists : [],
                    newTaskListKey : undefined,
                    completedTaskListKey : undefined,
                    newBoard : {},
                    upgradingClient : client,
                }

                var priority1ID = firebase.database().ref('/taskBoards').push().key,
                     priority2ID = firebase.database().ref('/taskBoards').push().key,
                     priority3ID = firebase.database().ref('/taskBoards').push().key,
                     priority4ID = firebase.database().ref('/taskBoards').push().key,
                     priority5ID = firebase.database().ref('/taskBoards').push().key,
                     priority1 = {
                          uid: priority1ID,
                          color: 'red',
                          label: 'Urgent',
                          priority: 1
                     },
                     priority2 = {
                          uid: priority2ID,
                          color: 'orange',
                          label: 'Important',
                          priority: 2
                     },
                     priority3 = {
                          uid: priority4ID,
                          color: 'green',
                          label: 'Neutral',
                          priority: 3
                     },
                     priority4 = {
                          uid: priority5ID,
                          color: 'blue',
                          label: 'Not Important',
                          priority: 4
                     };

               options.newBoard = {
                     label: 'Default Board',
                     uid: client.uid,
                     workspace: client.uid,
                     account: client.owner,
                     priorities: {},
                     status: 'active',
                     settings: {
                       showAssignee: true,
                       showDetails: true,
                       showWorkspaceName: true,
                       showRestLines: true,
                       showTimeControls: true,
                       color: '#eee'
                     }
                };

                options.newBoard.priorities[priority1ID] = priority1;
                options.newBoard.priorities[priority2ID] = priority2;
                options.newBoard.priorities[priority3ID] = priority3;
                options.newBoard.priorities[priority4ID] = priority4;

                var updates = {};

                // This update includes addition of user-specific sort orders.
                // so let's make sure the workspace owner gets the original order
                var clientOrder = index;
                if(_.has(client, 'order')){
                    clientOrder = client.order
                }

                updates['/clients/' + client.uid + '/userOrders/user' + client.owner] = clientOrder;
                updates['/clients/' + client.uid + '/allOrders/user' + client.owner] = clientOrder;

                updates['/taskBoards/' + options.newBoard.uid] = options.newBoard;
                updates['/clients/' + client.uid + '/taskBoards/' + options.newBoard.uid] = options.newBoard;
                return firebase.database().ref().update(updates)
                .then(function(){
                     return upgradeLists(client, options)
                     .then(function(){
                          return upgradeTasks(client, options)
                          .then(function(){
                               var updates = {};
                               updates['/clients/' + client.uid + '/defaultTaskBoard'] = options.newBoard.uid;
                               updates['/taskBoards/' + client.uid + '/defaultList'] = options.newTaskListKey;;
                               updates['/taskBoards/' + client.uid + '/closedList'] = options.completedTaskListKey;
                               updates['/clients/' + client.uid + '/taskBoards/' + options.newBoard.uid + '/defaultList'] = options.newTaskListKey;
                               updates['/clients/' + client.uid + '/taskBoards/' + options.newBoard.uid + '/closedList'] = options.completedTaskListKey;
                               $log.info(updates);
                               return firebase.database().ref().update(updates)
                               .then(function(){
                                    return upgradeRecurringTasks(client, options)
                                    .then(function(){
                                         return resolve(true)
                                    })
                               })
                          })
                          .catch(function(error){
                               return reject(error)
                          })
                     })
                     .catch(function(error){
                          return reject(error)
                     })
                })
                .catch(function(error){
                     return reject(error)
                })
            })//promise

        }//upgradeTaskBoard

        function upgradeLists(client, options){
             return new Promise(function(resolve, reject){
                  var updates = {};
                  // Add newTaskList & completedTaskList

                  options.newTaskListKey = firebase.database().ref('/taskBoards').push().key;
                  var newTaskList = {
                            uid: options.newTaskListKey,
                            color: '#bbb',
                            label: 'New Tasks',
                            editable: false,
                            order: 0,
                            type: 'new',
                       };

                  options.migratedLists.push(newTaskList);
                  updates['/taskBoards/' + options.newBoard.uid + '/lists/' + newTaskList.uid] = newTaskList;
                  updates['/clients/' + options.newBoard.workspace + '/taskBoards/' + options.newBoard.uid + '/lists/' + newTaskList.uid] = newTaskList;
                  // sort our taskPanels by order
                  var sortedPanels = _.sortBy(client.taskpanels, ['order']), index = 0;
                  // Add user-created Lists
                  _.each(sortedPanels, function(panel){
                       index ++
                       if(panel.uid){
                            var color = '#bbb';
                            if(panel.color){
                                 color = panel.color;
                            }
                            var newList = {
                                 color: color,
                                 uid: panel.uid,
                                 label: panel.label,
                                 order: index,
                                 type: 'custom'
                            }
                            updates['/taskBoards/' + options.newBoard.uid + '/lists/' + newList.uid] = newList;
                            updates['/clients/' + options.newBoard.workspace + '/taskBoards/' + options.newBoard.uid + '/lists/' + newList.uid] = newList;
                            options.migratedLists.push(newList);
                       }
                  });

                  options.completedTaskListKey = firebase.database().ref('/taskBoards').push().key;
                  var completedTaskList = {
                        uid: options.completedTaskListKey,
                        color: '#999',
                        label: 'Done',
                        editable: false ,
                        order: 1000,
                        type: 'closed'
                  };
                  updates['/taskBoards/' + options.newBoard.uid + '/lists/' + completedTaskList.uid] = completedTaskList;
                  updates['/clients/' + options.newBoard.workspace + '/taskBoards/' + options.newBoard.uid + '/lists/' + completedTaskList.uid] = completedTaskList;

                  return firebase.database().ref().update(updates)
                  .then(function(){
                       return resolve(true)
                  })
                  .catch(function(error){
                       return reject(error)
                  })
             })
        }//upgradeLists

        function upgradeTasks(client, options){
             return new Promise(function(resolve, reject){
                $log.info('upgradTasks');
                $log.info('new: ' + options.newTaskListKey);
                $log.info('completed: ' + options.completedTaskListKey);
                  var updates = {};
                  // File our Tasks in the correct list
                  _.each(client.tasks, function(task){
                       if(_.has(task, 'refID')){
                            if(!task.order){
                                 task.order = 1;
                            }
                            var newTask = task;
                            newTask.uid = newTask.refID;
                            // assign to new tasks list by default
                            newTask.list = options.newTaskListKey;

                            // if it is set for "Today" add priority 1 flag
                            if(newTask.focus == "today"){
                                 _.each(options.newBoard.priorities, function(priority){
                                      if(priority.priority == 1){
                                           newTask.priority = priority;
                                      }
                                 })
                            }

                            // if it's closed it goes in the completed list
                            if(newTask.status == 'closed'){
                                 newTask.list = options.completedTaskListKey;
                            } else {
                                 //if it's open but in 'Later' then put it in the new-tasks list
                                 if(newTask.panel == 'Later'){
                                      newTask.list = options.newTaskListKey;
                                 } else {
                                      // doesn't belong in new or completed.
                                      // make sure the list it's assigned to exists
                                      $log.info('looking for assigned list');
                                      _.each(options.migratedLists, function(panel){
                                           if(panel.uid == task.panel){
                                                $log.info('found list ' + panel.uid);
                                                newTask.list = panel.uid;
                                           }
                                      });
                                 }
                            }
                            $log.info('task: ' + newTask.uid + ' panel: ' + newTask.panel + ' list: ' + newTask.list + ' status: ' + newTask.status);
                            updates['/tasks/' + newTask.uid +  '/info/order'] = newTask.order;
                            updates['/tasks/' + newTask.uid +  '/info/board'] = options.newBoard.uid;
                            updates['/tasks/' + newTask.uid +  '/info/list'] = newTask.list;
                            // put UID on the task. We need to stop relying on refID. It's confusing.
                            updates['/tasks/' + newTask.uid +  '/info/uid'] = newTask.uid;
                            updates['/clients/' + client.uid +  '/tasks/' + newTask.uid + '/list'] = newTask.list;
                            updates['/clients/' + client.uid +  '/tasks/' + newTask.uid + '/board'] = options.newBoard.uid;
                            updates['/clients/' + client.uid +  '/tasks/' + newTask.uid + '/uid'] = newTask.uid;
                            var userID = $rootScope.userID;
                            if(_.has(newTask, 'assignee')){
                                 userID = newTask.assignee;
                            }
                            // updates['/users/' + userID +  '/tasks/' + newTask.uid + '/uid'] = newTask.uid;
                            // updates['/users/' + userID +  '/tasks/' + newTask.uid + '/board'] = options.newBoard.uid;
                            // updates['/users/' + userID +  '/tasks/' + newTask.uid + '/list'] = newTask.list;
                            updates['/taskBoards/' + options.newBoard.uid + '/lists/' + newTask.list + '/items/' + newTask.uid] = newTask;
                       }// if task.refID
                  });

                  return firebase.database().ref().update(updates)
                  .then(function(){
                       return resolve(true)
                  })
                  .catch(function(error){
                       return reject(error)
                  })
             })// promise
        }//upgradeTasks

        function upgradeRecurringTasks(client, options){
             return new Promise(function(resolve, reject){
                  if(_.has(client, 'taskTemplates')){
                       var updates = {};
                       _.each(client.taskTemplates, function(taskTemplate){
                            if(_.has(taskTemplate, 'info')){
                                var templateCopy = angular.copy(taskTemplate);
                                templateCopy.info.board = options.newBoard.uid;
                                templateCopy.info.uid = templateCopy.uid;
                                if(templateCopy.info.panel != 'Later'){
                                     templateCopy.info.list = templateCopy.info.panel;
                                } else {
                                     templateCopy.info.list = options.newTaskListKey;
                                }
                                updates['/taskTemplates/' + templateCopy.uid] = templateCopy;
                                updates['/clients/' + templateCopy.info.client + '/taskTemplates/' + templateCopy.uid] = templateCopy;
                            }
                       })
                       return firebase.database().ref().update(updates)
                       .then(function(){
                            return resolve (true);
                       })
                  } else {
                       return resolve(true)
                  }
             })
        }//upgradeRecurringTasks
    } // end taskDataService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('batchDialogController', batchDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// batchDialogController

        /* @ngInject */
        function batchDialogController($scope, $mdDialog, $log, $timeout, $mdToast, rrule, $rootScope, hotkeys, localStorageService, userDataService, taskDataService, clientDataService) {
            // $log.info('batchDialogController');
            var vm = this;
            vm.assignedClients = clientDataService.clients;
            vm.selectClient = selectClient;
            vm.clientChanged = false;
            if(_.has(vm.locals, 'board')){
                vm.thisBoard = vm.locals.board;
            }

            if(_.has(vm.locals, 'panel')){
                vm.thisPanel = vm.locals.panel;
            }

            if(_.has(vm.locals, 'client')){
                _.each(vm.assignedClients, function(client){
                    // $log.info('checking ' + client.uid);
                    if(client.uid == vm.locals.client){
                        // $log.info('found');
                        $timeout(function(){
                            vm.selectClient(client, true);
                            vm.thisClient = client;
                            if(vm.thisPanel == 'Later'){
                                vm.thisPanel = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].defaultList;
                            }
                        },500)
                    }
                })
            }
            if(_.has(vm.locals, 'panel')){
                $timeout(function(){
                    vm.thisPanel = vm.locals.panel;
                }, 250)
            }


              $timeout(function () {
                document.getElementById("focusfield").focus();
            }, 250, false);

              // we need to grab the enter key (and do nothing) because otherwise it will trigger a save thanks to
              // the hotkey in our task page controllers
              hotkeys.add({
                combo: 'enter',
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                description: 'Save task',
                callback: function (event, hotkey) {
                    // $log.info('ctrl+enter');
                    // event.preventDefault();
                }
            });


            function selectClient(client, inhibitListChange){
                // $log.info('selectClient');
                // we only need to reset panel and board if user manually changed client
                if(!inhibitListChange){
                    vm.thisPanel = client.taskBoards[client.defaultTaskBoard].defaultList;
                    vm.thisBoard = client.defaultTaskBoard;
                }
            }//selectClient

            vm.saveTasks = function(text){
                var taskList = text.split("\n");
                _.each(taskList, function(task){
                    var newTask = taskDataService.newTask(vm.thisClient.uid, vm.thisPanel);
                    newTask.info.description = task;
                    if(vm.thisBoard){
                        newTask.info.board = vm.thisBoard;
                        newTask.info.list = vm.thisPanel;
                        newTask.info.uid = newTask.uid;
                    }
                    userDataService.trackEvent('save-batch-tasks');
                    return taskDataService.saveNew(newTask);
                });
                $mdDialog.cancel();
            }
        }
        ; // end batchDialogController

})();

(function() {
    'use strict';


    angular.module('appServices')
        .service('taskPanelDataService', taskPanelDataService);

    /* @ngInject */
    function taskPanelDataService($log, $http, $injector, userDataService, pageDimensionsService, $mdToast, $firebaseArray, $firebaseObject, $mdMedia, $mdDialog, $rootScope, $timeout, $window) {
        var service = {
            newPanel: newPanel,
            editPanel: editPanel,
            createPanel: createPanel,
            deletePanel: deletePanel,
            saveUpdatedPanel: saveUpdatedPanel

        };

        return service;


        ///////////////////////////////////////////////////////////
        /// editPanel
        function editPanel(panel, hasClientUser) {
        var editPanel = angular.copy(panel),
            clientID = panel.client;

            var hasCards = false;

            if ($( ".app-item-container-items[panelid='" +panel.uid + "']").find('md-card').length){
               hasCards = true;
            };

            // $log.info(hasCards);
            userDataService.trackEvent('edit-task-list');
            $mdDialog.show({
              controller: taskPanelDialogController,// see below
              controllerAs: 'vm',
              templateUrl: 'app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html',
              locals: {panel: editPanel, clientID: clientID, hasCards: hasCards, hasClientUser: hasClientUser},
              // targetEvent: $event,
              focusOnOpen: false,
              clickOutsideToClose: true,
              fullscreen: true
          });

        };



        ///////////////////////////////////////////////////////////
        /// deletePanel
        function deletePanel(panel) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('PERMANENTLY delete this list?')
                .textContent(panel.label)
                .ariaLabel('Delete list? Y//N')
                .targetEvent(panel)
                .ok('Yes, Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                // Locate the detail record in our client array
                return firebase.database().ref().child('clients/' + panel.client + '/taskpanels/' + panel.uid).remove().then(function(){
                $mdToast.showSimple('List Removed');
                userDataService.trackEvent('delete-task-list');
                });
            }, function() {
                // $log.inf('delete panel cancelled');

            }); // end deletePanel
        }


        ///////////////////////////////////////////////////////////
        /// createPanel
        function createPanel(panel) {
            // $log.info('taskPanelDataService.createPanel');
            // $log.info(panel);
            // Get new key
            var newPanelKey = firebase.database().ref().child('clients/' + panel.client + '/taskpanels').push().key;
            // make sure you store it's key location as a uid
            panel.uid = newPanelKey;


            var updates ={};
            // store our canonical object
            updates['/clients/' + panel.client + '/taskpanels/' + newPanelKey] = panel;

            return firebase.database().ref().update(updates)
            .then(function(results){
                //heap.track('New Task List Saved');
                userDataService.trackEvent('create-task-list');
                return panel
            });

        }; // end createPanel

        ///////////////////////////////////////////////////////////
        /// saveUpdatedPanel
        function saveUpdatedPanel(panel) {
            var updates ={};

            // store our canonical object
            updates['/clients/' + panel.client + '/taskpanels/' + panel.uid] = panel;
            //heap.track('Task List Updated');
            return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('update-task-list');
            });

        }

        ///////////////////////////////////////////////////////////
        /// newPanel
        function newPanel(clientID, hasClientUser) {

            // $log.info('taskPanelDataService.newPanel(' + clientID + ')');
            var sort = $window.document.getElementsByClassName('custom-task-panel').length;

            var panel = {
                client: clientID,
                tasks: [],
                order: sort+1
            };
            var hasCards = false;

            $mdDialog.show({
                controller: taskPanelDialogController,// see below
                controllerAs: 'vm',
                templateUrl: 'app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html',
                locals: {panel: panel, clientID: clientID, hasCards: hasCards, hasClientUser: hasClientUser},
                // targetEvent: $event,
                focusOnOpen: false,
                clickOutsideToClose: true
            });

            //heap.track('New List Started');
            userDataService.trackEvent('new-task-list');

        };

        ////////////////////////////////////////////////////////
        // Create Panel and Populate with tasks
        function setupPanelAndTasks(panel){
            // $log.info(panel);

            // service.createPanel(panel).then(function(){
            // _.each(panel.tasks, function(task){
                // var newTask == taskDataService.newTask(panel.client, panel.uid);
                // return taskDataService.saveNewTask(newTask)
            // });
            // })
        }


        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// Panel Dialog Controller

        /* @ngInject */
        function taskPanelDialogController(panel, hasCards, hasClientUser, $scope, $rootScope, hotkeys) {
            var vm = this;
            vm.panel = panel;
            vm.hasCards = hasCards;
            vm.hasClientUser = hasClientUser;
            vm.colors = $rootScope.clientColors;

            $timeout(function(){
                $('input[name="detaillabel"]').focus();
            },300)

            vm.showColors = false;

            vm.toggleColors = function(){
                // $log.info('toggleColors');
                if(!vm.showColors){
                    vm.showColors = true;
                } else {
                    vm.showColors = false;
                }
            }

            // Hide color panel after selection made
            $scope.$watch('vm.panel.color', function (newValue, oldValue, scope) {
                if(vm.showColors){
                    vm.toggleColors();
                }
            });

            // Setup Hotkeys for this dialog
            hotkeys.bindTo($scope)
                // inhibit enter from submitting
                .add({
                  combo: 'enter',
                  callback: function(event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                  }
                })
                .add({
                  combo: 'ctrl+enter',
                  allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  description: 'Save/Update List',
                  callback: function(event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info($scope.clientDialogForm);
                    var pristine = $scope.vm.panelDialogForm.$pristine,
                        invalid = $scope.vm.panelDialogForm.$invalid;

                        if (!pristine && !invalid && vm.panel.uid){
                            $scope.updatePanel($scope.vm.panel);
                        }

                        if (!pristine && !invalid && !vm.panel.uid){
                            $scope.saveNewPanel($scope.vm.panel);
                        }
                    }
                });


            $scope.saveNewPanel = function saveNewPanel(panel) {
                // $log.info(panel);
                createPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('List ' + panel.label + ' created.');
                // $scope.editedPanel = null;
                pageDimensionsService.resizeColumns();
            }

            $scope.updatePanel = function updatePanel(panel) {
                // $log.info('DialogControl: updatePanel');
                // $log.info(panel);
                saveUpdatedPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('List ' + panel.label + ' updated.');
                pageDimensionsService.resizeColumns();
            }

            $scope.cancelDialog = function cancelDialog(dialog) {
                $mdDialog.cancel();
            }

            $scope.removePanel = function removePanel(panel) {
                deletePanel(panel);
                $timeout(function(){
                    pageDimensionsService.resizeColumns();
                },500);
            }


        }


    }; // end taskPanelDataService


})
();

(function () {
   'use strict';

   angular
           .module('appServices')
           .controller('duplicateListController', duplicateListController);

   /* @ngInject */
   function duplicateListController($log, $window, $scope, $rootScope,  $timeout,  clientDataService, $mdDialog, clients, thisClient) {
          var vm = this;
          $log.info('duplicateListController');
          vm.selectedClientID = vm.thisClient.uid;
          vm.confirm = function(targetID){
          	$mdDialog.hide(targetID)
          }

          vm.cancel = function(){
          	$mdDialog.cancel();
          }

   }//duplicateListController


   })();


(function () {
    'use strict';


    angular.module('appServices')
            .service('subscriptionService', subscriptionService)


    /* @ngInject */
    function subscriptionService($log, moment,
                userDataService, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject) {


        var service = {
            init: init
        };

        return service;


        // Initialize service.timerData object
        function init(){

        }



    }

})();

(function(){
	'use strict';


	angular.module('appServices')
	.service('scheduleDataService', scheduleDataService);

	/* @ngInject */
	function scheduleDataService($log, $mdDialog, $mdToast, $rootScope, $timeout, userDataService) {
		// $log.info('scheduleDataService init.');

		var service = {
			newSchedule: newSchedule,
			removeSchedule: removeSchedule,
			saveNewSchedule: saveNewSchedule,
			updateSchedule: updateSchedule,
			snoozeSchedule: snoozeSchedule,
			toggleUserStatus: toggleUserStatus,
			selectSchedule: selectSchedule,
			deSelectSchedule: deSelectSchedule,
			updateReminder: updateReminder,
			snoozePersonalReminder: snoozePersonalReminder
		};

		return service;

		function newSchedule(ownerID, options, due){
			$log.info('newSchedule');
			// $log.info(ownerID, options, due);
			// put the update path on the payload for use in app notifications
			options.payload.path = options.path;

			var userID = $rootScope.userID
			if(options.type == 'renew-package'){
				userID = ownerID;
			}

			var newSchedule = {
			owner: ownerID,
			path: options.path,
			type: options.type, // 'reminder', 'report', etc.
			created: moment().toISOString(),
			status: 'active',
			userStatus: 'active',
			message: options.message,
			payload: options.payload,
			userWhen: userID + '-' + moment(due).toISOString()
			}

			if(options.type == 'auto-invoice' || options.type == "auto-send-invoice"){
				newSchedule.clientID = options.clientID;
			}

			if(options.type == 'renew-package'){
				newSchedule.when = moment(due).toISOString();
				newSchedule.packageID = options.packageID;
			}

			if(due){
				newSchedule.when = moment(due).toISOString();
			}

			// Check for and include optional options
			if(_.has(options, 'client')){
				newSchedule.client = options.client;
			}

			if(_.has(options, 'repeat')){
				newSchedule.repeat = options.repeat;
			}

			if(_.has(options, 'repeatEvery')){
				newSchedule.repeatEvery = options.repeatEvery;
			}

			return newSchedule

		}// newSchedule


		function selectSchedule(schedule){
			// $log.info('selectSchedule');
			// $log.info(schedule.uid);
			service.selectedSchedule = schedule;
			$rootScope.$broadcast('selectedReminder', {schedule: schedule});
		}


		function deSelectSchedule(schedule){
			delete service.selectedSchedule;
		}

		function removeSchedule(schedule){
			return new Promise(function(resolve, reject){
				// $log.info('service - removeSchedule');
				// $log.info(schedule);
				var updates = {};
				updates[schedule.path + '/' + schedule.uid] = null;
				updates['/schedules/' + schedule.uid] = null;
				return firebase.database().ref().update(updates)
				.then(function(result){
					userDataService.trackEvent('schedule-removed');
					return resolve(true);
				})
			})

		}// removeSchedule


		function toggleUserStatus(schedule){
			$log.info('toggleUserStatus');
			// when marking complete, mark as triggered as well
			// when re-opening, remove triggered IF when < now
			if(schedule.userStatus == 'active'){
				schedule.userStatus = 'closed'
				// if there's a when, make sure it doesn't trigger a notification later
				if(schedule.when){
					schedule.status = 'triggered';
				}

			} else {
				schedule.userStatus = 'active';
				// only change to active if it MIGHT be triggered in the future
				if(moment().toISOString() < moment(schedule.when).toISOString()){
					schedule.status = 'active'
				} else {
					// alert('leave status as is')
				}

			}

			var updates = {};
			updates['/schedules/' + schedule.uid] = schedule;
			updates[schedule.path + '/' + schedule.uid] = schedule;
			return firebase.database().ref().update(updates)
			.then(function(){
				userpilot.track("Reminder Toggled");
				//heap.track("Reminder Toggled");
			})
		}//toggleUserStatus

		function saveNewSchedule(schedule){
			return new Promise(function(resolve, reject){
				var  schedulesRef = firebase.database().ref('/schedules'),
					updates = {},
				     newScheduleKey = schedulesRef.push().key,
				     fanData = undefined;

				schedule.uid = newScheduleKey;
				schedule.payload.scheduleID = newScheduleKey;
				schedule.payload.when = schedule.when;
				fanData = schedule;
				// payLoad is not include on the fanned data
				delete fanData.payLoad;
				// If we didn't give it a 'when', remove that node
				if(!schedule.when){
					delete schedule.when
					delete schedule.payload.when
					delete fanData.when
				}

				updates['/schedules/' + newScheduleKey] = schedule;
				updates[schedule.path + '/' + newScheduleKey] = fanData;
				return firebase.database().ref().update(updates)
				.then(function(success){
				if(schedule.type == 'reminder'){
					userDataService.trackEvent('add-reminder');
					//heap.track("New Reminder Created");
					return resolve(true)
				} else {
					userDataService.trackEvent('add-schedule');
					//heap.track("New Schedule Created");
					return resolve(true)
				}

				}, function(error){
					alert('There was a problem saving your reminder. Please try again.')
					return reject(error)
				})
			})

		}// saveNewSchedule

		function updateSchedule(schedule){
			var updates = {};
			updates[schedule.path + '/' + schedule.uid] = schedule;
			// Just update the when, we don't want to overwrite Payload if it exists.
			if(_.has(schedule, 'when')){
				updates['/schedules/' + schedule.uid + '/when'] = schedule.when;
				updates['/schedules/' + schedule.uid + '/userWhen'] = $rootScope.userID + '-' + schedule.when;
				updates['/schedules/' + schedule.uid + '/payload/when'] = schedule.when;
			}
			return firebase.database().ref().update(updates)
			.then(function(){
				userDataService.trackEvent('update-schedule');
			})
		}// updateSchedule

		function updateReminder(schedule){
			var updates = {};
			// update the payload and user "when"
			if(_.has(schedule, 'when')){
				schedule.payload.when = schedule.when;
				schedule.userWhen = $rootScope.userID + '-' + schedule.when;
			}
			updates[schedule.path + '/' + schedule.uid] = schedule;
			updates['/schedules/' + schedule.uid] = schedule;
			return firebase.database().ref().update(updates)
			.then(function(){
				userDataService.trackEvent('update-reminder');
			})
		}// updateReminder


		function snoozeSchedule(itemPayload, minutes){
			var newWhen = moment().add(minutes, 'minutes').toISOString(),
				updates = {};

			updates[itemPayload.path + '/' + itemPayload.scheduleID + '/when'] = newWhen;
			updates[itemPayload.path + '/' + itemPayload.scheduleID + '/status'] = 'active';
			updates['/schedules/' + itemPayload.scheduleID + '/when'] = newWhen;
			updates['/schedules/' + itemPayload.scheduleID + '/userWhen'] = $rootScope.userID + '-' + newWhen;
			// yes we store when on the main item, and in .payload because .payload gets sent with notifications for later processing
			updates['/schedules/' + itemPayload.scheduleID + '/payload/when'] = newWhen;
			updates['/schedules/' + itemPayload.scheduleID + '/status'] = 'active';

			return firebase.database().ref().update(updates)
			.then(function(){
				userDataService.trackEvent('snooze-schedule');
			})
		}

		function snoozePersonalReminder(item, minutes){
			var scheduleID = undefined;
			if(_.has(item, 'related')){
				scheduleID = item.related.scheduleID
			} else {
				scheduleID = item.payload.scheduleID
			}

			// update "when" and status on lead
			var newWhen = moment().add(minutes, 'minutes').toISOString();
			var updates = {};
			updates['schedules/' + scheduleID + '/when'] = newWhen;
			updates['schedules/' + scheduleID + '/status'] = 'active';
			updates['schedules/' + scheduleID + '/payload/when'] = newWhen;
			updates['schedules/' + scheduleID + '/userWhen'] = $rootScope.userID + '-' + newWhen;
			updates['users/' + $rootScope.userID + '/reminders/' + scheduleID + '/when'] = newWhen;
			updates['users/' + $rootScope.userID + '/reminders/' + scheduleID + '/status'] = 'active';
			updates['users/' + $rootScope.userID + '/reminders/' + scheduleID + '/payload/when'] = newWhen;
			updates['users/' + $rootScope.userID + '/reminders/' + scheduleID + '/userWhen'] = $rootScope.userID + '-' + newWhen;
			// vm.discardNotification(item);
			return firebase.database().ref().update(updates)
			.then(function(){
				userDataService.trackEvent('snooze-reminder');
			})
		}
	};// scheduleDataService


})
();

(function(){
	'use strict';


	angular.module('appServices')
	.service('profileDataService', profileDataService);


	/* @ngInject */
	function profileDataService($log, $http, pageDimensionsService, userDataService, clientDataService, $mdMedia, $mdDialog, $rootScope, $timeout, hotkeys) {
		var service = {
			newProfileDetail: newProfileDetail,
			editProfileDetail: editProfileDetail,
			profileDetailDialog: profileDetailDialog,
			saveProfileDetail: saveProfileDetail,
			deleteProfileDetail: deleteProfileDetail,
			updateProfileDetail: updateProfileDetail,
			upgradeBoard: upgradeBoard,
			cloneDetailList: cloneDetailList
		};

		return service;



	function cloneDetailList(list, sourceWorkspaceID, targetWorkspaceID){
	    $log.info('cloneDetailList');
	    return new Promise(function(resolve, reject){
	        _.each(clientDataService.clients, function(client){
	            if(client.uid == targetWorkspaceID){
	                var detailBoardID = client.defaultDetailBoard,
	                    taskBoard = client.detailBoards[client.defaultDetailBoard],
	                    order = _.size(client.detailBoards[client.defaultDetailBoard].lists),
	                    newList = angular.copy(list);
	                delete newList.items;
	                newList.order = order - 1;
	                if(sourceWorkspaceID != targetWorkspaceID){
	                    newList.order = 1;
	                }
	                newList.uid = firebase.database().ref('/detailBoards/' + detailBoardID + '/lists/').push().key;
	                if(sourceWorkspaceID == targetWorkspaceID){
	                    newList.label = "Copy of " + newList.label;
	                }
	                var updates = {};
	                updates['/detailBoards/' + detailBoardID + '/lists/' + newList.uid] = newList;
	                updates['/clients/' + client.uid + '/detailBoards/' + client.defaultDetailBoard + '/lists/' + newList.uid] = newList;
	                return firebase.database().ref().update(updates)
	                .then(function(){
	                    var detailPromises = [], options = {board: detailBoardID, client: client.uid, list: newList.uid};

	                    _.each(list.items, function(item){
	                    	if(item.type != 'client-card'){
	                    		var itemCopy = angular.copy(item);
	                    		itemCopy.list = newList.uid;
	                    		itemCopy.board = client.defaultDetailBoard;
	                    		itemCopy.client = client.uid;
	                    		delete itemCopy.files;
	                    		detailPromises.push(saveProfileDetail(itemCopy));
	                    	}
	                    });
	                    return Promise.all(detailPromises)
	                    .then(function(){
	                        return resolve(true)
	                    })
	                    .catch(function(error){
	                        $log.error(error);
	                        return reject(error);
	                    })
	                })
	            }
	        })
	    })// promise
	}//cloneDetailList

	///////////////////////////////////////////////////////////
	/// profileDetailDialog
	function profileDetailDialog(detail, title){
		$mdDialog.show({
		  controller: 'detailDialogController', // see below
		  controllerAs: 'vm',
		  templateUrl: 'app/app-services/profileDataService/dialog-profile-detail-'+ detail.type + '.tmpl.html',
		  locals: {detail: detail, title: title},
		  bindToController: true,
		  focusOnOpen: true,
		  clickOutsideToClose:true,
		  fullscreen: true
		});


		 // Set focus
		$timeout(function () {
		    angular.element("input[name='detaillabel']").focus();
		}, 300);

	};


	///////////////////////////////////////////////////////////
	/// editProfileDetail
	function editProfileDetail(detail){
		var title = "Edit " + detail.type;
		var editedDetail = angular.copy(detail);
		if (editedDetail.dob) {
		    editedDetail.dob = new Date(editedDetail.dob);
		}
		profileDetailDialog(editedDetail, title);
		//heap.track('Edit Profile Card Started');
		userpilot.track('Edit Profile Card Started');
	}

	///////////////////////////////////////////////////////////
	/// newProfileDetail
	function newProfileDetail(type, list, title, body){
		// What do we need for a new detail?
		// TYPE - this should be the only requirement
		// Parameters just shortcut certain selections

		var detail = {};
		    detail.type = type;
		    detail.order = 0;
		    detail.creator = $rootScope.userID;
		    detail.avatar = "https://www.adminja.co/assets/images/avatars/generic-person-avatar.png";

		  if(list){
			var order = _.size(list.details) + 1;
		  	detail.list = list.uid;
		  	detail.order = order;
		  	detail.client = list.client;
		  }

		  if(body){
		  	detail.note = body;
		  }


		// If we are making a new URL, set the default richembed mode
		if (detail.type == 'url'){
			detail.simpleEmbed = true;
		}

		// If we are making a new URL, set the default richembed mode
		if (detail.type == 'note'){
			detail.notecolor = '#fffde7';

		} else {
			detail.notecolor = '#fff';
		}

		if(type == "url"){
			type = "Bookmark"
		}

		if(type == "person"){
			type = "Contact"
		}

		return detail


	};


	///////////////////////////////////////////////////////////
	/// deleteProfileDetail
	function deleteProfileDetail(detail){
       	// Todo - remove any files before deleting
       	return firebase.database().ref().child('detailBoards/' + detail.board + '/lists/' + detail.list + '/items/' + detail.uid).remove().then(function(){
       		//heap.track('Profile Card Deleted');
	       	userpilot.track('Profile Card Deleted');
       	});

	}

	///////////////////////////////////////////////////////////
	/// saveProfileDetail
	function saveProfileDetail(detail, originalDetail) {
		var detailCopy = angular.copy(detail);
		detailCopy.timestamp = moment().toISOString();
		if (_.has(detailCopy, 'dob')) {
		    detailCopy.dob = moment(detailCopy.dob).toISOString();
		}

		// if there are files, give them each a responsePath so our cloud function knows where to write the thumb url
		var newDetailKey = firebase.database().ref().child('clients/' + detailCopy.client + '/lists/' + detailCopy.list + '/items/').push().key;
		detailCopy.uid = newDetailKey;

		if(detailCopy.files){
			_.each(detailCopy.files, function(file, index){
				if(_.has(file, 'thumbnail')){
					if(file.source == "firebaseStorage" && file.thumbnail == file.url){
						// this is a new file. Give it a response path
						file.responsePath = 'detailBoards/' + detailCopy.board + '/lists/' + detailCopy.list + '/items/' + detailCopy.uid + '/files/' + index ;
					}
				}// if has thumb
			});// each files
		}// if files
		var updates = {};

		// store our canonical object
		updates['/detailBoards/'+ detailCopy.board+'/lists/'+ detailCopy.list +'/items/' + newDetailKey] = detailCopy;

		return firebase.database().ref().update(updates)
		.then(function(){
			userDataService.trackEvent(detail.type + '-card-saved');
			return userDataService.count($rootScope.userID, 'profileCards', 1)
		})

	};// end addProfileDetail


	///////////////////////////////////////////////////////////
	/// updateProfileDetail
	function updateProfileDetail(detail, originalDetail) {

		if (detail.dob) {
		    detail.dob = detail.dob.toISOString();
		}

		// if there are files, give them each a responsePath so our cloud function knows where to write the thumb url
		if(detail.files){
			_.each(detail.files, function(file, index){
				if(_.has(file, 'thumbnail')){
					if(file.source == "firebaseStorage" && file.thumbnail == file.url){
						// this is a new file. Give it a response path
						file.responsePath = 'detailBoards/' + detail.board + '/lists/' + detail.list + '/items/' + detail.uid + '/files/' + index ;
					}
				}// if has thumb
			});// each files
		}// if files

		var updates = {};

		// store our canonical object
		updates['/detailBoards/'+detail.board+'/lists/'+ detail.list + '/items/' + detail.uid] = detail;
		// if the original detail was on a different client or list - remove from original
		if(originalDetail.list != detail.list){
			updates['/detailBoards/'+originalDetail.board+'/lists/'+ originalDetail.list + '/items/' + originalDetail.uid] = null;
		}
		return firebase.database().ref().update(updates)
		.then(function(){
			userDataService.trackEvent(detail.type + '-card-updated');
		});
	}


	///////////////////
	/// Setup Detail Boards
	function upgradeBoard(thisClient){
		return new Promise(function(resolve, reject){
			var newBoard = {
			   uid: thisClient.uid,
			   account: thisClient.owner,
			   workspace: thisClient.uid,
			   settings: {
			      color: '#ddd'
			   }
			 };
			 var updates = {};
			 updates['/detailBoards/' + newBoard.uid] = newBoard;
			 updates['/clients/' + thisClient.uid + '/detailBoards/' + newBoard.uid] = newBoard;
			 updates['/clients/' + thisClient.uid + '/defaultDetailBoard'] = newBoard.uid;
			 return firebase.database().ref().update(updates)
			 .then(function(){
			      // location.reload()
			      return upgradeLists(thisClient, newBoard)
			      .then(function(){
			           return upgradeCards(thisClient, newBoard)
			           .then(function(){
			                return resolve(true)
			           })
			      })
			      .catch(function(error){
			           $log.error(error)
			           return reject(error)
			      })
			 })
		})

	}//upgradeBoard

	function upgradeLists(thisClient, newBoard){
	       return new Promise(function(resolve, reject){
	            var updates = {};

	            var sortedPanels = _.sortBy(thisClient.panels, ['order']), index = 0, foundDefaultList = false;

	            _.each(sortedPanels, function(panel){
	                 index ++
	                 if(panel.uid){
	                      var color = '#bbb';
	                      if(panel.color){
	                           color = panel.color
	                      }
	                     var newList = {
	                           color: color,
	                           uid: panel.uid,
	                           label: panel.label,
	                           order: index,
	                           type: 'custom'
	                      }

	                      // if it's our client details list, it should be default for new notes
	                      if(newList.label == "Client Details"){
	                           foundDefaultList = true;
	                           newList.type = 'client-details'
	                           updates['/clients/' + thisClient.uid + '/detailBoards/' + newBoard.uid + '/defaultList'] = newList.uid;
	                           updates['/detailBoards/' + newBoard.uid +  '/defaultList'] = newList.uid;
	                      }
	                      updates['/detailBoards/' + newBoard.uid + '/lists/' + newList.uid] = newList;
	                      delete newList.items;
	                      updates['/clients/' + newBoard.workspace + '/detailBoards/' + newBoard.uid + '/lists/' + newList.uid] = newList;

	                 } else {
	                      $log.info('no uid for panel');
	                 }
	            })


	            return firebase.database().ref().update(updates)
	            .then(function(){
	                 return resolve(true)
	            })
	            .catch(function(error){
	                 return reject(error)
	            })
	       })
	}//upgradelists

	function upgradeCards(thisClient, newBoard){
	       return new Promise(function(resolve, reject){
	            var updates = {};
	            _.each(thisClient.panels, function(panel){
	                 _.each(panel.details, function(detail){
	                      // make a copy of this lists' details so we can modify them
	                      var item = angular.copy(detail);
	                           if(_.has(item, 'uid')){
	                                $log.info('adding ' + item.uid);
	                                item.list = item.panel;
	                                delete item.panel;
	                                item.board = newBoard.uid;
	                                if(item.type == 'person' || item.type == 'address'){
	                                     item.type = 'contact'
	                                }
	                                item.creator = thisClient.owner;
	                                item.owner = thisClient.owner;
	                                updates['/detailBoards/' + newBoard.uid + '/lists/' + item.list + '/items/' + item.uid] = item;
	                           }

	                 });
	                 // if we are in the client-details list, add the client card item
	                 if(panel.label == 'Client Details'){
	                      var clientCardID = firebase.database().ref('/detailBoards').push().key,
	                          clientCard = {
	                                uid: clientCardID,
	                                label: 'Client Card',
	                                type: 'client-card',
	                                order: '0',
	                                board: newBoard.uid,
	                                client: thisClient.uid,
	                                list: panel.uid,
	                                notecolor: '#fff',
	                                owner: thisClient.owner,
	                                creator: thisClient.owner
	                            };

	                      updates['/detailBoards/' + newBoard.uid + '/lists/' + clientCard.list + '/items/' + clientCard.uid] = clientCard;
	                 }// if client-details list
	            });
	            return firebase.database().ref().update(updates)
	            .then(function(){
	                 return resolve(true)
	            })
	            .catch(function(error){
	                 $log.error(error);
	                 return reject(error)
	            })
	       })
	}//upgradeCards





	};// end profileDataService







	})
();



(function () {
    'use strict';
    angular.module('appServices')
            .controller('detailDialogController', detailDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// detailDialogController

        /* @ngInject */
        function detailDialogController($log, triLoaderService, hotkeys, $mdDialog, profileDataService, $timeout, $scope,$state, $rootScope, $mdToast, teamDataService, clientDataService){
            $log.info('detailDialogController');
            var vm = this;
            vm.removeFile = removeFile;
            vm.getUserRole = getUserRole;
            vm.colorChange = colorChange;
            vm.togglePrivate = togglePrivate;
            vm.saveNewDetail = saveNewDetail;
            vm.updateDetail = updateDetail;
            vm.cancelDialog = cancelDialog;
            vm.removeFile = removeFile;
            vm.selectClient = selectClient;
            vm.forms = {};
            vm.originalDetail = angular.copy(vm.detail);
            $log.info('detailDialogController');

            // adding acomment to see if gulp is tracking
            // if unsaved when dialog closed, remove any files that have been uploaded

            vm.saved = false; // track whether saved or not
            $scope.$on("$destroy", function () {
                if(!vm.saved){
                    removeAllFiles();
                }
            });

            // setup our current client if there is one
            // If we are in a client space or editing, we should make that the active client
            // and load up their panels
            if($state.params.clientID){
                vm.detail.client = $state.params.clientID;
                selectClient(vm.detail.client);
            }




            vm.storage = firebase.storage(),
            vm.storageRef = vm.storage.ref();
            vm.showPicker = true;
            vm.countries = $rootScope.countries;
            vm.assignedClients = clientDataService.clients;
            vm.panels = [];

            vm.filePath = 'profile';
            // Prep our files array
            vm.numFiles = 0;


            init();


            function init(){


                    // Set the color of any editors


                    if (_.has(vm.detail, 'files')) {
                        vm.numFiles = vm.detail.files.length;
                    } else {
                        vm.detail.files = [];
                    }
                    if (vm.detail.type == 'url' && !vm.detail.url){
                        vm.detail.url = 'http://';
                    }

                    if(!_.has(vm.detail, 'list')){
                        // $log.info(vm.detail.panel);
                        vm.showPicker = true;
                    }

                    // setup our listener to make form dirty if avatar changed
                    $scope.$on('uploadComplete', setDirty);
                    function setDirty(){
                          vm.forms.detailDialogForm.$setDirty();
                    }



                    // Setup & Bind Hotkeys
                    // when you bind it to the controller's scope, it will automatically unbind
                    // the hotkey when the scope is destroyed
                    hotkeys.bindTo($scope)
                    .add({
                      combo: 'enter',
                      callback: function(event) {
                        event.preventDefault();
                        // $log.info('enter blocked');
                      }
                    })
                      .add({
                        combo: 'ctrl+enter',
                        description: 'Save Detail',
                        allowIn: ['INPUT', 'SELECT', 'TEXTAREA', 'DIV'],
                        callback: function(event, hotkey) {
                          // This doesn't appear to be working
                          // event.preventDefault();
                          // $log.info('ctrl + enter');
                        if ($scope.vm.detail.uid){
                            updateDetail(vm.detail, vm.originalDetail);
                          } else {
                            saveNewDetail(vm.detail, vm.originalDetail);
                          }
                        }
                      });

                      // configure color chooser

                      // if(vm.detail.type == 'note'){
                      //    // $log.info('have note autofocussing');
                      //    $timeout(function() {
                      //        angular.element('text-angular').find('*[id*=taText]').focus();
                      //    });
                      // }


                    $scope.colors = $rootScope.noteColors;
                    $timeout(function(){
                        $('div.fr-wrapper').css('background-color', vm.detail.notecolor);
                    },500)

            }// init


            function selectClient(clientID, isManuallySelected){
                $log.info('selectClient');
                // listPicker Needs reset or it will re-use values from previous client
                $timeout(function(){
                    vm.thisClient = undefined;
                },200)
                // get client and determine clientUser status
                _.each(clientDataService.clients, function(client){
                  if(client.uid == vm.detail.client){
                    $timeout(function(){
                        vm.thisClient = client;
                        vm.detail.board = vm.thisClient.defaultDetailBoard;
                        vm.detail.owner = vm.thisClient.owner;
                        var count = 0;
                        // if no list already, assign the first list
                        if(isManuallySelected){
                            _.each(vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists, function(list){
                                if (count == 0){
                                    vm.detail.list = list.uid;
                                }
                                count ++
                            })
                        }
                        // Determine if clientUser for this client
                        if(_.has(vm.thisClient, 'clientUsers')){
                          vm.hasClientUsers = true;
                          if(_.has(vm.thisClient.clientUsers, $rootScope.userID)){
                            vm.isClientUser = true;
                          }
                        }
                    }, 250)
                  }
                });
            }//selectClient


            function getUserRole(clientID){
                   // Set defaults

                   // Check to see if current user is admin or member so we can restrict who can see the 'admins only' toggle
                   var teamSize = _.keys(teamDataService.clientTeams[clientID]).length;

                   // if we have a team, check for permissions to edit otherwise, allow it
                   if(teamSize > 0 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
                    // $log.info('we have a team. returning role');
                       return teamDataService.clientTeams[clientID][$rootScope.userID].role;
                   } else if (clientDataService.isOwner(clientID, $rootScope.userID)) {
                    // no team but is owner
                    return 'admin'
                   } else {
                       // no team. and not owner
                       return 'member'
                   }

            }// getUserRole

            function removeAllFiles(){
                    _.each(vm.detail.files, function(file){
                        return vm.removeFile(file)
                    });
            }// removeAllFiles



            // }// upload File

            function removeFile(file){
                // find file in vm.detail.files to get the path
                var pathToDelete = file.fullPath,
                    triggerURL = $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=delete&segment1=' + pathToDelete;
                // $log.info('removeFile');

                 $http.get(triggerURL)
                        .then(function (response){
                            $scope.jsondata = response.data;
                            console.log("status:" + response.status);
                        }).catch(function(response) {
                          console.error('Error occurred:', response.status, response.data);
                        }).finally(function() {
                             console.log("Task Finished.");
                        });

            }


            function togglePrivate(detail) {
                    // $log.info('dialogController: toggleToday');
                    if (detail.private) {
                        detail.private = false;
                    } else {
                        detail.private = true;
                    }
                    vm.forms.detailDialogForm.$setDirty();
            }

            function saveNewDetail(detail){
                    // go through files and strip out $$hashKey
                    if(_.has(detail, 'files')){
                        _.each(detail.files, function(file){
                            file = ajUTILITIES.removePropertiesWith(file);
                        });
                    }
                    profileDataService.saveProfileDetail(detail, vm.originalDetail);
                    // Note that card has been saved so we don't treat the window closing as a cancellation and delete all of their files.
                    vm.saved = true;
                    cancelDialog();
            }

            function colorChange(){
                  // $log.info('colorChange');
                  vm.forms.detailDialogForm.$setDirty();
                  // find our froala editor (if one is open) and set it's color to the color
                  $timeout(function(){
                    $('div.fr-wrapper').css('background-color', vm.detail.notecolor);
                  }, 250);

            };



            function updateDetail(detail){
                // go through files and strip out $$hashKey
                if(_.has(detail, 'files')){
                    _.each(detail.files, function(file){
                        file = ajUTILITIES.removePropertiesWith(file);
                    });
                }

                profileDataService.updateProfileDetail(detail, vm.originalDetail);
                cancelDialog();
            }

            function cancelDialog(dialog){
              $mdDialog.cancel();

            }// cancelDialog

            function removeFile(chip){
                // $log.info('removeFile');
                // $log.info(chip);

                // Create a reference to the file to delete
                var storage = firebase.storage(),
                    storageRef = storage.ref();
                var fileRef = storageRef.child('clients/' + vm.detail.client + '/' + chip.fileName);

                // Delete the file
                fileRef.delete().then(function() {
                  // File deleted successfully
                  // $log.info('File ' + chip.fileName + ' deleted.');
                  // $mdToast.showSimple(chip.filenName + ' deleted.');
                  //heap.track('Profile Card File Deleted');
                  userpilot.track('Profile Card File Deleted');
                }).catch(function(error) {
                  // Uh-oh, an error occurred!
                  $log.info('Oops! File ' + chip.fileName + ' NOT! deleted.');
                });
            }// removeFile

            vm.froalaOptions = {
                    key: $rootScope.froalaKey,
                    pluginsEnabled: [
                    "align", "charCounter", "codeBeautifier", "codeView", "colors", "draggable",  "emoticons", "entities",  "fontSize",
                    "file", "image", "imageTUI",
                    // "imageManager",
                     "lineBreaker", "link", "lists", "paragraphFormat", "paragraphStyle", "quote",  "url", "wordPaste"
                    ],
                    spellcheck: true, // does not appear to actually enable spellcheck
                    toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "strikeThrough" ,"textColor", "|", "align", "formatOL", "formatUL", "|", "emoticons",  "insertLink",  "insertImage", "insertFile", "insertHR", "|", "html"],
                    autofocus: true,
                    listAdvancedTypes: true,
                    zIndex: 9999,
                    attribution: false,
                    pastePlain: true,
                    charCounterMax: 8000,
                    linkAlwaysBlank: true,
                    linkAutoPrefix: 'https://',
                    linkInsertButtons: '',
                    linkText: true,
                    imageInsertButtons: ['imageUpload'],
                    imageDefaultDisplay: 'block',
                    htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
                    pasteDeniedAttrs: ['class', 'id', 'data'],
                    pasteDeniedTags: ['iframe', 'script', 'style'],
                    // Set the file upload URL.
                     imageUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=clients&segment2=' + vm.detail.client + '&segment3=profile',
                     imageUploadMethod: 'POST',
                     fileUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=clients&segment2=' + vm.detail.client + '&segment3=profile',
                     // Set request type.
                     fileUploadMethod: 'POST',
                    events: {
                                'froalaEditor.initialized': function () {
                                },
                                'charCounter.exceeded': function () {
                              },
                              'file.beforeUpload': function($file){
                                // $timeout(function(){
                                //  $rootScope.loaderMessage="Uploading File";
                                //  triLoaderService.setLoaderActive(true);
                                // });
                              },
                              'file.uploaded': function($file){
                                // add the file to our file list so we can access it programmatically it later
                                var fileObject = angular.fromJson($file);
                                vm.newFileObject = {
                                            fileName: fileObject.filename,
                                            url: fileObject.link[0],
                                            thumbnail: fileObject.link[0],
                                            source: 'firebaseStorage',
                                            fullPath: fileObject.path
                                        }

                                        if(!_.has(vm.detail, 'files')){
                                                vm.detail.files = [];
                                        }

                                          vm.detail.files.push(vm.newFileObject);
                                // $timeout(function(){
                                //  triLoaderService.setLoaderActive(false);
                                // });
                              },
                              'file.inserted': function(e, editor, $file, response){
                                editor.html.insert("  ");
                              },
                              'image.beforeUpload': function($file){
                                // $timeout(function(){
                                //  $rootScope.loaderMessage="Uploading Image";
                                //  triLoaderService.setLoaderActive(true);
                                // });
                              },
                              'image.uploaded': function($file){
                                var fileObject = angular.fromJson($file);
                                vm.newFileObject = {
                                            fileName: fileObject.filename,
                                            url: fileObject.link[0],
                                            thumbnail: fileObject.link[0],
                                            source: 'firebaseStorage',
                                            fullPath: fileObject.path
                                        }

                                        if(!_.has(vm.detail, 'files')){
                                                vm.detail.files = [];
                                        }

                                          vm.detail.files.push(vm.newFileObject);

                                // $timeout(function(){
                                //  triLoaderService.setLoaderActive(false);
                                // });
                              },
                              'image.inserted': function(e, editor, $file, response){
                                // editor.html.insert("  ");
                              },
                              'image.removed':  function($file){
                                // $log.info('image.removed');
                                var thisLookupLink = $file[0].src;
                                _.each(vm.detail.files, function(file){
                                    if(file.url == thisLookupLink){
                                        // $log.info('found file to delete in array');
                                        // $log.info(file);
                                        // Send the file to be deleted
                                        // delete it from the array

                                        var newFiles = _.filter(vm.detail.files, function(x) { return x.url == thisLookupLink; });
                                        vm.detail.files = newFiles;
                                        return vm.removeFile(file);
                                    }
                                });
                                // return vm.removeImage($img)
                                // then update note so reference is removed as well
                              },
                            'file.unlink':  function($file){
                                // $log.info('File Removed');
                                var thisLookupLink = $($file). attr("href");
                                _.each(vm.detail.files, function(file){
                                    if(file.url == thisLookupLink){
                                        // $log.info('found file to delete in array');
                                        // Send the file to be deleted
                                        // $log.info(file);
                                        // delete it from the array
                                        var newFiles = _.filter(vm.detail.files, function(x) { return x.url == thisLookupLink; });
                                        vm.detail.files = newFiles;
                                        return vm.removeFile(file)
                                    }
                                });

                                // then update note so reference is removed as well
                            }
                            }//events
                }//froalaOptions



        }; // end detailDialogController

})();

(function() {
    'use strict';
    angular.module('appServices')
        .service('presenceService', presenceService);

    /* @ngInject */
    function presenceService($log, $http, $firebaseArray, $mdDialog, $firebaseAuth, triLoaderService, $firebaseObject, authFactory, $mdToast) {
       var service = {
       	monitor: monitor
              };

       return service;



       function monitor(uid){
        // $log.info('monitor starting...');
           var waitingForReconnect = false, showingReconnected = false;
           // Setup presence monitoring
           ////////////////////////////////////////////////////////
           // Manage Presence
           // since I can connect from multiple devices or browser tabs, we store each connection instance separately
           // any time that connectionsRef's value is null (i.e. has no children) I am offline
               var myConnectionsRef = firebase.database().ref('users/' + uid + '/connections');

               // stores the timestamp of my last disconnect (the last time I was seen online)
               var lastOnlineRef = firebase.database().ref('users/' + uid + '/lastOnline');

               var connectedRef = firebase.database().ref('.info/connected');

               // We are getting" offline" status when we shouldn't.
               // attempting to start with an off call per: http://stackoverflow.com/questions/38151265/firebase-ondisconnect-firing-multiple-times
               // to see if it fixes.
               // connectedRef.off();
               connectedRef.on('value', function(snap) {
                 if (snap.val() === true) {
                   // We're connected!
                   // add this device to my connections list
                   // var con = myConnectionsRef.push(true);

                   // when I disconnect, remove this device
                   // con.onDisconnect().remove();

                  // Add this device to connections list
                   // con.set(true);

                   // if this was a reconnection, let the user know
                   if(waitingForReconnect){
                       waitingForReconnect = false;
                       $mdDialog.cancel();
                   }// if waitingForReconnect


                   // when I disconnect, update the last time I was seen online (this actually happens on the server via firebase magic)
                   lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
                 } else {
                   // we've been disconnected!
                   // waitingForReconnect = true;
                   // $mdDialog.show({
                   //           controller: presenceDialogController, // see below
                   //           controllerAs: 'vm',
                   //           // bindToController: true,
                   //           templateUrl: 'app/app-services/presenceService/dialog-presence.tmpl.html',
                   //           locals: {
                   //               title: 'Network Alert',
                   //               message: 'There is no network connection. Operations have been paused.\nPlease make sure you are connected to the internet.',
                   //               button: false
                   //           },
                   //           focusOnOpen: false,
                   //           clickOutsideToClose: false,
                   //           escapeToClose: false
                   //       });


               };
       });

        function presenceDialogController(title, message, button){
          var vm = this;
          vm.title = title;
          vm.message = message;
          vm.showButton = button;

          vm.cancelDialog = function(){
            $mdDialog.cancel();
          }
        };


       }

       }// fbService





})
();

(function() {
    'use strict';


    angular.module('appServices')
        .service('panelDataService', panelDataService);

    /* @ngInject */
    function panelDataService($log, $http, pageDimensionsService, $mdToast, clientDataService, userDataService, $firebaseArray, $firebaseObject, $mdMedia, $mdDialog, $rootScope, $timeout, $window) {
        var service = {
            newPanel: newPanel,
            editPanel: editPanel,
            createPanel: createPanel,
            deletePanel: deletePanel,
            saveUpdatedPanel: saveUpdatedPanel

        };

        return service;



        ///////////////////////////////////////////////////////////
        /// editPanel
        function editPanel(panel) {
        var editPanel = angular.copy(panel),
            clientID = panel.client,
            hasClientUsers = false;

            var thisClient = undefined;
            _.each(clientDataService.clients, function(client){
                if(client.uid == clientID){
                    thisClient = client
                    if(_.has(thisClient, 'clientUsers')){
                        hasClientUsers = true;
                    }
                }
            });
            // var thisClient = clientDataService.clients(panel.client);
            // $log.info(thisClient);
            userDataService.trackEvent('edit-detail-list');
            $mdDialog.show({
              controller: panelDialogController,// see below
              controllerAs: 'vm',
              templateUrl: 'app/app-services/panelDataService/dialog-profile-panel.tmpl.html',
              locals: {panel: editPanel, clientID: clientID, hasClientUsers: hasClientUsers},
              // targetEvent: $event,
              focusOnOpen: false,
              clickOutsideToClose: true,
              fullscreen: true
          });

        };



        ///////////////////////////////////////////////////////////
        /// deletePanel
        function deletePanel(panel) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('PERMANENTLY delete this list?')
                .textContent(panel.label)
                .ariaLabel('Delete detail? Y//N')
                .targetEvent(panel)
                .ok('Yes, Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                // Locate the detail record in our client array
                return firebase.database().ref().child('clients/' + panel.client + '/panels/' + panel.uid).remove().then(function(){
                $mdToast.showSimple('List Removed');
                //heap.track('List Deleted');
                userDataService.trackEvent('delete-detail-list');
                });
            }, function() {
                // $log.inf('delete panel cancelled');

            });
        }// end deletePanel

        ///////////////////////////////////////////////////////////
        /// createPanel
        function createPanel(panel) {
            // $log.info('panelDataService.createPanel');
            // $log.info(panel);
            // Get new key
            var newPanelKey = firebase.database().ref().child('clients/' + panel.client + '/panels').push().key;
            // make sure you store it's key location as a uid
            panel.uid = newPanelKey;


            var updates ={};
            // store our canonical object
            updates['/clients/' + panel.client + '/panels/' + newPanelKey] = panel;

            //heap.track('New List Saved');
            userDataService.trackEvent('new-detail-list');
            return firebase.database().ref().update(updates);

        }; // end createPanel

        ///////////////////////////////////////////////////////////
        /// saveUpdatedPanel
        function saveUpdatedPanel(panel) {
            var updates ={};

            // store our canonical object
            updates['/clients/' + panel.client + '/panels/' + panel.uid] = panel;
            //heap.track('List Updated');

            return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('update-detail-list');
            });

        }

        ///////////////////////////////////////////////////////////
        /// newPanel
        function newPanel(clientID) {
            // $log.info('panelDataService.newPanel(' + clientID + ')');
            var sort = angular.element('profile-panel').length;
            var panel = {
                client: clientID,
                details: [],
                order: sort+1,
                createdOn: moment().toISOString()
            },
            hasClientUsers = false;

            var thisClient = undefined;
            _.each(clientDataService.clients, function(client){
                if(client.uid == clientID){
                    thisClient = client
                    if(_.has(thisClient, 'clientUsers')){
                        hasClientUsers = true;
                    }
                }
            });

            $mdDialog.show({
                controller: panelDialogController,// see below
                controllerAs: 'vm',
                templateUrl: 'app/app-services/panelDataService/dialog-profile-panel.tmpl.html',
                locals: {panel: panel, clientID: clientID, hasClientUsers: hasClientUsers},
                // targetEvent: $event,
                focusOnOpen: false,
                clickOutsideToClose: true
            });



        };

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// Panel Dialog Controller

        /* @ngInject */
        function panelDialogController($mdDialog, panel, hasClientUsers, $scope, hotkeys, $timeout) {
            var vm = this;
            vm.panel = panel;
            vm.colors = $rootScope.clientColors;
            vm.hasClientUsers = hasClientUsers;
            $timeout(function(){
                $('input[name="detaillabel"]').focus();
            },300)
            vm.showColors = false;
            vm.toggleColors = function(){
                if(!vm.showColors){
                    vm.showColors = true;
                } else {
                    vm.showColors = false;
                }
            }

            // Hide color panel after selection made
            $scope.$watch('vm.panel.color', function (newValue, oldValue, scope) {
                if(vm.showColors){
                    vm.toggleColors();
                }
            });

            // Setup Hotkeys for this dialog
            hotkeys.bindTo($scope)
                // inhibit enter from submitting
                .add({
                  combo: 'enter',
                  callback: function(event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                  }
                })
                .add({
                  combo: 'ctrl+enter',
                  allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                  description: 'Save/Update List',
                  callback: function(event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info($scope.clientDialogForm);
                    var pristine = $scope.vm.panelDialogForm.$pristine,
                        invalid = $scope.vm.panelDialogForm.$invalid;

                        if (!pristine && !invalid && vm.panel.uid){
                            $scope.updatePanel($scope.vm.panel);
                        }

                        if (!pristine && !invalid && !vm.panel.uid){
                            $scope.saveNewPanel($scope.vm.panel);
                        }
                    }
                });


            $scope.saveNewPanel = function saveNewPanel(panel) {
                createPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('List ' + panel.label + ' created.');
                // $scope.editedPanel = null;
                pageDimensionsService.resizeColumns();
            }

            $scope.updatePanel = function updatePanel(panel) {
                // $log.info('DialogControl: updatePanel');
                panel.updatedOn = moment().toISOString();
                // $log.info(panel);
                saveUpdatedPanel(panel);
                $scope.cancelDialog();
                $mdToast.showSimple('List ' + panel.label + ' updated.');
                pageDimensionsService.resizeColumns();
            }

            $scope.cancelDialog = function cancelDialog(dialog) {
                $mdDialog.cancel();
            }


        }


    }; // end panelDataService


})
();

(function() {
    'use strict';


    angular.module('appServices')
        .service('noteDataService', noteDataService);

    /* @ngInject */
    function noteDataService($mdToast, $log, notificationService, taskDataService, userDataService, clientDataService, $mdMedia, $rootScope, $timeout, $filter, hotkeys) {
        var service = {
            saveNote: saveNote,
            deleteNote: deleteNote,
            updateNote: updateNote
        };


        return service;

        function saveNote(newNote, task, clientID, numnotes, teamList){
            // $log.info('saveNote');
            // $log.info(newNote);
            // $log.info(task);
            // $log.info(task);
            // var task = angular.fromJson(jsonTask);
            // $log.info(task);
            var taskID = task.uid;
            var note = angular.copy(newNote),
                client = _.find(clientDataService.clients, function(client) { return client.uid == clientID; }),
                newNoteKey = firebase.database().ref().child('tasks/' + taskID + '/notes').push().key;

            note.uid = newNoteKey;
            note.date = Date.now();
            note.author = userDataService.user.uid;
            note.authorName = userDataService.user.profile.fullName;
            note.clientName = client.profile.fullName;

            // declare our updates
            var updates = {};

            // store our canonical object
            updates['/tasks/' + taskID + '/notes/' + newNoteKey] = note;
            // update numnotes on /tasks and /clients/task reference
            updates['/tasks/' + taskID + '/info/numnotes' ] = numnotes;
            updates['/clients/' + clientID + '/tasks/' + taskID + '/numnotes'] = numnotes;

            // if author isn't assignee, add them to following for this task.
            if(note.author != task.info.assignee){
              updates['/tasks/' + taskID + '/info/following/' + $rootScope.userID ] = true;
            }
            if(_.has(task.info, 'board')){
               updates['/taskBoards/' + task.info.board + '/lists/' + task.info.list + '/items/' + task.uid + '/numnotes'] = numnotes;
            }

            // Save the note
            return firebase.database().ref().update(updates)
            .then(function(){
                // prep notification
                var taskDescription = _.truncate(task.info.description, {
                  'length': 50,
                  'separator': '...'
                });
                //heap.track('addedTaskNote');
                userpilot.track('addedTaskNote');
                var notification = {
                  title: 'Comment from ' + note.authorName + ' on ' + taskDescription,
                  message: note.body,
                  meta: 'Task Comment',
                  type: 'comment',
                  related: taskID
                }

                var notificationList = {};


                // if not the creator making the comment, send notification to the creator
                if(task.info.creator != $rootScope.userID){
                  notification.assignee = task.creator;
                  notificationService.notify(notification);
                }

                // if not the assignee making the comment, send notification to the assignee
                if(task.info.assignee != $rootScope.userID){
                  notification.assignee = task.info.assignee;
                  notificationService.notify(notification);
                }

                // send notification to anyone else who is following (manually selected "follow" or commented previously.)
                if(_.has(task.info, 'following')){
                    _.each(task.info.following, function(user, key){
                      if(user && key != task.info.assignee && key != task.info.creator && key != $rootScope.userID){
                        notification.assignee = key;
                        notificationService.notify(notification);
                      }
                    });
                  }

                userDataService.trackEvent('submit-task-comment');
                // log the event on the task
                taskDataService.logTask(taskID, 'Comment added.');

                // if we are to notify the client, send off that email
                if (note.notifyClient){
                    return taskDataService.getTask(taskID)
                    .then(function(task){
                        var serialize = function(obj) {
                          var str = [];
                          for(var p in obj)
                            if (obj.hasOwnProperty(p)) {
                              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            }
                          return str.join("&");
                        }


                        var budget = task.info.budget/60;
                        var newImage = new Image();
                        var message = {};
                        message.recipientEmail = client.profile.email;
                        message.message = task.info.description + '<br><br>' + note.body;
                        message.subject = task.info.description.substring(0, 100);
                        message.budget = budget.toFixed(2);
                        message.due = moment(task.info.duedate).format('MM/DD/YYYY')
                        message.logged = $filter('HandM')(task.info.logged);
                        message.status = task.info.status;
                        message.sender = note.authorname;
                        message.senderEmail = userDataService.user.email;
                        var payload = serialize(message);
                        ;
                        newImage.src = "https://hooks.zapier.com/hooks/catch/44307/tkzfyb/?"+payload;

                    })
                }
            })// return Updates
        } // saveNote


        function deleteNote(note, taskID, clientID){
            // $log.info("deleteNote");

               // Update our canonical task
              var updates  = {}
              updates['/tasks/' + taskID + "/notes/" + note.uid ] = null;

               // Execute Updates
               //heap.track('Task Note Deleted');
               return firebase.database().ref().update(updates)
               .then(function(){
                    // Update Task's numnotes
                    return taskDataService.getTask(taskID)
                    .then(function(task){
                         // client's tasks are just our task.info
                         var workingTask = task.info;
                         // with a refID
                         workingTask.refID = task.uid;
                         // update numnotes total
                         workingTask.numnotes = workingTask.numnotes -1;
                         // Execute a quickupdate
                         taskDataService.quickUpdate(workingTask);
                    })
                    .then(function(response){
                        taskDataService.logTask(taskID, 'Comment deleted.');
                        userDataService.trackEvent('delete-task-comment');
                        $mdToast.show(
                             $mdToast.simple()
                               .textContent('Note removed')
                               .position('top right')
                               .hideDelay(2000)
                           );
                    })

               });
        }// deleteNote

        function updateNote(note, taskID, clientID){
            // $log.info("updateNote");
            delete note.$id;
            delete note.$priority;
            var updates = {};
             // store our canonical object
             updates['/tasks/' + taskID + '/notes/' + note.uid] = note;
             // Execute our updates
             return firebase.database().ref().update(updates)
                 // Add the default "Client Details" panel to this client
                 .then(function(response) {
                    userDataService.trackEvent('update-task-comment');
                    taskDataService.logTask(taskID, 'Comment edited.');
                    taskDataService.setupNotes();
                 });
        }// updateNote


    } // end noteDataService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('notificationService', notificationService);

    /* @ngInject */
    function notificationService($log, $sce, moment, userDataService, $rootScope, $firebaseArray, $firebaseObject) {
        var service = {
            notify: notify,
            init: init
        };


        return service;


        function init(){

        }// init

        function sanitizeMe(text) {
            return $sce.trustAsHtml(text)
        };

       function notify(notification){
        // $log.info('notify');
        // $log.info(notification);
        // $log.info(notification.assignee);

        // notification should include:
        //    - a title
        //    - a message
        //    - a meta
        //    - an assignee (as an array with one property userID)
        //    - optional - a type (general(default), task, email, tip, fix, thanks, recurring, retainer, date, alert, new)
        //    - optional - a 'team' ID (for sending notifications to an entire team)
        //    - optional - a related item ID (task/recurring task)


        // if a type wasn't set, set it to general
        if(!_.has(notification, 'type')){
          notification.type = 'general';
        }

        // Create our targets array
        var targets = [];

        if(_.has(notification, 'team')){
          // create a targetArray from the team and remove the property
          delete notification.team
        } else {
          var thisUser = {
            userID: notification.assignee
          };
          targets.push(thisUser);
        }
        notification.targets = targets;

        notification.timeStamp = moment().toISOString();

        var notificationRef = firebase.database().ref('notifications');
        var notificationKey = notificationRef.push().key,
            updates = {};
        updates['/notifications/' + notificationKey] = notification;
        return firebase.database().ref().update(updates)
                .then(function () {
                    // $log.info('sorted');
                });

       }// notify


    } // end notificationService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('leadTaskDialogController', leadTaskDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// leadTaskDialogController

        /* @ngInject */
        function leadTaskDialogController($scope,  $mdDialog, $timeout, $log, $mdToast, $rootScope, leadDataService) {
            // $log.info('leadTask dialog Controller');

            var vm = this;



            // We are editing an existing task. make sure it has a files node.
                if(!_.has(vm.leadTask, 'files')){
                    vm.leadTask.files = [];
                }

            vm.cancelDialog = cancelDialog;
            vm.init = init;
            vm.settings = $rootScope.userSettings;
            vm.saveNewTask = saveNewTask;
            vm.updateTask = updateTask;
            vm.stageColor = stageColor;
            vm.forms = {};
            vm.setReminder = setReminder;
            vm.froalaOptions = {
                    key: $rootScope.froalaKey,
                    pluginsEnabled: [
                    "align", "charCounter", "codeBeautifier", "codeView", "colors", "draggable",  "emoticons", "entities",  "fontSize",
                    // "file", "image", "imageTUI", "imageManager",
                     "lineBreaker", "link", "lists", "paragraphFormat", "paragraphStyle", "quickInsert", "quote",  "url", "wordPaste"
                    ],
                    spellcheck: true, // does not appear to actually enable spellcheck
                    toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "strikeThrough" ,"textColor", "|", "align", "formatOL", "formatUL", "indent", "outdent", "|", "insertLink", "emoticons", "insertHR", "|", "html"],
                    autofocus: true,
                    attribution: false,
                    pastePlain: true,
                    charCounterMax: 8000,
                    linkAlwaysBlank: true,
                    linkAutoPrefix: 'https://',
                    linkInsertButtons: '',
                    linkText: true,
                    htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
                    pasteDeniedAttrs: ['class', 'id', 'data'],
                    pasteDeniedTags: ['iframe', 'script', 'style'],
                    events: {
                                'froalaEditor.initialized': function () {
                                },
                                'charCounter.exceeded': function () {
                                }
                            }//events
                }//froalaOptions
            // Setup
            vm.init();


            function init(){
                $timeout(function() {
                    var field = angular.element('text-angular[name=description-editor]').find('*[id*=taText]');
                    if(field){
                        field.focus()
                    }
                },500);
            }// init




            function saveNewTask(task){
                // $log.info('saveNewTask');
                // $log.info(task);
                return leadDataService.saveNewLeadTask(task)
                .then(function(){
                    $mdDialog.cancel();
                });
            }

            function updateTask(task){
                // $log.info('updateTask');
                // $log.info(task);
                return leadDataService.updateLeadTask(task)
                .then(function(){
                    $mdDialog.cancel();
                });
            }

            function stageColor(typeID){
                var color = undefined;
                _.each(vm.leadTypes, function(type){
                    if(type.uid == typeID){
                        color = type.color
                    }
                });
                return color
            }

            function cancelDialog(){
                $mdDialog.cancel();
            }

            function setReminder(task,event){
                    $mdDialog.show(
                          $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Coming Soon!')
                            .textContent('We are working hard on a new Reminder system for Adminja. We\'ll let you know when it\'s ready!')
                            .ariaLabel('Reminder Alert')
                            .ok('Got it!')
                            .targetEvent(event)
                        );
                  }

        } // end leadTaskDialogController

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('leadFormDialogController', leadFormDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// leadFormDialogController

        /* @ngInject */
        function leadFormDialogController($scope,  $mdDialog, $timeout, $log, $mdToast, $rootScope, $location, leadDataService, userDataService, clientDataService, dragulaService) {
            $log.info('Lead form Controller');
            var vm = this;
            vm.config = fbConfig;
            vm.cancelDialog = cancelDialog;
            vm.init = init;
            vm.settings = $rootScope.userSettings;
            vm.forms = {};
            vm.addField = addField;
            vm.setDirty = setDirty;
            vm.removeField = removeField;
            vm.saveNewField = saveNewField;
            vm.cancelAddField = cancelAddField;
            vm.updateField = updateField;
            vm.saveLeadForm = saveLeadForm;
            vm.updateLeadForm = updateLeadForm;
            vm.editField = editField;
            vm.exportLeadForm = exportLeadForm;
            vm.splitOptions = splitOptions;
            vm.copyLeadForm = copyLeadForm;
            vm.customFieldLength = customFieldLength;
            vm.useCustomResponse = false;
            vm.customThankYou = null;
            vm.leadDataService = leadDataService;
            vm.clientDataService = clientDataService;
            vm.userID = $rootScope.userID;
            vm.setWorkspace = setWorkspace;
            vm.changeFormType = changeFormType;
            vm.hostingURL = $location.protocol() + '://' + $location.host();
            vm.showHeading = true;
            vm.customFieldsCopy = angular.copy(vm.thisForm.customFields);


            init();

            function init(){
                vm.workspaces = clientDataService.thisUsersWorkspaces(userDataService.user);

                vm.formActions = [
                    {
                        label: 'Create a Lead',
                        value: 'createLead'
                    },
                    {
                        label: 'Create a Task',
                        value: 'createTask'
                    },
                    {
                        label: 'Create a Note',
                        value: 'createNote'
                    },
                    {
                        label: 'Send an Email',
                        value: 'sendEmail'
                    },
                ];

                // make sure our workspace is selected on load if set
                if(_.has(vm.thisForm, 'targetWorkspace')){
                    vm.selectedWorkspace = clientDataService.getWorkspace(vm.thisForm.targetWorkspace);
                }

                $timeout(function(){if(!vm.thisForm.uid){
                    $("#formNameField").focus();
                }},500)


            }// init


            function setWorkspace(workspaceID){
                delete vm.thisForm.targetList;
                vm.selectedWorkspace = clientDataService.getWorkspace(workspaceID);
            }// set Workspace


            function changeFormType(type){
                if(type == 'createLead'){
                    // Make sure name and email are enabled
                    _.each(vm.thisForm.fields, function(field){
                        if(field.nodeName == 'firstName' || field.nodeName == 'lastName' || field.nodeName == 'email'){
                            field.on = true;
                        }
                    })
                }
                delete vm.selectedWorkspace;
                delete vm.thisForm.targetWorkspace;
            }// changeFormType

            function setDirty(){
              vm.forms.leadForm.$setDirty();
          }

          function splitOptions(options){
            var newOptions = options.split("\n");
            return newOptions
          }

            function resetNewField(){
                vm.newField = {
                    label: '',
                    type: 'text',
                    required: false,
                    on: true
                }
            }

            function customFieldLength(){
                return _.size(vm.customFields);
            }

            function addField(field){
                $log.info('addField');
               resetNewField();
                vm.showAddForm = true;
                $timeout(function(){
                    document.getElementById("focusfield").focus();
                },250);

            }



            function cancelAddField(){
                vm.showAddForm = false;
                vm.showEditForm = false;
            }

            function saveNewField(field){
                // spacers and dividers need unique names for behind the scenes
                if(field.type == 'divider'){
                    field.label = 'divider-' + _.size(vm.thisForm.customFields);
                }
                if(field.type == 'spacer'){
                    field.label = 'spacer-' + _.size(vm.thisForm.customFields);
                }
                if(field.label != ''){
                    var newField = angular.copy(field);
                    newField.nodeName = 'cf_' + newField.label.toLowerCase().replace(/[^0-9a-zA-Z]/g, "_").replace(/[\. ,:-]+/g, "-");
                    if(!_.has(vm.thisForm, 'customFields')){
                        vm.thisForm.customFields = [];
                    }
                    newField.order = _.size(vm.thisForm.customFields) + 1;
                    vm.thisForm.customFields.push(newField);
                    //saving on delay - for some reason some fields don't get added to DOM immediately
                    $timeout(function(){
                        return updateLeadForm(vm.thisForm)
                        .then(function(){
                            //heap.track('saveNewField');
                            resetNewField();
                            vm.showAddForm = false;
                        });
                    },250)


                }
            }// saveNewField

            function updateField(editedField){
                // $log.info('updateField');
                _.each(vm.thisForm.customFields, function(field, index){
                    if(editedField.nodeName == field.nodeName && editedField.order == field.order){

                        // spacers and dividers need unique names for behind the scenes
                        if(editedField.type == 'divider'){
                            editedField.label = 'divider-' + _.size(vm.thisForm.customFields);
                        }
                        if(editedField.type == 'spacer'){
                            editedField.label = 'spacer-' + _.size(vm.thisForm.customFields);
                        }
                        if(editedField.label != ''){
                            var newField = angular.copy(field);
                            newField.nodeName = 'cf_' + newField.label.toLowerCase().replace(/[^0-9a-zA-Z]/g, "_").replace(/[\. ,:-]+/g, "-");

                            // replace the original
                            vm.thisForm.customFields[index] = angular.copy(editedField);

                            //saving update on delay - for some reason some fields don't get added to DOM immediately
                            $timeout(function(){
                                return updateLeadForm(vm.thisForm)
                                .then(function(){
                                    //heap.track('saveNewField');
                                    resetNewField();
                                    vm.showAddForm = false;
                                    vm.showEditForm = false;
                                });
                            },250)


                        }
                    }
                })
            }// updateField


            function editField(field){
                // $log.info('editField');
                var editingField = angular.copy(field);
                // $log.info(editingField);
                vm.newField = editingField;
                vm.showEditForm = true;
            }//editField


            function removeField(index){
                for( var i = 0; i < vm.thisForm.customFields.length; i++){
                   if ( vm.thisForm.customFields[i] === index) {
                     vm.thisForm.customFields.splice(i, 1);
                     return updateLeadForm(vm.thisForm)
                     .then(function(){
                         vm.setDirty();
                     });
                   }
                }
            }// removeField

            function saveLeadForm(saveForm){
                saveForm.timeStamp = moment().toISOString();
                return leadDataService.saveLeadForm(saveForm)
                .then(function(){
                    //heap.track('saveLeadForm');
                    userpilot.track('saveLeadForm');
                    // cancelDialog();
                    $timeout(function(){
                        vm.forms.leadForm.$setPristine();
                    },0)
                })
            }

            function updateLeadForm(updateForm){
                updateForm.lastChange = moment().toISOString();
                return leadDataService.updateLeadForm(updateForm)
                .then(function(){
                    // cancelDialog();
                    $timeout(function(){
                        vm.forms.leadForm.$setPristine();
                    },0)

                });
            }



            function exportLeadForm(form){
                return leadDataService.exportLeadForm(form)
                .then(function(html){
                    $timeout(function(){
                        vm.exportHTML = true;
                        vm.HTML = html;
                    },0);
                })
            }// exportLeadForm



            function copyLeadForm() {
              /* Get the text field */
              var copyText = document.getElementById("copycode");

              /* Select the text field */
              copyText.select();

              /* Copy the text inside the text field */
              document.execCommand("copy");

              //heap.track('copyLeadFormEmbed');
              userpilot.track('copyLeadFormEmbed');

              /* Alert the copied text */
              $mdToast.showSimple('Lead form copied to your clipboard');
            }

            function cancelDialog(){
                $mdDialog.cancel();
            }

            // Field Dragging
            dragulaService.options($scope, 'drag-fields', {
                moves: function (el, container, handle) {
                        return !handle.classList.contains('drag-handle');
                    // return handle.classList.contains('task-handle');
                },
                accepts: function (el, target, source, sibling) {
                    // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

                   return true

                },
                invalid: function(el, handle){
                    // return var === 'condition'
                    return false
                },
                direction: 'vertical',
                revertOnSpill: true
            });


            $scope.$on('drag-fields.drop', function (event, item, target, source, sibling) {
                $timeout(function(){
                    vm.setDirty();
                },0);
                // Now we can do our work - prep the variables
                var itemID = item[0].attributes.catid.value,
                        thisContainer = $('.default-fields-container'),
                        sortItems = Array.from(thisContainer.find('.category-item'));

                // Change sort order
                _.each(sortItems, function(category, index){
                    var catID = category.attributes.catid.value;
                    // find the matching object
                    _.each(vm.thisForm.fields, function(field){
                        if(field.nodeName === catID){
                            field.order = index + 1;
                        }
                    });
                });
                // update the form with the new array
                var updates = {};
                updates['/leadBoards/' + vm.thisForm.owner + '/forms/' + vm.thisForm.uid + '/fields'] = vm.thisForm.fields;
                updates['/forms/' + vm.thisForm.uid + '/fields'] = vm.thisForm.fields;
                return firebase.database().ref().update(updates)
                .then(function(){
                    $timeout(function(){
                        $timeout(function(){
                            vm.forms.leadForm.$setPristine();
                        },0)
                    },0)
                })
            });// drag-fields.drop


            // Field Dragging
            dragulaService.options($scope, 'drag-custom-fields', {
                moves: function (el, container, handle) {
                        return !handle.classList.contains('drag-handle');
                    // return handle.classList.contains('task-handle');
                },
                accepts: function (el, target, source, sibling) {
                    // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

                   return true

                },
                invalid: function(el, handle){
                    // return var === 'condition'
                    return false
                },
                direction: 'vertical',
                revertOnSpill: true
            });


            $scope.$on('drag-custom-fields.drop', function (event, item, target, source, sibling) {
                vm.setDirty();
                vm.customFieldsCopy = angular.copy(vm.thisForm.customFields);
                // Now we can do our work - prep the variables
                var itemID = item[0].attributes.catid.value,
                        thisContainer = $('.custom-fields-container'),
                        sortItems = Array.from(thisContainer.find('.category-item')),
                        updates = {};

                // // Change sort order
                _.each(sortItems, function(category, index){
                    var catID = category.attributes.catid.value;
                    // find the matching object
                        _.each(vm.customFieldsCopy, function(field){
                            if(field.nodeName === catID){
                                field.order = index;
                            }
                        });
                });
                // update the form with the new order
                var updates = {};
                updates['/leadBoards/' + vm.thisForm.owner + '/forms/' + vm.thisForm.uid + '/customFields'] = vm.customFieldsCopy;
                updates['/forms/' + vm.thisForm.uid + '/customFields'] = vm.customFieldsCopy;
                return firebase.database().ref().update(updates)
                .then(function(){
                    $timeout(function(){
                        $timeout(function(){
                            vm.forms.leadForm.$setPristine();
                        },0)
                    },0)
                })

            });// drag-custom-fields.drop

        } // end leadFormDialogController

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('leadDataService', leadDataService);

    /* @ngInject */
    function leadDataService($q, $mdToast, $mdBottomSheet, $mdDialog, $log, scheduleDataService, $location, pageDimensionsService, $firebaseArray,$rootScope, $timeout, $firebaseObject, userDataService, clientDataService) {
        var service = {
        	newLead: newLead,
        	leadSheet: leadSheet,
            saveNewLead: saveNewLead,
            updateLead: updateLead,
            cloneLead: cloneLead,
            deleteLead: deleteLead,
            getLeadBoard: getLeadBoard,
            getLead: getLead,
            clearLeadData: clearLeadData,
            newContact: newContact,
            saveNewContact: saveNewContact,
            editContact: editContact,
            updateContact: updateContact,
            deleteContact: deleteContact,
            newLeadTask: newLeadTask,
            saveNewLeadTask: saveNewLeadTask,
            editLeadTask: editLeadTask,
            updateLeadTask: updateLeadTask,
            deleteLeadTask: deleteLeadTask,
            newWorkspace: newWorkspace,
            changeLeadStatus: changeLeadStatus,
            currentView: 'active',
            createLeadForm: createLeadForm,
            saveLeadForm: saveLeadForm,
            updateLeadForm: updateLeadForm,
            deleteLeadForm: deleteLeadForm,
            openLeadForm: openLeadForm,
            toggleLeadTask: toggleLeadTask,
            exportLeadForm: exportLeadForm
        };

        return service;

        service.leadBoard = {};



        function newWorkspace(lead){
            userDataService.trackEvent('new-workspace-for-lead');
            // $log.info('New workspace for: ', lead);
            var newWorkspace = clientDataService.newClient(lead.owner, lead);
            //heap.track('newWorkspaceFromLead');
            userpilot.track('newWorkspaceFromLead');
            clientDataService.clientDialog(newWorkspace, 'New Client Workspace');
        }

        function clearLeadData(){
            delete service.leads;
            service.leadBoard = {};
        } //clearLeadData

        function saveNewContact(contact){
            // $log.info('saveNewContact');
            contact.timeStamp = moment().toISOString();
            var newContactKey = firebase.database().ref().child('leadBoards/' + contact.leadBoard + '/leads/' + contact.lead + '/contacts').push().key;
            var contactCopy = angular.copy(contact);
            ajUTILITIES.removePropertiesWith(contactCopy);
            contactCopy.uid = newContactKey;

            var newActivityKey = firebase.database().ref().child('leadBoards/' + contactCopy.leadBoard + '/leads/' + contactCopy.lead + '/activity').push().key,
            activity = {
                timeStamp: moment().toISOString(),
                activity: 'Added lead activity',
                user: userDataService.user.profile.fullName
            }

            var updates = {};
            updates['/leadBoards/' + contactCopy.leadBoard + '/leads/' + contactCopy.lead + '/contacts/' + contactCopy.uid] = contactCopy;
            updates['/leadBoards/' + contactCopy.leadBoard + '/leads/' + contactCopy.lead + '/activity/' + newActivityKey] = activity;

            return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('saveNewLeadContact');
                userDataService.trackEvent('save-lead-contact');
                return
            })
        }// saveNewContact

        function updateContact(contact){
            $log.info('updateContact');
            var contactCopy = angular.copy(contact);
            ajUTILITIES.removePropertiesWith(contactCopy);
            contactCopy.lastUpdate = moment().toISOString();

            var newActivityKey = firebase.database().ref().child('leadBoards/' + contact.owner + '/leads/' + contact.lead + '/activity').push().key,
            activity = {
                timeStamp: moment().toISOString(),
                activity: 'Updated lead activity item ',
                user: userDataService.user.profile.fullName
            }

            var updates = {};
            updates['/leadBoards/' + contact.owner + '/leads/' + contact.lead + '/contacts/' + contact.uid] = contactCopy;
            updates['/leadBoards/' + contact.owner + '/leads/' + contact.lead + '/activity/' + newActivityKey] = activity;

            return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('updateLeadContact');
                userDataService.trackEvent('update-lead-contact');
                return
            })
        }// updateContact

        function deleteContact(contact){
            $log.info('delete activity');
             var confirm = $mdDialog.confirm()
                      .title('Delete this activity log?')
                      .htmlContent('This action cannot be undone.')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                var activityRef = firebase.database().ref('leadBoards/' + contact.leadBoard + '/leads/' + contact.lead + '/contacts/' + contact.uid);
                activityRef.set(null);
                $mdDialog.cancel();
                }, function(){
                    //heap.track('deleteLeadContact');
                    userDataService.trackEvent('delete-lead-contact');
                    $mdDialog.cancel();
                });

        }// deleteContact

        function editContact(contact){
            $log.info('service: editContact');
            userDataService.trackEvent('edit-lead-contact');
            $mdDialog.show({
                controller: 'contactDialogController',
                controllerAs: 'vm', // see below
                templateUrl: 'app/app-services/leadDataService/dialog-edit-contact.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    contact: contact
                },
                bindToController: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true
            });

        }// editContact

        function newContact(lead, type){
            // $log.info('service: newContact');
            //heap.track('NewLeadContact');
            userDataService.trackEvent('new-lead-contact');
            $mdDialog.show({
                controller: 'contactDialogController',
                controllerAs: 'vm', // see below
                templateUrl: 'app/app-services/leadDataService/dialog-edit-contact.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    lead: lead,
                    type: type
                },
                bindToController: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true
            });

        }// newContact

        function cloneLead(lead){
            userDataService.trackEvent('clone-lead');
            var leadClone = angular.copy(lead);
            // get a fresh lead to acquire a fresh uid
            var freshLead = service.newLead();
            // combine the two
            leadClone.uid = freshLead.uid;
            delete leadClone.activity;
            delete leadClone.contacts;
            delete leadClone.notes;
            delete leadClone.timeStamp;
            //heap.track('Clone lead');
            userpilot.track('Clone lead');
            service.leadSheet(leadClone,0);
        }// cloneLead


        function changeLeadStatus(lead, status){


            var updates = {};

            // update status
            updates['leadBoards/' + lead.owner + '/leads/' + lead.uid + '/status/'] = status;

            // if moving from active, record the closedDate
            if(status == 'won' || status == 'archived' || status == 'lost'){
                updates['leadBoards/' + lead.owner + '/leads/' + lead.uid + '/closedDate'] = moment().toISOString();
            }
            // if moving to active, remove the closedDate
            if(status == 'active'){
                updates['leadBoards/' + lead.owner + '/leads/' + lead.uid + '/closedDate'] = null;
            }

            return firebase.database().ref().update(updates)
            .then(function(){
                // $mdDialog.hide();
                userDataService.trackEvent('change-lead-status');
               $timeout(function () {
                   pageDimensionsService.resizeColumns();
                   //heap.track('Lead Status Changed');
                   userpilot.track('Lead Status Changed');
               }, 500);
            });


            var activityRef = firebase.database().ref('leadBoards/' + lead.owner + '/leads/' + lead.uid + '/status/');
            return activityRef.set(status)
            .then(function(){
                $mdToast.show($mdToast.adminjaAlert(
                    {
                        locals:{
                            title: 'Your lead has been moved to ' + status,
                            message: '' ,
                            color: 'green'
                        }
                    }));// mdToast
            })
        }



        function deleteLead(lead){
            $log.info('service.deleteLead');
            var confirm = $mdDialog.confirm()
                    .title('Delete Lead: Are you sure?')
                    .textContent('All of your history for this lead will be permanently deleted. This can\'t be undone.')
                    .ariaLabel('Delete Lead? Y//N')
                    .targetEvent(lead)
                    .ok('Yes, Delete')
                    .cancel('No');
            $mdDialog.show(confirm)
                    .then(function () {

                        // remove our client's reference
                        var updates = {};
                        updates['/leadBoards/' + lead.owner + '/leads/' + lead.uid] = null;
                        return firebase.database().ref().update(updates)
                        .then(function(){
                            $mdDialog.hide();
                           $timeout(function () {
                               pageDimensionsService.resizeColumns();
                               //heap.track('Lead deleted');
                               userDataService.trackEvent('delete-lead');

                           }, 500);
                        });
                    });
        }


        function getLeadBoard(accountID, force){
            return $timeout(function(){
                // if(!accountID){
                //     var accountID = $rootScope.userID;
                // }
                // if(_.size(service.leadBoard) > 0 && !force){
                //     return service.leadBoard
                // } else {
                    var boardRef = firebase.database().ref('leadBoards/' + accountID);
                    service.leadBoard = {};
                    service.leadBoard = $firebaseObject(boardRef);
                    service.leads = service.leadBoard.leads;
                    return service.leadBoard
                // }
            });
        }//getLeadBoard

        function getLead(accountID, leadID){
            var leadRef = firebase.database().ref('leadBoards/' + accountID + '/leads/' + leadID);
            return $firebaseObject(leadRef);
        }

        function leadSheet(lead, targetTab, option){
            // converted from opening a dialog to opening a bottomSheet

        	var editedLead = lead;
                $mdBottomSheet.show({
                  templateUrl: 'app/app-services/leadDataService/leadBottomSheet.tmpl.html',
                  controller: 'leadBottomSheetController',
                  controllerAs: 'vm',
                  bindToController: true,
                  clickOutsideToClose: true,
                  disableBackdrop: false,
                  focusOnOpen: true,
                  disableParentScroll: false,
                  escapeToClose: true,
                  locals: {
                    lead: lead,
                    selectedTabIndex: targetTab,
                    option: option
                  }
                }).then(function(lead) {
                  // $log.info('sheet open');
                }).catch(function(error) {
                  // User clicked outside or hit escape
                  // $log.warn("Error!" , error);
                });

        	// $mdDialog.show({
        	//     controller: 'leadSheetController',
        	//     controllerAs: 'vm', // see below
        	//     templateUrl: 'app/app-services/leadDataService/dialog-edit-lead.tmpl.html',
        	//     parent: angular.element(document.body),
        	//     locals: {
        	//         lead: lead,
        	//         targetTab: targetTab
        	//     },
        	//     bindToController: true,
        	//     focusOnOpen: false,
        	//     clickOutsideToClose: true,
        	//     fullscreen: true
        	// });
        }// leadSheet

        function newLead(accountID, type){
            userDataService.trackEvent('new-lead');
            // $log.info(label);
            // if no owner passed, use current user's account
                    if(!accountID){
                        var accountID = $rootScope.userID;
                    }


	        var newLeadKey =  firebase.database().ref().child('leadBoards/' + accountID).push().key;


	        var newLead = {
	        	owner: accountID,
	   			color: '#999',
	   			leadType: 'new',
	   			uid: newLeadKey,
	   			status: 'active',
                order: .5,
                avatar: "/assets/images/avatars/generic-person-avatar.png",
                avatarThumb: "/assets/images/avatars/generic-person-avatar.png"
	   		}

	        	if(type){
	        		newLead.leadType = type;
	        	}


	        	return newLead
        }// newLead

        function saveNewLead(lead){
            // $log.info('saveNewLead');
            lead.timeStamp = moment().toISOString();
            lead.created = moment().toISOString();
            lead.activity = [];
            var newActivityKey =  firebase.database().ref().child('leadBoards/' + lead.owner).push().key;

            var activity = {
            	timeStamp: moment().toISOString(),
            	activity: 'Created Lead',
            	user: userDataService.user.profile.fullName,
                uid: newActivityKey
            }
            lead.activity.push(activity);

            var updates = {};
            updates['/leadBoards/' + lead.owner + '/leads/' + lead.uid] = lead;
            return firebase.database().ref().update(updates)
           .then(function(){
             //heap.track('saveNewLead');
             userDataService.trackEvent('save-lead');
             return 'success'
           }, function(error){
             return error
           });
        }// saveNewLead

        function updateLead(lead, actionTaken){
            // $log.info('updateLead');

            // var leadCopy = angular.copy(lead);
            var leadCopy = angular.fromJson(angular.toJson(lead));
            leadCopy.updated = moment().toISOString();
            ajUTILITIES.removePropertiesWith(leadCopy);
            var newActivityKey =  firebase.database().ref().child('leadBoards/' + lead.owner).push().key;
            var activityAction = 'Updated Lead';

            if(actionTaken){
              activityAction = actionTaken;
            }

            if(actionTaken != false && actionTaken != undefined){
              var activity = {
              	timeStamp: moment().toISOString(),
              	activity: activityAction,
              	user: userDataService.user.profile.fullName,
                  uid: newActivityKey
              }

              leadCopy.activity[newActivityKey] = activity;
            }// if activity isn't suppressed
             var updates = {};
             updates['/leadBoards/' + lead.owner + '/leads/' + lead.uid] = leadCopy;
             return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('Lead Udpated');
                userDataService.trackEvent('update-lead');
              return 'success'

            }, function(error){
              return error
            });
        }// updateLead


        function exportLeadForm(form){
            $log.info('exportLeadForm');
            var html = '<style type="text/css"> .adminja-lead-capture-form input{display:block; margin: 1em; padding: 5px; min-width: 200px;} .adminja-lead-capture-form textarea{display:block; margin: 1em; padding: 5px; width: 100%; min-height: 200px;} .adminja-field{display:block;} .adminja-field-checkbox input{ display:inline; } .adminja-field-label{margin-top: 11px;} .adminja-field-select{ } .adminja-field-select select{display:block; margin-top: 1em; height: 20px; min-width: 200px;} .adminja-submit-button{ height: 40px; width: 200px;margin-top: 1em; font-size: 14px;}</style>';
            html = html + '<script>function adminjaFormSubmit(){ document.getElementById("adminjaForm").style.opacity = .5 }</script>';
            if(fbConfig.env == 'production'){
                html = html + '<form id="adminjaForm" onsubmit="adminjaFormSubmit()" class="adminja-lead-capture-form" name="adminja-lead-capture-form" action="https://www.adminja.co/processForm/" method="get">';
            }
            if(fbConfig.env == 'staging'){
                html = html + '<form id="adminjaForm" onsubmit="adminjaFormSubmit()" class="adminja-lead-capture-form" name="adminja-lead-capture-form" action="https://adminja-staging.firebaseapp.com/processForm/" method="get">';
            }
            if(_.has(form, 'instructions')){
                html = html + '<p style="margin-top: 2em;">' + form.instructions + '</p> <hr style="margin-bottom: 2em;">';
            }

            html = html + '<input type="hidden" name="userID" value="' + $rootScope.userID + '"/>';
            html = html + '<input type="hidden" name="formID" value="' + form.uid + '"/>';

            html = html + '<input type="hidden" name="formName" value="' + form.name + '"/>';
            html = html + '<input type="hidden" name="action" value="' + form.action + '"/>';
            if(_.has(form, 'targetWorkspace')){
                html = html + '<input type="hidden" name="workspace" value="' + form.targetWorkspace + '"/>';
            }
            if(_.has(form, 'target')){
                html = html + '<input type="hidden" name="targetEmail" value="' + form.target + '"/>';
            }
            if(_.has(form, 'targetList')){
                html = html + '<input type="hidden" name="list" value="' + form.targetList + '"/>';
            }
            if(_.has(form, 'customID')){
                html = html + '<input type="hidden" name="customID" value="' + form.customID + '"/>';
            }
            if(form.useCustomResponse){
                html = html + '<input type="hidden" name="responseURL" value="' + form.responseURL+ '">'
            }

            // Sort our fields
            var sortedFields = _.orderBy(form.fields, ['order'],['asc']),
                sortedCustomFields = _.orderBy(form.customFields, ['order'],['asc']);

            _.each(sortedFields, function(field){
                if(field.on){
                   html = html + fieldToHTML(field)
                }
            });

            _.each(sortedCustomFields, function(field){
                if(field.on){
                   html = html + fieldToHTML(field)
                }
            });
            html = html + '<div class="adminja-submit-container"><button type="submit" class="adminja-submit-button">Submit</button></div></form>';
            return $timeout(function(){ return html},150);
        }// exportLeadForm

        function fieldToHTML(field){
            var fieldHTML = undefined;

                if(field.type == 'text'){
                    if(field.required){
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><input type="text" name="'+field.nodeName +'" required>'
                    } else {
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><input type="text" name="'+field.nodeName +'" >'
                    }
                }

                if(field.type == 'email'){
                    if(field.required){
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><input type="email" name="'+field.nodeName +'"  required>'
                    } else {
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><input type="email" name="'+field.nodeName +'"  >'
                    }
                }

                if(field.type == 'textarea'){
                    if(field.required){
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><textarea name="'+field.nodeName +'" required></textarea>'
                    } else {
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><textarea name="'+field.nodeName +'" ></textarea>'
                    }
                }

                if(field.type == 'select'){
                    if(field.required){
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><select name="'+field.nodeName +'" required>';
                    } else {
                        fieldHTML = '<label for="'+ field.nodeName+'">' + field.label + '</label><select name="'+field.nodeName +'">';
                    }

                    var options = field.options.split("\n");
                    _.each(options, function(option){
                        fieldHTML = fieldHTML + '<option value="' + option + '">' + option + '</option>';
                    });
                    fieldHTML = fieldHTML + '</select>'
                }

                if(field.type == 'label'){
                    fieldHTML = '<label>' + field.label + '</label>';
                }

                if(field.type == 'divider'){
                    fieldHTML = '<hr>';
                }

                if(field.type == 'heading'){
                    fieldHTML = '<h3 style="text-align: center;">' + field.label + '</h3>';
                }

                if(field.type == 'paragraph'){
                    fieldHTML = '<p>' + field.label + '</p>';
                }
                if(field.type == 'spacer'){
                    fieldHTML = '<p>&nbsp;</p>';
                }

                if(field.type == 'checkbox'){
                    fieldHTML = '<input type="checkbox" name="'+field.nodeName +'"/>' + field.label;
                    // fieldHTML = fieldHTML + '<label for="'+ field.nodeName+'">' + field.label + '</label>';
                }

                fieldHTML = "<div class='adminja-field adminja-field-" + field.type +"'>" + fieldHTML + "</div>"
                if(fieldHTML){
                    return fieldHTML
                }

        }
        function createLeadForm(){
            userDataService.trackEvent('new-form');
            var form = {
                customFields: [],
                responseURL: '',
                useCustomResponse: false,
                owner: $rootScope.userID,
                action: 'createLead',
                targetList: 'new'
            };
            form.fields =  [
            { label: 'First name',
              nodeName: 'firstName',
              type: 'text',
              required: true,
              leadRequired: true,
              on: true,
              order: 1
              },
              { label: 'Last name',
                nodeName: 'lastName',
                type: 'text',
                required: true,
                leadRequired: true,
                on: true,
              order: 2
                },
            { label: 'Email',
              nodeName: 'email',
              type: 'email',
              required: true,
              leadRequired: true,
              on: true,
              order: 3
              },
            { label: 'Company',
              nodeName: 'company',
              type: 'text',
              required: false,
              on: false,
              order: 4
              },
            { label: 'Position',
              nodeName: 'position',
              type: 'text',
              required: false,
              on: false,
              order: 5
              },
            { label: 'Phone',
              nodeName: 'phone',
              type: 'text',
              required: false,
              on: false,
              order: 6
              },

            { label: 'Fax',
              nodeName: 'companyfax',
              type: 'text',
              required: false,
              on: false,
              order: 7
              },
            { label: 'Street Address',
              nodeName: 'adr_street',
              type: 'text',
              required: false,
              on: false,
              order: 8
              },
            { label: 'Street Address (line 2)',
              nodeName: 'adr_street2',
              type: 'text',
              required: false,
              on: false,
              order: 9
              },
            { label: 'City',
              nodeName: 'adr_city',
              type: 'text',
              required: false,
              on: false,
              order: 10
              },
            { label: 'State/Province',
              nodeName: 'adr_state',
              type: 'text',
              required: false,
              on: false,
              order: 11
              },
            { label: 'Zip/Postal Code',
              nodeName: 'adr_zip',
              type: 'text',
              required: false,
              on: false,
              order: 12
              },
            { label: 'Country',
              nodeName: 'adr_country',
              type: 'text',
              required: false,
              on: false,
              order: 13
              },
              { label: 'Work Description',
                nodeName: 'description',
                type: 'textarea',
                required: false,
                on: false,
              order: 14
                }
            ];

            //heap.track('createNewLeadForm');

            $mdDialog.show({
                controller: 'leadFormDialogController',
                controllerAs: 'vm', // see below
                templateUrl: 'app/app-services/leadDataService/dialog-lead-form.tmpl.html',
                parent: angular.element(document.body),
                locals:{
                    thisForm: form
                },
                bindToController: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true
            });

        }

        function updateLeadForm(updateForm){
             var updates = {};
             updates['/leadBoards/' + $rootScope.userID + '/forms/' + updateForm.uid] = updateForm;
             updates['/forms/' + updateForm.uid] = updateForm;
             return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('update-form');
              return 'success'
            }, function(error){
              return error
            });
        }

        function saveLeadForm(saveForm){
             var updates = {},
                  leadFormRef = firebase.database().ref('/leadBoards/' + $rootScope.userID + '/leadForms'),
                  newKey = leadFormRef.push().key;
                  saveForm.uid = newKey;
             updates['/leadBoards/' + $rootScope.userID + '/forms/' + newKey] = saveForm;
             updates['/forms/' + newKey] = saveForm;
             return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('saveLeadForm');
                userDataService.trackEvent('save-form');
              return 'success'
            }, function(error){
              return error
            });
        }

        function openLeadForm(form){
            userDataService.trackEvent('open-form');
            $mdDialog.show({
                controller: 'leadFormDialogController',
                controllerAs: 'vm', // see below
                templateUrl: 'app/app-services/leadDataService/dialog-lead-form.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    thisForm: form
                },
                bindToController: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true
            });
        }


        function deleteLeadForm(form){
             var updates = {};
             updates['/leadBoards/' + $rootScope.userID + '/forms/' + form.uid] = null;
             updates['/forms/'+ form.uid] = null;
             return firebase.database().ref().update(updates)
            .then(function(){
                //heap.track('deleteLeadForm');
                userDataService.trackEvent('delete-form');
              return 'success'
            }, function(error){
              return error
            });
        }

      function newLeadTask(lead){
        userDataService.trackEvent('new-lead-tasl');
          // $log.info(label);

        var newTaskKey =  firebase.database().ref().child('leadBoards/' + lead.owner).push().key;
        // if no owner passed, use current user's account


        var newLeadTask = {
          owner: lead.owner,
          lead: lead.uid,
          color: '#999',
          status: 'open',
          uid: newTaskKey,
          order: .5,
          type: 'other'
      }

            //heap.track('newLeadTask');

         return editLeadTask(newLeadTask, lead)

      }// newLeadTask

      function saveNewLeadTask(task){
          $log.info('Service: saveNewLeadTask');
          task.timeStamp = moment().toISOString();
          var taskCopy = angular.copy(task);
          ajUTILITIES.removePropertiesWith(task);
          var newActivityKey = firebase.database().ref().child('leadBoards/' + task.owner + '/leads/' + task.lead + '/activity').push().key,
              shortDescription = _.truncate(task.description, {
                  'length': 50,
                  'separator': '...'
                }),
                activity = {
                    timeStamp: moment().toISOString(),
                    activity: 'Added lead task: ' + shortDescription,
                    user: userDataService.user.profile.fullName
                }

          var updates = {};
          updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/tasks/' + task.uid] = taskCopy;
          updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/activity/' + newActivityKey] = activity;
          return firebase.database().ref().update(updates)
          .then(function(){
            //heap.track('saveNewLeadTask');
            userDataService.trackEvent('save-lead-task');
              return
          })
      }// saveNewLeadTask

      function updateLeadTask(task){
          $log.info('updateLeadTask');
          var taskCopy = angular.copy(task);
          ajUTILITIES.removePropertiesWith(task);
          taskCopy.lastUpdate = moment().toISOString();

          var newActivityKey = firebase.database().ref().child('leadBoards/' + task.owner + '/leads/' + task.lead + '/activity').push().key,
          shortDescription = _.truncate(task.description, {
              'length': 50,
              'separator': '...'
            }),
            activity = {
                timeStamp: moment().toISOString(),
                activity: 'Updated todo: ' + shortDescription,
                user: userDataService.user.profile.fullName
            },
            updates = {};

          updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/tasks/' + task.uid] = taskCopy;
          updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/activity/' + newActivityKey] = activity;

          return firebase.database().ref().update(updates)
          .then(function(){
            //heap.track('updateLeadTask');
            userDataService.trackEvent('update-lead-task');
              return
          })
      }// updateLeadTask

      function deleteLeadTask(task){
          $log.info('delete task');
           var confirm = $mdDialog.confirm()
                    .title('Delete this todo?')
                    .htmlContent('This action cannot be undone.')
                    .ariaLabel('Are you sure?')
                    .ok('Do it')
                    .cancel('Never mind');

          $mdDialog.show(confirm).then(function() {
            // Remove any reminders on this task
            var updates = {};
            if(_.has(task, 'reminders')){
                _.each(task.reminders, function(reminder){
                    updates['/schedules/' + reminder.uid] = null;
                });
            }
            updates['leadBoards/' + task.owner + '/leads/' + task.lead + '/tasks/' + task.uid] = null
              return firebase.database().ref().update(updates)
              .then(function(){
                //heap.track('deleteLeadTask');
                userDataService.trackEvent('delete-lead-task');
                $mdDialog.cancel();
                }, function(){
                    $mdDialog.cancel();
                });
              })
      }// deleteLeadTask

      function editLeadTask(task, lead){
          $log.info('service: editLeadTask');
          userDataService.trackEvent('edit-lead-task');
           $mdDialog.show({
               controller: 'leadTaskDialogController',
               controllerAs: 'vm', // see below
               templateUrl: 'app/app-services/leadDataService/dialog-edit-lead-task.tmpl.html',
               parent: angular.element(document.body),
               locals: {
                   leadTask: task,
                   lead: lead
               },
               bindToController: true,
               focusOnOpen: false,
               clickOutsideToClose: true,
               fullscreen: true
           });

      }// editLeadTask

      function toggleLeadTask(task){
        // $log.info('toggleLeadTask');

        if(task.status == 'open'){
          task.status = 'closed'
          //heap.track('completedLeadTask');
          userDataService.trackEvent('complete-lead-task');
          if(_.has(task, 'reminders')){
            _.each(task.reminders, function(reminder){
               return scheduleDataService.removeSchedule(reminder);
            });
          }
        } else {
          userDataService.trackEvent('reopen-lead-task');
          task.status = 'open'
        }

        var updates = {};
        updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/tasks/' + task.uid + '/status'] = task.status;
        updates['/leadBoards/' + task.owner + '/leads/' + task.lead + '/tasks/' + task.uid + '/closedDate'] = moment().toISOString();
        return firebase.database().ref().update(updates)
        .then(function(){
            return
        })
      }// toggleLeadTask



    } // end leadDataService
})();

(function() {
    'use strict';
    angular
        .module('appServices')
        .controller('leadBottomSheetController', leadBottomSheetController);

        /* #ngInject */
        function leadBottomSheetController($log, $rootScope, $mdDialog, $scope,  $timeout, $mdBottomSheet, $mdUtil, $element, leadDataService, dragulaService) {
        	$log.info('leadBottomSheetController');
        	var vm = this;
            vm.closeSheet = closeSheet;
            vm.saveNewLead = saveNewLead;
            vm.updateLead = updateLead;
            vm.getLeadTypeColor = getLeadTypeColor;
            vm.countries = $rootScope.countries;
            vm.forms = {};
            vm.sortBy = 'order';
            vm.colors = ['#fff', '#fffde7', '#e8f5e9', '#e1f5fe', '#fce4ec', '#ede7f6'];
            vm.showPicker = false;
            vm.settings = $rootScope.userSettings;
            vm.leadTypes = leadDataService.leadBoard.leadTypes;
            vm.contactTypes = leadDataService.leadBoard.contactTypes;
            vm.newContact = newContact;
            vm.editContact = editContact;
            vm.newLeadTask = newLeadTask;
            vm.editTask = editTask;
            vm.removeTask = removeTask;
            vm.toggleTask = toggleTask;
            vm.reminderOptions = _.memoize(reminderOptions);
            vm.hasTasks = hasTasks;
            vm.hasReminder = hasReminder;
            vm.myReminderDue = myReminderDue;
            vm.myReminder = myReminder;
            vm.checkFields = checkFields;

            vm.froalaOptions = {
                    key: $rootScope.froalaKey,
                    pluginsEnabled: [
                     "lineBreaker", "link", "lists", "paragraphFormat", "paragraphStyle","url"
                    ],
                    spellcheck: true, // does not appear to actually enable spellcheck
                    toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "strikeThrough", "|", "align", "formatOL", "formatUL", "|", "insertLink"],
                    autofocus: true,
                    attribution: false,
                    pastePlain: true,
                    placeholderText: 'What does this deal entail?',
                    charCounterMax: 8000,
                    linkAlwaysBlank: true,
                    linkAutoPrefix: 'https://',
                    linkInsertButtons: '',
                    linkText: true,
                    imageInsertButtons: ['imageUpload'],
                    imageDefaultDisplay: 'inline',
                    htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
                    pasteDeniedAttrs: ['class', 'id', 'data'],
                    pasteDeniedTags: ['iframe', 'script', 'style'],
                    // iframeDefaultStyle: 'body{position:relative;z-index:2;}pre{white-space:pre-wrap;word-wrap:break-word;}',
                    events: {
                                'froalaEditor.initialized': function () {
                                },
                                'charCounter.exceeded': function () {
                              }
                            }//events
                }//froalaOptions


            // Disable scroll to close bottomsheet?
          // Simple solution to Prevent Drag to Close bottomSheet
                      // By Hunt Nguyen
                      $element
                          .on('$md.dragstart', preventDrag)
                          .on('$md.drag', preventDrag)
                          .on('$md.dragend', preventDrag);
                      var parent = $element.parent();
                      var backdrop = parent.find('md-backdrop');
                      backdrop.on('$md.dragstart', preventDrag)
                          .on('$md.drag', preventDrag)
                          .on('$md.dragend', preventDrag);

                  function preventDrag(event) {
                      event.stopPropagation();
                      return false;
                  }


            // There are some fields that can be toggled to edit if they already have values.
            // The editing controls need to know their current state
            checkFields(vm.lead);

            // if the lead doesn't have files, it will need a file node to upload to
            if(!_.has(vm.lead.files)){
                vm.lead.files = [];
            }

            // if this is a new lead, put the cursor in the first name field
            $timeout(function(){
                if(!_.has(vm.lead, 'timeStamp')){
                    document.getElementById("focusfield").focus();
                    vm.editWebsite = true;
                    vm.editFacebook = true;
                    vm.editTwitter = true;
                    vm.editInstagram = true;
                    vm.editPinterest = true;
                    vm.editLinkedin = true;
                    vm.editEmail = true;
                } else {
                    // remove the autofocus which we sent to the field so
                    // it wasn't picking up avatar buttons on load instead
                    document.getElementById("focusfield").blur();
                }
            },500, false);


            // Watch for file uploads to change form state
            $scope.$on('uploadComplete', setDirty);
            function setDirty(){
                  vm.forms.leadForm.$setDirty();
                  // vm.updateLead(vm.lead);
            }

            function saveNewLead(lead){
                // $log.info('saveNewLead');
                var newLead = angular.copy(lead);
                return leadDataService.saveNewLead(newLead)
                .then(function(response){
                    if(response == 'success'){
                        closeSheet();
                        $timeout(function(){
                            $rootScope.$emit('leadChange');
                        },500);
                    } else {
                        alert(response + '/n Please refresh and contact support if this persists.')
                    }
                });
            }// saveNewLead

            function updateLead(lead){
                // we only want to update if the lead has been saved


                $mdUtil.debounce(function(){
                    if(_.has(lead, 'timeStamp')){
                        doUpdate(lead);
                     }
                    }, 500)();

                function doUpdate(lead){
                    $log.info('updating lead...');
                    // checkFields(lead);

                    $timeout(function(){
                        vm.updatingLead = true;
                    },0);
                    // $log.info('updateLead');
                    return leadDataService.updateLead(lead)
                    .then(function(response){
                        vm.forms.leadForm.$setPristine();
                        // closeSheet();
                        $timeout(function(){
                            $rootScope.$emit('leadChange');
                            vm.updatingLead = false;
                        },0);
                    })
                }
            }// updateLead

        	function closeSheet(){
                $mdBottomSheet.cancel();
        	}


            function getLeadTypeColor(leadID){

                if(leadID != 'new'){
                    var leadType =   _.find(vm.leadTypes, function (leadType) {
                        return leadType.uid == leadID;
                    });
                    return leadType.color;
                } else {
                    return '#999'
                }
            }// getleadTypeColor

            function getLeadTypeLabel(leadID){
                if(leadID != 'new'){
                    var leadType =   _.find(vm.leadTypes, function (leadType) {
                        return leadType.uid == leadID;
                    });
                    return leadType.label;
                } else {
                    return '#999'
                }
            }// getLeadTypeLabel

            function hasTasks(lead){
                if(_.has(lead, 'tasks')){
                    return true
                } else {
                    return false
                }
            }// hasTasks

            // There are some fields that can be toggled to edit if they already have values.
            // The editing controls need to know their current state
            function checkFields(lead){
                // $log.info('checkFields');
                doCheckfields(lead);

                // if(_.has(lead, 'timeStamp')){
                //     $log.info('doing checkFields');

                // }

                function doCheckfields(lead){
                    vm.editWebsite = false;
                    vm.editFacebook = false;
                    vm.editTwitter = false;
                    vm.editInstagram = false;
                    vm.editPinterest = false;
                    vm.editLinkedin = false;
                    vm.editEmail = false;
                    if(!_.has(lead, 'website')){
                        // make sure it's not an empty value
                        if(!lead.website){
                            vm.editWebsite = true;
                        }
                    } else if (lead.website == ''){
                        vm.editWebsite = true;
                    }
                    if(!_.has(lead, 'facebook')){
                        // make sure it's not an empty value
                        if(!lead.facebook){
                            vm.editFacebook = true;
                        }
                    } else if (lead.facebook == ''){
                        vm.editFacebook = true;
                    }

                    if(!_.has(lead, 'twitter')){
                        // make sure it's not an empty value
                        if(!lead.twitter){
                            vm.editTwitter = true;
                        }
                    } else if (lead.twitter == ''){
                        vm.editTwitter = true;
                    }

                    if(!_.has(lead, 'linkedin')){
                        // make sure it's not an empty value
                        if(!lead.linkedin){
                            vm.editLinkedin = true;
                        }
                    } else if (lead.linkedin == ''){
                        vm.editLinkedin = true;
                    }

                    if(!_.has(lead, 'instagram')){
                        // make sure it's not an empty value
                        if(!lead.instagram){
                            vm.editInstagram = true;
                        }
                    } else if (lead.instagram == ''){
                        vm.editInstagram = true;
                    }
                    if(!_.has(lead, 'pinterest')){
                        // make sure it's not an empty value
                        if(!lead.pinterest){
                            vm.editPinterest = true;
                        }
                    } else if (lead.pinterest == ''){
                        vm.editPinterest = true;
                    }
                    if(!_.has(lead, 'email')){
                        // make sure it's not an empty value
                        if(!lead.email){
                            vm.editEmail = true;
                        }
                    } else if (lead.email == ''){
                        vm.editEmail = true;
                    }
                }// doCheckfields

            }// checkFields

            function newContact(lead, type){
                return leadDataService.newContact(lead, type);
            }// newContact

            function editContact(contact){
                var lead = undefined;
                return leadDataService.editContact(contact);
            }// newContact

            function newLeadTask(lead){
                return leadDataService.newLeadTask(lead)
            }

            function editTask(task, lead){
                return leadDataService.editLeadTask(task, lead)
            }

            function removeTask(task){
                return leadDataService.deleteLeadTask(task)
            }

            function toggleTask(task){
                return leadDataService.toggleLeadTask(task);
            }

            // Drag and drop for lead Tasks
            // Field Dragging
            dragulaService.options($scope, 'drag-lead-tasks', {
                moves: function (el, container, handle) {
                        if(handle.classList.contains('drag-handle')){
                            return true
                        } else {
                            return false
                        }
                        // return !handle.classList.contains('drag-handle');
                },
                accepts: function (el, target, source, sibling) {
                   return true
                },
                invalid: function(el, handle){
                    return false
                },
                direction: 'vertical',
                revertOnSpill: true
            });


            $scope.$on('drag-lead-tasks.drop', function (event, item, target, source, sibling) {
                // Now we can do our work - prep the variables
                var itemID = item[0].attributes.catid.value,
                        thisContainer = $('.lead-tasks-container'),
                        sortItems = Array.from(thisContainer.find('.category-item'));

                // Change sort order
                _.each(sortItems, function(category, index){
                    var catID = category.attributes.catid.value;
                    // find the matching object
                    _.each(vm.lead.tasks, function(task){
                        if(task.uid === catID){
                            task.order = index + 1;
                        }
                    });
                });

                 var updates = {};
                 updates['/leadBoards/' + vm.lead.owner + '/leads/' + vm.lead.uid + '/tasks/'] = vm.lead.tasks;
                 return firebase.database().ref().update(updates)
                .then(function(){
                  return 'success'
                }, function(error){
                  return error
                });

            });// drag-lead-tasks.drop

            // function setReminder(task,event){
            //   $mdDialog.show(
            //         $mdDialog.alert()
            //           .parent(angular.element(document.querySelector('#popupContainer')))
            //           .clickOutsideToClose(true)
            //           .title('Coming Soon!')
            //           .htmlContent('<p>We are working hard on a more powerful <strong>Reminder system</strong> for Adminja.<br>We\'ll let you know when it\'s ready!</p>')
            //           .ariaLabel('Reminder Alert')
            //           .ok('Got it!')
            //           .targetEvent(event)
            //       );
            // }

            function htmlToPlaintext(text) {
              return text ? String(text).replace(/<[^>]+>/gm, '') : '';
            }

            // we use memoize here so the function isn't called to death and we don't throw
            // digest errors
            function reminderOptions(task, lead) {
                    var options = {};
                    options.description = htmlToPlaintext(task.description);
                    options.message = "Lead " + lead.firstName + ' ' + lead.lastName + ' has Todo that needs attention: '+ options.description;
                    options.type = "lead-reminder";
                    options.path = '/leadBoards/' + lead.owner + '/leads/' + task.lead + '/tasks/' + task.uid + '/reminders';
                    // options.payLoad contains info the cloud function can use
                    options.payload = {
                        taskID : task.uid,
                        leadBoard : lead.owner,
                        leadID : lead.uid
                    }

                    return options
            }

            function hasReminder(task){
                var found = false;
                if(_.has(task, 'reminders')){
                    _.each(task.reminders, function(reminder){
                        if(reminder.owner == $rootScope.userID && reminder.status != 'closed'){
                            found = true;
                        }
                    });
                }
                if(found){
                    return true;
                }
            }// hasReminder

            function myReminderDue(task){
               var foundReminder = myReminder(task);
               if(foundReminder){
                    return moment(foundReminder.when).format(vm.settings.amDateFormat);
               }
            }// hasReminder

            function myReminder(task){
                var found = false,
                    thisReminder = undefined;
                if(_.has(task, 'reminders')){
                    _.each(task.reminders, function(reminder){
                        if(reminder.owner == $rootScope.userID){
                            found = true;
                            thisReminder = reminder;
                        }
                    });
                    if(found){
                        return thisReminder
                    }
                }// if has reminders
            }// thisReminder

        }//leadBottomSheetController
        })();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('contactDialogController', contactDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// contactDialogController

        /* @ngInject */
        function contactDialogController($scope,  hotkeys, $mdDialog, $timeout, $log, $mdToast, $rootScope, leadDataService) {
            $log.info('contact dialog Controller');

            var vm = this;
            vm.cancelDialog = cancelDialog;
            vm.init = init;
            vm.settings = $rootScope.userSettings;
            vm.saveNewContact = saveNewContact;
            vm.updateContact = updateContact;
            vm.stageColor = stageColor;
            vm.setType = setType;
            vm.forms = {};
            vm.setReminder = setReminder;

            vm.froalaOptions = {
                    key: $rootScope.froalaKey,
                    pluginsEnabled: [
                    "align", "charCounter", "codeBeautifier", "codeView", "colors", "draggable",  "emoticons", "entities",  "fontSize",
                    // "file", "image", "imageTUI", "imageManager",
                     "lineBreaker", "link", "lists", "paragraphFormat", "paragraphStyle", "quickInsert", "quote",  "url", "wordPaste"
                    ],
                    spellcheck: true, // does not appear to actually enable spellcheck
                    toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "strikeThrough" ,"textColor", "|", "align", "formatOL", "formatUL", "indent", "outdent", "|", "insertLink", "emoticons", "insertHR", "|", "html"],
                    autofocus: true,
                    attribution: false,
                    pastePlain: true,
                    charCounterMax: 8000,
                    linkAlwaysBlank: true,
                    linkAutoPrefix: 'https://',
                    linkInsertButtons: '',
                    linkText: true,
                    imageInsertButtons: ['imageUpload'],
                    imageDefaultDisplay: 'inline',
                    htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
                    pasteDeniedAttrs: ['class', 'id', 'data'],
                    pasteDeniedTags: ['iframe', 'script', 'style'],
                    // iframeDefaultStyle: 'body{position:relative;z-index:2;}pre{white-space:pre-wrap;word-wrap:break-word;}',
                   events: {
                               'froalaEditor.initialized': function () {
                               },
                               'charCounter.exceeded': function () {
                               }
                           }//events
                }//froalaOptions


            // if a lead was passed, set it to the selected lead for this contact
            if(vm.lead){
                // lead was passed to contact. Create contact with proper vars.
                vm.contact = {};
                vm.contact.lead = vm.lead.uid;
                vm.contact.files = [];
                vm.contact.leadBoard = vm.lead.owner;
                vm.contact.owner = $rootScope.userID;
                if(vm.type){
                    // if a type was passed, preselect it
                    vm.contact.type = vm.type;
                    setType();
                }
            } else if (vm.contact) {
                // We are editing a contact
                if(!_.has(vm.contact, 'files')){
                    vm.contact.files = [];
                }
                    setType();
                    // we are passing a lead to be edited.

            } else {
                vm.contact = {};
                vm.contact.leadBoard = $rootScope.userID;
                vm.contact.owner = $rootScope.userID;
                vm.contact.files = [];
            }



            // Load our Leads Board
            vm.init();


            function init(){
                return leadDataService.getLeadBoard(leadDataService.activeAccount)
                .then(function(leadboard){
                  vm.leadBoard = leadDataService.leadBoard;
                  vm.contactTypes = vm.leadBoard.contactTypes;
                  vm.leads = vm.leadBoard.leads;
                });
            }// init



            function setType(type){
                $log.info('setType - type changed!');
                vm.showContactForm = true;

                $timeout(function() {
                    var field = angular.element('text-angular[name=description-editor]').find('*[id*=taText]');
                    if(field){
                        field.focus()
                    }
                },2000);
            }

            function saveNewContact(contact){
                return leadDataService.saveNewContact(contact)
                .then(function(){
                    $mdDialog.cancel();
                });
            }

            function updateContact(contact){
                return leadDataService.updateContact(contact)
                .then(function(){
                    $mdDialog.cancel();
                });
            }

            function stageColor(typeID){
                var color = undefined;
                _.each(vm.leadTypes, function(type){
                    if(type.uid == typeID){
                        color = type.color
                    }
                });
                return color
            }

            function cancelDialog(){
                $mdDialog.cancel();
            }

            function setReminder(task,event){
                    $mdDialog.show(
                          $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Coming Soon!')
                            .textContent('We are working hard on a new Reminder system for Adminja. We\'ll let you know when it\'s ready!')
                            .ariaLabel('Reminder Alert')
                            .ok('Got it!')
                            .targetEvent(event)
                        );
                  }

        } // end contactDialogController

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('messagingService', messagingService);

    /* @ngInject */
    function messagingService($log, $mdMedia, $mdDialog, $mdToast, userDataService, $rootScope,$timeout, $firebaseArray, $firebaseObject, $window) {

        // Make sure messaging is supported by browser or skip entirely
        if (firebase.messaging.isSupported()){
         // Retrieve Firebase Messaging object.
          var messaging = firebase.messaging();

        } else {
          console.log("messaging not supported in this browser. Disabling")
          return
        }

        var userRef = undefined;
        var service = {
            init: init,
            storeToken: storeToken,
            refreshToken: refreshToken,
            requestPermission: requestPermission
        };

        return service;

        //

        // Initialize service.timerData object
        function init(){
          // we disable messaging on registration page so we don't accidentally create a firebase record for the user until registration complete
          if(!$rootScope.disableMessaging){
            // $log.info('Messaging Enabled!');
            // $log.info('messagingService Initializing');
            userRef = firebase.database().ref('users/');
             // Get Instance ID token. Initially this makes a network call, once retrieved
              // subsequent calls to getToken will return from cache.
              return messaging.getToken()
              .then(function(currentToken) {
                // $log.info('We have a token:' + currentToken);
                if (currentToken) {
                  // $log.info('token success');
                  // $log.info('storing for user:' + $rootScope.userID);
                  // store the token on the user so any notifications we send will go to the right place
                    service.storeToken(currentToken, $rootScope.userID);
                    return
                } else {
                  // Show permission request.
                  console.log('No Instance ID token available. Request permission to generate one.');
                  // Show permission UI.
                  // updateUIForPushPermissionRequired();
                  // setTokenSentToServer(false);
                  // if(userDataService.getUser().limits.hasNotifications){
                  //   requestPermission();
                  // }
                  requestPermission();
                  return
                }
              })
              .catch(function(err) {
                console.log('An error occurred while retrieving messsaging token. ', err);
                // showToken('Error retrieving Instance ID token. ', err);
                // setTokenSentToServer(false);
              });
          } else {
            $log.info('Messaging Disabled');
          }// if no disableMessaging
        }// messagingService.init

        function storeToken(token, userID){
          // $log.info('storeToken');
          // $log.info(token, userID);
          return userRef.child(userID).child('deviceID').set(token)
          .then(function(res){
            // $log.info('Response:', res);
          });
        }

        function requestPermission(){
          $log.info('requesting permission to notify');
          userDataService.trackEvent('request-notification-permission');
            Notification.requestPermission()
               .then(function(result) {
                if(result.code != 'messaging/notifications-blocked'){
                 $log.info('Notification permission granted.')
                 $mdToast.show($mdToast.adminjaAlert(
                     {
                         locals:{
                             title: 'Notifications Enabled!',
                             message: '',
                             color: '#fff'
                         }
                     }));
                 // re-init service to get and store the devices new token
                 //heap.track('Enabled Notifications');
                 userDataService.trackEvent('enable-notifications');

                 service.init();
               } else {
                //heap.track('Disabled Notifications');
                userDataService.trackEvent('disable-notifications');
               }// if permission granted
               })
               .catch(function(err) {
                 $log.error('Unable to get permission to notify. ', err)
               });
        }// requestPermission

        function refreshToken(){
          messaging.getToken()
          .then(function(refreshedToken) {
            console.log('Token refreshed.');
            service.storeToken(refreshedToken);
          })
          .catch(function(err) {
            $log.error('Unable to retrieve refreshed token ', err);
            // showToken('Unable to retrieve refreshed token ', err);
          });
        }




    } // end messagingService
})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('kanbanService', kanbanService);

    /* @ngInject */
    function kanbanService($log, $http, $rootScope, $timeout, $filter, teamDataService, clientDataService, taskDataService, timerDataService) {
        var service = {
            newTaskElement: newTaskElement,
            newTaskListElement: newTaskListElement,
            newDetailElement: newDetailElement,
            newDetailListElement: newDetailListElement,
            setupHandlebars: setupHandlebars,
            setAllTaskView: setAllTaskView,
            init: init,
            allTasksView: 'all'

        };

        return service;


        function init(){
          return new Promise(function(resolve, reject){
               return setupHandlebars()
               .then(function(){
                    return resolve(true);
               });
          })

        }

        function setAllTaskView(view){
          service.allTasksView = view;
        }//setAllTaskView

        function newDetailListElement(listData, boardSettings, userRole){
            // $log.info('newDetailListElement');
            if((userRole == 'client' && listData.clientEnabled) || userRole != 'client'){
                  var columnHTML = '' +
                    '<div class="board-column board-column-tasks list-type-' + listData.type;

                    columnHTML = columnHTML + '" data-id="'+listData.uid+'" data-order="'+listData.order+'" data-type="'+listData.type+'"';

                    if(listData.type == 'client-info'){
                         columnHTML = columnHTML + ' style="margin-left: 10px;" '
                    }


                    columnHTML = columnHTML + '>' +
                      '<div class="board-column-container">' +
                         '<div class="board-column-header drag-handle" style="background-color: '+listData.color+';">' +
                            '<div class="board-column-title">';

                            columnHTML = columnHTML + listData.label + '</div>'+
                            '<div class="board-column-controls">';

                              columnHTML = columnHTML + '<i class="adminja-icon-button detail-list-menu-button zmdi zmdi-plus"></i>'

                              columnHTML = columnHTML + '<i class="adminja-icon-button board-column-menu zmdi zmdi-more-vert"></i>';

                           columnHTML = columnHTML +  '</div>'+
                          '</div>'+
                          '<div class="board-column-content-wrapper small-scrollbar">'+
                              '<div class="board-column-content" data-id="'+listData.uid+'" data-type="'+listData.type+'" >';
                                 // add the items
                                 _.each(listData.items, function(item){
                                           if (_.has(item, 'uid')){
                                                  // only generate task if userRole allows it
                                                  if(!item.private || (item.private && userRole != 'client' && userRole != 'member')){
                                                        columnHTML = columnHTML + newDetailElement(item, boardSettings);
                                                  }
                                             }
                                  });

                                 columnHTML = columnHTML +'</div>' +
                          '</div>' +
                      '</div>' +
                    '</div>'

                    return columnHTML
               }// if not a client, or if a client and this list is enabled.
        }//newDetailListElement

        function newDetailElement(item, boardSettings){
            // we are using static data until we write script to migrate existing task boards to murri boards
               if(_.has(item, 'uid')){
                        // prepare the data

                        // Convert dates to display format
                        var displayDateShortFormat = 'MMM DD',
                            displayDateLongFormat = 'MMM DD, YYYY';

                        if($rootScope.userSettings.dateFormat == 'eu'){
                             displayDateShortFormat = 'DD MMM';
                             displayDateLongFormat = 'DD MMM, YYYY';
                        }

                        if(_.has(item, 'dob')){
                              item.displayDOB = moment(item.dob).format(displayDateLongFormat);
                        }



                        if(item.type == 'client-card'){

                              _.each(clientDataService.clients, function(client){
                                   if(client.uid == item.client){
                                        // apply all non-object client properties to item
                                       for (var property in client.profile) {
                                             if (typeof client.profile[property] != 'object'){
                                                  item[property] = client.profile[property]
                                             }
                                       }// recurse client.profile properties

                                       // tack on Address objects
                                       if(_.has(client.profile, 'address')){
                                             item.address = client.profile.address;
                                       }

                                       if(_.has(client.profile, 'companyAddress')){
                                             $log.info('has companyAddress');
                                             item.companyAddress = client.profile.companyAddress;
                                       }

                                       if(_.has(item, 'startDate')){
                                             item.displayStartDate = moment(item.startDate).format(displayDateLongFormat);
                                       }

                                       // bryan was dumb and we store client birthdays in a different format
                                       // convert for display in card
                                       if(_.has(client.profile, 'birthday')){
                                             var year = moment().format('YYYY');
                                             if(_.has(client.profile.birthday, 'year')){
                                                  year = client.profile.birthday.year;
                                             }
                                             var birthDay = moment(year + '-' + client.profile.birthday.month + '-' + client.profile.birthday.day).toISOString();
                                             item.displayDOB = moment(birthDay).format('MMM DD');
                                             if(_.has(client.profile.birthday, 'year')){
                                                  if(client.profile.birthday.year != ''){
                                                       item.displayDOB = moment(birthDay).format('MMM DD, YYYY');
                                                  }
                                             }
                                       }
                                       // if there's a 'type' property on the client, it overwrites the item type.
                                       // let's fix that
                                       item.type = 'client-card'
                                   }// if client found
                              });// each client

                        }

                        if(item.type == 'url'){
                         if(!_.has(item, 'label') || item.label == ''){
                              item.label = item.url;
                         }
                        }



                        var hbData = {
                            item: item,
                            settings: boardSettings
                        }
                    return service.detailTemplate(hbData);
               }// if item is valid
        }//newDetailElement

        function newTaskListElement(listData, boardSettings, userRole){
          if((userRole == 'client' && listData.clientEnabled) || userRole != 'client'){

                 // $log.info('newTaskListElement');
                  var columnHTML = '' +
                    '<div class="board-column board-column-tasks'
                    if(listData.type == 'closed'){
                         columnHTML = columnHTML + ' drag-disabled'
                    }

                    columnHTML = columnHTML + '" data-id="'+listData.uid+'" data-order="'+listData.order+'" data-type="'+listData.type+'"';

                    if(listData.type == 'new'){
                         columnHTML = columnHTML + ' style="margin-left: 10px;" '
                    }
                    if(listData.type == 'closed'){
                         columnHTML = columnHTML + ' style="margin-right: 10px;" '
                    }

                    columnHTML = columnHTML + '>' +
                      '<div class="board-column-container">' +
                         '<div class="board-column-header" style="background-color: '+listData.color+';">';


                          columnHTML = columnHTML + '<div class="board-column-title drag-handle">';
                          //all tasks includes client avatar
                          if(boardSettings.excludeClosed){
                            var avatar = '/assets/images/avatars/generic-person-avatar.png';
                            if(_.has(listData, 'avatar')){
                                 if(listData.avatar){
                                      avatar = listData.avatar
                                 }
                            }
                            columnHTML = columnHTML + '<a href="/#/workspaces/' + listData.uid + '"> <img src="' + avatar + '" class="avatar" ui-sref=""/></a>'
                          }

                            columnHTML = columnHTML + listData.label + '</div>'+
                            '<div class="board-column-controls">';

                            if(listData.type != 'closed'){
                              columnHTML = columnHTML + '<i class="adminja-icon-button board-column-quick-task zmdi zmdi-plus"></i>' +
                              '<i class="adminja-icon-button board-column-menu zmdi zmdi-more-vert"></i>';
                            } else  {
                              columnHTML = columnHTML + '<i class="adminja-icon-button board-column-archive-closed zmdi zmdi-archive"></i>';
                            }


                           columnHTML = columnHTML +  '</div>'+
                          '</div>'+
                          '<div class="board-column-content-wrapper small-scrollbar">'+
                              '<div class="board-column-content" data-id="'+listData.uid+'" data-type="'+listData.type+'" >';
                                 // add the items
                                 _.each(listData.items, function(item){
                                   // excludeClosed is used for allTasks which might have today filters
                                   if(boardSettings.excludeClosed){
                                        if(item.status == 'open'){
                                             var pass = true;

                                             if(service.allTasksView == 'today'){
                                                  if(_.has(item, 'duedate')){
                                                       // if it's not due, shouldn't include
                                                       if(moment(item.duedate).toISOString() > moment().endOf('day').toISOString()){
                                                            pass = false;
                                                       }
                                                  } else {
                                                       if(!_.has(item, 'priority')){
                                                            pass = false;
                                                       }
                                                  }
                                             }// if filtering just today

                                             if(pass && !item.private || (item.private && userRole != 'client' && userRole != 'member')){
                                                   columnHTML = columnHTML + newTaskElement(item, boardSettings, userRole);
                                             }
                                         }

                                   } else if (_.has(item, 'uid')){
                                        // only generate task if userRole allows it
                                        if(!item.private || (item.private && userRole != 'client' && userRole != 'member')){
                                              columnHTML = columnHTML + newTaskElement(item, boardSettings, userRole);
                                        }
                                   }
                                  });

                                 columnHTML = columnHTML +'</div>' +
                          '</div>' +
                      '</div>' +
                    '</div>'

                    return columnHTML
               }// if not a client OR is a client and this list is enabled
        }//newTaskListElement


        function newTaskElement(item, boardSettings, userRole){
            // we are using static data until we write script to migrate existing task boards to murri boards
               if(_.has(item, 'uid')){
                        // prepare the data
                        // split the description into title and description
                       if(item.description){
                            var  displayTitle = item.description.split('\n')[0], restLinesText,
                                 displayDescription = item.description.split('\n');
                            // remove one line, starting at the first position
                            displayDescription.splice(0, 1);
                            // join the array back into a single string
                            displayDescription = displayDescription.join('\n');
                             item.displayTitle = displayTitle;
                             if(_.has(item, 'refID')){
                              if(item.uid != item.refID){
                                   $log.info(item.uid + ' != ' + item.refID);
                                   if(!boardSettings.excludeClosed){
                                        item.errorMessage = "This task did not migrate properly. Click here to fix.";
                                   } else {
                                        item.errorMessage = "This task did not migrate properly. Visit the workspace to fix it.";
                                   }
                              }// uid & refID don't match
                             }// has refID

                             item.displayDescription = displayDescription;
                       }

                        item.clientColor = clientDataService.clientColor(item.client);
                        item.clientName = clientDataService.clientName(item.client);
                        var assignee = undefined, assigneeColor = '#999';
                        if(item.assignee){
                            assignee = item.assignee;
                        } else {
                            assignee = item.owner;
                        }
                        _.each(teamDataService.teamList, function(member){
                            if(member.uid == assignee){
                                 assigneeColor = member.color;
                                 // find index of 1st space
                                 // splice index + 2 + '.'
                                 var splitName = member.fullName.split(" "),
                                     firstName = splitName[0],
                                     lastInit = splitName[1].substring(0, 1);
                                 item.assigneeName = firstName + ' ' + lastInit + '.';
                            }
                        });

                        item.assigneeColor = assigneeColor;


                        if(item.files){
                            item.numFiles = _.size(item.files);
                            _.each(item.files, function(file){
                              var fileNameParts = file.fileName.split('.');
                              file.extension = fileNameParts[1];
                              file.type = 'file';
                              if(file.extension == 'gif' || file.extension == 'png' || file.extension == 'jpg' || file.extension == 'heic'){
                                   file.type = 'image';
                              }
                            })
                        };

                        var numNotes = 0;
                        if(_.has(item, 'numnotes')){
                            if(item.numnotes > 0){
                                 numNotes = item.numnotes;
                            }
                        }
                        item.numNotes = numNotes;

                        if(item.checklist){
                            item.numSubtasks = _.size(item.checklist);
                            var count = 0;
                            _.each(item.checklist, function(item){
                                 if(item.complete){
                                      count ++
                                 }
                            });
                            item.totalSubtasks = count;
                        }

                        if(item.duedate){
                            if($rootScope.userSettings.dateFormat == 'eu'){
                                 item.displayDueDate = moment(item.duedate).format('DD MMM');
                            } else {
                                 item.displayDueDate = moment(item.duedate).format('MMM DD');
                            }
                            var now = moment(),
                                due = moment(item.duedate),
                                timeUntil = now.diff(due, 'hours');

                            item.dueStatus = 'none';
                            if(timeUntil > -48 && timeUntil < 0){
                                 item.dueStatus = 'orange';
                            }
                            if(timeUntil >= 0){
                                 item.dueStatus = 'red'
                            }

                        }

                        if(item.logged){
                            item.displayLogged = HandM(item.logged);
                        } else {
                            item.displayLogged = HandM(0);
                        }

                        if(item.budget){
                            item.displayBudget = HandM(item.budget);
                            item.budgetProgress = Number(item.logged/item.budget).toFixed(2) * 100;
                            if(item.budgetProgress <= 70){
                                 item.budgetStatus = 'green';
                            }
                            if(item.budgetProgress > 70 && item.budgetProgress < 90){
                                 item.budgetStatus = 'orange';
                            }

                            if(item.budgetProgress > 60 && item.budgetProgress > 90){
                                 item.budgetStatus = 'red';
                            }
                        }


                        // check to see if task has a timer for this user and add the timer's status
                        _.each(timerDataService.timerData.timers, function(timer){
                                  if (_.has(timer, 'task')){
                                      if(timer.task.uid == item.uid){
                                          item.timerID = timer.uid;
                                          item.timerActive = timer.on;
                                      }
                                  }
                              });// each timer

                        boardSettings.showTimer = true;
                        if(userRole == 'client'){
                              boardSettings.showTimer = false;
                        }

                        var hbData = {
                            item: item,
                            settings: boardSettings
                        }

                    return service.taskTemplate(hbData);
               }// if item is valid
        }//newTaskElement

        function setupHandlebars(){
          return new Promise(function(resolve, reject){
               return setupTaskTemplate()
               .then(function(){
                    setupDetailTemplate()
                    .then(function(){
                         setupClientTemplate()
                         .then(function(){
                              return resolve(true)
                         })
                         .catch(function(error){
                              return reject(error)
                         })
                    })
               })
          })

        }//setupHandlebars

        function setupTaskTemplate(){
          return new Promise(function(resolve, reject){
               // fetch and compile our task card template for later use
               var templateRef = firebase.app().storage("gs://"+ fbConfig.templateBucket).ref("/task-card.html");
               templateRef.getDownloadURL().then(function(url) {
                  $http({
                         method: 'GET',
                         url: url
                     }).success(function (file, status, headers) {
                         service.taskTemplate = Handlebars.compile(file);
                         return resolve(true)
                     }).error(function (data) {
                         $log.error('Task template Error!');
                         $log.error(data.error.message);
                         alert('We had a problem downloading all of Adminja\'s templates. Please refresh your browser.\n' + data.error.message)
                         return reject(data.error.message)
                     });
               });

          })
        }//setupTaskTemplate

        function setupClientTemplate(){
          return new Promise(function(resolve, reject){
               // fetch and compile our task card template for later use
               var templateRef = firebase.app().storage("gs://"+ fbConfig.templateBucket).ref("/client-card.html");
               templateRef.getDownloadURL().then(function(url) {
                  $http({
                         method: 'GET',
                         url: url
                     }).success(function (file, status, headers) {
                         service.clientTemplate = Handlebars.compile(file);
                         return resolve(true)
                     }).error(function (data) {
                         $log.error('Detail template Error!');
                         $log.error(data.error.message);
                         alert('We had a problem downloading all of Adminja\'s templates. Please refresh your browser.\n' + data.error.message)
                         return reject(data.error.message)
                     });
               });

          })
        }//setupClientTemplate

        function setupDetailTemplate(){
          return new Promise(function(resolve, reject){
               // fetch and compile our task card template for later use
               var templateRef = firebase.app().storage("gs://"+ fbConfig.templateBucket).ref("/detail-card.html");
               templateRef.getDownloadURL().then(function(url) {
                  $http({
                         method: 'GET',
                         url: url
                     }).success(function (file, status, headers) {
                         service.detailTemplate = Handlebars.compile(file);
                         return resolve(true)
                     }).error(function (data) {
                         $log.error('Detail template Error!');
                         $log.error(data.error.message);
                         alert('We had a problem downloading all of Adminja\'s templates. Please refresh your browser.\n' + data.error.message)
                         return reject(data.error.message)
                     });
               });

          })
        }//setupTaskTemplate

        function HandM(minutes){

               if($rootScope.userSettings.timeFormat){
                 var total = minutes/60;
                 return Number(total).toFixed(2);
               } else {

                // if it's minutes-based
                var isNegative = false;
                if (minutes < 0){
                  isNegative = true;
                }
                // convert to an integer so we aren't doing a floor/ceiling dance
                minutes = Math.abs(minutes);

                var hours = Math.floor( minutes / 60);
                hours = _.toString(hours);
                // we don't pad our hours. They may go into 3 digits for some users.
                var minutes = Math.round(minutes % 60);
                minutes = _.toString(minutes);
                minutes = _.padStart(minutes, 2, '0');

                // set our return object
                var duration = hours;

                // if we have minutes, add them. Otherwise, 00
                 if (minutes){
                  duration = duration + ':' + minutes;
                 } else {
                  duration = duration + ':' + '00';
                 }

                 // if it was a negative minutes, prepend it
                 if (isNegative){
                  duration = '-' + duration;
                 }

                 // if(minutes < 60){
                 //  duration = duration + ' min'
                 // } else {
                 //  duration = duration + ' hrs'
                 // }
                 return duration

          }
        }// HandM

    } // end kanbanService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('paymentDialogController', paymentDialogController);

///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// paymentDialogController

/* @ngInject */
function paymentDialogController($log,  $mdDialog, $mdToast,  $timeout,  $rootScope,  $scope, invoiceService, userDataService) {
    // $log.info('paymentDialogController');
    var vm = this;
    vm.user = userDataService.user,
    vm.settings = $rootScope.userSettings;
    vm.currency = "$";
    vm.saving = false;
    if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
     }
    vm.newPayment = {};
    vm.newPayment.date = new Date();

    // if we are editing a payment, we've passed it the 'payment' object. Use that.
    if(vm.payment){
      // make a copy of original for our edits - will be used when updating to remove original amount and apply new amount
      vm.newPayment = angular.fromJson(angular.toJson(vm.payment))
    }


    vm.cancel = function(){
      $mdDialog.cancel();
    }

    vm.updatePayment = function(original, updated){
      $timeout(function(){
        vm.saving = true;
      })
      updated.amount = Number(updated.amount).toFixed(2);
      return invoiceService.updatePayment(original, updated)
      .then(function(){

           userDataService.trackEvent('payment-updates');

           $rootScope.$emit('paymentUpdated');
           $timeout(function(){
             vm.saving = false;
           })
           $mdDialog.cancel();
      })
      .catch(function(error){
        $log.info('Problem updating payment ' + updated.uid);
        $timeout(function(){
          vm.saving = false;
        })
        return error
      })
    };

    vm.saveNewPayment = function(payment, invoice){
      $timeout(function(){
        vm.saving = true;
      })
        var dateFormat = 'MMM DD';
        if(invoice.info.dateFormat == 'eu'){
          dateFormat = 'DD MMM'
        }
        payment.dateFormat = dateFormat;
        payment.amount = Number(payment.amount).toFixed(2);
        return invoiceService.saveNewPayment(payment, invoice)
        .then(function(){
             userDataService.trackEvent('payment-applied');
             $rootScope.$emit('paymentApplied');
             $mdDialog.cancel();
        })
    };



}

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('invoiceService', invoiceService)
            .controller('emailInvoiceDialogController', emailInvoiceDialogController);

    /* @ngInject */
    function invoiceService($log, moment, $http, taskDataService,
                userDataService, clientDataService, timeDataService, scheduleDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject, $firebaseStorage) {


        var service = {
            init: init,
            newInvoice: newInvoice,
            saveInvoice: saveInvoice,
            updateInvoice: updateInvoice,
            deleteInvoice: deleteInvoice,
            lockTimeEntries: lockTimeEntries,
            lockLineItems: lockLineItems,
            selectInvoice: selectInvoice,
            unlockTimeEntries: unlockTimeEntries,
            unlockLineItems: unlockLineItems,
            calcInvoice: calcInvoice,
            preparePDF: preparePDF,
            createPDF: createPDF,
            getLastInvoice: getLastInvoice,
            mailInvoiceDialog: mailInvoiceDialog,
            getClientInvoices: getClientInvoices,
            getInvoiceHTML : getInvoiceHTML,
            newPayment:newPayment,
            saveNewPayment: saveNewPayment,
            changeInvoiceMode: changeInvoiceMode,
            selectedClient: undefined,
            selectClient: selectClient,
            invoiceMode: 'none',
            newPackageInvoice: newPackageInvoice,
            addToInvoice: addToInvoice,
            removeTimeEntry: removeTimeEntry,
            removeChargeEntry: removeChargeEntry,
            updatePackageInvoice: updatePackageInvoice,
            deletePackageInvoice: deletePackageInvoice,
            reGroupTime: reGroupTime,
            tabulateInvoice: tabulateInvoice,
            changeInvoiceGrouping: changeInvoiceGrouping,
            setupHandlebars: setupHandlebars,
            editPayment: editPayment,
            updatePayment: updatePayment,
            removePayment: removePayment,
            emailInvoice: emailInvoice,
            invoiceSaving: false,
            invoiceError: false
        };

        return service;

        var userID = undefined;

        // Initialize service.timerData object
        function init(client){
          return new Promise(function(resolve, reject){
            $log.info('invoiceService.init');
              var user = firebase.auth().currentUser;
              if (user){
                userID = user.uid;
                // clear our selected Period
                delete service.selectedInvoice;
                delete service.lastInvoiceNumber;
                delete service.selectedClient;
                getLastInvoice(client);
                return resolve(true)
              }   else {
                return resolve(true)
              }
          })

        }

      service.lastInvoiceNumber = {};

      function emailInvoice(invoice, recipients){
        invoice = angular.fromJson(angular.toJson(invoice));
        return new Promise(function(resolve, reject){
          var invoicing = firebase.functions().httpsCallable('invoicing'),
              request = {
                invoice: invoice,
                recipients: recipients,
                action: 'emailInvoice'
              }
          return invoicing(request)
          .then(function(invoice){
            userDataService.trackEvent('email-invoice');
            return resolve(invoice)
          })
          .catch(function(error){
            return reject(error)
          })
        })
      }//


      function newPackageInvoice(userID, clientID, date){
        return new Promise(function(resolve, reject){
          var invoicing = firebase.functions().httpsCallable('invoicing'),
              request = {
                userID: userID,
                clientID: clientID,
                date: moment(date).toISOString(),
                action: 'new'
              }
          return invoicing(request)
          .then(function(invoice){
            return resolve(invoice)
          })
          .catch(function(error){
            return reject(error)
          })
        })
      }//newPackageInvoice





      function addToInvoice(invoice, time, charges){
        $log.info('service/addToInvoice');
        invoice = angular.fromJson(angular.toJson(invoice));
        time = angular.fromJson(angular.toJson(time));
        charges = angular.fromJson(angular.toJson(charges));
        return new Promise(function(resolve, reject){
          var invoicing = firebase.functions().httpsCallable('invoicing'),
              request = {
                invoice: invoice,
                time: time,
                charges: charges,
                action: 'addToInvoice'
              }
          var isNew = true;
          if(_.has(invoice, 'timeStamp')){
            isNew = false;
          }
          return invoicing(request)
          .then(function(response){
            var updatedInvoice = response.data
            service.lastInvoiceNumber = updatedInvoice.info.number;
            // if isNew, we need to get our recently saved invoice into a $firebaseObject for
            // error-free 2-way syncing.

            userDataService.trackEvent('add-items-to-invoice');

            if(isNew){
                // select the invoice for further editing
                return selectInvoice(updatedInvoice.uid)
                .then(function(invoice){
                  return resolve('Invoice ' + updatedInvoice.info.number + ' Updated')
                })
            } else {
               return resolve('Invoice ' + updatedInvoice.info.number + ' Updated');
            }
          })
          .catch(function(error){
            console.error('Unable to update Invoice ' + invoice.uid)
            console.error(error);
            service.invoiceError = true;
            return reject(error)
          })

        })

      }//addToInvoice




      function reGroupTime(invoice){
        return new Promise(function(resolve, reject){
          if(_.size(invoice.time) > 0){
            invoice.timeGroups = {};
            if(invoice.grouping == 'none'){
              invoice.timeGroups['time'] = {
                label: 'Time',
                time: {},
                id: 'time',
                total: 0,
                quantity: 0
              };
              _.each(invoice.time, function(entry){
                if(_.has(entry, 'total')){
                  invoice.timeGroups['time'].time[entry.uid] = entry;
                  invoice.timeGroups['time'].total = (Number(invoice.timeGroups['time'].total) + Number(entry.total)).toFixed(2);
                  invoice.timeGroups['time'].quantity = (Number(invoice.timeGroups['time'].quantity) + Number(entry.logged));
                }
              })
              return resolve(invoice);
            }  else {
              var groupByNode = undefined, groupByLabel = undefined;
              if(invoice.grouping == 'category'){
                groupByNode = 'rateLabel';
                groupByLabel = 'rateLabel'
              }

              if(invoice.grouping == 'package'){
                groupByNode = 'packageID';
                groupByLabel = 'packageLabel'
              }

              if(invoice.grouping == 'task'){
                groupByNode = 'task';
                groupByLabel = 'taskName';
              }

              if(invoice.grouping == 'member'){
                groupByNode = 'creator';
                groupByLabel = 'creatorName';
              }

              _.each(invoice.time, function(entry){
                if(_.has(entry, 'total')){
                  var node = entry[groupByNode];

                  // it's possible the entry doesn't have the node we are grouping by
                  // those entries should go in a "No <NodeName>" group.

                  if(node){
                    var thisNode = entry[groupByNode],
                        thisLabel = entry[groupByLabel]
                  } else {
                    var thisNode = 'no'+groupByNode,
                    thisLabel = 'No ' + groupByNode
                  }

                  if(!_.has(invoice.timeGroups, node)){
                    invoice.timeGroups[node] = {
                        label: thisLabel,
                        id: thisNode,
                        quantity: 0,
                        total: 0,
                        time: {},
                        type: groupByNode
                    }
                  }

                  invoice.timeGroups[node].time[entry.uid] = entry;
                  invoice.timeGroups[node].total = (Number(invoice.timeGroups[node].total) + Number(entry.total)).toFixed(2);
                  invoice.timeGroups[node].quantity = (Number(invoice.timeGroups[node].quantity) + Number(entry.logged));

                }
              });
             return resolve(invoice);
            }// if grouping option not 'none'
          } else {
            return resolve(invoice)
          }

        })

      }

      function tabulateInvoice(invoice){
        return new Promise(function(resolve, reject){
          var subTotal = 0, total = 0, taxes = 0, paid = 0;
          invoice.info.chargesTotal = 0;
          invoice.info.timeTotal = 0;
          if(_.has(invoice, 'time')){
            _.each(invoice.time, function(entry){
              if(entry.packageType == 'hourly'){
                var accrued = (entry.logged/60) * entry.rate;
                entry.total = accrued.toFixed(2);
                invoice.info.timeTotal = (Number(invoice.info.timeTotal) + Number(entry.total)).toFixed(2);
                subTotal = subTotal + accrued;
              }
            });
          }// time loop

          if(_.has(invoice, 'lineItems')){
            _.each(invoice.lineItems, function(item){
                var accrued = Number(item.quantity) * Number(item.amount);
                item.total = accrued.toFixed(2);
                invoice.info.chargesTotal = (Number(invoice.info.chargesTotal) + Number(item.total)).toFixed(2);
                subTotal = Number(subTotal) + Number(accrued);
            });
          }// charge loop


          if(_.has(invoice, 'payments')){
            _.each(invoice.payments, function(item){
                paid = paid + item.amount;
            });
            invoice.totalPayments = Number(paid).toFixed(2);
          }// charge loop

          if(invoice.info.calculateTax){

            var taxPercentage = Number(invoice.info.taxPercentage)/100;
            taxes = Number(subTotal) * taxPercentage;
            invoice.info.taxedAmount = Number(taxes).toFixed(2);
          }
          subTotal = subTotal.toFixed(2);
          total = Number(subTotal) + Number(taxes);
          total = total.toFixed(2);
          invoice.info.subTotal = subTotal;
          invoice.info.total = total;
          invoice.info.balance = Number(invoice.info.total - paid).toFixed(2);
          invoice.info.totalPayments = Number(paid).toFixed(2);
          return resolve(invoice)
        })

      }// tabulateInvoice


      function changeInvoiceGrouping(invoice){
        invoice = angular.fromJson(angular.toJson(invoice));
        return new Promise(function(resolve, reject){
           var invoicing = firebase.functions().httpsCallable('invoicing'),
               request = {
                 invoice: invoice,
                 action: 'changeInvoiceGrouping'
               }
           return invoicing(request)
           .then(function(response){
            userDataService.trackEvent('change-invoice-grouping');
             var updatedInvoice = response.data;
             return resolve(updatedInvoice);
           })
           .catch(function(error){
             console.error('Unable to update Invoice ' + invoice.uid)
             console.error(error);

             service.invoiceError = true;
             return reject(error)
           })
        })
      }// changeInvoiceGrouping

      function removeTimeEntry(invoice, entryID){
        invoice = angular.fromJson(angular.toJson(invoice));
        return new Promise(function(resolve, reject){
          delete invoice.time[entryID]
          var invoicing = firebase.functions().httpsCallable('invoicing'),
              request = {
                invoice: invoice,
                entryID: entryID,
                action: 'removeTimeEntry'
              }
          return invoicing(request)
          .then(function(response){
            var updatedInvoice = response.data;
            userDataService.trackEvent('remove-time-from-invoice');
            return resolve(updatedInvoice);
          })
          .catch(function(error){
            console.error('Unable to update Invoice ' + invoice.uid)
            console.error(error);

            service.invoiceError = true;
            return reject(error)
          })
        })
      }//removeTimeEntry

      function removeChargeEntry(invoice, chargeID){
        invoice = angular.fromJson(angular.toJson(invoice));
        return new Promise(function(resolve, reject){
          delete invoice.lineItems[chargeID]
          var invoicing = firebase.functions().httpsCallable('invoicing'),
              request = {
                invoice: invoice,
                entryID: chargeID,
                action: 'removeChargeEntry'
              }
          return invoicing(request)
          .then(function(response){
            userDataService.trackEvent('remove-charge-from-invoice');
            var updatedInvoice = response.data;
            return resolve(updatedInvoice);
          })
          .catch(function(error){
            console.error('Unable to update Invoice ' + invoice.uid)
            console.error(error);

            service.invoiceError = true;
            return reject(error)
          })
        })
      }//removeChargeEntry

      function removePayment(invoice, paymentID){
        return new Promise(function(resolve, reject){
          // get payment
          return firebase.database().ref('/payments/' + paymentID).once('value', function(snapshot){
          // remove payment from counts
          var payment = snapshot.val();
          // if payment is "locked" then it was made BY THE CLIENT and can not be deleted
          if(!payment.locked){
            var removedAmount = -1 * Number(payment.amount);
             return userDataService.count(invoice.info.owner, 'paid', removedAmount)
             .then(function(){
              return userDataService.count(payment.account, 'payments', -1)
              .then(function(){
                  // Remove payment from invoice and update received before updating invoice
                  delete invoice.info.payments[paymentID]
                  var received = 0;
                  _.each(invoice.info.payments, function(payment){
                    received = received + payment.amount
                  })
                  invoice.info.received = received;

                  var updates = {};
                  updates['/payments/' + paymentID ] = null;
                  return firebase.database().ref().update(updates)
                  .then(function(){
                    return tabulateInvoice(invoice)
                    .then(function(invoice){
                      return reGroupTime(invoice)
                      .then(function(invoice){
                        return updatePackageInvoice(invoice)
                        .then(function(invoice){
                          userDataService.trackEvent('remove-payment');
                          return resolve(invoice);
                        })
                      })
                    })
                  })
                  .catch(function(error){
                    $log.info('Error removing PaymentID ' + paymentID);
                    $log.info(error);
                    service.invoiceError = true;
                    return reject(error)
                  })
                })
              })
            } else {
             // payment is locked
              $mdDialog.show(
                   $mdDialog.alert()
                     .parent(angular.element(document.querySelector('#popupContainer')))
                     .clickOutsideToClose(true)
                     .title('Cannot delete Payment')
                     .textContent('This payment was applied by someone else and cannot be removed')
                     .ariaLabel('Adminja Error Dismissed')
                     .ok('Got it!')
                 );
              return resolve(true)
            }
           })
          })


      }//removePayment

      function updatePackageInvoice(invoice){
        invoice = angular.fromJson(angular.toJson(invoice));
        return new Promise(function(resolve, reject){
          var invoicing = firebase.functions().httpsCallable('invoicing'),
               request = {
                 invoice: invoice,
                 action: 'updateInvoice'
               }
           return invoicing(request)
           .then(function(response){
             var updatedInvoice = response.data;
             return resolve(updatedInvoice);
           })
           .catch(function(error){
             console.error('Unable to update Invoice ' + invoice.uid)
             console.error(error);

             service.invoiceError = true;
             return reject(error)
           })
        })
      }// updatePackageInvoice

      function deletePackageInvoice(invoice){
          invoice = angular.fromJson(angular.toJson(invoice));
         return new Promise(function(resolve, reject){
           var invoicing = firebase.functions().httpsCallable('invoicing'),
                request = {
                  invoice: invoice,
                  action: 'deleteInvoice'
                }
            return invoicing(request)
            .then(function(response){
              userDataService.trackEvent('delete-invoice');
              var updatedInvoice = response.data;
              return resolve(updatedInvoice);
            })
            .catch(function(error){
              console.error('Unable to update Invoice ' + invoice.uid)
              console.error(error);

              service.invoiceError = true;
              return reject(error)
            })
         })
      }// deletePackageInvoice


      function changeInvoiceMode(mode){
        service.invoiceMode = mode;
      }// changeInvoicemode

      function selectClient(client){
        service.selectedClient = client;
      }// changeInvoicemode

      function getInvoiceHTML(invoice, data){

        setupHandlebars(invoice);
        // is this a legacy invoice or a package-based invoice
        if(_.has(invoice.info, 'billingPeriod')){
          return new Promise(function(resolve, reject){
            var templateRef = firebase.app().storage("gs://"+ fbConfig.templateBucket).ref("/invoice.html");
            templateRef.getDownloadURL().then(function(url) {
               $http({
                      method: 'GET',
                      url: url
                  }).success(function (file, status, headers) {
                     var template = Handlebars.compile(file);
                     var renderedInvoice = template(invoice);
                     return resolve(renderedInvoice)
                  }).error(function (data) {
                      $log.error('Error!');
                      $log.info(data);
                      return reject
                  });
            });
          })
        } else {
          var invoiceTemplate = 'invoice2021.html';
          if(_.has(invoice, 'invoiceTemplate')){
            invoiceTemplate = invoice.invoiceTemplate
          }

          // Sort our time
          _.each(invoice.timeGroups, function(group){
            // sort our group
            var groupTime = _.sortBy(group.time, '[logDate]');
            group.time = {};
            _.each(groupTime, function(sortedEntry){
              group.time[sortedEntry.uid] = sortedEntry;
              console.log(moment(sortedEntry.logDate).format('MMM DD'));
            });
          });

          return new Promise(function(resolve, reject){
            if(!_.has(service, 'invoiceTemplate')){
              var templateRef = firebase.app().storage("gs://"+ fbConfig.templateBucket).ref("/"+invoiceTemplate);
              templateRef.getDownloadURL().then(function(url) {
                 $http({
                        method: 'GET',
                        url: url
                    }).success(function (file, status, headers) {
                        service.invoiceTemplate = Handlebars.compile(file);
                        var renderedInvoice = service.invoiceTemplate(invoice);
                        return resolve(renderedInvoice)
                    }).error(function (data) {
                        $log.error('Error!');
                        $log.info(data);
                        return reject
                    });
              });
            } else {
              // we already have the template, just compile it
              var renderedInvoice = service.invoiceTemplate(invoice);
              return resolve(renderedInvoice)
            }
          })// promise
        }

      }// getInvoiceHTML


      function getClientInvoices(client, start, end){
        return new Promise(function(resolve, reject){
          var thisStart = client + moment(start).format('YYYY-MM-DD'),
              thisEnd = client + moment(end).format('YYYY-MM-DD'),
              invoicesRef = firebase.database().ref('invoices');
              invoicesRef.orderByChild('info/clientDate').startAt(thisStart).endAt(thisEnd)
              .once('value', function(snapshot){
                var invoices = snapshot.val();
                // $log.info('invoiceService has invoices:');
                // $log.info(invoices);
                resolve(invoices);
              });

         });
      }// getClientInvoices

      function getLastInvoice(client){
        $log.info('getLastInvoice');
        // clear out from previous use
        delete service.lastInvoiceNumber;
        service.lastInvoiceNumber = 0;
        var invoiceListRef = firebase.database().ref('invoiceNumbers').child(client.owner);
        invoiceListRef.once('value', function(snapshot){
          if(snapshot.exists()){
            var invoices = snapshot.val();
            var mostRecent = {
              number: 1,
              date: '2016-01-01'
            }
            _.each(invoices, function(invoice){
              if(invoice.date > mostRecent.date){
                mostRecent = invoice;
              }
            });
            service.lastInvoiceNumber = mostRecent.number
            // $log.info(service.lastInvoiceNumber);
            // if(_.has(invoices[0], 'number')){
            //   service.lastInvoiceNumber = invoices[0].number
            // }
          } else {
            service.lastInvoiceNumber = 1;
          }

        })

      }// get invoices




      // Creates a new invoice object to be edited
      function newInvoice(user, billingPeriod, lineItems, time){
        return $timeout(function(){
          // We'll need the full client object to build our invoice
          var client = {};

          _.each(clientDataService.clients, function(item){
            if(item.uid == billingPeriod.info.client){
              client = item
            }
          })
            var invoiceRef = firebase.database().ref('invoices'),
                // newInvoiceKey = invoiceRef.push().key,
                invoice = {
                  // 'uid': newInvoiceKey,
                  'lineItems': lineItems,
                  'time': time,
                  'type': billingPeriod.info.type
                };

                // only put these properties on for retainers - handlebars can only check for EXISTENCE of a property.
                if(billingPeriod.info.type == 'retainer'){
                  invoice.showLogged = false;
                  invoice.logged = billingPeriod.info.logged;
                  invoice.allocated = billingPeriod.info.allocated;
                }

                // by default, show remittance
                invoice.showRemittance = true;

                if(_.has(user, 'profile.paymentLink')){
                  invoice.paymentLink = user.profile.paymentLink;
                }

                var remitCompany = "";
                if(_.has(user, 'profile.company')){
                  remitCompany = user.profile.company;
                } else {
                  remitCompany = user.profile.firstname + ' ' + user.profile.lastname;
                }

                if(_.has(user.profile, 'address')){
                  invoice.remit={
                    company: remitCompany,
                    street: (typeof user.profile.address.street === 'undefined') ? "" : user.profile.address.street,
                    city: user.profile.address.city || "",
                    state: user.profile.address.state || "",
                    zip: user.profile.address.zip || ""
                  }
                } else {
                  invoice.remit={
                    company: remitCompany,
                    street: '',
                    city: '',
                    state: '',
                    zip: ''
                  }
                }


                // only add street2 if it's there
                if(_.has(user, 'profile.address.street2')){
                  invoice.remit.street2 = user.profile.address.street2;
                }

                // only add country if it's there
                if(_.has(user, 'profile.address.country')){
                  invoice.remit.country = user.profile.address.country;
                }


                // get some possibly empty values from client
                var address = {};
                if(_.has(client, 'profile.address.street')){
                  address.street = client.profile.address.street;
                } else {address.street = "Street Address"};

                if(_.has(client, 'profile.address.city')){
                  address.city = client.profile.address.city;
                } else {address.city = "City/Town"};

                if(_.has(client, 'profile.address.state')){
                  address.state = client.profile.address.state;
                } else {address.state = "State"};

                if(_.has(client, 'profile.address.zip')){
                  address.zip = client.profile.address.zip;
                } else {address.zip = "Postal Code"};

                if(_.has(client, 'profile.address.country')){
                  address.country = client.profile.address.country;
                } else {address.country = "Country"};

            var dueDate = moment().add(30, 'days').toDate();

            if(_.has(user.profile, 'invoiceDueDays')){
              dueDate = moment().add(user.profile.invoiceDueDays, 'days').toDate();
            }

            // Set Invoice Label, tax status, label and amount
            var customInvoiceLabel = "Invoice", customTaxLabel = "Taxes", customTaxPercentage = 0, shouldCalculateTax = false;
            if(_.has(user.profile, 'invoiceLabel')){
              customInvoiceLabel = user.profile.invoiceLabel
            }
            if(_.has(user.profile, 'calculateTax')){
                shouldCalculateTax = user.profile.calculateTax;
            }
            if(_.has(user.profile, 'taxLabel')){
              customTaxLabel = user.profile.taxLabel
            }
            if(_.has(user.profile, 'taxPercentage')){
              customTaxPercentage = user.profile.taxPercentage
            }


            var newInvoiceNumber = _.toNumber(service.lastInvoiceNumber) + 1;
            newInvoiceNumber = _.padStart(newInvoiceNumber, 5, '0');
            var notes = '';
            if(_.has(user.profile, 'invoiceNotes')){
              notes = user.profile.invoiceNotes
            }

            invoice.info = {
                number: newInvoiceNumber,
                owner: billingPeriod.owner,
                billingPeriod: billingPeriod.uid,
                date: moment().toDate(),
                due: dueDate,
                terms: user.profile.invoiceTerms,
                notes: notes,
                status: 'open',
                client: client.uid,
                calculateTax : shouldCalculateTax,
                invoiceLabel : customInvoiceLabel,
                taxPercentage : customTaxPercentage,
                taxLabel : customTaxLabel,
                recipient:{
                  name: client.profile.fullName,
                  email: client.profile.email,
                  address: address.street,
                  city: address.city || "City",
                  state: address.state || "State",
                  postal: address.zip || "Zip",
                  country: address.country || "Country",
                }

              } // invoice.info declaration
          userDataService.trackEvent('new-invoice');
          return invoice
        });


      } // newInvoice

      // Saves a new invoice
      function saveInvoice(invoice){
        // $log.info('saveInvoice');
        var invoiceCopy = angular.fromJson(angular.toJson(invoice));
        var invoiceRef = firebase.database().ref('invoices'),
            newInvoiceKey = invoiceRef.push().key;

        invoiceCopy.uid = newInvoiceKey;
        invoiceCopy.info.uid = newInvoiceKey;

        // Convert our dates to simple format so cloud functions dont miscalculate
        invoiceCopy.info.date = moment(invoiceCopy.info.date).format('YYYY-MM-DD');
        invoiceCopy.info.due = moment(invoiceCopy.info.due).format('YYYY-MM-DD');

        // Setup our client and owner dates for optimized queries
        invoiceCopy.info.clientDate = invoiceCopy.info.client + invoiceCopy.info.date;
        invoiceCopy.info.ownerDate = invoiceCopy.info.owner + invoiceCopy.info.date;

        invoiceCopy.timeStamp = moment().toISOString();

        var shortInvoice = {
          uid: newInvoiceKey,
          number: invoiceCopy.info.number,
          date: invoiceCopy.info.date,
          due: invoiceCopy.info.due,
          owner: invoiceCopy.info.owner
        }
        // Send copies to lock (in case invoice gets removed before locking finished)
        var timeCopy = angular.copy(invoiceCopy.time),
            lineItemCopy = angular.copy(invoiceCopy.lineItems);
        service.lockTimeEntries(timeCopy);
        service.lockLineItems(lineItemCopy);

        ajUTILITIES.removePropertiesWith(invoice);

        // Check to make sure terms and notes aren't blank
        if(!invoiceCopy.info.terms){
            invoiceCopy.info.terms = "";
        }
        if(!invoiceCopy.info.notes){
            invoiceCopy.info.notes = "";
        }

        // Update the database
        var updates = {};
        // store our canonical object
        updates['invoices/' + newInvoiceKey] = invoiceCopy;
        // store a shortinvoice on our owner-based list of invoice numbers
        updates['invoiceNumbers/' + invoiceCopy.info.owner + '/' + newInvoiceKey] = shortInvoice;
        // store our reference in the client's store
        updates['clients/' + invoiceCopy.info.client + '/invoices/' + newInvoiceKey ] = true;
        // store our reference in the billingPeriod's store
        updates['billingPeriods/' + invoiceCopy.info.billingPeriod + '/invoices/' + newInvoiceKey ] = invoiceCopy.info;
        // Execute our update
        return firebase.database().ref().update(updates)
                .then(function () {
                  // re-select the new invoice
                    service.selectInvoice(newInvoiceKey);
                  // update our lastInvoiceNumber
                  service.lastInvoiceNumber = invoiceCopy.info.number;
                  userDataService.trackEvent('save-new-invoice');
          });
      } // saveInvoice

      // Update existing invoice
      function updateInvoice(invoice){
        // $log.info('updating invoice:' , invoice);
        // $log.info('updateInvoice');
        var invoiceCopy = angular.fromJson(angular.toJson(invoice));

        invoiceCopy.info.date = moment(invoiceCopy.info.date).format('YYYY-MM-DD');
        invoiceCopy.info.due = moment(invoiceCopy.info.due).format('YYYY-MM-DD');
        var now = moment().toISOString();
        invoiceCopy.updated = now;
        invoiceCopy.accountUpdated = invoiceCopy.info.owner + now;
        // Setup our client and owner dates for optimized queries
        invoiceCopy.info.clientDate = invoiceCopy.info.client + invoiceCopy.info.date;
        invoiceCopy.info.ownerDate = invoiceCopy.info.owner + invoiceCopy.info.date;

        // Remove our PDF since we've changed the invoice. Needs to be generated again.
        delete invoiceCopy.pdf

        var timeCopy = undefined, lineItemCopy = undefined;
        // Send copies to lock (in case we added new items)
        var timeCopy = angular.copy(invoice.time),
            lineItemCopy = angular.copy(invoice.lineItems);

        // clean out our firebase $ cruft
        ajUTILITIES.removePropertiesWith(invoiceCopy);
        if(timeCopy){
          ajUTILITIES.removePropertiesWith(timeCopy);
        }
        if(lineItemCopy){
          ajUTILITIES.removePropertiesWith(lineItemCopy);
        }
        // Update the database
        var updates = {};
        // update our canonical object
        updates['invoices/' + invoiceCopy.uid] = invoiceCopy;
        // update our billingPeriod's copy
        updates['billingPeriods/' + invoiceCopy.info.billingPeriod + '/invoices/' + invoiceCopy.uid] = invoiceCopy.info;
        // Update this item in our invoiceLIst
        updates['invoiceNumbers/' + invoiceCopy.info.owner + '/' + invoiceCopy.info.uid + '/number'] = invoiceCopy.info.number;
        // Execute our update
        // TODO - this always yields a TypeError from firebase when we are updating after removing a line item. No idea why

        return firebase.database().ref().update(updates)
                .then(function () {
                  service.lockTimeEntries(timeCopy);
                  service.lockLineItems(lineItemCopy);
                  // re-select the new invoice
                  // service.selectInvoice(invoiceCopy.uid);
          });
      } // updateInvoice

      // Deletes existing invoice
      function deleteInvoice(invoice){
        // $log.info('deleteInvoice');
        // Unlock time and lineItems so they can be freed for a different invoice
        if (_.has(invoice, 'time')){
          service.unlockTimeEntries(invoice.time);
        }
        if(_.has(invoice, 'lineItems')){
          service.unlockLineItems(invoice.lineItems);
        }

        var updates = {};
        updates['invoices/' + invoice.uid] = null;
        updates['billingPeriods/' + invoice.info.billingPeriod + '/invoices/' + invoice.uid] = null;
        return firebase.database().ref().update(updates)
        .then(function(){
          userDataService.trackEvent('delete-invoice');
          $timeout(function(){
            delete service.selectedInvoice
          }, 0);

        })
      } // deleteInvoice

      // Sets "invoiced" status of time entries in this invoice to true.
      function lockTimeEntries(entries){
        // $log.info('lockTimeEntries');
        var updates = {};

        _.each(entries, function(thisEntry){
          updates['time/' + thisEntry.uid + '/invoiced'] = true;
        });
        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // lockTimeEntries

      // Sets "invoiced" status of line items in this invoice to true.
      function lockLineItems(items){
        // $log.info('lockLineItems');
        var updates = {};

        _.each(items, function(item){
          updates['billingPeriods/' + service.selectedInvoice.info.billingPeriod + '/lineItems/' + item.uid + '/invoiced'] = true;
        });

        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // lockLineItems

      function putInView() {
          $timeout(function(){
            $('#scroll-h').animate({
                scrollLeft: 3000
            }, 20, 'linear');
          }, 100)

         }// putInView




      // Sets the service.selectedInvoice to the invoice matching the passed ID
      function selectInvoice(invoiceID){
        service.invoiceSaving = false;
        service.invoiceError = false;
        return new Promise(function(resolve, reject){
          // $log.info('selectInvoice');
          // $log.info('selectPeriod:', period);
          var newInvoice = {},
              invoiceRef = firebase.database().ref('invoices/' + invoiceID);
          return $firebaseObject(invoiceRef)
          .$loaded(function (data) {
              // convert start and end dates to date objects for use in display
              // $log.info('date: ' + data.info.date + 'due: ' + data.info.due);
              data.info.date = moment(data.info.date, 'YYYY-MM-DD').toDate();
              data.info.due = moment(data.info.due, 'YYYY-MM-DD').toDate();
              // $log.info('date: ' + data.info.date + 'due: ' + data.info.due);

              // Set default label for invoices

              // Support showing legacy invoices that don't have an invoiceLabel set
              if(!_.has(data.info.invoiceLabel)){
                data.info.invoiceLabel = "Invoice"
              }

              userDataService.trackEvent('select-invoice');
              service.selectedInvoice = data;
              setupHandlebars(service.selectedInvoice);
              putInView();
              return resolve(service.selectedInvoice)
              // $log.info(service.selectedInvoice);
          });
        })

      } // selectInvoice

      // Sets "invoiced" status of time entries in this invoice to false.
      function unlockTimeEntries(entries){
        // $log.info('unlockTimeEntries');
       var updates = {};
               _.each(entries, function(thisEntry){
                 updates['time/' + thisEntry.uid + '/invoiced'] = false;
               });
               // Execute our atomic update
               return firebase.database().ref().update(updates)
               .then(function () {
                   // $log.info('sorted');
               });
      } // unlockTimeEntries

      // Sets "invoiced" status of line items in this invoice to false.
      function unlockLineItems(items){
        // $log.info('unlockLineItems');
        var updates = {};

        _.each(items, function(item){
          updates['billingPeriods/' + service.selectedInvoice.info.billingPeriod + '/lineItems/' + item.uid + '/invoiced'] = false;
        });

        // Execute our atomic update
        return firebase.database().ref().update(updates)
        .then(function () {
            // $log.info('sorted');
        });
      } // unlockLineItems

      // Calculates the total for the selectedInvoice
      function calcInvoice(){
        // $log.info('calcInvoice');
      } // calcInvoice



      // Saves invoice to /pdfRequests so a pdf can be created and attached for download/sending
      function createPDF(invoice , next){
        // $log.info('createPDF');
        // save a copy of our invoice in pdfRequests
        var invoiceCopy = angular.fromJson(angular.toJson(invoice));
        // Convert our dates to plain text for our cloud function
        invoiceCopy.timestamp = moment().toISOString();
        invoiceCopy.info.date = moment(invoiceCopy.info.date).format('YYYY-MM-DD');
        invoiceCopy.info.due = moment(invoiceCopy.info.due).format('YYYY-MM-DD');
        ajUTILITIES.removePropertiesWith(invoiceCopy);
        var updates = {};
        updates['pdfRequests/'+ invoiceCopy.uid] = invoiceCopy;
        // Execute our update
        return firebase.database().ref().update(updates)
                .then(function () {
                    // $log.info('pdfRequest sent');
                  // if there's a next step, let's handle it
                });

      } // printInvoice

      function preparePDF(invoice, user, client, next){
        // $log.info('PreparePDF invoice:', invoice);
        // $log.info('preparePDF user:' + user.uid);
        // $log.info('preparePDF client: ', client);
        // $log.info('PreparePDF');
        // Add our client info to our invoice so cloud function has all the info it needs to build invoice
        invoice.client = client.profile;

        invoice.time = _.sortBy(invoice.time, ['logDate']);
        invoice.lineItems = _.sortBy(invoice.lineItems, ['date']);

        // Add proper date to time and lineItems
        _.each(invoice.time, function(time){

          time.displayDate = moment(time.logDate).format('MMM D');

        });
        _.each(invoice.lineItems, function(item){

          item.displayDate = moment(item.date).format('MMM D');

        });

        // prepare a new Filename
        if(_.has(client.profile, 'firstName')){
          // remove slashes from filename
          var cleanFirstName = client.profile.firstName.replace(/\//g, '-'),
              cleanLastName = client.profile.lastName.replace(/\//g, '-');
            var newFilename = cleanFirstName + '_' + cleanLastName+'_invoice-'+ invoice.info.number + '.pdf';
        } else {
          // remove slashes from filename
          var cleanFirstName = client.profile.firstname.replace(/\//g, '-'),
              cleanLastName = client.profile.lastname.replace(/\//g, '-');
            var newFilename = cleanFirstName + '_' + cleanLastName+'_invoice-'+ invoice.info.number  + '.pdf';
        }

        // Prepare our the pdf node of our pdfRequest
        var pdf = {
            template: 'invoice',
            filename: newFilename,
            parentPath: "invoices/"+ invoice.uid
        }

        // if we are not emailing the PDF (i.e. we are waiting for it)
        // set our indicator on the invoice
        if(!next){
          pdf.link = 'pending'
        }

        // if we have a "next" step, add it to our pdf request
        if(next){
            if (next == 'emailClient'){
                pdf.next = 'emailClient';
                pdf.senderEmail = user.email;
                pdf.senderName = user.profile.fullName;
                pdf.emailSubject = 'New Invoice from ' + pdf.senderName;
                pdf.emailBody = 'Attached you\'ll find your recent invoice from ' + pdf.senderName + '.\n';
                if(_.has(invoice, 'paymentLink')){
                pdf.emailBody = pdf.emailBody + '<p>You can <a href="' + invoice.paymentLink + '" target="_blank"> pay your invoice immediately here.</a></p>';
                }

                pdf.recipientEmail = invoice.recipientEmail;
            }
        }

        // add our company logo to invoice
        if (_.has(user, 'profile.logo')){
            invoice.logo = user.profile.logo
        }

        invoice.currency = user.profile.settings.currency;

        // Add our PDF meta info to invoice so cloud function knows what to do with it
        invoice.pdf = pdf;

      }// preparePDF



      function mailInvoiceDialog(invoice, user, client){
        $mdDialog.show({
            controller: 'emailInvoiceDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/invoiceService/emailInvoice.html',
            parent: angular.element(document.body),
            locals: {
                invoice: invoice,
                user: user,
                client: client

            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });
      }


      function newPayment(invoice){
        $mdDialog.show({
            controller: 'paymentDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/invoiceService/paymentDialog.tmpl.html',
            parent: angular.element(document.body),
            locals: {
                invoice: invoice
            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });
      }//

      function editPayment(paymentID){

          return firebase.database().ref('/payments/' + paymentID).once('value', function(snapshot){
            if(snapshot.exists()){
              var payment = snapshot.val();
              $mdDialog.show({
                  controller: 'paymentDialogController',
                  controllerAs: 'vm', // see below
                  templateUrl: 'app/app-services/invoiceService/paymentDialog.tmpl.html',
                  parent: angular.element(document.body),
                  locals: {
                      payment: payment
                  },
                  bindToController: true,
                  focusOnOpen: false,
                  clickOutsideToClose: true,
                  fullscreen: true
              });
            } else {
              $log.info('Error loading payment');
            }
          })


      }//

      function updatePayment(original, updated){
        updated.date = moment(original.date).toISOString();
        updated.updated = moment().toISOString();
        var displayDateFormat = 'MMM DD';
        if(updated.dateFormat == 'eu'){
          displayDateFormat = 'DD MMM'
        }
        newPayment.displayDate = moment(newPayment.date).format(newPayment.dateFormat);
        var updates = {};
        updates['invoices/' + updated.invoice + '/info/payments/' + updated.uid] = updated;
        updates['invoices/' + updated.invoice + '/updated/'] = moment().toISOString();
        updates['payments/' + updated.uid] = updated;
        return firebase.database().ref().update(updates)
        .then(function(){
          var remove = -1 * Number(original.amount),
              add = Number(updated.amount),
              countUpdate = remove + add;
            // remove original amount and add new amount
            return userDataService.count(updated.account, 'paid', countUpdate)
            .catch(function(error){
              $log.info(error);
              return error
            })
          })
      };// updatePayment

      function saveNewPayment(payment, invoice){
        // this function is duplicated in paymentProcessor.js if any structural changes are made here,
        // they need to be made in paymentProcessor.js as well.
        return new Promise(function(resolve, reject){
          var newPayment = angular.copy(payment);
          newPayment.date = moment(payment.date).toISOString();
          newPayment.displayDate = moment(newPayment.date).format(newPayment.dateFormat);
          // Get our new key
          var newKey = firebase.database().ref('payments').push().key, now = moment().toISOString();
          // Save our key on our object
          newPayment.uid = newKey;
          newPayment.client = invoice.info.client;
          newPayment.clientName = clientDataService.clientName(newPayment.client);
          if(!newPayment.clientName){
            newPayment.clientName = "Unknown";
          }
          newPayment.invoice = invoice.uid;
          newPayment.invoiceNumber = invoice.info.number;
          newPayment.created = now;
          newPayment.account = invoice.info.owner;
          newPayment.accountCreated = invoice.info.owner + now;
          var updates = {};
          if(_.has(invoice.info, 'billingPeriod')){
            updates['billingPeriods/' + invoice.info.billingPeriod + '/invoices/' + invoice.uid + '/payments/' + newKey] = newPayment;
          }
            updates['invoices/' + invoice.uid + '/info/payments/' + newKey] = newPayment;
            updates['invoices/' + invoice.uid + '/updated/'] = moment().toISOString();
            updates['payments/' + newKey] = newPayment;
            return firebase.database().ref().update(updates)
            .then(function(){
              return userDataService.count(newPayment.account, 'payments', 1)
              .then(function(){
                return userDataService.count(newPayment.account, 'paid', newPayment.amount)
                .then(function(){
                  resolve(true)
                })
                .catch(function(error){
                  $log.info(error);
                  reject(error)
                })
              })
            });
          });
      }


      function setupHandlebars(invoice){
              function HandM(minutes){
                if(invoice.timeFormat == 'decimal'){
                  var total = minutes/60;
                  return Number(total).toFixed(2);
                } else {

                 // if it's minutes-based
                 var isNegative = false;
                 if (minutes < 0){
                   isNegative = true;
                 }
                 // convert to an integer so we aren't doing a floor/ceiling dance
                 minutes = Math.abs(minutes);

                 var hours = Math.floor( minutes / 60);
                 hours = _.toString(hours);
                 // we don't pad our hours. They may go into 3 digits for some users.
                 var minutes = Math.round(minutes % 60);
                 minutes = _.toString(minutes);
                 minutes = _.padStart(minutes, 2, '0');

                 // set our return object
                 var duration = hours;

                 // if we have minutes, add them. Otherwise, 00
                  if (minutes){
                   duration = duration + ':' + minutes;
                  } else {
                   duration = duration + ':' + '00';
                  }

                  // if it was a negative minutes, prepend it
                  if (isNegative){
                   duration = '-' + duration;
                  }

                  // if(minutes < 60){
                  //  duration = duration + ' min'
                  // } else {
                  //  duration = duration + ' hrs'
                  // }
                  return duration

                }
              }// HandM

              // Custom Helpers for formatting our data in the template
              Handlebars.registerHelper({
                toFixed: function(data) {
                  var fixed = Number(data).toFixed(2);
                  return fixed
                },
                minutesToHandM: function(number) {
                  return HandM(number)
                },
                timeTotal: function(rate, logged) {
                  var total = rate * (logged/60)
                  return Number(total).toFixed(2);
                },
                longDate: function(data) {
                  return moment(data).format('MMMM DD,YYYY')
                },
                shortDate: function(data) {
                  return moment(data).format('MMM DD')
                },
                lineTotal: function(cost, quantity) {
                  var thisTotal =  (cost * quantity);
                  thisTotal = thisTotal.toFixed(2);
                  return thisTotal
                },
                 ifEqual: function(value, comparison, options){
                          if (value == comparison) { return options.fn(this); }
                             return options.inverse(this);
                         },
                 ifNotEqual: function(value, comparison, options){
                          if (value != comparison) { return options.fn(this); }
                             return options.inverse(this);
                         },
                ifGreaterThan: function(a, b) {
                  if(a >= b){
                    return true
                  } else {
                    return false
                  }
                },
                ifLessThan: function(a, b) {
                  if(a <= b){
                    return true
                  } else {
                    return false
                  }
                },
                ifPastDue: function(date, balance, options) {
                  var now = moment().toISOString();
                  date = moment(date).toISOString();
                  // return date + ' > ' + now
                  if(now >= date && Number(balance) > 0){
                    return options.fn(this);
                  }
                  return options.inverse(this);
                },
                ifPaid: function(balance, received, options) {
                  // return date + ' > ' + now
                  if(Number(balance) <= 0 && Number(received) > 0){
                    return options.fn(this);
                  }
                  return options.inverse(this);
                },
                paymentTotal: function(payments) {
                  var total = 0;
                  _.each(payments, function(payment){
                    total = total + Number(payment.amount);
                  })
                  var fixedTotal = Number(total).toFixed(2);
                  return fixedTotal
                },
                remainFrom: function(allocatedMinutes, total) {
                  var remainingMinutes = allocatedMinutes - total;

                  return HandM(remainingMinutes)

                },
                trimTo: function(text,length){
                    var trimmed = _.truncate(text, {
                      'length': length,
                      'separator': ' '
                    });
                    return trimmed
                  }

              });
           }// setupHandlebars


    } // end invoiceService



    /* @ngInject */
    function emailInvoiceDialogController($mdDialog, $mdToast, $log, $scope, $rootScope, invoiceService){
      // $log.info('emailInvoiceDialogController');
      var vm = $scope.vm;
      // determine if user is clientUser for this workspace
      vm.isClientUser = false;
      if(_.has($rootScope, 'VAWorkspaces')){
          if(_.has($rootScope.VAWorkspaces, vm.client.uid)){
                  vm.isClientUser = true;
          }
      }
      // $log.info(vm);
      vm.recipientEmail = vm.client.profile.email;
      vm.cancel = function(){
        $mdDialog.cancel();
      }
      var thisTimeFormat = 'minutes';

      if(_.has(vm.user.profile.settings, 'timeFormat')){
          if(vm.user.profile.settings.timeFormat){
              thisTimeFormat = 'decimal'
          }
      }

      vm.invoice.timeFormat = thisTimeFormat;

      vm.sendPDF = function(recipientEmail){
        $mdDialog.cancel();
        // $log.info('Send invoice to:' + recipientEmail);
        vm.invoice.recipientEmail = recipientEmail;
        invoiceService.preparePDF(vm.invoice, vm.user, vm.client, 'emailClient')
        $mdToast.show($mdToast.adminjaAlert(
            {
                locals:{
                    title: 'Woot!',
                    message: 'Your invoice is being prepared and will be emailed to ' + recipientEmail+'.' ,
                    color: 'orange'
                }
            }));// mdToast
        return invoiceService.createPDF(vm.invoice)


      }

    }

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('inboxService', inboxService);

    /* @ngInject */
    function inboxService($log, $sce, moment, userDataService, taskDataService, profileDataService, $rootScope, $timeout, $firebaseArray, $firebaseObject) {
        var service = {
            importTask: importTask,
            importNote: importNote,
            // discardMessage: discardMessage,
            // clearInbox: clearInbox,
            init: init
        };


        return service;


        function init(){

        }// init

        function sanitizeMe(text) {
            return $sce.trustAsHtml(text)
        };

        // Deprecated 10/19/17. These items now appear in user/notifications
        // function loadInbox(email){
        //   var emailKey = email.replace(/\./g, "-");
        //   var inboxRef = firebase.database().ref().child('/inbox/' + emailKey);
        //       $firebaseArray(inboxRef)
        //       .$loaded(
        //           function(messages) {
        //               service.inbox = messages;
        //               // $log.info(service.inbox);
        //           });
        // }

        function importTask(message) {
          // $log.info('importTask');
          //heap.track('Start Task Import');

          var userID = userDataService.user.uid,
              task = taskDataService.newTask();

          var cleanMessage = sanitizeMe(message.message);
          task.info.panel = 'Later';
          task.info.description = message.title + '\n' + cleanMessage;
          // task.note = message.body;

          taskDataService.taskDialog(task);
           _dcq.push(["identify", {
            email: userDataService.user.email,
            tags: ["Imported Task"]
          }]);
        };// importTask

      function importNote(message){
        // $log.info('importTask');
        //heap.track('Start Note Import');

        var userID = userDataService.user.uid,
            cleanMessage = sanitizeMe(message.message),
            messageBody = message.title + '\n' + cleanMessage,
            newNote = profileDataService.newProfileDetail('note', null, null, messageBody);
        // $log.info(newNote);
        profileDataService.profileDetailDialog(newNote);
         _dcq.push(["identify", {
          email: userDataService.user.email,
          tags: ["Imported Note"]
        }]);

      } // importNote

      // Deprecated 10/19/17. These items now appear in user/notifications and discarded there.
      // function discardMessage(message){
      //   var emailKey = userDataService.user.email.replace(/\./g, "-");
      //   // $log.info('discardMessage', message);
      //   //heap.track('Discard Inbox Item');
      //   return firebase.database().ref().child('/inbox/' + emailKey +'/' + message.$id).remove();
      // }

      // function clearInbox(){
      //   delete service.inbox
      // }// clearInbox


    } // end inboxService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('subscriptionDialogController', subscriptionDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// subscriptionDialogController

        /* @ngInject */
        function subscriptionDialogController($scope, $q, $rootScope, userDataService, $mdDialog, $log, $timeout, $mdToast, thisTitle, message) {
            // $log.info('subscriptionDialogController');
            var vm = this;
            vm.user = userDataService.user;
            vm.title = thisTitle;
            vm.message = message;


        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('gateService', gateService);

    /* @ngInject */
    function gateService($log, moment, $rootScope, $state, $timeout, $firebaseArray, $mdDialog, $firebaseObject, triMenu) {
        var vm = this;
        var service = {
            // gateData: gateData,
            setupGates: setupGates,
            clearGates: clearGates,
            setGate : setGate,
            getConsent: getConsent,
            init: init
        };


        return service;


        function init(){
          // $log.info('gateservice init');

        }// init


        function setGate(gate, value){
            service.gateData[gate] = value;
            // $log.info('setGate');
            // $log.info(service.gateData[gate]);
        }

        // delcare our function
        function getConsent(){
          $mdDialog.show({
              controller: 'consentDialogController', // see below
              controllerAs: 'vm',
              // bindToController: true,
              templateUrl: 'app/app-services/gateService/consent-dialog.tmpl.html',
              focusOnOpen: true,
              clickOutsideToClose: false,
              fullscreen: true
          });
          // flag so this only gets triggered once on page load
          // $rootScope.consentNeeded = true;
          // $timeout(function(){


          // },250)
        }

      function setupGates(user){
        // $log.info('gateService.init');




        var planID = 'starter-2018c', subStatus = 'in_trial', clientLimit = 1, teamLimit = 1, recurringLimit = 0, userTimers = 100, clientUserLimit = 1, trialStart = undefined, trialEnd = undefined;

        // If Loadmodule enabled, add the menu item
        if(_.has(user.profile, 'onboardingFlags.hasLeadboard')){
          if(user.profile.onboardingFlags.hasLeadboard){
            // We need to make sure we don't duplicate or triplicate this on subsequent runs
            var found = false;
            _.each(triMenu.menu, function(menuItem){
              if(menuItem.name == 'Leads'){
                found = true;
              } else{
              }
            })

            if(!found){
              triMenu.addMenu({
                         // give the menu a name to show (should be translatable and in the il8n folder json)
                         name: 'Leads',
                         // point this menu to the state we created in the $stateProvider above
                         state: 'triangular.leads',
                         // set the menu type to a link
                         type: 'link',
                         // set an icon for this menu
                         icon: 'zmdi zmdi-accounts-alt',
                         // icon: 'zmdi zmdi-accounts-outline',
                         // set a proirity for this menu item, menu is sorted by priority
                         priority: 10.5
                     });
            }// if not found

          }

        }

        // if client, remove menus that clients shouldn't have access to
        if(user.type == 'client'){
          triMenu.removeMenu('triangular.allWorkspaces');
          triMenu.removeMenu('triangular.today');
          triMenu.removeMenu('triangular.tasks-page');
          triMenu.removeMenu('triangular.calendar');
          triMenu.removeMenu('triangular.manage');
          triMenu.removeMenu('triangular.leads');
          triMenu.removeMenu('triangular.time-reports');
          triMenu.removeMenu('triangular.guides');
          triMenu.removeMenu('triangular.billing');
          triMenu.removeMenu('triangular.allWorkspaces');

        }

        // if we do have a plan node (and they should), then use that info
        if (_.has(user, 'plan')){
            planID = user.plan.content__subscription__plan_id;
            subStatus = user.plan.content__subscription__status;
            if(_.has(user.plan, 'content__subscription__trial_start')){
              trialStart = user.plan.content__subscription__trial_start;
              trialEnd = user.plan.content__subscription__trial_end;
            }



            // if we have a client limit set (via chargebee/zapier event), use it instead
            if (_.has(user.limits, 'clients')){
              clientLimit = user.limits.clients;
            }

            // if we have a client limit set (via chargebee/zapier event), use it instead
            if (_.has(user.limits, 'team')){
              teamLimit = user.limits.team;
              if(_.has(user.limits, 'additionalTeamMembers')){
                teamLimit = Number(user.limits.team) + Number(user.limits.additionalTeamMembers);
              }
            }

            // if cancelled, set a flag so we can throw up our modal (see app.module)
            if(subStatus == 'cancelled'){
              $rootScope.cancelled = true;
            }


            // if a cancelled paid plan -
            if(subStatus == 'cancelled' && !_.startsWith(planID, 'starter')){
              $rootScope.trial = {
                daysLeft: 0,
                type: 'paid',
                status: 'expired',
                color: 'red'
              }
            }

            // if paused, set a flag so we can throw up our modal (see app.module)
            if(subStatus == 'paused'){
              $rootScope.paused = true;
            }

          // if they are in trial, and on a paid account they should have all features
          if (subStatus == 'in_trial'){


           var today = moment(), numDaysLeft = 0, statusColor = undefined;

             if(trialEnd && subStatus == 'in_trial'){
              numDaysLeft = moment(trialEnd).diff(today, 'days');
             }

               if (numDaysLeft > 15){
                statusColor = 'green'
               }

               if (numDaysLeft <= 15){
                statusColor = 'orange'
               }

               if (numDaysLeft > 0){
                  // setup our trial object for upgrade pushing
                  $rootScope.trial = {
                    daysLeft: numDaysLeft,
                    type: 'paid',
                    status: 'in_trial',
                    color: statusColor
                  }
               }
          }// if in trial

          // set clientUser Limit
         if(_.startsWith(planID, 'starter')){
           clientUserLimit = 0;
         }

         if(_.includes(planID, 'assistant')){
           clientUserLimit = 0;
         }

         if(_.startsWith(planID, 'ninja')){
           clientUserLimit = 1;
         }

          if(_.includes(planID, 'pro')){
            clientUserLimit = 3;
          }
          if(_.startsWith(planID, 'pod')){
            clientUserLimit = 3;
          }
          if(_.includes(planID, 'team')){
            clientUserLimit = 3;
          }

          // allow for overrides
          if(_.has(user.limits, 'clientUsers')){
            clientUserLimit = user.limits.clientUsers
          }

        } else {

        } // if has plan

        service.gateData = {
           'canLogTime' : true,
           'canUseTimer': true,
           'canViewTime' : true,
           'canEmailClient' : true,
           'canImportEmail' : true,
           'clientLimit' :clientLimit,
           'clientUserLimit': clientUserLimit,
           'teamLimit': teamLimit,
           'hasRecurring': true,
           'hasBilling': true,
           'canUseChecklists' : true,
           'subStatus': subStatus,
           'recurringLimit': recurringLimit,
           'planID' : planID
         }

         if(teamLimit >1){
          service.gateData.hasTeams = true;
         }

         // client changes
         if(user.type == 'client'){
          service.gateData.canUseTimer = false;
          service.gateData.canLogTime = false;
          service.gateData.clientLimit = 1;
          service.gateData.subStatus = 'active';
          service.gateData.planID = 'client-access';
         }

      }// setupGates

      function clearGates(){
        delete service.gateData
      }// clearGates


    } // end gateService
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('consentDialogController', consentDialogController);

        ///////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////
        /// consentDialogController

        /* @ngInject */
        function consentDialogController($scope, $q, $state, $rootScope, $mdDialog, $log, $timeout, $mdToast, userDataService) {
            // $log.info('consentDialogController');
            var vm = this;
            vm.showVersion = 'simple';


            vm.saveConsentAndTimeOffset = function(){
                vm.settingConsent = true;
                var now = moment().toISOString();
                vm.timeZoneOffset = moment(now).utcOffset()/60;
                var consent = {
                    description: "In order to use Adminja you will need to accept our privacy policy and terms.",
                    entity: "privacy",
                    hasConsent: true,
                    timeStamp: moment().toISOString()
                }

                var updates = {};

                // Store the consent
                updates['/users/' + $rootScope.userID + '/consent/privacy'] = consent;
                // Store the timezone
                updates['/users/' + $rootScope.userID + '/profile/timeZoneOffset'] = vm.timeZoneOffset;
                updates['/users/' + $rootScope.userID + '/profile/timeZoneUpdated'] = moment().toISOString();
                // Execute transaction
                return firebase.database().ref().update(updates)
                .then(function(){
                    userDataService.trackEvent('accept-privacy-policy');

                    $mdToast.show($mdToast.adminjaAlert(
                       {
                           locals:{
                               title: 'Thank you!',
                               message: 'Your consent is appreciated.' ,
                               color: 'green'
                           }
                       }));// mdToast
                    // $rootScope.$emit('keySetupChanged');
                    $mdDialog.cancel();
                })
            }// saveConsentAndTimeOffset

        }; // end teamInviteDialog Controller

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('refillPackageDialogController', refillPackageDialogController);

///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// refillPackageDialogController

/* @ngInject */
function refillPackageDialogController($log,  $mdToast, $mdDialog,  $timeout,  $rootScope,  $scope,  userDataService, clientPackageService) {
    $log.info('refillPackageDialogController');
    // Setup our core variables
    var vm = this;
    vm.user = userDataService.user,
    vm.settings = $rootScope.userSettings;
    vm.forms = {};
    vm.packageService = clientPackageService,
    // So it's easy to start over
    vm.cleanPackageState = angular.copy(vm.clientPackage);
    vm.currency = "$";
    if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
     }


     // Assign our functions to model
     vm.cancel = cancel;
     vm.selectOption = selectOption;
     vm.submitRefill = submitRefill;
     vm.editPackage = editPackage;
    function cancel(){
      $mdDialog.cancel();
    }

    function editPackage(clientPackage){
      $mdDialog.cancel()
      .then(function(){
        clientPackageService.editPackage(clientPackage);
      })
    }//editPackage

    function selectOption(option){
      // $log.info('selectOption');
      vm.refillOption = option;
      vm.refillOption.quantity = 1;
    }

    function submitRefill(clientPackage, refillRequest){
      // $log.info(refillRequest);
      var newKey = firebase.database().ref('/lineItemCharges').push().key,
          now = moment().toISOString(),
          totalHours = Number(refillRequest.quantity) * Number(refillRequest.hours),
          newLineItem = {
            accountDate: clientPackage.owner + now,
            uid: newKey,
            amount: refillRequest.cost,
            package: clientPackage.uid,
            packageDate: clientPackage.uid + now,
            workspace: clientPackage.workspace,
            workspaceDate: clientPackage.workspace + now,
            owner: clientPackage.owner,
            type: 'refill',
            refillHours: totalHours,
            date: now,
            quantity: refillRequest.quantity,
            description: refillRequest.label + ' (adds ' + refillRequest.hours + 'hr each to budget.)',
            timeStamp: now,
            total: (Number(refillRequest.quantity) * Number(refillRequest.cost)).toFixed(2)
          };

      return clientPackageService.saveLineItem(newLineItem)
      .then(function(){
        $mdToast.show($mdToast.adminjaAlert(
            {
                locals:{
                    title: 'Woot!',
                    message: 'Package has been refilled and charges have been added. ' ,
                    color: 'green'
                }
            }));// mdToast
        cancel();
      })
    }
}//refillPackageDialogController

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('lineItemDialogController', lineItemDialogController);

///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// lineItemDialogController

/* @ngInject */
function lineItemDialogController($log,  $mdDialog, $mdToast,  $timeout,  clientPackageService, $rootScope,  $scope, invoiceService, userDataService) {
    $log.info('lineItemDialogController');
    var vm = this;

    vm.user = userDataService.user;
    vm.userType = $rootScope.admin;
    vm.fbConfig = fbConfig;
    vm.settings = $rootScope.userSettings;
    vm.currency = "$";

    if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
     }

     vm.delete = function(lineItem){
          clientPackageService.deleteLineItem(lineItem)
          .then(function(){
            vm.cancel();
          })
     }

    vm.save = function(lineItem){
      return clientPackageService.saveLineItem(lineItem)
      .then(function(){
        vm.cancel();
      });
    } //

    vm.cancel = function(){
      $mdDialog.cancel();
    }


}//lineItemDialogController

})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('clientPackageService', clientPackageService);

    /* @ngInject */
    function clientPackageService($log, moment, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject, $mdToast, userDataService, scheduleDataService) {


        var service = {
            newLineItem : newLineItem,
            editLineItem: editLineItem,
            lineItemDialog: lineItemDialog,
            saveLineItem: saveLineItem,
            getPackageCharges: getPackageCharges,
            deleteLineItem: deleteLineItem,
            newPackage: newPackage,
            editPackage: editPackage,
            refillPackage: refillPackage,
            submitRefill: submitRefill,
            deletePackage: deletePackage,
            getMonthSequence: getMonthSequence,
            getWeekSequence: getWeekSequence,
            savePackage: savePackage,
            getNextRenewal: getNextRenewal,
            removeNextRenewal: removeNextRenewal,
            savePackageTemplate: savePackageTemplate,
            newPackageFromTemplate: newPackageFromTemplate,
            newCategory: newCategory,
            updateCategory: updateCategory,
            deleteCategory: deleteCategory,
            newOption: newOption,
            updateOption: updateOption,
            deleteOption: deleteOption,
            fetchPackageHistory: fetchPackageHistory,
            fetchPackage: fetchPackage,
            closePackage: closePackage,
            archivePackage: archivePackage,
            reopenPackage: reopenPackage,
            activatePackage: activatePackage,
            setupTriggerSchedule: setupTriggerSchedule,
            billingModuleState: 'activity',
            changeBillingModuleState: changeBillingModuleState,
            setAsDefault: setAsDefault
        };


        var userID = undefined;


        function setAsDefault(thisPackage, allPackages){
          return new  Promise(function(resolve, reject){
            var updates = {};
            updates['/clientPackages/' + thisPackage.uid + '/isDefault'] = true;
            _.each(allPackages, function(otherPackage){
              if(otherPackage.isDefault){
                updates['/clientPackages/' + otherPackage.uid + '/isDefault'] = false;
              }
            });
            return firebase.database().ref().update(updates)
            .then(function(){
              return resolve
            })
            .catch(function(error){
              $log.info('error setting default package');
              $log.info(error);
              return reject(error)
            })
          })

        }//setAsDefault

        function changeBillingModuleState(state){
          service.billingModuleState = state
        }
        function activatePackage(thisPackage){
             return new Promise(function(resolve, reject){
                thisPackage.triggerOpen = true;
                return savePackage(thisPackage)
                .then(function(results){
                  userDataService.trackEvent('activate-package');
                  return resolve(true)
                })
             });
        }// activatePackage

        function closePackage(thisPackage){
             return new Promise(function(resolve, reject){
                thisPackage.status = 'closed';
                return savePackage(thisPackage)
                .then(function(results){
                  userDataService.trackEvent('close-package');
                  return resolve(true)
                })
             });
        }// closePackage

        function archivePackage(thisPackage){
          return new Promise(function(resolve, reject){
             thisPackage.status = 'archived';
             return savePackage(thisPackage)
             .then(function(results){
               userDataService.trackEvent('archive-package');
               return resolve(true)
             })
          });
        }// archivePackage

        function reopenPackage(thisPackage){
          return new Promise(function(resolve, reject){
             thisPackage.status = 'open';
             thisPackage.previouslyClosed = true;
             thisPackage.expired = false;
             thisPackage.accountStatus = thisPackage.owner + 'active';
             thisPackage.workspaceStatus = thisPackage.workspace + 'active';
             return savePackage(thisPackage)
             .then(function(results){
              userDataService.trackEvent('reopen-package');
               return resolve(true)
             })
          });
        }// reopenPackage


        function fetchPackageHistory(clientPackage){
          return new Promise(function(resolve, reject){
            var seriesRef = firebase.database().ref('/clientPackages').orderByChild('originalPackageID').equalTo(clientPackage.originalPackageID);
            seriesRef.once('value', function(snapshot){
             if(snapshot.exists()){
               return resolve(snapshot.val());
             } else {
               return resolve({})
             }
            })
          });
        }// fetchPackageHistory

        function fetchPackage(packageID){
          return new Promise(function(resolve, reject){
            var packageRef = firebase.database().ref('/clientPackages/' + packageID);
            packageRef.once('value', function(snapshot){
              if(!snapshot.exists()){
                return resolve(false)
              }
              if(snapshot.exists()){
                return resolve(snapshot.val())
              }
            })
          })

        }// fetchPackage

        function newOption(clientPackage, order){
          var newKey = firebase.database().ref('/clientPackages').push().key,
              newOption = {
                uid: newKey,
                order: order + 1,
                label: 'New Option',
                hours: 1,
                cost: clientPackage.rate,
                clientPackage: clientPackage.uid
              }
              userDataService.trackEvent('new-refillable-option');
              return newOption
        }// newCategory

        function updateOption(clientPackage, option){
          option.timeStamp = moment().toISOString();
          var updates = {};
          if(clientPackage.isTemplate){
            updates['/users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid + '/refillOptions/' + option.uid]  = option;
          }

          if(!clientPackage.isTemplate){
            updates['/clientPackages/' + clientPackage.uid + '/refillOptions/' + option.uid]  = option;
          }

          return firebase.database().ref().update(updates)
          .then(function(){
            userDataService.trackEvent('save-refillable-option');
            $log.info('Option Saved/Updated');
          })
        }// updateOption

        function deleteOption(clientPackage, option){
          var updates = {};
          if(clientPackage.isTemplate){
            updates['/users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid + '/refillOptions/' + option.uid]  = null;
          }

          if(!clientPackage.isTemplate){
            updates['/clientPackages/' + clientPackage.uid + '/refillOptions/' + option.uid]  = null;
          }

          return firebase.database().ref().update(updates)
          .then(function(){
            $timeout(function(){
              // clientPackage.refillOptions[option.uid] = null;
              userDataService.trackEvent('delete-refillable-option');
              $log.info('Option Deleted');
            })

          })
        }// deleteOption



      function newCategory(clientPackage, order){
        userDataService.trackEvent('new-package-category');
        var newKey = firebase.database().ref('/clientPackages').push().key,
            newCategory = {
              uid: newKey,
              order: order + 1,
              label: 'New Category',
              rate: 0,
              clientPackage: clientPackage.uid,
              adminOnly: false
            }
            return newCategory
      }// newCategory

      function updateCategory(clientPackage, category){
        category.timeStamp = moment().toISOString();
        var updates = {};
        if(clientPackage.isTemplate){
          updates['/users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid + '/categories/' + category.uid]  = category;
        }

        if(!clientPackage.isTemplate){
          updates['/clientPackages/' + clientPackage.uid + '/categories/' + category.uid]  = category;
        }

        return firebase.database().ref().update(updates)
        .then(function(){
          userDataService.trackEvent('update-package-category');
          // $log.info('Category Saved/Updated');
        })
      }// updateCategory

      function deleteCategory(clientPackage, category){
        var updates = {};
        if(clientPackage.isTemplate){
          updates['/users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid + '/categories/' + category.uid]  = null;
        }

        if(!clientPackage.isTemplate){
          updates['/clientPackages/' + clientPackage.uid + '/categories/' + category.uid]  = null;
        }

        return firebase.database().ref().update(updates)
        .then(function(){
          $log.info('Category Deleted');
          userDataService.trackEvent('delete-package-category');
        })
      }// deleteCategory


      function getNextRenewal(clientPackage){
        if(clientPackage.schedule.interval == "month"){
          return moment(clientPackage.startDate).add(clientPackage.schedule.frequency, 'months').set('date', clientPackage.schedule.day).startOf('day').toISOString();

        }

        if(clientPackage.schedule.interval == "week"){
          return moment(clientPackage.startDate).add(clientPackage.schedule.frequency, 'weeks').day(clientPackage.schedule.day).startOf('day').toISOString();
        }
      }// getNextRenewal

      function removeNextRenewal(sequence){
        var lowest = 12;
        var lowestInstance = undefined;

        _.each(sequence, function(instance){
          if(instance.id < lowest){
            lowestInstance = instance;
            lowest = instance.id
          }
        });

        delete sequence[lowestInstance.id]
        return sequence
      }// removeNextRenewal

      function deletePackage(clientPackage){
        return new Promise(function(resolve, reject){
          var updates = {};
          if(!clientPackage.isTemplate){
            updates['/clientPackages/' + clientPackage.uid] = null;
          }
          if(clientPackage.isTemplate){
            updates['/users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid] = null;
          }
          return firebase.database().ref().update(updates)
          .then(function(){
            $log.info('PackageID ' + clientPackage.uid + ' has been deleted.');
            userDataService.trackEvent('delete-package');
            return resolve(true)
          })
          .catch(function(error){
            $log.info('Error deleting packageID '+ clientPackage.uid);
            $log.info(error);
            return reject(error)
          })
        })
      }//deletePackage

      function setupTriggerSchedule(thisPackage){

          var promises = [];
          if(thisPackage.type == 'retainer' || thisPackage.type == 'hourly'){
            if(_.has(thisPackage, 'triggerSchedules')){
              if(_.size(thisPackage.triggerSchedules) > 0){
                _.each(thisPackage.triggerSchedules, function(thisSchedule){
                  $log.info('adding schedule promise to be removed');
                  promises.push(scheduleDataService.removeSchedule(thisSchedule))
                });
              }
            }
          } else {
            return resolve(true)
          }

          promises.push(createSchedule(thisPackage))
          $log.info('executing promise chain');
          return Promise.all(promises)

        function createSchedule(thisPackage){
          return new Promise(function(resolve, reject){
              $log.info('createSchedule for ' + thisPackage.uid);
                var options = {
                  message: '',
                  package: thisPackage.uid,
                  repeat: false,
                  type: 'renew-package',
                  path: '/clientPackages/' + thisPackage.uid +'/triggerSchedules/',
                  packageID: thisPackage.uid,
                  payload:{
                      userID: thisPackage.owner,
                      path: '/clientPackages/' + thisPackage.uid +'/triggerSchedules/',
                  }
                }// options

                var newSchedule = scheduleDataService.newSchedule(thisPackage.owner, options, thisPackage.schedule.packageCreate);
                return scheduleDataService.saveNewSchedule(newSchedule)
                .then(function(schedule){
                  return resolve(true)
                }, function(error){
                  $log.info(error);
                  return reject(error)
                });
          });// promise
        }//createSchedule
      }// setupSchedule

      function savePackage(clientPackage){
        clientPackage = ajUTILITIES.removePropertiesWith(clientPackage);
        return new Promise(function(resolve, reject){
          var updates = {};

          if(clientPackage.isNew){
            clientPackage.startDate = moment(clientPackage.startDate).startOf('day').toISOString();
            if(clientPackage.expiryDate){
              clientPackage.expiryDate = moment(clientPackage.expiryDate).startOf('day').toISOString();
            }
          } else {
            // we don't want to accidentally reset their times to a different timezone
            // Also, we don't want to override the startDate auto-generated
            clientPackage.startDate = moment(clientPackage.startDate).toISOString();
            if(clientPackage.expiryDate){
              clientPackage.expiryDate = moment(clientPackage.expiryDate).toISOString();
            }
          }

          delete clientPackage.isNew

          clientPackage.budgetedMinutes = clientPackage.budgetedHours * 60;
          updates['/clientPackages/' + clientPackage.uid] = clientPackage;
          return firebase.database().ref().update(updates)
          .then(function(){
              userDataService.trackEvent('save-package');
              $log.info('PackageID ' + clientPackage.uid + ' has been saved.');
            if(!clientPackage.previouslyClosed && clientPackage.status == 'open' && (clientPackage.type == 'hourly' || clientPackage.type == 'retainer') ){
              $log.info('Updating schedule trigger');
                return setupTriggerSchedule(clientPackage)
                .then(function(response){
                  return resolve(true)
                }, function(error){
                  $log.info(error);
                  return reject(error)
                });
              } else {
                return resolve(true)
              }

          })
          .catch(function(error){
            $log.info('Error saving packageID '+ clientPackage.uid);
            $log.info(error);
            return reject(error)
          })
        })


      }// savePackage

      function savePackageTemplate(clientPackage){
        clientPackage = ajUTILITIES.removePropertiesWith(clientPackage);
        clientPackage.accountDate = '';
        clientPackage.accountStatus = '';
        clientPackage.status = 'open';
        clientPackage.accrued = 0;
        clientPackage.autoInvoice = false;
        clientPackage.charges= 0;
        clientPackage.dueAlerted = false;
        clientPackage.exemptMinutes = 0;
        clientPackage.expiryDate = false;
        clientPackage.notes = '';
        clientPackage.qualifiedMinutes = 0;
        clientPackage.totalMinutes = 0;
        clientPackage.whenNotified = false;
        clientPackage.workspace = '';
        clientPackage.workspaceDate = '';
        clientPackage.workspaceStatus = '';
        clientPackage.startDate = moment(clientPackage.startDate).toISOString();


        return new Promise(function(resolve, reject){
          var updates = {};
          clientPackage.startDate = moment(clientPackage.startDate).toISOString();
          if(clientPackage.endDate){
            clientPackage.endDate = moment(clientPackage.endDate).toISOString();
          }

          if(clientPackage.expiryDate){
            clientPackage.expiryDate = moment(clientPackage.expiryDate).toISOString();
          }
          clientPackage.budgetedMinutes = clientPackage.budgetedHours * 60;
          updates['users/' + clientPackage.owner + '/packageTemplates/' + clientPackage.uid] = clientPackage;
          return firebase.database().ref().update(updates)
          .then(function(){
            $log.info('Package template' + clientPackage.uid + ' has been saved.');
            userDataService.trackEvent('save-package-template');
            return resolve(true)
          })
          .catch(function(error){
            $log.info('Error saving package template '+ clientPackage.uid);
            $log.info(error);
            return reject(error)
          })
        })
      }// savePackage


      function getWeekSequence(clientPackage){
        return new Promise(function(resolve, reject){
          var sequence = {}, seedDate = moment(clientPackage.startDate);
          for (var thisStep = 1; thisStep < 13; thisStep++) {
            seedDate = moment(seedDate).add(clientPackage.schedule.frequency, 'weeks').day(clientPackage.schedule.day).startOf('day').toISOString();
            sequence[thisStep] = {
              id: thisStep,
              date: seedDate
            };
          }
          return resolve(sequence)
        });
      }// getWeekSequence

      function getMonthSequence(clientPackage){
        return new Promise(function(resolve, reject){
          var sequence = {}, seedDate = moment(clientPackage.startDate);
          for (var step = 1; step < 13; step++) {
            seedDate = moment(seedDate).add(clientPackage.schedule.frequency, 'months').set('date', clientPackage.schedule.day).startOf('day').toISOString();
            sequence[step] = {
              id: step,
              date: seedDate
            };
          }
          return resolve(sequence)
        });
      }// getMonthSequence

      function editPackage(clientPackage){
        userDataService.trackEvent('open-package');
        $mdDialog.show({
            controller: 'clientPackageDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/clientPackageService/clientPackageDialog.tmpl.html',
            parent: angular.element(document.body),
            locals: {
                clientPackage: clientPackage
            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });

      }// editPackage


      function refillPackage(clientPackage){
        $mdDialog.show({
            controller: 'refillPackageDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/clientPackageService/refillPackageDialog.tmpl.html',
            parent: angular.element(document.body),
            locals: {
                clientPackage: clientPackage
            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });
      }


      function submitRefill(refillRequest){
        return new Promise(function(resolve, reject){
          userDataService.trackEvent('submit-refill-request');
          return resolve(true);
        })
      }//

      function newPackage(client, isTemplate, billingPeriod){
        $log.info('packageService.newPackage');
        userDataService.trackEvent('new-package');
        return userDataService.getLoggedInUser()
        .then(function(results){
          var user = results, isDefault = false;
          // is this the only package for this workspace? If so, make it defeault.
          if(!_.has(client, 'packages') && !isTemplate){
            isDefault = true;
          }
          // define our object
            var newKey = firebase.database().ref('/clientPackages').push().key,
                now = moment().toISOString(),
                clientPackage = {
                  accountDate: client.owner+now,
                  accountStatus: client.owner+'active',
                  accrued: 0,
                  autoInvoice:false,
                  budgetAlerted: false,
                  budgetedMinutes: 0,
                  budgetedHours: 0,
                  defaultBudgetedHours: 0,
                  charges: 0,
                  cost:0,
                  dueAlerted: false,
                  expiryDate: false,
                  exemptMinutes: 0,
                  invoiceLabel: '',
                  isTemplate: false,
                  isDefault: isDefault,
                  label: client.profile.fullName,
                  notes: '',
                  notifyWhen: false,
                  notifyWhenLimit: 0,
                  offset: 0,
                  owner: client.owner,
                  qualifiedMinutes: 0,
                  rate: 0,
                  recalc: false,
                  renewable: false,
                  schedule: {
                    interval: 'month',
                    frequency: 1,
                    day: 1,
                    sequence: {},
                    triggerOffset: 0
                  },
                  startDate: now,
                  status: 'open',
                  timeZone: user.profile.timeZone,
                  totalMinutes: 0,
                  type: 'none',
                  uid: newKey,
                  whenNotified: false,
                  workspace: client.uid,
                  workspaceName: client.profile.fullName,
                  workspaceDate: client.uid+now,
                  workspaceStatus: client.uid+'active'
                }

                if(isTemplate){
                  clientPackage.isTemplate = true;
                }

                packageDialog(clientPackage, billingPeriod)
        })


        // open dialog
      }//

      function packageDialog(clientPackage, billingPeriod){

        $mdDialog.show({
            controller: 'clientPackageDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/clientPackageService/clientPackageDialog.tmpl.html',
            parent: angular.element(document.body),
            locals: {
                clientPackage: clientPackage,
                billingPeriod: billingPeriod
            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true,
            multiple: true
        });

      }// packageDialog

      function newPackageFromTemplate(template, client){
        userDataService.trackEvent('new-package-from-template');
        var now = moment().toISOString(),
            newKey = firebase.database().ref('/clientPackages').push().key
        delete template.timeStamp;
        var isDefault = false;
        // is this the only package for this workspace? If so, make it defeault.
        if(!_.has(client, 'packages')){
          isDefault = true;
        }
        template.fromTemplate = template.uid;// just so we have a source reference
        template.isDefault = isDefault;
        template.uid = newKey;
        template.isTemplate = false;
        template.startDate = moment();
        template.accountDate = client.owner + now;
        template.accountStatus = client.owner+'active';
        template.label = client.profile.fullName + ' ' + template.label;
        template.workspace = client.uid;
        template.workspaceDate = client.uid + now;
        template.workspaceStatus = client.uid + 'active'
        packageDialog(template);
      }

      function getPackageCharges(packageID){
        return new Promise(function(resolve, reject){
            return $firebaseArray(firebase.database().ref('/lineItemCharges').orderByChild('package').equalTo(packageID))
                    .$loaded(function(charges){
                      return resolve(charges)
                    })
        })
      }// getPackageCharges


      function newLineItem(clientPackage, auto){
        userDataService.trackEvent('new-line-item');
        var newKey = firebase.database().ref('/lineItemCharges').push().key,
            newLineItem = {
              uid: newKey,
              package: clientPackage.uid,
              workspace: clientPackage.workspace,
              owner: clientPackage.owner,
              type: 'charge'
            };
            if(!auto){
              lineItemDialog(newLineItem);
            } else {
              return newLineItem
            }

      }// newLineItem

      function lineItemDialog(lineItem){
        $mdDialog.show({
            controller: 'lineItemDialogController',
            controllerAs: 'vm', // see below
            templateUrl: 'app/app-services/clientPackageService/lineItemDialog.tmpl.html',
            parent: angular.element(document.body),
            locals: {
                lineItem: lineItem
            },
            bindToController: true,
            focusOnOpen: false,
            clickOutsideToClose: true,
            fullscreen: true
        });
      }// newLineItem

      function editLineItem(lineItem){
        userDataService.trackEvent('edit-line-item');
        lineItemDialog(lineItem)
      }// eidtLineItem

      function deleteLineItem(lineItem){
        var updates = {};
        updates['/lineItemCharges/' + lineItem.uid] = null;
        updates['/clientPackages/' + lineItem.package + '/recalc'] = true;
        return firebase.database().ref().update(updates)
        .then(function(){
          userDataService.trackEvent('delete-line-item');
          $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Line Item Charge Deleted!',
                        message: '' ,
                        color: 'green'
                    }
                }));// mdToast
        })
        .catch(function(error){
          $mdToast.show($mdToast.adminjaAlert(
              {
                  locals:{
                      title: 'Oops!',
                      message: 'We were unable to delete your charge. Please contact support if this continues to happen.' ,
                      color: 'red'
                  }
              }));// mdToast

          console.log('Couldn\'t delete new line item for package ' + lineItem.package);
          console.error(error);

        });

      }


      function saveLineItem(lineItem){
        // $log.info('saveLineItem');
        // $log.info(lineItem);
        lineItem = ajUTILITIES.removePropertiesWith(lineItem);
        if(!_.has(lineItem, 'timeStamp')){
          lineItem.timeStamp = moment().toISOString();
        }

        lineItem.date = moment(lineItem.date).toISOString();
        lineItem.packageDate = lineItem.package + moment(lineItem.date).toISOString();
        lineItem.accountDate = lineItem.owner + moment(lineItem.date).toISOString();
        lineItem.workspaceDate = lineItem.workspace + moment(lineItem.date).toISOString();
        lineItem.total = Number(Number(lineItem.quantity) * Number(lineItem.amount)).toFixed(2);
        var updates = {};
        updates['/lineItemCharges/' + lineItem.uid] = lineItem;
        updates['/clientPackages/' + lineItem.package + '/recalc'] = true;
        return firebase.database().ref().update(updates)
        .then(function(){
          userDataService.trackEvent('save-line-item');
          $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Line Item Charge Saved!',
                        message: '' ,
                        color: 'green'
                    }
                }));// mdToast
        })
        .catch(function(error){
          $mdToast.show($mdToast.adminjaAlert(
              {
                  locals:{
                      title: 'Oops!',
                      message: 'We were unable to save your charge. Please contact support if this continues to happen.' ,
                      color: 'red'
                  }
              }));// mdToast

          console.log('Couldn\'t save new line item for package ' + lineItem.package);
          console.error(error);

        })
      }// saveLineItem


      service.packageTypes = [
       {
        type: 'hourly',
        label: 'Renewable Hourly',
        description: 'Client will be charged hourly rates. Renews on a regular interval.',
        id: 1,
        renewable: true
       },
       {
        type: 'retainer',
        label: 'Renewable Retainer',
        description: 'Client is charged a fixed fee for a specified # of hours. Renews on a regular interval.',
        id: 2,
        renewable: true
       },
       {
        type: 'balance',
        label: 'Renewable Balance',
        description: 'Client is charged a set fee for a specified # of hours. Renews automatically when balance is depleted.',
        id: 3,
        renewable: true
       },
       {
         type: 'fixed',
         label: 'Fixed Fee',
         description: 'Client is charged a fixed fee. Hours are managed against an optional budget but do not incur hourly rates.\n Great for one-off projects.',
         id: 4,
         renewable: false
        },
        {
        type: 'refillable',
        label: 'Refillable Balance',
        description: 'Client pays a set fee for a certain number of hours. Additional hours can be added whenever necessary.',
        id: 5,
        renewable: false
       }
     ]

     service.monthDayOptions = [
       { value: 1, label: '1st', id: 1},
       { value: 2, label: '2nd', id: 2},
       { value: 3, label: '3rd', id: 3},
       { value: 4, label: '4th', id: 4},
       { value: 5, label: '5th', id: 5},
       { value: 6, label: '6th', id: 6},
       { value: 7, label: '7th', id: 7},
       { value: 8, label: '8th', id: 8},
       { value: 9, label: '9th', id: 9},
       { value: 10, label: '10th', id: 10},
       { value: 11, label: '11th', id: 11},
       { value: 12, label: '12th', id: 12},
       { value: 13, label: '13th', id: 13},
       { value: 14, label: '14th', id: 14},
       { value: 15, label: '15th', id: 15},
       { value: 16, label: '16th', id: 16},
       { value: 17, label: '17th', id: 17},
       { value: 18, label: '18th', id: 18},
       { value: 19, label: '19th', id: 19},
       { value: 20, label: '20th', id: 20},
       { value: 21, label: '21st', id: 21},
       { value: 22, label: '22nd', id: 22},
       { value: 23, label: '23rd', id: 23},
       { value: 24, label: '24th', id: 24},
       { value: 25, label: '25th', id: 25},
       { value: 26, label: '26th', id: 26},
       { value: 27, label: '27th', id: 27},
       { value: 28, label: '28th', id: 28}
     ]

     service.weekDayOptions = [
       { value: 'Monday', label: 'Monday', id: 1},
       { value: 'Tuesday', label: 'Tuesday', id: 2},
       { value: 'Wednesday', label: 'Wednesday', id: 3},
       { value: 'Thursday', label: 'Thursday', id: 4},
       { value: 'Friday', label: 'Friday', id: 5},
       { value: 'Saturday', label: 'Saturday', id: 6},
       { value: 'Sunday', label: 'Sunday', id: 7}
     ]

     return service;

    }

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('clientPackageDialogController', clientPackageDialogController);

///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// clientPackageDialogController

/* @ngInject */
function clientPackageDialogController($log,  $state, $mdDialog, dragulaService, $mdToast,  $timeout,  $rootScope,  $scope, timeDataService, invoiceService, userDataService, timeReportService, clientBillingService, clientDataService, clientPackageService) {
    $log.info('clientPackageDialogController');
    // Setup our core variables
    var vm = this;
    vm.user = userDataService.user,
    vm.settings = $rootScope.userSettings;
    vm.forms = {};
    vm.packageService = clientPackageService,
    // So it's easy to start over
    vm.cleanPackageState = angular.copy(vm.clientPackage);
    vm.currency = "$";
    if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
     }
     vm.editState = 'package';

      // add package's client to the model
     _.each(clientDataService.clients, function(client){
      if(client.uid == vm.clientPackage.workspace){
        vm.client = client;
      }
     })

     // Assign our functions to model
     vm.cancel = cancel;
     vm.selectType = selectType;
     vm.startOver = startOver;
     vm.calcRenewal = calcRenewal;
     vm.changeInterval = changeInterval;
     vm.dateChanged = dateChanged;
     vm.startDateFilter = startDateFilter;
     vm.savePackage = savePackage;
     vm.updatePackage = updatePackage;
     vm.savePackageTemplate = savePackageTemplate;
     vm.updatePackageTemplate = updatePackageTemplate;
     vm.newCategory = newCategory;
     vm.updateCategory = updateCategory;
     vm.deleteCategory = deleteCategory;
     vm.editCategory = editCategory;
     vm.changeState = changeState;
     vm.newOption = newOption;
     vm.updateOption = updateOption;
     vm.deleteOption = deleteOption;
     vm.editOption  = editOption;
     vm.getCreateDate = getCreateDate;
     vm.completeConversion = completeConversion;
     vm.selectTemplate = selectTemplate;
     // vm.validHours = /^[1-9]+[0-9]*$/




     // if we are editing an existing package
     if(_.has(vm.clientPackage, 'timeStamp')){
      if(vm.clientPackage.renewable){
        $log.info('Editing existing package');
      // Set our form options to match this package interval
        if(vm.clientPackage.schedule.interval == 'month'){
          vm.dayOptions = vm.packageService.monthDayOptions;
        }
        if(vm.clientPackage.schedule.interval == 'week'){
          vm.dayOptions = vm.packageService.weekDayOptions;
        }
        // set or default state to instance
        if(!vm.clientPackage.isTemplate){
          vm.editState = 'instance';
        }
        vm.calcRenewal(vm.clientPackage);
      }

      // set edit state if editing refillable
      // set or default state to instance
      if(vm.clientPackage.type == 'refillable' || vm.clientPackage.type == 'fixed'){
        vm.editState = 'instance';
      }
     }


     // When creating FROM a template - we need to get the typeLabel for this package type.
     if(!vm.clientPackage.timeStamp && vm.clientPackage.fromTemplate){
      // $log.info('Creating FROM a template');
      _.each(vm.packageService.packageTypes, function(packageType){
        if(packageType.type == vm.clientPackage.type){
          vm.typeLabel = packageType.label;
        }
      });

      // and make sure we've setup our dropdowns and processed a schedule
      if(vm.clientPackage.schedule.interval == 'month'){
        vm.dayOptions = vm.packageService.monthDayOptions;
      }
      if(vm.clientPackage.schedule.interval == 'week'){
        vm.dayOptions = vm.packageService.weekDayOptions;
      }
      calcRenewal(vm.clientPackage)
     }

     /////////////////////////////
     // if a billingPeriod was passed, we are converting a billingPeriod into a package.
     // we need to define the initial values
     if(vm.billingPeriod){
      definePackageFromBillingPeriod(vm.billingPeriod)
     }// if vm.billingPeriod


     /////////////////////////// Functions /////////////////////////////

     function selectTemplate(template){
      $mdDialog.cancel();
      clientPackageService.newPackageFromTemplate(template, vm.client)
     }

     function getCreateDate(date, offset){
      return moment(date).subtract(offset, 'days');
     }

     function changeState(newState){
      vm.editState = newState
     }//changeState

     // Category Manager
     function editCategory(category){
        $timeout(function(){
          vm.categorySpinner = true;
        },0);
        return timeDataService.getPackageTime(category.clientPackage)
        .then(function(time){
          var alreadyHasTime = false;
          _.each(time, function(entry){
            if(_.has(time, 'categoryID')){
              if(time.categoryID == category.uid){
                alreadyHasTime = true;
              }
            }
          });
          if(alreadyHasTime){
             var confirm = $mdDialog.confirm()
                      .title('Modify this category?')
                      .htmlContent('<p>This will alter any time already logged against this category.</p>')
                      .ariaLabel('Are you sure?')
                      .multiple(true)
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
              $timeout(function(){
                vm.categorySpinner = false;
                vm.editingCategory = category;
              },0);
            })
          } else {
            $timeout(function(){
              vm.categorySpinner = false;
              vm.editingCategory = category;
            },0)
          }
        });


     }//editCategory

     function newCategory(clientPackage){
      var order = _.size(vm.clientPackage.categories);
      vm.editingCategory =  vm.packageService.newCategory(clientPackage, order)
     }



     function updateCategory(clientPackage, category){
        var updates = {};

        // if it's not a template, check for time that may need updated
        if(!clientPackage.isTemplate){
        // modify rate and label for any time already assigned to this category
        // $log.info('Saving category on a live package');
          return timeDataService.getPackageTime(clientPackage.uid)
          .then(function(time){
            _.each(time, function(entry){
              if(_.has(entry, 'category')){
                if(entry.category.uid == category.uid){
                  entry.category = category;
                  entry.rate = category.rate;
                  entry.rateLabel = category.label;
                  entry.rateID = category.uid;
                  entry.category = category;
                  entry = ajUTILITIES.removePropertiesWith(entry);
                  updates['/time/' + entry.uid] = entry;
                }// if category match
              }// if time assigned to category
            });// each entry

            if(_.size(updates) > 0 && !clientPackage.isTemplate){
              updates['/clientPackages/' + clientPackage.uid + '/recalc'] = true;
            }
            return firebase.database().ref().update(updates)
            .then(function(){
              return vm.packageService.updateCategory(clientPackage, category)
              .then(function(){
                $timeout(function(){
                  vm.editingCategory = null;
                  // when we are creating a category, updates to the model don't get reflected in the dialog
                  // so we'll manually add them to the model
                  if(!_.has(clientPackage.categories, category.uid)){
                    clientPackage.categories[category.uid] = category;
                  }
                })
              });// update category
            })// update time
          });// getPackageTime
        } else {
          // If it is a template, just save the category
          // $log.info('Saving category on a template');
          return vm.packageService.updateCategory(clientPackage, category)
          .then(function(){
           $timeout(function(){
             vm.editingCategory = null;
             // when we are creating a category, updates to the model don't get reflected in the dialog
             // so we'll manually add them to the model
             if(!_.has(clientPackage.categories, category.uid)){
               clientPackage.categories[category.uid] = category;
             }
           })
          });// update category
        }

     }// updateCategory

     function deleteCategory(clientPackage, category){
        return timeDataService.getPackageTime(clientPackage.uid)
        .then(function(time){
          var alreadyHasTime = false;
          _.each(time, function(entry){
            if(_.has(time, 'categoryID')){
              if(time.categoryID == category.uid){
                alreadyHasTime = true;
              }
            }
          });
          if(alreadyHasTime){
             var confirm = $mdDialog.confirm()
                      .title('Category Cannot be Deleted')
                      .htmlContent('<p>You already have time logged against this category</p><p>Please assign this time to a different category first.</p>')
                      .ariaLabel('Are you sure?')
                      .multiple(true)
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {

            })
          } else {
             var confirm = $mdDialog.confirm()
                      .title('Delete Time Category?')
                      .htmlContent('<p>This cannot be undone.</p>')
                      .ariaLabel('Are you sure?')
                      .multiple(true)
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                return vm.packageService.deleteCategory(clientPackage, category)
                .then(function(){
                  $timeout(function(){
                    clientPackage.categories[category.uid] = null;
                  });
                })
            })

          }
        });//getPackageTime


     }// deleteCategory


     // Options Manager
     function editOption(option){

          $timeout(function(){
            vm.editingOption = option;
          },0)
     }//editOption

     function newOption(clientPackage){
      if(!_.has(clientPackage, 'refillOptions')){
        clientPackage.refillOptions = {}
      }
      var order = _.size(vm.clientPackage.refillOptions);
      vm.editingOption =  vm.packageService.newOption(clientPackage, order)
     }

     function updateOption(clientPackage, option){
          return vm.packageService.updateOption(clientPackage, option)
          .then(function(){
            vm.editingOption = null;
            // when we are creating a category, updates to the model don't get reflected in the dialog
            // so we'll manually add them to the model
            if(!_.has(clientPackage.refillOptions, option.uid)){
              clientPackage.refillOptions[option.uid] = option;
            }
          });// update category
     }// updateOption

     function deleteOption(clientPackage, option){
           var confirm = $mdDialog.confirm()
                    .title('Delete Refill Option?')
                    .htmlContent('<p>This cannot be undone.</p>')
                    .ariaLabel('Are you sure?')
                    .multiple(true)
                    .ok('Do it')
                    .cancel('Never mind');

          $mdDialog.show(confirm).then(function() {
              return vm.packageService.deleteOption(clientPackage, option)
              .then(function(){
                // update our local model
                $timeout(function(){
                  clientPackage.refillOptions[option.uid] = null;
                })
              })
          })
     }// deleteCategory

     function prepDatesForSave(clientPackage){
      return new Promise(function(resolve, reject){
        // Set our Start and Create Dates
        if(clientPackage.type != 'balance' && clientPackage.type != 'fixed' && clientPackage.type != 'refillable'){
          clientPackage.schedule.packageStart = moment(clientPackageService.getNextRenewal(clientPackage)).toISOString();
          clientPackage.endDate = moment(clientPackage.schedule.packageStart).subtract(1, 'ms').toISOString();
          clientPackage.schedule.packageCreate = moment(clientPackage.schedule.packageStart).toISOString();
          // Determine our next packageRenew and packageStart dates
          if(clientPackage.schedule.triggerOffset > 0){
            clientPackage.schedule.packageCreate = moment(clientPackage.schedule.packageStart).subtract(clientPackage.schedule.triggerOffset, 'days').toISOString();
          }
          // set our end date
          return resolve(clientPackage);
        } else {
          return resolve(clientPackage);
        }
      })

     }//prepDatesForSave

     function savePackage(clientPackage, converting){
        // $log.info('savePackage');
        $timeout(function(){
          vm.updating = true;
        })
        // if we are creating a new package.
        // use the defaultBudgetedHours input for budgetedHours
        // store the originalPackageID so the series can be queried.
        if(!clientPackage.timeStamp){
          clientPackage.budgetedHours = clientPackage.defaultBudgetedHours;
          if(!clientPackage.isTemplate){
            clientPackage.originalPackageID = clientPackage.uid;
          }
        }

        return prepDatesForSave(clientPackage)
        .then(function(clientPackage){
          // add timeStamp
          clientPackage.timeStamp = moment().toISOString();
          // set temporary isNew flag so package service knows how to handle first save.
          clientPackage.isNew = true;
          // if we don't already have a categories node...
          if(!_.has(clientPackage, 'categories')){
            clientPackage.categories = {};
          }

          // Add defaultRate as our first time category (even if originally present in template, package save can override it)
          clientPackage.categories['defaultRate'] = {
            order: 0,
            label: 'Default',
            rate: clientPackage.rate,
            uid: 'defaultRate',
            clientPackage: clientPackage.uid,
            adminOnly: false
          };

          return vm.packageService.savePackage(clientPackage)
          .then(function(response){
            if(response == true){
              $rootScope.$emit('packageAdded');
              // if we already have more than one category (because we are creating from a template), no need to prompt to add more on save
              if(!converting){
                if(_.size(clientPackage.categories)>1){
                  $mdDialog.cancel();
                } else {
                  $timeout(function(){
                    vm.updating = false;
                  })
                  vm.editState = 'nextSteps';
                }
              } else {
                // save was the result of a billingPeriod conversion. We now need to migrate the time, charges, and categories.
                return migrateBillingPeriod(clientPackage)
              }

            } else {
              $timeout(function(){
                vm.updating = false;
              })
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'We had a problem saving your package:',
                          message: error ,
                          color: 'red'
                      }
                  }));// mdToast
              $log.error(error);
            }
          });
        })

     }// savePackage

     function migrateBillingPeriod(clientPackage){
      $timeout(function(){
        vm.editState = 'converting'
        vm.conversionStatus = "Migrating Charges."
      })
      return migrateCharges(vm.fullBillingPeriod, clientPackage)
      .then(function(){
        $timeout(function(){
          vm.conversionStatus = "Migrating Time Categories."
        },1000)
        return migrateCategories(vm.client, clientPackage)
        .then(function(){
          $timeout(function(){
            vm.conversionStatus = "Migrating Time."
          },1000)
          return migrateTime(vm.billingPeriod, clientPackage)
          .then(function(){
            $timeout(function(){
              vm.conversionStatus = "Updating Workspace."
            },1000)
            var updates = {};
            updates['/clients/' + vm.client.uid + '/billingType'] = 'packages';
            return firebase.database().ref().update(updates)
            .then(function(){
              $timeout(function(){
                vm.editState = 'conversionConfirm';
                userDataService.trackEvent('client-billing-upgraded');
              }, 1000)
            })
          })
        })
      })
      .catch(function(error){
        $timeout(function(){
          vm.editState = 'conversionError';
          userDataService.trackEvent('client-billing-upgrade-failed');
          vm.conversionError = error;
        })
      })
     }// migrateBillingPeriod



     function migrateCharges(billingPeriod, clientPackage){
        // $log.info('migrateCharges');
        return new Promise(function(resolve, reject){
          var promises = [];
          _.each(billingPeriod.lineItems, function(lineItem){
            if(lineItem.type != 'recurringPlan'){
              var newLineItem = clientPackageService.newLineItem(clientPackage, true);
              newLineItem.amount = Number(lineItem.cost);
              newLineItem.quantity = Number(lineItem.quantity);
              newLineItem.description = lineItem.description;
              newLineItem.date = lineItem.date;
              promises.push(clientPackageService.saveLineItem(newLineItem))
            }
          });

          return Promise.all(promises)
          .then(function(){
            return resolve(true)
          })
          .catch(function(error){
            $log.error(error);
            return reject(error)
          });
        });
     }// migrateCharges

     function migrateTime(billingPeriod, clientPackage){
        return new Promise(function(resolve, reject){
          // get all time in billingPeriod range
          return clientBillingService.selectPeriod(billingPeriod)
          .then(function(){
            $timeout(function(){
              var time = timeReportService.report.data, promises = [];
              _.each(time, function(entry){
                if(!_.has(entry, 'category')){
                  // our default rate is stored on the package
                  if(entry.rateLabel == 'default'){
                    entry.category = clientPackage.categories['defaultRate'];
                  } else {
                    // migrated categories are stored in vm.newCategories for this exact purpose
                    _.each(vm.newCategories, function(category){
                      if(category.label == entry.rateLabel){
                        entry.category = category;
                      }
                    });
                  }
                  promises.push(updateTimeEntry(entry, clientPackage));
                }
              });
              return Promise.all(promises)
              .then(function(){
                return resolve(true);
              })
              .catch(function(error){
                return reject(error)
              })
            },5000)
          });


          // recalc package
        })
     }// migrateTime

     function updateTimeEntry(entry, clientPackage){
      return new Promise(function(resolve, reject){
        var updates = {};
        // now assign the entry to the package
        updates['/time/' + entry.uid + '/rate'] = entry.category.rate;
        updates['/time/' + entry.uid + '/rateLabel'] = entry.category.label;
        updates['/time/' + entry.uid + '/packageDate'] = clientPackage.uid + moment(entry.logDate).toISOString();
        updates['/time/' + entry.uid + '/packageID'] = clientPackage.uid
        updates['/time/' + entry.uid + '/packageLabel'] = clientPackage.invoiceLabel;
        updates['/time/' + entry.uid + '/packageType'] = clientPackage.type;

        return firebase.database().ref().update(updates)
        .then(function(){
          return resolve(true)
        })
        .catch(function(error){
          return reject(error)
        })
      });
     }// updateTimeEntry

     function migrateCategories(client, clientPackage){
        vm.newCategories = {};
        return new Promise(function(resolve, reject){
          if(_.has(client.profile, 'categories')){
            if(_.has(client.profile.categories, 'time')){
              var order = 0, promises = [];
              _.each(client.profile.categories.time, function(oldCategory){
                var newCategory = clientPackageService.newCategory(clientPackage, order);
                order = newCategory.order;
                newCategory.label = oldCategory.label;
                newCategory.rate = oldCategory.rate;
                newCategory.adminOnly = oldCategory.adminOnly;
                vm.newCategories[newCategory.uid] = newCategory;
                promises.push(clientPackageService.updateCategory(clientPackage, newCategory))
              });
              return Promise.all(promises)
              .then(function(){
                // $log.info(vm.newCategories);
                return resolve(true);
              })
              .catch(function(error){
                return reject(error);
              })
            }
          } else {
            return resolve(true);
          }
        })
     }// migrateCategories

     function completeConversion(){
      $mdDialog.cancel();
      $state.go('triangular.workspaces.client-billing');
     }// completeConversion

     function savePackageTemplate(clientPackage){
        // add timeStamp
        var newKey = firebase.database().ref('/clientPackages').push().key;
        clientPackage.categories = {};
        clientPackage.categories['defaultRate'] = {
          order: 0,
          label: 'Default',
          rate: clientPackage.rate,
          uid: 'defaultRate',
          clientPackage: clientPackage.uid,
          adminOnly: false
        };
        clientPackage.uid = newKey;
        clientPackage.isTemplate = true;
        clientPackage.timeStamp = moment().toISOString();
        return vm.packageService.savePackageTemplate(clientPackage)
        .then(function(response){
          if(response == true){
            vm.editState = 'nextSteps';
          } else {
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'We had a problem saving your package template:',
                        message: error ,
                        color: 'red'
                    }
                }));// mdToast
            $log.error(error);
          }
        });
        // then prompt to add time categories
     }// savePackageTemplate

     function updatePackageTemplate(clientPackage){
        // in case default rate was changed
        clientPackage.categories['defaultRate'] = {
          order: 0,
          label: 'Default',
          rate: clientPackage.rate,
          uid: 'defaultRate',
          clientPackage: clientPackage.uid,
          adminOnly: false
        };

        return vm.packageService.savePackageTemplate(clientPackage)
        .then(function(response){
          if(response == true){
            // $log.info('Controller: Package Template Updated');
            cancel();
          } else {
            $log.error(error);
          }
        });
     }// updatePackage

     function updatePackage(clientPackage){
      $timeout(function(){
        vm.updating = true;
      })
        return prepDatesForSave(clientPackage)
        .then(function(clientPackage){
          // in case budgetedMinutes was edited
          clientPackage.recalc = true;
          // in case default rate was changed
          clientPackage.categories['defaultRate'] = {
            order: 0,
            label: 'Default',
            rate: clientPackage.rate,
            uid: 'defaultRate',
            clientPackage: clientPackage.uid,
            adminOnly: false
          };
          // $log.info(clientPackage);
          return vm.packageService.savePackage(clientPackage)
          .then(function(response){
            if(response == true){
              // Hide and show directive so it rebuilds it's progress bar
              clientPackage.hide = true;
              $timeout(function(){
                delete clientPackage.hide
              },100)
              // $log.info('Controller: Package Updated');
              $timeout(function(){
                vm.updating = false;
              })
              cancel();
            } else {
              $timeout(function(){
                vm.updating = false;
              })
              $log.error(error);
            }
          });
        })
     }// updatePackage



     function dateChanged(clientPackage){
      calcRenewal(clientPackage);
     }

     function startDateFilter(date){
       //  var distance = 180;
       //  // start date should be restricted to within 1 period of the interval/frequency set

       // if(vm.clientPackage.renewable){
       //    if(vm.clientPackage.schedule.interval == 'month'){
       //      distance = 30 * Number(vm.clientPackage.schedule.frequency);
       //    }
       //    if(vm.clientPackage.schedule.interval == 'week'){
       //      distance = 7 * Number(vm.clientPackage.schedule.frequency)
       //    }
       // }

       // // add a buffer
       // distance = distance + 1;
       //  var now = moment().toISOString(),
       //      min = moment(now).subtract(distance, 'days').toISOString(),
       //      day = moment(date).toISOString(),
       //      dayNumber = Number(moment(date).format('D')),
       //      result = false;
       //      // if it's in the allowed range OR if we are converting from a billingPeriod, allow it
       //      if(day >= min || vm.billingPeriod){
       //          result = dayNumber;
       //      }
       //      return result
       return true
     }// startDateFilter

     function calcRenewal(clientPackage){
       if(clientPackage.renewable && clientPackage.type != 'balance'){
            if(clientPackage.schedule.interval == 'month'){
              return clientPackageService.getMonthSequence(clientPackage)
              .then(function(sequence){
                $timeout(function(){
                  vm.upcomingRenewals = sequence;
                  vm.clientPackage.schedule.packageStart = clientPackageService.getNextRenewal(clientPackage);
                })
              });
            }// if month

            if(clientPackage.schedule.interval == 'week'){
              vm.dayOptions = vm.packageService.weekDayOptions;
              return clientPackageService.getWeekSequence(clientPackage)
              .then(function(sequence){
                $timeout(function(){
                  vm.upcomingRenewals = sequence;
                  vm.clientPackage.schedule.packageStart = clientPackageService.getNextRenewal(clientPackage);
                })
              });
            }// if week
       }// if renewable

     }//calcRenewal


     function changeInterval(clientPackage){
        $timeout(function(){
          var interval = clientPackage.schedule.interval;
            if(interval == 'month'){
              vm.dayOptions = vm.packageService.monthDayOptions;
              if(!clientPackage.isTemplate){
                vm.clientPackage.schedule.day = 1;
              }
            }
            if(interval == 'week'){
              vm.dayOptions = vm.packageService.weekDayOptions;
              if(!clientPackage.isTemplate){
                vm.clientPackage.schedule.day = "Monday";
              }
            }
            calcRenewal(vm.clientPackage);
        })
     }// changeInterval




    function startOver(){
      vm.clientPackage = angular.copy(vm.cleanPackageState);
    }

    function selectType(packageType){
      if(packageType != 'none'){
          vm.clientPackage.type = packageType.type;
          vm.clientPackage.renewable = packageType.renewable;
          vm.typeLabel = packageType.label;
          vm.clientPackage.label = vm.typeLabel;
          vm.clientPackage.invoiceLabel = vm.typeLabel;
          // Set our form options to match this package interval
          if(vm.clientPackage.renewable){
            vm.changeInterval(vm.clientPackage);
          }

          if(vm.clientPackage.type == 'refillable' || vm.clientPackage.type == 'fixed'){
            vm.clientPackage.expiryDate = moment().add(3, 'months');
          }
          // select the label field
          $timeout(function(){
            var labelField = document.getElementById('package-label');
            labelField.focus();
            labelField.select();
          }, 500);

      } else {
        $mdDialog.cancel();
      }

    }

    //// dragula setup for categories
    dragulaService.options($scope, 'drag-category', {
        moves: function (el, container, handle) {
                return !handle.classList.contains('drag-handle');
            // return handle.classList.contains('task-handle');
        },
        accepts: function (el, target, source, sibling) {
            // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

           return true

        },
        invalid: function(el, handle){
            // return var === 'condition'
            return false
        },
        direction: vm.taskDragDirection,
        revertOnSpill: true
    })


    // declare our categoryBag so we can track drake.dragging
    var categoryBag = dragulaService.find($scope, 'drag-category');
    $scope.$on('drag-category.drag', function(event, item, target, source, sibling){
        // On mobile this prevents the default page scrolling while dragging an item.
        $(document).on('touchstart', function(e) {
            e.preventDefault();
        });

    })
    $scope.$on('drag-category.drop', function (event, item, target, source, sibling) {
        $(document).off('touchstart')
        // Now we can do our work - prep the variables
        var itemID = item[0].attributes.catid.value,
                thisContainer = $('.client-category-manager'),
                sortItems = Array.from(thisContainer.find('.category-item'));

        // Change sort order
        _.each(sortItems, function(category, index){
            var catID = category.attributes.catid.value,
            childCategoryObject = vm.clientPackage.categories[catID];
            childCategoryObject.order = index + 1;
        });
        if(vm.clientPackage.isTemplate){
          return vm.packageService.savePackageTemplate(vm.clientPackage);
        } else {
          return vm.packageService.savePackage(vm.clientPackage);
        }


    });// drag-category.drop

    //// dragula setup for refill options
    dragulaService.options($scope, 'drag-option', {
        moves: function (el, container, handle) {
                return !handle.classList.contains('drag-handle');
            // return handle.classList.contains('task-handle');
        },
        accepts: function (el, target, source, sibling) {
            // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

           return true

        },
        invalid: function(el, handle){
            // return var === 'condition'
            return false
        },
        direction: vm.taskDragDirection,
        revertOnSpill: true
    })


    // declare our categoryBag so we can track drake.dragging
    var categoryBag = dragulaService.find($scope, 'drag-option');
    $scope.$on('drag-option.drag', function(event, item, target, source, sibling){
        // On mobile this prevents the default page scrolling while dragging an item.
        $(document).on('touchstart', function(e) {
            e.preventDefault();
        });

    })
    $scope.$on('drag-option.drop', function (event, item, target, source, sibling) {
        $(document).off('touchstart')
        $log.info('drop');
        // Now we can do our work - prep the variables
        var itemID = item[0].attributes.catid.value,
                thisContainer = $('.client-options-manager'),
                sortItems = Array.from(thisContainer.find('.option-item'));

        // Change sort order
        _.each(sortItems, function(category, index){
            var catID = category.attributes.catid.value,
            childCategoryObject = vm.clientPackage.refillOptions[catID];
            childCategoryObject.order = index + 1;
        });
        if(vm.clientPackage.isTemplate){
          return vm.packageService.savePackageTemplate(vm.clientPackage);
        } else {
          return vm.packageService.savePackage(vm.clientPackage);
        }

    });// drag-option.drop
    function cancel(){
      $mdDialog.cancel();
    }

    function definePackageFromBillingPeriod(){
     return firebase.database().ref('/billingPeriods/' + vm.billingPeriod.uid).once('value', function(snapshot){
       if(snapshot.exists()){
         // set start date
         vm.fullBillingPeriod = snapshot.val();

         var packageType = undefined;
         _.each(clientDataService.clients, function(thisClient){
           if(thisClient.uid == vm.billingPeriod.client){
             vm.client = thisClient
           }
         });

         switch(vm.billingPeriod.type) {
             case 'retainer':
                 if(vm.billingPeriod.recurrenceType != 'zero'){
                   packageType = 'retainer';
                   vm.clientPackage.budgetedHours = Number(vm.billingPeriod.allocated);
                   vm.clientPackage.defaultBudgetedHours = Number(vm.client.profile.plan.allocated);
                   vm.clientPackage.budgetedMinutes = vm.clientPackage.budgetedHours * 60;
                   vm.clientPackage.cost = Number(vm.billingPeriod.cost);
                   vm.clientPackage.startDate = vm.billingPeriod.start;
                   vm.clientPackage.endDate = vm.billingPeriod.end;
                   vm.clientPackage.schedule.frequency = vm.client.profile.plan.interval;

                   if(vm.client.profile.recurrenceType == 'month'){
                     vm.clientPackage.schedule.interval = 'month';
                     vm.clientPackage.schedule.day = vm.client.profile.plan.monthDay;
                   }
                   if(vm.client.profile.recurrenceType == 'week'){
                     vm.clientPackage.schedule.interval = 'week';
                     vm.clientPackage.schedule.day = vm.client.profile.plan.displayWeekDay;
                   }

                 } else {
                   packageType = 'balance';
                   vm.clientPackage.budgetedHours = Number(vm.billingPeriod.allocated);
                   vm.clientPackage.defaultBudgetedHours = Number(vm.client.profile.plan.allocated);
                   vm.clientPackage.budgetedMinutes = vm.clientPackage.budgetedHours * 60;
                   vm.clientPackage.cost = Number(vm.billingPeriod.cost);
                   vm.clientPackage.startDate = vm.billingPeriod.start;
                 }
                 break;
             case 'hourly':
                 packageType = 'hourly';
                 vm.clientPackage.startDate = vm.billingPeriod.start;
                 vm.clientPackage.endDate = vm.billingPeriod.end;
                 vm.clientPackage.schedule.frequency = vm.client.profile.plan.interval;
                 if(vm.client.profile.recurrenceType == 'month'){
                   vm.clientPackage.schedule.interval = 'month';
                   vm.clientPackage.schedule.day = vm.client.profile.plan.monthDay;
                 }
                 if(vm.client.profile.recurrenceType == 'week'){
                   vm.clientPackage.schedule.interval = 'week';
                   vm.clientPackage.schedule.day = vm.client.profile.plan.displayWeekDay;
                 }
                 vm.clientPackage.rate = Number(vm.client.profile.plan.rate);
                 break;
             default:
                 packageType = 'retainer';
               }

               if(_.has(vm.client.profile.plan, 'notifyWhen')){
                 if(vm.client.profile.plan.notifyWhen){
                   vm.clientPackage.notifyWhen = true;
                   vm.clientPackage.notifyWhenLimit = Number(vm.client.profile.plan.notifyWhenLimit);
                   if(packageType != 'hourly'){
                     vm.clientPackage.notifyWhenLimit = 100 - Number(vm.client.profile.plan.notifyWhenLimit);
                   }
                 }
               }

         _.each(clientPackageService.packageTypes, function(thisType){
           if(thisType.type == packageType){
             packageType = thisType;
           }
         });

         vm.selectType(packageType);
         vm.forms.packageForm.$setDirty();
       } else {
         alert('Could not locate billing period information. Please contact help@getadminja.com to complete this process.')
       }
     })
    }//definePackageFromBillingPeriod

}//clientPackageDialogController

})();

;(function () {
    'use strict';

    angular.module('appServices')
            .controller('workspaceAddressDialogController', workspaceAddressDialogController);


///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// workspaceAddressDialogController

/* @ngInject */
function workspaceAddressDialogController($log, $filter,  gateService, $mdDialog, $mdToast, client, clientDataService, userDataService, $timeout, $rootScope, $scope, $state) {
    // Force appcues trigger after delay...to acommodate it's failure at fireing on locationchange success

    var vm = this;
    // client is already provided
    vm.client = client;
    vm.inputPattern = /^\d+$/;
    vm.userType = $rootScope.admin;
    vm.inputOptions = { updateOn: 'default blur',
                             debounce: {
                               default: 300,
                               blur: 0
                             }
                        };
    vm.workspaceAddress = "customaddress";
    if(_.has(vm.client.profile, 'workspaceAddress')){
        vm.workspaceAddress = vm.client.profile.workspaceAddress
        vm.addressVerified = true;
    };

    var prohibited = [
        '`', '~', '!', '@', '#', '$', '%', '^', '&', '*',
        '(', ')', '=', '+', '[', ']', '\'', '\"', '\\', '|',
        ';', ':', "'", '"', '<', '>', ',', '.', '/', '?','\ '
    ]

    // Focus the field (it's an editable HTML element)
     $timeout(function () {
       document.getElementById("workspaceaddress").focus();
   }, 500, false);

vm.checkKey = function(){
    var e = event || window.event;  // get event object
       var key = e.keyCode || e.which; // get key cross-browser

       var e = event || window.event;
         var key = e.keyCode || e.which;
         $log.info(e.keyCode + '|' + e.which);


         // if (((key>=48)&&(key<=57))||(key==8)||(key == 46)) { //allow backspace //and delete
         //         if (e.preventDefault) e.preventDefault();
         //         e.returnValue = false;
         // }
}


vm.checkAvailability = function(address){
  // $log.info('checkAvailability triggered');
    vm.setDirty();
    if(address){
      // $log.info('has address..checking.');
        var letters = address.split('');

        var pass = true;

        if (/\s/.test(address)) {
            // It has any kind of whitespace
            pass = false;
        }

        // make sure they aren't using prohibited characters
        _.each(letters, function(letter){
            _.each(prohibited, function(bad){
                if(bad === letter){
                    pass = false;
                }
            })
        });

        if(pass){
          // $log.info('input passes. polling for ' + address);
            $timeout(function(){
                vm.checking = true;
            }, 0);
            var workspaceRef = firebase.database().ref('workspaceAddresses');
            return workspaceRef.child(address).once('value',
                function(snapshot){
                    // Workspace Found
                    if(snapshot.exists()){
                      // $log.info('snapshot exists!');
                        var workspaceAddress = snapshot.val();
                        // if the one we found belongs to this workspace, it's still valid
                        if(workspaceAddress.uid == vm.client.uid){
                            $timeout(function(){
                                vm.addressVerified = true;
                                vm.checking = false;
                            },0);
                        } else {
                            // the workspaceAddress we found isn't for this workspace
                            $timeout(function(){
                                vm.addressVerified = false;
                                vm.checking = false;
                            },0);
                        }

                    } else {
                      // $log.info('snapshot doesn\'t exist!');
                        $timeout(function(){
                            vm.addressVerified = true;
                            vm.checking = false;
                        },0);
                    }
            });

        } else {
                   vm.failedPass = true;
               }
    } else {
      vm.checking = false;
      // $log.info('nothing to check.');
    }// if address


}// checkAvailability


vm.isAddressValid = function(address){
      if(address.length < 4 || address.length > 20){
          return false
      } else {
          return true
      }
}
vm.updateWorkspaceAddress = function(client, address){
    $log.info('vm.updateWorkspaceAddress');
    var cleanAddress = _.trim(address), updates = {};
    // Prep our workspaceAddress object
    var newWorkspaceAddress = {
        address: cleanAddress,
        owner: client.owner,
        uid: client.uid,
        created: moment().toISOString()
    },
        updates = {};

    if(_.has(client.profile, 'workspaceAddress')){
        // if we aren't changing it. Don't do anything
        if(client.profile.workspaceAddress == cleanAddress){
            vm.cancelDialog();
            return
        } else {
            // we already have an address, we'll need to remove it from the nodes
            updates['/workspaceAddresses/' + client.profile.workspaceAddress] = null;
        }
    }

    $log.info('Continuing with updates.');
    // Update workspaceAddress
    updates['/workspaceAddresses/' + cleanAddress] = newWorkspaceAddress;
    // Update client.profile.workspaceAddress
    updates['/clients/'+ client.uid + '/profile/workspaceAddress'] = cleanAddress;
    // Tag the user account that they've used this feature
    updates['/users/'+ $rootScope.userID + '/profile/onboardingFlags/hasWorkspaceAddress'] = true;
    return firebase.database().ref().update(updates)
    // Add the default "Client Details" panel to this client
    .then(function (response) {
        // update our local copy for instant gui refresh
        $timeout(function(){
            vm.client.profile.workspaceAddress = cleanAddress;
            userDataService.trackEvent('claim-workspace-address');
            // tag it in drip so they get the instruction email
             _dcq.push(["identify", {
              email: userDataService.user.email,
              tags: ['hasWorkspaceAddress']
            }]);

            vm.showConfirm = true;
        },0)
        .then(function(){
          return userDataService.count(client.owner, 'workspaceInboxes', 1)
        });
    });

}// updateWorkspaceAddress

  vm.setDirty = function(){
       vm.workspaceAddressForm.$setDirty();
       vm.addressVerified = false;
       vm.failedPass = false;
   }

    vm.cancelDialog = function (task) {
        $mdDialog.cancel();
    };



}

})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('clientStatusReportController', clientStatusReportController);
///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// clientStatusReportController

/* @ngInject */
function clientStatusReportController($log, $mdDialog, $mdToast,  $timeout,  $rootScope,  $scope, client,  clientDataService, userDataService) {
    // $log.info('paymentDialogController');
    var vm = this;
    vm.client = client;
    vm.sendManualReport = sendManualReport;
    vm.updateManualReport = updateManualReport;
    vm.cancel = cancel;
    vm.showSample = showSample;

    vm.manualReport = {
            includeBillingPeriod: true,
            includeTimeDetail: true,
            includeTaskStatus: true,
            showForm: false,
            recipients: vm.client.profile.email,
            offset: userDataService.user.profile.timeZoneOffset,
            start: moment().subtract(7, 'days').startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        }

   function cancel(){
   	$mdDialog.cancel();
   }

    function resetManualReport(){
       vm.manualReport.includeBillingPeriod = true;
       vm.manualReport.includeTimeDetail = true;
       vm.manualReport.includeTaskStatus = true;
       delete vm.manualReport.start;
       delete vm.manualReport.end;
       vm.manualReport.recipients = vm.client.profile.email;
    }

    function updateManualReport(){
        // set maxdate for start
        vm.manualReport.maxStart = vm.manualReport.end;
        vm.manualReport.minEnd = vm.manualReport.start;
        vm.manualReport.start = moment(vm.manualReport.start).startOf('day');
        vm.manualReport.end = moment(vm.manualReport.end).endOf('day');
        // set minDate for end
    }

    function sendManualReport(report){
        vm.manualReport.sending = true;
        var now = moment().toISOString();
        var scheduleID = firebase.database().ref('/schedules').push().key;
        var newSchedule = {
          isCustom: true,
          owner: $rootScope.userID,
          offset: Number(userDataService.user.profile.timeZoneOffset),
          timeZone: userDataService.user.profile.timeZone, // we will move over to this in the future
          client: vm.client.uid,
          path: '/clients/'+client.uid+'/schedules',
          type: 'weekly-client-report',
          created: moment().toISOString(),
          start: moment(report.start).toISOString(),
          end: moment(report.end).toISOString(),
          startLabel: moment(report.start).format('MMM D'),
          endLabel: moment(report.end).format('MMM D'),
          status: 'active',
          repeat: false,
          includeBillingPeriod: report.includeBillingPeriod,
          includeTimeDetail: report.includeTimeDetail,
          includeTaskStatus: report.includeTaskStatus,
          message: 'Custom client report for ' + vm.client.profile.fullName + ' has been sent.',
          payload: {
            scheduleID: scheduleID,
            message: 'Custom client report for ' + vm.client.profile.fullName + ' has been sent.',
            when: now,
            recipients: report.recipients
          },
          when: now,
          uid: scheduleID
        }// newSchedule

        var updates = {};
        updates['/schedules/' + scheduleID] = newSchedule;
        return firebase.database().ref().update(updates)
        .then(function(){
            userDataService.trackEvent('send-client-status-report');
            $timeout(function(){
                vm.manualReport.sending = false;
                vm.manualReport.sent = true;
            },0)
            resetManualReport();
        });
    }// sendManualReport


    function showSample(){
         var showImage = $mdDialog.confirm()
                  .title('Client Status Report Sample')
                  .htmlContent('<img flex style="max-width: 400px;" src="/assets/images/reports/client-weekly-status-sample.png">')
                  .multiple(true)
                  .ariaLabel('Ok')
                  .ok('Close')

            $mdDialog.show(showImage);
    }

}//clientStatusReportController
})();

(function () {
    'use strict';

    angular.module('appServices')
            .controller('clientDialogController', clientDialogController);


///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// clientDialogController

/* @ngInject */
function clientDialogController($log, $filter, dragulaService, gateService, teamDataService, userDataService, $mdDialog, $mdToast, client, tab, triMenu, clientDataService, $timeout, clientColors, $rootScope, title, $scope, hotkeys, timeDataService, $state, canOpenDialog, clientPackageService, scheduleDataService) {
    // Force appcues trigger after delay...to acommodate it's failure at fireing on locationchange success

    var clientConsent = false;
    if(userDataService.hasConsent('clients')){
        clientConsent = true;
    } else {
        return userDataService.getConsent('clients', 'We need permission first! Is Adminja allowed to store information about your clients?','<p>In order to use Adminja, we need permission to store your client\'s information. <br> We will only store the information you choose to submit.' )
    };

    var vm = this;
    vm.isCurrentPeriod = isCurrentPeriod;
    vm.user = userDataService.user;
    vm.getMonthSequence = getMonthSequence;
    vm.getWeekSequence = getWeekSequence;
    vm.calcRenewal = calcRenewal;
    vm.setupInvoicing = setupInvoicing;
    vm.changeInterval = changeInterval;
    vm.populateRecipients = populateRecipients;
    vm.getNextOccurence = getNextOccurence;
    vm.sendStatusReport = sendStatusReport;


    // Determine if they have client-access
    vm.usersPlan = gateService.gateData.planID;
    vm.canClientAccess = true;
    vm.showCurrentPeriodInfo = false;
    if(vm.usersPlan.startsWith('starter') || vm.usersPlan.startsWith('assistant')){
        vm.canClientAccess = false;
    }

    if(tab){
        vm.tab = tab;
    }
    // client is already provided
    vm.client = client;

    if(!_.has(vm.client, 'settings')){
        vm.client.settings = {}
    }

    vm.fbConfig = fbConfig;
    vm.canOpenDialog = canOpenDialog;
    vm.settings = $rootScope.userSettings;
    vm.hasBilling = _.has(vm.client, 'billing');
    vm.now = moment().toISOString();
    vm.debugForm = false;
    vm.clientUserLimit = gateService.gateData.clientUserLimit;
    // $log.info('passed to dialog: '+ vm.canOpenDialog);

    if(!_.has(vm.client.profile, 'plan.type')){
        vm.client.profile.plan.type = 'none';
    }

    // if new client, put today as default start date
    if(!_.has(vm.client, 'uid') || !_.has(vm.client.profile, 'startDate')){
        vm.client.profile.startDate = moment().toDate();
    }

    //if reports not setup, pre-fill fields
    if(_.has(vm.client.profile, 'email')){
        if(!_.has(vm.client.profile, 'weeklyStatusReport')){
            vm.client.profile.weeklyStatusReport = {
                    day: 'friday',
                    time: 8,
                    includeBillingPeriod: true,
                    includeTimeDetail: true,
                    includeTaskStatus: true,
                    recipients: vm.client.profile.email,
                    lastUpdated: moment().toISOString(),
                    offset: userDataService.user.profile.timeZoneOffset
                }

        }// if reports

    }// if we have client email address

    // Prep years array for birthday
    var max = moment().format('YYYY'),
        min = Number(max) - 120;
        max = Number(max);

    vm.years = [];

      for (var i = max; i >= min; i--) {
        vm.years.push(i)
      }
    max = 31;
    min = 1;
    vm.days = [];
    for (var i = min; i<= max; i++){
        vm.days.push(i);
    }


    // prep our paymentProcessor control
    // Setup payment Processor Selector Support
    vm.paymentProcessors = [
      {label: 'No Payment Link', value: 'none'}
    ];
    if(vm.user.profile.settings.paypalEnabled){
      vm.paymentProcessors.push({label: 'PayPal', value: 'paypal'})
    }
    if(vm.user.profile.settings.stripeEnabled){
      vm.paymentProcessors.push({label: 'Stripe', value: 'stripe'})
    }
    if(vm.user.profile.settings.urlEnabled){
      vm.paymentProcessors.push({label: 'Custom Payment Link', value: 'url'})
    }
    vm.selectedPaymentProcessor = 'none';
    if(_.has(vm.client.profile, 'settings')){
        if(vm.client.profile.settings.enablePaypal){
          vm.selectedPaymentProcessor = 'paypal';
        }
        if(vm.client.profile.settings.enableStripe){
          vm.selectedPaymentProcessor = 'stripe';
        }

        if(vm.client.profile.settings.enableURL){
          vm.selectedPaymentProcessor = 'url';
        }
    }

    function sendStatusReport(client){
        return clientDataService.sendStatusReport(client);
    }//sendStatusReport

    vm.changePaymentProcessor = function(processor){
      // $log.info('changePaymentProcessor');
      // $log.info(processor);
      if(processor == 'paypal'){
        vm.client.profile.settings.enablePaypal = true;
        vm.client.profile.settings.enableStripe = false;
        vm.client.profile.settings.enableURL = false;
      }

      if(processor == 'stripe'){
        vm.client.profile.settings.enablePaypal = false;
        vm.client.profile.settings.enableStripe = true;
        vm.client.profile.settings.enableURL = false;
      }

    if(processor == 'url'){
      vm.client.profile.settings.enablePaypal = false;
      vm.client.profile.settings.enableStripe = false;
      vm.client.profile.settings.enableURL = true;
    }


      if(processor == 'none'){
        vm.client.profile.settings.enablePaypal = false;
        vm.client.profile.settings.enableStripe = false;
        vm.client.profile.settings.enableURL = false;
      }
    }

    vm.groupingChanged = function(group){
        // $log.info('grouping changed: ' + group);
        if(group == 'none'){
            $timeout(function(){
                vm.client.profile.settings.showTimeDetail = true
            })
        }
        // $log.info(vm.client.profile.settings.showTimeDetail);
    }//


    vm.groupingOptions = [
            {
              label: 'No Grouping',
              value: 'none'
            },
            {
              label: 'Package',
              value: 'package'
            },{
              label: 'Category',
              value: 'category'
            },
            {
              label: 'Task',
              value: 'task'
            },
            {
              label: 'Team Member',
              value: 'member'
            }
          ]


          vm.removeLogo = function(){
              vm.client.profile.settings.logo = null;
              vm.clientDialogForm.$pristine = false;
          };

          vm.uploadLogo = function($files) {
              // $log.info('upload logo');
              // $log.info($files);
              if($files !== null && $files.length > 0) {
                  var storage = firebase.storage(),
                      storageRef = storage.ref();

                      _.each($files, function(file){

                          // $log.info('Saving '+filename);
                          var filename = vm.client.uid + '_invoiceLogo.' + file.type;
                          // $log.info(filename);

                          var imageRef = storageRef.child('clients/' + vm.client.uid + '/invoicing/' + filename);

                          var uploadTask = imageRef.put(file);

                          uploadTask.on('state_changed', function(snapshot){
                              // observe state change for progress, pause, resume
                              // $log.info('upload state changed');
                          }, function(error){
                              $log.warn('upload failed');
                              // Handle unsuccessful upload
                          }, function(success){
                              $log.info('upload success');
                              return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadUrl){
                                 $timeout(function(){
                                        vm.client.profile.settings.logo = downloadUrl;
                                        vm.clientDialogForm.$pristine = false;
                                    },0);

                              });

                          });// uploadTask.on
                      });// ._each files
              } // if files
          };// vm.uploadLogo
    // locate the current period
    if(vm.client.billingType != "packages"){
        _.each(vm.client.billing, function(period){
            if(vm.isCurrentPeriod(period)){
                vm.currentPeriod = period;
            }
        })

    // Due to varying changes through the years, this form is very complex and we have an issue with copied clients not having the right properties for this form to work properly.
    // The following checks are to ensure that the default properties exist if billing is not already set upso the form displays properly.

        if(!_.has(vm.client.profile.plan, 'allocated')){
            vm.client.profile.plan.allocated = 0;
        }

        if(!_.has(vm.client.profile.plan, 'cost')){
            vm.client.profile.plan.cost = 0;
        }

        if(!_.has(vm.client.profile.plan, 'displayWeekDay')){
            vm.client.profile.plan.displayWeekDay = "Monday";
        }

        if(!_.has(vm.client.profile.plan, 'interval')){
                vm.client.profile.plan.interval = 1;
            }

        if(!_.has(vm.client.profile.plan, 'rate')){
                vm.client.profile.plan.rate = 0;
            }

        if(!_.has(vm.client.profile.plan, 'recurrenceType')){
                vm.client.profile.plan.recurrenceType = 'month';
            }


        if(!_.has(vm.client.profile.plan, 'weekDay')){
                vm.client.profile.plan.weekDay = 'MO';
            }
        }// if not packages billing


vm.visitBilling = function(client){
    $mdDialog.cancel();
    $state.go("triangular.workspaces.client-legacy-billing", {"clientID": client.uid});
}



    // make sure we have our invoicing schedule nodes or updates will fail
    if(!_.has(vm.client.profile, 'settings')){
        vm.client.profile.settings = {
            autoInvoice: false,
            invoiceFrequency: 1,
            invoiceInterval: 'month',
            invoiceDay: 1,
            autoSendInvoice: false
        }
    }// if doesn't have profile/settings node

    vm.clientCopy = angular.copy(client);

    vm.teamDataService = teamDataService;
    vm.clientColors = clientColors;
    vm.countries = $rootScope.countries;
    vm.title = title;
    vm.userType = $rootScope.admin;
    vm.selectedTabIndex = 0;
    if(vm.tab){
        vm.selectedTabIndex = vm.tab;

        // if we are opening dialog and requesting tab 4, it's for a manual report.
        if(vm.tab == 4){
            vm.manualReport.showForm = true
        }
    }
    vm.inputOptions = { updateOn: 'default blur',
                             debounce: {
                               default: 300,
                               blur: 0
                             }
                        };
    vm.currency = "$";
    vm.teamLimit = gateService.gateData.teamLimit;
    vm.showAvatar = true;

    // info for current billing period status
    if(_.has(vm.client, 'billing') && _.has(vm.client.profile.plan, 'currentPeriod')){
        if(_.has(vm.client.billing, 'vm.client.profile.plan.currentPeriod')){
            vm.currentPeriodStart = vm.client.billing[vm.client.profile.plan.currentPeriod].start;
            vm.currentPeriodEnd = vm.client.billing[vm.client.profile.plan.currentPeriod].end;
            // if(vm.client.profile.plan.recurrenceType == 'zero'){
            //     vm.currentPeriodEnd = vm.client.billing[vm.client.profile.plan.currentPeriod].expirationDate;
            // }
        } else {
            _.each(vm.client.billing, function(period){
                if(isCurrentPeriod(period)){
                    vm.currentPeriodStart = period.start;
                    vm.currentPeriodEnd = period.end;
                    // if(vm.client.profile.plan.recurrenceType == 'zero'){
                    //     vm.currentPeriodEnd = vm.client.billing[vm.client.profile.plan.currentPeriod].expirationDate;
                    // }
                }
            })
        }

        vm.showCurrentPeriodInfo = true;
    }


    // Set our default for our select
    if(!vm.client.status){
        vm.client.status = 'active'
    }

    if(vm.teamLimit > 1 && _.has(vm.client.access.admins, $rootScope.userID)){
        vm.showTeam = true;
    }

    if(vm.client.billingType != 'packages'){
        // convert our simple nextCycleDate to a date object the datepicker can use and display accurately:
        if(_.has(vm.client, 'profile.plan.nextCycle')){
            $log.info('Already has nextCycle. Using that');
            // vm.displayNextCycle = moment().startOf('day').toDate();
            vm.displayNextCycle = moment(vm.client.profile.plan.nextCycle).startOf('day').toDate();
        } else {
            $log.info('Doesnt have nextCycle. Checking for billing periods');
            // if they already have billing periods (and are just restarting plans) - make sure nextDate is after last period
            if(_.has(vm.client, 'billing')){
                $log.info('Has billing periods');
                var lastDay = moment().toISOString();
                _.each(vm.client.billing, function(period){
                    if (period.end > lastDay){
                        lastDay = period.end;
                    }
                });
                $log.info('Last period end date: ' + moment(lastDay).toISOString());
                // we have last endDate. Make sure nextCycle is after that
                vm.client.profile.plan.nextCycle = moment(lastDay).add(1, 'ms');
                vm.displayNextCycle = moment(vm.client.profile.plan.nextCycle).toDate();
            } else {
                $log.info('NO next cycle. No Billing plans. Using start of current month.');
                // no previous billing plans. Suggest start date at beginning of this month
                vm.client.profile.plan.nextCycle = moment().startOf('month').startOf('day');
                vm.displayNextCycle =moment(vm.client.profile.plan.nextCycle).toDate();
            }
        }
    }// if not package billing

    if(_.has(vm.settings, 'currency')){
        vm.currency = vm.settings.currency;
    }

    // isolate the teamList for this client
     vm.thisMember = undefined;

    // Set defaults
    vm.canEdit = false;
    vm.isOwner = false;
    vm.isAdmin = false;
    vm.isClientUser = false;

    if(_.has(vm.client, 'clientUsers['+$rootScope.userID+']')){
        vm.isClientUser = true;
        vm.canEdit = true;
    }
    // Check to see if current user is admin or member so we can restrict which time entries they can see here

    var teamSize = 0;
    // If we don't check here, errors for solo accounts may get thrown.
    if(_.has(teamDataService, 'clientTeams')){
        if(_.has(teamDataService.clientTeams, vm.client.uid)){
            vm.clientTeam = teamDataService.clientTeams[vm.client.uid];
            teamSize = _.keys(vm.clientTeam).length;
        } else {
            // Has teams but not for this client.
        }
    }


    // if we have a team, check for permissions to edit otherwise, allow it
    if(teamSize > 0 && !vm.isClientUser){
        vm.role = vm.clientTeam[$rootScope.userID].role;
        // check if this user is owner, admin, or just a member

        if(vm.role == 'owner' || teamDataService.isTeamAdmin($rootScope.userID, vm.client.owner)){
            vm.isOwner = true;
            vm.isAdmin = true;
            vm.canEdit = true;
            // if not owner, check to see if admin or member
        } else if (vm.role == 'admin'){
            vm.isAdmin = true;
            vm.canEdit = true;
        } else if (vm.role != 'admin' && vm.role != 'owner'){
            vm.isAdmin = false;
            vm.canEdit = false;
            vm.isOwner = false;
        }

    } else {
        // no team. This is a solo account. Set all to true.
        vm.canEdit = true;
        vm.isOwner = true;
        vm.isAdmin = true;
    }

    // if this person can't edit, the formm will be disabled and they won't be able to expand the details
    // so let's open them by default for these folks.
    if(!vm.canEdit){
        vm.showPersonalInfo = true;
        vm.showBusinessInfo = true;
        vm.showSocialInfo = true;
    }


// if auto-invoice is enabled, make sure we have populated our day dropdowns by triggering changeInterval(settings)
if(_.has(vm.client.profile, 'settings.autoInvoice')){
    if(vm.client.profile.settings.autoInvoice){
        if(vm.client.profile.settings.invoiceInterval == 'month'){
          vm.dayOptions = clientPackageService.monthDayOptions;
        }
        if(vm.client.profile.settings.invoiceInterval == 'week'){
          vm.dayOptions = clientPackageService.weekDayOptions;
        }
        calcRenewal(vm.client.profile.settings);
    }
}

vm.updateReportConfig = function(){
    if(_.has(vm.client.profile, 'weeklyStatusReport')){
        vm.client.profile.weeklyStatusReport.lastUpdated = moment().toISOString();
    }

    // Populate our report welcome and closing
    if(_.has(vm.user.profile.settings, 'clientReportWelcome')){
        vm.client.profile.weeklyStatusReport.clientReportWelcome = vm.user.profile.settings.clientReportWelcome;
    }
    if(_.has(vm.user.profile.settings, 'clientReportClosing')){
        vm.client.profile.weeklyStatusReport.clientReportClosing = vm.user.profile.settings.clientReportClosing;
    }
}

vm.manageAddress = function(client){
    return clientDataService.workspaceAddressDialog(client);
}

vm.workspaceAddressDisplay = function(address){
    var start = "Not Chosen";
    if(address){
        start = address
    }
    return start + '@inbox.adminja.co'
}

vm.typeChange = function(type){
    // $log.info(vm);

    // make sure we are on the right tab
    $timeout(function(){
        vm.changeTab(0);
    },500);

    if(type == 'personal'){
        vm.setupAsPersonalSpace();
    }

    if(type == 'active'){
        vm.setupAsClientSpace();
    }

}
    // if this is our first client , show tooltips
    // if(vm.numClients < 1 && vm.isOwner){
    //     Appcues.show('-KnQzUkJ59lmSPOEoKqa');
    // }

    vm.showCue = function(){
        // Appcues.show('-L6YABBBcygHUzxFuyz4');
    };

   vm.clientLimit = gateService.gateData.clientLimit;




   // We put the form on $scope.forms. so it's forced to attach to original instead of child scope
   // See name="forms.clientDialogForm" in dialog-client.html
   // https://stackoverflow.com/questions/22436501/simple-angularjs-form-is-undefined-in-scope
   $scope.forms = {};


   // setup our listener to make form dirty if avatar changed
   $scope.$on('uploadComplete', setDirty);

   function setDirty(){
       vm.clientDialogForm.$setDirty();
   }


    // Setup Hotkeys for this dialog
    hotkeys.bindTo($scope)
            // inhibit enter from submitting
            .add({
                combo: 'enter',
                callback: function (event) {
                    event.preventDefault();
                    // $log.info('enter blocked');
                }
            })
            .add({
                combo: 'ctrl+enter',
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                description: 'Save/Update Client',
                callback: function (event) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();
                    // $log.info(vm.clientDialogForm);
                    var pristine = vm.clientDialogForm.$pristine,
                            invalid = vm.clientDialogForm.$invalid,
                            clientID = $scope.vm.client.uid;

                    if (!pristine && !invalid && clientID) {
                        vm.saveUpdatedClient($scope.vm.client);
                    }

                    if (!pristine && !invalid && !clientID) {
                        vm.saveNewClient($scope.vm.client);
                    }
                }
            });



    // monitor color changes and change pristine to false
    vm.colorChange = function (form) {
        form.$setDirty();
        $timeout(function(){
            vm.showAvatar = false;
        },0)
        $timeout(function(){
            vm.togglePicker();
            vm.showAvatar = true;
        }, 250);
        // console.log(vm.clientDialogForm.$error);
    };

    // autosuggest nextRenew based on deprecated retainerStart
    vm.suggestedRenew = function(retainerStart){
        // $log.info('retainerStart:' + retainerStart);
        var nextCycle = moment();

        // if we've already more than 2 weeks past the day in this month, move forward a month
        // if(Number(nextCycle.format('D')) > (retainerStart + 21)){
        //     nextCycle = moment(nextCycle).add(1, 'month').date(retainerStart).startOf('day');
        // } else {
        //     nextCycle = moment(nextCycle).date(retainerStart).startOf('day');
        // }

        // if cycle day is upcoming, start date should be in previous month
        if (Number(nextCycle.format('D')) <= retainerStart){
            nextCycle = moment(nextCycle).subtract(1, 'month').date(retainerStart).startOf('day');
        } else {
            nextCycle = moment(nextCycle).date(retainerStart).startOf('day');
        }


        return moment(nextCycle).format('MMM, D  YYYY')
    }



    vm.colorPicker = false;

    vm.togglePicker = function(){
        if (vm.colorPicker){
            vm.colorPicker = false;
        } else{
            vm.colorPicker = true;
        }
    }


    vm.changeBilling = function(){
        vm.showRetainerWarning = true;
    }

    // Ensures our nextCycle datePicker constrains
    // the date candidates
    vm.cycleDateLimit = function(date){
        // return date
        var now = moment(),
            min = moment(now).subtract(1, 'month'),
            max = moment(now).add(45, 'days'),
            day = moment(date),
            dayNumber = Number(moment(date).format('D')),
            pass = false;

        if(!_.has(vm.client, 'billing')){
            min = moment().startOf('month').startOf('day');
            max = moment().add(1, 'month');
        } else {
            if(_.has(vm.client.billing, vm.client.profile.plan.currentPeriod)){
                var currentPeriodStart = vm.client.billing[vm.client.profile.plan.currentPeriod].start;
                // current period might be a long one (more than 45 days) so IF there is a current period, then the Max should be set at least 1 month past it's end
                max = moment(vm.client.billing[vm.client.profile.plan.currentPeriod].end).add(1, 'month');
            } else {
                // currentPeriod not set. Find latest period and use that.
                var sortedPeriods = _.orderBy(vm.client.billing, ['start'], ['desc']);
                var currentPeriodStart = sortedPeriods[0].start;
                vm.client.profile.plan.currentPeriod = sortedPeriods[0].uid;
            }


            min = moment(currentPeriodStart).add(1, 'day');
        }

        // if it's an adminja admin, give them a wider range for triage and quick fixes.
        // if(vm.userType == 'admin'){
        //     min = moment().subtract(2, 'months');
        //     max = moment().add(2, 'months');
        // }

        // is within min/max dates?
        if(moment(day).isSameOrAfter(min) && moment(day).isSameOrBefore(max)){
            pass = true;
        }

        // // is less than 29?
        if(vm.client.profile.plan.recurrenceType == 'month'){
            if(dayNumber > 28){
                pass = false;
            }
        }


        if(pass){
            return dayNumber
        } else {
            return false
        }
    }// cycleDateLimit



    vm.cancelDialog = function () {
        $mdDialog.cancel();
    };

    vm.cycleDateChange = function(client, pickerCycle){
        $log.info('Cycle date changed!');
        // $log.info(client);
        // if we dont' have a frequency set, set it to 1
        if(!_.has(client.profile.plan, 'interval')){
            $timeout(function(){client.profile.plan.interval = 1;},0);
        }
        client.profile.plan.monthDay = moment(vm.displayNextCycle).format('D');
        // Convert the selected weekday to something rrule can understand
        var weekDay = moment(vm.displayNextCycle).format('dd');
        client.profile.plan.weekDay = $filter('uppercase')(weekDay);
        // Define displayWeekDay so user can understand
        switch(client.profile.plan.weekDay) {
          case 'SU':
              client.profile.plan.displayWeekDay = "Sunday";
              break;
          case 'MO':
              client.profile.plan.displayWeekDay = "Monday";
              break;
          case 'TU':
              client.profile.plan.displayWeekDay = "Tuesday";
              break;
          case 'WE':
              client.profile.plan.displayWeekDay = "Wednesday";
              break;
          case 'TH':
              client.profile.plan.displayWeekDay = "Thursday";
              break;
          case 'FR':
              client.profile.plan.displayWeekDay = "Friday";
              break;
          case 'SA':
              client.profile.plan.displayWeekDay = "Saturday";
              break;
      }
        // Old way of doing things
        // client.profile.plan.nextCycle = moment(pickerCycle).format('YYYY-MM-DD');
        // $log.info('nextCycle starts at:' + moment(pickerCycle).toISOString());
        // New way of doing things May 23, 2018 - set to start of day in current timezone

        client.profile.plan.nextCycle = moment(pickerCycle).startOf('day').toISOString();
        // $log.info('nextCycle adjusted to:' + moment(client.profile.plan.nextCycle).toISOString());
        // if this is an old client that wasnt setup with an RRule, display the RRule form now
        // with prepopulated values
        if(!_.has(client.profile.plan, 'recurrenceType')){
            client.profile.plan.recurrenceType = 'month';
            client.profile.plan.frequency = 1;
            client.profile.plan.weekDay = 'MO';
        }
        // $log.info(client.profile.plan.nextCycle);
        vm.newPeriodEndDate = moment(client.profile.plan.nextCycle).subtract(1, 'day');
        vm.showRetainerWarning = true;
    }

    // if changing recurrenceType from date to zero or vice-versa, throw up a warning so user knows what to expect
    vm.checkRecurrenceType = function(type){
            var showAlert = false;

        if(vm.client.uid && vm.client.billing){
            // if changing from date to zero - throw alert
            if(type == 'zero' && (vm.clientCopy.profile.plan.recurrenceType != type)){
                showAlert = true;
                dataLayer.push({'event': 'change-renewal-type'});

            }
            // if changing from zero to date - throw alert
            if(type != 'zero' && (vm.clientCopy.profile.plan.recurrenceType != type)){
                showAlert = true;
                dataLayer.push({'event': 'change-renewal-type'});

            }
            if(showAlert){


                    if(type == 'zero'){
                        var confirm = $mdDialog.confirm()
                         .title('Change this retainer to balance-based?')
                         .htmlContent('This will also adjust your CURRENT billing period.')
                         .ariaLabel('Alert - this will also adjust your current billing period')
                         .ok('Got it')
                         .multiple(true);
                    } else {
                        var confirm = $mdDialog.confirm()
                         .title('Change this retainer to date-based?')
                         .htmlContent('This will also adjust your CURRENT billing period.')
                         .ariaLabel('Alert - this will also adjust your current billing period')
                         .ok('Got it')
                         .multiple(true);
                    }

                    // disabled. We are taking a different tack on informing users.
                   // $mdDialog.show(confirm).then(function() {

                   // }, function() {

                   // });
            }


        }
    }

    vm.saveUpdatedClient = function (client) {
        // $log.info('vm.saveUpdatedClient');
        // $log.info(client);
        // remove the $$conf property...it causes errors
        delete client.$$conf;

        // New way of doing things May 23, 2018 - set to start of day in current timezone
        // client.profile.plan.nextCycle = moment(client.profile.plan.nextCycle).startOf('day').toISOString();

        if(!client.profile.weeklyStatusReportEnabled){
            delete client.profile.weeklyStatusReport
        }

        var promises = [];
        if(_.has(client.profile, 'settings')){
                // we only want to refresh the schedule if something about it changed
                var scheduleNeedsUpdated = false;
                if(vm.clientCopy.profile.settings.invoiceInterval != client.profile.settings.invoiceInterval){
                    // $log.info('invoiceInterval: schedule will be updated');
                    scheduleNeedsUpdated = true;
                }
                if(vm.clientCopy.profile.settings.invoiceFrequency != client.profile.settings.invoiceFrequency){
                    // $log.info('invoicefrequency: schedule will be updated');
                    scheduleNeedsUpdated = true;
                }

                if(vm.clientCopy.profile.settings.invoiceDay != client.profile.settings.invoiceDay){
                    // $log.info('invoiceday: schedule will be updated');
                    scheduleNeedsUpdated = true;
                }

                if(vm.clientCopy.profile.settings.autoInvoice != client.profile.settings.autoInvoice){
                    // $log.info('autoinvoice: schedule will be updated');
                    scheduleNeedsUpdated = true;
                }

                if(vm.clientCopy.profile.settings.autoSendInvoice != client.profile.settings.autoSendInvoice){
                    // $log.info('autosendinvoice: schedule will be updated');
                    scheduleNeedsUpdated = true;
                }

                if(scheduleNeedsUpdated){
                    promises.push(setupInvoiceSchedule(client))
                }
        }

        promises.push(clientDataService.updateClient(client, vm.clientCopy))


        return Promise.all(promises)
        .then(function () {
            // $log.info('update client - re-generate client menu');
            triMenu.removeMenu('triangular.workspaces');
            // Refresh Client Data
            clientDataService.setupWorkspaceMenu();
            vm.cancelDialog();
            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Updated Client:' + client.profile.firstname + ' ' + client.profile.lastname)
                    .position('top right')
                    .hideDelay(2000)
                    );
            //heap.track('Client Updated');

        }).then(function () {
            // timeDataService.reCreateTotals(client);
        });
    }



    vm.saveNewClient = function (client) {
        // $log.info('saveNewClient clicked');
        // $log.info(client);
        var visit;
        if(client.billingType == 'packages'){
            visit = true;
        } else {
            visit = false;
        }
        return clientDataService.saveNewClient(client, visit).then(function () {
            vm.cancelDialog();

            $mdToast.show(
                    $mdToast.simple()
                    .textContent('Added new Space')
                    .position('top right')
                    .hideDelay(2000)
                    );



            //heap.track('New Client Saved');

            // Update Client Menu
            // $log.info('new client - re-generate client menu');
            // triMenu.removeMenu('triangular.workspaces');
            // Refresh Client Data
            // clientDataService.setupUserAndClientMenu(true);

        });
    }


    vm.onTabChanges = function(tabIndex){
        // $log.info(tabIndex);
        // $log.info('tab changed to: ' + tabIndex);
        if(tabIndex == 1 && !vm.client.profile.phone){
            vm.showPersonalInfo = true;
        }

        // display the button we need depending on what tab we are on.
        // $log.info('Current tab ' + tabIndex);
    }

    vm.changeTab = function(targetTab){
        // $log.info('request tab change to: ' + targetTab);
        // display the button we need depending on what tab we are on.
        vm.selectedTabIndex = targetTab
    }

    vm.changeSpaceType = function(type){
        if(type == 'personal'){
            vm.client.profile.previousPlanType = vm.client.profile.plan.type;
            vm.client.profile.isCompany = true;
            vm.client.profile.plan.type = 'none';
            vm.client.status = 'personal';

        } else {
            if(_.has(vm.client.profile, 'previousPlanType')){
                vm.client.profile.plan.type = vm.client.profile.previousPlanType;
            }
            vm.client.status = 'active';
        }

    }// changeSpaceType

    vm.setupAsPersonalSpace = function(){
        vm.client.profile.isCompany = true;
        vm.client.profile.plan.type == 'none';
        vm.client.order = 1;
        vm.client.plan = {rate:0}
        if(!_.has(vm.client.profile, 'thumbnail')){
            vm.client.profile.avatar = "/assets/images/avatars/generic-default-avatar.png"
        }

    }


    function isCurrentPeriod(period){
        var now = moment().toISOString();
        if (period.start <= now && period.end >= now){
            return true
        } else {
            return false
        }
    }

    vm.setupAsClientSpace = function(){
        vm.client.profile.isCompany = false;
        vm.client.profile.plan.type == 'none';
        vm.client.order = 1;
        vm.client.plan = {rate:0}
        if(!_.has(vm.client.profile, 'thumbnail')){
            vm.client.profile.avatar = "/assets/images/avatars/generic-person-avatar.png"
        }

    }


    vm.manageSubscription = function(){
        $mdDialog.cancel();
        $state.go('authentication.profile', {selectedTab: 5});
    }
///// Category form logic
vm.toggleCategoryForm = function(show){
    if(show){
        vm.showCategoryForm = true;
        // focus on first field
    } else {
        vm.showCategoryForm = false;
    }
}

vm.addCategory = function(category){
    // first make sure the nodes exist
    if(!_.has(vm.client.profile, 'categories')){
        vm.client.profile.categories = {};
        vm.client.profile.categories.time = {};
    }
    var newCatKey = firebase.database().ref().child('clients/' + vm.client.uid + '/categories/time').push().key;
    category.uid = newCatKey;
    if(!category.rate){
        category.rate = 0;
    }
    category.order = _.size(vm.client.profile.categories.time) + 1;
    if(!_.has(category, 'adminOnly')){
        category.adminOnly = false
    }
    vm.client.profile.categories.time[newCatKey] = category;
    vm.clientDialogForm.$setDirty();
    vm.newCategory = {};
    vm.showCategoryForm = false;

} // addCategory

vm.removeCategory = function(items, category){
    $timeout(function(){
         delete items[category.uid];
         vm.clientDialogForm.$setDirty();
    },0);
}// removeCategory


vm.toggleAdminOnly = function(category){
    if(category.adminOnly){
        category.adminOnly = false;
    } else {
        category.adminOnly = true;
    }
    vm.clientDialogForm.$setDirty();
}
// Task Dragging
dragulaService.options($scope, 'drag-category', {
    moves: function (el, container, handle) {
            return !handle.classList.contains('drag-handle');
        // return handle.classList.contains('task-handle');
    },
    accepts: function (el, target, source, sibling) {
        // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

       return true

    },
    invalid: function(el, handle){
        // return var === 'condition'
        return false
    },
    direction: vm.taskDragDirection,
    revertOnSpill: true
})


// declare our categoryBag so we can track drake.dragging
var categoryBag = dragulaService.find($scope, 'drag-category');
$scope.$on('drag-category.drag', function(event, item, target, source, sibling){
    // On mobile this prevents the default page scrolling while dragging an item.
    $(document).on('touchstart', function(e) {
        e.preventDefault();
    });

})
$scope.$on('drag-category.drop', function (event, item, target, source, sibling) {
    $(document).off('touchstart')
    // Now we can do our work - prep the variables
    var itemID = item[0].attributes.catid.value,
            thisContainer = $('.client-category-manager'),
            sortItems = Array.from(thisContainer.find('.category-item'));

    // Change sort order
    _.each(sortItems, function(category, index){
        var catID = category.attributes.catid.value,
        childCategoryObject = vm.client.profile.categories.time[catID];
        childCategoryObject.order = index + 1;
    });

    $timeout(function(){
        vm.clientDialogForm.$setDirty();
    },0);

});// drag-category.drop


// $timeout(function(){
//     Appcues.start();
// }, 1000)

vm.showSample = function(){
     var showImage = $mdDialog.confirm()
              .title('Client Status Report Sample')
              .htmlContent('<img flex style="max-width: 400px;" src="/assets/images/reports/client-weekly-status-sample.png">')
              .multiple(true)
              .ariaLabel('Ok')
              .ok('Close')

        $mdDialog.show(showImage);
}

vm.nextCycleLabel = function(){
    var result = undefined;
    if(vm.hasBilling && vm.client.profile.plan.recurrenceType != 'zero'){
        result = 'next'
    }
    if(vm.hasBilling && client.profile.plan.recurrenceType == 'zero' && vm.clientCopy.profile.plan.recurrenceType != 'zero'){
        result = 'next'
    }
    if(vm.hasBilling && client.profile.plan.recurrenceType == 'zero' && vm.clientCopy.profile.plan.recurrenceType == 'zero'){
        result = 'heartbeat'
    }
    if(!vm.hasBilling){
        result = 'new'
    }
    return result
}

///// Report welcome/closing editing
vm.froala1Options = {
        key: $rootScope.froalaKey,
        pluginsEnabled: [
        "align", "charCounter", "codeBeautifier", "codeView",  "colors", "draggable",   "entities",  "fontSize",
        "file", "image", "imageTUI",
        // "imageManager",
         "lineBreaker", "link",  "paragraphFormat", "paragraphStyle", "url", "wordPaste"
        ],
        spellcheck: true, // does not appear to actually enable spellcheck
        toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", ,"textColor", "|", "align",  "|",  "insertLink",  "insertImage", "insertFile", "insertHR", "|", "html"],
        autofocus: true,
        listAdvancedTypes: true,
        zIndex: 9999,
        attribution: false,
        pastePlain: true,
        charCounterMax: 1000,
        linkAlwaysBlank: true,
        linkAutoPrefix: 'https://',
        linkInsertButtons: '',
        linkText: true,
        imageInsertButtons: ['imageUpload'],
        imageDefaultDisplay: 'block',
        htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
        pasteDeniedAttrs: ['class', 'id', 'data'],
        pasteDeniedTags: ['iframe', 'script', 'style'],
        // Set the file upload URL.
         imageUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=users&segment2=' + $rootScope.userID + '&segment3=profile',
         imageUploadMethod: 'POST',
         fileUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=users&segment2=' + $rootScope.userID + '&segment3=profile',
         // Set request type.
         fileUploadMethod: 'POST',
         events: {
                    'froalaEditor.initialized': function () {
                    },
                    'charCounter.exceeded': function () {
                  },
                  'file.beforeUpload': function($file){
                    // $timeout(function(){
                    //  $rootScope.loaderMessage="Uploading File";
                    //  triLoaderService.setLoaderActive(true);
                    // });
                  },
                  'file.uploaded': function($file){
                    // add the file to our file list so we can access it programmatically it later
                    var fileObject = angular.fromJson($file);
                    vm.newFileObject = {
                                fileName: fileObject.filename,
                                url: fileObject.link[0],
                                thumbnail: fileObject.link[0],
                                source: 'firebaseStorage',
                                fullPath: fileObject.path
                            }
                            // $log.info(vm.newFileObject);
                            // if(!_.has(vm.detail, 'files')){
                            //         vm.detail.files = [];
                            // }

                            //   vm.detail.files.push(vm.newFileObject);
                    // $timeout(function(){
                    //  triLoaderService.setLoaderActive(false);
                    // });
                  },
                  'file.inserted': function(e, editor, $file, response){
                    editor.html.insert("  ");
                  },
                  'image.beforeUpload': function($file){
                    // $timeout(function(){
                    //  $rootScope.loaderMessage="Uploading Image";
                    //  triLoaderService.setLoaderActive(true);
                    // });
                  },
                  'image.uploaded': function($file){
                    var fileObject = angular.fromJson($file);
                    vm.newFileObject = {
                                fileName: fileObject.filename,
                                url: fileObject.link[0],
                                thumbnail: fileObject.link[0],
                                source: 'firebaseStorage',
                                fullPath: fileObject.path
                            }

                            // if(!_.has(vm.detail, 'files')){
                            //         vm.detail.files = [];
                            // }

                            //   vm.detail.files.push(vm.newFileObject);

                    // $timeout(function(){
                    //  triLoaderService.setLoaderActive(false);
                    // });
                  },
                  'image.inserted': function(e, editor, $file, response){
                    // editor.html.insert("  ");
                  },
                  'image.removed':  function($file){
                    // $log.info('image.removed');
                    var thisLookupLink = $file[0].src;
                    // _.each(vm.detail.files, function(file){
                    //     if(file.url == thisLookupLink){
                    //         // $log.info('found file to delete in array');
                    //         // $log.info(file);
                    //         // Send the file to be deleted
                    //         // delete it from the array

                    //         var newFiles = _.filter(vm.detail.files, function(x) { return x.url == thisLookupLink; });
                    //         vm.detail.files = newFiles;
                    //         return vm.removeFile(file);
                    //     }
                    // });
                    // return vm.removeImage($img)
                    // then update note so reference is removed as well
                  },
                'file.unlink':  function($file){
                    // $log.info('File Removed');
                    var thisLookupLink = $($file). attr("href");
                    // _.each(vm.detail.files, function(file){
                    //     if(file.url == thisLookupLink){
                    //         // $log.info('found file to delete in array');
                    //         // Send the file to be deleted
                    //         // $log.info(file);
                    //         // delete it from the array
                    //         var newFiles = _.filter(vm.detail.files, function(x) { return x.url == thisLookupLink; });
                    //         vm.detail.files = newFiles;
                    //         return vm.removeFile(file)
                    //     }
                    // });

                    // then update note so reference is removed as well
                }
            }//events
    }//froalaOptions


    vm.froala2Options = angular.copy(vm.froala1Options);

    function removeAllFiles(){
            _.each(vm.detail.files, function(file){
                return vm.removeFile(file)
            });
    }// removeAllFiles


vm.removeFile = function(file){
    // find file in vm.detail.files to get the path
    var pathToDelete = file.fullPath,
        triggerURL = $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=delete&segment1=' + pathToDelete;
    // $log.info('removeFile');

     $http.get(triggerURL)
            .then(function (response){
                $scope.jsondata = response.data;
                console.log("status:" + response.status);
            }).catch(function(response) {
              console.error('Error occurred:', response.status, response.data);
            }).finally(function() {
                 console.log("Task Finished.");
            });

}

function setupInvoicing(client){
    if(client.profile.settings.autoInvoice){
        $timeout(function(){
            var startDate = moment().toISOString();
            client.profile.settings.invoiceInterval = 'month';
            client.profile.settings.invoiceFrequency = 1;
            client.profile.settings.invoiceDay = 1;
            changeInterval(client.profile.settings);
        })
    } else {
        // clear out schedules
    }

}//

function getWeekSequence(date){
  return new Promise(function(resolve, reject){
    var sequence = {}, seedDate = moment(date);
    for (var thisStep = 1; thisStep < 13; thisStep++) {
      seedDate = moment(seedDate).add(vm.client.profile.settings.invoiceFrequency, 'weeks').day(vm.client.profile.settings.invoiceDay).startOf('day').toISOString();
      sequence[thisStep] = {
        id: thisStep,
        date: seedDate
      };
    }
    return resolve(sequence)
  });
}// getWeekSequence

function populateRecipients(){
    if(!_.has(vm.client.profile.settings, 'invoiceRecipients')){
        vm.client.profile.settings.invoiceRecipients = vm.client.profile.email;
    }
}//populateRecipients

function getMonthSequence(date){
  return new Promise(function(resolve, reject){
    var sequence = {}, seedDate = moment(date);
    for (var step = 1; step < 13; step++) {
      seedDate = moment(seedDate).add(vm.client.profile.settings.invoiceFrequency, 'months').set('date', vm.client.profile.settings.invoiceDay).startOf('day').toISOString();
      sequence[step] = {
        id: step,
        date: seedDate
      };
    }
    return resolve(sequence)
  });
}// getMonthSequence

function changeInterval(settings){

   $timeout(function(){
     var interval = settings.invoiceInterval;
       if(interval == 'month'){
         vm.dayOptions = clientPackageService.monthDayOptions;
         vm.client.profile.settings.invoiceDay = 1;
       }
       if(interval == 'week'){
         vm.dayOptions = clientPackageService.weekDayOptions;
         vm.client.profile.settings.invoiceDay = "Monday";
       }
       calcRenewal(vm.client.profile.settings);
   })

}// changeInterval

function calcRenewal(settings){
       if(settings.invoiceInterval == 'month'){
         return getMonthSequence(moment().toISOString())
         .then(function(sequence){
           $timeout(function(){
             vm.invoicePreview = sequence;
           })
         });
       }// if month

       if(settings.invoiceInterval == 'week'){
         return getWeekSequence(moment().toISOString())
         .then(function(sequence){
           $timeout(function(){
             vm.invoicePreview = sequence;
           })
         });
       }// if week
}//calcRenewal

function setupInvoiceSchedule(client){
        var promises = [];
        if(_.has(client, 'schedules')){
            _.each(client.schedules, function(schedule){
                if(schedule.type == 'auto-invoice' || schedule.type == 'auto-send-invoice'){
                    promises.push(scheduleDataService.removeSchedule(schedule))
                }
            })
        }
        if(_.has(client.profile, 'settings.autoInvoice')){
            if(client.profile.settings.autoInvoice){
                $log.info('auto invoice was on. create schedule.');
                promises.push(createSchedule(client))
            }
        }
        return Promise.all(promises)

  function createSchedule(client){
    return new Promise(function(resolve, reject){
        $log.info('createSchedule for ' + client.profile.fullName);
        var timeZone = vm.user.profile.timeZone;
        if(_.has(client.profile, 'timeZone')){
            timeZone = client.profile.timeZone
        }

          var options = {
            message: '',
            repeat: true,
            type: 'auto-invoice',
            path: '/clients/' + client.uid +'/schedules/',
            clientID: client.uid,
            payload:{
                repeatInterval: client.profile.settings.invoiceInterval,
                repeatFrequency: client.profile.settings.invoiceFrequency,
                repeatDay: client.profile.settings.invoiceDay,
                timeZone: timeZone,
                userID: client.owner,
                path: '/clients/' + client.uid +'/schedules/',
            }
          }// options


          if(client.profile.settings.autoSendInvoice){
            options.type = 'auto-send-invoice';
          }

          var newSchedule = scheduleDataService.newSchedule(client.owner, options, vm.invoicePreview[1].date);
          return scheduleDataService.saveNewSchedule(newSchedule)
          .then(function(schedule){
            return resolve(true)
          }, function(error){
            $log.info(error);
            return reject(error)
          });
    });// promise
  }//createSchedule

}// setupSchedule

function getNextOccurence(date){
  var results = undefined;
  if(vm.client.profile.settings.invoiceInterval == 'month'){
      results = moment(date).add(Number(vm.client.profile.settings.invoiceFrequency), 'months').set('date', vm.client.profile.settings.invoiceDay).startOf('day').toISOString();
  } else if (vm.client.profile.settings.invoiceInterval == 'week'){
      results = moment(date).add(Number(vm.client.profile.settings.invoiceFrequency), 'weeks').day(vm.client.profile.settings.invoiceDay).startOf('day').toISOString();
  }
  $timeout(function(){
      vm.nextOccurence = results;
  })
}

}

})();

(function () {
    'use strict';
    angular.module('appServices')
            .service('clientDataService', clientDataService);


    /* @ngInject */
    function clientDataService(rrule, $timeout, $log, $q, $state, triLoaderService, localStorageService, $injector,
                            $mdDialog, $mdToast, $rootScope, $firebaseArray, $firebaseObject,
                            $stateParams, userDataService, clientPackageService, gateService, fbService, triMenu) {
        var clientMenu = [],
            clientsArray = [];

        var service = {
            newClient: newClient,
            clientColor: clientColor,
            clientName: clientName,
            clientOwner: clientOwner,
            clientDialog: clientDialog,
            workspaceAddressDialog: workspaceAddressDialog,
            editClient: editClient,
            saveNewClient: saveNewClient,
            updateClient: updateClient,
            deleteClient: deleteClient,
            getClient: getClient,
            clientBrief: clientBrief,
            getWorkspace: getWorkspace,
            getUsersClients: getUsersClients,
            thisUsersWorkspaces: thisUsersWorkspaces,
            setupUserAndClientMenu: setupUserAndClientMenu,
            setupWorkspaceMenu: setupWorkspaceMenu,
            clearClientData: clearClientData,
            updateTime: updateTime,
            easyClient: easyClient,
            getQuickClients: getQuickClients,
            restoreClient: restoreClient,
            archiveClient: archiveClient,
            copyClient: copyClient,
            isOwner : isOwner,
            sendStatusReport: sendStatusReport
        };


        return service;


        // $log.info(demoPanels);
        //////////////
        // updateTime
        function updateTime(timeEntry) {
            // $log.info('updateTime');
            // $log.info(timeEntry);
            // get current

        }

        function sendStatusReport(client){
          $mdDialog.show({
              controller: 'clientStatusReportController',
              controllerAs: 'vm',
              // bindToController: true,
              templateUrl: 'app/app-services/clientDataService/dialog-clientStatusReport.tmpl.html',
              locals: {
                  client: client
              },
              focusOnOpen: true,
              clickOutsideToClose: true,
              fullscreen: true,
              multiple: true
          });
        }//sendStatusReport

        function isOwner(clientID, userID){
            _.each(service.clients, function(client){
                if(client.uid == clientID){
                    var thisClient = client;
                    if(thisClient.owner == userID){
                        return true
                    } else {
                        return false
                    }

                }
            })
        }//isOwner

        function getQuickClients () {

            return service.clients;

        }






        function clientBrief(clientID){
            // this is duplicaterd in timerDataService.newTimer
            // because we couldnt' get newTimer to use this function efficiently
            _.each(service.clients, function(client){
                if(client.uid == clientID){
                    var newClientBrief = {
                        access: client.access,
                        clientColor: client.profile.clientColor,
                        email: client.profile.email,
                        name: client.profile.fullName,
                        order: client.order,
                        owner: client.owner,
                        status: client.status,
                        uid: client.uid
                    }

                    if(_.has(client, 'profile.avatar')){
                        newClientBrief.avatar = client.profile.avatar;
                    }

                    return newClientBrief
                }
            })
        }

        //////////////
        // easyClient
        function easyClient(clientID) {
            var found = {};
            _.each(service.clients, function (client) {
                if (client.uid === clientID) {
                    found = client
                }
            });
            return found
        }// easyClient


        //////////////
        // clearClientData
        function clearClientData() {
            delete service.clients;
            delete $rootScope.VAWorkspacesMenu;
            delete $rootScope.vaWorkspacesMenuBuilt;
            clientsArray = [];
            // Kill our quick list of client info
            // kill our client menu
            triMenu.removeMenu('triangular.workspaces');
        }




        ///////////////////////////////////////////////////////////
        // newClient
        function newClient(ownerID, lead) {
            var user = userDataService.user, billingType = 'periods';
            if (!ownerID) {
                var ownerID = user.uid;
            }


            // Define our client scaffold to pass to dialog for population
            var client = {
                owner: ownerID,
                created: moment().toISOString(),
                order: 1,
                billingType: 'packages',
                profile:{
                    plan: {
                        retainerStart: 1,
                        type: undefined,
                        cost: 0,
                        allocated: 0,
                        rate: 0,
                        recurrenceType: 'month',
                        weekDay: 'MO',
                        displayWeekDay: 'Monday',
                        interval: 1
                    }
                },
                access: {
                    users: {},
                    admins: {}
                },
                panels: {}
            }

            if(_.has(user.profile, 'logo')){
                client.profile.settings = {
                    logo: user.profile.logo
                };
            }

            // // Save the client owner in users/admins lists
            client.access.users[ownerID] = true;
            client.access.admins[ownerID] = true;
            // if being setup by someone other than owner, make sure they are added too
            if(ownerID != user.uid){
                client.access.users[user.uid] = true;
                client.access.admins[user.uid] = true;
            }

            // if a lead was passed, use it's info to prepopulate
            if(lead){
                client.profile.firstname = lead.firstName;
                client.profile.lastname = lead.lastName;
                client.profile.fullname = lead.firstName + ' ' + lead.lastName;

                // Add our lead object with metadata on this promotion to workspace
                client.lead = lead;
                client.lead.convertedOn = moment().toISOString;
                client.lead.convertedBy = $rootScope.userID;

                if(_.has(lead, 'email')){
                    client.profile.email = lead.email;
                }
                if(_.has(lead, 'company')){
                    client.profile.company = lead.company;
                }
                if(_.has(lead, 'position')){
                    client.profile.position = lead.position;
                }
                if(_.has(lead, 'avatar')){
                    client.profile.avatar = lead.avatar;
                }
                if(_.has(lead, 'avatarThumb')){
                    client.profile.avatarThumb = lead.avatarThumb;
                }
                if(_.has(lead, 'phone')){
                    client.profile.phone = lead.phone;
                }
                if(_.has(lead, 'companyfax')){
                    client.profile.companyfax = lead.companyfax;
                }
                if(_.has(lead, 'linkedin')){
                    client.profile.linkedin = lead.linkedin;
                }
                if(_.has(lead, 'facebook')){
                    client.profile.facebook = lead.facebook;
                }
                if(_.has(lead, 'twitter')){
                    client.profile.twitter = lead.twitter;
                }
                if(_.has(lead, 'pinterest')){
                    client.profile.pinterest = lead.pinterest;
                }
                if(_.has(lead, 'instagram')){
                    client.profile.instagram = lead.instagram;
                }
                if(_.has(lead, 'website')){
                    client.profile.companyurl = lead.website;
                }
                if(_.has(lead, 'address')){
                    client.profile.address = lead.address;
                }

                // make sure timeZone gets stored
                client.profile.timeZone = user.profile.timeZone;

            }// if lead
            // $log.info('new client scaffold:');
            // $log.info(client);

            userDataService.trackEvent('new-workspace');
            return client
        }// newClient

        ///////////////////////////////////////////////////////////
        /// clientColor
        function clientColor(clientID) {

                var selectedClient = _.find(clientsArray, function (client) {
                    return client.uid == clientID;
                });

                if (_.has(selectedClient, 'profile.clientColor')) {
                    return selectedClient.profile.clientColor;
                } else {
                    return '#888888'
                }

        }

        ///////////////////////////////////////////////////////////
        /// clientName
        function clientName(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            var name = "";
            if(selectedClient){
                if (_.has(selectedClient.profile,'fullName')){
                    name = selectedClient.profile.fullName;
                } else {
                    name = selectedClient.profile.name
                }
                return name
            }
        }

        /////////////////
        // getWorkspace
        //// returns full client based on id
        function getWorkspace(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            return selectedClient;
        }

        ///////////////////////////////////////////////////////////
        /// clientOwner
        function clientOwner(clientID) {
            var selectedClient = _.find(service.clients, function (client) {
                return client.uid === clientID
            });

            return selectedClient.owner;
        }

        function workspaceAddressDialog(client){
            $mdDialog.show({
                controller: 'workspaceAddressDialogController', // see below
                controllerAs: 'vm',
                bindToController: true,
                templateUrl: 'app/app-services/clientDataService/dialog-workspaceAddress.tmpl.html',
                locals: {
                    client: client
                },
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });
        }

        ///////////////////////////////////////////////////////////
        /// clientDialog
        function clientDialog(client, dialogTitle, tab) {

            // Make sure they are allowed to add clients
            // Not counting: Demo clients, Delegated Clients (their owner has unlimited anyways), archived clients
            var clientLimit = gateService.gateData.clientLimit;
            // $log.info('limit:' + clientLimit);


            //////////// Make sure we can open the dialog ////////////
            var numClients = 0, canOpenDialog = true;

            // Only check client count if adding for OWN account
            // team accounts have no limits anyways

            // if user owns the client and the client is new
            if(client.owner == $rootScope.userID && !client.uid){
                // count up our active, non-demo , owned clients
                _.each(service.clients, function(client){
                    if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                        numClients = numClients + 1;
                    }
                });
                // $log.info('numClients: '+numClients);

                if(numClients == clientLimit || numClients > clientLimit){
                    canOpenDialog = false;
                }
            }

            // $log.info('Original check: '+ canOpenDialog);

            var workingClient = angular.fromJson(angular.toJson(client));
            if(_.has(workingClient, 'profile.startDate')){
                workingClient.profile.startDate = new Date(workingClient.profile.startDate);
            }

            userDataService.trackEvent('edit-workspace');

            $mdDialog.show({
                controller: 'clientDialogController', // see below
                controllerAs: 'vm',
                // bindToController: true,
                templateUrl: 'app/app-services/clientDataService/dialog-client.tmpl.html',
                locals: {
                    title: dialogTitle,
                    client: workingClient,
                    clientColors: $rootScope.clientColors,
                    canOpenDialog: canOpenDialog,
                    tab: tab
                },
                focusOnOpen: false,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true
            });

        }
        ; // end clientDialog


        ///////////////////////////////////////////////////////////
        /// editClient
        function editClient(clientID, tab) {
            $log.info('service editClient ' + clientID);
            _.each(service.clients, function(client){
                if (client.uid == clientID ){
                    var editedClient = client;
                    // $log.info(editedClient.avatar);
                    clientDialog(editedClient, 'Edit ' + editedClient.firstname + ' ' + editedClient.lastname, tab);
                }
            });
        }
        ; // end editClient

        function getRuleString(client){

            switch(client.profile.plan.recurrenceType) {
                case 'week':
                    // $log.info('prepare weekly rule');
                    // always show button if menu is hidden
                    var ruleString = 'RRULE:FREQ=WEEKLY;BYDAY='+ client.profile.plan.weekDay + ';INTERVAL=' + client.profile.plan.interval;
                    break;
                case 'month':
                    // $log.info('prepare monthly rule');
                    // never show button if menu is turned off
                    var ruleString = 'RRULE:FREQ=MONTHLY;BYMONTHDAY='+ moment(client.profile.plan.nextCycle).format('D') +';INTERVAL=' + client.profile.plan.interval;
                    break;
                case 'zero':
                    // $log.info('prepare daily rule');
                    var ruleString = 'RRULE:FREQ=DAILY;INTERVAL=1';
                    break;
                default:
                    // $log.info('prepare default rule');
                   var ruleString = 'RRULE:FREQ=MONTHLY;BYMONTHDAY='+ moment(client.profile.plan.nextCycle).format('D') +';INTERVAL=' + client.profile.plan.interval;
            }
            return ruleString
        }

        ///////////////////////////////////
        // saveNewClient

        function saveNewClient(client, visit) {
            var user = userDataService.user;
            // if we are on dashboard, we need to turn the loader on while we rebuild it.


            // if this is a client space, make sure to include the default "Client Details" panel.
            var saveClient = angular.copy(client);

            saveClient.createdOn = moment().toISOString();


            // Also, store it as the client's "Start Date"
            if(_.has(saveClient, 'profile.startDate')){
                saveClient.profile.startDate = moment(saveClient.profile.startDate).startOf('day').toISOString();
            }

            // Set our client's default name
            if (saveClient.profile.isCompany && saveClient.profile.company) {
                // using company name for this client label
                saveClient.profile.fullName = saveClient.profile.company;
            } else {
                // using first/last for this client label
                saveClient.profile.fullName = saveClient.profile.firstname + ' ' + saveClient.profile.lastname;
            }

            // get unique ID for the new client
            var newClientKey = firebase.database().ref().child('clients').push().key;
            // put the key on the original client so our calling function has it
            client.uid = newClientKey;

            saveClient.uid = newClientKey;
            var updates = {};
            ////////////////////////////////////////
            // Prep default taskBoard for this client
            var defaultTaskBoard = newTaskBoard(saveClient);
            saveClient.taskBoards = {};
            saveClient.taskBoards[defaultTaskBoard.uid] = defaultTaskBoard;
            saveClient.defaultTaskBoard = defaultTaskBoard.uid;

            var thisMoment = moment().toISOString();
            saveClient.accountCreated = saveClient.owner + thisMoment
            saveClient.created = saveClient.owner + thisMoment

            updates['/taskBoards/' + defaultTaskBoard.uid] = defaultTaskBoard;
            // $log.info('saveNewClient client:');
            // $log.info(saveClient);
            // declare our updates

            // If a lead was attached, update the lead with the workspace info
            if(_.has(saveClient, 'lead')){
                // $log.info(saveClient.lead);
                updates['/leadBoards/' + saveClient.owner + '/leads/' + saveClient.lead.uid + '/promotedWorkspace'] = newClientKey;
            }

            // store our canonical object
            updates['/clients/' + newClientKey] = saveClient;
            // store our reference in the owner's assigned client list
            updates['/users/' + saveClient.owner + "/clients/" + newClientKey] = true;

            // if creator isn't owner, add to creator's client list as well
            if(saveClient.owner != user.uid){
                updates['/users/' + user.uid + "/clients/" + newClientKey] = true;
                // make sure added to their team
                updates['teams/' + saveClient.owner + "/members/" + user.uid + "/clients/" + newClientKey] = 'admin';
            }

            // Save the client
            return firebase.database().ref().update(updates)
                    // Add the default "Client Details" panel to this client
                    .then(function (response) {
                        userDataService.trackEvent('new-workspace-saved');
                        return addDetailBoard(saveClient)
                        .then(function(){
                            $log.info('detailBoard Added');
                            if(service.clients.length == 1 && !userDataService.user.profile.onboardingFlags.hasCreatedClient){
                                // Let Drip Knkow
                                _dcq.push(["identify", {
                                        email: userDataService.user.email,
                                        tags: ["Added First Client"]
                                    }]);
                                userDataService.changeOnboardingFlag('hasCreatedClient', true);
                            } else if(visit) {
                                if(saveClient.status != 'personal'){
                                    $timeout(function(){
                                        $log.info('setup package');
                                        clientPackageService.newPackage(saveClient)
                                        // $state.go("triangular.workspaces.client-billing", {"clientID": saveClient.uid});

                                    },1000);
                                }
                            }
                            return service.setupUserAndClientMenu(true);
                        })

                    // if this is our FIRST client, trigger the appcues flow that shows us where workspaces are

                }); //database update client

        } // end saveNewClient


        function addDetailBoard(thisClient){
            return new Promise(function(resolve, reject){
                var defaultListID = firebase.database().ref('/detailBoards').push().key, defaultLabel = "Client Details";
                if(thisClient.status == 'personal'){
                    defaultLabel = 'First List';
                }
                var newBoard = {
                   uid: thisClient.uid,
                   account: thisClient.owner,
                   workspace: thisClient.uid,
                   defaultList: defaultListID,
                   settings: {
                      color: '#ddd'
                   },
                   lists : {}
                 };
                 newBoard.lists[defaultListID] = {
                        uid: defaultListID,
                        type: 'client-details',
                        label: defaultLabel,
                        order: 1,
                        color: '#bbb'
                   }

                 var updates = {};
                 updates['/detailBoards/' + newBoard.uid] = newBoard;
                 updates['/clients/' + thisClient.uid + '/detailBoards/' + newBoard.uid] = newBoard;
                 updates['/clients/' + thisClient.uid + '/defaultDetailBoard'] = newBoard.uid;
                 return firebase.database().ref().update(updates)
                 .then(function(){
                    var clientCardID = firebase.database().ref('/detailBoards').push().key, updates = {},
                        clientCard = {
                              uid: clientCardID,
                              label: 'Client Card',
                              type: 'client-card',
                              order: '0',
                              board: newBoard.uid,
                              client: thisClient.uid,
                              list: defaultListID,
                              notecolor: '#fff',
                              owner: thisClient.owner,
                              creator: thisClient.owner
                          };
                    if(thisClient.status == 'active'){
                        updates['/detailBoards/' + newBoard.uid + '/lists/' + defaultListID + '/items/' + clientCard.uid] = clientCard;
                    }
                    return firebase.database().ref().update(updates)
                    .then(function(){
                        $log.info('addDetail Board Finished');
                        return resolve(true);
                    })

                 })
            })
        }//addDetailBoard

        function newTaskBoard(client){
            var priority1ID = firebase.database().ref('/taskBoards').push().key,
                 priority2ID = firebase.database().ref('/taskBoards').push().key,
                 priority3ID = firebase.database().ref('/taskBoards').push().key,
                 priority4ID = firebase.database().ref('/taskBoards').push().key,
                 priority5ID = firebase.database().ref('/taskBoards').push().key,
                 priority1 = {
                      uid: priority1ID,
                      color: 'red',
                      label: 'Urgent',
                      priority: 1
                 },
                 priority2 = {
                      uid: priority2ID,
                      color: 'orange',
                      label: 'Important',
                      priority: 2
                 },
                 priority3 = {
                      uid: priority4ID,
                      color: 'green',
                      label: 'Neutral',
                      priority: 3
                 },
                 priority4 = {
                      uid: priority5ID,
                      color: 'blue',
                      label: 'Not Important',
                      priority: 4
                 };

            var newBoard = {
                 label: 'Default Board',
                 uid: client.uid,
                 workspace: client.uid,
                 account: client.owner,
                 priorities: {},
                 status: 'active',
                 lists: {},
                 settings: {
                   color: '#eee',
                   showAssignee: true,
                   showDetails: true,
                   showWorkspaceName: true,
                   showRestLines: true,
                   showTimeControls: true
                 }
            };

            newBoard.priorities[priority1ID] = priority1;
            newBoard.priorities[priority2ID] = priority2;
            newBoard.priorities[priority3ID] = priority3;
            newBoard.priorities[priority4ID] = priority4;

            var newTaskListKey = firebase.database().ref('/taskBoards').push().key,
                newTaskList = {
                      uid: newTaskListKey,
                      color: '#bbb',
                      label: 'New Tasks',
                      editable: false,
                      order: 0,
                      type: 'new',
                 },
                 completedTaskListKey = firebase.database().ref('/taskBoards').push().key,
                 completedTaskList = {
                       uid: completedTaskListKey,
                       color: '#999',
                       label: 'Done',
                       editable: false ,
                       order: 1,
                       type: 'closed'
                 };

                 newBoard.lists[newTaskListKey] = newTaskList;
                 newBoard.lists[completedTaskListKey] = completedTaskList;
                 newBoard.defaultList = newTaskListKey;
                 newBoard.closedList = completedTaskListKey;
                 return newBoard;

        }//newTaskBoard


        function checkEmailAddresses(emailAddresses){
            var addressList = emailAddresses.split('\n');
            // $log.info(addressList);
            var valid = true;
            for (var n = 0; n < addressList.length; n++) {
              var addressInfo = addressList[n].trim();
              var validRegExp = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

              if (addressInfo.search(validRegExp) === -1) {
                  valid = false;
                  break
              }
            }

            return valid
        }// checkEmailAddresses

        ///////////////////////////////////
        // updateClient
        function updateClient(client, original) {
            var billingType = 'periods';
            if(_.has(client, 'billingType')){
                billingType = client.billingType;
            }
            if(billingType == 'periods'){
                if(_.has(client.profile, 'plan.nextCycle')){
                    client.profile.plan.nextCycle = moment(client.profile.plan.nextCycle).toISOString();
                    client.profile.plan.monthDay = moment(client.profile.plan.nextCycle).format('D');
                    client.profile.plan.weekDay = moment(client.profile.plan.nextCycle).format('dd');
                    client.profile.plan.weekDay = client.profile.plan.weekDay.toUpperCase();
                }

                if(_.has(client.profile, 'plan.expirationDate')){
                    client.profile.plan.expirationDate = moment(client.profile.plan.expirationDate).toISOString();
                }

            }

            var updates = {},
                adjustBillingPeriod = false,
                now = moment().toISOString();

                var ruleString= getRuleString(client);
                client.profile.plan.ruleString = ruleString;

            // remove deprecated dob property if they have it
            if(_.has(client, 'profile.dob')){
                delete client.profile.dob
            }

            var thisProfile = angular.copy(client.profile);

            if (_.has(thisProfile, 'startDate')) {
                thisProfile.startDate = thisProfile.startDate.toISOString();
            }


            // Set our client's default name
            if (thisProfile.isCompany && thisProfile.company) {
                // using company name for this client label
                thisProfile.fullName = thisProfile.company;
            } else {
                // using first/last for this client label
                thisProfile.fullName = thisProfile.firstname + ' ' + thisProfile.lastname;
            }

            thisProfile.updatedOn = now;

            // check to make sure email addresses in report are valid

            if(_.has(thisProfile, 'weeklyStatusReportEnabled')){
                if(thisProfile.weeklyStatusReportEnabled){
                    var isValid = checkEmailAddresses(thisProfile.weeklyStatusReport.recipients);

                    // Determine if the report is new
                        if(!original.profile.weeklyStatusReportEnabled){
                            //heap.track('Setup Weekly Client Report');

                            userDataService.trackEvent('enable-workspace-status-reports');
                        }


                    if(!isValid){
                        alert('At least one of the email addresses you provided are invalid. Please correct and try again.')
                        return
                    }
                } else {
                    // it's disabled. Delete it.
                    if(original.profile.weeklyStatusReportEnabled){
                        userDataService.trackEvent('disable-workspace-status-reports');
                    }
                    delete thisProfile.weeklyStatusReport
                }// if report enabled

            }// if has report

            // if billing plan set to none, remove everything else on the node
            if(thisProfile.plan.type == 'none'){
                thisProfile.plan = {
                    type: 'none'
                }
            }

            var updates = {};

            // store our canonical object
            updates['/clients/' + client.uid + '/profile'] = thisProfile;
            updates['/clients/' + client.uid + '/status'] = client.status;
            updates['/clients/' + client.uid + '/accountUpdated'] = client.owner + now;
            updates['/clients/' + client.uid + '/updated'] = now;


            // if recurrenceType has changed, also update the current billingPeriod
            var updateBillingPeriod = false;


            // if(original.profile.plan.recurrenceType == 'zero' && (original.profile.plan.recurrenceType != client.profile.plan.recurrenceType)){
            //     // $log.info('switched from balance-based to date-based')
            //     updateBillingPeriod = true;
            // };


            // If we've changed our nextCycle - adjust the last billing period to match
            if(original.profile.plan.nextCycle != client.profile.plan.nextCycle){
                // the cycle date has changed. We are going to find the Current billing period and adjust it's end-date to 1ms prior to the nextCycle
                    _.each(client.billing, function(period){
                        if(isCurrentPeriod(period)){
                            var newEnd = moment(client.profile.plan.nextCycle).subtract(1, 'ms');
                            updates['billingPeriods/' + period.uid + '/info/end'] = moment(newEnd).toISOString();
                            updates['clients/' + client.uid + '/billing/' + period.uid + '/end'] = moment(newEnd).toISOString();
                        }
                    })
            }// if cycle changed

            // remove plan entirely if set to none
            if(client.profile.plan.type == 'none' && client.status == 'active'){
                delete client.profile.plan.nextCycle
                updateBillingPeriod = false;
            }

            // this block converts EXISTING billing period to match the new rules and was originally only used to switch between zero and date based retainers
            // this is inconsistent and adds confusion, even if it's convenient in some cases.
            // We'v disabled the block above that triggers this
            if(updateBillingPeriod){
                // Find the current billing period that needs updating
                var now = moment().toISOString();
                // Find the current billingPeriod for adjusting
                _.each(client.billing, function(billingPeriod){
                   if(billingPeriod.start <= now && billingPeriod.end >= now){
                        // Update it's recurrenceType
                        updates['/billingPeriods/' + billingPeriod.uid + '/info/type'] = client.profile.plan.type;
                        updates['/billingPeriods/' + billingPeriod.uid + '/info/recurrenceType'] = client.profile.plan.recurrenceType;
                        updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/recurrenceType'] = client.profile.plan.recurrenceType;
                        updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/type'] = client.profile.plan.type;

                        //if we are now on balance-based - change the end date to match nextCycle for our daily checks.
                        if(client.profile.plan.recurrenceType == 'zero'){
                            var end = moment().add('2', 'days').toISOString();
                            // update end date for checks on billingPeriod

                            // we *may* have already set this specific node up top.
                            if(!updates['billingPeriods/' + client.profile.plan.currentPeriod + '/info/end']){
                                updates['/billingPeriods/' + billingPeriod.uid + '/info/end'] = end;
                            }
                            updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/end'] = end;
                            // update expiration date on billingPeriod
                            updates['/billingPeriods/' + billingPeriod.uid + '/info/expirationDate'] = client.profile.plan.expirationDate;
                            updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/expirationDate'] = client.profile.plan.expirationDate;
                        }

                        // $log.info(updates);
                        //if we are now on date-based - change the end date to day after "nextCycle"
                        if(client.profile.plan.recurrenceType != 'zero'){
                            var nextCheck = moment(client.profile.plan.nextCycle).subtract(1, 'ms').toISOString();
                            // update nextCheck on billing period
                            updates['/billingPeriods/' + billingPeriod.uid + '/info/end'] = nextCheck;
                            updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid + '/end'] = nextCheck;
                        }
                   };

                   // if billing period start is AFTER today, then it's a period that was created a few days before it starts
                   // and should be deleted because it's based on previous billing settings.
                   // a new period will get created on next check based on the new billing settings.
                   if(billingPeriod.start > now){
                    updates['/billingPeriods/' + billingPeriod.uid] = null;
                    updates['/clients/' + client.uid + '/billing/' + billingPeriod.uid] = null;
                    // save a backup of the discarded period in case it has invoice/charge data that may need restored if there is a problem.
                    updates['/discardedBillingPeriods/' + client.owner + '/' + billingPeriod.client + '/' + billingPeriod.uid] = billingPeriod;
                   }
                })
            }


            // if we are on a client-manager page (i.e. focused on a client)
            // update the rootscope instance of our key client details
            // so our color coding can pick up on it
            if ($state.is('triangular.workspaces.information')) {
                $rootScope.thisClient.clientColor = thisProfile.clientColor;
            }

            //heap.track('Client Updated');
            userpilot.track('Client Updated');
            return firebase.database().ref().update(updates).
            then(function(){
                userDataService.trackEvent('update-workspace');
                $rootScope.$emit('clientUpdated');
            })
        } // end updateClient


        ///////////////////////////////////
        // deleteClient
        function deleteClient(client) {
            // $log.info('deleting');
            var updates = {};

            // all we need to do is change the status to "deleted".
            // Our cloud function will take over from there.
            updates['/clients/' + client.uid + '/status' ] = 'deleting';


            return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('delete-workspace');
            })


        }
        ; // end deleteClient




        ///////////////////////////////////////////////////////////
        /// getClient
        /// Returns entire client object by ID
        function getClient(clientID) {
            // $log.info('clientObjectyByID called;')
            var client = {},
                    d = $q.defer(),
                    clientRef = firebase.database().ref('clients/' + clientID);
            return $firebaseObject(clientRef)
                    .$loaded(function (data) {
                        client = data;
                        // $log.info('client returned');
                        // $log.info(client);
                        d.resolve(client);
                        return d.promise;
                    });

        }
        ; // end getClient




        ///////////////////////////////////////////////////////////
        /// getUsersClients
        //  Gets complete array of client objects assigned to this user
        function getUsersClients(userID) {
            // $log.info(userID);
            var d = $q.defer();
            var clientsRef = firebase.database().ref().child('/clients');
            $firebaseArray(clientsRef.orderByChild("access/users/" + userID).equalTo(true))
                    .$loaded(
                            function (clients) {
                                // $log.info(clients);
                                d.resolve(clients);
                                return d.promise;
                            });
        }
        ; // End getClients



        ///////////////////////////////////////////////////////////
        /// Stores result in clientsArray
        // We have already double-checked and this is working properly (only running on initial load, otherwise returning the service.clientsArray)
        // our delays are not here
        function thisUsersWorkspaces(user, force) {
            // $log.info('thisUsersWorkspaces');
            // if(service.clients){
            //     $log.info('already has '+ service.clients.length +' clients');
            // }
            // $log.info(user);
            return $timeout(function(){
                if(!service.clients || force){
                    // $log.info('XXX - Loading workspaces');

                    // $log.info('Puilling Clients from scratch...');

                    // Clear our array and previous service values
                    clientsArray = [];
                    if(_.has(service, 'clients')){
                        delete service.clients;
                    }
                    if(_.has(user, 'limits.clients')){
                        var clientLimit = user.limits.clients, own = 0;
                    } else {
                        var clientLimit = 1, own = 0;
                    }



                    // Using Array of Promises
                    var clients=[],
                        reads = [],
                        ref= firebase.database().ref();

                    // prepare our array of promises
                    if(_.has(user, 'clients')){
                           _.each(user.clients, function(value, key){
                               var ref = firebase.database().ref('/clients/'+key),
                                   obj = $firebaseObject(ref),
                                   promise = obj.$loaded().then(function(){
                                       if(obj.owner == user.uid){
                                           // Check if we are within limits
                                           if(own <= clientLimit){
                                               // if Owned space
                                               if(obj.demo && obj.status != 'archived'){
                                                   own = own + 1;
                                                   clientsArray.push(obj);
                                               } else if(obj.status == 'active' || obj.status == 'personal'){
                                                   own = own + 1;
                                                   clientsArray.push(obj);
                                               }
                                           }// if under limit

                                       } else {
                                           // If delegated space
                                           if(obj.status == 'active' || obj.status == 'personal'){
                                               // $log.info('pushing delegated: ' + obj.profile.fullName);
                                               clientsArray.push(obj);
                                           }
                                       }
                                   }, function(error){
                                    $log.info('Workspace in user/' + user.uid + '/clients doesn\'t exist or user isn\'t on client\'s access list. Removing this client from list.' );
                                    firebase.database().ref('/users/' + user.uid + '/clients/' + key).set(null);
                                   });
                               reads.push(promise);
                           });

                            return Promise.all(reads)
                            .then(function(){
                               service.clients = clientsArray;
                               // service.setupWorkspaceMenu();
                               $rootScope.$emit('workspacesRefreshed');
                               // $log.info(service.clients);
                               return service.clients;
                            }, function(error){
                               $log.warn('error loading workspaces');
                               $log.warn(error);
                               //heap.track('error loading workspaces');
                               userpilot.track('error loading workspaces');
                               $mdDialog.show(
                                    $mdDialog.alert()
                                      .parent(angular.element(document.querySelector('#popupContainer')))
                                      .clickOutsideToClose(true)
                                      .title('Sorry, I\'m having a problem loading your workspace data.')
                                      .textContent('Please refresh or login again. Contact help@getadminja.com if this message persists.')
                                      .ariaLabel('Adminja Error Dismissed')
                                      .ok('Continue')
                                  );
                            });
                        } else {
                            service.clients = [];
                            return service.clients
                        }




                } else {
                    // $log.info('already have service.clients. Returning.');
                    return service.clients
                    // deferred.resolve(service.clients);
                    // // $log.info(service.clients);
                    // return $q.when(service.clients);
                }
            });
        }// thisUsersWorkspaces

        //this function used in the service function below
        function prepUserData(user){
            // var userType = 'unknown',
            // clientLimit = 1;

            // if(!_.has(user, 'profile')){
            //     var user = {};
            //     // alert('no user!');
            // }

            // if (_.has(user, 'limits.clients')) {
            //     clientLimit = user.limits.clients;
            // }

            // var startDate;
            // if (_.has(user, 'profile.startDate')) {
            //     startDate = user.profile.startDate;
            // } else {
            //     startDate = '2016-10-01';
            // }

            // // set our defaults so we don't throw errors
            // var plan = 'starter-2018c', status = 'unknown';
            // // and overwrite from .plan if it exists
            // if(_.has(user,'plan')){
            //     plan = user.plan.content__subscription__plan_id;
            //     status = user.plan.content__subscription__status;
            // }
            // var firstName = "",
            //     lastName = "";

            // if(_.has(user.profile, 'firstName')){
            //     firstName = user.profile.firstName;
            // }
            // if(_.has(user.profile, 'lastName')){
            //     lastName = user.profile.lastName;
            // }

            // If this is an old pre-launch beta user, we need to refer to non-camelCased names. Uggh.
            if (!localStorageService.get('userName')) {
                if (_.has(user, 'profile.firstName')) {
                    // we have a handful of users on a misnamed schema. FUN TIMES!
                    localStorageService.set('userName', user.profile.firstName + ' ' + user.profile.lastName);
                } else if (_.has(user, 'profile.firstname')){
                    localStorageService.set('userName', user.profile.firstname + ' ' + user.profile.lastname);
                }
            }

            if (!_.has(user, 'profile.avatar')) {
                localStorageService.set('userAvatar', "/assets/images/avatars/generic-person-avatar.png");
            } else {
                localStorageService.set('userAvatar', user.profile.avatar);
            }

        }

        //////////////////////////////////
        // setupUserAndClientMenu
        //////////////////////////////////
        function setupUserAndClientMenu(force) {
            // $log.info('setupUserAndClient Menu ' + force);
            return $timeout(function(){
                    return userDataService.getLoggedInUser(force)
                            .then(function (user) {
                                // extract our assigned client IDs
                                // $log.info('Asking for thisUsersWorkspaces');
                                return thisUsersWorkspaces(user, force)
                                .then(function (clients) {
                                    // triggered by an emit from "thisUsersWorkspaces"


                                    // if(clients.length){
                                    //     $log.info('setting up menu');
                                    //     // service.setupWorkspaceMenu();
                                    // }
                                });
                            });
                       },0);
        } // setupUserAndClientMenu

        function setupWorkspaceMenu(){
            $log.info('setup workspaceMenu');
            // $log.info(service.clients);
            var menus = triMenu.menu,
                    clientLimit = 1,
                    user = userDataService.user,
                    upgradeCandidates = [];


            // If this is an old pre-launch beta user, we need to refer to non-camelCased names. Uggh.
            if (!localStorageService.get('userName')) {
                if (_.has(user, 'profile.firstName')) {
                    // we have a handful of users on a misnamed schema. FUN TIMES!
                    localStorageService.set('userName', user.profile.firstName + ' ' + user.profile.lastName);
                } else if (_.has(user, 'profile.firstname')){
                    localStorageService.set('userName', user.profile.firstname + ' ' + user.profile.lastname);
                }
            }

            if (!_.has(user, 'profile.avatar')) {
                localStorageService.set('userAvatar', "/assets/images/avatars/generic-person-avatar.png");
            } else {
                localStorageService.set('userAvatar', user.profile.avatar);
            }

            // If we are forcing a client menu rebuild, remove the current one
                triMenu.removeMenu('triangular.workspaces');
                triMenu.removeMenu('triangular.vaworkspaces');
                triMenu.removeMenu('triangular.clients');
                triMenu.removeMenu('triangular.internal');
                triMenu.removeMenu('triangular.admin-menu');

            if (_.has(user, 'limits.clients')) {
                clientLimit = user.limits.clients;
            }

            var clientCount = 0, internalOwnCount = 0, internalDelegatedCount = 0, delegatedClientCount = 0;

            var workspaceMenuName = 'Client Workspaces';


            var clientMenu = {
                name: workspaceMenuName,
                icon: 'zmdi zmdi-folder-person',
                type: 'dropdown',
                state: 'triangular.clients',
                priority: 3.0,
                open: false,
                children: []
            }

            var internalMenu = {
                name: 'Internal Workspaces',
                icon: 'zmdi zmdi-folder',
                type: 'dropdown',
                state: 'triangular.internal',
                priority: 5.0,
                open: false,
                children: []
            }

            // if user is also a client, prep their menu as well

                var vaWorkspacesMenu = {
                    name: 'VA Workspaces',
                    icon: 'zmdi zmdi-folder',
                    type: 'dropdown',
                    state: 'triangular.internal',
                    priority: 4.0,
                    open: false,
                    children: []
                }



            if (service.clients.length > 0) {
                var ownClientCount = 0, clientUserClientCount = 0;;
                // Setup our menu object
                // $log.info('setting up menu');
                _.each(service.clients, function (client, index) {
                    if(!_.has(client, 'defaultTaskBoard')){
                      // $log.info('client not upgraded: ');
                      // $log.info(client.profile.fullName + '  ' + client.uid);
                      upgradeCandidates.push(client);
                    }
                    var disabled = true;
                    // Override - allow anything flagged as a demo workspace to show
                    if(client.demo == true){
                        disabled = false;
                        client.type = 'own';

                    } else if(client.owner === user.uid){
                        if (ownClientCount < clientLimit) {
                            disabled = false;
                        }
                        ownClientCount = ownClientCount + 1;
                        // set flag so we can know which clients are owned and which are delegated
                        client.type = 'own';
                        // if workspace has user listed as clientUser
                    } else if(_.has(client, 'clientUsers['+user.uid+']')){
                        client.type = 'clientUser';
                        clientUserClientCount ++;
                        disabled = false;
                    }
                    else {
                        // this client is owned by someone else's account. we MUST allow it.
                        disabled = false;
                        client.type = 'delegated';
                    }


                    if(client.type != 'clientUser'){
                        addClientMenuItem(client, index, disabled, status);
                    } else {
                        addVAMenuItem(client, index, disabled, status);
                    }


                });// each client

                      var searchMenuItem = {
                          name:'Workspace Search',
                          // state: 'triangular.workspaces-manager',
                          icon: 'fa fa-gears',
                          type: 'search',
                          searchScope: 'triangular.workspaces',
                          priority: 1
                      };

                      var delegatedLabel = {
                        name: 'Delegated Workspaces',
                        // state: 'triangular.workspaces-manager',
                        // icon: 'fa fa-gears',
                        type: 'label',
                        align: 'center',
                        // badgeIcon: 'fa fa-gears',
                        priority: 500
                    }



                      if((clientCount + delegatedClientCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          clientMenu.children.push(searchMenuItem)
                      }

                      if((internalOwnCount + internalDelegatedCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          internalMenu.children.push(searchMenuItem)
                      }

                      if((clientUserClientCount) > 10){
                          // $log.info('adding Search to clientMenu');
                          vaWorkspacesMenu.children.push(searchMenuItem)
                      }

                      // $log.info('clientCount: ' + clientCount);
                      // $log.info('delegatedClientCount: ' + delegatedClientCount);
                      // $log.info('internalOwnCount: ' + internalOwnCount);
                      // $log.info('internalDelegatedCount: ' + internalDelegatedCount);

                       // if(delegatedClientCount > 0 && clientCount > 0){
                       //    clientMenu.children.push(delegatedLabel);
                       // }

                       // if(internalOwnCount > 0 && internalDelegatedCount > 0){
                       //    internalMenu.children.push(delegatedLabel);
                       // }

                      if(user.type != 'client'){
                        triMenu.addMenu(clientMenu);
                        }

                      if(clientUserClientCount > 0 && !$rootScope.vaWorkspacesMenuBuilt){
                        triMenu.addMenu(vaWorkspacesMenu);
                        $rootScope.vaWorkspacesMenuBuilt = true;

                      }

                      if((internalOwnCount + internalDelegatedCount) > 0 && user.type != 'client'){
                          // $log.info('adding internal menu');
                          triMenu.addMenu(internalMenu);
                      }

                      if(!service.menuLabelsCreated){
                        triMenu.addMenu({
                            type: 'label',
                            priority: 2.9,
                            name: 'Workspaces',
                            color: 'rgba(255,255,255,0.87);'
                        });
                        if(user.type != 'client'){
                            triMenu.addMenu({
                                type: 'label',
                                priority: 5.2,
                                name: 'Global Views'
                            });
                            triMenu.addMenu({
                                type: 'label',
                                priority: 10.9,
                                name: 'Settings & Training'
                            });
                        }
                        service.menuLabelsCreated = true;
                      }

                if(_.size(upgradeCandidates) > 0){
                    $log.info('Needs upgraded');
                    // We are doing this in batches.
                    //Trim upgradeCandidates to first 5.
                    upgradeCandidates = upgradeCandidates.slice(0, 1);
                    upgradeUser(upgradeCandidates);
                  }


                $rootScope.$emit('clientMenuBuilt');
                return
            } else {

                    // spit out our empty menu so
                    triMenu.addMenu(clientMenu);

                    // alert teamDataService to init
                    $rootScope.$emit('clientMenuBuilt');
                    return

            }

            function upgradeUser(clients){
              $mdDialog.show({
                  controller: 'upgradeModalController',
                  controllerAs: 'vm', // see below
                  templateUrl: 'app/admin-dashboard/upgradeModal.tmpl.html',
                  parent: angular.element(document.body),
                  locals: {
                      workspaces: clients
                  },
                  bindToController: true,
                  focusOnOpen: true,
                  multiple: true,
                  clickOutsideToClose: false,
                  escapeToClose: true,
                  fullscreen: true
              });
            }//updgradeUser

            // utility function - setup and add each client to menu array
            function addClientMenuItem(client, index, disabled, userStatus) {

                    if (_.has(client.profile, 'fullName')) {
                        // TODO -we need to stop using .name and use .fullName instead throughout system
                        client.profile.name = client.profile.fullName;
                    } else {
                        client.profile.name = client.profile.firstname + ' ' + client.profile.lastname;
                    }


                    var thumbnail = undefined;

                    // Set most common default
                    thumbnail = "/assets/images/avatars/generic-person-avatar.png";

                    // Various cascade of checks to determine thumnbail for this workspace
                    if (!_.has(client.profile,'avatar') && client.status == 'personal') {
                        thumbnail = "/assets/images/avatars/generic-default-avatar.png";
                    }

                     if (_.has(client.profile,'avatar')) {
                         thumbnail = client.profile.avatar;
                     }

                     if (_.has(client.profile,'thumbnail')) {
                         thumbnail = client.profile.thumbnail;
                     }


                     // $log.info('nav thumb: ' + thumbnail);
                    if (!client.profile.clientColor) {
                        client.profile.clientColor = "#999"
                    }

                    // if we don't own this client. Put it at the bottom of our menu
                    var thisOrder = 1;
                    if(_.has(client, 'order')){
                        thisOrder = client.order
                    };
                    if(_.has(client, 'userOrders')){
                        if(_.has(client.userOrders, 'user'+$rootScope.userID)){
                            thisOrder = client.userOrders['user'+$rootScope.userID]
                        }
                    }

                    // if(client.owner != $rootScope.userID){
                    //     thisOrder = thisOrder + 100
                    // }

                    var newPriority = thisOrder + 6;

                    // if(client.type == 'delegated'){
                    //     newPriority = thisOrder + 500;
                    // }

                    var clientMenuItem = {
                            name: client.profile.fullName,
                            email: client.profile.email,
                            icon: thumbnail,
                            avatar: thumbnail,
                            avatarThumb: thumbnail,
                            clientType: client.type,
                            priority: newPriority,
                            type: 'client',
                            state: 'triangular.workspaces.tasks',
                            color: client.profile.clientColor,
                            clientid: client.uid,
                            clientactive: false,
                            disabled: disabled,
                            subStatus: userStatus,
                            status: client.status
                        }

                    // push to the correct menu

                    if(client.status == 'personal'){
                        if(client.type == 'own'){
                            internalOwnCount ++
                        } else if (client.type == 'delegated'){
                            internalDelegatedCount ++
                        }
                        internalMenu.children.push(clientMenuItem);
                    } else {
                        if(client.type == 'own'){
                            clientCount ++
                        }
                        if(client.type == 'delegated'){
                            delegatedClientCount ++
                        }
                        clientMenu.children.push(clientMenuItem);
                    }

            }
                function addVAMenuItem(client, index, disabled, userStatus) {
                    if(!_.has($rootScope, 'VAWorkspacesMenu')){
                        $rootScope.VAWorkspacesMenu = [];
                    }

                    firebase.database().ref('/userList/' + client.owner).once('value').then(function(snapshot){
                        var virtualAssistant = snapshot.val();
                        var thumbnail = undefined;
                        // Set most common default
                        thumbnail = "/assets/images/avatars/generic-person-avatar.png";
                        if(_.has(virtualAssistant, 'avatar')){
                            thumbnail = virtualAssistant.avatar
                        }

                         // $log.info('nav thumb: ' + thumbnail);
                        if (!client.profile.clientColor) {
                            client.profile.clientColor = "#999"
                        }

                        // adjust the client's fullName to indicate which VA it's with
                        if(!client.profile.adjustedName){
                            client.profile.fullName = client.profile.fullName + ' and ' + virtualAssistant.fullName;
                            client.profile.adjustedName = true;
                        }

                        var clientMenuItem = {
                                name: client.profile.fullName,
                                email: client.profile.email,
                                icon: thumbnail,
                                avatar: thumbnail,
                                avatarThumb: thumbnail,
                                clientType: client.type,
                                priority: 3 + index,
                                type: 'va',
                                state: 'triangular.workspaces.tasks',
                                color: client.profile.clientColor,
                                clientid: client.uid,
                                clientactive: false,
                                disabled: disabled,
                                subStatus: userStatus,
                                status: client.status
                            }

                            vaWorkspacesMenu.children.push(clientMenuItem);
                            $rootScope.VAWorkspacesMenu.push(clientMenuItem);
                    });
            }// addVaMenuItem
        }




        function restoreClient(client){
            // $log.info('clientDataService.restoreClient');
            var canRestore = true,
                today = moment();

            // if previously Restored, check to see if they should be allowed to do it again
            // if(_.has(client, 'lastRestored')){
            //     var previous = moment(client.lastRestored),
            //         difference = today.diff(previous, 'days');
            //     if (difference > 15){
            //         canRestore = true;
            //     }  else {
            //         canRestore = false;
            //     }
            // }

            if (canRestore || userDataService.user.type == 'admin'){
                var updates = {};
                updates['clients/' + client.uid + '/status'] = client.oldStatus;
                updates['clients/' + client.uid + '/lastRestored'] = moment().toISOString();
                updates['clients/' + client.uid + '/access/users/' + client.owner] = true;
                updates['clients/' + client.uid + '/access/admins/' + client.owner] = true;
                updates['users/' + client.owner + '/clients/'+ client.uid] = true;
                // remove from the team archive list
                updates['teams/' + client.owner + '/archivedWorkspaces/' + client.uid] = null;

                // if being restored by a team administrator, add them as well
                if(client.owner != $rootScope.userID){
                    updates['clients/' + client.uid + '/access/users/' + $rootScope.userID] = true;
                    updates['clients/' + client.uid + '/access/admins/' + $rootScope.userID] = true;
                    updates['users/' + $rootScope.userID + '/clients/'+ client.uid] = true;
                    updates['teams/' + client.owner + '/members/' + $rootScope.userID + '/clients/' + client.uid] = 'admin';
                }

                updates['clients/' + client.uid + '/access/archiveOwner/' + client.owner] = null;
                return firebase.database().ref().update(updates)
                // Add the default "Client Details" panel to this client
                .then(function (response) {
                    service.setupUserAndClientMenu(true);
                    // service.thisUsersWorkspaces(userDataService.user, true);
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: client.profile.fullName + ' has being restored.',
                                message: '' ,
                                color: 'green'
                            }
                        }));// mdToast
                });
            } else {
                // This Space has already been restored once in the past 30 days.
                // Prohibit doing it now
                $mdDialog.show(
                     $mdDialog.alert()
                       .parent(angular.element(document.querySelector('#popupContainer')))
                       .clickOutsideToClose(true)
                       .title('Restore Prohibited')
                       .textContent('To prevent abuse, a Space can only be archived/restored once per month.')
                       .ariaLabel('Restore Prohibited')
                       .ok('Got it!')
                       .targetEvent()
                   );
            }


            // if lastRestored IS within past 30 days - block restore

        } // restoreClient

        function archiveClient(client){
            // $log.info('clientDataService.archiveClient');
            if(_.has(client, 'packages')){
                var numPackages = _.size(client.packages), count = 0;
                _.each(client.packages, function(thisPackage){
                    return clientPackageService.archivePackage(thisPackage)
                    .then(function(){
                        count ++
                        if(count == numPackages){
                            doArchive(client);
                        }
                    })
                })
            } else {
                doArchive(client);
            }

            function doArchive(client){
                var oldStatus = client.status;
                var updates = {};
                updates['clients/' + client.uid + '/oldStatus'] = oldStatus;
                updates['clients/' + client.uid + '/status'] = 'archived';
                updates['clients/' + client.uid + '/lastArchived'] = moment().toISOString();
                // add owner to /access/archiveOwner
                updates['clients/' + client.uid + '/access/archiveOwner/' + client.owner] = true;
                // remove owner from /users list
                updates['clients/' + client.uid + '/access/users/' + client.owner] = null;

                // add to team node list of archived clients (we will pull archived clients from this)
                // TODO - create utility function and create this node for all archived clients that currently exist.

                updates['/teams/' + client.owner + '/archivedWorkspaces/' + client.uid] = true;


                return firebase.database().ref().update(updates)
                // Add the default "Client Details" panel to this client
                .then(function (response) {
                    userDataService.trackEvent('archive-workspace');
                    service.setupUserAndClientMenu(true);

                    // service.thisUsersWorkspaces(userDataService.user, true);
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: client.profile.fullName + ' is being archived.',
                                message: ' ',
                                color: 'red'
                            }
                        }));// mdToast
                });

            }// doArchive

        }// archiveClient


        function copyClient(clientID, targetUserID, isDemo){
            return new Promise(function(resolve, reject){
                return service.getClient(clientID)
                .then(function(client){
                    return doCopy(client, targetUserID, isDemo)
                    .then(function(newClient){
                        $log.info('done copying');
                        return resolve(newClient);
                    });
                });
            })// promise


            // the actual work
            function doCopy(client, targetUserID, isDemo){
                return new Promise(function(resolve, reject){
                    // prepare a backup client and our newClient object
                    var clientCopy = angular.fromJson(angular.toJson(client)),
                        newClient = angular.fromJson(angular.toJson(client)),
                        updates = {},
                        now = moment().toISOString();

                    clientCopy = ajUTILITIES.removePropertiesWith(clientCopy);
                    newClient = ajUTILITIES.removePropertiesWith(newClient);

                    //Get new UID for this client
                    var newKey = firebase.database().ref('/clients').push().key;

                    newClient.uid = newKey;
                    newClient.owner = targetUserID;

                    //Add demo flag if set
                    if(isDemo){
                        newClient.demo = true;
                        updates['/users/' + targetUserID + '/firstLogin'] = true;
                    }


                    // Remove accumulated dirt
                    delete newClient.lastRestored
                    delete newClient.lastArchived
                    delete newClient.oldStatus
                    delete newClient.retainer_totals
                    delete newClient.time
                    delete newClient.totals
                    delete newClient.billing
                    delete newClient.invoices
                    delete newClient.profile.workspaceAddress
                    delete newClient.schedules
                    delete newClient.packages
                    delete newClient.clientUsers
                    delete newClient.clientUserTabs
                    delete newClient.profile.weeklyStatusReport
                    delete newClient.profile.weeklyStatusReportEnabled
                    delete newClient.accountUpdated
                    delete newClient.taskBoards
                    delete newClient.detailBoards
                    delete newClient.defaultTaskBoard
                    delete newClient.defaultDetailBoard


                    // set our created nodes
                    newClient.created = now;
                    newClient.accountCreated = newClient.owner + now;

                    /// this isn't stored on the DB but is added after load.
                    // let's make sure we don't store it on the copy
                    delete newClient.type

                    // Remove and replace access
                    delete newClient.access
                    newClient.access = {};
                    newClient.access.users = {};
                    newClient.access.users[targetUserID] = true;
                    newClient.access.admins = {};
                    newClient.access.admins[targetUserID] = true;

                    // Prepare plan to start on today
                    if(_.has(newClient.profile, 'plan.currentPeriod')){
                        delete newClient.profile.plan.currentPeriod;
                    }
                    if(!_.has(newClient, 'profile')){
                        newClient.profile = {};
                    }
                    if(!_.has(newClient, 'profile.plan')){
                        newClient.profile.plan = {};
                    }

                    if(!isDemo){
                        newClient.profile.fullName = "Copy of " + newClient.profile.fullName;
                    }


                    // Give them an empty plan
                    newClient.profile.plan = { rate: 0};

                    // Remove the items we are going to rebuild properly from backup
                    delete newClient.tasks
                    delete newClient.taskpanels
                    delete newClient.taskTemplates
                    delete newClient.panels

                    // If archived, make it active
                    if(newClient.status == 'archived'){
                        newClient.status = 'active';
                    }


                    updates['/clients/' + newKey] = newClient;
                    updates['/users/' + targetUserID +'/clients/' + newKey] = true;


                    return firebase.database().ref().update(updates)
                    .then(function(){
                        $log.info('New Workspaces Created');
                        return copyTaskBoard(clientCopy, newClient)
                        .then(function(newClient){
                            $log.info('TaskBoard Copied');
                            var taskPromises = [];
                            _.each(clientCopy.tasks, function(task){
                                if(_.has(task, 'uid')){
                                    taskPromises.push(copyTask(task, clientCopy, newClient))
                                }
                            });
                            return Promise.allSettled(taskPromises)
                            .then(function(){
                                $log.info('Tasks Copied');
                                return copyDetailBoard(clientCopy, newClient)
                                .then(function(newClient){
                                    $log.info('DetailBoard Copied');
                                    return copyDetails(clientCopy, newClient)
                                    .then(function(){
                                        $log.info('Details Copied');
                                        var templatePromises = [];
                                        _.each(clientCopy.taskTemplates, function(task){
                                            templatePromises.push(copyTaskTemplate(task, clientCopy, newClient))
                                        })
                                        return Promise.allSettled(templatePromises)
                                        .then(function(){
                                            userDataService.trackEvent('clone-workspace');
                                            return resolve(newClient)
                                        })
                                        .catch(function(error){
                                            $log.error("Could not clone workspace!")
                                            $log.error(error)
                                            return reject(error)
                                        });
                                    })
                                })
                            })
                        })
                    })
                });//promise
            }// doCopy

        }// copyClient

            function copyTaskBoard(clientCopy, newClient){
                // $log.info('copy Task Board');
                return new Promise(function(resolve, reject){
                    var updates = {};
                    firebase.database().ref('/taskBoards/' + clientCopy.defaultTaskBoard).once('value', function(snap){
                        if(snap.exists()){
                            var thisTaskBoard = snap.val(),
                                newTaskBoardKey = newClient.uid,
                                newTaskBoard = thisTaskBoard;

                            newTaskBoard.uid = newTaskBoardKey;

                            // prep client
                            newClient.defaultTaskBoard = newTaskBoardKey;
                            newClient.taskBoards = {};

                            // clean up newTaskBoard
                            _.each(newTaskBoard.lists, function(list){
                                // delete items (they'll get copied in next function and we don't need them on the client)
                                delete list.items;
                                // give the list a new UID
                                var newListKey = firebase.database().ref('/taskBoards/').push().key;

                                // save the original ID so we can map tasks to it later
                                list.oldUid = list.uid;
                                list.uid = newListKey;

                                // add new list to taskBoard and remove the old one
                                newTaskBoard.lists[list.uid] = list;
                                delete newTaskBoard.lists[list.oldUid];

                                // if it's "new" or "closed" let's mark them
                                if(list.type == 'new'){
                                    newTaskBoard.defaultList = list.uid;
                                }

                                if(list.type == 'closed'){
                                    newTaskBoard.closedList = list.uid;
                                }
                            });

                            // put it on our new client
                            newClient.taskBoards[newTaskBoard.uid] = newTaskBoard;

                            updates['/taskBoards/' + newTaskBoard.uid] = newTaskBoard;
                            updates['/clients/' + newClient.uid + '/defaultTaskBoard'] = newClient.defaultTaskBoard;
                            updates['/clients/' + newClient.uid + '/taskBoards'] = newClient.taskBoards;
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                return resolve(newClient)
                            })
                            .catch(function(error){
                                $log.error('Could not save new taskBoard')
                                $log.error(error)
                                return reject(error)
                            })
                        }
                    })
                })
            }// copyTaskBoard

            function copyDetailBoard(clientCopy, newClient){
                    return new Promise(function(resolve, reject){
                        var updates = {};
                        firebase.database().ref('/detailBoards/' + clientCopy.defaultDetailBoard).once('value', function(snap){
                            if(snap.exists()){
                                var thisDetailBoard = snap.val(),
                                    newDetailBoardKey = newClient.uid,
                                    newDetailBoard = thisDetailBoard;

                                newDetailBoard.uid = newDetailBoardKey;

                                // prep client
                                newClient.defaultDetailBoard = newDetailBoardKey;
                                newClient.detailBoards = {};

                                // clean up newDetailBoard
                                _.each(newDetailBoard.lists, function(list){
                                    //delete items (they'll get copied in the next step)
                                    delete list.items;
                                    //give the list a new UID
                                    var newListKey = firebase.database().ref('/detailBoards/').push().key;

                                    // save the original ID so we can map tasks to it later
                                    list.oldUid = list.uid;
                                    list.uid = newListKey;

                                    // add new list to taskBoard and remove the old one
                                    newDetailBoard.lists[list.uid] = list;
                                    delete newDetailBoard.lists[list.oldUid];

                                    if(list.type == 'client-details'){
                                        newDetailBoard.defaultList = list.uid;
                                    }

                                });
                                // put it on our new client
                                newClient.detailBoards[newDetailBoard.uid] = newDetailBoard;

                                updates['/detailBoards/' + newDetailBoard.uid] = newDetailBoard;
                                updates['/clients/' + newClient.uid + '/defaultDetailBoard'] = newDetailBoard.uid;
                                updates['/clients/' + newClient.uid + '/detailBoards'] = newClient.detailBoards;
                                $log.info('saving new detail board');
                                $log.info(updates);
                                return firebase.database().ref().update(updates)
                                .then(function(){
                                    return resolve(newClient)
                                })
                                .catch(function(error){
                                    $log.error('Could not save new detailBoard')
                                    $log.error(error)
                                })
                            }
                        })
                    });
            }//copyDetailBoard

            function copyDetails(clientCopy, newClient){
                return new Promise(function(resolve, reject){
                    var updates = {};
                    firebase.database().ref('/detailBoards/' + clientCopy.defaultDetailBoard).once('value', function(snap){
                        if(snap.exists()){
                            var thisDetailBoard = snap.val();
                            _.each(thisDetailBoard.lists, function(list){
                                _.each(newClient.detailBoards[newClient.defaultDetailBoard].lists, function(newList){
                                    if(list.uid == newList.oldUid){
                                        _.each(list.items, function(detail){
                                            var newDetail = angular.fromJson(angular.toJson(detail));
                                            newDetail = ajUTILITIES.removePropertiesWith(newDetail);
                                            var newDetailKey = firebase.database().ref('/detailBoards').push().key;
                                            newDetail.client = newClient.uid;
                                            newDetail.list = newList.uid;
                                            newDetail.board = newClient.defaultDetailBoard;
                                            newDetail.uid = newDetailKey;
                                            newDetail.creator = $rootScope.userID;

                                            // Flag all files as pending copy
                                            // our taskFileChange cloud function will make file copies and adjust the paths.
                                            if(_.has(newDetail, 'files')){
                                                var uniqueID = guid();

                                                _.each(newDetail.files, function(file, index){
                                                    if(file.source == "firebaseStorage"){
                                                        file.source = "pendingFirebaseStorage";
                                                        file.newFullPath = '/clients/' + newDetail.client + '/profile/' + uniqueID + file.fileName;
                                                        file.newResponsePath = '/detailBoards/' + newClient.defaultDetailBoard + '/lists/' + newList.uid + '/items/' + newDetailKey + '/files/' + index;
                                                    }
                                                })
                                            }// if task has files
                                            updates['/detailBoards/' + newDetail.board + '/lists/'+ newDetail.list + '/items/' + newDetailKey] = newDetail;
                                        }); // each item in list
                                    }
                                });//each new List
                            });// each old List
                            return firebase.database().ref().update(updates)
                            .then(function(){
                                return resolve(newClient)
                            })
                            .catch(function(error){
                                $log.error('Could not copy detail cards');
                                $log.error(error)
                                return reject(error)
                            })
                        }
                    });//get original board
                });// promise
            }//copyDetails

            function copyTask(task, clientCopy, newClient){
                    // for some reason, if we make this a promise, promise.all never returns to the calling function.
                    var updates = {};
                    // only if it's good data

                    var newKey = firebase.database().ref('/tasks/').push().key;
                    // get the full task from DB
                    var taskRef = firebase.database().ref('tasks/' + task.uid);
                    taskRef.once('value', function(snap){
                        if(snap.exists()){
                            var fullTask = snap.val();
                            var newTask = angular.fromJson(angular.toJson(fullTask));
                            newTask = ajUTILITIES.removePropertiesWith(newTask);

                            delete newTask.notes
                            delete newTask.activity
                            delete newTask.info.assigneeName;
                            delete newTask.info.assigneeAvatar;
                            delete newTask.info.parentTemplate;
                            newTask.uid = newKey;
                            newTask.info.uid = newKey;
                            newTask.info.refID = newKey;
                            newTask.info.client = newClient.uid;
                            newTask.info.clientName = newClient.profile.fullName;
                            newTask.creator = newClient.owner;
                            newTask.info.assignee = newClient.owner;
                            newTask.info.created = moment().unix();
                            newTask.info.logged = 0;
                            newTask.info.numnotes = 0;
                            newTask.info.board = newClient.defaultTaskBoard;
                            if(_.has(newClient, 'demo')){
                                newTask.info.demo = true;
                            }
                            // newTask.info.status = 'open';


                           // Assign the proper list to the task
                           var listFound = false;
                           _.each(newClient.taskBoards[newClient.defaultTaskBoard].lists, function(list){
                                if(list.oldUid == newTask.info.list){
                                    newTask.info.list = list.uid;
                                    listFound = true;
                                }
                           });
                           // if list not found, put it on defaultList
                           if(!listFound){
                            newTask.info.list = newClient.taskBoards[newClient.defaultTaskBoard].defaultList
                           }

                            // Flag all files as pending copy
                            // our taskFileChange cloud function will make file copies and adjust the paths.
                            if(_.has(newTask.info, 'files')){
                                var uniqueID = guid();
                                _.each(newTask.info.files, function(file, index){
                                    if(file.source == "firebaseStorage"){
                                        file.source = "pendingFirebaseStorage";
                                        file.newFullPath = 'clients/' + newTask.info.client + '/tasks/' + uniqueID + file.fileName;
                                        file.newResponsePath = 'tasks/' + newTask.uid + '/info/files/' + index;
                                        file.newResponsePath2 = 'clients/' + newTask.info.client + '/tasks/' + newTask.uid + '/info/files/' + index;
                                    }
                                })
                            }// if task has files

                            // if checklist, get unique IDs for all of them.
                            if(_.has(fullTask, 'checklist')){
                               _.each(fullTask.checklist, function(item){
                                  var newChecklistItem = angular.fromJson(angular.toJson(item));
                                  newChecklistItem = ajUTILITIES.removePropertiesWith(newChecklistItem);
                                  delete newChecklistItem.reminders;
                                  newChecklistItem.complete = false;
                                  var newItemID = firebase.database().ref('/tasks').push().key, oldID = newChecklistItem.uid;
                                  newChecklistItem.uid = newItemID
                                  newTask.checklist[newItemID] = newChecklistItem;
                                  delete newTask.checklist[oldID]
                               });
                           };

                            updates['/tasks/' + newTask.uid] = newTask;
                            updates['/clients/' + newTask.info.client + '/tasks/' + newTask.uid] = newTask.info;
                            // updates['/users/' + newClient.owner + '/tasks/' + newTask.uid] = newTask.info;
                            updates['/taskBoards/' + newTask.info.board + '/lists/' + newTask.info.list + '/items/' + newTask.info.uid] = newTask.info;

                            // save our new task and it's fanned data
                            return firebase.database().ref().update(updates)
                        }
                        else {
                            // Snapshot doesn't exist. skipping
                            return
                        }
                        });// .once value



            }//copyTask


            function copyTaskTemplate(task, clientCopy, newClient){
                // $log.info('copy Tasks');
                    // $log.info('copying taskTemplates');
                    var updates = {};
                    // only if it's good data
                    if(_.has(task, 'uid')){
                        var newKey = firebase.database().ref('/taskTemplates/').push().key;
                        // get the full task from DB
                        var taskRef = firebase.database().ref('taskTemplates/' + task.uid);
                        taskRef.once('value', function(fullTask){
                            var newTask = angular.fromJson(angular.toJson(fullTask));
                            newTask = ajUTILITIES.removePropertiesWith(newTask);

                            delete newTask.notes;
                            delete newTask.activity;
                            delete newTask.checklist;
                            delete newTask.info.duedate;
                            delete newTask.info.startdate;
                            delete newTask.info.assigneeName;
                            delete newTask.info.assigneeAvatar;
                            delete newTask.info.parentTemplate;
                            newTask.schedule.count = 0;
                            newTask.uid = newKey;
                            newTask.info.refID = newKey;
                            newTask.info.client = newClient.uid;
                            newTask.info.clientName = newClient.profile.fullName;
                            newTask.creator = newClient.owner;
                            newTask.info.assignee = newClient.owner;
                            newTask.info.created = moment().unix();
                            newTask.info.logged = 0;
                            newTask.info.numnotes = 0;
                            // newTask.info.private = false;
                            newTask.info.status = 'open';
                            newTask.info.board = newClient.defaultTaskBoard;
                            newTask.info.list = newClient.taskBoards[newClient.defaultTaskBoard].defaultList;


                            // Flag all files as pending copy
                            // our taskFileChange cloud function will make file copies and adjust the paths.
                            if(_.has(newTask.info, 'files')){
                                _.each(newTask.info.files, function(file, index){
                                    // if the file is stored in firebase, we need to copy it to the new workspace
                                    if(file.source == "firebaseStorage"){
                                        file.source = "pendingFirebaseStorage";
                                        file.newFullPath = '/clients/' + newTask.info.client + '/taskTemplates/' + file.fileName;
                                        file.newResponsePath = '/taskTemplates/' + newTask.uid + '/info/files/' + index;
                                        file.newResponsePath2 = '/clients/' + newTask.info.client + '/taskTemplates/' + newTask.uid + '/info/files/' + index;
                                    }
                                })
                            }// if task has files

                            if(_.has(fullTask, 'checklist')){
                                _.each(fullTask.checklist, function(item){
                                   var newChecklistItem = angular.fromJson(angular.toJson(item));
                                   newChecklistItem = ajUTILITIES.removePropertiesWith(newChecklistItem);

                                   var newItemID = firebase.database().ref('/tasks').push().key, oldID = newChecklistItem.uid;
                                   newChecklistItem.uid = newItemID
                                   newTask.checklist[newChecklistItem.uid] = newChecklistItem;
                                   delete newTask.checklist[oldID];
                                });
                            };

                            updates['/taskTemplates/' + newTask.uid] = newTask;
                            updates['/clients/' + newTask.info.client + '/taskTemplates/' + newTask.uid] = newTask;
                            // updates['/users/' + newClient.owner + '/tasks/' + newTask.uid] = newTask.info;
                            // save our new task and it's fanned data
                            return firebase.database().ref().update(updates)
                        });// return Task
                    }// if valid task

            }//copyTaskTemplate


            function copyNotes(clientCopy, newClient){
                // $log.info('copy Note Board');
                _.each(clientCopy.panels, function(panel){
                    if(_.has(panel, 'uid')){
                        var updates = {};
                        // Setup our new Panel
                        var newPanel = angular.fromJson(angular.toJson(panel));
                        newPanel = ajUTILITIES.removePropertiesWith(newPanel);
                        var newPanelKey = firebase.database().ref('/clients/'+newClient.uid+'/panels').push().key;
                        delete newPanel.details;
                        newPanel.uid = newPanelKey;
                        newPanel.client = newClient.uid;
                        newPanel.createdOn = moment().toISOString();
                        updates['/clients/' + newClient.uid + '/panels/'+ newPanel.uid] = newPanel;
                        // create our panel
                        return firebase.database().ref().update(updates)
                        .then(function(){
                            var detailUpdates = {}
                            // setup our deails array
                            _.each(panel.details, function(detail){
                                var newDetail = angular.fromJson(angular.toJson(detail));
                                newDetail = ajUTILITIES.removePropertiesWith(newDetail);
                                var newDetailKey = firebase.database().ref('/clients').push().key;
                                newDetail.client = newClient.uid;
                                newDetail.panel = newPanelKey;
                                newDetail.uid = newDetailKey;

                                // Flag all files as pending copy
                                // our taskFileChange cloud function will make file copies and adjust the paths.
                                if(_.has(newDetail, 'files')){
                                    var uniqueID = guid();

                                    _.each(newDetail.files, function(file, index){
                                        if(file.source == "firebaseStorage"){
                                            file.source = "pendingFirebaseStorage";
                                            file.newFullPath = '/clients/' + newDetail.client + '/profile/' + uniqueID + file.fileName;
                                            file.newResponsePath = '/clients/' + newDetail.client + '/panels/' + newPanelKey + '/details/' + newDetailKey + '/files/' + index;
                                        }
                                        // if(file.source == "googleDrive"){
                                        //     file.source = "pendingGoogleDrive";
                                        //     file.newWorkspace = newDetail.client;
                                        //     file.newDetail = newDetailKey;
                                        //     file.newPanel = newPanelKey;

                                        // }
                                        // if(file.source == "dropbox"){
                                        //     file.source = "pendingDropbox";
                                        //     file.newWorkspace = newDetail.client;
                                        //     file.newDetail = newDetailKey;
                                        //     file.newPanel = newPanelKey;
                                        // }
                                    })
                                }// if task has files
                                detailUpdates['/clients/' + newClient.uid + '/panels/'+ newPanel.uid + '/details/' + newDetailKey] = newDetail;
                            });// each detail
                            // save our details on our panel
                            return firebase.database().ref().update(detailUpdates)
                        });
                    }//if valid panel

                }); // each panel
            }// copyNotes


            function setupClientPanels(client){

               var profilePanels = [];

                //if it's a client workspace, include the client details panel by default.
                if(client.status != 'personal'){
                    var defaultPanel = { 'label': 'Client Details',
                      'color': '#787575',
                      'order': 1
                    }
                    profilePanels.push(defaultPanel)
                }


                // Add our profile panels
                _.each(profilePanels, function(panel, index){
                    var updates = {};
                    var newPanelKey = firebase.database().ref().child('clients/' + client.uid + '/panels').push().key,
                        newPanel = {
                            client: client.uid,
                            details: {},
                            order: index+1,
                            label: panel.label,
                            color: panel.color,
                            uid: newPanelKey
                        };

                    // $log.info(newPanel);
                    updates['clients/' + client.uid + '/panels/' + newPanelKey] = newPanel;
                    return firebase.database().ref().update(updates)

                });

            }// setupClientPanels

            function isCurrentPeriod(period){
                var now = moment().toISOString();
                if (period.start <= now && period.end > now){
                    return true
                } else {
                    return false
                }
            }

            // Utility function used to generate unique IDs for each image uploaded to storage
            function guid() {
              function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
              }
              return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
            }

    };// service



})();

(function () {
    'use strict';


    angular.module('appServices')
            .service('clientBillingService', clientBillingService);

    /* @ngInject */
    function clientBillingService($log, $q, moment, taskDataService,
                userDataService, clientDataService, timeDataService, $mdMedia, $mdDialog, $rootScope,
                $timeout, $firebaseArray, $firebaseObject, timeReportService, invoiceService) {


        var service = {
            init: init,
            selectPeriod: selectPeriod,
            deselectPeriod: deselectPeriod,
            updateBillingPeriod: updateBillingPeriod,
            findPeriod: findPeriod,
            periodDatesChanged: false,
            getInvoices: getInvoices,
            getPackages: getPackages
        };

        return service;

        var userID = undefined;

        // Initialize service.timerData object
        function init(clientID){
            var user = firebase.auth().currentUser;
            if (user){
              userID = user.uid;
              // clear our selected Period
              delete service.selectedPeriod
            }
        }


        function getPackages(clientID, status){
          return new Promise(function(resolve, reject){
            $firebaseArray(firebase.database().ref().child('/clientPackages').orderByChild("workspaceStatus").equalTo(clientID+status))
                    .$loaded(
                        function (packages) {
                          return resolve(packages);
                        });
          });
        }//getActivePackages


        function getInvoices(start, end){
          return new Promise(function(resolve, reject){
            var invoiceRef = firebase.database().ref('/invoices').orderByChild('info/ownerDate').startAt(start).endAt(end);
            $firebaseArray(invoiceRef)
            .$loaded(function(invoices){
              // $log.info('service:', invoices);
              return resolve(invoices)
            })
          });

        }// getInvoices

        function findPeriod(client, date){
          if(_.has(client, 'billing')){
              var queryDate = moment(date).startOf('day').toISOString();
              _.each(client.billing, function(billingPeriod){
                  if(billingPeriod.start <= queryDate && billingPeriod.end > queryDate){
                     return billingPeriod
                  }
              });
          }
        }

        function selectPeriod(period){
          // $log.info('selectPeriod:', period);
          var newPeriod = {},
              periodRef = firebase.database().ref('billingPeriods/' + period.uid);
          return $firebaseObject(periodRef)
                  .$loaded(function (data) {
                      delete invoiceService.selectedInvoice;
                      delete invoiceService.selectedTime;
                      service.selectedPeriod = data;
                      // Take our simple start/end dates and convert them to a value our pickers can display correctly
                      service.selectedPeriod.displayStartDate = moment(service.selectedPeriod.info.start);
                      service.selectedPeriod.displayEndDate = moment(service.selectedPeriod.info.end);
                      if(_.has(service.selectedPeriod.info, 'expirationDate')){
                        service.selectedPeriod.displayExpirationDate = moment(service.selectedPeriod.info.expirationDate).endOf('day');
                      } else {
                        service.selectedPeriod.displayExpirationDate = moment(service.selectedPeriod.info.end);
                      }
                      // Update timeReportService so we have access to the time for this period.
                      // console.log('getting time between ' + service.selectedPeriod.info.start + ' and ' + service.selectedPeriod.info.end);
                      var thisStart =  moment(service.selectedPeriod.info.start).toISOString(),
                          thisEnd = moment(service.selectedPeriod.info.end).toISOString();

                      // $log.info('Pulling time for: ' + period.client);
                      // $log.info('Start: ' + thisStart);
                      // $log.info('End: ' + thisEnd);

                      timeReportService.getClientsTime(service.selectedPeriod.info.client, thisEnd, thisStart);
                  });
        } // selectPeriod


        function deselectPeriod(){
          service.selectedPeriod = undefined;
          service.periodDatesChanged = false;
        }

        function updateBillingPeriod(info){

          // update start/end if they've been changed
          if(service.periodDatesChanged){
            info.start = moment(info.start).startOf('day').toISOString();
            info.end = moment(info.end).endOf('day').toISOString();
          }

          var updates = {};
          // update our canonical object
          updates['billingPeriods/' + info.uid + '/info'] = info;
          // update our reference in the client's
          updates['clients/' + info.client + '/billing/' + info.uid] = info;
          // Execute our update
          return firebase.database().ref().update(updates)
                  .then(function () {
                      // $log.info('Billing Period Updated');
                      //heap.track('Billing Period Updated');
                      userpilot.track('Billing Period Updated');
                  });

        } // updateBillingPeriod


    } // end clientBillingService
})();

(function() {
    'use strict';

    angular
        .module('app.authentication', [
        	'appServices'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('registrationController', registrationController);

    /* @ngInject */
    function registrationController($log, $scope, $location, $timeout, $state, $http, $mdDialog, $firebaseArray, $firebaseObject, $window, firebase, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService, teamDataService, gateService, clientDataService) {
        // log.info('info')('registrationController');
      var vm = this;
      var subscriptionComplete = false;
      firebase.auth().signOut()
      .then(function(){
        var statusRef = firebase.database().ref('/appState/currentState');
        $firebaseObject(statusRef)
        .$loaded(function(response){
          vm.adminjaStatus = response;
        });// end get owner
      })
      // reset isRegistering

      vm.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      vm.timeZoneOffset = moment().utcOffset()/60;

      $rootScope.isRegistering = true;

        vm.fbConfig = fbConfig;
        // vm.data = {};
        vm.user = {};
        vm.forms = {};
        vm.isInvitationValid = false;
        vm.checkCoupon = checkCoupon;
        vm.registerClientUser = registerClientUser;
        vm.selectPlan = selectPlan;
        vm.loadAndCheckPlans = loadAndCheckPlans;
        vm.loading = true;

        vm.showRegistrationForm = false;
        vm.adjustUsers = adjustUsers;

        // define our checkoutURL early so couponchecks work properly
        // Get the plan info
         if(vm.fbConfig.databaseURL == "adminja-staging.firebaseio.com"){
           vm.checkoutURL = "https://us-central1-adminja-staging.cloudfunctions.net/checkout?key=hZPEbfkrPqyTimY4dbgE";
         } else {
           vm.checkoutURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net/checkout/?key=hZPEbfkrPqyTimY4dbgE";
         }


        init();

        function init(){
          // If invite, show registration form and set to starter plan
          // check to see if this is an invitation from another user
          if ($stateParams.inviteID){
            vm.showRegistrationForm = true;
            vm.inviteID = $stateParams.inviteID;
            $log.info('inviteID: ' + vm.inviteID);
            // $log.info('invite!: ' + vm.inviteID);
            var inviteRef = firebase.database().ref('teamInvites/');
              inviteRef.child(vm.inviteID).once('value', function(snapshot) {
                var exists = (snapshot.val() !== null);

                if(exists){
                  vm.invitation = snapshot.val();
                  // $log.info(vm.invitation);
                  // prepopulate our email
                  vm.user.email = vm.invitation.invitee;
                  // vm.checkEmail(vm.user.email);
                  // Change our flag so we show invitation info
                  $timeout(function(){vm.isInvitationValid = true;},0);

                } else {
                  if(vm.inviteID.length > 1 && vm.inviteID != 'coupon'){
                    vm.showInvalidInviteWarning = true;
                  }
                }
              });
          }// if we have an inviteID


          // if there's a coupon, check it and apply it
          // is there a coupon in our URL?
          $timeout(function(){
            vm.couponOK == true;
            if ($stateParams.couponID){
              vm.coupon = $stateParams.couponID;
              $timeout(function(){
                checkCoupon(vm.coupon);
              },1000);
            }// if we have an coupon

            // if we passed coupon as a query
            if($location.search().coupon){
             vm.coupon = $location.search().coupon;
             $timeout(function(){
              checkCoupon(vm.coupon)
             }, 1000)
            }// if we have coupon in query string
          },0);


           // If the visitor reached the registration page from a pricing plan page, we probably passed the plan as an ID.
           // Get it so we know which checkout page to send them to.
           vm.planID = 'starter-2018c';

           if($location.search().email){
            vm.user.email = $location.search().email;
           }
           // check for planID in $stateParams and query string
          if ($stateParams.planID){
             vm.planID = $stateParams.planID
             if (vm.planID == 'ava-pro-2019' || vm.planID == 'ava-pro-2022' ){
               vm.user.source = 'Assocation of Virtual Assistants'
             }
             // if someone signing up from old 2019 AVA link, change planID to 2022 plan.
             if(vm.planID == 'ava-pro-2019'){
              vm.planID = 'ava-pro-2022'
             }
             if (vm.planID == 'vavs-pro-2019'){
               vm.user.source = 'VA Virtuoso Summit'
             }
             // if it's a clientUser, set the source to the customer that invited them
             // and set the currentPlan object for user creation
             if(vm.planID == 'client-access' && vm.invitation){
              vm.user.source = 'VA-' + vm.invitation.ownerEmail + '-' + vm.invitation.owner;
              vm.currentPlan = {
                workspaces: 1,
                team: 1
              }
             }
             vm.showRegistrationForm = true;
             $timeout(function(){
               vm.loading = false;
               return
             }, 0);

            $timeout(function(){
               $( "#firstname" ).focus();
              },2000);
             } else if ($location.search().planid){
              vm.planID = $location.search().planid;
              vm.showRegistrationForm = true;
              $timeout(function(){
               $( "#firstname" ).focus();
              },2000);
             }
           // if planID

           // Figure out vm.currentPlan, etc.
           if(vm.planID != 'client-access' && vm.showRegistrationForm){
            // Load up the selected plan info from Firebase
            loadAndCheckPlans(vm.planID);
           }


        }// init() ////////////////

        function selectPlan(planID){
          vm.planID = planID;
          return loadAndCheckPlans(vm.planID)
          .then(function(){
            vm.showRegistrationForm = true;
            $timeout(function(){
             $( "#firstname" ).focus();
            },2000);
          })
        }




        function loadAndCheckPlans(planID){
          return getAdminjaPlanInfo(planID)
          .then(function(){
            // Load up the selected plan Info from Chargebee
            getChargebeePlanInfo(planID)
            .then(function(chargebeePlan){
              if(!chargebeePlan.error_code){
                $timeout(function(){
                  vm.loading = false;
                  return
                }, 0);
              } else {
                vm.showRegistrationForm = false;
                vm.loading = false;
                return
              }
            });

          });
        }// loadAndCheckPlans

        //////////////////////////////////////
        // Prep our addon values and functions


        vm.addonCosts = function(additionalUsers){
          var result = additionalUsers * 10;
          return result.toFixed(2)
        }

        vm.total = function(base, addons){
          return Number(base) + Number(addons)
        }
        // add-on supporting functions
        //////////////////////////////////////


        function getAdminjaPlanInfo(planID){
          var plansRef = firebase.database().ref().child('/plans');
          return $firebaseArray(plansRef)
          .$loaded(
              function(plans) {
                  vm.plans = plans;
                  _.each(vm.plans, function(plan){
                    if (plan.planID == vm.planID){
                      vm.currentPlan = plan;
                      vm.totalUsers = plan.team;
                    }// if planID matches
                  })//each
              });
        }// getAdminjaPlanInfo

        function getChargebeePlanInfo(planID){
          var planURL = vm.checkoutURL + '&method=getPlan&plan=' + planID;

            return $http.get(planURL)
                 .then(function(response){

                   vm.chargebeePlan = response.data;
                   return vm.chargebeePlan
            });
        }// getChargebeePlanInfo()



        function adjustUsers(amount){
          var newAmount = vm.totalUsers + amount;
          // make sure it's not lowered below the base # of users for this plan
          if(newAmount < vm.currentPlan.team){
            return
          } else {
            vm.totalUsers = vm.totalUsers + amount;
          }
        }
        /////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////
        // Create User and Subscription functions
        //  We need Chargebee loaded first. The other functions are wrapped in it
        // so they have access to chargebee's methods
        angularLoad.loadScript('https://js.chargebee.com/v2/chargebee.js').then(function() {
            // Script loaded succesfully.
            // $log.info('chargeBee Loaded');

            // Initialize Chargebee
            var cbInstance = Chargebee.init({
                site: $rootScope.chargebeeSettings.site,
                publishableKey: $rootScope.chargebeeSettings.api_key
              });

            // Setup our cart
            var cart = cbInstance.getCart();

            // Define the cart callbacks
            cbInstance.setCheckoutCallbacks(function(cart) {
              // you can define a custom callbacks based on cart object
              return {
                loaded: function() {
                  console.log("checkout opened");
                },
                close: function() {
                  window.removeEventListener("beforeunload", fixOrphans);
                  console.log("checkout closed");
                  $timeout(function(){
                    vm.processing = false;
                  },0);
                  var user = firebase.auth().currentUser;
                  if(!subscriptionComplete){
                    user.delete().then(function() {
                      // User deleted. - tag them as abandoned in drip
                      // Tag it in Drip so we can follow up with them if they don't complete registration
                       _dcq.push(["identify", {
                        email: vm.user.email,
                        first_name: vm.user.firstname,
                        last_name: vm.user.lastname,
                        tags: ["abandoned-registration"],
                        plan: vm.planID
                      }]);
                    }).catch(function(error) {
                      // An error happened.
                    });
                  }
                },
                success: function(hostedPageId) {
                  // we need this flag to inhibit user deletion if, at this point, they close window, refresh, or cancel subscription window prematurely
                  subscriptionComplete = true;
                  // window.removeEventListener("beforeunload", fixOrphans);
                  // $log.info(hostedPageId);
                  cbInstance.closeAll();
                  console.log('success')
                  // Update our drip tags - make sure abandoned is removed (in case they tried to register previously)
                   _dcq.push(["identify", {
                    email: vm.user.email,
                    remove_tags: ["abandoned-registration"]
                  }]);
                   // create our user record in Firebase
                   setupFirebaseRecord(vm.user, vm.newUserID)
                },
                step: function(value) {
                  // value -> which step in checkout
                  console.log(value);
                }
              }
            });// setCheckoutCallbacks


            // Open the cart and checkout
             vm.openCheckout = function(){
                $timeout(function(){
                  vm.processing = true;
                },0);
                // Make sure they aren't using '+' in their email addresses
                if(vm.user.email.includes("+")){
                 alert('Your email contains the "+" character.\n For security purposes, only valid email addresses are permitted.')
                       return
                }
                 // Create firebase account so we have our unique UID to send to chargebee
                 firebase.auth().createUserWithEmailAndPassword(vm.user.email, vm.user.password)
                 .then(function(_userData, error) {
                    if(error){
                      return alert(error)
                    }

                    // $log.info('firebase user created');
                    vm.newUserID = _userData.user.uid;


                    // Setup trigger to undo any user creation if they refresh or leave the page before completing
                    window.addEventListener("beforeunload", fixOrphans);

                    var customer = {email: vm.user.email,
                                    first_name: vm.user.firstname,
                                    last_name: vm.user.lastname,
                                    billing_address:{first_name: vm.user.firstname, last_name: vm.user.lastname},
                                    cf_adminja_user_id : vm.newUserID
                                  };

                    var product = cbInstance.initializeProduct(vm.planID);
                    product.setPlanQuantity(1);

                    if(vm.coupon){
                      product.addCoupon(vm.coupon);
                    }

                    // if we are asking for more users than included in the base plan, attach them as addons
                    if(vm.totalUsers > vm.currentPlan.team){
                      var addons = {
                        id:'additional-team-member',
                        quantity: vm.totalUsers - vm.currentPlan.team
                      }

                      product.addAddon(addons);
                    }

                    // if accepting an invite (starter-2018c plan) we should just create their subscription without checkout
                    if(vm.invitation && vm.planID == 'starter-2018c'){
                      $log.info('Team Invitation being accepted');
                      // used to instantly subscribe someone to starter account (no payment info needed)
                        var subscribeURL = vm.checkoutURL + '&method=subscribeUser&user=' + vm.newUserID + '&plan='+ vm.planID + '&email=' + vm.user.email + '&first=' + vm.user.firstname + '&last='+vm.user.lastname;
                          $http.get(subscribeURL)
                          .success(function (data, status){
                                console.log('success')
                                $log.info(data);
                                subscriptionComplete = true;
                                window.removeEventListener("beforeunload", fixOrphans);
                                // $log.info(hostedPageId);
                                cbInstance.closeAll();
                                // Update our drip tags - make sure abandoned is removed (in case they tried to register previously)
                                 _dcq.push(["identify", {
                                  email: vm.user.email,
                                  remove_tags: ["abandoned-registration"]
                                }]);
                                 // create our user record in Firebase
                                 setupFirebaseRecord(vm.user, vm.newUserID)
                              }).error(function(data, status) {
                                  console.error('Error occurred:', data, status);
                                  fixOrphans();
                                  $mdDialog.show(
                                       $mdDialog.alert()
                                         .clickOutsideToClose(true)
                                         .title('There was a problem processing your subscription request. Please contact support')
                                         .htmlContent('<p style="color:red;">help@getadminja.com</p>')
                                         .ariaLabel('Subscription failed')
                                         .ok('Continue')
                                     )
                                  $timeout(function(){
                                    vm.processing = false;
                                  },0);
                              }).finally(function() {
                                console.log("Task Finished.");
                              });

                    } else {
                      $log.info('signing up for trial. open checkout');

                      // Else (signing up for a trial) - open the cart.
                      cart.setCustomer(customer);
                      cart.replaceProduct(product);

                      // open modal
                      cart.proceedToCheckout();
                    }

                 })
                  .catch(function(error) {
                    // Handle Errors here.
                    $log.info(error);
                    fixOrphans();
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    $mdDialog.show(
                         $mdDialog.alert()
                           .clickOutsideToClose(true)
                           .title(errorMessage)
                           .htmlContent('<p style="color:red;">If this was in error, please contact help@getadminja.com</p>')
                           .ariaLabel('Subscription failed')
                           .ok('Continue')
                       )
                    $timeout(function(){
                      vm.processing = false;
                    },0);
                    // ...
                  });

                  ;
             }// vm.openCheckout

           });// chargebee script loaded



          vm.checkEmail = function(email){
            if(email){
              // convert email to lowercase
              vm.user.email = email.toLowerCase();
              delete vm.emailOK;
              var checkUserURL = vm.checkoutURL + '&method=checkUserExists&email=' + vm.user.email;
              $http.get(checkUserURL)
                  .then(function(response){
                    var userExists = response.data;
                    if(userExists == 'true'){                    ;
                      $timeout(function(){
                        vm.emailOK = false;
                      });
                    } else {
                      vm.emailOK = true;
                       _dcq.push(["identify", {
                        email: vm.user.email,
                        tags: ["started-registration"],
                        plan: vm.planID
                      }]);
                    }
                  });
            }// if email
          }// vm.checkEmail

          function fixOrphans(){
            var user = firebase.auth().currentUser;
            if(user && !subscriptionComplete){
              $log.info('Subscription not completed. Deleting user!');
              user.delete().then(function() {
                // User deleted. - tag them as abandoned in drip
                // Tag it in Drip so we can follow up with them if they don't complete registration
                 _dcq.push(["identify", {
                  email: vm.user.email,
                  tags: ["abandoned-registration"],
                  plan: vm.planID
                }]);
               });
            }// if user
          }


          function checkCoupon(coupon){
            // $log.info('checkCoupon: ' + coupon);
            if(coupon){
              var checkCoupon = vm.checkoutURL + '&method=getCoupon&coupon=' + coupon;
              // delete vm.couponOK;
              $http.get(checkCoupon)
                  .then(function(response){
                    if(!_.has(response.data, 'id')){
                      $timeout(function(){
                        vm.couponOK = false;

                      });
                    } else {
                      vm.couponOK = true;

                    }
                  });
            }
          }// checkCoupon


          function registerClientUser(user){
            $timeout(function(){
              vm.processing = true;
            },0);
            subscriptionComplete = true;
            firebase.auth().createUserWithEmailAndPassword(vm.user.email, vm.user.password).then(function(_userData, error) {
             if(error){
               return alert(error)
               $timeout(function(){
                 vm.processing = false;
               },0);
             }
              vm.newUserID = _userData.user.uid;
              setupFirebaseRecord(user, vm.newUserID)
           });
          }// registerClientUser

          function setupFirebaseRecord(user, userID){
            // make this function thenable
              window.removeEventListener("beforeunload", fixOrphans);

              // $log.info('setup firebase user');
              var authUser = firebase.auth().currentUser,
                  userRef = firebase.database().ref('users/'),
                  thisSource = "";


              // if we are accepting an invitation, the owner should be the source
              if(vm.isInvitationValid){
                thisSource = "Invited by " + vm.invitation.ownerEmail
              } else {
                thisSource = user.source
              }

              var newUserRecord = {
                     email: user.email,
                     uid: userID,
                     source: thisSource,
                     profile: {
                       timeZone: vm.timeZone,
                       onboardingFlags:{
                         hasCreatedClient: false
                       },
                       settings: {
                         currency: '$',
                         dateFormat: 'us',
                         startOfWeek: 0,
                         roundUpTo: 5,
                         pinMenu: true,
                         requireWorkDescription: false,
                         verticalProfilePanels: false,
                         verticalTaskPanels: true,
                         groupToday: true,
                         showTodayPanel: false,
                         hideCompletedPanel: false,
                         showTimerInSidebar: false,
                         notifyEmail: false,
                         showTimerGui: false
                       }
                     },
                     plan: {},
                     type: 'customer',
                     originalPlan: vm.planID
                 }

                 if(_.has(user, 'company')){
                  newUserRecord.profile.company = user.company;
                 }

                 if(vm.planID != 'client-access'){
                  newUserRecord.limits = {
                    clients: vm.currentPlan.workspaces,
                    team: vm.currentPlan.team
                  }
                 }

                 if(vm.planID == 'client-access'){
                  newUserRecord.type = 'client';
                  newUserRecord.limits = {
                    clients: 0,
                    team: 1
                  }
                 }

                 newUserRecord.profile.avatar = "/assets/images/avatars/generic-person-avatar.png";
                 newUserRecord.profile.firstName = user.firstname;
                 newUserRecord.profile.lastName = user.lastname;
                 newUserRecord.profile.fullName = user.firstname + ' ' + user.lastname;
                 newUserRecord.profile.startDate = new Date().toISOString();

                 // Setting up initial plan info in case users login before Chargebee resets them from the official subscription object
                 newUserRecord.plan.content__subscription__plan_id = vm.planID;
                 newUserRecord.plan.startDate = moment().toISOString();
                 newUserRecord.plan.content__subscription__status = 'in_trial';
                 if(vm.planID == 'client-access'){
                  newUserRecord.plan.content__subscription__status = 'active';
                 } else {
                  // not a client, let's make sure their daily status reports are enabled
                  newUserRecord.profile.settings.dailyStatusReportEnabled = true;
                  newUserRecord.profile.settings.weeklyStatusReportEnabled = false;
                  newUserRecord.profile.settings.dailyStatusReport = {
                    time: 6,
                    includeOpenTasks: false
                  };
                  newUserRecord.profile.timeZoneOffset = vm.timeZoneOffset;
                 }

                 // save our user record
                  var updates = {};
                  updates['users/' + userID] = newUserRecord;

                  return firebase.database().ref().update(updates)
                  .then(function(){

                      // send the verification email
                      authUser.sendEmailVerification();

                      // signout
                      // firebase.auth().signOut();
                      notifyThirdParties(newUserRecord);


                      if(vm.invitation){
                       // $log.info('accepting invitation...');
                        teamDataService.acceptInvite(vm.invitation, userID);
                      }

                      $timeout(function(){
                        console.log('setting up user record...')
                      }, 1000);

                      return userDataService.getLoggedInUser()
                      .then(function(){

                        if(!vm.invitation){
                          // clientDataService.copyClient(vm.adminjaStatus.trainingWorkspaceID, userID, true);
                          // By the time the consent form is shown, the user will have been redirected to the confirmation page behind it.
                          gateService.getConsent();
                        } else {
                          if(vm.planID == 'starter-2018c'){
                            // clientDataService.copyClient(vm.adminjaStatus.trainingWorkspaceID, userID, true);
                          }
                          //if this is an invite, we need to force them to the confirmation page
                          // actual trial accounts get redirected there by the checkout
                            $timeout(function(){
                              $state.go('authentication.confirmation');
                            },2000)
                        }


                      });

                  });

          }// setupFirebaseRecord


function notifyThirdParties(user){
  // $log.info('notifyTracking');
  var registrationTags = ["Adminja Signup", user.originalPlan];

       _dcq.push(["identify", {
        email: user.email,
        first_name: user.profile.firstName,
        last_name: user.profile.lastName,
        initial_plan: user.plan.content__subscription__plan_id,
        adminja_start_date: moment().toISOString(),
        // we need unix (i.e. a number) in order to do date range comparisons
        adminja_unix_start_date: moment().unix(),
        tags: registrationTags,
        uid: user.uid,
        source: user.source
      }]);


      if(vm.planID != 'client-access'){
        if(_dcq){
          _dcq.push(["track", "New Adminja User"]);
        }

        if(userpilot){
         userpilot.track('User registered');
        }

        if(ga){
         ga('send', {
           hitType: 'event',
           eventCategory: 'User',
           eventAction: 'user-created',
           plan: user.plan.content__subscription__plan_id,
           source: user.source
         });
        }

       //heap.track('User registered');
       // Log the goal event with google


      }// if not client-access account


      if(vm.planID == 'client-access'){
        //heap.track('clientUser registered');
        if(userpilot){
          userpilot.track('clientUser registered');
        }
        // Log the goal event with google
        if(ga){
          ga('send', {
            hitType: 'event',
            eventCategory: 'User',
            eventAction: 'client-user-created',
            plan: user.plan.content__subscription__plan_id,
            source: user.source
          });
        }

        if(_dcq){
           _dcq.push(["track", "New Adminja clientUser"]);
        }
      }// if is client-access acount



 }// notifyThirdParties


       }

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('confirmationController', confirmationController);

    /* @ngInject */
    function confirmationController($log, $scope, $timeout, $mdDialog, $state, $window, authFactory, $stateParams,  $rootScope,  userDataService) {
        // $log.info('confirmationController');
        var vm = this;
        // vm.data = {};
        var authData = authFactory.$getAuth();


         // Look for flag showing that we got here from a successful registration
        // if not, redirect to registration
          // vm.registered = $rootScope.registered;
          // if(!vm.registered){
          //     $state.go('authentication.registration');
          // }

          vm.login = function(){
            $state.go('authentication.login');
          }
        vm.sendEmailConfirmation = function(){
            return authData.sendEmailVerification()
            .then(function(){
                // Let them know what's happened and what to do
                $mdDialog.show(
                      $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Confirmation email re-sent')
                        .textContent('Please check your email inbox (and spam folder).')
                        .ariaLabel('Confirmation Email Sent')
                        .ok('Got it!')
                    ).then(function(){

                    });
            });
        }//sendEmailConfirmation

       }// confirmationController

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('subConfirmController', subConfirmController);

    /* @ngInject */
    function subConfirmController($log, $scope, $rootScope, $state, $window) {
        // $log.info('subConfirmController');
        var vm = this;
        // vm.data = {};

        vm.returnToAdminja = function(){
          var returnURL = $rootScope.adminjaURL + '/#/';
          $window.location.href= returnURL;
        }

       }//subConfirmController



})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('profileController', profileController);

    /* @ngInject */
    function profileController($log, $rootScope, clientPackageService, $window, $timeout, $mdDialog, triLoaderService, triMenu, $location, $state, $stateParams, $scope, userDataService, gateService, leadDataService, clientDataService, _userData) {
        var vm = this;
        // we stored this minor variable globally onAuthStateChagne
        vm.emailVerified = $rootScope.emailVerified;
        vm.userDataService = userDataService;
        vm.userType = $rootScope.admin;
        vm.user = _userData;
        vm.fbConfig = fbConfig;
        vm.hostingURL = $location.protocol() + '://' + $location.host() + ':' + $location.port();
        vm.settings = vm.user.profile.settings;
        vm.gates = gateService.gateData;
        vm.alertTimeZoneChange = alertTimeZoneChange;
        vm.showLeadGroups = false; // this will get changed to true if a leadBoard is found for the user
        if(vm.user.uid){
            checkForLeadsBoard();
        } else {
            // alert('There was a problem retrieving your user information. Please re-login and try again. If this problem persists, please contact us at help@getadminja.com');
            $state.go('authentication.login')
        }

        var tabs = $('md-tab-item'), count = 1;
        _.each(tabs, function(tab){
            $(tab).addClass('tab-number-'+count);
            count ++
        });

        // Clients' aren't loaded if this is the first page in the session. Let's make sure we have our clients so our forms Dialog has what it needs
        clientDataService.thisUsersWorkspaces(vm.user)

        // Our settings panel directive breaks our tabs if it's present on load.
        // to mitigate, it's waiting on vm.ready with an ng-if

        $timeout(function(){
            vm.ready = true;
            var timeZones = moment.tz.names(),
                results = {}, count = 0;

             _.each(timeZones, function(zone){
              results[count] = {
                id: count,
                name: zone,
                value: zone,
                offset: moment().tz(zone).format('Z')
              }
              count ++
             });

             vm.timeZones = results;

        }, 250)
        .then($timeout(function(){
            // get country list from our invoicing function
              var endpoint = firebase.functions().httpsCallable('invoicing'),
                  request = {
                    action: 'getCountries'
                  }
              endpoint(request)
              .then(function(results){
                vm.countries = results.data
              })
              .catch(function(error){
                $log.info(error);
              })
        },250));





        // if no invoiceDueDays, set default to 30
        if(!_.has(vm.user.profile, 'invoiceDueDays')){
            vm.user.profile.invoiceDueDays = 30;
        }

        if(!_.has(vm.user.profile, 'invoiceLabel')){
            vm.user.profile.invoiceLabel = 'Invoice';
        }

        if(!_.has(vm.user.profile, 'calculateTax')){
            vm.user.profile.calculateTax = false;
        }

        if(!_.has(vm.user.profile, 'taxLabel')){
            vm.user.profile.taxLabel = 'Taxes';
        }
        if(!_.has(vm.user.profile, 'taxPercentage')){
            vm.user.profile.taxPercentage = 0;
        }

        if(_.has($stateParams, 'selectedTab')){
            vm.selectedTab = $stateParams.selectedTab;

        }


      vm.checkCurrency = function(){
        $log.info('checkCurrency');
        // check to see if user's currency supports payment integrations
        vm.currencyIsValid = false;
        if(_.has(vm.user.profile.settings, 'currencyCode')){
            _.each($rootScope.currencies, function(currency){
                if(currency.code == vm.user.profile.settings.currencyCode){
                    if(currency.stripe || currency.paypal ){
                        vm.currencyIsValid = true;
                    }
                }
            })
        }

      }// checkCurrency


        vm.addKey = function(keyNode, keyName, provider, isSecret){
            var confirm = $mdDialog.prompt()
                         .title('Enter ' + keyName + ' key.')
                         .textContent('Enter the key exactly as provided by ' + provider + '.')
                         .placeholder('xxxxxxxxxxxxxxxxxxxxxxxxx')
                         .ariaLabel('Key')
                         .ok('Encrypt & Save')
                         .cancel('Cancel');

                       $mdDialog.show(confirm).then(function (results) {
                        var secret = {value: results}

                        if(isSecret){
                          return vm.saveNewSecret(secret, keyNode)
                          .then(function(){
                             $mdDialog.cancel();
                          })
                        } else {
                          var updates = {};
                          updates['/users/' + vm.user.uid + '/profile/settings/' + keyNode] = results;
                          return firebase.database().ref().update(updates)
                        }
                     })
        }//addKey


     vm.deleteSecret = function(secretID, name){
      return new Promise(function(resolve, reject){
        if(name == 'paypalClient' || name == 'stripeClient'){
            var updates = {};
            updates['/users/' + vm.user.uid + '/profile/settings/' + name] = null;
            return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('delete-secret');
                return resolve(true)
            })
        } else {
            var endpoint = firebase.functions().httpsCallable('secrets'),
                request = {
                  action: 'deleteSecret',
                  secretID: secretID
                }
                return endpoint(request)
                .then(function(results){
                   var updates = {};
                   updates['/users/' + vm.user.uid + '/secrets/' + name] = null;
                   return firebase.database().ref().update(updates)
                   .then(function(results){
                    userDataService.trackEvent('delete-secret');
                    return resolve(true)
                   })
                   .catch(function(error){
                    $log.info('error');
                    $log.info(error);
                    return reject(error)
                   })
                 })
        }

      })
     }//deleteSecret

      vm.saveNewSecret = function(userSecret, secretName){

            return new Promise(function(resolve, reject){
              var secretID = firebase.database().ref().child('users/' + vm.user.uid + '/secrets').push().key;
              userSecret.uid = secretID;
              userSecret.created = moment().toISOString();
              var endpoint = firebase.functions().httpsCallable('secrets'),
                  request = {
                    action: 'createSecret',
                    secretID: secretID,
                    value: userSecret.value
                  }

              return endpoint(request)
              .then(function(results){
                 delete userSecret.value
                 var updates = {};
                 updates['/users/' + vm.user.uid + '/secrets/' + secretName] = userSecret;
                 return firebase.database().ref().update(updates)
                 .then(function(results){
                  userDataService.trackEvent('add-secret');
                  return resolve(true)
                 })
                 .catch(function(error){

                  $log.info('error');
                  $log.info(error);
                  return reject(error)
                 })

              })
              .catch(function(error){

                 $log.info('error');
                 $log.info(error);
                 return reject(error)
              })
            })


       }//saveNewSecret

       vm.toggleProcessorEnable = function(node){
        var value = false;
        if(vm.user.profile.settings[node]){
            value = true;
            userDataService.trackEvent('enable-' + node + '-processor');
        } else {
            userDataService.trackEvent('disable-' + node + '-processor');
        }
        var updates = {};
        updates['/users/' + vm.user.uid + '/profile/settings/' + node] = value;
        return firebase.database().ref().update(updates)
        .then(function(){

        })
       }//



        function alertTimeZoneChange(){
             var confirm = $mdDialog.confirm()
                      .title('Change your Time Zone?')
                      .htmlContent('This will affect any schedules and reminders that you create going forward.')
                      .ariaLabel('Got it.')
                      .ok('Got it')

            $mdDialog.show(confirm).then(function() {
                $mdDialog.cancel();
            })
        }

        // setup our listener to make form dirty if avatar changed
        $scope.$on('uploadComplete', setDirty);
        function setDirty(){
            vm.profileForm.$setDirty();
        }


        vm.editPackageTemplate = function(template){
            template.startDate = moment();
            userDataService.trackEvent('edit-package-template');
            clientPackageService.editPackage(template);
        }

        vm.newPackageTemplate = function(){
            userDataService.trackEvent('new-package-template');
            // create a fake client to pass to the service so we can make a fresh template
            var client = {
                uid: ' ',
                owner: $rootScope.userID,
                profile: {
                    fullName: 'New Package Template'
                }
            }
            clientPackageService.newPackage(client, true)
        }

        vm.deletePackageTemplate = function(template){
             var confirm = $mdDialog.confirm()
                      .title('Permanently delete this package template?')
                      .htmlContent('')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                var updates = {};
                updates['/users/' + template.owner + '/packageTemplates/' + template.uid] = null;
                return firebase.database().ref().update(updates)
                .then(function(){
                    userDataService.trackEvent('delete-package-template');
                    $mdDialog.cancel();
                })
            })

        }

        vm.cancelProfile = function(){
                $window.history.back();
        };// vm.cancelProfile

        vm.removeLogo = function(){
            vm.user.profile.logo = undefined;
        };



        vm.updateReportConfig = function(report, user){

            // Set our defaults
            if(!_.has(vm.user.profile.settings, 'dailyStatusReport')){
                userDataService.trackEvent('enable-daily-status-report');
                vm.user.profile.settings.dailyStatusReport = {
                    time : 8,
                    includeOpenTasks: 'disabled'
                };
            }// if no dailyStatusReport

            if(!_.has(vm.user.profile.settings, 'weeklyStatusReport')){
                userDataService.trackEvent('disable-daily-status-report');
                vm.user.profile.settings.weeklyStatusReport = {
                    day: '5',
                    time : 8,
                    includeOpenTasks: 'disabled'
                };
            }// if no weeklyStatusReport

            // if no previous lastUpdated, then this is a new report setup
            if(!_.has(user.profile.settings[report], 'lastUpdated')){
                //heap.track('Setup ' + report);
                userDataService.trackEvent('setup-'+report+'-report');
            }

            user.profile.settings[report].lastUpdated = moment().toISOString();
        }

        vm.showExperience = function(experienceID){
            userpilot.trigger(experienceID);
        }

        vm.updateUser = function(user){

            // clear out schedule settings if schedules disabled
            if(!user.profile.settings.dailyStatusReportEnabled){
                delete user.profile.settings.dailyStatusReport
            }

            if(!user.profile.settings.weeklyStatusReportEnabled){
                delete user.profile.settings.weeklyStatusReport
            }

            // IF ALL KEYS NOT PROVIDED FOR PAYMENT PROCESSORS, DISABLE THE PROCESSORS
            if(!_.has(user.profile.settings, 'paypalClient')){
                user.profile.settings.paypalEnabled = false;
            }

            if(!_.has(user.profile.settings, 'stripeClient') || !_.has(user.secrets, 'stripeSecret')){
                user.profile.settings.stripeEnabled = false;
            }

            vm.updating = true;
            // $log.info(user);
            $timeout(function(){
                userDataService.updateUser(user);
            }, 2000)
            .then(function(){
                vm.profileForm.$setPristine();
                vm.companyForm.$setPristine();
                // need to check on this, some folks don't get this form and this throws an error
                if(_.has(vm, 'reportSettingsForm')){
                    vm.reportSettingsForm.$setPristine();
                }

                vm.updating = false;
            })

        }// vm.updateUser

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);

            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadUrl){
                                vm.user.profile.avatar = downloadUrl;
                                vm.profileForm.$pristine = false;
                                userDataService.trackEvent('upload-avatar');
                             })

                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar

        vm.uploadLogo = function($files) {
            // $log.info('upload logo');
            // $log.info($files);
            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userLogo.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child(vm.user.uid + '/files/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            $log.info('upload success');
                            return uploadTask.snapshot.ref.getDownloadURL().then(function(downloadUrl){
                               $timeout(function(){
                                      vm.user.profile.logo = downloadUrl;
                                      vm.companyForm.$pristine = false;
                                      userDataService.trackEvent('upload-logo');
                                  },0);

                            });

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadLogo

        vm.getConsent = function(node, title, description){
            userDataService.getConsent(node, title, description);
        }// vm.getConsent

        vm.changeConsent = function(node, newValue){
            userDataService.changeConsent(node, newValue)
        }

        vm.hasConsent = function(node){
            return userDataService.hasConsent(node)
        }// vm.hasConsent

        vm.numFields = function(form){
            var count = 0;
            _.each(form.fields, function(field){
                if(field.on){
                    count ++
                }
            });
            _.each(form.customFields, function(field){
                if(field.on){
                    count ++
                }
            });

            return count
        }

        function checkForLeadsBoard(){
            // $log.info('checking for leadBoard for ' + vm.user.uid);
            var boardRef = firebase.database().ref('leadBoards');
            return boardRef.child(vm.user.uid).on('value',
                function(snapshot){
                    var exists = (snapshot.val() !== null);
                    if(exists){
                        $timeout(function(){
                            vm.showLeadGroups = true;
                            vm.leadBoard = snapshot.val();
                        },0)
                    } else {
                        $log.info('no leadBoard found.');
                        vm.showLeadGroups = false;
                    }
                });
        }// vm.checkForLeadBoard

        vm.getNewID = function(){
            var boardRef = firebase.database().ref('leadBoards/').child(vm.user.uid);
            var newKey = boardRef.push().key;
            return newKey
        }

        vm.setupLeads = function(){
            $log.info('setup Leads board');
            vm.settingUp = true;
            var starterLeadTypes = [
                    {
                        uid: vm.getNewID(),
                        label: 'Cold',
                        color: 'blue',
                        order: 1
                    },
                    {
                        uid: vm.getNewID(),
                        label: 'Warm',
                        color: 'orange',
                        order: 2
                    },
                    {
                        uid: vm.getNewID(),
                        label: 'Hot',
                        color: 'red',
                        order: 3
                    }
                ]
            ,
            starterContactTypes = [
                    {
                        uid: vm.getNewID(),
                        label: 'Email',
                        color: 'green'
                    },
                    {
                        uid: vm.getNewID(),
                        label: 'Phone call',
                        color: 'purple'
                    },
                    {
                        uid: vm.getNewID(),
                        label: 'Online call',
                        color: 'blue'
                    },
                    {
                        uid: vm.getNewID(),
                        label: 'Meeting',
                        color: 'red'
                    }
                ];


            var leadBoard = {
                uid: vm.user.uid,
                leadTypes: {},
                contactTypes: {}
            };

            // Add our owner access node
            leadBoard.access = {};
            leadBoard.access[vm.user.uid] = true;

            // put our default lead and contact types on
            _.each(starterLeadTypes, function(type, index){
                type.order = index;
                leadBoard.leadTypes[type.uid] = type;
            });
            _.each(starterContactTypes, function(type, index){
                type.order = index;
                leadBoard.contactTypes[type.uid] = type;
            });
            var updates = {};
            updates['/leadBoards/' + vm.user.uid] = leadBoard;
            updates['/users/' + vm.user.uid + '/profile/onboardingFlags/hasLeadboard'] = true;
            return firebase.database().ref().update(updates)
            .then(function(){
                userDataService.trackEvent('enable-leadsboard');
                // dynamically add our leads menu
                triMenu.addMenu({
                           // give the menu a name to show (should be translatable and in the il8n folder json)
                           name: 'Leads',
                           // point this menu to the state we created in the $stateProvider above
                           state: 'triangular.leads',
                           // set the menu type to a link
                           type: 'link',
                           // set an icon for this menu
                           icon: 'zmdi zmdi-accounts-alt',
                           // icon: 'zmdi zmdi-accounts-outline',
                           // set a proirity for this menu item, menu is sorted by priority
                           priority: 10.5
                       });
                $timeout(function(){
                    checkForLeadsBoard();
                }, 2000);
            })
        }// vm.setupLeads

        vm.deleteLeadsBoard = function(){
            $log.info('Delete Leads board');
             var confirm = $mdDialog.confirm()
                      .title('Remove the Leadsboard, are you sure?')
                      .htmlContent('This will delete your leads and remove your custom lead types and activity types')
                      .ariaLabel('Are you sure?')
                      .ok('Do it')
                      .cancel('Never mind');

            $mdDialog.show(confirm).then(function() {
                var boardRef = firebase.database().ref('leadBoards').child(vm.user.uid);
                var updates = {};
                updates['/leadBoards/' + vm.user.uid] = null;
                updates['/users/' + vm.user.uid + '/profile/onboardingFlags/hasLeadboard'] = false;
                return firebase.database().ref().update(updates)
                .then(function(){
                    $timeout(function(){
                        vm.showLeadGroups = false;
                        userDataService.trackEvent('disable-leadsboard');
                    }, 500);
                })

            }, function(){
                $mdDialog.cancel();
            })

        }//vm.deleteLeadsBoard


        vm.showSample = function(){
             var showImage = $mdDialog.confirm()
                      .title('Personal Status Report Sample')
                      .htmlContent('<img flex style="max-width: 400px;" src="/assets/images/reports/va-daily-status-sample.png">')
                      .multiple(true)
                      .ariaLabel('Ok')
                      .ok('Close')

                $mdDialog.show(showImage);
        }

            vm.froala1Options = {
                    key: $rootScope.froalaKey,
                    pluginsEnabled: [
                    "align", "charCounter", "colors", "codeBeautifier", "codeView",  "draggable",   "entities",  "fontSize",
                    "file", "image", "imageTUI",
                    // "imageManager",
                     "lineBreaker", "link",  "paragraphFormat", "paragraphStyle", "url", "wordPaste"
                    ],
                    spellcheck: true, // does not appear to actually enable spellcheck
                    toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "textColor", "|", "align",  "|",  "insertLink",  "insertImage", "insertFile", "insertHR", "|", "html"],
                    autofocus: true,
                    listAdvancedTypes: true,
                    zIndex: 9999,
                    attribution: false,
                    pastePlain: true,
                    charCounterMax: 1000,
                    linkAlwaysBlank: true,
                    linkAutoPrefix: 'https://',
                    linkInsertButtons: '',
                    linkText: true,
                    imageInsertButtons: ['imageUpload'],
                    imageDefaultDisplay: 'block',
                    htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
                    pasteDeniedAttrs: ['class', 'id', 'data'],
                    pasteDeniedTags: ['iframe', 'script', 'style'],
                    // Set the file upload URL.
                     imageUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=users&segment2=' + $rootScope.userID + '&segment3=profile',
                     imageUploadMethod: 'POST',
                     fileUploadURL: $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=upload&segment1=users&segment2=' + $rootScope.userID + '&segment3=profile',
                     // Set request type.
                     fileUploadMethod: 'POST',
                     events: {
                                'froalaEditor.initialized': function () {
                                },
                                'charCounter.exceeded': function () {
                              },
                              'file.beforeUpload': function($file){

                              },
                              'file.uploaded': function($file){
                                // add the file to our file list so we can access it programmatically it later
                                var fileObject = angular.fromJson($file);
                                vm.newFileObject = {
                                            fileName: fileObject.filename,
                                            url: fileObject.link[0],
                                            thumbnail: fileObject.link[0],
                                            source: 'firebaseStorage',
                                            fullPath: fileObject.path
                                        }
                                        $log.info(vm.newFileObject);

                              },
                              'file.inserted': function(e, editor, $file, response){
                                editor.html.insert("  ");
                              },
                              'image.beforeUpload': function($file){

                              },
                              'image.uploaded': function($file){
                                var fileObject = angular.fromJson($file);
                                vm.newFileObject = {
                                            fileName: fileObject.filename,
                                            url: fileObject.link[0],
                                            thumbnail: fileObject.link[0],
                                            source: 'firebaseStorage',
                                            fullPath: fileObject.path
                                        }


                              },
                              'image.inserted': function(e, editor, $file, response){
                                // editor.html.insert("  ");
                              },
                              'image.removed':  function($file){
                                // $log.info('image.removed');
                                var thisLookupLink = $file[0].src;

                              },
                            'file.unlink':  function($file){
                                // $log.info('File Removed');
                                var thisLookupLink = $($file). attr("href");

                                // then update note so reference is removed as well
                            }
                        }//events
                }//froalaOptions


                vm.froala2Options = angular.copy(vm.froala1Options);

                function removeAllFiles(){
                        _.each(vm.detail.files, function(file){
                            return vm.removeFile(file)
                        });
                }// removeAllFiles


            vm.removeFile = function(file){
                // find file in vm.detail.files to get the path
                var pathToDelete = file.fullPath,
                    triggerURL = $rootScope.functionsURL + '/uploadFile/?key='+ $rootScope.functionsKey + '&action=delete&segment1=' + pathToDelete;
                // $log.info('removeFile');

                 $http.get(triggerURL)
                        .then(function (response){
                            $scope.jsondata = response.data;
                            console.log("status:" + response.status);
                        }).catch(function(response) {
                          console.error('Error occurred:', response.status, response.data);
                        }).finally(function() {
                             console.log("Task Finished.");
                        });

            }

    }// profileController
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('LoginController', LoginController);


        /* @ngInject */
    function LoginController($timeout, $log, Idle, $mdToast, $mdDialog, $window, $firebaseObject, timerDataService, leadDataService, userDataService,  clientDataService, $rootScope, triLoaderService, $state, $stateParams, triSettings, $scope, authFactory, $location, localStorageService) {

        // Go to dashboard after clients loaded
        // $rootScope.$on('clientMenuBuilt', function(){
        //   $state.go('triangular.dashboard')
        // });

        delete $rootScope.isRegistering;
        delete $rootScope.paused;
        // $timeout(function(){
        //     // Appcues.anonymous();
        //     document.getElementById("email").focus();
        //     }, 500)

        var vm = this;
        vm.showError = false;
        vm.showLogin = true;

        // on $rootScope so our onAuthStateChanged function in app.module has access to it
        $rootScope.rememberMe = false;

        // clear out ghost User if we are logged in as one
        localStorageService.remove('ghostUser');

            firebase.auth().signOut()
            .then(function(){
                userDataService.clearUserData();
                timerDataService.clearTimerData();
                clientDataService.clearClientData();
                leadDataService.clearLeadData();
                // make sure we've wiped out any previous sessions
                vm.showLogin = true;
                // Load up our login message and offline/online status
                var statusRef = firebase.database().ref('/appState/currentState');
                $firebaseObject(statusRef)
                .$loaded(function(response){
                  vm.adminjaStatus = response;
                });
            });




        vm.socialLogins = [{
            icon: 'fa fa-twitter',
            color: '#5bc0de',
            url: '#'
        },{
            icon: 'fa fa-facebook',
            color: '#337ab7',
            url: '#'
        },{
            icon: 'fa fa-google-plus',
            color: '#e05d6f',
            url: '#'
        },{
            icon: 'fa fa-linkedin',
            color: '#337ab7',
            url: '#'
        }];
        vm.triSettings = triSettings;
        // create blank user variable for login form
        vm.user = {
            email: '',
            password: ''
        };

        // vm.errorMessage = "Oops! We don't have an account by that email address. Please try again.";

        vm.loginClick = function(){

            // UPDATE - not working now that we are triggering the menu from our resolve in triangular/config.route.js
            // After login, we want to wait until clientMenu has been generated before redirecting to dashboard
            // var cleanUpFunc = $rootScope.$on('clientMenuBuilt', function() {
            //          $state.go('triangular.dashboard')
            //     });

            // $scope.$on('$destroy', cleanUpFunc);
            Idle.watch();
            vm.loggingIn = true;
            $log.info('login Clicked');
            // $timeout(function(){
            //     triLoaderService.setLoaderActive(true);
            // },0);
            // // Make sure all data from previous session is cleared in case someone logged in
            // // without logging out of a different account previously
            // timerDataService.clearTimerData();
            // userDataService.clearUserData();
            // clientDataService.clearClientData();

            // Logs user into firebase. Nothing more.
            // Auth listener (in app.module) will notice login change and trigger data loading/unloading.
            var ref = firebase.auth();
            ref.signInWithEmailAndPassword(vm.user.email, vm.user.password).catch(function(error){
                $log.info('Login Error!');
                $log.info(error);
            })
            .then(function(authData){
                // $log.info("Login Success!");
                // $log.info(authData.user);
                //heap.track('Logged In');
                userpilot.track('Logged In');
                console.log('login.controller: logged in successfully');
                // put it in localStorage so we can persist refreshes
                localStorageService.set('userID', authData.user.uid);
                $rootScope.userID = authData.user.uid;
                firebase.database().ref('users').child(authData.user.uid).child('/firstLogin').set(true);

                // Setup lastLogin
                var lastLogin = moment().toISOString(),
                    lastLoginUnix = moment().unix();


                // update our lastLogin in firebase
                firebase.database().ref('users/' + authData.user.uid + '/lastLogin').set(lastLogin)
                .then(function(){
                    $state.go('triangular.dashboard')
                });

            })
            .catch(function(error){
                $log.info('error!');
                var errorCode = error.code;
                  var errorMessage = error.message;
                $log.info(errorCode, errorMessage);
                vm.loggingIn = false;
                if(error.code == 'auth/user-not-found'){

                    $timeout(function(){
                        vm.errorMessage = "We couldn't find an account <br>for that email address. <br> Please try again."
                    },0)

                } else if (error.code =='auth/wrong-password'){
                    $timeout(function(){
                        vm.errorMessage = "Oops! That's not the right password. <br>Please try again."
                    },0)
                }
                else {

                    $timeout(function(){
                        vm.errorMessage = error.message;
                    },0)
                }

                // display firebase error message and reset email and password
                    $mdDialog.show(
                          $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('We had a problem logging you in. Either your login email or password are incorrect. ')
                            .textContent(error.message)
                            .ariaLabel('Login error')
                            .ok('Got it!')
                        ).then(function(){
                            vm.user.email = '';
                            vm.user.password = '';
                            location.reload();

                        });


                    // vm.showError = true;


            });
        }

        vm.logoutClick = function(){
            firebase.auth().signOut().then(function() {
              userDataService.trackEvent('log-out');
              console.log('login.controller logoutClick successful.');
              $state.go('authentication.login')
            }, function(error) {
              // An error happened.
                console.log('login.controller logoutClick FAILED.');
                console.error(error);
                vm.errorMessage = error.message;
            });
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('legalController', legalController);

    /* @ngInject */
    function legalController($log, $timeout, $state, $scope) {
        var vm = this;


        vm.cancelLegal = function(){
            $state.go('triangular.dashboard');
        };// vm.cancelProfile


    }// legalController
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('LockController', LockController);

    /* @ngInject */
    function LockController($state, $window, triSettings, $mdToast, $mdDialog, firebase, userDataService) {
        var vm = this;
        vm.loginClick = loginClick;
        vm.triSettings = triSettings;
        // destroy all firebase refs
         angular.forEach($window.openFirebaseConnections, function (item) {
             item.$destroy();
         });
         // remove Raven user context
        Sentry.configureScope(function(scope) {
          scope.setUser({
            "id": 'not-logged-in'
          });
        });
        ////////////////
        $mdToast.cancel();
        $mdDialog.cancel();
        // controller to handle login check
        function loginClick() {
            // user logged in ok so goto the dashboard
            $state.go('authentication.login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('idleDialogController', idleDialogController);

    /* @ngInject */
    function idleDialogController($log, $interval, Idle, $timeout, $mdDialog, $scope, $state, $rootScope) {
        setMessage();

        // start intervals
        var messageInterval = $interval(setMessage, 10000);
        var countdownInterval = $interval(showCountdown, 1000);

        // call this method to stop interval
        $scope.stop = function() {
          $interval.cancel(messageInterval);
          $interval.cancel(countdownInterval);
        };

        function setMessage (){
        // $log.info('setRandomMessage');
        $scope.idleMessage = undefined;
                $timeout(function(){
                    $scope.randomNumber = Math.floor(Math.random()* ($rootScope.loaderMessages.length));
                    $scope.idleMessage =  $rootScope.loaderMessages[$scope.randomNumber];
                },1000)

        };

        function showCountdown(){
        $timeout(function(){
            $scope.countdown = $rootScope.countdown;
        },0)

        }
        $scope.imBack = function(){
            Idle.watch();
            $mdDialog.cancel();
        }


            // $log.info(vm.idleMessage);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('ForgotController', ForgotController);

    /* @ngInject */
    function ForgotController($scope, $state, $mdToast, $filter, $http, triSettings, API_CONFIG) {
        var vm = this;
        vm.triSettings = triSettings;
        vm.user = {
            email: ''
        };
        vm.resetClick = resetClick;



        function resetClick() {
            var email = vm.user.email;

            firebase.auth().sendPasswordResetEmail(email).
            then(function() {

                $mdToast.show(
                    $mdToast.simple()
                    .content($filter('translate')('FORGOT.MESSAGES.RESET_SENT') + ' ' + email)
                    .position('bottom right')
                    .action($filter('translate')('FORGOT.MESSAGES.LOGIN_NOW'))
                    .highlightAction(true)
                    .hideDelay(0)
                ).then(function() {
                    $state.go('public.auth.login');
                });
            }).catch(function(error) {
                var errorCode       = error.code;
                var errorMessage    = error.message;

                if (errorCode == 'auth/invalid-email') {
                    alert(errorMessage);
                } else if (errorCode == 'auth/user-not-found') {
                    alert(errorMessage);
                }

                console.log(error);

                $mdToast.show(
                    $mdToast.simple()
                    .content($filter('translate')('FORGOT.MESSAGES.NO_RESET') + ' ' + email)
                    .position('bottom right')
                    .hideDelay(5000)
                );
            })
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('app.authentication')
    .controller('changeEmailController', changeEmailController);

    /* @ngInject */
    function changeEmailController($log, $timeout, $scope, $state, $mdToast, userDataService, _userData) {
        // $log.info('changeEmailController');
        var vm = this;
        vm.user = _userData;

        vm.changeEmail = function(newEmail){
            var user = firebase.auth().currentUser;
            user.updateEmail(newEmail).then(function() {
                var userRef = firebase.database().ref('users/' + user.uid);
                // save the previous email
                userRef.child('oldEmail').set(vm.user.email);
                // update actual email with new one
                userRef.child('email').set(newEmail);

              // Update successful.
              // $log.info('success!');
              // An error happened.
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Woohoo! Your login has changed!',
                          message: 'You will need to login again.',
                          color: '#128B04'
                      }
                  }));
              $timeout(function(){
                $state.go('authentication.login');
              },1000);

            }, function(error) {
              // An error happened.
              $mdToast.show($mdToast.adminjaAlert(
                  {
                      locals:{
                          title: 'Oops! Something went wrong!',
                          message: 'Please login again and try again.',
                          color: 'red'
                      }
                  }));
              $log.info('update email fail!');
              $log.info(error);
            });
        }

     }// changeEmailController
    })();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('cancelController', cancelController);

    /* @ngInject */
    function cancelController($log, $scope, $timeout, $state, $window, $mdDialog, firebase, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService, timerDataService, clientDataService, _userData) {
        // $log.info('cancelController');
        var vm = this;
        // vm.data = {};
        vm.user = _userData;
        vm.showPause = false;
        $mdDialog.cancel();
        // Some rare accounts don't have this property
        // so we check and use a less accurate one if that's the case
        if(_.has(vm.user.plan, 'content__subscription__started_at')){
          var subStarted = vm.user.plan.content__subscription__started_at;
        } else {
          var subStarted = vm.user.plan.startDate
        }


        // Is account eligble to be paused?
        if(_.has(vm.user.plan, 'content__subscription__status')){
          if(vm.user.plan.content__subscription__status != 'in_trial'){
            vm.showPause = true
          }
        }



        function init(){
          //heap.track('Visited Cancel Page');
          userDataService.trackEvent('visited-cancel-page');



          vm.request = {
            userID: vm.user.uid,
            name: vm.user.profile.fullName,
            email: vm.user.email,
            plan: vm.user.plan.content__subscription__plan_id,
            date: moment().toISOString(),
            started: subStarted
          };

          userDataService.trackEvent('Visited Cancellation Page');

        }

        init();

        vm.selectAction = function(action){
          vm.request.action = action;
        }

        vm.isSelected = function(state){
          if (vm.request.action == state){
            return true
          } else {
            return false
          }
        }// vm.isSelected

        vm.submitRequest = function(){
          vm.processing = true;
          var newKey = firebase.database().ref().child('intervention-requests/').push().key;

          vm.request.uid = newKey;
          var updates = {};

          updates['/intervention-requests/' + newKey] = vm.request;

          return firebase.database().ref().update(updates)
                  .then(function () {
                    $timeout(function(){
                      vm.showConfirm = true;
                    },0);

                  });

        }// vm.submitRequest

        vm.resetRequest = function(){
          delete vm.processing;
          delete vm.selectedState;
          delete vm.showConfirm;
          delete vm.request;
          delete vm.continue
          init();
        }

       }//cancelController



})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('cancelConfirmationController', cancelConfirmationController);

    /* @ngInject */
    function cancelConfirmationController($log, $scope, $timeout, $state, $window, angularLoad, $stateParams, $mdToast, $rootScope, localStorageService, userDataService) {
        // $log.info('confirmationController');
        var vm = this;
        // vm.data = {};

        // Look for flag that we got here from a successful registration
        // if not, redirect to registration
        vm.registered = $rootScope.registered;
        if(!vm.registered){
            $state.go('authentication.registration');
        }
       }

})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .controller('setupProfileController', setupProfileController);

    /* @ngInject */
    function setupProfileController($log, $timeout, $state, $scope, userDataService, _userData) {
        var vm = this;
        vm.user = _userData;

        // if we don't have user.settings, create the node so our form doesnt fail
        if (!vm.user.settings){
            vm.user.settings = {};
        }
        vm.updating = false;
        if (vm.user.profile != undefined){
            // vm.user.profile.dob = new Date(vm.user.profile.dob);
        }
        vm.countries = [
        {name: 'US'},
        {name: 'CA'},
        {name: 'UK'},
        {name: 'EU'},
        {name: 'AU'},
        {name: 'SA'},
        {name: 'AF'},

        ]


        vm.cancelProfile = function(){
            $state.go('triangular.dashboard');
        };// vm.cancelProfile

        vm.updateUser = function(user){
            vm.updating = true;
            // $log.info(user);
            $timeout(function(){
                userDataService.updateUser(user);
            }, 2000)
            .then(function(){
                vm.profileForm.$pristine = true;
                vm.updating = false;
            })

        }// vm.updateUser

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);

            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){

                        // $log.info('Saving '+filename);
                        var filename = vm.user.uid + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             vm.user.profile.avatar = uploadTask.snapshot.downloadURL;
                             vm.profileForm.$pristine = false;
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar
    }// profileController
})();

(function() {
    'use strict';

    angular
        .module('adminSetup', [
        	'appServices'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('adminSetup')
        .controller('setupClientsController', setupClientsController);

    /* @ngInject */
    function setupClientsController($scope, $state, $mdToast, $log, clientDataService, $timeout, $filter, $rootScope, _userData, _clientData) {
        var vm = this;
        vm.user = _userData;
        vm.clients = _clientData;
        vm.clientTemplate = {
            owner: vm.user.uid,
            status: 'active',
            profile: {
                firstname: '',
                lastname: '',
                email: '',
                plan:{
                    cost: '',
                    allocated: '',
                    retainerStart:'',
                    rate:'',
                    type:'retainer'
                }

            },

            access:{
                users:{},
                admins: {}
            },
            panels: {}
        };
        vm.clientLimit=3;
        vm.showColors = false;
        vm.clientColors = $rootScope.clientColors;

        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }


        init();

        function init(){
            // add assignment properties to our model
            vm.clientTemplate.order = _.size(vm.clients)+1;
            vm.newClient = angular.copy(vm.clientTemplate);
            // $log.info(vm.newClient);
            vm.newClient.access.users[vm.user.uid] = true;
            vm.newClient.access.admins[vm.user.uid] = true;
            // Cursor in Name field to prompt new user
            focusClientName();
            vm.numClients = _.size(vm.clients);
         }


        function focusClientName(){
              $timeout(function () {
                document.getElementById("focusfield").focus();
            }, 3000, false);
        }


        function resetForm(){
            // $log.info('resetForm');
            $timeout(function() {
                // reset our form flags
                vm.clientForm.$setPristine();
                vm.clientForm.$setUntouched();
                vm.clientForm.$submitted = false;

               });
            // setup for a new client
            init();
        }

        vm.continue = function(){

            $state.go('triangular.dashboard');

        }

        vm.deleteClient = function(client){
            clientDataService.deleteClient(client);
            clientDataService.setupWorkspaceMenu(true);
        }

        vm.addClient = function(client){
            return clientDataService.saveNewClient(client).then(function() {
                clientDataService.setupWorkspaceMenu(true);
                resetForm();
            });
        }

        vm.colorChange = function(form) {
            // $log.info('color changed');
            form.$setDirty();
            vm.toggleColors();
        };

        vm.toggleColors = function(){
            if (vm.showColors){
                vm.showColors = false;
            } else {
                vm.showColors = true;
            }
        }

        vm.hasClients = function(){
            if(_.size(vm.clients)){
                return true
            } else{
                return false
            }
        }

        vm.canAddNew = function(){
            if (_.size(vm.clients) < vm.clientLimit){
                return true
            } else {
                return false
            }
        }

    }// setupClientController
})();

//These are general utilities that are NOT app specific and may used for other apps
var ajUTILITIES = (function () {
    'use strict';

    var my = {};
    // abstract localstorage calls set/get
    Storage.prototype.setObject = function(key, value) {
        this.setItem(key, JSON.stringify(value));
    }

    Storage.prototype.getObject = function(key) {
        var value = this.getItem(key);
        return value && JSON.parse(value);
    }

    my.isDefined = function (variable)	{

        if (typeof variable === 'undefined' || variable === null) {
            return false;
        }
        else {
            return true;
		}
    };

    my.removePropertiesWith = function(obj, remove) {

        // for (var p in obj) {
        //     if (p[0] === '$')
        //         delete obj[p];
        // }

        Object.keys(obj).forEach(function(p) {
            if (p[0] === '$')
                delete obj[p];
        });

        return obj;
    };

    my.mapValidProperties = function(origObj, strInvalid) {


        var newObj = Object.keys(origObj).reduce(function(previous, current) {
            if (current[0] !== strInvalid) {
                previous[current] = origObj[current];
            }
            return previous;
        }, {});

        return newObj;
    }

    my.lightenDarkenColor = function(col, amt){
        var usePound = false;
        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }
        var num = parseInt(col, 16);
        var r = (num >> 16) + amt;
        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }
        var b = ((num >> 8) & 0x00FF) + amt;
        if (b > 255) {
            b = 255;
        } else if (b < 0) {
            b = 0;
        }
        var g = (num & 0x0000FF) + amt;
        if (g > 255) {
            g = 255;
        } else if (g < 0) {
            g = 0;
        }
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }


    // utility to set text color depending on background color
    my.getContrastTextColor = function(hexcolor){

      // remove hash in front of color
      while(hexcolor.charAt(0) === '#')
      {
       hexcolor = hexcolor.substr(1);
      }
        var r = parseInt(hexcolor.substr(0,2),16);
        var g = parseInt(hexcolor.substr(2,2),16);
        var b = parseInt(hexcolor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 180) ? '#000' : '#fff';
    }
    return my;
})();

(function() {
    'use strict';

    angular
        .module('triangular')
        .run(runFunction);

    /* @ngInject */
    function runFunction($rootScope, $timeout, $window) {
        // add a class to the body if we are on windows
        if($window.navigator.platform.indexOf('Win') !== -1) {
            $rootScope.bodyClasses = ['os-windows'];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('triangular')
        .provider('triSettings', settingsProvider);

    /* @ngInject */
    function settingsProvider() {
        // Provider
        var settings = {
            languages: [],
            name: '',
            logo: '',
            copyright: '',
            version: ''
        };

        this.addLanguage = addLanguage;
        this.setLogo = setLogo;
        this.setName = setName;
        this.setCopyright = setCopyright;
        this.setVersion = setVersion;

        function addLanguage(newLanguage) {
            settings.languages.push(newLanguage);
        }

        function setLogo(logo) {
            settings.logo = logo;
        }

        function setName(name) {
            settings.name = name;
        }

        function setCopyright(copy) {
            settings.copyright = copy;
        }

        function setVersion(version) {
            settings.version = version;
        }

        // Service
        this.$get = function() {
            return {
                languages: settings.languages,
                name: settings.name,
                copyright: settings.copyright,
                logo: settings.logo,
                version: settings.version,
                defaultSkin: settings.defaultSkin
            };
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('triangular')
        .config(routeConfig);

    /* @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
        .state('triangular', {
            abstract: true,
            // customized for Adminja
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 _userData: ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }],

                clientDataService: 'clientDataService',
                // resolve our _clientData in our service and make avail to Controller
                 _clientData: function(_userData, clientDataService) {
                   return clientDataService.thisUsersWorkspaces(_userData)
                   .then(function(data){
                        // console.log('config.route clients');
                        // console.log(data);
                        return data.$promise
                   });
                }
            },
            views: {
                'root': {
                    templateUrl: 'app/triangular/layouts/states/triangular/triangular.tmpl.html',
                    controller: 'TriangularStateController',
                    controllerAs: 'stateController'
                },
                'sidebarLeft@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.sidebarLeftTemplateUrl)) {
                            return $templateRequest(triLayout.layout.sidebarLeftTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.sidebarLeftController;
                    },
                    controllerAs: 'vm'
                },
                'sidebarRight@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.sidebarRightTemplateUrl)) {
                            return $templateRequest(triLayout.layout.sidebarRightTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.sidebarRightController;
                    },
                    controllerAs: 'vm'
                },
                'toolbar@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.toolbarTemplateUrl)) {
                            return $templateRequest(triLayout.layout.toolbarTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.toolbarController;
                    },
                    controllerAs: 'vm'
                },
                'loader@triangular': {
                    templateProvider: function($templateRequest, triLayout) {
                        if(angular.isDefined(triLayout.layout.loaderTemplateUrl)) {
                            return $templateRequest(triLayout.layout.loaderTemplateUrl);
                        }
                    },
                    controllerProvider: function(triLayout) {
                        return triLayout.layout.loaderController;
                    },
                    controllerAs: 'loader'
                }
            }
        });


    }// routeConfig

})();

!function(a,b){"function"==typeof define&&define.amd?define(["moment"],function(c){return a.DateRange=b(c)}):"object"==typeof exports?module.exports=b(require("moment")):a.DateRange=b(moment)}(this,function(a){function b(b,c){var d,e=b,f=c;(1===arguments.length||void 0===c)&&("object"==typeof b&&2===b.length?(e=b[0],f=b[1]):"string"==typeof b&&(d=b.split("/"),e=d[0],f=d[1])),this.start=a(null===e?-864e13:e),this.end=a(null===f?864e13:f)}function c(b,c,d){for(var e=a(this.start);this.contains(e,d);)c.call(this,e.clone()),e.add(1,b)}function d(b,c,d){var e=this/b,f=Math.floor(e);if(f!==1/0){f===e&&d&&f--;for(var g=0;f>=g;g++)c.call(this,a(this.start.valueOf()+b.valueOf()*g))}}var e={year:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0};return b.prototype.constructor=b,b.prototype.clone=function(){return a().range(this.start,this.end)},b.prototype.contains=function(a,c){var d=this.start,e=this.end;return a instanceof b?d<=a.start&&(e>a.end||e.isSame(a.end)&&!c):a>=d&&(e>a||e.isSame(a)&&!c)},b.prototype.overlaps=function(a){return null!==this.intersect(a)},b.prototype.intersect=function(a){var c=this.start,d=this.end;return c<=a.start&&a.start<d&&d<a.end?new b(a.start,d):a.start<c&&c<a.end&&a.end<=d?new b(c,a.end):a.start<c&&d>=c&&d<a.end?this:c<=a.start&&a.start<=a.end&&a.end<=d?a:null},b.prototype.add=function(c){return this.overlaps(c)?new b(a.min(this.start,c.start),a.max(this.end,c.end)):null},b.prototype.subtract=function(a){var c=this.start,d=this.end;return null===this.intersect(a)?[this]:a.start<=c&&d>c&&d<=a.end?[]:a.start<=c&&c<a.end&&a.end<d?[new b(a.end,d)]:c<a.start&&a.start<d&&d<=a.end?[new b(c,a.start)]:c<a.start&&a.start<a.end&&a.end<d?[new b(c,a.start),new b(a.end,d)]:c<a.start&&a.start<d&&a.end<d?[new b(c,a.start),new b(a.start,d)]:void 0},b.prototype.toArray=function(a,b){var c=[];return this.by(a,function(a){c.push(a)},b),c},b.prototype.by=function(a,b,e){return"string"==typeof a?c.call(this,a,b,e):d.call(this,a,b,e),this},b.prototype.toString=function(){return this.start.format()+"/"+this.end.format()},b.prototype.valueOf=function(){return this.end-this.start},b.prototype.center=function(){var b=this.start+this.diff()/2;return a(b)},b.prototype.toDate=function(){return[this.start.toDate(),this.end.toDate()]},b.prototype.isSame=function(a){return this.start.isSame(a.start)&&this.end.isSame(a.end)},b.prototype.diff=function(a){return this.end.diff(this.start,a)},a.range=function(c,d){return c in e?new b(a(this).startOf(c),a(this).endOf(c)):new b(c,d)},a.range.constructor=b,a.fn.range=a.range,a.fn.within=function(a){return a.contains(this._d)},b});

/**
 * Orignally textAngular-sanitaize
 * https://github.com/fraywing/textAngular
 */

/**
 * @license AngularJS v1.3.0-build.2711+sha.facd904
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular, undefined) {
    'use strict';

    var $sanitizeMinErr = angular.$$minErr('$sanitize');

    /**
     * @ngdoc module
     * @name ngSanitize
     * @description
     *
     * # ngSanitize
     *
     * The `ngSanitize` module provides functionality to sanitize HTML.
     *
     *
     * <div doc-module-components="ngSanitize"></div>
     *
     * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
     */

    /*
     * HTML Parser By Misko Hevery (misko@hevery.com)
     * based on:  HTML Parser By John Resig (ejohn.org)
     * Original code by Erik Arvidsson, Mozilla Public License
     * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
     *
     * // Use like so:
     * htmlParser(htmlString, {
     *     start: function(tag, attrs, unary) {},
     *     end: function(tag) {},
     *     chars: function(text) {},
     *     comment: function(text) {}
     * });
     *
     */


    /**
     * @ngdoc service
     * @name $sanitize
     * @function
     *
     * @description
     *   The input is sanitized by parsing the html into tokens. All safe tokens (from a whitelist) are
     *   then serialized back to properly escaped html string. This means that no unsafe input can make
     *   it into the returned string, however, since our parser is more strict than a typical browser
     *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
     *   browser, won't make it through the sanitizer.
     *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
     *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
     *
     * @param {string} html Html input.
     * @returns {string} Sanitized html.
     *
     * @example
     <example module="ngSanitize" deps="angular-sanitize.js">
     <file name="index.html">
     <script>
     function Ctrl($scope, $sce) {
         $scope.snippet =
           '<p style="color:blue">an html\n' +
           '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
           'snippet</p>';
         $scope.deliberatelyTrustDangerousSnippet = function() {
           return $sce.trustAsHtml($scope.snippet);
         };
       }
     </script>
     <div ng-controller="Ctrl">
     Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
     <table>
     <tr>
     <td>Directive</td>
     <td>How</td>
     <td>Source</td>
     <td>Rendered</td>
     </tr>
     <tr id="bind-html-with-sanitize">
     <td>ng-bind-html</td>
     <td>Automatically uses $sanitize</td>
     <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
     <td><div ng-bind-html="snippet"></div></td>
     </tr>
     <tr id="bind-html-with-trust">
     <td>ng-bind-html</td>
     <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
     <td>
     <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
     &lt;/div&gt;</pre>
     </td>
     <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
     </tr>
     <tr id="bind-default">
     <td>ng-bind</td>
     <td>Automatically escapes</td>
     <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
     <td><div ng-bind="snippet"></div></td>
     </tr>
     </table>
     </div>
     </file>
     <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getInnerHtml()).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
     </file>
     </example>
     */
    function $SanitizeProvider() {
        this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
            return function (html) {
                var buf = [];
                htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
                    return !/^unsafe/.test($$sanitizeUri(uri, isImage));
                }));
                return buf.join('');
            };
        }];
    }

    function sanitizeText(chars) {
        var buf = [];
        var writer = htmlSanitizeWriter(buf, angular.noop);
        writer.chars(chars);
        return buf.join('');
    }


// Regular Expressions for parsing tags and attributes
    var START_TAG_REGEXP =
            /^<\s*([\w:-]+)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*>/,
        END_TAG_REGEXP = /^<\s*\/\s*([\w:-]+)[^>]*>/,
        ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
        BEGIN_TAG_REGEXP = /^</,
        BEGING_END_TAGE_REGEXP = /^<\s*\//,
        COMMENT_REGEXP = /<!--(.*?)-->/g,
        DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
        CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
        SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
        NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;


// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements

// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
    var voidElements = makeMap("area,br,col,hr,img,wbr");

// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
    var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
        optionalEndTagInlineElements = makeMap("rp,rt"),
        optionalEndTagElements = angular.extend({},
            optionalEndTagInlineElements,
            optionalEndTagBlockElements);

// Safe Block Elements - HTML5
    var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));

// Inline Elements - HTML5
    var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));


// Special Elements (can contain anything)
    var specialElements = makeMap("script,style");

    var validElements = angular.extend({},
        voidElements,
        blockElements,
        inlineElements,
        optionalEndTagElements);

//Attributes that have href and hence need to be sanitized
    var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap");
    var validAttrs = angular.extend({}, uriAttrs, makeMap(
        'abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
        'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
        'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
        'scope,scrolling,shape,size,span,start,summary,target,title,type,' +
        'valign,value,vspace,width'));

    function makeMap(str) {
        var obj = {}, items = str.split(','), i;
        for (i = 0; i < items.length; i++) {
            obj[items[i]] = true;
        }
        return obj;
    }


    /**
     * @example
     * htmlParser(htmlString, {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * });
     *
     * @param {string} html string
     * @param {object} handler
     */
    function htmlParser(html, handler) {
        var index, chars, match, stack = [], last = html;
        stack.last = function () {
            return stack[stack.length - 1];
        };

        while (html) {
            chars = true;

            // Make sure we're not in a script or style element
            if (!stack.last() || !specialElements[stack.last()]) {

                // Comment
                if (html.indexOf("<!--") === 0) {
                    // comments containing -- are not allowed unless they terminate the comment
                    index = html.indexOf("--", 4);

                    if (index >= 0 && html.lastIndexOf("-->", index) === index) {
                        if (handler.comment) {
                            handler.comment(html.substring(4, index));
                        }
                        html = html.substring(index + 3);
                        chars = false;
                    }
                    // DOCTYPE
                } else if (DOCTYPE_REGEXP.test(html)) {
                    match = html.match(DOCTYPE_REGEXP);

                    if (match) {
                        html = html.replace(match[0], '');
                        chars = false;
                    }
                    // end tag
                } else if (BEGING_END_TAGE_REGEXP.test(html)) {
                    match = html.match(END_TAG_REGEXP);

                    if (match) {
                        html = html.substring(match[0].length);
                        match[0].replace(END_TAG_REGEXP, parseEndTag);
                        chars = false;
                    }

                    // start tag
                } else if (BEGIN_TAG_REGEXP.test(html)) {
                    match = html.match(START_TAG_REGEXP);

                    if (match) {
                        html = html.substring(match[0].length);
                        match[0].replace(START_TAG_REGEXP, parseStartTag);
                        chars = false;
                    }
                }

                if (chars) {
                    index = html.indexOf("<");

                    var text = index < 0 ? html : html.substring(0, index);
                    html = index < 0 ? "" : html.substring(index);

                    if (handler.chars) {
                        handler.chars(decodeEntities(text));
                    }
                }

            } else {
                html = html.replace(new RegExp("(.*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
                    function (all, text) {
                        text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");

                        if (handler.chars) {
                            handler.chars(decodeEntities(text));
                        }

                        return "";
                    });

                parseEndTag("", stack.last());
            }

            if (html === last) {
                throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
                    "of html: {0}", html);
            }
            last = html;
        }

        // Clean up any remaining tags
        parseEndTag();

        function parseStartTag(tag, tagName, rest, unary) {
            tagName = tagName.toLowerCase();
            if (blockElements[tagName]) {
                while (stack.last() && inlineElements[stack.last()]) {
                    parseEndTag("", stack.last());
                }
            }

            if (optionalEndTagElements[tagName] && stack.last() === tagName) {
                parseEndTag("", tagName);
            }

            unary = voidElements[tagName] || !!unary;

            if (!unary) {
                stack.push(tagName);
            }

            var attrs = {};

            rest.replace(ATTR_REGEXP,
                function (match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
                    var value = doubleQuotedValue ||
                        singleQuotedValue ||
                        unquotedValue ||
                        '';

                    attrs[name] = decodeEntities(value);
                });
            if (handler.start) {
                handler.start(tagName, attrs, unary);
            }
        }

        function parseEndTag(tag, tagName) {
            var pos = 0, i;
            
            // Find the closest opened tag of the same type
            if (tagName) {
                var needle = tagName.toLowerCase();
                for (pos = stack.length - 1; pos >= 0; pos--) {
                    if (stack[pos] === needle) {
                        break;
                    }
                }
            }

            if (pos >= 0) {
                // Close all the open elements, up the stack
                for (i = stack.length - 1; i >= pos; i--) {
                    if (handler.end) {
                        handler.end(stack[i]);
                    }
                }

                // Remove the open elements from the stack
                stack.length = pos;
            }
        }
    }

    var hiddenPre = document.createElement("pre");
    var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;

    /**
     * decodes all entities into regular string
     * @param value
     * @returns {string} A string with decoded entities.
     */
    function decodeEntities(value) {
        if (!value) {
            return '';
        }

        // Note: IE8 does not preserve spaces at the start/end of innerHTML
        // so we must capture them and reattach them afterward
        var parts = spaceRe.exec(value);
        var spaceBefore = parts[1];
        var spaceAfter = parts[3];
        var content = parts[2];
        if (content) {
            hiddenPre.innerHTML = content.replace(/</g, "&lt;");
            // innerText depends on styling as it doesn't display hidden elements.
            // Therefore, it's better to use textContent not to cause unnecessary
            // reflows. However, IE<9 don't support textContent so the innerText
            // fallback is necessary.
            content = 'textContent' in hiddenPre ?
                hiddenPre.textContent : hiddenPre.innerText;
        }
        return spaceBefore + content + spaceAfter;
    }

    /**
     * Escapes all potentially dangerous characters, so that the
     * resulting string can be safely inserted into attribute or
     * element text.
     * @param value
     * @returns {string} escaped text
     */
    function encodeEntities(value) {
        return value.
        replace(/&/g, '&amp;').
        replace(SURROGATE_PAIR_REGEXP, function (value) {
            var hi = value.charCodeAt(0);
            var low = value.charCodeAt(1);
            return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
        }).
        replace(NON_ALPHANUMERIC_REGEXP, function (value) {
            // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
            // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
            var c = value.charCodeAt(0);
            // if unsafe character encode
            if (c <= 159 ||
                c === 173 ||
                (c >= 1536 && c <= 1540) ||
                c === 1807 ||
                c === 6068 ||
                c === 6069 ||
                (c >= 8204 && c <= 8207) ||
                (c >= 8232 && c <= 8239) ||
                (c >= 8288 && c <= 8303) ||
                c === 65279 ||
                (c >= 65520 && c <= 65535)) {
                return '&#' + c + ';';
            }
            return value; // avoids multilingual issues
        }).
        replace(/</g, '&lt;').
        replace(/>/g, '&gt;');
    }

    var trim = (function () {
        // native trim is way faster: http://jsperf.com/angular-trim-test
        // but IE doesn't have it... :-(
        // TODO: we should move this into IE/ES5 polyfill
        if (!String.prototype.trim) {
            return function (value) {
                return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
            };
        }
        return function (value) {
            return angular.isString(value) ? value.trim() : value;
        };
    })();

// Custom logic for accepting certain style options only - angularFroala
// Currently allows only the color, background-color, text-align, direction, font-family, font-size, float, width and height attributes
// all other attributes should be easily done through classes.
    function validStyles(styleAttr) {
        var result = '';
        var styleArray = styleAttr.split(';');
        angular.forEach(styleArray, function (value) {
            var v = value.split(':');
            if (v.length === 2) {
                var key = trim(v[0].toLowerCase());
                value = trim(v[1].toLowerCase());
                if (
                    (key === 'color' || key === 'background-color') && (
                        value.match(/^rgb\([0-9%,\. ]*\)$/i) ||
                        value.match(/^rgba\([0-9%,\. ]*\)$/i) ||
                        value.match(/^hsl\([0-9%,\. ]*\)$/i) ||
                        value.match(/^hsla\([0-9%,\. ]*\)$/i) ||
                        value.match(/^#[0-9a-f]{3,6}$/i) ||
                        value.match(/^[a-z]*$/i)
                    ) ||
                    key === 'text-align' && (
                        value === 'left' ||
                        value === 'right' ||
                        value === 'center' ||
                        value === 'justify'
                    ) ||
                    key === 'float' && (
                        value === 'left' ||
                        value === 'right' ||
                        value === 'none'
                    ) ||
                    key === 'direction' && (
												value === 'rtl' ||
												value === 'ltr'
                    ) ||
 										key === 'font-family' && (
												value === 'arial,helvetica,sans-serif' ||
												value === 'georgia,serif' ||
												value === 'impact,charcoal,sans-serif' ||
												value === 'tahoma,geneva,sans-serif' ||
												value === "'times new roman',times,serif" ||
												value === 'verdana,geneva,sans-serif'
 										) ||
                    (key === 'width' || key === 'height' || key === 'font-size' || key === 'margin-left') && (
                        value.match(/[0-9\.]*(px|em|rem|%)/)
                    )
                ) {
                    result += key + ': ' + value + ';';
                }
            }
        });
        return result;
    }

// this function is used to manually allow specific attributes on specific tags with certain prerequisites
    function validCustomTag(tag, attrs, lkey, value) {
        // catch the div placeholder for the iframe replacement
        if (tag === 'img' && attrs['ta-insert-video']) {
            if (lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || (lkey === 'contenteditble' && value === 'false')) {
                return true;
            }
        }
        return false;
    }

    /**
     * create an HTML/XML writer which writes to buffer
     * @param {Array} buf use buf.jain('') to get out sanitized html string
     * @returns {object} in the form of {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * }
     */
    function htmlSanitizeWriter(buf, uriValidator) {
        var ignore = false;
        var out = angular.bind(buf, buf.push);
        return {
            start: function (tag, attrs, unary) {
                tag = tag.toLowerCase();
                if (!ignore && specialElements[tag]) {
                    ignore = tag;
                }
                if (!ignore && validElements[tag] === true) {
                    out('<');
                    out(tag);
                    angular.forEach(attrs, function (value, key) {
                        var lkey = key.toLowerCase();
                        var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
                        if ((lkey === 'style' && (value = validStyles(value)) !== '') || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true &&
                            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
                            out(' ');
                            out(key);
                            out('="');
                            out(encodeEntities(value));
                            out('"');
                        }
                    });
                    out(unary ? '/>' : '>');
                }
            },
            end: function (tag) {
                tag = tag.toLowerCase();
                if (!ignore && validElements[tag] === true) {
                    out('</');
                    out(tag);
                    out('>');
                }
                if (tag === ignore) {
                    ignore = false;
                }
            },
            chars: function (chars) {
                if (!ignore) {
                    out(encodeEntities(chars));
                }
            }
        };
    }


// define ngSanitize module and register $sanitize service
    angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

    /* sanitizeText: false */

    /**
     * @ngdoc filter
     * @name linky
     * @function
     *
     * @description
     * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
     * plain email address links.
     *
     * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
     *
     * @param {string} text Input text.
     * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
     * @returns {string} Html-linkified text.
     *
     * @usage
     <span ng-bind-html="linky_expression | linky"></span>
     *
     * @example
     <example module="ngSanitize" deps="angular-sanitize.js">
     <file name="index.html">
     <script>
     function Ctrl($scope) {
           $scope.snippet =
             'Pretty text with some links:\n'+
             'http://angularjs.org/,\n'+
             'mailto:us@somewhere.org,\n'+
             'another@somewhere.org,\n'+
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithTarget = 'http://angularjs.org/';
         }
     </script>
     <div ng-controller="Ctrl">
     Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
     <table>
     <tr>
     <td>Filter</td>
     <td>Source</td>
     <td>Rendered</td>
     </tr>
     <tr id="linky-filter">
     <td>linky filter</td>
     <td>
     <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
     </td>
     <td>
     <div ng-bind-html="snippet | linky"></div>
     </td>
     </tr>
     <tr id="linky-target">
     <td>linky target</td>
     <td>
     <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
     </td>
     <td>
     <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
     </td>
     </tr>
     <tr id="escaped-html">
     <td>no filter</td>
     <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
     <td><div ng-bind="snippet"></div></td>
     </tr>
     </table>
     </file>
     <file name="protractor.js" type="protractor">
     it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

     it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

     it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

     it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });
     </file>
     </example>
     */
    angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
        var LINKY_URL_REGEXP =
                /((ftp|https?):\/\/|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>]/,
            MAILTO_REGEXP = /^mailto:/;

        return function (text, target) {
            if (!text) {
                return text;
            }
            var match;
            var raw = text;
            var html = [];
            var url;
            var i;
            while ((match = raw.match(LINKY_URL_REGEXP))) {
                // We can not end in these as they are sometimes found at the end of the sentence
                url = match[0];
                // if we did not match ftp/http/mailto then assume mailto
                if (match[2] === match[3]) {
                    url = 'mailto:' + url;
                }
                i = match.index;
                addText(raw.substr(0, i));
                addLink(url, match[0].replace(MAILTO_REGEXP, ''));
                raw = raw.substring(i + match[0].length);
            }
            addText(raw);
            return $sanitize(html.join(''));

            function addText(text) {
                if (!text) {
                    return;
                }
                html.push(sanitizeText(text));
            }

            function addLink(url, text) {
                html.push('<a ');
                if (angular.isDefined(target)) {
                    html.push('target="');
                    html.push(target);
                    html.push('" ');
                }
                html.push('href="');
                html.push(url);
                html.push('">');
                addText(text);
                html.push('</a>');
            }
        };
    }]);


})(window, window.angular);

angular.module("dropbox-picker", []).provider("DropBoxSettings", function() {
    this.box_linkType = 'shared', this.box_multiselect = 'true', this.box_clientId = null, this.linkType = 'preview', this.multiselect = false, this.extensions = ['.pdf', '.doc', '.docx'], this.$get = function() {
        return {
            linkType: this.linkType,
            multiselect: this.multiselect,
            extensions: this.extensions,
            box_linkType: this.box_linkType,
            box_multiselect: this.box_multiselect,
            box_clientId: this.box_clientId

        }
    },
    this.configure = function(e) {
        for (key in e) this[key] = e[key]
    }

})
.directive("dropBoxPicker", ["DropBoxSettings",
            function(DropBoxSettings) {
    return {
        restrict: "A",
        scope: {
            dbpickerFiles: "=",
            counter: "=",
            form: "="
        },
        link: function(scope, element, attrs) {
            function instanciate() {
                Dropbox.choose(dropboxOptions);
            }
            var dropboxOptions = {
                success: dropboxsuccess,
                cancel: function() {},
                linkType : DropBoxSettings.linkType,
                multiselect: DropBoxSettings.multiselect,
                extensions : DropBoxSettings.extensions,
            };
            function dropboxsuccess(files){
                scope.$apply(function() {
                    for (var i = 0; i < files.length; i++){
                        console.log(files);
                        // For Amdinja - convert to normalized file structure
                            var framedLink = files[i].link;
                            // default link opens a frame that THEN loads the image
                            // we need to make this a raw image link
                            // https://cantonbecker.com/etcetera/2014/how-to-directly-link-or-embed-dropbox-images/
                            var rawLink = _.replace(framedLink,new RegExp("dl=0","g"),"raw=1")
                            var fileObject = {
                                fileName: files[i].name,
                                url: rawLink,
                                source: 'dropbox'
                            }

                            // some dropbox files don't have thumbs.
                            // we need to check for that so we don't send undefined
                            if(_.has(files[i], 'thumbnailLink')){
                                fileObject.thumbnail = files[i].thumbnailLink;
                            }
                            // Push onto our bound model

                                scope.dbpickerFiles.push(fileObject);
                                scope.counter = scope.counter + 1;
                                scope.form.$setDirty();


                        // End Adminja Customization

                        // Original push
                        // scope.dbpickerFiles.push(files[i]);
                    }
                });
            };
            element.bind("click", function() {
                instanciate()
            })
        }
    }
}])
.directive("boxPicker", ["DropBoxSettings",
            function(DropBoxSettings) {
    return {
        restrict: "A",
        scope: {
            boxpickerFiles: "="
        },
        link: function(scope, element, attrs) {
            function instanciate() {
                var success = false;
                var boxSelect = new BoxSelect(boxoptions);
                boxSelect.launchPopup();
                boxSelect.success(function(files) {
                    if(!success){
                        boxSelect.closePopup();
                        scope.$apply(function() {
                            for (var i = 0; i < files.length; i++){
                                scope.boxpickerFiles.push(files[i]);
                            }
                        });
                        //boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, successCallbackFunction);
                        success = true
                    }
                });
                boxSelect.cancel(function() {
                    console.log("The user clicked cancel or closed the popup");
                    boxSelect.closePopup();
                });
            }

            function successCallbackFunction(){
                boxSelect.closePopup();
            }

            var boxoptions = {
                clientId: DropBoxSettings.box_clientId,
                linkType: DropBoxSettings.box_linkType,
                multiselect: DropBoxSettings.box_multiselect
            };
            element.bind("click", function() {
                instanciate()
            })
        }
    }
}]);


(function() {
  'use strict';


})();

/*!
 * angular-hotkeys v1.7.0
 * https://chieffancypants.github.io/angular-hotkeys
 * Copyright (c) 2016 Wes Cruver
 * License: MIT
 */
!function(){"use strict";angular.module("cfp.hotkeys",[]).provider("hotkeys",["$injector",function(a){this.includeCheatSheet=!0,this.useNgRoute=a.has("ngViewDirective"),this.templateTitle="Keyboard Shortcuts:",this.templateHeader=null,this.templateFooter=null,this.template='<div class="cfp-hotkeys-container fade" ng-class="{in: helpVisible}"><div class="cfp-hotkeys"><h4 class="cfp-hotkeys-title" ng-if="!header">{{ title }}</h4><div ng-bind-html="header" ng-if="header"></div><table><tbody><tr ng-repeat="hotkey in hotkeys | filter:{ description: \'!$$undefined$$\' }"><td class="cfp-hotkeys-keys"><span ng-repeat="key in hotkey.format() track by $index" class="cfp-hotkeys-key">{{ key }}</span></td><td class="cfp-hotkeys-text">{{ hotkey.description }}</td></tr></tbody></table><div ng-bind-html="footer" ng-if="footer"></div><div class="cfp-hotkeys-close" ng-click="toggleCheatSheet()">&#215;</div></div></div>',this.cheatSheetHotkey="?",this.cheatSheetDescription="Show / hide this help menu",this.$get=["$rootElement","$rootScope","$compile","$window","$document",function(a,b,c,d,e){function f(){q=!1}function g(){q=!0}function h(a){var b={command:"⌘",shift:"⇧",left:"←",right:"→",up:"↑",down:"↓","return":"⏎",backspace:"⌫"};a=a.split("+");for(var c=0;c<a.length;c++)"mod"===a[c]&&(d.navigator&&d.navigator.platform.indexOf("Mac")>=0?a[c]="command":a[c]="ctrl"),a[c]=b[a[c]]||a[c];return a.join(" + ")}function i(a,b,c,d,e,f){this.combo=a instanceof Array?a:[a],this.description=b,this.callback=c,this.action=d,this.allowIn=e,this.persistent=f,this._formated=null}function j(){for(var a=r.hotkeys.length;a--;){var b=r.hotkeys[a];b&&!b.persistent&&m(b)}}function k(){r.helpVisible=!r.helpVisible,r.helpVisible?(w=n("esc"),m("esc"),l("esc",w.description,k,null,["INPUT","SELECT","TEXTAREA"])):(m("esc"),w!==!1&&l(w))}function l(a,b,c,d,e,f){var g,h=["INPUT","SELECT","TEXTAREA"],j=Object.prototype.toString.call(a);if("[object Object]"===j&&(b=a.description,c=a.callback,d=a.action,f=a.persistent,e=a.allowIn,a=a.combo),m(a),b instanceof Function?(d=c,c=b,b="$$undefined$$"):angular.isUndefined(b)&&(b="$$undefined$$"),void 0===f&&(f=!0),"function"==typeof c){g=c,e instanceof Array||(e=[]);for(var k,l=0;l<e.length;l++)e[l]=e[l].toUpperCase(),k=h.indexOf(e[l]),-1!==k&&h.splice(k,1);c=function(a){var b=!0;if(a){var c=a.target||a.srcElement,d=c.nodeName.toUpperCase();if((" "+c.className+" ").indexOf(" mousetrap ")>-1)b=!0;else for(var e=0;e<h.length;e++)if(h[e]===d){b=!1;break}}b&&p(g.apply(this,arguments))}}"string"==typeof d?Mousetrap.bind(a,p(c),d):Mousetrap.bind(a,p(c));var n=new i(a,b,c,d,e,f);return r.hotkeys.push(n),n}function m(a){var b=a instanceof i?a.combo:a;if(Mousetrap.unbind(b),angular.isArray(b)){for(var c=!0,d=b.length;d--;)c=m(b[d])&&c;return c}var e=r.hotkeys.indexOf(n(b));return e>-1?(r.hotkeys[e].combo.length>1?r.hotkeys[e].combo.splice(r.hotkeys[e].combo.indexOf(b),1):(angular.forEach(s,function(a){var b=a.indexOf(r.hotkeys[e]);-1!==b&&a.splice(b,1)}),r.hotkeys.splice(e,1)),!0):!1}function n(a){if(!a)return r.hotkeys;for(var b,c=0;c<r.hotkeys.length;c++)if(b=r.hotkeys[c],b.combo.indexOf(a)>-1)return b;return!1}function o(a){return a.$id in s||(s[a.$id]=[],a.$on("$destroy",function(){for(var b=s[a.$id].length;b--;)m(s[a.$id].pop())})),{add:function(b){var c;return c=arguments.length>1?l.apply(this,arguments):l(b),s[a.$id].push(c),this}}}function p(a){return function(c,d){if(a instanceof Array){var e=a[0],f=a[1];a=function(a){f.scope.$eval(e)}}b.$apply(function(){a(c,n(d))})}}var q=!0;Mousetrap.prototype.stopCallback=function(a,b){return q?(" "+b.className+" ").indexOf(" mousetrap ")>-1?!1:b.contentEditable&&"true"==b.contentEditable:!0},i.prototype.format=function(){if(null===this._formated){for(var a=this.combo[0],b=a.split(/[\s]/),c=0;c<b.length;c++)b[c]=h(b[c]);this._formated=b}return this._formated};var r=b.$new();r.hotkeys=[],r.helpVisible=!1,r.title=this.templateTitle,r.header=this.templateHeader,r.footer=this.templateFooter,r.toggleCheatSheet=k;var s={};if(this.useNgRoute&&b.$on("$routeChangeSuccess",function(a,b){j(),b&&b.hotkeys&&angular.forEach(b.hotkeys,function(a){var c=a[2];("string"==typeof c||c instanceof String)&&(a[2]=[c,b]),a[5]=!1,l.apply(this,a)})}),this.includeCheatSheet){var t=e[0],u=a[0],v=angular.element(this.template);l(this.cheatSheetHotkey,this.cheatSheetDescription,k),(u===t||u===t.documentElement)&&(u=t.body),angular.element(u).append(c(v)(r))}var w=!1,x={add:l,del:m,get:n,bindTo:o,template:this.template,toggleCheatSheet:k,includeCheatSheet:this.includeCheatSheet,cheatSheetHotkey:this.cheatSheetHotkey,cheatSheetDescription:this.cheatSheetDescription,useNgRoute:this.useNgRoute,purgeHotkeys:j,templateTitle:this.templateTitle,pause:f,unpause:g};return x}]}]).directive("hotkey",["hotkeys",function(a){return{restrict:"A",link:function(b,c,d){var e,f=[];angular.forEach(b.$eval(d.hotkey),function(b,c){e="string"==typeof d.hotkeyAllowIn?d.hotkeyAllowIn.split(/[\s,]+/):[],f.push(c),a.add({combo:c,description:d.hotkeyDescription,callback:b,action:d.hotkeyAction,allowIn:e})}),c.bind("$destroy",function(){angular.forEach(f,a.del)})}}}]).run(["hotkeys",function(a){}])}(),function(a,b,c){function d(a,b,c){return a.addEventListener?void a.addEventListener(b,c,!1):void a.attachEvent("on"+b,c)}function e(a){if("keypress"==a.type){var b=String.fromCharCode(a.which);return a.shiftKey||(b=b.toLowerCase()),b}return r[a.which]?r[a.which]:s[a.which]?s[a.which]:String.fromCharCode(a.which).toLowerCase()}function f(a,b){return a.sort().join(",")===b.sort().join(",")}function g(a){var b=[];return a.shiftKey&&b.push("shift"),a.altKey&&b.push("alt"),a.ctrlKey&&b.push("ctrl"),a.metaKey&&b.push("meta"),b}function h(a){return a.preventDefault?void a.preventDefault():void(a.returnValue=!1)}function i(a){return a.stopPropagation?void a.stopPropagation():void(a.cancelBubble=!0)}function j(a){return"shift"==a||"ctrl"==a||"alt"==a||"meta"==a}function k(){if(!q){q={};for(var a in r)a>95&&112>a||r.hasOwnProperty(a)&&(q[r[a]]=a)}return q}function l(a,b,c){return c||(c=k()[a]?"keydown":"keypress"),"keypress"==c&&b.length&&(c="keydown"),c}function m(a){return"+"===a?["+"]:(a=a.replace(/\+{2}/g,"+plus"),a.split("+"))}function n(a,b){var c,d,e,f=[];for(c=m(a),e=0;e<c.length;++e)d=c[e],u[d]&&(d=u[d]),b&&"keypress"!=b&&t[d]&&(d=t[d],f.push("shift")),j(d)&&f.push(d);return b=l(d,f,b),{key:d,modifiers:f,action:b}}function o(a,c){return a===b?!1:a===c?!0:o(a.parentNode,c)}function p(a){function c(a){a=a||{};var b,c=!1;for(b in u)a[b]?c=!0:u[b]=0;c||(x=!1)}function k(a,b,c,d,e,g){var h,i,k=[],l=c.type;if(!s._callbacks[a])return[];for("keyup"==l&&j(a)&&(b=[a]),h=0;h<s._callbacks[a].length;++h)if(i=s._callbacks[a][h],(d||!i.seq||u[i.seq]==i.level)&&l==i.action&&("keypress"==l&&!c.metaKey&&!c.ctrlKey||f(b,i.modifiers))){var m=!d&&i.combo==e,n=d&&i.seq==d&&i.level==g;(m||n)&&s._callbacks[a].splice(h,1),k.push(i)}return k}function l(a,b,c,d){s.stopCallback(b,b.target||b.srcElement,c,d)||a(b,c)===!1&&(h(b),i(b))}function m(a){"number"!=typeof a.which&&(a.which=a.keyCode);var b=e(a);if(b)return"keyup"==a.type&&v===b?void(v=!1):void s.handleKey(b,g(a),a)}function o(){clearTimeout(t),t=setTimeout(c,1e3)}function q(a,b,d,f){function g(b){return function(){x=b,++u[a],o()}}function h(b){l(d,b,a),"keyup"!==f&&(v=e(b)),setTimeout(c,10)}u[a]=0;for(var i=0;i<b.length;++i){var j=i+1===b.length,k=j?h:g(f||n(b[i+1]).action);r(b[i],k,f,a,i)}}function r(a,b,c,d,e){s._directMap[a+":"+c]=b,a=a.replace(/\s+/g," ");var f,g=a.split(" ");return g.length>1?void q(a,g,b,c):(f=n(a,c),s._callbacks[f.key]=s._callbacks[f.key]||[],k(f.key,f.modifiers,{type:f.action},d,a,e),void s._callbacks[f.key][d?"unshift":"push"]({callback:b,modifiers:f.modifiers,action:f.action,seq:d,level:e,combo:a}))}var s=this;if(a=a||b,!(s instanceof p))return new p(a);s.target=a,s._callbacks={},s._directMap={};var t,u={},v=!1,w=!1,x=!1;s._handleKey=function(a,b,d){var e,f=k(a,b,d),g={},h=0,i=!1;for(e=0;e<f.length;++e)f[e].seq&&(h=Math.max(h,f[e].level));for(e=0;e<f.length;++e)if(f[e].seq){if(f[e].level!=h)continue;i=!0,g[f[e].seq]=1,l(f[e].callback,d,f[e].combo,f[e].seq)}else i||l(f[e].callback,d,f[e].combo);var m="keypress"==d.type&&w;d.type!=x||j(a)||m||c(g),w=i&&"keydown"==d.type},s._bindMultiple=function(a,b,c){for(var d=0;d<a.length;++d)r(a[d],b,c)},d(a,"keypress",m),d(a,"keydown",m),d(a,"keyup",m)}for(var q,r={8:"backspace",9:"tab",13:"enter",16:"shift",17:"ctrl",18:"alt",20:"capslock",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"ins",46:"del",91:"meta",93:"meta",224:"meta"},s={106:"*",107:"+",109:"-",110:".",111:"/",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},t={"~":"`","!":"1","@":"2","#":"3",$:"4","%":"5","^":"6","&":"7","*":"8","(":"9",")":"0",_:"-","+":"=",":":";",'"':"'","<":",",">":".","?":"/","|":"\\"},u={option:"alt",command:"meta","return":"enter",escape:"esc",plus:"+",mod:/Mac|iPod|iPhone|iPad/.test(navigator.platform)?"meta":"ctrl"},v=1;20>v;++v)r[111+v]="f"+v;for(v=0;9>=v;++v)r[v+96]=v;p.prototype.bind=function(a,b,c){var d=this;return a=a instanceof Array?a:[a],d._bindMultiple.call(d,a,b,c),d},p.prototype.unbind=function(a,b){var c=this;return c.bind.call(c,a,function(){},b)},p.prototype.trigger=function(a,b){var c=this;return c._directMap[a+":"+b]&&c._directMap[a+":"+b]({},a),c},p.prototype.reset=function(){var a=this;return a._callbacks={},a._directMap={},a},p.prototype.stopCallback=function(a,b){var c=this;return(" "+b.className+" ").indexOf(" mousetrap ")>-1?!1:o(b,c.target)?!1:"INPUT"==b.tagName||"SELECT"==b.tagName||"TEXTAREA"==b.tagName||b.isContentEditable},p.prototype.handleKey=function(){var a=this;return a._handleKey.apply(a,arguments)},p.init=function(){var a=p(b);for(var c in a)"_"!==c.charAt(0)&&(p[c]=function(b){return function(){return a[b].apply(a,arguments)}}(c))},p.init(),a.Mousetrap=p,"undefined"!=typeof module&&module.exports&&(module.exports=p),"function"==typeof define&&define.amd&&define(function(){return p})}(window,document);

(function(window, angular, undefined) {
  'use strict';

  angular.module('froala', [])
    .value('froalaConfig', {})
    .directive('froala', ['froalaConfig', function(froalaConfig) {
      "use strict"; //Scope strict mode to only this directive
      var generatedIds = 0;
      var defaultConfig = {
        immediateAngularModelUpdate: false,
        angularIgnoreAttrs: null
      };

      var innerHtmlAttr = 'innerHTML';

      var scope = {
        froalaOptions: '=froala',
        initFunction: '&froalaInit'
      };

      froalaConfig = froalaConfig || {};

      // Constants
      var MANUAL = "manual";
      var AUTOMATIC = "automatic";
      var SPECIAL_TAGS = ['img', 'button', 'input', 'a'];

      return {
        restrict: 'A',
        require: 'ngModel',
        scope: scope,
        link: function(scope, element, attrs, ngModel) {
            // Create a blur event to update the data of ngModel
            element.on('blur', function () {
              ngModel.$setViewValue(element[0].innerHTML)
            });


          var specialTag = false;
          if (SPECIAL_TAGS.indexOf(element.prop("tagName").toLowerCase()) != -1) {
            specialTag = true;
          }

          var ctrl = {
            editorInitialized: false
          };

          var firstTime = false;

          scope.initMode = attrs.froalaInit ? MANUAL : AUTOMATIC;

          ctrl.init = function() {
            if (!attrs.id) {
              // generate an ID if not present
              attrs.$set('id', 'froala-' + generatedIds++);
            }

            //init the editor
            if (scope.initMode === AUTOMATIC) {
              ctrl.createEditor();
            }

            //Instruct ngModel how to update the froala editor
            ngModel.$render = function () {
              // Update special tags.
              if (specialTag) {
                var tags = ngModel.$modelValue;

                // add tags on element
                if (tags) {
                  for (var attr in tags) {
                    if (tags.hasOwnProperty(attr) && attr != innerHtmlAttr) {
                      element.attr(attr, tags[attr]);
                    }
                  }
                  if (tags.hasOwnProperty(innerHtmlAttr)) {
                    element[0].innerHTML = tags[innerHtmlAttr];
                  }
                }
              }
              else {
                if (ctrl.editorInitialized) {
                  // Set HTML.
                  ctrl.froalaEditor.html.set(ngModel.$viewValue || '')
                  //This will reset the undo stack everytime the model changes externally. Can we fix this?
                  ctrl.froalaEditor.undo.reset();
                  ctrl.froalaEditor.undo.saveStep();
                }
              }
            };

            ngModel.$isEmpty = function(value) {
              if (!value) {
                return true;
              }

              return true;
            };
          };

          ctrl.createEditor = function(froalaInitOptions) {
            if (!ctrl.editorInitialized) {
              froalaInitOptions = (froalaInitOptions || {});
              ctrl.options = angular.extend({}, defaultConfig, froalaConfig, scope.froalaOptions, froalaInitOptions);

              ctrl.registerEventsWithCallbacks('initializationDelayed', function() {
                ngModel.$render()
              });

              ctrl.registerEventsWithCallbacks('initialized', ctrl.options.events && ctrl.options.events.initialized)
              var initEvent = ctrl.options.events.initialized;
              if (!ctrl.options.events) ctrl.options.events = {};
              ctrl.options.events.initialized = function () {
                initEvent && initEvent();
                ctrl.initListeners();
                ctrl.editorInitialized = true;
                ngModel.$render()
              }
              ctrl.froalaEditor = new FroalaEditor(element[0], ctrl.options);

              //assign the froala instance to the options object to make methods available in parent scope
              if (scope.froalaOptions) {
                scope.froalaOptions.froalaEditor = ctrl.froalaEditor;
              }
            }
          };

          ctrl.initListeners = function() {
            if (ctrl.options.immediateAngularModelUpdate) {
              ctrl.froalaEditor.events.on('keyup', function() {
                scope.$evalAsync(ctrl.updateModelView);
              });
            }

            ctrl.froalaEditor.events.on('contentChanged', function() {
              scope.$evalAsync(ctrl.updateModelView);
            });

            if (ctrl.initEvents) {
              for (var i = 0; i < ctrl.initEvents; i++) {
                ctrl.initEvents[i].call(ctrl.froalaEditor);
              }
            }

            element.bind('$destroy', function() {
              if (element) {
                ctrl.froalaEditor.destroy();
                element = null;
              }
            });
          };

          ctrl.updateModelView = function() {
            if (!element) {
              return;
            }

            var modelContent = null;

            if (specialTag) {
              var attributeNodes = element[0].attributes;
              var attrs = {};

              for (var i = 0; i < attributeNodes.length; i++) {
                var attrName = attributeNodes[i].name;
                if (ctrl.options.angularIgnoreAttrs && ctrl.options.angularIgnoreAttrs.indexOf(attrName) != -1) {
                  continue;
                }
                attrs[attrName] = attributeNodes[i].value;
              }
              if (element[0].innerHTML) {
                attrs[innerHtmlAttr] = element[0].innerHTML;
              }
              modelContent = attrs;
            } else {
              var returnedHtml = ctrl.froalaEditor.html.get();
              if (angular.isString(returnedHtml)) {
                modelContent = returnedHtml;
              }
            }

            ngModel.$setViewValue(modelContent);
            if (!scope.$root.$$phase) {
              scope.$apply();
            }
          };

          ctrl.registerEventsWithCallbacks = function(eventName, callback) {
            if (eventName && callback) {
              if(!ctrl.options.events){
                ctrl.options.events = {};
              }

              if (eventName == 'initialized') {
                if (!ctrl.initEvents) ctrl.initEvents = [];
                ctrl.initEvents.push(callback);
              }
              else {
                ctrl.options.events[eventName] = callback;
              }
            }
          };

          if (scope.initMode === MANUAL) {
            var _ctrl = ctrl;
            var controls = {
              initialize: ctrl.createEditor,
              destroy: function() {
                if (_ctrl.froalaEditor) {
                  _ctrl.froalaEditor.destroy();
                  _ctrl.editorInitialized = false;
                }
              },
              getEditor: function() {
                return _ctrl.froalaEditor ? _ctrl.froalaEditor : null;
              }
            };
            scope.initFunction({
              initControls: controls
            });
          }
          ctrl.init();
        }
      };
    }])
    .directive('froalaView', ['$sce', function($sce) {
      return {
        restrict: 'ACM',
        scope: false,
        link: function(scope, element, attrs) {
          element.addClass('fr-view');
          scope.$watch(attrs.froalaView, function(nv) {
            if (nv || nv === '') {
              var explicitlyTrustedValue = $sce.trustAsHtml(nv);
              element.html(explicitlyTrustedValue.toString());
            }
          });
        }
      };
    }]);
})(window, window.angular);

(function() {
    'use strict';

    angular
        .module('app.translate', [
            'pascalprecht.translate',
            'LocalStorageModule'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('app.translate')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, triSettingsProvider) {
        var appLanguages = [{
            name: 'Chinese',
            key: 'zh'
        },{
            name: 'English',
            key: 'en'
        },{
            name: 'French',
            key: 'fr'
        },{
            name: 'Portuguese',
            key: 'pt'
        }];

        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a i18n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        // setup available languages in angular translate & triangular
        var angularTranslateLanguageKeys = [];
        for (var language in appLanguages) {
            // add language key to array for angular translate
            angularTranslateLanguageKeys.push(appLanguages[language].key);

            // tell triangular that we support this language
            triSettingsProvider.addLanguage({
                name: appLanguages[language].name,
                key: appLanguages[language].key
            });
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
            'en_US': 'en',
            'en_UK': 'en'
        })
        .use('en');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();

(function() {
    'use strict';

    angular
        .module('training', ['appServices', 'ngSanitize', 'ngAnimate'])
        .run(function($state, $rootScope){

        });
})();

(function() {
    'use strict';

    angular
        .module('training')
        .controller('trainingController', trainingController);
        // trainingController.$inject = ['$rootScope', '$scope', 'localStorageService']

    /* @ngInject */
    function trainingController($log, $state, $stateParams, $mdDialog, $timeout, $rootScope, $scope, userDataService, dragulaService) {
        var vm = this;
        $log.info('trainingController');
        vm.expose = {};
        vm.settings = $rootScope.userSettings;
        vm.userType = $rootScope.admin;
        vm.forms = {};


        init();

        function init(){
        	var categoryRef = firebase.database().ref('/courses/freelanceu/categories');
        	categoryRef.on('value', function(snapshot){
        		vm.categories = snapshot.val();

        		var coursesRef = firebase.database().ref('/courses/freelanceu/courses');
        		coursesRef.on('value', function(snapshot){
        			vm.courses = snapshot.val();
                    var instructorRef = firebase.database().ref('/courses/freelanceu/instructors');
                    instructorRef.on('value', function(snapshot){
                        vm.instructors = snapshot.val();
                    })
        		})
        	})
        }// init/

        _.each(vm.categories, function(category){
        	vm.expose[category.uid] = false;
        });


        vm.showCourse = function(course){
        	$mdDialog.show({
        			  controller: viewCourseDialogController, // see below
        			  controllerAs: 'vm',
        			  templateUrl: 'app/training/view-course.tmpl.html',
        			  locals: {course: course, instructors: vm.instructors, categories: vm.categories},
        			  bindToController: true,
        			  focusOnOpen: true,
        			  clickOutsideToClose:true,
        			  escapeToClose: true,
        			  fullscreen: true,
                      hasBackdrop: true
        			});
        }//showCourse

        vm.newCategory = function(event){
        	var confirm = $mdDialog.prompt()
        	     .title('New Category')
        	     .textContent('What should this category be called?')
        	     .placeholder('')
        	     .ariaLabel('Category Name')
        	     .initialValue('')
        	     .targetEvent(event)
        	     .ok('Save')
        	     .cancel('Cancel');

        	   $mdDialog.show(confirm).then(function (result) {
        	     var newKey = firebase.database().ref('courses').push().key;
        	     var payLoad = {
        	     	uid: newKey,
        	     	label: result,
        	     	order: 0
        	     }
        	     firebase.database().ref('/courses/freelanceu/categories/' + newKey).set(payLoad);

        	   }, function () {
        	     $log.info('cancelled');
        	   });
        }// newCategory

        vm.updateCategory = function(category){
        	$log.info('updateCategory');
        	var updates = {};
        	updates['/courses/freelanceu/categories/' + category.uid] = category;

        	return firebase.database().ref().update(updates)
        	.then(function(){
        		$timeout(function(){
	        		vm.expose[category.uid] = false;
        		})
        	});
        }// updateCategory

        vm.deleteCategory = function(category){
        	$log.info('deleteCategory');
        	var courseCount = 0;
        	_.each(vm.courses, function(course){
        		if(course.category == category.uid){
        			courseCount ++
        		}
        	});
        	if(courseCount > 0){
        		$mdDialog.show(
        		     $mdDialog.alert()
        		       .parent(angular.element(document.querySelector('#popupContainer')))
        		       .clickOutsideToClose(true)
        		       .title('Can\'t Delete Category')
        		       .htmlContent('This category has ' + courseCount + ' courses assigned to it. <br> Please move these courses to a different category first.')
        		       .ariaLabel('Alert Dialog Demo')
        		       .ok('Got it!')
        		   );
        	} else {
        		var confirm = $mdDialog.confirm()
        		      .title('Are you sure you want to delete ' + category.label + '?')
        		      .textContent('This cannot be undone')
        		      .ariaLabel('Lucky day')
        		      .ok('Please do it!')
        		      .cancel('Nevermind');

        		    $mdDialog.show(confirm).then(function () {
        		      firebase.database().ref('/courses/freelanceu/categories/' + category.uid).set(null);
        		    }, function () {
        		      $log.info('cancelled delete');
        		    });

        	}
        }// delete category

        vm.newCourse = function(category){
        	var newKey = firebase.database().ref('/courses/').push().key;
        	var newCourse = {
        		uid: newKey,
        		label: 'Course Name',
        		category: category.uid,
        		image: '',
        		url: '',
        		description: ''
        	}

        	showCourseDialog(newCourse, 'New')
        }// newCourse

        // opens dialog for individual course
        vm.editCourse = function(course){

        	showCourseDialog(course, 'Edit')
        }

        function showCourseDialog(course, state){
        	$mdDialog.show({
        			  controller: newCourseDialogController, // see below
        			  controllerAs: 'vm',
        			  templateUrl: 'app/training/dialog-new-course.tmpl.html',
        			  locals: {categories: vm.categories, instructors: vm.instructors, course: course, state: state},
        			  bindToController: true,
        			  focusOnOpen: true,
        			  clickOutsideToClose:true,
        			  escapeToClose: true,
        			  fullscreen: true
        			});
        }// showCourseDialog

        // enables course editing view
		vm.editCourses = function(){
			$log.info('editCourses');
			_.each(vm.expose, function(value, key){
				vm.expose[key] = false;
			});

			vm.showCourseManager = true;
		}

		vm.closeEditor = function(){
			$log.info('closeEditor');
			vm.showCourseManager = false;
		}

		vm.toggle = function(number){
			if(vm.expose[number]){
				vm.expose[number] = false;

			} else {
				// close all other categories
				_.each(vm.categories, function(category){
					vm.expose[category.uid] = false;
				})

				// open this category
				vm.expose[number] = true;
		}

        }// toggle visibility/edit



        dragulaService.options($scope, 'drag-category', {
            moves: function (el, container, handle) {
                    return handle.classList.contains('drag-handle');
                // return handle.classList.contains('task-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

               return true

            },
            invalid: function(el, handle){
                // return var === 'condition'
                return false
            },
            direction: 'vertical',
            revertOnSpill: true
        });

        // declare our categoryBag so we can track drake.dragging
        var categoryBag = dragulaService.find($scope, 'drag-category');

        $scope.$on('drag-category.drop', function (event, item, target, source, sibling) {
            // Now we can do our work - prep the variables
            $log.info('drop!');
            var categoryID = item[0].attributes.catid.value,
	          thisContainer = $('.edit-categories'),
	          sortItems = Array.from(thisContainer.find('.training-category'));

            // Change sort order
            _.each(sortItems, function(category, index){
                var catID = category.attributes.catid.value,
                childCategoryObject = vm.categories[catID];
           	childCategoryObject.order = index + 1;
            });

            $scope.$apply();

            var updates = {};
            updates['/courses/freelanceu/categories'] = vm.categories;
            return firebase.database().ref().update(updates)
            .then(function(){
            	$log.info('sort changed');
            });

        });// drag-category.drop


        dragulaService.options($scope, 'drag-course', {
            moves: function (el, container, handle) {
                    return handle.classList.contains('course-drag-handle');
                // return handle.classList.contains('task-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

               return true

            },
            invalid: function(el, handle){
                // return var === 'condition'
                return false
            },
            direction: 'vertical',
            revertOnSpill: true
        });


      $scope.$on('drag-course.drop', function (event, item, target, source, sibling) {
          var courseID = item[0].attributes.courseid.value,
	          thisContainer = $('.edit-course-list'),
	          sortItems = Array.from(thisContainer.find('.training-course'));

          // Change sort order
          _.each(sortItems, function(course, index){
              var courseID = course.attributes.courseid.value,
              childCourseObject = vm.courses[courseID];
         		childCourseObject.order = index + 1;
          });

          $scope.$apply();

          var updates = {};
          updates['/courses/freelanceu/courses'] = vm.courses;
          return firebase.database().ref().update(updates)
          .then(function(){
          	$log.info('sort changed');
          });

      });// drag-category.drop

    }//trainingController
/////////////////////////

     /* @ngInject */
    	function newCourseDialogController($log, $mdUtil, $timeout, $scope, $rootScope, $mdDialog){
    		$log.info('newCourseDialogController');
    		var vm = this;
    		vm.editedCourse = angular.copy(vm.course);
    		vm.showImage = true;
    		vm.forms = {};

    		vm.cancel = function(){
    			$mdDialog.cancel();
    		}

    		vm.toggleImage = function(){
    			$mdUtil.debounce(function(){
    			    $timeout(function(){
    			    	vm.showImage = false;
    			    },100)
    			    .then(function(){
    			    	$timeout(function(){
    			    		vm.showImage = true;
    			    	},100)
    			    });
    			}, 2000)();



    		}
    		vm.saveCourse = function(course){
    			$log.info('saveCourse');
    			// get instructor details and attach to course
    			var updates = {};
    			updates['/courses/freelanceu/courses/' + course.uid] = course;
    			return firebase.database().ref().update(updates)
    			.then(function(){
    				$mdDialog.cancel();
    			});
    		}// savecourse

    		vm.deleteCourse = function(course){
    			var confirm = $mdDialog.confirm()
    			      .title('Are you sure you want to delete ' + course.label + '?')
    			      .textContent('This cannot be undone')
    			      .ariaLabel('Lucky day')
    			      .ok('Please do it!')
    			      .cancel('Nevermind');

    			    $mdDialog.show(confirm).then(function () {
    			      firebase.database().ref('/courses/freelanceu/courses/' + course.uid).set(null);
    			      $mdDialog.cancel();
    			    }, function () {
    			      $log.info('cancelled delete');
    			    });

    		}// delete course

    		vm.froalaOptions = {
    		        key: $rootScope.froalaKey,
    		        pluginsEnabled: [
    		        "align", "charCounter", "colors", "codeBeautifier", "codeView",  "draggable",   "entities",  "fontSize",
    		         "lineBreaker", "link",  "paragraphFormat", "paragraphStyle", "url", "wordPaste"
    		        ],
    		        spellcheck: true, // does not appear to actually enable spellcheck
    		        toolbarButtons : ["paragraphFormat", "bold", "italic", "underline", "textColor", "|", "align",  "|",  "insertLink", "insertHR", "|", "html"],
    		        autofocus: true,
    		        listAdvancedTypes: true,
    		        zIndex: 9999,
    		        attribution: false,
    		        pastePlain: true,
    		        charCounterMax: 2000,
    		        linkAlwaysBlank: true,
    		        linkAutoPrefix: 'https://',
    		        linkInsertButtons: '',
    		        linkText: true,
    		        htmlIgnoreCSSProperties: ['font-family', 'font-size', 'background-color'],
    		        pasteDeniedAttrs: ['class', 'id', 'data'],
    		        pasteDeniedTags: ['iframe', 'script', 'style'],
    		         events: {
    		                    'froalaEditor.initialized': function () {
    		                    },
    		                    'charCounter.exceeded': function () {
    		                  }
    		            }//events
    		    }//froalaOptions
    	}//courseDialogController

    	/* @ngInject */
    	function viewCourseDialogController($log, $mdDialog, $scope, $rootScope){
    		var vm = this;
            vm.settings = $rootScope.userSettings;

            // get our instructor data
            var instructorRef = firebase.database().ref('/courses/freelanceu/instructors/' + vm.course.instructorID);
            instructorRef.once('value', function(snapshot){
                vm.instructor = snapshot.val();
            });


    		vm.close = function(){
    			$mdDialog.cancel();
    		}

            vm.edit = function(course, state){
                    $mdDialog.show({
                              controller: newCourseDialogController,
                              controllerAs: 'vm',
                              templateUrl: 'app/training/dialog-new-course.tmpl.html',
                              locals: {categories: vm.categories, instructors: vm.instructors, course: course, state: state},
                              bindToController: true,
                              focusOnOpen: true,
                              clickOutsideToClose:true,
                              escapeToClose: true,
                              fullscreen: true
                            });
            }// edit
    	}
})();

(function() {
    'use strict';

    angular
        .module('training')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
       $translatePartialLoaderProvider.addPart('app/training');
       $stateProvider
           .state('triangular.training', {
               abstract: false,
               url: '/training',
               templateUrl: 'app/training/training.tmpl.html',
               // set the controller to load for this page
               controller: 'trainingController',
               controllerAs: 'vm'
           });


          // triMenuProvider.addMenu({
          //     name: 'Learn New Skills',
          //     icon: 'fa fa-graduation-cap',
          //     type: 'link',
          //     state: 'triangular.training',
          //     priority: 80,
          //     color: 'orange'
          //     // badge: Math.round(Math.random() * (100 - 1) + 1)
          // });



    } // moduleConfig

})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .factory('UserService', UserService);

    /* @ngInject */
    function UserService($q, $http, RoleStore, $firebaseAuth) {
        // var currentUser = {
        //     displayName: 'Christos',
        //     username: 'christos',
        //     avatar: 'assets/images/avatars/avatar-5.png',
        //     roles: ['SUPERADMIN']
        // };

        var service = {
            getCurrentUser: getCurrentUser,
            getUsers: getUsers,
            hasPermission: hasPermission,
            login: login,
            auth: auth
        };

        return service;

        ///////////////

        function getCurrentUser() {
            // return currentUser;
        }

        function getUsers() {
            return $http.get('app/permission/data/users.json');
        }

        function hasPermission(permission) {
            var deferred = $q.defer();
            var hasPermission = false;

            // check if user has permission via its roles
            angular.forEach(currentUser.roles, function(role) {
                // check role exists
                if(RoleStore.hasRoleDefinition(role)) {
                    // get the role
                    var roleDef = RoleStore.getRoleDefinition(role);
                    // check if the permission we are validating is in this role's permissions
                    if(-1 !== roleDef.permissionNames.indexOf(permission)) {
                        hasPermission = true;
                    }
                }
            });

            // if we have permission resolve otherwise reject the promise
            if(hasPermission) {
                deferred.resolve();
            }
            else {
                deferred.reject();
            }

            // return promise
            return deferred.promise;
        }

        function auth() {
            var ref = firebase.auth();
            return $firebaseAuth(ref);
        }

        function login(username) {

            // you would replace the code below with a call you your API
            // request all users

            // return getUsers()
            // .then(function successCallback(response) {
            //     var returnUser = getCurrentUser();
            //     angular.forEach(response.data, function(user) {
            //         if(user.username === username) {
            //             returnUser = user;
            //             currentUser = user;
            //         }
            //     });
            //     return returnUser;
            // });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .run(permissionRun);


    function permissionRun($rootScope, $cookies, $state, RoleStore, UserService) {
        // normally this would be done at the login page but to show quick
        // demo we grab username from cookie and login the user
        var cookieUser = $cookies.get('tri-user');
        if(angular.isDefined(cookieUser)) {
            UserService.login(cookieUser);
        }

        // create roles for app
        RoleStore
        .defineRole('SUPERADMIN', ['viewEmail', 'viewGitHub', 'viewCalendar', 'viewLayouts', 'viewTodo', 'viewElements', 'viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('ADMIN', ['viewLayouts', 'viewTodo', 'viewElements', 'viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('USER', ['viewAuthentication', 'viewCharts', 'viewMaps'], checkRole);
        RoleStore
        .defineRole('ANONYMOUS', [], checkRole);


        ///////////////////////

        // default redirect if access is denied
        function accessDenied() {
            $state.go('401');
        }

        // function that calls user service to check if permission is allowed
        function checkRole(permission, transitionProperties) {
            return UserService.hasPermission(permission, transitionProperties);
        }

        // watches

        // redirect all denied permissions to 401
        var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

        // remove watch on destroy
        $rootScope.$on('$destroy', function() {
            deniedHandle();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .config(permissionConfig);

    /* @ngInject */
    function permissionConfig($stateProvider, triMenuProvider) {
        $stateProvider
        .state('triangular.permission', {
            url: '/permission',
            templateUrl: 'app/permission/pages/permission.tmpl.html',
            controller: 'PermissionController',
            controllerAs: 'vm',
            resolve: {
                users: ['UserService', function(UserService) {
                    return UserService.getUsers();
                }]
            },
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-define', {
            url: '/permission/define',
            templateUrl: 'app/permission/pages/permission-define.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-routes', {
            url: '/permission/routes',
            templateUrl: 'app/permission/pages/permission-routes.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        })
        .state('triangular.permission-views', {
            url: '/permission/views',
            templateUrl: 'app/permission/pages/permission-views.tmpl.html',
            data: {
                layout: {
                    contentClass: 'layout-column'
                }
            }
        });

        // triMenuProvider.addMenu({
        //     name: 'Permissions',
        //     icon: 'zmdi zmdi-lock',
        //     type: 'dropdown',
        //     priority: 100,
        //     children: [{
        //         name: 'Permissions',
        //         state: 'triangular.permission',
        //         type: 'link'
        //     },{
        //         name: 'Define Roles',
        //         state: 'triangular.permission-define',
        //         type: 'link'
        //     },{
        //         name: 'Routes',
        //         state: 'triangular.permission-routes',
        //         type: 'link'
        //     },{
        //         name: 'Views',
        //         state: 'triangular.permission-views',
        //         type: 'link'
        //     }]
        // });
    }
})();

(function() {
	'use strict';

	angular
		.module('publicForm', ['appServices', 'ngAnimate']);
})();

(function() {
    'use strict';

    angular
        .module('publicForm')
        .controller('publicFormController', publicFormController);

    /* @ngInject*/
    function publicFormController($log, $scope, $sce, $timeout, $stateParams, leadDataService) {
        var vm = this;
        // $log.info('publicFormController');

        if($stateParams.formID && $stateParams.accountID){
            vm.formID = $stateParams.formID;
            vm.accountID = $stateParams.accountID;
            init(vm.formID, vm.accountID);
        } else {
          vm.showError = true
        }

        function init(formID, accountID){
            $timeout(function(){
               vm.initDone = false;
               vm.showError = false;
               delete vm.thisUser;
               delete vm.thisForm;
            })
            .then(function(){
                var do_getForm = getForm(formID), do_getUser = getUser(accountID);
                return Promise.all([do_getForm, do_getUser])
                .then(function(){
                    // $log.info('init done');
                    $timeout(function(){
                        vm.initDone = true;
                        generateHTML(vm.thisUser, vm.thisForm);
                    },0)
                });
            });

        } // init

        function generateHTML(user, form){
            // $log.info('generateHTML');
            return leadDataService.exportLeadForm(form)
            .then(function(formHTML){
                vm.formHTML = $sce.trustAsHtml(formHTML);
                // $log.info(vm.formHTML);
            })
        }//

        function getForm(formID){
            // $log.info('getForm');
            var formRef = firebase.database().ref('/forms/' + formID);
           return formRef.once('value', function(snapshot){
                if(snapshot.exists()){
                    $timeout(function(){
                        vm.thisForm = snapshot.val();
                    });
                } else {
                    $timeout(function(){
                        vm.showError = true;
                    })
                }
            }, function(error){
                $timeout(function(){
                    vm.showError = true;
                })
            })
        }// getForm

        function getUser(userID){
            // $log.info('getUser');
            var userRef = firebase.database().ref('/userList/' + userID);
            return userRef.once('value', function(snapshot){
                if(snapshot.exists()){
                    $timeout(function(){
                        vm.thisUser = snapshot.val();
                    });
                } else {
                    $log.info('no user found');
                    $timeout(function(){
                        vm.showError = true;
                    })

                }
            }, function(error){
                $timeout(function(){
                    vm.showError = true;
                })
            })
        }// getUser

    } // publicFormController
})();

(function() {
    'use strict';

    angular
        .module('publicForm')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/public-form');

        $stateProvider
            .state('public-form', {
                abstract: false,
                views: {
                        'root': {
                            templateUrl: 'app/public-form/public-form.tmpl.html',
                            controller: 'publicFormController',
                            controllerAs: 'vm'
                        }
                    },
                url: '/form/:accountID/:formID',
                params: {
                        accountID: {squash: true, value: null},
                        formID: {squash: true, value: null}
                    }

            });

        // triMenuProvider.addMenu({
        //     name: 'All&nbsp;Tasks',
        //     icon: 'fa fa-check-square-o',
        //     type: 'link',
        //     state: 'triangular.tasks-page',
        //     priority: 5.3
        //     // badge: Math.round(Math.random() * (100 - 1) + 1)
        // });

    }
})();

(function() {
	'use strict';

	angular
		.module('paymentPortal', ['appServices', 'ngAnimate']);
})();

(function() {
    'use strict';

    angular
        .module('paymentPortal')
        .controller('paymentPortalController', paymentPortalController);

    /* @ngInject*/
    function paymentPortalController($log, $scope, $window, $sce, $timeout, $stateParams, angularLoad, invoiceService) {
        var vm = this;

        vm.now = moment().toISOString();
        vm.showError = false;
        vm.initDone = false;
        vm.pendingMessasge = 'Looking up Invoice...';

        vm.optionQuantity = 1;
        vm.paymentState = 'pending';
        vm.refillState = 'pending';
        vm.stripePay = stripePay;
        vm.resetForm = resetForm;
        vm.isRefill = false;
        vm.selectRefill = selectRefill;
        vm.optionTotal = optionTotal;
        vm.optionHours = optionHours;
        vm.newBalance = newBalance;
        vm.submitRefill = submitRefill;
        var stripe;
        var orderData;
        var clientSecret;

        init();


        function init(){
          $log.info('init');
          $log.info($stateParams);
            if($stateParams.clientID && $stateParams.invoiceID){
              $log.info('has params');
                vm.clientID = $stateParams.clientID;
                vm.invoiceID = $stateParams.invoiceID;
                vm.packageID = $stateParams.packageID
                $timeout(function(){
                  if(!$stateParams.packageID){
                    $log.info('invoice');
                    vm.pendingMessage = 'Looking up Invoice...'
                  } else {
                    $log.info('package');
                    vm.pendingMessage = 'Looking up Refill Options...'
                  }
                },0)

                  $timeout(function(){
                      vm.pendingMessage = 'Checking validity...';
                  },5000)
                  $timeout(function(){
                      vm.pendingMessage = 'Authenticating Keys...';
                  },8000)
                  $timeout(function(){
                      vm.pendingMessage = 'Just a few more moments...';
                  },10000)

                    if(vm.invoiceID != 'refill'){
                      // pay invoice
                      return getInvoice(vm.clientID, vm.invoiceID)
                      .then(function(results){
                          $timeout(function(){
                              vm.invoice = results;
                              vm.paymentAmount = Number(vm.invoice.info.balance).toFixed(2);
                              vm.initDone = true;
                              if(vm.invoice.info.enablePaypal){
                                  setupPaypalButtons();
                              }// if paypal

                              if(vm.invoice.info.enableStripe){
                                 setupStripe();
                              }// if stripe

                          },0)

                      })
                      .catch(function(error){
                          $log.info(error);
                          vm.initDone = true;
                          $timeout(function(){
                              vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>We could not authenticate your invoice link. <br>Please check with your virtual assistant.</p>"
                              vm.showError = true;
                          })
                      })

                    } else {
                      // purchase refill
                      return getPackage(vm.clientID, vm.packageID)
                      .then(function(results){
                        $log.info('package returned:');
                        $log.info(results);
                        $timeout(function(){
                          vm.package = results;
                          vm.initDone = true;
                          vm.isRefill = true;
                          vm.packageBalance = (Number(vm.package.budgetedMinutes)/60) - (Number(vm.package.qualifiedMinutes)/60);
                        })
                        .then(function(){
                          if(vm.package.status != 'closed'){
                            if(!_.has(vm.package, 'refillOptions')){
                              $timeout(function(){
                                  vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>There are no refill options for this package. <br>Please check with your virtual assistant.</p>"
                                  vm.showError = true;
                              })
                            }
                          } else {
                            $timeout(function(){
                                vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>This package has expired or closed. <br>Please check with your virtual assistant.</p>"
                                vm.showError = true;
                            })
                          }
                        })
                      })
                      .catch(function(error){
                        $log.info(error);
                        vm.initDone = true;
                        $timeout(function(){
                            vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>We could not authenticate your refill link. <br>Please check with your virtual assistant.</p>"
                            vm.showError = true;
                        })
                      })
                    }



            } else {
                 vm.showError = true
            }
        } // init

        function submitRefill(clientPackage, refillRequest){
          $timeout(function(){
            vm.refillState = 'submitting'
          })
           var endpoint = firebase.functions().httpsCallable('payments'),
               request = {
                 action: 'refillPackage',
                 package: clientPackage,
                 refill: refillRequest
               }

           return endpoint(request)
           .then(function(results){
              $timeout(function(){
                // results should be invoice AND new line item
                // getInvoice and reset loading state
                // should display payment form to complete
                vm.newLineItem = results.data;
                vm.refillState = 'complete';
              })
           })
           .catch(function(error){
              // $log.info('error');
              // $log.info(error);
              $timeout(function(){
                  vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>We were unable to commit your refill request. <br>Please try again.<br>If this keeps happening, check with your virtual assistant.</p>"
                  vm.showError = true;
              })

           })

        }// submitRefill


        function newBalance(option){
          var result = vm.packageBalance + (option.quantity * option.hours)
          result = result.toFixed(2);
          return result
        }

        function optionHours(option){
          var result = Number(option.quantity) * Number(option.hours);
          result = result.toFixed(2);
          return result
        }

        function optionTotal(option){
          var result = option.cost * option.quantity;
          result = result.toFixed(2);
          return result
        }

        function getPackage(clientID, packageID){
          // $log.info('getPackage: ' + packageID);

           return new Promise(function(resolve, reject){
                var endpoint = firebase.functions().httpsCallable('payments'),
                    request = {
                      action: 'getPackage',
                      clientID: clientID,
                      packageID: packageID
                    }

                return endpoint(request)
                .then(function(results){
                   return resolve(results.data)
                })
                .catch(function(error){
                   // $log.info('error');
                   // $log.info(error);
                   return reject(error)
                })
           })

        }// getPackage

        function selectRefill(option){
          option.quantity = 1;
          vm.refillOption = option;
        }//selectRefill

        function setupStripe(){
            orderData = {
                      items: [{ id: "VA Services" }],
                      currency: vm.invoice.currencyCode
                    };

            angularLoad.loadScript('https://js.stripe.com/v3/')
            .then(function(){
                // $log.info('Stripe Loaded');
                return setupStripeElements(vm.invoice.info.stripeClient)
                .then(function(results){
                    // $log.info('stripeElements Setup');
                    document.querySelector("button").disabled = false;
                       var form = document.getElementById("stripe-payment-form");
                       form.addEventListener("submit", function(event) {
                         event.preventDefault();
                         stripePay(results.stripe, results.card, results.clientSecret);
                     })
                })
            })
        }//setupStripe

        function stripePay(stripe, card) {

            // $log.info('stripePay');
              stripeChangeLoadingState(true);

              // Collects card details and creates a PaymentMethod
              stripe
                .createPaymentMethod("card", card)
                .then(function(result) {
                  if (result.error) {
                    // TODO - Use our own error message here
                    stripeShowError(result.error.message);
                  } else {
                    orderData.paymentMethodId = result.paymentMethod.id;
                    // call CFN to pay
                    orderData.orderAmount = Number(vm.paymentAmount) * 100;
                    orderData.stripeSecretID = vm.invoice.stripeSecretID;
                    var endpoint = firebase.functions().httpsCallable('payments');
                    orderData.action = 'stripePay';
                    return endpoint(orderData)
                    .then(function(results){
                        // $log.info('stripePay Results:');
                        // $log.info(results);
                        if(results.data.error){
                            // $log.info('error');
                            // $log.info(results.data.error);
                            $timeout(function(){
                                vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>"+results.data.error+ "</p>"
                                // we want to give opportunity to try again for certain error codes
                                switch(results.data.error){
                                     case 'The zip code you supplied failed validation.':
                                         vm.showRefresh = true;
                                         break;
                                     case 'Your card\'s security code is incorrect.':
                                         vm.showRefresh = true;
                                         break;
                                    case 'Your card was declined.':
                                        vm.showRefresh = true;
                                        break;
                                    case 'Your card has expired.':
                                        vm.showRefresh = true;
                                        break;
                                     default:
                                         vm.showRefresh = false;
                                }
                                vm.showError = true;
                            })
                        } else if (results.data.requiresAction){
                            // $log.info('requires action');
                            stripeHandleAction(results.data)
                        } else {
                            // $log.info('stripePay success!');
                            // $log.info(results);
                            stripeOrderComplete(results.data)
                        }

                    })
                    .catch(function(error){
                       $log.info('error');
                       $log.info(error);
                       $timeout(function(){
                           vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>We had a problem connecting to our payment servers. Please try again later.</p>"
                           vm.showError = true;
                       })
                    })
                  }
                })

        }//stripePay

        function stripeShowError(errorMsgText) {
            $timeout(function(){
              stripeChangeLoadingState(false);
                vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>"+errorMsgText+ "</p>"
                vm.showError = true;
            })
              setTimeout(function() {
                vm.showError = false;
                vm.errorMessage = '';
              }, 4000);

        };

        function stripeHandleAction(transactionInfo) {
          // $log.info('stripeHandleAction ' + transactionInfo.paymentIntent.id);
          stripe.handleCardAction(transactionInfo.clientSecret).then(function(data) {
            if (data.error) {
              showError(data.error);
            } else if (data.paymentIntent.status === "requires_confirmation") {
                // $log.info('requires_confirmation - sending paymentIntent.id');
                // Confirmatoin has been completed - send the paymentIntent to the processor to complete the charge
                orderData.paymentIntentId = transactionInfo.paymentIntent.id;
                delete orderData.paymentMethodId;
                var endpoint = firebase.functions().httpsCallable('payments');
                orderData.action = 'stripePay';
                return endpoint(orderData)
                .then(function(results){
                    // $log.info('post sending paymentIntent.id');
                    // $log.info(results);
                    stripeOrderComplete(results.data)
                })
                .catch(function(error){
                    // $log.info('stripe send paymentIntent.id error');
                    // $log.info(error);
                    return (error);
                })
            }
          });
        }//stripeHandleAction

        function stripeOrderComplete(transactionInfo) {
          // $log.info('stripeOrderComplete');
          return saveStripePayment(transactionInfo)
          .then(function(){
            // $log.info('stripeOrderCompleted!');
            stripeChangeLoadingState(false);
          })
          // stripe.retrievePaymentIntent(clientSecret).then(function(result) {
            // var paymentIntent = result.paymentIntent;
            // var paymentIntentJson = JSON.stringify(paymentIntent, null, 2);

            // document.querySelector(".sr-payment-form").classList.add("hidden");
            // // document.querySelector("pre").textContent = paymentIntentJson;

            // document.querySelector(".sr-result").classList.remove("hidden");
            // setTimeout(function() {
            //   document.querySelector(".sr-result").classList.add("expand");
            // }, 200);


          // });
        };

        function saveStripePayment(transactionID){
            return new Promise(function(resolve, reject){
                // $log.info('saveStripePayment transactionID:' + transactionID);

                // does this transaction require additional verification?
                     $timeout(function(){
                        vm.paymentState = 'recording';
                        vm.newBalance = Number(vm.invoice.info.balance) - Number(vm.paymentAmount);
                        vm.newBalance = Number(vm.newBalance).toFixed(2);
                    });
                     var recordPaymentRequest = {
                         id: transactionID,
                         accountID: vm.invoice.info.owner,
                         clientID: vm.invoice.info.client,
                         invoiceID: vm.invoice.uid,
                         invoiceNumber: vm.invoice.info.number,
                         senderID: transactionID,
                         date: moment().toISOString(),
                         amount: Number(vm.paymentAmount).toFixed(2),
                         processor: 'Stripe'
                     }

                    return recordPayment(vm.invoice, recordPaymentRequest)
                    .then(function(results){
                     // $log.info('Payment Recorded');
                        $timeout(function(){
                            vm.paymentResults = recordPaymentRequest;
                            vm.paymentState = 'recorded';
                        }, 1000);
                        return resolve(true);
                    })
                    .catch(function(error){
                         // $log.info('saveStripePayment error!');
                         // $log.info(error);
                         return reject(error)
                    });

            })

        }// saveStripPayment

        // Show a spinner on payment submission
        function stripeChangeLoadingState(isLoading) {
          if (isLoading) {
            document.querySelector("button").disabled = true;
            document.querySelector("#spinner").classList.remove("hidden");
            // document.querySelector("#card-element").classList.add("hidden");
            document.querySelector("#stripe-button-text").classList.add("hidden");
          } else {
            document.querySelector("button").disabled = false;
            document.querySelector("#spinner").classList.add("hidden");
            // document.querySelector("#card-element").classList.remove("hidden");
            document.querySelector("#stripe-button-text").classList.remove("hidden");
          }
        };

        function setupStripeElements(stripeClient){
            return new Promise(function(resolve, reject){
                stripe = Stripe(stripeClient);
                var elements = stripe.elements();

                var style = {
                  base: {
                    color: "#32325d",
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                      color: "#aab7c4"
                    }
                  },
                  invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a"
                  }
                }//style

                var card = elements.create("card", { style: style });
                  card.mount("#card-element");

                  return resolve({
                    stripe: stripe,
                    card: card
                  });
            })

        }// setupStripeElements

        function setupPaypalButtons(){
          $log.info('setupPaypalButtons');
            angularLoad.loadScript('https://www.paypal.com/sdk/js?currency='+ vm.invoice.currencyCode +'&client-id=' + vm.invoice.info.paypalClient)
            .then(function(){
                // paypal.Buttons().render('#paypal-button-container');
                paypal.Buttons({
                   createOrder: function(data, actions) {
                    $timeout(function(){
                        vm.paymentState = 'capturing';
                    })
                    var orderAmount = Number(vm.paymentAmount);
                     // This function sets up the details of the transaction, including the amount and line item details.
                     return actions.order.create({
                       purchase_units: [{
                         amount: {
                           value: orderAmount
                         }
                       }]
                     });
                   },
                   onApprove: function(data, actions) {
                        $log.info('onApprove');
                        // This function captures the funds from the transaction.
                        return actions.order.capture().then(function(transactionInfo) {
                            $timeout(function(){
                                vm.paymentState = 'recording';
                                vm.newBalance = Number(vm.invoice.info.balance) - Number(vm.paymentAmount);
                                vm.newBalance = Number(vm.newBalance).toFixed(2);

                            });
                            var recordPaymentRequest = {
                                id: transactionInfo.id,
                                accountID: vm.invoice.info.owner,
                                clientID: vm.invoice.info.client,
                                invoiceID: vm.invoice.uid,
                                invoiceNumber: vm.invoice.info.number,
                                senderID: transactionInfo.payer.email_address,
                                date: transactionInfo.create_time,
                                amount: Number(vm.paymentAmount).toFixed(2),
                                processor: 'PayPal'
                            }
                            return recordPayment(vm.invoice, recordPaymentRequest)
                            .then(function(results){
                                $timeout(function(){
                                    vm.paymentResults = recordPaymentRequest;
                                    vm.paymentState = 'recorded';
                                }, 1000);
                            })
                            .catch(function(error){
                                $log.info('recordPaymentError');
                                $log.info(error);                                ;
                            });

                        });
                      }
                 }).render('#paypal-button-container');
            })
            .catch(function(error){
              $log.info('Paypal Script Load error');
              // probably because invoice doesn't have currency
              $timeout(function(){
                  vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>This Invoice is missing some important payment processor information.<br> Please ask your Virtual Assistant to recreate and resend this invoice.</p>"
                  vm.showError = true;
              })
            })
        }// setupPaypalButtons

        function getInvoice(clientID, invoiceID){
            $log.info('geInvoice');
            return new Promise(function(resolve, reject){
                 var endpoint = firebase.functions().httpsCallable('payments'),
                     request = {
                       action: 'getInvoice',
                       clientID: clientID,
                       invoiceID: invoiceID
                     }

                 return endpoint(request)
                 .then(function(results){
                    return resolve(results.data)
                 })
                 .catch(function(error){
                    $log.info('error');
                    $log.info(error);
                    return reject(error)
                 })
            })
        }// getClient

        function recordPayment(invoice, recordPaymentRequest){
            $log.info('recordPayment');
            return new Promise(function(resolve, reject){
                 var endpoint = firebase.functions().httpsCallable('payments'),
                     request = {
                       action: 'recordPayment',
                       clientID: invoice.info.client,
                       invoice: invoice,
                       payment: recordPaymentRequest
                     }

                 return endpoint(request)
                 .then(function(results){
                    return resolve(results.data)
                 })
                 .catch(function(error){
                    $log.info('recordPayment error');
                    $timeout(function(){
                        vm.errorMessage = "<p class='md-title center'><strong>Sorry!</strong></p><p class='md-subhead center'>There was a problem recording your payment. <br>Please send an email to <a href='mailto:help@getadminja.com' target='_blank'>help@getadminja.com</a> with the following information and we will get it fixed in a jiffy!</p><p class='margin-top-40 center'><strong>Subject: </strong>Successful payment needs applied to my account.<br><strong>AccountID: </strong> " + invoice.info.owner + "<br><strong>ClientID: </strong> " + invoice.info.client + "<br><strong>PaymentID: </strong>" + recordPaymentRequest.id + "</p>"
                        vm.showError = true;
                    })
                    return reject(error)
                 })
            })
        }// recordPayment

        function resetForm(){
            $window.location.reload();
        };

    } // paymentPortalController
})();

(function() {
    'use strict';

    angular
        .module('paymentPortal')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/payment-portal');

        $stateProvider
            .state('payment-portal', {
                abstract: false,
                views: {
                        'root': {
                            templateUrl: 'app/payment-portal/payment-portal.tmpl.html',
                            controller: 'paymentPortalController',
                            controllerAs: 'vm'
                        }
                    },
                url: '/payment-portal/:clientID/:invoiceID/:packageID',
                params: {
                        clientID: {squash: true, value: null},
                        invoiceID: {squash: true, value: null},
                        packageID: {squash: true, value: null}
                    }

            });

        // triMenuProvider.addMenu({
        //     name: 'All&nbsp;Tasks',
        //     icon: 'fa fa-check-square-o',
        //     type: 'link',
        //     state: 'triangular.tasks-page',
        //     priority: 5.3
        //     // badge: Math.round(Math.random() * (100 - 1) + 1)
        // });

    }
})();

(function() {
    'use strict';

    angular
        .module('appDirectives')
        .directive('weatherWidget', weatherWidget);

    /* @ngInject */
    function weatherWidget($http) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            require: 'triWidget',
            link: link,
            restrict: 'A'
        };
        return directive;

        function link($scope, $element, attrs, widgetCtrl) {
            widgetCtrl.setLoading(true);

            var query = 'select item.condition from weather.forecast where woeid in (select woeid from geo.places(1) where text="' + attrs.weatherWidget + '")';
            var url = 'https://query.yahooapis.com/v1/public/yql?q=' + encodeURIComponent(query) + '&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys';

            $http.get(url).
            success(function(data) {
                if(data.query.count > 0) {
                    widgetCtrl.setLoading(false);
                    $scope.weather = {
                        iconClass: 'wi-yahoo-' + data.query.results.channel.item.condition.code,
                        date: new Date(data.query.created),
                        temp: data.query.results.channel.item.condition.temp,
                        text: data.query.results.channel.item.condition.text,
                        location: attrs.weatherWidget
                    };
                }
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
   .directive('selectOnClick', ['$window', function ($window) {
       return {
           restrict: 'A',
           link: function (scope, element, attrs) {
               element.on('click', function () {
                   if (!$window.getSelection().toString()) {
                       // Required for mobile Safari
                       this.setSelectionRange(0, this.value.length)
                   }
               });
           }
       };
   }]);
})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('resize', resize)

    /* @ngInject */
    function resize(pageDimensionsService,$state, $log, $window, $timeout) {
      return function (scope, element, attr) {
        var suppressResize = attr.resize;
        var w = angular.element($window);

        function update(mode) {
            $timeout(function(){
              pageDimensionsService.resizeColumns(mode);
            },0);
        }

          w.bind('resize', function () {
              // trigger $digest when window is resized and call `update` function
              if(w.width() < 1440){
                // alert("Window too small!")
              }
              scope.$apply(update(attr.resize));
          });

          update(attr.resize); // initial setup

      }
    }

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
   .directive('onlyDigits', function () {
       return {
         require: 'ngModel',
         restrict: 'A',
         link: function (scope, element, attr, ctrl) {
           function inputValue(val) {
             if (val) {
               var digits = val.replace(/[^0-9]/g, '');

               if (digits !== val) {
                 ctrl.$setViewValue(digits);
                 ctrl.$render();
               }
               return parseInt(digits,10);
             }
             return undefined;
           }
           ctrl.$parsers.push(inputValue);
         }
       };
   });
})();

(function() {
  'use strict';




  angular
    .module('appDirectives')
    .directive('lowercaseInput', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function(input) {
                    return input ? input.toLowerCase() : "";
                });
                element.css("text-transform","lowercase");
            }
        };
    });

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('isolateScrolling', function () {
      return {
        restrict: 'A',
          link: function (scope, element, attr) {
            element.bind('DOMMouseScroll', function (e) {
              if (e.detail > 0 && this.clientHeight + this.scrollTop == this.scrollHeight) {
                this.scrollTop = this.scrollHeight - this.clientHeight;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
              else if (e.detail < 0 && this.scrollTop <= 0) {
                this.scrollTop = 0;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
            });
            element.bind('mousewheel', function (e) {
              if (e.originalEvent.deltaY > 0 && this.clientHeight + this.scrollTop >= this.scrollHeight) {
                this.scrollTop = this.scrollHeight - this.clientHeight;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }
              else if (e.originalEvent.deltaY < 0 && this.scrollTop <= 0) {
                this.scrollTop = 0;
                e.stopPropagation();
                e.preventDefault();
                return false;
              }

              return true;
            });
          }
      };
    });

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('isolateForm', [function () {
      return {
        restrict: 'A',
        require: '?form',
        link: function (scope, elm, attrs, ctrl) {
          if (!ctrl) {
            return;
          }

          // Do a copy of the controller
          var ctrlCopy = {};
          angular.copy(ctrl, ctrlCopy);

          // Get the parent of the form
          var parent = elm.parent().controller('form');
          // Remove parent link to the controller
          parent.$removeControl(ctrl);

          // Replace form controller with a "isolated form"
          var isolatedFormCtrl = {
            $setValidity: function (validationToken, isValid, control) {
              ctrlCopy.$setValidity(validationToken, isValid, control);
              parent.$setValidity(validationToken, true, ctrl);
            },
            $setDirty: function () {
              elm.removeClass('ng-pristine').addClass('ng-dirty');
              ctrl.$dirty = true;
              ctrl.$pristine = false;
            },
          };
          angular.extend(ctrl, isolatedFormCtrl);
        }
      };
    }]);

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('inhibitBack', inhibitBack)

    // the inhbitBack directive detects scroll events and attempts to inhibit triggering a "back" gesture when scrolling too quickly to the left
    inhibitBack.$inject = ['$window'];
    function inhibitBack() {
      return {
        restrict: 'A',
              link: function(scope, elem, attr, ctrl) {
                // Get our element so we can monitor it
                var raw = elem[0];
                $(raw).addClass('inhibit-back');
                var thisScroll = $(elem)[0];

                $('.inhibit-back').on('scroll', function(event){
                      // We don't want to scroll below zero or above the width and height
                      var maxX = $(elem)[0].scrollWidth - $(elem)[0].offsetWidth;

                      // If this event looks like it will scroll beyond the bounds of the this event, prevent it and set the scroll to the boundary manually
                      // If scrolling too far left
                      if ($(elem)[0].scrollLeft - 10 < 0){
                        // console.log('Stopping going back');
                        event.preventDefault();
                        $(elem)[0].scrollLeft = 1;
                      }

                      // If scrolling too far right
                      if($(elem)[0].scrollLeft + 10 > maxX){
                        // console.log('Stopping going forward');
                        event.preventDefault();
                        $(elem)[0].scrollLeft = maxX;
                      }

                    });

               }
             }
      }

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive("formOnChange", function($parse){
      return {
        require: "form",
        link: function(scope, element, attrs){
           var cb = $parse(attrs.formOnChange);
           element.on("change", function(){
              cb(scope);
           });
        }
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive("contenteditable", function() {
      return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, element, attrs, ngModel) {

          function read() {
            ngModel.$setViewValue(element.html());
          }

          ngModel.$render = function() {
            element.html(ngModel.$viewValue || "");
          };

          element.bind("blur keyup change", function() {
            scope.$apply(read);
          });
        }
      };
    });

})();


(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('backButton', ['$window', function($window) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.bind('click', function () {
                        $window.history.back();
                    });
                }
            };
        }]);

})();

(function() {
  'use strict';

  angular
    .module('appDirectives')
    .directive('adminjaEnter', function () {
      return function (scope, element, attrs) {

        element.bind('keydown keypress', function(event) {
          var keyCode = event.which || event.keyCode;

          // If enter key is pressed
          if (keyCode === 13 && !event.shiftKey) {
            scope.$apply(function() {
              scope.$eval(attrs.adminjaEnter);
            });

            event.preventDefault();
          }
        });

      }
    })
    .directive('stringToNumber', function() {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$parsers.push(function(value) {
            return '' + value;
          });
          ngModel.$formatters.push(function(value) {
            return parseFloat(value, 10);
          });
        }
      };
    });;

})();

(function() {
    'use strict';

    angular
        .module('calendar', [

        ]);
})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .controller('CalendarToolbarController', CalendarToolbarController);

    /* @ngInject */
    function CalendarToolbarController($scope, $state, $element, $mdUtil, $mdSidenav, triBreadcrumbsService, uiCalendarConfig) {
        var vm = this;
        vm.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        vm.changeMonth = changeMonth;
        vm.changeView = changeView;
        vm.openSideNav = openSideNav;
        vm.views = [{
            name: 'CALENDAR.TOOLBAR.VIEWS.MONTH',
            icon: 'zmdi zmdi-view-module',
            viewName: 'month'
        },{
            name: 'CALENDAR.TOOLBAR.VIEWS.WEEK',
            icon: 'zmdi zmdi-view-week',
            viewName: 'agendaWeek'
        },{
            name: 'CALENDAR.TOOLBAR.VIEWS.DAY',
            icon: 'zmdi zmdi-view-day',
            viewName: 'agendaDay'
        }];
        vm.currentView = vm.views[0];

        //////////////

        function changeMonth(direction) {
            uiCalendarConfig.calendars['triangular-calendar'].fullCalendar(direction);
        }

        function changeView(view) {
            vm.currentView = view;
            uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('changeView', view.viewName);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .filter('padding', padding);

    function padding() {
        return paddingFilter;

        ////////////////

        function paddingFilter(n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .controller('EventDialogController', EventDialogController);

    /* @ngInject */
    function EventDialogController($scope, $mdDialog, $filter, triTheming, dialogData, event, edit) {

        var vm = this;
        vm.cancelClick = cancelClick;
        vm.colors = [];
        vm.colorChanged = colorChanged;
        vm.deleteClick = deleteClick;
        vm.allDayChanged = allDayChanged;
        vm.dialogData = dialogData;
        vm.edit = edit;
        vm.event = event;
        vm.okClick = okClick;
        vm.selectedColor = null;
        // create start and end date of event
        vm.start = event.start.toDate();
        vm.startTime = convertMomentToTime(event.start);

        if(event.end !== null) {
            vm.end = event.end.toDate();
            vm.endTime = convertMomentToTime(event.end);
        }

        ////////////////

        function colorChanged() {
            vm.event.backgroundColor = vm.selectedColor.backgroundColor;
            vm.event.borderColor = vm.selectedColor.backgroundColor;
            vm.event.textColor = vm.selectedColor.textColor;
            vm.event.palette = vm.selectedColor.palette;
        }

        function okClick() {
            vm.event.start = updateEventDateTime(vm.start, vm.startTime);
            if(vm.event.end !== null) {
                vm.event.end = updateEventDateTime(vm.end, vm.endTime);
            }
            $mdDialog.hide(vm.event);
        }

        function cancelClick() {
            $mdDialog.cancel();
        }

        function deleteClick() {
            vm.event.deleteMe = true;
            $mdDialog.hide(vm.event);
        }

        function allDayChanged() {
            // if all day turned on and event already saved we need to create a new date
            if(vm.event.allDay === false && vm.event.end === null) {
                vm.event.end = moment(vm.event.start);
                vm.event.end.endOf('day');
                vm.end = vm.event.end.toDate();
                vm.endTime = convertMomentToTime(vm.event.end);
            }
        }

        function convertMomentToTime(moment) {
            return {
                hour: moment.hour(),
                minute: moment.minute()
            };
        }

        function updateEventDateTime(date, time) {
            var newDate = moment(date);
            newDate.hour(time.hour);
            newDate.minute(time.minute);
            return newDate;
        }

        function createDateSelectOptions() {
            // create options for time select boxes (this will be removed in favor of mdDatetime picker when it becomes available)
            vm.dateSelectOptions = {
                hours: [],
                minutes: []
            };
            // hours
            for(var hour = 0; hour <= 23; hour++) {
                vm.dateSelectOptions.hours.push(hour);
            }
            // minutes
            for(var minute = 0; minute <= 59; minute++) {
                vm.dateSelectOptions.minutes.push(minute);
            }
        }

        // init
        createDateSelectOptions();

        // create colors
        angular.forEach(triTheming.palettes, function(palette, index) {
            var color = {
                name: index.replace(/-/g, ' '),
                palette: index,
                backgroundColor: triTheming.rgba(palette['500'].value),
                textColor: triTheming.rgba(palette['500'].contrast)
            };

            vm.colors.push(color);

            if(index === vm.event.palette) {
                vm.selectedColor = color;
                vm.colorChanged();
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .controller('CalendarController', CalendarController);

    /* @ngInject */
    function CalendarController($log, $scope, $compile, $filter, $stateParams, gateService, clientDataService, $timeout, taskDataService, taskTemplateDataService, userDataService, $rootScope, triLayout, uiCalendarConfig, teamDataService, _teams) {
        $log.info('calendarController');
        var vm = this, timeoutFunction;

          vm.init = init;
          vm.clients = clientDataService.clients;
          vm.changeMonth = changeMonth;
          vm.changeView = changeView;
          vm.loading = false;
          vm.refreshView = refreshView;
          vm.newTask = newTask;
          vm.user = userDataService.user;
          vm.settings = $rootScope.userSettings;
          vm.startOfDayArray = vm.settings.startOfWorkday.split(':');
          vm.startOfDay = vm.startOfDayArray[0];
          vm.hasCalendar = true;
          vm.hasCalendar = gateService.gateData.hasBilling;

          vm.teamDataService = teamDataService;
          vm.usersTeams = _teams;

          vm.clientTeams = teamDataService.clientTeams;
          vm.allMembers = teamDataService.allMembers;
          vm.filterOption = 'all';
          vm.snoozeFilter = false;
          var shortTitleLength = 80;

        var firstDayOfWeek;
        if(_.has(vm.settings, 'startOfWeek')){
          firstDayOfWeek = vm.settings.startOfWeek;
        } else {
          firstDayOfWeek = 0;
        }

        vm.currentView = 'month';

        // check to see if we've stored a view preference and use it
        if(_.has(vm.settings, 'calendarView')){
          vm.currentView = vm.settings.calendarView;
        }


        vm.viewFormats = {
            'month': 'MMMM YYYY',
            'agendaWeek': 'w',
            'agendaDay': 'Do MMMM YYYY'
        };


        vm.eventSources = [{
            events: []
        }];

        var startOfDay = '08:00', endOfDay = '17:00', calendarViewStart = '07:00';
        if(_.has(vm.settings, 'startOfWorkday')){
          startOfDay = vm.settings.startOfWorkday;
        }
        if(_.has(vm.settings, 'endOfWorkday')){
          endOfDay = vm.settings.endOfWorkday;
        }

        if(_.has(vm.settings, 'calendarViewStartOfDay')){
          calendarViewStart = vm.settings.calendarViewStartOfDay;
        }



        vm.calendarOptions = {
            contentHeight: 'auto',
            defaultView: vm.currentView,
            selectable: true,
            editable: true,
            header: false,
            firstDay: firstDayOfWeek,
            ignoreTimezone: false,
            defaultTimedEventDuration: '00:15:00',
            slotDuration: '00:15:00',
            slotLabelInterval: '1:00',
            minTime:calendarViewStart,
            nowIndicator: true,
            handleWindowResize: true,
            businessHours: {
              dow: [ 1, 2, 3, 4,5 ],
              start: startOfDay,
              end: endOfDay,
            },
            viewRender: function(view) {
                // change day
                vm.currentDay = view.calendar.getDate();
                vm.currentWeek = view.start;
                vm.currentView = view.name;
                // update toolbar with new day for month name
                $rootScope.$broadcast('calendar-changeday', vm.currentDay);
                // update background image for month
                triLayout.layout.contentClass = 'calendar-background-image background-overlay-static overlay-gradient-10 calendar-background-month-' + vm.currentDay.month();
            },
            eventClick: function(calEvent, jsEvent, view) { //eslint-disable-line
              return taskDataService.getTask(calEvent.uid)
              .then(function(editedItem){
                taskDataService.taskDialog(editedItem);
              });
            },
            eventMouseover: function(calEvent, jsEvent, view){

              if(calEvent.fullTitle.length > shortTitleLength){
                  // Get container dimensions and coordinates to calculate positio of tooltip
                  var calendarContainer = $('.calendar-directive'),
                      // get width for midpoint threshold calculation
                      contentWidth = $(calendarContainer).width(),
                      // isolate event moused over
                      targetEvent = jsEvent.currentTarget,
                      // get dimenions of event for calculations
                      targetEventWidth = $(targetEvent).width(),
                      targetEventTop = $(targetEvent).offset().top,
                      // Store the left and right edges of our event so we can place our tooltip
                      // Make sure we take into consideration parent's x offset so we have an accurate position WITHIN our calendar, not document
                      targetEventLeft = $(targetEvent).offset().left - $(calendarContainer).offset().left,
                      // based off of normalized left we don't need to consider parent offset here
                      targetEventRight = targetEventLeft + targetEventWidth,
                      // calc our midpoint threshold
                      threshold = (contentWidth/2).toFixed(0),
                      tipX, tipY;

                      // Set tooltip position depending on which side of threshold it falls
                      if(targetEventLeft > threshold){
                        // not sure exactly why 125 and 53 do what we need. I would have expected 150 (width of tooltip) to be minum for first here.
                        //BUT they work
                        tipX = targetEventLeft - 125;
                        tipY = targetEventTop;
                      }else {
                        tipX = targetEventRight + 53;
                        tipY = targetEventTop;
                      }

                  // define our tooltip
                  var tooltip = '<div class="tooltipevent">' + calEvent.fullTitle + '</div>';

                // Append our tooltip and apply it's positioning
                timeoutFunction = setTimeout(function() {
                  $(".calendar-directive").append(tooltip);
                    $('.tooltipevent').css('top', tipY);
                    $('.tooltipevent').css('left', tipX);

                    // Hack to temporarily disable scrollbars on BODY (sometimes triggered by tooltips)
                    $('.full-height').css('overflow-y', 'hidden');
                     }, 750);


              }// if title is longer than truncated limit

            },
            eventMouseout: function(calEvent, jsEvent, view){
              clearTimeout(timeoutFunction);
             $('.tooltipevent').remove();
             // Hack to re-enable scrollbars on BODY (see mouseover above)
             $('.full-height').css('overflow-y', 'auto');
            },
            eventDrop: function(calEvent, jsEvent, view){

                return taskDataService.getTask(calEvent.uid)
                .then(function(editedItem){
                  var lengthInMinutes = 15;
                  if(_.has(editedItem.info, 'startdate')){
                    lengthInMinutes = moment(editedItem.info.duedate).diff(editedItem.info.startdate, 'minutes');
                  }
                  // calendar.ui issue: our time zone is getting set to UTC 0 via calendar ui
                  // need to make sure time zone is in current. This does the trick.
                  var startDateFixedTimezone = moment(calEvent.start.format("YYYY-MM-DD HH:mm:SS")),
                  endDateFixedTimezone;

                  if(calEvent.end){
                    endDateFixedTimezone = moment(calEvent.end.format("YYYY-MM-DD HH:mm:SS"));
                  } else {
                    endDateFixedTimezone = moment(startDateFixedTimezone).add(lengthInMinutes, 'minutes');
                  }


                  if(!calEvent.allDay){
                      editedItem.info.startdate = moment(startDateFixedTimezone).toISOString();
                      editedItem.info.startDisplayTime = moment(startDateFixedTimezone).format('HH:mmA');
                      editedItem.info.duedate = moment(endDateFixedTimezone).toISOString();
                      editedItem.info.dueDisplayTime = moment(endDateFixedTimezone).format('HH:mmA');
                  } else {
                    editedItem.info.startdate = null;
                    editedItem.info.startDisplayTime = null;
                    editedItem.info.duedate = moment(editedItem.info.duedate).hour(vm.startOfDay).minutes(0).toISOString();
                  }

                  return taskDataService.quickUpdate(editedItem.info);
                });
            },
            eventResize: function(calEvent, jsEvent, view){
               return taskDataService.getTask(calEvent.uid)
              .then(function(editedItem){
                // calendar.ui issue: our time zone is getting set to UTC 0 via calendar ui
                // need to make sure time zone is in current. This does the trick.
                var startDateFixedTimezone = moment(calEvent.start.format("YYYY-MM-DD HH:mm:SS")),
                endDateFixedTimezone = moment(calEvent.end.format("YYYY-MM-DD HH:mm:SS"));

                // Set our start/due dates on our task
                editedItem.info.startdate = moment(startDateFixedTimezone).toISOString();
                editedItem.info.startDisplayTime = moment(startDateFixedTimezone).format('HH:mmA');
                editedItem.info.duedate = moment(endDateFixedTimezone).toISOString();
                editedItem.info.dueDisplayTime = moment(endDateFixedTimezone).format('HH:mmA');

                return taskDataService.quickUpdate(editedItem.info);
              });
            },
            dayClick: function(date, jsEvent, view) {
                // Apparently we don't need this. "Select" is being triggered as well and serves us just fine
                // vm.currentDay = date;
                // var newTask = taskDataService.newTask(undefined, 'Later');
                // newTask.info.duedate = date;
                // taskDataService.taskDialog(newTask);
              },
            select: function( start, end, jsEvent, view){
                var newTask = taskDataService.newTask();
                newTask.info.duedate = end;
                newTask.info.startdate = start;
                taskDataService.taskDialog(newTask);
            },
            eventRender: function(event, element, view) {
              // Build our event indicators depending on status and parentTemplate
              element.attr({'tooltip': event.title,
                                  'tooltip-append-to-body': true});
                     $compile(element)($scope);
              // element.attr({
              //        'tooltip': event.fullTitle,
              //        'tooltip-append-to-body': true});
              //   $compile(element)($scope);
              //   // Prepend the element to our event
                // element.prepend(el);


              var indicators = '<div class="event-indicators" layout="column"><md-tooltip>'+ event.fullTitle+'</md-tooltip>';
              // $log.info(event);
              // Add status toggle
               if(event.status == 'closed'){
                 indicators = indicators + '<md-icon class="event-checkbox" style="color:' + event.textColor + ';" md-font-icon="zmdi zmdi-check"></md-icon>';
                 $(element).addClass('event-closed');
               } else {
                indicators = indicators + '<md-icon class="event-checkbox" style="color:' + event.textColor + ';" md-font-icon="zmdi zmdi-square-o"></md-icon>';
               }



               // if recurring add recurring indicator
              if(event.recurring){
                indicators = indicators + '<md-icon class="event-recurring" style="color:' + event.textColor + ';" md-font-icon="zmdi zmdi-refresh"></md-icon>';
                // .tall ensures the height of the event accommodates both icons, even if only 1 line of text.
                $(element).addClass('tall');
              }

              // if we have a team, we should also show who's assigned to each task
              if(vm.showTeamFilter()){
                // Add assignee avatar and color
                var avatar = "/assets/images/avatars/generic-person-avatar.png";
                if(_.has(event, 'assigneeAvatar')){
                  avatar = event.assigneeAvatar;
                }

                indicators = indicators + '<img src="'+ avatar + '" class="event-avatar" style="border: 2px solid '+ event.assigneeColor + '; background-color: ' + event.assigneeColor + ';">'

              }

              //if we have a budget or time
              var includeFooter = false, footer = '<div class="event-footer" style="background-color: '+ event.backgroundColor + ';"><p>';

              if(_.has(event, 'budget')){
                if(event.budget > 0){
                  includeFooter = true;
                  var budget = $filter('userTimeFormat')(event.budget)
                  footer = footer + '<span class="event-budget"><strong>Budget:</strong> ' + budget + '</span>';
                }
              }


              if(_.has(event, 'logged')){
                if(event.logged > 0){
                    includeFooter = true;
                    var logged = $filter('userTimeFormat')(event.logged)
                    footer = footer + '<span class="event-logged"><strong>Logged:</strong> ' + logged + '</span>';
                  }
              }

             if(includeFooter){
              footer = footer + '</div>'
              indicators = indicators + footer;
             }

              // close out our indicators container tag
              indicators = indicators + '</div>'

              // compile the HTML to an element
              var el=$compile(indicators)($scope);

              // Prepend the element to our event
              element.prepend(el);

              // bind our click handler for the checkbox toggle
              element.find(".event-checkbox").bind('click', function () {
                      vm.toggleComplete(event);
                      return false;
                  });

              // bind our click handler for the checkbox toggle
              if(_.has(event, 'recurring')){
                element.find(".event-recurring").bind('click', function () {
                    vm.openTaskTemplate(event.recurring)
                    return false
                    });
              }// if has recurring

             }
        };// calendarOptions




        vm.openTaskTemplate = function(templateID){
          return taskTemplateDataService.getTaskTemplate(templateID)
             .then(function(parentTemplate){
               taskTemplateDataService.taskTemplateDialog(parentTemplate, 2);
             });
        }

        vm.toggleComplete = function(event){
          return taskDataService.getTask(event.uid)
          .then(function(editedItem){
            taskDataService.toggleComplete(editedItem.info);
          });
        }

        var prepareEvent = function(task, client){

            var shortTitle = _.truncate(task.description, {
                    'length': shortTitleLength,
                    'separator': ' '
                });

            // determine if there's a start date and what it should be
            var startDate, endDate, allDayFlag;

            if(_.has(task, 'startdate')){
                startDate = task.startdate;
                endDate = task.duedate;
                allDayFlag = false;
            } else {
                startDate = task.duedate;
                endDate = task.duedate;
                allDayFlag = true;
            }


            var clientColor = '#888', textColor = '#fff';

            if(_.has(client, 'profile.clientColor')){
              clientColor = client.profile.clientColor;
              textColor = ajUTILITIES.getContrastTextColor(clientColor);
            }


              // get the assignee info that we need
              var newAssigneeColor = "#888", newAssigneeName = task.assigneeName, newAssigneeAvatar = '/assets/images/avatars/generic-person-avatar.png';
              // Why can't we access vm.allMembers and vm.clientTeams deeply? We need to.
              _.each(vm.allMembers, function(member){
                if(member.uid == task.assignee){
                  newAssigneeColor = member.color;
                  newAssigneeAvatar = member.avatar;
                }
              });


            var newEvent = {
                title: shortTitle,
                fullTitle: task.description,
                allDay: allDayFlag,
                start: moment(startDate),
                end: moment(endDate),
                description: 'Description',
                backgroundColor: clientColor,
                borderColor: 'rgba(255,255,255,0)',
                textColor: textColor,
                uid: task.refID,
                client: task.client,
                status: task.status,
                assignee: task.assignee,
                assigneeName: newAssigneeName,
                assigneeColor: newAssigneeColor,
                assigneeAvatar: newAssigneeAvatar

            }

            if(_.has(task, 'budget')){
              newEvent.budget = task.budget;
            }

            if(_.has(task, 'logged')){
              newEvent.logged = task.logged;
            }

            if(_.has(task, 'parentTemplate')){
              newEvent.recurring = task.parentTemplate;
            }
            return newEvent
        }// prepareEvent

        function init(){

          return refreshView()
          .then(function(){
            $timeout(function(){
              // remove the default overflow inline style
              $('.fc-scroller').css('overflow', '');
              // add our no-scrollbar class
              $('.fc-scroller').addClass('no-scrollbar');
            },500);
          })

          }// init

        init();


        // View Controls
       function changeMonth(direction) {
           uiCalendarConfig.calendars['triangular-calendar'].fullCalendar(direction);
           // uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('refetchEvents');
       }

       function changeView(view) {
           $timeout(function(){
            vm.currentView = view;
            uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('changeView', view);
            userDataService.changeUserSetting('calendarView', view);
           },0);

       }

       function loadTasks(){
        return new Promise(function(resolve, reject){
            var count = 0;
            _.each(clientDataService.clients, function(client){
              var userRole = 'admin';
              if(_.has(teamDataService, 'clientTeams')){
                if(_.has(teamDataService.clientTeams, client.uid)){
                  if(_.has(teamDataService.clientTeams[client.uid], $rootScope.userID)){
                    userRole = teamDataService.clientTeams[client.uid][$rootScope.userID].role;
                  }
                }
              }

              count ++
              _.each(client.tasks, function(task){
                  var pass = true;
                  if(_.has(task, 'private')){
                    if(task.private){
                      if(userRole == 'member'){
                        pass = false;
                      }
                    }
                  }

                  if(pass && _.has(task, 'duedate') && _.has(task, 'uid') && task.status == 'open'){
                    if(!task.snooze || (task.snooze && vm.snoozeFilter)){
                      var newEvent = prepareEvent(task, client);
                      if(vm.filterOption == 'all'){
                        vm.eventSources[0].events.push(newEvent);
                      } else if (vm.filterOption.uid == newEvent.assignee){
                          vm.eventSources[0].events.push(newEvent);
                      }
                    }
                  }

              });
              if(count == _.size(clientDataService.clients)){
                return resolve(true);
              }
          });
        })
       }//loadTasks

       function refreshView(view){
        $timeout(function(){vm.loading = true;});
        // save view so it can be restored
        var thisView = vm.currentView;
          return new Promise(function(resolve, reject){
            // clear events (without removing vm.eventSources binding)
            // delayed with timeout so our animation has time to kick in before the calendar hangs the gui
            if(_.size(uiCalendarConfig.calendars) > 0){
              uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('removeEvents')
              vm.eventSources[0].events.splice(0);
              return loadTasks()
                .then(function(){
                  $timeout(function(){
                    uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('changeView', thisView);
                    $timeout(function(){vm.loading = false;});
                    return resolve(true);
                  })
                })
            } else {
              return loadTasks()
              .then(function(){
                $timeout(function(){
                  uiCalendarConfig.calendars['triangular-calendar'].fullCalendar('changeView', thisView);
                  $timeout(function(){vm.loading = false;});
                  return resolve(true)
                }, 0)
              })
            }
          })
       }// refreshView



       function newTask() {
             // console.log('newTask from Fab');
             var userID = userDataService.user.uid;
             // $log.info(userID);

              var clientID = null;

               // if we are on a client page and passed a Client ID, prepopulate our client info
               if ($stateParams.clientID){
                // $log.info('new task for client' + $stateParams.clientID);
                clientID = $stateParams.clientID;
               }

               var editedItem = taskDataService.newTask(clientID, 'Later');
               // $log.info($scope);
               // Set our dialogTitle
               var dialogTitle = "New";
               // console.log($scope.editedItem);
               taskDataService.taskDialog(editedItem);
         }// newTask

        // Watch for external updates and update the appropriate event
        var unwatchUpates = $rootScope.$on('taskUpdated',function(event, task) {
            // $log.info('change detected updating corresponding event');
             // isolate event related to this task
             var thisEvent = _.find(vm.eventSources[0].events, function (event) {
                 return event.uid == task.refID;
             });

             if(_.has(task, 'startdate')){
               thisEvent.start= moment(task.startdate);
             }

             thisEvent.status = task.status;
             thisEvent.end= moment(task.duedate);

             // event will only re-render if the title is modified
             // thus the two steps here
             thisEvent.title = "";
             $timeout(function(){
              thisEvent.title= task.description;
              thisEvent.budget = task.budget;
              thisEvent.logged = task.logged;
             },0);

             // refreshView();

       });// on taskUpdated

         var unwatchNew = $rootScope.$on('taskSaved',function(event, task) {
             // $log.info('New task saved.  Adding event');
             var thisClient = _.find(vm.clients, function(client){
                return client.uid == task.client;
             });
             var newEvent = prepareEvent(task, thisClient);
             vm.eventSources[0].events.push(newEvent);
             // refreshView();
        });// on taskUpdated

       $scope.$on('$destroy', function() {
           unwatchUpates();
           unwatchNew();
       });

       ///////// Filterbar Logic ///////////
       vm.showTeamFilter = function(){
        if (_.size(vm.allMembers) > 1){
            return true
        }
       }

       vm.resetFilter = function(){
           vm.filterOption = 'all';
       }

       vm.filterUser = function(option){
        refreshView();

       }// filterUser
       vm.closeFilterBar = function(){
           $timeout(function(){
              vm.showFilterBar = false;
           },100);
       }

       vm.resetTaskSearch = function(){
           $timeout(function(){
               vm.taskSearchQuery = "";
           },0);
       }



    }
})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/calendar');

        $stateProvider.state('triangular.calendar', {
            // set the url of this page
            url: '/calendar',
            // set the html template to show on this page
            templateUrl: 'app/calendar/calendar.tmpl.html',
            // set the controller to load for this page
            controller: 'CalendarController',
            controllerAs: 'vm',
            resolve: {
                '_teams': ['teamDataService', function (teamDataService) {
                        return teamDataService.getUsersTeams()
                                .then(function (data) {
                                    return data
                                })
                    }]
                }
        });

        triMenuProvider.addMenu({
            // give the menu a name to show (should be translatable and in the il8n folder json)
            name: 'Task Schedule',
            // point this menu to the state we created in the $stateProvider above
            state: 'triangular.calendar',
            // set the menu type to a link
            type: 'link',
            // set an icon for this menu
            icon: 'zmdi zmdi-calendar-alt',
            // set a proirity for this menu item, menu is sorted by priority
            priority: 8.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('calendar')
        .controller('CalendarFabController', CalendarFabController);

    /* @ngInject */
    function CalendarFabController($rootScope) {
        var vm = this;
        vm.addEvent = addEvent;

        ////////////////

        function addEvent($event) {
            $rootScope.$broadcast('addEvent', $event);
        }
    }
})();

(function(){
	'use strict';
	angular.module('appServices')
	.service('toastService', ['$rootScope', '$document', '$mdToast', function($rootScope,$document, $mdToast) {
		return {
			toast: function(msg){
				// console.log('toastservice: ' + msg);
				$mdToast.show($mdToast.simple().textContent(msg));
				// $mdToast.simple().content(msg);
			}
		};
	}])
})();

(function(){
	'use strict';
	angular.module('appServices')
	.service('templateDataService', templateDataService);

	templateDataService.$inject = ['$http'];

	function templateDataService($http) {
		var service = {
			getTemplates: getTemplates,
			getTemplate: getTemplate,
			addTemplate: addTemplate,
			removeTemplate: removeTemplate,
			updateTemplate: updateTemplate
		};

		return service;

		function getTemplates() {
			return $http.get('/assets/app-sample-data/templates.json')
	           .then(getTemplatesComplete)
	           .catch(getTemplatesFailed);

	       function getTemplatesComplete(response) {
	           return response.data;
	       }

	       function getTemplatesFailed(error) {
	           logger.error('XHR Failed for getTemplates.' + error.data);
	       }
		};// End getTemplates

		function getTemplate() {};// end getTemplate
		function addTemplate() {};// end addTemplate
		function removeTemplate() {};// end removeTemplate
		function updateTemplate() {};// end updateTemplate

	};



	})
();



// (function(){
// 	'use strict';
// 	angular.module('appServices')
// 	.factory('$exceptionHandler',
// 	          ['$window', '$log', '$injector',
// 	  function ($window,  $log, $injector) {

// 		// Putting the injecting into a function so it can be called lazily and avoid circular references
// 		// http://stackoverflow.com/questions/33463300/angular-circular-dependency-injector-whie-trying-inject-modal-to-exception-ha?noredirect=1&lq=1

// 	    if ($window.Raven && location.hostname != "localhost") {
// 	      // console.log('Using the RavenJS exception handler.');
// 	      // var Auth = $injector.get('Auth');
// 	      return function (exception, cause) {
// 	        $log.error.apply($log, arguments);
// 	        Raven.captureException(exception, {tags: { cause: cause }});
// 	      };
// 	    } else {
// 	      // console.log('Using the default logging exception handler.');
// 	      return function (exception, cause) {
// 	        $log.error.apply($log, arguments);
// 	      };
// 	    }
// 	  }
// 	]);

// })();

(function() {
    'use strict';

    angular.module('appServices')
		.service('rrule', rruleService)

/* @ngInject */
function rruleService($window) {
  if(!$window.rrule){
    // If lodash is not available you can now provide a
    // mock service, try to load it from somewhere else,
    // redirect the user to a dedicated error page, ...
  }
  return $window.rrule
}

})();

(function(){
	'use strict';
	angular.module('appServices')
	/* @ngInject */
	.service('pageDimensionsService', function($window, triLoaderService, $timeout, $log, $state) {
		return {
			resizeColumns: function(mode){

				var gridContainer = $('.time-grid-page-container');
				if(gridContainer){
					var containerWidth = $(gridContainer).outerWidth(true),
					containerHeight = $(gridContainer).height()-80;
					// $log.info('width: ' + containerWidth);
					// $log.info('height: ' + containerHeight);
					// $('.timeGrid').css('height', containerHeight + 'px');
					// $('.timeGrid').css('width', containerWidth - 40 + 'px');
					// // $('.timeGrid').find('.ui-grid-viewport').css('height', containerHeight + 'px');
					// $('.timeGrid').find('.ui-grid-canvas').css('width', containerWidth + 'px');
				}


				// Place it in a $timeout so we don't execute the script before the DOM is ready
				    var setWidth = function() {
				    	var containers = $('.app-item-container-items');
				    	// cycle through our containers and resize them to accommodate if they have children
				    	angular.forEach(containers, function(container) {
				        // If we have children,
				        //Calculate parent's newWidth based on the lasChild's position and width
				        if ($(container).find('md-card').length){
					        	// Get the last child in the set to determine how large the
					        	// parent container should be
					        	var lastChild = $(container).children().last();
						     var newWidth = lastChild.position().left + lastChild.outerWidth(true) - 2;
					        // Set the width
					        if(newWidth > 200){
					        	$(container).width(newWidth);
					        } else {
					        	$(container).width('auto');
					        }

				        }
				        // console.log('Width Changed');
				    	});
				    };

		    		    var setHeight = function() {
		    		    		var w = angular.element($window),
		    		    			removeHeight = 100;

		    		    	   removeHeight = removeHeight + $('md-toolbar').height();

		    		    	   // if we are managing team members, we need a different removeHeight
		    		    	   if($state.current.name == 'triangular.manage-team'){
		    		    	   	removeHeight = removeHeight - 49;
		    		    	   }

		    		    	   // adjust our height for Today panels
		    		    	   if($state.current.name == 'triangular.today'){
		    		    	   	removeHeight = removeHeight + 22;
		    		    	   }

		    		    	   // adjust our height for Today panels
		    		    	   if($state.current.name == 'triangular.workspaces.information'){
		    		    	   	removeHeight = removeHeight - 29;
		    		    	   }


		    		    	   if($state.current.name != 'triangular.time-reports' && $state.current.name != 'triangular.workspaces.time'){
    	   	        		        var containers = $('.app-item-container-items');
    	   		    	    		    angular.forEach(containers, function(container){
    	   		    	    				$(container).css('height', (w.height() - removeHeight) + 'px');
    	   		    	    				// make sure our client cards aren't more than 50% of viewport
    	   		    	    				$(container).find('md-card.client-card').find('md-card-content').css('max-height',(w.height()/2.5)+'px');
    	   		    	    		    });
		    		    	   } else if ($state.current.name != 'triangular.dashboard'){
	   	        		        var containers = $('.app-item-container');
	   		    	    		    angular.forEach(containers, function(container){
	   		    	    				$(container).css('height', (w.height() - removeHeight) + 'px');
	   		    	    		    });
		    		    	   }

		    		    };
				$timeout(function() {
					// $log.info('resize');
					// We don't want to be resizing today panel on dashboard
					if ($state.current.name != 'triangular.dashboard'){
						setHeight();
						if(mode != 'vertical'){
							setWidth();
						}
					}



				}, 250); // end our $timeout function

			}// resizeColumns



		};

	})
})();

(function() {
    'use strict';
    angular.module('appServices')
        .service('fbService', fbService);

    /* @ngInject */
    function fbService($log, $http, $firebaseArray, $firebaseAuth, $firebaseObject, authFactory, $mdToast) {
       var service = {
              };

       return service;

       }// fbService




})
();

 (function() {
     'use strict';
     angular.module('appServices')
     .factory('authFactory', authFactory)

     /* @ngInject */
     function authFactory ($firebaseAuth){
     	// console.log('Auth factory called. authData is:');
     	// console.log($firebaseAuth().$getAuth());
         return $firebaseAuth();
       }

})();

(function() {
    'use strict';

    angular
        .module('bry', []);
})();

(function() {
    'use strict';

    angular
        .module('bry')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/bry');

        $stateProvider
            .state('triangular.bry-page', {
                url: '/bry/bry-page',
                templateUrl: 'app/bry/bry-page.tmpl.html',
                // set the controller to load for this page
                controller: 'bryPageController',
                controllerAs: 'vm'
            });

        triMenuProvider.addMenu({
            name: "Bry's Place",
            icon: 'zmdi zmdi-airline-seat-recline-extra',
            type: 'link',
            state: 'triangular.bry-page',
            priority: 100.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bry')
        .controller('bryPageController', bryPageController)
        // bryPageController.$inject = ['$rootScope', '$scope', 'localStorageService']


    /* @ngInject */
    function bryPageController($http, $log, $timeout, angularLoad, localStorageService, $state, clientDataService, $filter, firebase, $firebaseArray, $firebaseObject, $rootScope, $scope, userDataService, taskDataService, timeDataService, _userData) {
        var vm = this;
        vm.fbConfig = fbConfig;
       vm.user = _userData;
       vm.count = 0;
       vm.pageCount = 0;
       vm.users = undefined;
       vm.processing = false;
       vm.loginAs = loginAs;
       vm.clients = []; vm.promises = [];
       vm.secret = {
        label: '',
        value: '',
        uid: undefined
       };
       vm.upgrading = {};

       function loginAs(user){
        var ghost = {
          email: user.email,
          uid: user.uid
        }
        localStorageService.set('ghostUser', ghost)
        $state.go('triangular.dashboard');
        location.reload();
       }// vm.ghostThisuser

       vm.playUserPilotExperience = function(ID){
        $log.info('Play userPilot Experience: ' + ID);
        userpilot.trigger(ID);
       }//

       vm.loadClients = function(user){
        vm.clients = []; vm.promises = [];
        vm.selectedUser = user;
        $log.info('loadClients');
        _.each(user.clients, function(value, key){
          vm.promises.push(addClient(key))
        });

        return Promise.all(vm.promises)
       }//loadClients

       function addClient(clientID){
        return new Promise(function(resolve, reject){
          $log.info('addClient: ' + clientID);
          firebase.database().ref('/clients/' + clientID).once('value', function(snapshot){
            if(snapshot.exists()){
              var thisClient = snapshot.val();
              $log.info('received: ' + thisClient.profile.fullName);
              if(thisClient.owner == vm.selectedUser.uid){
                vm.clients.push(thisClient);
                return resolve
              } else {
                $log.info('not owner skipping');
                return resolve
              }
            }
          ;})
        })
       }

       vm.clientCount = function(user){
        return _.size(user.clients);
       }

       vm.upgradeClient = function(client){
        $timeout(function(){
          vm.upgrading[client.uid] = true;
        })
        .then(function(){
          $timeout(function(){
            $log.info('faking promise');
          }, 2000)
          .then(function(){
            $timeout(function(){
              vm.upgrading[client.uid] = false;
            })
          })
        });

       }//upgradeClient

            var pageSize = 50;
           var objectsRef = firebase.database().ref('/users').orderByChild('sessionCount').limitToLast(pageSize);

            var paginate = function(cursor) {
              vm.clients = []; vm.promises = [];
                  vm.pageCount = vm.pageCount + 1;
                  $log.info('Page ' + vm.pageCount);
                  var paginatedRef = objectsRef;
                  if (cursor) {
                    paginatedRef = objectsRef.endAt(cursor);
                  }
                  return paginatedRef.once('value').then(function(snap){
                   return snap.val()
                  });
            }


            var paginateObjects = function(cursor) {
              vm.pageCount = vm.pageCount + 1;
              $log.info('Page ' + vm.pageCount);
              var paginatedRef = objectsRef;
              if (cursor) {
                paginatedRef = objectsRef.endAt(cursor);
              }
              return paginatedRef.once('value').then(function(snap){
               return snap.val()
              });
            }

            vm.processAllObjects = function(cursor) {
                $timeout(function(){
                  vm.processing = true;
                },0);
               vm.userCount = 0;
               vm.theseObjects = [];
              return paginateObjects(cursor).then(function(objects) {
                 var orderedKeys = Object.keys(objects).sort(function(a,b){return a - b});
                 vm.cursor = orderedKeys[0];
                 // $timeout(function(){vm.loaded = false;},0);
                 _.each(objects, function(object){
                  // put in conditions to push to interface
                      vm.theseObjects.push(object);
                 });// each object in page
                 $timeout(function(){
                   vm.processing = false;
                 },0);
             });// return paginate
           } // processAllTime

           vm.nextPage = function(cursor){
               $log.info('next page requested');
               return vm.processAllObjects(cursor);
           }

           vm.start = function(){
               $log.info('start requested');
               return vm.processAllObjects();
           }
////////////////////


          vm.deleteAll = function(){
           $timeout(function(){
             vm.processing = true;
           },0);
           $log.info('about to delete ' + _.size(vm.theseObjects));
           var updates = {};
           _.each(vm.theseObjects, function(object){
             updates['/pdfRequests/' + object.uid] = null
           });
           return firebase.database().ref().update(updates)
           .then(function(){
             $timeout(function(){
               vm.processing = false;
               vm.theseObjects = [];
             },0);
           })
          }

           vm.fixSchedule = function(client){
            var updates = {};
            updates['/schedules/' + client.profile.weeklyStatusReport.scheduleID] = null;
            updates['/clients/' + client.uid + '/schedules'] = null;
            updates['/clients/' + client.uid + '/profile/weeklyStatusReport'] = null;

            return firebase.database().ref().update(updates)
            .then(function(){
              alert('fixed');
            })
           }

           vm.fixSub = function(user){
                $log.info('fixSub');
                $log.info(user);
                var userRef = firebase.database().ref('users/' + user.uid + '/plan/content__subscription__status');
                userRef.set(user.subscriptionStatus);
                //  _dcq.push(["identify", {
                //   email: user.email,
                //   tags: ["change-to-" + user.subscriptionStatus]
                // }]);
           }

           // vm.getSubs = function(users){
           //     $log.info('getSubs');
           //     $log.info(ChargeBee);
           //     _.each(users, function(user){
           //      if(_.has(user.plan, 'content__subscription__id')){
           //          ChargeBee.subscription.retrieve(user.plan.content__subscription__id).request(function(error,result) {
           //            if(error){
           //              //handle error
           //              console.log(error);
           //            }else{
           //              console.log(result);
           //              var subscription = result.subscription;
           //              $log.info(subscription);
           //              // var customer = result.customer;
           //              // var card = result.card;
           //            }
           //          });
           //      }// if has planID
           //     });// each user
           // }


           vm.editSecret = function(secret){
            $log.info(secret);
            $log.info(vm.secret);
            vm.secret.label = secret.label;
            vm.secret.value = 'New Secret Value';
            vm.secret.uid = secret.uid;
            vm.editingSecret = true;
           }//editSecret

           vm.updateSecret = function(secret){
            return new Promise(function(resolve, reject){
              var endpoint = firebase.functions().httpsCallable('secrets'),
                  request = {
                    action: 'updateSecret',
                    secretID: secret.uid,
                    value: secret.value
                  }

              return endpoint(request)
              .then(function(results){
                $timeout(function(){
                  vm.secret.value = '';
                  vm.secret.label = '';
                  vm.secret.uid = '';
                  vm.editingSecret = false;
                })
                 return resolve(true);
              })
              .catch(function(error){
                 $log.info('error');
                 $log.info(error);
                 return reject(error)
              })
            })
           }//updateSecret

           vm.createSecret = function(userSecret){
            return new Promise(function(resolve, reject){
              var secretID = firebase.database().ref().child('users/' + vm.user.uid + '/secrets').push().key;
              userSecret.uid = secretID;
              userSecret.created = moment().toISOString();
              var endpoint = firebase.functions().httpsCallable('secrets'),
                  request = {
                    action: 'createSecret',
                    secretID: secretID,
                    value: userSecret.value
                  }

              return endpoint(request)
              .then(function(results){
                 delete userSecret.value
                 var updates = {};
                 updates['/users/' + vm.user.uid + '/secrets/' + userSecret.uid] = userSecret;
                 return firebase.database().ref().update(updates)
                 .then(function(results){
                  vm.secret.value = '';
                  vm.secret.label = '';
                  vm.secret.uid = '';
                  return resolve(true)
                 })
                 .catch(function(error){
                  $log.info('error');
                  $log.info(error);
                  return reject(error)
                 })

              })
              .catch(function(error){
                 $log.info('error');
                 $log.info(error);
                 return reject(error)
              })
            })


           }//createSecret

           vm.getSecret = function(secretID){
            $log.info('getSecret');
            var endpoint = firebase.functions().httpsCallable('secrets'),
                request = {
                  action: 'getSecret',
                  secretID: secretID
                }
                $log.info(request);
                return endpoint(request)
                .then(function(results){
                  $log.info(results);
                   alert(results.data);
                 });
           }

           vm.deleteSecret = function(secretID){
            return new Promise(function(resolve, reject){
              var endpoint = firebase.functions().httpsCallable('secrets'),
                  request = {
                    action: 'deleteSecret',
                    secretID: secretID
                  }
                  return endpoint(request)
                  .then(function(results){
                     var updates = {};
                     updates['/users/' + vm.user.uid + '/secrets/' + secretID] = null;
                     return firebase.database().ref().update(updates)
                     .then(function(results){
                      return resolve(true)
                     })
                     .catch(function(error){
                      $log.info('error');
                      $log.info(error);
                      return reject(error)
                     })
                   })
            })
           }//deleteSecret

           vm.getToken = function(){
            firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
              vm.token = idToken;
            }).catch(function(error) {
              alert(error);
            });
           }// getToken

           // get our subscription data import from chargebee (converted to json)


           // $http.get('assets/app-sample-data/subscriptions.json').success(function(data) {
           //      // $log.info(data);
           //     vm.subscriptions = data;
           //     // $log.info('Subscriptions loaded');
           //     // $log.info(vm.subscriptions);
           //     vm.loaded = true;
           // });






    }
})();

(function() {
    'use strict';

    angular
        .module('app.authentication')
        .config(moduleConfig)
        .run(authenticationRun);


    /* @ngInject */
    function authenticationRun($rootScope){
        var topRange = 5,
            bottomRange = 1;

        // Pick a random number and use it to set our rotating background class on auth pages
        var random = Math.floor(Math.random() * ((topRange-bottomRange)+1) + bottomRange);
        // $rootScope.authBackground = "mb-bg-12"
        $rootScope.authBackground = "mb-bg-" + random;
        // console.log('Auth: ' + $rootScope.authBackground);
    }

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/app-authentication');

        $stateProvider
        .state('authentication', {
            abstract: true,
            views:{
                'root':{
                    templateUrl: 'app/app-authentication/layouts/authentication.tmpl.html'
                }
            }

            // url: '/authentication'
        })
        .state('authentication.login', {
            url: '/login',
            templateUrl: 'app/app-authentication/login/login.tmpl.html',
            controller: 'LoginController',
            controllerAs: 'vm'
        })
        .state('authentication.registration', {
            url: '/registration/:planID/:inviteID/:couponID',
            templateUrl: 'app/app-authentication/registration/registration.tmpl.html',
            controller: 'registrationController',
            controllerAs: 'vm',
            params: {
                    planID: {squash: true, value: null},
                    inviteID: {squash: true, value: null},
                    couponID: {squash: true, value: null}
                }
        })
        .state('authentication.confirmation', {
            url: '/confirmation',
            templateUrl: 'app/app-authentication/registration/registration.confirmation.tmpl.html',
            controller: 'confirmationController',
            controllerAs: 'vm'
        })

        .state('authentication.legal', {
            url: '/legal',
            templateUrl: 'app/app-authentication/legal/legal.tmpl.html',
            controller: 'legalController',
            controllerAs: 'vm'
        })
        .state('authentication.forgot', {
            url: '/forgot',
            templateUrl: 'app/app-authentication/forgot/forgot.tmpl.html',
            controller: 'ForgotController',
            controllerAs: 'vm'
        })
        .state('authentication.change-email', {
            url: '/change-email',
            templateUrl: 'app/app-authentication/change-email/change-email.tmpl.html',
            controller: 'changeEmailController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })
        // .state('authentication.signup', {
        //     url: '/signup',
        //     templateUrl: 'app/app-authentication/signup/signup.tmpl.html',
        //     controller: 'SignupController',
        //     controllerAs: 'vm'
        // })
        .state('authentication.profile', {
            url: '/profile/:selectedTab',
            templateUrl: 'app/app-authentication/profile/profile.tmpl.html',
            controller: 'profileController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 _userData: ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        console.log('have user');
                        return data
                   })
                }]
            }
        })
        .state('authentication.cancel', {
            url: '/cancel',
            templateUrl: 'app/app-authentication/cancel/cancel.tmpl.html',
            controller: 'cancelController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }
        })
        .state('authentication.subconfirmation', {
            url: '/subconfirmation',
            templateUrl: 'app/app-authentication/subscription-confirmation/subscription-confirmation.tmpl.html',
            controller: 'subConfirmController',
            controllerAs: 'vm'
        })

        .state('authentication.lock', {
            url: '/lock',
            templateUrl: 'app/app-authentication/lock/lock.tmpl.html',
            controller: 'LockController',
            controllerAs: 'vm'
        })


        // triMenuProvider.addMenu({
        //     name: 'MENU.AUTH.AUTH',
        //     icon: 'zmdi zmdi-key',
        //     type: 'dropdown',
        //     // open: 'false',
        //     priority: 25.1,
        //     children: [{
        //         name: 'MENU.AUTH.LOGIN',
        //         state: 'authentication.login',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.SIGN_UP',
        //         state: 'authentication.signup',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.FORGOT',
        //         state: 'authentication.forgot',
        //         type: 'link'
        //     },{
        //         name: 'MENU.AUTH.LOCK',
        //         state: 'authentication.lock',
        //         type: 'link'
        //     }]
        // });

        // triMenuProvider.addMenu({
        //    name: 'Logout',
        //    icon: 'zmdi zmdi-lock-open',
        //    state: 'authentication.login',
        //    type: 'logout',
        //    priority: 25
        // })
    }
})();

(function() {
    'use strict';

    angular
        .module('appFilters', ['ngSanitize']);
})();

(function() {
    'use strict';

    angular
        .module('appFilters')
           .filter('ordinal', function() {

          // Create the return function
          // set the required parameter name to **number**
          return function(number) {

            // Ensure that the passed in data is a number
            if(isNaN(number) || number < 1) {

              // If the data is not a number or is less than one (thus not having a cardinal value) return it unmodified.
              return number;

            } else {

              // If the data we are applying the filter to is a number, perform the actions to check it's ordinal suffix and apply it.

              var lastDigit = number % 10;

              if(lastDigit === 1) {
                return number + 'st'
              } else if(lastDigit === 2) {
                return number + 'nd'
              } else if (lastDigit === 3) {
                return number + 'rd'
              } else if (lastDigit > 3) {
                return number + 'th'
              }

            }
          }
        }) // ordinal filter

        // Hours and Minutes filter
        // Give him minutes, he'll return pa proerly formatted (-)00:00 for it.
           .filter('HandM', function() {
          return function(number) {

           // if our grid aggregate is passing this value it includes "total: ". Let's make sure we remove it.
           if (typeof number == 'string'){
            number = number.replace('total: ','');
            number = Number(number);
           }

              // we'll need this later
              var isNegative = false;
              if (number < 0){
                isNegative = true;
              }

              // convert to an integer so we aren't doing a floor/ceiling dance
              number = Math.abs(number);

              var hours = Math.floor( number / 60);
              hours = _.toString(hours);
              // we don't pad our hours. They may go into 3 digits for some users.

              var minutes = (number % 60).toFixed(0);
              minutes = _.toString(minutes);
              minutes = _.padStart(minutes, 2, '0');

              // set our return object
              var duration = hours;

              // if we have minutes, add them. Otherwise, 00
               if (minutes){

                // Removed - it was taking 2 digit minutes (prepared above) and converting to 1 digit.
                // minutes = Math.abs(minutes);
                duration = duration + ':' + minutes;
               } else {
                duration = duration + ':' + '00';
               }

               // if it was a negative number, prepend it
               if (isNegative){
                duration = '-' + duration;
               }

               return duration
          }
        })

        // Months to Date this year Filter
        // @ngInject //
          .filter('monthsToDate', function($log) {
         // Create the return function
         return function(months) {
          var now = new Date(),
              thisMonth = now.getMonth() + 1,
              results = [];

          _.each(months, function(month){
            if (thisMonth >= month.month)
            {
              results.push(month);
            }
          });// end each months

          return results;
         }
       }) // Months to Date Filter

         // thisMonth Filter
         // @ngInject //
           .filter('thisMonth', function($log) {
          // Create the return function
          return function(timeLogs, viewMonth) {
           var results = [];
           _.each(timeLogs, function(entry){
            // convert to integer to ensure matching works correctly
            var entryMonth = parseInt(entry.month);
             if (entryMonth == viewMonth)
             {
               results.push(entry);
             }
           });// end each months
           return results;
          }
        }) // thisMonth filter

       // isInWeek Filter
       // @ngInject //
         .filter('isInWeek', function($log) {

        // Create the return function
        return function(input, currentWeek) {

          var results = [];
          _.each(input, function(entry){

           // convert to integer to ensure matching works correctly
           var entryWeek = parseInt(entry.week);
            if (entryWeek === currentWeek)
            {
              results.push(entry);
            }
          });// end each months
          return results;
        }
      }) // isInWeek filter

     .filter('userTimeFormat', ['userDataService', '$log', '$rootScope', function(userDataService, $log, $rootScope) {
         return function(number) {

              // True = Decimal
              // False = Hours and Minutes (default)

              // First, check for the setting. False as default if no setting.
              var timeFormat = false;
              if(_.has($rootScope, 'userSettings.timeFormat')){
                timeFormat = $rootScope.userSettings.timeFormat;
              }

              number = Number(number);

              if(number){

                if(timeFormat){


                  // Decimal
                  var decimalResult = number / 60;


                  return decimalResult.toFixed(2)

                } else {
                  // Hours and Minutes
                  // we'll need this later
                  var isNegative = false;
                  if (number < 0){
                    isNegative = true;
                  }
                  // convert to an integer so we aren't doing a floor/ceiling dance
                  number = Math.abs(number);

                  var hours = Math.floor( number / 60);
                  hours = _.toString(hours);
                  // we don't pad our hours. They may go into 3 digits for some users.

                  var minutes = Math.round(number % 60);
                  minutes = _.toString(minutes);
                  minutes = _.padStart(minutes, 2, '0');

                  // set our return object
                  var duration = hours;

                  // if we have minutes, add them. Otherwise, 00
                   if (minutes){
                    duration = duration + ':' + minutes;
                   } else {
                    duration = duration + ':' + '00';
                   }

                   // if it was a negative number, prepend it
                   if (isNegative){
                    duration = '-' + duration;
                   }

                   return duration
                }
            } else {
              return '00:00'
            }// if valid number
           }
         }])
      .filter('groupByProp', function(){
        return function(list, group_by) {

        var filtered = [];
        var prev_item = null;
        var group_changed = false;
        // this is a new field which is added to each item where we append "_CHANGED"
        // to indicate a field change in the list
        var new_field = group_by + '_CHANGED';

        // loop through each item in the list
        angular.forEach(list, function(item) {

          group_changed = false;

          // if not the first item
          if (prev_item !== null) {

            // check if the group by field changed
            if (prev_item[group_by] !== item[group_by]) {
              group_changed = true;
            }

          // otherwise we have the first item in the list which is new
          } else {
            group_changed = true;
          }

          // if the group changed, then add a new field to the item
          // to indicate this
          if (group_changed) {
            item[new_field] = true;
          } else {
            item[new_field] = false;
          }

          filtered.push(item);
          prev_item = item;

        });

        return filtered;
        };
      });

})();

(function() {
    'use strict';

    angular
        .module('appFilters')
        .filter('toTrusted', function ($sce) {
            return function (value) {
                return $sce.trustAsHtml(value);
            }
          })
        .filter('removeHTMLTags', function() {
            return function(text) {
                return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
            };
        })
        .filter("reverseGroupBy",["$parse","$filter",function($parse,$filter){
        //https://embed.plnkr.co/plunk/gZhSIa
          return function(array, groupByField){
            var result  = [];
                    var prev_item = null;
                    var groupKey = false;
                    var filteredData = $filter('orderBy')(array, '+'+groupByField);
                    for(var i=0;i<filteredData.length;i++){
                      groupKey = false;
                      if(prev_item !== null){
                        if(prev_item[groupByField] !== filteredData[i][groupByField]){
                          groupKey = true;
                        }
                      } else {
                        groupKey = true;
                      }
                      if(groupKey){
                        filteredData[i]['group_by_key'] =true;
                      } else {
                        filteredData[i]['group_by_key'] =false;
                      }
                      result.push(filteredData[i]);
                      prev_item = filteredData[i];
                    }
                    return result;
          }
        }])
        .filter("groupBy",["$parse","$filter",function($parse,$filter){
        //https://embed.plnkr.co/plunk/gZhSIa
          return function(array, groupByField){
            var result  = [];
                    var prev_item = null;
                    var groupKey = false;
                    var filteredData = $filter('orderBy')(array, groupByField);
                    for(var i=0;i<filteredData.length;i++){
                      groupKey = false;
                      if(prev_item !== null){
                        if(prev_item[groupByField] !== filteredData[i][groupByField]){
                          groupKey = true;
                        }
                      } else {
                        groupKey = true;
                      }
                      if(groupKey){
                        filteredData[i]['group_by_key'] =true;
                      } else {
                        filteredData[i]['group_by_key'] =false;
                      }
                      result.push(filteredData[i]);
                      prev_item = filteredData[i];
                    }
                    return result;
          }
        }])
        //    .filter('ordinal', function() {

        //   // Create the return function
        //   // set the required parameter name to **number**
        //   return function(number) {

        //     // Ensure that the passed in data is a number
        //     if(isNaN(number) || number < 1) {

        //       // If the data is not a number or is less than one (thus not having a cardinal value) return it unmodified.
        //       return number;

        //     } else {

        //       // If the data we are applying the filter to is a number, perform the actions to check it's ordinal suffix and apply it.

        //       var lastDigit = number % 10;

        //       if(lastDigit === 1) {
        //         return number + 'st'
        //       } else if(lastDigit === 2) {
        //         return number + 'nd'
        //       } else if (lastDigit === 3) {
        //         return number + 'rd'
        //       } else if (lastDigit > 3) {
        //         return number + 'th'
        //       }

        //     }
        //   }
        // }) // ordinal filter



})();



(function() {
    'use strict';

    angular
        .module('adminToday', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('adminToday')
        .controller('adminTodayController', adminTodayController);

    /* @ngInject */
    function adminTodayController($log, $rootScope, triLoaderService, teamDataService, taskDataService, $timeout, dragulaService, taskPanelDataService, pageDimensionsService, userDataService, $scope, $firebaseArray, clientDataService, _userData, _clientData) {
        // $log.info('adminTodayController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;
        vm.settings = $rootScope.userSettings;
        vm.user = _userData;
        vm.collapseCards = vm.settings.collapseCards;
        vm.now = moment().toISOString();
        vm.groupTodayByClients = false;
        // If we don't have a groupToday setting, make one
        if (_.has(vm.settings, 'groupToday')){
         vm.groupTodayByClients = vm.settings.groupToday;
          // vm.user.profile.settings.groupToday = false;
        };

        vm.clientLimit = 1;

        vm.teamList = teamDataService.allMembers;

        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }


        $timeout(function(){
            vm.clients = $scope.$resolve.clientDataService.clients;
            if(_.size(vm.clients) > 0){
                vm.hasClients = true;
                // setupAllTasks();
            } else {vm.hasClients = false}

        },0);


        // Setup filterbar stuff
        vm.snoozeFilter = true;
        vm.filterOption = 'all';

        if(_.has(vm.user, 'profile.settings.defaultAllTaskSort')){
                vm.sortOption = vm.user.profile.settings.defaultAllTaskSort;
        } else {
            vm.sortOption = 'allOrder';
        }


        // Watch for completion of initial paint and turn off loader when done
          var digestObserverValue = 0, digestObserverHandledValue  = -1;
          var onBeforePaint = function() {
              // Called before painting
              digestObserverValue++; // Prepare for the next digest
              // $(document.body).trigger("paint.ng");
              // $log.info('painting');
              setTimeout(function() {
                  // Called almost right after painting
                  triLoaderService.setLoaderActive(false);
              }, 1000);
          };
          $scope.$watch(function() {
              // Called on every digest.
              if( digestObserverHandledValue  !== digestObserverValue ) {
                  // Executed only once per multiple sequential digest cycles (until $evalAsync and later
                  // timeout/animation handlers are called).
                  digestObserverHandledValue = digestObserverValue;
                  $scope.$evalAsync(function() {
                      // Called after at least single digest cycle is finished, but before rendering.
                      if( "requestAnimationFrame" in window ) {
                          // Get onBeforePaint() called right before DOM styles are calculated and page is
                          // painted.
                          requestAnimationFrame(onBeforePaint);
                      }
                      else {
                          // For older browser compatibility: get onBeforePaint() called before painting
                          // when javascript engine finishes executing the current thread code and starts
                          // handling expired timers (0ms timeout).
                          setTimeout(onBeforePaint, 0);
                      }
                  });
              }
              return digestObserverValue;
          }, function() {});




        vm.changeSort = function(value){
            userDataService.changeUserSetting('defaultAllTaskSort', value);
            userDataService.getLoggedInUser();

        }

        vm.toggleCardCollapse = function(value){
            // make sure we bind it if it wasn't before (no setting state)
            userDataService.changeUserSetting('collapseCards', value);
            userDataService.getLoggedInUser();
            $timeout(function(){
                vm.collapseCards = vm.settings.collapseCards;
                // resize our columns
                if (!vm.verticalTaskPanels){
                      pageDimensionsService.resizeColumns();
                } else {
                      pageDimensionsService.resizeColumns('vertical');
                }
            }, 200);
        }// toggleCardCollapse

        vm.closeFilterBar = function(){
            $timeout(function(){
               vm.showFilterBar = false;
            },0);
        }


      // This filter makes sure the Client in question is in this list
      $scope.limitOwned = function(client, index) {
        if(_.find(vm.clients, function(o) { return o.uid == client.uid;})){
          return true
        };
      };


      vm.filterUser = function(option){
       if(option != 'all' ){
        if(_.has(option, 'uid')){
          teamDataService.filteredMember = option.uid;
          teamDataService.filteredMemberName = option.fullName;
        }
       } else {
           delete teamDataService.filteredMember;
           delete teamDataService.filteredMemberName;
       }

      }// filterUser

      vm.showTeamFilter = function(){
       if (_.size(vm.teamList) > 1){
           return true
       }
      }

        function setupAllTasks(){
          vm.allTasks = [];
          vm.hasClients = _.size(vm.clients);
          // we really only want to be prepping this array if we arent using it.
          // we don't use it if we are grouping today by client.
          if(!vm.groupTodayByClients){
            // concate all of our open client tasks into one array
            _.each(vm.clients, function(client){
                _.each(client.tasks, function(task){
                    vm.allTasks.push(task);
                });
            });
          }
        } // setupAllTasks

        // // Setup allTasks ONLY if we are
        // if(vm.groupTodayByClients){
        //   setupAllTasks();
        // }



        // // Watch vm.clients and update allTasks if it changes
        // var unwatch = vm.clients.$watch(function() {
        //   // console.log("data changed!");
        //   $timeout(function(){
        //     setupAllTasks();
        //   },100);

        // });

        // $scope.$on('$destroy', function() {
        //     // $log.info('unwatching clients');
        //     unwatch();
        // });



       // Force a resize to address a bug we can't solve
       // $timeout(function(){
       //   // pageDimensionsService.resizeColumns();
       //   triLoaderService.setLoaderActive(false);
       // },500);

    }
})();

(function() {
    'use strict';

    angular
        .module('adminToday')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-today');

        $stateProvider
            .state('triangular.today', {
                views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/layouts/toolbar/adminja-tasks-toolbar.tmpl.html',
                            controller: 'ToolbarController',
                            controllerAs: 'vm'
                        },
                        '@triangular': {
                            templateUrl: 'app/admin-tasks/tasks-page.tmpl.html',
                            // set the controller to load for this page
                            controller: 'tasksPageController',
                            controllerAs: 'vm'
                        }
                    },
                url: '/today',


            });

        // send /dashboard requests to triangular.dashboard state
        // $urlRouterProvider.when(/dashboard/, ['$state','$match', function ($state, $match) {
        //   $state.go('triangular.dashboard');
        // }]);

        triMenuProvider.addMenu({
            name: 'Today',
            icon: 'zmdi zmdi-sun',
            type: 'link',
            state: 'triangular.today',
            priority: 7,
            class: 'icon-today'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('manage', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, $rootScopeProvider, triLayoutProvider) {


        $translatePartialLoaderProvider.addPart('app/adminja-admin');

        $stateProvider

          $stateProvider
              .state('triangular.admin', {
                  abstract: true,
                  url: '/admin',
                  templateUrl: 'app/adminja-admin/manage-page.tmpl.html',
                  // set the controller to load for this page
                  controller: 'managePageController',
                  controllerAs: 'vm',
                  resolve: {
                      'currentAuth': ['authFactory', function(authFactory) {
                          return authFactory.$requireSignIn()
                      }],
                      // resolve our _userData and pass it to the Controller for saving
                       '_userData': ['userDataService', function(userDataService) {
                         return userDataService.getLoggedInUser()
                         .then(function(data){
                              return data
                         })
                      }]
                  }

              })
              // .state('triangular.admin.clone-clients', {
              //     url: '/admin/clone',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/clone-clients.tmpl.html',
              //             controller: 'cloneClientsController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              .state('triangular.admin.manage-users', {
                  url: '/admin/users',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-users.tmpl.html',
                          controller: 'manageUsersController',
                          controllerAs: 'vm'
                      }
                  }
              })
              .state('triangular.admin.manage-test', {
                  url: '/admin/test',
                  views: {
                      '@triangular': {
                          templateUrl: 'app/adminja-admin/manage-test.tmpl.html',
                          controller: 'manageTestController',
                          controllerAs: 'vm'
                      }
                  }
              })
              // .state('triangular.admin.manage-plans', {
              //     url: '/admin/plans',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/manage-plans.tmpl.html',
              //             controller: 'managePlansController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              // .state('triangular.admin.manage-changelog', {
              //     url: '/admin/changelog',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/update-changelog.tmpl.html',
              //             controller: 'changeLogController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              // .state('triangular.admin.manage-notifications', {
              //     url: '/admin/notifications',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/manage-notifications.tmpl.html',
              //             controller: 'manageNotificationsController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // })
              // .state('triangular.admin.manage-billing-periods', {
              //     url: '/admin/billing-periods',
              //     views: {
              //         '@triangular': {
              //             templateUrl: 'app/adminja-admin/manage-billing-periods.tmpl.html',
              //             controller: 'manageBillingPeriodsController',
              //             controllerAs: 'vm'
              //         }
              //     }
              // });



    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageUsersController', manageUsersController);
        // manageUsersController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageUsersController($q, $log, $window, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
    	var vm = this;
    	    vm.users = {};
    	    vm.user = _userData;
    	    vm.clients = {};
          vm.fbConfig = fbConfig;
    	    vm.selectedUser = undefined;

    	    // change the height of our container
    	    // var w = angular.element($window),
    	    // 		removeHeight = 100;
    	    // $('.admin-panel').css('height', (w.height() - removeHeight) + 'px');

          // ONLY execute if we are an admin.
          // No need to load this extra data for everyone
          // It will fail for non-admins anyways and we don't need those errors either.
          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
              var usersRef = firebase.database().ref().child('/userList');
              $firebaseArray(usersRef)
              .$loaded(
                  function(users) {
                      vm.users = users;
                  });

            },200);
          }

          vm.copyLearningBoard = function(userID){
            $log.info(userID);
            var statusRef = firebase.database().ref('/appState/currentState');
            $firebaseObject(statusRef)
            .$loaded(function(response){
              vm.adminjaStatus = response;
              clientDataService.copyClient(vm.adminjaStatus.trainingWorkspaceID, userID, true);
            });// end get adminjaStatus

          }// copyLearningBoard

          vm.teamSize = function(item){
            var size = _.size(item);
            return size;
          }
    	   vm.selectUser = function(userID){
    	   	// $log.info('selectUser' + userID);
    	   	var userRef = firebase.database().ref('users/' + userID);
    	   	return $firebaseObject(userRef)
    	   	.$loaded(
    	   	    function(user) {
    	   	    	// $log.info(user);
    	   	        vm.selectedUser = user;
    	   	        vm.numClients = _.size(vm.selectedUser.clients) || 0;
    	   	        vm.selectClients(user.uid);
    	   	    });
    	   } // vm.selectUser

    	   vm.panelCount = function(panel){
    	   	var count = _.size(panel.details);
    	   	return count
    	   }

    	   vm.openTasks = function(client){
    	   	// $log.info(client.tasks);
        		var openTasks = _.filter(client.tasks, function(o) {
        			return o.status != 'closed';
        		});
    		return _.size(openTasks)
    	   }

           vm.totalTasks = function(client){
            // $log.info(client.tasks);
            return _.size(client.tasks)
           }

        vm.updateUser = function (user){
          // $log.info('updateUser');

          // make a copy so we don't modify what's being shown and throw a DOB error
          // var userCopy = angular.copy(user);
          var userCopy = angular.fromJson(angular.toJson(user));
          // $log.info(userCopy);
          ajUTILITIES.removePropertiesWith(userCopy);
            // Make sure we reset fullName in case our name has changed
            userCopy.profile.fullName = userCopy.profile.firstName + ' ' + userCopy.profile.lastName;
            var updates = {};

            // store our canonical object - just update the PROFILE
            updates['/users/' + userCopy.uid] = userCopy;

            return firebase.database().ref().update(updates)


        }// updateUser

    	vm.selectClients = function(userID){
   		var clientsRef = firebase.database().ref().child('/clients');
   		$firebaseArray(clientsRef.orderByChild("access/users/" + userID).equalTo(true))
	        .$loaded(
	             function (clients) {
	             	// $log.info(clients);
	               vm.clients = clients;
	             });
    	   }
           /////////////////////////////////////////////////////////////////////////////////////
           /////////////////////////////////////////////////////////////////////////////////////
           // We need Chargebee loaded first. The entire registration function is wrapped in it
           // so it has access to chargebee's methods
           angularLoad.loadScript('https://js.chargebee.com/v1/chargebee.js').then(function() {
               // Script loaded succesfully.
               // $log.info('chargeBee Loaded');
               ChargeBee.configure({site: $rootScope.chargebeeSettings.site, api_key: $rootScope.chargebeeSettings.api_key});

               vm.ghostThisUser = function(user){
                var ghost = {
                  email: user.email,
                  uid: user.uid
                }
                localStorageService.set('ghostUser', ghost)
                alert('logged in. refresh to view as this user.')
               }// vm.ghostThisuser

               vm.subscribeUser =  function(user, plan){

                // first, deal with our previous inconsistency at variable naming
                var firstName, lastName;
                if (_.has(user, 'profile.firstName')){
                    firstName = user.profile.firstName;
                } else {
                    firstName = user.profile.firstname;
                }
                if (_.has(user, 'profile.lastName')){
                    lastName = user.profile.lastName;
                } else {
                    lastName = user.profile.lastname;
                }

                // $log.info('vm.subscribeUser');
                   // Create the subParam object to send to chargebee
                   var subParam = {};
                   subParam.customer = {};
                   subParam.customer.email = user.email;
                   subParam.customer.first_name = firstName;
                   subParam.customer.cf_adminja_user_id = user.uid;
                   subParam.customer.last_name = lastName;
                   subParam.plan_id= plan;
                   // $log.info(subParam);

                   // Create the subscription in chargeBee
                    ChargeBee.subscription.create(subParam).request(apiResponseHandler);

             }// end vm.subscribeUser
             }).catch(function() {
                 $log.info('There was some error loading the chargebee script. Meh');
             });


             //##ajax_error_handling_start##
             function subscribeErrorHandler(response) {
                 try {
                     // checking for param error
                     if (response.error.error_param != null) {
                         var errorMap = {};
                         var errParam = response.error.error_param;
                         var errMsg = response.error.error_msg;
                         //handling customer[id] field error
                         if (errParam == "customer[id]" && response.error.error_code == "param_not_unique") {
                             errorMap["customer[email]"] = errMsg;
                         } else {
                             errorMap[errParam] = errMsg;
                         }
                         // $("#subscribe-form").validate().showErrors(errorMap);
                     } else {
                         var errMsg = response.error.error_msg;
                         alert(errMsg);
                         // $(".alert-danger").show().text(errMsg);
                     }
                 } catch (err) {
                     alert(errMsg);
                     // $(".alert-danger").show().text("Error while processing your request");
                 }
             }
             //##ajax_error_handling_end##

             function apiResponseHandler(status, response) {
                 if (status != 200) {
                     subscribeErrorHandler(response);
                 } else {
                    alert('User Subscribed');
             }
            }


    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('manageToolbarController', manageToolbarController);

    /* @ngInject */
    function manageToolbarController($log, $scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('manageTestController', manageTestController);
        // manageTestController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageTestController($q, $log, $window, $timeout, angularLoad, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, fbService) {
    	var vm = this;
    	    vm.users = {};
    	    vm.user = _userData;
    	    vm.clients = {};

    	    vm.selectedUser = undefined;


          if(vm.user.type === 'admin'){
            // Load up our list of users
            $timeout(function(){
              var usersRef = firebase.database().ref().child('/users');
              $firebaseArray(usersRef)
              .$loaded(
                  function(users) {
                      vm.users = users;
                  });

            },200);


          }// if isAdmin
        vm.clearRruleTest = function(){
          init();
        }

        function init(){
          vm.testResults = [];
        }

        init();

    	 vm.testRule = function(start){
                  var dtStart = new Date(start),
                  recurDay = Number(moment.utc(start).format('D'));
                 var rule = new RRule({
                   freq: RRule.MONTHLY,
                   bymonthday: recurDay,
                   dtstart: dtStart,
                   until: new Date(2020, 12, 31)
                 })

                 // Get all occurrence dates (Date instances):
                 _.each(rule.all(), function(event){
                    var results = 'From: ' + moment.utc(event).format('YYYY-MM-DD') + '\n'
                                  + 'To: ' + moment.utc(event).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD');
                    vm.testResults.push(results);
                 });

             }

    }
})();

(function() {
    'use strict';

    angular
        .module('manage')
        .controller('managePageController', managePageController);
        // managePageController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function managePageController($q, $log, $timeout) {

    }
})();

(function() {
    'use strict';

    angular
        .module('time', []);
})();

(function() {
    'use strict';

    angular
        .module('time')
        .controller('timeReportsController', timeReportsController)
        /* @ngInject */
        .filter('HandMFilter', function ($filter) {
          return function (value) {
            return  $filter('HandM')(value)
          };
        })
        .filter('decimalFilter', function () {
          return function (value) {
            // if an aggregate value, it will be a string that includes "total: ".
            if (typeof value == 'string'){
             value = value.replace('total: ','');
             value = Number(value);
            }

            var hours = value/60,
                result = hours.toFixed(2);
            return  result;
          };
        })
        .filter('dateColorFilter', function () {
          return function (entity) {
            var difference = moment(entity.logDate).diff(entity.timestamp, 'hours'); // 86400000
            difference = Math.abs(difference);
            var color;
            if(difference > 48){
              color = 'red'
            } else if (difference > 12){
              color = 'pink';
            } else if (difference > 2){
              color = 'light-pink';
            } else {
              color = 'none'
            }
            return color
          };
        })
        .filter('dateFormatFilter', function(){
          return function(entity, format){
            // console.log(format);
            var out = moment(entity).format(format);
            return out
          }
        });


    /* @ngInject */
    function timeReportsController($log, uiGridGroupingConstants,  uiGridConstants, timeDataService, $sce, $scope, CSV, timeReportService, teamDataService, userDataService, clientDataService, $mdMedia, $mdDialog, $rootScope, $timeout, $filter, hotkeys, $firebaseArray, $firebaseObject, _userData, _clientData, _teams) {
    var vm = this;
    vm.showGrid = false;
     vm.user = _userData;
     vm.settings = $rootScope.userSettings;
     if(_.has(vm.settings, 'showArchivedByDefault')){
      if(vm.settings.showArchivedByDefault){
        vm.showArchived = true;
      }
     }

     var dateFormat = 'us';
     if (_.has(vm.settings, 'dateFormat')){
         dateFormat = vm.settings.dateFormat;
     }

     var textCellTemplate = '<div ng-if="!col.grouping || col.grouping.groupPriority === undefined || col.grouping.groupPriority === null || ( row.groupHeader && col.grouping.groupPriority === row.treeLevel )" class="ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
                   ' <div ng-click="grid.appScope.openEntry(row.entity)">{{COL_FIELD}}</div>' +
                   '</div>',
       workspaceCellTemplate = '<div ng-if="!col.grouping || col.grouping.groupPriority === undefined || col.grouping.groupPriority === null || ( row.groupHeader && col.grouping.groupPriority === row.treeLevel )" style="border-left: 4px solid {{row.entity.clientColor||\'#666\'}};" class="ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}">' +
                             ' <div ng-click="grid.appScope.openEntry(row.entity)">{{COL_FIELD}}</div>' +
                             '</div>';

     var dateCellTemplate = undefined;
     if(dateFormat == 'us'){
      dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents warning-{{row.entity |dateColorFilter}}"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
                         ' <div ng-click="grid.appScope.openEntry(row.entity)">{{COL_FIELD | dateFormatFilter:\'MMM D\'}}</div>' +
                         '</div>';
     }
     if(dateFormat == 'eu'){
      dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents warning-{{row.entity |dateColorFilter}}"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
                         ' <div ng-click="grid.appScope.openEntry(row.entity)">{{COL_FIELD | dateFormatFilter:\'D MMM\'}}</div>' +
                         '</div>';
     }
     var statusCellTemplate = '<div class="ngCellText ui-grid-cell-contents center" title="Invoice Status">' +
              '<md-icon ng-if="row.entity.invoiced" class="billing-invoice-icon" md-font-icon="fa fa-check" style="color: #96C089;"><md-tooltip md-delay="500">Invoiced</md-tooltip></md-icon>' +
              '</div>';

      function resizeGrid(){
        // $log.info('resizeGrid');
         var grid = $('.timeGrid'),
             pageHeight = $('md-content.triangular-content').height(),
             toolbarHeight = $('.triangular-toolbar').height(),
             reportControlsHeight = $('.time-report-controls').height(),
             gridHeight = pageHeight - toolbarHeight - reportControlsHeight - 50;
             // $log.info('newGrid Height: ' + gridHeight + 'px');

             $(grid).css('height', gridHeight);
     }

        vm.gridOptions = {
            rowHeight: 30,
            enableFiltering: true,
            enableExpandableRowHeader: false,
            excessRows: 50,
            flatEntityAccess: false,
            enableGridMenu: true,
            showGridFooter: false,
            showColumnFooter: true,
            fastWatch: true,
            virtualizationThreshold: 100,
            enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
            groupingShowCounts: true,
            exporterMenuPdf: false,
            exporterMenuExcel: false,
            exporterCsvFilename: 'time-export.csv',
            exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
            exporterExcelFilename: 'time-export.xlsx',
            exporterExcelSheetName: 'Sheet1',
            onRegisterApi: function( gridApi ) {
                 vm.gridApi = gridApi;
                  vm.gridApi.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
                   resizeGrid();
                 });

                // Set our time format filter
                // Depending on user setting, define the display filter to use for our logged time

                if(!vm.settings.timeFormat){
                   vm.gridOptions.columnDefs[8].cellFilter = 'HandMFilter';
                } else {
                   vm.gridOptions.columnDefs[8].cellFilter = 'decimalFilter';
                }

            },//onRegisterAPi Function
            gridMenuCustomItems: [
            {
                   title: 'Hide filters',
                   leaveOpen: false,
                   icon: 'fa fa-times',
                   order: 0,
                   action: function ($event) {
                       vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
                       vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                   },
                   shown: function () {
                       return vm.gridOptions.enableFiltering;
                   }
               },
               {
                   title: 'Show filters',
                   leaveOpen: false,
                   icon: 'fa fa-filter',
                   order: 0,
                   action: function ($event) {
                       vm.gridOptions.enableFiltering = !vm.gridOptions.enableFiltering;
                       vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                   },
                   shown: function () {
                       return !vm.gridOptions.enableFiltering;
                   }
               },
                {
                 title: 'Group by Workspace',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('clientName');
                 },
                 context: $scope
               },
                {
                 title: 'Group by Package',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('packageLabel');
                 },
                 context: $scope
               },
               {
                   title: 'Group by User',
                   icon: 'fa fa-indent',
                   action: function($event) {
                     // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                     vm.changeGrouping('creatorName');
                   },
                   context: $scope
                 },

                      {
                   title: 'Group by Category',
                   icon: 'fa fa-indent',
                   action: function($event) {
                     // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                     vm.changeGrouping('rateLabel');
                   },
                   context: $scope
                 },

                    {
                 title: 'Group by Workspace & User',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('clientName', 'creatorName');
                 },
                 context: $scope
               },
                    {
                 title: 'Group by Workspace & Category',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('clientName', 'rateLabel');
                 },
                 context: $scope
               },

                    {
                 title: 'Group by Workspace & Package',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('clientName', 'packageLabel');
                 },
                 context: $scope
               },
                    {
                 title: 'Group by User & Workspace',
                 icon: 'fa fa-indent',
                 action: function($event) {
                   // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                   vm.changeGrouping('creatorName', 'clientName');
                 },
                 context: $scope
               },


                  {
                      title: 'Remove Grouping',
                      icon: 'fa fa-ban',
                      action: function($event) {
                        // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                        vm.changeGrouping('none');
                      },
                      context: $scope
                    },
                    {
                        title: 'Payroll Report',
                        icon: 'fa fa-money',
                        action: function($event) {
                          // this.context.blargh(); // $scope.blargh() would work too, this is just an example
                          vm.runPayroll('none');
                        },
                        context: $scope
                      }
                   ]
         };// gridOptions


          vm.gridOptions.columnDefs = [
           {
                field:'clientName',
                displayName: 'Workspace',
                cellClass: 'grid-client-name',
                groupingShowAggregationMenu: false,
                groupingShowGroupingMenu: false,
                cellTemplate: workspaceCellTemplate,
                enableColumnResizing: true,
                width: 200

            },
           {
                field:'creatorName',
                displayName: 'User',
                cellClass: 'grid-creator-name',
                groupingShowAggregationMenu: false,
                groupingShowGroupingMenu: false,
                cellTemplate: textCellTemplate,
                enableColumnResizing: true,
                width: 175
            },
            {
                field:'packageLabel',
                displayName: 'Package',
                cellClass: 'grid-package-name',
                groupingShowAggregationMenu: false,
                groupingShowGroupingMenu: false,
                cellTemplate: textCellTemplate,
                enableColumnResizing: true,
                width: 200
            },

             {
                  field:'rateLabel',
                  width: 125,
                  displayName: 'Category',
                  cellClass: 'grid-time-category',
                  cellTemplate: textCellTemplate,
                  groupingShowAggregationMenu: false,
                  groupingShowGroupingMenu: false,
                  cellTooltip: true,
                  enableColumnResizing: true

              },
            {
                 field:'description',
                 displayName: 'Description',
                 cellTemplate: textCellTemplate,
                 cellClass: 'grid-task-description',
                 visible: true,
                 groupingShowAggregationMenu: false,
                 groupingShowGroupingMenu: false,
                 enableSorting: false,
                 cellTooltip: true,
                 enableColumnResizing: true
             },
            {
                 field:'taskName',
                 displayName: 'Task',
                 cellClass: 'grid-task-name',
                 cellTemplate: textCellTemplate,
                 visible: false,
                 groupingShowAggregationMenu: false,
                 groupingShowGroupingMenu: true,
                 cellTooltip: true,
                 enableColumnResizing: true
             },
           {
                field:'logDate',
                name: 'Date',
                displayName: 'Date',
                cellClass: 'grid-log-date',
                type: 'date',
                width: 100,
                enableColumnMenu: false,
                groupingShowGroupingMenu: false,
                cellTemplate: dateCellTemplate,
                sort: {
                    direction: uiGridConstants.ASC
                },
                enableFiltering: false
            },

             {
                  field:'timestamp',
                  displayName: 'Created on',
                  type: 'date',
                  width: 200,
                  cellFilter: 'date: \'MMM d, y @ h:mm a\'',
                  visible: false,
                  cellClass: 'grid-timestamp',
                  enableFiltering: false

              },
           {
             field:'logged',
             width: 150,
             displayName: 'Logged' ,
             cellClass: 'grid-logged',
             aggregationHideLabel: true,
             enableColumnMenu: false,
             groupingShowGroupingMenu: false,
             aggregationType: uiGridConstants.aggregationTypes.sum,
             footerCellTemplate: '<div class="ui-grid-cell-contents time-grid-total-logged" >Total: {{col.getAggregationValue()|HandMFilter}}</div>',
             enableFiltering: false
            },



            {
              field:'unused',
              width: 30,
              displayName: '' ,
              cellClass: 'grid-unused',
              aggregationHideLabel: true,
              enableColumnMenu: false,
              groupingShowGroupingMenu: false,
              enableFiltering: false,
              enableHiding: false
             }

         ];


         function init(){
          // set range setting override picker to current setting
           vm.rangeSetting = vm.settings.reportRange;
           vm.relatedMembers = [];
           vm.timeReportService = timeReportService;
           vm.timeReportService.init();
           vm.teamDataService = teamDataService;
           vm.showGrid = false;
           vm.groupingOption = 'none';
           // vm.selectedAccount = 'all';

            // Watch for changes in which period is selected and reset our form
           $scope.$watch('vm.timeReportService.report.loading', function() {
                 // Only do something IF we have a periodForm.
                  if(!vm.timeReportService.report.loading){
                    $timeout(function(){
                      vm.gridOptions.data = vm.timeReportService.report.data
                      vm.showGrid = true;},0)
                    .then(function(){
                       resizeGrid();
                    });
                  } else {
                    vm.showGrid = false;
                  }
              });




           $timeout(function(){
            vm.timeReportService = timeReportService;
            vm.timeReportService.report.selectedMember = 'all';
            vm.timeReportService.init();
            vm.teamDataService = teamDataService;
            vm.usersTeams = _teams;
             vm.retainerMode = false;
             vm.maxDate = moment().toDate();
             vm.minDate = moment().subtract(2, 'years').toDate();
             vm.today = moment();
             vm.now = moment().toISOString();
             vm.clientTeams = teamDataService.clientTeams;
             vm.allMembers = teamDataService.allMembers;
             vm.relatedMembers = [];
             vm.showGrid = false;
             vm.groupingOption = 'none';

             vm.updateDateRange = function(rangeSetting){
               timeReportService.setDateRangeFromSetting(rangeSetting);
               vm.updateReport();
             }

             if(!_.has(vm.settings, 'reportRange')){
               vm.settings.reportRange = 'saved'
             }

             timeReportService.setDateRangeFromSetting(vm.settings.reportRange);




             if(_.has(vm.settings, 'defaultTimeView')){
               // $log.info('using stored settings');
               timeReportService.report.view = vm.settings.defaultTimeView;
             } else {
               timeReportService.report.view = 'month'
             }

             // Our account picklist
             vm.managedTeams = [];
             vm.managedTeams.push({
               name: "All",
               ownerID: 'all',
               order: 1
             })


             _.each(vm.usersTeams, function(team, index){
               // if own team not setup, add it manually
               if(_.has(team, 'members')){
                 if(_.has(team.members[vm.user.uid], 'isTeamAdmin') || team.ownerID == vm.user.uid){
                   team.order = index + 2
                   vm.managedTeams.push(team)
                 }
               } else {
                 // team is user's own but it's not setup (or they don't have teams)
                 if(team.needsSetup){
                  vm.managedTeams.push({
                    name: "Your account",
                    ownerID: $rootScope.userID,
                    order: 2
                  })
                 }// if needsSetup
               }// if has members
             });// each team

               vm.selectedAccount = 'all';
               if(vm.settings.selectedAccount){
                vm.selectedAccount = vm.settings.selectedAccount
               }
               vm.selectAccount(vm.selectedAccount);
           }, 500);


         }// init

         init();




     $scope.openEntry = function(entry){
            return timeDataService.timeDialog(entry);
         }

         vm.changeGrouping = function(group, subgroup){
              vm.gridApi.grouping.clearGrouping();
              if(group != 'none'){
               vm.gridApi.grouping.groupColumn(group);

               // if we have a subgroup, setup that grouping
               if(subgroup){
                   vm.gridApi.grouping.groupColumn(subgroup);
               }
               vm.gridApi.grouping.aggregateColumn('logged', uiGridGroupingConstants.aggregation.SUM);
               // disable column footer
               vm.gridOptions.showColumnFooter = false;
                vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
              } else {
               // enable column footer
                  vm.gridOptions.showColumnFooter = !vm.gridOptions.showColumnFooter;
                   vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);

              }
         }


vm.runPayroll = function(){
  if(vm.managedTeams.length > 1){
    userDataService.trackEvent('run-payroll-report');
    timeDataService.payrollReportDialog(vm.timeReportService.report, vm.managedTeams);
  } else {
    $mdDialog.show(
         $mdDialog.alert()
           .parent(angular.element(document.querySelector('#popupContainer')))
           .clickOutsideToClose(true)
           .title('Unable to run Payroll Report')
           .textContent('Please make sure you have selected an account that you manage first.')
           .ariaLabel('Unable to run Payroll Report')
           .ok('Got it')
       );
  }

}// runPayroll




vm.refreshTeams = function(){
    // $log.info('refreshTeams');
    // Make sure all is selected
    vm.timeReportService.report.selectedMember = 'all';

    $timeout(function(){
      vm.teamDataService.init();
    },3000);
    init();

}


      function putInView() {
          $('#scroll-h').animate({
              scrollLeft: 0
          }, 20, 'linear');
      }

      vm.loadMenu = function(entry){
          timeDataService.getTimeUserMenu(entry)
          .then(function(menu){
              vm.entryMenu = menu;
              vm.menuLoaded = true;
          });
      }// vm.loadMenu



      vm.openTime = function(entry){
          timeDataService.timeDialog(entry, 'Modify');
      }

      vm.reportTime = function(group, entries){
          // $log.info('printTime');
          userDataService.trackEvent('run-report-time');
          vm.printReport = {};
          var title = "All Workspaces";

          // if for a specific client - prep the report with their id and contact info
          if (vm.timeReportService.report.source == 'client'){
            _.each(vm.clients, function(client){
              if(client.uid == vm.timeReportService.report.selectedClient){
                  title = client.profile.fullName;
                  vm.printReport.clientID = client.uid;
                  vm.printReport.clientEmail = client.profile.email;
              }
            });
          }// if source is client
          vm.printReport.clientName = title;
          vm.printReport.start = group.start;
          vm.printReport.end = group.end;
          vm.printReport.type = 'time';
          vm.printReport.rate = 0;
          vm.printReport.allocated = 0;
          vm.printReport.time = entries;
          vm.printReport.total = vm.logTotal(vm.printReport.time);
          vm.printReport.filename = vm.groupTimeReportFilename(group) + '.pdf';
          timeDataService.timeReportDialog(vm.printReport);
      }// printTime

      vm.reportAllTime = function(){
        if(vm.timeReportService.report.data.length > 2000){
          var confirm = $mdDialog.confirm()
                 .title('This report is rather large')
                 .htmlContent('It may take some additional time to format. <br>In the future, consider downloading it as a spreadsheet.')
                 .ariaLabel('Are you sure?')
                 .ok('I don\'t mind')
                 .cancel('Cancel');

         $mdDialog.show(confirm).then(function() {
            doReportAllTime();
         }, function() {
              // they chose the cancel option
              $mdDialog.cancel();
         });
          }else {
            doReportAllTime();
          }
      }// Print All Time

      function doReportAllTime(){
        var title = "All Workspaces";
        if (vm.timeReportService.report.source == 'client'){
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){
                title = client.profile.fullName;
            }
          });
        }// if source is client
        vm.printReport = {};
        vm.printReport.clientName = title;
        vm.printReport.start = vm.timeReportService.report.start;
        vm.printReport.end = vm.timeReportService.report.end;
        vm.printReport.type = 'time';
        vm.printReport.rate = 0;
        vm.printReport.allocated = 0;
        vm.printReport.time = vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end);
        vm.printReport.total = vm.logTotal(vm.printReport.time);
        vm.printReport.filename = vm.allTimeReportFilename() + '.pdf';
        timeDataService.timeReportDialog(vm.printReport);

      }

      // create array for populating our month/year drop downs.
      function setupMonthSelect(){
          var now = moment().startOf('month'),
              nowPlus = moment(now).add(1, 'month'),
              start = moment().subtract(23, 'months'),
              months = [];

          for (var m = moment(now); m.isAfter(start); m.subtract(1, 'month')) {
              var thisMonth = {
                   label: moment(m).format('MMM YYYY'),
                   date: moment(m).toISOString()
              }
              months.push(thisMonth);
          }
          vm.monthSelect = months;
      }

      setupMonthSelect();

      vm.allTimeReportFilename = function(){
        var filename = "";
        if(vm.timeReportService.report.source == 'all'){
          filename = 'all-clients-';
          filename = filename + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
          filename = filename;
          return filename
        } else {
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){

              // remove slashes
              var cleanName = client.profile.fullName.replace(/\//g, '-');
              filename = _.snakeCase(cleanName);
              filename = filename + '-' + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
              filename = filename;
            };
          });
          return filename
        } // if/else
      }// vm.allTimeReportFilename

      vm.groupTimeReportFilename = function(group){
        var filename = "";
        if(vm.timeReportService.report.source == 'all'){
          filename = 'all-clients-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
          filename = filename;
          return filename
        } else {
          _.each(vm.clients, function(client){
            if(client.uid == vm.timeReportService.report.selectedClient){
              filename = _.snakeCase(client.profile.fullName);
              filename = filename + '-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
              filename = filename;
            };
          });
          return filename
        }// if else
      }// vm.grouopTimeReportFilename


      vm.viewWeeks = function(){
        // Make sure retainerMode is off
        vm.retainerMode = false;
        // Set our report view
          vm.timeReportService.report.view = 'week';
        // Update our report
          vm.updateReport();
      }

      vm.viewMonths = function(){
          // Make sure retainerMode is off
          vm.retainerMode = false;
          // Set our View
          vm.timeReportService.report.view = 'month';
          // Update our report
          vm.updateReport();
      }

      vm.viewList = function(){
        vm.retainerMode = false;
        vm.timeReportService.report.view = 'list';
        vm.updateReport();
      }


      // Detect deletions and update report
      var unwatch = $rootScope.$on('updateTimeReport', function(event, data) {
          vm.updateReport();
        });
      $scope.$on('$destroy', function(){
        unwatch();
      })



      vm.updateReport = function(){
        vm.isFinished = {};
        vm.showGrid = false;
        // reset member picker
        // $log.info('time-reports.controller.js - vm.updateReport');
        // Update time data
        delete vm.printReport
        // make sure we are going from midnight to end of day for the range selected (in this timezone);
        vm.timeReportService.report.end = moment(vm.timeReportService.report.end).endOf('day').toISOString();
        vm.timeReportService.report.start = moment(vm.timeReportService.report.start).startOf('day').toISOString();

        if(vm.timeReportService.report.source == 'all'){
          vm.timeReportService.getEveryClientsTime(vm.clients, vm.timeReportService.report.end, vm.timeReportService.report.start);
        } else if (vm.timeReportService.report.source == 'client') {
          // $log.info('lets pull this client\'s time');
          vm.timeReportService.getClientsTime(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);
        }


      }// vm.updateReport

      vm.manualRangeUpdate = function(){
        $timeout(function(){
          vm.rangeSetting = 'saved';
        })
        vm.updateReport();
        // We are making manual change - so save the range in settings
        userDataService.changeUserSetting('reportStart', vm.timeReportService.report.start);
        userDataService.changeUserSetting('reportEnd', vm.timeReportService.report.end);
      }

      vm.switchSource = function(option){
        // Executed when client drop down is changed
        if(option == 'all'){
          // Showing all data for user
          vm.timeReportService.report.source = 'all';
          // Update report
          vm.updateReport();
        } else {
          // Showing data for specific client
          vm.timeReportService.report.source = 'client';
          // Update report
          vm.updateReport();
        }
      }// vm.switchSource


      vm.switchUser = function(user){
        vm.updateReport();
      }
      // Source of pre-filtered entries for each time group.
      // TODO - this is probably pretty expensive for big reports
      // 9/2018update - has been mitigated somewhat by not using the timeEntry directive and adding the blazing fast list view
      vm.groupEntries = function(start, end){
        // $log.info($scope.$$watchers);
        var entries = [],
            total = 0,
            count = 0;
        vm.reportTotal = 0;
        // reset allMembers

        start = moment(start).startOf('day').toISOString();
        end = moment(end).endOf('day').toISOString();
        var reportData = vm.timeReportService.report.data;

        _.each(reportData, function(entry, index){
          $log.info('processing entry');
          count = count + 1;
          // $log.info('entry: ' + entry.uid);
          if(_.has(vm.clientTeams, entry.client)){
            var role = 'member';
            if(_.has(vm.clientTeams[entry.client], $rootScope.userID)){
              role = vm.clientTeams[entry.client][$rootScope.userID].role;
            }
            if(teamDataService.isTeamAdmin($rootScope.userID, entry.account)){
               role = "admin";
            }
            // $log.info(role);
            // this client has a team, check roles
            if(role == 'owner' || role == 'admin'){
              // $log.info('Owns or admin: pass');
              if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){
                if(entry.logDate < end && entry.logDate >= start){
                  vm.prepareDisplayEntry(entry);
                  entries.push(entry);
                  vm.checkMember(entry);
                  vm.reportTotal = vm.reportTotal+entry.logged;
                }
              }// if passes userFilter
            } else if (role == 'member'){
              // $log.info('member entry');
              // role is 'member'. Only include time if it's created by this user
              if(entry.creator == $rootScope.userID){
              if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){
                if(entry.logDate < end && entry.logDate >= start){
                  vm.prepareDisplayEntry(entry);
                  entries.push(entry);
                  vm.checkMember(entry);
                  vm.reportTotal = vm.reportTotal+entry.logged;
                }
              }// if passes userFilter
              }
            }
          } else {
            // // no team for this client, no need to check roles
            if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){
              if(entry.logDate < end && entry.logDate >= start && entry.creator == vm.user.uid){
                // $log.info('Allowed.');
                vm.prepareDisplayEntry(entry);
                entries.push(entry);
                vm.checkMember(entry);
                vm.reportTotal = vm.reportTotal+entry.logged;
              }
            }// if passes userFilter
          }
        });

        return entries
      }

      vm.checkMember = function(entry){
        // checkmember is used to build our team picker.

         // Is this member already in our relatedMembers array?
         var isInRelatedMembers = _.find(vm.relatedMembers, function (member) {
            return member.uid == entry.creator;
        });

        if(!isInRelatedMembers){
          // this member is not in our picker yet
          // check to see if member is still part of the team and grab their object if they are
          var isInAllMembers = _.find(vm.allMembers, function (thisMember) {
               return thisMember.uid == entry.creator;
           });

          if(isInAllMembers){
            // this member is on the team, add it to relatedMembers
            vm.relatedMembers.push(isInAllMembers);
          } else {
            // this member no longer on the team. make a slug for them and add that
             var memberName = _.split(entry.creatorName, ' ', 2),
             memberSlug = {
              uid: entry.creator,
              profile: {
                firstName: memberName[0],
                lastName: memberName[1]
              }
            }
            vm.relatedMembers.push(memberSlug)
          }
         }
      }// vm.checkMember

      vm.prepareDisplayEntry = function(entry){
        // This function pre-calculates some variables so our ng-repeat doesn't have to
        // this yields a much faster render of big time reports
        entry.displayLogDate = moment(entry.logDate).format('MM/DD/YYYY');
        entry.displayLogTime = moment(entry.logDate).format('h:mm a');
        if(_.has(entry, 'description')){
          entry.displayDescription = entry.description.substring(0,50);
        }
        entry.displayLogged = $filter('userTimeFormat')(entry.logged);
      }

      //live totals calculation for each group
      vm.logTotal = function (logs) {
          var total = 0;
          _.each(logs, function (entry) {
              total += Math.round(entry.logged);
          })
          return total
      };

      // Functionality for downloading CSVs
      vm.downloadCSVFile = function(data, filename) {
                userDataService.trackEvent('download-time-csv');
                 var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
                 // $log.info(preppedData);
                 // var data = "text/json;charset=utf-8," + data;

                 var downloader = document.createElement('a');

                 downloader.setAttribute('href', preppedData);
                 downloader.setAttribute('download', filename + '.csv');
                 downloader.click();
      };

      vm.downloadCSV = function(logs, filename){
          // $log.info('downloadCSV');
          var cleanLogs = [];

          // Clean Up our logData (remove unnecessary things)
          _.each(logs, function(entry){

              // Get our clientname
              var clientName = "";
              if(!_.has(entry, 'clientName')){
                  clientName = entry.client;
              } else {
                  clientName = entry.clientName;
              }

              // get our taskName
              var taskName = 'none',
                  description = '';

              if(_.has(entry, 'taskName')){

                  taskName = entry.taskName;
                  // trim it
                  taskName = _.truncate(taskName, {
                                'length': 100,
                                'separator': ' '
                              });
                  // sanitize it (replace commas and line breaks)
                  taskName = _.replace(taskName,new RegExp(",","g"),"-");
                  taskName = _.replace(taskName,new RegExp("\n","g")," ");

              }

              if(!_.has(entry, 'taskName')){
                  taskName = "none";
              }

              if(_.has(entry, 'description')){
                // trim it
                description = _.truncate(entry.description, {
                              'length': 100,
                              'separator': ' '
                            });
                // sanitize it (replace commas and line breaks)
                description = _.replace(description,new RegExp(",","g"),"-");
                description = _.replace(description,new RegExp("\n","g")," ");

              }

              // build our new object
              var newCSVLog = {
                  'clientName': clientName,
                  'creatorName': entry.creatorName,
                  'description': description,
                  'logDate' :moment(entry.logDate).format('YYYY-MM-DD'),
                  'logged' : entry.logged,
                  'taskName': taskName
              }

              cleanLogs.push(newCSVLog);

          });

          // Set the header labels for our CSV file (note, we are accepting default alpha format)
          var csvOptions = {
              'header': [
                  'Client',
                  'User',
                  'Description',
                  'Date',
                  'Minutes',
                  'Task'
              ]
          }


          // Convert our json to CSV and start the download
          CSV.stringify(cleanLogs, csvOptions).then(function(result){
                     vm.downloadCSVFile(result, filename + '.csv');
                 });
      }// downloadCSV


      vm.selectAccount = function(teamID, update){

        // save selection
        userDataService.changeUserSetting('selectedAccount', teamID);

        if(teamID == 'all'){
          // $log.info('using default client list');
          vm.clients = $scope.$resolve.clientDataService.clients
          vm.updateReport();
        } else {
            var accountClientsRef = firebase.database().ref().child('/users/' + teamID + '/clients');
            $firebaseArray(accountClientsRef)
            .$loaded(function(clients){
                // Load up a client array based on these IDs
                 // Using Array of Promises
                 var accountClients=[],
                     reads = [],
                     ref= firebase.database().ref();

                 // prepare our array of promises
                 _.each(clients, function(client){
                     var ref = firebase.database().ref('/clients/'+client.$id),
                         obj = $firebaseObject(ref),
                         promise = obj.$loaded().then(function(){
                          // $log.info('client: ', obj);
                          if(obj.owner == teamID){
                            if(vm.showArchived){
                              accountClients.push(obj);
                            } else if (obj.status != 'archived'){
                              accountClients.push(obj);
                            }
                          }// if owned by team selected
                         });
                     reads.push(promise);
                 });

              return Promise.all(reads)
              .then(function(){
                $timeout(function(){vm.clients = accountClients;},100)
                .then(function(){
                  // $log.info(vm.clients);
                   vm.updateReport();
                });

              }, function(error){
                 $log.warn('error loading workspaces');
                 $log.warn(error);

              });

            });// end get owner
        }


        // if we were updating this MANUALLY, change the setting.
        // if (update){
        //   return userDataService.changeUserSetting('defaultAccount', teamID)
        //   .then(function(){
        //     $log.info('setting updated');
        //   });
        // }


      }// selectAccount

      vm.toggleArchived = function(teamID){
        // $log.info('toggle archived');
        $timeout(function(){
          return vm.selectAccount(teamID);
        }, 500)
      }

    } // end timeReportsController
})();

(function() {
    'use strict';

    angular
        .module('time')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triLayoutProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-time-reports');

        $stateProvider
            .state('triangular.time-reports', {
                url: '/time/',
                templateUrl: 'app/admin-time-reports/time-reports.tmpl.html',
                // set the controller to load for this page
                controller: 'timeReportsController',
                controllerAs: 'vm'
                ,
                resolve: {
                    '_teams': ['teamDataService', function (teamDataService) {
                            return teamDataService.getUsersTeams()
                                    .then(function (data) {
                                        return data
                                    })
                        }]
                    }
            });


        triMenuProvider.addMenu({
            name: 'Time Reports',
            icon: 'zmdi zmdi-time',
            state: 'triangular.time-reports',
            type: 'link',
            priority: 9.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('leads', ['appServices'

        ]);
})();

(function() {
    'use strict';

    angular
        .module('leads')
        .controller('LeadsController', LeadsController);

    /* @ngInject */
    function LeadsController($log, $scope, $state, hotkeys, $stateParams, clientDataService, $timeout, $rootScope, triLoaderService, dragulaService, leadDataService, $firebaseArray, $firebaseObject, _teams) {
        $log.info('LeadsController');
        var vm = this;
        vm.usersTeams = _teams;
        vm.init = init;
        vm.newLead = newLead;
        vm.changeView = changeView;
        vm.resetSearch = resetSearch;
        vm.leadCount = leadCount;
        vm.leadDataService = leadDataService;
        vm.leadSettings = leadSettings;
        vm.closeFilterBar = closeFilterBar;
        vm.selectAccount = selectAccount;
        vm.leadDataService.activeAccount = $rootScope.userID;

        // empty list to contain items without types
        vm.newLeads = [];



        // setup our accountPicker menu
        $timeout(function(){
            // Setup our account switcher
            // Our account picklist
            if(_.size(vm.usersTeams) > 1){
                vm.managedTeams = [];
                _.each(vm.usersTeams, function(team, index){
                  // if own team not setup, add it manually
                  if(_.has(team, 'members')){
                    if(_.has(team.members[$rootScope.userID], 'isTeamAdmin') || team.ownerID == $rootScope.userID){
                      team.order = index + 2
                      vm.managedTeams.push(team)
                    }
                  } else {
                    // team is user's own but it's not setup (or they don't have teams)
                    if(team.needsSetup){
                     vm.managedTeams.push({
                       name: "Your account",
                       ownerID: $rootScope.userID,
                       order: 2
                     })
                    }// if needsSetup
                  }// if has members
                });// each team
                if(_.size(vm.managedTeams) > 1){
                    vm.showAccountPicker = true;
                }
            }
        }, 2000);

        // listen for account picker changes from toolbar and retrigger init with proper account
        // similar to using init. But more reliable for some reason.
        $rootScope.$on('accountChanged', function(){
          init();
          });


        // Load our Leads Board
        vm.init();

        function init(){
          $timeout(function(){
            vm.leadBoard = undefined;
          });

            return leadDataService.getLeadBoard(leadDataService.activeAccount)
            .then(function(leadboard){
              // putting on rootscope so toolbar has access
              $rootScope.leadBoard = leadDataService.leadBoard;
              $scope.$on('$destroy', function(){
                delete $rootScope.leadBoard;
              });
              vm.leadBoard = leadDataService.leadBoard;
              vm.leads = vm.leadBoard.leads;

              if(_.has(vm.leadBoard, 'leadTypes')){
                $timeout(function(){
                  vm.showSetupMessage = false;
                },0);
              } else {
                $timeout(function(){
                  vm.showSetupMessage = true;
                },0);
              }
            });
            // if(_.size(vm.leadBoard) < 1){
            //   // leadBoard isn't ready. Ask for it again
            //    $timeout(function(){
            //     triLoaderService.setLoaderActive(true);
            //     return leadDataService.getLeadBoard(vm.accountID, true)
            //   },3000)
            //   // wait 3 secs and try it again.
            //   vm.leadBoard = leadDataService.getLeadBoard(vm.accountID);
            // }

        }// init

        function newLead(accountID, type, label){
        	var freshLead = leadDataService.newLead(accountID, type, label);
   		return leadDataService.leadSheet(freshLead)
        } // newLead

        function leadSettings(){
          $state.go('authentication.profile', {selectedTab: 2});
        }

      // Lead Dragging
      dragulaService.options($scope, 'drag-leads', {
          moves: function (el, container, handle) {
                  return el.classList.contains('lead-card');
          },
          accepts: function (el, target, source, sibling) {
             return true
          },
          invalid: function(el, handle){
              // return var === 'condition'
              return false
          },
          direction: 'vertical',
          revertOnSpill: true
      });

      $scope.$on('drag-leads.drop', function (event, item, target, source, sibling) {
        // pause for dragula to settle

          // Now we can do our work - prep the variables
          var itemID = item[0].getAttribute('uid'),
                  parentPanelID = item[0].getAttribute('listid'),
                  parentPanel = $('.app-item-container-items[listid="'+ parentPanelID +'"]'),
                  targetPanelID = target[0].getAttribute('listid'),
                  targetPanel = $('.app-item-container-items[listid="' + targetPanelID + '"]'),
                  sourcePanelID = source[0].getAttribute('listid'),
                  numTargetChildren = $(targetPanel).find('.lead-card').length,
                  numSourceChildren = $(parentPanel).find('.lead-card').length,
                  sourceChildren = $(parentPanel).find('.lead-card').toArray(),
                  ghostElement = document.querySelector('.gu-transit'),
                  targetChildren = Array.from(ghostElement.parentNode.children),
                  targetItemIndex = targetChildren.indexOf(ghostElement),
                  thisBag = dragulaService.find($scope, 'drag-leads'),
                  updates = {},
                  thisLead = vm.leadBoard.leads[itemID];


            // if target list different than source
            if(targetPanelID != parentPanelID){
              // $log.info('moving: ' + thisLead.firstName + ' ' + thisLead.lastName);
                // thisLead.leadType = targetPanelID;
                // thisLead.order = Number(targetItemIndex + 1);
                updates['/leadBoards/' + thisLead.owner + '/leads/' + thisLead.uid + '/leadType/'] = targetPanelID;
            }


            _.each(targetChildren, function(child, index){
                // only handle valid leads
                if(child.getAttribute('uid')){
                    var childID = child.getAttribute('uid'),
                    // get the data model for this child
                        childLead = vm.leadBoard.leads[childID];
                        // $log.info(childLead.firstName + ' ' + childLead.lastName + '=' + Number(index + 1));
                    // update local data
                        vm.leadBoard.leads[childLead.uid].order = Number(index + 1);
                    // $timeout(function(){
                    // },0);
                    updates['/leadBoards/' + childLead.owner + '/leads/' + childLead.uid + '/order'] = Number(index + 1);
                }
            }); // each targetChildren

            $timeout(function(){
            return firebase.database().ref().update(updates)
            .then(function(){

                  // this particular sequence completely erradicated our drag and drop
                  //
                    $scope.$apply();

                    // we have a problem where if the last item of a source list is dropped in a target list,
                    // all of the other items in target list get lost by ng-repeat
                    // Here we are checking to make sure the targetList did not lose any cards
                    // if it did, we are reloading the whole board

                    // only bother checking if this was a list move
                    if(targetPanelID != sourcePanelID){
                      var expected = Number(numTargetChildren), // this was stored before we made changes
                          actual = Number($(targetPanel).find('.lead-card').length); // this is the state after the changes

                      // $log.info('expected:' + expected) ;
                      // $log.info('actual: ' + actual);

                      if(actual < expected){
                        $timeout(function(){// force a digest is necessary
                          vm.leadBoard = {};
                        },0)
                        $timeout(function(){// force a digest is necessary
                          vm.leadBoard = leadDataService.leadBoard
                        },0)
                      }


                    }// if card was moved betwixt lists
            });
        },0)


      });// $on.drag-task.drop

    function closeFilterBar(){
      $timeout(function(){
         vm.showFilterBar = false;
      },100);
    }
    function changeView(view){
        $timeout(function(){
            vm.leadDataService.currentView = view;
        },0)
    }

    function resetSearch(){
       vm.filterText = '';
      document.getElementById("searchQuery").value = "";
    }

    function leadCount(status){
        var count = 0;
        if(_.has(vm, 'leadBoard.leads')){
            _.each(vm.leadBoard.leads, function(lead){
                if(lead.status == status){
                    count = count + 1;
                }
            });
            return count
        } else {
            return 0
        }

    }

    function selectAccount(teamID, update){
        // set the service
        leadDataService.activeAccount = teamID;
        // emit change
        $rootScope.$emit('accountChanged')
      }


      vm.newLeadFilter = function(lead){
        var found = false;
        _.each(vm.leadBoard.leadTypes, function(type){
            if(type.uid == lead.leadType){
                found = true
            }
        });
        if(!found){
            return true
        }
      }// vm.newLeadFilter

    }//leadsController
})();

(function() {
    'use strict';

    angular
        .module('leads')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-leads');

        $stateProvider.state('triangular.leads', {
            // set the url of this page
            url: '/leads',
            views: {
                // 'toolbar@triangular':{
                //     templateUrl: 'app/admin-leads/leads-toolbar.tmpl.html',
                //     controller: 'leadsToolbarController',
                //     controllerAs: 'vm'
                // },
                '@triangular': {
                    templateUrl: 'app/admin-leads/leads.tmpl.html',
                    controller: 'LeadsController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                '_teams': ['teamDataService', function (teamDataService) {
                        return teamDataService.getUsersTeams()
                                .then(function (data) {
                                    return data
                                })
                    }]
                //     ,
                // '_leadboard': ['leadDataService', function (leadDataService) {
                //         return leadDataService.getLeadBoard()
                //                 .then(function (data) {
                //                     return data
                //                 })
                //     }]
                }
        });



       // triMenuProvider.addMenu({
       //     // give the menu a name to show (should be translatable and in the il8n folder json)
       //     name: 'Leads',
       //     // point this menu to the state we created in the $stateProvider above
       //     state: 'triangular.leads',
       //     // set the menu type to a link
       //     type: 'link',
       //     // set an icon for this menu
       //     icon: 'fa fa-filter',
       //     // icon: 'zmdi zmdi-accounts-outline',
       //     // set a proirity for this menu item, menu is sorted by priority
       //     priority: 2
       // });
    }
})();

(function() {
    'use strict';

    angular
        .module('leads')
        .controller('leadsToolbarController', leadsToolbarController);

    /* @ngInject */
    function leadsToolbarController($log, $scope, $injector, $rootScope, $state,  $timeout, triSettings,  $stateParams, leadDataService, _userData, teamDataService) {
        // $log.info('leadsToolbarController');
        // For some reason, we absolutely don't have access to vm in our view. But Scope works just fine
        var vm = this;
            vm.user = _userData,
            vm.leadDataService = leadDataService;
            vm.leadDataService.currentView = 'active';
            vm.changeView = changeView;
            vm.leadCount = leadCount;
            vm.selectAccount = selectAccount;
            vm.selectedAccount = $rootScope.userID;
            vm.leadBoard = $rootScope.leadBoard;

            // setup our accountPicker menu
            $timeout(function(){
                vm.usersTeams = teamDataService.teams;
                // Setup our account switcher
                // Our account picklist
                if(_.size(vm.usersTeams) > 1){
                    vm.managedTeams = [];
                    _.each(vm.usersTeams, function(team, index){
                      // if own team not setup, add it manually
                      if(_.has(team, 'members')){
                        if(_.has(team.members[vm.user.uid], 'isTeamAdmin') || team.ownerID == vm.user.uid){
                          team.order = index + 2
                          vm.managedTeams.push(team)
                        }
                      } else {
                        // team is user's own but it's not setup (or they don't have teams)
                        if(team.needsSetup){
                         vm.managedTeams.push({
                           name: "Your account",
                           ownerID: $rootScope.userID,
                           order: 2
                         })
                        }// if needsSetup
                      }// if has members
                    });// each team
                    if(_.size(vm.managedTeams) > 1){
                        vm.showAccountPicker = true;
                    }
                }
            }, 2000);






        function leadCount(status){
            var count = 0;
            if(_.has($rootScope.leadBoard)){
                _.each(vm.leadBoard.leads, function(lead){
                    if(lead.status == status){
                        count = count + 1;
                    }
                });
                return count
            } else {
                return 0
            }

        }

        function changeView(view){
            $timeout(function(){
                vm.leadDataService.currentView = view;
            },0)
        }

        $scope.isActive = function(value){
            if($state.includes(value)){
                return true
            }
        }


        $scope.isTasks = function(){
            if($state.includes('tasks')){
                return true
            }
        }

        // $log.info($scope.hasRecurring);

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;



        // $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;



        function changeState(newState){
            $state.go(newState);
        }


        function selectAccount(teamID, update){
            // set the service
            leadDataService.activeAccount = teamID;
            // emit change
            $rootScope.$emit('accountChanged')
          }

    }
})();

(function() {
    'use strict';

    angular
        .module('adminTeam', ['appServices', 'ngSanitize', 'ngAnimate'])
        .run(function ($state,$rootScope) {
        	// Put state on rootscope so we ALWAYS know what it is.
            $rootScope.$state = $state;

        });
})();

(function() {
    'use strict';

    angular
        .module('adminTeam')
        .controller('teamController', teamController);
        // teamController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function teamController($log, $mdToast, hotkeys, triLoaderService, teamDataService,  $window, $scope, $timeout, gateService, $rootScope, $mdDialog, clientDataService, userDataService, currentAuth, _userData) {
        var vm = this;
        vm.clients = clientDataService.clients;
        vm.user = userDataService.user;
        vm.settings = $rootScope.userSettings;
        vm.teamDataService = teamDataService;
        vm.today = moment();
        vm.sortBy = '-becameMember';


        function init(){
            vm.hasTeams = gateService.gateData.hasTeams;
            vm.teamsSetup = teamDataService.teamsSetup;
            // vm.team = vm.teamDataService.team;
            vm.teamLimit = gateService.gateData.teamLimit;
            vm.teamName = vm.user.profile.fullName;
            vm.subStatus = gateService.gateData.subStatus;
            vm.usersTeams = teamDataService.teams;
            vm.initialized = true;
        }// init

        $timeout(function(){
            if(!teamDataService.teamsSetup){
            return vm.teamDataService.init()
            .then(function(){
                $log.info('teams setup');
                init();
            })
            } else {
                init();
            }
        },1000);

        // $timeout(function(){

        //   triLoaderService.setLoaderActive(false);
        // },1000).then(function(){
        //     init();
        // });



        vm.refreshTeams = function(){

            if(vm.teamDataService.selectedTeam){
                // A team was already selected. We need to reselect them after refreshing our team data

                // store the teamID
                var selectedTeamID = vm.teamDataService.selectedTeam.ownerID;
                // Reset Team Data
                $timeout(function(){
                  vm.teamDataService.init();
                },3000);
                $timeout(function(){
                    init();
                }, 1000)
                // Find and reselect our team
                _.each(vm.usersTeams, function(team){
                    if(team.ownerID == selectedTeamID){
                        $timeout(function(){
                            teamDataService.selectTeam(team);
                        },0);
                    }
                })
            } else {
                // nothing selected, just refresh our data
                $timeout(function(){
                  vm.teamDataService.init();
                },3000);

                $timeout(function(){
                    init();
                }, 1000)
            }

        }


        vm.canAddMembers = function(){
            var count = 0;
            _.each(vm.teamDataService.selectedTeam.members, function(member){
                if(member.status != 'archived'){
                    count = count + 1;
                }
            });
            return count < vm.teamDataService.selectedTeamLimit
        }

        // Monitor for need to refresh team data
       var unwatch = $rootScope.$on('refreshTeams',function() {
         $timeout(function(){
           vm.refreshTeams();
         },0);
       });

       $scope.$on('$destroy', function() {
           vm.teamDataService.selectedTeam = null;
           vm.teamDataService.selectedMember = null;
           unwatch();
       });


        // Support for showing appcues on demand
        vm.showCue = function(cue, flag){
            // trigger our primer
            // Appcues.show(cue);

            // // mark step complete
            // $timeout(function(){
            //     vm.changeOnboardingFlag(flag, true);
            // }, 5000);

        }


        vm.inviteMember = function(team, limit){
            var numMembers = _.size(team.members);
            numMembers = numMembers + 1;
            teamDataService.inviteDialog(team, numMembers, limit);
        }


        vm.setupTeam = function(user,name){
            $timeout(function(){
                vm.loading = true;
            })
            return teamDataService.initializeTeam(user, name)
            .then(function(){
                $timeout(function(){
                  vm.teamDataService.init();
                  // triLoaderService.setLoaderActive(false);
                },3000)
                .then(function(){
                    $timeout(function(){
                        vm.loading = false;
                    })
                    vm.teamsSetup = true;
                     var confirm = $mdDialog.confirm()
                              .title('Your new Team has been configured')
                              .htmlContent('Please refresh your browser to see your changes.')
                              .ariaLabel('Got it')
                              .ok('Got It');

                    $mdDialog.show(confirm).then(function() {

                    });
                });
            });

        }

        vm.changeSort = function(sortBy){
            vm.sortBy = sortBy
        }


        vm.search = function(query){
            vm.memberSearch = query.toLowerCase();
        }

        vm.resetSearch = function(){
            vm.filterText = '';
            vm.memberSearch = '';
            vm.showSearch = false;
        }

        vm.showSortSearch = function(){
            if(_.size(vm.teamDataService.selectedTeam.members) > 2){
                return true
            } else {
                return false
            }
        }

}// teamController
})();

(function () {
    'use strict';

    angular
            .module('adminTeam')
            .config(moduleConfig);
    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {

        $stateProvider
                .state('triangular.manage-team', {
                    abstract: false,
                    url: '/team',
                    templateUrl: 'app/admin-team/admin-team.tmpl.html',
                    // set the controller to load for this page
                    controller: 'teamController',
                    controllerAs: 'vm'
                });

        // add our "Manage Clients" Menu item
        // triMenuProvider.addMenu({
        //     name: 'Teams',
        //     state: 'triangular.manage-team',
        //     icon: 'fa fa-users',
        //     type: 'link',
        //     priority: 10
        // });

    } // end moduleConfig



})();

(function() {
	'use strict';

	angular
		.module('tasks', ['appServices', 'ngAnimate']);
})();

(function() {
    'use strict';

    angular
        .module('tasks')
        .controller('tasksPageController', tasksPageController);

    /* @ngInject*/
    function tasksPageController($q, $log, $mdSidenav, $state, $scope, $timeout, hotkeys, timerDataService, taskTemplateDataService, timeDataService, userDataService,  triLoaderService, teamDataService, $rootScope, clientDataService, taskDataService, kanbanService, profileDataService, localStorageService, $mdToast, _userData, _clientData) {
        $log.info('tasksPageController');
        // $timeout(function(){
        //   triLoaderService.setLoaderActive(true);
        // },0)
        // scope variables
        var vm = this;
        vm.user = _userData;
        var recurringErrorMessage = "This recurring task did not get upgraded properly. Please notify help@getadminja.com and we will fix it asap."
        vm.settings = $rootScope.userSettings;
        vm.priorityFilter = 'none';
        vm.userFilter = 'all';
        vm.searchTerm = '';
        vm.sortBy = 'order';
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.clientCount = _.size(vm.clients);
        vm.colors = $rootScope.boardColors;
        vm.teamDataService = teamDataService;
        vm.teamList = teamDataService.allMembers;
        vm.kanbanService = kanbanService;
        vm.clientLimit = 2;
        vm.userOrder = 'userOrders.user' + vm.user.uid;
        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }
        // Define our data for our priorities filter
        vm.priorities = [
          {
               uid: 1,
               color: 'red',
               label: 'Urgent',
               priority: 1
          },
          {
               uid: 2,
               color: 'orange',
               label: 'Important',
               priority: 2
          },
          {
               uid: 3,
               color: 'green',
               label: 'Neutral',
               priority: 3
          },
          {
               uid: 4,
               color: 'blue',
               label: 'Not Important',
               priority: 4
          }
        ]



        // scoped functions
        vm.filterItems = filterItems;
        vm.sortItems = sortItems;
        vm.toggleSidePanel = toggleSidePanel;
        vm.closeListMenu = closeListMenu;
        vm.closeTaskMenu = closeTaskMenu;
        vm.toggleElementVisibility = toggleElementVisibility;
        vm.updateBoard = updateBoard;
        vm.selectColor = selectColor;
        vm.listMenuNewTask = listMenuNewTask;
        vm.batchTasks = batchTasks;
        vm.newTaskFromTemplate = newTaskFromTemplate;
        vm.size = size;
        vm.remain = remain;
        vm.openClientPackages = openClientPackages;
        vm.setupPackageStatus = setupPackageStats;

        var changedWatchers = {}, addedWatchers = {}, removedWatchers = {};

        if($state.current.name == 'triangular.today'){
          kanbanService.setAllTaskView('today');
        } else {
          kanbanService.setAllTaskView('all');
        }

        // Forced TODAY view background color
        vm.todayBGColor = 'rgb(248, 248, 156)';

        // boardSettings
        // if user doesn't have boardSettings, set them, if they do, use them.
        if(!_.has(vm.settings, 'allTaskSettings')){
              $log.info('Setting user\'s default allTask settings');
              var defaultAllTaskSettings = {
               color: '#ddd',
               excludeClosed: true,
               useAllOrder: true,
               showAssignee: true,
               showDetails: true,
               showRestLines: true,
               showTimeControls: true,
               showWorkspaceName: true
            };
            // make sure we have immediate local access
            vm.settings.allTaskSettings = defaultAllTaskSettings;
            // store it for future visits
            firebase.database().ref('/users/' + vm.user.uid + '/profile/settings/allTaskSettings').set(defaultAllTaskSettings);
        };

       // muuri variables
        var columnGrids = [],
          boardElement,
          boardGrid,
          dragContainer = document.querySelector('.drag-container'),
          boardContainer = document.querySelector('.adminja-board-container'),
          itemDrag = {},
          columnDrag = {},
          resizeTimer,
          unwatchMode,
          setupComplete = false,
          boardLayout,
          roles = {};

          if(_.has(teamDataService, 'clientTeams')){
            setRole();
            init();
          } else {
            $timeout(function(){
              setRole()
            },1000)
            .then(function(){
              init();
            })
          }


          // persistent listener
          // Set our resize listener
          window.addEventListener('resize', windowResize, false);

      function windowResize(e){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          resizeBoard('window-size-change');
        }, 500);
      }//windowResize

       function init(){


            if(_.has(kanbanService, 'taskTemplate')){
                // Set our initial board and column heights
                resizeBoard('pre-initialize');

                initializeMainBoard();
                // this view combines owned and delegated and internal workspaces and each group relies on userOrders ordering which can't be combined here.
                // make sure we have an allOrders node on each client (will get set the first time user re-orders their worskpaces)
                _.each(vm.clients, function(client){
                  if(_.has(client, 'allOrders')){
                    if(_.has(client.allOrders, 'user'+vm.user.uid)){
                      client.sortBy = client.allOrders['user'+vm.user.uid]
                    }
                  }
                })

                vm.clients = _.sortBy(vm.clients,
                  [function(o) { return o.sortBy; }]);

                // we are skipping VA workspaces (clients don't have allTasks? we may need to change this)
                _.each(vm.clients, function(client){
                  addList(client)
                });

                boardLayout = {
                            horizontal: true,
                            fillGaps: true,
                          }

                if(_.has(vm.settings, 'verticalTaskPanels')){
                    if(vm.settings.verticalTaskPanels){
                        boardLayout = {
                           horizontal: false,
                           fillGaps: false,
                        }
                    }
                }

                // Setup our Listeners
                boardElement = document.querySelector('.board');
                boardContainer = document.querySelector('.adminja-board-container');
                setupListeners();

                hotkeys.add({
                  combo: 'esc',
                  description: 'Escape',
                  allowIn: ['TEXTAREA'],
                  callback: function(event, hotkey) {
                    event.preventDefault();
                    $log.info('escape');
                    if(vm.taskMenuOpen){
                      closeTaskMenu();
                    }
                    if(vm.taskFormVisible && vm.taskFormParentGrid){
                      closeQuickTaskForm();
                    }
                  }
                });
                hotkeys.add({
                    combo: 'ctrl+enter',
                    allowIn: ['TEXTAREA'],
                    description: 'Save Task',
                    callback: function (event) {
                        $log.info('ctrl+enter');
                        event.preventDefault();
                        if(vm.taskFormVisible){
                          saveQuickTask();
                        }
                    }
                });

                hotkeys.add({
                    combo: 'ctrl+alt+f',
                    description: 'Find and Filter',
                    callback: function (event) {
                        $log.info('Find & Filter');
                        vm.toggleSidePanel('board');
                    }
                });

                // Get our team members for team filter list
                vm.teamList = teamDataService.allMembers;
                setupWatchers();

              // make sure we have proper dimensions so horizontal scroll appears if necessary
              $timeout(function() {
                _.each(columnGrids, function(grid){
                  grid.refreshItems().layout();
                });
                boardGrid.refreshItems().layout();
                $timeout(function(){
                  resizeBoard();
                }, 2000)
                .then(function(){
                  boardGrid.sort('order', {layout: 'instant'});
                  setupComplete = true;
                  triLoaderService.setLoaderActive(false);
                })
              }, 500)
            } else {
                return kanbanService.init()
                .then(function(){
                  init()
                })
            }
       }//init


       /////////////////////////////////
       // Main
       function addList(client, suppressAnimation) {
         // $log.info('addList');

         // Create the column element.
         // sort each list's items so we don't need to rely on muuri to sort them initially
         var list = {
             order: client.sortBy,
             avatar: client.profile.avatar,
             uid: client.uid,
             label: client.profile.fullName,
             color: client.profile.clientColor,
             items: client.tasks,
             type: 'workspace'
         };


         list.items = _.sortBy(list.items,
           [function(o) { return o.allOrder; }]);


         var wrapper = document.createElement('div');
         var columnHTML = kanbanService.newTaskListElement(list, vm.settings.allTaskSettings, roles[client.uid]);
         if(columnHTML){
          wrapper.innerHTML = columnHTML;

          // Add the column to the DOM
          var columnElem = wrapper.children[0];
          if (!suppressAnimation) {
            initColumn(columnElem, list.order); // init this column's grid
          } else {
            fastInitColumn(columnElem, list.order)
          }
         }

       } // addList

       function removeList(client) {
         _.each(boardGrid.getItems(), function(item) {
           var gridID = item.getElement().getAttribute('data-id');
           if (client.uid == gridID) {
             boardGrid.remove([item], { removeElements: true });
           }
         });
       } //removeList

       // InitColumn functions call instantiate in different ways
       function fastInitColumn(columnElem, order) {

         var contentElem = columnElem.querySelector('.board-column-content');
         boardGrid.add([columnElem], { index: order });
         instantiateColumn(contentElem);
       } //fastInitColumn

       function initColumn(columnElem, order) {
         var contentElem = columnElem.querySelector('.board-column-content');
         boardGrid.show(
           boardGrid.add([columnElem], {
             active: false,
             index: order
           }), {
             onFinish: function(){
               // Instantiate grid
               instantiateColumn(contentElem)
             }
           }
         )
       } // initColumn

       function instantiateColumn(contentElem) {
         // $log.info('instantiate column grid!');
         var grid = new Muuri(contentElem, {
             items: '.board-item',
             layout: boardLayout,
             layoutDuration: 400,
             layoutOnResize: 200,
             layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
             // layoutEasing: 'none',
             dragEnabled: true,
             // dragSort: function() {
             //   return columnGrids;
             // },
             dragSortPredicate: function(item) {
               var thisGrid = item.getGrid(),
                 gridElem = thisGrid.getElement(),
                 itemID = item.getElement().getAttribute('data-id'),
                 defaultPredicate = Muuri.ItemDrag.defaultSortPredicate(item, {
                   action: 'move',
                   threshold: 50
                 });

               if ($(gridElem).hasClass('drag-disabled') || itemID == 'new-task') {
                 $log.info('new task. blocking drag');
                 return false
               } else {
                 return defaultPredicate
               }

             },
             // dragAxis: 'y',
             dragSortInterval: 200,
             dragContainer: dragContainer,
             dragReleaseDuration: 1000,
             dragReleaseEasing: 'ease',
             dragSortHeuristics: {
               sortInterval: 0,
               minDragDistance: 10,
               minBounceBackAngle: 1
             },
             dragPlaceholder: {
               enabled: true,
               createElement: null,
               onCreate: null,
               onRemove: null
             },
             dragStartPredicate: {
               distance: 20,
               delay: 0
             },
             dragAutoScroll: {
               targets: function(item){
                 return [
                   window,
                   {
                     element: boardContainer,
                     priority: 1,
                     axis: Muuri.AutoScroller.AXIS_X,
                   },
                   {
                     element: item.getGrid().getElement().parentNode,
                     priority: 1,
                     axis: Muuri.AutoScroller.AXIS_Y,
                   },
                 ];
               }
             },
             hideDuration: 0,
             showDuration: 0,
             sortData: {
               order: function(item, element) {
                 return Number(element.getAttribute('data-allorder')) || '';
               },
               due: function(item, element) {
                 return element.getAttribute('data-due') || '2050-01-01T00:00:00+0000';
               },
               priority: function(item, element) {
                 return element.getAttribute('data-priority') || 1000;
               },
               title: function(item, element) {
                 return element.getAttribute('data-title') || '';
               },
               assignee: function(item, element) {
                 return element.getAttribute('data-assignee') || '';
               },
             }

           })
           .on('dragStart', function(item, event) {
            // disable text selection on drag (safari bug)
            if (window.getSelection) {window.getSelection().removeAllRanges();}
            else if (document.selection) {document.selection.empty();}

             // Let's set fixed widht/height to the dragged item
             // so that it does not stretch unwillingly when
             // it's appended to the document body for the
             // duration of the drag.
             item.getElement().style.width = item.getWidth() + 'px';
             item.getElement().style.height = item.getHeight() + 'px';

             // define some of our itemDrag properties
             itemDrag.itemID = item.getElement().getAttribute('data-id');
             // we don't want to do anything if new task form dragged
             if(itemDrag.itemID != 'new-task'){
               itemDrag.item = item;
               itemDrag.sourceGrid = item.getGrid();
               itemDrag.sourceGridID = itemDrag.sourceGrid.getElement().getAttribute('data-id');
               itemDrag.sourceIndex = itemDrag.sourceGrid.getItems().indexOf(item);
               // Get the item's data
               _.each(vm.clients, function(client) {
                 if (client.uid == itemDrag.sourceGridID) {
                   _.each(client.items, function(listItem) {
                     if (listItem.uid == itemDrag.itemID) {
                       itemDrag.itemData = listItem;
                     }
                   })
                 }
               });
             }


           })
           // .on('layoutStart', function () {
           //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
           // })
           .on('receive', function(data) {
             // add targetGrid information to itemDrag
             itemDrag.targetGrid = data.toGrid;
             itemDrag.targetGridID = data.toGrid._element.getAttribute('data-id');
           })
           .on('dragReleaseEnd', function(item, event) {
             if(itemDrag.itemID != 'new-task'){
               // Process the new task position
               itemDrag.sourceScroll =  $('.board-column-content[data-id='+itemDrag.sourceGridID+']').closest('.board-column-content-wrapper').scrollTop();
               return updateTaskDrop(itemDrag)
               .then(function(){
                $timeout(function(){
                    $('.board-column-content[data-id='+itemDrag.sourceGridID+']').closest('.board-column-content-wrapper').scrollTop(itemDrag.sourceScroll);
                    resetDragData();
                }, 500)
               })
             }
           });

         grid.sort('order', { layout: 'instant' });
         columnGrids.push(grid);
         resizeBoard('after-list-push');

       } //instantiateColumn

       function initializeMainBoard(){
            Muuri.defaultPacker.destroy();
            Muuri.defaultPacker = new Muuri.Packer(0);
            boardGrid = new Muuri('.board', {
                layout: {
                  horizontal: true,
                },
                layoutOnInit: false,
                layoutOnResize: 200,
                layoutDuration: 300,
                layoutEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                dragEnabled: true,
                dragContainer: dragContainer,
                dragSort: columnGrids,
                dragAxis: 'x',
                dragSortInterval: 200,
                dragHandle: '.drag-handle',
                dragStartPredicate: {
                    distance: 20,
                    delay: 250,
                  },
                dragReleaseDuration: 400,
                dragReleaseEasing: 'ease',
                dragAutoScroll: {
                  sortDuringScroll: true,
                  targets: function(item){
                    return [
                      { element: window, priority: 0 },
                      { element: item.getGrid().getElement().parentNode, priority: 1 },
                    ];
                  }
                },
                itemDraggingClass: 'column-dragging',
                sortData: {
                  order: function(item, element) {
                    return parseFloat(element.getAttribute('data-order'));
                  },
                }
              })
            .on('dragStart', function(item, event) {
              // disable text selection on drag (safari bug)
              if (window.getSelection) {window.getSelection().removeAllRanges();}
              else if (document.selection) {document.selection.empty();}

              columnDrag.columnID = item.getElement().getAttribute('data-id');
              columnDrag.startIndex = boardGrid.getItems().indexOf(item);
              // Let's set fixed widht/height to the dragged item so that it does not stretch unwillingly when it's appended to the document body for the duration of the drag.
              item.getElement().style.width = item.getWidth() + 'px';
              item.getElement().style.height = item.getHeight() + 'px';
            })
            .on('dragEnd', function(item, event) {
              columnDrag.targetIndex = boardGrid.getItems().indexOf(item);

              // Let's remove the fixed width/height from the dragged item now that it is back in a grid column and can freely adjust to it's surroundings.
              item.getElement().style.width = '';
              item.getElement().style.height = '';

                return updateColumnSort()
                  .then(function() {
                    // Just in case, let's refresh the dimensions of all items
                    // in case dragging the item caused some other items to
                    // be different size.
                    // boardGrid.refreshItems();
                  })
            })
            // .on('layoutStart', function () {
            //   // DO NOT EVER USE LAYOUTSTART! MEMORY LEAK!
            // })
       }//initializeMainBoard

       function updateColumnSort() {
         return new Promise(function(resolve, reject) {
           var columns = boardGrid.getItems(),
             updates = {};
           _.each(columns, function(column) {
             var columnElem = column.getElement(),
               columnItemContainer = columnElem.querySelector('.board-column-content'),
               index = boardGrid.getItems().indexOf(column),
               uid = columnElem.getAttribute('data-id');
               if(uid && uid != 'undefined'){
                 var order = index;
                 // Add to DB changes
                 updates['/clients/' + uid + '/allOrders/user' + vm.user.uid] = order;
               }
           });

           return firebase.database().ref().update(updates)
             .then(function() {
               boardGrid.synchronize();
               return resolve(resetDragData())
             })
             .catch(function(error) {
               throwError(error);
             })
         });
       } //updateColumnSort

        function moveToggledTask(updatedTask){
          var moveData = {},
              item,
              targetGridID,
              targetGrid,
              sourceGridID,
              sourceGrid,
              targetGridIndex,
              sourceGridIndex,
              itemIndex;

          if(updatedTask.status == 'closed'){
              targetGridID = vm.boardData.closedList;
              sourceGridID = updatedTask.list;
            } else {
              targetGridID = vm.boardData.defaultList;
              sourceGridID = vm.boardData.closedList;
            }

            _.each(columnGrids, function(grid){
              if(grid.getElement().getAttribute('data-id') == targetGridID){
                targetGrid = grid;
                targetGridIndex = boardGrid.getItems().indexOf(targetGrid);
              }
              if(grid.getElement().getAttribute('data-id') == sourceGridID){
                sourceGrid = grid;
                sourceGridIndex = boardGrid.getItems().indexOf(sourceGrid);
                _.each(sourceGrid.getItems(), function(thisItem){
                  if(thisItem.getElement().getAttribute('data-id') == updatedTask.uid){
                    item = thisItem;
                    itemIndex = sourceGrid.getItems().indexOf(item);
                  }
                });//each items in sourcegrid
              }
            });// each grid

            sourceGrid.send(itemIndex, targetGrid, 0);

            moveData = {
              item: item,
              itemData: updatedTask,
              itemID: updatedTask.uid,
              sourceGrid: sourceGrid,
              sourceGridID: sourceGridID,
              targetGrid: targetGrid,
              targetGridID: targetGridID,
              targetIndex: 0
            }


            return updateTaskDrop(moveData)
            .then(function(){
              $log.info('Task Moved after Toggle');;
            })
            .catch(function(error){
              $log.error(error);
              throwError(error)
            });
        }//moveToggledTask

        function updateTaskDrop(itemDrag){
            $log.info('updateTaskDrop');
            return new Promise(function(resolve, reject) {
              var updates = {};
              // $log.info('Dropped from ' + itemDrag.sourceGridID + ' to ' + itemDrag.targetGridID);

                if(itemDrag.sourceGrid){
                  var sourceItems = itemDrag.sourceGrid.getItems();
                  _.each(sourceItems, function(item) {
                    var itemElem = item.getElement(),
                        itemID = itemElem.getAttribute('data-id'),
                        boardID = itemElem.getAttribute('data-board'),
                        listID = itemElem.getAttribute('data-list'),
                        clientID = itemElem.getAttribute('data-workspace'),
                        index = sourceItems.indexOf(item);
                        updates['/clients/' + clientID + '/tasks/' + itemID + '/allOrder'] = index;
                        updates['/taskBoards/' + boardID + '/lists/' + listID + '/items/' + itemID + '/allOrder'] = index;
                        updates['/tasks/' + itemID + '/info/allOrder'] = index;
                });
                    // Update the database
                    return firebase.database().ref().update(updates)
                    .then(function(){
                        // boardGrid.refreshItems();
                        // boardGrid.synchronize();
                        // itemDrag.sourceGrid.refreshItems();
                        // itemDrag.sourceGrid.refreshSortData();
                        // itemDrag.sourceGrid.layout();
                        // itemDrag.sourceGrid.synchronize();
                        // filterItems();
                        boardGrid.refreshItems().layout();
                        $log.info('taskDrop update complete');
                        return resolve(true)
                    })
                      .catch(function(error) {
                        throwError(error);
                      })
                }  else {
                  $log.error('itemDrag SourceGrid missing!');
                  $log.info(itemDrag);
                  return
                }

            })
        }//updateTaskDrop

        function updateTask(task){
          $log.info('updateTask');
          // we've already updated our local data
            var shouldUpdate = true;
            // was this the result of a drag operation?
            if(itemDrag.item){
              // if it wasn't dragged out of sourceGrid, we shouldn't update
              if(!itemDrag.targetGridID){
                  shouldUpdate = false;
                }
              // if it was dragged out of sourceGrid BUT ended up back in sourceGrid, we shouldn't update
              if(itemDrag.targetGridID){
                if(itemDrag.targetGridID == itemDrag.sourceGridID){
                  shouldUpdate = false;
                }
              }
            }

            if(shouldUpdate){
              _.each(columnGrids, function(grid){
                if(grid.getElement().getAttribute('data-id') == task.client){
                  _.each(grid.getItems(), function(item){
                      var itemIndex = grid.getItems().indexOf(item);
                      if(item.getElement().getAttribute('data-id') == task.uid){
                          var index = grid.getItems().indexOf(item);
                          grid.remove([item], { removeElements: true });
                          if(task.status == 'open'){
                            addTask(grid, task, itemIndex, vm.settings.allTaskSettings, 'owner')
                          }
                      }
                      grid.refreshItems().layout();
                  })
                  boardGrid.refreshItems().layout();
                }
              });
            }
        }//updateTask

        function addTask(grid, taskData, index, settings, userRole){
          // $log.info('addTask');
          var wrapper = document.createElement('div');
          var taskHTML = kanbanService.newTaskElement(taskData, settings, roles[taskData.client]);
          wrapper.innerHTML = taskHTML;
          var taskElement = wrapper.firstChild
          // $log.info('index: ' + index + ' userRole: ' + roles[taskData.client]);
          // $log.info(taskElement);
          // if we are in today mode, we should only be adding tasks that are due or flagged
          if(kanbanService.allTasksView != 'today'){
            var newItem = grid.add([taskElement], { active: true, index: index, layout: true});
          } else if (kanbanService.allTasksView == 'today' && (taskData.priority || taskData.duedate <= moment().endOf('day').toISOString())){
            var newItem = grid.add([taskElement], { active: true, index: index, layout: true});
          }
          grid.refreshItems();
          grid.refreshSortData();
          grid.layout();
        }// addTask

        function addNewTask(client, task){
          _.each(columnGrids, function(grid){
            if(grid.getElement().getAttribute('data-id') == client.uid){
              // Make sure we aren't adding a duplicate
              var found = false;
              _.each(grid.getItems(), function(item){
                if(item.getElement().getAttribute('data-id') == task.uid){
                  found = true;
                }
              });
              if(!found){
                addTask(grid, task, task.allOrder, vm.settings.allTaskSettings, roles[client.uid]);
                boardGrid.refreshItems();
                boardGrid.layout();
              }
            }
          })
        }//addNewTask

        function quickTask(parentElement, event) {
          $log.info('quickTask');
          hotkeys.add({
              combo: 'ctrl+enter',
              allowIn: ['TEXTAREA'],
              description: 'Save Task',
              callback: function (event) {
                  $log.info('ctrl+enter');
                  event.preventDefault();
                  if(vm.taskFormVisible){
                    saveQuickTask();
                  }
              }
          });
          $timeout(function(){
            var wrapper = document.createElement('div');
            var taskFormHTML = '<div class="quick-task-container board-item" data-id="new-task">' +
              '<form onsubmit="saveQuickTask()" class="quick-task-form">' +
                '<textarea class="quick-task-description" name="quicktaskdescription"></textarea>'+
                '<div class="quick-task-controls">'+
                  '<p class="right"><a class="quick-task-save-button">Add</a></p>' +
                  '<p class="right hotkey-label" style="padding-right: 1em;">ctrl + enter</p>'+
                '</div>' +
              '</form>'+
            '</div>';
            wrapper.innerHTML = taskFormHTML;

            // Add the column to the DOM
            vm.taskFormElement = wrapper.children[0];
            // get the parentID
            var parentID = parentElement.getAttribute('data-id');

              // find the parentGrid
              _.each(columnGrids, function(grid) {
                if (grid.getElement().getAttribute('data-id') == parentID) {
                  vm.taskFormParentGrid = grid;
                }
              });

                vm.taskFormParentGrid.add([vm.taskFormElement], { index: 0 });
                vm.taskFormVisible = true;

                // auto-focus on the textarea
              $( ".quick-task-form .quick-task-description" ).focus();


          });
        }//quickTask

        function saveQuickTask(){
          return new Promise(function(resolve, reject){
            //Get quicktaskdescription so we can save it
            var taskDescription = $( ".quick-task-form .quick-task-description" ).val(),
              clientID = vm.taskFormParentGrid.getElement().getAttribute('data-id'),
              thisClient,
              boardID,
              listID;

            // get the client
            _.each(vm.clients, function(client){
              if(client.uid == clientID){
                thisClient = client;
                boardID = thisClient.defaultTaskBoard;
                listID = thisClient.taskBoards[boardID].defaultList;

                // only continue if we have description and list
                if(taskDescription.length > 0 && listID){
                  // determine if we will need to scroll to position after saving
                  var scrollAfter = false,
                      boardWidth = $('.board').outerWidth(true), // widest
                      contentWidth = $('.adminja-board-container').outerWidth(true),
                      scrollPosition = $('.adminja-board-container').scrollLeft() + event.screenX; // where clicked
                      // if new task triggered near end of board, we will need to scroll to it after this update due to muuri jumping
                      if (scrollPosition >= (boardWidth - 50)) {
                        scrollAfter = true;
                      }
                      closeQuickTaskForm();

                      // Update the sort on existing items (starting at 2)
                      var parentItems = vm.taskFormParentGrid.getItems(),
                        updates = {},
                        order = 1;

                      _.each(parentItems, function(item) {
                        var itemElement = item.getElement(),
                          itemID = itemElement.getAttribute('data-id')
                        updates['/taskBoards/' + boardID + '/lists/' + listID + '/items/' + itemID + '/allOrder'] = order;
                        updates['/clients/' + thisClient.uid + '/tasks/' + itemID + '/allOrder'] = order;
                        // update the main task
                        updates['/tasks/' + itemID + '/info/allOrder'] = order;
                        order++
                      });

                      return firebase.database().ref().update(updates)
                        .then(function() {
                          // now add our task with order of 1
                          var newTask = taskDataService.newTask(thisClient.uid, listID);
                          newTask.info.description = taskDescription;
                          newTask.info.allOrder = 0;
                          if(vm.kanbanService.allTasksView == 'today'){
                            newTask.info.priority = vm.priorities[0]
                          }
                          return resolve(taskDataService.saveNew(newTask))
                        })
                        .catch(function(error) {
                          throwError(error);
                        })
                }// if valid quickTask
                else {
                  closeQuickTaskForm();
                }

              }
            })

          });
        }//saveQuickTask

        function toggleElementVisibility(){
          return updateBoard()
          .then(function(){
            // destroy all grids
            _.each(columnGrids, function(grid) {
                   grid.destroy(true);
             })
             boardGrid.destroy(true);
             init();
            // re-init Grid
          })
        }//toggleElementVisibility

        function updateBoard(){
          return new Promise(function(resolve, reject){
            $timeout(function(){
              vm.boardUpdating = true;
            })
            .then(function(){
              var updates = {};
              updates['/users/' + vm.user.uid + '/profile/settings/allTaskSettings'] = vm.settings.allTaskSettings;
              return firebase.database().ref().update(updates)
                .then(function() {
                  $log.info('board settings updated');
                  return resolve(true);
                  // location.reload()
                })
                .catch(function(error) {
                  reject(throwError(error));
                })
            })
          })
        }//updateBoard

        function filterToday(){
          _.each(columnGrids, function(grid){
            grid.filter(function(item){
              var pass = false;
              var element = item.getElement(),
                  priority = element.getAttribute('data-priority'),
                  due = element.getAttribute('data-due');

                  if(priority){
                    pass = true;
                  }

                  if(due){
                    if(moment(due).toISOString() <= moment().toISOString()){
                      pass = true;
                    }
                  }
                  return pass
            })
          })
        }//filterToday

        function resetFilters(){
          _.each(columnGrids, function(grid){
            grid.filter(function(item){
              return true
            })
          })
        }//resetFilters

        function filterItems(onFinish) {
            var priorityFilter = vm.priorityFilter,
                  userFilter = vm.userFilter,
                  searchFieldValue = vm.searchTerm.toLowerCase();

            _.each(columnGrids, function(grid) {
              grid.filter(function(item){
                  var element = item.getElement();
                  // we should be checking against content of .firstline and .restlines
                  // concatenate contents of both and then search against it
                  var firstline = $(element).find('.firstline').text(),
                      restlines = $(element).find('.restlines').text(),
                      textToSearch = firstline;
                      if(restlines){
                        textToSearch = textToSearch + restlines
                      }

                  var isSearchMatch = !searchFieldValue || (textToSearch).toLowerCase().indexOf(searchFieldValue) > -1;


                  var isPriorityMatch = false;
                  if(priorityFilter == 'none'){
                    isPriorityMatch = true;
                  } else {
                    if(priorityFilter == element.getAttribute('data-priority') ){
                      isPriorityMatch = true;
                    }
                  }

                  var isUserMatch = false;
                  if(userFilter == 'all'){
                    isUserMatch = true;
                    } else {
                      if (userFilter == element.getAttribute('data-assignee')){
                        isUserMatch = true;
                      }
                    }

                  return isSearchMatch && isPriorityMatch && isUserMatch;
                }, {  }
              );
            })
        } //filterItems

        function sortItems(sortBy) {
          // refresh in case itesm have been dragged around recently
          _.each(columnGrids, function(grid) {
            grid.refreshItems();
            grid.refreshSortData();
          })
          _.each(columnGrids, function(grid) {
            if(grid){
              updateDragState(grid, sortBy);
              grid.sort(
                sortBy === 'due' ? 'due order' : sortBy === 'priority' ? 'priority title' : sortBy === 'assignee' ? 'assignee order' : 'order'
              );
            }
          });
        } // sortItems


        ///////////////////////////////////////
        // Utilities

        function setRole(){
          // Prepare our roles array
          _.each(vm.clients, function(client){
            var userRole = 'owner';
            if(_.has(teamDataService.clientTeams, client.uid)){
                var teamSize = _.keys(teamDataService.clientTeams[client.uid]).length;
                // if we have a team, check for permissions to edit otherwise, allow it
                if(teamSize > 0 && _.has(teamDataService.clientTeams[client.uid], $rootScope.userID)){
                    userRole = teamDataService.clientTeams[client.uid][$rootScope.userID].role;
                }
                // check if clientUser and set userRole if so
                if(_.has($rootScope, 'VAWorkspaces')){
                    if(_.has($rootScope.VAWorkspaces, client.uid)){
                            userRole = 'client';
                    }
                }
            }
           roles[client.uid] = userRole;
          });
        }// setRole

        function remain(budget, used){
             return Number(budget) - Number(used)
        }

        function setupPackageStats(client){
                return new Promise(function(resolve, reject){
                  var packageStats = {};
                    ///////// BIlling PERIOD CALCS
                    ///////////PACKAGE CALCS
                    if(client.billingType == 'packages'){
                      _.each(client.packages, function(thisPackage){
                        var result = {};
                        var percentUsed = Number(thisPackage.qualifiedMinutes) / Number(thisPackage.budgetedMinutes);
                        if(thisPackage.type != 'hourly'){
                            result.progressBarPercent = 1 - percentUsed;
                            // we get Nan when dividing zeroes
                            if (isNaN(result.progressBarPercent)) {
                                result.progressBarPercent = 1;
                              }
                        }

                        if(thisPackage.type == 'hourly'){
                            result.progressBarPercent = percentUsed;
                            // we get Nan when dividing zeroes
                            if (isNaN(result.progressBarPercent)) {
                                result.progressBarPercent = 0;
                              }
                        }

                        // if we've gone over budget, progressbar should draw 0%
                        if(percentUsed > 1){
                          result.progressBarPercent = 0;
                        }

                        result.progressBarPercentLabel = Number(result.progressBarPercent * 100).toFixed(0) + '%';
                        result.packageBalance = thisPackage.budgetedMinutes - thisPackage.qualifiedMinutes;

                        // Convoluted because we don't always have 'cost' and 'charges'
                        if(thisPackage.type != 'hourly'){
                            if(_.has(thisPackage, 'charges')){
                                result.totalCost = Number(thisPackage.charges).toFixed(2);
                            }
                        } else {
                            result.totalCost = Number(thisPackage.accrued) + Number(thisPackage.charges);
                        }

                        // we need to remove base cost from charges so charges displayed are "additional"

                        // Make sure we don't attempt to draw out a negative number or number greater than 100%
                        if(result.progressBarPercent > 1){
                            result.progressBarPercent = 1;
                        }

                        if(thisPackage.type != 'hourly'){
                            if(result.progressBarPercent >= .34){
                               result.progressBarColor = 'rgb(76, 175, 80)'
                            }

                            if(result.progressBarPercent < .33){
                               result.progressBarColor = '#f36d0a'
                            }

                            if(result.progressBarPercent < .15){
                               result.progressBarColor = '#f42323'
                            }

                            // we want an alert-colored background if we are over budget
                            if(result.progressBarPercent <= 0){
                                // result.progressBarPercent = 0
                                result.progressBarBackgroundColor = '#FBD6D6';
                            } else {
                                result.progressBarBackgroundColor = '#efefef';
                            }
                        }// retainer labels

                        if(thisPackage.type == 'hourly'){
                            if(result.progressBarPercent >= .75){
                               result.progressBarColor = 'rgb(76, 175, 80)'
                            }

                            if(result.progressBarPercent < .75){
                               result.progressBarColor = '#f36d0a'
                            }

                            if(result.progressBarPercent < .15){
                               result.progressBarColor = '#efefef'
                            }

                            if(result.packageBalance < 0){
                                result.packageBalance = 0;
                            }
                            // we want an alert-colored background if we are over budget
                            result.progressBarBackgroundColor = '#efefef';
                        }// retainer labels
                        packageStats[thisPackage.uid] = result;
                      });// each package
                    }// if packages
                  return resolve(packageStats)
                })
              }//setupPackageStats

        function openClientPackages(client){
            var billingType = 'periods';
            if(_.has(client, 'billingType')){
              billingType = client.billingType;
            }

            if(billingType == 'packages'){
                $state.go("triangular.workspaces.client-billing", {"clientID": client.uid});
            }

            if(billingType == 'periods'){
             $state.go("triangular.workspaces.client-legacy-billing", {"clientID": client.uid});
            }

        }//openClientPackages

        function size(items){
          return _.size(items)
        }//size

        function listMenuNewTask(client) {
                    // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
                    var listID = client.taskBoards[client.defaultTaskBoard].defaultList;
                    var newTask = taskDataService.newTask(client.uid, listID);
                    newTask.info.order = -1;
                    taskDataService.taskDialog(newTask);
        }

        function batchTasks(client){
          var listID = client.taskBoards[client.defaultTaskBoard].defaultList;
            return taskDataService.batchDialog(client.uid, listID, client.defaultTaskBoard);
        }

        function newTaskFromTemplate(client, template) {
                    userDataService.trackEvent('new-task-from-template');
                    return taskTemplateDataService.getTaskTemplate(template.uid)
                             .then(function(thisTemplate){
                               var clone = ajUTILITIES.removePropertiesWith(thisTemplate);
                               var listID = client.taskBoards[client.defaultTaskBoard].defaultList;
                               // remove any template-only values
                               delete clone.type;
                               delete clone.schedule;
                               delete clone.isRecurring;
                               delete clone.uid;
                               delete clone.info.refID;
                               // delete clone.$id;
                               // delete clone.$priority;
                               // delete clone.$key;


                               clone.info.order = 0;
                               clone.info.allOrder = 0;
                               clone.info.list = listID;
                               clone.info.board = client.defaultTaskBoard;
                               clone.created = moment().unix();
                               taskDataService.taskDialog(clone, 0, true);
                             });
        }//newTaskFromTemplate


        function updateDragState(grid, sortBy) {
          var gridElem = grid.getElement();
          if (sortBy === 'order') {
            gridElem.classList.remove('drag-disabled');
          } else {
            gridElem.classList.add('drag-disabled');
          }
        } //updateDragState

        function selectColor(){
          $log.info('selectBoardColor');
          if(vm.sidePanelMode == 'board'){
            vm.forms.boardForm.$setDirty();
            updateBoard();
          }
        }// selectBoardColor

        function resizeBoard(when) {
            // $log.info('resizeBoard');
              var contentHeight = $('.task-board-wrapper').height() - 10,
                boardHeight = contentHeight - 10; // for padding above and below
              $('.adminja-board-container').height(contentHeight);
              $('.board').height(boardHeight)
              $('.board-column').height('auto');
              if(!vm.settings.verticalTaskPanels){
                $('.board-column-content').height(boardHeight - 60);
              }
              $('.board-column-content-wrapper').height(boardHeight - 50);
              // make sure our main md-content doesn't scroll vertically
              $('md-content.triangular-content').css('overflow-y', 'hidden');
              if(setupComplete){
                  _.each(columnGrids, function(grid){
                    grid.refreshItems().layout()
                  });
                  boardGrid.refreshItems().layout();

              }
        } // resizeBoard

        function throwError(error) {
              $log.error(error);
              alert('There was a problem. Please refresh. /n' + error);
        } //throwError



       function getTaskData(taskID){
         // for simplicity's sake, we search through client/{clientID}/tasks to find the task data.
         // this saves us from first finding the proper list AND THEN task in boardData;
         return new Promise(function(resolve, reject){
           _.each(vm.clients, function(client){
             _.each(client.tasks, function(item){
                 if(item.uid == taskID || item.refID == taskID){
                   if(_.has(item, 'refID')){
                     if(item.refID != item.uid){
                       return reject(alert(recurringErrorMessage))
                     } else {
                       return resolve(item)
                     }
                   } else {
                     return resolve(item)
                   }
                 }

             })
           });

           return reject('task-not-found')
         })
       }//getTaskData

       function editTask(taskID, targetTab){
         return taskDataService.getTask(taskID)
             .then(function(editedItem){
                 // closed tasks are not editable
                 if(_.has(editedItem, 'info.uid')){
                 if(editedItem.info.status == 'open'){
                   // convert our due date into a date object for md-date-picker
                   if (_.has(editedItem, 'info.duedate')) {
                       editedItem.info.duedate = new Date(editedItem.info.duedate);
                   }
                   // send it to our dialog
                   taskDataService.taskDialog(editedItem, targetTab);
                 }} else {
                  alert(recurringErrorMessage)
                 }
             })
       }// editTask

        function closeQuickTaskForm(){
          if(vm.taskFormParentGrid && vm.taskFormVisible){
            vm.taskFormParentGrid.remove(vm.taskFormParentGrid.getItems(0), { removeElements: true });
            $timeout(function(){
              vm.taskFormVisible = false;
              vm.taskFormParentGrid = null;
            })
          }
        }//closeQuickTaskForm

        function openTaskMenu(item, e){
          var rect = e.target.getBoundingClientRect();
          vm.y = rect.top - 50;
          vm.x = rect.right - 225;
          var boardWidth = $('.triangular-content').outerWidth(true);
          var boardHeight = $('.triangular-content').outerHeight(true);

          // make sure none of the menu is offscreen horizontally
          if (vm.x > (boardWidth - 300)) {
            vm.x = vm.x - 300;
          }

          // make sure none of the menu is offscreen vertically
          if (vm.y > (boardHeight - 400)) {
            vm.y = vm.y - 450;
          }
          // Get the boardData for the client
          _.each(vm.clients, function(client){
            if(client.uid == item.client){
              vm.boardData = client.taskBoards[item.board];
            }
          });
          // this triggers the menu directive to activate and position itself
          $timeout(function(){
            vm.selectedTask = item;
            vm.taskMenuOpen = true;
          },0)
        }//openTaskMenu

        function closeListMenu() {
          $('#list-menu').css('display', 'none');
          $timeout(function() {
            vm.listMenuOpen = false;
          })
        } //closeListMenu

        function closeTaskMenu() {
          $('#task-menu').css('display', 'none')
          $timeout(function() {
            vm.taskMenuOpen = false;
            vm.selectedTask = null;

          })
        } //closeTaskMenu

        function toggleSidePanel(mode) {
          if(vm.taskMenuOpen){
            vm.closeTaskMenu();
          }
          $timeout(function() {
            vm.sidePanelMode = mode;

            $mdSidenav('board-panel')
              .toggle()
              .then(function() {
                // put focus on search
                $( "#searchQuery" ).focus();
                // if we are opening board settings, remove the backdrop
                if(vm.sidePanelMode == 'board'){
                  $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:none;');
                } else {
                  $('md-backdrop.md-sidenav-backdrop').attr('style', 'display:block;');
                }
              });
          })
        } //toggleSidePanel

        function resetDragData() {
          itemDrag = {};
          columnDrag = {};
        } //resetDragData

        function setupListeners() {
              boardContainer.addEventListener('click', listeners, false);

              $scope.$on("$destroy", function() {
                cleanupMuuri();
                init();
              });
        } //setupListeners

        function listeners(e){
            // $log.info(e.target);
            // while task form is visible, nothing else can be done
              var clickHandled = false;
              // quickTask
              if (e.target.matches('.board-column-quick-task')) {
                clickHandled = true;
                closeQuickTaskForm()
                if (!vm.listMenuOpen) {
                  var gridElem = e.target.closest('.board-column').querySelector('.board-column-content');
                  quickTask(gridElem, e);
                }
              } // if listMenu Not Open


              // visit workspace
              // if (e.target.matches('img.avatar')) {
              //   $log.info('avatar');
              //   clickHandled = true;
              //     var gridElem = e.target.closest('.board-column').querySelector('.board-column-content'),
              //         workspaceID = gridElem.getAttribute('data-id');
              //         $state.go('triangular.workspaces.overview', {clientID: workspaceID});
              // }


              if (e.target.matches('.view-attachment')) {
                $log.info('view-attachment');
                clickHandled = true;
                }

              if (e.target.matches('.task-menu-button')) {
                clickHandled = true;
                  closeTaskMenu();
                  closeQuickTaskForm()
                  var taskElem = e.target.closest('.board-item');
                  vm.selectedTaskID = taskElem.getAttribute('data-id');
                  vm.taskListID = taskElem.getAttribute('data-list');

                  // get our taskData and x/y position and open task menu
                  // in a timeout so it properly triggers our menu directive
                    return getTaskData(taskElem.getAttribute('data-id'))
                    .then(function(data){
                      openTaskMenu(data, e)
                    })
                    .catch(function(error){
                      throwError('Oops! Something went wrong. Please Refresh your browser.')
                      $log.error(error);
                    });
              } // taskMenuButton Clicked


              // listMenu
              if (e.target.matches('.board-column-menu')) {
                clickHandled = true;
                // close any other menus open
                vm.closeListMenu();
                closeQuickTaskForm()
                // Open menu on new target list
                $timeout(function() {
                    vm.targetListID = e.target.closest('.board-column').getAttribute('data-id');
                    _.each(vm.clients, function(client) {
                      if (client.uid == vm.targetListID) {
                        return setupPackageStats(client)
                        .then(function(results){
                          vm.selectedClient = client;
                          vm.packageStats = results;
                        })

                      }
                    })
                  })
                  .then(function() {
                    vm.sidePanelMode = 'list';
                    vm.toggleSidePanel(vm.sidePanelMode);
                  })
              }


              // user button
              if(e.target.matches('.task-card-user-button')){
                clickHandled = true;
              }

              // clicked on existing quickTaskForm
              if(e.target.matches('.quick-task-container') || e.target.matches('.quick-task-form') || e.target.matches('.quick-task-description')){
                clickHandled = true;
                $log.info('selected quick task');
              }

              // save quickTask form
              if(e.target.matches('.quick-task-save-button')){
                $log.info('save quick task');
                clickHandled = true;
                saveQuickTask();
              }//saveQuickTask form

              // toggleStatus
              if(e.target.matches('.task-card-toggle-status')){
                $log.info('toggleStatus');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');

                return getTaskData(taskID)
                .then(function(taskData){
                  if(!timerDataService.hasTimer(taskData)){
                      return taskDataService.toggleStatus(taskData);
                    } else {
                        alert("You have open timers for this task. Please commit or discard them first.")
                    }

                })// getTaskdata
                .catch(function(error){
                  throwError(error)
                });
              }// if toggleStatus

              // openFlagMenu
              if(e.target.matches('.task-card-open-flag-menu')){
                clickHandled = true;
                closeQuickTaskForm()
                $log.info('open flag menu');
              }// if openFlagMenu

              // start timer
              if(e.target.matches('.task-card-start-timer')){
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');

                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.newTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });

              }// if start timer

              // pause timer
              if(e.target.matches('.task-card-pause-timer')){
                $log.info('pause timer');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');

                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.pauseTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if pause timer

              // resume timer
              if(e.target.matches('.task-card-resume-timer')){
                $log.info('resume timer');
                clickHandled = true;
                closeQuickTaskForm()
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.resumeSavedTaskTimer(taskData);
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if resume timer


              // log time
              if(e.target.matches('.task-card-log-time')){
                  clickHandled = true;
                  closeQuickTaskForm()
                  var taskElem = e.target.closest('.board-item'),
                      taskID = taskElem.getAttribute('data-id');
                  return getTaskData(taskID)
                  .then(function(taskData){
                    var newTimeEntry = timeDataService.newLogEntry(taskData.client, taskData.refID);
                    timeDataService.timeDialog(newTimeEntry, 'Log');
                  })
                  .catch(function(error){
                    throwError(error)
                  });
              }// if log time

              // stop timer
              if(e.target.matches('.task-card-stop-timer')){
                clickHandled = true;
                closeQuickTaskForm()
                $log.info('stop timer');
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.stopTaskTimer(taskID)
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if stop timer

              // discard timer
              if(e.target.matches('.task-card-discard-timer')){
                $log.info('discard timer');
                closeQuickTaskForm()
                clickHandled = true;
                var taskElem = e.target.closest('.board-item'),
                    taskID = taskElem.getAttribute('data-id');
                return getTaskData(taskID)
                .then(function(taskData){
                  timerDataService.discardTaskTimer(taskData)
                })
                .catch(function(error){
                  throwError(error)
                });
              }// if discard timer

              // EDIT TASK
              if(!clickHandled && !vm.taskMenuOpen){
                closeQuickTaskForm()
                var taskID = $(e.target).closest('.board-item').attr('data-id');
                // only edit if we isolated the id
                if(taskID){
                  editTask(taskID);
                }
              }

              // if no click handled AND a task menu is displayed, close the task menu
              if(!clickHandled && vm.taskMenuOpen){
                closeTaskMenu();
              }// if click wasn't handled
        }; // listeners

        function cleanupMuuri(){
          $log.info('clean up muuri');
          window.removeEventListener('resize', windowResize, false);
          delete vm.selectedTask
          delete vm.selectedList
          delete vm.selectedClient
          vm.sidePanelMode = 'board'
          delete vm.boardData
          boardContainer.removeEventListener('click', listeners, false);
          // clean up here
          _.each(columnGrids, function(grid) {
            grid.destroy(true);
          })
          if(boardGrid){
            boardGrid.destroy(true);
            _.each(vm.clients, function(client){
                var tasksRef = firebase.database().ref('/clients/' + client.uid + '/tasks');
                tasksRef.off('child_changed', changedWatchers[client.uid])
                tasksRef.off('child_added', addedWatchers[client.uid])
                tasksRef.off('child_removed', removedWatchers[client.uid])
            })
          }

        }//cleanupMuuri

        var refreshList = _.debounce(function(client){
            removeList(client);
            addList(client, true);
            boardGrid.refreshItems();
            boardGrid.sort('order', {layout: 'instant'})
            resizeBoard();
        }, 500 , {'maxWait': 1000})//refreshList

        function setupWatchers(){

             _.each(vm.clients, function(client){
                var tasksRef = firebase.database().ref('clients').child(client.uid);
                changedWatchers[client.uid] = tasksRef.child('tasks').on('child_changed', function(snapshot){
                  if(setupComplete){
                      $log.info('task changed');
                      var task = snapshot.val();
                      client.tasks[task.uid] = task;
                       // refreshList(client);
                      updateTask(task);
                  }
                })


                addedWatchers[client.uid] = tasksRef.child('tasks').on('child_added', function(snapshot){
                     // only add if setup complete
                     if(setupComplete){
                        // $log.info('task added');
                        var task = snapshot.val();
                        addNewTask(client, task);
                     }
                });

                removedWatchers[client.uid] = tasksRef.child('tasks').on('child_removed', function(snapshot){
                     $log.info('task removed from ' + client.uid);
                     var task = snapshot.val();
                     delete client.tasks[task.uid]
                     _.each(columnGrids, function(grid){
                      if(grid.getElement().getAttribute('data-id') == task.client){
                        _.each(grid.getItems(), function(item){
                          if(item.getElement().getAttribute('data-id') == task.uid){
                            grid.remove([item], {removeElements: true});
                            grid.refreshItems();
                          }
                        })
                      }
                     })

                })
             });
        }//setupWatchers
    } // tasksPageController
})();

(function() {
    'use strict';

    angular
        .module('tasks')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-tasks');

        $stateProvider
            .state('triangular.tasks-page', {
                views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/layouts/toolbar/adminja-tasks-toolbar.tmpl.html',
                            controller: 'ToolbarController',
                            controllerAs: 'vm'
                        },
                        '@triangular': {
                            templateUrl: 'app/admin-tasks/tasks-page.tmpl.html',
                            controller: 'tasksPageController',
                            controllerAs: 'vm'
                        }
                    },
                url: '/tasks',
                // templateUrl: 'app/admin-tasks/tasks-page.tmpl.html',
                // // set the controller to load for this page
                // controller: 'tasksPageController',
                // controllerAs: 'vm',
                resolve: {
                    // 'currentAuth': ['authFactory', function(authFactory) {
                    //     return authFactory.$requireSignIn()
                    // }],
                    // // resolve our _userData and pass it to the Controller for saving
                    //  '_userData': ['userDataService', function(userDataService) {
                    //    return userDataService.getLoggedInUser()
                    //    .then(function(data){
                    //         return data
                    //    })
                    // }],

                    // clientDataService: 'clientDataService',
                    // // resolve our _clientData in our service and make avail to Controller
                    //  _clientData: function(_userData, clientDataService) {
                    //    return clientDataService.thisUsersWorkspaces(_userData)
                    //    .then(function(data){
                    //         return data
                    //    });
                    // }
                }

            });

        triMenuProvider.addMenu({
            name: 'All&nbsp;Tasks',
            icon: 'fa fa-check-square-o',
            type: 'link',
            state: 'triangular.tasks-page',
            priority: 6.0
            // badge: Math.round(Math.random() * (100 - 1) + 1)
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tasks')
        .controller('legacyTasksPageController', legacyTasksPageController);

    /* @ngInject*/
    function legacyTasksPageController($q, $log, $scope, $timeout, hotkeys, userDataService, pageDimensionsService, triLoaderService, teamDataService, dragulaService, $rootScope, clientDataService, taskDataService, profileDataService, localStorageService, $mdToast, _userData, _clientData) {
        var vm = this;
        $log.info('legacyTasksPageController');

        // $timeout(function(){
        //       triLoaderService.setLoaderActive(true);
        //   },0);
        // reset teamDataService to make sure we have updated member lists for user drop downs
        // teamDataService.init();
        vm.user = _userData;
        vm.settings = $rootScope.userSettings;
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.clientCount = _.size(vm.clients);
        vm.now = new Date();
        vm.now = vm.now.toISOString();
        vm.snoozeFilter = true;
        if(_.has(vm.settings, 'collapseCards')){
            if(vm.settings.collapseCards){
                vm.collapseCards = vm.settings.collapseCards;
            } else {
                vm.collapseCards = false;
            }
        }


        if(_.has(vm.settings, 'defaultAllTaskSort')){
                vm.sortOption = vm.settings.defaultAllTaskSort;
        } else {
            vm.sortOption = 'allOrder';
        }


        // Watch for completion of initial paint and turn off loader when done
          var digestObserverValue = 0, digestObserverHandledValue  = -1;
          var onBeforePaint = function() {
              // Called before painting
              digestObserverValue++; // Prepare for the next digest
              // $(document.body).trigger("paint.ng");
              // $log.info('painting');
              setTimeout(function() {
                  // Called almost right after painting
                  triLoaderService.setLoaderActive(false);
              }, 1000);
          };
          $scope.$watch(function() {
              // Called on every digest.
              if( digestObserverHandledValue  !== digestObserverValue ) {
                  // Executed only once per multiple sequential digest cycles (until $evalAsync and later
                  // timeout/animation handlers are called).
                  digestObserverHandledValue = digestObserverValue;
                  $scope.$evalAsync(function() {
                      // Called after at least single digest cycle is finished, but before rendering.
                      if( "requestAnimationFrame" in window ) {
                          // Get onBeforePaint() called right before DOM styles are calculated and page is
                          // painted.
                          requestAnimationFrame(onBeforePaint);
                      }
                      else {
                          // For older browser compatibility: get onBeforePaint() called before painting
                          // when javascript engine finishes executing the current thread code and starts
                          // handling expired timers (0ms timeout).
                          setTimeout(onBeforePaint, 0);
                      }
                  });
              }
              return digestObserverValue;
          }, function() {});




        vm.verticalTaskPanels = vm.settings.verticalTaskPanels;
        vm.teamDataService = teamDataService;
        if (vm.settings.verticalTaskPanels){
            vm.taskDragDirection = 'vertical'
        } else {
            vm.taskDragDirection = 'horizontal'
        }
        vm.teamList = teamDataService.allMembers;

        vm.loading = false;
        vm.clientLimit = 2;
        vm.filterOption = 'all';

        if (_.has(vm.user, 'limits.clients')){
            vm.clientLimit = vm.user.limits.clients;
        }
        // clear clientID so client toolbar isn't displayed
        $rootScope.activeClientID = null;



        function setupCompletedTasks(){
            vm.completedTasks = [];
            // if we aren't showing completed items
            // and if we aren't showing the today panel
            // we shouldn't be prepping this big array on every change
                // concate all of our open client tasks into one array
                var count = 0;
                _.each(vm.user.tasks, function(task){
                        if(_.has(task, 'refID') && task.status == 'closed'){
                            vm.completedTasks.push(task);
                            count ++
                        }
                });

        } // setupCompletedTasks



        vm.expireCompleted = function(tasks){
            var updates = {};
            _.each(tasks, function(task){
                if(_.has(task, 'closedDate') && _.has(task, 'refID')){
                    updates['/clients/' + task.client + '/tasks/' + task.refID] = null;
                    updates['/users/' + task.assignee + '/tasks/' + task.refID] = null;
                    if(_.has(task, 'creator')){
                        updates['/users/' + task.creator + '/tasks/' + task.refID] = null;
                    }

                }
            });
            if(_.size(updates)>0){
                return firebase.database().ref().update(updates)
                .then(function(){
                    alert('Completed tasks archived.');
                  // $log.info('sorted');
                  // Force (true) Refresh our client menu
                  // clientDataService.setupUserAndClientMenu(true);
                })
            }
        }

        vm.getUserRole = function(clientID){
           // Set defaults

              // Check to see if current user is admin or member so we can restrict who can see the 'admins only' toggle
              var teamSize = _.keys(teamDataService.clientTeams[clientID]).length;

              // if we have a team, check for permissions to edit otherwise, allow it
              if(teamSize > 0 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
                  return teamDataService.clientTeams[clientID][$rootScope.userID].role;
              } else {
                  // no team. This is a solo account. Set all to true.
                  return 'member'
              }

           }// vm.isAdmin

        vm.changeSort = function(value){
            userDataService.changeUserSetting('defaultAllTaskSort', value);
            userDataService.getLoggedInUser();

        }

        vm.toggleCardCollapse = function(value){
            // make sure we bind it if it wasn't before (no setting state)
            userDataService.changeUserSetting('collapseCards', value);
            userDataService.getLoggedInUser();
            $timeout(function(){
                vm.collapseCards = vm.settings.collapseCards;
                // resize our columns
                if (!vm.verticalTaskPanels){
                      pageDimensionsService.resizeColumns();
                } else {
                      pageDimensionsService.resizeColumns('vertical');
                }
            }, 0);
        }// toggleCardCollapse

        // Only setup allTasks if we are showing today panel
        if(vm.settings.showTodayPanel || !vm.settings.hideCompletedPanel){
            setupCompletedTasks();
            // Watch vm.clients and update allTasks if it changes
            $rootScope.$on('clientMenuBuilt', function(){
                setupCompletedTasks();
            });
        }



        // This filter makes sure the Client in question is in this list
        $scope.limitOwned = function(client, index) {
          if(_.find(vm.clients, function(o) { return o.uid == client.uid;})){
            return true
          };
        };

        // Helps with the complicated filtering necessary for the "today" columns
        $scope.todayFilter = function(task) {
            return task.panel === 'due' || task.panel === 'today' || task.duedate <= vm.now;
        };

        $scope.laterFilter = function(task) {
            // $log.info(task.duedate + ' - ' + vm.now);
            return !task.duedate || task.duedate > vm.now;
        };

        $scope.userFilter = function(task){
            if(!task.private || vm.getUserRole(task.client) != 'member'){
                if(_.has(teamDataService, 'filteredMember')){
                    if(task.assignee == teamDataService.filteredMember){
                        return true
                    } else { return false}
                } else {
                    return true
                }
            }
        }// userFilter

        $scope.snoozeFilter = function(task){
         if(task.snooze && vm.snoozeFilter){
             return false
         } else {
             return true
         }
        }

        // // filter used for our client buckets
        $scope.allClientTasks = function(task){
            // filter: { 'status':'open' }  | filter: userFilter | filter: vm.filterText
            if(task.status == 'open' && $scope.userFilter(task)){
                if(vm.filterText){
                    if(_.lowerCase(task.description).includes(_.lowerCase(vm.filterText))){
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            } else {
                return false
            }

        }// allClientTasks

        vm.showTeamFilter = function(){
         if (_.size(vm.teamList) > 1){
             return true
         }
        }

        vm.resetFilter = function(){
            vm.filterOption = 'all';
            delete teamDataService.filteredMember;
            delete teamDataService.filteredMemberName;
        }

        vm.filterUser = function(option){
         if(option != 'all'){
             teamDataService.filteredMember = option.uid;
             teamDataService.filteredMemberName = option.fullName;
         } else {
             delete teamDataService.filteredMember;
             delete teamDataService.filteredMemberName;
         }

        }// filterUser
        vm.closeFilterBar = function(){
            $timeout(function(){
               vm.showFilterBar = false;
            },0);
        }


        vm.resetTaskSearch = function(){
            $timeout(function(){
                vm.taskSearchQuery = "";
            },0);
        }

        // Debounce our search filter
        // This is what you will bind the filter to
        vm.filterText = '';

        // Instantiate these variables outside the watch
        var tempFilterText = '',
            filterTextTimeout;
        $scope.$watch('searchQuery', function (val) {
            if (filterTextTimeout) $timeout.cancel(filterTextTimeout);

            tempFilterText = val;
            filterTextTimeout = $timeout(function() {
                vm.filterText = tempFilterText;
            }, 100)

          });

        vm.resetTaskSearch = function(){
          vm.filterText = '';
          document.getElementById("searchQuery").value = "";
        }// resetFilter


            // New Task
        $scope.newTask = function(clientID, panel) {
                // $log.info('newTask');
                //make empty editedDetail object
                $scope.editedItem = taskDataService.newTask(clientID, panel);
                // Set our dialogTitle
                $scope.dialogTitle = "New";
                // console.log($scope.editedItem);
                taskDataService.taskDialog($scope.editedItem);
            } // end newTask


            // Inhibit screen scroll on drag/mobile solution from:
            // https://github.com/bevacqua/dragula/issues/487

            var scrollable = true;

            var listener = function(e) {
                if (! scrollable) {
                    e.preventDefault();
                }
            }
            document.addEventListener('touchmove', listener, { passive:false });

        // Dragula Setup


        dragulaService.options($scope, 'drag-task', {
             moves: function (el, container, handle) {
                return true
               // return handle.classList.contains('task-handle');
             },
             accepts: function(el, target, source, sibling) {
                if (target == source){
                    if(vm.sortOption == 'allOrder'){
                        return true
                    } else {
                        return false
                    }
                }
            },
             direction: vm.taskDragDirection
           });



        // Regular panel Task Drop Listener
        $scope.$on('drag-task.drag', function(event, item, target, source, sibling){
            scrollable = false;
        });


        // Regular panel Task Drop Listener
        $scope.$on('drag-task.drop', function(event, item, target, source, sibling){
            // $log.info('drag-task.drop');
            // $log.info(target);

            scrollable = true;
            // Now we can do our work - prep the variables
            var itemID = item[0].attributes.taskid.value,
                parentPanelID = item[0].attributes.taskpanel.value,
                parentPanel = $('.app-item-container-items[panelid="'+ parentPanelID +'"]'),
                clientID = item[0].attributes.client.value,
                targetPanelID = target[0].attributes.panelid.value,
                // not used in alltasks
                // targetPanelOrder = target[0].attributes.panelorder.value,
                sourcePanelID = source[0].attributes.panelid.value,
                // not used in alltasks
                // sourcePanelOrder = source[0].attributes.panelorder.value,
                numSourceChildren = $(parentPanel).find('.task-app-item').length,
                sourceChildren = $(parentPanel).find('.task-app-item').toArray(),
                ghostElement = document.querySelector('.gu-transit'),
                targetChildren = Array.from(ghostElement.parentNode.children),
                targetItemIndex = targetChildren.indexOf(ghostElement),
                thisBag = dragulaService.find($scope, 'drag-task'),
                updates = {};

                var thisClient = _.find(vm.clients, function (client) {
                    return client.uid == clientID;
                }),
                thisTask = thisClient.tasks[itemID];


                // Prepare order changes for all tasks in set
                _.each(targetChildren, function(child, index){
                    var childID = child.attributes.taskid.value,
                        // getting thisTask will differ for other task views
                        childTask = thisClient.tasks[childID];


                    updates['/tasks/' + childID + '/info/allOrder'] = Number(index + 1);
                    updates['/users/' + childTask.assignee + '/tasks/' + childID + '/allOrder'] = Number(index + 1);
                    updates['/clients/' + childTask.client + '/tasks/' + childID + '/allOrder'] = Number(index + 1);
                }); // each targetChildren

                return firebase.database().ref().update(updates)
                .then(function(){
                    // thisBag.drake.cancel(true);
                    scrollable = true;
                        $rootScope.draggingTask = false;
                        pageDimensionsService.resizeColumns();
                        $scope.$apply();
                });




        });// $on.drag-task.drop




        vm.quickTask = function (client) {
            // close any other quicktasks
            vm.cancelQuickTask();
            // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
            // Set our dialogTitle
            // $log.info(panel);
            client.showQuickTask = true;

            // wait a hairs breadht and focus on field
            $timeout(function(){
                document.getElementById("quickTaskField").focus();
            },200);

            vm.newQuickTask = taskDataService.newTask(client.uid, 'Later');

            // enable our escape to cancel hotkey
            hotkeys.add({
              combo: 'esc',
              description: 'Cancel New Task',
              allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                vm.cancelQuickTask();
              }
            });
            hotkeys.add({
                combo: 'enter',
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                description: 'Save task',
                callback: function (event, hotkey) {
                    $log.info('ctrl+enter');
                    event.preventDefault();

                    if (vm.newQuickTask.info.description) {
                        vm.saveQuickTask(vm.newQuickTask)
                    }

                }
            });
            // console.log($scope.editedItem);
            // taskDataService.taskDialog($scope.editedItem);
        }

        vm.saveQuickTask = function(task){
            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            }
            else {
                _.each(vm.teamList, function(member){
                    if(member.uid == task.info.assignee){
                        task.info.assigneeName = member.fullName;
                        task.info.assigneeAvatar = member.avatar;
                    }
                });
            }

            taskDataService.saveNew(task);
            vm.cancelQuickTask()
        };
        vm.cancelQuickTask = function(){
            _.each(vm.clients, function(client){
                if(client.showQuickTask){
                    client.showQuickTask = false;
                    hotkeys.del('esc');
                    hotkeys.del('enter');

                }
            });
        }

        // add shortcut for task collapsing.
        hotkeys.add({
            combo: 'alt+ctrl+c',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            description: 'Collapse/Expand Task Cards',
            callback: function (event, hotkey) {

                event.preventDefault();

                if(vm.collapseCards){
                    // collapsed - switch to open
                    vm.toggleCardCollapse(false);
                } else {
                    // open - switch to collapsed
                    vm.toggleCardCollapse(true);
                }
            }
        });

         // Timeout without a duration gets run after the page is done
        // https://stackoverflow.com/questions/11125078/is-there-a-post-render-callback-for-angular-js-directive
        // $timeout(function () {
        //     $timeout(function(){
        //         triLoaderService.setLoaderActive(false);
        //     },0);
        // });

    } // legacyTasksPageController
})();

(function() {
    'use strict';

    angular.module('appServices')
            .controller('upgradeModalController', upgradeModalController);


///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
/// upgradeModalController

/* @ngInject */
function upgradeModalController($log, $scope, $state, $mdDialog, firebase, $timeout, triLoaderService, $location, $rootScope, $window, userDataService, taskDataService, profileDataService, clientDataService) {
    $log.info('upgradeModalController');
    var vm = this;
    vm.userDataService = userDataService;
    vm.taskDataService = taskDataService;
    vm.user = userDataService.user;
    vm.close = close;
    setupProgress();

    function setupProgress(){
        var upgradedWorkspaces = 0;
        _.each(clientDataService.clients, function(client){
            if(_.has(client, 'defaultTaskBoard')){
                upgradedWorkspaces ++
            }
        });
        var remainingWorkspaces = _.size(clientDataService.clients) - upgradedWorkspaces;
        vm.lastPass = false;
        if(remainingWorkspaces == _.size(vm.workspaces)){
            vm.lastPass = true;
        }

        // vm.upgradeMessage = "Optimizing " + _.size(vm.workspaces) + " of " + remainingWorkspaces + " Remaining Workspaces...";
        vm.upgradeMessage = "Workspaces remaining: " + remainingWorkspaces;
        vm.upgradeProgress = 1-(remainingWorkspaces/_.size(clientDataService.clients));
        vm.upgradeProgress = vm.upgradeProgress * 100;
        vm.upgradeProgress = vm.upgradeProgress.toFixed(0);
    }//setupProgress
    // if(vm.upgradeProgress > 0){
    //     alert(vm.upgradeProgress)
    //     return
    // }

    // vm.upgradeProgress = $rootScope.upgradeProgress;

    // add .sequence to Promise function to make sure workspaces are upgraded SEQUENTIALLY rather than in parallel
    Promise.sequence = function (chain) {
        var results = [];
        var entries = chain;
        if (entries.entries) entries = entries.entries();
        return new Promise(function (yes, no) {
            var next = function () {
                var entry = entries.next();
                if(entry.done) yes(results);
                else {
                    results.push(entry.value[1]().then(next, function() { no(results); } ));
                }
            };
            next();
        });
    };

    $timeout(function(){
        $('.triangular-loader').css('display', 'none');
        upgradeWorkspaces();
    }, 1000)

    function upgradeWorkspaces(){

         $state.go('triangular.dashboard');
         vm.upgradePromises = [];

         _.each(vm.workspaces, function(workspace, index){
             vm.upgradePromises.push(taskDataService.upgradeTaskBoard(workspace, index));
             vm.upgradePromises.push(profileDataService.upgradeBoard(workspace));
         });

        Promise.sequence(vm.upgradePromises)
            .then(function(results) {
                wrapUp(results);
            }, function(results) {
                wrapUp(results);
            });
    }//upgradeWorkspaces


    function wrapUp(results){
        $log.info('Wrapping up...');
        var upgradeCandidates = [];
        _.each(clientDataService.clients, function(thisClient){
            if(!_.has(thisClient, 'defaultTaskBoard')){
              upgradeCandidates.push(thisClient);
            }
        })
        if(_.size(upgradeCandidates) > 0){
            $timeout(function(){
                upgradeCandidates = upgradeCandidates.slice(0, 1);
                vm.workspaces = upgradeCandidates;
                setupProgress();
                upgradeWorkspaces();
            },3000);
        } else {
           var postUpgradeExperienceKey = firebase.database().ref().push().key;
            var updates = {};
            var experience = {
              uid: postUpgradeExperienceKey,
              timeStamp: moment().toISOString(),
              experienceID: '1628772735xBfq4328'
            }

            updates['/users/' + vm.user.uid + '/experienceQueue/' + postUpgradeExperienceKey] = experience;
            updates['/users/' + vm.user.uid + '/profile/onboardingFlags/taskBoardUpgrade0821Complete'] = moment().toISOString();
            firebase.database().ref().update(updates)
            .then(function(results){
             $timeout(function(){
                location.reload();
             }, 2000)
            })
        }
        // if(vm.lastPass){
        //     var postUpgradeExperienceKey = firebase.database().ref().push().key;
        //     var updates = {};
        //     var experience = {
        //         uid: postUpgradeExperienceKey,
        //         timeStamp: moment().toISOString(),
        //         experienceID: '1628772735xBfq4328'
        //     }

        //     updates['/users/' + vm.user.uid + '/experienceQueue/' + postUpgradeExperienceKey] = experience;
        //     updates['/users/' + vm.user.uid + '/profile/onboardingFlags/taskBoardUpgrade0821Complete'] = moment().toISOString();
        //     firebase.database().ref().update(updates)
        //     .then(function(results){
        //        $timeout(function(){
        //           location.reload();
        //        }, 2000)
        //     })
        // } else {
        //     $timeout(function(){
        //        location.reload();
        //        clientDataService.setupWorkspaceMenu()
        //        $mdDialog.cancel();
        //     }, 2000)
        // }

    }//wrapUp



    function close(){
        $mdDialog.cancel();
    }// close



}// controller

})();

(function() {
    'use strict';

    angular
        .module('adminDashboard', ['appServices', 'ngSanitize']);
})();

(function () {
    'use strict';

    angular
            .module('adminDashboard')
            .controller('adminDashboardController', adminDashboardController)
            .controller('firstLoginController', firstLoginController);

    /* @ngInject */

    function adminDashboardController($log, $mdDialog,  teamDataService, kanbanService, taskDataService, timeReportService, invoiceService, triMenu, $state, $timeout, $window, triLoaderService, $rootScope, userDataService, $scope, clientDataService, gateService, _userData, _clientData) {
        // $log.info('dashboardController');
        // $log.info('userData is:');
        // $log.info(_userData);
        // $log.info('clientData is:');
        // $log.info(_clientData);
        // $log.info('$resolve is:');
        // $log.info($scope.$resolve);

        // $scope.testing = true;
        var vm = this;
        vm.userData = _userData;
        vm.clients = clientDataService.clients;
        vm.settings = $rootScope.userSettings;
        vm.showMigrationTool = false;
        vm.showProgressChart = false;
        vm.clientLimit = gateService.gateData.clientLimit;
        vm.size = size;
        vm.showToday = true;
        vm.showNotifications = true;
        vm.clientsLoaded = false;
        vm.refreshing = false;
        vm.init = init;
        vm.newTask = newTask;
        // Development flags
        vm.onboardingDevMode = false;
        vm.checkIfDialogNeeded = checkIfDialogNeeded;
        vm.workspaceClass = workspaceClass;
        vm.triggerCount = triggerCount;
        vm.remain = remain;
        vm.changeStatusView = changeStatusView;
        vm.toggleWorkspacePackages = toggleWorkspacePackages;
        vm.toggleAllWorkspacePackages = toggleAllWorkspacePackages;
        vm.todayCount = todayCount;
        vm.flaggedCount = flaggedCount;
        vm.laterCount = laterCount;
        vm.workspaceVisibility = {};
        vm.allPackagesVisible = false;
        vm.userOrder = 'userOrders.user' + vm.userData.uid;
        vm.teamLabel = teamLabel;

        if(teamDataService.teams){
          vm.init();
        } else {
          return teamDataService.init()
          .then(function(){
            vm.init();
          })
        }

        vm.triggerEvent = triggerEvent;




        function triggerEvent(){
          // window._dcq.push(["track", "New Adminja User", {test: 'true'}]);
        }

        function initStatus(){
          vm.status = {};
          // Static Mocks
                    vm.status.now ={
                      due: 0,
                      flagged: 0,
                      upcoming: 0
                    };

                    vm.status.thisWeek = {
                      completed: 0,
                      logged: 0,
                      invoiced: 0,
                      start: undefined,
                      end: undefined,
                      teamCompleted: 0,
                      teamLogged:0,
                      teamInvoiced: 0
                    }

                    vm.status.lastWeek = {
                      completed: 0,
                      logged: 0,
                      invoiced: 0,
                      start: undefined,
                      end: undefined,
                      teamCompleted: 0,
                      teamLogged:0,
                      teamInvoiced: 0
                    }

                    vm.status.last30 = {
                      completed: 0,
                      logged: 0,
                      invoiced: '0',
                      start: undefined,
                      end: undefined,
                      teamCompleted: 0,
                      teamLogged:0,
                      teamInvoiced: 0
                    }
          }// initStatus
        function init(){
            initStatus();
          // $log.info('Dashboard init');
            vm.clientData = [];
            // Make sure we don't think we are on an individual client
            $rootScope.activeClientID = null;
            // Build our vm.clientData list based on limits and team
            return setupClients(vm.clients)
            .then(function(){
              return setupPackageStats()
              .then(function(results){
                vm.packageStats = results;
                setupStatusWidgetsV2();
                // Setup status widgets
                setupStatusWidgets();// this one is required for charges

                  // setup Charts
                  vm.charts = [];
                  if(!vm.settings.hideDashboardCharts){
                    setupWorkLoadChart();
                    setupRevenueChart();
                  }

                  $timeout(function(){
                      vm.clientsLoaded = true;
                      // triLoaderService.setLoaderActive(false)
                  }, 500)

                  // app module will throw up email verification and block app access if not verified
                  // let's make sure we dont fire other modals if that's the case.
                  if($rootScope.emailVerified || !$rootScope.emailVerificationTimeout){
                    // with a timeout to ensure we are ready for this check (bad form)
                    $timeout(function(){
                      checkConsent();
                    },1000)
                  }
              })
            });
        }// init dashboard

        // Listen for triggers that would cause us to recheck dialog
        $rootScope.$on('keySetupChanged', function(){
          vm.init();
        })

        function todayCount(client){
          var count = 0, now = moment().toISOString();
          _.each(client.tasks, function(task){
            if(_.has(task, 'duedate') && (task.status == 'open' || task.status == 'snoozed')){
              if(task.duedate <= now){
                count ++
              }
            }
          });
          return count
        }// todayCount

        function flaggedCount(client){
          var count = 0, now = moment().toISOString();
          _.each(client.tasks, function(task){
            if(task.focus == 'today' && (task.status == 'open' || task.status == 'snoozed')){
              if(_.has(task, 'duedate')){
                if(task.duedate <= now){
                  count ++
                }
              } else {
                count ++
              }
            }
          });
          return count
        }// flaggedCount

        function laterCount(client){
          var count = 0, qualifies = false, now = moment().toISOString();
          _.each(client.tasks, function(task){
            if(task.status == 'open' || task.status == 'snoozed'){
              if(_.has(task, 'duedate')){
                if(task.dueDate <= now && task.focus != 'today'){
                  count ++
                }
              } else if (task.focus != 'today'){
                count ++
              }
            }// if open
          });
          return count
        }// laterCount

        function toggleAllWorkspacePackages(){
          if(!vm.allPackagesVisible){
            _.each(vm.clients, function(client){
              vm.workspaceVisibility[client.uid] = true;
              vm.allPackagesVisible = true;;
            })
          } else {
            _.each(vm.clients, function(client){
              vm.workspaceVisibility[client.uid] = false;
              vm.allPackagesVisible = false;
            })
          }
        }

        function toggleWorkspacePackages(workspaceID){
          if(vm.workspaceVisibility[workspaceID]){
            vm.workspaceVisibility[workspaceID] = false;
          } else {
            vm.workspaceVisibility[workspaceID] = true;
          }
        }//toggleWorkspacePackages

        function setupPackageStats(){
          return new Promise(function(resolve, reject){
            var packageStats = {};
            _.each(vm.clients, function(client){
              ///////// BIlling PERIOD CALCS
              if(client.billingType == 'periods'){
                if(_.has(client.billing, client.profile.plan.currentPeriod)){
                  var thisPeriod;
                  var now = moment().toISOString();
                  var found = false;
                  _.each(client.billing, function(period){
                    if(period.start < now && period.end > now){
                      thisPeriod = period;
                      found = true;
                    }
                  })

                  if(found){
                    var result = {},
                    percentUsed = Number(thisPeriod.logged) / (Number(thisPeriod.allocated) * 60);
                    result.type = thisPeriod.type;
                    result.used = thisPeriod.logged;
                    result.start = thisPeriod.start;
                    result.end = thisPeriod.end;
                    if(thisPeriod.type != 'hourly'){
                      result.budget = Number(thisPeriod.allocated)*60;
                      result.remain = result.budget - result.used;
                      result.progressBarPercent = 1 - percentUsed;
                      if (isNaN(result.progressBarPercent)) {
                          result.progressBarPercent = 1;
                        }
                    }

                    if(thisPeriod.type == 'hourly'){
                        result.budget = 0;
                        result.progressBarPercent = percentUsed;
                        // we get Nan when dividing zeroes
                        if (isNaN(result.progressBarPercent)) {
                            result.progressBarPercent = 0;
                          }
                    }
                    result.progressBarPercentLabel = Number(result.progressBarPercent * 100).toFixed(0) + '%';
                    result.packageBalance = (Number(thisPeriod.allocated)*60) - thisPeriod.logged;
                    // Convoluted because we don't always have 'cost' and 'charges'
                    if(thisPeriod.type != 'hourly'){
                      result.totalCost = Number(thisPeriod.cost).toFixed(2);
                    } else {
                        result.totalCost = Number(thisPeriod.earned).toFixed(2);
                    }
                    // Make sure we don't attempt to draw out a negative number or number greater than 100%
                    if(result.progressBarPercent > 1){
                        result.progressBarPercent = 1;
                    }

                    if(result.progressBarPercent < 0){
                        result.progressBarPercent = 0;
                    }

                    if(thisPeriod.type != 'hourly'){
                        if(result.progressBarPercent >= .34){
                           result.progressBarColor = 'rgb(76, 175, 80)'
                        }

                        if(result.progressBarPercent < .33){
                           result.progressBarColor = '#f36d0a'
                        }

                        if(result.progressBarPercent < .15){
                           result.progressBarColor = '#f42323'
                        }

                        // we want an alert-colored background if we are over budget
                        if(result.progressBarPercent <= 0){
                            // result.progressBarPercent = 0
                            result.progressBarBackgroundColor = '#FBD6D6';
                        } else {
                            result.progressBarBackgroundColor = '#efefef';
                        }
                    }// retainer labels

                    if(thisPeriod.type == 'hourly'){
                        if(result.progressBarPercent >= .75){
                           result.progressBarColor = 'rgb(76, 175, 80)'
                        }

                        if(result.progressBarPercent < .75){
                           result.progressBarColor = '#f36d0a'
                        }

                        if(result.progressBarPercent < .15){
                           result.progressBarColor = '#efefef'
                        }

                        if(result.packageBalance < 0){
                            result.packageBalance = 0;
                        }
                        // we want an alert-colored background if we are over budget
                        result.progressBarBackgroundColor = '#efefef';
                    }// retainer labels
                    packageStats[client.uid] = result;
                  }// if found

                } else {

                }// if has period

              }// if periods

              ///////////PACKAGE CALCS
              if(client.billingType == 'packages'){
                _.each(client.packages, function(thisPackage){
                  var result = {};
                  var percentUsed = Number(thisPackage.qualifiedMinutes) / Number(thisPackage.budgetedMinutes);
                  if(thisPackage.type != 'hourly'){
                      result.progressBarPercent = 1 - percentUsed;
                      // we get Nan when dividing zeroes
                      if (isNaN(result.progressBarPercent)) {
                          result.progressBarPercent = 1;
                        }
                  }

                  if(thisPackage.type == 'hourly'){
                      result.progressBarPercent = percentUsed;
                      // we get Nan when dividing zeroes
                      if (isNaN(result.progressBarPercent)) {
                          result.progressBarPercent = 0;
                        }
                  }

                  // if we've gone over budget, progressbar should draw 0%
                  if(percentUsed > 1){
                    result.progressBarPercent = 0;
                  }

                  result.progressBarPercentLabel = Number(result.progressBarPercent * 100).toFixed(0) + '%';
                  result.packageBalance = thisPackage.budgetedMinutes - thisPackage.qualifiedMinutes;

                  // Convoluted because we don't always have 'cost' and 'charges'
                  if(thisPackage.type != 'hourly'){
                      if(_.has(thisPackage, 'charges')){
                          result.totalCost = Number(thisPackage.charges).toFixed(2);
                      }
                  } else {
                      result.totalCost = Number(thisPackage.accrued) + Number(thisPackage.charges);
                  }

                  // we need to remove base cost from charges so charges displayed are "additional"

                  // Make sure we don't attempt to draw out a negative number or number greater than 100%
                  if(result.progressBarPercent > 1){
                      result.progressBarPercent = 1;
                  }

                  if(thisPackage.type != 'hourly'){
                      if(result.progressBarPercent >= .34){
                         result.progressBarColor = 'rgb(76, 175, 80)'
                      }

                      if(result.progressBarPercent < .33){
                         result.progressBarColor = '#f36d0a'
                      }

                      if(result.progressBarPercent < .15){
                         result.progressBarColor = '#f42323'
                      }

                      // we want an alert-colored background if we are over budget
                      if(result.progressBarPercent <= 0){
                          // result.progressBarPercent = 0
                          result.progressBarBackgroundColor = '#FBD6D6';
                      } else {
                          result.progressBarBackgroundColor = '#efefef';
                      }
                  }// retainer labels

                  if(thisPackage.type == 'hourly'){
                      if(result.progressBarPercent >= .75){
                         result.progressBarColor = 'rgb(76, 175, 80)'
                      }

                      if(result.progressBarPercent < .75){
                         result.progressBarColor = '#f36d0a'
                      }

                      if(result.progressBarPercent < .15){
                         result.progressBarColor = '#efefef'
                      }

                      if(result.packageBalance < 0){
                          result.packageBalance = 0;
                      }
                      // we want an alert-colored background if we are over budget
                      result.progressBarBackgroundColor = '#efefef';
                  }// retainer labels
                  packageStats[thisPackage.uid] = result;
                });// each package
              }// if packages
            });// each client
            return resolve(packageStats)
          })
        }//setupPackageStats

        function remain(budget, used){
          return Number(budget) - Number(used)
        }

        function workspaceClass(workspaceName){
          // checking for workspaceName. During logout this function may yield an error as things get cleared out.
          if(workspaceName){
            var workspaceClass = workspaceName.replace(/\s+/g, '-').toLowerCase();
            return workspaceClass
          } else {
            return ''
          }

        }


        function size(item){
            return _.size(item);
        }



        function checkIfDialogNeeded(){
          // $log.info('checkIfDialogNeeded');
          // var skip = false;

          // // Check for consent and get it if we don't. No other modals

            // if(!vm.userData.firstLogin || vm.onboardingDevMode == true){
            //   $log.info('Never logged in');
            //   openFirstLogin(vm.userData);
            //   firebase.database().ref('users').child(vm.userData.uid).child('/firstLogin').set(true);
            // }
            //else {
          //     skip = true;
          //   }
            // if(skip){
            // // passed first login. Latest feature announcement?
            // if(!vm.userData.profile.onboardingFlags.hasLeadboard){
            //   if(!_.has(vm.userData.profile, 'onboardingFlags.feature-announcement-leadboards-7-2-19')){
            //       $rootScope.featureAnnouncementOpen = true;
            //         openFeatureAnnouncement(vm.userData);
            //   } // if !leadBoard
            // }   // if announcement
            // } //if skip
      }

        $timeout(function(){
            // Watch for client menu being rebuilt (which means a client has been added or removed)
            // and update the page if that's the case.
            var unwatchClients = $rootScope.$on('clientMenuBuilt',function() {
              $timeout(function(){
                vm.clients = clientDataService.clients;
                vm.init();
              },0);
            });

            // var unwatchTime = $rootScope.$on('timeChanged',function() {
            //   $timeout(function(){
            //     // $log.info('time changed');
            //     // Setup status widgets
            //     initStatus();
            //     setupStatusWidgets();
            //     setupStatusWidgetsV2();
            //   },0);
            // });

            $scope.$on('$destroy', function() {
                unwatchClients();
                // unwatchTime();
            });

        },0);

        function openFirstLogin(user){

          $mdDialog.show({
              controller: 'firstLoginController', // see below
              bindToController: true,
              templateUrl: 'app/admin-dashboard/dialogFirstLogin.tmpl.html',
              locals: {
                  user: user,
                  refreshClientSummaries: vm.refreshClientSummaries
              },
              focusOnOpen: true,
              clickOutsideToClose: false,
              fullscreen: true,
              multiple: false,
              escapeToClose: false
          });

          // triLoaderService.setLoaderActive(false)


        }// openFirstLogin

        function openFeatureAnnouncement(user){
          // $log.info('openFeatureAnnouncement');
          // $mdDialog.show({
          //     controller: 'featureAnnouncementController', // see below
          //     bindToController: true,
          //     templateUrl: 'app/admin-dashboard/dialogFeatureAnnouncement.tmpl.html',
          //     locals: {
          //         user: user
          //     },
          //     focusOnOpen: true,
          //     clickOutsideToClose: false,
          //     fullscreen: true,
          //     multiple: false,
          //     escapeToClose: false
          // })
          // .then(function(){
          //   $log.info('dialog success???');
          // }, function(){
          //   $log.info('dialog closed');
          //   // Update our onboarding flag so this doesn't appear again.
          //   // e.g. feature-announcement-11-28-18

          // });

          // triLoaderService.setLoaderActive(false)

        }// openFeatureAnnouncement


        function countTask(task){
          // countTask is a utility for setupStatusWidgetsV2
             if (_.has(task, 'duedate')) {
                if(moment(task.duedate).diff(moment()) < 0){
                  // is due
                  vm.status.now.due++
                } else if (task.focus == 'today'){
                  // is flagged
                  vm.status.now.flagged++
                } else {
                  // is upcoming
                  vm.status.now.upcoming++
                }
              }// if has duedate

              if(!_.has(task, 'duedate')){
                if (task.focus == 'today'){
                  // is flagged
                  vm.status.now.flagged++
                } else {
                  // is upcoming
                  vm.status.now.upcoming++
                }
              }// if no duedate

        }// countTask

        function changeStatusView(selected){
          if(selected == 'thisWeek'){
            vm.displayedRangeStart = vm.status.thisWeek.start;
            vm.displayedRangeEnd = vm.status.thisWeek.end;
          }
          if(selected == 'lastWeek'){
            vm.displayedRangeStart = vm.status.lastWeek.start;
            vm.displayedRangeEnd = vm.status.lastWeek.end;
          }

          if(selected == 'thisMonth'){
            vm.displayedRangeStart = vm.status.last30.start;
            vm.displayedRangeEnd = vm.status.last30.end;
          }

          if(selected == 'lastMonth'){
            vm.displayedRangeStart = vm.status.last30.start;
            vm.displayedRangeEnd = vm.status.last30.end;
          }
        }


        vm.hasTeamMembers = function(){
          if(_.size(teamDataService.allMembers) > 0){
            return true
          }
        }

        // Dashboard V2 Status Widget Setup - triggered after client loaded and when data changes
        function setupStatusWidgetsV2(){

          // Go through clients and count up the tasks
          _.each(vm.clients, function (client) {
             _.each(client.tasks, function(task){
                 if(_.has(task, 'refID')){
                   if(task.status == 'open' || task.status == 'snoozed'){
                     // task is not closed;
                     if(task.assignee == $rootScope.userID){
                       //open and assigned to this user. counting task
                       countTask(task);
                     } else {
                       // task not assigned to this user. Don't count.
                     }
                   }// if open or closed
                 }// task if valid
             });
           });// each client

          // Get our weekly and monthly progress stats
          var startChart = moment().startOf('week').subtract(1, 'weeks'),
              endChart = moment().endOf('week');

          return userDataService.getWeekCounts(startChart, endChart)
          .then(function(weekData){
            var thisWeek = moment().startOf('week').format('YYYY-MM-DD'),
                lastWeek = moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');

            if(weekData[thisWeek]){
              vm.status.thisWeek = weekData[thisWeek];
              if(vm.status.thisWeek.invoiced === undefined){
                vm.status.thisWeek.invoiced = 0;
              }
            }
            if(weekData[lastWeek]){
              vm.status.lastWeek = weekData[lastWeek];
              if(vm.status.lastWeek.invoiced === undefined){
                vm.status.lastWeek.invoiced = 0;
              }
            }


            startChart = moment().subtract(1, 'month').startOf('month');
            endChart = moment().endOf('month');

            return userDataService.getMonthCounts(startChart,endChart)
            .then(function(monthData){
              var thisMonth = moment().format('YYYY-MM'),
                  lastMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM');
              $timeout(function(){
                if(monthData[thisMonth]){
                  vm.status.thisMonth =  monthData[thisMonth];
                  if(vm.status.thisMonth.invoiced === undefined){
                    vm.status.thisMonth.invoiced = 0;
                  }
                }

                if(monthData[lastMonth]){
                  vm.status.lastMonth = monthData[lastMonth];
                  if(vm.status.lastMonth.invoiced === undefined){
                    vm.status.lastMonth.invoiced = 0;
                  }
                }

                if(vm.status.thisMonth){
                  vm.status.thisMonth.label = moment().startOf('month').format('MMM');
                }
                if(vm.status.lastMonth){
                  vm.status.lastMonth.label = moment().startOf('month').subtract(1, 'month').format('MMM');
                }

              },0)

            });

          });

        }// setupStatusWidgetsV2;


        function teamLabel(clientOwner){
          var result = "Shared with me";
          _.each(teamDataService.teams, function(team){
            if(team.ownerID == clientOwner ){
              result = team.name;
            }
          });
          return result
        }//teamLabel

        // This function is for limiting clients for cancelled or downgraded users.
        // They will only have access to the first n clients after cancellation/downgrade
        function setupClients(clients){
          return new Promise(function(resolve, reject){
            if (_.size(clients) > 0) {
                var ownClientCount = 0;
                // Setup our menu object

                _.each(clients, function (client, index) {
                    var disabled = true;
                    client.type = 'client';
                    // override for demo clients
                    if(client.demo){
                        disabled = false;
                        vm.userData.limits.clients = vm.userData.limits.clients + 1;
                    } else if(client.owner === vm.userData.uid){
                        if (ownClientCount < vm.userData.limits.clients) {
                            disabled = false;
                        }
                        ownClientCount = ownClientCount + 1;
                        // set flag so we can know which clients are owned and which are delegated
                        if(client.status == 'personal'){
                          client.type = 'internal'
                        }
                    } else {
                        // this client is owned by someone else's account. we MUST allow it.
                        disabled = false;
                        if(client.status == 'personal'){
                          client.type = 'internal'
                        }

                        // if it's a va workspace,
                        if(_.has(client, 'clientUsers')){
                          _.each(client.clientUsers, function(value, key){
                            if(key == vm.userData.uid){
                              client.type = 'vaworkspace'
                            }
                          })
                        }
                    }


                    if(!disabled){
                        vm.clientData.push(client);
                        vm.workspaceVisibility[client.uid] = false;
                    }

                });

                vm.clientsLoaded = true
              return resolve(true)
            }// if clients.length
            else{
                return resolve(true)
            }
          })
        }// setupClients

        vm.canSeeBilling = function(user, client){

            return user.uid == client.owner;
        };

        vm.showDashboard = function(){
            if (vm.clientsLoaded && _.size(vm.clientData)>0 && teamDataService.teams){
                // triLoaderService.setLoaderActive(false);
                return true
            } else {
                return false
            }
        }// vm.showDashboard



        vm.currency = "$";
        if (_.has(vm.settings, 'currency')) {
            vm.currency = vm.settings.currency;
        }

        if (_.has(vm.settings, 'hideDashboardToday')) {
          if(vm.settings.hideDashboardToday){
            vm.showToday = false;
          } else {
            vm.showToday = true;
          }
        }
        if (_.has(vm.settings, 'hideDashboardNotifications')) {
          if(vm.settings.hideDashboardNotifications){
            vm.showNotifications = false;
          } else {
            vm.showNotifications = true;
          }
        }


        vm.changeOnboardingFlag = function(flag, value){
            // $log.info('updateSettings');
            userDataService.changeOnboardingFlag(flag, value);

            if(flag == "complete" && value == true){
                // they dismissed the guide entirely. Explain how they can get it back
                $mdDialog.show(
                     $mdDialog.alert()
                       .parent(angular.element(document.querySelector('#popupContainer')))
                       .clickOutsideToClose(true)
                       .title('You\'ve dismissed your Adminja 101 Guide.')
                       .textContent('Please visit your settings if you wish to re-enable it.')
                       .ariaLabel('Adminja Guide Dismissed')
                       .ok('Continue')
                   );

            }// if they dismissed guide

            // Tag it in Drip
            if(value){
                _dcq.push(["identify", {
                 email: userDataService.user.email,
                 tags: ["onBoarding: " + flag]
               }]);
            } else {
                 _dcq.push(["identify", {
                  email: userDataService.user.email,
                  remove_tags: ["onBoarding: " + flag]
                }]);
            }
            // Update our local data
            // userDataService.getLoggedInUser();
        } // vm.updateSettings



        vm.getColor = function(clientID){
            return clientDataService.clientColor(clientID)
        }

        vm.openClient = function(clientID){
            $state.go("triangular.workspaces.overview", {"clientID": clientID});

        }

        vm.openClientPackages = function(client){
          var billingType = 'periods';
          if(_.has(client, 'billingType')){
            billingType = client.billingType;
          }

          if(billingType == 'packages'){
              $state.go("triangular.workspaces.client-billing", {"clientID": client.uid});
          }

          if(billingType == 'periods'){
           $state.go("triangular.workspaces.client-legacy-billing", {"clientID": client.uid});
          }

        }

        vm.newSpace = function(){
             clientDataService.clientDialog(clientDataService.newClient(), 'New Workspace');
         }

        vm.refresh = function () {
            // force refresh the page here
            location.reload();
        }

        ////////////////////////////////////////////////////////////
        // Support Current Status Widgets
        ////////////////////////////////////////////////////////////
        //
        function setupStatusWidgets(){
            // Force default start of week (temporary)
            moment.locale('en', {
              week : {
                dow : 0,
                doy : moment.localeData('en').firstDayOfYear()
              }
            });

            // $log.info(vm.userData);
            var thisWeek = parseInt(moment().week()),
                 thisYear = parseInt(moment().year());

            vm.thisWeek = {};
            var userTotalsPath = "totals." + thisYear + ".weekly." + thisWeek;

            // $log.info(userTotalsPath);
            vm.weekStart = moment().startOf('week');
            vm.weekEnd = moment().endOf('week');


            // Count Due, Flagged and Upcoming
            // vm.due = 0;
            // vm.new = 0;
            // vm.later = 0;
            // vm.today = 0;
            // _.each(vm.userData.tasks, function (task) {
            //     if (task.status == 'open' && !task.snooze) {
            //         if (task.duedate && moment(task.duedate).diff(moment()) < 0) {
            //             // $log.info('this ones due!');
            //             vm.due++
            //         } else if (task.focus == 'today') {
            //             vm.today++
            //         } else {
            //             vm.later++
            //         }
            //     }

            // });


            // Determine start and end of this week based on settings
            var startOfWeek = 0;

            if(_.has(vm.settings, 'startOfWeek')){
                startOfWeek = vm.settings.startOfWeek;
            }

            // change 1st day of week to startOfWeek
            moment.locale('en', {
              week : {
                dow : startOfWeek,
                doy : moment.localeData('en').firstDayOfYear()
              }
            });

            // switch to make vm.weekStart and vm.weekEnd WHEN we integrate
            // live pulling for completed tasks.


            vm.customWeekStart = moment().startOf('week');
            vm.customWeekEnd = moment().endOf('week');
             var startAtStamp = vm.userData.uid + '-' + moment(vm.customWeekStart).toISOString(),
                 endAtStamp = vm.userData.uid + '-' + moment(vm.customWeekEnd).toISOString();

            // Get our time for this week
                 // $log.info('Getting user time from: ' + moment(start).toISOString() + '-' + moment(end).toISOString());
             var ref = firebase.database().ref('time');
             ref.orderByChild('userDate').startAt(startAtStamp).endAt(endAtStamp)
                     .on('value', function(snap) {
                         if(snap.exists()){
                             var thisWeeksTime = snap.val(),
                                 logged = 0;
                             _.each(thisWeeksTime, function(entry){
                                 logged = Number(logged) + Number(entry.logged);
                             });
                             vm.thisWeek.minutes = logged;
                             vm.thisWeek.hours = vm.thisWeek.minutes/60;
                           }
                     });
            // Get our Completed Tasks for the week
            var ref = firebase.database().ref('tasks');
            ref.orderByChild('info/userCompleted').startAt(startAtStamp).endAt(endAtStamp)
                    .on('value', function(snap) {
                        if(snap.exists()){
                            vm.thisWeek.tasks = _.size(snap.val());
                          }
                    });
        } // setup status widgets



        // putting this on scope. FOR SOME REASON, if vm.showDashboard == false, vm isn't available.
        // We only need this single piece of functionality from that state
        $scope.showCue = function(cue, flag){
            // trigger our primer
            Appcues.show(cue);

            // mark step complete
            if(flag){
                $timeout(function(){
                    vm.changeOnboardingFlag(flag, true);
                }, 1000);
            }
        }// vm.showCue

        // function setupClientStatus(){
        //     ////////////////////////////////////////////////////////////
        //     // Support Client Status Widgets
        //     ////////////////////////////////////////////////////////////
        //     //

        //     var now = moment(),
        //             thisMonth = parseInt(now.month() + 1),
        //             thisWeek = parseInt(now.week()),
        //             thisYear = parseInt(moment().year()),
        //             totalsPath = "totals." + thisYear + ".monthly." + thisMonth
        //             // ,calendar_totalsPath = "calendar_totals." + thisYear + ".monthly." + thisMonth,
        //             // retainer_totalsPath = "retainer_totals." + thisYear + ".monthly." + thisMonth;


        //     vm.currentMonthRange = moment().startOf('month').format('MMM D') + ' - ' + moment().endOf('month').format('D, YYYY');
        //     if(vm.settings.dateFormat == 'eu'){
        //       vm.currentMonthRange = moment().startOf('month').format('D') + ' - ' + moment().endOf('month').format('D MMM, YYYY');
        //     }

        //     vm.monthRange = function (thisClient) {

        //         // if this client has already been upgraded to use profile.plan.nextCycle,
        //         // we can simply calculate and return our range.
        //         // Otherwise, the old, long, complicated way

        //         var queryDate = moment().startOf('day').toISOString(),
        //             thisBillingPeriod = undefined;

        //         _.each(thisClient.billing, function(billingPeriod){
        //             if(moment(billingPeriod.start).startOf('day').toISOString() <= queryDate && moment(billingPeriod.end).endOf('day').toISOString() > queryDate){
        //                thisBillingPeriod =  billingPeriod;
        //             }
        //         });

        //         if(thisBillingPeriod){
        //             var endDate = thisBillingPeriod.end,
        //                 startDate = thisBillingPeriod.start;
        //                 var displayEndDate = undefined, displayStartDate = undefined;
        //                 displayStartDate = moment(startDate).format('MMM D');
        //                 if(vm.settings.dateFormat == 'eu'){
        //                   displayStartDate = moment(startDate).format('D MMM');
        //                 }

        //                 if(thisClient.profile.plan.recurrenceType == 'zero'){
        //                     displayEndDate = '...'
        //                 } else {
        //                     displayEndDate = ' - ' + moment(endDate).format('MMM D, YYYY')
        //                     if(vm.settings.dateFormat == 'eu'){
        //                       displayEndDate = ' - ' + moment(endDate).format('D MMM, YYYY')
        //                     }
        //                 }
        //             return displayStartDate + displayEndDate;
        //         } else {
        //             return ""
        //         }

        //     };// vm.monthRange

        // } // setupClientStatus

        vm.refreshClientSummaries = function(){
            // we really only need for angular to re-build the directives.
            // Hiding and showing them with "vm.refreshing=true" will do the trick.
            vm.refreshing = true;
            triMenu.removeMenu('triangular.workspaces');
            clientDataService.setupUserAndClientMenu(true);

            $timeout(function(){
                    vm.refreshing = false;
                }, 3000)
        }

            function setupWorkLoadChart(){
              // $log.info('setupWorkLoadChart');
              // vm.chartColors = [ '#46BFBD', '#FDB45C', '#803690', '#00ADF9', '#DCDCDC',  '#949FB1', '#4D5360'];

              vm.workloadChartColors = [


                {
                    backgroundColor: "rgba(64,161,232,1)",
                    borderColor: "rgba(64,161,232,1)",
                    pointBackgroundColor: "rgba(64,161,232,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "rgba(64,161,232,0.4)",
                    pointHoverBorderColor: "rgba(64,161,232,1)"
                  },
                  {
                      backgroundColor: "rgba(242,154,77,1)",
                      borderColor: "rgba(242,154,77,1)",
                      pointBackgroundColor: "rgba(242,154,77,1)",
                      pointBorderColor: "#fff",
                      pointHoverBackgroundColor: "rgba(242,154,77,0.4)",
                      pointHoverBorderColor: "rgba(242,154,77,1)"
                    }]
                ////////////////////////////////////////////////////////////
                // Support Workload Widget - 6 weeks of data
                ////////////////////////////////////////////////////////////
                //
                vm.charts.workload = [];
                vm.charts.workload.series = ['Tasks Completed', 'Hours Logged'];
                vm.charts.workload.options = {
                  legend: {
                              display: true,
                              position: 'bottom',
                              align: 'end',
                              labels:{
                                boxWidth: 10
                              }

                          },
                  scales: {
                             xAxes: [{
                               gridLines: {
                                 color: '#fff'
                               }
                             }],
                             yAxes: [{
                               gridLines: {
                                 color: '#efefef'
                               },
                                ticks: {
                                   maxTicksLimit: 5
                                  }
                             }]
                           },
                           elements: {
                                               point:{
                                                   radius: 0
                                               }
                                           },
                    // scaleOverride: true,
                    //  scaleSteps : 100,
                    //  scaleStepWidth : 1,
                    //  scaleStartValue : 0
                    //  ,
                    showTooltips: true,
                    datasetFill: true,
                    scaleBeginAtZero: true,
                    pointRadius: 1,
                    // scaleOverride: true,
                    // scaleSteps: 4,
                    responsive: true,
                    maintainAspectRatio: false,
                    scaleLabel : function(label){
                        var thisLabel = label.value.toString();
                        if(label.value > 99){
                            thisLabel = thisLabel + '+'
                        }
                        return thisLabel
                    }
                };

                vm.charts.workload.labels = [];
                vm.charts.workload.tasks = [];
                vm.charts.workload.hours = [];
                vm.charts.workload.data = [];
                vm.charts.workload.range = moment().format('MMM D');

                // Set our range for the chart
                var endChart = moment(),
                    startChart = moment().subtract(8, 'weeks');

                vm.charts.workload.range = startChart.format('MMM D') + ' - ' + endChart.format('MMM D, YYYY');
                if(vm.settings.dateFormat == 'eu'){
                  vm.charts.workload.range = startChart.format('D') + ' - ' + endChart.format('D MMM, YYYY');
                }

                // we need to find the start week and end week to pull

                    return userDataService.getWeekCounts(startChart, endChart)
                    .then(function(weekData){
                      var chartRange = moment.range(startChart, endChart);

                      chartRange.by('weeks', function (targetWeek) {
                          // Do something with `moment`
                          var dateLabel = moment(targetWeek).day("Monday"),
                                  weekHours = 0,
                                  weekTasks = 0,
                                  weekMinutes = 0,
                                  weekDate = moment(targetWeek).day('Monday').format('YYYY-MM-DD'),
                                  adjustedWeekDate = moment(targetWeek).day('Sunday').format('YYYY-MM-DD');
                                  // $log.info(weekDate);
                                  // $log.info(adjustedWeekDate);
                                  if(_.has(weekData, weekDate) || _.has(weekData, adjustedWeekDate)){
                                    if(_.has(weekData[weekDate], 'tasksCompleted')){
                                      weekTasks = weekData[weekDate].tasksCompleted || 0;
                                    }

                                    if(_.has(weekData[weekDate], 'timeLogged')){
                                      weekMinutes = weekData[weekDate].timeLogged || 0 ;
                                    }
                                    /// against adjusted date
                                    if(_.has(weekData[adjustedWeekDate], 'tasksCompleted')){
                                      weekTasks = weekData[adjustedWeekDate].tasksCompleted || 0;
                                    }

                                    if(_.has(weekData[adjustedWeekDate], 'timeLogged')){
                                      weekMinutes = weekData[adjustedWeekDate].timeLogged || 0 ;
                                    }

                                  }

                                  weekHours = weekMinutes/60;

                          // we should have weekTasks and weekHours before proceeding

                          if(vm.settings.dateFormat == 'us'){
                            vm.charts.workload.labels.push(dateLabel.format('MMM D'));
                          } else {
                            vm.charts.workload.labels.push(dateLabel.format('D MMM'));
                          }

                          vm.charts.workload.tasks.push(weekTasks);
                          vm.charts.workload.hours.push(weekHours.toFixed(2));

                      });

                      // Push our data array's into workload.data for display
                      vm.charts.workload.data.push(vm.charts.workload.tasks);
                      vm.charts.workload.data.push(vm.charts.workload.hours);
                      vm.chart1Loaded = true;
                      $timeout(function(){
                        vm.showWorkload = true;
                        vm.showProgressChart = true;
                      }, 0);
                    });

                //
            } // setupWorkloadChart

            function setupRevenueChart(){
                // $log.info('setupRevenueChart');
                ////////////////////////////////////////////////////////////
                // Support Revenue Widget - 12 months of data
                ////////////////////////////////////////////////////////////
                //
                vm.invoicingChartColors = [


                  {
                      backgroundColor: "rgba(242,203,77,1)",
                      borderColor: "rgba(242,203,77,1)",
                      pointBackgroundColor: "rgba(242,203,77,1)",
                      pointBorderColor: "#fff",
                      pointHoverBackgroundColor: "rgba(242,203,77,0.4)",
                      pointHoverBorderColor: "rgba(242,203,77,1)"
                    },
                    {
                        backgroundColor: "rgba(106,175,85 ,1)",
                        borderColor: "rgba(106,175,85 ,1)",
                        pointBackgroundColor: "rgba(106,175,85 ,1)",
                        pointBorderColor: "#fff",
                        pointHoverBackgroundColor: "rgba(106,175,85 ,0.4)",
                        pointHoverBorderColor: "rgba(106,175,85 ,1)"
                      }]
                vm.charts.revenue = [];
                vm.charts.revenue.series = ['Invoiced', 'Received'];
                vm.charts.revenue.options = {
                    legend: {
                                display: true,
                                position: 'bottom',
                                align: 'end',
                                labels:{
                                  boxWidth: 10
                                }

                            },
                    scales: {
                               xAxes: [{
                                gridLines:{
                                  color: '#fff'
                                }
                               }],
                               yAxes: [{
                                   gridLines:{
                                    color: '#efefef'
                                   },
                                   ticks: {
                                       maxTicksLimit: 5,
                                       // Include a dollar sign in the ticks
                                       callback: function(value, index, values) {
                                           return value;
                                       }
                                   }
                               }]
                           },
                    elements: {
                          point:{
                              radius: 0
                          }
                      },
                      showTooltips: true,
                    datasetFill: true,
                    scaleBeginAtZero: false,
                    scaleStepWidth: 100,
                    pointRadius: 1,
                    responsive: true,
                    maintainAspectRatio: false,
                    scaleLabel:
                        function(label){return  label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},

                    };

                vm.charts.revenue.labels = [];
                vm.charts.revenue.invoiced = [];
                vm.charts.revenue.received = [];
                vm.charts.revenue.data = [];
                vm.charts.revenue.range = moment().format('MMM D');

                // Set our range for the chart
                var endChart = moment().endOf('month'),
                    startChart = moment().subtract(12, 'months').startOf('month');

                vm.charts.revenue.range = startChart.format('MMM YYYY') + ' - ' + endChart.format('MMM YYYY');

                // Loop through startChart until endChart to create our labels
                // Set range for our weekly loop
                var chartRange = moment.range(startChart, endChart);
                return userDataService.getMonthCounts(startChart, endChart)
                .then(function(monthData){
                  chartRange.by('months', function (targetMonth) {
                      var dateLabel = moment(targetMonth).format("MMM"),
                          monthMoment = moment(targetMonth).startOf('month').startOf('day').toISOString(),
                          monthDate = moment(targetMonth).format('YYYY-MM'),
                          invoiced = 0,
                          paid = 0;
                      // Set our label
                      vm.charts.revenue.labels.push(dateLabel);
                      if(_.has(monthData, monthDate)){
                        if(_.has(monthData[monthDate], 'invoiced')){
                          invoiced = monthData[monthDate].invoiced;
                        }

                        if(_.has(monthData[monthDate], 'paid')){
                          paid = monthData[monthDate].paid;
                        }
                      }

                      vm.charts.revenue.invoiced.push(invoiced);
                      vm.charts.revenue.received.push(paid);

                  });// chartRange.by.month

                  vm.charts.revenue.data.push(vm.charts.revenue.invoiced);
                  vm.charts.revenue.data.push(vm.charts.revenue.received);

                  $timeout(function(){
                    vm.chart2Loaded = true;
                    vm.showRevenueChart = true;
                  }, 0);

                });//get data


            } // setupRevenueChart

            function getInvoiced(monthMoment){
                // $log.info('getInvoiced for ' + monthMoment);
                var monthData = {};
                monthData.invoiced = 0;
                monthData.balance = 0;
                monthData.payments = 0;

                _.each(vm.clientData, function(client){
                  //if(client.owner == $rootScope.userID || client.access.admins[vm.userData.uid]){ XXX this version includes clients you are admin on
                  if(client.owner == $rootScope.userID){ // this version only counts clients you OWN.
                    // $log.info('processing client: ' + client.profile.fullName);
                    _.each(client.billing, function(period){
                        if (monthMoment >= period.start && monthMoment <= period.end){
                            // $log.info('found appropriate period. adding');
                            if(_.has(period, 'total')){
                                monthData.invoiced = monthData.invoiced + period.total;
                            };

                            if(_.has(period, 'received')){
                                monthData.payments = monthData.payments + period.received;
                            };

                        }

                        // $log.info(monthData.invoiced + '/' + monthData.payments);
                    });
                  }// if client belongs to user

                });
                return monthData
            }

        //

        function checkConsent(){

            // check to see if we have their consent  If not, get it.

            // make sure we have a user first, otherwise it's an endless loop
            if($rootScope.userID){
              if(_.has(vm.userData, 'consent.privacy.hasConsent')){
                    // if it's true
                    if(vm.userData.consent.privacy.hasConsent){
                      // no worries
                    } else {
                      // they've revoked consent
                        gateService.getConsent();
                    }
                } else {
                  // didn't even have the node
                  gateService.getConsent();
                }// if hasConsent
            }

        }// checkConsent

        function newTask() {
              var userID = $rootScope.userID;

                vm.editedItem = taskDataService.newTask();

                vm.dialogTitle = "New";


                taskDataService.taskDialog(vm.editedItem);
          }// newTask


          // TEMP CODE - setup dropdown for count tracking nodes
          vm.countNodes = [
            {
              label: "New tasks",
              value: "newTasks"
            },
            {
              label: "Tasks completed",
              value: "tasksCompleted"
            },
            {
              label: "Tasks re-opened",
              value: "tasksReopened"
            },
            {
              label: "Time Logs",
              value: "timeLogs"
            },
            {
              label: "Time Logged",
              value: "timeLogged"
            },
            {
              label: "Invoices",
              value: "invoices"
            },
            {
              label: "Invoiced",
              value: "invoiced"
            },
            {
              label: "Payments",
              value: "payments"
            },
            {
              label: "Payment Total",
              value: "paymentTotal"
            },
            {
              label: "New Leads",
              value: "newLeads"
            },
            {
              label: "Archved Leads",
              value: "archivedLeads"
            },
            {
              label: "Won Leads",
              value: "wonLeads"
            },
            {
              label: "New Workspaces",
              value: "newWorkspaces"
            },
            {
              label: "Archived Workspaces",
              value: "archivedWorkspaces"
            },
            {
              label: "New Members",
              value: "newMembers"
            },
            {
              label: "Removed Members",
              value: "removedMembers"
            },
            {
              label: "Team New Tasks",
              value: "teamNewTasks"
            },
            {
              label: "Team Completed Taskss",
              value: "teamCompletedTasks"
            },
            {
              label: "Team Tasks Reopened",
              value: "teamTasksReopened"
            },
            {
              label: "Team Time Logs",
              value: "teamTimeLogs"
            },
            {
              label: "Team Time Logged",
              value: "teamTimeLogged"
            },
            {
              label: "New Task Template",
              value: "newTaskTemplate"
            }
          ];


          function triggerCount(countNode, quantity){
            userDataService.count($rootScope.userID, countNode, quantity)
            .then(function(results){
              $log.info(results);
            })
          }// triggerCount

    }// adminDashboardController

    function firstLoginController($log ,$scope, gateService, $mdDialog, $rootScope, clientDataService, user, refreshClientSummaries){
      $log.info('firstLoginController');
        $scope.user = user;
        $scope.planID = gateService.gateData.planID;

        $scope.isStarter = function(planID){
            if(planID.includes('starter')){
                return true
            }
        }

        $scope.next = function(){
            $scope.selectedSlide = $scope.selectedSlide + 1;
        }

        $scope.finish = function(){
            $scope.copyingClients = true;
            if($scope.planID != 'client-access'){
              return $scope.setupSampleWorkspace()
              .then(function(){
                  // refreshClientSummaries();
                  $mdDialog.cancel();
                  $rootScope.$emit('keySetupChanged');
              });
            } else {
              firebase.database().ref('users').child($scope.user.uid).child('/firstLogin').set(true);
              $mdDialog.cancel();
              $rootScope.$emit('keySetupChanged')
            }
        }

        $scope.setupSampleWorkspace = function(){

            var sampleClientID = '-KVXwMsIzy9WIa8o9JO5';
             return clientDataService.copyClient(sampleClientID, $scope.user.uid, true)
             .then(function(){
                 // setup usersandclients and force reload of user
                 return clientDataService.setupUserAndClientMenu(true)
                 .then(function(){
                     return clientDataService.thisUsersWorkspaces($scope.user, true)
                     .then(function(clients){
                     })

                 })
                 });
             return


        }// setupSampleWorkspace




    }// firstLoginController






})();

(function() {
    'use strict';

    angular
        .module('adminDashboard')
        .config(moduleConfig)
        // .run(['$rootScope', '$state','$stateParams', function($rootScope, $state, $stateParams) {
        //     $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        //       // We can catch the error thrown when the $requireAuth promise is rejected
        //       // and redirect the user back to the home page
        //       // debugger;
        //       if (error === 'AUTH_REQUIRED') {
        //         $state.go('authentication.login');
        //       }
        //     });
        // }]);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-dashboard');

        $stateProvider
            .state('triangular.dashboard', {
                url: '/',
                templateUrl: 'app/admin-dashboard/dashboard.tmpl.html',
                // set the controller to load for this page
                controller: 'adminDashboardController',
                controllerAs: 'vm'
            });

        // // send /dashboard requests to triangular.dashboard state
        // $urlRouterProvider.when(/dashboard/, ['$state','$match', function ($state, $match) {
        //   $state.go('triangular.dashboard');
        // }]);

        triMenuProvider.addMenu({
            name: 'Dashboard',
            icon: 'fa fa-dashboard',
            type: 'link',
            state: 'triangular.dashboard',
            priority: 1.0
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adminSetup')
        .config(moduleConfig)
        .run(authenticationRun);


    /* @ngInject */
    function authenticationRun($rootScope){
        var topRange = 5,
            bottomRange = 1;

        // Pick a random number and use it to set our rotating background class on auth pages
        var random = Math.floor(Math.random() * ((topRange-bottomRange)+1) + bottomRange);
        // $rootScope.authBackground = "mb-bg-12"
        $rootScope.authBackground = "mb-bg-" + random;
        // console.log($rootScope.authBackground);
    }

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-setup');

        $stateProvider
        .state('setup', {
            abstract: true,
            views:{
                'root':{
                    templateUrl: 'app/admin-setup/layouts/setup.tmpl.html'
                }
            }

            // url: '/authentication'
        })
        .state('setup.profile', {
            url: '/setup/profile',
            templateUrl: 'app/admin-setup/profile/setup-profile.tmpl.html',
            controller: 'setupProfileController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }]
            }

            // ,
            //         resolve: {
            //           checkUser: ['$firebaseAuth', '$state',function($firebaseAuth, $state) {
            //             console.log('--login checkUser--');
            //               if (firebase.auth().currentUser.uid){
            //                 $state.transitionTo('triangular.dashboard');
            //               }
            //           }]
            //         }
        })
        .state('setup.clients', {
            url: '/setup/clients',
            templateUrl: 'app/admin-setup/clients/setup-clients.tmpl.html',
            controller: 'setupClientsController',
            controllerAs: 'vm',
            resolve: {
                'currentAuth': ['authFactory', function(authFactory) {
                    return authFactory.$requireSignIn()
                }],
                // resolve our _userData and pass it to the Controller for saving
                 '_userData': ['userDataService', function(userDataService) {
                   return userDataService.getLoggedInUser()
                   .then(function(data){
                        return data
                   })
                }],

                    clientDataService: 'clientDataService',
                    // resolve our _clientData in our service and make avail to Controller
                     _clientData: function(_userData, clientDataService) {
                       return clientDataService.thisUsersWorkspaces(_userData)
                       .then(function(data){
                            return data
                       });
                    }
            }
        })

    }
})();

(function() {
    'use strict';

    angular
        .module('diagnostics', []);
})();

(function() {
    'use strict';

    angular
        .module('diagnostics')
        .controller('diagnosticsController', diagnosticsController);

    /* @ngInject */
    function diagnosticsController($log, userDataService, localStorageService, $rootScope, clientDataService) {
   // $log.info('diagnosticsController');

   var vm = this;
   vm.localUserID = localStorageService.get('userID');
   vm.thisClient = $rootScope.thisClient;

  	}; // end diagnosticsController
})();

(function() {
    'use strict';

    angular
        .module('diagnostics')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-diagnostics');

        $stateProvider
            .state('triangular.diagnostics', {
                url: '/diagnostics/',
                templateUrl: 'app/admin-diagnostics/diagnostics.tmpl.html',
                // set the controller to load for this page
                controller: 'diagnosticsController',
                controllerAs: 'vm'
            });

    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager', ['appServices', 'ngSanitize', 'ngAnimate'])
        .run(function ($state,$rootScope) {
        	// Put state on rootscope so we ALWAYS know what it is.
            $rootScope.$state = $state;

        });
})();

(function () {
    'use strict';

    angular
            .module('clientManager')
            .controller('clientTimeController', clientTimeController);

    /* @ngInject */
    function clientTimeController($q, $log, $mdDialog, $filter, teamDataService, timeDataService, timeReportService, CSV, userDataService, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, _userData, _clientData) {
        // $log.info('clientTimeController');
        var vm = this;
        vm.user = _userData;
        vm.settings= $rootScope.userSettings;
        vm.timeReportService = timeReportService;
        vm.timeReportService.init();
        vm.retainerMode = false;
        vm.maxDate = moment().toDate();
        vm.minDate = moment().subtract(2, 'years').toDate();
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.now = moment().toISOString();
        $timeout(function(){
          //lonload we are initiliaing teams. Let's make sure there's an indictor until the report is ready
          vm.timeReportService.report.loading = true;
        },0);

        // Restrict our reporting to just this client
        vm.timeReportService.report.source = $stateParams.clientID;
        vm.timeReportService.report.selectedClient = $stateParams.clientID;
        // vm.timeReportService.report.uid = vm.client.uid;

        // Declare this so we don't thrown an error before we are setup
        vm.teamList = {};
        vm.relatedMembers = [];
        // Init function
        function init(){
          // set range setting override picker to current setting
          vm.rangeSetting = vm.settings.reportRange;
          // Identify thisClient
          vm.thisClient = _.find(vm.clients, function (client) {
              return client.uid == $stateParams.clientID;
          });

          vm.showRates = false;
          if(_.has(vm.thisClient.access.admins, $rootScope.userID)){
            vm.showRates = true;
          } else {
            vm.showRates = false;
          }

          // determine if this workspace is being made available to a clientUser instead of owner or team member
          if(_.has(vm.thisClient, 'clientUsers['+ vm.user.uid+']')){
            vm.isWorkspaceClient = true;
            vm.showRates = true;
            // restrict clientUsers from visiting this state if state is disabled in clientUserTabs
            if(!vm.thisClient.clientUserTabs.time){
              $state.go('triangular.workspaces.overview');
            }
          }

          // redirect if not allowed to view


            // $log.info('Teams');
            // $log.info(teamDataService.clientTeams);
            // $log.info('thisTeam');
            // $log.info(teamDataService.clientTeams[vm.thisClient.uid]);
            if(!_.has(teamDataService.clientTeams)){
              // $log.info('no teams');
              // turn on loading indicators

              return teamDataService.init()
              .then(function(){
                // $log.info('teamDataService initialized');
                vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
                vm.teamDataService = teamDataService;


                $timeout(function(){
                  postInit();
                }, 1000);

              })
            } else {
              // $log.info('have teams');
              vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
              vm.teamDataService = teamDataService;
              postInit();
            }


        } // init

        function postInit(){
          // $log.info('Team:');
          // $log.info(vm.teamList);

          // If no report range setting. Set it to default: 'saved' (last used)
          if(!_.has(vm.settings, 'reportRange')){
            vm.settings.reportRange = 'saved'
          }

          timeReportService.setDateRangeFromSetting(vm.settings.reportRange);


          if(_.has(vm.settings, 'defaultTimeView')){
            // $log.info('using stored settings');
            timeReportService.report.view = vm.settings.defaultTimeView;
          } else {
            timeReportService.report.view = 'month'
          }
          setupMonthSelect();
          vm.updateReport();
        }

        // Setup the report service and the page
        // in a $timeout becuase for some reason, refreshing on a client-time page was inhibiting rightsidenav.controller.js to get the user info.
        // suspicion is collision during init here running in concurrence
        $timeout(function(){init();}, 1000);



        vm.openTime = function(entry){
            timeDataService.timeDialog(entry, 'Modify');
        }

        vm.showTeamFilter = function(){
         if (_.size(vm.teamList) > 1){
             return true
         }
        }

        vm.updateDateRange = function(rangeSetting){
          timeReportService.setDateRangeFromSetting(rangeSetting);
          vm.updateReport();
        }

        function putInView() {
            $('#scroll-h').animate({
                scrollLeft: 0
            }, 20, 'linear');
        }

        vm.reportTime = function(group, entries){
            // $log.info('printTime');
            vm.printReport = {};
            vm.printReport.clientName = vm.thisClient.profile.fullName;
            if(vm.printReport.clientName != 'All Workspaces'){
              vm.printReport.clientID = vm.thisClient.uid
              if(_.has(vm.thisClient.profile, 'email')){
                vm.printReport.clientEmail = vm.thisClient.profile.email
              } else {
                vm.printReport.clientEmail = '';
              }
            }

            vm.printReport.start = group.start;
            vm.printReport.end = group.end;
            vm.printReport.type = 'time';
            vm.printReport.rate = vm.thisClient.profile.plan.rate;
            // vm.printReport.allocated = vm.thisClient.profile.plan.allocated;
            vm.printReport.time = entries;
            vm.printReport.total = vm.logTotal(vm.printReport.time);
            vm.printReport.filename = vm.groupTimeReportFilename(group) + '.pdf';
            timeDataService.timeReportDialog(vm.printReport);
        }

        vm.reportAllTime = function(){
          vm.printReport = {};
          vm.printReport.clientName = vm.thisClient.profile.fullName;
          if(vm.printReport.clientName != 'All Workspaces'){
            vm.printReport.clientID = vm.thisClient.uid
            vm.printReport.clientEmail = vm.thisClient.profile.email
          }
          vm.printReport.start = vm.timeReportService.report.start;
          vm.printReport.end = vm.timeReportService.report.end;
          vm.printReport.type = 'time';
          vm.printReport.rate = 0;
          // vm.printReport.allocated = 0;
          vm.printReport.time = vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end);
          vm.printReport.total = vm.logTotal(vm.printReport.time);
          vm.printReport.filename = vm.allTimeReportFilename() + '.pdf';
          timeDataService.timeReportDialog(vm.printReport);
        }// Print All Time


        // create array for populating our month/year drop downs.
        function setupMonthSelect(){
            var now = moment().startOf('month'),
                nowPlus = moment(now).add(1, 'month'),
                start = moment().subtract(23, 'months'),
                months = [];

            for (var m = moment(now); m.isAfter(start); m.subtract(1, 'month')) {
                var thisMonth = {
                     label: moment(m).format('MMM YYYY'),
                     date: moment(m).toISOString()
                }
                months.push(thisMonth);
            }
            vm.monthSelect = months;
        }



        vm.groupTimeReportFilename = function(group){
          var filename = "";
          if(vm.timeReportService.report.source == 'user'){
            filename = 'all-clients-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
            return filename
          } else {
            _.each(vm.clients, function(client){
              if(client.uid == vm.timeReportService.report.selectedClient){
                filename = _.snakeCase(client.profile.fullName);
                filename = filename + '-' + moment(group.start).format('MM-DD-YY--') + moment(group.end).format('MM-DD-YY');
              };
            });
            return filename
          }// if else
        }// vm.grouopTimeReportFilename

       vm.allTimeReportFilename = function(){
         var filename = "";
         if(vm.timeReportService.report.source == 'user'){
           filename = 'all-clients-';
           filename = filename + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
           return filename
         } else {
           _.each(vm.clients, function(client){
             if(client.uid == vm.timeReportService.report.selectedClient){
               filename = _.snakeCase(client.profile.fullName);
               filename = filename + '-' + moment(vm.timeReportService.report.start).format('MM-DD-YY--') + moment(vm.timeReportService.report.end).format('MM-DD-YY');
             };
           });
           return filename
         } // if/else
       }// vm.allTimeReportFilename




        vm.viewRetainer = function(){
            // convert our current date range to begin/end of months to match up with our new month/year select menus
            // vm.timeReportService.report.start = moment(vm.timeReportService.report.start).startOf('month').toISOString();
            // vm.timeReportService.report.end = moment(vm.timeReportService.report.end).startOf('month').toISOString();
            // NOTE: subtacting 1 month for start date...otherwise we aren't getting everything
            vm.timeReportService.report.start = moment(vm.timeReportService.report.start).subtract(1,'month').toISOString();
            vm.timeReportService.report.end = moment(vm.timeReportService.report.end).toISOString();
            // Enable retainerMode
            vm.retainerMode = true;
            // Set our report view
            vm.timeReportService.report.view = 'retainer';
            // Update our report
            vm.updateReport();

        }

        vm.viewWeeks = function(){
          // Make sure retainerMode is off
          userDataService.changeUserSetting('defaultTimeView', 'week');
          vm.retainerMode = false;
          // Set our report view
            vm.timeReportService.report.view = 'week';
          // Update our report
            vm.updateReport();


        }

        vm.viewMonths = function(){
            // Make sure retainerMode is off
            vm.retainerMode = false;
            // Set our View
            vm.timeReportService.report.view = 'month';
            // Update our report
            vm.updateReport();

        }

        vm.viewList = function(){
          vm.retainerMode = false;
          vm.timeReportService.report.view = 'list';
          vm.updateReport();

        }

        // Detect deletions and update report
        // Detect deletions and update report
             var unwatch = $rootScope.$on('updateTimeReport', function(event, data) {
                 vm.updateReport();
               });
             $scope.$on('$destroy', function(){
               unwatch();
             })

        vm.updateReport = function(){
          // $log.info('client-time.controller.js - vm.updateReport');
          delete vm.printReport;

          // Update time data

            // $log.info('lets pull this client\'s time');
            vm.timeReportService.getClientsTime(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);


          // $log.info(vm.timeReportService.report.data);
          // Update our grouping data
          switch(vm.timeReportService.report.view) {
              case 'retainer':
                  vm.timeReportService.setRetainerList(vm.timeReportService.report.selectedClient, vm.timeReportService.report.end, vm.timeReportService.report.start);
                  break;
              case 'week':
                  vm.timeReportService.setWeekList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                  break;
              case 'month':
                  vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
                  break;
              default:
                  vm.timeReportService.setMonthList(vm.timeReportService.report.end, vm.timeReportService.report.start);
          } // switch vm.timeReportService.report.view



          // if there are no members in the report, set the team picklist to Everyone so subsequent filters won't fail with a null
          if(vm.relatedMembers.length < 1){
            vm.timeReportService.report.selectedMember = "all"
          }
        }// vm.updateReport


        // Source of pre-filtered entries for each time group.
        // TODO - this is probably pretty expensive for big reports
        vm.groupEntries = function(start, end){

          var entries = [],
              total = 0,
              count = 0;
              vm.reportTotal = 0;
         start = moment(start).startOf('day').toISOString();
         end = moment(end).endOf('day').toISOString();
         vm.reportData = vm.timeReportService.report.data;
          _.each(vm.reportData, function(entry){
            count = count + 1;
            var role = "member";

            if(_.has(vm.thisClient.access.admins, $rootScope.userID)){
              role = 'admin'
            }

            if(teamDataService.isTeamAdmin($rootScope.userID, vm.thisClient.owner)){
              role = 'admin'
            }


            if(vm.thisClient.owner == $rootScope.userID){
              role = 'owner'
            }



            if(_.has(vm.teamList, $rootScope.userID)){
              // Convert to utc for accurate comparison
              if(role == 'owner' || role == 'admin' || vm.isWorkspaceClient){

                if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){

                  if(entry.logDate < end && entry.logDate >= start){

                     vm.prepareDisplayEntry(entry);
                     entries.push(entry);
                     vm.checkMember(entry);
                     vm.reportTotal = vm.reportTotal+entry.logged;
                  }// if in date range
                }// if passes userFilter
              } else if (role == 'member' || vm.isWorkspaceClient ){

                if(entry.creator == $rootScope.userID || vm.isWorkspaceClient){

                  if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember ){

                    if(entry.logDate < end && entry.logDate >= start){

                      vm.prepareDisplayEntry(entry);
                      entries.push(entry);
                      vm.checkMember(entry);
                      vm.reportTotal = vm.reportTotal+entry.logged;
                    }// if in date range
                  }// if passes userFilter
                }
              }
            } else {
              if(vm.timeReportService.report.selectedMember == 'all'  || entry.creator == vm.timeReportService.report.selectedMember || vm.isWorkspaceClient){
                if(entry.logDate < end && entry.logDate >= start && (entry.creator == vm.user.uid || vm.isWorkspaceClient)){
                  vm.prepareDisplayEntry(entry);
                  entries.push(entry);
                  vm.checkMember(entry);
                  vm.reportTotal = vm.reportTotal+entry.logged;
                }// if in date range
              }// if passes userFilter
            }

          });

          return entries
        }

        vm.manualRangeUpdate = function(){
          // Manual date range change should clear the quick range selected
          $timeout(function(){
            vm.rangeSetting = 'saved';
          });
          // update the report
          vm.updateReport();
          // we were making manual changes to save the range
            userDataService.changeUserSetting('reportStart', vm.timeReportService.report.start);
            userDataService.changeUserSetting('reportEnd', vm.timeReportService.report.end);
            userDataService.changeUserSetting('defaultTimeView', vm.timeReportService.report.view);
        }// manualRangeUpdate

        vm.checkMember = function(entry){
          // checkmember is used to build our team picker.

           // Is this member already in our relatedMembers array?
           var isInRelatedMembers = _.find(vm.relatedMembers, function (member) {
              return member.uid == entry.creator;
          });

          if(!isInRelatedMembers){
            // this member is not in our picker yet
            // check to see if member is still part of the team and grab their object if they are
            var isInAllMembers = _.find(vm.teamList, function (thisMember) {
                 return thisMember.uid == entry.creator;
             });

            if(isInAllMembers){
              // this member is on the team, add it to relatedMembers
              vm.relatedMembers.push(isInAllMembers);
            } else {
              // this member no longer on the team. make a slug for them and add that
               var memberName = _.split(entry.creatorName, ' ', 2),
               memberSlug = {
                uid: entry.creator,
                profile: {
                  firstName: memberName[0],
                  lastName: memberName[1]
                }
              }
              vm.relatedMembers.push(memberSlug)
            }
          }
         }// vm.checkMember

        vm.prepareDisplayEntry = function(entry){
          // This function pre-calculates some variables so our ng-repeat doesn't have to
          // this yields a much faster render of big time reports
          entry.displayLogDate = moment(entry.logDate).format(vm.settings.amDateFormat);
          entry.displayLogTime = moment(entry.logDate).format('h:mm a');

          // adding this check...seeing sentry errros that there's no description. That's possible.
          if(_.has(entry, 'description')){
            entry.displayDescription = entry.description.substring(0,50);
          }

          entry.displayLogged = $filter('userTimeFormat')(entry.logged);

        }

        //live totals calculation for each group
        vm.logTotal = function (logs) {
            var total = 0;
            _.each(logs, function (entry) {
                total += Math.round(entry.logged);
            })
            return total
        };

        // Functionality for downloading CSVs
        vm.downloadCSVFile = function(data, filename) {
                   var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
                   // $log.info(preppedData);
                   // var data = "text/json;charset=utf-8," + data;

                   var downloader = document.createElement('a');

                   downloader.setAttribute('href', preppedData);
                   downloader.setAttribute('download', filename + '.csv');
                   downloader.click();
               };

        vm.downloadCSV = function(logs, filename){

            var cleanLogs = [];

            // Clean Up our logData (remove unnecessary things)
            _.each(logs, function(entry){

                // Get our clientname
                var clientName = "";
                if(!_.has(entry, 'clientName')){
                    clientName = entry.client;
                } else {
                    clientName = entry.clientName;
                }

                // get our taskName
                var taskName = 'none',
                    description = '';
                if(_.has(entry, 'taskName')){
                    taskName = entry.taskName;
                    // trim it
                    taskName = _.truncate(taskName, {
                                  'length': 100,
                                  'separator': ' '
                                });
                    // sanitize it (replace commas and line breaks)
                    taskName = _.replace(taskName,new RegExp(",","g"),"-");
                    taskName = _.replace(taskName,new RegExp("\n","g")," ");

                    // $log.info(taskName);
                }


                if(_.has(entry, 'description')){
                  // trim it
                  description = _.truncate(entry.description, {
                                'length': 100,
                                'separator': ' '
                              });
                  // sanitize it (replace commas and line breaks)
                  description = _.replace(description,new RegExp(",","g"),"-");
                  description = _.replace(description,new RegExp("\n","g")," ");

                  // $log.info(description);
                }

                // build our new object
                var newCSVLog = {
                    'clientName': clientName,
                    'creatorName': entry.creatorName,
                    'description': description,
                    'logDate' :moment(entry.logDate).format('YYYY-MM-DD'),
                    'logged' : entry.logged,
                    'taskName': taskName
                }

                cleanLogs.push(newCSVLog);

            });

            // Set the header labels for our CSV file (note, we are accepting default alpha format)
            var csvOptions = {
                'header': [
                    'Client',
                    'User',
                    'Description',
                    'Date',
                    'Minutes',
                    'Task'
                ]
            }


            // Convert our json to CSV and start the download
            CSV.stringify(cleanLogs, csvOptions).then(function(result){
                    // $log.info(result);
                       vm.downloadCSVFile(result, filename + '.csv');
                   });
        }



    }// end clientTimeController


})();

  (function() {
     'use strict';

     angular
          .module('clientManager')
          .controller('clientTasksController', clientTasksController);

     /* @ngInject */
     function clientTasksController($q, $log, $window, $mdToast, $document, gateService, dragulaService, clientPackageService, taskPanelDataService, userDataService, teamDataService, localStorageService, $sanitize, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, taskTemplateDataService, pageDimensionsService, hotkeys, $mdDialog, _userData, _clientData) {
          // $log.info('clientTasksController');
          // $log.info(this);
          var vm = this;
          init();

          function init(){
               vm.clients = $scope.$resolve.clientDataService.clients;
               // get the client
               vm.thisClient = _.find(vm.clients, function(client) {
                    return client.uid == $stateParams.clientID;
               });
               if (_.has(vm.thisClient, 'defaultTaskBoard')) {
                    vm.boardID = vm.thisClient.defaultTaskBoard;
               }
               // else {
               //      $timeout(function() {
               //           vm.upgradingBoard = true;
               //      })
               //      .then(function(){
               //           return taskDataService.upgradeTaskBoard(vm.thisClient)
               //           .then(function(){
               //                $timeout(function(){
               //                     init();
               //                }, 5000)
               //           })
               //           .catch(function(error){
               //                $log.error(error);
               //                throwError(error)
               //           })
               //      })

               // }
          }// init




          function throwError(error){
               $log.error(error);
               alert('could not upgrade board')
               $timeout(function() {
                    vm.upgradingBoard = false;
                    vm.boardError = error;
               })
          }//throwError

          function cancelUpgrade(){
               $state.go('triangular.workspaces.legacy-tasks', {clientID: vm.thisClient.uid})
          }//cancelUpgrade

     }; //clientTasksController

  })();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientTaskTemplatesController', clientTaskTemplatesController);
        // clientTaskTemplatesController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */

    function clientTaskTemplatesController($log, $state, gateService, taskDataService, $stateParams, taskTemplateDataService,  $scope, dragulaService, $timeout, $rootScope, $mdDialog,  _clientData, _userData) {
        var vm = this;
        vm.user = _userData;
        vm.settings = $rootScope.userSettings;
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.clientID = $stateParams.clientID;
        vm.thisClient = _.find(vm.clients, function (client) {
            return client.uid == vm.clientID;
        });
        vm.account = vm.thisClient.owner;

        vm.recurringLimit = gateService.gateData.recurringLimit;

        vm.verticalTaskPanels = vm.settings.verticalTaskPanels;
        vm.suppressResize = false;
        if (vm.verticalTaskPanels === true){
            vm.suppressResize = true;
        }

        // restrict clientUsers from visiting this state directly
        vm.isClientUser = false;
        if(_.has($rootScope, 'VAWorkspaces')){
            if(_.has($rootScope.VAWorkspaces, $state.params.clientID)){
                    vm.isClientUser = true;
                      $state.go('triangular.workspaces.overview');
            }
        }



        // store small subset of properties globally so our toolbar has easy info
        $rootScope.thisClient = vm.thisClient.profile;


        if(_.has(vm.settings, 'collapseCards')){
            if(vm.settings.collapseCards){
                vm.collapseCards = vm.settings.collapseCards;
            } else {
                vm.collapseCards = false;
            }
        }

        vm.hasTemplates = function(){
            var found = false;
            _.each(vm.thisClient.taskTemplates, function(template){
                if(!template.isRecurring){
                    found = true
                }
            });

            return found
        }
        vm.hasRecurring = function(){
         var found = false;
         _.each(vm.thisClient.taskTemplates, function(template){
             if(template.isRecurring){
                 found = true
             }
         });

         return found
        }

        vm.newTaskTemplate = function(client){
            // $log.info('recurrringLimit: ' + vm.recurringLimit);
            // if no limit, or if they are under their limit, or if they were delegated this workspace start a new taskTemplate
            if(vm.recurringLimit == 0 || (_.size(vm.thisClient.taskTemplates) < vm.recurringLimit) || vm.thisClient.owner != $rootScope.userID){
                var template =  taskTemplateDataService.newTaskTemplate(client);
                template.account = vm.account;
                taskDataService.taskDialog(template);
            } else {
                var confirm = $mdDialog.confirm()
                         .title('You\'ve reached your Recurring Task limit for this Workspace')
                         .htmlContent('Your current plan limits you to ' + vm.recurringLimit + ' recurring tasks per Workspace.')
                         .ariaLabel('Change subscription?')
                         .ok('Ok')
                         .cancel('Get more Recurring Tasks');

                   $mdDialog.show(confirm).then(function() {

                   }, function() {

                    $state.go('authentication.profile', {selectedTab: 5});
                   });
            }

            // otherwise throw a dialog pushing them to upgrade
        }


            // Task Dragging
            dragulaService.options($scope, 'drag-task', {
                moves: function (el, container, handle) {
                        return true
                        // return handle.classList.contains('task-handle');
                },
                accepts: function (el, target, source, sibling) {

                    var targetPanelID = $( target ).attr( "panelid" ),
                    sourcePanelID = $( source ).attr( "panelid" );

                    if(targetPanelID == sourcePanelID){
                        return true
                    }

                },
                invalid: function(el, handle){
                    // return var === 'condition'
                    return false
                },
                direction: 'vertical',
                revertOnSpill: true
            });

            // declare our taskBag so we can track drake.dragging
            var taskBag = dragulaService.find($scope, 'drag-task');

            $scope.$on('drag-task.drag', function(){

            });
            $scope.$on('drag-task.cancel', function(){
                // $scope.$apply();
            });

            // Task Drop Listener
            $scope.$on('drag-task.drop', function (event, item, target, source, sibling) {
                // $log.info('drop');
                // $log.info(item);
                // Now we can do our work - prep the variables
                var itemID = item[0].attributes.taskid.value,
                        parentPanelID = source[0].attributes.panelid.value,
                        parentPanel = $('.app-item-container-items[panelid="'+ parentPanelID +'"]'),
                        // targetPanelID = target[0].attributes.panelid.value,
                        // numSourceChildren = $(parentPanel).find('.app-item-task').length,
                        // sourceChildren = $(parentPanel).find('.app-item-task').toArray(),
                        ghostElement = document.querySelector('.gu-transit'),
                        targetChildren = Array.from(ghostElement.parentNode.children),
                        // targetItemIndex = targetChildren.indexOf(ghostElement),
                        thisBag = dragulaService.find($scope, 'drag-task'),
                        updates = {},
                        thisTask = vm.thisClient.taskTemplates[itemID],
                        clientID = thisTask.info.client;

                // Prepare order changes for all tasks in set
                _.each(targetChildren, function(child, index){
                    var childID = child.attributes.taskid.value,
                        // getting thisTask will differ for other task views
                        childTask = vm.thisClient.taskTemplates[childID];
                        // $log.info(childTask);
                    updates['/taskTemplates/' + childID + '/info/order'] = Number(index + 1);
                    updates['/clients/' + clientID + '/taskTemplates/' + childID + '/info/order'] = Number(index + 1);
                }); // each targetChildren

                return firebase.database().ref().update(updates)
                .then(function(){
                    // thisBag.drake.cancel(true);
                    // scrollable = true;
                        // $rootScope.draggingTask = false;
                        $scope.$apply();
                });

            });// $on.drag-task.drop


    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientProfileController', clientProfileController);



        /* @ngInject */
        function clientProfileController($scope, $q, $log, gateService, hotkeys, triLayout, panelDataService, $sanitize, $http, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, pageDimensionsService, templateDataService, profileDataService, $mdDialog, $mdMedia, _userData, _clientData, triLoaderService, dragulaService) {
        var vm = this;
        vm.user = _userData;
        vm.settings = $rootScope.userSettings;
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.canUseTimer = gateService.gateData.canUseTimer;
        vm.isWorkspaceClient = false
        $rootScope.filterText = "";
        $scope.showFilterBar = false;
        // $timeout(function(){
        //     triLoaderService.setLoaderActive(true);
        // },0);



        $scope.client = _.find(vm.clients, function(client) { return client.uid == $stateParams.clientID; });


        if(_.has(vm.settings, 'verticalTaskPanels')){
            if(vm.settings.verticalTaskPanels){
                vm.taskDragDirection = "vertical"
            } else {
                vm.taskDragDirection = "horizontal"
            }
        }

        if(_.has(vm.settings, 'verticalProfilePanels')){
            if(vm.settings.verticalProfilePanels){
                vm.profileDragDirection = "vertical"
            } else {
                vm.profileDragDirection = "horizontal"
            }
        }

        // determine if this workspace is being made available to a clientUser instead of owner or team member
        if(_.has($scope.client, 'clientUsers['+ vm.user.uid+']')){
          vm.isWorkspaceClient = true;
          // restrict clientUsers from visiting this state if state is disabled in clientUserTabs
          if(!$scope.client.clientUserTabs.details){
            $state.go('triangular.workspaces.overview');
          }
        }


        $scope.launchPrimer = function(){
          // $log.info('launchPrimer clicked');
            // Appcues.show($rootScope.tutorials.manageClientProfile);
        };

        $scope.itemsBackground = function itemsBackground(color){
          // $log.info('itemsBackground', color);
          if(color){
            var newColor = ajUTILITIES.lightenDarkenColor(color, 120);
            // $log.info(newColor);
            return newColor
          }
        }



        $scope.showPrimer = function(){
          if (_.has($scope, 'client.panels')){
              if (_.size($scope.client.panels) < 2){
                return true
              } else {
                return false
              }
        } else {
          return true
        }
      };

        // store small subset of properties globally so our toolbar has easy info
        if (_.has($scope, 'client.profile')){
            $rootScope.thisClient = $scope.client.profile;
               };


        // $log.info('clientProfileController');
      // NOTE: $scope.user, and $scope.client client has already been established by our parent controller (clientManagerPageController)

        // We need $state to be avail to client-card directive to determine what elements in client card should be shown
        $rootScope.$state = $state;

        $rootScope.draggingDetail = false;
        $rootScope.draggingPanel = false;


        // Timeout without a duration gets run after the page is done
        // https://stackoverflow.com/questions/11125078/is-there-a-post-render-callback-for-angular-js-directive
        $timeout(function () {
          // after dom is loaded, our resizing directive needs a chance to arrange the page before we remove the loader
          // $timeout(function(){
          //   triLoaderService.setLoaderActive(false);
          // },100);
          $timeout(function(){
            pageDimensionsService.resizeColumns();
          }, 2000);
        });


        // Our Scrolling Helpers
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        }

        function scroll(amount) {
            $('#scroll-h').animate({
                scrollLeft: amount
            }, 50, 'linear');
        }

        // Dragula Setup

        // Inhibit screen scroll on drag/mobile solution from:
        // https://github.com/bevacqua/dragula/issues/487
        var scrollable = true;

        var listener = function(e) {
            if (! scrollable) {
                e.preventDefault();
            }
        }

        // document.addEventListener('touchmove', listener, { passive:true });
        // end inhibit touch scroll during drag events

        dragulaService.options($scope, 'drag-profile-panel', {
             moves: function (el, container, handle) {
               return handle.classList.contains('panel-drag-handle');
             },
             accepts: function (el, target, source, sibling) {
                 // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                 if ($(target).is('.scroll-trigger')){
                     // we can't drop on scroll-triggers
                     if($(target).is('.scroll-trigger-right') && $rootScope.draggingPanel){
                         var scrollAmount = '+=20';
                       debounce(scroll(scrollAmount), 250)
                     }
                     if($(target).is('.scroll-trigger-left') && $rootScope.draggingPanel){
                        var scrollAmount = '-=20';
                         debounce(scroll(scrollAmount), 250)
                     }
                     return false
                 }
                 else {
                     return true
                 }

             },
             allowNestedContainers: true,
             direction: 'horizontal',
             revertOnSpill: true
           });

        dragulaService.options($scope, 'drag-profile-detail', {

            moves: function (el, container, handle) {
               // return handle.classList.contains('detail-handle');
               // return handle.classList.contains('info-card');
               if(handle.classList.contains('detail-handle')){
                if (!handle.classList.contains('nodrag')){
                  return true
                } else {
                  return false
                }
               } else {
                return false
               }
             },

            accepts: function(el, target, source, sibling) {
               // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                  if ($(target).is('.scroll-trigger')){
                      // we can't drop on scroll-triggers
                      if($(target).is('.scroll-trigger-right') && $rootScope.draggingDetail){
                          var scrollAmount = '+=20';
                        debounce(scroll(scrollAmount), 250)
                      }
                      if($(target).is('.scroll-trigger-left') && $rootScope.draggingDetail){
                         var scrollAmount = '-=20';
                          debounce(scroll(scrollAmount), 250)
                      }
                      return false
                  }
                  else {
                      return true
                  }
               },
            direction: vm.profileDragDirection,
            revertOnSpill: true
            // ,
            // copy:true


           });

        // Function checks to see if we SHOULD show overflow scrollTrigger areas
        $scope.checkOverflow = function() {
            var scrollH = $('#scroll-h'),
                target = scrollH[0];
               if (target.offsetHeight < target.scrollHeight ||
                      target.offsetWidth < target.scrollWidth) {
                      // your element have overflow
                  return true
                    } else {
                      // your element doesn't have overflow
                      return false
                    }
        };

        $scope.$on('drag-profile-panel.drag', function(){
            $rootScope.draggingPanel = true;
            scrollable = false;
            if($scope.checkOverflow()){
                $rootScope.draggingPanel = true;
                $scope.$apply();
            }

        });

        $scope.$on('drag-profile-panel.cancel', function(){
               scrollable = true;
              $rootScope.draggingPanel = false;
              $scope.$apply();
        });

        $scope.$on('drag-profile-detail.drag', function(){

            scrollable = false;
            if($scope.checkOverflow()){
                $rootScope.draggingDetail = true;
                $scope.$apply();
            }

        });

        // // Drop Detail
        $scope.$on('drag-profile-detail.drop', function(event, el, target, source, sibling){
          // $log.info('Page Drop');
          // $log.info('Event: ', event);
          // $log.info('Element: ',el);
          // $log.info('Target: ', target);
          // $log.info('Source: ', source);
          // $log.info('Sibling: ', sibling);
            scrollable = true;
            if($scope.checkOverflow()){
                $rootScope.draggingDetail = false;
                $scope.$apply();
            }
            // $log.info(el);
            // Gather all of the properties we will need to execute the move
             var  detailID = el[0].id,
               parentPanelID =  el[0].attributes.panel.value,
               // we are using the clientID current context instead of what's on cards and panels, just in case the detail or panel was copied with the wrong clientID (pre 2020 client clones)
               // this also leet's us make sure that the correct clientID gets applied to panels & details when their order is updated.
               clientID = $scope.client.uid,
               // clientID = target[0].attributes.client.value,
               // clientID = el[0].attributes.client.value,
               targetPanelID = target[0].attributes.panelid.value,
               newOrder = undefined;

               // $log.info('clientID: ' + clientID);
               // $log.info('targetPanelID: ' + targetPanelID);
               // $log.info('detailID: ' + detailID);
            // var thisDetail = $scope.$parent.client.panels[targtPanelID].details[detailID];
            var thisDetail = $scope.client.panels[parentPanelID].details[detailID];

            // $log.info(thisDetail);

             // if there's a sibling in the targetPanel, then let's set our order so it is inserted in the right place
             if (sibling != undefined){
              if (!sibling[0].attributes.order.value) {
                // sibling doesnt have a value. Put this at the top.
                  newOrder = 0
              } else {
                // $log.info(sibling);
                // $log.info('Dropped before sibling: ' + sibling[0].attributes.id.value + ' Order: ' + Number(sibling[0].attributes.order.value));
                  // sibling has an order, put ours before it
                  newOrder = Number(sibling[0].attributes.order.value) - 5;
                  if(newOrder <1){ newOrder = 1};

              }
             } else {
              // no sibling...this should be on the end
              // $log.info('No sibling. Put it on the end');
              newOrder = 1000;
             }

             // $log.info(parentPanelID);
             // $log.info(targetPanelID);
             if (parentPanelID == targetPanelID){
              // just moving within the same panel
              sortDetails(parentPanelID, clientID, thisDetail);
              // resize our columns
              $timeout(function(){
                pageDimensionsService.resizeColumns();
                //heap.track('Profile Card Reordered');
                userDataService.trackEvent('reorder-detail-card');

              }, 250);

             } else {
              // moving betwixt panels
              moveToPanel(detailID, parentPanelID, targetPanelID, clientID, newOrder, thisDetail);
              // remove from DOM so we don't end up with a non-functional duplicate.
              el.remove();
              //heap.track('Profile Card Reordered');
              userDataService.trackEvent('reorder-detail-card');
             }

        });//// end detail drop


        function moveToPanel(detailID, parentPanelID, targetPanelID, clientID, newOrder){
            // $log.info('moveToPanel');
            // get a canonical copy of our detail
            var detailRef = firebase.database().ref('clients/' + clientID + '/panels/' + parentPanelID + '/details/' + detailID);

            detailRef.once('value', function(snap)  {
              var detail = snap.val(),
                  newPath = firebase.database().ref().child('clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid);

              // change our panel and set our order to just before the dropped sibling
              detail.panel = targetPanelID;

              if (newOrder){detail.order = Number(newOrder);}

              var updates = {};
              updates['clients/' + clientID + '/panels/' + targetPanelID + '/details/' + detail.uid] = detail;
              updates['clients/' + clientID + '/panels/' + parentPanelID + '/details/' + detail.uid] = null;
              // $log.info(updates);
              firebase.database().ref().update(updates)
              .then(function(){
                $timeout(function(){
                  pageDimensionsService.resizeColumns();
                  sortDetails(targetPanelID, clientID);
                  sortDetails(parentPanelID, clientID);
                }, 250);
              }, function(error){
                  // remove the original one if no error
                  detailRef.remove();
                  //heap.track('Profile Card Moved');
                  userDataService.trackEvent('move-detail-card');
                  $timeout(function(){
                    pageDimensionsService.resizeColumns();
                    sortDetails(targetPanelID, clientID);
                    sortDetails(parentPanelID, clientID);
                  }, 250);
              })
            });
        }// moveToPanel

        function sortDetails(panelID, clientID){
          //   $log.error('Sorting Details');
          // $log.info('panel: ' + panelID);
          // $log.info('client: ' + clientID);
            // Isolate this panel thanks to it's panelid attribute
            var sortingPanel = $('.app-item-container-items[panelid="' + panelID +'"]');
            // $log.info(sortingPanel);
            // $(sortingPanel).css('background-color', 'yellow');
            // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedDetails = $(sortingPanel).find('.info-card');

            // set our DB reference
            var detailsRef = firebase.database().ref('clients/' + clientID + '/panels/' + panelID + '/details'),
                updates = {};
                // Make sure panel (if poorly copied in the past) has the proper clientID.
                updates['clients/' + clientID + '/panels/' + panelID + '/client'] = clientID;

            // Update each item in firebase by ID
            _.each(sortedDetails, function(detail, index){
              var newOrder = (parseInt(index) + 1) * 10,
                  detailID = detail.getAttribute('uid');
              // Change the actual node's order value
              detail.attributes.order.value = newOrder;
              // update the order and client for each detail
              updates['clients/' + clientID + '/panels/' + panelID + '/details/' + detailID + '/order'] = newOrder;
              updates['clients/' + clientID + '/panels/' + panelID + '/details/' + detailID + '/client'] = clientID;
            });

            // $log.info(updates);

            firebase.database().ref().update(updates)
            .then(function(){
              // check to make sure our DOM didn't get screwed up
              var targetPanel = $('.app-item-container-items[panelid="' + panelID + '"]'),
              numTargetChildren = $(targetPanel).find('.info-card').length;

              var expected = Number(numTargetChildren), // this was stored before we made changes
                  actual = Number($(targetPanel).find('.info-card').length); // this is the state after the changes

               // $log.info('Expected: ' + expected);
               // $log.info('Actual: ' + actual);
              // $log.info('expected:' + expected) ;
              // $log.info('actual: ' + actual);

              if(actual != expected){
                $timeout(function(){// force a digest is necessary
                  alert('Oops! Please refresh Adminja to see the results of your drag and drop operation.')
                },0)
              }
            })

        }// sortDetails

        $scope.$on('drag-profile-detail.cancel', function(){
          scrollable = true;
          $rootScope.draggingDetail = false;
          $scope.$apply();
        });

        $scope.$on('drag-profile-panel.drop', function (event, item) {
          scrollable = true;
          // $log.info(event);
          // $log.info(item);
          $rootScope.draggingPanel = false;
          $scope.$apply();

          //heap.track('Profile Panel Moved');
          userDataService.trackEvent('move-detail-list');
          var droppedPanelID = item[0].attributes.panelid.nodeValue,
              clientID = item[0].attributes.client.nodeValue;
          // $log.info(droppedPanelID + 'dropped in client ' + clientID);
          // grab all of the panels directly from the DOM to ensure we have the correct sort order
          // make sure we don't accidentally pick up dragula's .gu-mirror copy that was used
          // and hidden during the drag process
          var sortedPanels = $('profile-panel:not(".gu-mirror")');

          // set our DB reference
          var panelsRef = firebase.database().ref('clients/' + clientID + '/panels');

          // Update each item in firebase by ID
          _.each(sortedPanels, function(panel, index){
            // If this isn't our undeletable Client Details panel, re-order it
              var newOrder = index+1,
                  panelID = panel.getAttribute('panelid');
                  // $log.info(panelID);
              // update JUST the order value on the detail
              panelsRef.child(panelID).child('order').set(newOrder);

            // $log.info(panel);

          })



      });// $on.drag-profile-panel.drop

        $scope.resetSearch = function(){
          // $log.info('resetSearch');
          $timeout(function(){
            // $rootScope.filterText = '';
            document.getElementById("searchQuery").value = "";
          },100);
        }

        $scope.toggleFilterBar = function(){
          // $log.info('toggleFilter bar');
          $timeout(function(){
            if($scope.showFilterBar){
              $scope.showFilterBar = false;
            } else {
              $scope.showFilterBar = true;
            }
          },0);
        }
    };// end clientProfileController





})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientOverviewController', clientOverviewController);
        // clientOverviewController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function clientOverviewController($mdToast, $state, $log, hotkeys, $http, gateService, dragulaService, teamDataService, taskDataService, $stateParams,  $window, $scope, triLoaderService, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, clientBillingService, timeReportService, timeDataService, invoiceService, currentAuth, _userData, _clientData) {
        $log.info('clientOverviewController');
          var vm = this;
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.user = userDataService.user;
        vm.userType = $rootScope.admin;
        vm.settings = $rootScope.userSettings;
        vm.client = _.find(vm.clients, function (client) {
            return client.uid == $state.params.clientID;
        });
        // $log.info(vm.userType);
        vm.clientCopy = angular.copy(vm.client);
        vm.teamDataService = teamDataService;
        vm.clientColors = $rootScope.clientColors;
        vm.countries = $rootScope.countries;
        vm.teamLimit = gateService.gateData.teamLimit;
        vm.usersPlan = gateService.gateData.planID;
        vm.clientUserLimit = gateService.gateData.clientUserLimit;
        vm.canClientAccess = true;
        vm.showCurrentPeriodInfo = false;

        if(vm.usersPlan.startsWith('starter') || vm.usersPlan.startsWith('assistant')){
            vm.canClientAccess = false;
        }
        vm.currency = "$";
        if(_.has(vm.settings, 'currency')){
            vm.currency = vm.settings.currency;
        }

    }//clientOverviewController

})();

(function () {
    'use strict';

    angular
            .module('clientManager')
            .config(moduleConfig);



    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {
        $stateProvider
                .state('triangular.workspaces', {
                    abstract: true,
                    views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/admin-client-manager/client-manager-toolbar.tmpl.html',
                            controller: 'clientManagerToolbarController',
                            controllerAs: 'vm'
                        }
                    },
                    url: '/workspaces/:clientID',
                    templateUrl: 'app/admin-client-manager/client-manager-page.tmpl.html',
                    // set the controller to load for this page
                    controller: 'clientManagerPageController',
                    controllerAs: 'vm'
                })
                .state('triangular.workspaces.dashboard', {
                    url: '/dashboard',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-overview.tmpl.html',
                            controller: 'clientOverviewController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.overview', {
                    url: '',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-tasks.tmpl.html',
                            controller: 'clientTasksController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.legacy-tasks', {
                    url: '',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-legacy-tasks.tmpl.html',
                            controller: 'clientLegacyTasksController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.archived-tasks', {
                    url: '/archives',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-archived-tasks.tmpl.html',
                            controller: 'clientArchivedTasksController',
                            controllerAs: 'vm'
                        }
                    }
                })
                // Proper states if client dashboard enabled
                // .state('triangular.workspaces.overview', {
                //     url: '',
                //     views: {
                //         '@triangular': {
                //             templateUrl: 'app/admin-client-manager/client-overview.tmpl.html',
                //             controller: 'clientOverviewController',
                //             controllerAs: 'vm'
                //         }
                //     }
                // })
                // .state('triangular.workspaces.tasks', {
                //     url: '/tasks',
                //     views: {
                //         '@triangular': {
                //             templateUrl: 'app/admin-client-manager/client-tasks.tmpl.html',
                //             controller: 'clientTasksController',
                //             controllerAs: 'vm'
                //         }
                //     }
                // })

                .state('triangular.workspaces.information', {
                    url: '/information',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-profile.tmpl.html',
                            controller: 'clientProfileController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.details', {
                    url: '/details',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-details.tmpl.html',
                            controller: 'clientDetailsController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.time', {
                    url: '/time',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-time.tmpl.html',
                            controller: 'clientTimeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {

                    }

                })


                .state('triangular.workspaces.task-templates', {
                    url: '/templates',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-task-templates.tmpl.html',
                            controller: 'clientTaskTemplatesController',
                            controllerAs: 'vm'
                        }
                    }
                })

                .state('triangular.workspaces.client-legacy-billing', {
                    url: '/legacy-billing',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-legacy-billing.tmpl.html',
                            controller: 'clientLegacyBillingController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces.client-billing', {
                    url: '/billing/:viewState',
                    views: {
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-billing.tmpl.html',
                            controller: 'clientBillingController',
                            controllerAs: 'vm'
                        }
                    }
                })
                .state('triangular.workspaces-manager', {
                    url: '/workspace-manager',
                    views: {
                        'toolbar@triangular': {
                            templateUrl: 'app/layouts/toolbar/adminja-toolbar.tmpl.html',
                            controller: 'clientManagerToolbarController'
                        },
                        '@triangular': {
                            templateUrl: 'app/admin-client-manager/client-manager-clients.tmpl.html',
                            controller: 'manageClientsController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        '_teams': ['teamDataService', function (teamDataService) {
                                return teamDataService.getUsersTeams()
                                        .then(function (data) {
                                            return data
                                        })
                            }]
                        }
                });

                // triMenuProvider.addMenu({
                //     name: 'Manage Workspaces',
                //     state: 'triangular.workspaces-manager',
                //     icon: 'fa fa-gears',
                //     // svgicon: '/assets/images/icons/manage-workspaces.svg',
                //     type: 'link',
                //     priority: 8
                // });




    } // end moduleConfig



})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('clientManagerToolbarController', clientManagerToolbarController);

    /* @ngInject */
    function clientManagerToolbarController($log, $scope, gateService, $injector, $rootScope, $mdDialog, $mdMedia, $state, teamDataService, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, userDataService, clientDataService,  $stateParams, _userData) {
        // $log.info('clientManagerToolbarController');
        // For some reason, we absolutely don't have access to vm in our view. But Scope works just fine
        var vm = this;
            vm.user = _userData,
            vm.thisClient = $state.params.clientID;
            $scope.userType = $rootScope.admin;
            $scope.dataURL = fbConfig.dataURL;
            $scope.taskLabel = "Tasks";

            // determine if user is clientUser for this workspace
            $scope.isClientUser = false;
            if(_.has($rootScope, 'VAWorkspaces')){
                if(_.has($rootScope.VAWorkspaces, $state.params.clientID)){
                        $scope.isClientUser = true;
                }
            }


            $scope.menuColor = function(color){
                if(color){
                    return ajUTILITIES.lightenDarkenColor(color, 30)
                }
            }

            $scope.clone = function(client){
                var clientID = client.uid, targetUserID = client.owner, isDemo = false;
              var clientLimit = gateService.gateData.clientLimit;

              var numClients = 0, canClone = true;

              // Only check client count if adding for OWN account
              // team accounts have no limits anyways

              // if user owns the client and the client is new
              if(targetUserID == $rootScope.userID){
                  // count up our active, non-demo , owned clients
                  _.each(clientDataService.clients, function(client){
                      if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                          numClients = numClients + 1;
                      }
                  });
                  // $log.info('numClients: '+numClients);

                  if(numClients == clientLimit || numClients > clientLimit){
                      canClone = false;
                  }
              }

             if(canClone){

                var confirm = $mdDialog.confirm()
                      .title('Clone Workspace: Are you Sure?')
                      .htmlContent('<p style="color: orange; padding-bottom: 1em; margin:0;">You are about to Clone this workspace <strong></p> <ul><li>- Time, Comments and Billing Plans will not be copied.</li> <li>- All Tasks will be initially assigned to you.</li><li>- Recurring task counts will be reset to zero.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Do It')
                      .targetEvent(event)
                      .ok('Clone It!')
                      .cancel('Cancel');

                // var confirm = $mdDialog.confirm()
                //       .title('Workspace Cloning is Temporarily Unavailable')
                //       .htmlContent('<p style="padding-bottom: 1em; margin:0;">We are sorry for the inconvenience. <br> It should return on or before September 8, 2021.</p>').ariaLabel('Do It')
                //       .targetEvent(event)
                //       .ok('Got it!');


                $mdDialog.show(confirm).then(function() {
                  return clientDataService.copyClient(clientID, targetUserID)
                  .then(function(newClient){
                    var workspaceType = 'Client';
                    if(newClient.status == 'personal'){
                      workspaceType = "Internal"
                    }

                      return clientDataService.setupUserAndClientMenu(true)
                      .then(function(){
                        var confirm = $mdDialog.confirm()
                              .title('Workspace Cloned!')
                              .htmlContent('<p style="padding-bottom: 1em; margin:0;">You\'ll find it in the '+ workspaceType +' Workspaces menu.</p>').ariaLabel('Clone Complete')
                              .targetEvent(event)
                              .ok('Got it')
                        $mdDialog.show(confirm).then(function(){
                          // $log.info('clone completed.');
                        })
                      });
                  })
                });

             }// if canClone
             else {
              var confirm = $mdDialog.confirm()
                    .title('Oops! You\'ve reached your workspace limit!')
                    .htmlContent('<p style="padding-bottom: 1em; margin:0;">You can clone this Workspace if you increase your Workspace limit or archive some Workspaces.</p>').ariaLabel('Do It')
                    .targetEvent(event)
                    .ok('Clone It!')
                    .cancel('Cancel');

              $mdDialog.show(confirm)
             }
            }// cloneWorkspace

            $scope.sendStatusReport = function(client){
                clientDataService.sendStatusReport(client)
            }// sendStatusReport

            $scope.clickTaskButton = function(taskLabel){
                if(taskLabel == 'Task Templates'){
                    $state.go('triangular.workspaces.task-templates')
                }
                if(taskLabel == 'Tasks'){
                    $state.go('triangular.workspaces.overview')
                }
                if(taskLabel == 'Archived Tasks'){
                    $state.go('triangular.workspaces.archived-tasks')
                }
            }//clickTaskButton

            // Set initial label of our tasks button
            function checkButtonLabels(){
                $timeout(function(){
                    if($state.includes('triangular.workspaces.task-templates')){
                        $scope.taskLabel = "Task Templates";
                    }

                    if ($state.includes('triangular.workspaces.archived-tasks')){
                        $scope.taskLabel = "Archived Tasks"
                    }

                    if($state.includes('triangular.workspaces.overview')) {
                        $scope.taskLabel = "Tasks"
                    }

                    if($state.includes('triangular.workspaces.client-legacy-billing')){
                        $scope.packageLabel = "Legacy Billing Periods";
                    } else {
                        $scope.packageLabel = "Billing"
                    }
                })

            }// checkButtonLabels

            checkButtonLabels();

            // Wath for changes.
            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                    checkButtonLabels();
            });

            $scope.teamList = {};
        // In a timeout to make sure the view gets the info
        $scope.isOwner = false;
       $timeout(function(){
        if(_.has(teamDataService.clientTeams, vm.thisClient)){
            $scope.teamList = teamDataService.clientTeams[vm.thisClient];
        } else {
            $scope.teamList = {};
        }
            $scope.teamDataService = teamDataService;
            $scope.hasBilling = gateService.gateData.hasBilling;
            $scope.canViewTime = gateService.gateData.canViewTime;
            $scope.client = clientDataService.easyClient($state.params.clientID);

            if($scope.client.owner == vm.user.uid){
                $scope.isOwner = true;
                $scope.isAdmin = true;
            }

            vm.clients = clientDataService.clients;
            _.each(vm.clients, function(client){
                if(client.uid == vm.thisClient){
                    $scope.client = client;
                    if(_.size($scope.client.access.users) > 1){
                        $log.info('Multiple users. Check for delegated permissionss');
                        if($scope.client.access.admins[vm.user.uid]){
                            $scope.isAdmin = true
                            $scope.hasBilling = true;
                        } else {
                            $scope.isAdmin = false
                        }
                    }
                }
            });// each find client



            // $log.info('this user:');
            // $log.info(('isAdmin: ' + $scope.isAdmin));
            // $log.info(('isOwner: ' + $scope.isOwner));
            // $log.info(('hasBilling: ' + gateService.gateData.hasBilling));
       },0);

       $scope.editClient = function(clientID){
        clientDataService.editClient(clientID);
       }

       $scope.showTeamFilter = function(){
        if (_.size($scope.teamList) > 1){
            return true
        }
       }

        $scope.currentPage = function(){
            var page = undefined;
            if($state.includes('triangular.workspaces.information')){
                page = "Profile"
            }
            if($state.includes('triangular.workspaces.tasks')){
                page = "Tasks"
            }
            if($state.includes('triangular.workspaces.time')){
                page = "Time"
            }
            if($state.includes('triangular.workspaces.task-templates')){
                page = "Recurring"
            }
            if($state.includes('triangular.workspaces.client-legacy-billing')){
                page = "Billing"
            }
            // $log.info(page);
            return page
        }

        $scope.isActive = function(value){
            if($state.includes(value)){
                return true
            }
        }


        $scope.isTasks = function(){
            if($state.includes('tasks')){
                return true
            }
        }

        // $log.info($scope.hasRecurring);

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;

        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        // $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $rootScope.showToday = false;

       ///

       $scope.filterUser = function(user){
        if(user != 'all'){
            // alert('Will trigger filtering to user ' + userID);
            // alert the parent controller of the new filter
            teamDataService.filteredMember = user.uid;
            teamDataService.filteredMemberName = user.profile.firstName;
        } else {
            delete teamDataService.filteredMember;
            delete teamDataService.filteredMemberName;
        }
       }// filterUser

        function changeState(newState){
            $log.info('changeState Function!');
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientManagerPageController', clientManagerPageController);

    /* @ngInject */
    function clientManagerPageController($q, $log, panelDataService, $sanitize, $http, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, pageDimensionsService, templateDataService, profileDataService, $mdDialog, $mdMedia, _userData, _clientData) {
        // $log.info('clientManagerPageController');
        // var vm = this;


    }; // end clientManagerPageController


})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('manageClientsController', manageClientsController);
        // manageClientsController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function manageClientsController($log, $window, $state, CSV, triLoaderService,$firebaseObject, $firebaseArray, $scope, dragulaService, $timeout, gateService, $rootScope, $mdDialog, clientDataService, teamDataService, userDataService, timeReportService, _userData, _clientData, _teams) {
        // $log.info('manageClientsController');
        // not sure whay, but we can't use vm. here for our controller. Despite controllerAs.
        var vm = this;

        vm.usersTeams = _teams;
        vm.user = _userData;
        vm.settings = $rootScope.userSettings;
        // Setup default view
        vm.spacesView = 'active';
        vm.showAccountChooser = false;
        vm.downloadCSV = downloadCSV;
        $scope.fbConfig = fbConfig;
        vm.teamDataService = teamDataService;
        vm.userOrder = 'userOrders.user' + vm.user.uid;
        vm.selectAccount = selectAccount;
        vm.toggleView = toggleView;
        vm.teamLabel = teamLabel;

        $scope.userType = $rootScope.admin;

        $scope.isTeamAdmin = function(client, userID){
          if (client.owner == userID){
            return true
          } else {
            if(teamDataService.isTeamAdmin(userID, client.owner)){
              return true
            }
          }
        }


        function init(){
          $log.info('manageClientsController init');
            var topPosition = $('.triangular-toolbar').outerHeight() + $('.time-report-controls').outerHeight();
            $('#scroll-up').css('top', topPosition);
          // Set default account so we can load our archive

            // if(_.has(vm.settings, 'defaultAccount')){
            //   vm.selectAccount(vm.settings.defaultAccount);
            //   vm.selectedAccount = vm.settings.defaultAccount;

            // } else {
            //   vm.selectAccount(vm.user.uid);

            $rootScope.$on('workspacesRefreshed', function(){
              init();
            })
            // }
            vm.selectedAccount = vm.user.uid;
            // vm.allClients = clientDataService.clients;
          selectAccount(vm.selectedAccount)
          // Our account picklist
          vm.managedTeams = [];
          _.each(vm.usersTeams, function(team){
            // if own team not setup, add it manually
            if(_.has(team, 'members')){
              var include = false;
              if(team.ownerID == vm.user.uid){
                include = true;
              }
              if(_.has(team.members[vm.user.uid], 'isTeamAdmin')){
                if(team.members[vm.user.uid].isTeamAdmin){
                  include = true;
                }
              }
              if(include){
                vm.managedTeams.push(team);
                // if team is NOT the current user's (but they are admin on it), display the account switcher
                if(team.ownerID != vm.user.uid){
                  vm.showAccountChooser = true;
                }
              }
            } else {
              // team is user's own but it's not setup (or they don't have teams)
              if(team.needsSetup){
                vm.managedTeams.push({
                  name: "Your Account",
                  ownerID: team.ownerID
                })
              }// if needsSetup
            }// if has members
          });// each team

          if(vm.canRestoreClients){
            // $log.info('can clone!');
            $rootScope.canClone = true;
          } else {
            // $log.info('can NOT clone!');
            $rootScope.canClone = false;
          }


        }// init


        $timeout(function(){
          init();
        }, 1000)

        function toggleView(state){
          $timeout(function(){
            vm.spacesView = state;
            if(state == 'archived'){
              return getArchivedWorkspaces(vm.selectedAccount)
            }
          },0)
        }//toggleView

        // this function loads up all of the archived workspaces.
        // should be in a service but we were having issues and time is short.
        function selectAccount(teamID, update){
          vm.allClients = undefined;
          if(teamID == vm.user.uid){
            // $log.info('Switched to logged in account');
            $timeout(function(){
              vm.allClients = clientDataService.clients;
              vm.spacesView = 'active';
              $log.info('workspaces loaded');
            },0);
          } else {
            // $log.info('Switched to account they administrate.');
            vm.allClients = [];

            $timeout(function(){
              vm.spacesView = 'active';
            })

            var listRef = firebase.database().ref('/users/' + teamID + '/clients');
            listRef.once('value', function(snapshot){
              if(snapshot.exists()){
                var clientList = snapshot.val(), workspacePromises = [];
                _.each(clientList, function(value, key){
                  workspacePromises.push(getWorkspace(key, teamID));
                });
                return Promise.all(workspacePromises)
                .then(function(){
                    $log.info('workspaces loaded');
                })
              } else {
                // $log.info('No client list for that user');
                vm.selectedAccount = vm.user.uid;
                selectAccount(vm.selectedAccount);
              }
            })
          }
          // Get this account's limits

          $timeout(function(){
            var ownerLimits = firebase.database().ref().child('/users/' + teamID + '/limits');
            ownerLimits.once('value', function(snapshot){
              vm.limits = snapshot.val();
            })
          },0)

          // if we were updating this MANUALLY, change the setting.
          // if (update){
          //   return userDataService.changeUserSetting('defaultAccount', teamID);
          // }


        }// selectAccount

        function teamLabel(clientOwner){
          var result = "Shared with me";
          if(vm.selectedAccount == vm.user.uid){
            _.each(teamDataService.teams, function(team){
              if(team.ownerID == clientOwner ){
                result = team.name;
              }
            });
          }
          return result
        }//teamLabel

        function getArchivedWorkspaces(accountID){
          return new Promise(function(resolve, reject){
              $log.info('getArchivedWorkspaces');
              vm.archivedClients = [];
              var promises = [];
              var teamRef = firebase.database().ref('teams/' + accountID);
              teamRef.once('value', function(snapshot){
                   // prepare our array of promises
                   if(snapshot.exists()){
                    var team = snapshot.val();
                    if(_.has(team, 'archivedWorkspaces')){
                      $log.info('has archives');
                       _.each(team.archivedWorkspaces, function(value, key){
                        promises.push(getArchivedSpace(key))
                       });
                       Promise.allSettled(promises)
                       .then(function(){
                           return resolve
                       })
                    }  else {
                      return resolve
                    }// if team has archived workspaces
                   } else {
                    return resolve
                   }// if snapshotExists
              });
          })

        }//getArchivedWorkspaces


        function getArchivedSpace(key){
          return new Promise(function(resolve, reject){
            $log.info('getting archived space: ' + key);
            firebase.database().ref('/clients/' + key).once('value', function(snapshot){
               if(snapshot.exists()){
                 vm.archivedClients.push(snapshot.val())
                  return resolve
               } else {
                return resolve
               }
             })
          })

        }//getArchivedSpace

        function getWorkspace(key, teamID){
          return new Promise(function(resolve, reject){
            // $log.info('getWorkspace ' + key);
             return firebase.database().ref('/clients/' + key).once('value', function(snapshot){
               if(snapshot.exists()){
                var client = snapshot.val();
                // we only want to include workspaces the team owner OWNS.
                // we don't want to include workspaces they might be assigned to from others
                if(client.owner == teamID){
                  vm.allClients.push(client)
                }
                return resolve
               } else {
                return resolve
               }
             }, function(error){
                   $log.info('Workspace is shared with selected account, not owned by it. Skipping.' );
                   return resolve
                });
          })

        }//getWorkspace


          vm.openClient = function(client){
              return clientDataService.clientDialog(client);
          }



        // checks client limit against # of clients they own to see if they have room to restore a client
        vm.canRestoreClients = function(){
          // count our demo clients and remove them from the total
          var numDemos = 0;
          _.each(vm.allClients, function(client){
            if(client.demo){
              numDemos = numDemos + 1;
            }
          });
          // vm.selectedClients is assigned in our ng-repeat
          if(vm.limits.clients > (vm.selectedClients.length - numDemos)){
            return true
          }
        }

        vm.copyClient = function(client){
          var targetUserID = vm.selectedAccount, clientID = client.uid, isDemo = false;
           /// XXX NOTE: This logic is duplicated on our client directive
           /// any changes made here likely need made there and vice versa
           var clientLimit = gateService.gateData.clientLimit;

           var numClients = 0, canClone = true;

           // Only check client count if adding for OWN account
           // team accounts have no limits anyways

           // if user owns the client and the client is new
           if(targetUserID == $rootScope.userID){
               // count up our active, non-demo , owned clients
               _.each(clientDataService.clients, function(client){
                   if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                       numClients = numClients + 1;
                   }
               });
               // $log.info('numClients: '+numClients);

               if(numClients == clientLimit || numClients > clientLimit){
                   canClone = false;
               }
           }

          if(canClone){

             var confirm = $mdDialog.confirm()
                   .title('Clone Workspace: Are you Sure?')
                   .htmlContent('<p style="color: orange; padding-bottom: 1em; margin:0;">You are about to Clone this workspace <strong></p> <ul><li>- Time, Comments and Billing Plans will not be copied.</li> <li>- All Tasks will be initially assigned to you.</li><li>- Recurring task counts will be reset to zero.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Do It')
                   .targetEvent(event)
                   .ok('Clone It!')
                   .cancel('Cancel');

             $mdDialog.show(confirm).then(function() {
               return clientDataService.copyClient(clientID, targetUserID, isDemo)
               .then(function(newClient){
                 var workspaceType = 'Client';
                 if(newClient.status == 'personal'){
                   workspaceType = "Internal"
                 }

                   return clientDataService.setupUserAndClientMenu(true)
                   .then(function(){
                     var confirm = $mdDialog.confirm()
                           .title('Workspace Cloned!')
                           .htmlContent('<p style="padding-bottom: 1em; margin:0;">You\'ll find it in the '+ workspaceType +' menu.</p>').ariaLabel('Clone Complete')
                           .targetEvent(event)
                           .ok('Got it')
                     $mdDialog.show(confirm).then(function(){
                       // $log.info('clone completed.');
                     })
                   });
               })
             });

          }// if canClone
          else {
           var confirm = $mdDialog.confirm()
                 .title('Oops! You\'ve reached your workspace limit!')
                 .htmlContent('<p style="padding-bottom: 1em; margin:0;">You can clone this Workspace if you increase your Workspace limit or archive some Workspaces.</p>').ariaLabel('Do It')
                 .targetEvent(event)
                 .ok('Clone It!')
                 .cancel('Cancel');

           $mdDialog.show(confirm)
          }
        }//copyClient

        vm.sendReport = function(client){
            return clientDataService.sendStatusReport(client);
        }

        // we need a client count that does NOT include demo workspaces
        vm.numClients = function(clients){
          var numDemos = 0;
          if(clients){
            _.each(clients, function(client){
              if(client.demo){
                numDemos = numDemos + 1;
              }
            });
            return clients.length - numDemos

          } else {
            return 0
          }

        }

        vm.restoreClient = function(client, event){
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: green; padding-bottom: 1em; margin:0;">You are requesting to restore the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- The restoration can take up to 5 minutes.</li><li>- You will need to manually re-set this space\'s Due Dates, Recurring Tasks and Billing Periods.</li><li>- A Space can only be restored from archive once every 15 days.</li><li>- If you need have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Restore')
                  .targetEvent(event)
                  .ok('Restore')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // vm.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             return clientDataService.restoreClient(client)
            }, function() {
              // vm.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });

        }


        // Edit a task
        vm.editClient = function(client) {
            $log.info('editClient got clicked!')
            $log.info(client);
            return clientDataService.clientDialog(client);

        }; // End editClient

        vm.viewClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            $state.go('triangular.workspaces.overview', {clientID: client.uid});
        }

        vm.archiveClient = function(client){
            //  to client's dashboard
            // $log.info('viewClient got clicked!')
            var confirm = $mdDialog.confirm()
                  .title('Are you Sure?')
                  .htmlContent('<p style="color: red; padding-bottom: 1em; margin:0;">You are about to Archive the <strong>' + client.profile. fullName + '</strong> space.</p> <ul><li>- Any active billing packages will be archived.</li><li>- Task Due Dates will be removed</li> <li>- Team members will be unassigned.</li><li>- Recurring tasks will be disabled.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Confirm Archive')
                  .targetEvent(event)
                  .ok('Archive It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              // $scope.status = 'You decided to get rid of your debt.';
             // alert('you decided to reactivate');
             // Store the current status (active or personal) so we have it for later use

             return clientDataService.archiveClient(client)
            }, function() {
              // $scope.status = 'You decided to keep your debt.';
              // alert('you decided to cancel');
            });
        }

        vm.isTeamAdmin = function(ownerID, userID){
          if (ownerID == userID){
            return true
          } else {
            if(teamDataService.isTeamAdmin(userID, ownerID)){
              return true
            }
          }
        }

        vm.deleteClient = function (client) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                    .title('PERMANENTLY delete this client and all of their data?')
                    .textContent(client.profile.firstname + ' ' + client.profile.lastname)
                    .ariaLabel('Delete client? Y//N')
                    .targetEvent(client)
                    .ok('Yes, Delete')
                    .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                clientDataService.deleteClient(client);
                $mdDialog.cancel();
              });


        }// delete client

        vm.newWorkspace = function(account){
                  clientDataService.clientDialog(clientDataService.newClient(account), 'New Workspace');
              }

        // var unwatch = $rootScope.$on('clientMenuBuilt',function() {
        //   // alert('workspace list changed!');
        //   $timeout(function(){
        //     init();
        //     // reselect the account so we refresh our archive list as well
        //     // vm.selectAccount(vm.selectedAccount);
        //   },0);
        // });

        var unwatchtoo = $rootScope.$on('clientUpdated', function(){
              // delete vm.allClients;
              vm.selectAccount(vm.selectedAccount);
          });

        // $scope.$on('$destroy', function() {
        //     unwatch();
        //     unwatchtoo()
        // });



        // Dragula Setup for list view sorting
        dragulaService.options($scope, 'client-list-sort', {
             moves: function (el, container, handle) {
               return handle.classList.contains('drag-handle');
             },
             accepts: function(el, target, source, sibling){
              if ($(target).is('.scroll-up') || $(target).is('.scroll-down')){
                  // we can't drop on scroll-triggers
                  if($(target).is('.scroll-down') && $rootScope.draggingClient){
                      var scrollAmount = 10;
                    scroll(scrollAmount);
                    // debounce(scroll(scrollAmount), 50)
                  }
                  if($(target).is('.scroll-up') && $rootScope.draggingClient){
                     var scrollAmount = -10;
                     scroll(scrollAmount);
                      // debounce(scroll(scrollAmount), 50)
                  }
                  return false
              }

              if(target != source){
                return false
              }

                return true
             },
             // allowNestedContainers: true,
             direction: 'vertical'

           });

            vm.launchPrimer = function(){
                // Appcues.show($rootScope.tutorials.manageClients);
            };

            $scope.$on('client-list-sort.drag', function(){
              $log.info('draggingClient');
                $rootScope.draggingClient = true;
                $scope.$apply();
            });


            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    }, wait);
                    if (immediate && !timeout) func.apply(context, args);
                };
            }

            function scroll(amount) {
              var y = $('.scroll-container').scrollTop();  //your current y position on the page
              $('.scroll-container').scrollTop(y+amount);
            }


        $scope.$on('client-list-sort.drop', function (event, el, target, source, sibling) {
            var sortingPanel = $('.client-list-item-container');
            // $(sortingPanel).css('background-color', 'yellow');
            // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order

           // Timeout ensures the DOM has settled before we sort.
           $timeout(function(){
            var sortedClients = $(sortingPanel).find('.client-list-item');
            // Go through and update all order properties
            var updates = {};
            // Update each item in firebase by ID
            _.each(sortedClients, function(client, index){
              var newOrder = Number(index) + 1,
                  clientID = client.getAttribute('uid');
              var clientData;
              _.each(vm.allClients, function(thisClient){
                if(thisClient.uid == clientID){
                  clientData = thisClient;
                }
              })

                if(clientData.status == 'personal'){
                  newOrder = newOrder + 100;
                }
                updates['/clients/' + clientID + '/userOrders/user' + vm.user.uid] = Number(newOrder);
            });
            return firebase.database().ref().update(updates)
            .then(function(){
              // $log.info('sorted');

              // Force (true) Refresh our client menu
              if(vm.selectedAccount == vm.user.uid){
                clientDataService.setupUserAndClientMenu(true);
              }
              else {
                  vm.selectAccount(vm.selectedAccount);
              }
            })
           },100)
        });

        $scope.cloneWorkspace = function(clientID, targetUserID, isDemo){

          var clientLimit = gateService.gateData.clientLimit;

          var numClients = 0, canClone = true;

          // Only check client count if adding for OWN account
          // team accounts have no limits anyways

          // if user owns the client and the client is new
          if(targetUserID == $rootScope.userID){
              // count up our active, non-demo , owned clients
              _.each(clientDataService.clients, function(client){
                  if(!client.demo && client.status != 'archived' && client.owner == $rootScope.userID){
                      numClients = numClients + 1;
                  }
              });
              // $log.info('numClients: '+numClients);

              if(numClients == clientLimit || numClients > clientLimit){
                  canClone = false;
              }
          }

         if(canClone){

            // var confirm = $mdDialog.confirm()
            //       .title('Workspace Cloning is Temporarily Unavailable')
            //       .htmlContent('<p style="padding-bottom: 1em; margin:0;">We are sorry for the inconvenience. <br> It should return on or before September 8, 2021.</p>').ariaLabel('Do It')
            //       .targetEvent(event)
            //       .ok('Got it!');
            var confirm = $mdDialog.confirm()
                  .title('Clone Workspace: Are you Sure?')
                  .htmlContent('<p style="color: orange; padding-bottom: 1em; margin:0;">You are about to Clone this workspace <strong></p> <ul><li>- Time, Comments and Billing Plans will not be copied.</li> <li>- All Tasks will be initially assigned to you.</li><li>- Recurring task counts will be reset to zero.</li><li>- If you have any questions, please submit a help desk ticket.</li></ul>').ariaLabel('Do It')
                  .targetEvent(event)
                  .ok('Clone It!')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              return clientDataService.copyClient(clientID, targetUserID, isDemo)
              .then(function(newClient){
                $log.info(newClient);
                var workspaceType = 'Client';
                if(newClient.status == 'personal'){
                  workspaceType = "Internal"
                }

                  return clientDataService.setupUserAndClientMenu(true)
                  .then(function(){
                    var message = '<p style="padding-bottom: 1em; margin:0;">You\'ll find it in the '+ workspaceType +' menu.</p>';
                    if(targetUserID != $rootScope.userID){
                      message = '<p style="padding-bottom: 1em; margin:0;">It is now available to be assigned to yourself and other members in the Team manager.</p>';
                    }
                    var confirm = $mdDialog.confirm()
                          .title('Workspace Cloned!')
                          .htmlContent(message).ariaLabel('Clone Complete')
                          .targetEvent(event)
                          .ok('Got it')
                    $mdDialog.show(confirm).then(function(){
                      // $log.info('clone completed.');
                    })
                  });
              })
            });

         }// if canClone
         else {
          var confirm = $mdDialog.confirm()
                .title('Oops! You\'ve reached your workspace limit!')
                .htmlContent('<p style="padding-bottom: 1em; margin:0;">You can clone this Workspace if you increase your Workspace limit or archive some Workspaces.</p>').ariaLabel('Do It')
                .targetEvent(event)
                .ok('Clone It!')
                .cancel('Cancel');

          $mdDialog.show(confirm)
         }
        }// cloneWorkspace


        function downloadCSV(workspaces, owner, type){
          var exportedWorkspaces = [];

          _.each(workspaces, function(workspace){
            if(type == 'active'){
              if(workspace.owner == owner && (workspace.status == 'active' || workspace.status == 'personal')){
                exportedWorkspaces.push(prepWorkspaceExport(workspace));
              }
            }

            if(type == 'archived'){
              if(workspace.owner == owner && workspace.status == 'archived'){
                exportedWorkspaces.push(prepWorkspaceExport(workspace));
              }
            }

          });

          // Set the header labels for our CSV file (note, we are accepting default alpha format)
          var csvOptions = {
              'txtDelim': '"',
              'quoteStrings': true,
              'header': [
                  'Start Date',
                  'Workspace Name',
                  'First Name',
                  'Last Name',
                  'Email',
                  'Phone',
                  'Birth Month',
                  'Birth Day',
                  'Street Address',
                  'City',
                  'State',
                  'Zip',
                  'Company',
                  'Company Email',
                  'Company Phone',
                  'Company Fax',
                  'Company Address',
                  'City',
                  'State',
                  'Zip',
                  'Website'
              ]

          }

          // Convert our json to CSV and start the download
          CSV.stringify(exportedWorkspaces, csvOptions).then(function(result){
                  // $log.info(result);
                     downloadCSVFile(result, type + '-workspace-export');
                 });

    }// downloadCSV

    function downloadCSVFile(data, filename) {
               var preppedData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);

               var downloader = document.createElement('a');

               downloader.setAttribute('href', preppedData);
               downloader.setAttribute('download', filename + '.csv');
               downloader.click();
           };

    function prepWorkspaceExport(workspace){

      // make sure nested nodes exist
      if(!_.has(workspace.profile, 'birthday')){
        workspace.profile.birthday = {}
      }

      if(!_.has(workspace.profile, 'companyAddress')){
        workspace.profile.companyAddress = {}
      }

      if(!_.has(workspace.profile, 'address')){
        workspace.profile.address = {}
      }

      var startDate = '';

      if(_.has(workspace.profile, 'startDate')){
        startDate = moment(workspace.profile.startDate).toISOString();
      }

      var streetAddress = workspace.profile.address.street || ' ';


      var exportedWorkspace = {
        startDate: startDate,
        fullName: workspace.profile.fullName || ' ',
        firstName: workspace.profile.firstname || ' ',
        lastName: workspace.profile.lastname || ' ',
        email: workspace.profile.email || ' ',
        phone: workspace.profile.phone || ' ',
        birthMonth: workspace.profile.birthday.month || ' ',
        birthDay: workspace.profile.birthday.day || ' ',
        streetAddress: streetAddress,
        city: workspace.profile.address.city || ' ',
        state: workspace.profile.address.state || ' ',
        zip: workspace.profile.address.zip || ' ',
        company: workspace.profile.company || ' ',
        companyEmail: workspace.profile.companyemail || ' ',
        companyPhone: workspace.profile.companyphone || ' ',
        companyFax: workspace.profile.companyfax || ' ',
        companyStreetAddress: workspace.profile.companyAddress.street || ' ',
        companyCity: workspace.profile.companyAddress.city || ' ',
        companyState: workspace.profile.companyAddress.state || ' ',
        companyZip: workspace.profile.companyAddress.zip || ' ',
        website: workspace.profile.companyurl || ' '
      }
      return exportedWorkspace
    }// prepWorkspaceExport

  }
})();

 (function () {
    'use strict';

    angular
            .module('clientManager')
            .controller('clientLegacyTasksController', clientLegacyTasksController);

    /* @ngInject */
    function clientLegacyTasksController($q, $log, $window, $mdToast, $document, gateService, dragulaService, clientPackageService, taskPanelDataService, userDataService, teamDataService, localStorageService,  $sanitize, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, taskTemplateDataService, pageDimensionsService, hotkeys, $mdDialog, _userData, _clientData) {
        // $log.info('clientLegacyTasksController');
        // $log.info(this);
        var vm = this;
        // turn on the loader immediately.
        // $timeout(function(){
        //     triLoaderService.setLoaderActive(true);
        // },0);

        vm.settings = $rootScope.userSettings;
        // $log.info('userData is:');
        // $log.info(_userData);
        // $log.info('clientData is:');
        // $log.info(_clientData);
        // $log.info('$resolve is:');
        // $log.info($scope.$resolve);
        vm.tasks = [];

        // $timeout(function(){
        //     vm.isFilterToolbarOpen = true;

        // }, 2000);

        init();


        function init(){
            vm.canUseTimer = false;
            vm.filterOption = 'all';
            vm.sortOption = 'order';
            vm.gateService = gateService;
            vm.now=moment().toISOString();
            vm.snoozeFilter = true;
            vm.canUseTimer = gateService.gateData.canUseTimer;
            vm.user = _userData;
            vm.userID = localStorageService.get('userID');
            vm.clientID = $stateParams.clientID;
            vm.clients = $scope.$resolve.clientDataService.clients;
            // Get our client data
            vm.thisClient = _.find(vm.clients, function (client) {
                return client.uid == $stateParams.clientID;
            });
            if(_.has(vm.thisClient, 'clientUsers['+ vm.user.uid+']')){
              vm.isWorkspaceClient = true;
            }

            if(_.has(vm.thisClient, 'clientUsers')){
                vm.hasClientUser = true;

            }

            if(_.has(vm.settings, 'collapseCards')){
                if(vm.settings.collapseCards){
                    vm.collapseCards = vm.settings.collapseCards;
                } else {
                    vm.collapseCards = false;
                }
            }
            if(_.has(vm.settings, 'defaultClientTaskSort')){
                vm.sortOption = vm.settings.defaultClientTaskSort;
                } else {
                vm.sortOption = 'order';
            }

            if(_.has(vm.settings, 'verticalTaskPanels')){
                if(vm.settings.verticalTaskPanels){
                    vm.taskDragDirection = "vertical"
                } else {
                    vm.taskDragDirection = "horizontal"
                }
            }

            vm.duplicateList = function(list, tasks){
                // $log.info('duplicateList');
                var targetWorkspaceID = '-MY5kqEYsRbkx2kRpZmC';

                // throw up dialog
                $mdDialog
                    .show({
                        templateUrl: "app/app-services/taskPanelDataService/duplicate-list-picker.tmpl.html",
                        clickOutsideToClose: true,
                        bindToController: true,
                        locals: {
                            clients: vm.clients,
                            thisClient: vm.thisClient
                        },
                        perserveScope: true,
                        controllerAs: 'vm',
                        controller: 'duplicateListController'
                    })
                    .then(function(targetWorkspaceID) {
                        return taskDataService.cloneTaskList(list, tasks, targetWorkspaceID)
                        .then(function(results){
                            // $log.info(results);
                            $mdToast.showSimple('Task list duplicated!');
                        })
                        .catch(function(error){
                            $log.info('error cloning task list');
                            $log.info(error);
                        })

                    });

            }//duplicateList



            vm.expireCompleted = function(tasks){
                var updates = {};
                _.each(tasks, function(task){
                    if(_.has(task, 'closedDate') && _.has(task, 'refID')){
                        updates['/tasks/' + task.refID + '/info/archived/'] = true;
                        updates['/clients/' + task.client + '/tasks/' + task.refID] = null;
                        updates['/users/' + task.assignee + '/tasks/' + task.refID] = null;
                        if(_.has(task, 'creator')){
                            updates['/users/' + task.creator + '/tasks/' + task.refID] = null;
                        }

                    }
                });
                if(_.size(updates)>0){
                    return firebase.database().ref().update(updates)
                    .then(function(){
                        alert('Completed tasks archived.');
                      // $log.info('sorted');
                      // Force (true) Refresh our client menu
                      // clientDataService.setupUserAndClientMenu(true);
                    })
                }
            }

        vm.getUserRole = function(clientID){
            // Set defaults

               // Check to see if current user is admin or member so we can restrict who can see the 'admins only' toggle
               var teamSize = _.keys(teamDataService.clientTeams[clientID]).length;

               // if we have a team, check for permissions to edit otherwise, allow it
               if(teamSize > 0 && _.has(teamDataService.clientTeams[clientID], $rootScope.userID)){
                   return teamDataService.clientTeams[clientID][$rootScope.userID].role;
               } else {
                   // no team. This is a solo account. Set all to true.
                   return 'member'
               }

            }// vm.getUserRole

        vm.toggleCardCollapse = function(value){
            // make sure we bind it if it wasn't before (no setting state)
            userDataService.changeUserSetting('collapseCards', value);
            userDataService.getLoggedInUser()
            .then(function(){
                $timeout(function(){
                    vm.collapseCards = vm.settings.collapseCards;
                    if (!vm.verticalTaskPanels){
                          pageDimensionsService.resizeColumns();
                    }
                },1000);
            });
        }// vm.toggleCardCollapse

            if(_.has(vm.settings, 'verticalProfilePanels')){
                if(vm.settings.verticalProfilePanels){
                    vm.profileDragDirection = "vertical"
                } else {
                    vm.profileDragDirection = "horizontal"
                }
            }

            vm.verticalTaskPanels = vm.settings.verticalTaskPanels;

            vm.hideCompletedPanel = false;
            if(_.has(vm.settings, 'settings.hideCompletedPanel')){
                vm.hideCompletedPanel = vm.settings.hideCompletedPanel;
            }

            vm.suppressResize = false;
            if (vm.verticalTaskPanels === true){
                vm.suppressResize = true;
            }

            vm.showToday = false;
            vm.showEmptyNewTaskList = true;

            // reset teamDataService to make sure we have updated member lists for user drop downs
            vm.teamDataService = teamDataService;

            // vm.teamDataService.init();


            // If we have a showClientTodayPanel setting, use it
            if (_.has(vm.settings, 'showClientTodayPanel')) {
                vm.showToday = vm.settings.showClientTodayPanel;
                // vm.user.profile.settings.groupToday = false;
            };

            if (_.has(vm.settings, 'showEmptyNewTaskList')) {
                vm.showEmptyNewTaskList = vm.settings.showEmptyNewTaskList;
            };

            // store small subset of properties globally so our toolbar has easy info
            if(vm.thisClient){
                $rootScope.thisClient = vm.thisClient.profile;
                $scope.numPanels = _.size(vm.thisClient.taskpanels);
            } else {
                $log.error('We don\'t have vm.thisClient on client-tasks-controller run');
            }


            // We need $state to be avail to client-card directive to determine what elements in client card should be shown
            $rootScope.$state = $state;

            // set "today" for our duedate comparisons
            $scope.today = new Date();
            $scope.today = moment().toISOString();

            // Debounce our search filter
            // This is what you will bind the filter to
            vm.filterText = '';

            // Instantiate these variables outside the watch
            var tempFilterText = '',
                filterTextTimeout;
            $scope.$watch('searchQuery', function (val) {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);

                tempFilterText = val;
                filterTextTimeout = $timeout(function() {
                    vm.filterText = tempFilterText;
                }, 100); // delay 250 ms
              });

            // Setup our scrolling triggers and listeners
            $rootScope.draggingTask = false;
            $rootScope.draggingPanel = false;

            //// Task Filters Toolbar
            if(_.has(teamDataService.clientTeams, vm.thisClient.uid)){
                vm.teamList = teamDataService.clientTeams[vm.thisClient.uid];
            } else { }

            // Timeout without a duration gets run after the page is done
            // https://stackoverflow.com/questions/11125078/is-there-a-post-render-callback-for-angular-js-directive
            // $timeout(function () {
            //     triLoaderService.setLoaderActive(false);
            // });

            // set a watcher for newTasks so we can show/hide the newTask list accordingly
            $scope.$watch(function () {
                $scope.newTasks = $scope.$eval("vm.thisClient.tasks| toArray  : false| filter: newTaskBucketFilter| filter: snoozeFilter | orderBy:vm.sortOption");
            });

            // To be enabled after Billing Beta Complete and final version live
           checkForUpgrade();

        };// init


        function checkForUpgrade(){
            if(_.has(vm.thisClient, 'billing')){
                if(vm.thisClient.billingType != 'packages' && vm.thisClient.profile.plan.type != 'none' && vm.thisClient.billing && vm.thisClient.owner == vm.user.uid){
                   var confirm = $mdDialog.confirm()
                            .title(vm.thisClient.profile.fullName + ' needs an upgrade!')
                            .htmlContent('<p class="md-subhead"><strong>' + vm.thisClient.profile.fullName +'</strong> is running on Adminja\'s legacy billing system.</p><p class="md-subhead"> We <strong>strongly</strong> recommend upgrading them to Adminja\'s new billing &amp; invoicing before July 1, 2021.</p><p class="md-subhead" style="font-size: .85em;"><sup>*</sup> Upgrading takes approximately 2 minutes and will not harm your data.</p>')
                            .ariaLabel('Upgrade Now')
                            .ok('Upgrade Now')
                            .cancel('I\'ll do it later');;

                  $mdDialog.show(confirm).then(function() {
                    var now = moment().toISOString(), targetPeriod = undefined;
                    _.each(vm.thisClient.billing, function (billingPeriod){
                        if(billingPeriod.start < now && billingPeriod.end > now){
                            targetPeriod = billingPeriod;
                        }
                    });

                    if(targetPeriod){
                        $mdDialog.cancel();
                        return clientPackageService.newPackage(vm.thisClient, false, targetPeriod)
                    } else {
                        $mdDialog.cancel();
                         var confirm = $mdDialog.confirm()
                                  .title('Something went wrong!')
                                  .htmlContent('<p class="md-subhead">We had a problem upgrading ' + vm.thisClient.profile.fullName + '\'s billing.</p><p class="md-subhead">Don\'t worry. We can fix this for you.</p><p class="md-subhead"> Please contact <a href="mailto:help@getadminja.com">help@getadminja.com</a> with the name of this workspace.</p>')
                                  .ariaLabel('Done')
                                  .ok('Got it');

                        $mdDialog.show(confirm)
                    }

                  }, function(){
                    $mdDialog.cancel();
                  })
                }
            }

        }


        vm.changeSort = function(value){
            userDataService.changeUserSetting('defaultClientTaskSort', value);
            userDataService.getLoggedInUser();
        }

        vm.toggleCardCollapse = function(value){
            // make sure we bind it if it wasn't before (no setting state)
            userDataService.changeUserSetting('collapseCards', value);
            userDataService.getLoggedInUser();
            $timeout(function(){
                vm.collapseCards = vm.settings.collapseCards;
                if (!vm.verticalTaskPanels){
                      pageDimensionsService.resizeColumns();
                } else {
                      pageDimensionsService.resizeColumns('vertical');
                }
            }, 100);
        }// toggleCardCollapse


        // we need this filter to be able to show appropriate items in today and waiting panels.
        $scope.todayFilter = function (task) {
            return  task.duedate <= vm.now | task.focus === 'today';
        };

        $scope.inboxFilter = function (task) {
            return task.status == 'open' && (task.panel == 'Later' || task.panel == 'backlog' || task.panel == 'waiting' || task.panel === 'due' || task.panel === 'today')
        };

        $scope.userFilter = function(task){
            if(!task.private || vm.getUserRole(task.client) != 'member'){
                if(_.has(teamDataService, 'filteredMember')){
                    if(task.assignee == teamDataService.filteredMember){
                        return true
                    } else { return false}
                } else {
                    return true
                }
            }
        }// userFilter


        // TEST THIS. Not sure if laterfilter is needed on client tasks
        // it's not. rmoved laterfilter from customBucketFilter
        $scope.laterFilter = function(task) {
           // $log.info(task.duedate + ' - ' + vm.now);
           return !task.duedate || task.duedate > vm.now;
       };

       $scope.snoozeFilter = function(task){
        if(task.snooze && vm.snoozeFilter){
            return false
        } else {
            return true
        }
       }

        // filter used for tasks in custom buckets
        $scope.customBucketFilter = function(task){
            //filter: laterFilter | filter: userFilter |vm.filterText

                // run against our filters
                if($scope.userFilter(task)){
                    // if we have filterText, check against that as wee
                    if(vm.filterText){
                        if(_.lowerCase(task.description).includes(_.lowerCase(vm.filterText))){
                            // has filter text and passed it
                            return true
                        } else {
                            // doesn't pass filtertext
                            return false
                        }
                    } else {
                        // no filter text and passed filters
                        return true
                    }
                } else {
                    // didn't pass initial filters
                    return false
                }

        }// customBucketFilter

        $scope.newTaskBucketFilter = function(task){
                if($scope.inboxFilter(task) && $scope.userFilter(task)){
                    if(vm.filterText){
                        if(_.lowerCase(task.description).includes(_.lowerCase(vm.filterText))){
                            // has filter text and passed it
                            return true
                        } else {
                            // doesn't pass filtertext
                            return false
                        }
                    } else {
                        // no filter text and passed filters
                        return true
                    }
                } else {
                    return false
                }

        }// newTaskBucketFilter




        vm.showTeamFilter = function(){
         if (_.size(vm.teamList) > 1){
             return true
         }
        }

        vm.resetFilter = function(){
            vm.filterOption = 'all';
            delete teamDataService.filteredMember;
            delete teamDataService.filteredMemberName;
        }

        vm.filterUser = function(option){
         if(option != 'all'){
             teamDataService.filteredMember = option.uid;
             teamDataService.filteredMemberName = option.fullName;
         } else {
             delete teamDataService.filteredMember;
             delete teamDataService.filteredMemberName;
         }


         // Auto close filterbar after use
         // $timeout(function(){
         //     vm.showFilterBar = false;

         // },500)
        }// filterUser
        vm.closeFilterBar = function(){
            $timeout(function(){
               vm.showFilterBar = false;
            },100);
        }




        vm.resetTaskSearch = function(){
          vm.filterText = '';
          document.getElementById("searchQuery").value = "";
        }// resetFilter



        // Our Scrolling Helpers
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        }

        function scroll(amount) {
            $('#scroll-h').animate({
                scrollLeft: amount
            }, 50, 'linear');
        }

        // Dragula Setup
        // Inhibit screen scroll on drag/mobile solution from:
        // https://github.com/bevacqua/dragula/issues/487
        var scrollable = true;

        var listener = function(e) {
            if (! scrollable) {
                e.preventDefault();
            }
        }

        // document.addEventListener('touchmove', listener, { passive:false });

        // Panel Dragging
        dragulaService.options($scope, 'drag-task-panel', {
            moves: function (el, container, handle) {
                return handle.classList.contains('panel-drag-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation
                if ($(target).is('.scroll-trigger')){
                    // we can't drop on scroll-triggers
                    if($(target).is('.scroll-trigger-right') && $rootScope.draggingPanel){
                        var scrollAmount = '+=20';
                      debounce(scroll(scrollAmount), 250)
                    }
                    if($(target).is('.scroll-trigger-left') && $rootScope.draggingPanel){
                       var scrollAmount = '-=20';
                        debounce(scroll(scrollAmount), 250)
                    }
                    return false
                }
                else {
                    return true
                }

            },
            allowNestedContainers: true,
            direction: 'horizontal',
            revertOnSpill: true
        });
        // declare our panelBag so we can track drake.dragging
        var panelBag = dragulaService.find($scope, 'drag-task-panel');


        // Task Dragging
        dragulaService.options($scope, 'drag-task', {
            moves: function (el, container, handle) {
                    return !handle.classList.contains('quickTaskEntry');
                // return handle.classList.contains('task-handle');
            },
            accepts: function (el, target, source, sibling) {
                // Yes, we are using JQuery because accepts is returning an HTML object, not a javascript representation

                if ($(target).is('.scroll-trigger')){
                    // we can't drop on scroll-triggers
                    if($(target).is('.scroll-trigger-right') && $rootScope.draggingTask){
                        var scrollAmount = '+=20';
                      debounce(scroll(scrollAmount), 250)
                    }
                    if($(target).is('.scroll-trigger-left') && $rootScope.draggingTask){
                       var scrollAmount = '-=20';
                        debounce(scroll(scrollAmount), 250)
                    }
                    return false
                }
                else {
                    // only allow if in manual sort mode
                    if(vm.sortOption == 'order'){
                        return true
                    } else {
                        return false}

                }

            },
            invalid: function(el, handle){
                // return var === 'condition'
                return false
            },
            direction: vm.taskDragDirection,
            revertOnSpill: true
        });
        // declare our taskBag so we can track drake.dragging
        var taskBag = dragulaService.find($scope, 'drag-task');

        // Function checks to see if we SHOULD show overflow scrollTrigger areas
        $scope.checkOverflow = function() {
            var scrollH = $('#scroll-h'),
                target = scrollH[0];
               if (target.offsetHeight < target.scrollHeight ||
                      target.offsetWidth < target.scrollWidth) {
                      // your element have overflow
                  return true
                    } else {
                      // your element doesn't have overflow
                      return false
                    }
        };

        $scope.$on('drag-task.drag', function(){
            vm.cancelQuickTask();
            scrollable = false;
            if($scope.checkOverflow()){
                $timeout(function(){
                    $rootScope.draggingTask = true;
                    $scope.$apply();
                });

            }
        });
        $scope.$on('drag-task.cancel', function(){
            $rootScope.draggingTask = false;
            $timeout(function(){
                scrollable = true;
                $scope.$apply();
            });

        });
        $scope.$on('drag-task-panel.drag', function(){
            scrollable = false;
            vm.cancelQuickTask();
            if($scope.checkOverflow()){
                $timeout(function(){
                    $rootScope.draggingPanel = true;
                    $scope.$apply();
                });

            }
        });
        $scope.$on('drag-task-panel.cancel', function(){
            $timeout(function(){
                $rootScope.draggingPanel = false;
                scrollable = true;
                $scope.$apply();
            });

        });


        // Task Drop Listener
        $scope.$on('drag-task.drop', function (event, item, target, source, sibling) {

            // Now we can do our work - prep the variables
            var itemID = item[0].attributes.taskid.value,
                    parentPanelID = item[0].attributes.taskpanel.value,
                    parentPanel = $('.app-item-container-items[panelid="'+ parentPanelID +'"]'),
                    clientID = item[0].attributes.client.value,
                    targetPanelID = target[0].attributes.panelid.value,
                    targetPanelOrder = target[0].attributes.panelorder.value,
                    sourcePanelID = source[0].attributes.panelid.value,
                    sourcePanelOrder = source[0].attributes.panelorder.value,
                    numSourceChildren = $(parentPanel).find('.task-app-item').length,
                    sourceChildren = $(parentPanel).find('.task-app-item').toArray(),
                    ghostElement = document.querySelector('.gu-transit'),
                    targetChildren = Array.from(ghostElement.parentNode.children),
                    targetItemIndex = targetChildren.indexOf(ghostElement),
                    thisBag = dragulaService.find($scope, 'drag-task'),
                    updates = {},
                    thisTask = vm.thisClient.tasks[itemID];

            // Cancel dragula's default drop operations - we want to handle this ourselves now so dragula and our model don't fight each other on sorting
            // thisBag.drake.cancel(true);


            // console.log(itemID + ' from ' + parentPanelID + ' to ' + targetPanelID + ' at position ' + targetItemIndex);

            // Prepare order changes for all tasks in set
            _.each(targetChildren, function(child, index){
                // only handle valid tasks
                if(_.has(child.attributes, 'taskid')){
                    var childID = child.attributes.taskid.value,
                        // getting thisTask will differ for other task views
                        childTask = vm.thisClient.tasks[childID];

                    // if target panel different than source AND we are on our moved task
                    if(targetPanelID != parentPanelID && childTask.uid == thisTask.uid){
                        updates['/tasks/' + itemID + '/info/panel/'] = targetPanelID;
                        updates['/users/' + childTask.assignee + '/tasks/' + itemID + '/panel/'] = targetPanelID;
                        updates['/clients/' + childTask.client + '/tasks/' + itemID + '/panel/'] = targetPanelID;
                        userDataService.trackEvent('move-task');
                    } else if (childTask.uid == thisTask.uid){
                        userDataService.trackEvent('reorder-task');
                    }

                    updates['/tasks/' + childID + '/info/order'] = Number(index + 1);
                    updates['/users/' + childTask.assignee + '/tasks/' + childID + '/order'] = Number(index + 1);
                    updates['/clients/' + childTask.client + '/tasks/' + childID + '/order'] = Number(index + 1);
                }
            }); // each targetChildren

            return firebase.database().ref().update(updates)
            .then(function(){
                // thisBag.drake.cancel(true);
                $timeout(function(){
                    scrollable = true;

                        $rootScope.draggingTask = false;
                        $scope.$apply();
                });

            });

        });// $on.drag-task.drop

        // hiding/showing scrolltriggers
        vm.showTaskScrollTriggers = function(){
               if(taskBag.drake.dragging){
                   return true
               } else { return false }
        }



        // If over a task container
        $scope.$on('drag-task.over', function (event, el, target, source) {
            // $log.info('over');
            // $log.info(target);
            if( (target[0].$$hashKey != source[0].$$hashKey) && (!_.has(target[0].classList, 'scroll-trigger')) ){
                pageDimensionsService.resizeColumns();
            }

        });

        /////////////////////////////////////////////
        // drag-profile-detail over function
        $scope.$on('drag-task.out', function (event, el, target, source) {

            if(target[0].$$hashKey != source[0].$$hashKey && (!_.has(target[0].classList, 'scroll-trigger')) ){
                pageDimensionsService.resizeColumns();
            }
        });

        // Task Panel Drop Listener\
        $scope.$on('drag-task-panel.drop', function (event, item) {
            // $log.info(event);
            // $log.info(item);
            scrollable = true;
            $rootScope.draggingPanel = false;
            //heap.track('Task Panel Moved');
            userDataService.trackEvent('move-task-list');
            var droppedPanelID = item[0].attributes.panelid.nodeValue,
                    clientID = item[0].attributes.client.nodeValue;

                    // $log.info('droppedPanelID:' + droppedPanelID);
                    // $log.info('clientID:' + clientID);
            // grab all of the panels directly from the DOM to ensure we have the correct sort order
            // make sure we don't accidentally pick up dragula's .gu-mirror copy that was used
            // and hidden during the drag process
            var sortedPanels = $('.task-panel:not(".gu-mirror")');

            // set our DB reference
            var panelsRef = firebase.database().ref('clients/' + clientID + '/taskpanels')

            // Update each item in firebase by ID
            _.each(sortedPanels, function (panel, index) {
                //if it's not the Today panel - order it
                if(!$(panel).hasClass('focused-item-container')){
                    var newOrder = index + 1,
                            panelID = panel.getAttribute('panelid');
                    // $log.info(panelID);
                    // update JUST the order value on the detail
                    panelsRef.child(panelID).child('order').set(newOrder);
                }
            });
        });


        function sortTodayTasks(panel, clientID) {
            var panelID = panel.attributes.panelid.nodeValue;
            // debugger
            // $log.info('sortTodayTasks');

            // // Isolate this panel thanks to it's panelid attribute
            var sortingPanel = panel;
            // $(sortingPanel).css('background-color', 'yellow');
            // // grab all of the cards in this panel directly from the DOM to ensure we have the correct sort order
            var sortedTasks = $(sortingPanel).find('app-item');

            // // set our DB references
            var tasksRef = firebase.database().ref('tasks/');
            var clientTasksRef = firebase.database().ref('clients/' + clientID + '/tasks/');

            // // Update each item in firebase by ID
            _.each(sortedTasks, function (task, index) {
                var newOrder = parseInt(index) + 1,
                        taskID = task.getAttribute('taskid');
                        assignee = task.getAttribute('assignee');

                // Update the database
                var updates = {};
                // store our canonical object
                updates['tasks/' + taskID + '/info/todayorder'] = newOrder;
                // store our reference in the client's store
                updates['clients/' + clientID + '/tasks/' + taskID + '/todayorder'] = newOrder;
                updates['users/' + assignee + '/tasks/' + taskID + '/todayorder'] = newOrder;
                // Execute our update
                return firebase.database().ref().update(updates)
                        .then(function () {
                            // $log.info('sorted');
                        });
            })
        }// sortTodayTasks


        vm.newTaskPanel = function (client) {
            // $log.info('newPanel (tasks) triggered');
            if(!vm.hasClientUser){
                taskPanelDataService.newPanel(client.uid, false);
            } else {
                taskPanelDataService.newPanel(client.uid, true);
            }

        };

        vm.changeSetting = function (setting, value) {
            // $log.info('Toggle Show Today panel clicked');
            userDataService.changeUserSetting(setting, value);
            userDataService.getLoggedInUser();
        };




        vm.editTaskPanel = function (panel) {
            // $log.info('editPanel (tasks) triggered');
            if(!vm.hasClientUser){
                taskPanelDataService.editPanel(panel);
            } else {
                taskPanelDataService.editPanel(panel, true);
            }
        };

        vm.deleteTaskPanel = function (panel) {
            // $log.info('newPanel (tasks) triggered');
            taskPanelDataService.deletePanel(panel);
        };


        vm.newTask = function (clientID, panel) {
            // $log.info('newTaskD for ' + clientID + ' with status of:' + status);
            $scope.editedItem = taskDataService.newTask(clientID, panel);
            // Set our dialogTitle
            $scope.dialogTitle = "New";
            // console.log($scope.editedItem);
            taskDataService.taskDialog($scope.editedItem);
        }


        vm.newFromTemplate = function (template, panel) {
            userDataService.trackEvent('new-task-from-template');
            return taskTemplateDataService.getTaskTemplate(template.uid)
                     .then(function(thisTemplate){
                       var clone = ajUTILITIES.removePropertiesWith(thisTemplate);;
                       // remove any template-only values
                       delete clone.type;
                       delete clone.schedule;
                       delete clone.isRecurring;
                       delete clone.uid;
                       delete clone.info.refID;
                       // delete clone.$id;
                       // delete clone.$priority;
                       // delete clone.$key;
                       clone.focus = 'someday';
                       clone.info.panel = 'Later';
                       if(panel != 'new'){
                        clone.info.panel = panel.uid;
                       }

                       clone.info.order = 0;
                       clone.created = moment().unix();
                       taskDataService.taskDialog(clone);
                     });
        }


        vm.isActiveList = function(panelID){
            if(vm.activeQuickTask == panelID){
                return true
            }
        }

        vm.quickTask = function (clientID, panelID) {
            userDataService.trackEvent('quick-task');
            // $log.info(panelID);
            vm.cancelQuickTask();
            vm.activeQuickTask = panelID;

            // wait a hairs breadht and focus on field
            $timeout(function(){
                document.getElementById("quickTaskField").focus();
            },200);

            vm.newQuickTask = taskDataService.newTask(clientID, panelID);

            // enable our escape to cancel hotkey
            hotkeys.add({
              combo: 'esc',
              description: 'Cancel New Task',
              allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
              callback: function(event, hotkey) {
                event.preventDefault();
                // $log.info(event);
                vm.cancelQuickTask();
              }
            })
            hotkeys.add({
                combo: 'enter',
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                description: 'Save task',
                callback: function (event, hotkey) {
                    // $log.info('ctrl+enter');
                    event.preventDefault();

                    if (vm.newQuickTask.info.description) {
                        vm.saveQuickTask(vm.newQuickTask)
                    }

                }
            });

            // console.log($scope.editedItem);
            // taskDataService.taskDialog($scope.editedItem);
        }

        vm.saveQuickTask = function(task){
            // $log.info('saving...');
            // if other team members are available, yet none selected, make sure assigned to this user
            if(!task.info.assignee){
                task.info.assignee = $rootScope.userID;
                task.info.assigneeName = userDataService.user.profile.fullName;
                task.info.assigneeAvatar = userDataService.user.profile.avatar;
            }
            else {
                _.each(vm.teamList, function(member){

                    if(member.uid == task.info.assignee){

                        task.info.assigneeName = member.fullName;
                        task.info.assigneeAvatar = member.avatar;
                    }
                });
            }

            taskDataService.saveNew(task);
            userDataService.trackEvent('save-quick-task');
            vm.cancelQuickTask()
        };

        vm.cancelQuickTask = function(){
            vm.activeQuickTask = null;
            _.each(vm.thisClient.taskpanels, function(panel){
                if(panel.showQuickTask){
                    panel.showQuickTask = false;
                    hotkeys.del('esc');
                    hotkeys.del('enter');
                }
            });
        }

        vm.batchTasks = function(clientID, panel){
            return taskDataService.batchDialog(clientID, panel);
        }

        vm.markAllComplete = function(panelID){
            // $log.info(panelID);
            // $log.info('mark all tasks complete');
            _.each(vm.thisClient.tasks, function(task){
                if(task.panel == panelID && task.status != 'closed'){
                    // $log.info('toggling');
                    taskDataService.toggleComplete(task);
                }
            })
            userDataService.trackEvent('mark-all-tasks-complete');
        }

        vm.deleteAll = function(panelID){
         // $log.info('delete all tasks');
         _.each(vm.thisClient.tasks, function(task){
             if(task.panel == panelID && task.status != 'closed'){
                taskDataService.removeTask(task);
             }
         })
         userDataService.trackEvent('delete-all-tasks');
        }

        // add shortcut for task collapsing.
        hotkeys.add({
            combo: 'alt+ctrl+c',
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            description: 'Collapse/Expand Task Cards',
            callback: function (event, hotkey) {

                event.preventDefault();

                if(vm.collapseCards){
                    // collapsed - switch to open
                    vm.toggleCardCollapse(false);
                } else {
                    // open - switch to collapsed
                    vm.toggleCardCollapse(true);
                }
            }
        });

        $rootScope.$on('loadArchived', function(){
            vm.loadArchived(vm.clientID);
        })

        vm.loadArchived = function(clientID){
            $timeout(function(){
                vm.archivedTasks = null;
                // triLoaderService.setLoaderActive(true);
            },0);
            var tasksRef = firebase.database().ref('tasks').orderByChild('info/clientCompleted').startAt(clientID + '-' + moment().subtract(30, 'days').toISOString()).endAt(clientID + '-' + moment().toISOString());
            tasksRef.once('value', function(data){
                var archivedTasks = data.val(), array = [];
                _.each(archivedTasks, function(task){
                    if(task.info.archived){
                        array.push(task.info);
                    }

                    // if(!_.has(vm.thisClient.tasks, task.uid)){
                    //     array.push(task.info)
                    // }
                });

                // $timeout(function(){
                //     vm.archivedTasks = array;
                //     triLoaderService.setLoaderActive(false);
                // },0);
            })
        }


    }
    ;// end clientLegacyTasksController



})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientLegacyBillingController', clientLegacyBillingController);
        // clientLegacyBillingController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function clientLegacyBillingController($mdToast, $state, $log, clientPackageService, hotkeys, $http, teamDataService, taskDataService, $stateParams,  $window, $scope, triLoaderService, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, clientBillingService, timeReportService, timeDataService, invoiceService, currentAuth, _userData, _clientData) {
        $log.info('clientLegacyBillingController');
        var vm = this;
        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.user = _userData;
        vm.userType = $rootScope.admin;
        // $log.info(vm.userType);
        vm.settings = $rootScope.userSettings;
        vm.newEntry = {};
        vm.newPayment = {};
        vm.newPayment.date = moment().toDate();
        vm.clientBillingService = clientBillingService;
        vm.invoiceService = invoiceService;
        vm.today = moment();
        vm.timeReportService = timeReportService;
        vm.now = moment().toISOString();
        vm.fbConfig = fbConfig;
        // $log.info(vm.fbConfig);
        vm.thisClient = _.find(vm.clients, function (client) {
            return client.uid == $state.params.clientID;
        });
        if(vm.thisClient.billingType == 'packages'){
           var confirm = $mdDialog.confirm()
                    .title('Use Legacy Billing at your own risk')
                    .htmlContent('<p class="md-subhead center">This client has migrated to Package-based billing. Legacy Billing is only for historical purposes.</p><p class="md-subhead">We do not recommend modifying Billing Periods or creating Invoices here.</p>')
                    .ariaLabel('Are you sure?')
                    .ok('I Understand');


          $mdDialog.show(confirm).then(function() {
            $mdDialog.cancel();
          })
        }

        // determine if user is clientUser for this workspace
        vm.isClientUser = false;
        if(_.has($rootScope, 'VAWorkspaces')){
            if(_.has($rootScope.VAWorkspaces, $state.params.clientID)){
                    vm.isClientUser = true;
                    // restrict clientUsers from visiting this state if state is disabled in clientUserTabs
                    if(!vm.thisClient.clientUserTabs.billing){
                      $state.go('triangular.workspaces.overview');
                    }
            }
        }

       // Watch for changes in which period is selected and reset our form
      $scope.$watch('vm.clientBillingService.selectedPeriod', function() {
            // Only do something IF we have a periodForm.
             if(_.has(vm, 'periodForm')){
                vm.periodForm.$setPristine();
             }
         });

      vm.editClient = function(client) {
          // $log.info('editClient got clicked!')
          // $log.info(client);
          return clientDataService.editClient(client.uid);

      }; // End editClient

      vm.openTime = function(entry){
        if(!vm.isClientUser){
          timeDataService.timeDialog(entry, 'Modify');
        }
      }



        // // Support for showing appcues on demand
        // vm.showCue = function(cue, flag){
        //     // trigger our primer
        //     Appcues.show(cue);

        //     // mark step complete
        //     $timeout(function(){
        //         vm.changeOnboardingFlag(flag, true);
        //     }, 5000);

        // }

        // NOTE we have vm.period and vm.client by default because it was passed in to "this" already

        vm.isCurrentPeriod = function(client, period){
            var now = moment().toISOString();
            if (period.info.start <= now && period.info.end >= now){
                return true
            } else {
                return false
            }
        }

        vm.forceNextPeriod = function(client){
          var checkURL = undefined;
          if(vm.fbConfig.databaseURL == "adminja-staging.firebaseio.com"){
            checkURL = "https://us-central1-adminja-staging.cloudfunctions.net/checkBillingPeriods?key=hZPEbfkrPqyTimY4dbgE";
          } else {
            checkURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net/checkBillingPeriods/?key=hZPEbfkrPqyTimY4dbgE";
          }

          var checkURL = checkURL + '&client=' + client.uid;
          $http.get(checkURL)
              .then(function(data){
                // $log.info(data);
                triLoaderService.setLoaderActive(false);
                $mdDialog.cancel();
              })
            }// forceNextPeriod

        vm.checkForPeriod = function(client){
           var confirm = $mdDialog.confirm()
                    .title('Create the next billing period?')
                    .htmlContent('This may take from 1-3 minutes. <br>Your client\'s "Next Renewal" will also be updated.')
                    .ariaLabel('Are you sure?')
                    .ok('Do it')
                    .cancel('Never mind');

          $mdDialog.show(confirm).then(function() {
              // Set the client's next cycle date to 1ms after the end date of the most recent period
              // $log.info(vm.thisClient);
              // find the most recent billing period
              var latestValue = "2017-01-01T00:00:00.000Z", latestID = undefined;
              _.each(vm.thisClient.billing, function(period){

                if(period.end > latestValue){
                  latestValue = period.end;
                  latestID = period.uid;
                }
              });

              if(latestID){
                var clientProfileRef = firebase.database().ref('/clients/' + vm.thisClient.uid + '/profile'),
                    newCycle = moment(latestValue).add(1, 'ms').toISOString();

                  // Change the client's cycle date
                  clientProfileRef.child('plan').child('nextCycle').set(newCycle);
                  $timeout(function(){
                    triLoaderService.setLoaderActive(true);
                    var checkURL = undefined;

                    if(vm.fbConfig.databaseURL == "adminja-staging.firebaseio.com"){
                      checkURL = "https://us-central1-adminja-staging.cloudfunctions.net/checkBillingPeriods?key=hZPEbfkrPqyTimY4dbgE";
                    } else {
                      checkURL = "https://us-central1-project-6414439425425792624.cloudfunctions.net/checkBillingPeriods/?key=hZPEbfkrPqyTimY4dbgE";
                    }

                    var checkURL = checkURL + '&client=' + client.uid;
                    $http.get(checkURL)
                        .then(function(data){
                          // $log.info(data);
                          triLoaderService.setLoaderActive(false);
                          $mdDialog.cancel();
                        })
                  },500);

               // get the period
              } else {
                $mdDialog.cancel();
              }


          }, function() {
               // they chose the cancel option
               $mdDialog.cancel();
          });


        }// createNextBillingPeriod

        vm.enableEditPeriod = function(ev){
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                  .title('Edit Billing Period Range: Are you Sure?')
                  .htmlContent('<span style="color: red;"><b>ONLY</b> edit this range if you know what you are doing.</span> <ul><li>- Please make sure none of your billing period ranges overlap.</li><li>- Please make sure the MOST RECENT billing period ends the day before this client\'s "Next Billing" date.</li><li>- If you need assistance. Please submit a help desk ticket.</li></ul>')
                  .ariaLabel('Confirm Edit')
                  .targetEvent(ev)
                  .ok('I know what I\'m Doing')
                  .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
              vm.editPeriod = true;
              userpilot.track("Enable Edit Period");
              dataLayer.push({'event': 'edit-billing-period-enabled'});
            }, function() {
            });

        }
        vm.cancelEditPeriod = function(){
            vm.editPeriod = false;
            // Clear the service's current selected period
            delete vm.clientBillingService.selectedPeriod;
            dataLayer.push({'event': 'edit-billing-period-cancelled'});
        }

        vm.changeOnboardingFlag = function(flag, value){
            // $log.info('updateSettings');
            userDataService.changeOnboardingFlag(flag, value);

            // Tag it in Drip
            if(value){
                _dcq.push(["identify", {
                 email: userDataService.user.email,
                 tags: ["onBoarding: " + flag]
               }]);
            } else {
                 _dcq.push(["identify", {
                  email: userDataService.user.email,
                  remove_tags: ["onBoarding: " + flag]
                }]);
            }
            // Update our local data
            userDataService.getLoggedInUser();
        } // vm.updateSettings

        // Clear the service's current selected period
        delete vm.clientBillingService.selectedPeriod;

        // Clear the service's selected arrays
        delete vm.invoiceService.selectedInvoice;
        delete vm.invoiceService.selectedTime

        // set our currency if user has selected one
         vm.currency = "$";
        if (_.has(vm.settings, 'currency')){
             vm.currency = vm.settings.currency;
         }
         // currency set

        // Identify thisClient
        vm.thisClient = _.find(vm.clients, function (client) {
            return client.uid == $stateParams.clientID;
        });

        // If not the owner and not Admin, don't allow access to this page
        if(!vm.isClientUser && vm.thisClient.owner != vm.user.uid && !vm.thisClient.access.admins[vm.user.uid]){
          $state.go("triangular.workspaces.tasks", {"clientID": vm.thisClient.uid});
        }

        // init our invoice service
        vm.invoiceService.init(vm.thisClient);


        // Calculate total time logged in this period
        vm.used = function(){
          var hours = 0;
          if(_.has(vm.clientBillingService.selectedPeriod.info, 'logged')){
            hours = vm.clientBillingService.selectedPeriod.info.logged / 60;
          }
            return hours

        }// vm.used

        // Calc hours remaining in current period
        vm.remain = function(){
            return vm.clientBillingService.selectedPeriod.info.allocated - vm.used()
        }

        // Calculates total cost of hourly time logged
        vm.timeCost = function(){
          var total = 0;
          _.each(vm.timeReportService.report.data, function(entry){
            var entryTotal = (entry.logged/60) * vm.entryRate(entry);
            total = total + entryTotal;
          });
            total = total.toFixed(2);
            return total
        }

        // we need to fake the inline edit for allocated time - it's displayed using  filter, but not edited with one.
        // inline-edit just can't handle that
        vm.editAllocated = function(){
          vm.tempAllocated = vm.clientBillingService.selectedPeriod.info.allocated;
          vm.editingAllocated = true;
        }
        // Update allocated field (via inline editing)
        vm.updateAllocated = function(data){
            vm.clientBillingService.selectedPeriod.info.allocated = data;
            vm.editingAllocated = false;
        }
        // Update allocated field (via inline editing)
        vm.updateRate = function(data){
            vm.clientBillingService.selectedPeriod.info.rate = data;
        }


        vm.entryRate = function(entry){
            if(_.has(entry, 'rate')){
                return entry.rate
            } else {
                return vm.clientBillingService.selectedPeriod.info.rate
            }

        }


        vm.datesChanged = function(){
          vm.clientBillingService.periodDatesChanged = true;
          dataLayer.push({'event': 'billing-period-dates-changed'});
        }

        // Update the database with the local copy
        vm.updatePeriod = function(){
            vm.editPeriod = false;
            // we really don't want to be changing the start/end dates every time the billing period is updated.
            if(vm.clientBillingService.periodDatesChanged && vm.clientBillingService.selectedPeriod.info.recurrenceType != 'zero'){
              vm.clientBillingService.selectedPeriod.info.start = moment(vm.clientBillingService.selectedPeriod.displayStartDate).startOf('day').toISOString();
              vm.clientBillingService.selectedPeriod.info.end = moment(vm.clientBillingService.selectedPeriod.displayEndDate).endOf('day').toISOString();
            }
            if(_.has(vm.clientBillingService.selectedPeriod, 'displayExpirationDate')){
              vm.clientBillingService.selectedPeriod.info.expirationDate = moment(vm.clientBillingService.selectedPeriod.displayExpirationDate).startOf('day').toISOString();
            }

            return clientBillingService.updateBillingPeriod(vm.clientBillingService.selectedPeriod.info)
            .then(function(){
              vm.periodForm.$setPristine();
              // We need to re-set these values or they are lost after subsequent edits on the same billing detail
              vm.clientBillingService.selectedPeriod.displayStartDate = moment(vm.clientBillingService.selectedPeriod.info.start);
              vm.clientBillingService.selectedPeriod.displayEndDate = moment(vm.clientBillingService.selectedPeriod.info.end);
                // so our view updates
                // if(_.has(vm, 'periodForm')){
                //   $timeout(function(){
                //       vm.periodForm.$setPristine();
                //   }, 1000);
                // }// if we have periodForm

                // Trigger a total recalc for this period
                timeDataService.triggerReCalc(vm.clientBillingService.selectedPeriod);
                // deselect the billing period
                // delete vm.clientBillingService.selectedPeriod
                dataLayer.push({'event': 'billing-period-updated'});

            })
            // send updated period to clientBillingService
        }


        // store small subset of properties globally so our toolbar  has easy info
        $rootScope.thisClient = vm.thisClient.profile;


        // Trigger appcues
        // $timeout(function(){
        //         if ($window.Appcues) {
        //             $window.Appcues.start();
        //         }
        //     }, 1000)


        //// Line Entry Management
        vm.newEntry.date = moment().toDate();

        vm.addNewEntry = function(newEntry){
            // $log.info('vm.addNewEntry:', newEntry);
            // make a copy so we aren't dealing with $ nodes
            var newEntryCopy = angular.copy(newEntry);
            // Convert date to ISOString
            newEntryCopy.date = moment(newEntryCopy.date).toISOString();
            // Set our Ref
            var entryRef = firebase.database().ref('billingPeriods/' + vm.clientBillingService.selectedPeriod.uid + '/lineItems/');
            // Get our new key
            var newKey = entryRef.push().key;
            // Save our key on our object
            newEntryCopy.uid = newKey;
            newEntryCopy.type = 'additionalCharge';
            // Store the object
            entryRef.child(newKey).set(newEntryCopy);
            // Clear the form
            vm.newEntry = {};
            vm.newEntry.date = moment().toDate();
            vm.displayChargeForm = false;
            dataLayer.push({'event': 'line-item-added'});
        } // vm.addNewEntry


        // replace this with invoiceService version
        vm.addNewPayment = function(newPayment){
            // $log.info('vm.addNewPayment:', newPayment);
            // make a copy so we aren't dealing with $ nodes
            var newPaymentCopy = angular.copy(newPayment);
            // Convert date to ISOString
            newPaymentCopy.date = moment(newPaymentCopy.date).toISOString();

            // Get our new key
            var newKey = firebase.database().ref('payments').push().key, now = moment().toISOString();
            // Save our key on our object
            newPaymentCopy.uid = newKey;
            newPaymentCopy.client = vm.invoiceService.selectedInvoice.info.client;
            newPaymentCopy.clientName = clientDataService.clientName(newPaymentCopy.client);
            newPaymentCopy.invoice = vm.invoiceService.selectedInvoice.uid;
            newPaymentCopy.invoiceNumber = vm.invoiceService.selectedInvoice.info.number;
            newPaymentCopy.created = now;
            newPaymentCopy.account = vm.invoiceService.selectedInvoice.info.owner;
            newPaymentCopy.accountCreated = vm.invoiceService.selectedInvoice.info.owner + now;
            var updates = {};
            updates['invoices/' + vm.invoiceService.selectedInvoice.uid + '/info/payments/' + newKey] = newPaymentCopy;
            updates['payments/' + newKey] = newPaymentCopy;
            return firebase.database().ref().update(updates)
            .then(function(){
              return userDataService.count(newPaymentCopy.account, 'payments', 1)
              .then(function(){
                return userDataService.count(newPaymentCopy.account, 'paid', newPaymentCopy.amount)
                .then(function(){
                  // Clear the form
                  vm.newPayment = {};
                  vm.newPayment.date = moment().toDate();
                  dataLayer.push({'event': 'payment-applied'});
                  userpilot.track("Payment Applied");

                  //heap.track('Payment Applied');
                   _dcq.push(["identify", {
                    email: userDataService.user.email,
                    tags: ["Applied a Payment"]
                  }]);
                  // Update our invoice to store new calculcation
                  vm.updateInvoice();
                })
              })
            });

        } // vm.addNewPayment

        vm.removePayment = function(payment){
            // $log.info(payment);
            // $log.info(vm.invoiceService.selectedInvoice.info.payments);
            var updatedPayments = [];
            _.each(vm.invoiceService.selectedInvoice.info.payments, function(item){
                // $log.info(item);
                if(item.uid != payment.uid){
                    updatedPayments.push(item);
                }
            });


            // $log.info(updatedPayments);
            vm.invoiceService.selectedInvoice.info.payments = updatedPayments;

            // remove the "/payments" node that matches this payment.
            firebase.database().ref('/payments/' + payment.uid).set(null);
            return userDataService.count(payment.account, 'payments', -1)
            .then(function(){
              var amount = -1 * payment.amount;
              return userDataService.count(payment.account, 'paid', amount)
              .then(function(){
                //heap.track('Payment Removed');
                userpilot.track("Payment Removed");

                // // ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
                vm.updateInvoice();
                dataLayer.push({'event': 'payment-removed'});
              })
            })
        }// vm.removePayment

        vm.invoiceDue = function(){
            var due = 0,
                paid = 0,
                amount = vm.invoiceTotal();
                if(_.has(vm.invoiceService.selectedInvoice, 'info.payments')){
                    _.each(vm.invoiceService.selectedInvoice.info.payments, function(payment){
                        paid = paid + Number(payment.amount);
                    });
                }

            due = amount - paid;
            // function may run after invoice removed.
            // make sure we aren't assigning to undefined
            if(_.has(vm.invoiceService, 'selectedInvoice.info')){
                vm.invoiceService.selectedInvoice.info.balance = due.toFixed(2);
            }
            return due
        }

        vm.total = function(entries){
          var total = 0;
          _.each(entries, function(entry){
            total = total+entry.logged;
          });

          return total
        }

        vm.deleteEntry = function(entry){
            // $log.info(Object.keys(entry));
           //  $log.info(entryID);
            var entryRef = firebase.database().ref('billingPeriods/' + vm.clientBillingService.selectedPeriod.uid + '/lineItems/');
           entryRef.child(entry.uid).set(null);
           dataLayer.push({'event': 'line-item-deleted'});
        }

        // Toggling for line items
        vm.toggleAllEntries = function() {
            // $log.info('toggleAllEntries');
            var toggleStatus = !vm.isAllSelected;
            angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced){
                    item.selected = toggleStatus;
                }
            });
            dataLayer.push({'event': 'toggle-all-lineitems'});
         }// vm.toggleAllEntries

         vm.optionToggled = function(){
            var isAllSelected = true;
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if (!item.selected){
                    isAllSelected = false;
                }
            });
           vm.isAllSelected = isAllSelected
         }// vm.optionToggled


         vm.markItemsPending = function(){
            angular.forEach(vm.timeReportService.report.data, function(item){
              if(!item.invoiced && item.selected){
                    item.selected = false;
                   item.pending = true;
              }
          });
              angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced && item.selected){
                    item.selected = false;
                     item.pending = true;
                }
            });
         }// markItemsPending

         vm.removeAllPending = function(){
            angular.forEach(vm.timeReportService.report.data, function(item){
              if(!item.invoiced){
                    item.selected = false;
                   item.pending = false;
              }
          });
              angular.forEach(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(!item.invoiced){
                    item.selected = false;
                     item.pending = false;
                }
            });
         }// removeAllPending

         // Toggling for time entries
         vm.toggleAllTimeEntries = function() {
             // $log.info('toggleAllEntries');
             var toggleStatus = !vm.isAllTimeSelected;
             angular.forEach(vm.timeReportService.report.data, function(item){
               if(!item.invoiced){
                    item.selected = toggleStatus;
               }
            });
             dataLayer.push({'event': 'toggle-all-time-entries'});
          }// vm.toggleAllTimeEntries

          vm.timeOptionToggled = function(){
             var isAllSelected = true;
             _.each(vm.timeReportService.report.data, function(item){
                 if (!item.selected){
                     isAllSelected = false;
                 }
             });
            vm.isAllTimeSelected = isAllSelected
          }// vm.timeOptionToggled

          vm.areInvoiceItemsSelected = function(){
            var areSelected = false;
            if(vm.clientBillingService.selectedPeriod){
              _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                  if (item.selected){
                      areSelected = true;
                  }
              });

              // If this is an hourly billingPeriod, then we need to check to see if any time is
              // selected as well
              if(vm.clientBillingService.selectedPeriod.info.type =='hourly'){
                  _.each(vm.timeReportService.report.data, function(entry){
                      if (entry.selected){
                          areSelected = true;
                      }
                  });
              }
              return areSelected
            } else {
              return areSelected
            }

          }// vm.areInvoiceItemsSelected

          vm.arePrintableItemsSelected = function(){
            var areSelected = false;
            _.each(vm.timeReportService.report.data, function(item){
                if (item.selected){
                    areSelected = true;
                }
            });
            return areSelected
          }// vm.areInvoiceItemsSelected

          ////////////
          // Invoice Handling
          vm.invoiceSelectedLineItems = function(){
            var sendItems = [],
                sendTime = [];

            // Gather our lineItems
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    sendItems.push(itemCopy);
                }
            });

            // Gather our time
            _.each(vm.timeReportService.report.data, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    ajUTILITIES.removePropertiesWith(itemCopy);
                    itemCopy.rate = vm.entryRate(itemCopy);
                    sendTime.push(itemCopy);
                }
            });

            return vm.invoiceService.newInvoice(vm.user, vm.clientBillingService.selectedPeriod, sendItems, sendTime)
            .then(function(invoice){
                vm.invoiceService.selectedInvoice = invoice;
                // mark the passed items as pending so they aren't
                // re-added to the invoice again (duplicated)
                vm.markItemsPending();
                //heap.track('New Invoice Started');
                dataLayer.push({'event': 'new-invoice-started'});
                userpilot.track('New Invoice Started');
                 _dcq.push(["identify", {
                  email: userDataService.user.email,
                  tags: ["Started and Invoice"]
                }]);
                 putInView();
                // $log.info(vm.invoiceService.selectedInvoice);
            });

          }// invoiceSelectedLineItems

          function putInView() {
              $timeout(function(){
                $('#scroll-h').animate({
                    scrollLeft: 3000
                }, 20, 'linear');
              }, 100)

             }// putInView

          // Add selected items to currently selected Invoice
          vm.addSelectedLineItems = function(){
            var sendItems = [],
                sendTime = [];

            // Gather our lineItems
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    if(_.has(vm.invoiceService.selectedInvoice, 'lineItems')){
                        vm.invoiceService.selectedInvoice.lineItems.push(itemCopy);
                    } else {
                        vm.invoiceService.selectedInvoice.lineItems = [];
                        vm.invoiceService.selectedInvoice.lineItems.push(itemCopy);
                    }

                }
            });

            // Gather our time
            _.each(vm.timeReportService.report.data, function(item){
                if(item.selected){
                    var itemCopy = angular.copy(item);
                    ajUTILITIES.removePropertiesWith(itemCopy);
                    itemCopy.rate = vm.entryRate(itemCopy);
                    if(_.has(vm.invoiceService.selectedInvoice, 'time')){
                        vm.invoiceService.selectedInvoice.time.push(itemCopy);
                    } else {
                        vm.invoiceService.selectedInvoice.time = [];
                        vm.invoiceService.selectedInvoice.time.push(itemCopy);
                    }
                }// if item.selected
            });

            vm.markItemsPending();
            vm.invoiceDirty = true;
            dataLayer.push({'event': 'add-selected-line-items-to-invoice'});
          }// invoiceSelectedLineItems

          vm.cancelInvoice = function(){
            vm.removeAllPending();
            delete vm.invoiceService.selectedInvoice
            delete vm.invoiceService.selectedTime
            delete vm.printReport
            dataLayer.push({'event': 'cancel-invoice'});
          }

          vm.saveInvoice = function(){
            var invoiceCopy = angular.copy(vm.invoiceService.selectedInvoice);
            if(!_.has(invoiceCopy, 'info.terms')){
                invoiceCopy.info.terms = "";
            }
            if(!_.has(invoiceCopy, 'info.notes')){
                invoiceCopy.info.notes = "";
            }
            // $log.info(invoiceCopy);
            // convert our date object to a string
            invoiceCopy.info.date = moment(invoiceCopy.info.date).toISOString();
            invoiceCopy.info.due = moment(invoiceCopy.info.due).toISOString();
            return vm.invoiceService.saveInvoice(invoiceCopy)
            .then(function(response){
                //
                // $log.info(response);
                //heap.track('Invoice Saved');
                 _dcq.push(["identify", {
                  email: userDataService.user.email,
                  tags: ["Saved New Invoice"]
                }]);
                 dataLayer.push({'event': 'new-invoice-saved'});
            });
          }// saveInvoice

          vm.updateInvoiceDate = function(){
            vm.invoiceService.selectedInvoice.info.due = moment(vm.invoiceService.selectedInvoice.info.date).add(1, 'month').toDate();
            vm.updateInvoice();
          }

          vm.updateInvoice = function(){

            // The timeout is required here to ensure that we are passing the invoice AFTER it's
            // total has been updated.
            // if invoice is a draft, just update model,
            if(_.has(vm.invoiceService.selectedInvoice, 'uid')){
                // if invoice has a uid, update the db
                $timeout(function(){

                    return vm.invoiceService.updateInvoice(vm.invoiceService.selectedInvoice)
                    .then(function(response){
                        // Convert our dates back to local
                        vm.invoiceService.selectedInvoice.info.date = moment(vm.invoiceService.selectedInvoice.info.date).toDate();
                        vm.invoiceService.selectedInvoice.info.due = moment(vm.invoiceService.selectedInvoice.info.due).toDate();
                        // $log.info('invoice updated');
                        vm.invoiceDirty = false;
                        // update our last Invoice in case our edit changed it
                        vm.invoiceService.getLastInvoice(vm.thisClient);
                        //heap.track('Invoice Updated');
                        dataLayer.push({'event': 'invoice-updated'});

                    });
                },0);
            } else {

            }

          }

          vm.showDeleteInvoice = function(invoice){
            vm.deleting = true;
          }
          vm.cancelDeleteInvoice = function(invoice){
            vm.deleting = false;
          }
          vm.deleteInvoice = function(invoice){
            return vm.invoiceService.deleteInvoice(invoice)
            .then(function(){
                vm.deleting = false;
                //heap.track('Invoice Deleted');
                dataLayer.push({'event': 'invoice-deleted'});
            });
          }

        vm.invoiceSubTotal = function(){
            var total = 0;
            _.each(vm.invoiceService.selectedInvoice.lineItems, function(lineItem){
                var updateAmount = 0;
                updateAmount = lineItem.cost * lineItem.quantity;
                total = total + updateAmount;
            });
            _.each(vm.invoiceService.selectedInvoice.time, function(entry){
                var updateAmount = 0;
                updateAmount = entry.rate * (entry.logged/60);
                total = total + updateAmount;
            });

            // This function might run after invoice removed.
            // let's double check before assigning to undefined
            if(_.has(vm.invoiceService, 'selectedInvoice.info')){
                vm.invoiceService.selectedInvoice.info.subTotal = total;
            }

            return total
        }

        vm.taxTotal = function(){
          var total = 0;
          _.each(vm.invoiceService.selectedInvoice.lineItems, function(lineItem){
              var updateAmount = 0;
              updateAmount = lineItem.cost * lineItem.quantity;
              total = total + updateAmount;
          });
          _.each(vm.invoiceService.selectedInvoice.time, function(entry){
              var updateAmount = 0;
              updateAmount = entry.rate * (entry.logged/60);
              total = total + updateAmount;
          });

          if(_.has(vm.invoiceService, 'selectedInvoice.info')){
            if(vm.invoiceService.selectedInvoice.info.calculateTax){
             var taxedAmount = (vm.invoiceService.selectedInvoice.info.taxPercentage/100) * total;
             // This function might run after invoice removed.
             // let's double check before assigning to undefined
             if(_.has(vm.invoiceService, 'selectedInvoice.info')){
                 vm.invoiceService.selectedInvoice.info.taxedAmount = taxedAmount;
             }
             return taxedAmount
          } else {return 0}
        }
    }// vm.taxTotal
        vm.invoiceTotal = function(){
           var total = 0;
           _.each(vm.invoiceService.selectedInvoice.lineItems, function(lineItem){
               var updateAmount = 0;
               updateAmount = lineItem.cost * lineItem.quantity;
               total = total + updateAmount;
           });
           _.each(vm.invoiceService.selectedInvoice.time, function(entry){
               var updateAmount = 0;
               updateAmount = entry.rate * (entry.logged/60);
               total = total + updateAmount;
           });

           // This function might run after invoice removed.
           // let's double check before assigning to undefined
           if(_.has(vm.invoiceService, 'selectedInvoice.info')){
            if(vm.invoiceService.selectedInvoice.info.calculateTax){
             var taxedAmount = (vm.invoiceService.selectedInvoice.info.taxPercentage/100) * total;
             total = total + taxedAmount;
            }
            vm.invoiceService.selectedInvoice.info.total = total;
          }


           return total
        };

        vm.removeInvoiceTimeEntry = function(thisEntry){
            // $log.info(thisEntry.uid);
            // First - determine if this is pending or already saved entry in our timereport data
            _.each(vm.timeReportService.report.data, function(entry){
                if(entry.uid == thisEntry.uid){
                    if(entry.pending){
                        // this entry has been added but not saved. no need to unlock or update invoice

                        // remove our pending flag
                        entry.pending = false;
                        // Find the item in our invoices time list and remove it
                        var updatedTimeArray = _.remove(vm.invoiceService.selectedInvoice.time, function(item) {
                          return item.uid != thisEntry.uid;
                        });
                        vm.invoiceDirty = true;
                        // assign our trimmed array to the invoice
                        vm.invoiceService.selectedInvoice.time = updatedTimeArray;

                    } else {
                        // This entry has already been saved. We need to unlock it and update the invoice

                        var entriesToUnlock = [
                            thisEntry
                        ];

                        vm.invoiceService.unlockTimeEntries(entriesToUnlock);

                        // Find the item in our time list and remove it
                        var updatedTimeArray = _.remove(vm.invoiceService.selectedInvoice.time, function(entry) {
                          return entry.uid != thisEntry.uid;
                        });
 //
                        vm.invoiceService.selectedInvoice.time = updatedTimeArray;
                        ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
                        // Save our changes if we have a invoice UID
                        if(vm.invoiceService.selectedInvoice.uid){
                            vm.updateInvoice();
                        }
                        vm.invoiceDirty = false;
                        // update our last Invoice in case our edit changed it
                        vm.invoiceService.getLastInvoice(vm.thisClient);
                        dataLayer.push({'event': 'invoice-time-entry-removed'});
                    }
                }
            });

        }// removeInvoiceTimeEntry


        vm.editInvoiceTimeEntry = function(entry){
          entry.editing = true;
          vm.editTimeItem = angular.copy(entry);
        }

        vm.cancelEditInvoiceTimeEntry = function(entry){
          entry.editing = false;
          vm.editTimeItem = undefined;
        }

        vm.updateTimeEntry = function(entry){
          // update our main item with vm.editTimeItem values
          var logged = 0;
          if(_.has(vm.editTimeItem, 'hours')){
            logged = logged + (vm.editTimeItem.hours*60);
            entry.hours = vm.editTimeItem.hours;
          }
          if(_.has(vm.editTimeItem, 'minutes')){
            logged = logged + (vm.editTimeItem.minutes);
            entry.minutes = vm.editTimeItem.minutes;
          }

          entry.logged = logged;
          entry.rate = vm.editTimeItem.rate;
          entry.editing = false;
          entry.description = vm.editTimeItem.description;
          vm.editTimeItem = undefined;
          dataLayer.push({'event': 'edit-invoiced-time-entry'});
          vm.updateInvoice();
        }


        vm.editInvoiceLineItem = function(item){
          item.editing = true;
          vm.editLineItem = angular.copy(item);
          // Apparently we have some costs saved as strings.
          // Fix it here
          vm.editLineItem.cost = Number(vm.editLineItem.cost);
        }

        vm.cancelEditInvoiceLineItem = function(item){
          item.editing = false;
          vm.editLineItem = undefined;
        }

        vm.updateLineItem = function(item){
          item.cost = vm.editLineItem.cost;
          item.quantity = vm.editLineItem.quantity;
          item.description = vm.editLineItem.description;
          vm.editLineItem = undefined;
          item.editing = false;
          dataLayer.push({'event': 'updated-invoiced-line-item'});
          vm.updateInvoice();
        }

        vm.removeInvoiceLineItem = function(thisItem){
            _.each(vm.clientBillingService.selectedPeriod.lineItems, function(item){
                if (item.uid == thisItem.uid){

                    if(item.pending){
                        // it's pending which means it hasn't been saved to the invoice yet.
                        // just remove pending and remove from invoice
                        item.pending = false;
                        vm.invoiceDirty = true;
                        // Find the item in our time list and remove it
                        var updatedLineItemArray = _.remove(vm.invoiceService.selectedInvoice.lineItems, function(item) {
                          return item.uid != thisItem.uid;
                        });

                        vm.invoiceService.selectedInvoice.lineItems = updatedLineItemArray;
                    } else {
                        // item has been saved to invoice. Needs removed and invoice updated
                        // put it on an array and send the array to be unlocked
                        var itemsToUnlock = [
                            thisItem
                        ];

                        vm.invoiceService.unlockLineItems(itemsToUnlock);

                        // Find the item in our time list and remove it
                        var updatedLineItemArray = _.remove(vm.invoiceService.selectedInvoice.lineItems, function(item) {
                          return item.uid != thisItem.uid;
                        });

                        vm.invoiceService.selectedInvoice.lineItems = updatedLineItemArray;
                        ajUTILITIES.removePropertiesWith(vm.invoiceService.selectedInvoice);
                        if(vm.invoiceService.selectedInvoice.uid){
                            vm.updateInvoice();
                            vm.invoiceDirty = false;
                            dataLayer.push({'event': 'remove-invoiced-line-item'});
                        }
                    }
                }
            });
        }

        // enable our escape to cancel hotkey
        hotkeys.add({
          combo: 'esc',
          description: 'Clear billing period selection',
          callback: function(event, hotkey) {
            event.preventDefault();
            $log.info('escape pressed');

            vm.cancelPeriod();
          }
        });

        vm.cancelPeriod = function(){
            // Clear the service's current selected period
            delete vm.clientBillingService.selectedPeriod;
        }

        vm.selectInvoice = function(invoiceID){
            // Make sure an unsaved dirty form for one period
            // doesn't enable the "save" button when we select a different period
            dataLayer.push({'event': 'invoice-selected'});
         return vm.invoiceService.selectInvoice(invoiceID);
        }

        vm.makeDirty = function(){
            vm.invoiceDirty = true;
        }


        vm.emailInvoice = function(invoice){
          var emailConsent = false;
          if(userDataService.hasConsent('email')){
              emailConsent = true;
          } else {
              return userDataService.getConsent('email', 'Can we send invoices through our email service?','<p>In order to send invoices to your client, we need permission to securely send your invoice information to a third party.</p>' )
          };
          var pdfConsent = false;
          if(userDataService.hasConsent('invoices')){
              pdfConsent = true;
          } else {
              return userDataService.getConsent('invoices', 'Can we send invoices to our PDF generator?','<p>In order to generate PDFs, we need permission to securely process your invoice information with a third party.</p>' )
          };
          dataLayer.push({'event': 'invoice-emailed'});
           return vm.invoiceService.mailInvoiceDialog(vm.invoiceService.selectedInvoice, vm.user, vm.thisClient);
        }


        vm.preparePDF = function(next, recipientEmail){
          var pdfConsent = false;
          if(userDataService.hasConsent('invoices')){
              pdfConsent = true;
          } else {
              return userDataService.getConsent('invoices', 'Can we send invoices to our PDF generator?','<p>In order to generate PDFs, we need permission to securely process your invoice information with a third party.</p>' )
          };
            vm.invoiceService.preparePDF(vm.invoiceService.selectedInvoice, vm.user, vm.thisClient)
            vm.invoiceService.createPDF(vm.invoiceService.selectedInvoice);
            $mdToast.show($mdToast.adminjaAlert(
                {
                    locals:{
                        title: 'Woot!',
                        message: 'Your report is being prepared. We will notify you when it is ready.' ,
                        color: 'orange'
                    }
                }));// mdToast
        }

        vm.printTime = function(){
            // $log.info('printTime');
            vm.cancelInvoice();
            vm.printReport = {};
            vm.printReport.clientName = clientBillingService.selectedPeriod.info.clientName;
            vm.printReport.clientID = vm.thisClient.uid
            vm.printReport.clientEmail = vm.thisClient.profile.email
            vm.printReport.start = clientBillingService.selectedPeriod.info.start;
            vm.printReport.end = clientBillingService.selectedPeriod.info.end;
            vm.printReport.type = clientBillingService.selectedPeriod.info.type;
            vm.printReport.rate = clientBillingService.selectedPeriod.info.rate;
            vm.printReport.allocated = clientBillingService.selectedPeriod.info.allocated;
            vm.printReport.total = vm.logTotal(vm.timeReportService.report.data);
            vm.printReport.time = vm.timeReportService.report.data;
            vm.printReport.filename = 'time-report-'+ clientBillingService.selectedPeriod.info.clientName + '-' + moment(clientBillingService.selectedPeriod.info.start).format('MM-DD-YY') + '.pdf';
            timeDataService.timeReportDialog(vm.printReport);

        }

        //live totals calculation for each group
        vm.logTotal = function (logs) {
            var total = 0;
            _.each(logs, function (entry) {
                total += entry.logged;
            })
            return total
        };

        vm.removeReportTimeEntry = function(entryToRemove){
            var updatedTimeArray = _.remove(vm.invoiceService.selectedTime, function(entry) {
              return entry.uid != entryToRemove.uid;
            });

            vm.invoiceService.selectedTime = updatedTimeArray;
        }

        vm.startBillingUpgrade = function(){
            // if they have billing periods - find the current one and migrate
            if(_.has(vm.client, 'billing')){
              if(vm.thisClient.billingType != 'packages' && vm.thisClient.profile.plan.type != 'none' && vm.thisClient.billing && vm.thisClient.owner == vm.user.uid){
                 var confirm = $mdDialog.confirm()
                          .title(vm.thisClient.profile.fullName + ' needs an upgrade!')
                          .htmlContent('<p class="md-subhead"><strong>' + vm.thisClient.profile.fullName +'</strong> is running on Adminja\'s legacy billing system.</p><p class="md-subhead"> We <strong>strongly</strong> recommend upgrading them to Adminja\'s new billing &amp; invoicing before June 1, 2021.</p><p class="md-subhead" style="font-size: .85em;"><sup>*</sup> Upgrading takes approximately 2 minutes and does not harm your data in any way.</p>')
                          .ariaLabel('Upgrade Now')
                          .ok('Upgrade Now')
                          .cancel('I\'ll do it later');;

                $mdDialog.show(confirm).then(function() {
                  var now = moment().toISOString(), targetPeriod = undefined;
                  _.each(vm.thisClient.billing, function (billingPeriod){
                      if(billingPeriod.start < now && billingPeriod.end > now){
                          targetPeriod = billingPeriod;
                      }
                  });

                  if(targetPeriod){
                      $mdDialog.cancel();
                      return clientPackageService.newPackage(vm.thisClient, false, targetPeriod)
                  } else {
                      $mdDialog.cancel();
                       var confirm = $mdDialog.confirm()
                                .title('Something went wrong!')
                                .htmlContent('<p class="md-subhead">We had a problem upgrading ' + vm.thisClient.profile.fullName + '\'s billing.</p><p class="md-subhead">Don\'t worry. We can fix this for you.</p><p class="md-subhead"> Please contact <a href="mailto:help@getadminja.com">help@getadminja.com</a> with the name of this workspace.</p>')
                                .ariaLabel('Upgrade Now')
                                .ok('Done');

                      $mdDialog.show(confirm)
                  }

                }, function(){
                  $mdDialog.cancel();
                })
              }
            } else {
              // they don't have any billing periods, we just need to switch them to package billing.
              // nothing to migrate. They'll set things up when they set up their first package.

              var updates = {};
              updates['/clients/' + vm.thisClient.uid + '/billingType'] = 'packages';
              return firebase.database().ref().update(updates)
              .then(function(){
                 var confirm = $mdDialog.confirm()
                          .title('Success!')
                          .htmlContent('<p class="md-subhead">' + vm.thisClient.profile.fullName + 'has been upgraded to the new billing sytem. You can now create billing packages for them to log time.</p>')
                          .ariaLabel('Done')
                          .ok('Got it!');
                $mdDialog.show(confirm)
                .then(function(){
                  $state.go("triangular.workspaces.client-billing", {"clientID": vm.thisClient.uid});
                })
              })
            }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientDetailsController', clientDetailsController);



        /* @ngInject */
        function clientDetailsController($scope, $log,  hotkeys, $rootScope, $state, $timeout, $stateParams, clientDataService, profileDataService, $mdDialog, _userData, _clientData) {
        $log.info('clienDetailsController');
        var vm = this;
        vm.user = _userData;
        vm.settings = $rootScope.userSettings;

        vm.isWorkspaceClient = false
        vm.clients = $scope.$resolve.clientDataService.clients;
        // get the client
        vm.thisClient = _.find(vm.clients, function(client) {
             return client.uid == $stateParams.clientID;
        });


        // determine if this workspace is being made available to a clientUser instead of owner or team member
        if(_.has($scope.client, 'clientUsers['+ vm.user.uid+']')){
          vm.isWorkspaceClient = true;
          // restrict clientUsers from visiting this state if state is disabled in clientUserTabs
          if(!$scope.client.clientUserTabs.details){
            $state.go('triangular.workspaces.overview');
          }
        }


        // store small subset of properties globally so our toolbar has easy info
        if (_.has($scope, 'client.profile')){
            $rootScope.thisClient = $scope.client.profile;
               };

          init();

          function init(){
               if (_.has(vm.thisClient, 'defaultDetailBoard')) {
                    vm.boardID = vm.thisClient.defaultDetailBoard;
                    $log.info('Board: ' + vm.boardID);
               }
               //  else {
               //      $log.info('No Default Board ID.');
               //      return profileDataService.upgradeBoard(vm.thisClient)
               //      .then(function(){
               //           init();
               //      })
               // }
          }// init


    };// end clientDetailsController





})();

(function() {
    'use strict';

    angular
        .module('clientManager')
        .controller('clientBillingController', clientBillingController)


    /* @ngInject */
    function clientBillingController($mdToast, $state, $log, hotkeys, timeDataService, $http, clientPackageService, $stateParams,  $window, $scope, triLoaderService, $timeout, $rootScope, $mdDialog, clientDataService, userDataService, clientBillingService,  invoiceService, currentAuth, _userData, _clientData) {
        var vm = this;

        $scope.workspaceID = $stateParams.clientID;
        vm.clientPackageService = clientPackageService;
        // Package Functions
        vm.newPackage = newPackage;
        vm.getActivePackages = getActivePackages;
        vm.getInactivePackages = getInactivePackages;
        vm.hideInactivePackages = hideInactivePackages;
        vm.archiveClosedPackages = archiveClosedPackages;
        vm.newPackageFromTemplate = newPackageFromTemplate;
        vm.setupState = setupState;
        vm.setInvoiceMode = setInvoiceMode;
        vm.setBillingModuleState = setBillingModuleState;
        vm.numPackages = numPackages;
        vm.showExperience = showExperience;
        vm.packageService = clientPackageService;
        // determines if we are creating/editing or managing invoicing. none = managing.


        init();

      function init(){
        $log.info('clientBillingController');

        if($stateParams.viewState){
          vm.setBillingModuleState($stateParams.viewState);
        }

        vm.clients = $scope.$resolve.clientDataService.clients;
        vm.fbConfig = fbConfig;
        vm.user = _userData;
        vm.userType = $rootScope.admin;
        vm.settings = $rootScope.userSettings;
        vm.currency = vm.settings.currency;
        vm.clientBillingService = clientBillingService;
        vm.invoiceService = invoiceService;
        vm.now = moment().toISOString();
        vm.client = _.find(vm.clients, function (client) {
            return client.uid == $state.params.clientID;
        });


        // determine if user is clientUser for this workspace
        vm.isClientUser = false;
        if(_.has($rootScope, 'VAWorkspaces')){
            if(_.has($rootScope.VAWorkspaces, $state.params.clientID)){
                    vm.isClientUser = true;
                    // restrict clientUsers from visiting this state if state is disabled in clientUserTabs
                    if(!vm.thisClient.clientUserTabs.billing){
                      $state.go('triangular.workspaces.overview');
                    }
            }
        }// determine clientUser

        selectWorkspace(vm.client);
        vm.setupState(vm.clientPackageService.billingModuleState);

        vm.closedCount = 0;
        _.each(vm.client.packages, function(thisPackage){
          if(thisPackage.status == 'closed'){
            vm.closedCount ++
          }
        })
        // vm.getActivePackages(vm.client.uid);
         // var unwatch = $rootScope.$on('packageAdded',function() {
         //     vm.getActivePackages(vm.client.uid)
         //   })

      }//

      function setBillingModuleState(state){
        clientPackageService.changeBillingModuleState(state)
      }


      function showExperience(experienceID){
                userpilot.trigger(experienceID);
            }

      function archiveClosedPackages(clientPackages){
         var closedCount = 0;
         _.each(clientPackages, function(thisPackage){
           if(thisPackage.status == 'closed'){
            closedCount ++
           }
         });

         var confirm = $mdDialog.confirm()
                  .title('Archive & hide '+ closedCount + ' closed packages?')
                  .htmlContent('<p><strong style="color: red;">Please make sure you\'ve invoiced these packages first!</strong></p>')
                  .ariaLabel('Are you sure?')
                  .ok('Do it')
                  .cancel('Never mind');

        $mdDialog.show(confirm).then(function() {
          var archivePromises = [];
          _.each(clientPackages, function(thisPackage){
            if(thisPackage.status == 'closed'){
             archivePromises.push(vm.packageService.archivePackage(thisPackage));
            }
          });
          return Promise.all(archivePromises)
          .then(function(){
            $mdDialog.cancel();
            init();
          })
        }, function(){
            $mdDialog.cancel();
          });

      }// archiveClosedPackages


      function numPackages(packages){
        return _.size(packages);
      }

      function setupState(state){


        if(state == 'invoicing'){
          if(vm.invoiceService.selectedInvoice){
            setInvoiceMode('edit');
          } else {
            setInvoiceMode('manage');

          }

        }

        vm.clientPackageService.changeBillingModuleState(state)
      }// setupState


      function setInvoiceMode(mode){
        invoiceService.changeInvoiceMode(mode);
        // if "none" - we should cleanup any invoice that's in an unsaved state
      }// newInvoice

      function selectWorkspace(workspace){
        return invoiceService.init(vm.client)
        .then(function(){
          invoiceService.selectClient(workspace);
        })
        // if "none" - we should cleanup any invoice that's in an unsaved state
      }// newInvoice




/// Packages Functions /////

      function getActivePackages(clientID){
        $timeout(function(){
          triLoaderService.setLoaderActive(true);
        })
        .then(function(){
            return clientBillingService.getPackages(clientID, 'active')
            .then(function(activePackages){
                $timeout(function(){
                  triLoaderService.setLoaderActive(false);
                  vm.activePackages = activePackages;
                  vm.numActivePackages = _.size(vm.activePackages)
                  // vm.activePackages = Object.assign([], openPackages, closedPackages);
              });
          });
        });
      }// getActivePackages

      function getInactivePackages(clientID){
        $timeout(function(){
          triLoaderService.setLoaderActive(true);
          userDataService.trackEvent('get-archived-packages');
        })
        .then(function(){
          return clientBillingService.getPackages(clientID, 'archived')
          .then(function(packages){
            $timeout(function(){
              vm.inactivePackages = packages;
              triLoaderService.setLoaderActive(false);
            })
          });
        })

      }// getActivePackages

      function hideInactivePackages(){
        vm.inactivePackages = null;
      }//hideInactivePackages

      function newPackage(client){
        userDataService.trackEvent('new-package');
        clientPackageService.newPackage(client)
      }// newPackage

      function newPackageFromTemplate(template, client){
        userDataService.trackEvent('new-package-from-template');
        clientPackageService.newPackageFromTemplate(template, client)
      }

       function openTime(entry){
        if(!vm.isClientUser){
          timeDataService.timeDialog(entry, 'Modify');
        }
      }

      function editCharge(lineItem){
        userDataService.trackEvent('edit-charge');
          clientPackageService.editLineItem(lineItem);
      }// addCharge


        vm.selectInvoice = function(invoiceID){
            // Make sure an unsaved dirty form for one period
            // doesn't enable the "save" button when we select a different period
            userDataService.trackEvent('invoice-selected');
         return vm.invoiceService.selectInvoice(invoiceID);
        }



    }
})();

  (function() {
     'use strict';

     angular
          .module('clientManager')
          .controller('clientArchivedTasksController', clientArchivedTasksController);

     /* @ngInject */
     function clientArchivedTasksController($q, $log, $window, $mdToast, $document, gateService, dragulaService, clientPackageService, taskPanelDataService, userDataService, teamDataService, localStorageService, $sanitize, $scope, $rootScope, $state, $timeout, $stateParams, clientDataService, taskDataService, taskTemplateDataService, pageDimensionsService, hotkeys, $mdDialog, _userData, _clientData) {
          // $log.info('clientArchivedTasksController');
          // $log.info(this);
          var vm = this;
          vm.restoreTask = restoreTask;
          vm.numTasks = 0;
          vm.fbConfig = fbConfig;
          vm.userType = $rootScope.admin;
          vm.search = search;
          vm.resetSearch = resetSearch;
          vm.filterText = '';
          vm.settings = $rootScope.userSettings;
          vm.dateFormat = 'MM/DD/YYYY';

          init();
          $log.info('archivedTasksController');
          function init(){

               var region = 'us';
               if (_.has(vm.settings, 'dateFormat')){
                   region = vm.settings.dateFormat;
               }

               if(region == 'eu'){
                    vm.dateFormat = 'DD/MM/YYYY'
               }


               vm.clients = $scope.$resolve.clientDataService.clients;
               // get the client
               vm.thisClient = _.find(vm.clients, function(client) {
                    return client.uid == $stateParams.clientID;
               });

               // Only Admins/Owners can view archived tasks
               if(vm.thisClient.access.admins[$rootScope.userID]){
                    // Fetch archived tasks for this client.
                    return fetchArchivedTasks(vm.thisClient.uid)
                    .then(function(archivedTasks){
                         $timeout(function(){
                              vm.archivedTasks = archivedTasks;
                              vm.setupComplete = true;
                              vm.numTasks = _.size(vm.archivedTasks);
                         }, 1000)
                    })
                    .catch(function(error){
                         $timeout(function(){
                              vm.setupComplete = true;
                              vm.errorMessage = "Could not query archived tasks for this workspace.<br>Please Contact Support"
                         })
                    })
               } else {
                    $state.go('triangular.workspaces.overview')
               }

          }// init


          function restoreTask(task){
               var taskID = undefined;

               if(_.has(task, 'uid')){
                    taskID = task.uid;
               } else {
                    taskID = task.refID;
               }
               $log.info('restore task ' + taskID);

               var updates = {};
               var userID = $rootScope.userID;
               if(_.has(task, 'assignee')){
                   userID = task.assignee;
               }

               task.archived = false;
               task.uid = taskID;
               task.board = vm.thisClient.defaultTaskBoard;
               task.list = vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].defaultList;
               task.status = 'open';

               // update canonical
               updates['/tasks/' + taskID + '/info'] = task;
               // add to client
               updates['/clients/' + task.client + '/tasks/' + taskID] = task;
               // add to defaultList on taskBoard
               updates['/taskBoards/' + vm.thisClient.defaultTaskBoard + '/lists/' + vm.thisClient.taskBoards[vm.thisClient.defaultTaskBoard].defaultList + '/items/' + taskID] = task;

                $log.info(updates);
                return firebase.database().ref().update(updates)
               .then(function(){
                    $mdToast.show($mdToast.adminjaAlert(
                        {
                            locals:{
                                title: 'Task Restored',
                                message: 'You will find it in the "New Tasks" list.',
                                color: '#128B04'
                            }
                        }));
               }, function(error){
                 $log.info(error);
               });
          }//restoreTask

          function fetchArchivedTasks(clientID){
               return new Promise(function(resolve, reject){
                    var tasksRef = firebase.database().ref('tasks').orderByChild('info/clientCompleted').startAt(clientID + '-' + moment().subtract(365, 'days').toISOString()).endAt(clientID + '-' + moment().toISOString());
                    // var tasksRef = firebase.database().ref('tasks').orderByChild('info/client').equalTo(clientID);
                    tasksRef.once('value', function(data){

                        var archivedTasks = data.val(), array = [];
                        _.each(archivedTasks, function(task){
                            if(_.has(task.info, 'board')){
                              if(task.info.archived){
                                  task.info.created = task.created;
                                  array.push(task.info);
                              }
                            } else if(task.info.status == 'closed'){
                              array.push(task.info)
                            }

                        });
                         return resolve(array);
                    })
                    .catch(function(error){
                         return reject(error);
                    })
               })
          }//fetchArchivedTasks

          function search(query){
               vm.taskFilter = query.toLowerCase();
          }

          function resetSearch(){
               vm.taskFilter = "";
               vm.filterText = "";
          }


          function throwError(error){
               $log.error(error);
          }//throwError


     }; //clientArchivedTasksController

  })();

(function() {
    'use strict';

    angular
        .module('customForms', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('customForms')
        .controller('customFormsController', customFormsController);

    /* @ngInject */
    function customFormsController($log, $rootScope, gateService, $mdDialog, $location, triLoaderService,  $timeout,  leadDataService, userDataService, $scope, $firebaseArray,  _userData) {
        // $log.info('customFormsController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;
       vm.userDataService = userDataService;
       vm.userType = $rootScope.admin;
       vm.user = _userData;
       vm.fbConfig = fbConfig;
       vm.hostingURL = $location.protocol() + '://' + $location.host() + ':' + $location.port();
       vm.settings = vm.user.profile.settings;
       vm.gates = gateService.gateData;

       vm.showLeadGroups = false; // this will get changed to true if a leadBoard is found for the user
       if(vm.user.uid){
           checkForLeadsBoard();
       } else {
           // alert('There was a problem retrieving your user information. Please re-login and try again. If this problem persists, please contact us at help@getadminja.com');
           $state.go('authentication.login')
       }

       vm.createLeadForm = function(){
           return leadDataService.createLeadForm();
       }

       vm.openLeadForm = function(form){
           return leadDataService.openLeadForm(form);
       }

       vm.deleteForm = function(form){
           var confirm = $mdDialog.confirm()
                   .title('Delete this lead form?')
                   .htmlContent('If this form has been deployed on your website, it will still remain active, <br>but your custom field names will not be formatted correctly going forward.')
                   .ariaLabel('Delete lead form? Y//N')
                   .ok('Yes, Delete')
                   .cancel('Cancel');

           $mdDialog.show(confirm).then(function () {
               return leadDataService.deleteLeadForm(form)
               .then(function(){

                   cancelDialog();
               });
             });
       }// deleteForm

       function checkForLeadsBoard(){
           // $log.info('checking for leadBoard for ' + vm.user.uid);
           var boardRef = firebase.database().ref('leadBoards');
           return boardRef.child(vm.user.uid).on('value',
               function(snapshot){
                   var exists = (snapshot.val() !== null);
                   if(exists){
                       $timeout(function(){
                           vm.showLeadGroups = true;
                           vm.leadBoard = snapshot.val();
                       },0)
                   } else {
                       $log.info('no leadBoard found.');
                       vm.showLeadGroups = false;
                   }
               });
       }// vm.checkForLeadBoard

    }
})();

(function() {
    'use strict';

    angular
        .module('customForms')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, $urlRouterProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-custom-forms');

        $stateProvider
            .state('triangular.custom-forms', {
                url: '/custom-forms',
                templateUrl: 'app/admin-custom-forms/custom-forms.tmpl.html',
                // set the controller to load for this page
                controller: 'customFormsController',
                controllerAs: 'vm'

            });



    }
})();

(function() {
	'use strict';

	angular
		.module('billing', ['appServices', 'ngAnimate']);
})();

(function() {
		'use strict';

		angular
				.module('billing')
				.controller('billingController', billingController)
				.filter('dateFormatFilter', function(){
					return function(entity, format){
						// console.log(format);
						var out = moment(entity).format(format);
						return out
					}
				});;

		/* @ngInject*/
		function billingController($log, $scope, $mdDialog, triLoaderService, $timeout,uiGridConstants, clientBillingService, invoiceService, userDataService,  $rootScope, clientDataService, $mdToast, _userData, _clientData) {
				$log.info('billingController');
				var vm = this;
				vm.clients = _clientData;
				vm.user = _userData;


				// vm.clients = $scope.$resolve.clientDataService.clients;
				// vm.userType = $rootScope.admin;


				// // Main Timeout Loop - making sure everything is on vm.
				// $timeout(function(){
				// 	vm.getInvoiceHTML = getInvoiceHTML;
				// 	vm.getInvoices = getInvoices;
				// 	vm.rowGetInvoiceHTML = rowGetInvoiceHTML;
				// 	vm.newPayment = newPayment;
				// 	vm.fbConfig = fbConfig;
				// 	vm.settings = $rootScope.userSettings;
				// 	vm.showInvoiceGrid = false;
				// 	vm.currency = "$";
				// 	if (_.has(vm.settings, 'currency')){
				// 			 vm.currency = vm.settings.currency;
				// 	 }
				// 	 vm.allStart = vm.user.uid + moment().subtract(10, 'years').format('YYYY-MM-DD');
				// 	vm.start = vm.user.uid + moment().startOf('year').format('YYYY-MM-DD');
				// 	vm.end = vm.user.uid + moment().endOf('year').format('YYYY-MM-DD');
				// 	vm.now = moment().toISOString();
				// 	vm.thisYear = moment().format('YYYY');
				// 	vm.invoiceCardLimit = 100;

				// 	// Prep our year list for invoice pulling
				// 	vm.yearList = [];
				// 	var startYear = Number(moment(vm.user.profile.startDate).format('YYYY')), endYear = Number(moment().format('YYYY'));
				// 	for (var i = startYear; i <= endYear; i++) {
				// 			var object = {
				// 				label: i,
				// 				year: Number(i),
				// 				start: vm.user.uid + moment(i+'-01-01').startOf('year').toISOString(),
				// 				end: vm.user.uid + moment(i+'-01-01').endOf('year').toISOString()
				// 			}
				// 	    vm.yearList.push(object);
				// 	}

				// 	vm.yearList.push({
				// 		label: 'All Time',
				// 		year: 'all',
				// 		start: vm.allStart,
				// 		end: vm.end
				// 	});

				// 	// Set our initial viewYear to this year
				// 	_.each(vm.yearList, function(year){
				// 		if(year.year == moment().format('YYYY')){
				// 			vm.viewYear = year;
				// 		}
				// 	});


				// 	// Configure our Grid
				// 	var dateCellTemplate = undefined;
				// 	if(vm.settings.dateFormat == 'us'){
				// 	 dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
				// 											' {{COL_FIELD | dateFormatFilter:\'MM/DD/YYYY\'}}' +
				// 											'</div>';
				// 	}
				// 	if(vm.settings.dateFormat == 'eu'){
				// 	 dateCellTemplate = '<div class="ngCellText ui-grid-cell-contents"  ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD | date: \'h:mm a\'}}">' +
				// 											' {{COL_FIELD | dateFormatFilter:\'DD/MM/YYYY\'}}' +
				// 											'</div>';
				// 	}

				// 	var currencyCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
				// 					 vm.settings.currency+'{{COL_FIELD | number: 2}}' +
				// 					 '</div>';

				// 	var paymentCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
				// 					 vm.settings.currency+'{{COL_FIELD | number: 2}}' +
				// 					 '<md-icon data-gtm-billing-click-enter-payment ng-click="grid.appScope.vm.newPayment(row.entity)" class="billing-invoice-icon" md-font-icon="zmdi zmdi-plus-circle" style="margin-left: 1em;"><md-tooltip md-delay="500">Add a Payment</md-tooltip></md-icon>' +
				// 					 '</div>';

				// 	var creditCellTemplate = '<div  class="text-right ngCellText ui-grid-cell-contents" title="{{COL_FIELD}}">' +
				// 					 '<span ng-if="row.entity.credit > 0" style="color: green;">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
				// 					 '</div>';
				// 	var debitCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" title="{{COL_FIELD}}">' +
				// 					 '<span ng-if="row.entity.debit > 0">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
				// 					 '</div>';
				// 	var lineItemCostCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
				// 					 '<span ng-if="row.entity.type != \'Payment\'">' + vm.settings.currency+'{{COL_FIELD | number: 2}}</span>' +
				// 					 '<span ng-if="row.entity.type == \'Payment\'">N/A</span>' +
				// 					 '</div>';

				// 	var uidCellTemplate = '<div class="ngCellText ui-grid-cell-contents center" title="View Invoice">' +
				// 					 '<md-icon data-gtm-billing-report-view-invoice ng-click="grid.appScope.vm.rowGetInvoiceHTML(row.entity.uid)" class="billing-invoice-icon" md-font-icon="fa fa-file-o"><md-tooltip md-delay="500">View Invoice</md-tooltip></md-icon>' +
				// 					 '</div>';
				// 	var footerCurrencyCellTemplate = '<div class="text-right ngCellText ui-grid-cell-contents" ng-class="{\'group-header\': row.groupHeader}" title="{{COL_FIELD}}">' +
				// 					 '<strong>' + vm.settings.currency+'{{col.getAggregationValue() | number : 2}}</strong>' +
				// 					 '</div>';

				// 	var paymentInfoTemplate = '<div layout="row" layout-align="center start" style="background-color: #FFF;">'+
				// 															'<div class="billing-payment-details" layout="column" layout-align="start layout-fill">'+
				// 																	'<p  class="md-subhead margin-top-0 padding-top-10 padding-bottom-10 center">Payments Applied</p>'+
				// 																	'<div class="billing-payment-list-item" layout="row" layout-align="start center" ng-repeat="payment in row.entity.PaymentData |toArray: false track by $index">' +
				// 																				'<div flex="10">{{payment.date | dateFormatFilter:\'MM/DD/YYYY\'}}</div>'+
				// 																				'<div flex="70" style="padding-left: 4em;">{{payment.notes}}</div>'+
				// 																				'<div flex="10" style="text-align: right;">{{row.entity.currency}}{{payment.amount| number: 2}}</div> '+
				// 																	'</div>'+
				// 																	'<div layout="row" layout-align="start center"><div flex="80"><p class="right"><strong>Total received:&nbsp;&nbsp;</strong></p></div><div flex="10"><p class="right"><strong>{{row.entity.currency}}{{row.entity.Payments}}</strong></p></div>'+
				// 															'</div>'+
				// 														'</div>'

				// 	// Different version of payment template for EU date format
				// 	if(vm.settings.dateFormat == 'eu'){
				// 		paymentInfoTemplate = '<div class="billing-payment-details"   layout="column" layout-align="start layout-fill"> <p palette-background="green:100" class="md-subhead margin-top-0 padding-top-10 padding-bottom-10 center">Payments received:</p>'+
				// 																'<div class="billing-payment-list-item" layout="row" layout-align="start center" ng-repeat="payment in row.entity.PaymentData |toArray: false track by $index">' +
				// 																		'<div flex="10">{{payment.date | dateFormatFilter:\'DD/MM/YYYY\'}}</div>'+
				// 																		'<div flex="60" class="padding-left-20">{{payment.notes}}</div>'+
				// 																		'<div flex="10">{{vm.settings.currency}}{{payment.amount| number: 2}}</div> '+
				// 														'</div></div>'
				// 	}


				// 	var invoiceDetailsTemplate = '<div class="invoice-details-container"><p class="md-subhead center">Invoice #{{row.entity.Number}}</p><div class="invoice-subgrid" ui-grid="row.entity.subGridOptions" ui-grid-auto-resize></div></div>';
				// 	var emptyCellTemplate = '<div></div>';
				// 	var qtyCellTemplate = '<div class="right">{{COL_FIELD}}</div>';


				// 	vm.invoiceGridOptions = {
				// 								rowHeight:30,
				// 								enableFiltering: true,
				// 								enableGridMenu: true,
				// 								groupingShowCounts: true,
				// 								exporterMenuPdf: false,
				// 								excessRows: 20,
				// 								virtualizationThreshold: 100,
				// 								exporterMenuExcel: false,
				// 								exporterCsvFilename: 'invoice-report.csv',
				// 								exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
				// 								exporterSuppressColumns: [ 'PaymentData', ' '],
				// 								enableRowSelection: false,
				// 								showColumnFooter: true,
				// 								gridMenuShowHideColumns: false,
				// 								columnDefs: [
				// 									{ field: 'Number',
				// 										enableSorting: true,
				// 										type: 'number',
				// 										width: 100},
				// 									{ field: 'Issued',
				// 										enableSorting: true,
				// 										cellTemplate: dateCellTemplate,
				// 										width: 150,
				// 										sort: {
				// 												direction: uiGridConstants.DESC
				// 										},
				// 									},
				// 									{ field: 'Due',
				// 										enableSorting: true,
				// 										cellTemplate: dateCellTemplate,
				// 										width: 150
				// 									},
				// 									{ field: 'Client',
				// 										enableSorting: true},
				// 									{ field: 'Total',
				// 										enableSorting: true,
				// 										type: 'number',
				// 										cellTemplate: currencyCellTemplate,
				// 										width: 150,
				// 										aggregationHideLabel: true,
				// 										aggregationType: uiGridConstants.aggregationTypes.sum,
				// 										footerCellTemplate: footerCurrencyCellTemplate},
				// 									{ field: 'Payments',
				// 										enableSorting: true,
				// 										type: 'number',
				// 										cellTemplate: paymentCellTemplate,
				// 										width: 150,
				// 										aggregationHideLabel: true,
				// 										aggregationType: uiGridConstants.aggregationTypes.sum,
				// 										footerCellTemplate: footerCurrencyCellTemplate},
				// 									{ field: 'Balance',
				// 										enableSorting: true,
				// 										type: 'number',
				// 										cellTemplate: currencyCellTemplate,
				// 										width: 150,
				// 										aggregationHideLabel: true,
				// 										aggregationType: uiGridConstants.aggregationTypes.sum,
				// 										footerCellTemplate: footerCurrencyCellTemplate},
				// 									{ field: ' ',
				// 										enableSorting: false,
				// 										enableFiltering: false,
				// 										enableColumnMenu :false,
				// 										cellTemplate: uidCellTemplate,
				// 										width: 75}
				// 								],
				// 								 expandableRowTemplate: invoiceDetailsTemplate,
				// 								 //This will be the height of the subgrid
				// 								 expandableRowHeight: 230,
				// 								 //Variables of object expandableScope will be available in the scope of the expanded subgrid
				// 								 expandableRowScope: {
				// 										subGridVariable: 'subGridScopeVariable'
				// 									},
				// 								onRegisterApi: function( gridApi ) {
				// 									vm.invoiceGridAPI = gridApi;
				// 									 vm.invoiceGridAPI.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
				// 									 		resizeGrid();
				// 											 // if(oldHeight != newHeight) {
				// 												// 	// alert('add code to resize height!')
				// 												// 	 vm.invoiceGridAPI.core.queueGridRefresh();
				// 											 // }
				// 									});

				// 									 vm.invoiceGridAPI.expandable.on.rowExpandedStateChanged($scope,function(row){
				// 										if (row.isExpanded) {
				// 											 row.entity.subGridOptions = {
				// 											 		 minRowsToShow: 3,
				// 											 		 data: row.entity.lineItems,
				// 											 		 showColumnFooter: true,
				// 											     columnDefs: [
				// 											         { name: 'Date',
				// 											           field:'date',
				// 											           width: 150,
				// 											           cellTemplate: dateCellTemplate,
				// 											           sort: {direction: uiGridConstants.DESC} },

				// 											         { name: 'Type',
				// 											           field: 'type',
				// 											           width: 150 },

				// 											         { name: 'Description',
				// 											           field: 'description' },

				// 											         { name: 'Quantity',
				// 											           field: 'quantity',
				// 											           width: 150 },

				// 											         { name: 'Unit Cost',
				// 											           field: 'cost',
				// 											           width: 150,
				// 											           cellTemplate: lineItemCostCellTemplate},

				// 											         { name: 'Debit',
				// 											           field: 'debit',
				// 											           width: 150,
				// 											           cellTemplate: debitCellTemplate,
				// 											           aggregationHideLabel: true,
				// 											           aggregationType: uiGridConstants.aggregationTypes.sum,
				// 											           footerCellTemplate: footerCurrencyCellTemplate
				// 											           },

				// 											         { name: 'Credit',
				// 											           field: 'credit',
				// 											           width: 150,
				// 											           cellTemplate: creditCellTemplate,
				// 												         aggregationHideLabel: true,
				// 												         aggregationType: uiGridConstants.aggregationTypes.sum,
				// 												         footerCellTemplate: footerCurrencyCellTemplate
				// 												       }
				// 											     ]
				// 											 };
				// 										}// if row expanded
				// 									 });

				// 								}
				// 							};

				// 	// setup a watcher to refresh the grid if payments are applied
				// 	var unwatch = $rootScope.$on('paymentApplied',function() {
				// 			triLoaderService.setLoaderActive(true);

				// 		$timeout(function(){
				// 			return getInvoices(vm.viewYear.start, vm.viewYear.end)
				// 		}, 5000)
				// 		.then(function(){
				// 			triLoaderService.setLoaderActive(false);
				// 		});


				// 	});

				// 		// load our initial gridData
				// 		return getInvoices(vm.viewYear.start, vm.viewYear.end);
				// },0)



				// function newPayment(invoiceRow){
				// 	// find the actual invoice from vm.invoices
				// 	var thisInvoice = _.find(vm.invoices, function(invoice){
				// 		return invoice.uid == invoiceRow.uid;
				// 	} )

				// 	return invoiceService.newPayment(thisInvoice);
				// }// newPayment


				// function getInvoices(start, end){
				// 	vm.showInvoiceGrid = false;
				// 	// $log.info('getInvoices for year ' + start);
				// 	return clientBillingService.getInvoices(start, end)
				// 	.then(function(results){
				// 			vm.invoices = results;
				// 			vm.invoiceGridData = [];
				// 			// get our total and past due balances
				// 			vm.outstanding = 0;
				// 			vm.pastDue = 0;
				// 			vm.monthLabel = moment().startOf('month').format('MMMM YYYY');
				// 			vm.invoiced = 0;
				// 			vm.received=0;
				// 			var monthStart = moment().startOf('month').startOf('day').toISOString(),
				// 					monthEnd = moment().endOf('month').endOf('day').toISOString();

				// 			// Count and decorate with client names and payment totals
				// 			_.each(vm.invoices, function(invoice, index){
				// 					// $log.info('Processing invoice #' + invoice.info.number);
				// 					vm.outstanding = Number(vm.outstanding) + Number(invoice.info.balance);
				// 					vm.dueDate = moment(invoice.info.due).toISOString();
				// 					vm.issueDate = moment(invoice.info.date).toISOString();

				// 					// if past Due, increment that counter
				// 					if(vm.now >= vm.dueDate){
				// 						vm.pastDue = Number(vm.pastDue) + Number(invoice.info.balance);
				// 					}

				// 						vm.invoiced = Number(vm.invoiced) + Number(invoice.info.total);

				// 					invoice.paymentsReceived = 0;
				// 					// add up payments
				// 					if(_.has(invoice.info, 'payments')){
				// 						_.each(invoice.info.payments, function(payment){
				// 							invoice.paymentsReceived = Number(invoice.paymentsReceived) + Number(payment.amount);
				// 							vm.received = Number(vm.received) + Number(payment.amount);

				// 						})// each payment

				// 					}

				// 					// put time entries and line items onto invoice (joined)
				// 					var lineItems = [];

				// 					if(_.has(invoice, 'lineItems')){
				// 						_.each(invoice.lineItems, function(item){
				// 							var total = Number(item.quantity * item.cost).toFixed(2);
				// 							var newLineItem = {
				// 								cost: Number(item.cost),
				// 								quantity: Number(item.quantity),
				// 								type: 'Charge',
				// 								description: item.description,
				// 								date: item.date,
				// 								uid: item.uid,
				// 								debit: Number(total).toFixed(2),
				// 								credit: 0
				// 							}
				// 							lineItems.push(newLineItem);
				// 						});
				// 					}

				// 					if(_.has(invoice, 'time')){
				// 						_.each(invoice.time, function(entry){
				// 							var logged = Number(entry.logged/60).toFixed(2),
				// 									total = Number(logged * entry.rate).toFixed(2);

				// 							var entryAsLineItem = {
				// 								cost: Number(entry.rate),
				// 								quantity: Number(logged).toFixed(2),
				// 								type: 'Time',
				// 								description: entry.description,
				// 								date: entry.logDate,
				// 								uid: entry.uid,
				// 								debit: Number(total).toFixed(2),
				// 								credit: 0
				// 							}
				// 							lineItems.push(entryAsLineItem);
				// 						});
				// 					}
				// 					if(_.has(invoice.info, 'payments')){
				// 						_.each(invoice.info.payments, function(payment){

				// 							var paymentAsLineItem = {
				// 								uid: payment.uid,
				// 								date: payment.date,
				// 								description: payment.notes,
				// 								type: 'Payment',
				// 								quantity: 1,
				// 								cost: 'N/A',
				// 								credit: payment.amount,
				// 								debit: 0
				// 							}
				// 							lineItems.push(paymentAsLineItem)
				// 						})
				// 					}

				// 					if(_.has(invoice.info, 'calculateTax')){
				// 						if(invoice.info.calculateTax){
				// 							var taxAsLineItem = {
				// 								uid: 'tax' + invoice.uid,
				// 								date: invoice.info.date,
				// 								description:  invoice.info.taxLabel,
				// 								type: 'Charge',
				// 								quantity: invoice.info.taxPercentage + '% ',
				// 								cost: invoice.info.subTotal,
				// 								debit: Number(invoice.info.taxedAmount)
				// 							}
				// 							lineItems.push(taxAsLineItem);
				// 						}
				// 					}


				// 					// Push into vm.invoiceGridData
				// 					var row = {
				// 						Number: invoice.info.number,
				// 						Issued: invoice.info.date,
				// 						Due: invoice.info.due,
				// 						Client: invoice.info.recipient.name,
				// 						Total: Number(invoice.info.total).toFixed(2),
				// 						Payments: Number(invoice.paymentsReceived).toFixed(2),
				// 						Balance: Number(invoice.info.balance).toFixed(2),
				// 						uid: invoice.uid,
				// 						// PaymentData: invoice.info.payments,
				// 						currency: vm.settings.currency,
				// 						lineItems: lineItems
				// 					}
				// 					vm.invoiceGridData.push(row);
				// 			});// each invoice

				// 	})
				// 	.then(function(){
				// 		$timeout(function(){
				// 			vm.invoiceGridOptions.data = vm.invoiceGridData;
				// 			vm.showInvoiceGrid = true;
				// 		},0)
				// 		// Adjust height of our grid
				// 		$timeout(function(){
				// 			resizeGrid();
				// 		},0);// timeoutFunction to make sure vm is working properly
				// 	});// return invoices chain

				// }//getInvoices

				// 	function resizeGrid(){
				// 			var grid = $('.invoice-grid'),
				// 					pageHeight = $('md-content.triangular-content').height(),
				// 					toolbarHeight = $('.triangular-toolbar').height(),
				// 					billingStatsHeight = $('.billing-stats').height(),
				// 					recentInvoicesHeight = $('.billing-invoices-container').height(),
				// 					gridHeight = pageHeight - toolbarHeight - billingStatsHeight - recentInvoicesHeight - 100;

				// 					$(grid).css('height', gridHeight);
				// 	}

				// function invoiceViewController($scope, $rootScope, invoiceService){
				// 	// $log.info('invoiceViewController');
				// 	var vm = this;
				// 	vm.userType = $rootScope.admin;
				// 	// hide the remittance slip
				// 	$timeout(function(){
				// 		$('.remittance').hide();
				// 	});

				// 	vm.logPayment = function(){
				// 		return invoiceService.newPayment(vm.invoice);

				// 	}

				// 	vm.close = function(){
				// 		$mdDialog.cancel();
				// 	}

				// 	vm.writeOffInvoice = function(invoiceID){
				// 		// $log.info('writeoff invoice and close:');
				// 	}

				// 	vm.downloadPDF = function(){
				// 		var pdfConsent = false;
				// 		if(userDataService.hasConsent('invoices')){
				// 				pdfConsent = true;
				// 		} else {
				// 				return userDataService.getConsent('invoices', 'Can we send invoices to our PDF generator?','<p>In order to generate PDFs, we need permission to securely process your invoice information with a third party.</p>' )
				// 		};
				// 			invoiceService.selectedInvoice = vm.invoice;
				// 			invoiceService.preparePDF(invoiceService.selectedInvoice, vm.user, vm.client)
				// 			invoiceService.createPDF(invoiceService.selectedInvoice);
				// 			$mdToast.show($mdToast.adminjaAlert(
				// 					{
				// 							locals:{
				// 									title: 'Woot!',
				// 									message: 'Your PDF is being prepared. We will notify you here when it is ready.' ,
				// 									color: 'orange'
				// 							}
				// 					}));// mdToast
				// 	}

				// }// invoiceView Controller

				// function rowGetInvoiceHTML(invoiceID){
				// 	// this function is called from within ui-grid click events
				// 	// ui-grid's data doesn't include the full invoice
				// 	// it acts as a bridge between ui-grid and getInvoiceHTML (below)
				// 	// by looking up the invoice by UID and then passing it on to getInvoiceHTML
				// 	var invoice = _.find(vm.invoices, function (invoice) {
				// 						 return invoice.uid == invoiceID;
				// 				 });
				// 	getInvoiceHTML(invoice);
				// }

				// function getInvoiceHTML(invoice){
				// 	$log.info('getInvoiceHTML');
				// 	triLoaderService.setLoaderActive(true);
				// 	var invoiceCopy = angular.fromJson(angular.toJson(invoice));
				// 	invoiceCopy.time = _.sortBy(invoiceCopy.time, ['logDate']);
				// 	invoiceCopy.lineItems = _.sortBy(invoiceCopy.lineItems, ['date']);

				// 	// Add proper date to time and lineItems
				// 	_.each(invoiceCopy.time, function(time){

				// 		time.displayDate = moment(time.logDate).format('MMM D');

				// 	});
				// 	_.each(invoiceCopy.lineItems, function(item){

				// 		item.displayDate = moment(item.date).format('MMM D');

				// 	});
				// 	invoiceCopy.logo = vm.user.profile.logo;
				// 	invoiceCopy.currency = vm.settings.currency;

				// 	// Get Client


				// 	vm.thisClient = _.find(vm.clients, function (client) {
				// 						 return client.uid == invoice.info.client;
				// 				 });


				// 	return invoiceService.getInvoiceHTML(invoiceCopy)
				// 	.then(function(renderedInvoice){
				// 		$timeout(function(){
				// 			triLoaderService.setLoaderActive(false);
				// 		})
				// 		.then(function(){
				// 			$mdDialog.show({
				// 							template:
				// 								'<md-dialog flex="100" class="invoice-viewer" aria-label="Invoice Viewer">' +
				// 								'  <md-dialog-content><div class="print-document-container" print-section>'+
				// 										renderedInvoice +
				// 								' </div> </md-dialog-content>' +
				// 								'  <md-dialog-actions>' +
				// 								'    <md-button data-gtm-billing-click-enter-payment ng-if="vm.userType == \'admin\'" ng-click="vm.logPayment()" class="md-primary">' +
				// 								'      Enter Payment' +
				// 								'    </md-button>' +
				// 								'    <md-button data-gtm-billing-request-pdf ng-click="vm.downloadPDF()" class="md-primary">' +
				// 								'      Request PDF' +
				// 								'    </md-button>' +
				// 								'    <md-button data-gtm-billing-print-invoice print-btn class="md-primary">' +
				// 								'      Print' +
				// 								'    </md-button>' +
				// 								'    <md-button ng-click="vm.close()" class="md-primary">' +
				// 								'      Done' +
				// 								'    </md-button>' +
				// 								'  </md-dialog-actions>' +
				// 								'</md-dialog>',
				// 							locals: {
				// 								invoice: invoice,
				// 								user: vm.user,
				// 								client: vm.thisClient
				// 							},
				// 							escapeToClose: true,
				// 							clickOutsideToClose: true,
				// 							controller: invoiceViewController,
				// 							bindToController: true,
				// 							controllerAs: 'vm'
				// 					 });
				// 		})
				// 	})// return invoiceService.getInvoiceHTML
				// }

		} // billingController
})();

(function() {
    'use strict';

    angular
        .module('billing')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider) {
        $translatePartialLoaderProvider.addPart('app/admin-billing');

        $stateProvider
        .state('triangular.billing', {
            abstract: false,
            url: '/billing',
            templateUrl: 'app/admin-billing/billing.tmpl.html',
            // set the controller to load for this page
            controller: 'billingController',
            controllerAs: 'vm'
        });


        triMenuProvider.addMenu({
            name: 'Billing',
            icon: 'fa fa-credit-card',
            type: 'link',
            state: 'triangular.billing',
            priority: 10.0
            // badge: Math.round(Math.random() * (100 - 1) + 1)
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('adminAwards', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('adminAwards')
        .controller('awardsPageController', awardsPageController);

    /* @ngInject */
    function awardsPageController($log, $rootScope) {
        // $log.info('awardClaimController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;
        // vm.user = _userData;



    }
})();

(function() {
    'use strict';

    angular
        .module('adminAwards')
        .config(moduleConfig)
        .run(awardsRun);

        /* @ngInject */
        function awardsRun($rootScope){
            var topRange = 5,
                bottomRange = 1;

            // Pick a random number and use it to set our rotating background class on auth pages
            var random = Math.floor(Math.random() * ((topRange-bottomRange)+1) + bottomRange);
            // $rootScope.authBackground = "mb-bg-12"
            $rootScope.authBackground = "mb-bg-" + random;
            // console.log(random);
        }

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, $rootScopeProvider, triLayoutProvider) {


        $translatePartialLoaderProvider.addPart('app/admin-awards');

          $stateProvider
              .state('awards', {
                  abstract: true,
                  views:{
                    'root':{
                        templateUrl: 'app/admin-awards/awards.tmpl.html'
                    }
                  }
              })

              .state('awards.claim', {
                  url: '/awards/claim/:campaign/:award',
                  templateUrl: 'app/admin-awards/awards-claim.tmpl.html',
                  controller: 'awardsClaimController',
                  controllerAs: 'vm',
                  resolve: {
                      'currentAuth': ['authFactory', function (authFactory) {
                              return authFactory.$requireSignIn()
                          }],
                      // resolve our _userData and pass it to the Controller for saving
                      '_userData': ['userDataService', function (userDataService) {
                              return userDataService.getLoggedInUser()
                                      .then(function (data) {
                                          return data
                                      })
                          }]
                        }
              })
              .state('awards.confirm', {
                  url: '/awards/confirm/:campaign/:award',
                  templateUrl: 'app/admin-awards/awards-confirm.tmpl.html',
                  controller: 'awardsConfirmController',
                  controllerAs: 'vm',
                  resolve: {
                      'currentAuth': ['authFactory', function (authFactory) {
                              return authFactory.$requireSignIn()
                          }],
                      // resolve our _userData and pass it to the Controller for saving
                      '_userData': ['userDataService', function (userDataService) {
                              return userDataService.getLoggedInUser()
                                      .then(function (data) {
                                          return data
                                      })
                          }]
                        }
              });

    }
})();

(function() {
    'use strict';

    angular
        .module('adminAwards')
        .controller('awardsConfirmController', awardsConfirmController);

    /* @ngInject */
    function awardsConfirmController($log, $rootScope) {
        // $log.info('awardsConfirmController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;



    }
})();

(function() {
    'use strict';

    angular
        .module('adminAwards')
        .controller('awardsClaimController', awardsClaimController);

    /* @ngInject */
    function awardsClaimController($log, $timeout, $rootScope, $stateParams, $scope, _userData) {
        // $log.info('awardsClaimController');
        // turn the loader on
        // teamDataService.init();
        // triLoaderService.setLoaderActive(true);
        var vm = this;
        vm.campaign = $stateParams.campaign;
        vm.award = $stateParams.award;
        vm.user = _userData;
        vm.userID = vm.user.uid;
        vm.workSpaceKey = 'ecapskrow';
        vm.teamMemberKey = "teammember";

        // Set our labels
        switch(vm.award) {
            // WORKSPACE
            case vm.workSpaceKey:
                vm.awardLabel = 'Workspace'
                break;
            // TEAM MEMBER
            case vm.teamMemberKey:
               vm.awardLabel = 'Team Member'
                break;
            default:
                vm.awardLabel = 'error'
        } // switch

        // if it wasn't in our list of approved rewards.
        if(vm.awardLabel == 'error'){
            vm.showAwardError = true;
        }

        if(vm.campaign && vm.award && checkAward()){
            // they have a campaign and and award and they pass check. disable maxError
            vm.showMaxError = false;


        } else if (!checkAward()){
            // they failed checkAward - turn on our maxError
            vm.showMaxError = true;
        };


        function checkAward(){
            var pass = true, timeStamp = undefined, targetDate = moment().subtract(30, 'days').toISOString();
            if(_.has(vm.user, 'awards')){
                _.each(vm.user.awards, function(thisAward){
                    // Has the user claimed this same award before?
                    if(thisAward.campaign == vm.campaign && thisAward.award == vm.award){
                        pass = false;
                    }

                    // Has the user claimed another award in past 30 days?
                    if(thisAward.timeStamp > targetDate){
                        pass = false;

                    }

                })
            } else {
                pass = true
            }
            return pass
        }//vm.checkAward

        vm.claimAward = function(){
            var updates = {};
            vm.newKey = firebase.database().ref().child('users/' + vm.userID).push().key,
            vm.sharePayLoad = {
                timeStamp: moment().toISOString(),
                campaign: vm.campaign,
                awardKey: vm.award,
                award: vm.awardLabel,
                uid: vm.newKey
            };

            // prepare the necessary updates depending on award type
            switch(vm.award) {
                case vm.workSpaceKey:
                    var newLimit = Number(vm.user.limits.clients) + 1;
                    updates['/users/' + vm.userID + '/limits/clients' ] = newLimit;
                    vm.confirmMessage = "Your workspace limit has been increased from " + vm.user.limits.clients + " to " + newLimit + ".";
                    break;
                case vm.teamMemberKey:
                    var newLimit = Number(vm.user.limits.team) + 1;
                    updates['/users/' + vm.userID + '/limits/team' ] = newLimit;
                    vm.confirmMessage = "Your team member limit has been increased from " + vm.user.limits.team + " to " + newLimit + 1 + ".";
                    break;
                default:
                    return
            } // switch

            updates['/users/' + vm.userID + '/awards/' + vm.newKey ] = vm.sharePayLoad;

            // make the update
            return firebase.database().ref().update(updates)
            .then(function(){
                $timeout(function(){
                    _dcq.push(["track", "Shared Adminja"]);
                    // if(Appcues){
                    //     Appcues.track("Shared-Adminja", {
                    //       campaign: vm.campaign,
                    //       award: vm.awardLabel
                    //     });
                    // }
                    vm.showConfirm = true;
                    $rootScope.showRefresh = true;
                },0);

            });// firebase.update

        }// vm.claimAward


        vm.toggle = function(item){
            item = !item
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('account', ['appServices']);
})();

(function() {
    'use strict';

    angular
        .module('account')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, triMenuProvider, triLayoutProvider) {


        $translatePartialLoaderProvider.addPart('app/admin-account');

        $stateProvider
            .state('triangular.account-page', {
                abstract: true,
                views: {
                    'toolbar@triangular': {
                        templateUrl: 'app/admin-account/account-toolbar.tmpl.html',
                        controller: 'accountToolbarController',
                        controllerAs: 'vm'
                    }
                },
                url: '/account',
                templateUrl: 'app/admin-account/account-page.tmpl.html',
                // set the controller to load for this page
                controller: 'accountPageController',
                controllerAs: 'vm'


            })
            .state('triangular.account-page.profile',{
                url: '/profile',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-profile.tmpl.html',
                        controller: 'accountPageController',
                        controllerAs: 'vm'
                    }
                  }
            })
            .state('triangular.account-page.team',{
                url: '/team',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-team.tmpl.html',
                        controller: 'accountTeamController',
                        controllerAs: 'vm'
                    }
                  }

            })
            .state('triangular.account-page.plan',{
                url: '/plan',
                views: {
                    '@triangular': {
                        templateUrl: 'app/admin-account/account-plan.tmpl.html',
                        controller: 'accountPageController',
                        controllerAs: 'vm'
                    }
                  }
            })
            // .state('triangular.account-page.clients',{
            //           templateUrl: 'app/admin-account/account-clients.tmpl.html',
            //           controller: 'accountClientsController',
            //           controllerAs: 'vm',
            //           url: '/clients'
            //   });



            triMenuProvider.addMenu({
                name: 'Account',
                icon: 'fa fa-gears',
                state: 'triangular.account-page.profile',
                type: 'dropdown',
                priority: 24,
                children: [{
                               name: 'Profile',
                               icon: 'fa fa-user',
                               state: 'triangular.account-page.profile',
                               type: 'link',
                               priority: 1
                           }

                           ,
                           // {
                           //  type: 'divider',
                           //  priority: 1.1
                           // },
                           // {
                           //     name: 'Manage Clients',
                           //     state: 'triangular.account-page.clients',
                           //     icon: 'zmdi zmdi-accounts-list',
                           //     type: 'link',
                           //     priority: 2
                           // },
                           {
                            type: 'divider',
                            priority: 2.1
                           },
                           {
                               name: 'Team',
                               state: 'triangular.account-page.team',
                               icon: 'fa fa-users',
                               type: 'link',
                               priority: 3
                           },
                           {
                            type: 'divider',
                            priority: 3.1
                           },

                           {
                               name: 'Plan',
                               state: 'triangular.account-page.plan',
                               icon: 'fa fa-credit-card',
                               type: 'link',
                               priority: 4
                           }
                           ,
                           {
                            type: 'divider',
                            priority: 4.1
                           }
                           ]
            });






    }
})();

(function() {
    'use strict';

    angular
        .module('triangular.components')
        .controller('accountToolbarController', accountToolbarController);

    /* @ngInject */
    function accountToolbarController($log, $scope, $injector, $rootScope, $mdMedia, $state, $element, $filter, $mdUtil, $mdSidenav, $mdToast, $timeout, $document, triBreadcrumbsService, triSettings, triLayout, UserService, clientDataService, $stateParams) {
        var vm = this;

        // again, vm. isn't working, we have to use $scope to get through to our template. Why is that?
        $scope.$state=$state;

        $scope.breadcrumbs = triBreadcrumbsService.breadcrumbs;
        $scope.emailNew = false;
        $scope.languages = triSettings.languages;
        $scope.openSideNav = openSideNav;
        $scope.hideMenuButton = hideMenuButton;
        $scope.switchLanguage = switchLanguage;
        $scope.toggleNotificationsTab = toggleNotificationsTab;
        $scope.isFullScreen = false;
        $scope.fullScreenIcon = 'zmdi zmdi-fullscreen';
        $scope.toggleFullScreen = toggleFullScreen;
        // $scope.currentUser = UserService.getCurrentUser();
        // added for Adminja
        $scope.changeState =changeState;
        $scope.logout =logout;

        // Added for Adminja
        function logout(){
            // clear out ghost User if we are logged in as one
            localStorageService.remove('ghostUser');
            firebase.auth().signOut().then(function() {
              // Sign-out successful.
              // $state.go('authentication.login')
            }, function(error) {
              // An error happened.
            });
        }
        ////////////////

        function changeState(newState){
            $state.go(newState);
        }

        function openSideNav(navID) {
            $mdUtil.debounce(function(){
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        function switchLanguage(languageCode) {
            if($injector.has('$translate')) {
                var $translate = $injector.get('$translate');
                $translate.use(languageCode)
                .then(function() {
                    $mdToast.show(
                        $mdToast.simple()
                        .content($filter('triTranslate')('Language Changed'))
                        .position('bottom right')
                        .hideDelay(500)
                    );
                    $rootScope.$emit('changeTitle');
                });
            }
        }

        function hideMenuButton() {
            switch(triLayout.layout.sideMenuSize) {
                case 'hidden':
                    // always show button if menu is hidden
                    return false;
                case 'off':
                    // never show button if menu is turned off
                    return true;
                default:
                    // show the menu button when screen is mobile and menu is hidden
                    return $mdMedia('gt-sm');
            }
        }

        function toggleNotificationsTab(tab) {
            $rootScope.$broadcast('triSwitchNotificationTab', tab);
            openSideNav('right');
        }

        function toggleFullScreen() {
            vm.isFullScreen = !vm.isFullScreen;
            vm.fullScreenIcon = vm.isFullScreen ? 'zmdi zmdi-fullscreen-exit':'zmdi zmdi-fullscreen';
            // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            var doc = $document[0];
            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                } else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                } else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                } else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                } else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                } else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                } else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        }



        $scope.$on('newMailNotification', function(){
            vm.emailNew = true;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountTeamController', accountTeamController);
        // accountTeamController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountTeamController($scope, $rootScope, $mdDialog, clientDataService) {

        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountPlanController', accountPlanController);
        // accountPlanController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountPlanController($scope, $rootScope, $mdDialog, clientDataService) {

        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('accountPageController', accountPageController);
        // accountPageController.$inject = ['$scope', '$rootScope','$mdDialog', 'clientDataService'];

    /* @ngInject */
    function accountPageController($log, $rootScope, $mdToast, $mdDialog, localStorageService, clientDataService, userDataService, $firebaseArray, $firebaseObject, _userData, _clientData, fbService) {
        var vm = this;
            vm.user = _userData;
            vm.user.dob = new Date(vm.user.dob);


        vm.updateUser = function(user){
            // $log.info(user);
            userDataService.updateUser(user);
        }

        vm.uploadAvatar = function($files) {
            // $log.info('upload file');
            // $log.info($files);


            if($files !== null && $files.length > 0) {
                var storage = firebase.storage(),
                    storageRef = storage.ref();

                    _.each($files, function(file){


                        // $log.info('Saving '+filename);
                        var filename = localStorageService.get('userID') + '_userAvatar.' + file.type;
                        // $log.info(filename);

                        var imageRef = storageRef.child('avatars/' + filename);

                        var uploadTask = imageRef.put(file);

                        uploadTask.on('state_changed', function(snapshot){
                            // observe state change for progress, pause, resume
                            // $log.info('upload state changed');
                        }, function(error){
                            // $log.warn('upload failed');
                            // Handle unsuccessful upload
                        }, function(success){
                            // $log.info('upload success');
                            // Handle successful uploads on complete
                             // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                             // Set the file url value in our model
                             vm.user.avatar = uploadTask.snapshot.downloadURL;
                             vm.customDirty = true;
                             userDataService.trackEvent('upload-avatar');
                             // $mdToast.showSimple('Profile photo uploaded. Thanks!');

                        });// uploadTask.on
                    });// ._each files
            } // if files
        };// vm.uploadAvatar


    }
})();


(function() {
    'use strict';

    angular
        .module('app')
        .value('googleChartApiConfig', {
            version: '1.1',
            optionalSettings: {
                packages: ['line', 'bar', 'geochart', 'scatter'],
                language: 'en'
            }
        });
})();
(function() {
    'use strict';

    angular
        .module('triangular')
        .filter('triTranslate', triTranslateFilter);

    /* @ngInject */
    function triTranslateFilter($injector, $filter) {
        return function(input) {
            // if angular translate installed this will return true
            // so we can translate
            if($injector.has('translateFilter')) {
                return $filter('translate')(input);
            }
            else {
                // no translation active so just return the same input
                return input;
            }
        };
    }
})();

(function() {
    angular
        .module('app')
        .controller('ErrorPageController', ErrorPageController);

    /* @ngInject */
    function ErrorPageController($state) {
        var vm = this;

        vm.goHome = goHome;
        console.log('ErrorPageController');
        /////////

        function goHome() {
            $state.go('authentication.login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(themesConfig);

    /* @ngInject */
    function themesConfig ($mdThemingProvider, triThemingProvider, triSkinsProvider) {
        /**
         *  PALETTES
         */
        $mdThemingProvider.definePalette('white', {
            '50': 'ffffff',
            '100': 'ffffff',
            '200': 'ffffff',
            '300': 'ffffff',
            '400': 'ffffff',
            '500': 'ffffff',
            '600': 'ffffff',
            '700': 'ffffff',
            '800': 'ffffff',
            '900': 'ffffff',
            'A100': 'ffffff',
            'A200': 'ffffff',
            'A400': 'ffffff',
            'A700': 'ffffff',
            'contrastDefaultColor': 'dark'
        });

        $mdThemingProvider.definePalette('adminja-blue-green', {
            '50': '#000000',
            '100': '#000101',
            '200': '#00111b',
            '300': '#002134',
            '400': '#00314e',
            '500': '#004167',
            '600': '#00619a',
            '700': '#0071b4',
            '800': '#0081cd',
            '900': '#0091e7',
            'A100': '#00619a',
            'A200': '#005181',
            'A400': '#004167',
            'A700': '#01a1ff',
            'contrastDefaultColor' :'light'
        });

        $mdThemingProvider.definePalette('adminja-blue-grey', {
             '50': '#3c4f82',
                    '100': '#344471',
                    '200': '#2c3a5f',
                    '300': '#242f4e',
                    '400': '#1c253c',
                    '500': '#141a2b',
                    '600': '#0c0f1a',
                    '700': '#040508',
                    '800': '#000000',
                    '900': '#000000',
                    'A100': '#455993',
                    'A200': '#4d64a5',
                    'A400': '#5970b2',
                    'A700': '#000000',
                'contrastDefaultColor' :'light'
            });

        $mdThemingProvider.definePalette('black', {
            '50': 'e1e1e1',
            '100': 'b6b6b6',
            '200': '8c8c8c',
            '300': '646464',
            '400': '3a3a3a',
            '500': 'e1e1e1',
            '600': 'e1e1e1',
            '700': '232323',
            '800': '1a1a1a',
            '900': '121212',
            'A100': '3a3a3a',
            'A200': 'ffffff',
            'A400': 'ffffff',
            'A700': 'ffffff',
            'contrastDefaultColor': 'light'
        });


        $mdThemingProvider.definePalette('firebase', {
          '50': 'e1e4e7',
          '100': 'b4bcc2',
          '200': '828f9a',
          '300': '506271',
          '400': '2b4052',
          '500': '051e34',
          '600': '041a2f',
          '700': '041627',
          '800': '031221',
          '900': '010a15',
          'A100': '5588ff',
          'A200': '2264ff',
          'A400': '0047ee',
          'A700': '0040d4',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': [
            '50',
            '100',
            '200',
            'A100'
          ],
          'contrastLightColors': [
            '300',
            '400',
            '500',
            '600',
            '700',
            '800',
            '900',
            'A200',
            'A400',
            'A700'
          ]
        });

        var triCyanMap = $mdThemingProvider.extendPalette('cyan', {
            'contrastDefaultColor': 'light',
            'contrastLightColors': '500 700 800 900',
            'contrastStrongLightColors': '500 700 800 900'
        });

        // Register the new color palette map with the name triCyan
        $mdThemingProvider.definePalette('triCyan', triCyanMap);

        /**
         *  SKINS
         */

        // CYAN CLOUD SKIN
        triThemingProvider.theme('cyan')
        .primaryPalette('triCyan')
        .accentPalette('amber')
        .warnPalette('deep-orange');

        triThemingProvider.theme('cyan-white')
        .primaryPalette('white')
        .accentPalette('triCyan', {
            'default': '500'
        })
        .warnPalette('deep-orange');

        triSkinsProvider.skin('cyan-cloud', 'Cyan Cloud')
        .sidebarTheme('cyan')
        .toolbarTheme('cyan-white')
        .logoTheme('cyan')
        .contentTheme('cyan');


        // PLUMB PURPLE SKIN
        triThemingProvider.theme('purple')
        .primaryPalette('purple')
        .accentPalette('deep-orange')
        .warnPalette('amber');

        triThemingProvider.theme('white-purple')
        .primaryPalette('white', {
            'default': '200',
            'hue-1': '200'
        })
        .accentPalette('purple', {
            'default': '400'
        })
        .warnPalette('deep-orange');

        triSkinsProvider.skin('plumb-purple', 'Plumb Purple')
        .sidebarTheme('purple')
        .toolbarTheme('white-purple')
        .logoTheme('purple')
        .contentTheme('purple');

        // DARK KNIGHT SKIN
        triThemingProvider.theme('dark')
        .primaryPalette('black', {
            'default': '300',
            'hue-1': '400'
        })
        .accentPalette('amber')
        .warnPalette('deep-orange')
        .backgroundPalette('black')
        .dark();

        triSkinsProvider.skin('dark-knight', 'Dark Knight')
        .sidebarTheme('dark')
        .toolbarTheme('dark')
        .logoTheme('dark')
        .contentTheme('dark');

        // BATTLESHIP GREY SKIN
        triThemingProvider.theme('blue-grey')
        .primaryPalette('blue-grey')
        .accentPalette('amber')
        .warnPalette('orange');


        triThemingProvider.theme('filter-menu')
        .primaryPalette('black',{
            'default': '50'
        })
        .accentPalette('blue-grey', {
            'default': '400'
        })
        .warnPalette('orange');

        triThemingProvider.theme('white-blue-grey')
        .primaryPalette('white')
        .accentPalette('blue-grey', {
            'default': '400'
        })
        .warnPalette('orange');

        triSkinsProvider.skin('battleship-grey', 'Battleship Grey')
        .sidebarTheme('blue-grey')
        .toolbarTheme('white-blue-grey')
        .logoTheme('blue-grey')
        .contentTheme('blue-grey');




        // ADMINJA SKIN
        triThemingProvider.theme('adminja-shade')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('light-blue',{
            'default': 'A700',
            'hue-1': '300'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        // ADMINJA SKIN
        triThemingProvider.theme('adminja-status')
        .primaryPalette('green', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('orange',{
            'default': '400',
            'hue-1': '300'
        })
        .warnPalette('red', {
            'default': '400'
        });

        // triThemingProvider.theme('adminja-status')
        // .primaryPalette('light-green')
        // .accentPalette('deep-orange')
        // .warnPalette('red');



        // triThemingProvider.theme('adminja-shade-copy')
        // .primaryPalette('blue-grey', {
        //     'default': 'A700',
        //     'hue-1': '900'
        // })
        // .accentPalette('cyan',{
        //     'default': '400'
        // })
        // .warnPalette('pink', {
        //     'default': 'A200'
        // });

        triThemingProvider.theme('adminja-neutral')
        .primaryPalette('light-blue',{
            'default': '400'
        })
        .accentPalette('light-blue', {
            'default': 'A700'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });


        triThemingProvider.theme('adminja-light')
        .primaryPalette('black',{
            'default': '400'
        })
        .accentPalette('light-blue', {
            'default': '400'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        triThemingProvider.theme('adminja-white')
        .primaryPalette('grey',{
            'default': '200'
        })
        .accentPalette('cyan', {
            'default': '400'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });


        // Used in a few places for some reason
        triThemingProvider.theme('adminja-green')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('green',{
            'default': '500',
            'hue-1': '300'
        })
        .warnPalette('red', {
            'default': 'A200'
        });

        // Theme for our settings panel
        $mdThemingProvider.theme('adminja-blue')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })
        .accentPalette('blue',{
            'default': 'A400'
        })
        .warnPalette('red', {
            'default': 'A200'
        });

        // Adminja's Main Content THeme (green buttons)
        triThemingProvider.theme('adminja-green')
        .primaryPalette('adminja-blue-grey', {
            'default': '400',
            'hue-1': '50',
            'hue-2': '400',
            'hue-3': 'A200'
        })

        .accentPalette('green',{
            'default': '500',
            'hue-1': '300'
        })
        .warnPalette('pink', {
            'default': 'A200'
        });

        // Custom Theme Options Work

        // Legacy
        triThemingProvider.theme('grey-menu')
        .primaryPalette('grey', {
            'default': '800',
            'hue-1': '600'
        })
        .accentPalette('green', {
            'default': '500'
        })
        .warnPalette('red');


        // White
        triThemingProvider.theme('white-menu')
        .primaryPalette('white', {
            'default': '800',
            'hue-1': '600'
        })
        .accentPalette('green', {
            'default': '500'
        })
        .warnPalette('red');



        // Adminja's Menu and Logo Theme
        triThemingProvider.theme('blue-green-menu')
        .primaryPalette('adminja-blue-green', {
            'default': '500',
            'hue-1': '600'
        })
        .accentPalette('green', {
            'default': '500'
        })
        .warnPalette('red');



/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

        triSkinsProvider.skin('adminja', 'Adminja')
        .sidebarTheme('grey-menu')
        .toolbarTheme('grey-menu')
        .logoTheme('grey-menu')
        .contentTheme('adminja-green')
        .statusTheme('adminja-status');

        /**
         *  SET DEFAULT SKIN
         */
        triSkinsProvider.setSkin('adminja');
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig(triSettingsProvider, triRouteProvider) {
        var now = new Date();
        // set app name & logo (used in loader, sidemenu, footer, login pages, etc)
        triSettingsProvider.setName('Adminja');
        triSettingsProvider.setCopyright('&copy;' + now.getFullYear() + ' openmotive.com');
        triSettingsProvider.setLogo('assets/images/brand/adminja-bug.svg');
        // set current version of app (shown in footer)
        triSettingsProvider.setVersion('1.5');
        // set the document title that appears on the browser tab
        triRouteProvider.setTitle('Adminja');
        triRouteProvider.setSeparator('|');
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(config);

    /* @ngInject */
    function config(triLayoutProvider) {
       // set app templates (all in app/layouts folder so you can tailor them to your needs)

       // loader screen HTML & controller
       triLayoutProvider.setDefaultOption('loaderTemplateUrl', 'app/layouts/loader/loader.tmpl.html');
       triLayoutProvider.setDefaultOption('loaderController', 'LoaderController');

       // left sidemenu HTML and controller
       triLayoutProvider.setDefaultOption('sidebarLeftTemplateUrl','app/layouts/adminja-menu.tmpl.html');
       triLayoutProvider.setDefaultOption('sidebarLeftController', 'LeftSidenavController');

       // right sidemenu HTML and controller
       triLayoutProvider.setDefaultOption('sidebarRightTemplateUrl', 'app/layouts/rightsidenav/rightsidenav.tmpl.html');
       triLayoutProvider.setDefaultOption('sidebarRightController', 'RightSidenavController');

       // top toolbar HTML and controller
       triLayoutProvider.setDefaultOption('toolbarTemplateUrl', 'app/layouts/toolbar/adminja-toolbar.tmpl.html');
       triLayoutProvider.setDefaultOption('toolbarController', 'ToolbarController');

       // footer HTML
       triLayoutProvider.setDefaultOption('footerTemplateUrl', 'app/layouts/footer/footer.tmpl.html');


        triLayoutProvider.setDefaultOption('toolbarSize', 'small');

        triLayoutProvider.setDefaultOption('toolbarShrink', true);

        triLayoutProvider.setDefaultOption('toolbarClass', '');

        triLayoutProvider.setDefaultOption('contentClass', '');

        triLayoutProvider.setDefaultOption('sideMenuSize', 'icon');

        triLayoutProvider.setDefaultOption('showToolbar', true);

        triLayoutProvider.setDefaultOption('footer', false);

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, APP_LANGUAGES) {
        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a il8n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/il8n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        // setup available languages in translate
        var languageKeys = [];
        for (var lang = APP_LANGUAGES.length - 1; lang >= 0; lang--) {
            languageKeys.push(APP_LANGUAGES[lang].key);
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(languageKeys, {
            'en_US': 'en',
            'en_UK': 'en'
        })
        .use('en');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();
(function() {
    'use strict';

   ///////////////////////////////////////////////////////////
   /// textAngularSetup
           angular.module('textAngularSetup')
               .config(['$provide', function($provide){
                   // this demonstrates how to register a new tool and add it to the default toolbar
                   $provide.decorator('taOptions', ['$delegate', function(taOptions){
                       // $delegate is the taOptions we are decorating
                       // here we override the default toolbars and classes specified in taOptions.
                       taOptions.forceTextAngularSanitize = true; // set false to allow the textAngular-sanitize provider to be replaced
                       taOptions.keyMappings = []; // allow customizable keyMappings for specialized key boards or languages
                       // taOptions.toolbar = [

                       //     ['bold', 'italics', 'underline','justifyLeft','justifyCenter', 'insertLink']
                       // ];
                       taOptions.classes = {
                           focussed: 'focussed',
                           toolbar: 'btn-toolbar',
                           toolbarGroup: 'btn-group',
                           toolbarButton: 'btn btn-default',
                           toolbarButtonActive: 'active',
                           disabled: 'disabled',
                           textEditor: 'form-control',
                           htmlEditor: 'form-control'
                       };

                       taOptions.defaultTagAttributes.a.target = '_blank';

                       return taOptions; // whatever you return will be the taOptions
                   }]);
                   // // this demonstrates changing the classes of the icons for the tools for font-awesome v3.x
                   // $provide.decorator('taTools', ['$delegate', function(taTools){
                   //     taTools.bold.iconclass = 'icon-bold';
                   //     taTools.italics.iconclass = 'icon-italic';
                   //     taTools.underline.iconclass = 'icon-underline';
                   //     taTools.ul.iconclass = 'icon-list-ul';
                   //     taTools.ol.iconclass = 'icon-list-ol';
                   //     taTools.undo.iconclass = 'icon-undo';
                   //     taTools.redo.iconclass = 'icon-repeat';
                   //     taTools.justifyLeft.iconclass = 'icon-align-left';
                   //     taTools.justifyRight.iconclass = 'icon-align-right';
                   //     taTools.justifyCenter.iconclass = 'icon-align-center';
                   //     taTools.clear.iconclass = 'icon-ban-circle';
                   //     taTools.insertLink.iconclass = 'icon-link';
                   //     taTools.insertImage.iconclass = 'icon-picture';
                   //     // there is no quote icon in old font-awesome so we change to text as follows
                   //     delete taTools.quote.iconclass;
                   //     taTools.quote.buttontext = 'quote';
                   //     return taTools;
                   // }]);
               }]);


})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routeConfig);

    /* @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {
        // disable strict so it doesn't matter if we have trailing slashes in our URLs or not
        $urlMatcherFactoryProvider.strictMode(false);
        // Setup the apps routes

        // 404 & 500 pages
        $stateProvider
        .state('404', {
            url: '/404',
            views: {
                'root': {
                    templateUrl: '404.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('401', {
            url: '/401',
            views: {
                'root': {
                    templateUrl: '401.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('500', {
            url: '/500',
            views: {
                'root': {
                    templateUrl: '500.tmpl.html',
                    controller: 'ErrorPageController',
                    controllerAs: 'vm'
                }
            }
        });



        // set default routes when no path specified
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/', '/dashboard');

        // always goto 404 if route not found
        $urlRouterProvider.otherwise('/404');
        // $urlRouterProvider.otherwise('/login');

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(config);

    /* @ngInject */
    function config(ChartJsProvider) {
        // Configure all charts to use material design colors
        ChartJsProvider.setOptions({
            colours: [ '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'],
            // full set of colors: [ '#803690', '#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360']
            responsive: true
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('app')
        .run(runFunction);

    /* @ngInject */
    function runFunction(Idle, $rootScope, $timeout, $state, $log, $mdDialog) {

        // default redirect if access is denied
        function redirectError() {
            $log.info('redirectError');
            $state.go('authentication.login');
        }

        // watches
        if ($state.name != 'authentication.lock' && $state.name != 'authentication.login' && $state.name != 'authentication.registration'){
            Idle.watch();
        }

        // redirect all errors to permissions to 500
        var errorHandle = $rootScope.$on('$stateChangeError', redirectError);

        // remove watch on destroy
        $rootScope.$on('$destroy', function() {
            errorHandle();
        });

        // $log.info('app run function');
        // $log.info($rootScope);


        $rootScope.events = [];

          $rootScope.$on('IdleStart', function() {
            $log.info('the user appears to have gone idle');

            $mdDialog.show({
                controller: 'idleDialogController', // see below
                bindToController: true,
                templateUrl: 'app/app-authentication/lock/dialogIdle.tmpl.html',
                focusOnOpen: true,
                clickOutsideToClose: false,
                fullscreen: true,
                multiple: false,
                escapeToClose: false
            }).then(function(){

            });

            // the user appears to have gone idle
          });

          $rootScope.$on('IdleWarn', function(e, countdown) {
            $log.info('idle warn');
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
            $rootScope.countdown = countdown;
          });

          $rootScope.$on('IdleTimeout', function() {
            // $log.info('idle timeout');
            $mdDialog.cancel();
            $state.go('authentication.lock');
            $rootScope.countdown = "Logged out";
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
          });

          $rootScope.$on('IdleEnd', function() {
            $log.info('idle end');
            $mdDialog.cancel();
            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
          });

          $rootScope.$on('Keepalive', function() {
            // $log.info('idle keepalive');
            // do something to keep the user's session alive
          });

          function HandM(minutes){
             // if it's minutes-based
             var isNegative = false;
             if (minutes < 0){
               isNegative = true;
             }
             // convert to an integer so we aren't doing a floor/ceiling dance
             minutes = Math.abs(minutes);

             var hours = Math.floor( minutes / 60);
             hours = _.toString(hours);
             // we don't pad our hours. They may go into 3 digits for some users.
             var minutes = Math.round(minutes % 60);
             minutes = _.toString(minutes);
             minutes = _.padStart(minutes, 2, '0');

             // set our return object
             var duration = hours;

             // if we have minutes, add them. Otherwise, 00
              if (minutes){
               duration = duration + ':' + minutes;
              } else {
               duration = duration + ':' + '00';
              }

              // if it was a negative minutes, prepend it
              if (isNegative){
               duration = '-' + duration;
              }

              return duration

          }// HandM
          // Configure our Handlebars Helpers for template parsing
             Handlebars.registerHelper({
               toFixed: function(data) {
                 var fixed = Number(data).toFixed(2);
                 return fixed
               },
               minutesToHandM: function(number) {
                 return HandM(number)
               },
               timeTotal: function(rate, logged) {
                 var total = rate * (logged/60)
                 return Number(total).toFixed(2);
               },
               longDate: function(data) {
                 return moment(data).format('MMMM DD,YYYY')
               },
               shortDate: function(data) {
                 return moment(data).format('MMM DD')
               },
               lineTotal: function(cost, quantity) {
                 var thisTotal =  (cost * quantity);
                 thisTotal = thisTotal.toFixed(2);
                 return thisTotal
               },
               paymentTotal: function(payments) {
                 var total = 0;
                 _.each(payments, function(payment){
                   total = total + Number(payment.amount);
                 })
                 var fixedTotal = Number(total).toFixed(2);
                 return fixedTotal
               },
               remainFrom: function(allocatedMinutes, total) {
                 var remainingMinutes = allocatedMinutes - total;

                 return HandM(remainingMinutes)

               },
               trimTo: function(text,length){
                   var trimmed = _.truncate(text, {
                     'length': length,
                     'separator': ' '
                   });
                   return trimmed
                 },
              ifEqual: function(value, comparison, options){
               if (value == comparison) { return options.fn(this); }
                  return options.inverse(this);
              }

             });


        // window.onbeforeunload = function (e) {

        //     alert('Please Refresh your Adminja browser.')
        //     return;
        // }
    }
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin-awards/awards-claim.tmpl.html","<div layout-padding layout=\"row\" layout-align=\"center center\" class=\"full-height\">\n  <md-content class=\"padding-50\" flex=\"100\" flex-lg=\"50\" flex-xl=\"40\" ng-if=\"!vm.showAwardError && !vm.showMaxError\">\n    <div ng-if=\"!vm.showConfirm\">\n      <div layout=\"row\" layout-align=\"center center\">\n        <div flex=\'nogrow\' class=\'padding-right-20\'><img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\" style=\"position: relative; top: 5px;\"></div>\n        <div flex=\'nogrow\'><h1 class=\"center\">Thank you for sharing Adminja!</h1></div>\n      </div>\n      <md-divider class=\"margin-top-10 margin-bottom-10\"></md-divider>\n  		<p class=\"center\">Now just click below to get your new {{vm.awardLabel}}!</p>\n    		<p class=\"center padding-0 margin-0\"><md-button class=\"md-raised md-accent\" ng-disable=\"vm.awardLabel == \'error\'\" ng-click=\"vm.claimAward()\" style=\"text-transform: uppercase; font-size: 14px;\">Increase my {{vm.awardLabel}} limit!</md-button></p>\n    	</div>\n    	<div ng-if=\"vm.showConfirm\">\n        <div layout=\"row\" layout-align=\"center center\">\n          <div flex=\'nogrow\' class=\'padding-right-20\'><img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\" style=\"position: relative; top: 5px;\"></div>\n          <div flex=\'nogrow\'><h1 class=\"center\">We like you!</h1></div>\n        </div>\n        <md-divider class=\"margin-top-10 margin-bottom-10\"></md-divider>\n    		<p class=\"center\">{{vm.confirmMessage}}</p>\n    		<p class=\"center\">Thank you again from the bottom of our hearts, <br>and please enjoy your new {{vm.awardLabel}}!</p>\n    		<p class=\"center padding-0 margin-0\"><md-button class=\"md-raised md-accent\" ui-sref=\"triangular.dashboard\">Return</md-button></p>\n    	</div>\n  </md-content>\n  <!-- showMaxError state - if they\'ve exceeded their limit or already redeemed this reward -->\n  <md-content class=\"padding-50\" flex=\"100\" flex-lg=\"50\" flex-xl=\"40\" ng-if=\"vm.showMaxError && !vm.showAwardError\">\n      <div layout=\"row\" layout-align=\"center center\">\n        <div flex=\'nogrow\' class=\'padding-right-20\'><img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\" style=\"position: relative; top: 5px;\"></div>\n        <div flex=\'nogrow\'><h1 class=\"center\">Oops!</h1></div>\n      </div>\n      <md-divider class=\"margin-top-10 margin-bottom-10\"></md-divider>\n    <p class=\"center\">Either you\'ve previously redeemed this reward or you\'ve redeemed another reward within the past 30 days. You may only redeem one reward per month.</p>\n    <p class=\"center padding-0 margin-0\"><md-button class=\"md-raised md-accent\" ui-sref=\"triangular.dashboard\">Return</md-button></p>\n  </md-content>\n  <!-- showAwardError state - if the parameters in the URL are invalid -->\n  <md-content class=\"padding-50\" flex=\"100\" flex-lg=\"50\" flex-xl=\"40\" ng-if=\"vm.showAwardError\">\n      <div layout=\"row\" layout-align=\"center center\">\n            <div flex=\'nogrow\' class=\'padding-right-20\'><img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\" style=\"position: relative; top: 5px;\"></div>\n            <div flex=\'nogrow\'><h1 class=\"center\">Oops!</h1></div>\n      </div>\n      <md-divider class=\"margin-top-10 margin-bottom-10\"></md-divider>\n    <p class=\"center\">That does not seem to be a valid reward.</p>\n    <p class=\"center\">Please contact us at <a href=\"mailto:help@getadminja.com\">help@getadminja.com</a> if you continue to have problems.</p>\n    <p class=\"center padding-0 margin-0\"><md-button class=\"md-raised md-accent\" ui-sref=\"triangular.dashboard\">Return</md-button></p>\n  </md-content>\n</div>\n<!-- testing tools -->\n<!-- <div ng-if=\"vm.user.type == \'admin\'\">\n	  <md-content class=\"padding-10\" layout=\"row\" layout-align=\"center center\">\n		<div flex=\'nogrow\' class=\"padding-10\"><md-switch class=\"md-secondary\" ng-model=\"vm.showMaxError\" ng-change=\"vm.toggle(vm.showMaxError)\"></md-switch> MaxError</div>\n		<div flex=\"nogrow\" class=\"padding-10\"><md-switch class=\"md-secondary\" ng-model=\"vm.showAwardError\" ng-change=\"vm.toggle(vm.showAwardError)\"></md-switch> AwardError</div>\n    <div flex=\"nogrow\" class=\"padding-10\"><md-switch class=\"md-secondary\" ng-model=\"vm.showConfirm\" ng-change=\"vm.toggle(vm.showConfirm)\"></md-switch> showConfirm</div>\n	  </md-content>\n</div>\n -->\n");
$templateCache.put("app/admin-awards/awards-confirm.tmpl.html","<div class=\"no-scrollbar\" layout-padding>\n  <md-content>\n    <h1>Award Confirm</h1>\n  </md-content>\n\n</div>\n");
$templateCache.put("app/admin-awards/awards.tmpl.html","<!-- Authentication.tmpl.html -->\n<div class=\"full-image-background\" ng-class=\"authBackground\" layout=\"row\" layout-fill>\n    <div class=\"animate-wrapper\" flex layout=\"row\">\n        <div class=\"login-frame no-scrollbar\" ui-view flex layout=\"column\" style=\"overflow: scroll;\"></div>\n    </div>\n</div>\n");
$templateCache.put("app/admin-account/account-page.tmpl.html","    <div class=\"full-height\" ui-view>\n\n    </div>\n\n\n");
$templateCache.put("app/admin-account/account-plan.tmpl.html","<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n<h1>plan</h1>\n</md-content>\n");
$templateCache.put("app/admin-account/account-profile.tmpl.html","\n<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n	<h3 class=\"center\" style=\"margin-bottom: 4em;\">Your Profile</h3>\n	<div layout-gt-md=\"row\" layout=\"column\">\n		<div flex=\"40\" >\n			<div class=\"center\">\n			<img ng-if=\"vm.user.avatar\" src=\"{{vm.user.avatar}}\" width=\"200\" height=\"200\"><br>\n	           <img ng-if=\"!vm.user.avatar\" src=\"/assets/images/avatars/generic-person-avatar.png\" width=\"200\" height=\"200\"><br>\n	           <md-button ng-hide=\"vm.user.avatar\" class=\"md-primary \" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\">\n	               <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Upload Photo\n	           </md-button>\n	           <md-button ng-show=\"vm.user.avatar\" class=\"md-primary \" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\">\n	               <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Change Photo\n	           </md-button>\n	           </div>\n		</div>\n		<div flex=\"60\">\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>First name</label>\n						<input name=\"firstname\" ng-model=\"vm.user.profile.firstname\" required>\n						<div ng-messages=\"vm.user.profile.firstname.$error\">\n						      <div ng-message=\"required\">Oops! Your name is required</div>\n						</div>\n					</md-input-container>\n				</div>\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Last name</label>\n						<input name=\"lastname\" ng-model=\"vm.user.profile.lastname\" required>\n						<div ng-messages=\"vm.user.profile.lastname.$error\">\n						      <div ng-message=\"required\">Oops! Your name is required</div>\n						</div>\n					</md-input-container>\n				</div>\n			</div>\n			<div  class=\"left\">\n				<md-input-container>\n					<label>E-mail Address</label>\n					<input disabled=\"disabled\" type=\"email\" name=\"email\" ng-model=\"vm.user.email\" required>\n					<div ng-messages=\"vm.user.email.$error\">\n					      <div ng-message=\"required\">Please provide a valid E-mail address!</div>\n					</div>\n				</md-input-container>\n			</div>\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Primary Phone</label>\n						<input name=\"phone\" ng-model=\"vm.user.profile.phone\">\n					</md-input-container>\n				</div>\n				<div class=\"center\" flex=\"50\">\n					<div style=\"display:block;\"> <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.dob\" md-placeholder=\"Date of Birth\"></md-datepicker></div>\n				</div>\n			</div>\n			<div layout=\"column\" layout-gt-md=\"row\">\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Business Info</label>\n						<input type=\"company\" name=\"company\" ng-model=\"vm.user.profile.company\" >\n					</md-input-container>\n				</div>\n				<div  class=\"left\" flex=\"50\">\n					<md-input-container>\n						<label>Website</label>\n						<input type=\"website\" name=\"website\" ng-model=\"vm.user.profile.website\" >\n					</md-input-container>\n				</div>\n			</div>\n				<div  class=\"left\">\n					<md-input-container>\n						<label>Twitter</label>\n						<input type=\"twitter\" name=\"twitter\" ng-model=\"vm.user.profile.twitter\" >\n					</md-input-container>\n				</div>\n				<div class=\"right\">\n					<md-button type=\"submit\" ng-disabled=\"userform.$pristine\" class=\"md-indigo-theme md-primary md-raised\" ng-click=\"vm.updateUser(vm.user)\">\n						Save\n					</md-button>\n				</div>\n		</div>\n	</div>\n</md-content>\n\n\n\n\n");
$templateCache.put("app/admin-account/account-team.tmpl.html","<div layout-padding>\n<!-- <h3 class=\"center\">Manage Your Team</h3>\n -->	<div class=\"account-card-container\" layout=\"row\" layout-wrap>\n		<md-card flex=\"1\">\n		  <md-card-title>\n		    <md-card-title-text>\n			 <span class=\"md-headline\"></span>\n			 <span class=\"md-subhead\">Your Company USA<br><a href=\"http://www.yahoo.com\">www.yourcompany.usa</a></span>\n		    </md-card-title-text>\n		    <md-card-title-media>\n			 <div class=\"md-media-sm card-media\">\n			 	<img src=\"/assets/images/avatars/avatar-1.png\" width=\"100\"><br>\n			 </div>\n		    </md-card-title-media>\n		  </md-card-title>\n		  <md-card-actions layout=\"row\" layout-align=\"end center\">\n		    <md-button>\n				Remove\n			</md-button>\n		    <md-button>\n				Manage\n			</md-button>\n		  </md-card-actions>\n		</md-card>\n\n	</div>\n</div>\n");
$templateCache.put("app/admin-account/account-toolbar.tmpl.html","<!-- // Account Manager Toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" >\n  <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"side navigation\">\n      <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n  </md-button>\n\n  <div flex=\"nogrow\"  style=\"padding-right: 2em;\">\n    <h3>My Account</h3>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" class=\"md-button\"  ui-sref=\"triangular.account-page.profile\" ><md-icon md-font-icon=\"fa fa-user\"></md-icon> Profile</a>\n  </div>\n\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-users\"></md-icon> Team</a>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Plan</a>\n  </div>\n  <div flex></div>\n  <sidebar-controls></sidebar-controls>\n</div>\n\n");
$templateCache.put("app/admin-billing/billing.tmpl.html","<invoice-manager user=\"vm.user\" clients=\"vm.clients\"></invoice-manager>\n");
$templateCache.put("app/admin-custom-forms/custom-forms.tmpl.html","\n<md-content class=\"md-padding\" style=\"background-color: #fff;\" layout=\"row\" layout-align=\"center start\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"40\" layout=\"column\">\n      <h3 class=\"md-title center\">Custom Forms</h3>\n      <p class=\"md-subhead center margin-bottom-40\">Create custom forms to capture new Leads, Tasks & Notes or send an Email. <br><span style=\"font-size: .85em;\">(hint) You can even embed them in your own website!</span></p>\n      <div  ng-if=\"!vm.showLeadGroups\">\n        <md-card class=\"md-padding\" style=\"\">\n          <div ng-if=\"!vm.showLeadGroups\">\n            <h3 class=\"md-title center\">To use custom forms, you  must first setup and enable your Leadboard.</h3>\n            <p class=\"md-subhead center\" style=\"font-size: 11px;\">The Leadboard is an optional module.<br>\n            Click the button below to setup and enable your Leadboard.</p>\n            <p class=\"center\">\n              <md-button ng-if=\"!vm.settingUp\" class=\"md-raised md-accent\" ng-click=\"vm.setupLeads()\">Enable Leadboard</md-button>\n              <md-button ng-if=\"vm.settingUp\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 16px; width: 16px; font-size: 16px; color: #fff; margin: 0 auto 0 auto;\"></md-icon></md-button>\n            </p>\n          </div>\n        </md-card>\n      </div>\n      <md-card  ng-if=\"vm.showLeadGroups\" style=\"\" flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"40\">\n        <div class=\"formlist\">\n          <div ng-repeat=\"form in vm.leadBoard.forms | toArray: false | orderBy: timeStamp track by $index\" layout=\"row\" layout-align=\"start center\" class=\"form-list-item\" style=\"\">\n            <span flex=\"auto\" ng-click=\"vm.openLeadForm(form)\" style=\"cursor: pointer;\">\n              {{form.name}} <br><span style=\"font-size: .65em;\">Created: {{form.timeStamp | amDateFormat: vm.settings.longDateFormat}}  | {{vm.numFields(form)}} fields<br>\n                <strong>{{form.action}}</strong></span>\n            </span>\n            <md-button flex=\"nogrow\" class=\"md-adminja-shade-theme md-warn md-button-small\" ng-click=\"vm.deleteForm(form)\">\n              Delete\n                <md-tooltip md-delay=\"500\">Delete Form</md-tooltip>\n            </md-button>\n            <md-button flex=\"nogrow\" class=\"md-button-small\" ng-href=\"{{vm.hostingURL}}/#/form/{{form.owner}}/{{form.uid}}\" target=\"_blank\">\n                View\n                <md-tooltip md-delay=\"500\">View Hosted Form</md-tooltip>\n            </md-button>\n            <md-button flex=\"nogrow\" class=\"md-button-small\" ng-click=\"vm.openLeadForm(form)\">\n              Edit\n              <md-tooltip md-delay=\"500\">Edit Form</md-tooltip>\n            </md-button>\n\n          </div>\n        </div>\n        <p class=\"center\" ng-if=\"vm.showLeadGroups\"><md-button class=\"adminja-status md-accent md-raised\" ng-click=\"vm.createLeadForm()\">Create a New Form</md-button></p>\n      </md-card>\n    </div>\n</md-content>\n\n");
$templateCache.put("app/admin-client-manager/client-archived-tasks.tmpl.html","\n	<div layout=\"column\" layout-align=\"start layout-fill\" layout-fill class=\"padding-bottom-20\">\n		<div ng-if=\"!vm.archivedTasks.length\" layout=\"row\" layout-align=\"center center\" style=\"padding-top: 2em; background-color: #bbb;\" class=\"layout-fill\">\n			<md-card flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"30\" style=\"padding: 1em; border-radius: 8px;\" layout=\"column\" layout-align=\"start center\">\n				<div ng-if=\"vm.setupComplete && vm.numTasks < 1\">\n					<h3 class=\"center\">You don\'t\' have any archived tasks for this workspace.</h3>\n				</div>\n				<div ng-if=\"!vm.setupComplete && !vm.errorMessage\">\n					<h3 class=\"center\">Fetching Archived Tasks</h3>\n					<p class=\"md-subhead\">This may take a few moments.</p>\n					<h3 class=\"center\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon></h3>\n				</div>\n				<div ng-if=\"vm.setupComplete && vm.errorMessage\">\n					<h3 class=\"center\">Oops! There was a problem.</h3>\n					<p class=\"md-subhead\">{{vm.errorMessage}}</p>\n				</div>\n\n			</md-card>\n\n		</div>\n		<md-content flex=\"none\" ng-if=\"vm.setupComplete && vm.numTasks > 0\">\n			<h3 class=\"center\">Archived Tasks</h3>\n			<!-- <p class=\"md-subhead center\"><strong>Note:</strong> If you need to restore a task archived prior to August 1, 2021, please contact <a href=\"mailto: help@getadminja.com\" target=\"_blank\">help@getadminja.com</a>.</p> -->\n			<!-- Loading -->\n\n\n				<div ng-controller=\"menuSearchController\" class=\"task-list-search\" layout=\"row\" layout-align=\"center center\">\n					<md-input-container class=\"margin-bottom-0\">\n						<input type=\"text\" ng-model-options=\"{debounce: 200}\" ng-model=\"vm.filterText\" placeholder=\"Search\" ng-change=\"vm.search(vm.filterText)\">\n					</md-input-container>\n					<md-button ng-click=\"vm.resetSearch()\" class=\"md-button-small\"><md-icon class=\"menu-search-reset\" md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n				</div>\n\n				<!-- display headings-->\n				<div layout-padding ng-if=\"vm.numTasks > 0\" layout=\"row\" layout-align=\"layout-fill center\" style=\"border-bottom: 1px solid #bbb;\">\n					<div flex=\"50\" layout=\"row\" layout-align=\"start start\">\n						<p flex=\"20\" class=\"padding-bottom-0 margin-bottom-0\" style=\"margin-left: 0!important; margin-top:10px; margin-bottom: 10px;\"><strong>Created</strong></p>\n						<p flex=\"20\" class=\"padding-bottom-0 margin-bottom-0\" style=\"margin-left: 0!important; margin-top:10px; margin-bottom: 10px;\"><strong>Completed</strong></p>\n						<p flex=\"grow\" class=\"padding-bottom-0 margin-bottom-0\" style=\"margin-left: 0!important; margin-top:10px; margin-bottom: 10px;\"><strong>Description</strong></p>\n					</div>\n					<div flex=\"50\" layout=\"row\" layout-align=\"end start\">\n\n					</div>\n				</div>\n\n\n		</md-content>\n\n		<!-- display -->\n		<md-content flex=\"auto\" layout-padding ng-if=\"vm.numTasks > 0\" class=\"small-scrollbar\" style=\"margin-bottom: 75px;\">\n			<div style=\"border-bottom:  1px solid #999;\" ng-if=\"task.created && task.status == \'closed\'\" ng-repeat=\"task in vm.archivedTasks | orderBy: [\'-created\'] | filter: vm.taskFilter track by $index+uid\" layout=\"row\" layout-align=\"layout-fill center\">\n				<div flex=\"50\" layout=\"row\" layout-align=\"start start\">\n					<p flex=\"20\">{{task.created | amDateFormat: vm.dateFormat}}</p>\n					<p flex=\"20\">{{task.closedDate | amDateFormat: vm.dateFormat}}</p>\n					<p flex=\"grow\" class=\"md-subhead\" style=\"font-size:  12px;\">{{task.description}}</p>\n				</div>\n				<div flex=\"50\" layout=\"row\" layout-align=\"end start\">\n\n					<md-button ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}tasks/{{task.refID}}\" target=\"_blank\" >X-ray</md-button>\n					<md-button ng-click=\"vm.restoreTask(task)\" class=\"md-raised md-primary\">Restore</md-button>\n				</div>\n			</div>\n		</md-content>\n	</div>\n");
$templateCache.put("app/admin-client-manager/client-billing.tmpl.html","<div layout=\"column\" layout-fill>\n	        <md-content ng-if=\"vm.clientPackageService.billingModuleState == \'activity\'\" class=\"md-padding package-activity\" layout=\"row\" layout-align=\"center start\" style=\"height: 100%;\">\n	        	<div flex=\"100\" style=\"max-width: 800px;\">\n	        		<div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-40\">\n	        			<div layout=\"row\" flex=\"nogrow\" layout-align=\"start center\">\n	        				<md-button ng-if=\"vm.closedCount > 0\" flex=\"nogrow\" ng-click=\"vm.archiveClosedPackages(vm.client.packages)\" class=\"md-warn padding-right-10\"><md-icon md-font-icon=\"zmdi zmdi-archive\"></md-icon> Archive Closed Packages</md-button>\n	        			</div>\n		        		<div layout=\"row\" flex=\"grow\" layout-align=\"end center\">\n		        			<md-button flex=\"nogrow\" ng-click=\"vm.newPackage(vm.client)\" class=\"md-raised md-accent md-split-button padding-right-10\"><md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon> New Package</md-button>\n			            <md-menu ng-if=\"!vm.forms.packageForm.$pristine && !vm.forms.packageForm.$invalid && vm.user.packageTemplates\" md-position-mode=\"target-right bottom\" md-offset=\"0 5\">\n			                <!-- Trigger element is a md-button with an icon -->\n			                <md-button class=\"md-split-button-menu md-raised md-accent\">\n			                		<md-icon ng-Click=\"$mdMenu.open($event)\" aria-label=\"Save Options\" md-font-icon=\"fa fa-caret-down\" style=\"color:#fff; font-size: 12px;\">\n			               		<md-tooltip md-delay=\"1000\">New Package from Template</md-tooltip></md-icon>\n			               </md-button>\n			                <md-menu-content class=\"md-dense\">\n			                	<md-menu-item>\n		                		    <md-button>\n		                		        <strong>From Template:</strong>\n		                		    </md-button>\n			                	</md-menu-item>\n			                    <md-menu-item ng-repeat=\"template in vm.user.packageTemplates | toArray: false | orderBy: [\'-timeStamp\'] track by uid + $index\">\n			                        <md-button ng-click=\"vm.newPackageFromTemplate(template, vm.client)\" aria-label=\"Choose template\" md-no-ink=\"true\">\n			                            {{template.label}}\n			                        </md-button>\n			                    </md-menu-item>\n			                </md-menu-content>\n			            </md-menu>\n			            <md-button  ng-click=\"vm.clientPackageService.billingModuleState = \'invoicing\'; vm.setupState(\'invoicing\')\" class=\"md-primary\">&nbsp;Manage Invoices <md-icon md-font-icon=\"fa fa-angle-right\"></md-icon></md-button>\n		           	</div>\n		          </div>\n		          <!-- empty state -->\n		          <div ng-if=\"vm.numPackages(vm.client.packages) == 0\">\n		          	<p class=\"center padding-top-40\"><md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"font-size: 4em;\"></md-icon></p>\n		            <p class=\"md-title center\"  style=\"padding-top: 1em;\">You don\'t have any active packages running for this client.</p>\n		            <p class=\"md-subhead center\"  style=\" padding-bottom: 2em;\">You\'ll need to create one before you can start logging time. </p>\n		       	</div>\n		            <div ng-if=\"vm.client && vm.numPackages(vm.client.packages) > 0\">\n		            	<client-package ng-if=\"package.status != \'archived\'\" ng-repeat=\"package in vm.client.packages | toArray: false | orderBy: \'-timeStamp\' track by uid + $index\" package=\"package\" client=\"vm.client\"></client-package>\n		            </div>\n		            <div layout=\"row\" layout-align=\"center center\" >\n		            	<md-button flex=\"nogrow\" ng-if=\"!vm.inactivePackages\" ng-click=\"vm.getInactivePackages(vm.client.uid)\"> - Fetch Archived Packages - </md-button>\n		            </div>\n		            <div layout=\"row\" layout-align=\"center center\">\n		            	<md-button flex=\"nogrow\" ng-if=\"vm.inactivePackages\" ng-click=\"vm.hideInactivePackages()\"> - Hide Archived Packages - </md-button>\n		            </div>\n		            <client-package ng-repeat=\"package in vm.inactivePackages | toArray: false | orderBy: \'-timeStamp\' track by uid + $index\" package=\"package\" client=\"vm.client\"></client-package>\n		            <div layout=\"row\" layout-align=\"center center\">\n		            	<md-button flex=\"nogrow\" ng-if=\"vm.inactivePackages\" ng-click=\"vm.hideInactivePackages()\"> - Hide Archived Packages - </md-button>\n		            </div>\n\n		     </div>\n	        </md-content>\n	        <div ng-if=\"vm.clientPackageService.billingModuleState == \'invoicing\'\" style=\"height: 100%;\">\n	        	<invoice-manager style=\"overflow:hidden!important;\" clients=\"vm.clients\" workspace=\"vm.invoiceService.selectedClient\" ng-if=\"vm.invoiceService.invoiceMode == \'manage\'\"></invoice-manager>\n	        	<invoice-editor style=\"overflow:hidden!important;\" clients=\"vm.clients\" workspace=\"vm.invoiceService.selectedClient\" ng-if=\"vm.invoiceService.invoiceMode == \'edit\'\"></invoice-editor>\n	        </div>\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-details.tmpl.html","<detail-board ng-if=\"vm.boardID\" boardid=\"vm.boardID\" client=\"vm.thisClient\"></detail-board>\n");
$templateCache.put("app/admin-client-manager/client-legacy-billing.tmpl.html","\n	<div class=\"no-scrollbar\" ng-if=\"!vm.thisClient.profile.plan.nextCycle\" layout-padding layout-fill>\n	       <md-content style=\"background-color: transparent; position:relative; top: -2em;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n	                <div layout=\"column\" layout-align=\"center center\">\n	                    <h1 class=\"md-display-1\">This Client Workspace Needs Upgraded</h1>\n	                    <p class=\"md-subhead\">Before you can continue, this workspace needs upgraded to Adminja\'s new Billing System</p>\n	                    <p class=\"center\" ng-if=\"vm.thisClient.owner == vm.user.uid\">\n	                    	<md-button flex=\"nogrow\" class=\"md-raised md-accent\" ng-click=\"vm.startBillingUpgrade()\">Upgrade to Package Billing</md-button>\n	                    </p>\n	                    <p class=\"center\" ng-if=\"vm.thisClient.owner != vm.user.uid\">\n	                    	Please ask your team owner to visit this page to upgrade this workspace.\n	                    </p>\n	                </div>\n	       </md-content>\n	</div>\n\n	<div id=\"scroll-h\" >\n\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    BILLING PERIOD LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div class=\"app-item-container hide-for-print\"\n	md-whiteframe=\"2\"\n	layout=\"column\"\n	layout-align=\"start\"\n	>\n	<div class=\"app-item-container-header\">\n		<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n			<div class=\"auto\">\n				<h3>Billing Periods</h3>\n			</div>\n				<md-menu class=\"billing-period-list-controls\" md-position-mode=\"target-right target\" ng-if=\"vm.thisClient.profile.plan.recurrenceType != \'zero\'\">\n				    <!-- Trigger element is a md-button with an icon -->\n				    <md-icon ng-Click=\"$mdMenu.open($event)\" aria-label=\"Billing Period Maintenance\" md-font-icon=\"zmdi zmdi-wrench\" style=\"color:#fff; font-size: 12px;\">\n				        <md-tooltip md-delay=\"1000\">Billing Period Maintenance</md-tooltip></md-icon>\n				    <md-menu-content class=\"md-dense\">\n					    	<md-menu-item>\n					    		<p ng-disabled=\"true\" style=\"width:100%; margin:0; padding: 3px; font-size: 12px; text-align: center;\">\n					    			Missing a Billing Period?\n					    		</p>\n					    	</md-menu-item>\n				        <md-menu-item>\n				            <md-button data-gtm-force-next-period-clicked ng-click=\"vm.checkForPeriod(vm.thisClient)\" aria-label=\"Edit\" md-no-ink=\"true\">\n				                <md-icon md-font-icon=\"zmdi zmdi-wrench\" class=\"button-edit-client\" style=\"font-size: 12px;\">\n				                </md-icon> Force-create the next one\n				            </md-button>\n				        </md-menu-item>\n				    </md-menu-content>\n				</md-menu>\n		</div><!-- // end app-item-container-title-bar -->\n	</div><!-- // end app-item-container-header -->\n\n	<div class=\"app-item-container-items billing-container-items\"\n	layout=\"column\"\n	layout-align=\"start start\"\n	style=\"padding-top:0px; margin-top: 8px;\"\n	>\n\n	<div ng-if=\"vm.thisClient.profile.plan.nextCycle\" ng-hide=\"vm.thisClient.billing\">\n		<p class=\"text-center md-subhead\" style=\"padding: 2em;\" >\n			This client\'s first billing period hasn\'t started yet.<br>It will start on {{vm.thisClient.profile.plan.nextCycle | amDateFormat: vm.settings.longDateFormat}}.\n		</p>\n		<p class=\"text-center md-subhead\" style=\"padding: 2em;\" >\n			If you recentlly added a new Billing Plan to this workspace, click the button below to kick it off.\n		</p>\n		<p class=\"center\" ng-if=\"vm.thisClient.profile.plan.nextCycle\">\n			<md-button data-gtm-force-next-period-clicked ng-click=\"vm.checkForPeriod(vm.thisClient)\" class=\"md-raised md-primary\" aria-label=\"Edit\" md-no-ink=\"true\">\n			     Start Plan\n			</md-button>\n		</p>\n	</div>\n\n	<div ng-if=\"!vm.thisClient.profile.plan.nextCycle\" ng-hide=\"vm.thisClient.billing\">\n		<p class=\"text-center md-subhead\" style=\"padding: 2em;\" >\n			Please set this client\'s next cycle date to start billing.\n		</p>\n		<p class=\"center\"><md-button ng-click=\"vm.editClient(vm.thisClient)\" class=\"md-raised md-accent\">Edit Workspace</md-button></p>\n	</div>\n\n\n\n\n	<billing-period-card ng-if=\"item.uid && item.start && item.end\" ng-repeat=\"item in billing = (vm.thisClient.billing | toArray : false  | orderBy: [\'-start\']) track by $index\" period=\"item\" client=\"vm.thisClient\" index=\"$index\"></billing-period-card>\n</div>\n</div>\n<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n<!-- /////////////////////////////////    BILLING PERIOD VIEW  /////////////////////////////////////////////-->\n<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n<div ng-if=\" vm.thisClient.billingType != \'packages\' && vm.thisClient.owner == vm.user.uid\" class=\"app-item-container billing-period-panel\" layout=\"row\" layout-align=\"center center\">\n	<md-button flex=\"nogrow\" class=\"md-raised md-accent\" ng-click=\"vm.startBillingUpgrade()\">Upgrade to Package Billing</md-button>\n</div>\n\n\n<div class=\"app-item-container billing-period-panel hide-for-print\"\nmd-whiteframe=\"2\"\nlayout=\"column\"\nlayout-align=\"start\"\nng-if=\"vm.clientBillingService.selectedPeriod\"\nstyle=\"background-color: #fff;\"\n>\n<div class=\"app-item-container-header\">\n	<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n		<div class=\"auto\">\n			<h3>Billing Period Detail</h3>\n		</div>\n\n	</div><!-- // end app-item-container-title-bar -->\n</div><!-- // end app-item-container-header -->\n\n<div class=\"sub-panel-details no-scrollbar\"\nlayout=\"column\"\nstyle=\"\"\n>\n<div class=\"sub-panel-details-header\" >\n	<form name=\"vm.periodForm\">\n		<div layout=\"row\">\n			<div flex=\'50\' layout=\'column\' layout-align=\"start start\">\n				<p class=\"md-headline\" style=\"margin-top: 0; line-height: 1.2em;\">\n					{{vm.clientBillingService.selectedPeriod.info.start | amDateFormat:\'MMMM YYYY\'}}<br>\n					<span style=\"font-size: 12px;\">{{vm.clientBillingService.selectedPeriod.info.clientName}}</span>\n				</p>\n				<md-divider></md-divider>\n				<div class=\"billing-period-summary\" layout=\"row\" layout-align=\"end start\">\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Invoiced</h3>\n						<p><span ng-bind-html=\"vm.currency\"></span>{{vm.clientBillingService.selectedPeriod.info.total || 0 | number : 2}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Received</h3>\n						<p><span ng-bind-html=\"vm.currency\"></span>{{vm.clientBillingService.selectedPeriod.info.received || 0 | number: 2}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" >\n						<h3>Balance</h3>\n						<p><span ng-bind-html=\"vm.currency\"></span>{{vm.clientBillingService.selectedPeriod.info.open || 0 | number: 2}}</p>\n					</div>\n				</div>\n			</div>\n\n			<div flex=\'50\' layout=\'column\' layout-align=\'start layout-fill\'>\n				<div layout=\"row\" layout-align=\"start start\" ng-if=\"!vm.editPeriod\">\n					<p flex=\"auto\" style=\"margin-right: 1em;\">\n						<span style=\"font-size: .85em; font-weight: 500;\">Period Start:</span> <br>\n						{{vm.clientBillingService.selectedPeriod.info.start | amDateFormat: vm.settings.amDateFormat}}\n						<span ng-if=\"vm.clientBillingService.selectedPeriod.info.recurrenceType == \'zero\'\" style=\"font-size: .85em;\"><br>{{vm.clientBillingService.selectedPeriod.info.start | amDateFormat: \'h:mm a\'}}</span>\n					</p>\n					<p flex=\"auto\">\n						<span  style=\"font-size: .85em; font-weight: 500;\">Period End:</span>\n						<!-- <span ng-if=\"vm.clientBillingService.selectedPeriod.info.recurrenceType == \'zero\'\" style=\"font-size: .85em; font-weight: 500;\">Expires:</span> -->\n						<br>\n						<span ng-if=\"vm.clientBillingService.selectedPeriod.info.recurrenceType != \'zero\' || !vm.isCurrentPeriod(vm.thisClient, vm.clientBillingService.selectedPeriod)\">\n							 {{vm.clientBillingService.selectedPeriod.info.end | amDateFormat: vm.settings.amDateFormat}}\n						</span>\n						<span ng-if=\"vm.clientBillingService.selectedPeriod.info.recurrenceType == \'zero\' && vm.isCurrentPeriod(vm.thisClient, vm.clientBillingService.selectedPeriod)\">\n							Pending\n							<!-- {{vm.clientBillingService.selectedPeriod.info.expirationDate | amDateFormat: vm.settings.amDateFormat || \'Pending\'}}\n							<span style=\"font-size: .85em;\"><br>{{vm.clientBillingService.selectedPeriod.info.expirationDate | amDateFormat: \'h:mm a\' || \'\'}}</span> -->\n						</span>\n\n					</p>\n					<span flex=\"nogrow\" ng-if=\"!vm.isClientUser\">\n						<md-button style=\"margin-left: 1em;\"  ng-click=\"vm.enableEditPeriod()\"><md-tooltip md-delay=\"1000\">Edit Period Range</md-tooltip><md-icon md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 12px;\"></md-icon></md-button>\n					</span>\n				</div>\n\n				<div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.editPeriod\">\n					<span flex=\"nogrow\"><md-datepicker  md-hide-icons=\"calendar\" ng-model=\"vm.clientBillingService.selectedPeriod.displayStartDate\" ng-change=\"vm.datesChanged()\" md-placeholder=\"Start\"></md-datepicker></span>\n					<span flex=\"nogrow\" style=\"font-size: 18px; padding:0 1em 0 1em;\">-</span>\n					<span flex=\"nogrow\"><md-datepicker  md-hide-icons=\"calendar\" ng-model=\"vm.clientBillingService.selectedPeriod.displayEndDate\" ng-change=\"vm.datesChanged()\" md-placeholder=\"End\"></md-datepicker></span>\n					<!-- <span flex=\"nogrow\" ng-if=\"vm.clientBillingService.selectedPeriod.info.recurrenceType == \'zero\'\"><md-datepicker  md-hide-icons=\"calendar\" ng-model=\"vm.clientBillingService.selectedPeriod.displayEndDate\" ng-change=\"vm.datesChanged()\" md-placeholder=\"End\"></md-datepicker></span> -->\n					<span flex=\"grow\"><md-button class=\"md-button-tiny\" ng-click=\"vm.cancelEditPeriod()\">cancel</md-button></span>\n				</div>\n\n				<div class=\"billing-period-summary\" layout=\"row\" layout-align=\"end start\" style=\"padding-top: 1em;\">\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">\n						<h3 class=\"\">Hours included</h3>\n						<p class=\"\" style=\"margin-top: 0; margin-bottom: 10px;\">\n							<span class=\"small\" ng-if=\"!vm.editingAllocated && vm.isClientUser\">{{vm.clientBillingService.selectedPeriod.info.allocated * 60 | userTimeFormat}} hrs</span>\n							<span class=\"inline-edit-field small\" ng-if=\"!vm.editingAllocated && !vm.isClientUser\" ng-click=\"vm.editAllocated()\">{{vm.clientBillingService.selectedPeriod.info.allocated * 60 | userTimeFormat}} hrs</span>\n							<span class=\"\" ng-if=\"vm.editingAllocated\"><input ng-model=\"vm.tempAllocated\" type=\"number\" style=\"width:60px; margin-left: 5px; margin-right: 5px;\">hrs</span><span ng-if=\"vm.editingAllocated\" style=\"cursor: pointer; background-color: green; color: #fff; padding:5px;\" ng-click=\"vm.updateAllocated(vm.tempAllocated)\">Done</span>\n\n							</span>\n						</p>\n					</div>\n\n					<div flex=\"nogrow\"  class=\"plan-box\">\n						<h3 class=\"\">Logged</h3>\n						<p>{{vm.used() * 60 | userTimeFormat}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\">\n						<h3 class=\"\">Remain</h3>\n						<p>{{vm.remain() * 60 | userTimeFormat}}</p>\n					</div>\n					<div flex=\"nogrow\"  class=\"plan-box\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\">\n						<h3 class=\"\">Total</h3>\n						<p><span ng-bind-html=\"vm.currency\"></span>{{vm.timeCost() | number: 2}}</p>\n					</div>\n				</div>\n\n\n			</div>\n		</div>\n		<div layout=\"column\" layout-align=\"start start\" style=\"margin-bottom: 1em;\" ng-if=\"vm.clientBillingService.selectedPeriod.invoices\">\n			<p class=\"md-subhead\" style=\"font-size: 12px; width: 100%; margin-bottom: 0;\">\n				<strong>Invoices</strong><br>\n							<!-- <md-chips ng-model=\"vm.clientBillingService.selectedPeriod.invoices\" name=\"invoices\" readonly=\"true\" md-removable=\"false\">\n								<md-chip-template ng-click=\"vm.selectInvoice($chip.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == $chip.uid}\"  style=\"cursor: pointer;\">\n									 <span class=\"chip-content\"><md-icon ng-if=\"$chip.balance <= 0\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon> <md-icon md-font-icon=\"zmdi zmdi-receipt\" style=\"color: #fff;\"></md-icon> #{{$chip.number}}  - <span ng-bind-html=\"vm.currency\"></span>{{$chip.total}} - {{$chip.due | amDateFormat: \'DD MMM\'}}</span >\n								</md-chip-template>\n							</md-chips> -->\n			</p>\n			<div class=\"invoice-list\" layout=\"row\" layout-align=\"start start\" layout-wrap >\n				<md-card layout-align=\"start center\" class=\"invoice-item\" ng-click=\"vm.selectInvoice(invoice.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == invoice.uid, \'due\': vm.now > invoice.due && invoice.balance > .5 }\"  style=\"cursor: pointer;\"  ng-repeat=\"invoice in vm.clientBillingService.selectedPeriod.invoices track by invoice.uid\">\n					<span class=\"invoice-number\">#{{invoice.number}}</span><br>\n					<span class=\"invoice-date\">{{invoice.date | amDateFormat: vm.settings.amDateFormat}}</span>\n					<!-- <span class=\"invoice-divider\">&nbsp;</span> -->\n					<span class=\"invoice-total\"><span ng-bind-html=\"vm.currency\"></span>{{invoice.total | number:2}}</span>\n						<!-- <md-icon ng-if=\"invoice.balance < 1\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon>\n						<md-icon ng-if=\"vm.now <= invoice.due && invoice.balance > .5 || !invoice.due && invoice.balance > 0\" md-font-icon=\"zmdi zmdi-receipt\"></md-icon>\n						<md-icon ng-if=\"vm.now > invoice.due && invoice.balance > .5\" md-font-icon=\"zmdi zmdi-receipt\" style=\"color: red;\"></md-icon>-->\n					<md-card-footer class=\"invoice-status\" ng-class=\"{\'due\': vm.now > invoice.due && invoice.balance > .5 , \'paid\': invoice.balance < .5}\">\n						<p ng-if=\"invoice.balance > .5 && vm.now > invoice.due\">\n							Past Due\n						</p>\n						<p ng-if=\"invoice.balance > .5 && vm.now < invoice.due\">\n							Pending\n						</p>\n						<p ng-if=\"invoice.balance < .5\">\n							Paid\n						</p>\n						<!-- <p>{{invoice.balance}}</p> -->\n\n					</md-card-footer>\n				</md-card>\n			</div>\n		</div>\n		<div layout=\"column\" class=\"period-stats\" style=\"margin-top: 1em;\">\n\n			<md-input-container style=\"margin-bottom: 0; margin-top:0; background-color: #fff; border-bottom: none;\" class=\"billing-notes-container\">\n				<textarea ng-model=\"vm.clientBillingService.selectedPeriod.info.notes\"\n				ng-disabled=\"vm.isClientUser\"\n				rows=\"1\"\n				placeholder=\"Notes\"\n				style=\"overflow-y: scroll; font-size: 11px; border-bottom: none;\"\n				class=\"no-scrollbar\"\n				data-gtm-add-billing-period-notes\n				>\n				</textarea>\n			</md-input-container>\n			<div ng-if=\"!vm.periodForm.$pristine && !vm.editingAllocated && !vm.isClientUser\" layout=\"row\" layout-align=\"end center\">\n				<md-button class=\"md-raised md-accent\" ng-click=\"vm.updatePeriod()\" ng-disabled=\"vm.periodForm.$pristine\"   aria-label=\"save changes\"> Save Changes</md-button>\n			</div>\n\n		</div>\n	</form>\n</div>\n\n<div class=\"sub-panel-content\" style=\"padding-bottom: 5em;\">\n\n	<div layout=\"row\">\n		<div flex>\n			<h3 style=\"margin-bottom: 0;\" class=\"md-title\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">Charges</h3>\n			<h3 style=\"margin-bottom: 0;\" class=\"md-title\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\">Time Logged</h3>\n			<p ng-if=\"!vm.isClientUser\" class=\"md-subhead\" style=\"margin-top:0; margin-bottom:0;\">Select items to add them to an invoice.</p>\n		</div>\n		<div flex class=\"text-right\">\n		<!-- 	<md-button ng-if=\"!vm.invoiceService.selectedInvoice && vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.invoiceSelectedLineItems()\" aria-label=\"Invoice Selected\">Invoice Selected Items</md-button>\n			<md-button ng-if=\"vm.invoiceService.selectedInvoice && vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.addSelectedLineItems()\" aria-label=\"Add Selected\">Add Selected Items</md-button> -->\n\n			<md-button class=\"md-button-small\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type != \'retainer\'\" ng-click=\"vm.printTime();\" >\n				<md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n			</md-button>\n\n		</div>\n	</div>\n\n	<!-- header used for both hourly and retainer views...only one difference in the cost/rate label -->\n	<div layout=\"row\" style=\"margin-top: 1em;\" class=\"billing-table-header\" layout-align=\"start start\">\n		<div flex=\"5\" ng-if=\"!vm.isClientUser\" >\n			<md-checkbox  ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllEntries()\" ng-model=\"vm.isAllSelected\" aria-label=\"select\"></md-checkbox>\n			<md-checkbox  ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllTimeEntries()\" ng-model=\"vm.isAllTimeSelected\" aria-label=\"select\"></md-checkbox>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\"><strong>Date</strong></span>\n		</div>\n		<div flex=\"45\">\n			<span class=\"md-subhead\"><strong>Description</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" class=\"md-subhead\"><strong>Rate</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Qty</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Total</strong></span>\n		</div>\n\n	</div>\n\n	<!-- TIME AS SELECTABLE LINE ITEMS////////////////////////////////////////////////////////////////////////////-->\n	<div ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" >\n		<div ng-if=\"entry.logged > 0\" ng-repeat=\"entry in displayedEntries =(vm.timeReportService.report.data | toArray: false | orderBy: [\'-logDate\']) track by entry.uid\" layout=\'row\' layout-align=\"end start\" style=\"cursor: pointer;\">\n			<div flex=\"5\">\n				<!-- <md-checkbox style=\"margin-bottom: 0;\" ng-model=\"entry.selected\" ng-click=\"vm.timeOptionToggled()\" aria-label=\"select\"></md-checkbox> -->\n				<md-checkbox ng-if=\"!entry.invoiced && !entry.pending\" style=\"margin-bottom: 0;\" ng-model=\"entry.selected\" ng-click=\"vm.timeOptionToggled()\" ng-disabled=\"vm.isClientUser\" aria-label=\"select\"></md-checkbox>\n				<md-icon  ng-if=\"entry.invoiced && !entry.pending\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n				<md-icon  ng-if=\"entry.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n			</div>\n			<div flex=\"10\">\n				<span class=\"md-subhead\" ng-click=\"vm.openTime(entry)\"  style=\"font-size: 11px; cursor: pointer;\">{{entry.logDate | amDateFormat: vm.settings.shortDateFormat}} </span>\n			</div>\n			<div flex=\"45\">\n				<span class=\"md-subhead\" ng-click=\"vm.openTime(entry)\" style=\"font-size: 11px; cursor: pointer;\">\n					<span ng-if=\"entry.taskName\">Task: {{entry.taskName}}</span>\n					<span ng-if=\"!entry.taskName || entry.taskName != entry.description\">{{entry.description}}</span>\n				</span>\n			</div>\n			<div flex=\"10\">\n				<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-bind-html=\"vm.currency\"></span>{{vm.entryRate(entry)}}</span>\n			</div>\n			<div flex=\"10\" layout-align=\"center center\">\n				<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logged |userTimeFormat}}</span>\n			</div>\n			<div flex=\"10\" layout-align=\"center center\">\n				<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-bind-html=\"vm.currency\"></span>{{(entry.logged/60) * vm.entryRate(entry) | number: 2}}</span>\n			</div>\n			<div flex=\"10\">\n				&nbsp;\n			</div>\n\n		</div>\n		<div layout=\"row\" layout-align=\"start center\">\n			<p class=\"md-subhead\" style=\"font-size: 11px; font-weight: bold;\">Total logged this period: {{vm.total(displayedEntries) | userTimeFormat}}</p>\n		</div>\n	</div>\n\n	<!-- <div layout=\"row\" layout-align=\"center center\">\n		<md-button ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" flex=\"nogrow\" style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"View Report\">View Report</md-button>\n	</div> -->\n\n	<!-- Line item detail header : ***ONLY USED IN HOURLY VIEW** -->\n	<h3 ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" class=\"md-title\" style=\"margin-top: 1.5em; margin-bottom:0;\">Additional Charges</h3>\n	<p ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" class=\"md-subhead\" style=\"margin-top:0; margin-bottom:0;\">Select items to add them to an invoice.</p>\n\n	<!-- <p ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'hourly\'\" style=\"fontclass=\"md-subhead\">Additional Charges</p> -->\n\n	<div layout=\"row\" layout-align=\"end start\" style=\"margin-top: 1em;\" class=\"billing-table-header\" ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\">\n		<div flex=\"5\" >\n			<md-checkbox  ng-if=\"!vm.isClientUser\" style=\"margin-bottom: 0;\" ng-click=\"vm.toggleAllEntries()\" ng-model=\"vm.isAllSelected\" aria-label=\"select\"></md-checkbox>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\"><strong>Date</strong></span>\n		</div>\n		<div flex=\"45\">\n			<span class=\"md-subhead\"><strong>Description</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'retainer\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n			<span ng-if=\"vm.clientBillingService.selectedPeriod.info.type ==\'hourly\'\" class=\"md-subhead\"><strong>Cost</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Qty</strong></span>\n		</div>\n		<div flex=\'10\'>\n			<span class=\"md-subhead\"><strong>Total</strong></span>\n		</div>\n		<div flex=\'10\'>\n		</div>\n	</div>\n	<!-- //Line item detail header : ***ONLY USED IN HOURLY VIEW** -->\n\n	<!-- LINE ITEM MANAGEMENT /////////////////////////////////////////////////////////////////////////////////////-->\n	<div ng-repeat=\"item in vm.clientBillingService.selectedPeriod.lineItems track by item.uid\" layout=\'row\' layout-align=\"end start\">\n		<div flex=\"5\">\n			<!-- <md-checkbox style=\"margin-bottom: 0;\" ng-model=\"item.selected\" ng-click=\"vm.optionToggled()\" aria-label=\"select\"></md-checkbox> -->\n			<md-checkbox ng-if=\"!item.invoiced && !item.pending && !vm.isClientUser\" style=\"margin-bottom: 0;\" ng-model=\"item.selected\" ng-click=\"vm.optionToggled()\" aria-label=\"select\"></md-checkbox>\n			<md-icon  ng-if=\"item.invoiced && !item.pending\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n\n\n			<md-icon  ng-if=\"item.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\" style=\"padding-left:3px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.date | amDateFormat: vm.settings.shortDateFormat}}</span>\n		</div>\n		<div flex=\"45\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.description | limitTo : 60 : begin}}</span>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-bind-html=\"vm.currency\"></span>{{item.cost}}</span>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\">{{item.quantity}}</span>\n		</div>\n		<div flex=\"10\">\n			<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-bind-html=\"vm.currency\"></span>{{item.cost * item.quantity | number : 2}}</span>\n		</div>\n		<div flex=\"10\">\n			<md-button data-gtm-remove-line-item ng-if=\"!item.invoiced && !vm.isClientUser\" style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.deleteEntry(item)\" aria-label=\"Delete\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n		</div>\n	</div>\n	<form ng-if=\"vm.displayChargeForm && !vm.isClientUser\" name=\"vm.addLineItemForm\" class=\"add-line-item-form\" ng-submit=\"vm.addNewEntry(vm.newEntry)\">\n		<div layout=\"column\" class=\"\" style=\"margin-top: 0; margin-bottom:0;\">\n			<h3 style=\"font-size: 16px; margin: 0 0 1em 0; padding:0;\" class=\"md-title center\">Add a Charge</h3>\n		</div>\n\n		<div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 0; padding-right: 1em;\">\n			<div flex=\"nogrow\">\n				<md-input-container style=\"margin-top: 0;\">\n					<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newEntry.date\" md-placeholder=\"Date\"></md-datepicker>\n				</md-input-container>\n			</div>\n		</div>\n		<div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 0; padding-right: 1em;\">\n			<div flex=\"grow\">\n				<md-input-container style=\"margin-bottom: 0; margin-top: 0;\">\n					<label>Description</label>\n					<input type=\"text\" ng-model=\"vm.newEntry.description\">\n				</md-input-container>\n			</div>\n			<div flex=\'20\' style=\"padding-right: 1em;\">\n				<md-input-container class=\"md-icon-float\" style=\"margin-bottom: 0; margin-top: 0;\">\n					<label>Cost</label>\n					<md-icon style=\"padding-left: 12px;\"><span ng-bind-html=\"vm.currency\"></span></md-icon>\n					<input type=\"text\" ng-model=\"vm.newEntry.cost\" >\n				</md-input-container>\n			</div>\n			<div flex=\'10\' style=\"padding-right: 0em;\">\n				<md-input-container style=\"margin-bottom: 0;margin-top: 0; \">\n					<label>Qty</label>\n					<input type=\"number\" ng-model=\"vm.newEntry.quantity\" ng-init=\"vm.newEntry.quantity = 1\">\n				</md-input-container>\n			</div>\n			<div flex=\'20\'>\n				<!-- <md-input-container style=\"margin-bottom: 0; margin-top: 0; padding-right: 1em;\" class=\"md-icon-float\"> -->\n					<md-icon style=\"padding-left: 12px;\"><span ng-bind-html=\"vm.currency\"></span></md-icon>\n					{{vm.newEntry.cost * vm.newEntry.quantity | number: 2}}\n					<!-- <input  ng-readonly=\"true\" type=\"text\" ng-value=\"vm.newEntry.cost * vm.newEntry.quantity | number: 2\"> -->\n				<!-- </md-input-container> -->\n			</div>\n		</div>\n		<div layout=\"row\" layout-align=\"end center\">\n			<div flex=\'nogrow\' layout-align=\"center center\">\n				<md-button ng-click=\"vm.newEntry = {}; vm.displayChargeForm = false;\">Cancel</md-button>\n				<md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.addNewEntry(vm.newEntry);\" ng-disabled=\"!vm.newEntry.description || !vm.newEntry.cost || !vm.newEntry.quantity \" aria-label=\"Add Line Item\">\n					Add Charge\n				</md-button>\n			</div>\n		</div>\n	</form>\n	<div ng-if=\"!vm.isClientUser\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 1em;\">\n		<md-button data-gtm-add-line-item class=\"md-accent\" ng-if=\"!vm.displayChargeForm\" ng-click=\"vm.displayChargeForm = true\">+ Add a charge</md-button>\n		<md-button data-gtm-add-to-invoice ng-if=\"!vm.invoiceService.selectedInvoice\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.invoiceSelectedLineItems()\" aria-label=\"Invoice Selected\">Invoice Selected Items</md-button>\n		<md-button data-gtm-add-to-invoice ng-if=\"vm.invoiceService.selectedInvoice\" class=\"md-accent md-raised\" ng-disabled=\"!vm.areInvoiceItemsSelected()\" ng-click=\"vm.addSelectedLineItems()\" aria-label=\"Add Selected\">Add Selected Items</md-button>\n	</div>\n\n\n	<!-- only show time detail for reference/printing if we are on a retainer plan -->\n	<div ng-if=\"vm.clientBillingService.selectedPeriod.info.type == \'retainer\'\">\n		<md-divider style=\"margin-top: 1em;\"></md-divider>\n		<div layout=\"row\" layout-align=\"start center\">\n			<div flex>\n				<h3 class=\"md-title\">Time Logged This Period</h3>\n			</div>\n			<div flex class=\"text-right\">\n				<md-button class=\"md-button-small\" ng-click=\"vm.printTime();\" >\n					<md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n				</md-button>\n			</div>\n		</div>\n		<div layout=\"row\" layout-align=\"end start\" style=\"margin-top: 1em;\" class=\"billing-table-header\">\n			<div flex=\"10\" style=\"padding-left: .5em;\">\n				<span class=\"md-subhead\"><strong>Date</strong></span>\n			</div>\n			<div flex>\n				<span class=\"md-subhead\"><strong>Description</strong></span>\n			</div>\n			<div flex=\'15\'>\n				<span class=\"md-subhead\"><strong>Logged</strong></span>\n			</div>\n		</div>\n\n		<div ng-click=\"vm.openTime(entry)\" ng-repeat=\"entry in displayedEntries = (vm.timeReportService.report.data | toArray: false | orderBy: [\'-logDate\']) track by entry.uid\" layout=\'row\' layout-align=\"end start\" style=\"cursor: pointer;\">\n			<div flex=\"10\">\n				<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logDate | amDateFormat: vm.settings.shortDateFormat}}</span>\n			</div>\n			<div flex>\n				<span class=\"md-subhead\" style=\"font-size: 11px;\">\n					<span ng-if=\"entry.taskName\">Task: {{entry.taskName}}<br></span>\n					<span ng-if=\"!entry.taskName || entry.taskName != entry.description\">{{entry.description}}</span>\n				</span>\n			</div>\n			<div flex=\"15\" layout-align=\"center center\">\n				<span class=\"md-subhead\" style=\"font-size: 11px;\">{{entry.logged |userTimeFormat}}</span>\n			</div>\n\n		</div>\n		<div layout=\"row\" layout-align=\"start center\">\n			<p class=\"md-subhead\" style=\"font-size: 11px; font-weight: bold;\">Total logged this period: {{vm.total(displayedEntries) | userTimeFormat}}</p>\n		</div>\n		<div layout=\"row\" layout-align=\"center center\">\n\n				<!-- <md-button style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"View Time Report\">View Report</md-button> -->\n\n			</div>\n		</div>\n	</div>\n</div>\n</div><!-- period detail -->\n\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<!-- /////////////////////////////////    INVOICE VIEW  /////////////////////////////////////////////-->\n		<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n		<div class=\"app-item-container invoice-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-if=\"vm.invoiceService.selectedInvoice\"\n		style=\"background-color: #fff; margin-right: 4em;\"\n		hotkey=\"{esc: vm.cancelInvoice}\"\n		>\n		<div class=\"app-item-container-header\"  >\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.thisClient.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>{{vm.invoiceService.selectedInvoice.info.invoiceLabel}} #{{vm.invoiceService.selectedInvoice.info.number}} - {{vm.thisClient.profile.fullName}}</h3>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"invoice-container\"layout=\"column\" style=\"overflow-y: scroll;\">\n			<!-- ///// Invoice -->\n			<div class=\"invoice\" layout=\"column\" print-section>\n				<div>\n					<div class=\"invoice-header\" layout=\"row\" layout-align=\"start start\">\n						<div flex=\"60\">\n							<p class=\"md-title\"><span style=\"color: red; font-weight: bold;\" ng-if=\"!vm.invoiceService.selectedInvoice.uid\">Draft </span>{{vm.invoiceService.selectedInvoice.info.invoiceLabel}} #\n								<span ng-if=\"!vm.isClientUser\" class=\"inline-edit-field small\" inline-edit=\"vm.invoiceService.selectedInvoice.info.number\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n								<span ng-if=\"vm.isClientUser\" class=\"\" >{{vm.invoiceService.selectedInvoice.info.number}}</span>\n								<span ng-if=\"vm.invoiceService.selectedInvoice.info.due < vm.now && vm.invoiceDue() > 0\" style=\"color: red;\">Past Due</span>\n\n							</p>\n							<p class=\"md-subhead\" ng-if=\"userSettings.isAdmin == true\"><a href=\"{{vm.fbConfig.dataURL}}invoices/{{vm.invoiceService.selectedInvoice.uid}}\" target=\"_blank\">X-ray</a></p>\n							<p class=\"md-subhead recipient-address\">\n								<strong>Bill to:</strong><br>\n								<div ng-if=\"!vm.isClientUser\">\n									<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.name\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n									<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.address\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n									<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.city\" inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>,\n									<span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.state\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n									<span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.postal\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n									<span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.country\"  inline-edit-callback=\"vm.updateInvoice()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n								</div>\n								<div ng-if=\"vm.isClientUser\">\n									{{vm.invoiceService.selectedInvoice.info.recipient.name}}<br>\n									{{vm.invoiceService.selectedInvoice.info.recipient.address}}<br>\n									{{vm.invoiceService.selectedInvoice.info.recipient.city}}, {{vm.invoiceService.selectedInvoice.info.recipient.state}} {{vm.invoiceService.selectedInvoice.info.recipient.postal}}<br>\n									{{vm.invoiceService.selectedInvoice.info.recipient.country}}\n								</div>\n							</p>\n						</div>\n						<div flex layout=\"column\" layout-align=\"none end\">\n\n							<img ng-if=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\">\n							<md-input-container class=\"hide-for-print\" style=\"margin-top: 1em; margin-bottom: 0;\">\n								<label>Invoice Date</label>\n								<md-datepicker ng-disabled=\"vm.isClientUser\"  class=\"md-indigo-theme md-primary\" ng-change=\"vm.updateInvoiceDate()\" ng-model=\"vm.invoiceService.selectedInvoice.info.date\" md-placeholder=\"\" md-current-view=\"month\"></md-datepicker>\n							</md-input-container>\n\n							<md-input-container class=\"hide-for-print\" style=\"margin-top: .5em; margin-bottom: 0;\">\n								<label>Due</label>\n								<md-datepicker ng-disabled=\"vm.isClientUser\"  class=\"hide-for-print md-indigo-theme md-primary\" ng-change=\"vm.updateInvoice()\" ng-model=\"vm.invoiceService.selectedInvoice.info.due\" md-placeholder=\"Due\" md-current-view=\"month\"></md-datepicker>\n							</md-input-container>\n\n							<p class=\"text-right\" print-only>Issued: {{vm.invoiceService.selectedInvoice.info.date | amDateFormat: vm.settings.amDateFormat}}<br>\n								Due: {{vm.invoiceService.selectedInvoice.info.due | amDateFormat: vm.settings.amDateFormat}}\n							</p>\n\n\n						</div>\n					</div><!-- // invoice-header -->\n				</div>\n				<div class=\"invoice-body\" style=\"padding-top: 1em;\">\n					<div layout=\'row\' layout-align=\"start start\" class=\"invoice-table-header\">\n						<div flex class=\"invoice-column-date\">\n							Date\n						</div>\n						<div flex class=\"invoice-column-description\">\n							Description\n						</div>\n						<div flex class=\"invoice-column-rate\">\n							Cost/Rate\n						</div>\n						<div flex class=\"invoice-column-quantity\">\n							Qty\n						</div>\n						<div flex=\"15\" class=\"text-center\" class=\"invoice-column-total\">\n							Total\n						</div>\n\n					</div>\n					<div ng-repeat=\"entry in vm.invoiceService.selectedInvoice.time | orderBy: [\'-logDate\'] track by entry.uid\">\n						<div layout=\'row\' layout-align=\"start start\" ng-if=\"!entry.editing\" class=\"invoice-line-item\" >\n							<div flex class=\"invoice-column-date\" style=\"padding-left: 15px;\">\n								<span class=\"md-subhead\" style=\"font-size: 12px;\">{{entry.logDate | amDateFormat: vm.settings.shortDateFormat}}</span>\n							</div>\n							<div flex class=\"invoice-column-description\">\n								<span class=\"md-subhead\" style=\"font-size: 12px;\">\n									<span ng-if=\"entry.taskName\"><strong>Task:</strong> <u>{{entry.taskName}}</u><br></span>\n									{{entry.description}}\n								</span>\n							</div>\n							<div flex class=\"invoice-column-rate\">\n								<span class=\"md-subhead\" style=\"font-size: 12px;\"><span ng-bind-html=\"vm.currency\"></span>\n									{{entry.rate}}\n								</span>\n							</div>\n							<div flex layout-align=\"center center\" class=\"invoice-column-quantity\">\n								<span class=\"md-subhead\" style=\"font-size: 12px;\">{{entry.logged | userTimeFormat}}</span></span>\n							</div>\n\n							<div flex=\"15\" class=\"text-center\" class=\"invoice-column-total\">\n								<span class=\"md-subhead\" style=\"font-size: 12px;\"><span ng-bind-html=\"vm.currency\"></span>{{(entry.logged/60) * entry.rate | number: 2}}</span>\n							</div>\n							<div flex=\"nogrow\" class=\"invoice-item-controls\" layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.invoiceService.selectedInvoice.sent\" >\n									<md-icon flex=\"nogrow\" ng-click=\"vm.editInvoiceTimeEntry(entry)\" md-font-icon=\"zmdi zmdi-edit\">\n										<md-tooltip md-delay=\"1000\">Edit entry</md-tooltip>\n									</md-icon>\n									<md-icon flex=\"nogrow\" ng-click=\"vm.removeInvoiceTimeEntry(entry)\"  md-font-icon=\"zmdi zmdi-close\">\n										<md-tooltip md-delay=\"1000\">Remove from invoice</md-tooltip>\n									</md-icon>\n							</div>\n						</div>\n						<form name=\"vm.editTimeForm\" ng-if=\"entry.editing && !vm.isClientUser\" style=\"padding: .5em; margin: 1em 0 1em 0; background-color: #efefef; border-radius: 4px;\">\n							<div layout=\"row\" layout-align=\"center center\">\n								<p class=\"md-subhead text-center\" style=\"margin-top:0;\">Modify entry</p>\n							</div>\n							<div layout=\"row\" layout-align=\"start start\">\n								<md-input-container flex=\"auto\" style=\"margin-bottom:0;\">\n									<label>Description</label>\n									<input ng-model=\"vm.editTimeItem.description\" required>\n								</md-input-container>\n								<md-input-container flex=\"1\" style=\"max-width: 100px; margin-bottom: 0;\">\n									<label>Hrs</label>\n									<input ng-model=\"vm.editTimeItem.hours\" type=\"number\" required>\n								</md-input-container>\n								<md-input-container flex=\"1\" style=\"max-width: 100px; margin-bottom: 0;\">\n									<label>Min</label>\n									<input ng-model=\"vm.editTimeItem.minutes\" type=\"number\" required>\n								</md-input-container>\n								<md-input-container flex=\"1\" layout=\"row\" style=\"max-width: 100px; margin-bottom: 0;\">\n									<label>Rate</label>\n									<span ng-bind-html=\"vm.currency\"></span>\n									<input ng-model=\"vm.editTimeItem.rate\" type=\"number\" required>\n								</md-input-container>\n								<div class=\"invoice-item-controls\" layout=\"row\" layout-align=\"end center\" style=\"padding-top: 1.5em;\">\n									<md-button ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"font-size: 10px;min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.cancelEditInvoiceTimeEntry(entry)\" aria-label=\"Cancel\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n								<md-button ng-disabled=\"vm.editLineItemForm.$invalid\" ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"font-size: 10px;min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small md-accent md-raised\" style=\"margin:0;\" ng-click=\"vm.updateTimeEntry(entry)\" aria-label=\"Update\"><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon></md-button>\n								</div>\n\n							</div>\n						</form>\n\n					</div>\n				<div ng-repeat=\"item in vm.invoiceService.selectedInvoice.lineItems track by item.uid\" >\n					<div layout=\'row\' layout-align=\"start start\" ng-if=\"!item.editing\" class=\"invoice-line-item\">\n						<div flex style=\"padding-left: 15px;\" class=\"invoice-column-date\">\n							<span class=\"md-subhead\" style=\"font-size: 12px;\">{{item.date | amDateFormat: vm.settings.shortDateFormat}}</span>\n						</div>\n						<div flex class=\"invoice-column-description\">\n							<span class=\"md-subhead\" style=\"font-size: 12px;\" >\n								{{item.description}}\n							</span>\n						</div>\n						<div flex class=\"invoice-column-rate\">\n							<span class=\"md-subhead\" style=\"font-size: 12px;\" >\n								<span ng-bind-html=\"vm.currency\"></span>{{item.cost}}\n							</span>\n						</div>\n						<div flex class=\"invoice-column-quantity\">\n							<span class=\"md-subhead\" style=\"font-size: 12px;\">\n								{{item.quantity}}\n							</span>\n						</div>\n						<div flex=\"15\" class=\"text-center\" class=\"invoice-column-total\">\n							<span class=\"md-subhead\" style=\"font-size: 11px;\"><span ng-bind-html=\"vm.currency\"></span>{{item.cost * item.quantity | number: 2}}</span>\n						</div>\n						<div flex=\"nogrow\" class=\"invoice-item-controls\" layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.invoiceService.selectedInvoice.sent && !vm.isClientUser\" >\n							<md-icon flex=\"nogrow\" ng-click=\"vm.editInvoiceLineItem(item)\" md-font-icon=\"zmdi zmdi-edit\">\n								<md-tooltip md-delay=\"1000\">Edit item</md-tooltip>\n							</md-icon>\n							<md-icon flex=\"nogrow\" ng-click=\"vm.removeInvoiceLineItem(item)\"  md-font-icon=\"zmdi zmdi-close\">\n								<md-tooltip md-delay=\"1000\">Remove from invoice</md-tooltip>\n							</md-icon>\n						</div>\n					</div>\n					<form name=\"vm.editLineItemForm\" ng-if=\"item.editing && !vm.isClientUser\" style=\"padding: .5em; margin: 1em 0 1em 0; background-color: #efefef; border-radius: 4px;\">\n						<div layout=\"row\" layout-align=\"center center\">\n							<p class=\"md-subhead text-center\" style=\"margin-top:0;\">Modify item</p>\n						</div>\n						<div layout=\"row\" layout-align=\"start start\">\n							<md-input-container flex=\"auto\" style=\"margin-bottom:0;\">\n								<label>Description</label>\n								<input ng-model=\"vm.editLineItem.description\" required>\n							</md-input-container>\n							<md-input-container flex=\"1\" style=\"max-width: 100px; margin-bottom: 0;\">\n								<label>Qty</label>\n								<input ng-model=\"vm.editLineItem.quantity\" type=\"number\" required>\n							</md-input-container>\n\n							<md-input-container flex=\"1\" layout=\"row\" style=\"max-width: 100px; margin-bottom: 0;\">\n								<label>Cost</label>\n								<span ng-bind-html=\"vm.currency\"></span>\n								<input ng-model=\"vm.editLineItem.cost\" type=\"number\" required>\n							</md-input-container>\n							<div flex=\"10\" class=\"hide-for-print\" layout=\"row\" layout-align=\"end end\" style=\"padding-top: 1.5em;\">\n								<md-button ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"font-size: 10px;min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small\" style=\"margin:0;\" ng-click=\"vm.cancelEditInvoiceLineItem(item)\" aria-label=\"Cancel\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n								<md-button ng-disabled=\"vm.editLineItemForm.$invalid\" ng-if=\"!vm.invoiceService.selectedInvoice.sent\" style=\"font-size: 10px;min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small md-accent md-raised\" style=\"margin:0;\" ng-click=\"vm.updateLineItem(item)\" aria-label=\"Update\"><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon></md-button>\n							</div>\n\n						</div>\n					</form>\n				</div>\n\n				<div layout=\'column\' style=\"margin-top: 2em;\">\n					<p flex class=\"text-right\" style=\"margin:0;\">\n						Subtotal:&nbsp; <span ng-bind-html=\"vm.currency\"></span>{{vm.invoiceSubTotal() |number: 2}}\n					</p>\n					<p flex class=\"text-right\" style=\"margin:0;\" ng-if=\"vm.invoiceService.selectedInvoice.info.calculateTax\">\n						{{vm.invoiceService.selectedInvoice.info.taxLabel}}({{vm.invoiceService.selectedInvoice.info.taxPercentage}}%):&nbsp; <span ng-bind-html=\"vm.currency\"></span>{{vm.taxTotal() |number: 2}}\n					</p>\n					<p flex class=\"text-right\" style=\"margin:0;\">\n						{{vm.invoiceService.selectedInvoice.info.invoiceLabel}} Amount:&nbsp;<span ng-bind-html=\"vm.currency\"></span>{{vm.invoiceTotal(vm.invoiceSubTotal()) |number: 2}}\n					</p>\n					<p flex ng-if=\"vm.invoiceService.selectedInvoice.showLogged\" class=\"text-right\" style=\"margin-top: 1em;\">\n						Time logged: {{vm.invoiceService.selectedInvoice.logged | userTimeFormat}}hrs<br>\n					   <!-- Remaining: {{(vm.invoiceService.selectedInvoice.allocated * 60) - vm.invoiceService.selectedInvoice.logged | userTimeFormat}}hrs -->\n					</p>\n				</div>\n				<div ng-if=\"vm.invoiceService.selectedInvoice.info.payments\" >\n					<h3 class=\"md-subhead invoice-table-header\">Payments received</h3>\n					<div layout=\"row\" layout-align=\"start start\" ng-repeat=\"payment in vm.invoiceService.selectedInvoice.info.payments | toArray: false | orderBy: \'date\' track by payment.uid\">\n						<div flex=\"15\" style=\"padding-left: 10px;\">\n							<span class=\"md-subhead\" style=\"font-size: 11px;\">{{payment.date | amDateFormat: vm.settings.shortDateFormat}}</span>\n						</div>\n						<div flex>\n							<span class=\"md-subhead\" style=\"font-size: 11px;\">{{payment.notes}}</span>\n						</div>\n						<div flex=\"15\" class=\"text-center\">\n							<span class=\"md-subhead\" style=\"font-size: 11px;\">(<span ng-bind-html=\"vm.currency\"></span>{{payment.amount | number: 2}})</span>\n						</div>\n						<div flex=\"10\" ng-if=\"!vm.isClientUser\" >\n							<md-button style=\"min-height: 24px; line-height: 24px; margin:0;\" class=\"md-button-small hide-for-print\" style=\"margin:0;\" ng-click=\"vm.removePayment(payment)\" aria-label=\"Remove\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n						</div>\n					</div>\n\n				</div>\n				<div layout=\'row\' style=\"margin-top: 1em;\">\n					<p flex class=\"text-right\" style=\"margin:0;\">\n						<strong>Balance Due:&nbsp;</strong><strong><span ng-bind-html=\"vm.currency\"></span>{{vm.invoiceDue() |number: 2}}</strong>\n					</p>\n				</div>\n				<!-- /// Payments -->\n				<form class=\"hide-for-print payment-form\" name=\"vm.paymentForm\" ng-if=\"!vm.isClientUser\" ng-submit=\"vm.addNewPayment(vm.newPayment)\">\n					<div class=\"payments md-padding\" ng-if=\"vm.invoiceService.selectedInvoice.uid\" style=\"margin-top: 1.5em; margin-bottom: 1em;\">\n						<div ng-if=\"vm.invoiceDirty\">\n							<p class=\"center\">Please commit your changes before applying payments.</p>\n						</div>\n\n						<div ng-if=\"!vm.invoiceDirty\">\n							<h3 style=\"margin-top: 0; font-size: 16px;\" class=\"md-title text-center\" >Record Payment</h3>\n\n\n							<div layout=\"row\" layout-align=\"center center\" >\n								<div flex=\"nogrow\">\n									<md-input-container md-no-float  style=\"width:90px;\">\n										<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newPayment.date\" md-placeholder=\"Date\" style=\"width:90px;\"></md-datepicker>\n									</md-input-container>\n								</div>\n								<div flex=\"20\" style=\"min-width: 120px; max-width: 120px;\">\n									<md-input-container md-no-float class=\"md-icon-float\" >\n										<md-icon style=\"padding-left: 12px;\"><span ng-bind-html=\"vm.currency\"></span></md-icon>\n										<input type=\"number\" step=\"0.01\" ng-model=\"vm.newPayment.amount\" placeholder=\"Amount\">\n									</md-input-container>\n								</div>\n								<div flex=\"auto\">\n									<md-input-container md-no-float>\n										<input type=\"text\" ng-model=\"vm.newPayment.notes\" placeholder=\"Method &amp; Notes\">\n									</md-input-container>\n								</div>\n\n							</div>\n							<div layout=\"row\" layout-align=\"end center\">\n								<md-button flex=\"nogrow\" type=\"submit\" style=\"margin-top: 0;\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newPayment.notes || !vm.newPayment.amount || !vm.newPayment.date \" aria-label=\"Apply Payment\">\n									Apply Payment\n								</md-button>\n							</div>\n						</div>\n					</div><!-- // End Payments -->\n				</form>\n\n				<div layout=\"row\" style=\"padding-top: 3em; \">\n					<div flex style=\"padding-right: 3em;\">\n\n						<md-input-container>\n							<textarea ng-disabled=\"vm.isClientUser\" style=\"border-bottom: none;\" rows=\"1\" max-rows=\"4\" ng-change=\"vm.makeDirty()\" ng-model=\'vm.invoiceService.selectedInvoice.info.terms\' placeholder=\"Terms\">\n							</textarea>\n						</md-input-container>\n					</div>\n					<div flex style=\"padding-right: 3em;\">\n						<md-input-container>\n							<textarea ng-disabled=\"vm.isClientUser\" style=\"border-bottom: none;\" rows=\"1\" max-rows=\"4\" ng-change=\"vm.makeDirty()\" ng-model=\'vm.invoiceService.selectedInvoice.info.notes\' placeholder=\"Notes\">\n							</textarea>\n						</md-input-container>\n					</div>\n				</div>\n			</div><!-- // invoice-body -->\n		</div><!-- invoice container -->\n\n\n			<!-- ///// Invoice Controls -->\n			<div class=\"invoice-controls\" layout=\"row\" style=\"width: 100%; background-color: rgba(240,240,240,1);\" layout-align=\"center center\">\n				<md-checkbox  ng-disabled=\"vm.invoiceService.selectedInvoice.uid\" style=\"margin-bottom: 0; font-size: 12px; font-weight: normal;\" ng-if=\"vm.invoiceService.selectedInvoice.type == \'retainer\' && !vm.isClientUser\" ng-model=\"vm.invoiceService.selectedInvoice.showLogged\" ng-true-value=\"true\" ng-false-value=\"false\" aria-label=\"Show hours\">Include time total</md-checkbox>\n				<md-checkbox  ng-if=\"!vm.isClientUser\" style=\"margin-bottom: 0; font-size: 12px; font-weight: normal;\" ng-model=\"vm.invoiceService.selectedInvoice.showRemittance\" ng-true-value=\"true\" ng-false-value=\"false\" aria-label=\"Show hours\">Include Payment Stub</md-checkbox>\n				<md-button flex=\"nogrow\" ng-if=\"vm.invoiceDirty || !vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Cancel</md-button>\n				<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceDirty && vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n				<span flex=\"nogrow\" ng-if=\"vm.invoiceService.selectedInvoice.uid\">\n\n					<!-- <md-button class=\"\" ng-click=\"vm.downloadInvoice()\">Download</md-button>\n						<md-button class=\"\" ng-click=\"vm.sendInvoice()\">Send</md-button> -->\n						<md-button ng-if=\"!vm.deleting && vm.invoiceService.selectedInvoice.pdf.link != \'pending\' && !vm.isClientUser\" class=\"md-button-small\" ng-click=\"vm.showDeleteInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete</md-button>\n						<md-button style=\"margin: 0; padding:0;\" ng-if=\"vm.deleting\" class=\"md-button-small\" ng-click=\"vm.deleting = false\">x</md-button>\n						<md-button ng-if=\"vm.deleting\" class=\"md-raised md-warn\" ng-click=\"vm.deleteInvoice(vm.invoiceService.selectedInvoice)\">Delete this Invoice?</md-button>\n					</span>\n					<!-- <md-button ng-href=\"https://console.firebase.google.com/u/0/project/adminja-staging/database/adminja-staging/data/invoices/{{vm.invoiceService.selectedInvoice.uid}}\">Invoice Data</md-button> -->\n\n					<div ng-if=\"vm.invoiceService.selectedInvoice.uid\">\n						<md-button flex=\"nogrow\" ng-if=\"vm.invoiceDirty\" class=\"md-raised md-accent\" ng-click=\"vm.updateInvoice()\" style=\"margin-right: 3em;\">Commit Changes</md-button>\n						<md-button ng-click=\"vm.preparePDF()\" ng-if=\"!vm.invoiceService.selectedInvoice.pdf.link && !vm.invoiceDirty\" flex=\"nogrow\"  class=\"\"><md-icon md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon>Request PDF</md-button>\n						<md-button ng-click=\"vm.preparePDF()\" ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" flex=\"nogrow\"  class=\"\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px;\"></md-icon>Requesting PDF</md-button>\n						<!-- <md-button ng-disabled=\"true\" ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" flex=\"nogrow\"  class=\"\" style=\"text-align: center;\">Preparing PDF. We will notify you when it is ready.</md-button> -->\n						<!-- <md-progress-linear ng-if=\"vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" class=\"md-accent margin-bottom-10\" md-mode=\"indeterminate\"></md-progress-linear> -->\n						<md-button ng-if=\"vm.invoiceService.selectedInvoice.pdf.link && vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" ng-href=\"{{vm.invoiceService.selectedInvoice.pdf.link}}\" download=\"{{vm.invoiceService.selectedInvoice.pdf.link}}\" target=\"_blank\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>Download PDF</md-button>\n						<md-button ng-if=\"vm.invoiceService.selectedInvoice.pdf.link != \'pending\'\" ng-click=\"vm.emailInvoice(vm.invoiceService.selectedInvoice)\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>Send by Email</md-button>\n					</div>\n					<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceService.selectedInvoice.uid\" class=\"md-raised md-accent\" ng-click=\"vm.saveInvoice()\" style=\"margin-right: 3em;\">Save</md-button>\n					<md-button flex=\"nogrow\" ng-if=\"!vm.invoiceDirty && vm.invoiceService.selectedInvoice.uid && vm.invoiceService.selectedInvoice.pdf.link == \'pending\'\" class=\"\" ng-click=\"vm.cancelInvoice()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n\n				</div>\n			</div>\n		</div><!-- invoice app-item-container -->\n		<!-- // End Invoice View -->\n		<div class=\"app-item-container billing-spacer\" style=\"display:inline-block; width:100px; opacity:0;\">\n			&nbsp;\n		</div>\n\n		</div>\n\n<!-- <div ng-show=\"billing.length == 1 && !vm.user.profile.onboardingFlags.billing\" layout=\"column\" layout-align=\"start center\" style=\"padding-top: 3em;\" class=\"md-padding\">\n	<p class=\"center\">First time working with Billing Periods?</p>\n	<md-button style=\"width: 150px; color: #fff;\" ng-if=\"billing.length == 1\" ng-click=\"vm.showCue(\'-KppUp3ARikBnT5MfMXk\', \'billing\')\">Learn How it Works</md-button>\n</div> -->\n<!-- this is required so we can slide invoice mostly into view. It\'s a hack but the right margin on the app-item-container isn\'t being respected without it-->\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-legacy-tasks.tmpl.html","<div class=\"task-filter-toolbar-container\" hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\"  ng-show=\"vm.showFilterBar\">\n	<md-toolbar palette-background=\"grey:800\" class=\"task-filter-toolbar\">\n		<div class=\"md-toolbar-tools\">\n			<!-- <h2 md-truncate flex=\"nogrow\"></h2> -->\n			<div flex>\n			</div>\n\n\n\n\n			<div flex=\"nogrow\">\n				<h3 style=\"font-weight: 900;\">Sort:</h3>\n			</div>\n			<div flex=\"nogrow\"  class=\"toolbar-section\"  style=\"margin-right: 1em; padding-right: 1em;\">\n				<md-select md-container-class=\"filter-toolbar-select\" class=\"task-filter-select md-no-underline\" ng-change=\"vm.changeSort(vm.sortOption)\" style=\"margin: 0;\" flex=\"nogrow\" placeholder=\"Sort by\" ng-model=\"vm.sortOption\">\n						<md-option value=\'order\'>\n								Manual\n						</md-option>\n						<md-option value=\'duedate\'>\n								Due date\n						</md-option>\n						<md-option value=\'-budget\'>\n								Budget\n						</md-option>\n						<md-option value=\'-logged\'>\n								Time logged\n						</md-option>\n				</md-select>\n			</div>\n			<div ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\">\n				<h3 style=\"font-weight: 900;\">Filter:</h3>\n			</div>\n			<div  class=\"toolbar-section\" ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\" style=\"margin-right: 1em; padding-right: 1em; \">\n				<md-select md-container-class=\"filter-toolbar-select\" class=\"task-filter-select md-no-underline\" style=\"width: 175px; margin: 0;\" flex=\"nogrow\" placeholder=\"Filter Users\" ng-model=\"vm.filterOption\" ng-change=\"vm.filterUser(vm.filterOption)\">\n						<md-option value=\'all\' style=\"border-left: 4px solid #fff;\">\n								<!-- <md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em;\"></md-icon> -->\n								All Team Members\n						</md-option>\n						<md-option ng-repeat=\"member in vm.teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by $index\" ng-value=\"{{member}}\" style=\"border-left: 4px solid {{member.color}};\" >\n								<img flex=\"nogrow\" src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; background-color: {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n								<span class=\"small\">{{member.fullName}}\'s Tasks</span>\n						</md-option>\n				</md-select>\n			</div>\n			<div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n				<md-input-container md-no-float style=\"margin:0; padding: 0;\">\n						<input hotkey=\"{esc: vm.resetTaskSearch}\" class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model-options=\"{debounce: 200}\" ng-model=\"vm.filterText\">\n				</md-input-container>\n					<md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"vm.resetTaskSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n							<md-tooltip md-delay=\"1000\">\n									Reset search\n							</md-tooltip>\n					</md-icon>\n			</div>\n			<div flex=\"nogrow\"  style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-left: 1em;\">\n				<md-switch  ng-model=\"vm.showToday\" ng-change=\"vm.changeSetting(\'showClientTodayPanel\', vm.showToday)\" aria-label=\"Show today panel\" style=\"margin:0;\">\n				Show Today List\n				</md-switch>\n\n			</div>\n			<div flex=\"nogrow\"  style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-left: 1em;\">\n				<md-switch  ng-model=\"vm.showEmptyNewTaskList\" ng-false-value=\"true\" ng-true-value=\"false\" ng-change=\"vm.changeSetting(\'showEmptyNewTaskList\', vm.showEmptyNewTaskList)\" aria-label=\"Show today panel\" style=\"margin:0;\">\n				Hide empty \"New Tasks\" list\n				</md-switch>\n\n			</div>\n			<div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n				<md-switch ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.snoozeFilter\" aria-label=\"Show snoozed tasks\" style=\"margin:0;\">\n				Show snoozed tasks\n				</md-switch>\n\n			</div>\n			<div flex=\"nogrow\"  style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-right: 0;\">\n				<md-switch  ng-change=\"vm.toggleCardCollapse(vm.collapseCards)\" ng-model=\"vm.collapseCards\" aria-label=\"Collapse Cards\" style=\"margin:0;\">\n				Collapse Cards\n				</md-switch>\n			</div>\n				<div flex=\"nogrow\">\n					<md-button class=\"task-filter-toolbar-toggle\" ng-click=\"vm.closeFilterBar()\" style=\"position: relative; right:10px;\">\n						<md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n								<md-tooltip md-delay=\"1000\">\n										Hide Task Filters\n								</md-tooltip>\n						</md-icon>\n					</md-button>\n				</div>\n		</div><!-- toolbar tools -->\n	</md-toolbar>\n</div>\n\n\n<div id=\"scroll-h\">\n		<md-button class=\"task-filter-toolbar-toggle task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!vm.showFilterBar\" ng-click=\"vm.showFilterBar = true\"><md-icon md-font-icon=\"fa fa-search\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n								Show Task Filters\n						</md-tooltip></md-icon></md-button>\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n		dragula=\"\'drag-task\'\"\n		dragula-scope=\"$scope\"\n		ng-if=\"draggingTask\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n		dragula=\"\'drag-task\'\"\n		dragula-scope=\"$scope\"\n		ng-if=\"draggingTask\">\n</div>\n\n<div class=\"scroll-trigger scroll-trigger-left fade\"\n		dragula=\"\'drag-task-panel\'\"\n		dragula-scope=\"$scope\"\n		ng-if=\"draggingPanel\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right fade\"\n		dragula=\"\'drag-task-panel\'\"\n		dragula-scope=\"$scope\"\n		ng-if=\"draggingPanel\">\n</div>\n\n		<today-panel  ng-if=\"vm.showToday\" ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\" client=\"client\" tasks=\"client.tasks\" days=\"0\"></today-panel>\n\n\n		<div class=\"app-item-container\" ng-if=\"vm.showEmptyNewTaskList || newTasks.length > 0\" ng-class=\"{\'collapsed-cards\': vm.collapseCards}\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n				<div class=\"app-item-container-header\" style=\"margin-bottom:6px;\">\n						<div layout=\"row\" layout-align=\"start center\" class=\"app-item-container-title\">\n								<div flex=\"auto\">\n										<h3 style=\"padding-left: 0;\">\n												New Tasks\n										</h3>\n								</div>\n								<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n										<md-button class=\"md-icon-button\" style=\"margin-right: 0;\" ng-click=\"vm.quickTask(vm.clientID, \'Later\')\" style=\"margin:0; width: 25px;\">\n												<md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n														<md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n												</md-icon>\n										</md-button>\n\n										<md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n												<!-- Trigger element is a md-button with an icon -->\n												<md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"List Menu\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n														<md-icon md-font-icon=\"zmdi zmdi-more-vert\">\n																<md-tooltip md-delay=\"1000\">List Menu</md-tooltip>\n														</md-icon>\n												</md-button>\n												<md-menu-content class=\"md-dense\">\n														<md-menu-item>\n																<md-button ng-click=\"vm.newTask(vm.clientID)\">\n																		<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n																</md-button>\n														</md-menu-item>\n\n														<md-menu>\n															    <md-button ng-click=\"$mdMenu.open($event);\">\n															       <md-icon style=\"margin-right: 18px;\" flex=\"nogrow\" md-font-icon=\"fa fa-check-square-o\"></md-icon>\n															       <span flex=\"auto\" style=\"text-align:left;display:inline-block; width:110px;\">New Task from Template</span>\n															       <span flex=\"nogrow\" style=\"text-align:right;\">\n															        <md-icon  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n															       </span>\n															    </md-button>\n\n															    <md-menu-content class=\"md-dense\">\n														                <md-menu-item ng-repeat=\"template in vm.thisClient.taskTemplates | toArray: false | orderBy: order track by $index+template.uid\">\n														                    <md-button ng-click=\"vm.newFromTemplate(template, \'new\')\" md-no-ink=\"true\">\n														                        <span md-truncate>{{template.info.description}}</span>\n														                    </md-button>\n														                </md-menu-item>\n															    </md-menu-content>\n														</md-menu>\n														<md-menu-item>\n																<md-button data-gtm-batch-tasks ng-click=\"vm.batchTasks(vm.clientID)\">\n																		<md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n																</md-button>\n														</md-menu-item>\n														<md-divider>\n														</md-divider>\n														<md-menu-item>\n																<md-button data-gtm-mark-list-complete ng-click=\"vm.markAllComplete(\'Later\')\">\n																		<md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark All Tasks Complete\n																</md-button>\n														</md-menu-item>\n\n														<md-menu-item ng-if=\"admin == \'admin\'\">\n																<md-button data-gtm-delete-all-tasks-in-list ng-click=\"vm.deleteAll(\'Later\')\">\n																		<md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete All Tasks\n																</md-button>\n														</md-menu-item>\n\n\n												</md-menu-content>\n										</md-menu>\n								</div>\n						</div><!-- // end app-item-container-title-bar -->\n				</div><!-- // end app-item-container-header -->\n\n				<div class=\"app-item-container-items\"\n						 dragula=\"\'drag-task\'\"\n						 ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n						 layout-align=\"start start\"\n						 resize=\"{{vm.suppressResize}}\"\n						 panelid=\"Later\"\n						 dragula-scope=\"$scope\"\n						 panelorder=\"0\"\n						 >\n						 <md-card class=\"quickTaskEntry\" ng-if=\"vm.isActiveList(\'Later\')\">\n								 <md-input-container class=\"md-no-underline\" md-no-float >\n										 <textarea type=\"text\" id=\"quickTaskField\" class=\"md-no-underline\" ng-model=\"vm.newQuickTask.info.description\" placeholder=\"\"></textarea>\n								 </md-input-container>\n								 <!-- <md-button palette-background=\"green:600\" class=\"md-raised\" ng-click=\"vm.saveQuickTask(vm.newQuickTask)\">Save</md-button> -->\n						 </md-card>\n						<app-item\n								class=\"task-app-item\"\n								taskid=\"{{item.refID}}\"\n								assignee=\"{{item.assignee}}\"\n								order=\"{{item.order}}\"\n								taskpanel=\"{{item.panel}}\"\n								client=\"{{item.client}}\"\n								ng-repeat=\"item in newTasks track by item.refID+item.order \"\n								>\n						</app-item>\n\n						<!-- <app-item ng-repeat=\"item in vm.thisClient.tasks | toArray |  filter: { \'panel\':\'Later\' || \'Backlog\' } | filter: {\'status\': \'open\'} | filter: laterFilter | orderBy: \'duedate\' track by item.refID \" /> -->\n				</div>\n		</div>\n		<!-- wrapper to constrain our drag/drop -->\n		<div flex=\"nogrow\" dragula=\"\'drag-task-panel\'\" layout=\"row\" layout-align=\"start\">\n				<!-- ################## -->\n				<!-- custom task panels -->\n				<div class=\"app-item-container task-panel custom-task-panel\"\n							ng-class=\"{\'collapsed-cards\': vm.collapseCards}\"\n							md-whiteframe=\"2\"\n							layout=\"column\"\n							layout-align=\"start\"\n							client=\"{{panel.client}}\"\n							panelid=\"{{panel.uid}}\"\n							ng-if=\"!vm.isWorkspaceClient || (vm.isWorkspaceClient && panel.clientEnabled)\"\n							ng-repeat=\"panel in vm.thisClient.taskpanels| toArray : false | orderBy:\'order\' track by panel.uid\"\n							>\n						<div class=\"app-item-container-header \" style=\"margin-bottom: 6px;\">\n								<div class=\"app-item-container-title panel-drag-handle\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{panel.color}};\">\n\n\n										<h3 style=\"cursor: move; width: 80%\" md-truncate>\n												<span class=\"panel-drag-handle\">{{panel.label}}</span>\n										</h3>\n\n										<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n												<md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.quickTask(vm.clientID, panel.uid)\" style=\"margin:0; width: 25px;\">\n														<md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n																<md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n														</md-icon>\n												</md-button>\n\n												<md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n														<!-- Trigger element is a md-button with an icon -->\n														<md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n																<md-icon md-font-icon=\"zmdi zmdi-more-vert\">\n																		<md-tooltip md-delay=\"1000\">List Menu</md-tooltip>\n																</md-icon>\n														</md-button>\n														<md-menu-content class=\"md-dense\">\n																<md-menu-item>\n																		<md-button ng-click=\"vm.newTask(vm.clientID, panel.uid)\">\n																				<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n																		</md-button>\n																</md-menu-item>\n																<md-menu>\n																	    <md-button ng-click=\"$mdMenu.open($event);\">\n																	       <md-icon style=\"margin-right: 18px;\" flex=\"nogrow\" md-font-icon=\"fa fa-check-square-o\"></md-icon>\n																	       <span flex=\"auto\" style=\"text-align:left;display:inline-block; width:110px;\">New Task from Template</span>\n																	       <span flex=\"nogrow\" style=\"text-align:right;\">\n																	        <md-icon  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n																	       </span>\n																	    </md-button>\n\n																	    <md-menu-content class=\"md-dense\">\n																                <md-menu-item ng-repeat=\"template in vm.thisClient.taskTemplates | toArray: false | orderBy: order track by $index+template.uid\">\n																                    <md-button ng-click=\"vm.newFromTemplate(template, panel)\" md-no-ink=\"true\">\n																                        <span md-truncate>{{template.info.description}}</span>\n																                    </md-button>\n																                </md-menu-item>\n																	    </md-menu-content>\n																</md-menu>\n																<md-menu-item>\n																		<md-button ng-click=\"vm.batchTasks(vm.clientID, panel.uid)\">\n																				<md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n																		</md-button>\n																</md-menu-item>\n																<md-menu-item ng-if=\"!vm.isWorkspaceClient\">\n																		<md-button ng-click=\"vm.editTaskPanel(panel)\">\n																				<md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit List\n																		</md-button>\n																</md-menu-item>\n																<md-menu-item ng-if=\"!listTasks.length && !vm.isWorkspaceClient\" >\n																		<md-button ng-click=\"vm.deleteTaskPanel(panel)\">\n																				<md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete List\n																		</md-button>\n																</md-menu-item>\n																<md-menu-item>\n																		<md-button data-gtm-clone-task-list ng-click=\"vm.duplicateList(panel, listTasks)\">\n																				<md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon> Duplicate this List\n																		</md-button>\n																</md-menu-item>\n																<!-- <md-menu-item ng-if=\"admin == \'admin\'\">\n																		<md-button ng-click=\"vm.exportPanel(panel)\">\n																				<md-icon md-font-icon=\"fa fa-download\"></md-icon> Export List\n																		</md-button>\n																</md-menu-item> -->\n																<md-divider>\n																</md-divider>\n																<md-menu-item ng-if=\"!vm.isWorkspaceClient\">\n																		<md-button ng-click=\"vm.markAllComplete(panel.uid)\">\n																				<md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark All Tasks Complete\n																		</md-button>\n																</md-menu-item>\n																<md-menu-item ng-if=\"admin == \'admin\' && !vm.isWorkspaceClient\">\n																		<md-button ng-click=\"vm.deleteAll(panel.uid)\">\n																				<md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete All Tasks\n																		</md-button>\n																</md-menu-item>\n\n														</md-menu-content>\n												</md-menu>\n										</div>\n								</div><!-- // end app-item-container-title-bar -->\n						</div><!-- // end app-item-container-header -->\n\n						<div class=\"app-item-container-items\"\n								 ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n								 layout-align=\"start start\"\n								 resize=\"{{vm.suppressResize}}\"\n								 dragula=\"\'drag-task\'\"\n								 dragula-scope=\"$scope\"\n								 panelid=\"{{panel.uid}}\"\n								 panelorder=\"{{panel.order}}\"\n								 >\n								<md-card class=\"quickTaskEntry\" ng-if=\"vm.isActiveList(panel.uid)\">\n										<md-input-container class=\"md-no-underline\" md-no-float >\n												<textarea type=\"text\" id=\"quickTaskField\" class=\"md-no-underline\" ng-model=\"vm.newQuickTask.info.description\" placeholder=\"\"></textarea>\n										</md-input-container>\n										<!-- <md-button palette-background=\"green:600\" class=\"md-raised\" ng-click=\"vm.saveQuickTask(vm.newQuickTask)\">Save</md-button> -->\n								</md-card>\n								<app-item\n										class=\"task-app-item\"\n										taskid=\"{{item.refID}}\"\n										assignee=\"{{item.assignee}}\"\n										order=\"{{item.order}}\"\n										taskpanel=\"{{item.panel}}\"\n										client=\"{{item.client}}\"\n										ng-repeat=\"item in listTasks = (vm.thisClient.tasks| toArray  : false |   filter: {\'panel\' : panel.uid} | filter: customBucketFilter | filter: snoozeFilter | orderBy:vm.sortOption) track by item.refID+item.order\" />\n\n						</div>\n				</div>\n				<!-- / custom task panels -->\n		</div><!-- / wrapper to constrain our drag/drop -->\n\n\n		<div ng-show=\"!vm.settings.hideCompletedPanel\" class=\"app-item-container completed-item-container\"  ng-class=\"{\'collapsed-cards\': vm.collapseCards}\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n				<div class=\"app-item-container-header\" style=\"margin-bottom: 6px;\">\n						<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\">\n								<div flex=\"auto\">\n										<h3 class=\"\" >\n												<span>Recently Completed</span>\n										</h3>\n\n								</div>\n								<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n									<md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n											<!-- Trigger element is a md-button with an icon -->\n											<md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n													<md-icon md-font-icon=\"zmdi zmdi-more-vert\">\n															<md-tooltip md-delay=\"1000\">List Menu</md-tooltip>\n													</md-icon>\n											</md-button>\n											<md-menu-content class=\"md-dense\">\n													<md-menu-item ng-if=\"!vm.isWorkspaceClient\">\n															<md-button  ng-click=\"vm.expireCompleted(vm.thisClient.tasks)\">\n																	<md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-archive\" >\n																			<md-tooltip md-delay=\"1000\">Archive Completed Tasks</md-tooltip>\n																	</md-icon>\n																	Archive Completed Tasks\n															</md-button>\n													</md-menu-item>\n													<md-menu-item ng-if=\"!vm.isWorkspaceClient\">\n														<md-button ng-click=\"vm.loadArchived(vm.thisClient.uid)\">\n															<md-icon md-font-icon=\"zmdi zmdi-open-in-browser\">\n																<md-tooltip md-delay=\"1000\">Browse Archived Tasks</md-tooltip>\n															</md-icon>\n															Browse Archived Tasks\n														</md-button>\n													</md-menu-item>\n											</md-menu-content>\n									</md-menu>\n									</div>\n						</div><!-- // end app-item-container-title-bar -->\n				</div><!-- // end app-item-container-header -->\n\n				<div class=\"app-item-container-items drag-container\"\n						 ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n						 layout-align=\"start start\"\n						 resize=\"{{vm.suppressResize}}\"\n						 >\n						<app-item\n								taskid=\"{{item.refID}}\"\n								assignee=\"{{item.assignee}}\"\n								class=\"task-app-item\"\n								ng-repeat=\"item in vm.thisClient.tasks| toArray  : false  | filter: userFilter | filter: vm.filterText | filter: {status:\'closed\'} | orderBy: \'closedDate\':true track by $index + item.refID\"\n								/>\n				</div>\n		</div>\n		<div  ng-if=\"vm.archivedTasks\" class=\"app-item-container archived-item-container\"  ng-class=\"{\'collapsed-cards\': vm.collapseCards}\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n				<div class=\"app-item-container-header\" style=\"margin-bottom: 6px;\">\n						<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\">\n								<div flex=\"auto\">\n										<h3 class=\"\" >\n												<span>Archived (within last 30 days)</span>\n										</h3>\n\n								</div>\n								<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n									<md-button class=\"md-icon-button\" ng-click=\"vm.archivedTasks = null\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n									</div>\n						</div><!-- // end app-item-container-title-bar -->\n				</div><!-- // end app-item-container-header -->\n\n				<div class=\"app-item-container-items drag-container\"\n						 ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n						 layout-align=\"start start\"\n						 resize=\"{{vm.suppressResize}}\"\n						 >\n						<app-item\n								taskid=\"{{item.refID}}\"\n								assignee=\"{{item.assignee}}\"\n								class=\"task-app-item\"\n								ng-repeat=\"item in vm.archivedTasks| toArray  : false  | filter: userFilter | filter: vm.filterText | filter: {status:\'closed\'} | orderBy: \'closedDate\':true track by item.refID\"\n								/>\n				</div>\n		</div>\n<!--\n				<md-content ng-show=\"!vm.thisClient.taskpanels\" class=\"account-card-container\" style=\"background-color: transparent;\">\n				<div class=\"engraved-box\"  style=\"width: 400px; margin: 0 auto 0 auto;\">\n						<h3 style=\"text-align: center;\">You don\'t have any Task Lists yet.</h3>\n						<p style=\"text-align: center;\">Click <strong>New List</strong> to add your first.</p>\n						<p style=\"text-align: center;\">\n						<md-button ng-click=\"vm.newTaskPanel(vm.thisClient)\" style=\"margin-top: 1em;\">\n								+ New List\n						</md-button>\n						</p>\n				</div>\n				</md-content> -->\n\n\n		<div ng-if=\"!vm.isWorkspaceClient\" layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px; padding-left: 0px; padding-right: 100px;\">\n				<md-button  class=\"\" ng-click=\"vm.newTaskPanel(vm.thisClient)\" style=\"width: 200px;\">\n						+ New List\n				</md-button>\n		</div>\n\n\n\n\n\n\n\n\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-manager-clients.tmpl.html","<div style=\"background-color: #bbb; height: 100%; overflow: hidden;\" layout=\"column\" layout-align=\"start layout-fill\">\n	<div layout=\"row\" layout-align=\"center center\" class=\"time-report-controls scroll-up\" dragula=\"\'client-list-sort\'\" dragula-scope=\"$scope\" style=\"border-bottom: 1px solid #666; width: 100%;\">\n		<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showAccountChooser\">\n\n			<p class=\"md-subhead\" style=\"margin:0 1em 0 1em;\">\n				Account:\n			</p>\n			<md-select flex=\"nogrow\" ng-model=\"vm.selectedAccount\" ng-change=\"vm.selectAccount(vm.selectedAccount, true)\" style=\"margin-top: 0; margin-bottom: 0;\">\n				<md-option ng-repeat=\"team in vm.managedTeams | toArray: false track by $index + team.ownerID\" ng-value=\"team.ownerID\">\n					{{team.name}}\n				</md-option>\n			</md-select>\n		</div>\n\n		<div flex=\"auto\" layout=\"row\" layout-align=\"center center\" style=\"max-width: 1024px;\">\n			<p hide-xs hide-sm class=\"md-subhead\" style=\"margin-right: 1em;\" ng-if=\"vm.selectedAccount == vm.user.uid\">Using <span>{{vm.numClients(vm.selectedClients)}}</span> of <span style=\"\" ng-if=\"vm.limits.clients < 200\">{{vm.limits.clients}}</span> <span  ng-if=\"vm.limits.clients > 200\">unlimited</span> Workspaces</p>\n			<md-button class=\"md-accent md-raised\" ng-click=\"vm.newWorkspace(vm.selectedAccount)\" >\n			    + New Workspace\n			</md-button>\n		</div>\n		<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n			<md-button ng-class=\"{\'active\' : vm.spacesView ==\'active\'}\" no-ink ng-click=\"vm.toggleView(\'active\')\" class=\"md-button-small\">Active</md-button>\n			<md-button  ng-class=\"{\'active\' : vm.spacesView ==\'archived\'}\" no-ink ng-click=\"vm.toggleView(\'archived\')\" class=\"md-button-small\">Archived</md-button>\n			<md-divider hide-xs hide-sm></md-divider>\n			<!-- <md-button hide-xs hide-sm class=\"md-button-small\" ng-disabled=\"vm.spacesView == \'archived\'\" ng-click=\"vm.viewMode = \'list\'\" ng-class=\"{\'active\': vm.viewMode == \'list\'}\"><md-icon md-font-icon=\"zmdi zmdi-view-list\"></md-icon><md-tooltip md-delay=\"500\">List view</md-tooltip></md-button> -->\n			<!-- <md-button hide-xs hide-sm class=\"md-button-small\" ng-disabled=\"vm.spacesView == \'archived\'\" ng-click=\"vm.viewMode = \'cards\'\" ng-class=\"{\'active\': vm.viewMode == \'cards\'}\"><md-icon md-font-icon=\"zmdi zmdi-view-module\"></md-icon><md-tooltip md-delay=\"500\">Card view</md-tooltip></md-button> -->\n		</div>\n		<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n			<md-button hide-xs hide-sm class=\"md-button-small\" ng-if=\"vm.spacesView != \'archived\'\" ng-click=\"vm.downloadCSV(vm.allClients, vm.selectedAccount, \'active\')\"><md-icon md-font-icon=\"zmdi zmdi-download\"></md-icon><md-tooltip md-delay=\"500\">Download CSV of Active Workspaces</md-tooltip></md-button>\n			<md-button hide-xs hide-sm class=\"md-button-small\" ng-if=\"vm.spacesView == \'archived\'\" ng-click=\"vm.downloadCSV(vm.archivedClients, vm.selectedAccount, \'archived\')\"><md-icon md-font-icon=\"zmdi zmdi-download\"></md-icon><md-tooltip md-delay=\"500\">Download CSV of Archived Workspace</md-tooltip></md-button>\n		</div>\n	</div>\n	<md-content class=\"small-scrollbar scroll-container\" ng-show=\"vm.allClients.length\" style=\"background-color: rgba(255,255,255,0); margin-bottom: 2em; height: 100%; padding-bottom: 2em; \">\n\n		<div class=\"scroll-down\"  dragula=\"\'client-list-sort\'\" dragula-scope=\"$scope\" ng-if=\"draggingClient\"></div>\n		<div ng-if=\"vm.spacesView == \'active\'\" style=\"position: relative;\">\n\n			<div layout=\"column\" layout-align=\"start center\">\n\n				<!-- we repeat this container twice, once for client workspaces. the other for internal workspaces -->\n				<h3 class=\"center\" style=\"\">Client Workspaces</h3>\n				<!-- <p class=\"md-subhead\" ng-if=\"vm.selectedAccount != vm.user.uid\">This list only contains workspaces you are <strong>assigned</strong> to.</p> -->\n				<div style=\"width: 100%; max-width: 800px; background-color: #fff; padding: 0; margin-bottom: 2em;\" layout=\"column\" dragula=\"\'client-list-sort\'\" class=\"client-list-item-container\">\n					<div class=\"client-list-item\" ng-if=\"vm.allClients && client.clientUsers[vm.user.uid].status != \'active\'\" layout=\"row\" layout-align=\"start center\" uid=\"{{client.uid}}\"  ng-repeat=\"client in vm.allClients | toArray: false | orderBy: [vm.userOrder]  | filter : {status: \'active\'} track by client.uid\"  style=\"border-left: 10px solid {{client.profile.clientColor}}; padding:1em; border-bottom: 1px solid #bbb; background-color: #fff;\">\n						<div flex=\"nogrow\">\n							<md-menu class=\"client-controls\" md-position-mode=\"target-right target\">\n							    <!-- Trigger element is a md-button with an icon -->\n							<md-button ng-Click=\"$mdMenu.open($event)\" class=\"md-icon-button\" style=\"margin-right: 1em;\">\n							    <md-icon  aria-label=\"Client Options\" md-font-icon=\"zmdi zmdi-more-vert\">\n							        <md-tooltip md-delay=\"1000\">Client Options</md-tooltip>\n							   </md-icon>\n							</md-button>\n							    <md-menu-content class=\"md-dense\">\n							        <md-menu-item>\n							            <md-button ng-click=\"vm.editClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-client\">\n							                </md-icon>Edit {{client.profile.fullName}}\n							            </md-button>\n							        </md-menu-item>\n							        <md-menu-item ng-if=\"client.access.users[vm.user.uid]\">\n							            <md-button ng-click=\"vm.viewClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n			                                   			 <md-icon md-font-icon=\"zmdi zmdi-open-in-browser\" class=\"button-view-client\">\n							                </md-icon>Visit this Workspace\n							            </md-button>\n							        </md-menu-item>\n\n		        					        <md-menu-item>\n		        					            <md-button ng-click=\"vm.sendReport(client)\" aria-label=\"Send Report\" md-no-ink=\"true\">\n		        	                                   			 <md-icon md-font-icon=\"fa fa-paper-plane-o\" class=\"button-send-report\"></md-icon>\n		        	                                   			 Send Status Report\n		        					            </md-button>\n		        					        </md-menu-item>\n		        					        <md-menu-item>\n					                     <md-button ng-disabled=\"!isTeamAdmin(client, userID)\" ng-click=\"cloneWorkspace(client.uid, vm.selectedAccount, false)\" aria-label=\"Clone\" md-no-ink=\"true\">\n					                         <md-icon md-font-icon=\"fa fa-clone\" class=\"button-view-client\">\n					                         </md-icon>Clone this Workspace\n					                     </md-button>\n					                 </md-menu-item>\n							        <md-menu-item>\n							            <md-button ng-disabled=\"!vm.isTeamAdmin(client.owner, vm.user.uid)\" ng-click=\"vm.archiveClient(client, $event)\" aria-label=\"Archive\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"fa fa-archive\" class=\"button-view-client\">\n							                </md-icon>Archive this Space\n							            </md-button>\n							        </md-menu-item>\n							        <md-menu-item ng-if=\"userType == \'admin\'\">\n							            <a class=\"md-button\" ng-href=\"{{fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"zmdi zmdi-code\" class=\"button-view-client\"></md-icon> X-ray\n							            </a>\n							        </md-menu-item>\n\n							    </md-menu-content>\n							</md-menu>\n						</div>\n					    <div flex=\"nogrow\" style=\"max-width: 50px;\">\n					        <a class=\"workspace-manager-avatar\" ng-click=\"vm.editClient(client)\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n					            <avatar parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar>\n					        </a>\n					    </div>\n					    <div flex layout=\"column\" layout-align=\"center start\" style=\"padding: 1em;\">\n					        <a ng-click=\"vm.editClient(client)\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n					        	<p style=\"font-size: 1em; margin:0;\">{{client.profile.fullName}}\n					        		<small ng-if=\"client.owner != vm.user.uid && (client.access.users[vm.user.uid] || client.access.admins[vm.user.uid])\" class=\"grey-hint\"><md-icon class=\"grey-hint\" style=\"font-size:  12px; min-width:12px;\" md-font-icon=\"zmdi zmdi-share\"></md-icon> <i>{{::vm.teamLabel(client.owner)}}</i></small>\n					        	</p>\n					        </a>\n					    </div>\n					    <div hide-xs hide-sm flex=\"50\">\n					        <!--<client-summary-strip this-client=\"client\" show-progress=\"true\"></client-summary-strip>-->\n					    </div>\n					    <div flex=\"nogrow\" style=\"padding: 1em;\"><md-icon md-font-icon=\"fa fa-reorder\" class=\"drag-handle\" ng-if=\"vm.selectedAccount == vm.user.uid\" style=\"cursor: move;\"></md-icon></div>\n					    <!-- <div flex=\"nogrow\" style=\"padding: 1em;\" ng-if=\"!vm.isTeamAdmin(client.owner, vm.user.uid)\"><md-icon md-font-icon=\"fa fa-reorder\" style=\"color:#fff;\" ></md-icon></div> -->\n					</div>\n\n\n				</div>\n\n\n					<h3 class=\"center\" style=\"\">Internal Workspaces</h3>\n				<div style=\"width: 100%; max-width: 800px; background-color: #fff; padding: 0; margin-bottom: 3em;\" layout=\"column\" dragula=\"\'client-list-sort\'\" class=\"client-list-item-container\">\n					<div class=\"client-list-item\" ng-if=\"vm.allClients && client.clientUsers[vm.user.uid].status != \'active\'\" layout=\"row\" layout-align=\"start center\" uid=\"{{client.uid}}\" ng-repeat=\"client in vm.allClients | toArray: false | orderBy: [vm.userOrder]   |filter : {status: \'personal\'} track by client.uid\"  style=\"border-left: 10px solid {{client.profile.clientColor}}; padding:1em; border-bottom: 1px solid #bbb; background-color: #fff;\">\n						<div flex=\"nogrow\">\n							<md-menu class=\"client-controls\" md-position-mode=\"target-right target\">\n							    <!-- Trigger element is a md-button with an icon -->\n							<md-button ng-Click=\"$mdMenu.open($event)\" class=\"md-icon-button\" style=\"margin-right: 1em;\">\n							    <md-icon  aria-label=\"Client Options\" md-font-icon=\"zmdi zmdi-more-vert\">\n							        <md-tooltip md-delay=\"1000\">Client Options</md-tooltip>\n							   </md-icon>\n							</md-button>\n							    <md-menu-content class=\"md-dense\">\n							        <md-menu-item>\n							            <md-button ng-click=\"vm.editClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-client\">\n							                </md-icon>Edit {{client.profile.fullName}}\n							            </md-button>\n							        </md-menu-item>\n							        <md-menu-item ng-if=\"client.access.users[vm.user.uid]\">\n							            <md-button ng-click=\"vm.viewClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n										<md-icon md-font-icon=\"zmdi zmdi-open-in-browser\" class=\"button-view-client\">\n\n							                </md-icon>Visit this Workspace\n							            </md-button>\n							        </md-menu-item>\n							        <md-menu-item>\n					                     <md-button ng-disabled=\"!isTeamAdmin(client, userID)\" ng-click=\"cloneWorkspace(client.uid, userID, false)\" aria-label=\"Clone\" md-no-ink=\"true\">\n					                         <md-icon md-font-icon=\"fa fa-clone\" class=\"button-view-client\">\n					                         </md-icon>Clone this Workspace\n					                     </md-button>\n					                 </md-menu-item>\n							        <md-menu-item>\n							            <md-button ng-disabled=\"!vm.isTeamAdmin(client.owner, vm.user.uid)\" ng-click=\"vm.archiveClient(client, $event)\" aria-label=\"Archive\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"fa fa-archive\" class=\"button-view-client\">\n							                </md-icon>Archive this Space\n							            </md-button>\n							        </md-menu-item>\n							        <md-menu-item ng-if=\"userType == \'admin\'\">\n							            <a class=\"md-button\" ng-href=\"{{fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n							                <md-icon md-font-icon=\"zmdi zmdi-code\" class=\"button-view-client\"></md-icon> X-ray\n							            </a>\n							        </md-menu-item>\n\n							    </md-menu-content>\n							</md-menu>\n						</div>\n					    <div flex=\"nogrow\" style=\"max-width: 50px;\">\n					        <a ng-click=\"vm.editClient(client)\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n					            <avatar parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar>\n					        </a>\n					    </div>\n					    <div flex layout=\"column\" layout-align=\"center start\" style=\"padding: 1em;\">\n					        <a ng-click=\"vm.editClient(client)\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n					        	<p style=\"font-size: 1em; margin:0;\">{{client.profile.fullName}}\n					        		<small ng-if=\"client.owner != vm.user.uid && (client.access.users[vm.user.uid] || client.access.admins[vm.user.uid])\" class=\"grey-hint\"> <md-icon class=\"grey-hint\" style=\"font-size:  12px; min-width:12px;\" md-font-icon=\"zmdi zmdi-share\"></md-icon> {{::vm.teamLabel(client.owner)}}</small>\n					        	</p>\n					        </a>\n					    </div>\n					    <div flex=\"50\" hide-xs hide-sm>\n					        <client-summary-strip this-client=\"client\" show-progress=\"true\"></client-summary-strip>\n					    </div>\n					    <div flex=\"nogrow\" style=\"padding: 1em;\"><md-icon md-font-icon=\"fa fa-reorder\" class=\"drag-handle\" ng-if=\"vm.selectedAccount == vm.user.uid\" style=\"cursor: move;\"></md-icon></div>\n					    <!-- <div flex=\"nogrow\" style=\"padding: 1em;\" ng-if=\"!vm.isTeamAdmin(client.owner, vm.user.uid)\"><md-icon md-font-icon=\"fa fa-reorder\" style=\"color:#fff;\" ></md-icon></div> -->\n					</div>\n\n\n				</div>\n				<!-- hack to get vm.selectedClients to contain totals from both lists -->\n				<div style=\"display:none;\" class=\"client-list-item\" layout=\"row\" layout-align=\"start center\" uid=\"{{client.uid}}\" ng-repeat=\"client in vm.selectedClients = (vm.allClients | toArray: false | orderBy: \'order\'  |filter : {status: \'!archived\', owner: vm.selectedAccount}) track by client.uid\"  style=\"padding:1em; border-bottom: 1px solid #bbb; background-color: #fff;\">\n				</div>\n			</div>\n\n		</div>\n		<div ng-if=\"vm.spacesView == \'archived\'\">\n			<div layout=\"row\" layout-align=\"center center\" style=\"\"><h3 class=\"md-title center\" style=\"color: #fff;\">Archived Workspaces</h3></div>\n			<div layout=\"row\" layout-align=\"center center\">\n				<div style=\"width: 100%; max-width: 800px; background-color: #fff; padding: 0; margin-bottom: 3em;\" layout=\"column\" class=\"client-list-item-container\">\n\n					<div class=\"client-list-item\" layout=\"row\" layout-align=\"start center\" uid=\"{{client.uid}}\" ng-repeat=\"client in vm.archivedClients | toArray: false | orderBy: \'-lastArchived\' | filter: { owner: vm.selectedTeam, status: \'archived\' } track by client.uid\"   style=\"border-left: 10px solid {{client.profile.clientColor}}; padding:1em; border-bottom: 1px solid #bbb; background-color: #fff;\">\n						<div flex=\"nogrow\">\n							&nbsp;&nbsp;&nbsp;&nbsp;\n							<!-- <a class=\"md-button\" ng-href=\"{{fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n							    <md-icon md-font-icon=\"zmdi zmdi-code\" class=\"button-view-client\"></md-icon> X-ray\n							</a> -->\n						</div>\n						<div flex=\"nogrow\" style=\"max-width: 50px;\">\n							<avatar  parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar>\n						</div>\n						<div flex=\"auto\" layout=\"column\" layout-align=\"center start\" style=\"padding: 1em;\">\n							<p style=\"font-size: 1em; margin:0;\">{{client.profile.fullName}}</p>\n						</div>\n						<div flex=\"20\" layout=\"column\">\n							<span style=\"font-size: .85em;\">{{client.lastArchived | amDateFormat: \'MMMM Do, YYYY\' }}</span>\n						</div>\n						<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n							<md-button class=\"md-accent\"  ng-click=\"vm.copyClient(client)\">Clone\n							</md-button>\n							<md-button class=\"md-accent\" ng-if=\"!vm.canRestoreClients()\"ng-disabled=\"true\" ui-sref=\"authentication.profile({selectedTab: 2})\">Upgrade to restore\n							</md-button>\n							<md-button class=\"md-accent\" ng-if=\"vm.canRestoreClients()\" ng-click=\"vm.restoreClient(client, $event)\">Restore\n							</md-button>\n							<md-button ng-if=\"client.status == \'archived\'\" class=\"md-button-small md-warn\" ng-click=\"vm.deleteClient(client, $event)\"><md-icon md-font-icon=\"fa fa-trash\"></md-icon></md-button>\n							<md-button ng-if=\"client.status == \'deleting\'\" class=\"md-button-small md-warn\" ng-disabled=\"true\"><md-icon md-font-icon=\"fa fa-trash\"></md-icon> Deleting...</md-button></td>\n						</div>\n						<!-- <div flex=\"nogrow\" style=\"padding: 1em;\" ng-if=\"!vm.isTeamAdmin(client.owner, vm.user.uid)\"><md-icon md-font-icon=\"fa fa-reorder\" style=\"color:#fff;\" ></md-icon></div> -->\n					</div>\n\n				</div>\n			</div>\n\n		</div>\n	</md-content>\n\n	  <md-content ng-show=\"!vm.allClients.length && vm.spacesView == \'active\'\" style=\"background-color: transparent; padding-top: 6em;\" layout=\"column\" layout-align=\"start center\" layout-fill>\n	       <img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n	       <h1 class=\"md-display-1\">Welcome to Adminja!</h1>\n	      <p class=\"md-headline center margin-20\">Please create a Workspace to get started! <br></p>\n	      <md-button class=\"md-accent md-raised\" ng-click=\"vm.newWorkspace(vm.selectedAccount)\" >\n	          + New Workspace\n	      </md-button>\n\n	  </md-content>\n\n\n\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-manager-page.tmpl.html","\n<div ui-view>\n\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-manager-toolbar.tmpl.html","<!-- // client manager toolbar -->\n<div class=\"md-toolbar-tools client-manager-toolbar\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}}88;\">\n	<md-button md-no-ink class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n			<md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n	</md-button>\n	<!-- desktop client toolbar -->\n	<div show-sm show-md show-lg show-xl hide-xs flex=\"auto\" layout=\"row\" layout-align=\"start center\" class=\"scrollable-toolbar-container\">\n\n\n		<div flex=\"none\">\n\n			<h3 md-truncate style=\"font-weight: 500; white-space: nowrap; padding-right: 1em;\" ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" >{{client.profile.fullName}}</h3>\n\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n				<md-button md-no-ink ui-sref-active=\"active\"  ui-sref=\"triangular.workspaces.overview\" ng-if=\"client.billingType == \'packages\' && bryanSays\">\n					<md-icon md-font-icon=\"fa fa-dashboard\" style=\"margin-top: -3px;\"></md-icon>\n					<!-- <md-icon md-font-icon=\"fa fa-list-alt\" style=\"margin-top: -3px;\"></md-icon> -->\n					<span class=\"\">Dashboard</span>\n				</md-button>\n\n				<md-button md-no-ink class=\"md-split-button\" ui-sref-active=\"active\" ng-class=\"{\'active\': $state.includes(\'triangular.workspaces.task-templates\') || $state.includes(\'triangular.workspaces.overview\') || $state.includes(\'triangular.workspaces.archived-tasks\')}\" ng-click=\"clickTaskButton(taskLabel)\">\n					<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon>\n					<span class=\"\">{{taskLabel}}</span>\n				</md-button>\n				<md-menu ng-if=\"!isClientUser\">\n				    <!-- Trigger element is a md-button with an icon -->\n				    <md-button ng-Click=\"$mdMenu.open($event)\"  ng-class=\"{\'active\': $state.includes(\'triangular.workspaces.task-templates\') || $state.includes(\'triangular.workspaces.overview\') || $state.includes(\'triangular.workspaces.archived-tasks\')}\" class=\"md-split-button-menu\">\n				    		<md-icon aria-label=\"Billing Period Maintenance\" md-font-icon=\"fa fa-caret-down\" style=\"color:#fff;\">\n				   		<md-tooltip md-delay=\"1000\">View Options</md-tooltip></md-icon>\n				   </md-button>\n				    <md-menu-content class=\"md-dense\" style=\"\">\n				        <md-menu-item>\n				            <md-button ui-sref=\"triangular.workspaces.overview\" ui-sref-active=\"active\" aria-label=\"Tasks\" md-no-ink=\"true\">\n				                Active Tasks\n				            </md-button>\n				        </md-menu-item>\n				        <md-menu-item>\n				            <md-button ui-sref=\"triangular.workspaces.task-templates\" ui-sref-active=\"active\" aria-label=\"Task Templates\" md-no-ink=\"true\">\n				                Task Templates &amp; Recurring Tasks\n				            </md-button>\n				        </md-menu-item>\n				        <md-menu-item ng-if=\"!isClientUser && (isOwner || isAdmin)\">\n				            <md-button ui-sref=\"triangular.workspaces.archived-tasks\" ui-sref-active=\"active\" aria-label=\"Archived Tasks\" md-no-ink=\"true\">\n				                Archived Tasks\n				            </md-button>\n				        </md-menu-item>\n				    </md-menu-content>\n				</md-menu>\n\n		</div>\n		<div ng-if=\"!isClientUser || client.clientUserTabs.details\" flex=\"nogrow\" class=\"toolbar-button-container\">\n				<!--<md-button md-no-ink ui-sref-active=\"active\" ui-sref=\"triangular.workspaces.information\">\n					<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon>\n					<span class=\"\">Legacy Details</span>\n				</md-button>-->\n				<md-button md-no-ink ui-sref-active=\"active\" ui-sref=\"triangular.workspaces.details\">\n					<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon>\n					<span class=\"\">Details</span>\n				</md-button>\n		</div>\n\n		<!-- disabled now that we have a split menu on \"Tasks\" -->\n		<!-- <div flex=\"nogrow\" class=\"toolbar-button-container\" ng-if=\"!isClientUser\">\n			<md-button md-no-ink  ui-sref=\"triangular.workspaces.task-templates\"  ui-sref-active=\"active\" >\n\n						<md-icon md-font-icon=\"zmdi zmdi-refresh\">\n\n						</md-icon>\n						<span class=\"\">Recurring</span>\n			</md-button>\n		</div> -->\n\n		<div ng-if=\"!isClientUser || client.clientUserTabs.time\" flex=\"nogrow\" class=\"toolbar-button-container\">\n			<md-button md-no-ink  ui-sref-active=\"active\" ui-sref=\"triangular.workspaces.time\" >\n				<md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n				<span class=\"\">Time</span>\n			</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" ng-if=\"(!isClientUser && (isOwner || isAdmin) && client.status != \'personal\' && client.billingType != \'packages\')  || (isClientUser && client.clientUserTabs.billing && client.status != \'personal\' && client.billingType != \'packages\')\">\n			<md-button md-no-ink ui-sref-active=\"active\" ui-sref=\"triangular.workspaces.client-legacy-billing\" >\n				<md-icon md-font-icon=\"fa fa-credit-card\"></md-icon>\n				<span class=\"\" style=\"color: #fff;\"> Billing</span>\n\n			</md-button>\n		</div>\n\n\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" ng-if=\"(!isClientUser && (isOwner || isAdmin) && client.status != \'personal\' && client.billingType == \'packages\')\">\n			<md-button md-no-ink ui-sref-active=\"active\" class=\"md-split-button\" ui-sref=\"triangular.workspaces.client-billing\" ng-class=\"{\'active\': $state.includes(\'triangular.workspaces.client-legacy-billing\')}\" >\n				<md-icon md-font-icon=\"fa fa-credit-card\"></md-icon>\n				<span class=\"\" style=\"color: #fff;\"> {{packageLabel}}</span>\n			</md-button>\n			<md-menu ng-if=\"client.billing\">\n			    <!-- Trigger element is a md-button with an icon -->\n			    <md-button ng-class=\"{\'active\': $state.includes(\'triangular.workspaces.client-legacy-billing\') || $state.includes(\'triangular.workspaces.client-billing\')}\" class=\"md-split-button-menu\">\n			    		<md-icon ng-Click=\"$mdMenu.open($event)\"  md-font-icon=\"fa fa-caret-down\" style=\"color:#fff; font-size: 12px;\"></md-icon>\n			   </md-button>\n			    <md-menu-content class=\"md-dense\" style=\"\">\n			        <md-menu-item>\n			            <md-button ui-sref=\"triangular.workspaces.client-billing\" ui-sref-active=\"active\" aria-label=\"Packages\" md-no-ink=\"true\">\n			                Billing\n			            </md-button>\n			        </md-menu-item>\n			        <md-menu-item>\n			            <md-button ui-sref=\"triangular.workspaces.client-legacy-billing\" ui-sref-active=\"active\" aria-label=\"Legacy Billing\" md-no-ink=\"true\">\n			                Legacy Billing Periods\n			            </md-button>\n			        </md-menu-item>\n			    </md-menu-content>\n			</md-menu>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" ng-if=\"!isClientUser\">\n			<md-button class=\"md-split-button\" md-no-ink ui-sref-active=\"active\" ng-click=\"editClient(client.uid)\" >\n				<md-icon md-font-icon=\"zmdi zmdi-account-box-o\" ng-if=\"!client.profile.isCompany\"></md-icon>\n				<md-icon md-font-icon=\"zmdi zmdi-city-alt\" ng-if=\"client.profile.isCompany\"></md-icon>\n				<span class=\"\" style=\"color: #fff;\"> Workspace</span>\n			</md-button>\n			<md-menu >\n			    <!-- Trigger element is a md-button with an icon -->\n			    <md-button class=\"md-split-button-menu\">\n			    		<md-icon ng-Click=\"$mdMenu.open($event)\"  md-font-icon=\"fa fa-caret-down\" style=\"color:#fff; font-size: 12px;\"></md-icon>\n			   </md-button>\n			    <md-menu-content class=\"md-dense\">\n			        <md-menu-item>\n			            <md-button ng-click=\"editClient(client.uid)\" aria-label=\"Edit Workspace\" md-no-ink=\"true\">\n			                <md-icon style=\"font-size: 14px; margin-right:10px;\" md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-client\"></md-icon>\n			                Edit\n			            </md-button>\n			        </md-menu-item>\n			        <md-menu-item>\n			            <md-button  ng-click=\"sendStatusReport(client)\"  aria-label=\"Send Status Report\" md-no-ink=\"true\">\n			                <md-icon style=\"font-size: 14px; margin-right:10px;\" md-font-icon=\"fa fa-paper-plane-o\" class=\"button-send-report\"></md-icon>\n			                Send Status Report\n			            </md-button>\n			        </md-menu-item>\n			        <md-menu-item ng-if=\"isAdmin || isOwner\">\n			            <md-button  ng-click=\"clone(client)\" aria-label=\"Clone\" md-no-ink=\"true\">\n			                <md-icon style=\"font-size: 14px; margin-right:10px;\" md-font-icon=\"fa fa-clone\" class=\"button-view-client\"></md-icon>\n			                Clone this Workspace\n			            </md-button>\n			        </md-menu-item>\n			        <md-menu-item ng-if=\"userType == \'admin\'\">\n			           <a class=\"md-button\" ng-href=\"{{dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                             <md-icon style=\"font-size: 14px; margin-right: 10px;\" md-font-icon=\"zmdi zmdi-code\" class=\"button-view-client\"></md-icon>  X-ray\n                           </a>\n			        </md-menu-item>\n\n			    </md-menu-content>\n			</md-menu>\n		</div>\n		<!-- <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\" ng-show=\"$state.includes(\'triangular.workspaces.tasks\')\">\n			<label><md-icon md-font-icon=\"fa fa-exclamation\" style=\"color: orange; font-size: 12px;\"></md-icon></label>\n			<md-switch  ng-model=\"$rootScope.showToday\" aria-label=\"Show Today\" >\n			 </md-switch>\n		</div> -->\n		<div flex>\n		</div>\n	</div><!-- // scrollable-toolbar-container -->\n	<!-- mobile client toolbar -->\n	<div hide-sm hide-md hide-lg hide-xl show-xs flex=\"auto\" layout=\"row\"  class=\"scrollable-toolbar-container\" >\n			<h3 flex=\"nogrow\" style=\"font-weight: 500;\" ng-show=\"client.profile.fullName\" class=\"toolbar-title\" md-truncate>\n				{{client.profile.fullName}}\n			</h3>\n			<div flex=\"auto\">\n			<md-menu md-position-mode=\"target-right target\" flex=\"nogrow\">\n					<!-- Trigger element is a md-button with an icon -->\n					<md-button md-no-ink ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-button-small\" style=\"margin-right: 0; margin-left: 0;\">\n							{{currentPage()}} <md-icon md-font-icon=\"zmdi zmdi-caret-down\">\n									<md-tooltip md-delay=\"1000\">List Menu</md-tooltip>\n							</md-icon>\n					</md-button>\n					<md-menu-content class=\"md-dense\">\n\n							<md-menu-item>\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.workspaces.tasks\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n											 Tasks\n									</md-button>\n							</md-menu-item>\n							<md-menu-item ng-if=\"!isClientUser || client.clientUserTabs.details\">\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.workspaces.information\')\">\n											<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon>\n											 Details\n									</md-button>\n							</md-menu-item>\n							<md-menu-item ng-if=\"!isClientUser || client.clientUserTabs.time\">\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.workspaces.time\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon> Time\n									</md-button>\n							</md-menu-item>\n							<md-menu-item ng-if=\"!isClientuser\">\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.workspaces.task-templates\')\">\n											<md-icon md-font-icon=\"zmdi zmdi-refresh\">\n											</md-icon>\n											 Recurring\n									</md-button>\n							</md-menu-item>\n							<md-menu-item ng-if=\"(!isClientUser && (isOwner || isAdmin) && client.status != \'personal\')  || (isClientUser && client.clientUserTabs.billing && client.status != \'personal\')\">\n									<md-button md-no-ink ng-click=\"changeState(\'triangular.workspaces.client-legacy-billing\')\">\n											<md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Billing\n									</md-button>\n							</md-menu-item>\n\n					</md-menu-content>\n				</md-menu>\n\n		</div>\n\n	</div>\n	<sidebar-controls ></sidebar-controls>\n</div>\n");
$templateCache.put("app/admin-client-manager/client-overview.tmpl.html","<div class=\"workspace-overview md-padding\">\n	<h3>Workspace Overview</h3>\n</div>\n");
$templateCache.put("app/admin-client-manager/client-profile.tmpl.html","<div class=\"task-filter-toolbar-container\"  hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\"  ng-show=\"showFilterBar\">\n  <md-toolbar palette-background=\"grey:800\" class=\"task-filter-toolbar\">\n    <div class=\"md-toolbar-tools\">\n      <!-- <h2 md-truncate flex=\"nogrow\"></h2> -->\n      <div flex>\n      </div>\n      <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n        <md-input-container md-no-float style=\"margin:0; padding: 0;\">\n            <input class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model-options=\"{debounce: 200}\" ng-model=\"filterText\">\n        </md-input-container>\n          <!-- <md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"resetSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n              <md-tooltip md-delay=\"1000\">\n                  Reset search\n              </md-tooltip>\n          </md-icon> -->\n      </div>\n        <div flex=\"nogrow\">\n          <md-button class=\"task-filter-toolbar-toggle\" ng-click=\"toggleFilterBar()\" style=\"position: relative; right:10px;\">\n            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n                <md-tooltip md-delay=\"1000\">\n                    Hide Task Filters\n                </md-tooltip>\n            </md-icon>\n          </md-button>\n        </div>\n    </div><!-- toolbar tools -->\n  </md-toolbar>\n</div>\n<div id=\"scroll-h\"  style=\"padding-left: 5px;\">\n    <md-button class=\"task-filter-toolbar-toggle task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!showFilterBar\" ng-click=\"toggleFilterBar()\"><md-icon md-font-icon=\"fa fa-search\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n                Show Task Filters\n        </md-tooltip></md-icon></md-button>\n<div class=\"scroll-trigger scroll-trigger-left\"\n    dragula=\"\'drag-profile-detail\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingDetail\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right\"\n    dragula=\"\'drag-profile-detail\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingDetail\">\n</div>\n\n<div class=\"scroll-trigger scroll-trigger-left\"\n    dragula=\"\'drag-profile-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n<div class=\"scroll-trigger scroll-trigger-right\"\n    dragula=\"\'drag-profile-panel\'\"\n    dragula-scope=\"$scope\"\n    ng-if=\"draggingPanel\">\n</div>\n<!--     <profile-panel\n    	class=\"app-item-container\"\n    	client=\"{{panel.client}}\"\n    	panelid=\"{{panel.uid}}\"\n    	ng-cloak\n    	class=\"profile-panel\"\n    	layout=\"column\"\n    	layout-align=\"start\"\n    	ng-repeat=\"panel in client.panels | toArray : false| orderBy: \'order\' | limitTo:1  track by panel.uid\"/>\n\n    	</profile-panel> -->\n	<!-- <new-client-button ng-if=\"clients.length\"></new-client-button> -->\n\n	<div  dragula=\"\'drag-profile-panel\'\" layout=\"row\">\n		<profile-panel\n			class=\"app-item-container profile-item-container\"\n			client=\"{{panel.client}}\"\n			panelid=\"{{panel.uid}}\"\n      ng-if=\"!vm.isWorkspaceClient || (vm.isWorkspaceClient && panel.clientEnabled)\"\n			ng-cloak\n			class=\"profile-panel\"\n			layout=\"column\"\n			layout-align=\"start\"\n			ng-repeat=\"panel in client.panels | toArray : false| orderBy: \'order\'  track by panel.uid\"/></profile-panel>\n	</div>\n	<!-- <div ng-show=\"showPrimer()\" flex=\"20\" layout=\"column\" layout-align=\"start center\">\n		<div class=\"engraved-box\">\n\n			<h3 class=\"center\">This your first time?</h3>\n			<p class=\"center\"><md-button ng-click=\"launchPrimer()\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> Learn about Client Profiles</md-button></p>\n		</div>\n\n		<new-profile-panel  client=\"client.uid\"></new-profile-panel>\n	</div> -->\n\n\n\n\n		<new-profile-panel  ng-if=\"!vm.isWorkspaceClient\" client=\"client.uid\" style=\"\"></new-profile-panel>\n\n</div>\n<!-- end scroll-h-->\n");
$templateCache.put("app/admin-client-manager/client-task-templates.tmpl.html","<div id=\"scroll-h\">\n	<div class=\"app-item-container\"\n		ng-class=\"{\'collapsed-cards\': vm.collapseCards}\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\"\n		>\n		<div class=\"app-item-container-header\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Active Recurring Tasks</h3>\n					<div class=\"app-item-container-controls\" style=\"right: 10px;\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n					    <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"margin:0; width: 25px;\">\n					        <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n					            <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n					        </md-icon>\n					    </md-button>\n					</div>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"app-item-container-items drag-recurring-container\"\n			dragula=\"\'drag-task\'\"\n			ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n			dragula-scope=\"$scope\"\n			layout=\"column\"\n			layout-align=\"start start\"\n			resize=\'{{vm.suppressResize}}\'\n			style=\"padding-top: 10px;\"\n			panelid=\'recurring\'\n			>\n			<div ng-if=\"!vm.hasRecurring()\" layout=\"column\" layout-align=\"center center\">\n				<p style=\"padding: 1em 2em;\" class=\"center md-subhead\">Any tasks that are set to automatically clone on a schedule are stored here.</p>\n				<md-button ng-click=\"vm.newTaskTemplate(vm.thisClient)\">Create one</md-button>\n			</div>\n			<task-template-card\n			ng-repeat=\"item in vm.thisClient.taskTemplates| toArray : false  | filter: {isRecurring:true} | orderBy: [\'info.order\'] track by item.uid\"\n			taskid=\"{{item.uid}}\"\n			clientid=\"{{item.client}}\"\n			template=\"item\"/>\n		</div>\n	</div>\n\n<!-- ////////////////// -->\n	<div class=\"app-item-container\"\n		ng-class=\"{\'collapsed-cards\': vm.collapseCards, \'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		resize=\'{{vm.suppressResize}}\'\n		ng-repeat=\"client in vm.clients| filter: {\'uid\': vm.clientID} | limitTo: 1 track by client.uid\"\n		>\n		<div class=\"app-item-container-header\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>Task Library</h3>\n					<div class=\"app-item-container-controls\" style=\"right: 10px;\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n					    <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"margin:0; width: 25px;\">\n					        <md-icon aria-label=\"Create New Task\" md-font-icon=\"zmdi zmdi-plus\" >\n					            <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n					        </md-icon>\n					    </md-button>\n					</div>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n\n		<div class=\"app-item-container-items drag-template-container\"\n			layout=\"column\"\n			dragula=\"\'drag-task\'\"\n			dragula-scope=\"$scope\"\n			layout-wrap\n			layout-align=\"start start\"\n			resize=\'false\'\n			style=\"padding-top: 10px;\"\n			panelid=\'template\'\n			>\n			<div ng-if=\"!vm.hasTemplates()\" layout=\"column\" layout-align=\"center center\">\n				<p style=\"padding: 1em 2em;\" class=\"center md-subhead\">You can store tasks to be cloned and re-used here</p>\n				<md-button ng-click=\"vm.newTaskTemplate(vm.thisClient)\">Create one</md-button>\n			</div>\n			<task-template-card\n				ng-repeat=\"item in vm.thisClient.taskTemplates| toArray  : false| filter: {isRecurring:false} | orderBy:[\'info.order\'] track by item.uid \"\n				taskid=\"{{item.uid}}\"\n				clientid=\"{{item.client}}\"\n				template=\"item\"\n				/>\n		</div>\n	</div>\n	<!-- <div  layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px;\">\n	    <md-button class=\"\"  ng-click=\"vm.newTaskTemplate(vm.clientID)\" style=\"width: 150px; color: #fff;\">\n	        + New Task\n	    </md-button>\n	</div> -->\n\n</div>\n");
$templateCache.put("app/admin-client-manager/client-tasks.tmpl.html","<task-board ng-if=\"vm.boardID\" boardid=\"vm.boardID\" client=\"vm.thisClient\"></task-board>\n\n<!-- no boardID? Walk user through upgrade -->\n<div ng-if=\"vm.upgradingBoard && !vm.boardID\" layout=\"row\" layout-align=\"center center\" style=\"padding-top: 2em; background-color: #bbb;\" class=\"layout-fill\">\n	<md-card flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"30\" style=\"padding: 1em; border-radius: 8px;\" layout=\"column\" layout-align=\"start center\">\n		<div ng-if=\"!vm.boardError\" >\n				<h3 class=\"center\">Surf\'s up!</h3>\n				<h4 class=\"center\">Preparing your tasks for a faster, smoother experience.<br>This will only take a few seconds</h4>\n				<p class=\"center\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n					<md-progress-linear class=\"margin-bottom-20 md-accent\" md-mode=\"indeterminate\"></md-progress-linear>\n					<!-- <md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 64px; width: 64px; font-size: 64px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon> -->\n				</p>\n				<p class=\"md-title center\" style=\"font-weight: 400;\">Please <strong>don\'t</strong> leave this page or refresh.</p>\n\n			</div>\n		</div>\n		<div ng-if=\"vm.boardError\">\n			<h3 class=\"center\">Oops! We were unable to upgrade this workspace.</p>\n			<h4 class=\"center\">Don\'t worry! Your data is safe!</h4>\n			<p class=\"md-subhead center\">\n				Please refresh this page and try again. If you continue to get this message, please contact <a href=\"mailto: help@getadminja.com\">help@getadminja.com</a> with the error below and we\'ll optimize these tasks right away.\n			</p>\n		</div>\n\n	</md-card>\n\n</div>\n\n");
$templateCache.put("app/admin-client-manager/client-time.tmpl.html","<div style=\"overflow-y: hidden;\">\n    <div class=\"time-report-controls\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n        <div flex layout=\"row\" layout-align=\"start center\">\n        <md-input-container flex=\"nogrow\" style=\"margin-left: 21px;\">\n            <label>Date Range</label>\n            <md-select style=\"margin: 0 1em 0 1em;\" ng-placeholder=\"Select a range\" ng-model=\"vm.rangeSetting\" ng-change=\"vm.updateDateRange(vm.rangeSetting, true)\">\n                <md-option value=\"saved\">\n                    User selected\n                </md-option>\n                <md-option value=\"last7\">\n                    Last 7 Days\n                </md-option>\n                <md-option value=\"last14\">\n                    Last 14 Days\n                </md-option>\n                <md-option value=\"last30\">\n                    Last 30 Days\n                </md-option>\n                <md-option value=\"last90\">\n                    Last 90 Days\n                </md-option>\n                <md-option value=\"thisMonth\">\n                    Month to Date\n                </md-option>\n        </md-input-container>\n        <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin-bottom: 0; margin-left: 21px; margin-top: 21px;\">\n            <label>From</label>\n            <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 0 0 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\"  md-placeholder=\"Start\" ng-change=\"vm.manualRangeUpdate()\"></md-datepicker>\n        </md-input-container>\n        <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin: 21px 0 0 0;\">\n            <label>To</label>\n            <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 1em 0 1em;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\"  md-placeholder=\"End\"  ng-change=\"vm.manualRangeUpdate()\"></md-datepicker>\n        </md-input-container>\n\n\n        <md-input-container ng-if=\"vm.retainerMode\" flex=\"nogrow\" style=\"margin-left: 21px; margin-right: 21px;\">\n            <label>From</label>\n            <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\" ng-change=\"vm.manualRangeUpdate()\">\n                <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date}}\">\n                    {{month.label}}\n                </md-option>\n            </md-select>\n        </md-input-container>\n        <md-input-container ng-if=\"vm.retainerMode\" flex=\"nogrow\" style=\"margin-right: 21px;\">\n            <label>To</label>\n            <md-select style=\"margin: 0 1em 0 1em;\"  ng-model=\"vm.timeReportService.report.end\" ng-change=\"vm.manualRangeUpdate()\">\n                <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date | amAdd : \'1\' : \'month\'| amSubtract: \'1\' : \'day\'}}\">\n                    {{month.label}}\n                </md-option>\n            </md-select>\n        </md-input-container>\n\n        <md-input-container ng-if=\"vm.showTeamFilter() && !vm.isWorkspaceClient\" flex=\"nogrow\" style=\"margin-right: 2em;\">\n            <label>Team Filter</label>\n            <md-select ng-model=\"vm.timeReportService.report.selectedMember\" style=\"width: 250px;\"   placeholder=\"Restrict to user...\">\n                <md-option value=\"all\">Everyone ({{vm.relatedMembers.length}})</md-option>\n                <md-option ng-repeat=\"member in vm.relatedMembers | toArray : false | orderBy: \'profile.lastName\' track by member.uid\" value=\"{{member.uid}}\" style=\"border-left: 4px solid {{member.color}};\">\n                    <img src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-right: 1em; position: relative; top: 5px;\">\n                    <span class=\"small\">{{member.fullName}}</span></md-option>\n            </md-select>\n        </md-input-container>\n        </div>\n        <div flex layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\">\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'month\'}\" ng-click=\"vm.viewMonths()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-comfy\">\n                        <md-tooltip>\n                            Group by Month\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'week\'}\" ng-click=\"vm.viewWeeks()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-view-week\">\n                        <md-tooltip>\n                            Group by Week\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'list\'}\" ng-click=\"vm.viewList()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-list\">\n                        <md-tooltip>\n                            Show as List\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            <span flex=\"nogrow\" style=\"border-right: 1px solid #bbb; width: 2px; margin:0 1em 0 1em;\"></span>\n              <!--   <md-button flex=\"nogrow\" ng-disabled=\"vm.timeReportService.report.selectedClient == \'user\'\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'retainer\'}\" ng-click=\"vm.viewRetainer()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-money\">\n                        <md-tooltip>\n                            Group by Billing Period\n                        </md-tooltip>\n                    </md-icon>\n                </md-button> -->\n                <md-button ng-if=\"vm.showRates\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.downloadCSV(vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end), vm.allTimeReportFilename())\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                        <md-tooltip>\n                            Download Spreadsheet\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button ng-if=\"vm.showRates\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.reportAllTime();\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-print\">\n                        <md-tooltip>\n                            View Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            </div>\n\n        </div>\n\n\n    </div>\n    <div ng-if=\"vm.timeReportService.report.view == \'list\'\" style=\"background-color: #fff; padding: 0;\">\n        <md-toolbar class=\"md-accent\">\n          <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"end center\">\n            <h2 flex=\"nogrow\" style=\"margin-right: 1em;\">{{vm.reportTotal | userTimeFormat}} logged</h2>\n          </div>\n        </md-toolbar>\n        <md-content>\n            <div ng-click=\"vm.openTime(entry)\" class=\"time-report-list-view-item\" ng-repeat=\"entry in timeEntries = (vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end)) | orderBy: \'-logDate\' track by entry.uid+entry.locked\" style=\"border-top: 2px solid {{::entry.clientColor}}\">\n                <div layout=\"row\" layout-align=\"fill center\" style=\"padding: 0 1em 0 1em;\">\n                    <div flex>\n                        <p class=\"entry-client\">{{::entry.clientName }}</p>\n                        <p class=\"entry-description\">{{::entry.description | limitTo : 150 : begin | limitTo : 150 : begin}}\n                        <span ng-if=\"::entry.rateLabel && entry.rateLabel != \'default\'\" class=\"time-category-label\"><br>{{::entry.rateLabel}}</span></p>\n                    </div>\n                    <div flex=\'nogrow\'>\n                        <p style=\"text-align: right; margin:0;\">\n                            {{::entry.logDate |  amDateFormat:vm.settings.amDateFormat}}<br>\n                            {{::entry.logDate |  amDateFormat:\'h:mm a\'}}\n                        </p>\n                        <p class=\"entry-logged right\">{{::entry.logged | userTimeFormat}}</p>\n                    </div>\n                </div>\n                <div flex layout=\"row\" layout-align=\"start end\"  style=\"padding: 0 1em 0 1em;\">\n                    <div flex=\"50\">\n                        <p class=\"task-info\" style=\"cursor: pointer;\" ng-if=\"::entry.task\">\n                         <md-icon aria-label=\"View Related Task\" md-font-icon=\"fa fa-check\" style=\"font-size: 12px; min-width: 10px; width: 10px; margin-right: 5px;\">\n                             <md-tooltip md-delay=\"1000\">View Related Task</md-tooltip>\n                         </md-icon>\n                         {{::entry.taskName}}\n                       </p>\n                     </div>\n                    <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n                        <p class=\"creator-info right\">\n                            {{::entry.creatorName}}\n                        </p>\n                    </div>\n                </div>\n\n                 <md-icon class=\"lock-icon\" ng-if=\"::entry.locked\" md-font-icon=\"fa fa-lock\"></md-icon>\n\n            </div>\n        </md-content>\n    </div>\n    <div id=\"scroll-h\" ng-if=\"vm.timeReportService.report.view != \'list\'\">\n\n        <!-- Time Buckets -->\n        <div ng-if=\"group.start < vm.now\" class=\"app-item-container time-container\" ng-repeat=\"group in vm.timeReportService.report.groups |orderBy:\'-start\' track by $index\" resize md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\" print-remove style=\"padding-top: .5em;\">\n            <div class=\"app-item-container-header\">\n                <div class=\"app-item-container-title-bar\" layout=\"row\">\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'week\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'month\'\" class=\"time-container-heading\" flex>\n                        {{group.name}}\n                    </h3>\n                    <h3 ng-if=\"vm.timeReportService.report.view == \'retainer\'\" class=\"time-container-heading\" flex>\n                        {{group.startLabel}} - {{group.endLabel}}\n                    </h3>\n                    <h3 class=\"time-container-heading right\" flex=\"nogrow\">\n                        {{vm.logTotal(timeEntries) | userTimeFormat}} logged\n                    </h3>\n                    <div class=\"time-container-controls\" flex=\"nogrow\">\n                    </div>\n                </div><!-- // end app-item-container-title-bar -->\n            </div><!-- // end app-item-container-header -->\n\n            <div class=\"app-item-container-items \"\n                        layout=\"column\"\n                        layout-align=\"start start\"\n                        style=\"width: 328px; overflow-y: scroll;\"\n                        resize\n                        >\n                <div ng-if=\"vm.timeReportService.report.loading\" layout=\"row\" layout-align=\"center center\">\n                   <p style=\"padding-left: 150px;\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n                </div>\n                <p style=\"text-align: center; width: 100%; padding-top: 2em; color: #666;\"  ng-show=\"!timeEntries.length && !vm.timeReportService.report.loading\">No time logged for this period.</p>\n               <div ng-click=\"vm.openTime(entry)\" class=\"time-entry-list-item-manual\" ng-repeat=\"entry in timeEntries = (vm.groupEntries(group.start, group.end)) | orderBy: \'-logDate\' track by entry.uid+entry.locked\" style=\"border-top: 3px solid {{::entry.clientColor}}; border-right: none; background-color: #fff; position: relative; cursor: pointer; width: 100%;\" >\n                   <div class=\"time-entry-package-info\" ng-if=\"::entry.packageLabel\"><md-icon md-font-icon=\"fa fa-suitcase\" style=\"font-size: 12px; min-width: 10px; width: 10px; margin-right: 5px; margin-top: -2px;\"></md-icon> {{::entry.packageLabel}}</div>\n                   <div layout=\"row\" layout-align=\"fill center\" style=\"padding: 0 1em 0 1em;\">\n                       <div flex>\n                           <p class=\"entry-client\">{{::entry.clientName }}</p>\n                           <div ng-if=\"entry.invoiced\" style=\"color: green;\">Invoiced</div>\n                           <p class=\"entry-description dont-break-out\">{{::entry.description | limitTo : 150 : begin}}\n                            <span ng-if=\"::entry.rateLabel && entry.rateLabel != \'default\'\" class=\"time-category-label\"><br>{{::entry.rateLabel}}</span></p>\n                       </div>\n                       <div flex=\'nogrow\'>\n                        <p style=\"text-align: right; margin: 0; padding:0;\">\n                           {{::entry.displayLogDate}}<br>\n                           {{::entry.displayLogTime}}\n                        </p>\n                           <p class=\"entry-logged right\">{{::entry.displayLogged}}</p>\n                       </div>\n                   </div>\n                   <div flex layout=\"row\" layout-align=\"start end\"  style=\"padding: 0 1em 0 1em;\">\n                       <div flex=\"50\">\n                           <p class=\"task-info\" style=\"cursor: pointer;\" ng-if=\"::entry.task\" ng-click=\"::vm.openTask(entry.task)\">\n                            <md-icon aria-label=\"View Related Task\" md-font-icon=\"fa fa-check\" style=\"font-size: 12px; min-width: 10px; width: 10px; margin-right: 5px;\">\n                            </md-icon>\n                            {{::entry.taskName}}\n                          </p>\n\n                        </div>\n                       <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n                           <p class=\"creator-info right\">\n                               <md-icon  md-font-icon=\"fa fa-check\" style=\"color: #fff;\"></md-icon>\n                               <!-- <img class=\"avatar\" src=\"{{entry.creatorAvatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"14\"> -->\n                               {{::entry.creatorName}}\n                           </p>\n                       </div>\n                   </div>\n\n                    <md-icon class=\"lock-icon\" ng-if=\"::entry.locked\" md-font-icon=\"fa fa-lock\"></md-icon>\n\n\n               </div>\n            </div>\n            <div class=\"time-footer\" layout=\"row\" layout-align=\"end center\">\n\n                    <md-button ng-if=\"vm.showRates\" flex=\"nogrow\" ng-click=\"vm.downloadCSV(timeEntries, vm.groupTimeReportFilename(group))\" class=\"md-button-small md-secondary\" >\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                            <md-tooltip>\n                                Download Spreadsheet\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button ng-if=\"vm.showRates\" flex=\"nogrow\" ng-click=\"vm.reportTime(group, timeEntries)\" class=\"md-button-small md-secondary\" >\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-print\">\n                            <md-tooltip>\n                                View Report\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <div flex>\n                        <h3 class=\"time-container-heading right\">\n                            {{vm.logTotal(timeEntries) | userTimeFormat}} logged\n                        </h3>\n                    </div>\n\n            </div>\n           <!--  <div class=\"time-footer\" flex layout=\"row\">\n                <a class=\"md-button\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon></a>\n                <a class=\"md-button\"><md-icon md-font-icon=\"fa fa-share\"></md-icon></a>\n            </div> -->\n        </div>\n\n\n    </div>\n</div>\n");
$templateCache.put("app/admin-dashboard/dashboard.tmpl.html","<div ng-if=\"vm.showDashboard()\" ng-class=\"{\'user-dashboard\': vm.userData.type != \'client\', \'client-dashboard\':vm.userData.type == \'client\' }\" class=\"dashboard small-scrollbar\" style=\"padding:0;   height: 100%; background-color: #fff;\">\n  <div ng-if=\"testing\" layout=\"row\" layout-align=\"center center\">\n      <p show-xs hide-sm hide-md hide-lg hide-xl class=\"md-subhead\">Xtra Small</p>\n      <p show-sm hide-xs hide-md hide-lg hide-xl class=\"md-subhead\">Small</p>\n      <p show-md hide-xs hide-sm hide-lg hide-xl class=\"md-subhead\">Medium</p>\n      <p show-lg hide-xs hide-sm hide-md hide-xl class=\"md-subhead\">Large</p>\n      <p show-xl hide-xs hide-sm hide-md hide-lg class=\"md-subhead\">Xtra Large</p>\n  </div>\n  <!-- main row -->\n  <div layout=\"row\" layout-fill layout-align=\"layout-fill layout-fill\" style=\"padding-bottom: 2em;\">\n      <!-- main column -->\n      <div layout=\"column\" flex=\"grow\">\n         <!-- Workspace Snapshots -->\n          <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"layout-fill layout-fill\" class=\"dashboard-row-1\">\n            <!-- snapshots column -->\n            <div class=\"workspace-snapshots-container\" flex=\"30\" flex-sm=\"auto\" flex-xs=\"auto\" layout=\"column\" style=\"padding: 0px 16px 0 0; max-height: 100%; height: 100%; position: relative;\">\n              <div layout=\"row\" layout-align=\"layout-fill center\">\n                <div flex=\"50\">\n                  <p class=\"small-label\" style=\"padding-left: 1em;\">\n                    <!-- <span ng-if=\"vm.userData.type != \'client\'\">Workspace Snapshots</span>\n                    <span ng-if=\"vm.userData.type == \'client\'\">Workspace Snapshots</span> -->\n                  </p>\n                </div>\n                <div flex=\"50\" layout=\"row\" layout-align=\"end center\" class=\"padding-right-20\">\n                  <md-button style=\"position:  relative; right:  -8px; margin-top: 10px;\" class=\"md-icon-button\" ng-click=\"vm.toggleAllWorkspacePackages()\">\n                    <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\" ng-if=\"!vm.allPackagesVisible\"></md-icon>\n                    <md-icon md-font-icon=\"zmdi zmdi-minus-circle-outline\" ng-if=\"vm.allPackagesVisible\"></md-icon>\n                    <md-tooltip md-delay=\"500\">Show/Hide all Billing Packages</md-tooltip>\n                  </md-button>\n                </div>\n              </div>\n\n              <md-content class=\"package-snapshots small-scrollbar\" style=\"height: 100%; background-color: #fff; \">\n                  <div ng-repeat=\"client in vm.clientData | orderBy:[vm.userOrder] | reverseGroupBy: \'type\' track by client.uid + $index\" layout=\"column\" layout-align=\"start layout-fill\" class=\"workspace-packages workspace-snapshot fade workspace-{{::vm.workspaceClass(client.profile.fullName)}}\">\n\n                      <div class=\"groupHeader\" ng-show=\"client.group_by_key\">\n                        <p class=\"md-subhead margin-top-0 margin-bottom-0 \" style=\"padding-left: 18px; font-size:12px; color: #999; text-transform: uppercase;\" ng-if=\"client.type == \'client\'\">Client Workspaces</p>\n                        <p class=\"md-subhead margin-top-0 margin-bottom-0  padding-top-20\" style=\"padding-left: 18px; font-size:12px; color: #999; text-transform: uppercase;\" ng-if=\"client.type == \'vaworkspace\'\">Virtual Assistants</p>\n                        <p class=\"md-subhead margin-top-0 margin-bottom-0  padding-top-20\" style=\"padding-left: 18px; font-size:12px; color: #999; text-transform: uppercase;\" ng-if=\"client.type == \'internal\'\">Internal Workspaces</p>\n                      </div>\n                      <!-- Workspace Stats -->\n                      <div class=\" workspace-stats\"  layout=\"row\" layout-align=\"layout-fill center\" style=\"\">\n                        <div flex=\"nogrow\" style=\"width: 52px; min-width: 52px; max-width: 52px;\" layout=\"column\" layout-align=\"center center\">\n                          <md-button ng-if=\"client.status != \'personal\'\" class=\"md-icon-button md-secondary\" ng-click=\"vm.toggleWorkspacePackages(client.uid)\" md-no-ink=\"true\">\n                            <md-icon ng-if=\"!vm.workspaceVisibility[client.uid]\" md-font-icon=\"fa fa-caret-right\" class=\"font-size-2\"></md-icon>\n                            <md-icon ng-if=\"vm.workspaceVisibility[client.uid]\" md-font-icon=\"fa fa-caret-down\" class=\"font-size-2\"></md-icon>\n                            <md-tooltip md-delay=\"1000\">Show/Hide Billing Packages</md-tooltip>\n                          </md-button>\n                        </div>\n                        <div flex=\"100\" layout=\"row\" layout-align=\"layout-fill center\" class=\"workspace-stats-link-target\" >\n                          <md-tooltip md-delay=\"1000\">Open this Workspace</md-tooltip>\n                          <div flex=\"50\" layout=\"row\" layout-align=\"layout-fill layout-fill\" ng-click=\"vm.openClient(client.uid)\" >\n                            <div flex=\"nogrow\" class=\"padding-right-20\" style=\"padding-top: 14px; cursor: pointer;\"  >\n                                <avatar ng-if=\"client.status == \'personal\'\"  type=\"default\" parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar>\n                                <avatar  ng-if=\"client.status != \'personal\'\" parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar>\n                            </div>\n                            <div flex layout=\"column\" layout-align=\"center start\" style=\"overflow-x: hidden; cursor: pointer;\" ng-click=\"vm.openClient(client.uid)\"  >\n                                <p flex md-truncate class=\"md-title workspace-fullname\" style=\"white-space: nowrap; margin-top:32px; font-size: 16px; padding-right: 1em; width: 100%;\">{{client.profile.fullName}}\n                                  <em class=\"grey-hint\" ng-if=\"client.owner != vm.userData.uid\" class=\"small workspace-internal\" style=\"font-size: 12px;\"><br><md-icon class=\"grey-hint\" style=\"font-size:  12px; min-width:15px;\" md-font-icon=\"zmdi zmdi-share\"></md-icon>{{vm.teamLabel(client.owner)}}</em>\n                                </p>\n                            </div>\n                          </div>\n                          <div flex=\"50\" class=\"workspace-package-details\" layout=\"row\" layout-align=\"end layout-fill\" style=\"\">\n                            <div flex class=\"package-detail-text-container\" layout=\"column\" layout-align=\"layout-fill layout-fill\" style=\"\">\n                              <div  layout=\"row\" layout-align=\"end layout-fill\" class=\"progress-widgets progress-widgets-small margin-bottom-0\" style=\"max-height: 100%;  \">\n                                <div flex=\"33\" class=\"package-detail-text\" ng-click=\"vm.openClient(client.uid)\">\n                                  <div class=\"progress-widget md-whiteframe-z1dfasdf widget-due\">\n                                    <p class=\"center widget-heading\"><strong>Due</strong></p>\n                                    <p class=\"center widget-text\">{{vm.todayCount(client)}}</p>\n                                  </div>\n                                </div>\n                                <div flex=\"33\" class=\"package-detail-text\" ng-click=\"vm.openClient(client.uid)\">\n                                  <div class=\"progress-widget md-whiteframe-z1dfasdf widget-flagged\">\n                                    <p class=\"center widget-heading\"><strong>Flagged</strong></p>\n                                    <p class=\"center widget-text\">{{vm.flaggedCount(client)}}</p>\n                                  </div>\n                                </div>\n                                <div flex=\"33\" class=\"package-detail-text\" ng-click=\"vm.openClient(client.uid)\">\n                                  <div class=\"progress-widget md-whiteframe-z1dfasdf widget-upcoming\">\n                                    <p class=\"center widget-heading\"><strong>Later</strong></p>\n                                    <p class=\"center widget-text\" >{{vm.laterCount(client)}}</p>\n                                  </div>\n                                </div>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <!-- billing period -->\n                      <div ng-click=\"vm.openClientPackages(client)\" class=\"workspace-package workspace-period\" ng-if=\"vm.workspaceVisibility[client.uid]  && client.billingType == \'periods\' && client.status != \'personal\' && client.profile.plan.currentPeriod\" layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"nogrow\" style=\"width:50px; max-width: 50px; min-width: 50px;\"></div>\n                        <div flex=\"40\" layout=\"row\" layout-align=\"center center\">\n                          <div flex=\"nogrow\" class=\"padding-left-10 padding-right-20\">\n                              <md-icon style=\"font-size: 24px; color: #bbb;\" md-font-icon ng-class=\"\n                                         {\'zmdi zmdi-time-restore\': vm.packageStats[client.uid].type ==\'hourly\',\n                                          \'zmdi zmdi-time-interval\': vm.packageStats[client.uid].type == \'retainer\',\n                                          \'zmdi zmdi-hourglass-alt\': vm.packageStats[client.uid].type == \'balance\'\n                                          }\"\n                              ></md-icon>\n                          </div>\n                          <div flex layout=\"column\" layout-align=\"center start\" style=\"overflow-x: hidden;\">\n                            <p flex class=\"md-subhead workspace-fullname\" md-truncate style=\"white-space: nowrap; width: 100%; \">\n                              <span style=\"text-transform: capitalize;\">{{vm.packageStats[client.uid].type}}</span> <br>\n                              <span style=\"color: #999;\">{{vm.packageStats[client.uid].start | amDateFormat: vm.settings.superShortDateFormat}} - {{vm.packageStats[client.uid].end | amDateFormat: vm.settings.superShortDateFormat}}</span></p>\n                          </div>\n                        </div>\n                        <div flex=\"60\" class=\"workspace-package-details\" layout=\"row\" layout-align=\"end center\">\n                          <div flex class=\"package-detail-text-container\" layout=\"column\">\n                            <div flex=\"50\" layout=\"row\" layout-align=\"end layout-fill\">\n                              <div flex=\"25\" class=\"package-detail-text\"  layout=\"column\" layout-align=\"center center\" >\n                                <p class=\"center\"><strong>Budget</strong></p>\n                                <p class=\"center\" ng-if=\"vm.packageStats[client.uid].type != \'hourly\'\">{{vm.packageStats[client.uid].budget | HandM}}</p>\n                                <p class=\"center\" ng-if=\"vm.packageStats[client.uid].type == \'hourly\'\">N/A</p>\n                              </div>\n                              <div flex=\"25\" class=\"package-detail-text\" layout=\"column\" layout-align=\"center center\" >\n                                <p class=\"center\"><strong>Used</strong></p>\n                                <p class=\"center\">{{vm.packageStats[client.uid].used | HandM}}</p>\n                              </div>\n                              <div flex=\"25\" class=\"package-detail-text\"  layout=\"column\" layout-align=\"center center\" ng-if=\"vm.packageStats[client.uid].type != \'hourly\'\">\n                                <p class=\"center\"><strong>Remain</strong></p>\n                                <p class=\"center\" >{{vm.packageStats[client.uid].remain | HandM}}</p>\n                              </div>\n                              <div flex=\"25\" class=\"package-detail-text\"  layout=\"column\" layout-align=\"center center\" ng-if=\"vm.packageStats[client.uid].type == \'hourly\'\">\n                                <p class=\"center\"><strong>Earned</strong></p>\n                                <p class=\"center\" ng-if=\"client.access.admins[userID]\"><span ng-bind-html=\"vm.currency\"></span>{{vm.packageStats[client.uid].totalCost || \'0.00\'}}</p>\n                                <p class=\"center\" ng-if=\"!client.access.admins[userID]\">XXXX</p>\n                              </div>\n                             <div flex=\"25\" layout=\"column\" layout-align=\"center center\" class=\"\">\n                               <progress-arc\n                                  ng-if=\"vm.packageStats[client.uid].budget > 0\"\n                                  class=\"package-progress-circle\"\n                                  size=\"50\"\n                                  stroke=\"{{vm.packageStats[client.uid].progressBarColor}}\"\n                                  stroke-width=\"5\"\n                                  complete=\"vm.packageStats[client.uid].progressBarPercent\"\n                                  counter-clockwise=\"true\"\n                                  background=\"{{vm.packageStats[client.uid].progressBarBackgroundColor}}\"\n                                  label=\"{{vm.packageStats[client.uid].progressBarPercentLabel}}\">\n                              </progress-arc>\n                             </div>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                     <!-- packages -->\n                     <div ng-if=\"vm.size(client.packages) == 0 && vm.workspaceVisibility[client.uid]  && client.billingType == \'packages\' && client.status != \'personal\'\" class=\"workspace-package\" layout=\"column\" layout-align=\"center layout-fill\">\n                      <p flex class=\"md-subhead center\">There are no active Packages running for this Workspace</p>\n                      <p class=\"center\" flex><md-button class=\"md-accent md-raised\" ng-click=\"vm.openClientPackages(client)\">Configure Packages</md-button>\n                     </div>\n                     <div ng-click=\"vm.openClientPackages(client)\" ng-animate-children=\"true\" class=\"workspace-package\" ng-if=\"vm.workspaceVisibility[client.uid]  && client.billingType == \'packages\' && client.status != \'personal\' && clientPackage.status == \'open\'\"  layout=\"row\" layout-align=\"layout-fill center\" ng-repeat=\"clientPackage in client.packages | toArray: false | orderBy: [\'-startDate\'] track by $index+uid\">\n                       <div flex=\"nogrow\" style=\"width:50px; max-width: 50px; min-width: 50px;\"></div>\n                       <div flex=\"40\" layout=\"row\" layout-align=\"center center\">\n                         <div flex=\"nogrow\" class=\"padding-left-10 padding-right-20\">\n                           <md-icon style=\"font-size: 24px; color: #888;\" md-font-icon ng-class=\"\n                                      {\'zmdi zmdi-time-restore\': clientPackage.type ==\'hourly\',\n                                       \'zmdi zmdi-time-interval\': clientPackage.type == \'retainer\',\n                                       \'zmdi zmdi-hourglass-alt\': clientPackage.type == \'balance\',\n                                       \'zmdi zmdi-dot-circle\': clientPackage.type ==\'fixed\',\n                                       \'zmdi zmdi-gas-station\': clientPackage.type == \'refillable\'\n                                       }\"\n                           ></md-icon>\n                         </div>\n                         <div flex layout=\"column\" layout-align=\"center start\" style=\"overflow-x: hidden;\">\n                             <p flex class=\"md-subhead workspace-fullname\" md-truncate style=\"white-space: nowrap; width: 100%; color: #555;\">\n                                 {{clientPackage.label}}<br>\n                                 <span style=\"color: #555;\">{{clientPackage.startDate | amDateFormat: vm.settings.superShortDateFormat}} - {{(clientPackage.endDate | amDateFormat: vm.settings.superShortDateFormat) || \"Pending\"}}</span>\n                             </p>\n\n                         </div>\n                       </div>\n                       <div flex=\"60\" class=\"workspace-package-details\" layout=\"row\" layout-align=\"end center\">\n                         <div flex class=\"package-detail-text-container\" layout=\"column\">\n                           <div flex=\"50\" layout=\"row\" layout-align=\"end layout-fill\">\n                             <div flex=\"25\" class=\"package-detail-text\" layout=\"column\" layout-align=\"center center\">\n                               <p class=\"center\" ng-if=\"clientPackage.type != \'hourly\'\"><strong>Budget</strong></p>\n                               <p class=\"center\" ng-if=\"clientPackage.type == \'hourly\'\"><strong>Goal</strong></p>\n                               <p class=\"center\" ng-if=\"clientPackage.budgetedHours > 0\">{{clientPackage.budgetedMinutes | HandM}}</p>\n                               <p class=\"center\" ng-if=\"clientPackage.budgetedHours == 0\">N/A</p>\n                             </div>\n                             <div flex=\"25\" class=\"package-detail-text\" layout=\"column\" layout-align=\"center center\">\n                               <p class=\"center\"><strong>Used</strong></p>\n                               <p class=\"center\">{{clientPackage.qualifiedMinutes | HandM}}</p>\n                             </div>\n                             <div flex=\"25\" class=\"package-detail-text\" ng-if=\"clientPackage.type != \'hourly\'\" layout=\"column\" layout-align=\"center center\">\n                               <p class=\"center\" ng-if=\"clientPackage.type != \'hourly\'\"><strong>Remain</strong></p>\n                               <p class=\"center\" ng-if=\"clientPackage.budgetedHours > 0\">{{vm.remain(clientPackage.budgetedMinutes, clientPackage.qualifiedMinutes) | HandM}}</p>\n                               <p class=\"center\" ng-if=\"clientPackage.budgetedHours == 0\">N/A</p>\n                             </div>\n                             <div flex=\"25\" class=\"package-detail-text\" ng-if=\"clientPackage.type == \'hourly\'\" layout=\"column\" layout-align=\"center center\">\n                               <p class=\"center\" ng-if=\"clientPackage.type == \'hourly\'\"><strong>Earned</strong></p>\n                               <p class=\"center\" ng-if=\"client.access.admins[userID]\"><span ng-bind-html=\"vm.currency\"></span>{{clientPackage.accrued | number: 2 || 0 | number: 2}}</p>\n                               <p class=\"center\" ng-if=\"!client.access.admins[userID]\"><span ng-bind-html=\"vm.currency\"></span>XXX.XX</p>\n                             </div>\n                             <div flex=\"25\" layout=\"column\" layout-align=\"center center\" class=\"\">\n                                <div style=\"min-height: 50px; height: 50px; max-height: 50px; padding-top: 15px;\" ng-if=\"clientPackage.type == \'hourly\' && clientPackage.budgetedHours > 0 && vm.packageStats[clientPackage.uid].progressBarPercent <= 0\" >\n                                 <md-icon md-font-icon=\"fa fa-check\" style=\"font-size: 24px; color: rgb(76, 175, 80); padding-left: 3px;\"></md-icon>\n                               </div>\n                                <progress-arc\n                                   ng-if=\"(clientPackage.budgetedHours > 0 && clientPackage.type != \'hourly\') || (clientPackage.type == \'hourly\' && vm.packageStats[clientPackage.uid].progressBarPercent > 0)\"\n                                   class=\"package-progress-circle\"\n                                   size=\"50\"\n                                   stroke=\"{{vm.packageStats[clientPackage.uid].progressBarColor}}\"\n                                   stroke-width=\"5\"\n                                   complete=\"vm.packageStats[clientPackage.uid].progressBarPercent\"\n                                   counter-clockwise=\"true\"\n                                   background=\"{{vm.packageStats[clientPackage.uid].progressBarBackgroundColor}}\"\n                                   label=\"{{vm.packageStats[clientPackage.uid].progressBarPercentLabel}}\">\n                               </progress-arc>\n                               <!-- spacer if no budget for hourly packages -->\n                               <progress-arc ng-if=\"clientPackage.budgetedHours == 0 && clientPackage.type == \'hourly\'\"\n                                class=\"package-progress-circle\"\n                                size=\"50\"\n                                stroke=\"#ffffff\"\n                                stroke-width=\"5\"\n                                complete=\"0\"\n                                counter-clockwise=\"true\"\n                                background=\"#ffffff\"\n                                label=\"N/A\"\n                                >\n                               </progress-arc>\n                             </div>\n                           </div>\n                         </div>\n                       </div>\n                     </div>\n                  </div><!-- client package group -->\n              </md-content>\n            </div>\n            <div flex=\"auto\" hide-sm hide-xs>\n              <!-- spacer -->\n            </div>\n            <!-- workload and progress column -->\n            <div flex=\"nogrow\" flex-sm=\"auto\" flex-xs=\"auto\" class=\"workload-and-progess-container\" layout=\"row\" layout-align=\"end start\" style=\"height: 100%; max-height: 100%;\">\n              <md-content flex=\"auto\" class=\"small-scrollbar\" style=\"background-color: #fff; height: 100%; max-height: 100%;\">\n                <div layout=\"column\" layout-align=\"start start\" class=\"md-padding padding-left-0 padding-right-0\" style=\"max-width:580px; padding-top: 26px;\">\n                    <div class=\"client-request-form-container\" layout=\"column\" layout-align=\"start layout-fill\" ng-if=\"vm.userData.type == \'client\'\"  flex=\"100\">\n                      <p class=\"center md-subhead\">Submit a new request for your Virtual Assistant</p>\n                      <div layout=\"row\" layout-align=\"center center\">\n                        <md-button flex=\"grow\" style=\"max-width: 300px;\" class=\"md-raised md-accent\" ng-click=\"vm.newTask()\">New Request</md-button>\n                      </div>\n                    </div>\n\n                    <!--- Progress Widgets -->\n                    <!-- Workload Widgets -->\n                    <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\" ng-if=\"vm.userData.plan.content__subscription__plan_id != \'client-access\'\">\n                        <p class=\"small-label\" flex=\"100\" style=\"padding-bottom: 1em; height: 36px;\">My Workload</p>\n                        <div class=\"progress-widget widget-due md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                            <p class=\"widget-heading\">\n                              <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-alert-circle\"></md-icon>\n                              <span>Due</span>\n                            </p>\n                            <p class=\"md-title center\">{{vm.status.now.due || 0}} tasks</p>\n                        </div>\n                        <div class=\"progress-widget widget-flagged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                          <p class=\"widget-heading\">\n                              <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n                              <span>Flagged</span>\n                          </p>\n                          <p class=\"md-title center\">{{vm.status.now.flagged || 0}} tasks</p>\n                        </div>\n                        <div class=\"progress-widget widget-upcoming md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                          <p class=\"widget-heading\">\n                            <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-coffee\"></md-icon>\n                            <span>Later</span>\n                          </p>\n                          <p class=\"md-title center\">{{vm.status.now.upcoming || 0}} tasks</p>\n                        </div>\n                    </div>\n\n                    <!--- user progress -->\n                    <div ng-if=\"vm.userData.type != \'client\' && !vm.settings.showTeamStatus\" class=\"fade\" style=\"width: 100%;\" >\n                        <div layout=\"row\" layout-align=\"start center\">\n                            <p class=\"small-label\">My Progress</p>\n                            <!-- <p class=\"small-label padding-right-20\">{{vm.displayedRangeStart |amDateFormat : vm.settings.superShortDateFormat}} - {{vm.displayedRangeEnd |amDateFormat : vm.settings.superShortDateFormat}}</p> -->\n                        </div>\n                        <md-tabs  md-align-tabs=\"top\"  md-stretch-tabs=\"never\" class=\"weekly-status \" md-dynamic-height=\"true\" >\n                          <md-tab md-on-select=\"vm.changeStatusView(\'thisWeek\')\">\n                              <md-tab-label>This Week</md-tab-label>\n                              <md-tab-body >\n                                  <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                    <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                          <span>Completed</span>\n                                        </p>\n                                        <p class=\"md-title center\">{{vm.status.thisWeek.tasksCompleted || 0}} tasks</p>\n                                    </div>\n                                    <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                          <span>Logged</span>\n                                        </p>\n                                        <p class=\"md-title center\">\n                                        {{vm.status.thisWeek.timeLogged || 0 | userTimeFormat}} hrs\n                                        <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                      </p>\n                                    </div>\n                                    <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                          <span>Invoiced</span>\n                                        </p>\n                                        <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.thisWeek.invoiced | number: 2}}</p>\n                                    </div>\n                                  </div>\n                              </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'lastWeek\')\">\n                                <md-tab-label>Last Week</md-tab-label>\n                                <md-tab-body>\n                                    <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                      <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                          <p class=\"widget-heading\">\n                                            <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                            <span>Completed</span>\n                                          </p>\n                                          <p class=\"md-title center\">{{vm.status.lastWeek.tasksCompleted || 0}} tasks</p>\n                                      </div>\n                                      <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                          <p class=\"widget-heading\">\n                                            <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                            <span>Logged</span>\n                                          </p>\n                                          <p class=\"md-title center\">\n                                           {{vm.status.lastWeek.timeLogged || 0 | userTimeFormat}} hrs\n                                           <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                         </p>\n                                      </div>\n                                      <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                          <p class=\"widget-heading\">\n                                            <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                            <span>Invoiced</span>\n                                          </p>\n                                          <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.lastWeek.invoiced | number: 2}}</p>\n                                      </div>\n                                    </div>\n                                </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'thisMonth\')\">\n                              <md-tab-label>{{vm.status.thisMonth.label}}</md-tab-label>\n                              <md-tab-body>\n                                <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                  <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                        <span>Completed</span>\n                                      </p>\n                                      <p class=\"md-title center\">{{vm.status.thisMonth.tasksCompleted || 0}} tasks</p>\n                                  </div>\n                                  <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                        <span>Logged</span>\n                                      </p>\n                                      <p class=\"md-title center\">\n                                        {{vm.status.thisMonth.timeLogged || 0 | userTimeFormat}} hrs\n                                        <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                      </p>\n                                  </div>\n                                  <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                        <span>Invoiced</span>\n                                      </p>\n                                      <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.thisMonth.invoiced | number: 2}}</p>\n                                  </div>\n                                </div>\n                              </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'lastMonth\')\">\n                              <md-tab-label>{{vm.status.lastMonth.label}}</md-tab-label>\n                              <md-tab-body>\n                                <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                  <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                        <span>Completed</span>\n                                      </p>\n                                      <p class=\"md-title center\">{{vm.status.lastMonth.tasksCompleted || 0}} tasks</p>\n                                  </div>\n                                  <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                        <span>Logged</span>\n                                      </p>\n                                      <p class=\"md-title center\">\n                                        {{vm.status.lastMonth.timeLogged || 0 | userTimeFormat}} hrs\n                                        <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                      </p>\n                                  </div>\n                                  <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                        <span>Invoiced</span>\n                                      </p>\n                                      <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.lastMonth.invoiced | number: 2}}</p>\n                                  </div>\n                                </div>\n                              </md-tab-body>\n                          </md-tab>\n                        </md-tabs>\n                    </div>\n\n                    <!--- team progress -->\n                    <div ng-if=\"vm.userData.type != \'client\' && vm.settings.showTeamStatus\" class=\"fade\" style=\"width: 100%;\">\n                        <div layout=\"row\" layout-align=\"space-between center\">\n                            <p class=\"small-label\">Team Progress</p>\n                            <!-- <p class=\"small-label padding-right-20\">{{vm.displayedRangeStart |amDateFormat : vm.settings.superShortDateFormat}} - {{vm.displayedRangeEnd |amDateFormat : vm.settings.superShortDateFormat}}</p> -->\n                        </div>\n                        <md-tabs  md-align-tabs=\"top\" md-stretch-tabs=\"never\" class=\"weekly-status \" md-dynamic-height=\"true\">\n                          <md-tab md-on-select=\"vm.changeStatusView(\'thisWeek\')\">\n                              <md-tab-label>This Week</md-tab-label>\n                              <md-tab-body>\n                                  <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                    <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                          <span>Completed</span>\n                                        </p>\n                                        <p class=\"md-title center\">{{vm.status.thisWeek.teamCompletedTasks || 0}} tasks</p>\n                                    </div>\n                                    <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                          <span>Logged</span>\n                                        </p>\n                                        <p class=\"md-title center\">\n                                          {{vm.status.thisWeek.teamTimeLogged || 0 | userTimeFormat}} hrs\n                                          <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                        </p>\n                                    </div>\n                                    <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                        <p class=\"widget-heading\">\n                                          <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                          <span>Invoiced</span>\n                                        </p>\n                                        <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.thisWeek.invoiced | number: 2}}</p>\n                                    </div>\n                                  </div>\n                              </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'lastWeek\')\">\n                                <md-tab-label>Last Week</md-tab-label>\n                                <md-tab-body>\n                                      <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                        <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                            <p class=\"widget-heading\">\n                                              <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                              <span>Completed</span>\n                                            </p>\n                                            <p class=\"md-title center\">{{vm.status.lastWeek.teamCompletedTasks || 0}} tasks</p>\n                                        </div>\n                                        <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                            <p class=\"widget-heading\">\n                                              <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                              <span>Logged</span>\n                                            </p>\n                                            <p class=\"md-title center\">\n                                              {{vm.status.lastWeek.teamTimeLogged || 0 | userTimeFormat}} hrs\n                                              <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                            </p>\n                                        </div>\n                                        <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                            <p class=\"widget-heading\">\n                                              <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                              <span>Invoiced</span>\n                                            </p>\n                                            <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.lastWeek.invoiced | number: 2}}</p>\n                                        </div>\n                                      </div>\n\n                                </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'thisMonth\')\">\n                              <md-tab-label>{{vm.status.thisMonth.label}}</md-tab-label>\n                              <md-tab-body>\n                                <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                  <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                        <span>Completed</span>\n                                      </p>\n                                      <p class=\"md-title center\">{{vm.status.thisMonth.teamCompletedTasks || 0}} tasks</p>\n                                  </div>\n                                  <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                        <span>Logged</span>\n                                      </p>\n                                      <p class=\"md-title center\">\n                                        {{vm.status.thisMonth.teamTimeLogged || 0 | userTimeFormat}} hrs\n                                        <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                      </p>\n                                  </div>\n                                  <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                        <span>Invoiced</span>\n                                      </p>\n                                      <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.thisMonth.invoiced | number: 2}}</p>\n                                  </div>\n                                </div>\n                              </md-tab-body>\n                          </md-tab>\n                          <md-tab md-on-select=\"vm.changeStatusView(\'lastMonth\')\">\n                              <md-tab-label>{{vm.status.lastMonth.label}}</md-tab-label>\n                              <md-tab-body>\n                                <div class=\"progress-widgets\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\">\n                                  <div class=\"progress-widget widget-completed md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-check-square\"></md-icon>\n                                        <span>Completed</span>\n                                      </p>\n                                      <p class=\"md-title center\">{{vm.status.lastMonth.teamCompletedTasks || 0}} tasks</p>\n                                  </div>\n                                  <div class=\"progress-widget widget-logged md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                                        <span>Logged</span>\n                                      </p>\n                                      <p class=\"md-title center\">\n                                        {{vm.status.lastMonth.teamTimeLogged || 0 | userTimeFormat}} hrs\n                                        <!-- <md-icon md-font-icon=\"zmdi zmdi-info-outline\"><md-tooltip md-delay=\"500\">Undergoing Maintenance</md-tooltip></md-icon> -->\n                                      </p>\n                                  </div>\n                                  <div class=\"progress-widget widget-invoiced md-whiteframe-z1 fade\" flex=\"auto\" layout=\"column\" layout-align=\"start layout-fill\">\n                                      <p class=\"widget-heading\">\n                                        <md-icon class=\"font-size-2 opacity-80\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n                                        <span>Invoiced</span>\n                                      </p>\n                                      <p class=\"md-title center\"><span ng-bind-html=\"vm.currency\"></span>{{vm.status.lastMonth.invoiced | number: 2}}</p>\n                                  </div>\n                                </div>\n                              </md-tab-body>\n                          </md-tab>\n                        </md-tabs>\n                    </div>\n\n                    <!-- charts -->\n                    <div ng-if=\"vm.userData.type != \'client\'\" layout=\"column\" class=\"\" style=\"margin-top: 1em;\">\n                        <div ng-if=\"!vm.settings.hideDashboardCharts\" style=\"padding-right: 2em; position: relative;\" class=\"fade\">\n                            <p class=\"small-label\" style=\"padding-bottom: 1em;\">\n                                My Progress ({{vm.charts.workload.range}})\n                            </p>\n\n                            <div class=\"dashboard-chart-box\"  ng-show=\"vm.showProgressChart && vm.showDashboard() && !vm.showWorkload\"  layout=\"column\" layout-align=\"center center\" style=\"border-radius: 4px; color: #999; font-size: 14px;  padding: 2em;\">\n                              <p class=\"md-subhead center\" >\n                               <md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 64px; width: 64px; font-size: 64px; color: #bbb; margin: 1em;\"></md-icon><br>\n                               Loading Progress Chart\n                             </p>\n                            </div>\n                            <div class=\"dashboard-chart-box\"  ng-if=\"!vm.showProgressChart\" layout=\"column\" layout-align=\"center center\" style=\"border-radius: 4px; color: #999; font-size: 14px;  padding: 2em;\">\n                              <p class=\"md-subhead center\" >\n                                <md-icon md-font-icon=\"fa fa-bar-chart-o\" style=\"font-size: 64px; color: #999; margin: 1em; \"></md-icon><br>\n                                Progress Charts will be available once you\'ve logged some time.\n                             </p>\n                            </div>\n                            <canvas  class=\"chart chart-line dashboard-chart-box\" ng-show=\"vm.showProgressChart && vm.showWorkload && vm.showDashboard()\" chart-colors=\"vm.workloadChartColors\" chart-data=\"vm.charts.workload.data\" chart-labels=\"vm.charts.workload.labels\" chart-legend=\"true\" chart-series=\"vm.charts.workload.series\"  chart-options=\"vm.charts.workload.options\" style= margin-bottom: 2em;\"></canvas>\n                        </div>\n                        <div ng-if=\"!vm.settings.hideDashboardCharts\" flex=\"100\" flex-gt-md=\"50\" style=\"padding-right: 2em; position: relative;\" class=\"fade\">\n                            <p class=\"small-label\" style=\"padding-bottom: 1em;\">My Billing ({{vm.charts.workload.range}})</p>\n                            <div class=\"dashboard-chart-box\" ng-show=\"vm.showProgressChart && vm.showDashboard() && !vm.showRevenueChart\" style=\"border-radius: 4px; color: #999; font-size: 14px;  padding: 2em;\" >\n                              <p  class=\"subhead center\" >\n                                <md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 64px; width: 64px; font-size: 64px; color: #bbb; margin:1em;\"></md-icon><br>\n                                Loading Billing Chart\n                              </p>\n                            </div>\n                            <div class=\"dashboard-chart-box\" ng-if=\"!vm.showProgressChart\"  style=\"border-radius: 4px; color: #999; font-size: 14px;  padding: 2em;\">\n                              <p class=\"md-subhead center\">\n                                <md-icon md-font-icon=\"fa fa-bar-chart-o\" style=\"font-size: 64px; color: #999; margin: 1em; \"></md-icon><br>\n                                Billing Charts will be available once you\'ve created some invoices.\n                             </p>\n                            </div>\n                            <canvas  ng-show=\"vm.showProgressChart  && vm.showDashboard() && vm.showRevenueChart\" class=\"chart chart-line dashboard-chart-box\" chart-colors=\"vm.invoicingChartColors\" chart-data=\"vm.charts.revenue.data\" chart-labels=\"vm.charts.revenue.labels\" chart-legend=\"true\" chart-series=\"vm.charts.revenue.series\"  chart-options=\"vm.charts.revenue.options\" style= margin-bottom: 2em;\"></canvas>\n                        </div>\n\n\n                    </div>\n\n                </div><!-- /right column -->\n              </md-content>\n            </div>\n\n          </div><!--- /main row -->\n\n\n      </div><!-- / main column -->\n      <!-- Right Column -->\n      <div ng-if=\"!vm.settings.hideDashboardNotifications\" flex=\"nogrow\" style=\"padding: 26px 0 30px 16px; background-color: #fff; width: 330px; height: 100%; max-height: 100%;\" class=\"recent-activity-column\">\n          <p class=\"small-label\" style=\"padding-bottom: 26px;\">Recent Activity</p>\n          <md-content style=\"background-color: #fff; height: 100%; max-height: 100%;\" class=\"notification-list\" style=\"width: 330px;\">\n              <notification-card class=\"fade\" ng-if=\"item.uid && item.type == \'reminder\'\" ng-repeat=\"item in vm.userData.notifications | toArray |  orderBy: \'-date\' track by $index\" item=\"item\"></notification-card>\n              <notification-card class=\"fade\" ng-if=\"item.uid && item.type != \'reminder\'\" ng-repeat=\"item in vm.userData.notifications | toArray |  orderBy: \'-date\'| limitTo: 50 track by $index\" item=\"item\"></notification-card>\n              <div ng-hide=\"vm.size(vm.userData.notifications) > 0\" class=\"no-notifications-message\" layout=\"column\" layout-align=\"center center\">\n                      <img src=\"/assets/images/brand/adminja-bug-300-greyscale.png\" width=\"150\">\n                      <p class=\"center\">Nothing to review!</p>\n              </div>\n          </md-content>\n      </div><!-- /right column -->\n  </div><!-- /main row -->\n</div>\n\n\n<div ng-if=\"!vm.showDashboard()\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 4em;\">\n   <img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n   <h1 class=\"md-display-1 margin-bottom-80\">Welcome to Adminja!</h1>\n   <!-- Account Owner Greeting -->\n   <div ng-if=\"vm.userData.plan.content__subscription__plan_id != \'starter-2018c\' && vm.userData.plan.content__subscription__plan_id != \'client-access\'\">\n      <p  class=\"md-headline center margin-20\">Please open the orange <strong>Guides &amp; Resources</strong> panel your left and select <strong>First Steps</strong> for a guided setup.</p>\n      <!-- <p  class=\"md-headline center margin-20\">Or dive right in on your own and create your first Client Workspace.</p> -->\n      <!-- <p class=\"center\">\n        <md-button class=\"md-accent md-raised\" ng-click=\"vm.newSpace()\" >\n            + New Workspace\n        </md-button>\n      </p> -->\n  </div>\n   <!-- Team Member Greeting -->\n   <div ng-if=\"vm.userData.plan.content__subscription__plan_id == \'starter-2018c\'\" style=\"max-width: 1000px;\">\n      <p class=\"md-headline center margin-20\">Your team membership has been confirmed and your Team Leader has been notified.</p>\n      <p class=\"md-headline center margin-20\">Your account includes one FREE Client Workspace for your own use.</p>\n      <p  class=\"md-headline center margin-20 margin-top-60\">While you wait for your Team Leader to delegate Workspaces to you, you can get a head start by opening the orange <strong>Guides &amp; Resources</strong> panel to your left.</p>\n  </div>\n\n\n</div>\n");
$templateCache.put("app/admin-dashboard/dialogCaptureAnnouncement.tmpl.html","<md-dialog class=\"onboarding-modal\" flex=\"100\" flex-lg=\"70\" flex-xl=\"60\" style=\"max-width: 900px;\">\n\n    <!-- <md-toolbar>\n      <div class=\"md-toolbar-tools\">\n        <h2>First Login</h2>\n        <span flex></span>\n\n      </div>\n    </md-toolbar> -->\n\n    <md-dialog-content style=\"padding: 2em;\">\n      <md-content style=\"background-color: #fff;\">\n              <div layout=\"column\" layout-align=\"center center\">\n                                    <!-- <h1 class=\"center\" style=\"margin-top: 2em;\"><md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 148px;\"></md-icon></h1> -->\n                <h1 class=\"center\" style=\"margin-top: 0; margin-bottom: .5em;\">\n                  Ready to kickstart your workflow?\n                </h1>\n                <!-- <h3 class=\"center\" style=\"margin-top: 0; font-weight: normal;\">Effortlessly add Tasks, Notes and Time with our new <strong>Capture</strong> Chrome Extension!</h3> -->\n\n                     <h3 class=\"center\" style=\"margin-top: 0; font-weight: normal; padding: 0 1em 0 1em;\">The new <a href=\"https://www.getadminja.com/capture-extension\" target=\"_blank\" style=\"font-weight: bold; border-bottom: dashed 1px #bbb; text-decoration:none;\">Capture Chrome Extension</a> for Adminja is the fastest way <br>to save <strong>Tasks</strong>, <strong>Notes</strong>, and <strong>Time</strong> on-the-fly!</h3>\n\n\n              </div>\n                              <div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 1em;\">\n                                    <div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"start center\" style=\"padding: 2em 2em 0 2em;\">\n                                          <!-- <img flex=\"nogrow\"  class=\"md-whiteframe-z3\" style=\"padding: 0; margin-top: 1em; width:360px; height: 228px; border: 1px solid #ddd;\" src=\"/assets/images/feature-releases/time-report-module-upgrade-11-28-18.png\"> -->\n                                          <img flex=\"nogrow\"   style=\"padding: 0; margin-top: 0; width: 100%;\" src=\"/assets/images/feature-releases/capture-feature.png\">\n                                    </div>\n                                    <div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\">\n<!--                                           <p >The <strong>Capture</strong> extension is always available from any webpage, so adding tasks, notes and time is easier than ever!</p>\n -->                                          <ul style=\"font-size: .85em; margin: 3em 0 0 1em; padding-left: 1em;\" class=\"feature-icon-list\">\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-download\" style=\"font-size: 1em; margin-left: -2em;\"></md-icon>Easy, one-click installation!</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-flash\" style=\"font-size: 1em; margin-left: -2em;\"></md-icon>Send Tasks, Notes and Time directly to the proper <br>Workspace <strong>without opening Adminja</strong>!</li>\n                                                <!-- <li><md-icon md-font-icon=\"fa fa-columns\" style=\"font-size: 1em;\"></md-icon>Send Tasks &amp; Notes directly to specific Workspace Lists.</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 1em;\"></md-icon>Apply Time directly to a specific Workspace.</li> -->\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-scissors\" style=\"font-size: 1em; margin-left: -2em;\"></md-icon>Automatically include <strong>selected text</strong> from the current webpage.</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-bookmark\" style=\"font-size: 1em; margin-left: -2em;\"></md-icon>Saves the current <strong>webpage URL</strong> for reference.</li>\n                                            </ul>\n                                    </div>\n                              </div>\n                              <div layout=\"column\" layout-align=\"space-between center\">\n                                    <p class=\"center\" style=\"margin: 2em 2em 1em 2em;\">\n                                          <md-button style=\"cursor: pointer;\" class=\"\" ng-click=\"dontAskAgain()\">Don\'t ask me again.</md-button>\n                                          <md-button style=\"cursor: pointer;\" class=\"md-accent\" ng-click=\"cancelDialog()\">Ask again later</md-button>\n                                          <md-button class=\"md-accent md-raised margin-left-20\" target=\"_blank\" ng-click=\"checkItOut()\">Check it out!</md-button>\n                                    </p>\n                              </div>\n                              <div layout=\"row\" layout-align=\"center center\">\n                                <p class=\"margin-0\">\n                                 <a href=\"https://chrome.google.com/webstore/detail/adminja-capture/nopjmnpokiieibhkaahoglobjkddbckc?authuser=2\" target=\"_blank\"><img flex=\"nogrow\"  style=\"margin-top: 1em; width: 150px;\" src=\"/assets/images/feature-releases/chrome-webstore-icon.png\"></a>\n                                </p>\n                              </div>\n\n\n    <!-- <div layout=\"row\" layout-align=\"end center\">\n      <md-button style=\"cursor: pointer;\" class=\"md-accent md-raised\" ng-click=\"vm.closeDialog()\">NEXT</md-button>\n    </div> -->\n\n</md-content>\n   </md-dialog-content>\n\n</md-dialog>\n\n");
$templateCache.put("app/admin-dashboard/dialogFirstLogin.tmpl.html","<md-dialog class=\"onboarding-modal\" flex=\"100\" flex-lg=\"70\" flex-xl=\"60\" style=\"max-width: 900px;\">\n\n    <!-- <md-toolbar>\n      <div class=\"md-toolbar-tools\">\n        <h2>First Login</h2>\n        <span flex></span>\n\n      </div>\n    </md-toolbar> -->\n\n    <md-dialog-content>\n      <div class=\"md-dialog-content\">\n            {{selectedSlide}}\n      	<md-tabs md-selected=\"selectedSlide\" md-dynamic-height=\"true\" md-stretch-tabs=\"never\" md-center-tabs=\"true\" md-align-tabs=\"bottom\" md-no-ink-bar=\"true\" md-no-ink=\"true\">\n      		<md-tab>\n      			<md-tab-label>\n      				<md-icon ng-if=\"selectedSlide == 0\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n      				<md-icon ng-if=\"selectedSlide != 0\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n      			</md-tab-label>\n      			<md-tab-body>\n      				<div layout=\"column\" layout-align=\"center center\">\n      					<img flex=\"nogrow\"  style=\"margin-top: 2em;\" src=\"/assets/images/brand/adminja-bug-medium.png\">\n      					<h1 class=\"center\" style=\"margin-top: 1em; margin-bottom: .25em;\">\n      						Welcome to Adminja!\n      					</h1>\n      					<h3 class=\"center\" style=\"margin-top: 0;\">We\'re glad that you\'re here!</h3>\n      					<!-- <h3 class=\"center\">Ready to get started?</h3> -->\n      					<p class=\"center\">Before you dive in, give us 30 seconds to show you some key tips.</p>\n      					<p class=\"center\">\n      						<md-button style=\"cursor: pointer;\" class=\"md-accent md-raised\" ng-click=\"next()\">GET STARTED</md-button>\n      					</p>\n\n      				</div>\n\n\n				</md-tab-body>\n      		</md-tab>\n                  <md-tab>\n                        <md-tab-label>\n                              <md-icon ng-if=\"selectedSlide == 1\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n                              <md-icon ng-if=\"selectedSlide != 1\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n                        </md-tab-label>\n                        <md-tab-body>\n                              <div layout=\"column\" layout-align=\"center center\">\n                                    <img flex=\"nogrow\"  style=\"margin-top: 2em;\" src=\"/assets/images/onboarding/chrome-logo.png\">\n                                    <h1 class=\"center\" style=\"margin-top: 1em; margin-bottom: .25em;\">\n                                          Adminja works best with Chrome\n                                    </h1>\n\n                                    <!-- <h3 class=\"center\">Ready to get started?</h3> -->\n                                    <p class=\"center\" style=\"max-width: 650px;\">While Adminja should work just fine on most modern web browsers, for the best performance and compatibility, we recommend <a href=\"https://www.google.com/chrome\" target=\"_blank\">Google Chrome</a>.</p>\n\n                              </div>\n\n\n                        </md-tab-body>\n                  </md-tab>\n      		<md-tab>\n      			<md-tab-label>\n      				<md-icon ng-if=\"selectedSlide == 2\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n      				<md-icon ng-if=\"selectedSlide != 2\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n      			</md-tab-label>\n				<md-tab-body>\n					<div layout=\"row\" layout-align=\"center start\">\n						<img flex=\"100\" flex-gt-xs=\"50\" class=\"slide-image\" src=\"/assets/images/onboarding/gestures-slide.gif\">\n						<div flex=\"100\" flex-gt-sm=\"50\" style=\"padding-left: 3em;\">\n							<h1>Use Gestures to Scroll</h1>\n							<h3>Windows OS</h3>\n							<p><strong>Trackpad</strong><br>Two-fingers slide left/right/up/down</p>\n							<p><strong>Mouse</strong><br>Scrollwheel = up/down<br>Shift + Scrollwheel = left/right</p>\n							<h3>MacOS</h3>\n							<p><strong>Trackpad &amp; Mouse</strong><br>Two-fingers slide left/right/up/down</p>\n						</div>\n					</div>\n				</md-tab-body>\n      		</md-tab>\n      		<md-tab>\n      			<md-tab-label>\n      				<md-icon ng-if=\"selectedSlide == 3\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n      				<md-icon ng-if=\"selectedSlide != 3\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n      			</md-tab-label>\n      			<md-tab-body>\n      				<div layout=\"row\" layout-align=\"center start\">\n						<img flex=\"100\" flex-gt-xs=\"50\" class=\"slide-image\" src=\"/assets/images/onboarding/shortcuts-slide.gif\">\n						<div flex=\"100\" flex-gt-sm=\"50\" style=\"padding-left: 3em;\">\n							<h1>Kill it with Shortcuts</h1>\n							<p>Use the Shortcut Menu ( <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>) to quickly capture everything, so you\'ll never lose anything.</p>\n                                          <ul style=\"line-height: 2em;\">\n                                                <li><strong>Quickly Capture:</strong></li>\n                                                <li><md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> Tasks</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> Time</li>\n                                                <li><md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> Notes</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-account-box-o\"></md-icon> People</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> Bookmarks</li>\n                                                <li><md-icon md-font-icon=\"zmdi zmdi-more\"></md-icon> and more!</li>\n                                          </ul>\n						</div>\n					</div>\n				</md-tab-body>\n      		</md-tab>\n                  <md-tab>\n                        <md-tab-label>\n                              <md-icon ng-if=\"selectedSlide == 4\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n                              <md-icon ng-if=\"selectedSlide != 4\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n                        </md-tab-label>\n                        <md-tab-body>\n                              <div layout=\"row\" layout-align=\"center start\">\n                                    <img flex=\"100\" flex-gt-xs=\"50\" class=\"slide-image\" src=\"/assets/images/onboarding/notifications-slide.gif\">\n                                    <div flex=\"100\" flex-gt-sm=\"50\" style=\"padding-left: 3em;\">\n                                          <h1>Get a heads up</h1>\n                                          <p>Adminja will let you know when important things happen.</p>\n                                          <p>Look for the <md-icon md-font-icon=\"fa fa-bell\"></md-icon> at the top of your screen.</p>\n                                    </div>\n                              </div>\n                        </md-tab-body>\n                  </md-tab>\n      		<md-tab ng-if=\"planID != \'client-access\'\">\n      			<md-tab-label>\n      				<md-icon ng-if=\"selectedSlide == 5\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n      				<md-icon ng-if=\"selectedSlide != 5\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n      			</md-tab-label>\n      			<md-tab-body>\n      				<div layout=\"row\" layout-align=\"center start\">\n						<img flex=\"100\" flex-gt-xs=\"50\" class=\"slide-image\" style=\"max-width: 396px; margin-top: 41px; margin-left: 1em;\" src=\"/assets/images/onboarding/timer-animation.gif\">\n						<div flex=\"100\" flex-gt-sm=\"50\" style=\"padding-left: 3em;\">\n							<h1>Start with the Timer</h1>\n							<p>Use the Multi-timer to track time spent on tasks and clients.</p>\n							<p>Just select a Workspace and click &nbsp;<md-icon md-font-icon=\"fa fa-play\"></md-icon>.</p>\n							<p>The Timer Tray ( <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>) makes it easy to switch between timers.</p>\n                                          <p>Click&nbsp;&nbsp;<md-icon md-font-icon=\"fa fa-stop\"></md-icon> when you are ready to log your time.</p>\n						</div>\n					</div>\n				</md-tab-body>\n      		</md-tab>\n\n                  <md-tab ng-if=\"planID != \'client-access\'\">\n                        <md-tab-label>\n                              <md-icon ng-if=\"selectedSlide == 6\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n                              <md-icon ng-if=\"selectedSlide != 6\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n                        </md-tab-label>\n                        <md-tab-body>\n                              <div layout=\"row\" layout-align=\"center start\">\n                                    <img flex=\"100\" flex-gt-xs=\"50\" class=\"slide-image\" style=\"max-width: 221px; margin-top: 41px; margin-left: 0;\" src=\"/assets/images/onboarding/adminja-menu.png\">\n                                    <div flex=\"100\" flex-gt-sm=\"50\" style=\"padding-left: 3em;\">\n                                          <h1>Watch the Tutorials</h1>\n                                          <p>We\'ve prepared a series of short videos to guide you.</p>\n                                          <p>Click on&nbsp;&nbsp;<md-icon md-font-icon=\"zmdi zmdi-tv-play\"></md-icon> <strong>Adminja Tutorials</strong> in your left Menu.</p>\n                                    </div>\n                              </div>\n                        </md-tab-body>\n                  </md-tab>\n\n      		<md-tab>\n      			<md-tab-label>\n      				<md-icon ng-if=\"selectedSlide == 7\" md-font-icon=\"zmdi zmdi-circle\"></md-icon>\n      				<md-icon ng-if=\"selectedSlide != 7\" md-font-icon=\"zmdi zmdi-circle-o\"></md-icon>\n      			</md-tab-label>\n      			<md-tab-body>\n					<h1 class=\"center\" style=\"margin-top: 1.5em;\">\n						That\'s it!&nbsp; &nbsp;Ready to go?\n					</h1>\n                              <div ng-if=\"planID != \'client-access\'\">\n      					<h3 class=\"center\">We\'re preparing a sample workspace for you to play with.</h3>\n      					<!-- <h3 class=\"center\">Ready to get started?</h3> -->\n      					<p class=\"center\"><!-- Give it a spin. --></p>\n      					<p class=\"center\">You can setup your own Workspaces whenever you\'re ready.</p>\n                              </div>\n                              <div ng-if=\"planID == \'client-access\'\">\n                                    <h3 class=\"center\">Your Virtual Assistant has already given you access to their Workspace.</h3>\n                                    <p class=\"center\">You\'ll find it in the main menu on the left.</p>\n                              </div>\n					<p class=\"center\">\n						<md-button  class=\"md-accent md-raised\" ng-if=\"!copyingClients\" ng-click=\"finish()\">Let\'s Go!</md-button>\n                                    <md-button  class=\"md-accent md-raised\" ng-if=\"copyingClients\" ><md-icon md-font-icon=\"fa fa-circle-notch fa-spin\"></md-icon></md-button>\n					</p>\n				</md-tab-body>\n\n      		</md-tab>\n\n      		<!-- md-tabs attributes you can use:\n      		md-selected - integer - Index of the active/selected tab\n      		md-no-ink - boolean - If present, disables ink ripple effects.\n      		md-no-bar - boolean -If present, disables the selection ink bar.\n      		md-align-tabs string - Attribute to indicate position of tab buttons: bottom or top; default is top\n      		md-stretch-tabs string - Attribute to indicate whether or not to stretch tabs: auto, always, or never; default is auto\n      		md-dynamic-height - boolean - When enabled, the tab wrapper will resize based on the contents of the selected tab\n      		md-center-tabs - boolean - When enabled, tabs will be centered provided there is no need for pagination\n      		md-no-pagination - boolean - When enabled, pagination will remain off\n      		md-swipe-content - boolean - When enabled, swipe gestures will be enabled for the content area to jump between tabs\n      		md-no-disconnect - boolean - If your tab content has background tasks (ie. event listeners), you will want to include this to prevent the scope from being disconnected\n      		md-autoselect - boolean - When present, any tabs added after the initial load will be automatically selected\n      		-->\n      	</md-tabs>\n		<div  layout=\"row\" ng-if=\"planID != \'client-access\' && selectedSlide != 7 && selectedSlide != 0\" layout-align=\"end center\">\n			<md-button style=\"cursor: pointer;\" class=\"md-accent md-raised\" ng-click=\"next()\">NEXT</md-button>\n		</div>\n            <div layout=\"row\" ng-if=\"planID == \'client-access\' && selectedSlide != 5 && selectedSlide != 0\" layout-align=\"end center\">\n                  <md-button style=\"cursor: pointer;\" class=\"md-accent md-raised\" ng-click=\"next()\">NEXT</md-button>\n            </div>\n\n      </div>\n   </md-dialog-content>\n\n</md-dialog>\n\n");
$templateCache.put("app/admin-dashboard/upgradeModal.tmpl.html","<md-dialog class=\"onboarding-modal\" flex=\"100\" flex-lg=\"70\" flex-xl=\"60\" style=\"max-width: 800px;\">\n    <md-dialog-content style=\"padding: 2em;\">\n      <md-content style=\"background-color: #fff;\">\n               <!-- <p class=\"right\"><md-button ng-click=\"vm.close()\">X</md-button></p> -->\n              <div layout=\"column\" layout-align=\"center center\">\n                    <div layout=\"row\" layout-align=\"layout-fill center\" class=\"margin-bottom-20\">\n                         <div flex=\"50\" class=\"padding-right-20\"><img src=\"/assets/images/feature-releases/surfs-up.png\"></div>\n                         <div flex=\"50\" layout=\"column\" layout-align=\"start start\">\n                              <h1 class=\"margin-bottom-0\">Surf\'s up!</h1>\n                              <h4>We are optimizing Adminja for a faster, smoother experience.</h4>\n                              <h4>This should only take a few moments.</h4>\n                              <!-- <p class=\"progress-message\">{{vm.upgradeMessage}} -->\n                         </div>\n                    </div>\n\n                    <p class=\"md-title center\" style=\"font-weight: 400;\">Please <strong>don\'t</strong> leave this page or refresh.</p>\n                    <p class=\"center\">{{vm.upgradeMessage}}</p>\n                    <md-progress-linear md-theme=\"adminja-blue\" class=\"margin-bottom-20 md-accent\" md-mode=\"determinate\" ng-value=\"vm.upgradeProgress\"></md-progress-linear>\n                    <p class=\"md-subhead center margin-top-0 small\">{{vm.upgradeProgress}}% Complete</p>\n                    <p class=\"center\" style=\"width:  80%; padding: 1em; border-radius: 8px; background-color: #efefef; margin-top: 2em;\">Please notify <a href=\"mailto: help@getadminja.com\" target=\"_blank\">help@getadminja.com</a> immediately <br>if you encounter any issues during this optimization.</p>\n\n               </div>\n     </md-content>\n   </md-dialog-content>\n</md-dialog>\n\n\n");
$templateCache.put("app/admin-diagnostics/diagnostics.tmpl.html","<div layout-padding>\n	<md-content class=\"md-whiteframe-z3\" style=\"max-width: 1024px; margin: 2em auto 2em auto;\" layout-padding>\n\n		<h3 class=\"center\">Adminja Diagnostics</h3>\n		<p>Please copy the information below and paste it in your e-mail to support.</p>\n\n		<p><strong>rootUserID</strong><br>{{userID}}</p>\n		<p><strong>localUserID</strong><br>{{vm.localUserID}}</p>\n		<p><strong>authData</strong><br>{{authData}}</p>\n		<p><strong>assignedClients</strong><br>\n		{{quickClients | json}}</p>\n		<p><strong>thisClient</strong><br>\n		{{thisClient | json}}\n		</p>\n		<p><strong>rootClientID</strong><br>\n		{{clientID}}\n		</p>\n	</md-content>\n</div>\n");
$templateCache.put("app/admin-leads/leads-toolbar.tmpl.html","\n<div class=\"md-toolbar-tools leads-toolbar\" layout=\"row\" layout-align=\"start center\" style=\"\">\n\n	<div show-sm show-md show-lg show-xl hide-xs flex=\"auto\" layout=\"row\" layout-align=\"start center\" class=\"scrollable-toolbar-container\">\n\n		<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showAccountPicker\">\n		    <md-input-container style=\"margin-left: 1em;\" class=\"small-select toolbar-select\">\n		        <label>Account</label>\n		        <md-select flex=\"nogrow\" ng-model=\"vm.selectedAccount\" ng-change=\"vm.selectAccount(vm.selectedAccount, true)\" style=\"margin-top: 0; margin-bottom: 0;\">\n		            <md-option ng-repeat=\"team in vm.managedTeams | toArray: false |orderBy:[\'order\'] track by $index + team.ownerID\" ng-value=\"team.ownerID\">\n		                {{team.name}}\n		            </md-option>\n		        </md-select>\n		    </md-input-container>\n		</div>\n		<div flex=\"none\">\n			<h3 style=\"font-weight: 500; white-space: nowrap; padding-right: 1em; padding-top: 0!important;\" ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" >Leads</h3>\n		</div>\n\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n				<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'active\'}\"  ng-click=\"vm.changeView(\'active\')\">\n					<md-icon md-font-icon=\"zmdi zmdi-coffee\"> </md-icon><span class=\"\">Active ({{vm.leadCount(\'active\')}})</span>\n				</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n				<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'won\'}\" ng-click=\"vm.changeView(\'won\')\">\n					<md-icon md-font-icon=\"fa fa-thumbs-up\"> </md-icon><span class=\"\">Won ({{vm.leadCount(\'won\')}})</span>\n				</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n				<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'lost\'}\" ng-click=\"vm.changeView(\'lost\')\">\n					<md-icon md-font-icon=\"fa fa-thumbs-down\"> </md-icon><span class=\"\">Lost ({{vm.leadCount(\'lost\')}})</span>\n				</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\">\n				<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'archived\'}\" ng-click=\"vm.changeView(\'archived\')\">\n					<md-icon md-font-icon=\"fa fa-archive\"> </md-icon><span class=\"\">Archived ({{vm.leadCount(\'archived\')}})</span>\n				</md-button>\n		</div>\n\n\n		<div flex>\n		</div>\n	</div><!-- // scrollable-toolbar-container -->\n	<sidebar-controls ></sidebar-controls>\n\n</div>\n");
$templateCache.put("app/admin-leads/leads.tmpl.html","<div class=\"task-filter-toolbar-container\" hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\" >\n  <md-toolbar palette-background=\"grey:600\" class=\"task-filter-toolbar\">\n    <div class=\"md-toolbar-tools\">\n      <!-- <h2 md-truncate flex=\"nogrow\"></h2> -->\n	<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showAccountPicker\">\n		<span style=\"color: #fff;\">Account:</span>\n	    <md-input-container style=\"margin-left: 1em;\" class=\"small-select toolbar-select\">\n	        <md-select flex=\"nogrow\" ng-model=\"vm.leadDataService.selectedAccount\" ng-change=\"vm.selectAccount(vm.leadDataService.selectedAccount, true)\" style=\"margin-top: 0; margin-bottom: 0;\">\n	            <md-option ng-repeat=\"team in vm.managedTeams | toArray: false |orderBy:[\'order\'] track by $index + team.ownerID\" ng-value=\"team.ownerID\">\n	                {{team.name}}\n	            </md-option>\n	        </md-select>\n	    </md-input-container>\n	</div>\n      <div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" style=\"margin-right: 1em;\">\n      		<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'active\'}\"  ng-click=\"vm.changeView(\'active\')\">\n      			<md-icon md-font-icon=\"zmdi zmdi-coffee\"> </md-icon><span class=\"\">Active ({{vm.leadCount(\'active\')}})</span>\n      		</md-button>\n      </div>\n      <div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" style=\"margin-right: 1em;\">\n      		<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'won\'}\" ng-click=\"vm.changeView(\'won\')\">\n      			<md-icon md-font-icon=\"fa fa-thumbs-up\"> </md-icon><span class=\"\">Won ({{vm.leadCount(\'won\')}})</span>\n      		</md-button>\n      </div>\n      <div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" style=\"margin-right: 1em;\">\n      		<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'lost\'}\" ng-click=\"vm.changeView(\'lost\')\">\n      			<md-icon md-font-icon=\"fa fa-thumbs-down\"> </md-icon><span class=\"\">Lost ({{vm.leadCount(\'lost\')}})</span>\n      		</md-button>\n      </div>\n      <div flex=\"nogrow\" class=\"toolbar-button-container\" layout=\"row\" style=\"margin-right: 1em;\">\n      		<md-button md-no-ink ng-class=\"{\'active\': vm.leadDataService.currentView == \'archived\'}\" ng-click=\"vm.changeView(\'archived\')\">\n      			<md-icon md-font-icon=\"fa fa-archive\"> </md-icon><span class=\"\">Archived ({{vm.leadCount(\'archived\')}})</span>\n      		</md-button>\n      </div>\n      <div flex=\"nogrow\" style=\"margin-left: 2em; padding-right: 2.5em; position: relative;max-height:29px; \">\n        <md-input-container md-no-float style=\"margin:0; padding: 0;\">\n            <input  class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model-options=\"{debounce: 200}\" ng-model=\"vm.filterText\">\n        </md-input-container>\n          <md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"vm.resetSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n              <md-tooltip md-delay=\"1000\">\n                  Reset search\n              </md-tooltip>\n          </md-icon>\n      </div>\n      <div flex>\n      </div>\n        <div flex=\"nogrow\">\n          <!-- <md-button class=\"task-filter-toolbar-toggle\" ng-click=\"vm.closeFilterBar()\" style=\"position: relative; right:10px;\">\n            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n                <md-tooltip md-delay=\"1000\">\n                    Hide Lead Filters\n                </md-tooltip>\n            </md-icon>\n          </md-button> -->\n        </div>\n    </div><!-- toolbar tools -->\n  </md-toolbar>\n</div>\n<!-- <md-button class=\"task-filter-toolbar-toggle task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!vm.showFilterBar\" ng-click=\"vm.showFilterBar = true\"><md-icon md-font-icon=\"fa fa-search\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n                Show Task Filters\n       </md-tooltip></md-icon></md-button> -->\n<div ng-if=\"vm.showSetupMessage\" class=\"md-padding\" layout=\"column\" layout-align=\"center center\">\n	<md-card layout=\"column\" layout-align=\"center center\" class=\"md-padding\" style=\"max-width: 600px;\">\n	<p class=\"md-title center\"><strong>Leads</strong> is an optional module</p>\n	<p class=\"md-subhead center\"> Visit <md-button  class=\"md-raised md-accent\" ui-sref=\"authentication.profile({selectedTab: 2})\">My Account</md-button> to enable and setup this Leadboard.</p>\n	</md-card>\n</div>\n\n<div ng-if=\"!vm.showSetupMessage\"\n	id=\"scroll-h\"\n	resize class=\"lead-board\"\n	layout=\"row\"\n	layout-align=\"start start\"\n	>\n	<!-- Live lead testing list - reenable for debugging purposes only-->\n	<!-- <div class=\"app-item-container\">\n		<div class=\"app-item-container-items\">\n			<div ng-repeat=\"lead in vm.leadBoard.leads track by $index + timeStamp\">\n				{{lead.firstName}} {{lead.lastName}}\n			</div>\n		</div>\n	</div> -->\n\n	<!-- unassigned Leads container -->\n	<div class=\"app-item-container board-list board-list-new\"\n		flex=\"nogrow\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		layout-align=\"start\"\n		>\n		<div class=\"board-list-header\" style=\"background-color: #666;\">\n			New Leads\n			<md-icon class=\"new-lead-button\" md-font-icon=\"zmdi zmdi-plus\" ng-click=\"vm.newLead(vm.account, \'new\', \'New\')\"></md-icon>\n		</div>\n		<div class=\"app-item-container-items item-container\"\n			resize=\"false\"\n			layout-align=\"start start\"\n			listid=\"new\"\n			dragula=\"\'drag-leads\'\"\n			dragula-scope=\"$scope\"\n			style=\"padding-top: 0;\"\n			>\n			<lead-card  dragula-model=\"leads\" ng-repeat=\"lead in vm.leadBoard.leads | toArray: false  | filter: vm.newLeadFilter | filter:{\'status\':  vm.leadDataService.currentView} | filter: vm.filterText | orderBy: \'order\' track by $index + timeStamp\"></lead-card>\n		</div>\n\n	</div>\n\n	<!-- Leads List Container -->\n		<div class=\"app-item-container board-list board-list-{{leadType.label}}\"\n			flex=\"nogrow\"\n			ng-repeat=\"leadType in vm.leadBoard.leadTypes |toArray : false | orderBy: \'order\' track by $index+uid\"\n			md-whiteframe=\"2\"\n			layout=\"column\"\n			layout-align=\"start\"\n			listid=\"{{leadType.uid}}\"\n			>\n			<div class=\"board-list-header drag-handle\" style=\"background-color: {{leadType.color}};\">\n				{{leadType.label}}\n				<md-icon class=\"new-lead-button\" md-font-icon=\"zmdi zmdi-plus\" ng-click=\"vm.newLead(vm.account, leadType.uid, leadType.label)\"></md-icon>\n			</div>\n			<div class=\"app-item-container-items item-container\"\n				resize=\"false\"\n				layout-align=\"start start\"\n				dragula-scope=\"$scope\"\n				dragula=\"\'drag-leads\'\"\n				listid=\"{{leadType.uid}}\"\n				style=\"padding-top: 0;\">\n				<lead-card\n			     dragula-model=\"leads\"\n			     lead=\"{{lead.uid}}\"\n			     ng-repeat=\"lead in vm.leadBoard.leads | toArray |  filter: {leadType: leadType.uid} | filter:{\'status\':  vm.leadDataService.currentView} |   filter: vm.filterText | orderBy: \'order\'  track by $index + timeStamp\">\n			     </lead-card>\n			</div>\n		</div>\n\n\n	<div layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px; padding-left: 0px; padding-right: 100px;\">\n	    <md-button class=\"\" ng-click=\"vm.leadSettings()\" style=\"width: 200px;\">\n	        <md-icon md-font-icon=\"fa fa-gears\" style=\"font-size: 12px; \"></md-icon> Leadboard Settings\n	    </md-button>\n	</div>\n</div>\n");
$templateCache.put("app/admin-tasks/legacy-tasks-page.tmpl.html","<div class=\"task-filter-toolbar-container\" hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\" ng-show=\"vm.showFilterBar\">\n  <md-toolbar palette-background=\"grey:800\" class=\"task-filter-toolbar\">\n    <div class=\"md-toolbar-tools\">\n      <h2 md-truncate flex=\"nogrow\"></h2>\n      <div flex>\n      </div>\n      <div flex=\"nogrow\">\n        <h3 style=\"font-weight: 900;\">Sort:</h3>\n      </div>\n      <div flex=\"nogrow\"  class=\"toolbar-section\" style=\"margin-right: 1em; padding-right: 1em;\">\n        <md-select md-container-class=\"filter-toolbar-select\" ng-change=\"vm.changeSort(vm.sortOption)\" class=\"task-filter-select md-no-underline\" style=\"margin: 0;\" flex=\"nogrow\" placeholder=\"Sort by\" ng-model=\"vm.sortOption\">\n            <md-option value=\'allOrder\'>\n                Manual\n            </md-option>\n            <md-option value=\'duedate\'>\n                Due date\n            </md-option>\n            <md-option value=\'-budget\'>\n                Budget\n            </md-option>\n            <md-option value=\'-logged\'>\n                Time logged\n            </md-option>\n        </md-select>\n      </div>\n      <div ng-if=\"::vm.showTeamFilter()\"flex=\"nogrow\">\n        <h3 style=\"font-weight: 900;\">Filter:</h3>\n      </div>\n      <div  class=\"toolbar-section\" ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\" style=\"margin-right: 1em; padding-right: 1em;\">\n        <md-select md-container-class=\"filter-toolbar-select\" class=\"task-filter-select md-no-underline\" style=\"width: 175px; margin: 0;\" flex=\"nogrow\" placeholder=\"Filter Users\" ng-model=\"vm.filterOption\" ng-change=\"vm.filterUser(vm.filterOption)\">\n            <md-option value=\'all\' style=\"border-left: 4px solid #fff;\">\n                <!-- <md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em;\"></md-icon> -->\n                All Team Members\n            </md-option>\n            <md-option ng-repeat=\"member in vm.teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by $index\" ng-value=\"{{member}}\" style=\"border-left: 4px solid {{member.color}};\" >\n                <img flex=\"nogrow\" src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; background-color: {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n                <span class=\"small\">{{member.fullName}}\'s Tasks</span>\n            </md-option>\n        </md-select>\n      </div>\n\n      <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-right: 2em;\">\n        <md-input-container md-no-float style=\"margin:0; padding: 0;\">\n            <input hotkey=\"{esc: vm.resetTaskSearch}\" class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model=\"vm.filterText\" ng-model-options=\"{debounce: 200}\">\n        </md-input-container>\n          <md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"vm.resetTaskSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n              <md-tooltip md-delay=\"1000\">\n                  Reset search\n              </md-tooltip>\n          </md-icon>\n      </div>\n\n    <div flex=\"nogrow\" class=\"toolbar-section\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n      <md-switch ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.snoozeFilter\" aria-label=\"Show snoozed tasks\" style=\"margin:0;\">\n      Show snoozed tasks\n      </md-switch>\n\n    </div>\n\n\n      <div flex=\"nogrow\"  style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-right: 0;\">\n        <md-switch  ng-change=\"vm.toggleCardCollapse(vm.collapseCards)\" ng-model=\"vm.collapseCards\" aria-label=\"Collapse Cards\" style=\"margin:0;\">\n        Collapse Cards\n        </md-switch>\n      </div>\n\n\n        <div flex=\"nogrow\">\n          <md-button class=\"task-filter-toolbar-toggle\" ng-click=\"vm.closeFilterBar()\" style=\"position: relative; right:10px;\">\n            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n                <md-tooltip md-delay=\"1000\">\n                    Hide Task Filters\n                </md-tooltip>\n            </md-icon>\n          </md-button>\n        </div>\n    </div><!-- toolbar tools -->\n  </md-toolbar>\n</div>\n<div class=\"no-scrollbar\" layout-padding ng-if=\"vm.clientCount == 0\" layout-fill>\n       <md-content style=\"background-color: transparent;position:relative; top: -2em;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n            <img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n            <h1 class=\"md-display-1\">Welcome to Adminja!</h1>\n           <p class=\"md-headline center margin-20\">Please create a Workspace to get started! <br></p>\n           <new-client-button flex=\"nogrow\"></new-client-button>\n       </md-content>\n</div>\n\n<div id=\"scroll-h\" ng-if=\"vm.clientCount > 0\">\n  <md-button class=\"task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!vm.showFilterBar\" ng-click=\"vm.showFilterBar = true\"><md-icon md-font-icon=\"fa fa-search\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n              Show Task Filters\n          </md-tooltip></md-icon></md-button>\n    <all-today-panel days=\"0\" ng-if=\"vm.settings.showTodayPanel\" tasks=\"vm.user.tasks\"></all-today-panel>\n\n	<!-- ++ Client Panels -->\n\n	<div class=\"app-item-container task-item-container\" ng-class=\"{\'collapsed-cards\': vm.collapseCards}\" md-whiteframe=\"2\" ng-repeat=\"client in vm.clients | toArray:false | filter: limitOwned | orderBy:\'order\' track by client.uid\" ng-show=\"client.profile\" layout=\"column\" layout-align=\"start\">\n		<div class=\"app-item-container-header\" style=\"margin-bottom: 6px;\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{client.profile.clientColor}};\">\n				<div class=\"auto\">\n					<h3>\n						<a href=\"/#/workspaces/{{client.uid}}\">\n						<md-tooltip md-direction=\"right\" md-delay=\"2000\">\n							View Client\n						</md-tooltip>\n\n							<md-icon ng-if=\"client.status != \'personal\'\" class=\"heading-avatar\"><avatar  parent=\"client.profile\" upload=\"false\" border=\"client.profile.clientColor\"></avatar></md-icon>\n              <md-icon ng-if=\"client.status == \'personal\'\" class=\"heading-avatar\"><avatar  type=\"default\" parent=\"client.profile\" border=\"client.profile.clientColor\" upload=\"false\"></avatar></md-icon>\n\n							<span ng-if=\"!client.profile.fullName\">{{client.profile.firstname}} {{client.profile.lastname}}</span>\n						  <span ng-if=\"client.profile.fullName\">{{client.profile.fullName}}</span>\n					</a></h3>\n				</div>\n				<div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n					<md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"vm.quickTask(client)\" >\n						<md-icon aria-label=\"Create new task for {{client.profile.fullName}}\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n							<md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n						</md-icon>\n					</md-button>\n					</a>\n				</div>\n			</div><!-- // end app-item-container-title-bar -->\n			<!-- <client-summary-strip this-client=\"client\"></client-summary-strip> -->\n		</div><!-- // end app-item-container-header -->\n		<div class=\"app-item-container-items \"\n			dragula=\"\'drag-task\'\"\n      resize=\"{{vm.suppressResize}}\"\n			ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n			layout-align=\"start start\"\n			dragula-scope=\"$scope\"\n      panelid=\"{{client.uid}}\"\n			>\n\n      <md-card class=\"quickTaskEntry\" ng-if=\"client.showQuickTask\">\n          <md-input-container class=\"md-no-underline\" md-no-float >\n              <textarea type=\"text\" id=\"quickTaskField\" class=\"md-no-underline\" ng-model=\"vm.newQuickTask.info.description\" placeholder=\"\"></textarea>\n          </md-input-container>\n          <!-- <md-button palette-background=\"green:600\" class=\"md-raised\" ng-click=\"vm.saveQuickTask(vm.newQuickTask)\">Save</md-button> -->\n      </md-card>\n            <app-item\n            	class=\"task-app-item\"\n                taskid=\"{{item.refID}}\"\n                assignee=\"{{item.assignee}}\"\n                order=\"{{item.order}}\"\n                taskpanel=\"{{item.panel}}\"\n                client=\"{{item.client}}\"\n                ng-repeat=\"item in client.tasks| toArray: false | filter:allClientTasks |  filter: snoozeFilter | orderBy: vm.sortOption track by item.refID\"\n                >\n            </app-item>\n\n\n        </div>\n\n    </div>\n    <!-- // Client Panels -->\n\n</div>\n\n");
$templateCache.put("app/admin-tasks/tasks-page.tmpl.html","<div class=\"task-board-wrapper\" ng-style=\"{ \'background-color\' : (vm.kanbanService.allTasksView != \'today\') ? vm.settings.allTaskSettings.color : vm.todayBGColor }\">\n  <!-- task board -->\n  <div class=\"adminja-board-container small-scrollbar\" inhibit-back >\n    <!-- drag-container is used to attached drag animated objects to until they are dropped -->\n    <div class=\"drag-container\">\n    </div>\n    <!-- Muuri Board -->\n    <div class=\"board\" flex=\"nogrow\" ng-style=\"{ \'background-color\' : (vm.kanbanService.allTasksView != \'today\') ? vm.settings.allTaskSettings.color : vm.todayBGColor }\">\n    </div><!-- board -->\n  </div><!-- /adminja-board-container-->\n  <!-- board/list settings panel -->\n  <md-sidenav class=\"md-sidenav-right md-whiteframe-4dp board-side-panel\"  md-component-id=\"board-panel\" layout=\"column\" layout-align=\"layout-fill center\">\n    <md-toolbar class=\"md-theme-light\" style=\"background-color: {{vm.selectedClient.profile.clientColor}}\" layout=\"row\" layout-align=\"start center\">\n      <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"vm.toggleSidePanel()\" class=\"md-warn\">\n        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n      </md-button>\n      <h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'board\'\" class=\"md-toolbar-tools\">Configure Board</h1>\n      <h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'list\' && vm.selectedClient.uid\" class=\"md-toolbar-tools\" md-truncate=\"\">{{vm.selectedClient.profile.fullName}}</h1>\n    </md-toolbar>\n    <md-content layout=\"column\" flex=\"grow\" layout-align=\"start center\" style=\"width:100%;\">\n      <!-- List controls -->\n      <div flex=\"grow\" class=\"board-panel-settings list-settings\" ng-if=\"vm.sidePanelMode == \'list\'\" layout=\"column\" layout-align=\"start layout-fill\">\n        <form name=\"vm.forms.listForm\" style=\"\">\n            <div ng-if=\"vm.selectedClient.uid\">\n              <md-subheader ng-if=\"vm.selectedClient.billingType == \'packages\' && vm.selectedClient.status != \'personal\'\">Packages</md-subheader>\n              <div ng-if=\"vm.size(vm.selectedClient.packages) == 0 && vm.selectedClient.billingType == \'packages\' && vm.selectedClient.status != \'personal\'\" class=\"workspace-package\" layout=\"column\" layout-align=\"start layout-fill\">\n                     <p flex class=\"md-subhead center\">There are no active Packages running for this Workspace</p>\n                    </div>\n                    <div style=\"cursor:  pointer; border-bottom: 1px solid #ededed; padding-bottom: 16px;\" layout=\"column\" ng-click=\"vm.openClientPackages(vm.selectedClient)\"  class=\"workspace-package\" ng-if=\"vm.selectedClient.billingType == \'packages\' && vm.selectedClient.status != \'personal\' && clientPackage.status == \'open\'\"  layout=\"row\" layout-align=\"layout-fill center\" ng-repeat=\"clientPackage in vm.selectedClient.packages | toArray: false | orderBy: [\'-startDate\'] track by $index+uid\">\n                        <div layout=\"row\">\n                          <div flex=\"nogrow\" class=\"padding-left-10 padding-right-20\">\n                            <md-icon style=\"font-size: 20px; color: #888; margin-top: 16px;\" md-font-icon ng-class=\"\n                                       {\'zmdi zmdi-time-restore\': clientPackage.type ==\'hourly\',\n                                        \'zmdi zmdi-time-interval\': clientPackage.type == \'retainer\',\n                                        \'zmdi zmdi-hourglass-alt\': clientPackage.type == \'balance\',\n                                        \'zmdi zmdi-dot-circle\': clientPackage.type ==\'fixed\',\n                                        \'zmdi zmdi-gas-station\': clientPackage.type == \'refillable\'\n                                        }\"\n                            ></md-icon>\n                          </div>\n                          <div layout=\"column\" flex=\"auto\">\n                            <div layout=\"row\">\n                              <div flex=\"auto\" layout=\"column\" layout-align=\"center start\" style=\"overflow-x: hidden;\">\n                                  <p flex class=\"md-subhead workspace-fullname\" md-truncate style=\"white-space: nowrap; width: 100%; color: #555;\">\n                                      <strong>{{clientPackage.label}}</strong><br>\n                                      <span style=\"color: #555; font-size: .85em;\">{{clientPackage.startDate | amDateFormat: vm.settings.superShortDateFormat}} - {{(clientPackage.endDate | amDateFormat: vm.settings.superShortDateFormat) || \"Pending\"}}</span>\n                                  </p>\n                              </div>\n                              <div flex=\"25\" layout=\"column\" layout-align=\"center center\" class=\"\">\n                                 <div style=\"min-height: 50px; height: 50px; max-height: 50px; padding-top: 15px;\" ng-if=\"clientPackage.type == \'hourly\' && clientPackage.budgetedHours > 0 && vm.packageStats[clientPackage.uid].progressBarPercent <= 0\" >\n                                  <md-icon md-font-icon=\"fa fa-check\" style=\"font-size: 24px; color: rgb(76, 175, 80); padding-left: 3px;\"></md-icon>\n                                </div>\n                                 <progress-arc\n                                    ng-if=\"(clientPackage.budgetedHours > 0 && clientPackage.type != \'hourly\') || (clientPackage.type == \'hourly\' && vm.packageStats[clientPackage.uid].progressBarPercent > 0)\"\n                                    class=\"package-progress-circle\"\n                                    size=\"50\"\n                                    stroke=\"{{vm.packageStats[clientPackage.uid].progressBarColor}}\"\n                                    stroke-width=\"5\"\n                                    complete=\"vm.packageStats[clientPackage.uid].progressBarPercent\"\n                                    counter-clockwise=\"true\"\n                                    background=\"{{vm.packageStats[clientPackage.uid].progressBarBackgroundColor}}\"\n                                    label=\"{{vm.packageStats[clientPackage.uid].progressBarPercentLabel}}\">\n                                </progress-arc>\n                                <!-- spacer if no budget for hourly packages -->\n                                <progress-arc ng-if=\"clientPackage.budgetedHours == 0 && clientPackage.type == \'hourly\'\"\n                                 class=\"package-progress-circle\"\n                                 size=\"50\"\n                                 stroke=\"#ffffff\"\n                                 stroke-width=\"5\"\n                                 complete=\"0\"\n                                 counter-clockwise=\"true\"\n                                 background=\"#ffffff\"\n                                 label=\"N/A\"\n                                 >\n                                </progress-arc>\n                              </div>\n                            </div>\n                            <div flex=\"100\" class=\"workspace-package-details\">\n                               <div class=\"package-detail-text-container\" layout=\"row\" layout-align=\"start center\">\n                                   <div flex=\"25\" class=\"package-detail-text\" layout=\"column\" layout-align=\"center start\">\n                                     <p ng-if=\"clientPackage.type != \'hourly\'\"><strong>Budget</strong></p>\n                                     <p ng-if=\"clientPackage.type == \'hourly\'\"><strong>Goal</strong></p>\n                                     <p ng-if=\"clientPackage.budgetedHours > 0\">{{clientPackage.budgetedMinutes | HandM}}</p>\n                                     <p ng-if=\"clientPackage.budgetedHours == 0\">N/A</p>\n                                   </div>\n                                   <div flex=\"25\" class=\"package-detail-text\" layout=\"column\" layout-align=\"center start\">\n                                     <p><strong>Used</strong></p>\n                                     <p>{{clientPackage.qualifiedMinutes | HandM}}</p>\n                                   </div>\n                                   <div flex=\"25\" class=\"package-detail-text\" ng-if=\"clientPackage.type != \'hourly\'\" layout=\"column\" layout-align=\"center start\">\n                                     <p ng-if=\"clientPackage.type != \'hourly\'\"><strong>Remain</strong></p>\n                                     <p ng-if=\"clientPackage.budgetedHours > 0\">{{vm.remain(clientPackage.budgetedMinutes, clientPackage.qualifiedMinutes) | HandM}}</p>\n                                     <p ng-if=\"clientPackage.budgetedHours == 0\">N/A</p>\n                                   </div>\n                                   <div flex=\"25\" class=\"package-detail-text\" ng-if=\"clientPackage.type == \'hourly\'\" layout=\"column\" layout-align=\"center start\">\n                                     <p ng-if=\"clientPackage.type == \'hourly\'\"><strong>Earned</strong></p>\n                                     <p ng-if=\"vm.selectedClient.access.admins[vm.user.uid]\"><span ng-bind-html=\"vm.settings.currency\"></span>{{clientPackage.accrued | number: 2 || 0 | number: 2}}</p>\n                                     <p ng-if=\"!vm.selectedClient.access.admins[vm.user.uid]\"><span ng-bind-html=\"vm.settings.currency\"></span>XXX.XX</p>\n                                   </div>\n                               </div>\n                             </div>\n                          </div>\n                        </div>\n                  </div>\n\n\n\n\n              <md-subheader class=\"margin-top-0\"><span translate>Task Actions</span></md-subheader>\n              <md-list-item>\n                <md-button class=\"wide\" ng-click=\"vm.listMenuNewTask(vm.selectedClient)\">\n                  <md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n                </md-button>\n              </md-list-item>\n              <md-list-item>\n                <md-menu class=\"wide\" style=\"padding-left:0;\">\n                  <md-button class=\"wide\" ng-click=\"$mdMenu.open($event);\">\n                    <md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon>\n                    New Task from Template\n                    <md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                  </md-button>\n                  <md-menu-content class=\"md-dense\" style=\"max-width: 400px;\">\n                    <md-menu-item ng-repeat=\"template in vm.selectedClient.taskTemplates | toArray: false | orderBy: order track by $index+template.uid\">\n                      <md-button ng-click=\"vm.newTaskFromTemplate(vm.selectedClient, template, \'new\')\" md-no-ink=\"true\">\n                        <span md-truncate=\"\">{{template.info.description}}</span>\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n              </md-list-item>\n              <md-list-item ng-if=\"vm.kanbanService.allTasksView != \'today\'\">\n                <md-button class=\"wide\" data-gtm-batch-tasks ng-click=\"vm.batchTasks(vm.selectedClient)\">\n                  <md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n                </md-button>\n              </md-list-item>\n              <!-- <md-list-item>\n                <md-button class=\"wide\" data-gtm-mark-list-complete ng-click=\"vm.markAllComplete(vm.selectedClient)\">\n                  <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark All Tasks Complete\n                </md-button>\n              </md-list-item> -->\n              <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                  <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}clients/{{vm.selectedClient.uid}}\">\n                      <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                  </md-button>\n              </md-menu-item>\n            </div>\n        </form>\n      </div>\n      <!-- Board controls -->\n      <div flex=\"grow\" class=\"board-panel-settings board-settings\" ng-if=\"vm.sidePanelMode == \'board\'\">\n        <form name=\"vm.forms.boardForm\" style=\"\">\n        <md-list class=\"board-settings-list\">\n          <md-subheader style=\"margin-bottom: .5em;\">Search, Filter &amp; Sort</md-subheader>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"layout-fill center\">\n            <div layout=\"row\" layout-align=\"layout-fill center\">\n              <md-input-container flex=\"80\" class=\"task-board-search\">\n                <label>Search</label>\n                  <input style=\"width:  290px;\" hotkey=\"{esc: vm.resetTaskSearch}\" id=\"searchQuery\" type=\"text\" ng-model=\"vm.searchTerm\" ng-change=\"vm.filterItems()\" ng-model-options=\"{debounce: 200}\">\n              </md-input-container>\n                <md-button flex=\"nogrow\" style=\"margin-top:  1em; margin-left: 0px;\" class=\"md-icon-button\" ng-click=\"vm.resetTaskSearch()\">\n                  <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"  style=\"font-size:  14px; color: #999;\">\n                    <md-tooltip md-delay=\"1000\">\n                        Reset search\n                    </md-tooltip>\n                </md-icon>\n            </md-button>\n             </div>\n            <!-- <md-button ng-click=\"vm.filterItems()\">Search</md-button> -->\n          </md-list-item>\n\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n            <md-input-container flex=\"100\">\n              <label>Filter Priorities:</label>\n              <md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.priorityFilter\" ng-change=\"vm.filterItems()\">\n                <md-option value=\'none\'><md-icon md-font-icon=\"zmdi zmdi-flag\"></md-icon>All</md-option>\n                <md-option ng-repeat=\"priority in vm.priorities | orderBy: \'[priority]\' track by $index\" value=\"{{priority.priority}}\">\n                  <md-icon md-font-icon=\"zmdi zmdi-flag\" class=\"{{priority.color}}\"></md-icon>\n                  Priority {{priority.priority}}\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </md-list-item>\n          <md-list-item ng-if=\"vm.teamList\" style=\"padding: 0 10px;\" layout=\"row\">\n            <md-input-container flex=\"100\">\n              <label>Filter Users:</label>\n              <md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.userFilter\" ng-change=\"vm.filterItems()\">\n                <md-option value=\'all\'><md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>All Members</md-option>\n                <md-option ng-repeat=\"member in vm.teamList | toArray: false | orderBy: \'[fullName]\' track by $index\" value=\"{{member.uid}}\">\n                  <md-icon md-font-icon=\"zmdi zmdi-account\" style=\"color:  {{member.color}}\" ></md-icon>\n                  <span style=\"color:  {{member.color}}\">{{member.fullName}}</span>\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </md-list-item>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n            <md-input-container flex=\"100\">\n              <label>Sort by:</label>\n              <md-select class=\"md-no-underline\" ng-model=\"vm.sortBy\" ng-change=\"vm.sortItems(vm.sortBy)\">\n                <md-option value=\"order\">Manual Sort</md-option>\n                <md-option value=\"due\">Due Date</md-option>\n                <md-option value=\"priority\">Priority</md-option>\n                <md-option value=\"assignee\">Team Member</md-option>\n              </md-select>\n            </md-input-container>\n          </md-list-item>\n          <md-subheader style=\"margin-top: 2em;\">Board Settings</md-subheader>\n          <div ng-if=\"vm.kanbanService.allTasksView != \'today\'\">\n            <md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.showColorPicker\" ng-click=\"vm.showColorPicker = true\">\n                <div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n                  <md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-right\"  ></md-icon>\n                  <p>Background Color</p>\n                </div>\n                <div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n                  <div class=\"color-swatch\" style=\"background-color: {{vm.settings.allTaskSettings.color}};\"></div>\n                </div>\n            </md-list-item>\n            <md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showColorPicker\" ng-click=\"vm.showColorPicker = false\">\n                <div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n                  <md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n                  <p>Background Color</p>\n                </div>\n                <div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n                  <div class=\"color-swatch\" style=\"background-color: {{vm.settings.allTaskSettings.color}};\"></div>\n                </div>\n            </md-list-item>\n            <div class=\"list-color-chooser\" ng-if=\"vm.showColorPicker\" style=\"margin-top: 1em;\">\n              <lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.settings.allTaskSettings.color\" ng-model=\"vm.settings.allTaskSettings.color\" ng-click=\"vm.selectColor();\"></lk-color-chooser>\n            </div>\n          </div>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n                  <p translate>Show workspace Name</p>\n                  <md-switch ng-change=\"vm.toggleElementVisibility()\" class=\"md-secondary\" ng-model=\"vm.settings.allTaskSettings.showWorkspaceName\"></md-switch>\n          </md-list-item>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n                  <p translate>Show extended Task Description</p>\n                  <md-switch ng-change=\"vm.toggleElementVisibility()\" class=\"md-secondary\" ng-model=\"vm.settings.allTaskSettings.showRestLines\"></md-switch>\n          </md-list-item>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n                  <p translate>Show Files, Checklist & Comments</p>\n                  <md-switch ng-change=\"vm.toggleElementVisibility()\" class=\"md-secondary\" ng-model=\"vm.settings.allTaskSettings.showDetails\"></md-switch>\n          </md-list-item>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n                  <p translate>Show Assignee</p>\n                  <md-switch ng-change=\"vm.toggleElementVisibility()\" class=\"md-secondary\" ng-model=\"vm.settings.allTaskSettings.showAssignee\"></md-switch>\n          </md-list-item>\n          <md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n                  <p translate>Show Budget & Time </p>\n                  <md-switch ng-change=\"vm.toggleElementVisibility()\" class=\"md-secondary\" ng-model=\"vm.settings.allTaskSettings.showTimeControls\"></md-switch>\n          </md-list-item>\n        </md-list>\n        </form>\n      </div>\n\n    </md-content>\n\n  </md-sidenav>\n  <!-- popup task menu -->\n  <task-menu ng-if=\"vm.selectedTask\" selectedtask=\"vm.selectedTask\" x=\"vm.x\" y=\"vm.y\" board=\"vm.boardData\"></task-menu>\n  <!-- task board filter bar -->\n  <div class=\"adminja-board-controls\" layout=\"column\" layout-align=\"start center\">\n      <!-- <md-icon class=\"adminja-icon-button\" style=\"padding-left:  2px;\" ng-click=\"vm.newList(vm.boardID)\" md-font-icon=\"zmdi zmdi-plus\"></md-icon> -->\n      <md-icon class=\"adminja-icon-button\" style=\"padding-left:  6px;\" ng-click=\"vm.toggleSidePanel(\'board\')\" md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n  </div><!-- /task board filter bar -->\n</div>\n");
$templateCache.put("app/admin-team/admin-team.tmpl.html","<div ng-if=\"vm.initialized\">\n	<div class=\"no-scrollbar\" layout-fill style=\"position: relative; top: -3em;\" ng-if=\"vm.hasTeams && vm.noTeam\">\n		<md-content style=\"background-color: transparent;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n			<md-button ng-click=\"vm.loadTeams()\" class=\"md-primary md-raised\">Load Teams</md-button>\n		</md-content>\n	</div>\n\n	<!-- <div ng-cloak ng-if=\"vm.hasTeams && vm.teamLimit > 1 && !vm.teamsSetup\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 4em; padding-bottom: 4em;\">\n		<div flex layout=\"column\" layout-align=\"start center\" class=\"md-whiteframe-8dp md-padding\" style=\"background-color: #fff; min-width: 500px; min-height: 300px;\">\n			<h3 class=\"center\">Before you can add Team Members, <br>\n			We need to Setup your Team </h3>\n			<md-input-container>\n				<label>Give your team a name</label>\n				<input type=\"text\" ng-model=\"vm.teamName\" placeholder=\"{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\">\n			</md-input-container>\n			<md-button ng-click=\"vm.setupTeam(vm.user, vm.teamName)\" class=\"md-raised md-accent\">Setup Team</md-button>\n		</div>\n	</div> -->\n</div>\n\n<div id=\"scroll-h\" style=\"margin-right: 2em;\" ng-if=\"vm.usersTeams\">\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    TEAM LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div class=\"app-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		tlayout-align=\"start\"\n		>\n		<div class=\"app-item-container-header\" style=\"margin-bottom: 3px;\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\' cursor: default;\'>\n				<div class=\"auto\">\n					<h3>Teams You Are On</h3>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n		<div class=\"app-item-container-items team-card-items\"\n			layout=\"column\"\n			layout-align=\"start start\"\n			resize=\'false\'\n			>\n\n\n\n			<team-card class=\"team-card\" ng-if=\"vm.teamsSetup\" ng-repeat=\"team in vm.usersTeams | toArray: false | orderBy: [\'name\'] track by $index\" team=\"team\"></team-card>\n\n			<md-card ng-if=\"!vm.teamsSetup && vm.hasTeams && vm.teamLimit > 1\" style=\"margin-left:0; margin-right:0; padding: 10px; width:100%;\">\n				<h3 class=\"md-subhead center\">Your plan includes your own team!</h3>\n				<md-input-container>\n					<label>Start by giving it a name</label>\n					<input type=\"text\" ng-model=\"vm.teamName\" placeholder=\"{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\">\n				</md-input-container>\n				<md-button ng-if=\"!vm.loading\" ng-click=\"vm.setupTeam(vm.user, vm.teamName)\" class=\"md-raised md-accent\">Setup Team</md-button>\n				<md-button ng-if=\"vm.loading\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"color: #fff;\"></md-icon> Configuring Team</md-button>\n			</md-card>\n\n			<div ng-if=\"!vm.usersTeam.length\">\n				<p class=\"md-subhead center\" style=\"font-size: 11px;width: 270px;\">You can be a member of more than one team.</p>\n				<p class=\"md-subhead center\" style=\"font-size: 11px;width: 270px;\">If you accept another team\'s invitation, <br>the team will appear here.</p>\n			</div>\n\n			<div ng-if=\"!vm.usersTeams.length && vm.user.limits.team > 1\" layout=\"column\" layout-align=\"center center\" style=\"width: 270px; margin-top: 1em;\">\n				<p class=\"md-subhead center\" style=\"width: 270px;\">Looking for your teams?</p>\n				<md-button class=\"\" ng-click=\"vm.refreshTeams();\"><md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> Refresh</md-button>\n			</div>\n\n\n		</div>\n	</div>\n	 <div class=\"no-scrollbar\" ng-if=\"vm.initialized && !vm.hasTeams && !vm.usersTeams.length\" layout-fill style=\"position: relative; top: -3em;\">\n	       <md-content style=\"background-color: transparent;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n		       	<img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n		        <p class=\"md-headline center \">Teams are only available for certain plans.<br></p>\n		        <p class=\"center\"><md-button class=\"md-raised md-primary md-accent\" ui-sref=\"authentication.profile({selectedTab: 4})\">Upgrade your Subscription</md-button></p>\n	       </md-content>\n	</div>\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<!-- /////////////////////////////////    MEMBER LIST  ////////////////////////////////////////-->\n	<!-- //////////////////////////////////////////////////////////////////////////////////////////////////-->\n	<div class=\"app-item-container\"\n		md-whiteframe=\"2\"\n		layout=\"column\"\n		tlayout-align=\"start\"\n		ng-if=\"vm.teamDataService.selectedTeam\"\n		>\n		<div class=\"app-item-container-header\" style=\"margin-bottom: 3px;\">\n			<div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\' cursor: default;\'>\n				<div class=\"auto\">\n					<h3>{{vm.teamDataService.selectedTeam.name}}</h3>\n				</div>\n\n			</div><!-- // end app-item-container-title-bar -->\n		</div><!-- // end app-item-container-header -->\n		<!-- <p class=\"text-center md-subhead\" ng-hide=\"vm.teamDataService.team\"><strong>No Team Members Have Been Added</strong><br> Invite someone to get started.\n			</p> -->\n		<md-button class=\"invite-member-button\" ng-if=\"vm.teamDataService.selectedTeam.ownerID == vm.user.uid || vm.teamDataService.selectedTeam.members[vm.user.uid].isTeamAdmin\" ng-disabled=\"!vm.canAddMembers()\" style=\"\" class=\"md-raised md-accent\" ng-click=\"vm.inviteMember(vm.teamDataService.selectedTeam, vm.teamDataService.selectedTeamLimit);\" >\n			<span ng-if=\"vm.canAddMembers()\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Invite a New Member</span>\n			<span ng-if=\"!vm.canAddMembers()\">{{vm.teamDataService.selectedTeamLimit}} of {{vm.teamDataService.selectedTeamLimit}} members used</span>\n		</md-button>\n\n		<div class=\"team-list-filter-bar\" layout=\"column\" ng-if=\"vm.showSortSearch()\">\n			<md-divider></md-divider>\n			<div class=\"team-list-filters\" layout=\"row\" layout-align=\"start center\">\n				<span flex=\"nogrow\" style=\"font-size: 12px; padding-left: 10px; padding-right: 10px;\"><strong>Sort: </strong> </span>\n				<div flex=\"grow\" layout=\"row\" layout-align=\"start center\">\n					<md-button ng-class=\"{\'selected\': vm.sortBy == \'-becameMember\'}\" class=\"md-button-flat-round\" ng-click=\"vm.changeSort(\'-becameMember\')\">Joined</md-button>\n					<md-button ng-class=\"{\'selected\': vm.sortBy == \'firstName\'}\" class=\"md-button-flat-round\" ng-click=\"vm.changeSort(\'firstName\')\">First</md-button>\n					<md-button ng-class=\"{\'selected\': vm.sortBy == \'lastName\'}\" class=\"md-button-flat-round\" ng-click=\"vm.changeSort(\'lastName\')\">Last</md-button>\n					<md-button ng-class=\"{\'selected\': vm.sortBy == \'email\'}\" class=\"md-button-flat-round\" ng-click=\"vm.changeSort(\'email\')\">Email</md-button>\n					<md-button class=\"md-button-flat-round\" ng-if=\"!vm.showSearch\" ng-click=\"vm.showSearch = true\"><md-icon md-font-icon=\"zmdi zmdi-search\"></md-icon></md-button>\n				</div>\n			</div>\n			<div ng-if=\"vm.showSearch\" ng-controller=\"menuSearchController\" class=\"team-list-search\" layout=\"row\" layout-align=\"center center\">\n				<input ng-model-options=\"{debounce: 200}\" ng-model=\"vm.filterText\" placeholder=\"Search\" ng-change=\"vm.search(vm.filterText)\">\n				<md-button ng-click=\"vm.resetSearch()\" class=\"md-button-small\"><md-icon class=\"menu-search-reset\" md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n			</div>\n		</div>\n		<div class=\"app-item-container-items team-card-items\"\n			layout=\"column\"\n			layout-align=\"start start\"\n			resize=\'false\'\n			>\n			<team-member-card ng-if=\"member.uid == vm.teamDataService.selectedTeam.ownerID || vm.teamDataService.selectedTeam.members[vm.user.uid].isTeamAdmin || vm.user.uid == vm.teamDataService.selectedTeam.ownerID\" ng-repeat=\"member in vm.teamDataService.selectedTeam.members  | toArray: false| limitTo:vm.teamDataService.selectedTeamLimit | filter: vm.memberSearch | orderBy: [vm.sortBy] track by member.uid\" displaytype=\"card\" member=\"member\" team=\"{{vm.teamDataService.ownerID}}\"></team-member-card>\n			<div ng-if=\"!vm.teamDataService.selectedTeam.members[vm.user.uid].isTeamAdmin && vm.user.uid != vm.teamDataService.selectedTeam.ownerID\">\n				<p class=\"md-subhead\" style=\"text-align: center; font-size: 12px; width: 270px;\">Only Team Admins and Team Owners <br>can view or manage team members.</p>\n			</div>\n		</div>\n	</div>\n	<team-member-detail ng-if=\"vm.teamDataService.selectedMember\" member=\"vm.teamDataService.selectedMember\" user=\"vm.teamDataService.selectedUser\" team=\"vm.teamDataService.selectedTeam\"></team-member-detail>\n</div><!-- //scrollH -->\n");
$templateCache.put("app/admin-time-reports/time-reports.tmpl.html","<div layout=\"column\"  layout-padding >\n\n    <div class=\"time-report-controls\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" >\n        <div flex layout=\"row\" layout-align=\"start center\" style=\"overflow-x: scroll;\">\n            <md-input-container style=\"margin-left: 1em;\" ng-if=\"vm.managedTeams.length > 1\" flex=\"nogrow\" style=\"max-width: 200px;\">\n                <label>Account</label>\n                <md-select flex=\"nogrow\" ng-model=\"vm.selectedAccount\" ng-change=\"vm.selectAccount(vm.selectedAccount, true)\" style=\"margin-top: 0; margin-bottom: 0;\">\n                    <md-option ng-repeat=\"team in vm.managedTeams | toArray: false |orderBy:[\'order\'] track by $index + team.ownerID\" ng-value=\"team.ownerID\">\n                        {{team.name}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container flex=\"nogrow\" style=\"margin-left: 21px;\">\n                <label>Date Range</label>\n                <md-select style=\"margin: 0 1em 0 1em;\" ng-placeholder=\"Select a range\" ng-model=\"vm.rangeSetting\" ng-change=\"vm.updateDateRange(vm.rangeSetting)\">\n                    <md-option value=\"saved\">\n                        User selected\n                    </md-option>\n                    <md-option value=\"last7\">\n                        Last 7 Days\n                    </md-option>\n                    <md-option value=\"last14\">\n                        Last 14 Days\n                    </md-option>\n                    <md-option value=\"last30\">\n                        Last 30 Days\n                    </md-option>\n                    <md-option value=\"last90\">\n                        Last 90 Days\n                    </md-option>\n                    <md-option value=\"thisMonth\">\n                        Month to Date\n                    </md-option>\n            </md-input-container>\n            <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin-bottom: 0; margin-left: 21px; margin-top: 21px;\">\n                <label>From</label>\n                <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0 0 0 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\"  md-placeholder=\"Start\" ng-change=\"vm.manualRangeUpdate()\"></md-datepicker>\n            </md-input-container>\n            <md-input-container ng-if=\"!vm.retainerMode\" flex=\"nogrow\" style=\"margin: 21px 0 0 0;\">\n                <label>To</label>\n                <md-datepicker md-current-view=\"year\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" style=\"margin: 0\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\"  md-placeholder=\"End\"  ng-change=\"vm.manualRangeUpdate()\"></md-datepicker>\n            </md-input-container>\n\n            <md-input-container  ng-if=\"vm.retainerMode\" style=\"margin-left: 21px; margin-right: 21px;\">\n                <label>From</label>\n\n                <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.start\" ng-change=\"vm.updateReport()\">\n                    <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date}}\">\n                        {{month.label}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container ng-if=\"vm.retainerMode\" style=\"margin-right: 21px;\">\n                <label>To</label>\n                <md-select style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.timeReportService.report.end\" ng-change=\"vm.updateReport()\">\n                    <md-option ng-repeat=\"month in vm.monthSelect track by month.date\" value=\"{{month.date | amAdd : \'1\' : \'month\'| amSubtract: \'1\' : \'day\'}}\">\n                        {{month.label}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n\n            <md-input-container flex=\"nogrow\" style=\"margin-right: 2em;\">\n                <label>Workspace Filter</label>\n                <md-select ng-disabled=\"vm.showArchived\"  ng-model=\"vm.timeReportService.report.selectedClient\" style=\"width: 200px;\" ng-change=\"vm.switchSource(vm.timeReportService.report.selectedClient)\" placeholder=\"Restrict to client...\">\n                    <md-option value=\"all\">All Workspaces ({{vm.clients.length}})</md-option>\n                    <md-option ng-if=\"!client.disabled\" ng-repeat=\"client in vm.clients | orderBy: \'order\' track by client.uid\" ng-value=\"\'{{client.uid}}\'\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n                        <img ng-if=\"client.status != \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                        <img ng-if=\"client.status == \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                        <span class=\"small\">{{client.profile.fullName}}</span><span ng-if=\"client.clientType == \'delegated\'\"><md-icon style=\"font-size: 10px; margin-left: 2em;\" md-font-icon=\"fa fa-users\"></md-icon></span></md-option>\n                </md-select>\n            </md-input-container>\n\n\n            <md-input-container flex=\"nogrow\" style=\"margin-right: 2em;\" ng-if=\"vm.teamDataService.allMembers.length > 1\">\n                <label>User</label>\n                <md-select ng-model=\"vm.timeReportService.report.selectedMember\" ng-change=\"vm.switchUser(vm.timeReportService.report.selectedMember)\" style=\"width: 200px;\"   placeholder=\"Restrict to user...\">\n                        <md-option value=\"all\">All Active Users</md-option>\n                        <md-option ng-repeat=\"member in vm.teamDataService.allMembers | toArray: false | orderBy: \'profile.lastName\' track by member.uid\" value=\"{{member.uid}}\" style=\"border-left: 4px solid {{member.color}};\">\n                            <img src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; background-color: {{member.color}}; margin-right: 1em; position: relative; top: 5px;\">\n                            <span class=\"small\">{{member.fullName}}</span>\n                        </md-option>\n                        <!-- <md-option ng-click=\"vm.refreshTeams()\"><md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> Refresh Team Filter</md-option> -->\n                </md-select>\n            </md-input-container>\n            <md-input-container flex=\"grow\" ng-if=\"vm.selectedAccount != \'all\'\">\n                <md-checkbox  style=\"margin-bottom: 0;\" ng-click=\"vm.toggleArchived(vm.selectedAccount)\" ng-model=\"vm.showArchived\"></md-checkbox><span style=\"font-size: 11px;\">Include archived</span>\n            </md-input-container>\n        </div>\n        <div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                <!-- <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'month\'}\" ng-click=\"vm.viewMonths()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-comfy\">\n                        <md-tooltip>\n                            Group by Month\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'week\'}\" ng-click=\"vm.viewWeeks()\">\n                    <md-icon  class=\"report-control-button\"  md-font-icon=\"zmdi zmdi-view-week\">\n                        <md-tooltip>\n                            Group by Week\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-class=\"{\'active\': vm.timeReportService.report.view == \'list\'}\" ng-click=\"vm.viewList()\">\n                    <md-icon class=\"report-control-button\"   md-font-icon=\"zmdi zmdi-view-list\">\n                        <md-tooltip>\n                            Show as List\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <span flex=\"nogrow\" style=\"border-right: 1px solid #bbb; width: 2px; margin:0 1em 0 1em;\"></span>\n -->\n                <md-button ng-if=\"vm.showGrid\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.updateReport()\">\n                    <md-icon   class=\"report-control-button\" md-font-icon=\"zmdi zmdi-refresh\">\n                        <md-tooltip>\n                            Refresh/Fit Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button ng-if=\"!vm.showGrid\" ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" >\n                    <md-icon class=\"report-control-button\" md-font-icon=\"zmdi zmdi-refresh fa-spin\">\n                        <md-tooltip>\n                            Loading Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button ng-disabled=\"!vm.showGrid\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.downloadCSV(vm.groupEntries(vm.timeReportService.report.start, vm.timeReportService.report.end), vm.allTimeReportFilename())\">\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-download\">\n                        <md-tooltip md-delay=\"500\">\n                            Download Spreadsheet\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <md-button ng-disabled=\"!vm.showGrid\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.reportAllTime();\" >\n                    <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-print\">\n                        <md-tooltip md-delay=\"500\">\n                            View Report\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n                <!-- <div flex=\"nogrow\" ng-if=\"vm.timeReportService.report.data.length >= 5000\">\n                    <md-button ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.reportAllTime();\" >\n                        <md-icon  class=\"report-control-button\" md-font-icon=\"zmdi zmdi-print\">\n                            <md-tooltip class=\"tt-multiline\">\n                                This report contains {{vm.timeReportService.report.data.length}} entries <br>and is too large to email or convert to PDF.<br>Please consider downloading it as a spreadsheet.\n                            </md-tooltip>\n                        </md-icon>\n                    </md-button>\n                </div> -->\n            </div>\n\n        </div>\n\n\n    </div>\n    <div class=\"time-grid-page-container\" >\n\n\n        <div ng-if=\"vm.showGrid && vm.gridOptions.data.length > 0\" ui-grid=\"vm.gridOptions\" ui-grid-auto-resize ui-grid-exporter ui-grid-grouping class=\"timeGrid\">\n        </div>\n        <div layout-fill ng-if=\"!vm.showGrid\" layout=\"row\" layout-align=\"center center\" style=\"width: 100%; background-color:#fff; \">\n            <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n            <h3 flex=\"nogrow\" class=\"center md-title\">Gathering Your Time</h3>\n        </div>\n        <div layout-fill layout=\"column\" layout-align=\"center center\" ng-if=\"vm.showGrid && vm.gridOptions.data.length == 0\" style=\"background-color: #fff;\">\n            <div layout=\'row\' layout-align=\"center center\">\n                <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-exclamation-circle\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n                <h3 flex=\"nogrow\" class=\"center md-title\">No Time Found</h3>\n            </div>\n            <p class=\"center md-subhead\">Please try a different date range or filter combination.</p>\n            <p class=\"center md-subhead\">\n                <md-button ng-if=\"vm.showGrid\" flex=\"nogrow\" class=\"md-button-small md-secondary\" ng-click=\"vm.updateReport()\">\n                    <md-icon   class=\"report-control-button\" md-font-icon=\"zmdi zmdi-refresh\">\n                        <md-tooltip>\n                            Refresh/Fit Report\n                        </md-tooltip>\n                    </md-icon>\n\n                    Re-fetch Time Records\n                </md-button>\n                <md-button ng-if=\"!vm.showGrid\" ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" >\n                    <md-icon class=\"report-control-button\" md-font-icon=\"zmdi zmdi-refresh fa-spin\">\n                        <md-tooltip>\n                            Loading Report\n                        </md-tooltip>\n                    </md-icon>\n                    Fetching time records\n                </md-button></p>\n        </div>\n\n    </div>\n\n</div>\n");
$templateCache.put("app/admin-timer-prototype/timer-prototype.tmpl.html","<md-content class=\"timer-prototype\" flex layout-padding style=\"max-width: 700px; margin:0 auto;\">\n<!--    <h2>Timer Prototype</h2>\n    <p>The directives in the prototype do not need to have any real \"design\" or \"styling\" beyond making it functional. Do not feel obligated to utilize angular-material or any existing stylesheets. There is a stylesheet you can use for this page if you would like.<p>-->\n    <!--<timer></timer>-->\n    <timer-list></timer-list>\n</md-content>\n");
$templateCache.put("app/admin-today/today.tmpl.html","<div ng-if=\"vm.groupTodayByClients\" class=\"task-filter-toolbar-container\" hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\" ng-show=\"vm.showFilterBar\">\n  <md-toolbar palette-background=\"grey:800\" class=\"task-filter-toolbar\">\n    <div class=\"md-toolbar-tools\">\n      <h2 md-truncate flex=\"nogrow\"></h2>\n      <div flex>\n      </div>\n      <!--\n      <div flex=\"nogrow\">\n        <h3 style=\"font-weight: 900;\">Sort:</h3>\n      </div>\n      <div flex=\"nogrow\" class=\"toolbar-section\" style=\"margin-right: 1em; padding-right: 1em;\">\n         <md-select md-container-class=\"filter-toolbar-select\" ng-change=\"vm.changeSort(vm.sortOption)\" class=\"task-filter-select md-no-underline\" style=\"margin: 0;\" flex=\"nogrow\" placeholder=\"Sort by\" ng-model=\"vm.sortOption\">\n          <md-option value=\'allOrder\'>\n            Manual\n          </md-option>\n          <md-option value=\'duedate\'>\n            Due date\n          </md-option>\n          <md-option value=\'-budget\'>\n            Budget\n          </md-option>\n          <md-option value=\'-logged\'>\n            Time logged\n          </md-option>\n        </md-select>\n      </div>-->\n      <div ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\">\n        <h3 style=\"font-weight: 900;\">Filter:</h3>\n      </div>\n      <div class=\"toolbar-section\" ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\" style=\"margin-right: 1em; padding-right: 1em;\">\n        <md-select md-container-class=\"filter-toolbar-select\" class=\"task-filter-select md-no-underline\" style=\"width: 175px; margin: 0;\" flex=\"nogrow\" placeholder=\"Filter Users\" ng-model=\"vm.filterOption\" ng-change=\"vm.filterUser(vm.filterOption)\">\n          <md-option value=\'all\' style=\"border-left: 4px solid #fff;\">\n            <!-- <md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em;\"></md-icon> -->\n            All Team Members\n          </md-option>\n          <md-option ng-repeat=\"member in vm.teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by $index\" ng-value=\"{{member}}\" style=\"border-left: 4px solid {{member.color}};\">\n            <img flex=\"nogrow\" src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n            <span class=\"small\">{{member.fullName}}\'s Tasks</span>\n          </md-option>\n        </md-select>\n      </div>\n      <!-- <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-right: 2em;\">\n        <md-input-container md-no-float style=\"margin:0; padding: 0;\">\n          <input hotkey=\"{esc: vm.resetTaskSearch}\" class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model=\"vm.filterText\" ng-model-options=\"{debounce: 200}\">\n        </md-input-container>\n        <md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"vm.resetTaskSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n          <md-tooltip md-delay=\"1000\">\n            Reset search\n          </md-tooltip>\n        </md-icon>\n      </div> -->\n      <!-- <div flex=\"nogrow\" class=\"toolbar-section\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n        <md-switch ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.snoozeFilter\" aria-label=\"Show snoozed tasks\" style=\"margin:0;\">\n          Show snoozed tasks\n        </md-switch>\n      </div> -->\n      <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; margin-right: 0;\">\n        <md-switch ng-change=\"vm.toggleCardCollapse(vm.collapseCards)\" ng-model=\"vm.collapseCards\" aria-label=\"Collapse Cards\" style=\"margin:0;\">\n          Collapse Cards\n        </md-switch>\n      </div>\n      <div flex=\"nogrow\">\n        <md-button class=\"task-filter-toolbar-toggle\" ng-click=\"vm.closeFilterBar()\" style=\"position: relative; right:10px;\">\n          <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n            <md-tooltip md-delay=\"1000\">\n              Hide Task Filters\n            </md-tooltip>\n          </md-icon>\n        </md-button>\n      </div>\n    </div>\n    <!-- toolbar tools -->\n  </md-toolbar>\n</div>\n\n<div class=\"no-scrollbar\" layout-padding ng-if=\"vm.hasClients == 0\" layout-fill>\n       <md-content style=\"background-color: transparent; position:relative; top: -2em;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n            <img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n            <h1 class=\"md-display-1\">Welcome to Adminja!</h1>\n           <p class=\"md-headline center margin-20\">Please create a Workspace to get started! <br></p>\n           <new-client-button flex=\"nogrow\"></new-client-button>\n       </md-content>\n</div>\n<div id=\"scroll-h\" ng-if=\"vm.hasClients > 0\">\n	<md-button class=\"task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!vm.showFilterBar\" ng-click=\"vm.showFilterBar = true\"><md-icon md-font-icon=\"fa fa-search\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n	            Show Task Filters\n	        </md-tooltip></md-icon></md-button>\n	<all-today-panel days=\"0\" ng-if=\"!vm.groupTodayByClients\" limitto=\"1000\" tasks=\"vm.user.tasks\"></all-today-panel>\n\n  	<today-panel ng-if=\"vm.groupTodayByClients\" ng-repeat=\"client in vm.clients | toArray:false |  filter: limitOwned | orderBy:\'order\' track by client.uid\" days=\"0\" client=\"client\" tasks=\"client.tasks\" ng-show=\"client.profile\"></today-panel>\n\n\n</div>\n");
$templateCache.put("app/adminja-admin/manage-page.tmpl.html","");
$templateCache.put("app/adminja-admin/manage-test.tmpl.html","<div layout=\"column\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<md-content layout=\"row\" layout-align=\"center start\">\n			<div layout=\"column\" flex=\"50\" layout-align=\"start center\">\n				<md-input-container>\n					<md-datepicker ng-change=\"vm.clearRruleTest()\" md-hide-icons=\"calendar\" ng-model=\"vm.dtStart\" placeholder=\"dtStart\"></md-datepicker>\n				</md-input-container>\n				<md-button class=\"md-raised md-primary\" ng-click=\"vm.testRule(vm.dtStart)\">Test rRule</md-button>\n			</div>\n			<div layout=\"column\" flex=\"50\">\n				<div ng-repeat=\"results in vm.testResults track by $index\">\n					{{results}}\n				</div>\n			</div>\n		</md-content>\n</div>\n\n\n");
$templateCache.put("app/adminja-admin/manage-toolbar.tmpl.html","<!-- // Account Manager Toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" >\n\n  <div flex=\"nogrow\"  style=\"padding-right: 2em;\">\n    <h3>Manage Adminja</h3>\n  </div>\n<!--   <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" class=\"md-button\"  ui-sref=\"triangular.account-page.profile\" ><md-icon md-font-icon=\"fa fa-user\"></md-icon> Profile</a>\n  </div>\n\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-users\"></md-icon> Team</a>\n  </div>\n  <div flex=\"nogrow\" style=\"padding-top: 5px; padding-bottom: 5px;\">\n    <a ui-sref-active=\"active\" ng-disabled=\"true\" class=\"md-button\"><md-icon md-font-icon=\"fa fa-credit-card\"></md-icon> Plan</a>\n  </div>\n  <div flex></div>\n  <sidebar-controls></sidebar-controls> -->\n</div>\n\n");
$templateCache.put("app/adminja-admin/manage-users.tmpl.html","<div layout=\"row\" flex ng-show=\"vm.user.type == \'admin\'\" class=\"admin-panel\" layout-fill>\n		<div flex=\"25\" layout=\"column\">\n			<md-content flex=\"100\">\n				<md-list>\n\n				       <md-subheader class=\"md-sticky\">Users</md-subheader>\n				       <md-list-item ng-class=\"{\'selected\': user.uid === vm.selectedUser.uid}\" class=\"md-3-line\" ng-repeat=\"user in vm.users | toArray:false | orderBy: \'email\' track by $index\" ng-click=\"vm.selectUser(user.uid)\">\n				         <img ng-src=\"{{user.avatar|| \'/assets/images/avatars/generic-person-avatar.png\'}}\" class=\"md-avatar\" alt=\"{{user.fullName}}\" />\n				         <div class=\"md-list-item-text\" layout=\"column\">\n				           <h3>{{user.fullName}}</h3>\n				           <h4>{{user.email}}</h4>\n				           <p>Teams: {{vm.teamSize(user.teams)}}</p>\n				           <p>Plan: {{user.plan}}</p>\n				         </div>\n				       </md-list-item>\n				       <md-divider ></md-divider>\n				</md-list>\n			</md-content>\n		</div>\n		<div flex layout=\"column\">\n			<md-content flex=\"100\" layout-padding>\n			<md-card>\n				<h3>User Details</h3>\n				<form name=\"userAdminForm\">\n				<div layout=\"row\">\n					<div flex layout-align=\"center center\">\n						<img ng-src=\"{{vm.selectedUser.profile.avatar|| \'/assets/images/avatars/generic-person-avatar.png\'}}\" class=\"md-avatar\" alt=\"{{vm.selectedUser.profile.fullName}}\" style=\"width: 200px; border-radius: 200px;\"/>\n						<h3>{{vm.selectedUser.profile.fullName}}</h3>\n						<h4>{{vm.selectedUser.email}}</h4>\n						<p class=\"md-caption\">\n							<strong>Started:</strong> {{vm.selectedUser.profile.startDate | amDateFormat: \'MMM Do, YYYY\'}}<br>\n							<strong>Country:</strong> {{vm.selectedUser.profile.country || \'unspecified\'}}<br>\n							<strong># Clients:</strong> {{vm.numClients}}<br>\n						</p>\n						<md-button ng-click=\"vm.copyLearningBoard(vm.selectedUser.uid)\">Copy Learning Adminja board</md-button>\n					</div>\n					<div flex layout=\"column\">\n						<h3><small>Plan &amp; Limits</small></h3>\n						<p class=\"md-caption\"  style=\"margin-bottom: 2em;\">\n						<strong>Plan: </strong> {{vm.selectedUser.plan.content__subscription__plan_id}}<br>\n						<strong>Status: </strong> {{vm.selectedUser.plan.content__subscription__status}}<br>\n							<small><strong>UID:</strong> <a href=\"{{vm.fbConfig.dataURL}}users/{{vm.selectedUser.uid}}\" target=\"_blank\">{{vm.selectedUser.uid}}</a></small>\n						</p>\n						<p><strong>Teams</strong><br>\n							<span ng-repeat=\"(key, value) in vm.selectedUser.teams track by $index\">\n								<a href=\"{{vm.fbConfig.dataURL}}teams/{{key}}\" target=\"_blank\">{{key}}</a>\n							</span>\n						</p>\n						<md-input-container label=\"Client Limit\">\n							<label for=\"limit\">Client Limit</label>\n							<input type=\"text\" name=\"limit\"ng-model=\"vm.selectedUser.limits.clients\">\n						</md-input-container>\n						<md-input-container label=\"Team Limit\">\n							<label for=\"teamLimit\">Team Limit</label>\n							<input type=\"text\" name=\"teamLimit\"ng-model=\"vm.selectedUser.limits.team\">\n						</md-input-container>\n						<md-input-container label=\"Account Type\">\n							<label for=\"type\">Account Type</label>\n							<input type=\"text\" name=\"type\" ng-model=\"vm.selectedUser.type\">\n						</md-input-container>\n						<md-button ng-click=\"vm.updateUser(vm.selectedUser)\" class=\"md-raised md-accent\">Update</md-button>\n\n					</div>\n					<div flex layout=\"column\" layout-align=\"start end\" >\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.ghostThisUser(vm.selectedUser)\">Login as This User</md-button>\n						<div ng-show=\"!vm.selectedUser.plan.api_version\">\n					<!-- 	<h3>Trigger Subscribe</h3>\n\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'beta-ninja\')\">Subscribe as \"Beta Ninja\"</md-button>\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'early-ninja\')\">Subscribe as \"Early Ninja\"</md-button>\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'starter-2017b\')\">Subscribe as \"Starter\"</md-button>\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'lite-2017b\')\">Subscribe as \"Lite\"</md-button>\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'assistant-2017b\')\">Subscribe as \"Assistant\"</md-button>\n						<md-button class=\"md-raised mid-primary\" ng-click=\"vm.subscribeUser(vm.selectedUser, \'pro-2017b\')\">Subscribe as \"Pro\"</md-button> -->\n					</div>\n					</div>\n				</div>\n				</form>\n				</md-card>\n\n			</md-content>\n		</div>\n\n\n</div>\n\n\n");
$templateCache.put("app/bry/bry-page.tmpl.html","<md-content class=\"padded-content-page time-grid-page-container\" layout-fill resize>\n    <div layout=\"column\" layout-align=\"center center\">\n        <h2 class=\"md-display-3\">Bryan\'s Sandbox</h2>\n        <!-- <md-button class=\"md-raised md-primary\" ng-click=\"vm.getCaptureUsers()\">Get Capture Users</md-button> -->\n\n    </div>\n    <md-card>\n        <h2 class=\"center\">Manage TaskBoard Upgrades</h2>\n        <md-button  ng-if=\"!vm.theseObjects\" class=\"md-raised md-accent\" ng-click=\"vm.start()\">Start</md-button>\n        <div layout=\"row\" layout-align=\"start start\">\n            <div flex=\"40\">\n                <div ng-if=\"vm.theseObjects\" class=\"user\" ng-repeat=\"user in vm.theseObjects | toArray: false | orderBy: [\'-sessionCount\'] track by $index+uid\" layout=\"column\" >\n                    <p class=\"md-subhead\">\n                        <md-icon ng-if=\"user.profile.onboardingFlags.taskBoardUpgrade0821Complete\" md-font-icon=\"fa fa-check\" style=\"color: green;\"></md-icon>\n                        <md-icon ng-if=\"!user.profile.onboardingFlags.taskBoardUpgrade0821Complete\" md-font-icon=\"fa fa-exclamation-circle\" style=\"color: red;\"></md-icon>\n                        {{user.email}} / {{user.profile.firstName}} {{user.profile.lastName}}<br>\n                        Last Login: {{user.lastSession | amDateFormat: \'MM/DD/YY\'}}<br>\n                        {{user.sessionCount}} Sessions<br>\n                        {{vm.clientCount(user)}} Workspaces\n                        <md-button class=\"md-raised md-primary\" ng-click=\"vm.loadClients(user)\">View Workspaces</md-button>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"vm.loginAs(user)\">Login As</md-button>\n                    </p>\n                </div>\n            </div>\n            <div flex=\"60\">\n                <h3 ng-if=\"vm.selectedUser\">{{vm.selectedUser.profile.firstName}}\'s Workspaces</h3>\n                <div ng-if=\"vm.selectedUser\" ng-repeat=\"client in vm.clients track by $index+uid\" layout=\"row\">\n                    <div flex=\"40\">\n                        {{client.profile.fullName}} / {{client.status}}\n                        <md-button href=\"{{vm.fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\">X-ray</md-button>\n                    </div>\n                    <div flex=\"60\">\n                        <md-button ng-if=\"!client.taskBoards && !vm.upgrading[client.uid]\" class=\"md-raised md-accent\" ng-click=\"vm.upgradeClient(client)\">Upgrade</md-button>\n                        <md-icon ng-if=\"client.taskBoards && !vm.upgrading[client.uid]\" md-font-icon=\"fa fa-check\" style=\"color: green;\"></md-icon>\n                        <md-icon ng-if=\"vm.upgrading[client.uid]\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 16px; width: 16px; font-size: 16px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <span ng-if=\"vm.processing\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: orange; margin: 0 auto 0 auto;\"></md-icon></span>\n            <span ng-if=\"!vm.processing\"><md-icon md-font-icon=\"fa fa-check\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: green; margin: 0 auto 0 auto;\"></md-icon></span>\n            <!-- <md-button ng-if=\"vm.theseObjects && !vm.processing\" class=\"md-raised md-primary\" ng-click=\"vm.deleteAll()\">Delete All</md-button> -->\n            <md-button ng-if=\"vm.cursor && !vm.processing\" class=\"md-raised md-primary\" ng-click=\"vm.nextPage(vm.cursor)\">Next Page</md-button>\n            <md-button ng-if=\"!vm.cursor\" class=\"md-raised md-primary\" ng-click=\"vm.start()\">Load Objects</md-button>\n\n            <!-- <md-button ng-if=\"vm.cursor\" class=\"md-raised md-primary\" ng-click=\"vm.getSubs(vm.users)\">Get Subscription Data</md-button> -->\n        </div>\n    </md-card>\n    <hr>\n    <md-card ng-if=\"bryanSays\">\n        <md-title>Task Cards</md-title>\n        <div layout=\"row\" layout-align=\"center center\" style=\"padding: 3em;\">\n            <div class=\"task-card\" style=\"border-top: 4px solid blue;\">\n                  <div class=\"status\">\n                      <i class=\"margin-top-0 adminja-icon-button zmdi zmdi-square-o\"></i>\n                      <i class=\"adminja-icon-button zmdi zmdi-flag red\"></i>\n                      <i class=\"adminja-icon-button zmdi zmdi-stop blue\"></i>\n                  </div>\n                  <div class=\"title\">\n                      <h3>Title of the task</h3>\n                      <h4>Lori Birch</h4>\n                      <p class=\"description\">Lorem ipsum dolor sit amet consectetur adipiscing elit torquent potenti ligula, ad per rhoncus...</p>\n                      <!-- <div class=\"task-thumbnails\">\n                        <img src=\"https://via.placeholder.com/50\">\n                        <img src=\"https://via.placeholder.com/50\">\n                        <img src=\"https://via.placeholder.com/50\">\n                        <img src=\"https://via.placeholder.com/50\">\n                      </div> -->\n                  </div>\n                  <div class=\"utility\">\n                      <i class=\"margin-top-0 adminja-icon-button zmdi zmdi-more-vert\"></i>\n                  </div>\n                  <div class=\"assignee\">\n                    <p class=\"margin-top-0 margin-bottom-0\">\n                        <i class=\"adminja-icon-button zmdi zmdi-account-circle\"></i> <span>Bryan Lewis</span>\n                    </p>\n                  </div>\n                  <div class=\"due\">\n                    <p class=\"due-date right red\" >Jun 21</p>\n                  </div>\n                  <div class=\"items\">\n                        <p class=\"right margin-top-0 margin-bottom-0\">\n                          <i class=\"padding-left-0 adminja-icon-button zmdi zmdi-view-list-alt\"></i> <span>2/10</span>\n                          <i class=\"adminja-icon-button zmdi zmdi-attachment\"></i> <span>3</span>\n                          <i class=\"adminja-icon-button zmdi zmdi-comment-outline\"></i> <span>2</span>\n                       </p>\n                  </div>\n\n                  <div class=\"time\">\n                      <i class=\"adminja-icon-button zmdi zmdi-time\"></i>\n                      <span class=\"time-logged green\">2:23</span>\n                      <div class=\"task-progress-container\">\n                        <div class=\"task-progress\" style=\"background-color: green; height:  4px; width:  40%;\"></div>\n                      </div>\n                      <span class=\"time-budget\">4:00</span>\n                      <div class=\"time-controls\">\n                          <i class=\"adminja-icon-button zmdi zmdi-plus\"></i>\n                          <i class=\"adminja-icon-button zmdi zmdi-play\"></i>\n                          <i class=\"margin-right-0 adminja-icon-button zmdi zmdi-stop\"></i>\n                     </div>\n                  </div>\n            </div>\n        </div>\n    </md-card>\n    <hr>\n    <md-card ng-if=\"bryanSays\" class=\"md-padding\">\n        <h3>Secret Management</h3>\n        <md-input-container>\n            <label>Secret Name</label>\n            <input ng-model=\"vm.secret.label\" ng-disabled=\"vm.editingSecret\" type=\"text\">\n        </md-input-container>\n        <md-input-container>\n            <label>Secret Value</label>\n            <input ng-model=\"vm.secret.value\" type=\"text\">\n        </md-input-container>\n        <md-button ng-if=\"!vm.editingSecret\" ng-click=\"vm.createSecret(vm.secret)\" class=\"md-raised md-primary\">+ Create</md-button>\n        <md-button ng-if=\"vm.editingSecret\" ng-click=\"vm.updateSecret(vm.secret)\" class=\"md-raised md-primary\">Confirm Update</md-button>\n        <md-divider style=\"margin-bottom: 25px;\"></md-divider>\n        <h4>Stored Secrets</h4>\n        <ul>\n            <li ng-repeat=\"secret in vm.user.secrets | toArray: false track by $index+uid\">\n                {{secret.label}} <md-button ng-click=\"vm.getSecret(secret.uid)\" class=\"md-warn\">Get</md-button>\n                <md-button ng-click=\"vm.editSecret(secret)\" class=\"md-warn\">Edit</md-button>\n                <md-button ng-click=\"vm.deleteSecret(secret.uid)\" class=\"md-warn\">Delete</md-button>\n            </li>\n        </ul>\n    </md-card>\n\n\n\n\n    <div layout=\"row\">\n        <div flex=\"30\">\n            <strong>ID</strong>\n        </div>\n        <div flex=\"20\">\n            <strong>Title</strong>\n        </div>\n        <div flex=\"30\">\n            <strong>type</strong>\n        </div>\n        <div flex=\"20\">\n            <strong>recipient</strong>\n        </div>\n\n    </div>\n    <div ng-if=\"bryanSays\" ng-if=\"vm.theseObjects\">\n        <div ng-repeat=\"object in vm.theseObjects track by $index+uid\" layout=\"row\">\n            <div flex=\"30\">\n                <a href=\"{{vm.fbConfig.dataURL}}notifications/{{object.uid}}\" target=\"_blank\">{{object.uid}}</a>\n            </div>\n            <div flex=\"20\">\n                {{object.title}}\n            </div>\n            <div flex=\"30\">\n                {{object.type}}\n            </div>\n            <div flex=\"20\">\n                {{object.targets[0].userID}}\n            </div>\n        </div>\n    </div>\n\n<md-divider></md-divider>\n<md-divider></md-divider>\n<md-divider></md-divider>\n<h3>userPilot Tests</h3>\n<md-button ng-click=\"vm.playUserPilotExperience(\'1628772735xBfq4328\')\" class=\"md-raised md-primary\">Muuri Post-Upgrade Modal</md-button>\n</md-content>\n");
$templateCache.put("app/calendar/calendar-fabs.tmpl.html","<md-button ng-click=\"vm.addEvent($event)\" class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"{{\'CALENDAR.ADD_EVENT\' | translate}}\">\n    <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n</md-button>\n");
$templateCache.put("app/calendar/calendar.tmpl.html","<div class=\"no-scrollbar\" ng-if=\"!vm.hasCalendar\" layout-fill style=\"position: relative; top: -3em;\">\n       <md-content style=\"background-color: transparent;\" layout=\"column\" layout-align=\"center center\" layout-fill>\n	       	<img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"50\">\n	        <p class=\"md-headline center \">The Task Calendar is not available on the Free Starter plan.<br></p>\n	        <p class=\"center\"><md-button class=\"md-raised md-primary md-accent\" ui-sref=\"authentication.profile({selectedTab: 2})\">Upgrade your Subscription</md-button>\n       </md-content>\n</div>\n\n	<div ng-if=\"vm.hasCalendar\" class=\"task-filter-toolbar-container\" hotkey=\"{esc: vm.closeFilterBar}\" layout=\"column\"  ng-show=\"vm.showFilterBar\">\n	  <md-toolbar palette-background=\"grey:800\" class=\"task-filter-toolbar\">\n	    <div class=\"md-toolbar-tools\">\n	      <!-- <h2 md-truncate flex=\"nogrow\"></h2> -->\n	      <div flex>\n	      </div>\n\n	      <div ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\">\n	        <h3 style=\"font-weight: 900;\">Filter:</h3>\n	      </div>\n	      <div  class=\"toolbar-section\" ng-if=\"::vm.showTeamFilter()\" flex=\"nogrow\" style=\"margin-right: 1em; padding-right: 1em; \">\n	        <md-select md-container-class=\"filter-toolbar-select\" class=\"task-filter-select md-no-underline\" style=\"width: 175px; margin: 0;\" flex=\"nogrow\" placeholder=\"Filter Users\" ng-model=\"vm.filterOption\" ng-change=\"vm.filterUser(vm.filterOption)\">\n	            <md-option value=\'all\' style=\"border-left: 4px solid #fff;\">\n	                <!-- <md-icon md-font-icon=\"fa fa-users\" style=\"margin-right: .5em; margin-left: .5em;\"></md-icon> -->\n	                All Team Members\n	            </md-option>\n	            <md-option ng-repeat=\"member in vm.allMembers | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'member.fullName\' track by $index\" ng-value=\"{{member}}\" style=\"border-left: 4px solid {{member.color}};\" >\n	                <img flex=\"nogrow\" src=\"{{member.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{member.color}}; margin-left: .5em; margin-right: .5em; position: relative; top: 5px;\">\n	                <span class=\"small\">{{member.fullName}}\'s Tasks</span>\n	            </md-option>\n	        </md-select>\n	      </div>\n	      <!-- <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n	        <md-input-container md-no-float style=\"margin:0; padding: 0;\">\n	            <input hotkey=\"{esc: vm.resetTaskSearch}\" class=\"task-query\" id=\"searchQuery\" placeholder=\"Search\" type=\"text\" ng-model-options=\"{debounce: 200}\" ng-model=\"vm.filterText\">\n	        </md-input-container>\n	          <md-icon md-font-icon=\"zmdi zmdi-close\" ng-click=\"vm.resetTaskSearch()\" style=\"cursor: pointer; color: #666; font-size: 12px; position:absolute; right: 29px; top: 3px;\">\n	              <md-tooltip md-delay=\"1000\">\n	                  Reset search\n	              </md-tooltip>\n	          </md-icon>\n	      </div> -->\n\n	      <div flex=\"nogrow\" style=\"padding-right: 2.5em; position: relative;max-height:29px; \">\n	        <md-switch ng-change=\"vm.refreshView()\" ng-model=\"vm.snoozeFilter\" aria-label=\"Show snoozed tasks\" style=\"margin:0;\">\n	        Show snoozed tasks\n	        </md-switch>\n\n	      </div>\n\n	        <div flex=\"nogrow\">\n	          <md-button class=\"task-filter-toolbar-toggle\" ng-click=\"vm.closeFilterBar()\" style=\"position: relative; right:10px;\">\n	            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 12px;\">\n	                <md-tooltip md-delay=\"1000\">\n	                    Hide Task Filters\n	                </md-tooltip>\n	            </md-icon>\n	          </md-button>\n	        </div>\n	    </div><!-- toolbar tools -->\n	  </md-toolbar>\n	</div>\n	<div class=\"no-scrollbar\" ng-if=\"vm.hasCalendar\" class=\"calendar-height-container\">\n	<div class=\"calendar-page\">\n		<div layout=\"row\" layout-align=\"start center\">\n			<!-- <md-button ng-if=\"!vm.loading\" class=\"md-button-small\" ng-click=\"vm.refreshView()\">\n				<md-icon ng-show=\"!vm.loading\" md-font-icon=\"zmdi zmdi-refresh\" aria-label=\"Refresh Calendar\" style=\"color: #fff;\"></md-icon>\n				<md-tooltip md-delay=\"1000\">\n					Refresh Calendar (Expiremental)\n				</md-tooltip>\n			</md-button>\n			<md-button ng-if=\"vm.loading\" ng-disabled=\"true\" class=\"md-button-small\" ng-click=\"vm.refreshView()\">\n				<md-icon  md-font-icon=\"zmdi zmdi-refresh fa-spin\" aria-label=\"Refresh Calendar\" style=\"color: #fff;\"></md-icon>\n				<md-tooltip md-delay=\"1000\">\n					Refreshing\n				</md-tooltip>\n			</md-button> -->\n		    <h2 class=\"font-weight-300 font-size-4 text-light margin-top-30 margin-bottom-30\" flex ng-hide=\"vm.currentView == \'agendaWeek\'\">{{vm.currentDay | amDateFormat:vm.viewFormats[vm.currentView]}}</h2>\n		    <h2 class=\"font-weight-300 font-size-4 text-light margin-top-30 margin-bottom-30\" flex ng-show=\"vm.currentView == \'agendaWeek\'\">Week {{vm.currentWeek | amDateFormat:\'W\'}} - {{vm.currentWeek | amDateFormat:\'YYYY\'}}</h2>\n		    <div layout=\"row\" flex=\"50\" layout-align=\"end center\" class=\"calendar-toolbar\">\n			    	<md-button class=\"md-button-small\" ng-click=\"vm.changeMonth(\'prev\')\">\n			    		<md-icon md-font-icon=\"zmdi zmdi-chevron-left\" aria-label=\"Previous month\"></md-icon>\n			    		<md-tooltip md-delay=\"1000\">\n			    			<span ng-if=\"vm.currentView == \'month\'\" >Previous Month</span>\n			    			<span ng-if=\"vm.currentView == \'agendaWeek\'\" >Previous Week</span>\n			    			<span ng-if=\"vm.currentView == \'agendaDay\'\" >Previous Day</span>\n			    		</md-tooltip>\n\n			    	</md-button>\n			    	<md-button class=\"md-button-small\" ng-click=\"vm.changeMonth(\'today\')\">\n			    		<!-- <md-icon md-font-icon=\"fa fa-bullseye\" aria-label=\"Today\"></md-icon> -->\n			    		<span style=\"color: #fff;\">Today</span>\n			    		<md-tooltip md-delay=\"1000\">\n			    			Now\n			    		</md-tooltip>\n			    	</md-button>\n\n\n\n			    	<md-button class=\"md-button-small\" ng-click=\"vm.changeMonth(\'next\')\">\n			    		<md-icon md-font-icon=\"zmdi zmdi-chevron-right\" aria-label=\"Next Month\"></md-icon>\n			    		<md-tooltip md-delay=\"1000\">\n			    			<span ng-if=\"vm.currentView == \'month\'\" >Next Month</span>\n			    			<span ng-if=\"vm.currentView == \'agendaWeek\'\" >Next Week</span>\n			    			<span ng-if=\"vm.currentView == \'agendaDay\'\" >Next Day</span>\n			    		</md-tooltip>\n			    	</md-button>\n\n			    	<md-button class=\"md-button-small\" ng-class=\"{\'active\': vm.currentView == \'month\'}\" ng-click=\"vm.changeView(\'month\')\" style=\"color:#fff;\">\n			    		<md-icon md-font-icon=\"zmdi zmdi-view-module\" ></md-icon>\n			    		<md-tooltip md-delay=\"1000\">\n			    			View by Month\n			    		</md-tooltip>\n			    	</md-button>\n			    	<md-button class=\"md-button-small\" ng-class=\"{\'active\': vm.currentView == \'agendaWeek\'}\" ng-click=\"vm.changeView(\'agendaWeek\')\" style=\"color:#fff;\">\n			    		<md-icon md-font-icon=\"zmdi zmdi-view-week\" ></md-icon>\n			    		<md-tooltip md-delay=\"1000\">\n			    			View by Week\n			    		</md-tooltip>\n			    	</md-button>\n				<md-button class=\"md-button-small\" ng-class=\"{\'active\': vm.currentView == \'agendaDay\'}\" ng-click=\"vm.changeView(\'agendaDay\')\" style=\"color:#fff;\">\n					<md-icon md-font-icon=\"zmdi zmdi-view-day\" ></md-icon>\n					<md-tooltip md-delay=\"1000\">\n						View by Day\n					</md-tooltip>\n				</md-button>\n\n			    	<md-button class=\"md-raised md-button-small md-accent\" ng-click=\"vm.newTask()\">\n			    		<md-icon md-font-icon=\"zmdi zmdi-plus\" aria-label=\"New Task\"></md-icon>\n			    		<md-tooltip md-delay=\"1000\">\n			    			New Task\n			    		</md-tooltip>\n			    	</md-button>\n\n		    </div>\n		</div>\n\n		<md-button class=\"task-filter-toolbar-toggle task-filter-toolbar-tab-button\" palette-background=\"grey:800\" ng-if=\"!vm.showFilterBar\" ng-click=\"vm.showFilterBar = true\"><md-icon md-font-icon=\"fa fa-chevron-down\" style=\"color: #fff; font-size: 11px;\"><md-tooltip md-delay=\"1000\">\n		            Show Task Filters\n		</md-tooltip></md-icon></md-button>\n	    <div class=\"calendar-directive triangular-calendar \" flex ui-calendar=\"vm.calendarOptions\" ng-model=\"vm.eventSources\" calendar=\"triangular-calendar\" ></div>\n	</div>\n\n</div>\n");
$templateCache.put("app/calendar/event-dialog.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog\" flex=\"60\" flex-xs=\"100\">\n    <md-toolbar class=\"toolbar-default\" ng-style=\"{ \'background-color\': vm.selectedColor.backgroundColor, color: vm.selectedColor.textColor }\">\n        <div class=\"md-toolbar-tools\">\n            <h2>\n                <span translate>{{::vm.dialogData.title}}</span>\n                <span ng-show=\"vm.event.title\"> - {{vm.event.title}}</span>\n            </h2>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"cancel\">\n                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-divider></md-divider>\n\n    <md-dialog-content class=\"md-dialog-content\">\n        <form class=\"event-dialog-form\" name=\"eventForm\">\n            <md-input-container class=\"md-block\">\n                <label translate>CALENDAR.EVENT.TITLE</label>\n                <input ng-model=\"vm.event.title\" required>\n            </md-input-container>\n            <md-list>\n                <md-list-item layout=\"row\" layout-align=\"space-between center\">\n                    <p translate>CALENDAR.EVENT.ALL-DAY</p>\n                    <md-switch class=\"md-secondary\" ng-model=\"vm.event.allDay\" ng-change=\"vm.allDayChanged()\"></md-switch>\n                </md-list-item>\n            </md-list>\n            <div class=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start center\">\n                <p flex hide-xs translate>CALENDAR.EVENT.START</p>\n                <md-datepicker ng-model=\"vm.start\" md-placeholder=\"CALENDAR.EVENT.START | translate\"></md-datepicker>\n            </div>\n            <div class=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start center\">\n                <p flex translate>CALENDAR.EVENT.START-TIME</p>\n                <div layout=\"row\" layout-align=\"end center\">\n                    <md-icon class=\"padding-right-10\" md-font-icon=\"zmdi zmdi-access-time\"></md-icon>\n                    <md-select class=\"padding-right-10\" placeholder=\"{{\'CALENDAR.EVENT.HOUR-PICK\' | translate}}\" ng-model=\"vm.startTime.hour\">\n                        <md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour | padding:2}}</md-option>\n                    </md-select>\n                    <md-select class=\"padding-right-10\" placeholder=\"{{\'CALENDAR.EVENT.MINUTE-PICK\' | translate}}\" ng-model=\"vm.startTime.minute\">\n                        <md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute | padding:2}}</md-option>\n                    </md-select>\n                </div>\n            </div>\n            <div class=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start center\" ng-hide=\"vm.event.allDay\">\n                <p translate flex hide-xs>CALENDAR.EVENT.END</p>\n                <md-datepicker ng-model=\"vm.end\" md-placeholder=\"CALENDAR.EVENT.END | translate\"></md-datepicker>\n            </div>\n            <div class=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start center\" ng-hide=\"vm.event.allDay\">\n                <p flex translate>CALENDAR.EVENT.END-TIME</p>\n                <div layout=\"row\" layout-align=\"end center\">\n                    <md-icon class=\"padding-right-10\" md-font-icon=\"zmdi zmdi-access-time\"></md-icon>\n                    <md-select class=\"padding-right-10\" placeholder=\"{{\'CALENDAR.EVENT.HOUR-PICK\' | translate}}\" ng-model=\"vm.endTime.hour\">\n                        <md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour | padding:2}}</md-option>\n                    </md-select>\n                    <md-select class=\"padding-right-10\" placeholder=\"{{\'CALENDAR.EVENT.MINUTE-PICK\' | translate}}\" ng-model=\"vm.endTime.minute\">\n                        <md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute | padding:2}}</md-option>\n                    </md-select>\n                </div>\n            </div>\n            <md-input-container class=\"md-block\">\n                <label translate>CALENDAR.EVENT.LOCATION</label>\n                <input type=\"text\" ng-model=\"vm.event.location\">\n            </md-input-container>\n            <md-input-container class=\"md-block\">\n                <label translate>CALENDAR.EVENT.DESCRIPTION</label>\n                <textarea ng-model=\"vm.event.description\"></textarea>\n            </md-input-container>\n            <md-input-container class=\"md-block\">\n                <div layout=\"row\" layout-align=\"space-between center\">\n                    <p flex translate>CALENDAR.EVENT.COLOR</p>\n                    <md-select md-container-class=\"calendar-color-select\" placeholder=\"{{\'CALENDAR.EVENT.COLOR-PICK\' | translate}}\" ng-model=\"vm.selectedColor\" ng-change=\"vm.colorChanged()\">\n                        <md-option ng-value=\"color\" ng-repeat=\"color in vm.colors\">{{color.name}}</md-option>\n                    </md-select>\n                </div>\n            </md-input-container>\n        </form>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\">\n        <md-button class=\"md-warn\" ng-click=\"vm.deleteClick()\" aria-label=\"{{\'CALENDAR.DELETE\' | translate}}\" ng-show=\"vm.edit\" translate=\"CALENDAR.DELETE\"></md-button>\n        <span flex></span>\n        <md-button ng-click=\"vm.cancelClick()\" aria-label=\"{{\'CALENDAR.CANCEL\' | translate}}\" translate=\"CALENDAR.CANCEL\"></md-button>\n        <md-button ng-click=\"vm.okClick()\" class=\"md-primary\" ng-disabled=\"eventForm.$invalid\" aria-label=\"{{vm.dialogData.confirmButtonText | translate}}\" translate=\"{{::vm.dialogData.confirmButtonText}}\"></md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/calendar/toolbar.tmpl.html","<div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" hide-gt-md ng-click=\"vm.openSideNav(\'left\')\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n    <h2 flex>\n        <span ng-repeat=\"crumb in vm.breadcrumbs.crumbs\">\n            <span translate>{{crumb.name}}</span>\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\">\n        </span>\n    </h2>\n\n    <div class=\"widget-buttons\">\n        <md-button class=\"widget-button md-icon-button\" ng-click=\"vm.changeMonth(\'prev\')\" aria-label=\"previous month\">\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n        </md-button>\n        <md-button hide show-gt-lg class=\"widget-button md-icon-button\" ng-click=\"vm.changeMonth(\'today\')\" aria-label=\"today\">\n            <md-icon md-font-icon=\"zmdi zmdi-calendar-alt\"></md-icon>\n        </md-button>\n        <md-button class=\"widget-button md-icon-button\" ng-click=\"vm.changeMonth(\'next\')\" aria-label=\"next month\">\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n        </md-button>\n    </div>\n\n    <md-menu>\n        <md-button class=\"md-icon-button\" aria-label=\"{{\'CALENDAR.TOOLBAR.CHANGE-VIEW\' | translate}}\" ng-click=\"$mdOpenMenu()\">\n            <md-icon md-font-icon=\"{{vm.currentView.icon}}\" ng-class=\"vm.currentView.icon\"></md-icon>\n        </md-button>\n        <md-menu-content  class=\"md-dense\" width=\"2\">\n            <md-menu-item ng-repeat=\"view in vm.views\">\n                <md-button ng-click=\"vm.changeView(view)\" translate=\"{{::view.name}}\" aria-label=\"{{::view.name}}\"></md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n\n");
$templateCache.put("app/layouts/adminja-menu.tmpl.html","<md-toolbar class=\"sidebar-left-toolbar\" md-theme=\"{{::triSkin.elements.logo}}\">\n    <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\" style=\"padding:0;\">\n        <div class=\"sidebar-left-icon\" ng-if=\"vm.layout.sideMenuSize == \'icon\'\" >\n            <img class=\"menu-bug\" ng-src=\"assets/images/brand/adminja-bug-app.png\" alt=\"{{::vm.sidebarInfo.appName}}\" ng-click=\"vm.toggleIconMenu()\">\n        </div>\n\n        <div flex class=\"sidebar-left-title\" ><img class=\"app-logotype\" src=\"assets/images/brand/adminja-logotype-white.svg\"  alt=\"{{::vm.sidebarInfo.appName}}\"></div>\n\n        <md-button class=\"md-icon-button sidebar-left-icon hide-xs hide-sm \" style=\"margin-right: .5em;\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\" md-no-ink= \"true\">\n            <md-icon md-no-ink=\"true\" md-font-icon style=\"font-size: 11px;\" ng-class=\"{ \'fa fa-thumb-tack\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-close\' : vm.layout.sideMenuSize == \'full\' }\">\n                <md-tooltip md-delay=\"1000\">\n                    Pin/UnPin Menu\n                </md-tooltip>\n            </md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button hide-md hide-lg hide-xl\" style=\"margin-right: .5em; color: #fff;\" ng-click=\"vm.closeSideNav(\'left\')\" aria-label=\"Close side menu\" md-no-ink=\"true\" >\n            <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"font-size: 14px;\" >\n                <md-tooltip md-delay=\"1000\">\n                    Close Menu\n                </md-tooltip>\n            </md-icon>\n            Close\n        </md-button>\n\n    </div>\n\n</md-toolbar>\n<!-- <md-divider></md-divider> -->\n\n<tri-menu style=\"height: 100%;\" md-theme=\"{{triSkin.elements.sidebar}}\" flex layout=\"column\"></tri-menu>\n<!-- <div ng-if=\"vm.user.profile.settings.onboardingComplete != true\" ng-click=\"vm.openOnboarding();\" class=\"side-menu-link onboarding-progress-button\" style=\"padding:25px 0 0px 0;\">\n    <md-progress-linear flex md-theme=\"adminja-status\" ng-class=\"{ \'md-accent\' : vm.onboardingProgress() < 71, \'md-primary\' : vm.onboardingProgress()>70}\" class=\"margin-bottom-0\" md-mode=\"determinate\" value=\"{{vm.onboardingProgress()}}\"></md-progress-linear>\n    <span>Progress</span>\n</div> -->\n\n<!-- <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"end center\" style=\"padding:0;\">\n    <md-button class=\"md-icon-button sidebar-left-icon hide-xs hide-sm hide-md\" style=\"margin-right: .5em;\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\">\n        <md-icon md-font-icon style=\"font-size: 14px; color: #fff;\" ng-class=\"{ \'zmdi zmdi-lock-open\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-lock-outline\' : vm.layout.sideMenuSize == \'full\' }\">\n            <md-tooltip md-delay=\"1000\">\n                Pin/UnPin Menu\n            </md-tooltip>\n        </md-icon>\n    </md-button>\n</div> -->\n\n\n");
$templateCache.put("app/payment-portal/payment-portal.tmpl.html","<!-- Authentication.tmpl.html -->\n<div id=\"public-form\" class=\"full-image-background payment-portal\" ng-class=\"authBackground\" layout=\"column\" layout-align=\"center start\" layout-fill style=\"padding-left: 5px; padding-right: 5px;\">\n	<md-card class=\"payment-portal\">\n		<md-content class=\"form-container\" layout=\"column\" layout-align=\"start layout-fill\" style=\"padding-left: 10px; padding-right: 10px;\">\n					<!-- initializing -->\n					<div ng-if=\"!vm.initDone\" layout=\"column\" layout-align=\"layout-fill center\">\n							<h3 class=\"md-title center margin-bottom-40\">{{vm.pendingMessage}}</h3>\n							<p class=\"center margin-bottom-40\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 72px; width: 72px; font-size: 72px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n					</div>\n\n					<!-- error -->\n					<div ng-if=\"vm.showError && vm.initDone\">\n						<p class=\"center margin-bottom-40\"><md-icon md-font-icon=\"fa fa-frown-o\" style=\"font-size: 4em;\"></md-icon></md-idon>\n						<div ng-bind-html=\"vm.errorMessage\"></div>\n						<p class=\"center\"><md-button ng-if=\"vm.showRefresh\" class=\"md-raised md-accent\" ng-click=\"vm.resetForm()\">Try Again</md-button></p>\n					</div>\n\n					<!-- payment form -->\n					<div ng-if=\"!vm.showError && vm.initDone && !vm.isRefill\" layout=\"column\">\n						<div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.invoice.logo\" style=\"padding-bottom: 2em;\">\n							<img flex=\"nogrow\" class=\"logo\" src=\"{{vm.invoice.logo}}\" style=\"width:150px;\">\n							<h3 ng-if=\"!vm.invoice.logo && vm.invoice.remit.company\">{{vm.invoice.remit.company}}</h3>\n							<h3 ng-if=\"vm.invoice.logo && !vm.invoice.remit.company\">{{vm.invoice.remit.email}}</h3>\n						</div>\n						<md-divider></md-divider>\n						<!-- invoice details -->\n						<div class=\"invoice-details\" ng-if=\"(vm.paymentState == \'pending\' || vm.paymentState == \'capturing\') && !vm.isRefill\" layout=\"column\">\n							<p class=\"md-title center margin-top-0\">Invoice # {{vm.invoice.info.number}}</p>\n							<p class=\"md-subhead center margin-top-0\"><strong>Due {{vm.invoice.info.displayDueDate}}</strong></p>\n							<p class=\"md-subhead center margin-top-0 small\">For: {{vm.invoice.info.recipient.name}},<br>{{vm.invoice.info.recipient.email}}</p>\n							<div  layout=\"row\" layout-align=\"layout-fill start\">\n								<div flex=\"50\" class=\"padding-right-10\">\n									<p class=\"md-subhead right margin-top-0\">\n										<!--Subtotal:<br>\n										<span ng-if=\"vm.invoice.info.taxPercentage > 0\">{{vm.invoice.info.taxLabel}} ({{vm.invoice.info.taxPercentage}}%): <br></span>-->\n										<strong>Total: </strong><br>\n										<strong style=\"color: green;\">Payments: </strong><br>\n										<strong style=\"color: red;\">Balance: </strong>\n									</p>\n								</div>\n								<div flex=\"50\" class=\"padding-left-10\">\n									<p class=\"md-subhead margin-top-0\">\n										<!--{{vm.invoice.currency}}{{vm.invoice.info.subTotal}}<br>\n										<span ng-if=\"vm.invoice.info.taxPercentage > 0\">{{vm.invoice.currency}}{{vm.invoice.info.taxedAmount}}<br></span>-->\n										{{vm.invoice.currency}}{{vm.invoice.info.total}}<br>\n										<span style=\"\">{{vm.invoice.currency}}{{vm.invoice.info.received || \'0.00\'}}<br></span>\n										<span style=\"\">{{vm.invoice.currency}}{{vm.invoice.info.balance}}</span>\n									</p>\n								</div>\n							</div>\n						</div>\n\n\n						<!-- Accept Payment -->\n						<div ng-if=\"!vm.isRefill\" ng-class=\"{\'obscure\' : vm.paymentState == \'capturing\', \'hide\': vm.paymentState == \'recording\' || vm.paymentState == \'recorded\'}\">\n							<div class=\"payment-form\">\n								<p class=\"md-subhead center\">Amount to pay:</p>\n								<md-input-container layout=\"row\" style=\"width: 125px;\">\n									<span class=\"currency\">{{vm.invoice.currency}}</span><input class=\"payment-amount\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" style=\"display:inline-block; text-align:center;\" type=\"text\" ng-model=\"vm.paymentAmount\">\n								</md-input-container>\n							</div>\n							<!-- payment processors -->\n							<div class=\"payment-processors\">\n								<div ng-if=\"vm.invoice.info.enablePaypal\" class=\"paypal-buttons\">\n									<div id=\"paypal-button-container\"></div>\n								</div>\n								<div ng-if=\"vm.invoice.info.enableStripe\" class=\"padding-left-20 padding-right-20 padding-top-40 padding-bottom-10\" style=\" border-radius: 4px;\">\n									<div class=\"sr-root\">\n									      <div class=\"sr-main\">\n										        <form id=\"stripe-payment-form\" class=\"sr-payment-form\">\n										        	<div layout=\"column\">\n											          <div class=\"sr-combo-inputs-row\">\n											            <div class=\"sr-input sr-card-element\" id=\"card-element\" style=\"border: 2px padding: 1em;\"></div>\n											          </div>\n											          <div class=\"sr-field-error\" id=\"card-errors\" role=\"alert\"></div>\n											          <div layout=\"row\" layout-align=\"center center\" class=\"padding-top-20\">\n												          <md-button style=\"height: 48px; width: 100%; max-height: 48px;\" id=\"submit\" type=\"submit\" class=\"md-accent md-raised\">\n												            <div style=\"height: 36px;\" class=\"hidden\" id=\"spinner\">\n												            	<md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"color: #999;\"></md-icon> <span>Authorizing Payment</span>\n												            </div>\n												            <span style=\"height: 36px;\" id=\"stripe-button-text\">Pay Now</span><span style=\"height: 36px;\" id=\"order-amount\"></span>\n												          </md-button>\n												     </div>\n											     </div>\n										        </form>\n									      </div>\n									</div>\n									<div layout=\"row\" layout-align=\"center center\" class=\"padding-top-20\">\n										<p class=\"center payments-by\">Payments secured by</p> <img class=\"payments-by\" src=\"/assets/images/elements/stripe-blurple.png\" width=\"80\"></p>\n									</div>\n								</div>\n							</div>\n						</div>\n\n						<!-- recording payment -->\n						<div ng-if=\"!vm.isRefill\">\n							<div ng-if=\"vm.paymentState != \'pending\' && vm.paymentState != \'recorded\'\">\n								<p class=\"center md-subhead\" ng-if=\"vm.paymentState == \'recording\'\">Finalizing Your Payment</p>\n								<p class=\"center md-subhead\" ng-if=\"vm.paymentState == \'capturing\' && vm.invoice.info.enablePaypal\">Waiting for PayPal Checkout</p>\n								<p class=\"center md-subhead\" ng-if=\"vm.paymentState == \'capturing\' && vm.invoice.info.enableStripe\">Waiting for Stripe Checkout</p>\n								<p class=\"center margin-bottom-40 margin-top-40\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 4em; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n							</div>\n							<!-- success -->\n							<div ng-if=\"vm.paymentState == \'recorded\'\" layout=\"column\" layout-align=\"start center\">\n								<h1 class=\"md-title center margin-top-40\" style=\"color: #444; font-size: 3em; margin-bottom: 25px;\">Thank You!</h1>\n								<h2 class=\"center\"><md-icon style=\"font-size: 6em; margin-top: 40px; margin-bottom: 40px;\" class=\"green\" md-font-icon=\"fa fa-check\"></md-icon></h2>\n\n								<p class=\"md-subhead center\">Invoice #{{vm.invoice.info.number}}<br>Payment received:  {{vm.invoice.currency}}{{vm.paymentAmount | number: 2}}<br><strong>Balance:</strong> {{vm.invoice.currency}}{{vm.newBalance}}</p>\n								<p class=\"md-subhead center small margin-top-80\">Transaction ID# {{vm.paymentResults.id}}</p>\n							</div>\n						</div>\n						<!-- debug status -->\n						<!-- {{vm.paymentState}} -->\n\n					</div><!-- vm.initDone no error -->\n\n\n					<!-- refill details -->\n					<div class=\"refill-details\" ng-if=\"vm.isRefill && vm.initDone\" layout=\"column\" layout-align=\"start layout-fill\">\n						<div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.package.logo\" style=\"padding-bottom: 2em;\">\n							<img flex=\"nogrow\" class=\"logo\" src=\"{{vm.package.logo}}\" style=\"width:150px;\">\n						</div>\n						<div ng-if=\"!vm.refillOption\" class=\"invoice-details\" style=\"margin-left: 1em; margin-right: 1em; width: auto;\">\n							<p class=\"md-subhead center\"><strong>{{vm.package.label}}</strong><br>Hours purchased: {{vm.package.budgetedHours}} hrs <br>\n							Hours remaining: {{vm.packageBalance | number: 2}} hrs<br>\n							Expires: {{vm.package.expiryDate | amDateFormat: \"MMMM DD, YYYY\"}}\n							</p>\n						</div>\n						<h3 class=\"center md-title\" ng-if=\"vm.refillState == \'pending\'\">Refill Package</h3>\n						<div ng-if=\"!vm.showError && vm.package.refillOptions\" class=\"md-padding\">\n							<!-- refill options -->\n							<div ng-if=\"!vm.refillOption\" ng-repeat=\"option in vm.package.refillOptions | toArray: false track by uid+$index\" layout=\"row\" layout-align=\"layout-fill center\" style=\"border-bottom: 1px solid #bbb; padding-top: .5em;\">\n								<div flex>\n									<p  class=\"md-subhead margin-top-0\" >\n										<strong>{{option.label}}</strong><br>\n										<span class=\"small\"><strong>Hours Included: </strong>{{option.hours}} <strong>Cost: </strong>{{vm.package.currency}}{{option.cost}}</span>\n									</p>\n								</div>\n								<div flex=\"nogrow\">\n									<md-button ng-click=\"vm.selectRefill(option)\" class=\"md-raised md-accent\">\n										<md-icon md-font-icon=\"zmdi zmdi-gas-station\"></md-icon>\n										Refill\n									</md-button>\n								</div>\n							</div>\n							<!-- set quantity and commit -->\n							<div ng-if=\"vm.refillOption && vm.refillState == \'pending\'\">\n								<p class=\"md-subhead center\">\n									<strong>Selected Refill: </strong> {{vm.refillOption.label}}\n								</p>\n								<div layout=\"row\" layout-align=\"center center\">\n									<div flex=\"nogrow\" style=\"text-align: right;\">\n										<strong>Quantity: </strong>\n									</div>\n									<div flex=\"nogrow\">\n										<md-input-container class=\"\" style=\"width: 50px; margin-left:1em; margin-top:0; margin-bottom:0;\">\n											<md-select ng-model=\"vm.refillOption.quantity\">\n												<md-option value=\"1\">1</md-option>\n												<md-option value=\"2\">2</md-option>\n												<md-option value=\"3\">3</md-option>\n												<md-option value=\"4\">4</md-option>\n												<md-option value=\"5\">5</md-option>\n												<md-option value=\"6\">6</md-option>\n												<md-option value=\"7\">7</md-option>\n												<md-option value=\"8\">8</md-option>\n												<md-option value=\"9\">9</md-option>\n												<md-option value=\"10\">10</md-option>\n											</md-select>\n										</md-input-container>\n									</div>\n								</div>\n								<p class=\"md-subhead center\">\n									<strong>Hours to Add: </strong> {{vm.optionHours(vm.refillOption)}}<br>\n									<strong>Cost: </strong> {{vm.package.currency}}{{vm.optionTotal(vm.refillOption)}}<br>\n									<!-- <strong>New Hours Balance: </strong> {{vm.newBalance(vm.refillOption)}}hrs -->\n								</p>\n\n\n\n								<md-divider style=\"padding-bottom: 15px;\"></md-divider>\n\n								<div layout=\"row\" layout-align=\"end center\" class=\"padding-top-20\">\n									<div flex=\"33\" layout=\"row\" layout-align=\"start center\">\n										<md-button flex style=\"max-width: 85px;\" class=\"md-button-small\" ng-click=\"vm.refillOption = null\"><md-icon md-font-icon=\"fa fa-caret-left\"></md-icon> Go Back</md-button>\n									</div>\n									<div flex=\"66\" layout=\"row\" layout-align=\"layout-fill center\">\n										<md-button flex=\"grow\" ng-click=\"vm.submitRefill(vm.package, vm.refillOption)\" class=\"md-raised md-accent\">\n										<md-icon md-font-icon=\"zmdi zmdi-gas-station\"></md-icon>\n										 Purchase {{vm.optionHours(vm.refillOption)}} hours</md-button>\n									</div>\n\n								</div>\n							</div>\n							<div ng-if=\"vm.refillOption && vm.refillState == \'submitting\'\">\n								<h3 class=\"center md-title\">Processing request</h3>\n								<p class=\"center margin-bottom-40 margin-top-40\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 72px; width: 72px; font-size: 72px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n							</div>\n							<!-- confirmation -->\n							<div ng-if=\"vm.refillOption && vm.refillState == \'complete\'\">\n								<h1 class=\"md-title center margin-top-40\" style=\"color: #444; font-size: 3em; margin-bottom: 25px;\">Thank You!</h1>\n\n								<h2 class=\"center\"><md-icon style=\"font-size: 6em; margin-top: 40px; margin-bottom: 40px;\" class=\"green\" md-font-icon=\"fa fa-check\"></md-icon></h2>\n\n								<p class=\"md-subhead center\">Your {{vm.package.label}} package has been refilled with {{vm.optionHours(vm.refillOption)}} hours.<br>\n									It will appear on your next invoice.\n								</p>\n									<p class=\"center md-title\">\n										<strong>New package balance:</strong><br> <strong>{{vm.newBalance(vm.refillOption)}} hours</strong>\n									</p>\n								<p class=\"md-subhead center small margin-top-80\">Transaction ID# {{vm.newLineItem.uid}}</p>\n							</div>\n						</div>\n					</div>\n		</md-content>\n	</md-card>\n</div>\n");
$templateCache.put("app/public-form/public-form.tmpl.html","<!-- Authentication.tmpl.html -->\n<div id=\"public-form\" class=\"full-image-background\" ng-class=\"authBackground\" layout=\"row\" layout-align=\"center start\" layout-fill>\n        <md-card>\n          <md-content class=\"form-container\" layout=\"column\" layout-align=\"start layout-fill\" >\n              <!-- <h1>Public Form Template</h1>\n              <h3>Form: {{vm.formID}}</h3>\n              <h3>Account: {{vm.accountID}}</h3> -->\n\n              <div ng-if=\"vm.showError && vm.initDone\">\n                <h3>Sorry, that form doesn\'t exist. Please check with your virtual assistant.</h3>\n              </div>\n              <div ng-if=\"!vm.showError && vm.initDone\">\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.thisUser.logo\" style=\"padding-bottom: 2em;\">\n                  <img flex=\"nogrow\" class=\"logo\" src=\"{{vm.thisUser.logo}}\">\n                </div>\n                <div ng-if=\"!vm.thisUser.logo\" layout=\"row\" layout-align=\"center center\">\n                  <h3 class=\"center\">{{vm.thisUser.fullName}}</h3>\n                </div>\n                <div ng-bind-html=\"vm.formHTML\">\n                </div>\n              </div>\n          </md-content>\n        </md-card>\n    </div>\n</div>\n\n<!-- mb-bg-39 -->\n\n");
$templateCache.put("app/training/dialog-new-course.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"80\" flex-gt-lg=\"70\" class=\"new-course-dialog\">\n	<md-dialog-content class=\"md-padding\" layout=\"column\">\n		<form name=\"vm.forms.courseForm\">\n		<h3 class=\"text-center\">{{vm.state}} Course</h3>\n		<div layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex=\"50\">\n					<md-input-container>\n						<label>Course Name</label>\n						<input name=\"courseName\" ng-model=\"vm.editedCourse.label\" required>\n						<div ng-messages=\"vm.forms.courseForm.courseName.$error\">\n					          <div ng-message=\"required\">This is required.</div>\n				        </div>\n					</md-input-container>\n			</div>\n			<div flex=\"50\">\n				<md-input-container>\n					<label>Course Tagline</label>\n					<input name=\"courseTagline\" ng-model=\"vm.editedCourse.tagline\">\n				</md-input-container>\n			</div>\n		</div>\n\n\n		<div layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex=\"50\">\n				<md-input-container>\n					<label>Category</label>\n					<md-select   ng-model=\"vm.editedCourse.category\">\n					   <md-option ng-repeat=\"category in vm.categories |toArray: false | orderBy: [\'order\'] track by uid+$index\" ng-value=\'category.uid\'>\n					      {{category.label}}\n					   </md-option>\n					</md-select>\n				</md-input-container>\n			</div>\n			<div flex=\"50\">\n				<md-input-container>\n					<label>Instructor</label>\n					<md-select ng-model=\"vm.editedCourse.instructorID\">\n					   <md-option ng-repeat=\"instructor in vm.instructors |toArray: false track by uid+$index\" ng-value=\'instructor.uid\'>\n					      {{instructor.name}}\n					   </md-option>\n					</md-select>\n				</md-input-container>\n			</div>\n		</div>\n		<p class=\"center\"><strong>Course Description</strong></p>\n		<div  class=\"course-description\" froala=\"vm.froalaOptions\" ng-model=\"vm.editedCourse.description\" style=\"min-height: 100px; margin-bottom: 1em;\">\n		</div>\n		<p class=\"center\"><strong>Buttons</strong></p>\n\n		<md-input-container>\n			<label>Signup URL</label>\n			<input name=\"courseURL\" ng-model=\"vm.editedCourse.url\" required>\n			<div ng-messages=\"vm.forms.courseForm.courseURL.$error\">\n		          <div ng-message=\"required\">This is required.</div>\n	        </div>\n		</md-input-container>\n		<md-input-container>\n			<label>More Information URL</label>\n			<input ng-model=\"vm.editedCourse.sourceURL\">\n		</md-input-container>\n		<p class=\"center\"><strong>Images</strong></p>\n			<div layout=\"row\" layout-align=\"layout-fill center\">\n				<div flex=\"60\">\n					<md-input-container>\n						<label>Grid Thumbnail URL</label>\n						<input required name=\"courseImage\" ng-change=\"vm.toggleImage()\" ng-model=\"vm.editedCourse.image\">\n						<div ng-messages=\"vm.forms.courseForm.courseImage.$error\">\n					          <div ng-message=\"required\">An Image URL is required.</div>\n				        </div>\n					</md-input-container>\n				</div>\n				<div flex=\"40\" layout=\"column\" layout-align=\"center center\" class=\"padding-left-40\">\n					<img ng-if=\"vm.showImage\" src=\"{{vm.editedCourse.image}}\" width=\"150\">\n				</div>\n			</div>\n			<div layout=\"row\" layout-align=\"layout-fill center\">\n				<div flex=\"60\">\n					<md-input-container>\n						<label>Banner Image URL</label>\n						<input required name=\"courseBannerImage\" ng-change=\"vm.toggleImage()\" ng-model=\"vm.editedCourse.bannerImage\">\n						<div ng-messages=\"vm.forms.courseForm.courseBannerImage.$error\">\n					          <div ng-message=\"required\">A Banner Image URL is required.</div>\n				        </div>\n					</md-input-container>\n				</div>\n				<div flex=\"40\" layout=\"column\" layout-align=\"center center\" class=\"padding-left-40\">\n					<img ng-if=\"vm.showImage\" src=\"{{vm.editedCourse.bannerImage}}\" height=\"150\">\n				</div>\n			</div>\n\n\n			<p>&nbsp;</p>\n\n		<div layout=\"row\" layout-align=\"end center\" class=\"margin-top-40\">\n			<md-button flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel Payment\">\n				Cancel\n			</md-button>\n\n			<md-button ng-if=\"vm.state == \'Edit\'\" flex=\"nogrow\" ng-click=\"vm.deleteCourse(vm.editedCourse)\" class=\"md-icon-button md-warn\"><md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon></md-button>\n\n			<md-button flex=\"nogrow\" ng-click=\"vm.saveCourse(vm.editedCourse)\" style=\"margin-top: 0;\" class=\"md-raised md-accent\" ng-disabled=\"vm.forms.courseForm.$invalid || vm.forms.courseForm.$pristine\" aria-label=\"Save/Update Course\">\n				Save/Update\n			</md-button>\n		</div>\n	</form>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/training/training.tmpl.html","<md-content class=\"md-padding\" palette-background=\"grey:A200\" layout=\"column\" layout-fill flex=\"100\">\n	<div class=\"courses\" ng-if=\"!vm.showCourseManager\">\n		<div class=\"training-masthead\" style=\"padding-top: 60px; padding-bottom: 60px; margin-right: 2.5em; margin-left: 2.5em;\" layout=\"column\" layout-align=\"start layout-fill\">\n			<div ng-if=\"vm.settings.canEditCourses\" layout=\"row\" layout-align=\"end center\" style=\"position: absolute; top: 2em; right: 4em;\">\n				<md-button flex=\"nogrow\" ng-if=\"!vm.showCourseManager\" class=\"md-raised md-warn\"ng-click=\"vm.editCourses()\">Manage Courses</md-button>\n				<md-button flex=\"nogrow\" ng-if=\"vm.showCourseManager\" class=\"md-raised md-warn\"ng-click=\"vm.closeEditor()\"><md-icon md-font-icon=\"fa fa-close\"></md-icon> Close Editor</md-button>\n			</div>\n			<div layout=\"row\" layout-align=\"layout-fill center\">\n				<div flex=\"40\" layout=\"column\" layout-align=\"start end\" style=\"padding-right: 1em;\">\n					<img class=\"margin-top-20 margin-left-20\" src=\"https://www.freelanceu.com/wp-content/uploads/2020/05/newlogo.png\" height=\"150\">\n				</div>\n				<div flex=\"60\" layout=\"column\" layout-align=\"center start\" style=\"padding-left: 1em;\">\n					<h3 style=\"font-size: 2em;\">LEARN SKILLS. WORK FROM HOME. LIVE FREE.</h3>\n					<p style=\"font-size: 1.5em; margin-top:0; font-weight: normal;\">Upgrade Your VA Skills with our partner, Freelance University and Receive a <strong>15% Discount!</strong></p>\n				</div>\n			</div>\n		</div>\n		<div class=\"course-categories\">\n			<div class=\"training-category\" layout=\"column\" ng-repeat=\"category in vm.categories | toArray: false | orderBy: [\'order\'] track by $index + uid\">\n				<div class=\"training-category-header\" layout=\"row\" layout-align=\"layout-fill center\" ng-click=\"vm.toggle(category.uid)\">\n					<div flex=\"nogrow\">\n							<md-icon style=\"font-size: 2em; cursor: pointer; margin-left: 1em; margin-top: .5em;\" ng-if=\"vm.expose[category.uid]\"  md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n							<md-icon style=\"font-size: 2em; cursor: pointer; margin-left: 1em; margin-top: .5em;\" ng-if=\"!vm.expose[category.uid]\"  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n					</div>\n					<h2 flex=\"grow\" class=\"center\">{{category.label}}</h2>\n				</div>\n				<div ng-if=\"vm.expose[category.uid]\" class=\"course-list\" layout=\"row\" layout-align=\"start center\" layout-wrap>\n					<div class=\"course-box\" ng-click=\"vm.showCourse(course)\" target=\"_new\" flex=\"auto\"\n						ng-repeat=\"course in vm.courses | toArray: false | orderBy: [\'order\'] | filter: {\'category\': category.uid} track by $index + uid\"\n						style=\"background-image: url(\'{{course.image}}\');\"\n						layout=\"column\" layout-align=\"center center\"\n						>\n			                <h3 class=\"course-name\">{{course.label}}</h3>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div><!--- / courses -->\n	<!--- course manager -->\n	<div class=\"course-editor\" layout=\"column\" ng-if=\"vm.settings.canEditCourses && vm.showCourseManager\" layout-align=\"start center\" style=\"position:relative;\">\n		<div ng-if=\"vm.settings.canEditCourses\" layout=\"row\" layout-align=\"end center\" style=\"position: absolute; top: 0; right: 2em;\">\n			<md-button flex=\"nogrow\" ng-if=\"!vm.showCourseManager\" class=\"md-raised md-warn\"ng-click=\"vm.editCourses()\">Manage Courses</md-button>\n			<md-button flex=\"nogrow\" ng-if=\"vm.showCourseManager\" class=\"md-raised md-warn\"ng-click=\"vm.closeEditor()\"><md-icon md-font-icon=\"fa fa-close\"></md-icon> Close Editor</md-button>\n		</div>\n		<div class=\"edit-categories\" dragula=\"\'drag-category\'\" dragula-scope=\"$scope\" style=\"width:750px;\">\n			<div class=\"training-category\" catid=\"{{category.uid}}\" ng-repeat=\"category in vm.categories | toArray: false | orderBy: [\'order\'] track by $index+uid\">\n				<div class=\"training-category-header\" layout=\"row\" layout-align=\"layout-fill center\">\n					<div flex=\"nogrow\">\n							<md-icon style=\"font-size: 2em; cursor: pointer; margin-left: 1em; margin-top: .5em;\" ng-if=\"vm.expose[category.uid]\" ng-click=\"vm.toggle(category.uid)\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n							<md-icon style=\"font-size: 2em; cursor: pointer; margin-left: 1em; margin-top: .5em;\" ng-if=\"!vm.expose[category.uid]\" ng-click=\"vm.toggle(category.uid)\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n					</div>\n					<!-- <div flex=\"10\">\n						<p class=\"center\" style=\"color: #000;\">{{category.order}}</p>\n					</div> -->\n					<p class=\"md-subhead\" style=\"color: #000;\" flex=\"grow\" ng-click=\"vm.toggle(category.uid)\">{{category.label}}</p>\n\n					<div flex=\"nogrow\">\n						<md-button style=\"cursor: pointer; margin-top: 5px; margin-right: 10px;\" ng-disabled=\"true\" class=\"drag-handle md-icon-button\"><md-icon class=\"drag-handle\" md-font-icon=\"zmdi zmdi-menu\"></md-icon></md-button>\n					</div>\n				</div>\n				<div ng-if=\"vm.expose[category.uid]\" class=\"category-management-container\">\n					<p class=\"md-subhead center\" style=\"color: #000; padding-top: 1em; margin-top:0; \">Edit Category</p>\n					<form name=\"vm.forms.categoryForm\" class=\"course-category-form\" layout=\"column\">\n						<div layout=\"row\" layout-align=\"center center\">\n							<md-input-container flex=\"80\">\n						       <label>Category Label</label>\n						       <input ng-model=\"category.label\">\n							 </md-input-container>\n						</div>\n						<div layout=\"row\" layout-align=\"layout-fill center\">\n							<div flex=\"nogrow\">\n								<md-button ng-click=\"vm.deleteCategory(category)\" class=\"md-icon-button md-warn\"><md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon></md-button>\n							</div>\n							<div flex=\"grow\" layout=\"row\" layout-align=\"end center\">\n								<md-button ng-click=\"vm.updateCategory(category)\" class=\"md-raised md-primary\">Update</md-button>\n							</div>\n						</div>\n					</form>\n					<p class=\"md-subhead center\" style=\"color: #000; padding-top: 1em;\">Manage Courses</p>\n					<div class=\"edit-course-list drag-course\" dragula=\"\'drag-course\'\" dragula-scope=\"$scope\">\n						<div class=\"training-course\" courseid=\"{{course.uid}}\" ng-repeat=\"course in vm.courses | toArray: false | orderBy: [\'order\'] | filter: {\'category\': category.uid} track by $index + uid\" layout=\"row\" layout-align=\"layout-fill start\">\n\n							<div flex=\"nogrow\">\n								<md-button class=\"md-button-small margin-left-0 margin-right-0\" ng-click=\"vm.showCourse(course)\" style=\"margin-top: 10px;\">\n									<md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon><md-tooltip md-delay=\"500\">View Course</md-tooltip>\n								</md-button>\n							</div>\n							<div flex=\"nogrow\" class=\"padding-right-40\">\n								<md-button class=\"md-button-small margin-left-0 margin-right-0\" ng-click=\"vm.editCourse(course)\" style=\"margin-top: 10px;\">\n									<md-icon md-font-icon=\"fa fa-edit\"></md-icon><md-tooltip md-delay=\"500\">Edit Course</md-tooltip>\n								</md-button>\n							</div>\n							<p class=\"md-subhead\" flex=\"auto\" style=\"color: #000;\">{{course.label}}</h2>\n\n							<div flex=\"nogrow\">\n								<md-button style=\"cursor: pointer;\" ng-disabled=\"true\" class=\"course-drag-handle\"><md-icon class=\"course-drag-handle\" md-font-icon=\"zmdi zmdi-menu\"></md-icon></md-button>\n							</div>\n						</div>\n					</div>\n					<div layout=\"row\" layout-align=\"center center\">\n						<md-button class=\"md-raised\" ng-click=\"vm.toggle(category.uid)\">Cancel</md-button>\n						<md-button ng-click=\"vm.newCourse(category)\" class=\"md-raised md-accent\">+ Add a Course</md-button>\n					</div>\n				</div><!-- exposed container -->\n			</div>\n		</div>\n		<div layout=\"row\" layout-align=\"center center\" class=\"\">\n			<md-button class=\"md-raised md-accent margin-top-40\" ng-click=\"vm.newCategory($event)\">\n				Create a new Category\n			</md-button>\n		</div>\n\n	</div>\n</md-content>\n\n");
$templateCache.put("app/training/view-course.tmpl.html","<md-dialog flex=\"100\" fles-gt-sm=\"80\" flex-gt-md=\"60\" flex-gt-lg=\"50\" flex-xl=\"50\" class=\"view-course\">\n	<md-dialog-content layout=\"column\">\n		<div flex=\"50\" layout=\"column\" layout-align=\"center center\" class=\"view-course-banner\" style=\"background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(\'{{vm.course.bannerImage}}\'); background-position: center center; background-repeat: no-repeat; background-size: cover;\">\n			<h1 class=\"center\">{{vm.course.label}}</h1>\n		</div>\n		<div class=\"md-padding\" >\n			<div layout=\"row\" layout-align=\"center start\">\n				<div flex=\"100\" flex-gt-sm=\"80\" layout=\"column\">\n\n					<p class=\"md-title\" ng-if=\"vm.course.tagline\">{{vm.course.tagline}}</p>\n					<div froala-view=\"vm.course.description\" ng-if=\"vm.course.description\"></div>\n\n					<div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start layout-fill\" layout-align-gt-xs=\"layout-fill start\">\n						<div flex=\"100\" flex-gt-xs=\"40\" layout=\"column\" layout-align=\"start layout-fill\">\n							<md-card flex>\n						        <md-card-title>\n						          <md-card-title-text>\n						            <span class=\"md-headline\">{{vm.instructor.name}}</span>\n						            <span class=\"md-subhead\">Course Instructor</span>\n						          </md-card-title-text>\n						          <md-card-title-media>\n						            <div class=\"md-media-sm card-media\" style=\"width: auto;\"><div class=\"course-instructor-image-container\"><img src=\"{{vm.instructor.imageURL}}\" /></div></div>\n						          </md-card-title-media>\n						        </md-card-title>\n						        <div style=\"padding: 0 1em 1em 1em;\" class=\"course-instructor-bio\" ng-bind-html=\"vm.instructor.bio\"></div>\n						     </md-card>\n						</div>\n						<div flex=\"100\" flex-gt-xs=\"60\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 3em;\">\n							<h3 class=\"md-title center\" style=\"font-weight: normal; margin-bottom: 2em;\">Use coupon code <strong>ADMINJA15</strong> <br>to save 15% on your tuition!</h3>\n							<md-button flex class=\"md-button-flat-round freelanceu-signup\" style=\"color: #fff; width: 80%;\" target=\"_blank\" href=\"{{vm.course.url}}\" palette-background=\"blue:400\">Start This Course Today! <md-icon style=\"color: #fff; font-size: 2em; margin-top: -5px;\" md-font-icon=\"fa fa-angle-right\"></md-icon></md-button>\n							<!-- removed per Craig\'s request -->\n							<!-- <p flex ng-if=\"vm.course.sourceURL\" class=\"md-subhead center\"><md-button style=\"border-radius: 20px; padding-left: 1em; padding-right: 1em;\" href=\"{{vm.course.sourceURL}}\" target=\"_blank\">Explore Course Curriculum <md-icon md-font-icon=\"fa fa-angle-right\"></md-icon></md-button></p> -->\n						</div>\n					</div>\n\n\n					<!-- <md-divider class=\"margin-40\"></md-divider>\n					<h3 class=\"center\">Course Instructor</h3>\n					<div class=\"course-instructor-block\" layout=\"row\" layout-align=\"layout-fill center\">\n						<div flex=\"30\" class=\"course-instructor-image-container\">\n							<img src=\"{{vm.instructor.imageURL}}\">\n						</div>\n						<div flex=\"70\">\n							<p class=\"md-subhead\">{{vm.instructor.name}}</p>\n							<div class=\"course-instructor-bio\" ng-bind-html=\"vm.instructor.bio\"></div>\n						</div>\n					</div> -->\n\n				</div>\n			</div>\n\n		</div>\n		<md-dialog-actions layout=\"row\" layout-align=\"end center\">\n			<md-button ng-if=\"vm.settings.canEditCourses\" ng-click=\"vm.edit(vm.course, \'Edit\')\">Edit</md-button>\n			<md-button ng-click=\"vm.close()\">Done</md-button>\n		</md-dialog-actions>\n\n\n\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/admin-setup/clients/setup-clients.tmpl.html","<div class=\"client-setup\" ng-show=\"vm.user\">\n    <div class=\"padding-20 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n        <!-- <md-button class=\"cancel-profile md-icon-button\" ng-click=\"vm.cancelProfile();\">\n        <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n        </md-button> -->\n        <div class=\"margin-right-20\">\n            <div>\n                <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"100\" style=\"margin-right: 1em;\"/>\n            </div>\n        </div>\n        <div class=\"text-light\">\n            <h1 class=\"md-display-1\" style=\"margin-top: 0;\">Welcome!</h1>\n            <h3 class=\"font-weight-600 margin-bottom-0 margin-top-0 text-light\" ng-show=\"vm.user.profile.firstName\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}} <small ng-show=\"vm.user.profile.position\">{{vm.user.profile.position}}</small></h3>\n            <p class=\"font-weight-400 margin-top-0 text-light\">{{vm.user.email}}</p>\n        </div>\n    </div>\n    <div layout=\"row\" layout-align=\"center start\" layout-fill>\n        <div flex-sm=\"100\" flex-md=\"100\" flex-gt-md=\"60\" layout=\"column\" class=\"md-whiteframe-4dp\">\n            <md-content layout-padding flex style=\"padding-bottom: 60px;\">\n                <div ng-show=\"!vm.hasClients()\">\n                    <p class=\"md-display-1 text-center\" style=\"line-height: 1.25em;\" style=\"font-size: 1.75em;\">Before we get started, <br>we need to setup your first Client</p>\n                    <p class=\"text-center\" style=\"font-size: 12px; line-height: 1em;\">(Hint: You can create a Client Space for yourself, too.)</p>\n                </div>\n                <div ng-show=\"vm.hasClients()\">\n                    <p ng-show=\"vm.canAddNew()\" class=\"md-display-1 text-center\" style=\"font-size: 1.75em;\">Great! Now we have something to work with!</p>\n                    <p ng-show=\"vm.canAddNew()\" class=\"md-display-1 text-center\" style=\"font-size: 1.75em;\"><strong>Want to add some more?</strong></p>\n                    <p ng-show=\"vm.canAddNew()\" class=\"text-center\" style=\"font-size: 12px; line-height: 1em;\"><a ui-sref=\"triangular.dashboard\">No thanks. I\'ll add the rest of my clients later.</a></p>\n                    <p ng-show=\"!vm.canAddNew()\" class=\"md-display-1 text-center\" \">Whoa! You\'ve reached the client limit for your plan.</p>\n                    <p ng-show=\"!vm.canAddNew()\" class=\"text-center\">\n                        <md-button  style=\" padding-left: .5em; padding-right: .5em;\" md-colors=\"\" flex=\"nogrow\" class=\"md-raised md-accent \" ng-click=\"vm.continue();\" aria-label=\"Continue to Adminja\">\n                            Continue to Adminja\n                        </md-button>\n                   </p>\n                </div>\n                <form name=\"vm.clientForm\" ng-show=\"vm.canAddNew()\">\n                    <div class=\"quick-client-form md-whiteframe-4dp\" layout=\"column\" layout-gt-sm=\"row\" style=\"position: relative; margin-left: 1em; margin-right: 1em; padding: 1em; \">\n\n                        <div  flex-gt-sm=\"40\" flex=\"100\" layout=\"column\">\n                            <!-- <p class=\"md-body-2\" style=\"margin-top: 0;\">Details</p> -->\n                            <div layout=\"row\">\n                                 <md-input-container flex=\"40\">\n                                    <label>First Name</label>\n                                    <input name=\"clientfirstname\" id=\"focusfield\" ng-model=\"vm.newClient.profile.firstname\" required>\n                                </md-input-container>\n                                 <md-input-container flex=\"40\">\n                                     <label>Last Name</label>\n                                     <input name=\"clientlastname\" ng-model=\"vm.newClient.profile.lastname\" required>\n                                 </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <md-input-container flex=\"80\">\n                                    <label>Client\'s Primary Email</label>\n                                    <input name=\"clientemail\" ng-model=\"vm.newClient.profile.email\" type=\"email\" required>\n                                </md-input-container>\n                            </div>\n                        </div>\n                        <div flex-gt-sm=\"60\" flex=\"100\" ng-show=\"!vm.showColors\">\n                            <!-- <p class=\"md-body-2\" style=\"margin-top: 0;\">Plan</p> -->\n                            <md-radio-group ng-model=\"vm.newClient.profile.plan.type\" layout=\"row\" style=\"margin-bottom: 1em;\">\n                                <md-radio-button flex=\"none\" value=\"retainer\" aria-label=\"Monthly Retainer\">\n                                  <span style=\"font-size: 12px;\">Monthly Retainer</span>\n                                </md-radio-button>\n                                <md-radio-button flex value=\"hourly\" aria-label=\"Hourly\">\n                                  <span style=\"font-size: 12px;\">Hourly</span>\n                                </md-radio-button>\n                            </md-radio-group>\n                            <div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"vm.newClient.profile.plan.type ==\'retainer\' \">\n                                <div flex=\"40\" layout=\"row\">\n                                    <md-input-container flex >\n                                        <label>Monthly Fee</label>\n                                        <md-icon md-font-icon=\"zmdi zmdi-money\" style=\"color: #666;\"></md-icon>\n                                        <input style=\"min-width: 150px;\" name=\"rate\" type=\"number\" step=\"any\"  maxlength=\"7\" ng-model=\"vm.newClient.profile.plan.cost\" placeholder=\"000.00\">\n                                    </md-input-container>\n                                    <md-input-container flex>\n                                       <label>Hours Allocated</label>\n                                       <input style=\"min-width: 150px;\" name=\"allocated\" type=\"number\" maxlength=\"3\" ng-model=\"vm.newClient.profile.plan.allocated\" placeholder=\"00\">\n                                   </md-input-container>\n                                </div>\n                                <div flex=\"100\">\n                                   <md-input-container flex>\n                                      <label>Cycle day:</label>\n                                      <input style=\"max-width: 100px;\" name=\"start\" type=\"number\" maxlength=\"2\" ng-model=\"vm.newClient.profile.plan.retainerStart\" placeholder=\"01\">\n                                  </md-input-container>\n                                </div>\n                            </div>\n                            <div layout=\"row\" ng-show=\"vm.newClient.profile.plan.type ==\'hourly\'\">\n                                <md-input-container flex=\"40\">\n                                   <label>Hourly Rate</label>\n                                   <md-icon md-font-icon=\"zmdi zmdi-money\" style=\"color: #666;\"></md-icon>\n                                   <input name=\"hourly-rate\" type=\"number\" maxlength=\"3\" ng-model=\"vm.newClient.profile.plan.rate\" placeholder=\"00\">\n                               </md-input-container>\n                            </div>\n                            <div layout=\"row\">\n                                <!-- toggle Colors -->\n                                <div flex=\"10\">\n                                    <div class=\"setupToggleColors\" ng-click=\"vm.toggleColors()\" style=\"border-radius: 30px; display: inline-block; position: relative; top: -7px; margin-right: 1em; background-color: {{vm.newClient.profile.clientColor || \'#aaa\'}}; width: 30px; height: 30px; border: 1px solid #333;\"></div>\n                                </div>\n                                <div flex=\"50\"><span style=\"font-size: 12px;\">Choose a color to identify this client</span></div>\n                                <p class=\"text-right\" flex=\"50\" style=\"margin-bottom:0;\">\n                                    <md-button flex=\"nogrow\" ng-disabled=\"vm.clientForm.$invalid || vm.clientForm.$pristine\"  class=\"md-raised md-primary\"  ng-if=\"vm.canAddNew()\" ng-click=\"vm.addClient(vm.newClient)\" aria-label=\"Add Client\">\n                                    <!-- <md-icon md-font-icon=\"zmdi zmdi-account-add\" style=\"font-size: 16px; color: #fff;\"></md-icon>  -->\n                                    New Space\n                                    </md-button>\n                                </p>\n                            </div>\n                        </div>\n\n                            <md-input-container style=\"background-color: #fff; margin-top: 0; margin-bottom: 0;\" ng-show=\"vm.showColors\">\n                              <lk-color-chooser style=\"width: 320px;\" colors=\"vm.clientColors\" selected-color=\"vm.newClient.profile.clientColor\" ng-model=\"vm.newClient.profile.clientColor\" ng-click=\"vm.colorChange(vm.clientForm);\"></lk-color-chooser>\n                            </md-input-container>\n\n                    </div><!-- // quick-client-form -->\n                </form>\n                <md-divider ng-show=\"vm.hasClients()\"></md-divider>\n            <!-- list of clients that have been added -->\n            <div class=\"clientList\">\n            <div ng-repeat=\"client in vm.clients track by $index\" class=\"\" layout=\"row\" layout-align=\"center center\" style=\"margin-left: .5em; margin-bottom: 2em; padding: 1em; \">\n                <div layout=\"column\" layout-gt-sm=\"row\" flex=\"90\">\n                    <div  flex-gt-sm=\"60\" flex=\"100\" >\n                        <div layout=\"row\">\n                            <div flex=\"20\">\n                                <div style=\"border-radius: 30px;  position: relative; top: 1em; display: inline-block;  background-color: {{client.profile.clientColor || \'#aaa\'}}; width: 30px; height: 30px; border: 1px solid #333;\"></div>\n                            </div>\n                            <div flex=\"80\">\n                                <strong>{{client.profile.firstname}} {{client.profile.lastname}}</strong><br>\n                                {{client.profile.email}}\n                            </div>\n                        </div>\n\n                    </div>\n                    <div flex-gt-sm=\"40\" flex=\"100\" layout=\"row\">\n\n                            <div flex=\"50\" flex-gt-sm=\"85\">\n                                    <p ng-show=\"client.profile.plan.type == \'retainer\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 12px;\">\n                                        {{client.profile.plan.allocated}}hr Retainer @ ${{client.profile.plan.cost}}/month<br>\n                                        Renews on the {{client.profile.plan.retainerStart|ordinal}} of every month.\n                                    </p>\n                                    <p ng-show=\"client.profile.plan.type == \'hourly\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 12px;\">\n                                        Hourly rate: ${{client.profile.plan.rate}}\n                                    </p>\n                            </div>\n                            <div flex=\"30\" flex-gt-sm=\"15\" layout-align=\"center center\">\n                                <md-button ng-click=\"vm.deleteClient(client);\">\n                                    <md-icon md-font-icon=\"zmdi zmdi-close\">\n                                    </md-icon>\n                                </md-button>\n                            </div>\n\n                    </div>\n                </div>\n            </div>\n            <md-divider ng-show=\"vm.hasClients()\"></md-divider>\n            </div><!-- end clientList scrolling wrapper -->\n            <!-- add new client form -->\n\n            <p class=\"text-center\" ng-show=\"vm.hasClients() && vm.canAddClients()\">\n                <md-button style=\" padding-left: .5em; padding-right: .5em;\" md-colors=\"\" flex=\"nogrow\" class=\"md-raised md-accent \" ng-click=\"vm.continue();\" aria-label=\"Continue to Adminja\">\n                Continue to Adminja\n                </md-button><br>\n                <span style=\"font-size: 12px;\">Don\'t worry, you can add more clients later.</span>\n            </p>\n\n            </md-content>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/admin-setup/layouts/setup.tmpl.html","<!-- Authentication.tmpl.html -->\n<div class=\"full-height full-image-background mg-bg-01\" ng-class=\"authBackground\" layout=\"row\" layout-fill  style=\"background-repeat: auto;\">\n    <div class=\"animate-wrapper\" flex layout=\"row\">\n        <div  ui-view flex layout=\"column\" style=\"overflow: scroll;\">\n        </div>\n    </div>\n</div>\n\n<!-- mb-bg-39 -->\n");
$templateCache.put("app/admin-setup/profile/setup-profile.tmpl.html","<h3>Profile</h3>\n");
$templateCache.put("app/app-authentication/cancel/cancel.confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n\n                    <h3>Signup Complete!</h3>\n                    <p class=\"center\">\n                        Please look in your email for a request to confirm your email address.\n                        <md-button ui-sref=\"authentication.login\">Login Now</md-button>\n                    </p>\n                </div>\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/cancel/cancel.tmpl.html","\n<div class=\"cancel-whiteframe no-scrollbar\" layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\" style=\"padding-left: 20px; padding-right: 20px;\">\n    <div flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-gt-lg=\"40\" md-whiteframe=\"3\" style=\"background-color: #fff;\" layout=\"column\" layout-align=\"start stretch\">\n        <form name=\"vm.cancelRequestForm\">\n        <h1 ng-if=\"!vm.request.action\" class=\"md-headline center\" >Before you go, maybe we can help?</h1>\n        <div ng-if=\"!vm.request.action\" layout=\"column\" layout-gt-sm=\"row\">\n            <div flex class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'demo\');\" layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Request a Demo\n                </h3>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'support\');\" layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Get Support\n                </h3>\n                <p class=\"md-caption center\">A 1:1 Call</p>\n            </div>\n            <div flex ng-if=\"vm.showPause\" class=\"cancel-request-option cancel-request-ok\" ng-click=\"vm.selectAction(\'pause\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Pause Subscription\n                </h3>\n                <p class=\"md-caption center\">For 90 days</p>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-risk\" ng-click=\"vm.selectAction(\'discount\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Request a Discount\n                </h3>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-risk\" ng-click=\"vm.selectAction(\'extend\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Extend your Trial\n                </h3>\n                <p class=\"md-caption center\">For 14 days</p>\n            </div>\n            <div flex class=\"cancel-request-option cancel-request-delete\" ng-click=\"vm.selectAction(\'cancel\');\"  layout=\"column\" layout-align=\"center stretch\">\n                <h3 class=\"md-subhead center\">\n                    Delete Your Account\n                </h3>\n                <p class=\"md-caption center\">But leave us feedback</p>\n            </div>\n        </div>\n        <div layout-fill layout=\"column\" layout-align=\"start stretch\">\n        <!--- forms and confirmations -->\n\n            <div ng-if=\"vm.isSelected(\'demo\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Demo</h2>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We\'d be more than happy to setup a 1:1 demo with you to go over Adminja\'s functionality.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>What area of your workflow would you like to focus on?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay! We got your request!</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Someone will be reaching out to you asap to coordinate a call.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'support\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request 1:1 Support</h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p>We are very sorry if you are having difficulty with Adminja. We’ll do everything we can to try to make things right.</p>\n                                <md-input-container style=\"margin-top: 3em;\">\n                                    <label>What seems to be the trouble?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                                </md-input-container>\n                            </div>\n                        </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay! We got your request for support!</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Someone will be reviewing your issue and reaching out to you ASAP to resolve it.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'pause\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Pause your subscription</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We completely understand if circumstances require you to take a break. Sometimes we can help without limiting your access to Adminja.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>Would you mind sharing your circumstances with us?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\" required>\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your pause request has been submitted. </h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">You should hear back from our team within 1 business day with confirmation.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'discount\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Discount</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>We completely understand if finances can sometimes get tight and we will do everything we can to help. </p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>Care to share anything about your situation?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your discount request has been submitted. </h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">You should hear back from our team within 1 business day.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'extend\')\" flex>\n                <div ng-if=\"!vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Request a Trial Extension</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p>Sometimes it takes a little more time to get to know a piece of software well enough to make an investment decision. We’ll try to do everything we can to help.</p>\n                            <md-input-container style=\"margin-top: 3em;\">\n                                <label>How much more time do you need?</label>\n                                <input ng-model=\"vm.request.length\" minlength=\"5\" required>\n                            </md-input-container>\n                            <md-input-container style=\"\">\n                                <label>Reason?</label>\n                                <input ng-model=\"vm.request.details\" minlength=\"20\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Yay!  Your trial extension request has been submitted. </h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p class=\"center\">You should hear back from our team within 1 business day.</p>\n                            </div>\n                        </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.isSelected(\'cancel\')\" flex=\"grow\">\n                <div ng-if=\"!vm.showConfirm\">\n                    <div ng-if=\"!vm.continue\">\n                        <h1 class=\"md-headline center\">\n                            Thanks for giving Adminja a shot.<br>\n                            We’ll be sorry to see you go!\n                        </h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-sm=\"70\">\n                                <p>We really appreciate you taking the the time to give Adminja a try and we hope that we can serve you again sometime in the future.</p>\n                            </div>\n                        </div>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\"  flex-gt-md=\"70\">\n                                <p style=\"margin-bottom:0;\"><strong>After you confirm your cancellation:</strong></p>\n                                <ul style=\"list-style: disc; margin-left: 2em;\">\n                                    <li>Your account will be deleted at the end of your current billing period</li>\n                                    <li>You won’t be charged again</li>\n                                    <li>Any information in your account will be deleted from our backups after 30 days</li>\n                                    <li>This cannot be reversed</li>\n                                </ul>\n                                <p><strong>You are responsible for any charges already incurred.</strong> </p>\n                            </div>\n                        </div>\n                    </div><!-- !vm.continue -->\n\n                    <div ng-if=\"vm.continue\" layout=\"column\" layout-align=\"start stretch\">\n                        <h1 flex class=\"md-headline center\">Help us make Adminja better!</h1>\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p style=\"margin:0 0 1em 0;\">In order to make Adminja better for future users, it really helps us to learn why it wasn\'t a good fit for you.</p>\n                            </div>\n                        </div>\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <div flex=\"100\" flex-gt-md=\"70\">\n                                <p><strong>Please indicate why you wish to delete your account:</strong></p>\n                                <md-radio-group flex ng-model=\"vm.request.reason\" required>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Cost\'\" value=\"Cost\">Cost</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Difficulty of use\'\" value=\"Difficulty of use\">Difficulty of use</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Missing functionality\'\" value=\"Missing functionality\">Missing functionality</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Using other product\'\" value=\"Using other product\">Using other product</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Not using it\'\" value=\"Not using it\">Not using it</md-radio-button>\n                                    <md-radio-button ng-if=\"!vm.request.reason  || vm.request.reason ==\'Something else\'\" value=\"Something else\">Something else</md-radio-button>\n                                </md-radio-group>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Cost\'\" style=\"margin-top: 3em;\">\n                                    <label>What, in your opinion, would be a fairer price for Adminja?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Difficulty of use\'\" style=\"margin-top: 3em;\">\n                                    <label>Could you shared the area of difficulty?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Missing functionality\'\" style=\"margin-top: 3em;\">\n                                    <label>What features are you looking for that Adminja doesn\'t have?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Using other product\'\" style=\"margin-top: 3em;\">\n                                    <label>What product</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"7\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Not using it\'\" style=\"margin-top: 3em;\">\n                                    <label>Would you mind sharing your circumstances with us?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                                <md-input-container flex ng-if=\"vm.request.reason == \'Something else\'\" style=\"margin-top: 3em;\">\n                                    <label>Could you explain?</label>\n                                    <input ng-model=\"vm.request.details\" minlength=\"20\" required md-select-on-focus>\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.showConfirm\">\n                    <h1 class=\"md-headline center\">Thank you! <br>Your cancellation request has been received.</h1>\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-gt-md=\"70\">\n                            <p class=\"center\">Your account is scheduled to close at the end of your current billing period. <strong>You can continue to use Adminja uninterrupted until then.</strong> We\'ll send you an email when your account cancellation is complete./p>\n                            <p class=\"center\"><strong>Thank you again for trying Adminja!</strong></p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div><!-- layout-fill container -->\n\n        <p class=\"center\">\n            <md-button class=\"md-accent\" ui-sref=\"authentication.profile({selectedTab: 4})\" >\n                <span  ng-if=\"!vm.showConfirm\">Cancel</span>\n                <span ng-if=\"vm.showConfirm\">Continue</span>\n            </md-button>\n            <md-button class=\"md-primary md-raised\" ng-if=\"!vm.continue && vm.request.action == \'cancel\'\" ng-click=\"vm.continue = true\">I understand and wish to continue</md-button>\n            <md-button class=\"md-primary md-raised\" ng-if=\"vm.request.action && !vm.showConfirm && vm.request.action == \'cancel\' && vm.continue\" ng-click=\"vm.submitRequest()\" ng-disabled=\"vm.cancelRequestForm.$invalid || vm.processing\">Confirm Account Deletion</md-button>\n            <md-button class=\"md-primary md-raised\" ng-if=\"vm.request.action && !vm.showConfirm && vm.request.action != \'cancel\'\" ng-click=\"vm.submitRequest()\" ng-disabled=\"vm.cancelRequestForm.$invalid || vm.processing\">Submit Request</md-button>\n        </p>\n        <!-- dev reset for testing -->\n        <!-- <p class=\"right\" ng-if=\"vm.request.action\">\n            <md-button ng-click=\"vm.resetRequest()\">Reset</md-button>\n        </p> -->\n        </form>\n    </div>\n</div>\n\n\n");
$templateCache.put("app/app-authentication/forgot/forgot.tmpl.html","<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <!-- <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"150\" style=\"margin-top: 2em;\"> -->\n                    <h3>Reset password</h3>\n                    <md-divider></md-divider>\n                    <form name=\"forgot\">\n                        <md-input-container class=\"md-block\" md-no-float>\n                            <label for=\"email\" translate>Please enter your email address</label>\n                            <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required/>\n                            <div ng-messages=\"forgot.email.$error\" ng-if=\"forgot.email.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your email address</span></div>\n                                <div ng-message when=\"email\"><span translate>Please enter a valid email address</span></div>\n                            </div>\n                        </md-input-container>\n\n                        <md-button class=\"md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ng-click=\"vm.resetClick()\" ng-disabled=\"forgot.$invalid\" >Reset</md-button>\n\n                        <md-button class=\"md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ui-sref=\"authentication.login\" >Remember it? Login here!</md-button>\n                    </form>\n                </div>\n\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.registration\" >Join Adminja for Free!</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/change-email/change-email.tmpl.html","<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <!-- <img src=\"/assets/images/brand/adminja-bug.svg\" width=\"150\" style=\"margin-top: 2em;\"> -->\n                    <h3>Change Login Email</h3>\n                    <md-divider></md-divider>\n                    <form name=\"change-email\">\n                        <md-input-container class=\"md-block\" md-no-float>\n                            <label for=\"email\" translate>Please enter your new login email address</label>\n                            <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.newEmail\" required/>\n                            <div ng-messages=\"forgot.email.$error\" ng-if=\"forgot.email.$dirty\">\n                                <div ng-message when=\"required\"><span translate>Please enter your email address</span></div>\n                                <div ng-message when=\"email\"><span translate>Please enter a valid email address</span></div>\n                            </div>\n                        </md-input-container>\n\n                        <md-button class=\"md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ng-click=\"vm.changeEmail(vm.newEmail)\" ng-disabled=\"change-email.$invalid\" >Change</md-button>\n\n                        <md-button class=\"md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ui-sref=\"authentication.profile\" >Change your mind?</md-button>\n                    </form>\n                </div>\n\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.registration\" >Join Adminja for Free!</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/layouts/authentication.tmpl.html","<!-- Authentication.tmpl.html -->\n<div class=\"full-image-background\" ng-class=\"authBackground\" layout=\"row\" layout-fill>\n    <div class=\"animate-wrapper\" flex layout=\"row\">\n        <div id=\"ui-login\" class=\"login-frame\" ui-view flex layout=\"column\" style=\"overflow: scroll;\"></div>\n    </div>\n</div>\n\n<!-- mb-bg-39 -->\n");
$templateCache.put("app/app-authentication/legal/legal.tmpl.html","<div class=\"user-profile\">\n\n\n<div class=\"mb-bg-1 padding-20 padding-top-100 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"cancel-profile md-icon-button\" back-button>\n    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n</md-button>\n    <div class=\"text-light\">\n        <h3 class=\"font-weight-600 margin-bottom-0 text-light\">Terms &amp; Privacy</h3>\n     </div>\n</div>\n\n<div layout=\"row\" class=\"profile\" layout-wrap>\n    <div flex=\"100\" flex-gt-md=\"100\">\n        <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n            <md-tab label=\"Terms & Conditions\">\n                <md-content class=\"md-padding\" layout=\"column\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"90\" flex-lg=\"70\" flex-gt-lg=\"50\">\n                        <!-- <h1>Terms and Conditions</h1> -->\n                        <p>Last updated: December 08, 2016</p>\n                        <p>Please read these Terms and Conditions (\"Terms\", \"Terms and Conditions\") carefully before using the https://www.getadminja.com website and the https://www.adminja.co application (the \"Service\") operated by Openmotive, Inc. (\"us\", \"we\", or \"our\").</p>\n                        <p>Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service.</p>\n                        <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service.</p>\n                        <p class=\"md-headline\">Communications</p>\n                        <p>By creating an Account on our service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</p>\n                        <p class=\"md-headline\">Subscriptions</p>\n                        <p>Some parts of the Service are billed on a subscription basis (\"Subscription(s)\"). You will be billed in advance on a recurring and periodic basis (\"Billing Cycle\"). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.</p>\n                        <p>At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or Openmotive, Inc. cancels it. You may cancel your Subscription renewal either through your online account management page or by contacting Openmotive, Inc. customer support team.</p>\n                        <p>A valid payment method, including credit card, is required to process the payment for your Subscription. You shall provide Openmotive, Inc. with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information. By submitting such payment information, you automatically authorize Openmotive, Inc. to charge all Subscription fees incurred through your account to any such payment instruments.</p>\n                        <p>Should automatic billing fail to occur for any reason, Openmotive, Inc. will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.</p>\n                        <p class=\"md-headline\">Fee Changes</p>\n                        <p>Openmotive, Inc., in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then-current Billing Cycle.</p>\n                        <p>Openmotive, Inc. will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.</p>\n                        <p>Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.</p>\n                        <p class=\"md-headline\">Refunds</p>\n                        <p>Certain refund requests for Subscriptions may be considered by Openmotive, Inc. on a case-by-case basis and granted in sole discretion of Openmotive, Inc..</p>\n                        <p class=\"md-headline\">Content</p>\n                        <p>Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material (\"Content\"). You are responsible for the Content that you post on or through the Service, including its legality, reliability, and appropriateness.</p>\n                        <p>By posting Content on or through the Service, You represent and warrant that: (i) the Content is yours (you own it) and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms, and (ii) that the posting of your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity. We reserve the right to terminate the account of anyone found to be infringing on a copyright.</p>\n                        <p>You retain any and all of your rights to any Content you submit, post or display on or through the Service and you are responsible for protecting those rights. We take no responsibility and assume no liability for Content you or any third party posts on or through the Service. However, by posting Content using the Service you grant us the right and license to use, modify, perform, display, reproduce, and distribute such Content on and through the Service.</p>\n                        <p>Openmotive, Inc. has the right but not the obligation to monitor and edit all Content provided by users.</p>\n                        <p>In addition, Content found on or through this Service are the property of Openmotive, Inc. or used with permission. You may not distribute, modify, transmit, reuse, download, repost, copy, or use said Content, whether in whole or in part, for commercial purposes or for personal gain, without express advance written permission from us.</p>\n                        <p class=\"md-headline\">Accounts</p>\n                        <p>When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service.</p>\n                        <p>You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</p>\n                        <p>You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than you, without appropriate authorization. You may not use as a username any name that is offensive, vulgar or obscene.</p>\n                        <p class=\"md-headline\">Intellectual Property</p>\n                        The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of Openmotive, Inc. and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Openmotive, Inc..</p>\n                        <p class=\"md-headline\">Links To Other Web Sites</p>\n                        <p>Our Service may contain links to third party web sites or services that are not owned or controlled by Openmotive, Inc..</p>\n                        <p>Openmotive, Inc. has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites.</p>\n                        <p>You acknowledge and agree that Openmotive, Inc. shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services.</p>\n                        <p>We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit.</p>\n                        <p class=\"md-headline\">Termination</p>\n                        <p>We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>\n                        <p>If you wish to terminate your account, you may simply discontinue using the Service.</p>\n                        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>\n                        <p class=\"md-headline\">Indemnification</p>\n                        <p>You agree to defend, indemnify and hold harmless Openmotive, Inc. and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney\'s fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password; b) a breach of these Terms, or c) Content posted on the Service.</p>\n                        <p class=\"md-headline\">Limitation Of Liability</p>\n                        <p>In no event shall Openmotive, Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.</p>\n                        <p class=\"md-headline\">Disclaimer</p>\n                        <p>Your use of the Service is at your sole risk. The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.</p>\n                        <p>Openmotive, Inc. its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.</p>\n                        <p class=\"md-headline\">Exclusions</p>\n                        <p>Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you.</p>\n                        <p class=\"md-headline\">Governing Law</p>\n                        <p>These Terms shall be governed and construed in accordance with the laws of Illinois, United States, without regard to its conflict of law provisions.</p>\n                        <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.</p>\n                        <p class=\"md-headline\">Changes</p>\n                        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>\n                        <p>By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.</p>\n                        <p class=\"md-headline\">Contact Us</p>\n                        <p>If you have any questions about these Terms, please contact us.</p>\n\n                        </div>\n                    </div>\n                <div layout=\"row\" layout-align=\"center center\" md-padding>\n                    <md-button class=\"margin-left-0\" ng-click=\"vm.cancelLegal();\">Return</md-button>\n                </div>\n                </md-content>\n            </md-tab>\n         <!--    <md-tab label=\"Team\">\n                <md-content class=\"md-padding\">\n\n                </md-content>\n            </md-tab> -->\n            <md-tab label=\"Privacy Policy\">\n                <md-content class=\"md-padding\" layout=\"column\">\n                    <div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"100\" flex-md=\"90\" flex-lg=\"70\" flex-gt-lg=\"50\">\n                            <!-- <h1>Privacy Policy</h1> -->\n                            <p>Last updated: December 08, 2016</p>\n                            <p>Openmotive, Inc. (&quot;us&quot;, &quot;we&quot;, or &quot;our&quot;) operates the https://www.getadminja.com website and the https://www.adminja.co application(the &quot;Service&quot;).</p>\n                            <p>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.</p>\n                            <p>We will not use or share your information with anyone except as described in this Privacy Policy.</p>\n                            <p>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible at https://www.getadminja.com</p>\n                            <p class=\"md-headline\">Information Collection And Use</p>\n                            <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address, name, phone number, postal address, other information (&quot;Personal Information&quot;).\n                            We collect this information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/inquiries, servicing your purchase orders, and improving our services.</p>\n                            <p class=\"md-headline\">Log Data</p>\n                            <p>We may also collect information that your browser sends whenever you visit our Service (&quot;Log Data&quot;). This Log Data may include information such as your computer\'s Internet Protocol (&quot;IP&quot;) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>\n                            <p>In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service\'s functionality. These third party service providers have their own privacy policies addressing how they use such information.</p>\n                            <p class=\"md-headline\">Cookies</p>\n                            <p>Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.</p>\n                            <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.</p>\n                            <p>If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.</p>\n                            <p class=\"md-headline\">Do Not Track Disclosure</p>\n                            <p>We support Do Not Track (&quot;DNT&quot;). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</p>\n                            <p>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</p>\n                            <p class=\"md-headline\">Service Providers</p>\n                            <p>We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.</p>\n                            <p>These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.</p>\n                            <p class=\"md-headline\">Communications</p>\n                            <p>We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</p>\n                            <p class=\"md-headline\">Compliance With Laws</p>\n                            <p>We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security or integrity of our Service.</p>\n                            <p class=\"md-headline\">Security</p>\n                            <p>The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.</p>\n                            <p>However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.</p>\n                            <p class=\"md-headline\">International Transfer</p>\n                            <p>Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.</p>\n                            <p>If you are located outside United States and choose to provide information to us, please note that we transfer the information, including Personal Information, to United States and process it there.</p>\n                            <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>\n                            <p class=\"md-headline\">Links To Other Sites</p>\n                            <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>\n                            <p>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>\n                            <p class=\"md-headline\">Children\'s Privacy</p>\n                            <p>Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age of 13 (&quot;Children&quot;).</p>\n                            <p>We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.</p>\n                            <p class=\"md-headline\">Changes To This Privacy Policy</p>\n                            <p>This Privacy Policy is effective as of December 08, 2016 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p>\n                            <p>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>\n                            <p>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</p>\n                            <p class=\"md-headline\">Contact Us</p>\n                            <p>If you have any questions about this Privacy Policy, please contact us.</p>\n\n                        </div>\n                    </div>\n                    <div layout=\"row\" layout-align=\"center center\" md-padding>\n                        <md-button class=\"margin-left-0\" ng-click=\"vm.cancelLegal();\">Return</md-button>\n                    </div>\n                </md-content>\n            </md-tab>\n            <!-- <md-tab label=\"Account\">\n                <md-content class=\"md-padding\">\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.settingsGroups\">\n                            <md-subheader class=\"md-accent\" translate=\"{{::group.name}}\"></md-subheader>\n                            <md-list-item ng-repeat=\"setting in ::group.settings\" layout=\"row\" layout-align=\"space-around center\">\n                                <md-icon md-font-icon=\"{{::setting.icon}}\"></md-icon>\n                                <p translate>{{::setting.title}}</p>\n                                <md-switch class=\"md-secondary\" ng-model=\"setting.enabled\"></md-switch>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                    <md-button class=\"md-raised md-primary margin-left-0\" ng-disabled=\"profile.$invalid\" translate=\"PROFILE.BUTTON\"></md-button>\n                </md-content>\n            </md-tab> -->\n        </md-tabs>\n\n    </div>\n\n</div>\n\n</div>\n");
$templateCache.put("app/app-authentication/lock/dialogIdle.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"80\" style=\"background-color: rgba(0,0,0,0); box-shadow:none; overflow: hidden;\" class=\"dialog-idle\">\n    <md-dialog-content  layout=\"column\" layout-align=\"center center\" style=\"min-height: 200px;\">\n      <div class=\"md-dialog-content\"  flex layout-fill layout=\"column\" layout-align=\"center center\">\n          <p ng-if=\"idleMessage\" ng-bind-html=\"idleMessage\" class=\"fade idle-message md-headline center\" style=\"font-size: 3.5em; line-height: 1.2em; color: rgba(255,255,255,.8);\">\n        </p>\n      </div>\n    </md-dialog-content>\n    <md-dialog-actions style=\"\" layout=\"column\" layout-align=\"start center\">\n      <p class=\"md-subhead center\" style=\"color:#fff; color: rgba(255,255,255,.8);\">\n        We\'ve paused Adminja while you are away.<br>\n        <span ng-idle-countdown=\"countdown\">{{countdown | HandM}}</span> until logout.\n      </p>\n      <!-- <md-button class=\"md-raised md-accent\" ng-click=\"imBack()\">I\'m Back!</md-button> -->\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-authentication/lock/lock.tmpl.html","<div layout=\"row\" flex layout-padding layout-align=\"center center\">\n    <div flex=\"100\" flex-md=\"50\" flex-lg=\"30\" flex-gt-lg=\"20\">\n        <md-card style=\"border-radius: 8px!important;\">\n            <md-content class=\"md-padding\" style=\"border-radius: 8px!important;\">\n                <h2 class=\"center margin-top-20 margin-bottom-20\" translate>Yay! You\'re Back!</h2>\n                <p class=\"center\">For your security, we\'ve logged you out.</p>\n                <p class=\"center\"><md-button ng-click=\"vm.loginClick()\" class=\"md-raised md-accent\">Return</md-button>\n                <p class=\"center\" style=\"font-size: 11px;\">You can modify this security timer in your settings.</p>\n            </md-content>\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/login/login.tmpl.html","\n<div class=\"full-height\" layout=\"row\" id=\"login-page\" layout-align=\"center center\" ng-show=\"vm.showLogin\">\n    <md-card ng-if=\"!vm.adminjaStatus.adminjaOnline\" flex=\"100\" flex-gt-xs=\"30\" layout=\"column\" layout-align=\"start center\" style=\"padding: 3em 0 3em 0;\">\n        <img flex=\"nogrow\" src=\"/assets/images/brand/adminja-logotype-blue-400.png\" style=\"margin-top: 20px; width: 200px;\">\n        <h3>{{vm.adminjaStatus.offlineTitle}}</h3>\n        <p class=\"md-subhead\">{{vm.adminjaStatus.offlineMessage}}</p>\n    </md-card>\n    <md-card ng-if=\"vm.adminjaStatus.adminjaOnline\" flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-xl=\"50\" style=\"border-radius: 8px!important; max-width: 750px;\" class=\"md-whiteframe-12dp login-card\" style=\"background-color: #0091ea;\">\n        <md-content style=\" border-radius: 8px!important;\">\n            <!-- staging notification -->\n            <div layout=\"column\" ng-if=\"adminjaEnv == \'staging\'\" >\n                <md-button ng-disabled=\"true\" class=\"hide-s hide-xs\">\n                    <md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: orange;\"></md-icon>\n                    <span style=\"color: orange;\">Test Server</span>\n                </md-button>\n            </div>\n            <div layout=\"row\">\n                <div flex=\"50\" class=\"hide-xs\" style=\"padding: 1em 3em 1em 2em; margin-bottom: 50px;\">\n                    <img flex=\"nogrow\" src=\"/assets/images/brand/adminja-logotype-blue-400.png\" width=\"100\" style=\"margin-top: 20px;\">\n                    <!-- <img flex=\"nogrow\" src=\"/assets/images/brand/adminja-bug-app.png\" width=\"25\" style=\"margin-top: 20px;\"> -->\n                    <div style=\"padding-left: 1em; padding-top: 1em; padding-rigth: 3em;\" class=\"login-feature-message\">\n                        <h3>What\'s new</h3>\n                        <div layout=\"row\">\n                            <div flex=\"nogrow\" ng-if=\"vm.adminjaStatus.loginMessageIcon\" style=\"padding-right: 1em;\"><md-icon md-font-icon=\"{{vm.adminjaStatus.loginMessageIcon}}\" style=\"color: {{vm.adminjaStatus.loginMessageIconColor}}; font-size: 48px; padding-top: 24px;\"></md-icon></div>\n                            <div flex>\n                                <h4 class=\"md-subhead margin-bottom-0\">{{vm.adminjaStatus.loginMessageTitle}}</h4>\n                                <p class=\"md-subhead margin-top-0\">{{vm.adminjaStatus.loginMessage}}</p>\n                                <p class=\"md-subhead margin-top-0\" ng-if=\"vm.adminjaStatus.loginLinkURL\"><a href=\"{{vm.adminjaStatus.loginLinkURL}}\">{{vm.adminjaStatus.loginLinkLabel}}</a></p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div flex=\"100\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"50\" style=\"padding-top: 1em;\" layout=\"row\" layout-align=\"center start\">\n                    <div flex=\"auto\">\n                        <p class=\"center\"><img class=\"hide-gt-xs\" flex=\"nogrow\" src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"100\" style=\"margin-top:20px;\"></p>\n                        <h4 ng-if=\"!vm.loggingIn\" class=\"center\" style=\"margin-top:20px;\">Log In to Adminja</h4>\n                        <form ng-if=\"!vm.loggingIn\" name=\"login\" style=\"padding: 1em 2em 0 2em;\">\n                            <!-- <div class=\"message-box fade\" ng-if=\"vm.errorMessage\" style=\"margin-left: -1em; margin-top: 1em; margin-bottom: 2em;\">\n                                <p class=\"center\" ><span ng-bind-html=\'vm.errorMessage\'></span></p>\n                            </div> -->\n                            <md-input-container class=\"md-block\" md-no-float=\"true\">\n                                <label for=\"email\" translate>email</label>\n                                <input placeholder=\"\" style=\"border-radius: 8px; padding: 20px; border-bottom: none!important; background-color: #efefef;\" id=\"email\" md-no-asterisk name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required md-autofocus/>\n                                <div ng-messages=\"login.email.$error\" ng-if=\"login.email.$dirty\">\n                                    <div ng-message when=\"required\" style=\"padding-left: 1em;\">* <span translate>Please enter your email address.</span></div>\n                                    <!-- <div ng-message when=\"email\"><span translate>Please enter a valid email address.</span></div> -->\n                                </div>\n                            </md-input-container>\n                            <md-input-container class=\"md-block\" style=\"margin-bottom: 0;\" md-no-float=\"true\">\n                                <label for=\"password\" translate>password</label>\n                                <input  placeholder=\"\" style=\"border-radius: 8px; padding: 20px; border-bottom: none!important; background-color: #efefef;\" md-no-asterisk id=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" adminja-enter=\"vm.loginClick()\" required/>\n                                <div ng-messages for=\"login.password.$error\" ng-if=\"login.password.$dirty\">\n                                    <div ng-message when=\"required\" style=\"padding-left: 1em;\">* <span translate>Please enter your password</span></div>\n                                </div>\n                            </md-input-container>\n\n                            <div layout=\"column\" layout-align=\"center end\" style=\"margin-top: -1em;\">\n                                    <p  style=\"margin:0; text-align: right;\">\n                                        <a flex style=\"font-size: 12px;\" ui-sref=\"authentication.forgot\" translate=\"Forgot your password?\" aria-label=\"Forgot your password?\">Forgot your Password?</a>\n                                    </p>\n                            </div>\n\n\n                            <div layout=\"column\"  style=\"padding-top: 2em; padding-bottom: 2em;\">\n                                <md-button data-gtm-login style=\"margin:0 0 0 0; padding: 0 16px 0 16px; display:block; width:100%; border-radius: 8px;\"  class=\"md-raised md-accent\"  ng-click=\"vm.loginClick()\" ng-disabled=\"login.$invalid\"  aria-label=\"Log in\">Log in</md-button>\n                            </div>\n\n                        </form>\n                        <div layout=\"column\"  ng-if=\"vm.loggingIn\" style=\"padding-bottom: 2em;\" layout-align=\"start center\" style=\"min-height: 296px;\">\n                            <!-- <img flex=\"nogrow\" src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"100\" style=\"margin-top: 20px;\"> -->\n                            <h4  class=\"center\" style=\"margin-top:20px;\">Loading Data...</h4>\n                            <div class=\"adminja-loader\"></div>\n                            <!-- <div class=\"spinner\">\n                              <div class=\"double-bounce1\"></div>\n                              <div class=\"double-bounce2\"></div>\n                            </div> -->\n                            <!-- <div class=\"spinner login-spinner\">\n                              <div class=\"bounce1\"></div>\n                              <div class=\"bounce2\"></div>\n                              <div class=\"bounce3\"></div>\n                            </div> -->\n                            <!-- <p class=\"md-subhead text-center\">Preparing your workspaces...</p>\n                            <md-progress-linear class=\"md-accent margin-bottom-20\" md-mode=\"indeterminate\"></md-progress-linear> -->\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <p ng-if=\"!vm.loggingIn\" class=\"center\" style=\"background-color: #405d89; margin:0; padding: 1em; opacity:.8;\"><a style=\"color: #fff;\" href=\"/#/registration\" >Try Adminja FREE for 30 days!</a></p>\n\n        </md-content>\n    </md-card>\n</div>\n\n<!-- Analytics for Chargebee Cross-domain tracking-->\n<script>\n  (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n  })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n\n  ga(\'create\', \'UA-78636602-1\', \'auto\');\n  // ga(\'send\', \'pageview\');\n\n</script>\n<script>\nvar _gaq;\nsetTimeout(function(){\n    _gaq = _gaq || [];\n    _gaq.push([\'_setAccount\', \'UA-78636602-1\']);\n    _gaq.push([\'_setDomainName\', \'adminja.co\']);\n    _gaq.push([\'_setAllowLinker\', true]);\n    _gaq.push([\'_trackPageview\']);\n}, 1000);\n\n</script>\n\n");
$templateCache.put("app/app-authentication/profile/profile.tmpl.html","<div class=\"user-profile no-scrollbar\" ng-if=\"vm.user\">\n\n\n\n<div ng-if=\"vm.user\" class=\"mb-bg-1 no-scrollbar padding-20 padding-top-50 overlay-gradient-70 profile-header\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"cancel-profile md-icon-button\" ng-click=\"vm.cancelProfile();\">\n		<md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: #fff;\"></md-icon>\n</md-button>\n		<div class=\"margin-right-20\">\n				<div>\n						<avatar parent=\"vm.user.profile\" upload=\"true\" context=\"dark\"></avatar>\n				</div>\n		</div>\n		<div class=\"text-light\">\n				<h3 class=\"font-weight-600 margin-bottom-0 text-light\" ng-hide=\"vm.user.profile.firstName\">First name Last name</h3>\n				<h3 class=\"font-weight-600 margin-bottom-0 text-light\" ng-show=\"vm.user.profile.firstName\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}} <small ng-show=\"vm.user.profile.position\">{{vm.user.profile.position}}</small></h3>\n				<p class=\"font-weight-400 margin-top-0 text-light\">{{vm.user.email}}<span ng-if=\"!vm.emailVerified\" style=\"background-color: red; padding: 2px; margin-left: 10px; font-size: 10px;\">Not Verified</span><span ng-if=\"vm.emailVerified\" style=\"background-color: green; padding: 2px; margin-left: 10px; font-size: 10px;\">Verified</span><md-button ng-if=\"vm.emailVerified\" class=\"md-secondary md-button-small\" ui-sref=\"authentication.change-email\"><md-icon md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 12px; color: #fff;\"></md-icon></md-button>\n</p>\n		 </div>\n</div>\n\n<div layout=\"row\" class=\"profile\" layout-wrap>\n		<div flex=\"100\" flex-gt-md=\"100\">\n				<md-content>\n				<md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\" md-selected=\"vm.selectedTab\">\n\n						<md-tab label=\"User Profile\">\n								<md-content class=\"md-padding\">\n\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n\n												<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n													<md-card class=\"md-padding\" style=\"margin-bottom: 1em;\">\n														<h3 class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0; margin-top: 1em;\">Business Logo</h3>\n														<p class=\"md-subhead center\" style=\"font-size: .85em; margin-bottom: 2em;\">Will appear on all of your invoices, reports and custom forms.</p>\n														 <p class=\"center\">\n														<img\n														style=\"cursor: pointer;\"\n														ngf-select=\"vm.uploadLogo($files)\"\n														ngf-multiple=\"false\"\n														aria-label=\"upload logo\"\n														ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n														ng-hide=\"vm.user.profile.logo\" src=\"https://fpoimg.com/250x100?text=Your%20Logo\"   width=\"250\" />\n\n														<img\n														style=\"cursor: pointer;\"\n														ngf-select=\"vm.uploadLogo($files)\"\n														ngf-multiple=\"false\"\n														aria-label=\"upload logo\"\n														ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n														ng-show=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\"  width=\"250\"/>\n														</p>\n														<p class=\"md-subhead center\" style=\"font-size: 11px; margin-bottom: 3em;\">(250 X 100 max) <a ng-if=\"vm.user.profile.logo\" style=\"cursor: pointer;\" ng-click=\"vm.removeLogo()\">Remove</a></p>\n													</md-card>\n												<md-card class=\"md-padding\">\n													<h3 class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0; margin-top: 1em;\">Profile</h3>\n													<form name=\"vm.profileForm\">\n														<md-input-container class=\"md-block\">\n																<label for=\"name\" >First Name</label>\n																<input id=\"name\" label=\"name\" name=\"lastname\" type=\"text\" ng-model=\"vm.user.profile.firstName\" required/>\n																<div ng-messages=\"profile.name.$error\">\n																		<div ng-message when=\"required\"><span >Sorry, but we need to know who you are.</span></div>\n																</div>\n														</md-input-container>\n														<md-input-container class=\"md-block\">\n																<label for=\"name\" >Last Name</label>\n																<input id=\"name\" label=\"name\" name=\"firstname\" type=\"text\" ng-model=\"vm.user.profile.lastName\" required/>\n																<div ng-messages=\"profile.name.$error\">\n																		<div ng-message when=\"required\"><span >Sorry, but we need to know who you are.</span></div>\n																</div>\n														</md-input-container>\n														<!-- <p ng-if=\"!vm.timeZones\" style=\"margin-top: 0; margin-bottom: 2em; color: rgba(0,0,0,0.54); font-size: 13px;\">\n															<label style=\"display:block;\">Timezone</label>\n															<md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 16px; width: 16px; font-size: 16px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon> Loading Timezone Data</p> -->\n														<md-input-container flex=\"50\" class=\"padding-right-20\" style=\"margin-top: 1em; margin-bottom: 2em;\">\n														  <label>Timezone</label>\n\n														   <md-select ng-model=\"vm.user.profile.timeZone\" ng-change=\"vm.alertTimeZoneChange()\" required>\n														       <md-option ng-if=\"!zone.name.includes(\'Etc\')\" ng-repeat=\"zone in vm.timeZones track by $index + id\" ng-value=\"zone.value\">{{zone.name}}</md-option>\n														   </md-select>\n														</md-input-container>\n\n													 <md-input-container class=\"md-block\">\n																<label>Company</label>\n																<input name=\"company\" ng-model=\"vm.user.profile.company\">\n														</md-input-container>\n														<md-input-container class=\"md-block\">\n																<label>Position</label>\n																<input name=\"clientposition\" ng-model=\"vm.user.profile.position\">\n														</md-input-container>\n													 <md-input-container class=\"md-block\">\n															 <label>Website</label>\n															 <input name=\"website\" ng-model=\"vm.user.profile.website\">\n													 </md-input-container>\n													 <md-input-container class=\"md-block\">\n															 <label>Twitter</label>\n															 <input name=\"twitter\" ng-model=\"vm.user.profile.twitter\">\n													 </md-input-container>\n\n													<!--  <md-input-container>\n														<md-datepicker  class=\"md-indigo-theme md-primary\" ng-model=\"vm.user.profile.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n														</md-input-container> -->\n													</form>\n												</md-card>\n											<div layout=\"row\" layout-align=\"center center\" md-padding>\n													<md-button class=\"md-secondary\" ui-sref=\"authentication.forgot\">Reset Password</md-button>\n													<md-button ng-show=\"!vm.profileForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Cancel</md-button>\n													<md-button ng-show=\"vm.profileForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Done</md-button>\n													<md-button ng-hide=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\" ng-disabled=\"vm.profileForm.$invalid || vm.profileForm.$pristine\" translate=\"Update Profile\">\n\n													</md-button>\n													<md-button ng-show=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\">\n															<md-icon aria-label=\"updating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px; color: #fff;\"></md-icon> Saving\n													</md-button>\n											</div>\n									</div>\n								</div>\n							</md-content>\n						</md-tab>\n						<md-tab label=\"User Settings\">\n								<md-tab-body>\n									<md-content class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n										 <div flex=\"100\" style=\'max-width: 800px;\'>\n											<p class=\"md-subhead center\" style=\"font-size: 11px;\">Customize your Adminja experience by changing the units, defaults, and display settings below.</p>\n											<p class=\"text-center\" style=\"padding: 2em 2em 2em 2em;\"><small>NOTE: Some settings may require a refresh for the change to take effect.</small></p>\n\n											<settings-panel ng-if=\"vm.ready\"></settings-panel>\n										 </div>\n									 </md-content>\n								 </md-tab-body>\n						</md-tab>\n\n\n						<md-tab ng-if=\"vm.userType != \'client\'\" label=\"Lead Settings\">\n							<md-tab-body>\n									<md-content class=\"md-padding\" layout=\"column\" layout-align=\"start fill\">\n										<div ng-if=\"vm.showLeadGroups\">\n											<h3 class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0; margin-top: 1em;\">Leadboard settings</h3>\n											<p class=\"md-subhead center\" style=\"font-size: .85em; margin-bottom: 2em;\">Organize your sales process by customizing your Leadboard stages and activities.</p>\n											<!-- <p class=\"md-subhead center\" style=\"font-size: .85em; margin-bottom: 2em;\">Manage your sales leads by visiting <strong>Leads</strong> in the main menu.</p> -->\n										</div>\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n												<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n													<md-card class=\"md-padding\" ng-if=\"!vm.showLeadGroups\" >\n															<h3 class=\"md-title center\">Setup and enable your Leadboard.</h3>\n															<p class=\"md-subhead center\" style=\"font-size: 11px;\">The Leadboard is an optional module.<br>\n															If you\'d like to track your sales leads in Adminja, click the button below to setup and enable your Leadboard.</p>\n															<p class=\"center\">\n																<md-button ng-if=\"!vm.settingUp\" class=\"md-raised md-accent\" ng-click=\"vm.setupLeads()\">Enable Leadboard</md-button>\n																<md-button ng-if=\"vm.settingUp\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 16px; width: 16px; font-size: 16px; color: #fff; margin: 0 auto 0 auto;\"></md-icon></md-button>\n															</p>\n													</md-card>\n													<md-card class=\"md-padding\" ng-if=\"vm.showLeadGroups\">\n														<h3 class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0;\">Lead Stages</h3>\n															<lead-groups uid=\"{{vm.user.uid}}\" path=\"leadTypes\" boarddata=\"{{vm.leadBoard.leadTypes}}\"></lead-groups>\n													</md-card>\n													<md-card class=\"md-padding\" ng-if=\"vm.showLeadGroups\">\n														<h3 class=\"md-title center\" style=\"font-weight: 400;\">Lead Activity Types</h3>\n														<lead-groups uid=\"{{vm.user.uid}}\" path=\"contactTypes\" boarddata=\"{{vm.leadBoard.contactTypes}}\"></lead-groups>\n													</md-card>\n\n													<!-- <p class=\"center\" ng-if=\"vm.showLeadGroups\"><md-button ng-click=\"vm.deleteLeadsBoard()\">Disable and Delete Leads board</md-button></p> -->\n											</div>\n										</div>\n									</md-content>\n							</md-tab-body>\n						</md-tab>\n\n\n						<md-tab ng-if=\"vm.userType != \'client\'\" label=\"Package Templates\">\n							<md-tab-body>\n									<md-content class=\"md-padding\" layout=\"column\" layout-align=\"start fill\">\n										<h3 class=\"center\">\n											Package Templates </h3>\n											<p class=\"center\"><md-button ng-click=\"vm.newPackageTemplate()\" class=\"md-primary md-raised\">\n												+ New Package Template\n											</md-button></p>\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n\n											<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\" layout=\"column\" layout-align=\"start layout-fill\" style=\"min-height:\">\n												<md-card class=\"md-padding\" ng-repeat=\"template in vm.user.packageTemplates | toArray: false | orderBy: [\'-timeStamp\'] track by uid + $index\">\n													<md-card-content>\n														<div layout=\"row\" layout-align=\"layout-fill center\">\n															<div flex=\"nogrow\" style=\"padding-right: 1em;\">\n																<md-button class=\"md-icon-button\" ng-click=\"vm.editPackageTemplate(template)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n															</div>\n															<div flex=\"grow\">\n																<p class=\"md-subhead margin-top-0\" style=\"padding-top: 8px;\">\n																	<md-icon  md-font-icon ng-class=\"\n																	           {\'zmdi zmdi-time-restore adjust-left-neg-1\': template.type ==\'hourly\',\n																	            \'zmdi zmdi-time-interval adjust-left-1\': template.type == \'retainer\',\n																	            \'zmdi zmdi-hourglass-alt adjust-left-6\': template.type == \'balance\',\n																	            \'zmdi zmdi-dot-circle adjust-left-1\': template.type ==\'fixed\',\n																	            \'zmdi zmdi-gas-station adjust-left-6\': template.type == \'refillable\'\n																	            }\"\n																	>\n																	</md-icon>\n																	{{template.label}}<br></p>\n															</div>\n															<div flex=\"nogrow\">\n																<md-button class=\"md-icon-button\" ng-click=\"vm.deletePackageTemplate(template)\"><md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon></md-button>\n															</div>\n														</div>\n													</md-card-content>\n												</md-card>\n											</div>\n										</div>\n									</md-content>\n							</md-tab-body>\n						</md-tab>\n						<md-tab ng-if=\"vm.userType != \'client\'\"  label=\"Invoice Settings\" md-on-select=\"vm.checkCurrency()\">\n								<md-content class=\"md-padding\">\n									<form name=\"vm.companyForm\">\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n												<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n\n													<md-card class=\"md-padding\">\n														<div layout=\"row\" layout-align=\"start center\">\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showInvoiceDefaults\" ng-click=\"vm.showInvoiceDefaults = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showInvoiceDefaults\" ng-click=\"vm.showInvoiceDefaults = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n															<h3 flex>Invoice Defaults</h3>\n														</div>\n														<div ng-if=\"vm.showInvoiceDefaults\" style=\"padding-top: 1em;\" layout=\"column\" layout-align=\"start start\">\n															 <p class=\"md-subhead center\" style=\"font-size: .85em; margin-bottom: 2em;\">You may override these when preparing invoices.</p>\n															<md-input-container class=\"\">\n																	<label>Days until invoice is due</label>\n																	<input ng-model=\"vm.user.profile.invoiceDueDays\" type=\"number\" style=\"color: #000;\">\n															</md-input-container>\n															<md-input-container class=\"\">\n																	<label>Default Invoice Terms</label>\n																	<input ng-model=\"vm.user.profile.invoiceTerms\" style=\"color: #000;\">\n															</md-input-container>\n															<md-input-container class=\"\" style=\"width:300px;\">\n																	<label>Default Invoice Notes</label>\n																	<textarea ng-model=\"vm.user.profile.invoiceNotes\" style=\"color: #000;\"></textarea>\n															</md-input-container>\n\n														</div>\n													</md-card>\n													<md-card class=\"md-padding\">\n														<div layout=\"row\" layout-align=\"start center\">\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showLabelsTaxes\" ng-click=\"vm.showLabelsTaxes = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showLabelsTaxes\" ng-click=\"vm.showLabelsTaxes = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n															<h3 flex>Labels &amp; Taxes</h3>\n														</div>\n														<div ng-if=\"vm.showLabelsTaxes\" style=\"padding-top: 1em;\">\n															 <md-input-container class=\"md-block\">\n															 	<label>Invoice Label</label>\n															 	<input ng-model=\"vm.user.profile.invoiceLabel\" style=\"color: #000;\" placeholder=\"Invoice\">\n															 </md-input-container>\n\n															 <!-- only show if taxes enabled -->\n															<div ng-if=\"vm.user.profile.calculateTax\">\n															 	<md-input-container class=\"md-block\">\n																 	<label>Tax Label</label>\n																 	<input ng-model=\"vm.user.profile.taxLabel\" placeholder=\"Tax\" style=\"color: #000;\">\n																 </md-input-container>\n																  	<md-input-container class=\"md-block\">\n																 	 	<label>Tax %</label>\n																 	 	<input  ng-model=\"vm.user.profile.taxPercentage\" placeholder=\"10\" style=\"color: #000;\" type=\"number\">\n																 	 </md-input-container>\n															</div>\n															 <md-input-container>\n															 	<md-checkbox ng-model=\"vm.user.profile.calculateTax\"></md-checkbox> Add Tax to Invoices\n															 </md-input-container>\n														</div>\n													</md-card>\n													<md-card class=\"md-padding\">\n														<div layout=\"row\" layout-align=\"start center\">\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showRemittance\" ng-click=\"vm.showRemittance = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showRemittance\" ng-click=\"vm.showRemittance = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n															<h3 flex>Invoice Remittance Mailing Address</h3>\n														</div>\n														<div ng-if=\"vm.showRemittance\" style=\"padding-top: 1em;\">\n															 <!-- <p class=\"md-subhead center\" style=\"font-size: .85em; margin-bottom: 2em;\">Will automatically appear on your invoice remittance slips.</p> -->\n																<md-input-container class=\"md-block\" style=\"margin-bottom:0;\">\n																	<label>Company</label>\n																	<input ng-model=\"vm.user.profile.company\">\n																</md-input-container>\n\n																<md-input-container class=\"md-block\">\n																	<label>Street</label>\n																	<input ng-model=\"vm.user.profile.address.street\" style=\"color: #000;\">\n																</md-input-container>\n																<md-input-container class=\"md-block\">\n																	<label>Street 2</label>\n																	<input ng-model=\"vm.user.profile.address.street2\" style=\"color: #000;\">\n																</md-input-container>\n																<md-input-container class=\"md-block\">\n																	<label>City or Town</label>\n																	<input ng-model=\"vm.user.profile.address.city\" style=\"color: #000;\">\n																</md-input-container>\n																<md-input-container class=\"md-block\">\n																	<label>State or Region</label>\n																	<input ng-model=\"vm.user.profile.address.state\" style=\"color: #000;\">\n																</md-input-container>\n																<md-input-container class=\"md-block\">\n																	<label>Postal Code/Zip</label>\n																	<input ng-model=\"vm.user.profile.address.zip\" style=\"color: #000;\">\n																</md-input-container>\n																<md-input-container class=\"md-block\">\n																	<label translate>Country/Region</label>\n																	<md-select name=\"country\" ng-model=\"vm.user.profile.address.country\">\n																		<md-option ng-value=\"country.name\" ng-repeat=\"country in vm.countries track by $index+code\">{{country.name}}</md-option>\n																	</md-select>\n																</md-input-container>\n														</div>\n													</md-card>\n\n													<md-card class=\"md-padding\">\n														<ng-form name=\"paypmentProcessorForm\" isolate-form>\n														<div layout=\"row\" layout-align=\"start center\">\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showPaymentProcessors\" ng-click=\"vm.showPaymentProcessors = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n															<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showPaymentProcessors\" ng-click=\"vm.showPaymentProcessors = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n															<h3 flex>Payment Processors</h3>\n															<md-button class=\"md-button-small\" ng-click=\"vm.showExperience(\'1622049191cFlc8103\')\">\n																<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n																<md-tooltip md-delay=\"500\">How does this work?</md-tooltip>\n															</md-button>\n														</div>\n\n\n														<div ng-if=\"vm.showPaymentProcessors\">\n															<!-- <p class=\"md-subhead center margin-top-0\">Accept payments directly from your invoices!</p> -->\n															<div ng-if=\"vm.user.profile.settings.currencyCode\">\n																<div layout=\"row\" layout-align=\"layout-fill center\" class=\"margin-top-40\">\n																	<div flex=\"nogrow\" class=\"padding-right-20\">\n																		<md-icon md-font-icon=\"zmdi zmdi-paypal\" style=\"font-size: 2em;\"></md-icon>\n																	</div>\n																	<md-input-container flex=\"grow\" class=\"margin-top-0\">\n																		<md-checkbox  ng-change=\"vm.toggleProcessorEnable(\'paypalEnabled\')\" ng-model=\"vm.user.profile.settings.paypalEnabled\" aria-label=\"paypalEnabled\"> Enable PayPal Payments</md-checkbox>\n																	</md-input-container>\n\n																</div>\n																<div layout=\"column\" ng-if=\"vm.user.profile.settings.paypalEnabled\">\n																	<!-- no paypalID -->\n																	<div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.user.profile.settings.paypalClient\">\n																		<h3 flex=\"20\">Step 1</h3>\n																		<div flex=\"grow\">\n																			<md-button ng-click=\"vm.addKey(\'paypalClient\', \'PayPal Client ID\', \'PayPal\', false)\" class=\"md-raised md-secondary\" style=\"width: 200px;\">Enter PayPal Client ID</md-button>\n																		</div>\n																		<div flex=\"nogrow\">\n																			<md-button class=\"md-accent margin-top-20\" ng-click=\"vm.showExperience(\'1619109756cHmr2114\')\">What\'s this?</md-button>\n																		</div>\n																	</div>\n																	<!-- has paypalID -->\n																	<div layout=\"row\" layout-align=\"layout-fill center\" ng-if=\"vm.user.profile.settings.paypalClient\">\n																		<div flex=\"10\">\n																			<md-button class=\"md-icon-button\" ng-disabled=\"true\"><md-icon style=\"color: green;\" md-font-icon=\"fa fa-check\"></md-icon></md-button>\n																		</div>\n																		<md-input-container flex=\"grow\" >\n																			<label>PayPal Client ID</label>\n																			<input ng-disabled=\"true\" value=\"XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\" style=\"color: #999;\" >\n																		</md-input-container>\n																		<div flex=\"nogrow\">\n																			<md-button class=\"md-warn\" ng-click=\"vm.deleteSecret(vm.user.secrets.paypalClient.uid, \'paypalClient\')\"><md-icon md-font-icon=\"fa fa-trash\"></md-icon></md-button>\n																		</div>\n\n																	</div>\n																</div>\n																<!--<div layout=\"row\" layout-align=\"layout-fill center\" ng-if=\"vm.user.profile.settings.paypalEnabled\" >\n																	<md-input-container flex=\"80\" >\n																		<label>PayPal ClientID</label>\n																		<input ng-model=\"vm.user.profile.settings.paypalClient\" style=\"color: #000;\" required>\n																	</md-input-container>\n																	<div flex=\"20\">\n																		<md-button class=\"md-accent margin-top-20\" ng-click=\"vm.showExperience(\'1619109756cHmr2114\')\">What\'s this?</md-button>\n																	</div>\n																</div>-->\n\n																<md-divider class=\"\" style=\"margin-bottom: 25px;\"></md-divider>\n																<div layout=\"row\" layout-align=\"layout-fill center\">\n																	<div flex=\"nogrow\" class=\"padding-right-20\">\n																		<md-icon md-svg-src=\"/assets/images/icons/stripe.svg\" style=\"zoom: 1.25; -webkit-filter: grayscale(1); filter: grayscale(1);\"></md-icon>\n																	</div>\n																	<md-input-container flex=\"grow\" class=\"margin-top-0\">\n																		<md-checkbox  ng-change=\"vm.toggleProcessorEnable(\'stripeEnabled\')\" ng-model=\"vm.user.profile.settings.stripeEnabled\" aria-label=\"paypalEnabled\"> Enable Stripe Payments</md-checkbox>\n																	</md-input-container>\n																</div>\n																<div ng-if=\"vm.user.profile.settings.stripeEnabled\">\n																	<!-- stripe form if enabled and key not already saved -->\n																	<div layout=\"column\">\n																		<!-- no stripePublishable -->\n																		<div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.user.profile.settings.stripeClient\">\n																			<h3 flex=\"20\">Step 1</h3>\n																			<div flex=\"grow\">\n																				<md-button ng-click=\"vm.addKey(\'stripeClient\', \'Stripe Publishable\', \'Stripe\', false)\" class=\"md-raised md-secondary\" style=\"width: 200px;\">Enter Stripe Publishable Key</md-button>\n																			</div>\n																			<div flex=\"nogrow\">\n																				<md-button class=\"md-accent margin-top-20\" ng-click=\"vm.showExperience(\'1619110128xMnk3998\')\">What\'s this?</md-button>\n																			</div>\n																		</div>\n																		<!-- has stripePublishable -->\n																		<div layout=\"row\" layout-align=\"layout-fill center\" ng-if=\"vm.user.profile.settings.stripeClient\">\n																			<div flex=\"10\">\n																				<md-button class=\"md-icon-button\" ng-disabled=\"true\"><md-icon style=\"color: green;\" md-font-icon=\"fa fa-check\"></md-icon></md-button>\n																			</div>\n																			<md-input-container flex=\"grow\" >\n																				<label>Stripe Publishable Key</label>\n																				<input ng-disabled=\"true\" value=\"XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\" style=\"color: #999;\" >\n																			</md-input-container>\n																			<div flex=\"nogrow\">\n																				<md-button class=\"md-warn\" ng-click=\"vm.deleteSecret(vm.user.profile.settings.stripeClient, \'stripeClient\')\"><md-icon md-font-icon=\"fa fa-trash\"></md-icon></md-button>\n																			</div>\n\n																		</div>\n																		<!-- no stripeSecret -->\n																		<div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.user.secrets.stripeSecret\">\n																			<h3 flex=\"20\">Step 2</h3>\n																			<div flex=\"grow\">\n																				<md-button ng-click=\"vm.addKey(\'stripeSecret\', \'Stripe Secret\', \'Stripe\', true)\" class=\"md-raised md-secondary\" style=\"width: 200px;\">Enter Stripe Secret Key</md-button>\n																			</div>\n																			<div flex=\"nogrow\">\n																				<md-button class=\"md-accent margin-top-20\" ng-click=\"vm.showExperience(\'1619110128xMnk3998\')\">What\'s this?</md-button>\n																			</div>\n																		</div>\n																		<!-- has stripeSecret -->\n																		<div layout=\"row\" layout-align=\"layout-fill center\" ng-if=\"vm.user.secrets.stripeSecret\">\n																			<div flex=\"10\">\n																				<md-button class=\"md-icon-button\" ng-disabled=\"true\"><md-icon style=\"color: green;\" md-font-icon=\"fa fa-check\"></md-icon></md-button>\n																			</div>\n																			<md-input-container flex=\"grow\" >\n																				<label>Stripe Secret Key</label>\n																				<input ng-disabled=\"true\"  value=\"XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX\" style=\"color: #999;\" >\n																			</md-input-container>\n																			<div flex=\"nogrow\">\n																				<md-button class=\"md-warn\" ng-click=\"vm.deleteSecret(vm.user.secrets.stripeSecret.uid, \'stripeSecret\')\"><md-icon md-font-icon=\"fa fa-trash\"></md-icon></md-button>\n																			</div>\n																		</div>\n																	</div>\n																</div>\n\n															</div>\n															<div ng-if=\"!vm.user.profile.settings.currencyCode\">\n																<p class=\"md-subhead center\"><md-icon style=\"font-size: 2em; margin-bottom: 1em;\" md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon><br> Payment integrations require new currency definitions.<br>Please visit the <strong>User Settings</strong> tab and select your currency first.</p>\n															</div>\n															<!-- static payment link -->\n															<md-divider class=\"\" style=\"margin-bottom: 25px;\"></md-divider>\n\n															<div>\n																<div layout=\"row\" layout-align=\"layout-fill center\" class=\"margin-top-40\">\n																	<div flex=\"nogrow\" class=\"padding-right-20\">\n																		<md-icon md-font-icon=\"zmdi zmdi-link\" style=\"font-size: 2em;\"></md-icon>\n																	</div>\n																	<div flex=\"grow\" layout=\"column\">\n																		<md-input-container flex=\"grow\" class=\"margin-top-0\">\n																			<md-checkbox  ng-change=\"vm.toggleProcessorEnable(\'urlEnabled\')\" ng-model=\"vm.user.profile.settings.urlEnabled\" aria-label=\"urlEnabled\"> Enable Custom Payment Link</md-checkbox>\n																		</md-input-container>\n																		<md-input-container ng-if=\"vm.user.profile.settings.urlEnabled\" class=\"\" style=\"width: 100%; margin-top: 40px;\">\n																				<label>Custom Payment URL</label>\n																				<input ng-model=\"vm.user.profile.paymentLink\" ng-disabled=\"vm.user.profile.settings.paypalEnabled || vm.user.profile.settings.stripeEnabled\" placeholder=\"https://paypal.me/adminja\" style=\"color: #000;\">\n																		</md-input-container>\n																	</div>\n\n																</div>\n															</div>\n															<!-- <p class=\"md-subhead center\">Once configured here, you can enable these payment processors for each of your client workspaces.</p> -->\n\n															<!-- <div ng-if=\"!vm.user.profile.settings.paypalEnabled && !vm.user.profile.settings.stripeEnabled\" style=\"padding: 2em;\">\n																<h3 class=\"md-subhead\"><strong>Legacy \"Pay Now\" Button</strong></h3>\n\n																<md-input-container class=\"\" style=\"width: 100%; margin-top: 40px;\">\n																		<label>Button URL</label>\n																		<input ng-model=\"vm.user.profile.paymentLink\" ng-disabled=\"vm.user.profile.settings.paypalEnabled || vm.user.profile.settings.stripeEnabled\" placeholder=\"https://paypal.me/adminja\" style=\"color: #000;\">\n																</md-input-container>\n\n															</div> -->\n														</div>\n														<div ng-if=\"vm.showPaymentProcessors && vm.user.profile.settings.currencyCode && !vm.currencyIsValid\">\n															<p class=\"md-subhead center\"><md-icon style=\"font-size: 2em; margin-bottom: 1em;\" md-font-icon=\"fa fa-frown-o\"></md-icon><br> We\'re sorry, payment integrations aren\'t available for {{vm.user.profile.settings.currencyCode}} currency.</p>\n														</div>\n\n													</ng-form>\n													</md-card>\n\n\n\n\n\n										<div layout=\"row\" layout-align=\"center center\" md-padding>\n\n												<md-button ng-show=\"!vm.companyForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Cancel</md-button>\n												<md-button ng-show=\"vm.companyForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Done</md-button>\n												<md-button ng-hide=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\" ng-disabled=\"vm.companyForm.$invalid || vm.companyForm.$pristine\" translate=\"Update Invoice Settings\">\n\n												</md-button>\n												<md-button ng-show=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\">\n														<md-icon aria-label=\"updating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px; color: #fff;\"></md-icon> Saving\n												</md-button>\n										</div>\n									</div>\n								</div>\n								</form>\n							</md-content>\n						</md-tab>\n\n						<!-- subscription manager -->\n						<md-tab ng-if=\"vm.userType != \'client\'\" >\n								<md-tab-label>\n										<span ng-if=\"vm.user.plan.content__subscription__status == \'cancelled\'\">\n												<md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: red;\">\n														<md-tooltip md-delay=\"1000\">Please check your subscription!</md-tooltip>\n												</md-icon>\n										</span> Subscription\n								</md-tab-label>\n								<md-tab-body>\n									<md-content class=\"md-padding\">\n									<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n											<div layout=\"column\" flex=\"100\" flex-md=\"100\" flex-lg=\"80\" flex-xl=\"70\" style=\"padding-bottom: 150px;\">\n													<subscription-manager user=\"vm.user\" style=\"padding-top: 2em;  margin-bottom :7em;\"></subscription-manager>\n											</div>\n									</div>\n\n									<p class=\"text-center\">\n											<br>\n											<span class=\"md-caption\"><strong>USER ID:</strong> {{vm.user.uid}}</span>\n									</p>\n\n									</md-content>\n							 </md-tab-body>\n						</md-tab>\n\n						<md-tab  label=\"Privacy &amp; Consent\">\n								<md-tab-body>\n									<md-content>\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n												<div flex=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"40\">\n													<p class=\"center\">For security compliance, and to provide transparency on the information we collect, we sometimes ask you for your consent before we store or transmit potentially personal information. </p>\n													<p class=\"center\" style=\"margin-bottom: 2em;\">You can review and manage the consent you\'ve given here.</p>\n												</div>\n										</div>\n										<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n												<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n														<md-card class=\"md-padding\" ng-repeat=\"consent in vm.userDataService.user.consent track by $index\">\n																	<div layout=\"row\" layout-align=\"start center\">\n																		<h3 flex=\"auto\" style=\"text-transform: capitalize;\">{{consent.entity}}</h3>\n																		<div flex=\"10\"><md-switch ng-model=\"consent.hasConsent\" ng-change=\"vm.changeConsent(consent.entity, consent.hasConsent)\"></md-switch></div>\n																	</div>\n																	<div ng-bind-html=\"consent.description\"></div>\n																	<p class=\"md-subtitle right\" style=\"font-size: 12px;\">Updated {{consent.timeStamp | amTimeAgo}}</p>\n														</md-card>\n											</div>\n										</div>\n											<div flex=\'100\' layout=\"row\" layout-align=\"center center\">\n													<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n														<p class=\"md-subhead center\" style=\"font-size: 12px;\"><strong>Note:</strong> <br>Information consent is required for Adminja to function properly. <br>Revoking consent may disable certain features until you\'ve granted consent again.</p>\n													</div>\n											</div>\n\n									</md-content>\n								 </md-tab-body>\n						</md-tab>\n\n						<md-tab ng-if=\"vm.userType != \'client\'\" label=\"Report Settings\">\n							<md-tab-body>\n								<md-content class=\"md-padding\" layout=\"column\" layout-align=\"start fill\" style=\"min-height: 500px;\">\n									<form name=\"vm.reportSettingsForm\">\n										<div layout=\"row\" flex=\"100\" layout-align=\"center center\">\n											<div flex=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\">\n												<md-card class=\"md-padding\">\n													<h3 class=\"center\">Personal Status Reports</h3>\n					                                        <div layout=\"column\" flex=\"100\" >\n														<div layout=\"column\" layout-align=\"start layout-fill\">\n														    <div flex style=\"\" layout=\"column\" layout-align=\"start start\">\n														    	<div layout=\"row\" layout-align=\"start center\">\n															        <md-input-container flex=\"nogrow\" style=\"margin-right: 2em;\">\n															            <md-checkbox ng-model=\"vm.user.profile.settings.dailyStatusReportEnabled\" aria-label=\"Enable daily status reports\" ng-change=\"vm.updateReportConfig(\'dailyStatusReport\', vm.user)\">Send <strong>daily</strong> status reports</md-checkbox>\n															        </md-input-container>\n															        <md-button class=\"md-button-small\" ng-click=\"vm.showSample()\"  style=\"font-size: 11px; color: #999;\">See sample</md-button>\n															 </div>\n														        <div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.user.profile.settings.dailyStatusReportEnabled\">\n																   <div flex=\"nogrow\" layout=\"row\" >\n																   	 <span style=\"padding-top: 5px;\">Every day at</span>\n															            <md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n															                <md-select  ng-model=\"vm.user.profile.settings.dailyStatusReport.time\" ng-change=\"vm.updateReportConfig(\'dailyStatusReport\', vm.user)\" placeholder=\"Set time\">\n																			<md-option ng-value=\"00\">12am</md-option>\n																			<md-option ng-value=\"02\">2am</md-option>\n																			<md-option ng-value=\"06\">6am</md-option>\n																			<md-option ng-value=\"08\">8am</md-option>\n																			<md-option ng-value=\"09\">9am</md-option>\n																			<md-option ng-value=\"10\">10am</md-option>\n															               </md-select>\n																       </md-input-container>\n																       <md-input-container flex=\"nogrow\" style=\"margin-top:0; margin-left: 2em;\">\n																           <md-checkbox ng-model=\"vm.user.profile.settings.dailyStatusReport.includeOpenTasks\" ng-true-value=\"\'enabled\'\" ng-false-value=\"\'disabled\'\" aria-label=\"Include Open Task Detail\" ng-change=\"vm.updateReportConfig(\'dailyStatusReport\', vm.user)\">Include uncompleted tasks in report</md-checkbox>\n																       </md-input-container>\n																   </div>\n																</div>\n														    </div>\n														    <p ng-if=\"vm.userType == \'admin\'\"><a href=\"{{vm.fbConfig.dataURL}}schedules/{{vm.user.profile.settings.dailyStatusReport.scheduleID}}\" target=\"_blank\">{{vm.user.profile.settings.dailyStatusReport.scheduleID}}</a></p>\n														    <md-divider></md-divider>\n\n															<div layout=\"column\" layout-align=\"start start\">\n																<md-input-container flex=\"nogrow\">\n																    <md-checkbox ng-model=\"vm.user.profile.settings.weeklyStatusReportEnabled\" aria-label=\"Enable daily status reports\" ng-change=\"vm.updateReportConfig(\'weeklyStatusReport\', vm.user)\">Send <strong>weekly</strong> status reports</md-checkbox>\n																</md-input-container>\n																<div ng-if=\"vm.user.profile.settings.weeklyStatusReportEnabled\" layout=\'column\' layout-align=\"start start\">\n																	<div layout=\"row\" style=\"padding-left: 1em;\" >\n																		   <span style=\"padding-top: 5px;\">Every</span>\n																		    <md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n																		        <md-select ng-model=\"vm.user.profile.settings.weeklyStatusReport.day\" ng-change=\"vm.updateReportConfig(\'weeklyStatusReport\', vm.user)\" ng-value=\"friday\" placeholder=\"Set day\">\n																		            <md-option value=\"1\">Monday</md-option>\n																		            <md-option value=\"2\">Tuesday</md-option>\n																		            <md-option value=\"3\">Wednesday</md-option>\n																		            <md-option value=\"4\">Thursday</md-option>\n																		            <md-option value=\"5\">Friday</md-option>\n																		            <md-option value=\"6\">Saturday</md-option>\n																		            <md-option value=\"0\">Sunday</md-option>\n																		        </md-select>\n																		  </md-input-container>\n																		  <span style=\"padding-top: 5px;\"> at </span>\n																	      <md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n																	          <md-select ng-model=\"vm.user.profile.settings.weeklyStatusReport.time\" ng-change=\"vm.updateReportConfig(\'weeklyStatusReport\', vm.user)\" placeholder=\"Set time\">\n																			      <md-option ng-value=\"00\">12am</md-option>\n																			      <md-option ng-value=\"02\">2am</md-option>\n																			      <md-option ng-value=\"06\">6am</md-option>\n																			      <md-option ng-value=\"08\">8am</md-option>\n																			      <md-option ng-value=\"09\">9am</md-option>\n																			      <md-option ng-value=\"10\">10am</md-option>\n																	         </md-select>\n																		  </md-input-container>\n																		<md-input-container style=\"margin-left: 2em; margin-top:0;\">\n																		    <md-checkbox ng-model=\"vm.user.profile.settings.weeklyStatusReport.includeOpenTasks\" ng-true-value=\"\'enabled\'\" ng-false-value=\"\'disabled\'\" aria-label=\"Include Open Task Detail\" ng-change=\"vm.updateReportConfig(\'weeklyStatusReport\', vm.user)\">Include uncompleted tasks in report</md-checkbox>\n																		</md-input-container>\n\n																	</div>\n\n																</div>\n\n															</div>\n															<p ng-if=\"vm.userType == \'admin\'\"><a href=\"{{vm.fbConfig.dataURL}}schedules/{{vm.user.profile.settings.weeklyStatusReport.scheduleID}}\" target=\"_blank\">{{vm.user.profile.settings.weeklyStatusReport.scheduleID}}</a></p>\n\n\n														</div><!-- centered column -->\n													</div>\n												</md-card>\n												<md-card class=\"md-padding\">\n													<h3 class=\"center\">Clients Status Reports</h3>\n													<p class=\"center md-subhead\">Client Status Reports can be enabled when editing a Workspace.</p>\n													<p class=\"md-subhead center\" style=\"font-size: .85em;margin-left: 3em; margin-right: 3em;\">The default \"Welcome\" and \"Closing\" below will be copied over to any Workspaces you create. These messages can be customized for each client by editing their workspace.</p>\n													<h4 ><strong>Default Report Welcome</strong></h4>\n													<div  style=\"\" class=\"welcome-field\" froala=\"vm.froala1Options\" ng-model=\"vm.user.profile.settings.clientReportWelcome\" style=\"min-height: 350px;\">\n													    <!-- <text-angular name=\"noteEditor\" ng-model=\"vm.detail.note\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'p\', \'pre\', \'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\',\'insertLink\', \'html\']]\" ></text-angular> -->\n													</div>\n													<h4 style=\"margin-top: 1em;\"><strong>Default Report Closing</strong></h4>\n													<div  style=\"\" class=\"closing-field\" froala=\"vm.froala2Options\" ng-model=\"vm.user.profile.settings.clientReportClosing\" style=\"min-height: 350px;\">\n													    <!-- <text-angular name=\"noteEditor\" ng-model=\"vm.detail.note\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'p\', \'pre\', \'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\',\'insertLink\', \'html\']]\" ></text-angular> -->\n													</div>\n\n												</md-card>\n											</div>\n										</div>\n									</form>\n								</md-content>\n								<!--- controls -->\n								<div layout=\"row\" layout-align=\"center center\" md-padding style=\"padding-bottom: 1em;\">\n										<md-button ng-show=\"!vm.reportSettingsForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Cancel</md-button>\n										<md-button ng-show=\"vm.reportSettingsForm.$pristine\" class=\"margin-left-0\" ng-click=\"vm.cancelProfile();\">Done</md-button>\n										<md-button ng-disabled=\"((vm.reportSettingsForm.$pristine) && (vm.profileForm.$pristine)) || vm.reportSettingsForm.$invalid || vm.profileForm.$invalid\" ng-hide=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\" translate=\"Update Settings\"></md-button>\n										<md-button ng-show=\"vm.updating\"  ng-click=\"vm.updateUser(vm.user)\" class=\"md-raised md-accent margin-left-0\">\n												<md-icon aria-label=\"updating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px; color: #fff;\"></md-icon> Saving\n										</md-button>\n								</div>\n							</md-tab-body>\n						</md-tab>\n\n				</md-tabs>\n				</md-content>\n		</div>\n</div>\n</div>\n");
$templateCache.put("app/app-authentication/subscription-confirmation/subscription-confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div class=\"cancel-whiteframe no-scrollbar\" layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\" style=\"padding-left: 20px; padding-right: 20px;\">\n    <div flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-gt-lg=\"40\" md-whiteframe=\"3\" style=\" background-color: #fff;\" layout=\"column\" layout-align=\"start stretch\">\n\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"center center\">\n                    <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n\n                    <h3>Subscription Complete!</h3>\n                    <p class=\"center\">\n                        Thank you for updating your payment information!<br>\n                        It may take up to 5 minutes for your account to be fully reactivated.<br>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"vm.returnToAdminja()\">Return to Adminja</md-button>\n                    </p>\n                </div>\n\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/registration/registration.confirmation.tmpl.html","<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-padding layout-fill layout-align=\"center center\" >\n    <div flex=\"100\" flex-md=\"80\" flex-lg=\"80\" flex-gt-lg=\"80\">\n        <md-card class=\"md-whiteframe-12dp\" style=\"background-color: #aaa;\">\n            <md-content class=\"\">\n                <div layout=\"column\" class=\"md-padding\" layout-align=\"start stretch\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <img src=\"/assets/images/brand/adminja-hlogo-blue.svg\" width=\"300\" style=\"margin-top: 2em; margin-bottom: 2em;\">\n                    </div>\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <h1 style=\"margin-bottom: 40px;\" class=\"center\">Thank you for signing up!</h1>\n                        <!-- <p class=\"center\" style=\"margin-bottom: 40px;\">\n                            For a smooth start, please <strong>follow these steps</strong> to login:\n                        </p> -->\n                    </div>\n\n                    <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"center center\" class=\"post-confirmation-steps\"  style=\"\">\n\n                            <md-card flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align=\"start center\">\n                                <div class=\"step-number\">\n                                    <h2 class=\"\">1</h2>\n                                </div>\n                                <h3 class=\"center\">Please check your email inbox</h3>\n                                <p class=\"center\">You should receive an email from <strong>Adminjabot</strong> to confirm your identity address.</p>\n                                <p class=\"center\"><md-button class=\"md-button-small md-primary\" ng-click=\"vm.sendEmailConfirmation()\">Re-send Email</md-button></p>\n                            </md-card>\n\n\n                            <!-- <md-card flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align=\"start center\">\n                                <div class=\"step-number\">\n                                    <h2 class=\"\">2</h2>\n                                </div>\n                                <h3 class=\"center\">Start Using Adminja</h3>\n                                <p class=\"center\">Click the link to confirm your email address.</p>\n                            </md-card> -->\n\n\n                            <md-card flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align=\"start center\">\n                                <div class=\"step-number\">\n                                    <h2 class=\"\">2</h2>\n                                </div>\n                                <h3 class=\"center\">Log in and start using Adminja!</h3>\n                                <p class=\"center\">We\'ll guide you along the way.</p>\n                                <p class=\"center\"><md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.login()\">Login</md-button></p>\n                            </md-card>\n\n\n                    </div>\n\n\n                </div>\n            </md-content>\n            <!-- <p  class=\"center\"><a style=\"color: #fff;\" ui-sref=\"authentication.login\" >Already have an account? Login</a></p> -->\n        </md-card>\n    </div>\n</div>\n");
$templateCache.put("app/app-authentication/registration/registration.tmpl.html","\n<!-- login.tmpl.html-->\n\n<div layout=\"row\" flex layout-fill layout-align=\"center start\" id=\"registration-page\">\n    <!-- mobile content -->\n\n    <!-- desktop content -->\n    <!-- Plan selector -->\n    <div ng-if=\"!vm.showRegistrationForm\" layout=\"column\" layout-align=\"center layout-fill\" class=\"plans-and-pricing\" >\n        <a style=\"margin-left: auto; margin-right: auto;\" class=\"home-link\" href=\"https://www.getadminja.com/\"><img ng-src=\"assets/images/brand/adminja-hlogo-white.svg\" width=\"200\"></a>\n        <h1 flex class=\"center white\">Choose Your Subscription Plan</h1>\n        <h2 flex class=\"center white\">All plans include a Free 30-day Trial</h2>\n        <h3 flex class=\"center white\">Upgrade, downgrade or cancel at any time.</h3>\n        <md-button ng-disabled=\"true\" ng-if=\"adminjaEnv == \'staging\'\" class=\"hide-s hide-xs\">\n            <md-icon flex=\"nogrow\" md-font-icon=\'zmdi zmdi-alert-triangle\' style=\"color: orange;\"></md-icon>\n            <span style=\"color: orange;\">Test Server</span>\n        </md-button>\n        <!-- plan cards -->\n        <div flex layout=\"column\" layout-align=\"start center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\" class=\"pricing-table\">\n            <md-card class=\"md-whiteframe-12dp plan-card primary\">\n                <div class=\"details\" layout=\"column\" layout-align=\"start layout-fill\">\n                    <h2 class=\"plan-name\">Solo</h2>\n                    <div class=\"divider\"></div>\n                    <h3 class=\"plan-price\">$29.99<small>/mo</small></h3>\n                    <div layout-gt-sm=\"row\" layout-align-gt-sm=\"layout-fill start\" layout=\"column\" layout-align=\"start start\">\n                        <md-list flex=\"50\" class=\"plan-details\" style=\"margin-bottom: -40px;\">\n                          <md-list-item class=\"md-3-line md-long-text\">\n\n                            <div class=\"md-list-item-text\">\n                              <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> <strong>Unlimited</strong> Workspaces</h4>\n                                <p>For organizing all of your client\'s key information, tasks, time and billing.</p>\n                            </div>\n                          </md-list-item>\n\n                          <md-list-item class=\"md-3-line md-long-text\">\n\n                            <div class=\"md-list-item-text\">\n                              <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Automatic client plan tracking &amp; renewals</h4>\n                            </div>\n                          </md-list-item>\n                          <md-list-item class=\"md-3-line md-long-text\">\n\n                            <div class=\"md-list-item-text\">\n                              <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Crash-proof multi-timer</h4>\n                            </div>\n                          </md-list-item>\n                          <md-list-item class=\"md-3-line md-long-text\">\n\n                            <div class=\"md-list-item-text\">\n                              <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> 3-click Invoicing and Payment tracking</h4>\n                            </div>\n                          </md-list-item>\n                          <md-list-item class=\"md-3-line md-long-text\">\n\n                            <div class=\"md-list-item-text\">\n                              <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Tasks with budgets, attachments and <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unlimited subtasks.</h4>\n                            </div>\n                          </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Recurring tasks &amp; procedures</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Personal Reminders</h4>\n                           </div>\n                         </md-list-item>\n\n\n                        </md-list>\n\n                        <md-list flex=\"50\" class=\"plan-details\">\n                            <md-list-item class=\"md-3-line md-long-text\">\n\n                              <div class=\"md-list-item-text\">\n                                <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Weekly Client Status Reports</h4>\n                              </div>\n                            </md-list-item>\n                            <md-list-item class=\"md-3-line md-long-text\">\n\n                              <div class=\"md-list-item-text\">\n                                <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Daily/Weekly Personal Status Reports</h4>\n                              </div>\n                            </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Sales Lead tracking</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Custom Forms</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Client Access</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Dedicated Workspace Inboxes</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Google Chrome Extension</h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> 3rd party integrations via <a href=\"https://www.zapier.com\" target=\"_blank\">Zapier</a></h4>\n                           </div>\n                         </md-list-item>\n                         <md-list-item class=\"md-3-line md-long-text\">\n                           <div class=\"md-list-item-text\">\n                             <h4><md-icon md-font-icon=\"zmdi zmdi-close\" style=\"color: red!important;\"></md-icon> Team manager</h4>\n                           </div>\n                         </md-list-item>\n                        </md-list>\n                    </div>\n\n                </div>\n                <md-button\n                    md-colors=\"{background: \'green-500\'}\"\n                    style=\"height: 60px; font-size: 1em; color: #fff!important; margin-top: 2em!important;\"\n                    ng-click=\"vm.selectPlan(\'solo-2020\')\"\n                    class=\"md-raised margin-0\">Start a Solo Trial</md-button>\n            </md-card>\n            <md-card class=\"md-whiteframe-12dp plan-card secondary\">\n                <div class=\"details\" layout=\"column\" layout-align=\"start layout-fill\">\n                    <h2 class=\"plan-name\">Team</h2>\n                    <div class=\"divider\"></div>\n                    <h3 class=\"plan-price\">$10<small>/mo per member</small></h3>\n                    <p class=\"center margin-0\" style=\"font-size: .85em;\">(5 member minimum)</p>\n                    <md-list class=\"plan-details\">\n                      <md-list-item class=\"md-3-line md-long-text\">\n\n                        <div class=\"md-list-item-text\">\n                          <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Everything available in the <strong>Solo</strong> plan</h4>\n                        </div>\n                      </md-list-item>\n                      <md-list-item class=\"md-3-line md-long-text\">\n                        <div class=\"md-list-item-text\">\n                          <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> <strong>Team manager</strong></h4>\n                        </div>\n                      </md-list-item>\n                      <md-list-item class=\"md-3-line md-long-text\">\n                        <div class=\"md-list-item-text\">\n                          <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> <strong>Payroll Reports</strong></h4>\n                        </div>\n                      </md-list-item>\n                      <md-list-item class=\"md-3-line md-long-text\">\n                        <div class=\"md-list-item-text\">\n                          <h4><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> <strong>Priority Support</strong></h4>\n                        </div>\n                      </md-list-item>\n                    </md-list>\n\n                </div>\n                    <md-button\n                    md-colors=\"{background: \'green-900\'}\"\n                    style=\"height: 60px; font-size: 1em; margin-top: 2em!important;\"\n                    ng-click=\"vm.selectPlan(\'team-2020\')\"\n                    class=\"md-raised margin-0\">Start a Team Trial</md-button>\n\n            </md-card>\n        </div>\n        <p class=\"text-center white margin-top-40\">All prices shown in USD</p>\n        <div flex layout=\"column\" class=\"faqs\" layout-align=\"start layout-fill\">\n            <h3  class=\"center\" style=\"color: #fff; padding-bottom: 1em; margin-bottom:0;\">Frequently Asked Questions</h3>\n            <div class=\"divider\" style=\" margin-bottom: 2em; background-color: #fff; height: 1px; width: 300px;\"></div>\n            <div layout-gt-sm=\"row\" layout-align-gt-sm=\"layout-fill start\" layout=\"column\" layout-align=\"start center\">\n                <div flex=\"50\" layout=\"column\" layout-align=\"start start\" style=\"padding: 1em 2em 1em 1em;\">\n                    <dl>\n                        <dt>Is a credit card required?</dt>\n                        <dd>A credit card is required to start a 30 Day Trial. If you cancel before the end of your trial you will not be charged.</dd>\n                        <dt>Are Workspaces just for Clients?</dt>\n                        <dd>\n                            No. You can create personal Workspaces to manage your own projects or departments. Internal Workspaces do not include a Billing module.\n                        </dd>\n                        <dt>When do I pay?</dt>\n                        <dd>You\'ll receive email notifications near the end of your 30 Day trial to let you know that your trial is about to expire and the amount that is about to be charged.</dd>\n                        <dt>What happens if I don\'t pay?</dt>\n                        <dd>If your trial ends without a valid payment method, your account will be closed and you will lose access to your workspaces. You can restore your data and gain access to all of Adminja\'s features again by logging in and selecting a plan to reactivate within 30 days.</dd>\n                        <dt>What if I pay but then want to change plans?</dt>\n                        <dd>You can change plans at any time by visiting the \"My Account\" page and selecting the \"Subscription\" tab. You can change plans in the middle of your billing cycle and any changes will be pro-rated.</dd>\n                    </dl>\n                </div>\n                <div flex=\"50\" layout=\"column\" layout-align=\"start start\" style=\"padding: 1em 2em 1em 1em;\">\n                    <dl>\n                        <dt>What if I need more time in my trial?</dt>\n                        <dd>Need more than 30 Days? Just let us know! We\'ll be more than happy to accommodate most reasonable requests.</dd>\n                        <dt>What if my team size changes in the future?</dt>\n                        <dd>You can adjust your team member limit by visiting the \"My Account\" page and selecting the \"Subscription\" tab. Changes made to your team member limits are immediate and will result in pro-rated credits and/or pro-rated charges applied to your next billing cycle.</dd>\n                        <dt>What about security?</dt>\n                        <dd>Adminja runs on 256-bit SSL security in transit and your data is encrypted at rest using rotating keys to restrict access and ensure privacy. Adminja is hosted securely on the Google Cloud Platform and includes GDPR compliance through both Google Cloud\'s infrastructure and our own security policies and facilities. <a href=\"https://cloud.google.com/security/\" target=\"_blank\">Learn more Google Cloud security.</a> <a href=\"https://cloud.google.com/security/gdpr\" target=\"_blank\">Learn more about GDPR compliance.</a> You may revoke consent or request a copy of your data at any time. </dd>\n                        <dt>How do I cancel?</dt>\n                        <dd>You can cancel your plan at any time by visiting the Subscription tab in \"My Account\".  Cancellations will be executed at the end of your current billing period.</dd>\n                    </dl>\n                </div>\n            </div>\n            <p class=\"center\"><strong>Other Questions?</strong> Just send an email to <a href=\"mailto:help@getadminja.com\">help@getadminja.com.</a></p>\n\n        </div>\n    </div>\n\n    <!-- If trying to register from mobile device -->\n    <div ng-if=\"vm.showRegistrationForm\" layout=\"column\" layout-align=\"center center\" hide-gt-sm=\"true\">\n        <md-card class=\"md-whiteframe-12dp\">\n            <div layout=\"column\" layout-align=\"start center\" style=\"background-color: #0091ea; padding: 2em;\">\n                <div flex  class=\"text-center\" style=\"\" layout=\"column\" layout-align=\"start center\">\n                      <h2 style=\"color: #fff;\" class=\"center\">We\'re Sorry,</h2>\n                      <p class=\"md-subhead center\" style=\"color: #fff; margin-bottom: 2em;\">You need to be using a Tablet in landscape mode, or a Computer with your browser maximized to sign up for Adminja.</p>\n                      <md-button ng-if=\"!vm.isInvitationValid\" ng-click=\"vm.showRegistrationForm = false; vm.planID = undefined;\" style=\"color: #fff;\"><md-icon md-font-icon=\"fa fa-angle-left\" style=\"color: #fff;\"></md-icon>Return to Plans</md-button>\n                      <img src=\"/assets/images/brand/adminja-hlogo-white-white.svg\" width=\"100\" style=\"margin-top: 2em;\">\n                </div>\n            </div>\n        </md-card>\n    </div>\n    <!-- registration form -->\n    <div ng-if=\"vm.showRegistrationForm\" class=\"show-gt-sm hide-sm hide-xs\" flex=\"100\" flex-md=\"60\" flex-gt-md=\"40\" style=\"max-width: 600px;\">\n        <p class=\"text-center\"><a style=\"margin-left: auto; margin-right: auto;\" class=\"home-link\" href=\"https://www.getadminja.com/\"><img ng-src=\"assets/images/brand/adminja-hlogo-white.svg\" width=\"200\"></a></p>\n        <div ng-if=\"vm.loading\" layout=\"column\" layout-align=\"start center\" class=\"greybox\">\n                <h1 class=\"center white\">Getting subscription plan information...</h1>\n                <div class=\"adminja-loader\"></div>\n        </div>\n        <div ng-if=\"vm.showInvalidInviteWarning\" class=\"greybox\">\n            <h3 class=\"center white\">The invitation you are trying to accept is invalid. <br>Please contact your team leader and ask them to re-issue your invitation.</h3>\n        </div>\n        <div ng-if=\"!vm.showInvalidInviteWarning && !vm.loading\" class=\"greybox\">\n            <h3 class=\"text-center white\" ng-if=\"!vm.isInvitationValid && vm.planID && vm.planID != \'starter-2018c\' && vm.planID != \'ava-pro-2019\' && vm.planID != \'ava-pro-2022\' && vm.planID != \'vavs18-pro\' && vm.chargebeePlan.period_unit == \'month\'\">Start your  <strong>{{vm.chargebeePlan.name}}</strong> Trial <br> it\'s free for {{vm.chargebeePlan.trial_period}} {{vm.chargebeePlan.trial_period_unit}}s!<Br><span style=\"font-size: .85em;\">After that, only ${{vm.total(vm.chargebeePlan.price/100, vm.addonCosts(vm.totalUsers - vm.currentPlan.team))}}/month</span></h3>\n            <h3 class=\"text-center white\" ng-if=\"!vm.isInvitationValid && vm.planID && vm.planID != \'starter-2018c\' && vm.planID != \'ava-pro-2019\' && vm.planID != \'ava-pro-2022\' && vm.planID != \'vavs18-pro\' && vm.chargebeePlan.period_unit == \'year\'\">Start your  <strong>{{vm.chargebeePlan.name}}</strong> Trial <br> it\'s free for {{vm.chargebeePlan.trial_period}} {{vm.chargebeePlan.trial_period_unit}}s!<Br><span style=\"font-size: .85em;\">After that, only ${{vm.total(vm.chargebeePlan.price/100, vm.addonCosts(vm.totalUsers - vm.currentPlan.team))}}/year</span></h3>\n            <h3 class=\"text-center white\" ng-if=\"!vm.isInvitationValid && !vm.planID || vm.planID == \'starter-2018c\' && !vm.isInvitationValid\">Open a Free Starter account</h3>\n            <h3 class=\"text-center white\" ng-if=\"vm.planID && (vm.planID == \'ava-pro-2019\')\">Start your exclusive AVA Member Trial <br> It\'s free for 90 days!</h3>\n            <h3 class=\"text-center white\" ng-if=\"vm.planID && (vm.planID == \'ava-pro-2022\')\">Start your exclusive AVA Member Trial <br> It\'s free for 90 days!</h3>\n            <h3 class=\"text-center white\" ng-if=\"vm.planID && vm.planID == \'vavs18-pro\'\">Start your exclusive VANetworking Member Trial <br> It\'s free for 60 days!</h3>\n            <h3 ng-if=\"vm.isInvitationValid && vm.planID != \'client-access\'\" class=\"text-center white\">Accept Team invite from {{vm.invitation.ownerName}}</h3>\n            <h3 ng-if=\"vm.isInvitationValid && vm.planID == \'client-access\'\" class=\"text-center white\">Accept Workspace invitation from {{vm.invitation.ownerName}}</h3>\n            <p ng-if=\"vm.planID != \'client-access\' && !vm.inviteID\" class=\"md-subhead text-center white\">You\'ve selected a {{vm.chargebeePlan.description}}</p>\n        </div>\n        <md-card class=\"md-whiteframe-12dp\" style=\"margin-top:0; margin-bottom:0;\">\n            <md-content style=\"margin-top: 0em; margin-bottom: 0em;\" ng-if=\"!vm.loading\">\n                <div layout=\"row\" ng-if=\"!vm.showInvalidInviteWarning\">\n                    <div layout=\"column\" flex=\"100\">\n                                        <div layout=\"column\" class=\"md-padding\"  style=\"padding: 1em;\" layout-align=\"start center\">\n                        <!-- Begin Form -->\n                                            <form id=\"subscribe-form\" name=\"vm.forms.registration\" flex=\"100\" style=\"width: 100%;\">\n                                                <div layout=\'column\' layout-gt-xs=\'row\' >\n                                                    <md-input-container flex-gt-xs=\"50\" class=\"md-block\" style=\"margin-bottom:-1em;\">\n                                                        <label>First name</label>\n                                                        <input name=\"firstname\" id=\"firstname\" ng-model=\"vm.user.firstname\" required>\n                                                        <div ng-messages=\"vm.user.firstname.$error\">\n                                                              <div ng-message=\"required\">Oops! Your name is required</div>\n                                                        </div>\n                                                    </md-input-container>\n\n                                                    <md-input-container flex-gt-xs=\"50\" class=\"md-block\" style=\"margin-bottom:-1em;\">\n                                                        <label>Last name</label>\n                                                        <input name=\"lastname\" ng-model=\"vm.user.lastname\" required>\n                                                        <div ng-messages=\"vm.user.lastname.$error\">\n                                                              <div ng-message=\"required\">Oops! Your name is required</div>\n                                                        </div>\n                                                    </md-input-container>\n                                                </div>\n                                                <div layout=\"column\">\n                                                  <md-input-container flex-gt-xs=\"50\" class=\"md-block\" style=\"margin-bottom:-1em;\">\n                                                      <label>Company</label>\n                                                      <input name=\"company\" id=\"company\" ng-model=\"vm.user.company\">\n                                                  </md-input-container>\n                                                </div>\n                                                <div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.isInvitationValid\" style=\"padding-top: 1em;\">\n                                                    <md-icon flex=\"nogrow\" ng-if=\"vm.emailOK == true\" md-font-icon=\"zmdi zmdi-check-circle\" style=\"color: green; position: relative; top: -12px;\" ></md-icon>\n                                                    <md-icon flex=\"nogrow\" ng-if=\"vm.emailOK == false\" md-font-icon=\"zmdi zmdi-close-circle\" style=\"color: red; position: relative; top: -17px;\" ></md-icon>\n                                                    <md-input-container flex=\"grow\" ng-if=\"!vm.isInvitationValid\" class=\"md-block\">\n                                                        <label for=\"email\" translate>Email</label>\n                                                        <!-- ng-pattern=\"/^[^[\\]:;|=*?<>/\\\\,]+$/\" -->\n                                                        <input  id=\"email\"  md-no-asterisk label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" ng-blur=\"vm.checkEmail(vm.user.email)\" ng-change=\"vm.user.email=vm.user.email.toLowerCase();\" required/>\n\n                                                        <div  ng-if=\"vm.emailOK == false\" style=\"\">\n                                                            <p class=\"center\" style=\"color: red;\">That email address is already taken.</p>\n                                                        </div>\n                                                    </md-input-container>\n                                                </div>\n                                                <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.isInvitationValid\" style=\"padding-top: 1em;\">\n                                                    <md-input-container flex=\"grow\" class=\"md-block\">\n                                                        <label for=\"email\" translate>Email</label>\n                                                            <input ng-disabled=\"true\" type=\"email\" id=\"email\"  name=\"email\" ng-model=\"vm.user.email\"/>\n                                                    </md-input-container>\n                                                </div>\n                                                <md-input-container flex>\n                                                    <label translate>Password</label>\n                                                    <input ng-change=\"vm.checkStrength(vm.user.password)\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" minlength=\"6\" required>\n\n                                                    <div ng-messages=\"accountForm.password.$error\" md-auto-hide=\"false\" ng-show=\"accountForm.password.$touched\">\n                                                        <div ng-message when=\"required\">\n                                                            <span translate>This field is required. Minimum 7 characters.</span>\n                                                        </div>\n                                                    </div>\n                                                </md-input-container>\n\n\n\n\n                                                <div ng-if=\"vm.planID == \'team-2020\'\" >\n                                                    <div layout=\"column\" layout-gt-xs=\"row\" style=\"padding-bottom: 1em;\">\n\n\n                                                        <div flex=\"100\" layout=\"row\" layout-align=\"center center\" class=\"useradjust\">\n                                                            <h3>Team Members Included: </h3>\n                                                            <md-button class=\"md-icon-button\" ng-click=\"vm.adjustUsers(-1)\">\n                                                                <md-icon md-font-icon=\"zmdi zmdi-minus-circle-outline\"></md-icon>\n                                                                <md-tooltip md-delay=\"500\">Decrease</md-tooltip>\n                                                            </md-button>\n                                                            <h3 class=\"usercount\" style=\"font-size: 1.25em;\">{{vm.totalUsers}}</h3>\n                                                            <md-button class=\"md-icon-button\" ng-click=\"vm.adjustUsers(1)\">\n                                                                <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n                                                                <md-tooltip md-delay=\"500\">Increase</md-tooltip>\n                                                            </md-button>\n                                                            <h3>\n                                                                &nbsp;=&nbsp;&nbsp;&nbsp;${{vm.total(vm.chargebeePlan.price/100, vm.addonCosts(vm.totalUsers - vm.currentPlan.team))}}/mo\n                                                            </h3>\n\n                                                        </div>\n                                                    </div>\n                                                    <p class=\"text-center margin-top-0 margin-bottom-50 md-subhead\" style=\"color: #999; font-size: 12px;\">You can adjust your team member limit at any time.</p>\n                                                </div>\n                                                <div ng-if=\"!vm.isInvitationValid\"  layout=\"column\">\n                                                    <div  flex layout=\"row\" layout-align=\"start center\" ng-if=\"vm.planID != \'ava-pro-2022\'\">\n                                                        <md-icon flex=\"nogrow\" ng-if=\"vm.couponOK == true\" md-font-icon=\"zmdi zmdi-check-circle\" style=\"color: green; position: relative; top: -12px;\" ></md-icon>\n                                                        <md-icon flex=\"nogrow\" ng-if=\"vm.couponOK == false && vm.coupon\" md-font-icon=\"zmdi zmdi-close-circle\" style=\"color: red; position: relative; top: -17px;\" ></md-icon>\n                                                        <md-input-container flex style=\"\" >\n                                                            <label translate>Do you have a coupon?</label>\n                                                            <input name=\"coupon\" ng-blur=\"vm.checkCoupon(vm.coupon)\" ng-model=\"vm.coupon\"  placeholder=\"Enter Coupon Code\">\n                                                            <div  ng-if=\"vm.couponOK == false && vm.coupon\" style=\"\">\n                                                                <p class=\"center\" style=\"color: red;\">That Coupon Code is invalid or has already expired.</p>\n                                                            </div>\n                                                            <div ng-if=\"vm.coupon && vm.couponOK\">\n                                                                <p class=\"center md-subhead margin-top-10\">This coupon will be applied to your plan during checkout.</p>\n                                                            </div>\n                                                        </md-input-container>\n                                                    </div>\n                                                    <md-input-container flex  >\n                                                        <label translate>How\'d you hear about Adminja?</label>\n                                                        <input name=\"howHeard\" ng-model=\"vm.user.source\" minlength=\"6\" required>\n                                                    </md-input-container>\n\n                                                </div>\n                                                <input ng-if=\"vm.isInvitationValid\" type=\"hidden\" ng-model=\"vm.user.source\">\n\n                                                <div ng-if=\"!vm.loading\">\n                                                    <div layout=\"row\" layout-align=\"center center\" style=\"padding-bottom: 2em;\" ng-if=\"vm.planID && vm.planID != \'starter-2018c\' && vm.planID != \'client-access\'\">\n                                                        <md-button flex style=\"font-size: 1em; padding: .25em 2em .25em 2em;\" class=\"md-raised md-accent\" ng-disabled=\"vm.forms.registration.$invalid || vm.processing\" ng-click=\"vm.openCheckout()\" aria-label=\"Enter Payment Info\">Enter Payment Info<md-icon md-font-icon=\"fa fa-angle-double-right\"></md-icon></md-button>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"end center\" style=\"padding-bottom: 2em;\" ng-if=\"!vm.planID || vm.planID == \'starter-2018c\'\">\n                                                        <md-button flex style=\"font-size: 1em; padding: .25em 2em .25em 2em;\" class=\"md-raised md-accent\" ng-disabled=\"vm.forms.registration.$invalid || vm.processing\" ng-click=\"vm.openCheckout()\" ng-disabled=\"login.$invalid\" aria-label=\"Sign Up!\">Next <md-icon md-font-icon=\"fa fa-angle-double-right\"></md-icon></md-button>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"end center\" style=\"padding-bottom: 2em;\" ng-if=\"vm.planID == \'client-access\'\">\n                                                        <md-button flex style=\"font-size: 1em; padding: .25em 2em .25em 2em;\" class=\"md-raised md-accent\" ng-disabled=\"vm.forms.registration.$invalid || vm.processing\" ng-click=\"vm.registerClientUser(vm.user)\" ng-disabled=\"login.$invalid\" aria-label=\"Sign Up!\">Accept Invitation</md-button>\n                                                    </div>\n                                                </div>\n                                            </form>\n                        <!-- End Form -->\n\n                                    </div>\n                    </div>\n                   <!--  <div ng-if=\"!vm.isInvitationValid\" layout=\"column\" flex=\"auto\" hide-xs hide-sm style=\"background-color: #2c3a5f;\" class=\"md-padding\">\n                        <h3 style=\"color: #fff; font-weight: bold; font-size: 17px; text-align: center;\">Why are so many Virtual Assistants <br>switching to Adminja?</h3>\n                        <ul class=\"check-bullets\">\n                            <li>They are saving time with their Client information, Tasks, Time and Billing safe and secure under <b>ONE LOGIN</b>.</li>\n                            <li>Many aspects of their businesses run on Auto-pilot with Adminja\'s <b>Recurring Tasks</b>.</li>\n                            <li>Real-time <b>Client Summaries</b> keep them on top of things at all times.</li>\n                            <li>Auto-renewing <b>Client Retainers</b> make their retainer and invoice management a cinch.</li>\n                            <li>Adminja\'s <b>Help Desk</b> is responsive to their issues and implements many of their feature requests.</li>\n                        </ul>\n\n                    </div> -->\n                </div>\n\n            </md-content>\n\n\n\n        </md-card>\n        <div layout=\"row\" class=\"greybox\" ng-if=\"!vm.loading && !vm.showInvalidInviteWarning\">\n             <div flex>\n                 <md-button ng-if=\"!vm.isInvitationValid\" ng-click=\"vm.showRegistrationForm = false; vm.planID = undefined;\" style=\"color: #fff;\"><md-icon md-font-icon=\"fa fa-angle-left\" style=\"color: #fff;\"></md-icon>Choose a different plan</md-button>\n             </div>\n             <div flex layout=\"row\" layout-align=\"end center\">\n                 <md-button ng-if=\"!vm.isInvitationValid\" ui-sref=\"authentication.login\" style=\"color: #fff;\">Already have an account? Login <md-icon md-font-icon=\"fa fa-angle-right\" style=\"color: #fff;\"></md-icon></md-button>\n             </div>\n        </div>\n    </div>\n\n</div>\n\n\n");
$templateCache.put("app/app-directives/billing-period/billing-period-card.tmpl.html","<md-card ng-click=\"vm.selectPeriod(vm.period)\" ng-class=\"{\'active\': vm.isSelected(), \'md-whiteframe-20dp\' : vm.isSelected()}\" class=\"billing-period-card\" ng-style=\"vm.isSelected() && {\'border-top\':\'8px solid {{vm.clientColor()}}\'} || {\'border-top\': \'8px solid #bcbcbc\'}\"  style=\"\">\n    <div layout=\"row\">\n        <div class=\"card-controls\" flex=\"nogrow\" style=\"padding-right:0;\">\n            <md-menu md-position-mode=\"target-right target\">\n                <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n                <md-menu-content class=\"md-dense\">\n\n                    <md-menu-item>\n                        <md-button aria-label=\"Delete\" ng-click=\"vm.recalcPeriod(vm.period)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> Recalculate\n                        </md-button>\n                    </md-menu-item>\n\n                    <md-menu-item ng-if=\"!vm.period.overageDeductedFrom && vm.index != 0 && vm.used() > (vm.period.allocated * 60)\">\n                        <md-button  aria-label=\"Deduct Overage\" ng-click=\"vm.deductOverage(vm.period)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-minus-circle\"></md-icon> Deduct Overage from current billing period.\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"!vm.period.remainingRolledOver && vm.index == 1 && vm.used() < (vm.period.allocated * 60)\">\n                        <md-button  aria-label=\"Deduct Overage\" ng-click=\"vm.rolloverUnused(vm.period)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon> Rollover unused hours to next billing period.\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.period.overageDeductedFrom\">\n                        <md-button  aria-label=\"Delete period\" ng-disabled=\"true\">\n                            <md-icon md-font-icon=\"zmdi zmdi-minus-circle\"></md-icon> Overage has already been deducted from a future period.\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.period.remainingRolledOver\">\n                        <md-button  aria-label=\"Delete period\" ng-disabled=\"true\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon> Unused hours have already been rolled over to next period.\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"(vm.client.billingType == \'periods\' && (vm.index == 0 && !vm.period.total && !vm.period.received)) || vm.userType == \'admin\'\">\n                        <md-button  aria-label=\"Delete period\" ng-click=\"vm.deletePeriod(vm.period)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete Billing Period\n                        </md-button>\n                    </md-menu-item>\n                    <!-- admin-only functions -->\n                    <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                        <md-button aria-label=\"X-ray\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}billingPeriods/{{vm.period.uid}}\">\n                            <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                        <md-button aria-label=\"View fanned data\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}clients/{{vm.period.client}}/billing/{{vm.period.uid}}\">\n                            <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray Fanned\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.userType == \'admin\' && vm.client.billingType == \'periods\'\">\n                        <md-button aria-label=\"Make current\" ng-click=\"vm.setCurrentPeriod(vm.period.uid)\">\n                             Make this the \"Current Period\"\n                        </md-button>\n                    </md-menu-item>\n                    <!-- <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                        <md-button aria-label=\"Make current\" ng-click=\"vm.fixEndDate(vm.period)\">\n                             Fix End Date\n                        </md-button>\n                    </md-menu-item>-->\n                    <md-menu-item>\n                        <md-button ng-disabled=\"true\" >\n                            Start: {{vm.period.start | amDateFormat: vm.settings.longDateFormat}} at {{vm.period.start | amDateFormat: vm.settings.time}}\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.period.recurrenceType != \'zero\' || !vm.isCurrentPeriod(vm.client, vm.period)\">\n                        <md-button ng-disabled=\"true\">\n                            End: {{vm.period.end | amDateFormat: vm.settings.longDateFormat}} at {{vm.period.end | amDateFormat: vm.settings.time}}\n                        </md-button>\n                    </md-menu-item>\n                    <!-- <md-menu-item>\n                        <md-button ng-click=\"vm.setupAsPackage(vm.period)\">\n                            Convert Client to New Package-Based Billing\n                        </md-button>\n                    </md-menu-item> -->\n                </md-menu-content>\n            </md-menu>\n        </div>\n        <div flex=\"70\" layout=\"column\">\n            <p class=\"md-title\" style=\"margin-bottom: 0; margin-top: 6px;\">\n                {{vm.period.start | amDateFormat:\'MMMM YYYY\'}}<br>\n            </p>\n\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: .85em;\">\n                {{vm.period.start | amDateFormat: vm.settings.shortYearFormat}}\n                <span ng-if=\"vm.period.recurrenceType != \'zero\' || !vm.isCurrentPeriod(vm.client, vm.period)\"> - {{vm.period.end | amDateFormat: vm.settings.shortYearFormat}}</span>\n                <span ng-if=\"vm.period.recurrenceType == \'zero\' && vm.isCurrentPeriod(vm.client, vm.period)\"> - Pending</span>\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                <span ng-if=\"vm.period.recurrenceType == \'zero\' && vm.period.type == \'retainer\'\">Balance-based </span>\n                <span ng-if=\"vm.period.recurrenceType != \'zero\' && vm.period.type == \'retainer\'\">Date-based </span>\n                    {{vm.period.type}}\n            </p>\n        </div>\n        <div flex=\"30\" layout-align=\"start end\">\n            <p class=\"md-subhead\" style=\"margin-bottom: 0; font-size: 10px;\">\n                Invoiced\n            </p>\n            <p class=\"md-title cost\" style=\"margin-top:0;\"><span ng-bind-html=\"vm.currency\"></span>{{vm.period.total || 0 | number: 2 }}</p>\n\n        </div>\n\n    </div>\n    <div layout=\"row\">\n        <div flex=\"50\">\n            <p class=\"md-subhead\" style=\"font-size: 12px;\"  ng-if=\"vm.period.type ==\'hourly\'\">\n                <strong>Logged:</strong> {{vm.used() | userTimeFormat}}<br>\n                <!-- <strong>Rate:</strong> <span ng-bind-html=\"vm.currency\"></span>{{vm.period.rate | number: 2}}<br> -->\n                <strong>Earned:</strong> <span ng-bind-html=\"vm.currency\"></span>{{vm.earned(vm.period)}}\n            </p>\n            <p class=\"md-subhead\" style=\"font-size: 12px;\" ng-if=\"vm.period.type ==\'retainer\'\">\n                <strong>Logged:</strong> <span class=\"{{vm.retainerStatusClass()}}\">{{vm.used()|userTimeFormat}}</span> <md-icon style=\"font-size: 12px; color: green;\" ng-if=\"vm.period.overageDeductedFrom || vm.period.remainingRolledOver\" md-font-icon=\"zmdi zmdi-check\"></md-icon><br>\n                <strong>Allocated:</strong> {{vm.period.allocated * 60 |userTimeFormat}}\n            </p>\n\n        </div>\n        <div flex=\"50\" layout=\"column\" layout-align=\"start end\">\n            <p class=\"md-subhead\" style=\"font-size: 12px;\">\n<!--                 <strong>Invoiced:</strong> <span ng-bind-html=\"vm.currency\"></span>{{vm.period.total || 0  | number: 2}}<br>\n -->                <strong>Payments:</strong> <span ng-bind-html=\"vm.currency\"></span>{{vm.period.received || 0  | number: 2}}<br>\n                <strong>Balance:</strong> <span ng-bind-html=\"vm.currency\"></span>{{vm.period.open || 0 | number: 2}}\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/avatar/avatar.tmpl.html","<div class=\"avatar-container\">\n\n	<img ng-if=\"!vm.uploading && !vm.upload && vm.border\" class=\"avatar\"  src=\"{{vm.thumbnail}}\"  style=\"border: 2px solid {{vm.border}}; background-color: {{vm.workspaceColor}};\">\n	<img ng-if=\"!vm.uploading && !vm.upload && !vm.border\" class=\"avatar\"  src=\"{{vm.thumbnail}}\" style=\"background-color: {{vm.workspaceColor}};\">\n	<img ng-if=\"!vm.uploading && vm.upload\" ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\" aria-label=\"upload\" class=\"avatar avatar-upload\"  src=\"{{vm.thumbnail}}\" style=\"background-color: {{vm.workspaceColor}};\" >\n	<img ng-if=\"vm.uploading\" src=\"/assets/images/elements/Spinner-1s-200px.gif\" width=\"80\" style=\"background-color: {{vm.workspaceColor}};\">\n	 <div ng-if=\"vm.upload\" layout=\"row\" layout-align=\"center center\">\n	 	<md-button class=\"md-icon-button\" ngf-select=\"vm.uploadAvatar($files)\" ngf-multiple=\"false\">\n	 		<md-icon md-font-icon=\"zmdi zmdi-cloud-upload\" style=\"color: {{vm.iconColor}};\">\n	 			<md-tooltip md-delay=\"500\">\n	 				    Upload Replacement\n	 				</md-tooltip>\n	 		</md-icon>\n	 	</md-button>\n	      <md-menu class=\"avatar-select-menu\" md-position-mode=\"target-right target\">\n	         <md-button class=\"md-icon-button\" ng-Click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"zmdi zmdi-accounts-list-alt\" style=\"color:{{vm.iconColor}};\"></md-icon> <md-tooltip md-delay=\"500\">Choose from Library</md-tooltip></md-button>\n	         <md-menu-content style=\"min-width: 200px; width: 200px; max-width: 200px;\">\n	             <md-menu-item ng-repeat=\"item in vm.avatars track by $index\" ng-click=\"vm.setAvatar(item.image)\" style=\"min-height: 60px!important; max-height: 60px!important; height: 60px!important; border-bottom: 1px solid #bbb; cursor: pointer;\" layout=\"row\" layout-align=\"start center\">\n	                <div style=\"background-color: {{vm.workspaceColor}}; border-radius: 25px; width: 50px; height: 50px; margin-right: 1em; margin-left: 1em; padding-left: 5px; padding-top: 5px;\">\n	                	<img src=\"{{item.image}}\" style=\"height: 40px; min-width: 40px!important; width:40px!important; max-width: 40px!important;\"/>\n	                </div>\n	                {{item.label}}\n	             </md-menu-item>\n	             <md-menu-item ng-repeat=\"item in vm.icons track by $index\" ng-click=\"vm.setAvatar(item.image)\" style=\"min-height: 60px!important; max-height: 60px!important; height: 60px!important; border-bottom: 1px solid #bbb; cursor: pointer;\" layout=\"row\" layout-align=\"start center\">\n	             	<div style=\"background-color: {{vm.workspaceColor}}; border-radius: 25px; width: 50px; height: 50px; margin-right: 1em; margin-left: 1em; padding-left: 5px; padding-top: 5px;\">\n		                <img src=\"{{item.image}}\" style=\"height: 40px; min-width: 40px!important; width:40px!important; max-width: 40px!important;\"/>\n	               </div>\n	                {{item.label}}\n	             </md-menu-item>\n	         </md-menu-content>\n	         </md-button>\n	     </md-menu>\n	</div>\n</div>\n");
$templateCache.put("app/app-directives/client-access-manager/client-access-manager.tmpl.html","\n		<div class=\"client-access-manager\" layout=\"row\" layout-align=\"center start\">\n			<div flex=\"100\" layout=\"column\" layout-align=\"start layout-fill\" style=\"max-width: 800px; \">\n\n				<div ng-if=\"vm.clientUserLimit > vm.clientUserCount\">\n					<ng-form name=\"vm.clientAccessUserForm\" isolate-form >\n						<h3 style=\"color: #888; font-size: 1em;\">Invite Client Users</h3>\n						<div style=\"border-radius: 8px; padding: 2em; background-color: #efefef;\">\n							<div layout=\"row\" layout-align=\"start center\" >\n								<div flex=\"grow\" style=\"max-width: 400px;\">\n									<md-input-container>\n										<label>Email</label>\n										<input required type=\"email\" ng-model=\"vm.newUser.email\">\n									</md-input-container>\n								</div>\n								<div flex=\"nogrow\" style=\"padding-left: 2em;\">\n									<md-button data-gtm-invite-client ng-disabled=\"vm.clientAccessUserForm.$pristine || vm.clientAccessUserForm.$invalid\" ng-click=\"vm.inviteClientUser(vm.client, vm.newUser)\" class=\"md-raised md-accent\">Send Invitation</md-button>\n								</div>\n							</div>\n							<div ng-if=\"vm.alertMessage\"><p style=\"color: red;\">{{vm.alertMessage}}</p></div>\n						</div>\n					</ng-form>\n				</div>\n				<h3 style=\"color: #888; font-size: 1em; margin-top: 2em;\">Invited Users ({{vm.clientUserCount}} of {{vm.clientUserLimit}})</h3>\n				<div class=\"small-scrollbar\" style=\"height: 100px; max-height: 100px;\">\n\n					<div layout=\"row\" layout-align=\"start center\" ng-repeat=\"clientUser in vm.client.clientUsers track by $index\">\n						<div flex style=\"max-width: 400px;\">\n							{{clientUser.email}}\n						</div>\n						<div flex style=\"max-width: 100px;\">\n							<span style=\"font-size: .85em;\" ng-class=\"{\'error\': clientUser.status == \'declined\' || clientUser.status == \'suspended\', \'warn\': clientUser.status == \'pending\', \'success\': clientUser.status == \'active\'}\">{{clientUser.status}}</span>\n						</div>\n						<div flex=\"nogrow\">\n							<md-button ng-if=\"clientUser.status == \'suspended\'\" ng-click=\"vm.enableClientUser(vm.client, clientUser)\">Enable</md-button>\n							<md-button ng-if=\"clientUser.status == \'active\'\" ng-click=\"vm.suspendClientUser(vm.client, clientUser)\">Disable</md-button>\n\n							<md-button data-gtm-remove-client ng-click=\"vm.removeClientUser(vm.client, clientUser)\">Remove</md-button>\n						</div>\n					</div>\n				</div>\n\n				<ng-form name=\"vm.clientAccessPermissionsForm\" isolate-form >\n					<div layout=\"column\" layout-gt-sm=\"row\">\n						<!-- tasks and time -->\n						<div flex=\"100\" flex-gt-sm=\"50\">\n							<h3 style=\"color: #888; font-size: 1em; margin-top: 2em;\">Workspace Section Visibility</h3>\n							<md-input-container style=\"margin-top:0;\">\n								<md-checkbox ng-model=\"vm.showTasks\" ng-disabled=\"vm.showTasks\" aria-label=\"Show the tasks board\">Show the Tasks Board (required)</md-checkbox>\n							</md-input-container>\n							<md-input-container style=\"margin-top:0;\">\n								<md-checkbox ng-change=\"vm.updateAccess()\" ng-model=\"vm.client.clientUserTabs.details\" aria-label=\"Show the details board\">Show the Details Board</md-checkbox>\n							</md-input-container>\n							<md-input-container style=\"margin-top:0;\">\n								<md-checkbox ng-change=\"vm.updateAccess()\" ng-model=\"vm.client.clientUserTabs.time\" aria-label=\"Show the time board\">Show the Time Board</md-checkbox>\n							</md-input-container>\n							<md-input-container style=\"margin-top:0;\">\n								<md-checkbox ng-change=\"vm.updateAccess()\" ng-model=\"vm.client.clientUserTabs.billing\" aria-label=\"Show the billing board\">Show the Billing Board</md-checkbox>\n							</md-input-container>\n						</div>\n						<!-- details and billing -->\n						<div flex=\"100\" flex-gt-sm=\"50\">\n							<h3 style=\"color: #888; font-size: 1em; margin-top: 2em;\">List Visibility</h3>\n							<p class=\"md-subhead margin-bottom-0\" style=\"color: #888; font-size: 12px;\"><strong>Task Lists</strong></p>\n							<div class=\"small-scrollbar\" style=\"height: 100px; max-height: 100px; max-width: 200px; border: 1px solid #efefef; padding: 0 1em;\">\n								<md-input-container ng-repeat=\"list in vm.client.taskBoards[vm.client.defaultTaskBoard].lists\" style=\"margin-top:0;\">\n									<md-checkbox ng-change=\"vm.updateListAccess(\'tasks\', list.uid, list.clientEnabled)\" ng-model=\"list.clientEnabled\" aria-label=\"Enable client access\">{{list.label}}</md-checkbox>\n								</md-input-container>\n							</div>\n							<p class=\"md-subhead margin-bottom-0\" style=\"color: #888; font-size: 12px;\"><strong>Detail Lists</strong></p>\n							<div class=\"small-scrollbar\" style=\"height: 100px; max-height: 100px; max-width: 200px; border: 1px solid #efefef; padding: 0 1em;\">\n								<md-input-container  ng-repeat=\"list in vm.client.detailBoards[vm.client.defaultDetailBoard].lists\" style=\"margin-top:0;\">\n									<md-checkbox ng-change=\"vm.updateListAccess(\'details\', list.uid, list.clientEnabled)\" ng-disabled=\"!vm.client.clientUserTabs.details\" ng-model=\"list.clientEnabled\" aria-label=\"Enable client access\">{{list.label}}</md-checkbox>\n								</md-input-container>\n							</div>\n						</div>\n					</div>\n				</ng-form>\n			</div>\n		</div>\n");
$templateCache.put("app/app-directives/client-member-list-item/client-member-list-item.tmpl.html","<md-card ng-click=\"vm.selectTeamMember(vm.member)\" ng-class=\"{\'active\': vm.isMemberSelected(), \'md-whiteframe-20dp\' : vm.isMemberSelected()}\" class=\"team-member-card\" ng-style=\"vm.isMemberSelected() && {\'border-top\':\'8px solid {{vm.member.color}}\'} || {\'border-top\': \'8px solid #bcbcbc\'}\">\n    <div layout=\"row\">\n        <div flex=\"20\" layout=\"row\" layout-align=\"start start\">\n            <img src=\"{{vm.user.profile.avatar}}\" class=\"avatar\">\n        </div>\n        <div flex=\"80\" layout=\"column\">\n            <p class=\"md-headline\" style=\"margin-bottom: 0; margin-top: 8px;\">\n                {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n                <a href=\"mailto:{{vm.member.email}}\">{{vm.user.email}}</a>\n            </p>\n            <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Became a member on {{vm.becameMember}}\n            </p>\n            <p ng-if=\"vm.member.status == \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Invitated on {{vm.invited}}\n            </p>\n        </div>\n\n    </div>\n    <div layout=\"row\" layout-align=\"end center\">\n        <div flex=\"nogrow\">\n            <p class=\"md-subhead member-{{vm.member.status}}\" style=\"font-size: 12px;\">\n                {{vm.member.status}}\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/client-directives/client-card.tmpl.html","<md-card  class=\"client-card md-whiteframe-2dp drag-handle clicked-{{client.clicked}}\" flex=\"1\" uid=\"{{client.uid}}\" layout-align=\"start\" layout=\"column\" style=\"background-color: #fff; border-top: 16px solid {{client.profile.clientColor}}; width: 284px;\">\n   <div ng-if=\"client.demo == true\" style=\"position: absolute; top: -18px; left: 0; color: #fff;\">\n       <p class=\"md-subhead\" style=\"text-align: center; width: 100%; color: #fff; margin: 0 0 0 1em; font-size: 8px;\">Sample Workspace</p>\n   </div>\n    <md-menu class=\"client-controls\" md-position-mode=\"target-right target\">\n        <!-- Trigger element is a md-button with an icon -->\n        <md-button ng-Click=\"$mdMenu.open($event)\" class=\"md-icon-button\" style=\"position: relative; left: 5px;\">\n        <md-icon  aria-label=\"{{detail.type}} Options\" md-font-icon=\"zmdi zmdi-more-vert\">\n            <md-tooltip md-delay=\"1000\">Client Options</md-tooltip></md-icon>\n        </md-button>\n        <md-menu-content>\n            <md-menu-item>\n                <md-button ng-click=\"editClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-client\">\n                    </md-icon>Edit {{client.profile.fullName}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item  ng-if=\"user.type != \'client\'\">\n                <md-button ng-click=\"sendStatusReport(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"fa fa-paper-plane-o\" class=\"button-send-report\">\n                    </md-icon>Send Status Report\n                </md-button>\n            </md-menu-item>\n            <md-menu-item  ng-if=\"user.type != \'client\'\">\n                <md-button ng-click=\"viewClient(client)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-open-in-browser\" class=\"button-view-client\">\n                    </md-icon>Visit Workspace\n                </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"user.type != \'client\'\">\n                <md-button ng-disabled=\"!isTeamAdmin(client, userID)\" ng-click=\"cloneWorkspace(client.uid, userID, false)\" aria-label=\"Clone\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"fa fa-clone\" class=\"button-view-client\">\n                    </md-icon>Clone this Workspace\n                </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"user.type != \'client\'\">\n                <md-button ng-disabled=\"!isTeamAdmin(client, userID)\" ng-click=\"archiveClient(client, $event)\" aria-label=\"Archive\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"fa fa-archive\" class=\"button-view-client\">\n                    </md-icon>Archive this Workspace\n                </md-button>\n            </md-menu-item>\n            <!-- Enabled while testing non-admin accounts: Disable this and enable the last one before deploying -->\n          <!--   <md-menu-item>\n                <a class=\"md-button\" ng-href=\"{{fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                    X-ray\n                </a>\n            </md-menu-item> -->\n            <md-menu-item ng-if=\"userType == \'admin\' && client.billingType != \'packages\'\">\n\n                <a class=\"md-button\" ng-click=\"setupPackagesBilling(client)\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                  <md-icon md-font-icon=\"fa fa-credit-card\" class=\"button-view-client\"></md-icon>  Switch to Package Billing\n                </a>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userType == \'admin\' && client.billingType == \'packages\'\">\n                <a class=\"md-button\" ng-click=\"setupPeriodsBilling(client)\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                  <md-icon md-font-icon=\"fa fa-credit-card\" class=\"button-view-client\"></md-icon>  Switch to Periods Billing\n                </a>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userType == \'admin\'\">\n\n                <a class=\"md-button\" ng-href=\"{{fbConfig.dataURL}}clients/{{client.uid}}\" target=\"_blank\" aria-label=\"View\" md-no-ink=\"true\">\n                  <md-icon md-font-icon=\"zmdi zmdi-code\" class=\"button-view-client\"></md-icon>  X-ray\n                </a>\n            </md-menu-item>\n\n\n        </md-menu-content>\n    </md-menu>\n\n    <md-card-title ng-click=\"editClient(client)\" >\n\n        <md-card-title-text>\n            <!-- if we have fullName, then show it, otherwise, first and last. This lets us grandfather in existing clients without error -->\n            <span class=\"md-title\" ng-show=\"!client.profile.fullName\" >{{client.profile.firstname}} {{client.profile.lastname}}</span>\n            <!-- display the client\'s fullName -->\n            <span class=\"md-title\" ng-show=\"client.profile.fullName\">{{client.profile.fullName}}</span>\n            <!-- if this is a business, display the primary user\'s name -->\n            <span class=\"md-subhead\" ng-show=\"client.profile.isCompany\" >{{client.profile.firstname}} {{client.profile.lastname}}</span>\n\n            <span ng-if=\"client.profile.position\" class=\"md-subhead\">{{client.profile.position}} <br><a target=\"_blank\" href=\"{{client.profile.companyurl}}\">{{client.profile.company}}</a></span>\n\n        </md-card-title-text>\n        <md-card-title-media>\n            <div class=\"md-media-sm card-media\">\n                <avatar ng-if=\"client.status != \'personal\'\" parent=\"client.profile\" upload=\"false\"></avatar>\n                <avatar ng-if=\"client.status == \'personal\'\" type=\"default\" parent=\"client.profile\" upload=\"false\" ></avatar>\n            </div>\n        </md-card-title-media>\n    </md-card-title>\n\n    <div  class=\"card-content small-scrollbar\" style=\"width:284px;\">\n\n        <p class=\"md-subhead\">\n            <!-- <span ng-if=\"client.profile.email\" style=\"border-bottom: 1px solid #bbb;\"><strong>Personal Info</strong></span><br> -->\n            <span ng-if=\"client.profile.phone\" class=\"md-subhead dont-break-out\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon><a href=\"tel:{{client.profile.phone}}\"  target=\"_blank\">{{client.profile.phone}}</a><br></span>\n            <span ng-if=\"client.profile.email\" class=\"md-subhead dont-break-out\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon><a href=\"mailto: {{client.profile.email}}\" target=\"_blank\">{{client.profile.email}}</a></span>\n        </p>\n        <p ng-if=\"client.profile.address\">\n            <span ng-if=\"client.profile.address.street\">{{client.profile.address.street}}<br></span>\n            <span ng-if=\"client.profile.address.city\">{{client.profile.address.city}}</span><span ng-if=\"client.profile.address.city && client.profile.address.state\">, </span>\n            <span ng-if=\"client.profile.address.state\">{{client.profile.address.state}}</span>\n            <span ng-if=\"client.profile.address.zip\">{{client.profile.address.zip}}</span>\n        </p>\n        <p ng-if=\"client.profile.twitter || client.profile.facebook || client.profile.linkedin || client.profile.instagram\">\n            <span ng-if=\"client.profile.email\" style=\"border-bottom: 1px solid #bbb;\"><strong>Social</strong></span><br>\n            <span ng-if=\"client.profile.twitter\"><md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon> <a href=\"https://www.twitter.com/{{client.profile.twitter}}\"  target=\"_blank\">{{client.profile.twitter}}</a><br></span>\n            <span ng-if=\"client.profile.facebook\"><md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon> <a href=\"https://www.facebook.com/{{client.profile.facebook}}\"  target=\"_blank\">{{client.profile.facebook}}</a><br></span>\n            <span ng-if=\"client.profile.linkedin\"><md-icon md-font-icon=\"zmdi zmdi-linkedin\"></md-icon> <a href=\"https://www.linkedin.com/in/{{client.profile.linkedin}}\"  target=\"_blank\">{{client.profile.linkedin}}</a><br></span>\n            <span ng-if=\"client.profile.pinterest\"><md-icon md-font-icon=\"zmdi zmdi-pinterest\"></md-icon> <a href=\"https://www.pinterest.com/{{client.profile.pinterest}}\"  target=\"_blank\">{{client.profile.pinterest}}</a><br></span>\n            <span ng-if=\"client.profile.instagram\"><md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon> <a href=\"https://www.instagram.com/{{client.profile.instagram}}\"  target=\"_blank\">{{client.profile.instagram}}</a><br></span>\n        </p>\n\n\n        <p ng-if=\"client.profile.company && client.status != \'personal\'\">\n            <span class=\"md-subhead\" ng-show=\"client.profile.company || client.profile.companyemail || client.profile.companyphone\" style=\"border-bottom: 1px solid #bbb;\"><strong>Business</strong></span>\n            <br>\n            <span ng-if=\"client.profile.company\" class=\"md-subhead\">{{client.profile.company}}<br></span>\n            <span ng-if=\"client.profile.companyemail\" class=\"md-subhead\" ><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon><a href=\"mailto:{{client.profile.companyemail}}\" target=\"_blank\">{{client.profile.companyemail}}</a><br></span>\n            <span ng-if=\"client.profile.companyphone\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{client.profile.companyphone}}\" target=\"_blank\">{{client.profile.companyphone}}</a><br></span>\n            <span ng-if=\"client.profile.companyfax\" class=\"md-subhead\"><md-icon md-font-icon=\"fa fa-fax\"></md-icon> {{client.profile.companyfax}}<br></span>\n            <span ng-if=\"client.profile.companyurl\" class=\"md-subhead\">\n                <a class=\"dont-break-out\" href=\"{{client.profile.companyurl}}\" target=\"_blank\"><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon>{{client.profile.companyurl}}</a><br>\n            </span>\n            <span ng-if=\"client.profile.companyAddress.street\">{{client.profile.companyAddress.street}}<br></span>\n            <span ng-if=\"client.profile.companyAddress.city\">{{client.profile.companyAddress.city}}</span><span ng-if=\"client.profilie.companyAddress.city && client.profile.companyAddress.state\">, </span><span ng-if=\"client.profile.companyAddress.state\">{{client.profile.companyAddress.state}}</span> <span ng-if=\"client.profile.companyAddress.zip\">{{client.profile.companyAddress.zip}}</span>\n        </p>\n        <span ng-if=\"client.profile.address.country\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-globe-alt\" style=\"font-size: 1em;\"></md-icon>{{client.profile.address.country}}<br></span>\n        <span ng-if=\"client.profile.timezone\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 1em;\"></md-icon> {{client.profile.timezone}}</span><br>\n        <span ng-if=\"client.profile.birthday.month\" class=\"md-subhead\"><md-icon md-font-icon=\"zmdi zmdi-cake\" style=\"font-size: 1em;\"></md-icon>{{displayBirthday(client)}}</span>\n        <span ng-if=\"client.profile.birthday.year\">(<small style=\"display:inline;\">{{client.profile.birthday.year}}</small>)</span>\n\n    </div>\n    <p style=\"padding:0 1em 0 1em; margin-bottom: 0; color: #888; font-size: 10px;\"  class=\"md-caption\" ng-if=\"client.status != \'personal\' && client.profile.plan.type != \'none\'\"><!-- <md-icon md-font-icon=\"zmdi zmdi-refresh\" style=\"font-size: 1.25em; margin-right: 0\"></md-icon> -->\n        <span ng-if=\"client.profile.plan.recurrenceType != \'zero\'\">Renews on: {{nextRenewal(client) | amDateFormat:\'MMM Do\'}}</span>\n        <span ng-if=\"client.profile.plan.recurrenceType == \'zero\'\"> Renews when balance is 0</span>\n    </p>\n    <p style=\"padding:0 1em 1em 1em; margin-bottom: 0; margin-top: 0; color: #888; font-size: 10px;\"  class=\"md-caption\" >\n        <span ng-if=\"client.profile.workspaceAddress\"><b>Inbox</b>: <a href=\"mailto: {{client.profile.workspaceAddress}}@inbox.adminja.co\"  target=\"_blank\"><!-- <md-icon md-font-icon=\"fa fa-envelope\" style=\"font-size: 11px; color:#888;\"></md-icon> -->{{client.profile.workspaceAddress}}@inbox.adminja.co</a></span>\n        <span ng-if=\"!client.profile.workspaceAddress\"><b>Inbox</b>: Not Set</span>\n    </p>\n\n    <!--<client-summary-strip  this-client=\"client\" style=\"background-color: {{client.profile.clientColor}}; color: #000;\"></client-summary-strip>-->\n    <!--   <md-card-actions layout=\"row\" layout-align=\"end center\">\n        <md-button ng-click=\"editClient(client)\">\n            Edit\n        </md-button>\n        <md-button data-ng-show=\"$state.includes(\'triangular.account-page.clients\')\" ng-click=\"viewClient(client)\">\n            View\n        </md-button>\n      </md-card-actions> -->\n\n</md-card>\n");
$templateCache.put("app/app-directives/client-directives/new-client-button.tmpl.html","<div flex class=\"center\">\n    <md-button class=\"md-accent md-raised\" ng-click=\"newClient()\" >\n        + New Workspace\n    </md-button>\n</div>\n\n");
$templateCache.put("app/app-directives/client-package/client-package.tmpl.html","<fieldset ng-if=\"vm.package.uid && !vm.package.hide\" class=\"client-package md-padding fade\" layout=\"column\" layout-align=\"start layout-fill\" style=\"border: 1px solid {{vm.client.profile.clientColor}}\">\n    <legend><span class=\"package-label\">{{vm.package.label}}</span>\n      <span ng-if=\"vm.package.isDefault && vm.package.status == \'open\'\" style=\"font-size: 10px; color: green; display: block;\">Default Package</span></legend>\n    <div layout=\"row\" layout-align=\"layout-fill layout-fill\" style=\"margin-top: -1em;\">\n      <div flex=\"30\">\n        <div flex=\"nogrow\" class=\"package-status\">\n            <div ng-if=\"vm.package.status == \'open\'\">\n              <md-icon style=\"color: #6AAF55;\" md-font-icon ng-class=\"\n                         {\'zmdi zmdi-time-restore adjust-left-neg-1\': vm.package.type ==\'hourly\',\n                          \'zmdi zmdi-time-interval adjust-left-1\': vm.package.type == \'retainer\',\n                          \'zmdi zmdi-hourglass-alt adjust-left-6\': vm.package.type == \'balance\',\n                          \'zmdi zmdi-dot-circle adjust-left-1\': vm.package.type ==\'fixed\',\n                          \'zmdi zmdi-gas-station adjust-left-6\': vm.package.type == \'refillable\'\n                          }\"\n              >\n                <md-tooltip md-delay=\"500\">Package is Open</md-tooltip>\n              </md-icon>\n              <span style=\"font-weight: normal; color: #999; font-size: .85em;\">{{vm.packageType(vm.package.type)}}</span>\n            </div>\n            <div ng-if=\"vm.package.status == \'closed\' || vm.package.status == \'archived\'\" >\n              <md-icon md-font-icon=\"fa fa-lock\" style=\"color:#EA8E8E; \"><md-tooltip md-delay=\"500\">Package is Closed</md-tooltip></md-icon>\n              <span style=\"font-weight: normal; color: #999; font-size: .85em;\">{{vm.packageType(vm.package.type)}}</span>\n            </div>\n            <div ng-if=\"vm.package.status == \'pending\'\">\n              <md-icon style=\"color: orange;\"   md-font-icon=\"fa fa-ellipsis-h\">\n                <md-tooltip md-delay=\"500\">Package is Pending Activation</md-tooltip>\n              </md-icon>\n              <span style=\"font-weight: normal; color: orange; font-size: .85em;\">Upcoming {{vm.packageType(vm.package.type)}}</span>\n            </div>\n\n            <!-- <div ng-if=\"vm.package.status == \'archived\'\">\n              <md-icon ng-if=\"vm.packageService.packageUpdating\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: orange; margin: 0 auto 0 auto;\"><md-tooltip md-delay=\"500\">Updating Package Renewal Sequence</md-tooltip></md-icon>\n              <md-icon md-font-icon=\"zmdi zmdi-archive\">\n                <md-tooltip md-delay=\"500\">Package is Archived</md-tooltip>\n              </md-icon>\n              <span style=\"font-weight: normal; color: #999; font-size: .85em;\">{{vm.packageType}}</span>\n            </div> -->\n        </div>\n      </div>\n      <div flex=\"40\"  layout=\"row\" layout-align=\"center center\">\n        <p class=\"md-subhead center\" ng-if=\"vm.package.expired\" style=\"color: red;\"><md-icon md-font-icon=\"zmdi zmdi-alert\" style=\"color: red;\"></md-icon> Package Has <span ng-if=\"vm.package.type == \'refillable\'\">Expired!</span> <span ng-if=\"vm.package.type == \'refillable\'\">Ended.</span></p>\n      </div>\n      <div flex=\"30\" layout=\"row\" layout-align=\"end center\">\n        {{vm.package.startDate |  amDateFormat: vm.settings.shortDateFormat}} <!--{{vm.package.startDate | amDateFormat: \'LTS\'}}-->\n      </div>\n    </div>\n    <!-- status icon -->\n\n\n\n\n    <div class=\"client-package-header padding-top-20\" layout=\"row\" layout-align=\"layout-fill center\">\n        <!-- Non-Hourly Progress -->\n        <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.package.type != \'hourly\' && vm.package.budgetedHours != 0\" class=\"padding-right-20\">\n          <progress-arc\n              class=\"package-progress-circle\"\n              size=\"100\"\n              stroke=\"{{vm.progressBarColor}}\"\n              stroke-width=\"20\"\n              complete=\"vm.progressBarPercent\"\n              counter-clockwise=\"true\"\n              background=\"{{vm.progressBarBackgroundColor}}\"\n              label=\"{{vm.progressBarPercentLabel}}\">\n          </progress-arc>\n\n          <div>\n             <div ng-if=\"vm.packageBalance > 0\">\n              <p  class=\"md-title center margin-top-0\">\n                {{vm.packageBalance || 0 | userTimeFormat}}\n              </p>\n              <p class=\"md-subhead center margin-top-0\">Remain</p>\n            </div>\n            <p ng-if=\"vm.packageBalance <= 0\" class=\"md-title center margin-top-0\" style=\"color: red;\">\n              Budget Depleted!\n            </p>\n\n            <md-tooltip md-delay=\"1000\">Package Balance</md-tooltip>\n          </div>\n        </div>\n        <!-- Hourly Progress -->\n        <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.package.budgetedHours > 0 && vm.package.type == \'hourly\'\" class=\"padding-right-20\">\n          <!-- ng-if=\"vm.progressBarDefined\" ensures that we don\'t see an initial 100% flash when directive instantiating -->\n          <progress-arc\n              class=\"package-progress-circle\"\n              size=\"100\"\n              stroke=\"{{vm.progressBarColor}}\"\n              stroke-width=\"20\"\n              complete=\"vm.progressBarPercent\"\n              counter-clockwise=\"false\"\n              background=\"{{vm.progressBarBackgroundColor}}\"\n              label=\"{{vm.progressBarPercentLabel}}\"\n              >\n          </progress-arc>\n\n          <div>\n              <div ng-if=\"vm.packageBalance > 0\">\n               <p  class=\"md-title center margin-top-0\">\n                 {{vm.packageBalance || 0 | HandM }}\n               </p>\n               <p class=\"md-subhead center margin-top-0\">To Goal</p>\n             </div>\n             <p ng-if=\"vm.packageBalance <= 0\" class=\"md-title center margin-top-0\">\n               Goal Reached!\n             </p>\n\n               <md-tooltip md-delay=\"1000\">To Goal</md-tooltip>\n             </div>\n        </div>\n        <div flex=\"grow\" layout=\"column\" layout-align=\"start layout-fill\">\n\n          <div class=\"package-stats\" layout=\"row\" layout-align=\"layout-fill start\">\n            <div flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p class=\"md-title center\">\n                  Start\n                </p>\n                <p class=\"md-subhead center\">\n                  {{vm.package.startDate | amDateFormat: vm.settings.amDateFormat}}\n                </p>\n            </div>\n\n              <div ng-if=\"vm.package.renewable\" flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                  <p class=\"md-title center\">\n                    End\n                  </p>\n                  <p class=\"md-subhead center\" ng-if=\"vm.package.type != \'balance\'\">\n                    {{vm.package.endDate | amDateFormat: vm.settings.amDateFormat}}\n                  </p>\n                  <p class=\"md-subhead center\" ng-if=\"vm.package.type == \'balance\' && vm.package.status == \'closed\'\">\n                    {{vm.package.closedDate | amDateFormat: vm.settings.amDateFormat}}\n                  </p>\n                  <p class=\"md-subhead center\" ng-if=\"vm.package.type == \'balance\' && vm.package.status != \'closed\'\">\n                    Pending\n                  </p>\n              </div>\n\n            <div  ng-if=\"vm.package.type == \'fixed\'\" flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p class=\"md-title center\">\n                  Due\n                </p>\n                <p class=\"md-subhead center\">\n                  <!-- change this to END date -->\n                  {{vm.package.expiryDate | amDateFormat: vm.settings.amDateFormat}}\n                </p>\n            </div>\n            <div  ng-if=\"vm.package.type == \'refillable\'\" flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p class=\"md-title center\">\n                  Expires\n                </p>\n                <p class=\"md-subhead center\">\n                  <!-- change this to END date -->\n                  {{vm.package.expiryDate | amDateFormat: vm.settings.amDateFormat}}\n                </p>\n            </div>\n\n            <div ng-if=\"vm.package.type != \'hourly\'\" flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p class=\"md-title center\">\n                  Budget\n                </p>\n                <p class=\"md-subhead center\">\n                  {{vm.package.budgetedMinutes || 0 | userTimeFormat}}\n                  <md-tooltip md-delay=\"1000\">Package Budget</md-tooltip>\n                </p>\n            </div>\n            <div flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p class=\"md-title center\" ng-if=\"vm.package.type != \'hourly\'\">\n                  Used\n                </p>\n                <p class=\"md-title center\" ng-if=\"vm.package.type == \'hourly\'\">\n                  Billable\n                </p>\n                <p class=\"md-subhead center\">\n                  {{vm.package.qualifiedMinutes || 0| userTimeFormat}}\n                  <md-tooltip md-delay=\"1000\">Used hours logged</md-tooltip>\n                </p>\n            </div>\n            <div flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                <p ng-if=\"vm.package.type != \'hourly\'\" class=\"md-title center\">\n                  Comped\n                </p>\n                <p ng-if=\"vm.package.type == \'hourly\'\" class=\"md-title center\">\n                  Non-Billable\n                </p>\n                <p class=\"md-subhead center\">\n                  {{vm.package.exemptMinutes || 0| userTimeFormat}}\n                  <md-tooltip md-delay=\"1000\">Exempt hours logged</md-tooltip>\n                </p>\n            </div>\n            <div ng-if=\"vm.package.type != \'hourly\'\" flex=\"25\" layout=\"column\" layout-align=\"start center\">\n                <p class=\"md-title center\">\n                  Total\n                </p>\n                <p class=\"md-subhead center\">\n                  <span ng-bind-html=\"vm.currency\"></span>{{vm.totalCost || 0 | number: 2}}\n                  <md-tooltip md-delay=\"1000\">Total Cost</md-tooltip>\n                </p>\n            </div>\n          </div>\n          <!-- hourly -->\n          <div class=\"package-stats margin-top-40\" layout=\"row\" layout-align=\"layout-fill start\" ng-if=\"vm.package.type == \'hourly\'\">\n            <div flex=\"25\" layout=\"column\" layout-align=\"start center\">\n                <p class=\"md-title center\">\n                  Goal\n                </p>\n                <p class=\"md-subhead center\">\n                 {{vm.package.budgetedMinutes || 0 | userTimeFormat}}\n                 <md-tooltip md-delay=\"1000\">Package Goal</md-tooltip>\n                </p>\n            </div>\n            <div flex=\"25\" layout=\"column\" layout-align=\"start center\">\n                <p class=\"md-title center\">\n                  Accrued\n                </p>\n                <p class=\"md-subhead center\">\n                  <span ng-bind-html=\"vm.currency\"></span>{{vm.package.accrued || 0 | number : 2}}\n                  <md-tooltip md-delay=\"1000\">Accrued hourly earnings</md-tooltip>\n                </p>\n            </div>\n            <div flex=\"25\" layout=\"column\" layout-align=\"start center\">\n                <p class=\"md-title center\">\n                  Charges\n                </p>\n                <p class=\"md-subhead center\">\n                  <span ng-bind-html=\"vm.currency\"></span>{{vm.package.charges || 0 | number: 2}}\n                  <md-tooltip md-delay=\"1000\">Additional Charges</md-tooltip>\n                </p>\n            </div>\n            <div flex=\"25\" layout=\"column\" layout-align=\"start center\">\n                <p class=\"md-title center\">\n                  Total\n                </p>\n                <p class=\"md-subhead center\">\n                  <span ng-bind-html=\"vm.currency\"></span>{{vm.totalCost || 0 | number: 2}}\n                  <md-tooltip md-delay=\"1000\">Total Cost</md-tooltip>\n                </p>\n            </div>\n\n          </div>\n        </div>\n    </div><!-- client-package-header -->\n\n\n      <div class=\"client-package-details\" ng-if=\"vm.detailsEnabled\">\n        <div ng-if=\"vm.package.notes\" class=\"client-package-notes md-padding\">\n          <p class=\"md-subhead margin-bottom-0 margin-top-0\"><strong>Package Notes</strong></p>\n          <p class=\"md-subhead\">{{vm.package.notes}}</p>\n        </div>\n        <md-tabs md-dynamic-height md-border-bottom md-center-tabs>\n              <md-tab label=\"Charge Details\">\n                <md-content class=\"md-padding\">\n                  <div class=\"client-package-line-items\" ng-if=\"vm.numberLineItems > 0\">\n                      <div layout=\"row\" layout-align=\"layout-fill center\">\n                          <div flex=\"10\" class=\"package-table-cell\">\n                          </div>\n                          <div flex=\"10\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Date</p>\n                          </div>\n                          <div flex=\"40\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Description</p>\n                          </div>\n                          <div flex=\"10\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Quantity</p>\n                          </div>\n                          <div flex=\"10\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Amount</p>\n                          </div>\n                          <div flex=\"10\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Total</p>\n                          </div>\n                          <div flex=\"10\" class=\"package-table-cell\">\n                            <p class=\"package-table-header\">Invoiced</p>\n                          </div>\n                      </div><!-- charges line-item-header-row -->\n                      <!-- <md-divider class=\"margin-top-10 margin-bottom-0\"></md-divider> -->\n                      <div class=\"package-line-item\"  ng-repeat=\"charge in vm.packageCharges   track by $index+uid\" layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <md-button class=\"md-icon-button\" ng-click=\"vm.editCharge(charge)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p>{{charge.date | amDateFormat: vm.settings.shortDateFormat}}</p>\n                        </div>\n                        <div flex=\"40\" class=\"package-table-cell\">\n                          <p>{{charge.description}}</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell \">\n                          <p class=\"padding-left-20\">{{charge.quantity}}</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p><span ng-bind-html=\"vm.currency\"></span>{{charge.amount | number: 2}}</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p><span ng-bind-html=\"vm.currency\"></span>{{charge.total | number: 2}}</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell padding-left-10\">\n                            <md-icon md-font-icon=\"fa fa-check\" ng-if=\"charge.invoiced\" style=\"color: green;\"></md-icon>\n                        </div>\n                      </div><!-- charges-line-items -->\n                      <div class=\"package-line-item-total\" layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"80\" class=\"package-table-cell\">\n                          <p class=\"package-table-cell right padding-right-10\">\n                            <strong>Total Charges: </strong>\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p><strong><span ng-bind-html=\"vm.currency\"></span>{{vm.package.charges | number: 2}}</strong></p>\n                        </div>\n                        <div flex=\"10\">\n                        </div>\n                      </div><!-- charges-line-item-totals -->\n                  </div><!-- charges - all line items -->\n                  <div ng-if=\"vm.numberLineItems == 0\">\n                      <p class=\"md-subhead center\">No charges logged against this package.</p>\n                  </div>\n                  <p class=\"md-subhead center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.addCharge(vm.package)\">+ Add a Charge</md-button></p>\n                </md-content>\n              </md-tab>\n              <md-tab label=\"Time Details\">\n                <md-content class=\"md-padding\">\n                    <div layout=\"row\" layout-align=\"center center\" class=\"margin-bottom-20\" ng-if=\"vm.numberTimeEntries > 0\">\n                        <p class=\"md-subhead center\" flex=\"20\">\n                          <strong ng-if=\"vm.package.type == \'hourly\'\">Billable Time</strong>\n                          <strong ng-if=\"vm.package.type != \'hourly\'\">Used Time</strong>\n                          <br> {{vm.package.qualifiedMinutes | userTimeFormat}}\n                        </p>\n                        <p class=\"md-subhead center\" flex=\"20\">\n                          <strong ng-if=\"vm.package.type != \'hourly\'\">Comped Time</strong>\n                          <strong ng-if=\"vm.package.type == \'hourly\'\">Non-Billable Time</strong>\n                          <br> {{vm.package.exemptMinutes | userTimeFormat}}\n                        </p>\n                        <p class=\"md-subhead center\" flex=\"20\">\n                          <strong>Total Time</strong><br> {{vm.package.totalMinutes|userTimeFormat}}\n                        </p>\n                    </div>\n                  <div class=\"client-package-time\" ng-if=\"vm.numberTimeEntries > 0\">\n                    <div layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\">\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Date</p>\n                        </div>\n                        <div flex=\"30\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-header\">Description</p>\n                        </div>\n                        <div flex=\"60\" class=\"package-table-cell\" ng-if=\"vm.package.type != \'hourly\'\">\n                          <p class=\"package-table-header\">Description</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\" ng-if=\"vm.package.type == \'hourly\'\">Billable</p>\n                          <p class=\"package-table-header\" ng-if=\"vm.package.type != \'hourly\'\">Used</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Hours</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-header\" >Rate</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-header\" >Total</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-header\" >Invoiced</p>\n                        </div>\n                    </div><!-- time header row -->\n                    <div class=\"package-line-item\" ng-click=\"vm.editTime(entry)\" ng-repeat=\"entry in vm.packageTime |  orderBy: \'-logDate\' track by $index+uid\"  layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\">\n                          <md-button class=\"md-icon-button\" ng-click=\"vm.editTime(entry)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p>\n                            {{entry.logDate | amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                        </div>\n                        <div flex=\"30\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p>\n                            {{entry.description}}<br>\n                            <span style=\"font-size: 10px;\">{{entry.category.label}}</span>\n                          </p>\n                        </div>\n                        <div flex=\"60\" class=\"package-table-cell\" ng-if=\"vm.package.type != \'hourly\'\">\n                          <p>\n                            {{entry.description}}<br>\n                            <span style=\"font-size: 10px;\">{{entry.category.label}}</span>\n\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                          <p class=\"padding-left-20\">\n                            <md-icon ng-if=\"!entry.exempt\" md-font-icon=\"fa fa-check\"></md-icon>\n                            <!-- <md-icon ng-if=\"entry.exempt\" md-font-icon=\"zmdi zmdi-block\"></md-icon> -->\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\">\n                            <p>\n                              {{entry.logged | HandM}}\n                            </p>\n                        </div>\n\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-cell\"  ng-if=\"!entry.exempt\">\n                            <span ng-bind-html=\"vm.currency\"></span>{{entry.rate | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <p class=\"package-table-cell\"  ng-if=\"!entry.exempt\">\n                            <span ng-bind-html=\"vm.currency\"></span>{{vm.timeEntryTotal(entry) | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"padding-left-10\" ng-if=\"vm.package.type == \'hourly\'\">\n                          <md-icon ng-if=\"entry.invoiced\" md-font-icon=\"fa fa-check\" style=\"color: green;\"></md-icon>\n                        </div>\n\n                    </div><!-- time package-line-item -->\n\n                    <div ng-if=\"vm.package.type == \'hourly\'\" class=\"package-line-item-total\" layout=\"row\" layout-align=\"layout-fill center\">\n                      <div flex=\"80\" class=\"package-table-cell\">\n                        <p class=\"package-table-cell right padding-right-10\">\n                          <strong>Total Accrued: </strong>\n                        </p>\n                      </div>\n                      <div flex=\"10\" class=\"package-table-cell\">\n                        <p><strong><span ng-bind-html=\"vm.currency\"></span>{{vm.package.accrued || 0 | number : 2}}</strong></p>\n                      </div>\n                      <div flex=\"10\" class=\"package-table-cell\">\n                      </div>\n                    </div><!-- time line-item-totals -->\n                  </div><!-- time - all line items -->\n\n                  <div ng-if=\"vm.numberTimeEntries == 0\">\n                      <p class=\"md-subhead center\">No time logged to this package.</p>\n                  </div>\n                </md-content>\n              </md-tab>\n              <md-tab label=\"Package History\" ng-if=\"vm.package.type != \'fixed\'\">\n                <md-content ng-if=\"vm.package.type != \'refillable\'\" class=\"md-padding\">\n                  <div class=\"client-package-time\" ng-if=\"vm.numberHistoryItems > 0\">\n                    <div layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\" class=\"package-table-cell\">\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Start</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">End</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Goal</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Budget</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Billable</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Used</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Non-Billable</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Comped</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">\n                          <p class=\"package-table-header\">Accrued</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Charges</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Total</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.userType == \'admin\'\">\n                        </div>\n                    </div><!-- time header row -->\n                    <div class=\"package-line-item\" ng-if=\"instance.uid != vm.package.uid\" ng-repeat=\"instance in vm.packageHistory | toArray: false | orderBy: \'-startDate\' track by $index+uid\"  layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\" class=\"package-table-cell\">\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p>\n                            {{instance.startDate |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p ng-if=\"instance.closedDate\">\n                            {{instance.endDate |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                          <p ng-if=\"!instance.closedDate\">\n                            {{instance.schedule.packageStart |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>{{instance.budgetedHours}}hrs</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>\n                            {{instance.qualifiedMinutes | HandM}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>\n                            {{instance.exemptMinutes | HandM}}\n                          </p>\n\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{instance.accrued || 0 | number : 2}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{instance.charges || 0 | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{vm.totalCost || 0 | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.userType == \'admin\'\">\n                          <md-button class=\"md-icon-button\"  target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}clientPackages/{{instance.uid}}\"><md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon></md-button>\n                        </div>\n\n\n\n                    </div><!-- time package-line-item -->\n\n                  </div><!-- time - all line items -->\n\n                  <div ng-if=\"vm.numberHistoryItems == 0\">\n                      <p class=\"md-subhead center\">This is the first instance of this package.</p>\n                  </div>\n                  <div ng-if=\"!vm.packageHistory\">\n                      <div layout=\"column\" layout-align=\"center center\" >\n                          <md-button ng-if=\"!vm.showHistoryLoader\" ng-click=\"vm.fetchPackageHistory(vm.package)\">Fetch Package History</md-button>\n                          <md-button ng-if=\"vm.showHistoryLoader\" ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" >\n                              <md-icon md-font-icon=\"zmdi zmdi-refresh fa-spin\">\n                                  <md-tooltip>\n                                      Loading Package History\n                                  </md-tooltip>\n                              </md-icon>\n                              Fetching History\n                          </md-button>\n                      </div>\n                  </div>\n                </md-content>\n                <md-content ng-if=\"vm.package.type == \'refillable\'\" class=\"md-padding\">\n                  <p class=\"md-subhead center\">Package Refill History will be displayed here</p>\n                  <div class=\"client-package-time\" ng-if=\"bryanSays\">\n                    <div layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\" class=\"package-table-cell\">\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Start</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">End</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Goal</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Budget</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Billable</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Used</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">Non-Billable</p>\n                          <p ng-if=\"vm.package.type != \'hourly\'\" class=\"package-table-header\">Comped</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-header\">\n                          <p class=\"package-table-header\">Accrued</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Charges</p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p class=\"package-table-header\">Total</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.userType == \'admin\'\">\n                        </div>\n                    </div><!-- time header row -->\n                    <div class=\"package-line-item\" ng-if=\"instance.uid != vm.package.uid\" ng-repeat=\"instance in vm.packageHistory | toArray: false | orderBy: \'-startDate\' track by $index+uid\"  layout=\"row\" layout-align=\"layout-fill center\">\n                        <div flex=\"10\" class=\"package-table-cell\">\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p>\n                            {{instance.startDate |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p ng-if=\"instance.closedDate\">\n                            {{instance.closedDate |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                          <p ng-if=\"!instance.closedDate\">\n                            {{instance.schedule.packageStart |amDateFormat: vm.settings.shortDateFormat}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>{{instance.budgetedHours}}hrs</p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>\n                            {{instance.qualifiedMinutes | HandM}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" >\n                          <p>\n                            {{instance.exemptMinutes | HandM}}\n                          </p>\n\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.package.type == \'hourly\'\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{instance.accrued || 0 | number : 2}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{instance.charges || 0 | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"15\" class=\"package-table-cell\">\n                          <p>\n                            <span ng-bind-html=\"vm.currency\"></span>{{vm.totalCost || 0 | number: 2}}\n                          </p>\n                        </div>\n                        <div flex=\"10\" class=\"package-table-cell\" ng-if=\"vm.userType == \'admin\'\">\n                          <md-button class=\"md-icon-button\"  target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}clientPackages/{{instance.uid}}\"><md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon></md-button>\n                        </div>\n                    </div><!-- time package-line-item -->\n\n                  </div><!-- time - all line items -->\n                </md-content>\n              </md-tab>\n        </md-tabs>\n      </div><!-- /client-package-details -->\n\n    <div layout=\"column\" layout-align=\"center center\" >\n        <!-- admin only schedule testing tool -->\n        <div ng-if=\"vm.showSchedules\" layout=\"column\" layout-align=\"start layout-fill\">\n          <div layout=\"row\" layout-align=\"layout-fill center\" ng-repeat=\"schedule in vm.package.triggerSchedules | toArray: false| orderBy: [\'when\'] track by $index + uid\">\n            <div flex>\n              <p class=\"md-subhead center\"><strong>When</strong><br>\n              {{schedule.when | amDateFormat: vm.settings.shortDateFormat}}\n              </p>\n            </div>\n            <div flex>\n              <p class=\"md-subhead center\"><strong>Type</strong><br>\n              {{schedule.type}}\n              </p>\n            </div>\n            <div flex>\n              <p class=\"md-subhead center\">\n                <md-button class=\"md-primary md-raised\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}schedules/{{schedule.uid}}\">X-Ray</md-button>\n              </p>\n            </div>\n          </div>\n        </div>\n        <md-button ng-if=\"!vm.detailsEnabled && !vm.showLoader\" ng-click=\"vm.showDetails(vm.package)\">- Show Details -</md-button>\n        <md-button ng-if=\"vm.detailsEnabled && !vm.showLoader\" ng-click=\"vm.hideDetails()\">- Hide Details -</md-button>\n        <md-button ng-if=\"vm.showLoader\" ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" >\n            <md-icon md-font-icon=\"zmdi zmdi-refresh fa-spin\">\n                <md-tooltip>\n                    Loading Package Details\n                </md-tooltip>\n            </md-icon>\n            Fetching History\n        </md-button>\n    </div><!-- detail controls -->\n\n      <!-- package menu -->\n      <md-menu class=\"package-menu\" md-position-mode=\"target target\">\n          <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Open package menu\"><md-icon  md-font-icon=\"fa fa-gears\" class=\"app-item-more\"></md-icon></md-button>\n          <md-menu-content class=\"md-dense\">\n              <md-menu-item ng-if=\"vm.package.type == \'refillable\'\">\n                  <md-button ng-click=\"vm.refillPackage(vm.package, $event)\">\n                  <md-icon md-font-icon=\"zmdi zmdi-gas-station\"></md-icon>  Refill Package\n                 </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.type == \'refillable\'\">\n                  <md-button target=\"_blank\" href=\"/#/payment-portal/{{vm.package.workspace}}/refill/{{vm.package.uid}}\">\n                  <md-icon md-font-icon=\"zmdi zmdi-link\"></md-icon>  Client Refill Link\n                 </md-button>\n              </md-menu-item>\n              <md-menu-item >\n                  <md-button aria-label=\"Edit\" ng-disabled=\"vm.package.status == \'closed\' || vm.package.status == \'archived\'\" ng-click=\"vm.editPackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"fa fa-edit\"></md-icon> Edit Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.status == \'pending\'\" >\n                  <md-button aria-label=\"Edit\" ng-click=\"vm.activatePackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"zmdi zmdi-play\"></md-icon> Start Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.status == \'open\'\" >\n                  <md-button aria-label=\"Edit\" ng-click=\"vm.closePackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"zmdi zmdi-lock\"></md-icon> Close Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.status == \'closed\' || vm.package.status == \'archived\'\">\n                  <md-button aria-label=\"Edit\" ng-click=\"vm.reopenPackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"zmdi zmdi-lock-open\"></md-icon> Re-open Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.status == \'closed\'\">\n                  <md-button  aria-label=\"Edit\" ng-click=\"vm.archivePackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"fa fa-archive\"></md-icon> Archive Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item >\n                  <md-button aria-label=\"Edit\" ng-disabled=\"vm.package.status != \'closed\'\" ng-click=\"vm.deletePackage(vm.package, $event)\">\n                      <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete Package\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                  <md-button aria-label=\"Renew\" ng-click=\"vm.triggerRecalc(vm.package)\">\n                      <md-icon md-font-icon=\"zmdi zmdi-flash\"></md-icon> Trigger Recalc\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                  <md-button aria-label=\"Renew\" ng-click=\"vm.triggerRenewal(vm.package)\" ng-disabled=\"vm.package.type != \'hourly\' && vm.package.type != \'retainer\'\">\n                      <md-icon md-font-icon=\"zmdi zmdi-flash\"></md-icon> Trigger Next Instance\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"vm.package.triggerSchedules\">\n                  <md-button aria-label=\"X-ray\" target=\"_blank\" ng-click=\"vm.showSchedules = true\">\n                      <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> View Schedules\n                  </md-button>\n              </md-menu-item>\n\n              <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                  <md-button aria-label=\"X-ray\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}clientPackages/{{vm.package.uid}}\">\n                      <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                  </md-button>\n              </md-menu-item>\n              <md-menu-item ng-if=\"!vm.package.isDefault && vm.package.status == \'open\'\">\n                  <md-button ng-click=\"vm.setAsDefault(vm.package)\">\n                      <md-icon md-font-icon=\"fa fa-thumb-tack\"></md-icon> Set as Default Package\n                  </md-button>\n              </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n</fieldset>\n");
$templateCache.put("app/app-directives/client-summary-strip/client-summary-strip.tmpl.html","<div class=\"app-item-container-client-summary-wrapper\" style=\"background-color: {{vm.thisClient.color}};\">\n<!-- if client has old-style nextCycle date - prompt user to fix it -->\n<!-- <div ng-show=\"(vm.thisClient.profile.plan.nextCycle.length > 10 || !vm.thisClient.profile.plan.nextCycle) && !isPersonalSpace()\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary\">\n    <div flex=\"100\">\n        <div class=\"client-summary-element\"  style=\"cursor: pointer;\">\n            <h3  ng-click=\"openClient(vm.thisClient)\" class=\"center\" style=\"color: red; margin:6px 0 6px 0;\">Set next Billing cycle to reactivate</h3>\n        </div>\n    </div>\n</div> -->\n\n\n<!-- If this is an hourly client -->\n<div ng-show=\"vm.selectedPeriod && !isPersonalSpace() && vm.type ==\'hourly\' && showSummary()\" layout=\"row\" layout-align=\"space-between center\" class=\"app-item-container-client-summary\" >\n    <div flex=\"25\" ng-if=\"vm.showRate\">\n        <div class=\"client-summary-element\" ng-show=\"vm.type != \'retainer\'\">\n            <p class=\"md-caption\">Rate</p>\n            <h3><span ng-bind-html=\"vm.currency\"></span>{{vm.rate}}/<small>hr</small></h3>\n        </div>\n    </div>\n    <div flex=\"25\">\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Logged</p>\n            <h3>{{vm.used | userTimeFormat}}</h3>\n        </div>\n    </div>\n    <div flex=\"25\" ng-if=\"vm.showRate\">\n        <div class=\"client-summary-element\"  ng-show=\"vm.type != \'retainer\'\">\n            <p class=\"md-caption\">Total</p>\n            <h3>\n                <span ng-bind-html=\"vm.currency\"></span>{{vm.total |number:0}}\n            </h3>\n        </div>\n    </div>\n</div>\n\n<!-- If this is a retainer-based client -->\n<div ng-show=\"vm.selectedPeriod && !isPersonalSpace() && vm.type ==\'retainer\' && showSummary()\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary\" >\n    <div flex ng-show=\"vm.type == \'retainer\' && vm.recurrenceType != \'zero\'\">\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Renews</p>\n            <h3>{{vm.renewsIn}}<small>d</small></h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\" ng-show=\"vm.type == \'retainer\'\">\n            <p class=\"md-caption\">Allocated</p>\n            <h3>{{vm.plan * 60 | userTimeFormat}}</h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\">\n            <p class=\"md-caption\">Logged</p>\n            <h3>{{vm.used|userTimeFormat}}</h3>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element\"  ng-show=\"vm.type == \'retainer\'\">\n            <p class=\"md-caption\"><strong>Remain</strong></p>\n            <h3 ng-class=\"retainerStatus(vm.used, vm.plan*60)\"  style=\"font-weight: bold;\">{{vm.remain | userTimeFormat}}</h3>\n        </div>\n    </div>\n\n</div>\n<!-- message if active plan with no valid period yet -->\n<div layout=\'row\' layout-align=\"center center\" ng-if=\"!vm.selectedPeriod && !isPersonalSpace() && vm.thisClient.profile.plan.type != \'none\' && vm.thisClient.profile.plan.type\" class=\"no-billing-period-message\" style=\"height:45px;\">\n    <p class=\"md-subhead center\" style=\"font-size: 11px;\">Waiting for Current Billing Period &nbsp;&nbsp;\n        <md-icon md-font-icon=\"zmdi zmdi-info-outline\" style=\"font-size: 11px;\">\n            <md-tooltip md-delay=\"1000\">\n                If this is a Balance-based retainer or if the Next Renew Date is not in the future, please contact help@getadminja.com.\n            </md-tooltip>\n        </md-icon>\n\n    </p>\n</div>\n<!-- message if no plan enabled -->\n<div layout=\'row\' layout-align=\"center center\" ng-if=\"!vm.selectedPeriod && (vm.thisClient.profile.plan.type == \'none\' || !vm.thisClient.profile.plan.type) && !isPersonalSpace()\" class=\"no-billing-period-message\" style=\"height:45px;\">\n    <p class=\"md-subhead center\" style=\"font-size: 11px;\">No Billing Plan Configured.\n        <!-- <span ng-if=\"!isNew(vm.thisClient)\" style=\"font-size: .65em;\">Please contact support if it doesn\'t appear shortly.</span> -->\n    </p>\n</div>\n\n<!-- optional retainer progress bar -->\n<div ng-if=\"vm.selectedPeriod && vm.showProgress && showSummary()\">\n    <!-- <p flex=\"100\" class=\"md-subhead center\" ng-show=\"vm.thisClient.profile.plan.type === \'retainer\'\" style=\"margin-top: 0px; font-size: 12px; color: #666;\">{{vm.progress(vm.used || 0, vm.plan)}}% of plan used</p> -->\n    <md-progress-linear  ng-if=\"vm.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'ok\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-primary\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n    <md-progress-linear  ng-if=\"vm.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'close\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-accent\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n    <md-progress-linear  ng-if=\"vm.type === \'retainer\' && retainerStatus(vm.used, vm.plan*60) == \'over\'\" md-theme=\"adminja-status\" class=\"padding-bottom-10 md-warn\" md-mode=\"determinate\" ng-value=\"vm.progress(vm.used || 0, vm.plan)\"></md-progress-linear>\n\n</div>\n<div ng-if=\"vm.selectedPeriod && vm.showProgress && showSummary() && vm.type == \'retainer\' && vm.showRate && vm.settings.showWeeklyStatus\">\n    <p ng-if=\"!vm.weeklyStatusReady\" class=\"this-weeks-status margin-top-0 margin-bottom-0\" style=\"height: 18px;\">\n        Projected this week: {{::vm.expected | HandM}} &nbsp;&nbsp;\n        Actual: <md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 9px; width:9px; min-width:9px; height: 9px; margin:-2px 0 0 0; padding:0;\"></md-icon>\n    </p>\n    <p ng-if=\"vm.weeklyStatusReady\" class=\'this-weeks-status\'>\n        Projected this week: {{::vm.expected | HandM}} &nbsp;&nbsp;\n        Actual: {{::vm.actual | HandM}}\n    </p>\n</div>\n<md-divider ng-if=\"(!vm.selectedPeriod || vm.type == \'hourly\') && !isPersonalSpace() && vm.type != \'none\' && vm.bryanSays\"></md-divider>\n\n<!-- if we don\'t have a billing period and not a personal space -->\n<!-- <div ng-if=\"!vm.selectedPeriod && !isPersonalSpace() && !isNew(vm.thisClient)\" class=\"no-billing-period-message\">\n    <p>Current Billing Period Not Found<br>\n        <span style=\"font-size: .65em;\">Please check the date range for the current plan period.</span>\n    </p>\n</div> -->\n<div ng-show=\"vm.showTaskStatus && vm.bryanSays\" layout=\"row\" layout-align=\"space-between start\" class=\"app-item-container-client-summary task-stats\" style=\"margin:0; padding:0 10px 0 10px;\">\n    <div flex >\n        <div class=\"client-summary-element center\">\n            <h3 class=\"center\">{{vm.tasksDue || 0}}</h3>\n            <p class=\"md-caption\">Due</p>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element center\">\n            <h3 class=\"center\">{{vm.tasksFlagged || 0}}</h3>\n            <p class=\"md-caption\">Flagged</p>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element center\">\n            <h3 class=\"center\">{{vm.tasksOpen || 0}}</h3>\n            <p class=\"md-caption\">Upcoming</p>\n        </div>\n    </div>\n    <div flex>\n        <div class=\"client-summary-element center\">\n            <h3 class=\"center\">{{vm.tasksTotal || 0}}</h3>\n            <p class=\"md-caption\">Total</p>\n        </div>\n    </div>\n</div>\n\n\n</div>\n");
$templateCache.put("app/app-directives/client-team-member-access/client-team-member-access.tmpl.html","<div layout=\"row\" layout-align=\"start center\" style=\"padding-top: .5em; padding-bottom: .5em;\">\n    <div flex=\"nogrow\">\n        <a ui-sref=\"triangular.workspaces.information({clientID: vm.client.uid})\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n            <avatar parent=\"vm.client.profile\" upload=\"false\" border=\"vm.client.profile.clientColor\"></avatar>\n            <!-- <img class=\"avatar\" src=\"{{vm.client.avatar|| \'/assets/images/avatars/generic-avatar.png\'}}\" style=\"border: 2px solid {{vm.client.clientColor}}; width: 30px; height: 30px;\" > -->\n        </a>\n    </div>\n    <div flex layout=\"column\" layout-align=\"center start\">\n        <a ui-sref=\"triangular.workspaces.information({clientID: vm.client.uid})\" flex layout=\"column\" style=\"color: #000; cursor: pointer;\">\n        <p style=\"font-size: 1em; margin:0;\">{{vm.client.profile.fullName}}</p>\n        </a>\n    </div>\n\n    <div flex=\"50\">\n        <md-radio-group ng-disabled=\"vm.team.ownerID == vm.member.uid || vm.member.status == \'disabled\'\" ng-model=\"vm.clientAccess\" ng-change=\"vm.setMemberAccess(vm.member, vm.clientAccess)\" layout=\"row\" layout-align=\"end center\" style=\"margin-right: 1em;\">\n             <md-radio-button flex value=\"none\" class=\"md-primary\">None </md-radio-button>\n             <md-radio-button flex value=\"member\" class=\"md-accent\"><md-tooltip>Members cannot override task assignments.</md-tooltip>Member </md-radio-button>\n             <md-radio-button flex value=\"admin\" class=\"md-warn\">Admin <md-tooltip>Admins can see billing info and reassign any task.</md-radio-button>\n         </md-radio-group>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/detail-board/detail-board.tmpl.html","<div class=\"detail-board-wrapper\" style=\"background-color: {{vm.boardData.settings.color}};\">\n	<!-- Empty State Message -->\n	<div ng-if=\"vm.listCount < 1 && vm.setupComplete\" layout=\"row\" layout-align=\"center center\">\n		<md-card flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-xl=\"40\" class=\"padding-top-40 padding-bottom-40 padding-left-20 padding-right-20 margin-top-60\" layout=\"row\" layout-align=\"center center\" style=\"border-radius: 8px;\">\n				<div flex=\"30\">\n					<p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-info\" style=\"font-size: 72px; color: #999;\"></md-icon></p>\n				</div>\n				<div ng-if=\"vm.userRole != \'client\'\" flex=\"70\" class=\"padding-right-20\">\n					<h2 class=\"\">Before adding &amp; organizing your details, you\'ll need to add some lists!</h2>\n					<p class=\"md-subhead\">Click the plus button to the right of this board to get started.</p>\n				</div>\n				<div ng-if=\"vm.userRole == \'client\'\" flex=\"70\" class=\"padding-right-20\">\n					<h2 class=\"\">Your Virtual Assistant hasn\'t enabled any lists for you yet.</h2>\n					<p class=\"md-subhead\"><!-- Click the plus button to the right of this board to get started. --></p>\n				</div>\n		</md-card>\n	</div>\n	<!-- detail board -->\n	<div class=\"adminja-board-container small-scrollbar\" inhibit-back >\n		<!-- drag-container is used to attached drag animated objects to until they are dropped -->\n		<div class=\"drag-container\">\n		</div>\n		<!-- Muuri Board -->\n		<div class=\"board\" flex=\"nogrow\" style=\"background-color: {{vm.boardData.settings.color}};\">\n		</div><!-- board -->\n	</div><!-- /adminja-board-container-->\n\n	<!-- board/list settings panel -->\n	<md-sidenav class=\"md-sidenav-right md-whiteframe-4dp board-side-panel\"  md-component-id=\"board-panel\" layout=\"column\" layout-align=\"layout-fill center\">\n		<md-toolbar class=\"md-theme-light\" style=\"background-color: {{vm.selectedList.color}}\" layout=\"row\" layout-align=\"start center\">\n			<md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"vm.toggleSidePanel()\" class=\"md-warn\">\n				<md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n			</md-button>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'board\'\" class=\"md-toolbar-tools\">Configure Board</h1>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'list\' && vm.selectedList.uid\" class=\"md-toolbar-tools\">{{vm.selectedList.label}}</h1>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'list\' && !vm.selectedList.uid\" class=\"md-toolbar-tools\"><span ng-if=\"!vm.selectedList.label\">New List</span> <span ng-if=\"vm.selectedList.label\">{{vm.selectedList.label}}</span></h1>\n		</md-toolbar>\n		<md-content layout=\"column\" flex=\"grow\" layout-align=\"start center\" style=\"width:100%;\">\n			<!-- List controls -->\n			<div flex=\"grow\" class=\"board-panel-settings list-settings\" ng-if=\"vm.sidePanelMode == \'list\'\" layout=\"column\" layout-align=\"start layout-fill\">\n				<form name=\"vm.forms.listForm\" style=\"\">\n					<md-input-container style=\"margin-left: 1em; margin-right: 1em; margin-top: 2em;\">\n						<label>List Name</label>\n						<input ng-disabled=\"vm.selectedList.type == \'client-details\' || vm.userRole == \'client\'\" required md-autofocus=\"!vm.selectedList.uid\" md-maxlength=\"28\" ng-model=\"vm.selectedList.label\">\n					</md-input-container>\n					<div ng-if=\"vm.selectedList.type == \'client-details\'\" class=\"md-padding\">\n						<p class=\"md-subhead\" style=\"color: #999;\">This is your client\'s default list for incoming notes and cannot be removed or copied.</p>\n					</div>\n					<md-list>\n						<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.showColorPicker && vm.selectedList.uid && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = true\">\n								<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n									<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-right\"  ></md-icon>\n									<p style=\"font-size: 12px;\">List Color</p>\n								</div>\n								<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n									<div class=\"color-swatch\" style=\"background-color: {{vm.selectedList.color}};\"></div>\n								</div>\n						</md-list-item>\n						<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showColorPicker && vm.selectedList.uid && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = false\">\n								<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n									<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n									<p style=\"font-size: 12px;\">List Color</p>\n								</div>\n								<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n									<div class=\"color-swatch\" style=\"background-color: {{vm.selectedList.color}};\"></div>\n								</div>\n						</md-list-item>\n\n						<div class=\"list-color-chooser\" ng-if=\"!vm.selectedList.uid || vm.showColorPicker\" style=\"margin-top: 1em;\">\n							<lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.selectedList.color\" ng-model=\"vm.selectedList.color\" ng-click=\"vm.selectListColor();\"></lk-color-chooser>\n						</div>\n						<!-- <md-list-item>\n							<md-checkbox ng-model=\"vm.selectedList.clientEnabled\" aria-label=\"\" style=\"margin-left:  1em; margin-right: 5px;\"></md-checkbox> <span style=\"font-size: 12px;\">Visible to Client</span>\n						</md-list-item> -->\n						<div ng-if=\"vm.selectedList.uid && vm.userRole != \'client\'\">\n							<md-subheader class=\"margin-top-20\"><span translate>List Actions</span></md-subheader>\n							<!-- <md-list-item>\n								<md-button class=\"wide\" ng-click=\"vm.listMenuNewTask(vm.thisClient.uid, vm.selectedList.uid)\">\n									<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Note\n								</md-button>\n							</md-list-item> -->\n\n							<md-list-item ng-if=\"vm.selectedList.type != \'client-details\'\">\n								<md-button class=\"wide\" data-gtm-batch-tasks ng-click=\"vm.duplicateList(vm.selectedList)\">\n									<md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon> Duplicate List\n								</md-button>\n							</md-list-item>\n							<md-list-item ng-if=\"vm.userType == \'admin\'\">\n							    <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}detailBoards/{{vm.boardID}}/lists/{{vm.selectedList.uid}}\">\n							        <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n							    </md-button>\n							</md-list-item>\n						</div>\n					</md-list>\n				</form>\n			</div>\n			<!-- Board controls -->\n			<div flex=\"grow\" class=\"board-panel-settings board-settings\" ng-if=\"vm.sidePanelMode == \'board\'\">\n\n\n				<form name=\"vm.forms.boardForm\" style=\"\">\n				<md-list class=\"board-settings-list\">\n					<md-subheader style=\"margin-bottom: .5em;\">Search &amp; Filter</md-subheader>\n					<md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"layout-fill center\">\n						<div layout=\"row\" layout-align=\"layout-fill center\">\n						  <md-input-container flex=\"80\" class=\"task-board-search\">\n						  	<label>Search</label>\n						      <input style=\"width:  290px;\" hotkey=\"{esc: vm.resetTaskSearch}\" id=\"searchQuery\" type=\"text\" ng-model=\"vm.searchTerm\" ng-change=\"vm.filterItems()\" ng-model-options=\"{debounce: 200}\">\n						  </md-input-container>\n						    <md-button flex=\"nogrow\" style=\"margin-top:  1em; margin-left: 0px;\" class=\"md-icon-button\" ng-click=\"vm.resetTaskSearch()\">\n						    	<md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"  style=\"font-size:  14px; color: #999;\">\n						        <md-tooltip md-delay=\"1000\">\n						            Reset search\n						        </md-tooltip>\n						    </md-icon>\n						</md-button>\n						 </div>\n						<!-- <md-button ng-click=\"vm.filterItems()\">Search</md-button> -->\n					</md-list-item>\n\n					<md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Filter Cards:</label>\n							<md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.typeFilter\" ng-change=\"vm.filterItems()\">\n								<md-option value=\'none\'>All</md-option>\n								<md-option value=\"note\">\n									<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon>\n									Notes\n								</md-option>\n								<md-option value=\"contact\">\n									<md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n									Contacts\n								</md-option>\n								<md-option value=\"url\">\n									<md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon>\n									Bookmarks\n								</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item>\n					<!-- <md-list-item ng-if=\"vm.teamList\" style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Filter Users:</label>\n							<md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.userFilter\" ng-change=\"vm.filterItems()\">\n								<md-option value=\'all\'><md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>All Members</md-option>\n								<md-option ng-repeat=\"member in vm.teamList | toArray: false | orderBy: \'[fullName]\' track by $index\" value=\"{{member.uid}}\">\n									<md-icon md-font-icon=\"zmdi zmdi-account\" style=\"color:  {{member.color}}\" ></md-icon>\n									<span style=\"color:  {{member.color}}\">{{member.fullName}}</span>\n								</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item> -->\n					<!-- <md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Sort by:</label>\n							<md-select class=\"md-no-underline\" ng-model=\"vm.sortBy\" ng-change=\"vm.sortItems(vm.sortBy)\">\n								<md-option value=\"order\">Manual Sort</md-option>\n								<md-option value=\"due\">Due Date</md-option>\n								<md-option value=\"priority\">Priority</md-option>\n								<md-option value=\"assignee\">Team Member</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item> -->\n					<md-subheader ng-if=\"vm.userRole != \'client\'\" style=\"margin-top: 2em;\">Board Settings</md-subheader>\n					<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.showColorPicker && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = true\">\n							<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n								<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-right\"  ></md-icon>\n								<p>Background Color</p>\n							</div>\n							<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n								<div class=\"color-swatch\" style=\"background-color: {{vm.boardData.settings.color}};\"></div>\n							</div>\n					</md-list-item>\n					<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showColorPicker && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = false\">\n							<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n								<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n								<p>Background Color</p>\n							</div>\n							<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n								<div class=\"color-swatch\" style=\"background-color: {{vm.boardData.settings.color}};\"></div>\n							</div>\n					</md-list-item>\n					<div class=\"list-color-chooser\" ng-if=\"vm.showColorPicker\" style=\"margin-top: 1em;\">\n						<lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.boardData.settings.color\" ng-model=\"vm.boardData.settings.color\" ng-click=\"vm.selectBoardColor();\"></lk-color-chooser>\n					</div>\n					<md-list-item ng-if=\"vm.userType == \'admin\'\">\n					    <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}detailBoards/{{vm.boardID}}\">\n					        <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n					    </md-button>\n					</md-list-item>\n				</md-list>\n				</form>\n\n\n			</div>\n\n		</md-content>\n		<div flex=\"nogrow\" ng-if=\"vm.sidePanelMode == \'list\'\" class=\"board-panel-actions\" layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex layout=\"row\" layout-align=\"start center\">\n\n				<md-button ng-disabled=\"vm.selectedList.items.length > 0 || vm.selectedList.type == \'client-details\' || vm.userRole == \'client\'\" ng-if=\"vm.selectedList.uid\" class=\"md-warn\" ng-click=\"vm.deleteList(vm.selectedList.uid)\">\n					<md-icon md-font-icon=\"fa fa-trash\"></md-icon> Delete List\n				</md-button>\n			</div>\n			<div flex layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"vm.selectedList.uid\" class=\"md-accent md-raised\" ng-click=\"vm.updateList(vm.selectedList)\" ng-disabled=\"vm.forms.listForm.$pristine || vm.forms.listForm.$invalid\">Save Changes</md-button>\n				<md-button ng-if=\"!vm.selectedList.uid\" class=\"md-accent md-raised\" ng-click=\"vm.saveList(vm.selectedList)\" ng-disabled=\"vm.forms.listForm.$pristine || vm.forms.listForm.$invalid\">Save</md-button>\n			</div>\n		</div>\n		<!--<div flex=\"nogrow\" ng-if=\"vm.sidePanelMode == \'board\'\" class=\"board-panel-actions\" layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex layout=\"row\" layout-align=\"start center\">\n			</div>\n			<div flex layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"!vm.boardUpdating\" class=\"md-accent md-raised\" ng-click=\"vm.updateBoard(vm.boardData)\" ng-disabled=\"vm.forms.boardForm.$pristine || vm.forms.boardForm.$invalid\">Save Changes</md-button>\n				<md-button ng-if=\"vm.boardUpdating\" class=\"md-accent md-raised\" ng-disabled=\"true\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon></md-button>\n			</div>\n		</div>-->\n	</md-sidenav>\n\n	<!-- popup menus -->\n	<detail-menu ng-if=\"vm.selectedDetail\" selecteddetail=\"vm.selectedDetail\" x=\"vm.x\" y=\"vm.y\" board=\"vm.boardData\"></detail-menu>\n	<detail-list-menu ng-if=\"vm.activeList\" selectedlist=\"vm.activeList\" x=\"vm.x\" y=\"vm.y\" board=\"vm.boardData\"></detail-list-menu>\n	<!-- board settings and new list -->\n	<div class=\"adminja-board-controls\" layout=\"column\" layout-align=\"start center\">\n			<md-icon ng-if=\"vm.userRole != \'client\'\" class=\"adminja-icon-button\" style=\"padding-left:  2px;\" ng-click=\"vm.newList(vm.boardID)\" md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n			<md-icon class=\"adminja-icon-button\" style=\"padding-left:  6px;\" ng-click=\"vm.toggleSidePanel(\'board\')\" md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n	</div><!-- /task board filter bar -->\n</div><!-- board-wrapper -->\n");
$templateCache.put("app/app-directives/detail-board/detail-list-menu.tmpl.html","<div class=\"detail-list-menu md-whiteframe-8dp\" layout=\"column\" layout-align=\"layout-fill layout-fill\" style=\"\" ng-style=\"{\'left\': vm.x, \'top\': vm.y}\">\n	<md-content flex=\"auto\" class=\"small-scrollbar\" style=\"background-color: #fff;\" layout=\"column\" layout-align=\"start start\">\n		<md-list style=\"width: 100%;\">\n			<md-list-item  ng-click=\"vm.newDetail(vm.selectedList, \'note\', $event)\">\n				<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon>\n				<p>New Note</p>\n			</md-list-item>\n			<md-list-item  ng-click=\"vm.newDetail(vm.selectedList, \'url\', $event)\">\n				<md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon>\n				<p>New Bookmark</p>\n			</md-list-item>\n			<md-list-item  ng-click=\"vm.newDetail(vm.selectedList, \'contact\', $event)\">\n				<md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n				<p>New Contact</p>\n			</md-list-item>\n			<!-- absolutely not avail to clientUser -->\n			<div ng-if=\"!vm.isClientUser\">\n				<md-list-item  ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}detailBoards/{{vm.boardData.uid}}/lists/{{vm.selectedList.uid}}\" target=\"_blank\">\n					<md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n					<p>X-ray</p>\n				</md-list-item>\n			</div>\n		</md-list>\n	</md-content>\n</div>\n");
$templateCache.put("app/app-directives/detail-board/detail-menu.tmpl.html","<div class=\"detail-menu md-whiteframe-8dp\" layout=\"column\" layout-align=\"layout-fill layout-fill\" style=\"\" ng-style=\"{\'left\': vm.x, \'top\': vm.y}\">\n	<md-content flex=\"auto\" class=\"small-scrollbar\" style=\"background-color: #fff;\" layout=\"column\" layout-align=\"start start\">\n		<div ng-if=\"!vm.isClientUser\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 1em 1em 1em .5em;\">\n				<div flex=\"nogrow\" ng-click=\"vm.setColor(color, $event)\" ng-class=\"{\'selected\': vm.selectedDetail.notecolor == color}\" ng-repeat=\"color in vm.colors | toArray: false  track by $index\" class=\"color-swatch\" style=\"background-color: {{color}}; cursor: pointer;\"></div>\n		</div>\n		<md-list style=\"width: 100%;\">\n			<md-list-item  ng-click=\"vm.editDetail(vm.selectedDetail, $event)\">\n				<md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n				<p>Edit</p>\n			</md-list-item>\n			<md-list-item  ng-click=\"vm.cloneDetail(vm.selectedDetail, $event)\">\n				<md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon>\n				<p>Clone</p>\n			</md-list-item>\n			<!-- absolutely not avail to clientUser -->\n			<div ng-if=\"!vm.isClientUser\">\n				<md-list-item  ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}detailBoards/{{vm.boardData.uid}}/lists/{{vm.selectedDetail.list}}/items/{{vm.selectedDetail.uid}}\" target=\"_blank\">\n					<md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n					<p>X-ray</p>\n				</md-list-item>\n			</div>\n		</md-list>\n	</md-content>\n	<div class=\"task-menu-controls\" ng-if=\"!vm.isClientUser && !vm.showDeleteConfirm\"  layout=\"row\" layout-align=\"start center\" >\n		<md-button style=\"margin-left:  0;\" ng-disabled=\"!vm.canDelete(vm.selectedDetail)\" class=\"md-warn\" ng-click=\"vm.showDeleteConfirm = true\">\n			<md-icon class=\"margin-right-0\" md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n			Delete\n		</md-button>\n	</div>\n	<div class=\"task-menu-controls\" style=\"background-color: pink;\" ng-if=\"!vm.isClientUser && vm.showDeleteConfirm\"  layout=\"row\" layout-align=\"start center\">\n		<span flex=\"40\" class=\"small padding-left-10\">Are you sure?</span>\n		<div flex=\"60\" layout=\"row\"  layout-align=\"end center\">\n			<md-button class=\"md-icon-button margin-left-0 margin-right-0\" flex=\"nogrow\" ng-click=\"vm.showDeleteConfirm = false\">\n				<md-icon class=\"margin-right-0\" md-font-icon=\"zmdi zmdi-close\"></md-icon>\n			</md-button>\n			<md-button flex=\"nogrow\"  ng-disabled=\"!vm.canDelete(vm.selectedDetail)\" class=\"md-warn\" ng-click=\"vm.deleteDetail(vm.selectedDetail, $event)\">\n				<md-icon class=\"margin-right-0\" md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n				Delete\n			</md-button>\n		</div>\n\n		</md-list>\n	</div>\n</div>\n");
$templateCache.put("app/app-directives/fab-button/fab-button.tmpl.html","<md-fab-speed-dial ng-cloak md-direction=\"{{vm.fabDirection}}\"  md-open=\"vm.fabStatus\"  ng-class=\"vm.fabAnimation\">\n    <md-fab-trigger >\n        <md-button data-gtm-open-shortcut-menu palette-background=\"green:500\" aria-label=\"Shortcut Menu\" class=\"md-fab md-fab-open\">\n            <md-icon md-svg-src=\"/assets/images/icons/ninja-star.svg\"><md-tooltip md-delay=\"2000\" md-direction=\"top\">Adminja Shortcuts</md-tooltip></md-icon>\n        </md-button>\n    </md-fab-trigger>\n    <md-fab-actions>\n        <md-button data-gtm-shortcut-add-task ng-show=\"vm.hasSpaces()\" aria-label=\"New Task\" md-colors=\"{background: \'orange-900\'}\" class=\"md-fab md-accent md-hue-1 md-raised md-mini\" ng-click=\"vm.newTask()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-check-square-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Add a Task </md-tooltip></md-icon>\n        </md-button>\n        <md-button data-gtm-shortcut-batch-tasks ng-show=\"vm.hasSpaces()\" aria-label=\"New Batch Tasks\" md-colors=\"{background: \'orange-900\'}\" class=\"md-fab md-accent md-hue-1 md-raised md-mini\" ng-click=\"vm.batchTasks()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-tasks\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Add Multiple Tasks</md-tooltip></md-icon>\n        </md-button>\n        <md-button data-gtm-shortcut-new-time-log ng-if=\"vm.userType != \'client\'\" ng-show=\"vm.hasSpaces()\" aria-label=\"New Time Log\" md-colors=\"{background: \'orange-800\'}\"  class=\"md-fab md-accent md-hue-1  md-raised md-mini\" ng-click=\"vm.newTime()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-timer\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Log Time</md-tooltip></md-icon>\n        </md-button>\n        <md-button data-gtm-shortcut-new-reminder ng-if=\"vm.userType == \'admin\' || vm.userType == \'betaTester\'\"  aria-label=\"New Reminder\" md-colors=\"{background: \'orange-700\'}\"  class=\"md-fab md-accent md-hue-1  md-raised md-mini\" ng-click=\"vm.newReminder()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon md-svg-src=\"/assets/images/icons/reminder.svg\" style=\"color: #fff;\"><md-tooltip md-direction=\"top\" md-delay=\"1000\">New Reminder</md-tooltip></md-icon>\n        </md-button>\n\n\n\n        <md-button data-gtm-shortcut-new-note ng-show=\"vm.hasSpaces()\" aria-label=\"New Note\" md-colors=\"{background: \'orange-700\'}\" class=\"md-fab md-hue-2 md-raised md-mini\" ng-click=\"vm.newFabDetail(\'note\')\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-file-text-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Save a Note</md-tooltip></md-icon>\n        </md-button>\n\n        <md-button data-gtm-shortcut-new-bookmark ng-show=\"vm.hasSpaces()\" aria-label=\"New Bookmark\" md-colors=\"{background: \'orange-700\'}\" class=\"md-fab md-hue-2  md-raised md-mini\" ng-click=\"vm.newFabDetail(\'url\')\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-bookmark\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Save a Bookmark</md-tooltip></md-icon>\n        </md-button>\n        <!-- <md-button ng-show=\"vm.hasSpaces()\" aria-label=\"New Contact\" md-colors=\"{background: \'orange-700\'}\" class=\"md-fab md-hue-2  md-raised md-mini\" ng-click=\"vm.newFabDetail(\'contact\')\">\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-account\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Save a Contact</md-tooltip></md-icon>\n        </md-button> -->\n        <md-button data-gtm-shortcut-new-lead-activity ng-if=\"vm.userType != \'client\'\" ng-show=\"vm.hasSpaces()\" aria-label=\"Log Lead Activity\" md-colors=\"{background: \'orange-600\'}\"  class=\"md-fab md-accent md-hue-1  md-raised md-mini\" ng-click=\"vm.newTouchpoint()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-comments-o\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Log Lead Activity</md-tooltip></md-icon>\n        </md-button>\n        <md-button data-gtm-shortcut-new-lead ng-if=\"vm.userType != \'client\'\" ng-show=\"vm.hasSpaces()\" aria-label=\"New Lead\" md-colors=\"{background: \'orange-500\'}\" class=\"md-fab md-hue-2  md-raised md-mini\" ng-click=\"vm.newLead()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"fa fa-filter\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Add a New Lead</md-tooltip></md-icon>\n        </md-button>\n        <md-button data-gtm-shortcut-new-workspace ng-if=\"vm.userType != \'client\'\" aria-label=\"New Space\" md-colors=\"{background: \'orange-400\'}\" class=\"md-fab md-raised md-mini\" ng-click=\"vm.newFabSpace()\">\n            <!-- <md-icon class=\"plus\" md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff;\" ></md-icon> -->\n            <!-- <md-icon class=\"md-fab-child-button svg-icon\" md-svg-src=\"/assets/images/icons/all-workspaces-alt2.svg\" style=\"color: #fff; margin-left: 7px;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">New Workspace</md-tooltip></md-icon> -->\n            <md-icon class=\"md-fab-child-button\" md-font-icon=\"zmdi zmdi-folder-outline\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"1000\">Add a New Workspace</md-tooltip></md-icon>\n        </md-button>\n\n        <!-- <md-button data-gtm-shortcut-help  ng-click=\"vm.getHelp()\" aria-label=\"Help\" md-colors=\"{background: \'orange-300\'}\" class=\"md-fab md-hue-2 md-raised md-mini\">\n            <md-icon md-font-icon=\"fa fa-life-ring\" style=\"color: #fff;\">\n                <md-tooltip md-direction=\"top\" md-delay=\"1000\">Docs and Help</md-tooltip>\n            </md-icon>\n        </md-button> -->\n\n\n        <!-- <md-button aria-label=\"Send Diagnostics\"class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.launchDiagnostics()\">\n            <md-icon md-font-icon=\"fa fa-medkit\" style=\"color: #fff;\" ><md-tooltip md-direction=\"top\" md-delay=\"400\">Bug Medic</md-tooltip></md-icon>\n        </md-button> -->\n    </md-fab-actions>\n</md-fab-speed-dial>\n\n");
$templateCache.put("app/app-directives/file-attachment-list/file-attachment-list.tmpl.html","<!-- <md-chips  ng-show=\"vm.files.length\" ng-model=\"vm.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n    <md-chip-template>\n         <strong>\n            <a ng-if=\"!$chip.source || $chip.source == \'firebaseStorage\'\" href=\"{{$chip.url}}\" target=\"_blank\" download>{{$chip.fileName}}</a>\n            <a ng-if=\"$chip.source == \'googleDrive\'\" href=\"{{$chip.url}}\"  target=\"_blank\">{{$chip.fileName}}</a>\n            <a ng-if=\"$chip.source == \'dropbox\'\" href=\"{{$chip.url}}\" target=\"_blank\">{{$chip.fileName}}</a>\n        </strong>\n    </md-chip-template>\n</md-chips>\n<div ng-if=\"vm.files.length\" layout=\"row\" layout-align=\"start start\" layout-wrap style=\"padding: 10px 0 10px 0;\">\n   <div flex=\"25\" ng-repeat=\"file in vm.files track by $index\" ng-if=\"isImage(file)\">\n       <a href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"background-image: url(\'{{file.thumbnail}}\');\" style=\"border: none;\"></div></a>\n   </div>\n</div>\n -->\n<div class=\"file-attachment-list\" layout=\"row\" layout-align=\"start center\" layout-wrap>\n\n  <div flex=\"nogrow\" class=\"file-attachment\"  ng-repeat=\"file in vm.files track by $index\" layout=\"column\" layout-align=\"end center\" >\n  <span ng-if=\"file.source != \'pendingDropbox\' && file.source != \'pendingGoogleDrive\' && file.source != \'pendingFirebaseStorage\'\">\n    <md-icon ng-if=\"removeable\" md-font-icon=\"zmdi zmdi-close-circle\" ng-click=\"removeFile(file, $event)\" class=\"delete-file\" ></md-icon>\n    <!-- if isImage image thumb -->\n      <a class=\"attachment-icon\"  href=\"{{file.url}}\" download=\"{{file.url}}\" target=\"_blank\">\n        <div class=\"attachment-thumbnail\" ng-if=\"isImage(file)\"  style=\"background-image: url(\'{{file.thumbnail}}\');\" style=\"border: none;\"></div>\n        <div class=\"\" ng-if=\"!isImage(file)\"><md-icon md-font-icon=\"fa fa-file-text-o\" style=\"font-size: 30px; line-height: 30px;\"></md-icon></div>\n      </a>\n\n    <!-- if !isImage default thumb -->\n      <label><a href=\"{{file.url}}\"  download=\"{{file.url}}\" target=\"_blank\">{{shortenFilename(file.fileName)}}</a>\n              <!-- <a ng-if=\"file.source == \'googleDrive\'\" href=\"{{file.url}}\"  download=\"{{file.url}}\" target=\"_blank\">{{shortenFilename(file.fileName)}}</a>\n              <a ng-if=\"file.source == \'dropbox\'\" href=\"{{file.url}}\" download>{{shortenFilename(file.fileName)}}</a> -->\n        </label>\n        <md-tooltip md-delay=\"1000\" md-direction=\"bottom\">Download {{file.fileName}}</md-tooltip>\n    </span>\n    <span ng-if=\"file.source == \'pendingDropbox\' || file.source == \'pendingGoogleDrive\' || file.source == \'pendingFirebaseStorage\'\">\n      <md-tooltip md-delay=\"500\">File is currently in the copy queue. It will be available shortly.</md-tooltip>\n      <!-- if isImage image thumb -->\n        <span class=\"attachment-icon\">\n          <div class=\"attachment-thumbnail\" style=\"border: none;\"><md-icon md-font-icon=\"fa fa-refresh\"></md-icon></div>\n        </span>\n        <label>{{shortenFilename(file.fileName)}}</label>\n      </span>\n  </div>\n</div>\n");
$templateCache.put("app/app-directives/file-attachments/file-attachments.tmpl.html","<div class=\"attachment-list dropzone md-padding\"\n    ngf-multiple=\"true\"\n    ngf-max-files=\"5\"\n    ngf-max-size=\"5mb\"\n    ngf-drop=\"uploadFile($files)\"\n    ngf-drag-over-class=\"\'dragover\'\"\n    style=\"padding-top: 5px;\">\n\n    <div layout=\"row\" layout-align=\"start center\">\n        <p flex=\"50\" class=\"task-budget-label\" style=\"margin:0; padding:0;\">Attachments</p>\n        <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n\n                <a class=\"md-button md-icon-button\" flex=\"nogrow\" href=\"javascript:;\" lk-google-picker on-picked=\"vm.onPicked(docs)\" on-loaded=\"vm.onLoaded()\" on-cancel=\"vm.onCancel()\">\n                    <md-icon md-font-icon=\"zmdi zmdi-google-drive\"></md-icon>\n                    <md-tooltip>Attach Files from Google Drive </md-tooltip>\n                </a>\n                <a class=\"md-button md-icon-button\" flex=\"nogrow\" href=\"javascript:;\" drop-box-picker dbpicker-files=\"vm.files\" counter=\"vm.count\" form=\"vm.form\">\n                    <md-icon md-font-icon=\"fa fa-dropbox\"></md-icon>\n                    <md-tooltip>Attach Files from Dropbox </md-tooltip>\n                </a>\n                <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-disabled=\"!vm.status\" ng-show=\"!vm.isUploading\"\n                        class=\"md-primary \"\n                        ngf-select=\"uploadFile($files)\"\n                        ngf-multiple=\"true\"\n                        ngf-max-files=\"5\"\n                        ngf-max-size=\"5mb\"\n                        aria-label=\"upload\">\n                    <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon>\n                    <md-tooltip>Upload files from your computer</md-tooltip>\n                </md-button>\n\n                <md-button  flex=\"nogrow\" ng-show=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n                     <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n                        Uploading\n                </md-button>\n                <!-- <div class=\"dropzone text-center\">\n                    <p class=\"center md-subhead\" style=\"margin:0; padding:0;\"><md-icon md-font-icon=\"zmdi zmdi-upload\"></md-icon></p>\n                </div> -->\n        </div>\n    </div>\n    <p flex=\"100\" class=\"md-subhead instructions center\">Release here to upload</p>\n    <md-chips  ng-show=\"vm.files.length\" ng-model=\"vm.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n        <md-chip-template>\n            <div ng-if=\"$chip.source != \'pendingDropbox\' && $chip.source != \'pendingGoogleDrive\' && $chip.source != \'pendingFirebaseStorage\'\">\n                 <strong>\n                    <a ng-if=\"!$chip.source || $chip.source == \'firebaseStorage\'\" href=\"{{$chip.url}}\" download={{$chip.url}} target=\"_blank\">{{$chip.fileName}}</a>\n                    <a ng-if=\"$chip.source == \'googleDrive\'\" download=\"{$chip.url}}\" href=\"{{$chip.url}}\"  target=\"_blank\">{{$chip.fileName}}</a>\n                    <a ng-if=\"$chip.source == \'dropbox\'\" download=\"{{$chip.url}}\" href=\"{{$chip.url}}\" target=\"_blank\">{{$chip.fileName}}</a>\n                </strong>\n            </div>\n            <div ng-if=\"$chip.source == \'pendingDropbox\' || $chip.source == \'pendingGoogleDrive\' || $chip.source == \'pendingFirebaseStorage\'\">\n\n                 <md-icon style=\"font-size: 12px;\" md-font-icon=\"fa fa-refresh\"></md-icon><md-tooltip md-delay=\"500\">File is currently in the copy queue. It will be available shortly.</md-tooltip>\n                <span>File Copy Pending</span>\n            </div>\n        </md-chip-template>\n    </md-chips>\n\n\n</div>\n");
$templateCache.put("app/app-directives/file-picker/file-picker.tmpl.html","<div class=\"attachment-list dropzone\"\n    ngf-multiple=\"true\"\n    ngf-max-files=\"5\"\n    ngf-max-size=\"5mb\"\n    ngf-drop=\"uploadFile($files)\"\n    ngf-drag-over-class=\"\'dragover\'\"\n    style=\"padding-top: 5px;\">\n\n   <div layout=\"row\" layout-align=\"left center\">\n        <a flex=\"nogrow\" class=\"md-button-small md-button \" flex=\"nogrow\" href=\"javascript:;\" lk-google-picker on-picked=\"vm.onPicked(docs)\" on-loaded=\"vm.onLoaded()\" on-cancel=\"vm.onCancel()\">\n            <md-icon md-font-icon=\"zmdi zmdi-google-drive\"></md-icon> Google Drive\n            <md-tooltip>Attach Files from Google Drive </md-tooltip>\n        </a>\n        <a class=\"md-button-small md-button \" flex=\"nogrow\" href=\"javascript:;\" drop-box-picker dbpicker-files=\"vm.files\" counter=\"vm.count\" form=\"vm.form\">\n            <md-icon md-font-icon=\"fa fa-dropbox\"></md-icon> Dropbox\n            <md-tooltip>Attach Files from Dropbox </md-tooltip>\n        </a>\n        <md-button flex=\"nogrow\" class=\"md-button-small \" ng-disabled=\"vm.disabled\" ng-show=\"!vm.isUploading\"\n                class=\"md-primary \"\n                ngf-select=\"uploadFile($files)\"\n                ngf-multiple=\"true\"\n                ngf-max-files=\"5\"\n                ngf-max-size=\"5mb\"\n                aria-label=\"upload\">\n            <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Upload\n            <md-tooltip>Upload files from your computer</md-tooltip>\n        </md-button>\n\n        <md-button  flex=\"nogrow\" ng-show=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n             <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n                Uploading\n        </md-button>\n        <p flex=\"auto\" style=\"text-align: center; font-size: 1em; color: #bbb;\">Drop here to upload</p>\n    </div>\n\n</div>\n");
$templateCache.put("app/app-directives/global-timer/global-timer.tmpl.html","<div class=\"globaltimer\" layout=\"column\" layout-align=\"center none\" style=\"padding-left: 1em; padding-right: 1em;\">\n  <div flex=\"1\" class=\"timer-task-title\" style=\"font-size: 10px; padding: .5em 0 0 0; margin:0;\">\n    <md-icon md-font-icon=\"zmdi zmdi-check-circle\" style=\"font-size: 12px; color:#fff!important;\"></md-icon>&nbsp;\n      Coordinate Office Lunch for Next Friday\n  </div>\n  <div flex=\"2\" layout=\"row\" layout-align=\"start center\">\n    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" style=\" padding-right: 1em;\">\n      <!-- Controls -->\n       <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Pause Global timer\"><md-icon md-font-icon=\"zmdi zmdi-pause\"></md-icon></md-button>\n        <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Start Global timer\"><md-icon md-font-icon=\"zmdi zmdi-play\"></md-icon></md-button>\n        <md-button flex=\"none\" class=\"md-icon-button timer-control\" aria-label=\"Stop Global timer\"><md-icon md-font-icon=\"zmdi zmdi-stop\"></md-icon></md-button>\n    </div>\n      <div flex=\"nogrow\" style=\"padding-right: 1em;\">\n        <!-- Timer -->\n        <span class=\"timer-count\">15:32</span>\n      </div>\n      <!-- Task name and budget -->\n      <p flex=\"auto\" style=\"color: #fff; font-size: 10px;\" class=\"timer-task-info\">\n        <span class=\"timer-budget\">Budget: .75hr</span>\n      </p>\n\n      <div flex=\"nogrow\" style=\"padding-left: 2em;\">\n        <!-- Dropdown -->\n        <md-input-container>\n\n               <md-select placeholder=\"Choose client\" ng-model=\"ctrl.userState\">\n                   <md-option  ng-repeat=\"client in clients | orderBy: \'order\' track by client.uid\" value=\"{{client.uid}}\">\n                   {{client.firstname}} {{client.lastname}}\n                 </md-option>\n               </md-select>\n        </md-input-container>\n      </div>\n    </div>\n\n\n\n</div>\n\n");
$templateCache.put("app/app-directives/gravatar-image/gravatar-image.tmpl.html","");
$templateCache.put("app/app-directives/invoice-manager/invoice-manager.tmpl.html","<div layout=\"column\"  layout-padding class=\"billing-manager\">\n\n    <div class=\"billing-stats\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n      <div flex=\"100\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\">\n        <div flex=\"30\" style=\"min-width: 300px; max-width: 300px;\">\n              <md-input-container style=\"margin-top: 2em; transform: scale(1.5);\">\n                <md-select  data-gtm-billing-report-range-changed class=\"md-no-underline\" ng-change=\"vm.getInvoices(vm.viewYear.start, vm.viewYear.end)\" style=\"margin: 0; max-width: 175px; margin-left: auto; margin-right: auto;\" flex=\"nogrow\" ng-model=\"vm.viewYear\">\n                    <md-option ng-repeat=\"option in vm.yearList track by start+$index\" ng-value=\'option\'>\n                       Billing for {{option.label}}\n                    </md-option>\n                </md-select>\n            </md-input-container>\n            <div ng-if=\"vm.workspace\">\n              <md-button  ng-click=\"vm.changeBillingModuleState(\'activity\');\" class=\"md-primary\"><md-icon md-font-icon=\"fa fa-angle-left\"></md-icon> Manage Packages </md-button>\n              <md-button  ng-click=\"vm.newInvoice()\" class=\"md-raised md-accent padding-right-10\"><md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon> New Invoice</md-button>\n\n            </div>\n        </div>\n        <div flex=\"auto\">&nbsp;\n        </div>\n        <div flex=\"30\" style=\"min-width: 150px; max-width: 300px;\">\n          <div md-whiteframe=\"1\" class=\"billing-stats-box billing-stats-box-invoiced\" layout=\"column\" layout-align=\"center layout-fill\" content-padding class=\"margin-20\">\n            <p class=\"billing-balance-icon\">\n              <!-- <md-icon md-font-icon=\"fa fa-file\"></md-icon>  -->\n            Invoiced</p>\n            <p class=\"billing-balance-stats center\">\n              <span ng-bind-html=\"vm.currency\"></span>{{vm.invoiced  | number:2}}\n            </p>\n            <!-- <p class=\"billing-balance-label center\">Invoiced</p> -->\n\n          </div>\n        </div>\n        <div flex=\"30\" style=\"min-width: 150px; max-width: 300px;\">\n          <div md-whiteframe=\"1\" class=\"billing-stats-box billing-stats-box-received\" layout=\"column\" layout-align=\"center layout-fill\" content-padding class=\"margin-20\">\n            <p class=\"billing-balance-icon\">\n              <!-- <md-icon md-font-icon=\"fa fa-money\"></md-icon>  -->\n              Received</p>\n            <p class=\"billing-balance-stats center\">\n              <span ng-bind-html=\"vm.currency\"></span>{{vm.received  | number:2}}\n            </p>\n            <!-- <p class=\"billing-balance-label center\">Invoiced</p> -->\n\n          </div>\n        </div>\n        <div flex=\"30\" style=\"min-width: 150px; max-width: 300px;\">\n          <div md-whiteframe=\"1\" class=\"billing-stats-box billing-stats-box-outstanding\" layout=\"column\" layout-align=\"center layout-fill\" content-padding class=\"margin-20\">\n            <p class=\"billing-balance-icon\">\n              <!-- <md-icon md-font-icon=\"fa fa-smile-o\"></md-icon>  -->\n              Outstanding</p>\n            <p class=\"billing-balance-stats center\">\n              <span ng-bind-html=\"vm.currency\"></span>{{vm.outstanding  | number:2}}\n            </p>\n            <!-- <p class=\"billing-balance-label center\">Outstanding</p> -->\n\n          </div>\n        </div>\n\n        <div flex=\"30\" style=\"min-width: 150px; max-width: 300px;\">\n          <div md-whiteframe=\"1\" class=\"billing-stats-box billing-stats-box-due\" layout=\"column\" layout-align=\"center layout-fill\" content-padding class=\"margin-20\">\n            <p class=\"billing-balance-icon\">\n                <!-- <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon> -->\n                 Past Due</p>\n            <p class=\"billing-balance-stats center\">\n              <span ng-bind-html=\"vm.currency\"></span>{{vm.pastDue  | number:2}}\n            </p>\n            <!-- <p class=\"billing-balance-label center\">Past Due</p> -->\n          </div>\n        </div>\n\n      </div>\n    </div><!-- first row-->\n    <div class=\"billing-invoices-container padding-top-0\" >\n      <p class=\"margin-top-0\">Most recent:</p>\n      <div class=\"invoice-list\" layout=\"row\" layout-align=\"start start\" style=\"overflow-x: scroll; max-width: 100%; padding-bottom: 10px;\">\n        <md-card data-gtm-billing-report-view-invoice  ng-repeat=\"invoice in vm.invoices | orderBy: \'-info.number\' | limitTo: vm.invoiceCardLimit track by invoice.uid\" target=\"_blank\" ng-click=\"vm.selectInvoice(invoice)\" layout-align=\"start center\" class=\"invoice-item\"  ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == invoice.uid, \'due\': vm.now > invoice.due && invoice.balance > .5 }\"  style=\"cursor: pointer;\">\n          <span class=\"invoice-number\">#{{invoice.info.number}}</span>\n          <span class=\"invoice-date\">{{invoice.info.date | amDateFormat: vm.settings.amDateFormat}}</span>\n          <p class=\"invoice-total\"><strong><span ng-bind-html=\"vm.currency\"></span>{{invoice.info.total | number:2}}</strong></p>\n          <!-- <p class=\"invoice-total\"><strong><span ng-bind-html=\"vm.currency\"></span>{{invoice.info.balance | number:2}}</strong></p> -->\n          <p class=\"invoice-number margin-top-0 padding-top-0 margin-bottom-0\" md-truncate style=\"text-align:center;\">{{invoice.info.recipient.name}}</p>\n          <!-- <span class=\"invoice-total\"><span ng-bind-html=\"vm.currency\"></span>{{invoice.paymentsReceived | number:2}} Received</span> -->\n            <md-card-footer class=\"invoice-status\" ng-class=\"{\'due\': vm.now > invoice.info.due && invoice.info.balance > 0 , \'paid\': invoice.info.balance <= 0}\">\n            <p ng-if=\"invoice.info.balance > 0 && vm.now > invoice.info.due\">\n              Past Due\n            </p>\n            <p ng-if=\"invoice.info.balance > 0 && vm.now < invoice.info.due\">\n              Outstanding\n            </p>\n            <p ng-if=\"invoice.info.balance <= 0\">\n              Paid\n            </p>\n            <!-- <p>{{invoice.balance}}</p> -->\n            <!-- <md-button class=\"md-raised md-secondary\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}invoices/{{invoice.uid}}\">X-ray</md-button> -->\n          </md-card-footer>\n        </md-card>\n\n      </div>\n    </div><!-- Invoices container -->\n    <div class=\"billing-invoice-report-container\">\n      <div ng-if=\"vm.showInvoiceGrid && vm.invoiceGridOptions.data.length > 0\" ui-grid=\"vm.invoiceGridOptions\" ui-grid-auto-resize ui-grid-expandable ui-grid-exporter class=\"invoice-grid\"></div>\n      <md-button ng-if=\"!vm.showInvoiceGrid\" ng-disabled=\"true\" flex=\"nogrow\" class=\"md-button-small md-secondary\" >\n          <md-icon class=\"report-control-button\" md-font-icon=\"zmdi zmdi-refresh fa-spin\">\n              <md-tooltip>\n                  Loading Invoices\n              </md-tooltip>\n          </md-icon>\n          Fetching Invoice History\n      </md-button>\n\n      <div layout-fill layout=\"column\" layout-align=\"center center\" ng-if=\"vm.showInvoiceGrid && vm.invoiceGridOptions.data.length == 0\" style=\"background-color: #fff;\">\n          <div layout=\'row\' layout-align=\"center center\">\n              <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-exclamation-circle\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n              <h3 flex=\"nogrow\" class=\"center md-title\">No Invoices Found</h3>\n          </div>\n          <p class=\"center md-subhead\">Please select a different year or create some invoices for your clients.</p>\n\n      </div>\n    </div>\n\n\n</div>\n");
$templateCache.put("app/app-directives/invoice-editor/invoice-editor.tmpl.html","            <div layout=\"row\" class=\"invoice-editor\" layout-align=\"start start\" style=\"\" layout-fill>\n              <div flex=\"40\"  class=\"hide-for-print\" layout-fill>\n                  <div style=\"background-color: rgb(250,250,250);\">\n                      <h3 class=\"md-title center\">Add Unbilled Items</h3>\n                      <div layout=\"row\" layout-align=\"start center\">\n                        <div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n                          <!-- <md-button  ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\" ng-click=\"vm.newInvoice()\" class=\"md-accent\">New Invoice</md-button> -->\n                        </div>\n                        <div flex=\"50\" layout=\"row\" layout-align=\"end center\" class=\"padding-right-20 padding-bottom-20\">\n                          <md-button ng-click=\"vm.addSelectedToInvoice(vm.invoiceService.selectedInvoice, vm.selectedTime, vm.selectedCharges)\" class=\"md-accent button-add-selected-items padding-right-10\" ng-class=\"{\'md-raised\': vm.size(vm.selectedTime) > 0 || vm.size(vm.selectedCharges) > 0}\" ng-disabled=\"(vm.size(vm.selectedTime) < 1 && vm.size(vm.selectedCharges) < 1) || vm.invoiceService.invoiceSaving\"><md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon> Add Selected Items</md-button>\n\n                           <md-button ng-click=\"vm.cancel()\" class=\"button-close\">\n                            <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n                            <span ng-if=\"!vm.invoiceService.selectedInvoice.timeStamp\">Cancel</span>\n                            <span ng-if=\"vm.invoiceService.selectedInvoice.timeStamp\">Close</span>\n                          </md-button>\n                          <md-button class=\"md-button-small\" ng-click=\"vm.showExperience(\'1622057370xQem1367\')\">\n                              <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n                              <md-tooltip md-delay=\"500\">How does this work?</md-tooltip>\n                            </md-button>\n                        </div>\n                      </div>\n                  </div>\n                  <md-content class=\"small-scrollbar\" style=\"overflow-y: scroll; padding-top: 0; max-height:  80%; height: auto;\">\n                    <div ng-if=\"vm.numCandidates() == 0\">\n                      <div ng-if=\"vm.initializing\" layout=\"column\" layout-align=\"center center\">\n                        <p class=\"md-subhead center\"><md-icon md-font-icon=\"zmdi zmdi-refresh fa-spin fa-spin\" style=\"min-width: 48px; width: 48px; font-size: 48px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></p>\n                        <p class=\"md-subhead center\" style=\"color: #999;\"> Fetching Available Charges &amp; Time</p>\n                      </div>\n                      <div ng-if=\"!vm.initializing\" class=\"invoice-no-candidates\">\n                        <p class=\"center margin-bottom-40\"><md-icon class=\"green\" md-font-icon=\"fa fa-check\"></md-icon></p>\n                        <p class=\"md-subhead center\">There are no charges or billable time to invoice.</p>\n                      </div>\n                    </div>\n                    <div ng-if=\"vm.numCandidates() > 0 && !vm.initializing\">\n                      <div class=\"expanding-packages\">\n                        <div class=\"package-charges-package\"  ng-if=\"vm.getPackageCount(clientPackage.uid) > 0\" ng-repeat=\"clientPackage in vm.workspace.packages | toArray: false | orderBy: [\'-timeStamp\'] track by $index + uid\">\n                          <div class=\"package-charges-expander\" layout=\"row\" layout-align=\"layout-fill center\" ng-click=\"vm.expose(clientPackage.uid)\">\n                            <div flex=\"10\">\n                              <md-icon style=\"font-size: 2em; cursor: pointer; margin-left: .5em; margin-top: 16px;\" ng-if=\"vm.exposed[clientPackage.uid]\"  md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n                              <md-icon style=\"font-size: 2em; cursor: pointer; margin-left: .5em; margin-top: 16px;\" ng-if=\"!vm.exposed[clientPackage.uid]\"  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                            </div>\n                            <div flex>\n                              <p class=\"md-subhead\">{{clientPackage.startDate | amDateFormat: \'MMM D\'}}:  {{clientPackage.label}}</p>\n                            </div>\n                            <div flex=\"30\">\n                              <p class=\"md-subhead right padding-right-20 package-status-{{clientPackage.status}}\" style=\"font-size: 12px;\">{{vm.packageTypeLabel(clientPackage.type)}}</p>\n                            </div>\n                            <div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n                              <md-button  ng-click=\"vm.addEntirePackageToInvoice(vm.invoiceService.selectedInvoice, vm.timeCandidates[clientPackage.uid], vm.chargeCandidates[clientPackage.uid])\" ng-disabled=\"vm.invoiceService.invoiceSaving\" class=\"md-secondary button-add-selected-items\">\n                                <!-- <md-icon md-font-icon=\"fa fa-plus\"></md-icon> -->\n                                Add {{vm.getPackageCount(clientPackage.uid)}} items\n                              </md-button>\n                              <!-- <p class=\"md-subhead\" style=\"font-size: .85em;\">{{vm.getPackageCount(clientPackage.uid)}} items</p> -->\n                            </div>\n                          </div>\n                          <div class=\"package-expanded-details\" ng-if=\"vm.exposed[clientPackage.uid]\">\n                            <div class=\"charge-candidate-list invoice-candidate-list\" ng-if=\"vm.candidateCount(vm.chargeCandidates[clientPackage.uid])  > 0\">\n                              <p class=\"md-subhead package-detail-group-heading margin-bottom-0\">Charges</p>\n                              <div layout=\"row\" layout-align=\"layout-fill center\">\n                                  <div flex=\"10\" class=\"package-table-cell center\">\n                                    <p class=\"package-table-header\">Select</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Date</p>\n                                  </div>\n                                  <div flex=\"40\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Description</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Quantity</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Amount</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Total</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"hide-xs hide-sm hide-md package-table-cell\">\n                                    <p class=\"package-table-header\"></p>\n                                  </div>\n                              </div><!-- charges line-item-header-row -->\n                              <div class=\"package-line-item\" ng-if=\"charge.uid && !charge.invoiced\" ng-repeat=\"charge in vm.chargeCandidates[clientPackage.uid]  track by $index+uid\" layout=\"row\" layout-align=\"layout-fill center\">\n                                <div flex=\"10\" class=\"package-table-cell padding-left-10\">\n                                    <md-checkbox ng-if=\"!charge.invoiced && !charge.pending\" ng-disabled=\"vm.isClientUser\" style=\"margin-bottom: 0;\" ng-model=\"charge.selected\" ng-click=\"vm.chargeOptionToggled(charge)\" aria-label=\"select\"></md-checkbox>\n                                    <md-icon  ng-if=\"charge.invoiced && !charge.pending\" md-font-icon=\"fa fa-check\" style=\"padding-left:3px; color: green;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n                                    <md-icon  ng-if=\"charge.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\"  style=\"margin-left:21px; margin-top: 10px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n                                </div>\n                                <div flex=\"10\" class=\"package-table-cell\">\n                                  <p>{{charge.date | amDateFormat: vm.settings.shortDateFormat}}</p>\n                                </div>\n                                <div flex=\"40\" class=\"package-table-cell\">\n                                  <p>{{charge.description}}</p>\n                                </div>\n                                <div flex=\"10\" class=\"package-table-cell \">\n                                  <p class=\"padding-left-20\">{{charge.quantity}}</p>\n                                </div>\n                                <div flex=\"10\" class=\"package-table-cell\">\n                                  <p><span ng-bind-html=\"vm.currency\"></span>{{charge.amount | number: 2}}</p>\n                                </div>\n                                <div flex=\"10\" class=\"package-table-cell\">\n                                  <p><span ng-bind-html=\"vm.currency\"></span>{{charge.total | number: 2}}</p>\n                                </div>\n                                <div flex=\"10\" class=\"hide-xs hide-sm hide-md package-table-cell\">\n                                  <md-button class=\"md-icon-button\" ng-click=\"vm.editCharge(charge)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n                                </div>\n\n                              </div><!-- charges-line-items -->\n                            </div>\n                            <div class=\"time-candidate-list invoice-candidate-list\" ng-if=\"clientPackage.type == \'hourly\' && vm.candidateCount(vm.timeCandidates[clientPackage.uid]) > 0\">\n                              <p class=\"md-subhead package-detail-group-heading margin-bottom-0\">Billable Time</p>\n                              <div layout=\"row\" layout-align=\"layout-fill center\">\n                                  <div flex=\"10\" class=\"package-table-cell center\">\n                                    <p class=\"package-table-header\">Select</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Date</p>\n                                  </div>\n                                  <div flex=\"40\" class=\"package-table-cell\" >\n                                    <p class=\"package-table-header\">Description</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\">Logged</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\" >Rate</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p class=\"package-table-header\" >Total</p>\n                                  </div>\n                                  <div flex=\"10\" class=\"hide-xs hide-sm hide-md package-table-cell\">\n                                    <p class=\"package-table-header\" ></p>\n                                  </div>\n                              </div><!-- time header row -->\n                              <div class=\"package-line-item\" ng-click=\"vm.editTime(entry)\" ng-if=\"!entry.exempt && !entry.invoiced\" ng-repeat=\"entry in vm.packageCounts[clientPackage.uid] = (vm.timeCandidates[clientPackage.uid] | orderBy: [\'-logDate\']) track by $index + uid\" layout=\"row\" layout-align=\"layout-fill center\">\n                                  <div flex=\"10\" class=\"padding-left-10\">\n                                    <md-checkbox ng-if=\"!entry.invoiced && !entry.pending\" style=\"margin-bottom: 0;\" ng-model=\"entry.selected\" ng-click=\"vm.timeOptionToggled(entry)\" ng-disabled=\"vm.isClientUser\" aria-label=\"select\"></md-checkbox>\n                                    <md-icon  ng-if=\"entry.invoiced && !entry.pending\" md-font-icon=\"fa fa-check\" style=\"margin-bottom: 0;  color: green;\"><md-tooltip md-delay=\"1000\">Item already invoiced.</md-tooltip></md-icon>\n                                    <md-icon  ng-if=\"entry.pending\" md-font-icon=\"zmdi zmdi-center-focus-weak\" style=\"margin-left:21px; margin-top: 10px;\"><md-tooltip md-delay=\"1000\">Item applied to a pending invoice.</md-tooltip></md-icon>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                    <p>\n                                      {{entry.logDate | amDateFormat: vm.settings.shortDateFormat}}\n                                    </p>\n                                  </div>\n                                  <div flex=\"40\" class=\"package-table-cell\">\n                                    <p>\n                                      {{entry.description}}\n                                    </p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\">\n                                      <p>\n                                        {{entry.logged | HandM}}\n                                      </p>\n                                  </div>\n\n                                  <div flex=\"10\" class=\"package-table-cell\" >\n                                    <p class=\"package-table-cell\"  ng-if=\"!entry.exempt\">\n                                      <span ng-bind-html=\"vm.currency\"></span>{{entry.rate | number: 2}}\n                                    </p>\n                                  </div>\n                                  <div flex=\"10\" class=\"package-table-cell\" >\n                                    <p class=\"package-table-cell\"  ng-if=\"!entry.exempt\">\n                                      <span ng-bind-html=\"vm.currency\"></span>{{vm.timeEntryTotal(entry) | number: 2}}\n                                    </p>\n                                  </div>\n                                  <div flex=\"10\" class=\"hide-xs hide-sm hide-md\">\n                                    <md-button class=\"md-icon-button\" ng-click=\"vm.openTime(entry)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n                                  </div>\n\n                              </div><!-- time package-line-item -->\n                            </div><!-- time-candidate-list -->\n                          </div><!-- expanded-details -->\n\n                        </div><!-- package-repeat -->\n\n                      </div><!-- expanding-packages-->\n                    </div>\n                  </md-content>\n              </div>\n              <div flex=\"60\"   layout-fill>\n                  <div ng-if=\"!vm.showDeleteConfirm\" class=\"hide-for-print\" class=\"md-padding\" layout=\"row\" layout-align=\"layout-fill center\" style=\"background-color: rgb(250,250,250);\">\n                    <div layout=\"row\" flex=\"nogrow\" layout-align=\"start center\">\n\n                      <md-button print-btn ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon> Print</md-button>\n\n                      <md-button ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\" ng-click=\"vm.emailInvoice(vm.invoiceService.selectedInvoice)\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Email</md-button>\n\n                      <md-menu md-position-mode=\"target-right bottom\" md-offset=\"0 5\">\n                          <md-button ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\"  ng-Click=\"$mdMenu.open($event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-money-box\"></md-icon> Payments <md-icon  md-font-icon=\"fa fa-caret-down\" style=\"font-size: 12px;\"></md-button>\n                          <md-menu-content class=\"md-dense\">\n                            <md-menu-item>\n                                <md-button ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\" ng-click=\"vm.newPayment(vm.invoiceService.selectedInvoice)\" flex=\"nogrow\" class=\"\"><md-icon md-font-icon=\"zmdi zmdi-money-box\"></md-icon> Log a Payment</md-button>\n                            </md-menu-item>\n                              <md-menu-item>\n                                  <md-button ng-disabled=\"!vm.invoiceService.selectedInvoice.paymentLink\" target=\"_blank\" href=\"{{vm.invoiceService.selectedInvoice.paymentLink}}\" flex=\"nogrow\" class=\"\">\n                                    <md-icon md-font-icon=\"zmdi zmdi-link\" style=\"font-size: 1.6em\"></md-icon>\n                                    Client Payment Link\n                                </md-button>\n                              </md-menu-item>\n                          </md-menu-content>\n                      </md-menu>\n\n\n\n                    </div>\n                    <div layout=\"row\" flex layout-align=\"end center\">\n\n                      <!-- <md-button ng-disabled=\"!vm.invoiceService.selectedInvoice.timeStamp\"  flex=\"nogrow\" class=\"\" ng-click=\"vm.requestPDF(vm.invoiceService.selectedInvoice)\"><md-icon md-font-icon=\"fa fa-file-pdf-o\"></md-icon> Request a PDF</md-button> -->\n\n                      <div flex=\"nogrow\" ng-if=\"vm.invoiceService.selectedInvoice.timeStamp\">\n                        <md-button ng-if=\"vm.invoiceService.invoiceSaving && !vm.invoiceService.invoiceError\" flex=\"nogrow\"  class=\"md-accent\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 11px; line-height: 25px;\"></md-icon>Updating</md-button>\n                        <md-button ng-if=\"!vm.invoiceService.invoiceSaving && !vm.invoiceService.invoiceError\" flex=\"nogrow\"  class=\"md-accent\"><md-icon md-font-icon=\"fa fa-check\" style=\"font-size: 11px; line-height: 25px;\"></md-icon>Saved</md-button>\n                        <md-button ng-if=\"vm.invoiceService.invoiceError\" flex=\"nogrow\"  class=\"md-warn\"><md-icon md-font-icon=\"zmdi zmdi-alert-octagon\" style=\"font-size: 11px; line-height: 25px; color: red;\"></md-icon>Error!</md-button>\n                      </div>\n                      <md-button ng-if=\"vm.invoiceService.selectedInvoice.timeStamp\" ng-click=\"vm.showDeleteConfirm = true\" class=\"md-warn md-icon-button\"><md-tooltip md-delay=\"500\">Delete Invoice</md-tooltip><md-icon  md-font-icon=\"fa fa-trash\"></md-icon></md-button>\n                      <md-button ng-if=\"vm.userType == \'admin\'\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}invoices/{{vm.invoiceService.selectedInvoice.uid}}\"><md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray</md-button>\n                    </div>\n                  </div>\n                  <div ng-if=\"vm.showDeleteConfirm\" class=\"hide-for-print confirm-delete package-invoice-controls md-padding\" layout=\"row\" layout-align=\"center center\">\n                    <p flex=\"nogrow\" class=\'center\"\' style=\"margin:0;\">\n                        Permanently delete Invoice#{{vm.invoiceService.selectedInvoice.info.number}}?<br>\n                        <small>All items on this invoice will return to \"uninvoiced\" status.</small>\n                    </p>\n                    <md-button class=\"\" ng-click=\"vm.showDeleteConfirm = false\">\n                        cancel\n                    </md-button>\n                    <md-button data-gtm-delete-time-log class=\"md-warn md-raised\" ng-click=\"vm.deleteInvoice(vm.invoiceService.selectedInvoice)\">\n                        Confirm\n                    </md-button>\n                  </div>\n                  <md-content class=\"small-scrollbar invoice-editor-content\" style=\"overflow-y: scroll; min-height:  80%; max-height: 80%; height: auto; padding-left: 1em; padding-right: 1em;\">\n                    <div layout=\"column\" layout-align=\"start layout-fill\" class=\"margin-bottom-40\">\n                        <div flex class=\"\"  ng-if=\"vm.invoiceService.selectedInvoice\" layout=\"column\" >\n                          <div id=\"invoice-wrapper\" ng-bind-html=\"vm.invoiceHTML\" print-section></div>\n                        </div><!-- // invoice -->\n                    </div><!-- invoice card wrapper -->\n                  </md-content>\n                  <div layout=\"row\" layout-align=\"center center\"  style=\"border-top: 1px solid #efefef;\">\n                      <md-input-container style=\"width: 200px; max-width:200px; margin-bottom:0;\" class=\"margin-right-40\" flex=\"nogrow\">\n                        <label>Group time by:</label>\n                        <md-select class=\"md-no-underline\" flex=\"nogrow\" ng-model=\"vm.invoiceService.selectedInvoice.grouping\" ng-change=\"vm.changeGrouping(vm.invoiceService.selectedInvoice.grouping)\">\n                          <md-option ng-repeat=\"option in vm.groupingOptions track by $index\" ng-value=\"option.value\">\n                            {{option.label}}\n                          </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container flex=\"nogrow\" style=\"width: 100px; max-width: 100px; margin-bottom:0;\">\n                      <label style=\"font-size: 12px; padding-bottom: 10px; color: rgba(0,0,0,0.54);\">Show time details</label>\n                      <md-switch ng-disabled=\"vm.invoiceService.selectedInvoice.grouping == \'none\'\" class=\"md-secondary\" ng-model=\"vm.invoiceService.selectedInvoice.showTimeDetail\" ng-change=\"vm.timeDetailsToggled(vm.invoiceService.selectedInvoice)\"></md-switch>\n                    </md-input-container>\n                      <md-input-container ng-if=\"vm.user.profile.settings.paypalEnabled || vm.user.profile.settings.stripeEnabled\" style=\"width: 200px; max-width:200px; margin-bottom:0;\" class=\"margin-left-60\" flex=\"nogrow\">\n                        <label>\'Pay Now\' Button Uses:</label>\n                        <md-select class=\"md-no-underline\" flex=\"nogrow\" ng-model=\"vm.selectedPaymentProcessor\" ng-change=\"vm.changePaymentProcessor(vm.selectedPaymentProcessor)\">\n                          <md-option ng-selected=\"option.value == vm.selectedPaymentProcessor\" ng-repeat=\"option in vm.paymentProcessors track by $index\" ng-value=\"option.value\">\n                            <md-icon ng-if=\"option.value == \'stripe\'\" md-svg-src=\"/assets/images/icons/stripe.svg\" style=\"margin-right: .5em;  -webkit-filter: grayscale(1); filter: grayscale(1); opacity: .7;\"></md-icon>\n                            <md-icon ng-if=\"option.value == \'paypal\'\" md-font-icon=\"zmdi zmdi-paypal\" style=\"font-size: 1.6em\"></md-icon>\n                            <md-icon ng-if=\"option.value == \'url\'\" md-font-icon=\"zmdi zmdi-link\" style=\"font-size: 1.6em\"></md-icon>\n                            {{option.label}}\n                          </md-option>\n                        </md-select>\n                    </md-input-container>\n\n                  </div>\n              </div>\n            </div>\n\n          </div><!-- /main row for invoice editor -->\n");
$templateCache.put("app/app-directives/lead-activity-item/lead-activity-item.tmpl.html","<div  layout=\"column\" class=\"activity-item\">\n\n        <div style=\"cursor: pointer;\" ng-click=\"vm.editActivity(contact, $event)\" layout=\"row\" layout-align=\"space-between center\" class=\"activity-header\">\n            <div flex>\n                <p class=\"md-title\"><md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{vm.getColor(contact)}};\"></md-icon> {{vm.getType(contact)}}</p>\n            </div>\n            <div flex style=\"position: relative;\">\n                <p class=\"md-subhead text-right\" style=\"color: #666; padding-right: 3em;\">\n                    {{contact.timeStamp | amDateFormat: vm.settings.longDateFormat}}<br>\n                </p>\n                <md-menu class=\"lead-activity-item-menu\" flex=\"nogrow\" md-position-mode=\"target-right target\" >\n                    <md-button ng-Click=\"$mdMenu.open($event)\" class=\"md-icon-button\" style=\"margin-top: -9px; cursor: pointer;\">\n                        <md-icon  aria-label=\"Lead Options\" md-font-icon=\"zmdi zmdi-more-vert\" style=\"font-size: 1.5rem;\"></md-icon>\n                        <md-tooltip md-delay=\"1000\">Activity Options</md-tooltip></md-icon>\n                    </md-button>\n                    <md-menu-content class=\"md-dense \" >\n\n                        <md-menu-item>\n                            <md-button ng-click=\"vm.editActivity(contact, $event)\">\n                                <md-icon md-font-icon=\"fa fa-edit\" ></md-icon> Edit\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"vm.deleteActivity(contact, $event)\">\n                                <md-icon md-font-icon=\"fa fa-trash\" ></md-icon> Delete\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n\n                            <md-button ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}leadBoards/{{contact.leadBoard}}/leads/{{contact.lead}}/contacts/{{contact.uid}}\" target=\"_blank\">\n                            <md-icon md-font-icon=\"zmdi zmdi-code\" ></md-icon>\n                             X-ray\n                            </md-button>\n                        </md-menu-item>\n\n                    </md-menu-content>\n                </md-menu>\n            </div>\n        </div>\n        <div froala-view=\"contact.description\" style=\"cursor: pointer;\" ng-click=\"vm.editActivity(contact, $event)\" class=\"contact-description\"></div>\n        <p class=\"md-subhead\" ng-if=\"contact.files\" style=\"color: #666; font-size: 12px;\">Attachments</p>\n        <file-attachment-list ng-if=\"contact.files\" style=\"margin-bottom: 1em;\" files=\"contact.files\" removeable=\"false\"></file-attachment-list>\n        <div layout=\"row\" layout-align=\"start center\" class=\"activity-item-footer\">\n            <div flex=\"nogrow\">\n                <!-- <img class=\"avatar\" src=\"{{vm.thisUser.avatar}}\" style=\"border: 1px solid {{vm.thisUser.color}};\" /> -->\n                 {{vm.getUser(contact)}} logged this {{vm.getType(contact)}} at {{contact.timeStamp | amDateFormat: vm.settings.time}}\n            </div>\n            <div flex>\n            </div>\n\n        </div>\n\n</div>\n");
$templateCache.put("app/app-directives/lead-card/lead-card.tmpl.html","<md-card class=\"app-item lead-card\" ng-click=\"vm.openLead(lead, 0, $event)\" listid=\"{{lead.leadType}}\"  uid=\"{{lead.uid}}\" style=\"cursor: pointer;\">\n    <md-menu class=\"lead-action-menu\" flex=\"nogrow\" md-position-mode=\"target-right target\" >\n        <!-- Trigger element is a md-button with an icon -->\n\n        <md-button ng-Click=\"$mdMenu.open($event)\" class=\"lead-card-menu md-button-small\" style=\"margin-top: -9px; cursor: pointer;\">\n            <md-icon  aria-label=\"Lead Options\" md-font-icon=\"zmdi zmdi-more-vert\" style=\"font-size: 1.5rem;\"></md-icon>\n            <md-tooltip md-delay=\"1000\">Lead Options</md-tooltip></md-icon>\n        </md-button>\n        <md-menu-content class=\"md-dense\" style=\"max-height: 500px!important;\">\n\n            <md-menu-item>\n                <md-button ng-disabled=\"true\">\n                    Log Lead Activity\n                </md-button>\n            </md-menu-item>\n            <md-menu-item class=\"contact-type-menu-item\" ng-repeat=\"contactType in vm.contactTypes | toArray: false | orderBy: \'order\' track by $index + uid\">\n                <md-button ng-click=\"vm.addTouchpoint(lead, $event, contactType.uid)\">\n                    <md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{contactType.color}};\"></md-icon> {{contactType.label}}\n                </md-button>\n            </md-menu-item>\n\n            <!-- <md-menu-item>\n                <md-button ng-click=\"vm.openLead(lead, 0, $event)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-lead\">\n                    </md-icon>Edit\n                </md-button>\n            </md-menu-item> -->\n\n            <md-divider></md-divider>\n            <md-menu-item>\n                <md-button ng-disabled=\"true\">\n                    Change Lead Status\n                </md-button>\n            </md-menu-item>\n            <md-menu-item >\n                <md-button ng-disabled=\"lead.status == \'won\'\" ng-click=\"vm.changeLeadStatus(lead, \'won\')\" aria-label=\"Clone\" md-no-ink=\"true\">\n\n                    <md-icon md-font-icon=\"fa fa-thumbs-o-up\" class=\"button-edit-lead\">\n                    </md-icon>Mark Lead as \"Won\"\n                </md-button>\n            </md-menu-item>\n            <md-menu-item >\n                <md-button ng-disabled=\"lead.status == \'lost\'\" ng-click=\"vm.changeLeadStatus(lead, \'lost\')\" aria-label=\"Clone\" md-no-ink=\"true\">\n\n                    <md-icon md-font-icon=\"fa fa-thumbs-o-down\" class=\"button-edit-lead\">\n                    </md-icon>Mark Lead as \"Lost\"\n                </md-button>\n            </md-menu-item>\n\n           <md-menu-item ng-if=\"lead.status != \'archived\'\">\n               <md-button ng-click=\"vm.changeLeadStatus(lead, \'archived\')\" aria-label=\"Clone\" md-no-ink=\"true\">\n\n                   <md-icon md-font-icon=\"fa fa-archive\" class=\"button-edit-lead\">\n                   </md-icon>Archive Lead\n               </md-button>\n           </md-menu-item>\n          <md-menu-item ng-if=\"lead.status != \'active\'\">\n              <md-button ng-click=\"vm.changeLeadStatus(lead, \'active\')\" aria-label=\"Clone\" md-no-ink=\"true\">\n\n                  <md-icon md-font-icon=\"zmdi zmdi-coffee\" class=\"button-edit-lead\">\n                  </md-icon>Restore Lead to \"Active\"\n              </md-button>\n          </md-menu-item>\n          <md-divider></md-divider>\n          <md-menu-item>\n              <md-button ng-click=\"vm.openLead(lead, 0, $event)\">\n                  <md-icon md-font-icon=\"fa fa-edit\" ></md-icon>\n\n                  Open/Edit Lead\n              </md-button>\n          </md-menu-item>\n          <md-menu-item>\n              <md-button ng-click=\"vm.cloneLead(lead)\" aria-label=\"Clone\" md-no-ink=\"true\">\n                  <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\" class=\"button-edit-lead\"></md-icon>\n                  </md-icon>Clone Lead\n              </md-button>\n          </md-menu-item>\n           <md-menu-item>\n               <md-button ng-click=\"vm.deleteLead(lead)\" aria-label=\"Delete\" md-no-ink=\"true\">\n                   <md-icon md-font-icon=\"zmdi zmdi-delete\" class=\"button-edit-lead\">\n                   </md-icon>Delete Lead\n               </md-button>\n           </md-menu-item>\n           <md-menu-item>\n               <md-button ng-disabled=\"lead.status == \'won\'\" ng-click=\"vm.createWorkspace(lead)\" aria-label=\"Clone\" md-no-ink=\"true\">\n                   <md-icon md-font-icon=\"zmdi zmdi-folder-outline\" class=\"button-edit-lead\">\n                   </md-icon>Create a Workspace for this Lead\n                   <md-tooltip>Create a workspace without moving lead to \"Won\"</md-tooltip>\n               </md-button>\n           </md-menu-item>\n           <md-menu-item>\n               <md-button ng-click=\"vm.inviteUser(lead)\" aria-label=\"Invite\" md-no-ink=\"true\">\n                   <md-icon md-font-icon=\"fa fa-users\" class=\"button-edit-lead\">\n                   </md-icon>Invite Lead to your team\n                   <md-tooltip>Send team invitation to this person</md-tooltip>\n               </md-button>\n           </md-menu-item>\n            <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                <md-button aria-label=\"X-ray\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}leadBoards/{{lead.owner}}/leads/{{lead.uid}}\">\n                    <md-icon md-font-icon=\"zmdi zmdi-database\"></md-icon> X-ray\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n    <div layout=\"column\" layout-align=\"start start\" class=\"lead-content md-padding\">\n        <!-- main info -->\n        <div layout=\"row\">\n            <div flex=\"nogrow\">\n                <img src=\"{{lead.avatarThumb}}\" class=\"avatar\" style=\"background-color: #999;\">\n\n                <!-- <avatar class=\"lead-card-avatar\" parent=\"lead\" upload=\"false\"></avatar> -->\n            </div>\n            <div flex>\n                <p class=\"margin-0 lead-card-info\">\n                    <strong>{{lead.firstName}} {{lead.lastName}}</strong>\n                    <span class=\"smalltext\" ng-if=\"lead.position\" >\n                        <br><em>{{lead.position}}</em>\n                    </span>\n                    <span class=\"smalltext\" ng-if=\"lead.company\" >\n                        <br>{{lead.company}}\n                    </span>\n                    <span class=\"smalltext\" ng-if=\"lead.email\" >\n                        <br><a md-truncate style=\" width: 100%; display:block;\" href=\"mailto:{{lead.email}}\" target=\"_blank\">{{lead.email}}</a>\n                    </span>\n                    <span class=\"smalltext\" ng-if=\"lead.phone\" >\n                        <br>{{lead.phone}}\n                    </span>\n                </p>\n            </div>\n        </div>\n        </div>\n\n        <!-- if this lead has a description, display it -->\n        <div flex ng-if=\"lead.description\" class=\"md-padding\" style=\"padding-top:0;\">\n        	<div style=\"margin-top: 0; font-size: .75em;\" class=\"smalltext\">{{vm.shortDescription(lead.description)}}</div>\n            <md-divider style=\"margin-top: .5em;\"></md-divider>\n        </div>\n\n        <!-- stats rows-->\n        <div layout=\"row\" layout-align=\"start center\" style=\"padding-left: .5em; padding-right: 1em;\">\n            <div flex=\"nogrow\" class=\"lead-status-icon\" style=\"margin-left: 0px;\">\n                <strong>Created: </strong> {{lead.timeStamp | amDateFormat : vm.settings.shortDateFormat}}\n            </div>\n            <div ng-if=\"vm.lastContact\" flex=\"auto\" class=\"lead-status-icon {{vm.contactStatus}}\" layout=\"row\" layout-align=\"end center\" style=\"margin-right:0;\">\n                Last contact: &nbsp;\n                <strong ng-if=\"vm.lastContact\">{{vm.lastContact | amDateFormat: vm.settings.shortDateFormat}}</strong>\n            </div>\n        </div>\n\n        <div flex=\"auto\" layout=\"row\" layout-align=\"end center\">\n            <div flex=\"auto\" layout=\"row\" layout-align=\"start center\" style=\"padding-left: .5em; padding-right: 1em;\">\n                <div flex=\"nogrow\" class=\"lead-status-icon\" style=\"margin-left:0;\">\n                        <strong>Deal size:</strong> {{lead.size || \"Undefined\"}}\n\n                </div>\n            </div>\n            <div flex=\"nogrow\" class=\"lead-status-icon\" ng-if=\"vm.numTasks\" >\n                    <md-icon  md-font-icon=\"zmdi zmdi-check-square\" >\n                        <md-tooltip md-delay=\"500\">Lead Tasks</md-tooltip>\n                    </md-icon>\n                <label class=\"icon-label\">{{vm.numTasks}}</label>\n            </div>\n\n            <div flex=\"nogrow\" class=\"lead-status-icon\" >\n                    <md-icon  md-font-icon=\"fa fa-comments-o\" >\n                        <md-tooltip md-delay=\"500\">Lead Activity</md-tooltip>\n                    </md-icon>\n                <label class=\"icon-label\">{{vm.numContacts}}</label>\n            </div>\n\n            <div flex=\"nogrow\" class=\"lead-status-icon\">\n                <md-icon   md-font-icon=\"fa fa-bell-o\" style=\"color: #999;\">\n                </md-icon>\n            </div>\n        </div>\n\n        <!-- hotness bar -->\n        <div class=\"task-progress-container\" ng-if=\"lead.chance && !lead.promotedWorkspace\" style=\"margin-top: .5em;\">\n            <div layout=\"row\" layout-align=\"start center\">\n                <div flex=\"nogrow\" class=\"lead-status-icon\" style=\"margin-left:0; margin-right: .5em;\">\n                    {{lead.chance || 0}}% chance\n                </div>\n                <div flex layout=\"column\" layout-align=\"center start\" style=\"height: 32px;\">\n                    <div class=\"task-progress-bar\" ng-class=\"{\'little\':(lead.chance < 25) , \'some\': (lead.chance >= 25 && lead.chance < 50 ) , \'somemore\': (lead.chance >= 50 && lead.chance < 75 ), \'great\': (lead.chance >= 75) }\" style=\"width: {{lead.chance}}%;\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"task-progress-container\"ng-click=\"vm.visitWorkspace(lead.promotedWorkspace, $event)\" ng-if=\"lead.promotedWorkspace\" style=\"margin-top: .5em; cursor: pointer; color: #fff; background-color: rgba(76,175,80, .8);\" layout=\"row\" layout-align=\"center center\" >\n            <p class=\"lead-status-icon text-center\">Visit Workspace</p>\n            <!-- <div layout=\"row\" layout-align=\"start center\">\n                <div flex=\"nogrow\" class=\"lead-status-icon\" style=\"margin-left:0; margin-right: .5em;\">\n                    {{lead.chance || 0}}% chance\n                </div>\n                <div flex layout=\"column\" layout-align=\"center start\" style=\"height: 32px;\">\n                    <div class=\"task-progress-bar\" ng-class=\"{\'little\':(lead.chance < 25) , \'some\': (lead.chance >= 25 && lead.chance < 50 ) , \'somemore\': (lead.chance >= 50 && lead.chance < 75 ), \'great\': (lead.chance >= 75) }\" style=\"width: {{lead.chance}}%;\"></div>\n                </div>\n            </div> -->\n        </div>\n</md-card>\n");
$templateCache.put("app/app-directives/lead-groups/lead-groups.tmpl.html","<div class=\"lead-settings\" >\n    <!-- container -->\n    <div flex=\"100\" layout=\"column\" layout-align=\"start fill\" >\n        <!-- item -->\n        <div class=\"{{groupClass}} lead-category-container\" dragula=\"\'drag-category\'\" dragula-scope=\"$scope\" ng-if=\"setupComplete\">\n        <div catid=\"{{category.uid}}\"\n            ng-repeat=\"category in categories | toArray: false | orderBy: [\'order\'] track by uid+$index\"\n            class=\"category-item lead-category-item\"\n             layout=\"row\"\n             layout-align=\"start center\">\n            <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\">\n                <md-icon md-font-icon=\"fa fa-reorder\"></md-icon>\n            </md-button>\n            <div class=\"lead-group-swatch\" style=\"background-color: {{category.color || \'#fff\'}};\">\n            </div>\n            <p flex=\"auto\" class=\"md-subhead\">{{category.label}}</p>\n\n            <md-button ng-click=\"editCategory(category)\" flex=\"nogrow\" class=\"md-button-small\">\n                   <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n            </md-button>\n            <md-button ng-click=\"removeCategory(category)\" flex=\"nogrow\" class=\"md-button-small\">\n                <md-icon md-font-icon=\"fa fa-trash\"></md-icon>\n            </md-button>\n\n        </div>\n        </div>\n        <md-button ng-if=\"!showCategoryForm\" class=\"md-accent\" ng-click=\"toggleCategoryForm(true)\">+ Add</md-button>\n    </div>\n    <!-- form -->\n    <div ng-if=\"showCategoryForm\" style=\"margin-top: 1em;\" class=\"lead-category-form\">\n        <ng-form name=\"forms.categoryForm\" novalidate isolate-form layout=\"row\" layout-align=\"center center\" >\n            <md-input-container flex=\"60\">\n                <label>Label</label>\n                <input mdInput autofocus required ng-model=\"newCategory.label\">\n            </md-input-container>\n            <div class=\"color-field\" style=\"position:relative;\">\n                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\">\n                    <div flex style=\"position: relative; top: 3px; margin-left: 2em; margin-right: 1em;\" class=\"toggleSwatch\" ng-click=\"togglePicker()\" flex=\"nogrow\" aria-label=\"Assign a Color\" md-no-ink=\"true\" >\n                        <div class=\"swatch\" style=\"background-color: {{newCategory.color || \'#999\'}};\" >\n                            <md-tooltip md-delay=\"1000\">\n                                Select a color\n                            </md-tooltip>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"color-picker\" ng-if=\"colorPicker\">\n                    <lk-color-chooser ng-change=\"dirtyForm()\" colors=\"colors\" selected-color=\"newCategory.color\" ng-model=\"newCategory.color\" ng-click=\"togglePicker()\"></lk-color-chooser>\n                </div>\n            </div>\n            <md-button ng-if=\"newCategory.uid\" ng-disabled=\"forms.categoryForm.$invalid || forms.categoryForm.$pristine\" ng-click=\"updateCategory(newCategory)\" flex=\"nogrow\" class=\"md-raised md-accent\">Update</md-button>\n            <md-button ng-if=\"!newCategory.uid\" ng-disabled=\"forms.categoryForm.$invalid || forms.categoryForm.$pristine\" ng-click=\"addCategory(newCategory)\" flex=\"nogrow\" class=\"md-raised md-accent\">Create</md-button>\n            <md-button ng-click=\"toggleCategoryForm(false)\" flex=\"nogrow\" class=\"\" style=\"min-width: 40px;\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n        </ng-form>\n    </div>\n\n</div>\n");
$templateCache.put("app/app-directives/note-entry/note-entry.tmpl.html","<md-list-item class=\"md-3-line task-note-item\" ng-if=\"!vm.editMode\">\n    <div class=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\">\n\n        <div flex>\n            <p style=\"white-space: pre-wrap;\" class=\"speech-bubble\" ng-bind-html=\"vm.note.body | linky\"></p>\n        </div>\n        <div flex=\"nogrow\" style=\"width: 120px;\" layout=\"column\" layout-align=\"end stretch\">\n                <p flex class=\"md-caption\" style=\"width: 120px; text-align: center;\">\n                <img flex src=\"{{vm.thisMember.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"25\" style=\"border-radius: 50%; border: 2px solid {{vm.thisMember.color}}; margin-right: 1em; top: 5px;\"><br>\n                <span  style=\"font-weight: bold;\">{{vm.thisMember.fullName}}</span><br>\n                <span flex class=\"notedate\" am-time-ago=\"vm.note.date\"></span>\n                <span  ng-if=\"vm.note.notifyClient\">\n                <br>\n                    Client CC\'d\n                </span>\n                </p>\n        </div>\n        <div class=\"card-controls\" class=\"right\" ng-if=\"vm.thisMember.uid == vm.userID\">\n            <md-button ng-click=\"editNote(vm.note)\" style=\"min-width: 50px; width: 50px;\">\n                <md-icon aria-label=\"Edit Note\" md-font-icon=\"zmdi zmdi-edit\" style=\"font-size: 12px;\"></md-icon>\n            </md-button>\n        </div>\n        </div>\n    </div>\n</md-list-item>\n<md-list-item class=\"md-3-line task-note-item inline-edit\" ng-if=\"vm.editMode\">\n    <div class=\"md-list-item-text\" layout=\"column\" layout-align=\"center stretch\">\n            <form name=\"noteEntryForm\" novalidate layout=\"column\">\n                <div flex layout=\"column\">\n                    <md-input-container >\n                        <textarea md-autofocus md-maxlength=\"2000\" name=\"editNotebody\" ng-model=\"vm.editNote.body\" placeholder=\"Edit note\"></textarea>\n                    </md-input-container>\n                </div>\n                <!-- normal controls -->\n                <div flex layout=\"row\" ng-show=\"vm.editStatus == \'editing\'\" layout-align=\"end center\" style=\"margin-top: 40px;\">\n                   <div flex=\"nogrow\" class=\"button-label-container\">\n                       <md-button  class=\"md-indigo-theme\" ng-click=\"startDelete(vm.editNote)\">\n                          Delete\n                       </md-button>\n                   </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button  class=\"md-indigo-theme\" ng-click=\"cancelEdit(vm.editNote)\">\n                            Cancel\n                        </md-button>\n                    </div>\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button type=\"submit\" class=\"md-indigo-theme md-primary md-raised\" ng-click=\"updateNote(vm.editNote, vm.task, vm.client)\">\n                            Update\n                        </md-button>\n                    </div>\n                </div>\n                <!-- Delete controls -->\n                <div flex layout=\"row\" ng-show=\"vm.editStatus == \'startdelete\' || vm.editStatus == \'deleting\'\" layout-align=\"end center\" style=\"background-color: pink; margin-top: 1em;\">\n                <p ng-show=\"vm.editStatus ==\'startdelete\'\" class=\'\' style=\"margin:0 auto 0 auto; text-align: right;\">\n                    Permanently delete?\n                </p>\n\n                <md-button ng-show=\"vm.editStatus ==\'startdelete\'\" class=\"md-primary\" ng-click=\"cancelDelete()\">\n                    cancel\n                </md-button>\n\n                <md-button class=\"md-primary\" ng-click=\"deleteNote(vm.editNote, vm.task, vm.client)\">\n                    <span ng-show=\"vm.editStatus == \'startdelete\'\">\n                            Confirm\n                        </span>\n                    <span ng-show=\"vm.editStatus == \'deleting\'\">\n                            <md-icon aria-label=\"Deleting\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px; line-height: 25px;\">\n                            </md-icon>\n                            Please Wait\n                        </span>\n                    <span ng-show=\"vm.editStatus == \'deleted\'\">\n                            <md-icon  aria-label=\"Note Deleted\" md-font-icon=\"zmdi zmdi-check\" style=\"min-width: 12px; width:12px; font-size: 12px;\">\n                            </md-icon> Note Deleted\n                        </span>\n                </md-button>\n                </div>\n            </form>\n\n        <div class=\"card-controls\" flex=\"20\" class=\"right\">\n            <md-button ng-click=\"cancelEdit(note)\" style=\"min-width: 50px; width: 50px;\">\n                <md-icon aria-label=\"Cancel Edit\" md-font-icon=\"zmdi zmdi-caret-up\"></md-icon>\n            </md-button>\n        </div>\n    </div>\n</md-list-item>\n<md-divider></md-divider>\n");
$templateCache.put("app/app-directives/notification-card/notification-card.tmpl.html","<md-card class=\"notification-list-item\" ng-class=\"{\'viewed\': vm.item.read, \'old\' : isOld(vm.item)}\" \">\n    <div ng-if=\"!vm.toast\" class=\"notification-header\" layout=\"row\" layout-align=\"start center\">\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'invite\'\" style=\"color: green;\" md-font-icon=\"fa fa-envelope-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'email\'\" style=\"color: green;\" md-font-icon=\"fa fa-envelope-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'thanks\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-favorite\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'tip\'\" style=\"color: blue;\" md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'payment-received\'\" style=\"color: green;\" md-font-icon=\"fa fa-money\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'fix\' || vm.item.type ==\'improvement\'\" style=\"color: orange;\" md-font-icon=\"zmdi zmdi-wrench\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'task\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'billing-period\'\" ng-click=\"vm.openBilling(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-time\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'invoice-ready\'\" ng-click=\"vm.openClient(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"zmdi zmdi-check-circle\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'invoice-empty\'\" ng-click=\"vm.openClient(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-alert-circle\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'invoice-sent\'\" ng-click=\"vm.openClient(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-send-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'subtask\'\" ng-click=\"vm.openSubTask(vm.item, 1, $event)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'lead-reminder\'\" ng-click=\"vm.openLead(vm.item, 3, $event)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'taskOverBudget\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-time\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'packageBudget\'\" ng-click=\"vm.openBilling(vm.item)\" style=\"cursor: pointer; color: red;\" md-font-icon=\"zmdi zmdi-time\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'packageRenewed\'\" style=\"cursor: pointer; color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'package-refilled\'\" ng-click=\"vm.openBilling(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-money\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'taskComplete\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-check-square\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'comment\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: grey;\" md-font-icon=\"zmdi zmdi-comments\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'assignment\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-check-square\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'taskReceived\'\" ng-click=\"vm.openTask(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-check-square\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'noteReceived\'\"  style=\"cursor: pointer; color: green;\" md-font-icon=\"fa fa-file-text-o\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'clientAssignment\'\" ng-click=\"vm.gotoClient(vm.item)\" style=\"cursor: pointer; color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'recurring\'\" ng-click=\"vm.openTask(vm.item)\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'retainer\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'date\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'alert\' || vm.item.type == \'invoice-due\' || vm.item.type == \'package-expired\'\" style=\"color: red;\" md-font-icon=\"zmdi zmdi-alert-polygon\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'newlead\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-alert-polygon\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'new\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-mood\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'pdf\'\" style=\"color: green;\" md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'flowTrigger\'\"  style=\"color: blue;\" md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n        <md-icon flex=\"nogrow\" class=\"notification-badge\" ng-if=\"vm.item.type == \'link\'\"  style=\"color: blue;\" md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n        <img flex=\"nogrow\" ng-if=\"vm.item.type == \'reminder\'\" ng-click=\"vm.toggleNotificationsTab(3)\" src=\"/assets/images/icons/reminder.png\" width=\"12\" style=\"margin-right: 10px; padding: 4px 0 3px 0;\">\n        <img flex=\"nogrow\" ng-if=\"!vm.item.type || vm.item.type == \'general\'\" src=\"/assets/images/brand/adminja-bug.svg\" width=\"15\" style=\"margin-right: 10px; padding: 4px 0 3px 0;\">\n        <span flex=\"grow\" class=\"notification-meta\">{{vm.item.meta}}</span>\n\n        <md-icon ng-click=\"vm.discardNotification(vm.item)\" class=\"button-discard-notification\" aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-close-circle\" class=\"\">\n            <md-tooltip md-delay=\"1000\">Discard</md-tooltip>\n        </md-icon>\n    </div>\n    <div ng-if=\"vm.toast\" style=\"border: 1px solid #bbb; background-color: #fff; color: #666; height: 0; border-top: 4px solid {{vm.item.color}};\">\n    </div>\n    <div class=\"notification-body\">\n        <h3 class=\"notification-title\" ng-if=\"!vm.toast\" style=\"padding-bottom: .25em;\">{{vm.item.title}}</h3>\n        <h3 class=\"notification-title\" ng-if=\"vm.toast\" style=\"font-size: 1em; padding-bottom: .5em;\">{{vm.item.title}}</h3>\n        <p class=\"notification-message\" ng-bind-html=\"vm.sanitizeMe(vm.item.message | limitTo: 200) \"></p>\n        <p class=\"notification-timestamp\"  am-time-ago=\"vm.item.date\"></p>\n    </div>\n    <!-- flowTriger action buttons -->\n    <div class=\"notification-actions\" ng-if=\"vm.item.type == \'flowTrigger\'\" layout=\"row\" layout-align=\"end center\" >\n        <md-button class=\"md-primary\" ng-click=\"vm.showCue(vm.item.related)\">\n             <md-tooltip md-delay=\"1000\">Show Me</md-tooltip>\n                 Show Me\n         </md-button>\n     </div>\n     <!-- Personal Reminder notifications -->\n     <div class=\"notification-actions\" ng-if=\"vm.item.type == \'reminder\'\" layout=\"row\" layout-align=\"end center\" >\n            <md-button ng-if=\"vm.toast\" style=\"\" flex=\"nogrow\" class=\"md-primary\" ng-click=\"vm.dismissPersonalReminder(vm.item)\">\n                 <md-tooltip md-delay=\"1000\">Dismiss</md-tooltip>\n                     Dismiss\n             </md-button>\n            <md-menu ng-if=\"vm.toast\" md-position-mode=\"target bottom\">\n              <md-button  style=\"margin-right: 0;\" flex=\"nogrow\" ng-click=\"$mdOpenMenu($event)\">\n                Snooze\n                <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n              </md-button>\n              <md-menu-content >\n                <!-- <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 1, $event)\">\n                    1 min\n                  </md-button>\n                </md-menu-item> -->\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 5, $event)\">\n                    5 min\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 15, $event)\">\n                    15 min\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 30, $event)\">\n                    30 min\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 60, $event)\">\n                    1 hr\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 120, $event)\">\n                    2 hr\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 240, $event)\">\n                    4 hr\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 480, $event)\">\n                    8 hr\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 720, $event)\">\n                    12 hr\n                  </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                  <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 1440, $event)\">\n                    1 day\n                  </md-button>\n                </md-menu-item>\n              </md-menu-content>\n            </md-menu>\n\n         <md-button style=\"margin-left: 0; margin-right: 1em;\" class=\"md-primary\" ng-click=\"vm.toggleNotificationsTab(3)\">\n              <md-tooltip md-delay=\"1000\">Open</md-tooltip>\n                  Open\n          </md-button>\n         <!--  <md-button class=\"md-primary\" ng-click=\"vm.sendToast(vm.item)\">\n            Display Test Toast\n          </md-button> -->\n      </div>\n     <!-- link action buttons -->\n     <div class=\"notification-actions\" ng-if=\"vm.item.type == \'link\'\" layout=\"row\" layout-align=\"end center\" >\n         <md-button class=\"md-primary\" href=\"{{vm.item.related}}\">\n              <md-tooltip md-delay=\"1000\">Open</md-tooltip>\n                  Open\n          </md-button>\n      </div>\n\n      <!-- billing-period action buttons -->\n      <div class=\"notification-actions\" ng-if=\"vm.item.type == \'billing-period\'\" layout=\"row\" layout-align=\"end center\" >\n          <md-button ng-if=\"vm.toast\" style=\"\" flex=\"nogrow\" class=\"md-primary\" ng-click=\"vm.dismissBillingNotification(vm.item)\">\n               <md-tooltip md-delay=\"1000\">Dismiss</md-tooltip>\n                   Dismiss\n           </md-button>\n          <md-button class=\"md-primary\" ng-click=\"vm.openBilling(vm.item)\">\n               <md-tooltip md-delay=\"1000\">Show Me</md-tooltip>\n                   Show Me\n           </md-button>\n       </div>\n\n\n       <!-- billing-period action buttons -->\n       <div class=\"notification-actions\" ng-if=\"vm.item.type == \'invoice-ready\' || vm.item.type == \'invoice-sent\' || vm.item.type == \'invoice-empty\'\" layout=\"row\" layout-align=\"end center\" >\n           <md-button ng-if=\"vm.toast\" style=\"\" flex=\"nogrow\" class=\"md-primary\" ng-click=\"vm.dismissBillingNotification(vm.item)\">\n                <md-tooltip md-delay=\"1000\">Dismiss</md-tooltip>\n                    Dismiss\n            </md-button>\n           <md-button class=\"md-primary\" ng-click=\"vm.openClient(vm.item)\">\n                <md-tooltip md-delay=\"1000\">Show Me</md-tooltip>\n                    Visit Workspace\n            </md-button>\n        </div>\n\n\n    <!-- Task action buttons -->\n    <div class=\"notification-actions\" ng-if=\"vm.item.type == \'task\' ||vm.item.type == \'taskOverBudget\' || vm.item.type == \'recurring\' || vm.item.type ==\'assignment\' || vm.item.type ==\'taskComplete\'\" layout=\"row\" layout-align=\"end center\" >\n       <!-- <md-button class=\"md-primary\" ng-click=\"vm.sendToast(vm.item)\">\n         Display Toast\n       </md-button> -->\n        <md-button class=\"md-primary\" ng-click=\"vm.openTask(vm.item)\">\n             <md-tooltip md-delay=\"1000\">Open Task</md-tooltip>\n                 Open\n         </md-button>\n          <md-menu ng-if=\"vm.item.type == \'task\'\">\n               <md-button ng-click=\"$mdOpenMenu()\">\n                 <!-- <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"margin-right: 18px;\"></md-icon> -->\n                  Snooze\n                  <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                 </md-button>\n               <md-menu-content>\n                   <md-menu-item>\n                        <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 15, $event)\">\n                           15 min\n                       </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                         <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 30, $event)\">\n                            30 min\n                        </md-button>\n                     </md-menu-item>\n                     <md-menu-item>\n                          <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 60, $event)\">\n                             60 min\n                         </md-button>\n                      </md-menu-item>\n                      <md-menu-item>\n                           <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 120, $event)\">\n                              2 hr\n                          </md-button>\n                       </md-menu-item>\n                       <md-menu-item>\n                            <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 480, $event)\">\n                               8 hr\n                           </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                             <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 720, $event)\">\n                                12 hr\n                            </md-button>\n                         </md-menu-item>\n                         <md-menu-item>\n                              <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 1440, $event)\">\n                                 1 day\n                             </md-button>\n                          </md-menu-item>\n                          <md-menu-item>\n                               <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 2880, $event)\">\n                                  2 days\n                              </md-button>\n                           </md-menu-item>\n                           <md-menu-item>\n                                <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 10080, $event)\">\n                                   1 week\n                               </md-button>\n                            </md-menu-item>\n                            <md-menu-item>\n                                 <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeTask(vm.item, 20160, $event)\">\n                                    2 weeks\n                                </md-button>\n                             </md-menu-item>\n\n             </md-menu-content>\n         </md-menu>\n     </div>\n\n  <!-- <div class=\"notification-actions\" ng-if=\"vm.item.type == \'newlead\'\" layout=\'row\' layout-align=\"end center\">\n    <md-button class=\"md-primary\" ng-click=\"vm.openLead(vm.item, 0, $event)\">\n         <md-tooltip md-delay=\"1000\">Open Lead</md-tooltip>\n             Open\n     </md-button>\n  </div> -->\n  <!-- Schedule Reminder buttons -->\n     <div class=\"notification-actions\" ng-if=\"vm.item.type == \'lead-reminder\'\" layout=\"row\" layout-align=\"end center\" >\n         <md-button class=\"md-primary\" ng-click=\"vm.openLead(vm.item, 3, $event)\">\n              <md-tooltip md-delay=\"1000\">Open Lead</md-tooltip>\n                  Open\n          </md-button>\n          <md-menu>\n        <md-button ng-click=\"$mdOpenMenu()\">\n          <!-- <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"margin-right: 18px;\"></md-icon> -->\n          Snooze\n          <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n        </md-button>\n        <md-menu-content>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 15, $event)\">\n              15 min\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 30, $event)\">\n              30 min\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 60, $event)\">\n              60 min\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 120, $event)\">\n              2 hr\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 480, $event)\">\n              8 hr\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 720, $event)\">\n              12 hr\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 1440, $event)\">\n              1 day\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 2880, $event)\">\n              2 days\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 10080, $event)\">\n              1 week\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n            <md-button flex=\"nogrow\" ng-click=\"vm.snoozeLeadReminder(vm.item, 20160, $event)\">\n              2 weeks\n            </md-button>\n          </md-menu-item>\n          <md-menu-item>\n               <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeLeadReminder(vm.item, 40320, $event)\">\n                  1 month\n              </md-button>\n           </md-menu-item>\n           <md-menu-item>\n                <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeLeadReminder(vm.item, 120960, $event)\">\n                   3 months\n               </md-button>\n            </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n</div>\n      <!-- Subtask Reminder buttons -->\n         <div class=\"notification-actions\" ng-if=\"vm.item.type == \'subtask\'\" layout=\"row\" layout-align=\"end center\" >\n             <md-button class=\"md-primary\" ng-click=\"vm.openSubTask(vm.item, 1, $event)\">\n                  <md-tooltip md-delay=\"1000\">Open Subtasks</md-tooltip>\n                      Open\n              </md-button>\n              <md-menu>\n            <md-button ng-click=\"$mdOpenMenu()\">\n              <!-- <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"margin-right: 18px;\"></md-icon> -->\n              Snooze\n              <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n            </md-button>\n            <md-menu-content>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 15, $event)\">\n                  15 min\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 30, $event)\">\n                  30 min\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 60, $event)\">\n                  60 min\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 120, $event)\">\n                  2 hr\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 480, $event)\">\n                  8 hr\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 720, $event)\">\n                  12 hr\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 1440, $event)\">\n                  1 day\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button flex=\"nogrow\" ng-click=\"vm.snoozeReminder(vm.item, 2880, $event)\">\n                  2 days\n                </md-button>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n</div>\n\n      <div class=\"notification-actions\" ng-if=\"vm.item.type == \'comment\'\" layout=\"row\" layout-align=\"end center\">\n         <md-button ng-click=\"vm.openTask(vm.item, 2)\">\n             <md-tooltip md-delay=\"1000\">View Comment</md-tooltip>\n                 View\n         </md-button>\n      </div>\n      <!-- Client assignment -->\n       <div class=\"notification-actions\" ng-if=\"vm.item.type == \'clientAssignment\'\" layout=\"row\" layout-align=\"start center\" >\n             <md-button class=\"\" ng-click=\"vm.refreshClients()\">\n                 Refresh my Client list\n             </md-button>\n\n       </div>\n      <!-- invitation action buttons -->\n       <div class=\"notification-actions\" ng-if=\"vm.item.type == \'invite\'\" layout=\"row\" layout-align=\"start center\" >\n             <md-button class=\"\" ng-click=\"vm.acceptInvite(vm.item)\">\n                 Accept\n             </md-button>\n             <md-button class=\"\" ng-click=\"vm.declineInvite(vm.item)\">\n                  Decline\n             </md-button>\n       </div>\n        <!-- email action buttons -->\n        <div class=\"notification-actions\" ng-if=\"vm.item.type == \'email\'\" layout=\"row\" layout-align=\"end center\" >\n             <md-button class=\"\" ng-click=\"vm.importTask(vm.item)\">\n                 <md-icon aria-label=\"Import task\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                     <md-tooltip md-delay=\"1000\">Import as Task</md-tooltip>\n                     </md-icon>\n                     Task\n             </md-button>\n             <md-button class=\"\" style=\"margin-right: 0;\" ng-click=\"vm.importNote(vm.item)\">\n                 <md-icon aria-label=\"Import note\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                     <md-tooltip md-delay=\"1000\">Import as Note</md-tooltip>\n                     </md-icon> Note\n             </md-button>\n        </div>\n        <!-- pdf action buttons -->\n         <div class=\"notification-actions\" ng-if=\"vm.item.type == \'pdf\'\" layout=\"row\" layout-align=\"end center\">\n                 <md-button ng-href=\"{{vm.item.related}}\" download=\"{{vm.item.related}}\" class=\"\" target=\"_blank\" >\n                     <md-icon aria-label=\"Download PDF\" md-font-icon=\"zmdi zmdi-download\" class=\"\">\n                         <md-tooltip md-delay=\"1000\">Download PDF</md-tooltip>\n                    </md-icon>\n                    Download PDF\n                 </md-button>\n         </div>\n</md-card>\n");
$templateCache.put("app/app-directives/profile-detail-item/profile-detail-item.tmpl.html","<md-card ng-click=\"editDetail(detail)\" ng-init=\"init(detail)\" class=\"app-item info-card info-card-{{::detail.type}} detail-handle\" ng-style=\"applyBackground(detail)\" panel=\"{{::detail.panel}}\" order=\"{{::detail.order}}\" client=\"{{::detail.client}}\" uid=\"{{::detail.uid}}\">\n    <!-- <md-button class=\"md-icon-button edit-detail-icon\" ng-click=\"editDetail(detail); $event.stopPropagation();\">\n        <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" style=\"color: #666;\" class=\"md-icon-button\" ></md-icon>\n    </md-button> -->\n    <!-- <md-icon class=\"edit-note-toggle\" md-font-icon=\"fa fa-close\" style=\"\" ng-if=\"detail.editMode && detail.type == \'note\'\" class=\"md-icon-button\" ng-click=\"finishEdit(detail); $event.stopPropagation();\"></md-icon> -->\n\n    <div class=\"detail-controls \">\n    <md-menu  flex=\"nogrow\" md-position-mode=\"target-right target\" style=\"position: absolute; top: -4px; right: 0px;\">\n        <!-- Trigger element is a md-button with an icon -->\n        <md-button class=\"md-button-small\" ng-Click=\"$mdMenu.open($event)\" style=\"width: 30px;\">\n            <md-icon  aria-label=\"{{::detail.type}} Options\" md-font-icon=\"zmdi zmdi-more-vert\" style=\"font-size: 1.5rem;\">\n                    <md-tooltip md-delay=\"1000\">{{::detail.type}} Options</md-tooltip>\n            </md-icon>\n        </md-button>\n        <md-menu-content class=\"md-dense\" style=\"overflow-x: hidden; padding:0;\">\n            <md-menu-item>\n                <md-button ng-click=\"editDetail(detail)\" aria-label=\"Edit\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-detail\">\n                    </md-icon>Edit {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"copyDetail(detail)\" aria-label=\"Clone\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"button-edit-detail\">\n                    </md-icon>Clone {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button ng-click=\"removeDetail(detail)\" aria-label=\"Delete\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-delete\" class=\"button-edit-detail\">\n\n                    </md-icon>Delete {{::detail.type}}\n                </md-button>\n            </md-menu-item>\n            <md-menu ng-if=\"!item.snooze\" style=\"margin:0;\">\n                 <md-button ng-click=\"$mdOpenMenu()\" style=\"width:100%; margin:0;\" layout=\"row\">\n                   <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-palette\" style=\"margin-left: 5px; margin-right: 18px;\"></md-icon>\n                    <span flex=\"grow\">Set Color</span>\n                    <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                   </md-button>\n                 <md-menu-content style=\"overflow:hidden;\">\n                   <md-menu-item ng-repeat=\"color in colors track by $index\" >\n                        <md-button flex=\"nogrow\"  ng-value=\"{{$index}}\" ng-click=\"setColor(detail,color, $event)\" style=\"background-color: {{color}};\">\n\n                       </md-button>\n                    </md-menu-item>\n            <!-- <md-menu-item ng-if=\"detail.panel != panel.uid\" ng-repeat=\"panel in client.panels | toArray | orderBy: \'order\' track by panel.uid\">\n                <md-button ng-click=\"moveToPanel(detail, panel.uid)\" aria-label=\"Move to Panel {{::panel.label}}\" md-no-ink=\"true\">\n                    <md-icon md-font-icon=\"zmdi zmdi-forward\" class=\"button-move-detail\">\n                    </md-icon>Move to {{::panel.label}}\n                </md-button>\n            </md-menu-item> -->\n        </md-menu-content>\n    </md-menu>\n\n    </div>\n    <!-- <div class=\"drag-handle\">\n            <md-icon md-font-icon=\"fa fa-reorder\" class=\"detail-handle\">\n            </md-icon>\n    </div> -->\n\n    <div layout=\"column\" layout-align=\"start start\" class=\"detail-content md-padding small-scrollbar nodrag\" ng-style=\"applyBackground(detail)\">\n        <!-- <p class=\"md-subhead right\">{{detail.order}}</p> -->\n        <!-- Contact -->\n        <div ng-if=\"detail.type == \'contact\'\" layout=\"column\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n            <div ng-if=\"detail.treatAsCompany\">\n                <p style=\"font-size: 1.25em;\">\n                    <strong>{{detail.company}}</strong>\n                </p>\n                <div ng-if=\"detail.firstname\" class=\"detail-label\"  layout=\"row\">\n                    <div flex=\"nogrow\" style=\"padding-right: 1em;\" ng-if=\"detail.avatar\">\n                        <avatar parent=\"detail\" upload=\"false\"></avatar>\n                    </div>\n                    <div flex>\n                        <strong>{{detail.firstname}} {{detail.lastname}}</strong>\n                        <span ng-if=\"detail.position\"><br><em>{{detail.position}}</em></span>\n\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"!detail.treatAsCompany\">\n                <div ng-if=\"detail.firstname\" class=\"detail-label\"  layout=\"row\">\n                    <div flex=\"nogrow\" style=\"padding-right: 1em;\" ng-if=\"detail.avatar\">\n                        <avatar parent=\"detail\" upload=\"false\"></avatar>\n                    </div>\n                    <div flex>\n                        <strong style=\"font-size: 1.25em;\">{{detail.firstname}} {{detail.lastname}}</strong>\n                        <span ng-if=\"detail.position\"><br><em>{{detail.position}}</em></span>\n                        <span ng-if=\"detail.company\"><br>{{detail.company}}</span>\n\n                    </div>\n                </div>\n            </div>\n            <p  class=\"detail-label\" style=\"margin-top: 1em;\">\n                <span style=\"display:block;\" ng-if=\"detail.dob\"><md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon> {{detail.dob | amDateFormat: settings.shortOrdDateFormat}}, {{detail.dob | amDateFormat: \'YYYY\'}}</span>\n                <span style=\"display:block;\" ng-if=\"detail.number\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{detail.number}}\">{{detail.number}}</a></span>\n                <span md-truncate style=\"display:block;\" ng-if=\"detail.email\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"mailto:{{detail.email}}\">{{detail.email}}</a></span>\n                <span md-truncate style=\"display:block;\" ng-if=\"detail.companyurl\"><md-icon md-font-icon=\"zmdi zmdi-globe\"></md-icon> <a href=\"{{detail.companyurl}}\" target=\"_blank\">{{detail.companyurl}}</a></span>\n\n             </p>\n\n\n\n            <div ng-if=\"detail.address1\">\n                <md-divider></md-divider>\n                <div layout=\"row\" layout-align=\"start start\">\n                    <div flex=\"nogrow\">\n                        <md-icon md-font-icon=\"zmdi zmdi-pin-drop\"></md-icon>\n                    </div>\n                    <div flex>\n                            <p>\n                                <a target=\"_blank\" ng-href=\"https://www.google.com/maps/search/?api=1&query={{detail.address1 + \',\' + detail.address2 + \',\' + detail.city + \',\' + detail.state + \',\' + detail.zip + \',\' + detail.country| escape}}\">\n                             {{detail.address1}}\n                            <br>\n                            <span ng-if=\"detail.address2\">{{detail.address2}}<br></span>\n                            {{detail.city}}, {{detail.state}}, {{detail.zip}}\n                            <br> {{detail.country}}\n                        </a>\n                        </p>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-if=\"detail.facebook || detail.linkedin || detail.twitter || detail.instagram\">\n                <!-- <p class=\"text-center\"><strong>Social Media</strong></p> -->\n                <md-divider></md-divider>\n                <p>\n                    <span ng-if=\"detail.twitter\"><md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon> <a href=\"https://www.twitter.com/{{detail.twitter}}\" target=\"_blank\">{{detail.twitter}}</a><br/></span>\n                    <span ng-if=\"detail.facebook\"><md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon> <a href=\"{{detail.facebook}}\" target=\"_blank\">Facebook</a><br/></span>\n                    <span ng-if=\"detail.linkedin\"><md-icon md-font-icon=\"zmdi zmdi-linkedin\"></md-icon> <a href=\"{{detail.linkedin}}\" target=\"_blank\">LinkedIn</a><br/></span>\n                    <span ng-if=\"detail.instagram\"><md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon> <a href=\"{{detail.instagram}}\" target=\"_blank\">Instagram</a><br/></span>\n                </p>\n            </div>\n\n        </div>\n        <!-- Address -->\n        <div ng-if=\"detail.type == \'address\'\" layout=\"column\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n            <p>\n                 {{detail.address1}}\n                <br>\n                <span ng-if=\"detail.address2\">{{detail.address2}}<br></span>\n                {{detail.city}}, {{detail.state}}, {{detail.zip}}\n                <br> {{detail.country}}\n            </p>\n            <p ng-if=\"detail.number\" class=\"detail-label\">\n\n                <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{detail.number}}\">{{detail.number}}</a>\n                </p>\n        </div>\n        <!-- RichURL -->\n        <div ng-if=\"detail.type == \'url\' && !detail.simpleEmbed\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n            <a class=\"embedly-card\" data-card-controls=\"0\" data-card-width=\"320px\" data-card-chrome=\"0\" data-card-branding=\"0\" data-card-type=\"article\" href=\"{{detail.url}}\"></a>\n            <!-- <p><md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon> <a href=\"{{detail.url}}\" target=\"_blank\">{{detail.url}}</a></p> -->\n        </div>\n        <!-- PlainURL -->\n        <div ng-if=\"detail.type == \'url\' && detail.simpleEmbed\">\n            <p class=\"detail-label\" >\n              <strong>{{detail.label}}</strong>\n            </p>\n            <p><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <a href=\"{{detail.url}}\" target=\"_blank\">{{detail.url}}</a></p>\n        </div>\n        <!-- Email -->\n        <div ng-if=\"detail.type == \'email\'\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n            <p><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"{{detail.address}}\">{{detail.address}}</a></p>\n        </div>\n        <!-- Phone -->\n        <div ng-if=\"detail.type == \'phone\'\">\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n                <p><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"tel:{{detail.number}}\">{{detail.number}}</a></p>\n        </div>\n        <!-- Note -->\n        <div ng-if=\"detail.type == \'note\'\" layout=\"column\" layout-align=\"start center\" style=\"\" class=\"note-content\" >\n            <!-- <div froala=\"froalaOptions\" name=\"{{detail.uid}}\" ng-if=\"detail.editMode\" style=\"width: 235px;\" ng-blur=\"finishEdit(detail)\" ng-model-options=\'{ debounce: 500 }\' ng-change=\'updateOnChange(detail)\' ng-model=\"detail.note\" ta-min-text=\"5\"  ta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\',\'insertLink\']]\" ></div> -->\n            <div froala-view=\"detail.note\" style=\"width: 235px; overflow-wrap: break-word;\" ng-if=\"!detail.editMode && detail.note\" class=\"view-note\" ng-click=\"toggleEditMode(detail, $event)\"></div>\n            <div layout=\"row\" layout-align=\"center center\" style=\"width: 235px;\">\n                <md-button ng-if=\"!detail.editMode && !detail.note\" flex=\"nogrow\" ng-click=\"prepAndEdit(detail, $event)\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon></md-button>\n            </div>\n        </div>\n        <!-- Files -->\n        <div ng-if=\"detail.type == \'files\'\" layout=\"row\" style=\"\">\n            <p ng-if=\"detail.label\" class=\"detail-label dont-break-out\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n        </div>\n        <!-- Question -->\n        <div ng-if=\"detail.type == \'question\'\" flex class >\n            <p ng-if=\"detail.label\" class=\"detail-label\" >\n                <strong>{{detail.label}}</strong>\n            </p>\n            <div class=\"detail-answer\" ng-bind-html=\"detail.a\">\n\n            </div>\n        </div>\n        <!-- Person -->\n        <div ng-if=\"detail.type == \'person\'\" layout=\"column\">\n            <div flex=\"nogrow\">\n                <div style=\"padding-right: 10px;\" >\n                    <div class=\"detail-label\"  layout=\"row\">\n                        <div flex=\"nogrow\" style=\"padding-right: 1em;\">\n                            <avatar parent=\"detail\" upload=\"false\"></avatar>\n\n                        </div>\n                        <div flex>\n\n                            <strong>{{detail.firstname}} {{detail.lastname}}</strong>\n                            <small ng-if=\"detail.label\" >\n                                <strong>{{detail.label}} <span ng-if=\"detail.position\">,{{detail.position}}</span></strong>\n                            </small>\n                        </div>\n                    </div>\n                    <small ng-if=\"detail.dob\"><br>Birthday: {{detail.dob | amDateFormat:\'MMM Do YYYY\'}}</small></p>\n\n                    <md-divider ng-if=\"detail.email || detail.phone\"></md-divider>\n                    <span ng-if=\"detail.email\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"mailto:{{detail.email}}\">{{detail.email}}</a><br></span>\n                    <span ng-if=\"detail.phone\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"{{detail.phone}}\">{{detail.phone}}</a><br></span>\n                    <span ng-if=\"detail.twitter\"><md-icon md-font-icon=\"zmdi zmdi-twitter\"></md-icon> <a href=\"https://www.twitter.com/{{detail.twitter}}\">{{detail.twitter}}</a><br/></span>\n                    <span ng-if=\"detail.facebook\"><md-icon md-font-icon=\"zmdi zmdi-facebook\"></md-icon> <a href=\"{{detail.facebook}}\">Facebook</a><br/></span>\n                    <span ng-if=\"detail.linkedin\"><md-icon md-font-icon=\"zmdi zmdi-linkedin\"></md-icon> <a href=\"{{detail.linkedin}}\">LinkedIn</a><br/></span>\n                    <span ng-if=\"detail.instagram\"><md-icon md-font-icon=\"zmdi zmdi-instagram\"></md-icon> <a href=\"{{detail.instagram}}\">Instagram</a><br/></span>\n\n                    <md-divider ng-if=\"detail.company || detail.companyemail || detail.companyphone || detail.website\"></md-divider>\n\n                    <p ng-if=\"detail.company\"><md-icon md-font-icon=\"fa fa-building\" ></md-icon><strong>{{detail.company}}</strong></p>\n                    <p ng-if=\"detail.position\" style=\"margin-top: 0;\">{{detail.position}}</p>\n                    <span ng-if=\"detail.companyemail\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <a href=\"mailto:{{detail.companyemail}}\">{{detail.companyemail}}</a><br></span>\n                    <span ng-if=\"detail.companyphone\"><md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> <a href=\"{{detail.companyphone}}\">{{detail.companyphone}}</a><br></span>\n                    <span ng-if=\"detail.website\"><md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <a href=\"{{detail.website}}\">Company Website</a></span>\n\n                </div>\n\n\n            </div>\n        </div>\n        <!-- if this detail has a description, display it -->\n        <div ng-if=\"detail.description\" style=\"width: 100%;\">\n        	<md-divider></md-divider>\n        	<p ng-bind-html=\"detail.description\" style=\"white-space: pre-wrap;\"></p>\n        </div>\n\n        <!-- if it has files, display them -->\n        <div ng-if=\"detail.files && detail.type != \'note\'\"  style=\"margin-top:10px;\">\n            <div layout=\"row\" layout-align=\"start start\" ng-repeat=\"file in detail.files track by $index\" class=\"attachment-grid\" >\n                <div ng-if=\"isImage(file) && file.source != \'googleDrive\'\" flex=\"nogrow\"  style=\"min-width: 50px!important; margin-right: 1em;\">\n                    <a ng-if=\"file.source != \'pendingDropbox\' && file.source != \'pendingGoogleDrive\' && file.source != \'pendingFirebaseStorage\' href=\"{{file.url}}\" target=\"_new\"><img class=\"attachment-thumbnail\" src=\"{{file.thumbnail}}\" width=\"50\">\n                    </a>\n                    <span ng-if=\"file.source == \'pendingDropbox\' || file.source == \'pendingGoogleDrive\' || file.source == \'pendingFirebaseStorage\'\">\n                        <md-tooltip md-delay=\"500\">File is currently in the copy queue. It will be available shortly.</md-tooltip>\n                        <md-icon md-font-icon=\"fa fa-refresh\"></md-icon> {{shortenFilename(file.fileName)}}</span>\n                    </span>\n                </div>\n                <div flex=\"auto\" style=\"padding-right: 1em;\">\n                    <md-chips>\n                    <md-chip><div class=\"md-chip-content\">\n                        <a ng-if=\"file.source != \'pendingDropbox\' && file.source != \'pendingGoogleDrive\' && file.source != \'pendingFirebaseStorage\'\" href=\"{{file.url}}\" target=\"_new\">{{shortenFilename(file.fileName)}}</a>\n                        <span ng-if=\"file.source == \'pendingDropbox\' || file.source == \'pendingGoogleDrive\' || file.source == \'pendingFirebaseStorage\'\" >\n                            <md-tooltip md-delay=\"500\">File is currently in the copy queue. It will be available shortly.</md-tooltip>\n                            <md-icon md-font-icon=\"fa fa-refresh\"></md-icon> {{shortenFilename(file.fileName)}}</span>\n                    </div></md-chip>\n                    </md-chips>\n                </div>\n\n            </div>\n        </div>\n    </div>\n        <div ng-if=\"detail.private\">\n            <p  style=\"text-align: center; font-size: 10px; margin:0;\">Admin only</p>\n        </div>\n        <!-- <div style=\"height: 8px;\">\n            <p class=\"profile-edit\" style=\"position: relative; top: -5px; margin:0; padding:0; font-size: 8px;\" ng-click=\"editDetail(detail)\" ><md-icon md-font-icon=\"fa fa-edit\" style=\" opacity: 1;\"><md-tooltip md-delay=\"500\">Edit</md-tooltip></md-icon></p>\n        </div> -->\n        <!-- <md-divider ng-if=\"detail.files && detail.type == \'note\'\"></md-divider>\n        <file-attachment-list style=\"margin-top: 10px; margin-bottom: 0px;\" ng-if=\"detail.files && detail.type == \'note\'\" files=\"detail.files\" removeable=\"false\"></file-attachment-list> -->\n\n\n</md-card>\n");
$templateCache.put("app/app-directives/print-time-report/print-time-report.tmpl.html","<div layout-fill ng-if=\"!vm.showReport\" layout=\"row\" layout-align=\"center center\" style=\"width: 100%; background-color:#fff; min-height: 300px;\">\n    <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n    <h3 flex=\"nogrow\" class=\"center md-title\">Preparing Report</h3>\n</div>\n<div class=\"print-time-report\" style=\"width: 100%;\" ng-if=\"vm.showReport\">\n    <!-- https://github.com/samwiseduzer/angularPrint -->\n\n    <div style=\"padding: 1em 2em 1em 1em; margin-bottom: 5em; width: 96%; overflow-y: scroll; overflow-x: hidden;\" print-section>\n        <div class=\"invoice-header\" layout=\"row\" layout-align=\"start center\">\n            <div flex style=\"padding-right: 2em;\">\n                <img ng-show=\"vm.user.profile.logo\" src=\"{{vm.user.profile.logo}}\"  width=\"150\" style=\"margin-left: 2em;\">\n                <p ng-show=\"!vm.user.profile.logo\">\n                    {{vm.user.profile.fullName}}\n                </p>\n            </div>\n            <div flex>\n                <p class=\"md-subhead recipient-address\" style=\"font-size: .85em;\">\n                    <strong>Time Report for:</strong> {{vm.report.clientName}}<br>\n                    <strong>Period:</strong> {{vm.report.start | amDateFormat: vm.settings.amDateFormat}} - {{vm.report.end | amDateFormat: vm.settings.amDateFormat}}<br>\n                    <span ng-if=\"vm.report.type == \'hourly\'\">\n                        <strong>Logged:</strong> {{vm.used(vm.report.time) | userTimeFormat}}<br>\n                        <strong>Total:</strong> {{::vm.currency}}{{vm.reportTotal() | number: 2}}\n                    </span>\n                    <!-- <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.address\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n                    <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.city\" inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>,\n                    <span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.state\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span>\n                    <span class=\"inline-edit-field small\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.postal\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span><br>\n                    <span class=\"inline-edit-field med\" inline-edit-on-blur=\"cancel\" inline-edit=\"vm.invoiceService.selectedInvoice.info.recipient.country\"  inline-edit-callback=\"vm.makeDirty()\" inline-edit-on-click  inline-edit-btn-save=\" Done  \"></span> -->\n                </p>\n                <p class=\"md-subhead\" ></p>\n            </div>\n            <div flex layout=\"column\">\n            <p class=\"md-subhead text-right\" style=\"margin-top: 0; padding-right: 0;\">\n                {{vm.today | amDateFormat: vm.settings.amDateFormat}}<br>&nbsp;<br>\n                <span ng-if=\"vm.report.type == \'retainer\'\">\n                    <strong>Allocated:</strong> {{vm.report.allocated * 60 |userTimeFormat}}<br>\n                    <strong>Logged:</strong> {{vm.used() | userTimeFormat}}<br>\n                    <strong>Remain:</strong> {{vm.remain() | userTimeFormat}}\n                </span>\n                <span ng-if=\"vm.report.type == \'time\'\">\n                    <strong>Logged:</strong> {{vm.used() | userTimeFormat}}\n                </span>\n                </p>\n            </div>\n    </div><!-- // header -->\n\n\n\n    <!-- column headings -->\n    <div layout=\'row\' layout-align=\"start start\" style=\"background-color: #eee; margin-bottom: 1em;\">\n        <div flex=\"15\">\n            Date\n        </div>\n        <div flex=\"20\" ng-if=\"vm.report.type == \'time\' && vm.showClient\">\n            Client\n        </div>\n        <div flex ng-if=\"vm.showMember\">\n            Member\n        </div>\n        <div flex>\n            Description\n        </div>\n        <div flex=\"15\" style=\"text-align: right; padding-right: 1em;\">\n            Logged\n        </div>\n        <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n            Total\n        </div>\n    </div>\n\n    <!-- default report - time in date order -->\n    <div ng-if=\"vm.groupBy == \'none\' && !vm.creatingGroups\">\n\n        <div layout=\'row\' layout-align=\"start start\" class=\"entry-line-item\"\n        ng-repeat=\"entry in vm.report.time | orderBy: [\'logDate\'] track by $index\">\n            <div flex=\"15\">\n                {{::entry.logDate | amDateFormat: vm.settings.shortDateFormat}}\n            </div>\n            <div flex=\"20\" ng-if=\"vm.report.type == \'time\' && vm.showClient\">\n                {{::entry.clientName}}\n            </div>\n            <div flex ng-if=\"vm.showMember\">\n                {{::entry.creatorName}}\n            </div>\n            <div flex class=\"entry-description\">\n                <span ng-if=\"entry.rateLabel && entry.rateLabel != \'default\'\" class=\"rate-label\">\n                    {{::entry.rateLabel}}<br>\n                </span>\n                    {{::entry.description}}\n\n            </div>\n\n            <div flex=\"15\" style=\"text-align:right; padding-right: 1em;\">\n               {{::entry.logged | userTimeFormat}}\n               <span ng-if=\"vm.report.type == \'hourly\' && vm.shouldShowRate(entry)\">\n                   @ {{::vm.currency}}{{vm.entryRate(entry)}}/hr\n               </span>\n            </div>\n\n            <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n                {{::vm.currency}}{{::vm.lineItemTotal(entry) | number: 2}}\n            </div>\n        </div>\n\n    </div>\n    <!-- // default report -->\n\n    <!-- grouped by task -->\n    <div ng-if=\"vm.groupBy !=\'none\' && !vm.creatingGroups\">\n        <div ng-repeat=\"group in vm.groups | orderBy: \'group.id\' track by $index\">\n             <md-divider ng-show=\"$index != 0\" style=\"margin-top: 1.5em; margin-bottom: 1em;\">\n             </md-divider>\n            <div layout=\"row\" layout-align=\"start start\" style=\"margin-bottom: 1.5em;\" class=\"entry-group-info\">\n                <div flex=\"70\" layout=\"column\" layout-align=\"center start\">\n                    <md-truncate flex=\"100\"><strong>{{group.label | uppercase}}</strong></md-truncate>\n                    <p ng-if=\"group.created\" class=\"md-subhead margin-0\" style=\"color: #999; font-size: .75em; line-heigh: 1.75em;\">\n                        <span ng-if=\"group.created\"><strong>Created:</strong> {{group.created | amDateFormat: vm.settings.shortDateFormat}} </span>\n                         <span ng-if=\"group.due\"><br><strong>Due:</strong> {{group.due | amDateFormat: vm.settings.shortDateFormat}}  </span>\n                        <span ng-if=\"group.created && !group.completed\"><br><strong>Completed:</strong> pending</span>\n                        <span ng-if=\"group.created && group.completed\"><br><strong>Completed:</strong> {{group.completed | amDateFormat: vm.settings.shortDateFormat}}</span>\n                    </p>\n                </div>\n                <span flex=\"30\" style=\"text-align: right; padding-right: 15px;\" layout=\"column\" layout-align=\"start end\">\n                    <div><strong>\n                        <span ng-if=\"group.id != \'none\'\"> {{vm.groupDisplayLabel}} total:</span>\n                        <span ng-if=\"group.id == \'none\'\"> Total:</span>\n                        {{vm.groupTotal(group.id) | userTimeFormat}}\n                    </strong></div>\n                    <p class=\"md-subhead margin-0\" style=\"color: #999; font-size: .75em;\" ng-if=\"group.budget\"><strong>Budget:</strong> {{group.budget | userTimeFormat}}</p>\n                </span>\n            </div>\n            <div layout=\'row\' layout-align=\"start start\" class=\"entry-line-item\"\n            ng-if=\"entry[vm.groupBy] == group.id\"\n            ng-repeat=\"entry in vm.groupReportTime | orderBy: \'entry.logDate\' track by $index\" >\n                <div flex=\"15\">\n                    {{::entry.logDate | amDateFormat: vm.settings.shortDateFormat}}\n                </div>\n                <div flex=\"20\" ng-if=\"vm.report.type == \'time\' && vm.showClient\">\n                    {{::entry.clientName}}\n                </div>\n                <div flex ng-if=\"vm.showMember\">\n                    {{::entry.creatorName}}\n                </div>\n                <div flex class=\"entry-description\">\n                        {{::entry.description}}\n                </div>\n\n                <div flex=\"15\" style=\"text-align:right; padding-right: 15px;\">\n                   {{::entry.logged | userTimeFormat}}\n                   <span ng-if=\"vm.report.type == \'hourly\' && vm.shouldShowRate(entry)\">\n                       @ {{::vm.currency}}{{vm.entryRate(entry)}}/hr\n                   </span>\n                </div>\n\n                <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n                    {{::vm.currency}}{{::vm.lineItemTotal(entry) | number: 2}}\n                </div>\n            </div>\n\n        </div><!-- group block -->\n    </div>\n    <!-- // group by task -->\n    <div layout-fill ng-if=\"vm.creatingGroups\" layout=\"row\" layout-align=\"center center\" style=\"width: 100%; background-color:#fff; min-height: 300px;\">\n        <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n        <h3 flex=\"nogrow\" class=\"center md-title\">Loading Task Detail</h3>\n    </div>\n    <md-divider ng-if=\"vm.report.type==\'hourly\'\" style=\"margin:1em 0 1em 0;\"></md-divider>\n    <div layout=\"row\" ng-if=\"vm.report.type==\'hourly\'\" layout-align=\"end center\" style=\"padding-right: 1em;\">\n            <strong>Total: {{::vm.currency}}{{vm.reportTotal() | number: 2}}</strong>\n    </div>\n\n</div>\n\n<div class=\"invoice-controls\" layout=\"row\" style=\"width: 100%; background-color: rgba(240,240,240,1);\" layout-align=\"center center\">\n\n    <!-- <md-button class=\"\" ng-click=\"vm.downloadInvoice()\">Download</md-button>\n    <md-button class=\"\" ng-click=\"vm.sendInvoice()\">Send</md-button> -->\n    <md-button flex=\"nogrow\" class=\"\" ng-click=\"vm.cancelReport()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n    <md-divider class=\"vertical-divider\"></md-divider>\n    <md-input-container style=\"padding:0 6px 0 6px;\">\n        <md-select style=\"margin: 0;\" class=\"small-select md-no-underline\" flex=\"nogrow\" ng-model=\"vm.groupBy\" ng-change=\"vm.groupByChanged(vm.groupBy)\">\n            <md-option ng-repeat=\"option in vm.groupOptions track by $index\" value=\"{{option.value}}\">\n                <md-icon md-font-icon=\"{{option.icon}}\"></md-icon>\n               {{option.name}}\n            </md-option>\n        </md-select>\n    </md-input-container>\n        <md-input-container flex=\"nogrow\" style=\"padding:0 6px 0 6px;\">\n            <!-- <label>Hide/Show Columns</label> -->\n        <md-select class=\"small-select md-no-underline\" ng-model=\"vm.columnVisibilityControl\" placeholder=\"Column Visibility\">\n\n            <md-option value=\"none\" ng-disabled=\"true\"><md-icon md-font-icon=\"fa fa-columns\"></md-icon> Column Visibility</md-option>\n            <md-option value=\"client\" ng-click=\"vm.toggleClientVisibility()\">\n                    <span ng-if=\"vm.showClient\"><md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon></span>\n                    <span ng-if=\"!vm.showClient\"><md-icon md-font-icon=\"zmdi zmdi-eye-off\"></md-icon></span>\n                    Client Column\n            </md-option>\n            <md-option value=\"member\" ng-click=\"vm.toggleMemberVisibility()\">\n                    <span ng-if=\"vm.showMember\"><md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon></span>\n                    <span ng-if=\"!vm.showMember\"><md-icon md-font-icon=\"zmdi zmdi-eye-off\"></md-icon></span>\n                    Member Column\n            </md-option>\n        </md-select>\n    </md-input-container>\n    <md-divider class=\"vertical-divider\"></md-divider>\n    <md-button print-btn flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon> Print Report</md-button>\n    <!-- <md-button ng-click=\"vm.printReport(vm.report)\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon> Request PDF</md-button> -->\n\n    <md-button  ng-if=\"vm.payloadKB <= 999\" ng-click=\"vm.emailReport(vm.report)\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Email Report</md-button>\n    <div ng-if=\"vm.payloadKB > 999\">\n        <md-button  ng-disabled=\"true\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Email Report</md-button>\n        <md-tooltip class=\"tt-multiline\">\n            This report is too large to be emailed or converted to PDF ({{vm.payloadLabel}}.)<br>\n            Please consider printing it to PDF locally.\n        </md-tooltip>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/print-time-report/time-line-item.tmpl.html","<div layout=\'row\' layout-align=\"start start\" class=\"entry-line-item\">\n    <div flex=\"15\">\n        {{::entry.logDate | amDateFormat: \'MMM DD\'}}\n    </div>\n    <div flex=\"20\" ng-if=\"vm.report.type == \'time\'\">\n        {{::entry.clientName}}\n    </div>\n    <div flex>\n        {{::entry.creatorName}}\n    </div>\n    <div flex class=\"entry-description\">\n            {{::entry.description}}\n    </div>\n\n    <div flex=\"15\" style=\"text-align:right; padding-right: 1em;\">\n       {{::entry.logged | userTimeFormat}}\n       <span ng-if=\"vm.report.type == \'hourly\' && vm.shouldShowRate(entry)\">\n           @ {{::vm.currency}}{{::vm.report.rate}}/hr\n       </span>\n    </div>\n\n    <div flex=\"15\" ng-if=\"vm.report.type == \'hourly\'\">\n        {{::vm.currency}}{{::vm.lineItemTotal(entry) | number: 2}}\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/profile-panel/new-profile-panel.tmpl.html","<div layout=\"column\" layout-align=\"start center\" style=\"padding-top: 5px; padding-left: 0px; padding-right: 100px;\">\n    <md-button class=\"\" ng-click=\"newPanel()\" style=\"width: 200px;\">\n        + New List\n    </md-button>\n</div>\n\n\n");
$templateCache.put("app/app-directives/profile-panel/profile-panel.tmpl.html","\n    <div class=\"app-item-container-header\" style=\"margin-bottom: 10px;\">\n\n        <div class=\"app-item-container-title panel-drag-handle\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{panel.color}};\">\n                <h3 class=\"panel-drag-handle\">\n                    {{panel.label}}\n                </h3>\n\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end start\">\n                <md-button class=\"md-icon-button\" ng-click=\"addDetail(\'note\', panel)\" layout=\"row\" flex=\"nogrow\" style=\"margin:0; width: 32px;\">\n                    <!-- <md-icon md-font-icon=\"zmdi zmdi-plus\" style=\"color: #fff; margin-right: 0;\"></md-icon> -->\n                    <span style=\"font-size: 10px; position: relative; left: 5px;\">+</span>\n                    <md-icon md-font-icon=\"fa fa-file-text-o\" style=\"color: #fff; margin-right: 0; font-size: 11px;\"></md-icon>\n                    <md-tooltip md-delay=\"1000\">New Note</md-tooltip>\n                </md-button>\n                <md-menu md-position-mode=\"target-right target\">\n                    <!-- Trigger element is a md-button with an icon -->\n                    <md-button ng-click=\"$mdMenu.open($event)\" aria-label=\"Add new profile detail\" class=\"md-icon-button\" style=\"margin-right: 0; margin-left: 0;\">\n                        <md-icon md-font-icon=\"zmdi zmdi-more-vert\">\n                            <md-tooltip md-delay=\"1000\">List Actions</md-tooltip>\n                        </md-icon>\n                    </md-button>\n\n                    <md-menu-content  class=\"md-dense\" style=\"width:200px;\">\n                        <md-menu-item>\n                            <md-button ng-disabled=\"true\">\n                                Add New\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button data-gtm-new-note-card ng-click=\"addDetail(\'note\', panel)\">\n                                <md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> Note Card\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button data-gtm-new-bookmark-card ng-click=\"addDetail(\'url\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> Bookmark Card\n                            </md-button>\n                        </md-menu-item>\n                        <!-- <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'files\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-attachment-alt\"></md-icon> Files\n                            </md-button>\n                        </md-menu-item> -->\n                        <md-menu-item>\n                            <md-button data-gtm-new-contact-card ng-click=\"addDetail(\'contact\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> Contact Card\n                            </md-button>\n                        </md-menu-item>\n                       <!--  <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'person\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> Person\n                            </md-button>\n                        </md-menu-item> -->\n                        <!-- <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'email\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> Email\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'phone\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> Phone\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item>\n                            <md-button ng-click=\"addDetail(\'address\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon> Address\n                            </md-button>\n                        </md-menu-item> -->\n                        <!-- The following two menu items ONLY appear in custom panels -->\n                        <md-menu-item>\n                            <md-button data-gtm-new-qa-card ng-click=\"addDetail(\'question\', panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-help\"></md-icon> Q&amp;A\n                            </md-button>\n                        </md-menu-item>\n                        <md-divider></md-divider>\n                        <md-menu-item ng-if=\"!isClientUser\">\n                            <md-button data-gtm-edit-detail-list ng-click=\"editPanel(panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit List\n                            </md-button>\n                        </md-menu-item>\n                        <md-menu-item ng-if=\"!isClientUser\" ng-if=\"panel.label != \'Client Details\'\">\n                            <md-button data-gtm-delete-detail-list ng-click=\"deletePanel(panel)\">\n                                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete List\n                            </md-button>\n                        </md-menu-item>\n                    </md-menu-content>\n                </md-menu>\n            </div>\n        </div>\n        <!-- // end app-item-container-title-bar -->\n    </div>\n    <!-- // end app-item-container-header -->\n\n    <div class=\"app-item-container-items\"\n        client=\"{{panel.client}}\"\n        panelid=\"{{panel.uid}}\"\n        ng-class=\"{\'layout-wrap\': !verticalProfilePanels , \'layout-column\': !verticalProfilePanels, \'vertical-scroll\': verticalProfilePanels}\"\n        layout-align=\"start start\"\n\n        dragula=\'\"drag-profile-detail\"\'\n        dragula-scope=\"$scope\"\n        style=\"overflow-y: scroll;\"\n        >\n        <!-- if this is the default/permanent \"Client Details\" panel, include our client\'s personal profile -->\n        <!-- For explanation of this syntax (we only want this function to bind once)\n             http://shuheikagawa.com/blog/2016/04/05/one-time-binding-for-ng-if/-->\n        <div ng-show=\"::!!(showClientCard(panel.label))\">\n            <client-card style=\"margin-top:3px;\"></client-card>\n        </div>\n        <profile-detail-item ng-if=\"!detail.rebuilding && detail.uid\" ng-repeat=\"detail in panel.details | toArray | filter: userFilter  | filter: filterText | orderBy: \'order\' track by detail.uid\" id=\"{{detail.uid}}\"></profile-detail-item>\n\n    </div>\n\n");
$templateCache.put("app/app-directives/reminder-card/reminder-card.tmpl.html","<md-card class=\"reminder-list-item\" ng-click=\"vm.selectReminder(vm.item)\" ng-class=\"{\'selected-reminder\': vm.scheduleService.selectedSchedule.uid == vm.item.uid}\">\n    <div class=\"reminder-header\" layout=\"row\" layout-align=\"start center\">\n        <md-icon ng-click=\"vm.discardReminder(vm.item)\" class=\"button-discard-reminder\" aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-close-circle\" class=\"\">\n            <md-tooltip md-delay=\"1000\">Discard</md-tooltip>\n        </md-icon>\n    </div>\n\n\n    <div class=\"reminder-body\" layout=\"row\" layout-align=\"layout-fill start\">\n      <div flex=\"nogrow\" style=\"padding-right: 1em;\">\n            <md-icon ng-if=\"vm.item.userStatus == \'active\'\" ng-click=\"vm.toggleStatus(vm.item, $event)\" class=\"button-complete-reminder\" aria-label=\"Mark Complete\" md-font-icon=\"zmdi zmdi-circle-o\">\n                <md-tooltip md-delay=\"1000\">Mark Complete</md-tooltip>\n            </md-icon>\n            <md-icon style=\"color: green;\" ng-if=\"vm.item.userStatus == \'closed\'\" ng-click=\"vm.toggleStatus(vm.item, $event)\" class=\"button-complete-reminder\" aria-label=\"Mark Complete\" md-font-icon=\"zmdi zmdi-check-circle\" class=\"\">\n                <md-tooltip md-delay=\"1000\">Reopen Reminder</md-tooltip>\n            </md-icon>\n      </div>\n      <div flex=\"grow\">\n            <p class=\"reminder-message\" ng-class=\"{\'triggered\': vm.item.status == \'triggered\' && vm.item.userStatus == \'active\'}\"  ng-bind-html=\"vm.sanitizeMe(vm.item.message) \"></p>\n            <!-- <p ng-if=\"vm.item.status == \'triggered\' && vm.item.userStatus == \'active\'\" style=\"color: red;\">DUE!!!</p> -->\n            <!-- <p class=\"reminder-timestamp\"  am-time-ago=\"vm.item.when\"></p> -->\n      </div>\n    </div>\n    <div class=\"reminder-footer\" layout=\"row\" layout-align=\"end center\">\n        <md-menu ng-if=\"vm.item.status == \'triggered\' && vm.item.userStatus == \'active\'\" md-position-mode=\"target bottom\">\n          <md-button  style=\"margin-right: 0;\" flex=\"nogrow\" ng-click=\"$mdOpenMenu($event)\">\n            Snooze\n            <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n          </md-button>\n          <md-menu-content >\n            <!-- <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 1, $event)\">\n                1 min\n              </md-button>\n            </md-menu-item> -->\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 5, $event)\">\n                5 min\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 15, $event)\">\n                15 min\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 30, $event)\">\n                30 min\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 60, $event)\">\n                1 hr\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 120, $event)\">\n                2 hr\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 240, $event)\">\n                4 hr\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 480, $event)\">\n                8 hr\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 720, $event)\">\n                12 hr\n              </md-button>\n            </md-menu-item>\n            <md-menu-item>\n              <md-button flex=\"nogrow\" ng-click=\"vm.snoozePersonalReminder(vm.item, 1440, $event)\">\n                1 day\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n        <span ng-if=\"!vm.showLongWhen(vm.item) && vm.item.when\" am-time-ago=\"vm.item.when\" style=\" margin: 0 10px 10px 10px; text-align: right;\"></span>\n        <span ng-if=\"vm.showLongWhen(vm.item) && vm.item.when\" style=\"text-align: right; margin: 0 10px 10px 10px\">{{vm.item.when | amDateFormat : vm.userSettings.longDateFormat}} at {{vm.item.when | amDateFormat: \'h:mm a\'}}</span>\n        <span ng-if=\"!vm.item.when\" style=\"text-align: right; margin: 0 10px 10px 10px\">&nbsp;</span>\n    </div>\n\n\n\n\n</md-card>\n");
$templateCache.put("app/app-directives/reminders/reminders-menu.tmpl.html","<div>\n  <span ng-if=\"vm.status == \'on\'\" class=\'reminder-datestamp\'>{{vm.reminderDate()}}</span>\n    <md-menu ng-if=\"vm.status == \'off\'\" class=\"reminders-menu\" md-position-mode=\"target-right target\">\n    <md-button class=\"md-icon-button\" ng-Click=\"$mdMenu.open($event);\">\n        <md-icon   md-font-icon=\"fa fa-bell-o\">\n            <md-tooltip md-delay=\"1000\">Set a Reminder</md-tooltip>\n        </md-icon>\n    </md-button>\n\n    <md-menu-content class=\"md-dense small-scrollbar\" style=\"overflow-x: hidden; min-height: 350px; width: 340px;\">\n            <h4 class=\"text-center md-subhead\">Remind me...</h3>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-click=\"vm.prepReminder(\'1h\')\" md-no-ink=\"true\">\n                        In 1 Hour\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-click=\"vm.prepReminder(\'1d\')\" md-no-ink=\"true\">\n                        In 1 Day\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-click=\"vm.prepReminder(\'2d\')\" md-no-ink=\"true\">\n                        In 2 Days\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-click=\"vm.prepReminder(\'3d\')\" md-no-ink=\"true\">\n                        In 3 Days\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-click=\"vm.prepReminder(\'7d\')\" md-no-ink=\"true\">\n                        In 1 Week\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-disabled=\"true\" md-no-ink=\"true\">\n                        or\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button style=\"text-align: center;\" ng-disabled=\"true\" md-no-ink=\"true\">\n                        <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon> Pick a Date <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item style=\"padding:0!important;\">\n                    <md-calendar style=\"padding-left: 0!important; padding-right:0!important;\" md-min-date=\"vm.minDate\" ng-change=\"vm.prepReminder(vm.when)\" ng-model=\"vm.when\"></md-calendar>\n                </md-menu-item>\n                <!-- <md-menu-item style=\"text-align: center;\">\n                    <md-datepicker  md-min-date=\"vm.minDate\" ng-change=\"vm.prepReminder(vm.when)\" ng-model=\"vm.when\" md-placeholder=\"Choose a day\"></md-datepicker>\n                </md-menu-item> -->\n    </md-menu-content>\n</md-menu>\n\n<md-menu ng-if=\"vm.status == \'on\'\" class=\"reminders-menu\" md-position-mode=\"target-right target\">\n    <md-button class=\"md-icon-button\" ng-Click=\"$mdMenu.open($event)\">\n        <md-icon  ng-if=\"vm.status==\'on\' && vm.options.status != \'triggered\'\"  md-font-icon=\"fa fa-bell-o\" style=\"color: orange;\" >\n                    <md-tooltip md-delay=\"1000\">Change Reminder</md-tooltip>\n                </md-icon>\n                <md-icon  ng-if=\"vm.status==\'on\' && vm.options.status == \'triggered\'\"  md-font-icon=\"fa fa-bell\" style=\"color:red;\">\n                            <md-tooltip md-delay=\"1000\">Reminder Due</md-tooltip>\n                        </md-icon>\n    </md-button>\n    <md-menu-content class=\"md-dense\" style=\"overflow-x: hidden;\">\n        <md-menu ng-if=\"vm.options.status == \'triggered\'\" style=\"margin:0;\">\n             <md-button ng-click=\"$mdOpenMenu()\" style=\"width:100%; text-align: left; padding-left: 9px;\" layout=\"row\">\n               <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"margin-right: 18px;\"></md-icon>\n                <span flex=\"grow\">Snooze</span>\n                <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n               </md-button>\n             <md-menu-content>\n               <md-menu-item>\n                    <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 5, $event)\">\n                       5 min\n                   </md-button>\n                </md-menu-item>\n                 <md-menu-item>\n                      <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 15, $event)\">\n                         15 min\n                     </md-button>\n                  </md-menu-item>\n                  <md-menu-item>\n                       <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 30, $event)\">\n                          30 min\n                      </md-button>\n                   </md-menu-item>\n                   <md-menu-item>\n                        <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 60, $event)\">\n                           60 min\n                       </md-button>\n                    </md-menu-item>\n                <md-menu-item>\n                     <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 120, $event)\">\n                        2 hr\n                    </md-button>\n                 </md-menu-item>\n                 <md-menu-item>\n                      <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 480, $event)\">\n                         8 hr\n                     </md-button>\n                  </md-menu-item>\n              <md-menu-item>\n                   <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 720, $event)\">\n                      12 hr\n                  </md-button>\n               </md-menu-item>\n               <md-menu-item>\n                    <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 1440, $event)\">\n                       1 day\n                   </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                     <md-button flex=\"nogrow\"  ng-click=\"vm.snoozeReminder(vm.options, 2880, $event)\">\n                        2 days\n                    </md-button>\n                 </md-menu-item>\n           </md-menu-content>\n       </md-menu>\n        <md-menu-item>\n            <md-button  ng-click=\"vm.removeReminder()\" md-no-ink=\"true\">\n                <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n                Cancel Reminder\n            </md-button>\n        </md-menu-item>\n        <md-menu-item ng-if=\"vm.options.status != \'triggered\'\">\n            <md-button ng-click=\"vm.setReminderTime()\" md-no-ink=\"true\">\n                <md-icon md-font-icon=\"fa fa-clock-o\"></md-icon>\n                Specify time\n            </md-button>\n        </md-menu-item>\n    </md-menu-content>\n</md-menu>\n</div>\n");
$templateCache.put("app/app-directives/settings-panel/settings-panel.tmpl.html","<div md-theme=\"adminja-blue\">\n<md-list>\n        <div>\n                <md-subheader class=\"md-primary\"><span translate>Units</span></md-subheader>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"fa fa-dollar\"></md-icon>\n                        <p translate>Currency</p>\n                        <md-input-container>\n                                <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a currency\" ng-model=\"vm.settings.currencyCode\" ng-change=\"vm.updateCurrency(vm.settings.currencyCode)\">\n                                    <md-option ng-repeat=\"currency in currencies track by $index+id\" value=\"{{currency.code}}\">\n                                        <span style=\"font-size: 1.5em; font-weight: bold; padding-right: 1em;\" ng-bind-html=\"currency.symbol\"></span> {{currency.code}} - {{currency.description}}\n                                    </md-option>\n                                </md-select>\n                        </md-input-container>\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n                        <p translate>Date Format</p>\n                        <md-input-container style=\"\">\n                                <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a date format\" ng-model=\"vm.settings.dateFormat\"  ng-change=\"vm.updateSettings(\'dateFormat\',vm.settings.dateFormat)\">\n                                        <md-option value=\"us\">US: mm/dd/yyyy</md-option>\n                                        <md-option value=\"eu\">EU: dd/mm/yyyy</md-option>\n                                </md-select>\n                        </md-input-container>\n\n                        <!-- <md-switch class=\"md-secondary\" ng-model=\"vm.settings.dateFormat\"></md-switch> -->\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-time-interval\"></md-icon>\n                        <p translate>Show time in decimal format</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.timeFormat\" ng-change=\"vm.updateSettings(\'timeFormat\',vm.settings.timeFormat)\"></md-switch>\n                </md-list-item>\n\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\" ng-if=\"vm.user.type != \'client\'\">\n                        <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                        <p translate>Round timers up to nearest...</p>\n                        <md-input-container>\n                                <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a unit\" ng-model=\"vm.settings.roundUpTo\" ng-change=\"vm.updateSettings(\'roundUpTo\',vm.settings.roundUpTo)\">\n                                        <md-option value=\"1\">minute</md-option>\n                                        <md-option value=\"5\">5 minutes</md-option>\n                                        <md-option value=\"10\">10 minutes</md-option>\n                                        <md-option value=\"15\">15 minutes</md-option><!-- rupee -->\n                                        <md-option value=\"30\">half hour</md-option><!-- franc -->\n                                        <md-option value=\"60\">hour</md-option><!-- Swedish franc -->\n                                </md-select>\n                        </md-input-container>\n                </md-list-item>\n        </div>\n        <div ng-if=\"vm.user.type != \'client\'\">\n            <md-subheader class=\"md-primary\"><span translate>Calendar</span></md-subheader>\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                    <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n                    <p translate>Start of week</p>\n                    <md-input-container style=\"\">\n                            <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a day\" ng-model=\"vm.settings.startOfWeek\"  ng-change=\"vm.updateSettings(\'startOfWeek\',vm.settings.startOfWeek)\">\n                                    <md-option value=\"0\">Sunday</md-option>\n                                    <md-option value=\"1\">Monday</md-option>\n                                    <md-option value=\"2\">Tuesday</md-option>\n                                    <md-option value=\"3\">Wednesday</md-option>\n                                    <md-option value=\"4\">Thursday</md-option>\n                                    <md-option value=\"5\">Friday</md-option>\n                                    <md-option value=\"6\">Saturday</md-option>\n                            </md-select>\n                    </md-input-container>\n\n                    <!-- <md-switch class=\"md-secondary\" ng-model=\"vm.settings.dateFormat\"></md-switch> -->\n            </md-list-item>\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                    <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n                    <p translate>Start of work Day</p>\n                    <md-input-container style=\"\">\n                            <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a time\" ng-model=\"vm.settings.startOfWorkday\"  ng-change=\"vm.updateSettings(\'startOfWorkday\',vm.settings.startOfWorkday)\">\n                                <md-option value=\"00:00\">12:00am</md-option>\n                                <md-option value=\"01:00\">1:00am</md-option>\n                                <md-option value=\"02:00\">2:00am</md-option>\n                                <md-option value=\"03:00\">3:00am</md-option>\n                                <md-option value=\"04:00\">4:00am</md-option>\n                                <md-option value=\"05:00\">5:00am</md-option>\n                                <md-option value=\"06:00\">6:00am</md-option>\n                                <md-option value=\"07:00\">7:00am</md-option>\n                                <md-option value=\"08:00\">8:00am</md-option>\n                                <md-option value=\"09:00\">9:00am</md-option>\n                                <md-option value=\"10:00\">10:00am</md-option>\n                                <md-option value=\"11:00\">11:00am</md-option>\n                                <md-option value=\"12:00\">12:00pm</md-option>\n                                <md-option value=\"13:00\">1:00pm</md-option>\n                                <md-option value=\"14:00\">2:00pm</md-option>\n                                <md-option value=\"15:00\">3:00pm</md-option>\n                                <md-option value=\"16:00\">4:00pm</md-option>\n                                <md-option value=\"17:00\">5:00pm</md-option>\n                                <md-option value=\"18:00\">6:00pm</md-option>\n                                <md-option value=\"19:00\">7:00pm</md-option>\n                                <md-option value=\"20:00\">8:00pm</md-option>\n                                <md-option value=\"21:00\">9:00pm</md-option>\n                                <md-option value=\"22:00\">10:00pm</md-option>\n                                <md-option value=\"23:00\">11:00pm</md-option>\n                            </md-select>\n                    </md-input-container>\n\n                    <!-- <md-switch class=\"md-secondary\" ng-model=\"vm.settings.dateFormat\"></md-switch> -->\n            </md-list-item>\n\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                    <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n                    <p translate>End of work Day</p>\n                    <md-input-container style=\"\">\n                            <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a time\" ng-model=\"vm.settings.endOfWorkday\"  ng-change=\"vm.updateSettings(\'endOfWorkday\',vm.settings.endOfWorkday)\">\n                                    <md-option value=\"00:00\">12:00am</md-option>\n                                    <md-option value=\"01:00\">1:00am</md-option>\n                                    <md-option value=\"02:00\">2:00am</md-option>\n                                    <md-option value=\"03:00\">3:00am</md-option>\n                                    <md-option value=\"04:00\">4:00am</md-option>\n                                    <md-option value=\"05:00\">5:00am</md-option>\n                                    <md-option value=\"06:00\">6:00am</md-option>\n                                    <md-option value=\"07:00\">7:00am</md-option>\n                                    <md-option value=\"08:00\">8:00am</md-option>\n                                    <md-option value=\"09:00\">9:00am</md-option>\n                                    <md-option value=\"10:00\">10:00am</md-option>\n                                    <md-option value=\"11:00\">11:00am</md-option>\n                                    <md-option value=\"12:00\">12:00pm</md-option>\n                                    <md-option value=\"13:00\">1:00pm</md-option>\n                                    <md-option value=\"14:00\">2:00pm</md-option>\n                                    <md-option value=\"15:00\">3:00pm</md-option>\n                                    <md-option value=\"16:00\">4:00pm</md-option>\n                                    <md-option value=\"17:00\">5:00pm</md-option>\n                                    <md-option value=\"18:00\">6:00pm</md-option>\n                                    <md-option value=\"19:00\">7:00pm</md-option>\n                                    <md-option value=\"20:00\">8:00pm</md-option>\n                                    <md-option value=\"21:00\">9:00pm</md-option>\n                                    <md-option value=\"22:00\">10:00pm</md-option>\n                                    <md-option value=\"23:00\">11:00pm</md-option>\n                            </md-select>\n                    </md-input-container>\n\n                    <!-- <md-switch class=\"md-secondary\" ng-model=\"vm.settings.dateFormat\"></md-switch> -->\n            </md-list-item>\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                    <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n                    <p translate>Calendar slots start at:</p>\n                    <md-input-container style=\"\">\n                            <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a time\" ng-model=\"vm.settings.calendarViewStartOfDay\"  ng-change=\"vm.updateSettings(\'calendarViewStartOfDay\',vm.settings.calendarViewStartOfDay)\">\n                                <md-option value=\"00:00\">12:00am</md-option>\n                                <md-option value=\"01:00\">1:00am</md-option>\n                                <md-option value=\"02:00\">2:00am</md-option>\n                                <md-option value=\"03:00\">3:00am</md-option>\n                                <md-option value=\"04:00\">4:00am</md-option>\n                                <md-option value=\"05:00\">5:00am</md-option>\n                                <md-option value=\"06:00\">6:00am</md-option>\n                                <md-option value=\"07:00\">7:00am</md-option>\n                                <md-option value=\"08:00\">8:00am</md-option>\n                                <md-option value=\"09:00\">9:00am</md-option>\n                                <md-option value=\"10:00\">10:00am</md-option>\n                                <md-option value=\"11:00\">11:00am</md-option>\n                                <md-option value=\"12:00\">12:00pm</md-option>\n                                <md-option value=\"13:00\">1:00pm</md-option>\n                                <md-option value=\"14:00\">2:00pm</md-option>\n                                <md-option value=\"15:00\">3:00pm</md-option>\n                                <md-option value=\"16:00\">4:00pm</md-option>\n                                <md-option value=\"17:00\">5:00pm</md-option>\n                                <md-option value=\"18:00\">6:00pm</md-option>\n                                <md-option value=\"19:00\">7:00pm</md-option>\n                                <md-option value=\"20:00\">8:00pm</md-option>\n                                <md-option value=\"21:00\">9:00pm</md-option>\n                                <md-option value=\"22:00\">10:00pm</md-option>\n                                <md-option value=\"23:00\">11:00pm</md-option>\n                            </md-select>\n                    </md-input-container>\n\n                    <!-- <md-switch class=\"md-secondary\" ng-model=\"vm.settings.dateFormat\"></md-switch> -->\n            </md-list-item>\n        </div>\n        <div>\n                <md-subheader class=\"md-primary\"><span translate>Behavior</span></md-subheader>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"fa fa-thumb-tack\"></md-icon>\n                        <p translate>Pin Left Menu Open</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.pinMenu\" ng-change=\"vm.updateSettings(\'pinMenu\',vm.settings.pinMenu)\"></md-switch>\n\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\" ng-if=\"vm.user.type != \'client\'\">\n                        <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                        <p translate>Require work description for time entries</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.requireWorkDescription\" ng-change=\"vm.updateSettings(\'requireWorkDescription\',vm.settings.requireWorkDescription)\"></md-switch>\n\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-time-countdown\"></md-icon>\n                        <p translate>Log out when I\'m idle for:</p>\n                        <md-input-container>\n                                <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a timeframe\" ng-model=\"vm.settings.idleTimeout\" ng-change=\"vm.updateSettings(\'idleTimeout\',vm.settings.idleTimeout); setIdleTimeout(vm.settings.idleTimeout);\">\n                                        <md-option value=\"300\">5 minutes</md-option>\n                                        <md-option value=\"1800\">30 minutes</md-option>\n                                        <md-option value=\"3600\">1 hour</md-option>\n                                        <md-option value=\"5400\">90 minutes</md-option>\n                                        <md-option value=\"14400\">4 hours</md-option>\n                                        <md-option value=\"28800\">8 hours</md-option>\n                                </md-select>\n                        </md-input-container>\n                </md-list-item>\n\n        </div>\n        <div>\n            <md-subheader class=\"md-primary\"><span translate>Time Reporting</span></md-subheader>\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                    <md-icon md-font-icon=\"fa fa-th-list\"></md-icon>\n                    <p translate>Default Report Date Range</p>\n                    <md-input-container>\n                            <md-select class=\"small-select md-no-underline\" md-no-asterisk  ng-model=\"vm.settings.reportRange\" ng-change=\"vm.updateSettings(\'reportRange\',vm.settings.reportRange)\">\n                                    <md-option value=\"saved\">User Selected</md-option>\n                                    <md-option value=\"last7\">Last 7 Days</md-option>\n                                    <md-option value=\"last14\">Last 14 Days</md-option>\n                                    <md-option value=\"last30\">Last 30 Days</md-option>\n                                    <md-option value=\"last90\">Last 90 Days</md-option>\n                                    <md-option value=\"thisMonth\">This Month</md-option>\n                            </md-select>\n                    </md-input-container>\n            </md-list-item>\n            <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\" ng-if=\"vm.user.type != \'client\'\">\n                    <md-icon md-font-icon=\"fa fa-th-list\"></md-icon>\n                    <p translate>Include Archived Workspaces by default</p>\n                    <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showArchivedByDefault\" ng-change=\"vm.updateSettings(\'showArchivedByDefault\',vm.settings.showArchivedByDefault)\"></md-switch>\n            </md-list-item>\n        </div>\n        <div>\n                <md-subheader class=\"md-primary\"><span translate>Recent Activity/Notifications</span></md-subheader>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-notifications-off\"></md-icon>\n                        <p translate>Disable in-Adminja notification alerts</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.disableToasts\" ng-change=\"vm.updateSettings(\'disableToasts\',vm.settings.disableToasts)\"></md-switch>\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n                        <p translate>Forward copy of all notifications to Email</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.notifyEmail\" ng-change=\"vm.updateSettings(\'notifyEmail\',vm.settings.notifyEmail)\"></md-switch>\n                </md-list-item>\n\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"noGhostUser()\">\n                        <md-button flex=\"nogrow\" ng-click=\"vm.requestNotificationPermission()\"> <md-icon md-font-icon=\"zmdi zmdi-notifications\"></md-icon> Enable Browser OS Notifications</md-button>\n                </div>\n        </div>\n        <div ng-if=\"vm.user.type != \'client\'\">\n                <md-subheader class=\"md-primary\"><span translate>Dashboard</span></md-subheader>\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Use Classic Dashboard</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.useOriginalDashboard\" ng-change=\"vm.updateSettings(\'useOriginalDashboard\',vm.settings.useOriginalDashboard)\"></md-switch>\n                        <md-tooltip md-delay=\"250\">The classic dashboard will become unavailable in the near future.</md-tooltip>\n                </md-list-item>\n                <div ng-if=\"vm.settings.useOriginalDashboard\">\n                    <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                            <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                            <p translate>Hide Today Panel</p>\n                            <md-switch class=\"md-secondary\" ng-model=\"vm.settings.hideDashboardToday\" ng-change=\"vm.updateSettings(\'hideDashboardToday\',vm.settings.hideDashboardToday)\"></md-switch>\n\n                    </md-list-item>\n                </div> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Show Weekly Status</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showWeeklyStatus\" ng-change=\"vm.updateSettings(\'showWeeklyStatus\',vm.settings.showWeeklyStatus)\"></md-switch>\n                        <md-tooltip md-delay=\"250\">Adds a weekly progress to workspace snapshots.</md-tooltip>\n                </md-list-item> -->\n                <div ng-if=\"!vm.settings.useOriginalDashboard\">\n                    <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                            <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                            <p translate>Hide Progress &amp; Billing Charts</p>\n                            <md-switch class=\"md-secondary\" ng-model=\"vm.settings.hideDashboardCharts\" ng-change=\"vm.updateSettings(\'hideDashboardCharts\',vm.settings.hideDashboardCharts)\"></md-switch>\n                    </md-list-item>\n                </div>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Hide Recent Activity</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.hideDashboardNotifications\" ng-change=\"vm.updateSettings(\'hideDashboardNotifications\',vm.settings.hideDashboardNotifications)\"></md-switch>\n\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Show Team progress instead of Personal</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showTeamStatus\" ng-change=\"vm.updateSettings(\'showTeamStatus\',vm.settings.showTeamStatus)\"></md-switch>\n\n                </md-list-item>\n\n\n        </div>\n        <div>\n                <md-subheader class=\"md-primary\"><span translate>Layout</span></md-subheader>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Vertical Details Lists</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.verticalProfilePanels\" ng-change=\"vm.updateSettings(\'verticalProfilePanels\',vm.settings.verticalProfilePanels)\"></md-switch>\n\n                </md-list-item>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon>\n                        <p translate>Vertical Task Lists</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.verticalTaskPanels\" ng-change=\"vm.updateSettings(\'verticalTaskPanels\',vm.settings.verticalTaskPanels)\"></md-switch>\n\n                </md-list-item>\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n                        <p translate>Group <strong>Today</strong> view by Workspace</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.groupToday\" ng-change=\"vm.updateSettings(\'groupToday\',vm.settings.groupToday)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n                        <p translate>Show <strong>Today</strong> List in <Strong>All Tasks</Strong></p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showTodayPanel\" ng-change=\"vm.updateSettings(\'showTodayPanel\',vm.settings.showTodayPanel)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n                        <p translate>Show <strong>Today</strong> Lists in in Workspaces by default (not recommended)</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showClientTodayPanel\" ng-change=\"vm.updateSettings(\'showClientTodayPanel\',vm.settings.showClientTodayPanel)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon>\n                        <p translate>Hide empty <strong>New Tasks</strong> list</p>\n                        <md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.settings.showEmptyNewTaskList\" ng-change=\"vm.updateSettings(\'showEmptyNewTaskList\',vm.settings.showEmptyNewTaskList)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"fa fa-check\"></md-icon>\n                        <p translate>Show <strong>Recently Completed</strong> tasks</p>\n                        <md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.settings.hideCompletedPanel\" ng-change=\"vm.updateSettings(\'hideCompletedPanel\',vm.settings.hideCompletedPanel)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\" >\n                        <md-icon md-font-icon=\"zmdi zmdi-tv-play\"></md-icon>\n                        <p translate>Show <strong> Video Tutorials</strong></p>\n                        <md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.settings.hideGuide\" ng-change=\"vm.updateSettings(\'hideGuide\',vm.settings.hideGuide)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink ng-if=\"vm.settings.onboardingComplete != undefined\" layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n                        <p translate>Show <strong>Onboarding Progress</strong></p>\n                        <md-switch class=\"md-secondary\" ng-true-value=\"false\" ng-false-value=\"true\" ng-model=\"vm.settings.onboardingComplete\" ng-change=\"vm.updateSettings(\'onboardingComplete\',vm.settings.onboardingComplete)\"></md-switch>\n                </md-list-item> -->\n                <!-- <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n                        <p translate>Show Timer in Right Sidebar instead</p>\n                        <md-switch class=\"md-secondary\" ng-model=\"vm.settings.showTimerInSidebar\" ng-change=\"vm.updateSettings(\'showTimerInSidebar\',vm.settings.showTimerInSidebar)\"></md-switch>\n                </md-list-item> -->\n        </div>\n\n        <!-- <md-list-item md-no-ink layout=\"column\" layout-align=\"center center\">\n                <md-button class=\"\" ng-click=\"resetOnboarding()\">Reset Onboarding Checklist</md-button>\n        </md-list-item> -->\n        <!-- <div ng-repeat=\"group in ::statisticsGroups\"> -->\n                <!-- <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader> -->\n                <!-- <md-list-item md-no-ink ng-repeat=\"stat in ::group.stats\" layout=\"column\" layout-align=\"space-around start\"> -->\n                 <!--   <md-progress-linear class=\"margin-top-20 ng-class=\"::stat.mdClass\" md-mode=\"determinate\" ng-value=\"::stat.value\"></md-progress-linear>-->\n                        <!-- <p translate>{{::stat.title}}</p> -->\n                <!-- </md-list-item> -->\n        <!-- </div> -->\n        <div>\n                <md-subheader class=\"md-primary\"><span translate>Onboarding Progress</span></md-subheader>\n                <md-list-item md-no-ink layout=\"row\" layout-align=\"space-around center\">\n                        <md-icon md-font-icon=\"fa fa-check\"></md-icon>\n                        <p translate>Reset Onboarding Checklists</p>\n                        <md-button class=\"md-small-button md-raised md-primary\" ng-click=\"vm.resetProgress()\">Reset</md-button>\n                </md-list-item>\n            </div>\n</md-list>\n</div>\n");
$templateCache.put("app/app-directives/sidebar-controls/sidebar-controls.tmpl.html","<div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" style=\"height: 100%;\">\n<!--     <md-button data-gtm-reactivate-account md-no-ink style=\"margin-left: 1em;\" flex=\"nogrow\" class=\"md-green-button\" ng-if=\"vm.gates.subStatus == \'cancelled\' \"  ui-sref=\"authentication.profile({selectedTab: 4})\" class=\"\">\n        Reactivate\n    </md-button> -->\n    <md-button data-gtm-upgrade-account md-no-ink ng-class-on-mobile class-to-add=\"hide\" style=\"margin-left: 1em;\" flex=\"nogrow\" class=\"md-green-button\" ng-if=\"vm.user.plan.content__subscription__plan_id.includes(\'starter\') && vm.user.plan.content__subscription__status != \'cancelled\' && !vm.user.teams\" ui-sref=\"authentication.profile({selectedTab: 4})\" class=\"\">\n        Upgrade\n    </md-button>\n    <div ng-if=\"vm.config.env == \'staging\'\" style=\"width: 5px; background-color: orange; height: 100%;\">\n    	&nbsp;\n    </div>\n\n    <timer\n        hide-xs\n        hide-sm\n        ng-if=\"canUseTimer\"\n        style=\"border-right: 1px solid rgba(255,255,255,.3);padding:0;\">\n    </timer>\n\n\n    <div flex=\"nogrow\" layout=\"row\" style=\"position: relative;\">\n        <md-button data-gtm-open-timer-tray md-no-ink hide-xs hide-sm  ng-if=\"canUseTimer\" ng-disabled=\"!vm.user.timers\" style=\"margin-right:0; \" class=\"md-icon-button\" ng-click=\"toggleNotificationsTab(1)\" aria-label=\"Timer\">\n            <md-icon md-font-icon=\"zmdi zmdi-timer\" ng-class=\"{\'hit-limit\': vm.numTimers() > 9}\">\n            </md-icon>\n            <md-tooltip md-delay=\"1000\">\n                View Open Timers\n            </md-tooltip>\n        </md-button>\n        <span class=\"badge hide-sm hide-xs\" ng-class=\"{\'hit-limit\': vm.numTimers() > 9}\" ng-if=\"vm.numTimers() > 0 && canUseTimer\">{{vm.numTimers()}}</span>\n    </div>\n\n    <!-- Notifications toggle-->\n    <div flex=\"nogrow\" class=\"notification-badge\" style=\"position: relative;\" hide-sm hide-xs>\n        <md-button data-gtm-open-notification-tray md-no-ink class=\"md-icon-button\" ng-click=\"toggleNotificationsTab(notificationTabIndex); vm.markAllRead()\" aria-label=\"Recent Activity\" style=\"margin-right: 0;\">\n            <md-icon ng-if=\"vm.inboxCount() > 0\"  md-font-icon=\"fa fa-bell\"></md-icon>\n            <md-icon ng-if=\"vm.inboxCount() == 0\" md-font-icon=\"fa fa-bell-o\"></md-icon>\n            <md-tooltip md-delay=\"1000\">\n                Show Notifications\n            </md-tooltip>\n        </md-button>\n\n        <span class=\"badge hide-sm hide-xs\" ng-if=\"vm.inboxCount() > 0\">{{vm.inboxCount()}}</span>\n\n    </div>\n\n    <div flex=\"nogrow\" layout=\"row\" style=\"position: relative;\">\n        <md-button data-gtm-open-reminders-tray md-no-ink hide-xs hide-sm  ng-if=\"canUseTimer\" style=\"margin-right:0; \" class=\"md-icon-button\" ng-click=\"toggleNotificationsTab(3)\" aria-label=\"Timer\">\n            <md-icon md-svg-src=\"/assets/images/icons/reminder.svg\"></md-icon>\n            <md-tooltip md-delay=\"1000\">\n                Reminders\n            </md-tooltip>\n        </md-button>\n        <span class=\"badge hide-sm hide-xs\" ng-if=\"vm.reminderCount() > 0\">{{vm.reminderCount()}}</span>\n    </div>\n    <div flex=\"nogrow\" style=\"margin-right: 0; margin-left: 10px;\">\n        <md-menu>\n            <md-button md-no-ink class=\"md-icon-button\" aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"User Menu\" style=\"margin-left: 0;\">\n                <!-- <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon> -->\n                <img class=\"toolbar-user-avatar\" src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" style=\"background-color: #405d89;\">\n                <!-- <span style=\"text-transform: none; padding-left: 1em;\">{{vm.user.profile.firstName}} {{vm.user.profile.lastName}}</span> -->\n                <md-tooltip md-delay=\"1000\">\n                    User Menu\n                </md-tooltip>\n            </md-button>\n            <md-menu-content  style=\"padding-bottom:0;\" class=\"md-dense\">\n                <md-menu-item>\n                    <md-button md-no-ink ui-sref=\"authentication.profile\" aria-label=\"Account\" style=\"padding-top:0;\">\n                        <img class=\"toolbar-user-avatar\" src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" style=\"background-color: #405d89;\">\n                        <span style=\"text-transform: none; padding-left: 1em;\">My Account<!-- {{vm.user.profile.firstName}} {{vm.user.profile.lastName}} --></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item>\n                    <md-button md-no-ink ng-click=\"toggleNotificationsTab(4)\" aria-label=\"Account\" style=\"padding-top:0;\">\n                        <md-icon md-font-icon=\"fa fa-gear\" style=\"font-size: 15px;\"></md-icon>\n                        <span translate=\"Settings\"></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item hide-sm hide-xs>\n                    <md-button data-gtm-toggle-fullscreen md-no-ink ng-click=\"vm.toggleFullScreen(\'right\')\" aria-label=\"Toggle Full Screen\" style=\"padding-top: 0;\">\n                            <md-icon ng-if=\"!vm.isFullScreen\" md-font-icon=\"zmdi zmdi-fullscreen\"></md-icon>\n                            <md-icon ng-if=\"vm.isFullScreen\"  md-font-icon=\"zmdi zmdi-fullscreen-exit\"></md-icon>\n                            <span translate=\"Toggle Fullscreen\">Toggle Fullscreen</span>\n                    </md-button>\n                </md-menu-item>\n                <!-- <md-menu-item>\n                    <md-button md-no-ink ng-click=\"vm.getHelp()\" aria-label=\"Help\">\n                        <md-icon md-font-icon=\"fa fa-life-ring\" style=\"font-size: 15px;\"></md-icon>\n                        <span translate=\"Help\"></span>\n                    </md-button>\n                </md-menu-item> -->\n                <md-menu-item>\n                    <md-button data-gtm-logout md-no-ink ng-click=\"vm.logout()\" aria-label=\"Log Out\">\n                        <md-icon md-font-icon=\"zmdi zmdi-lock-open\" style=\"font-size: 15px; margin-left: 5px;\"></md-icon>\n                        <span translate=\"Logout\"></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                    <md-button data-gtm-logout md-no-ink href=\"{{vm.fbConfig.dataURL}}users/{{vm.user.uid}}\" target=\"_blank\" aria-label=\"X-Ray\">\n                        <md-icon md-font-icon=\"zmdi zmdi-code\" style=\"font-size: 15px; margin-left: 5px;\"></md-icon>\n                        <span translate=\"X-Ray\"></span>\n                    </md-button>\n                </md-menu-item>\n                <md-menu-item ng-if=\"trial\" style=\"background-color: {{trial.color}}; color: #fff; height: auto!important; max-height: 150px;\" class=\"hotspot-sidebarcontrols-one\">\n                    <md-button md-no-ink style=\"padding-top:0;\"  ng-click=\"vm.showTrialMessage()\" style=\"\">\n\n                        <div ng-if=\"trial.type == \'paid\'\" style=\"display:block; padding: 1em;\">\n                            <p ng-if=\"trial.status != \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your free trial ends in {{trial.daysLeft}} days.</p>\n                            <p ng-if=\"trial.status == \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\">Your premium account has been suspended.<br>You still have access to free <b>Starter</b> plan features and limits.</p>\n                            <p ng-if=\"trial.status == \'expired\'\" style=\"display: block; text-align: center; margin:0; line-height: 1.5em;\"><a style=\"color: #fff;\" ui-sref=\"authentication.profile({selectedTab: 2})\"><b>Visit your Account settings</b></a> to upgrade to a different plan.</p>\n                        </div>\n\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n\n    </div>\n\n\n</div>\n");
$templateCache.put("app/app-directives/subscription-manager/subscription-manager.tmpl.html","<div class=\"subscription-manager\" layout=\"column\">\n\n    <div layout=\"row\" layout-align=\"center start\">\n        <div layout=\"row\" layout-wrap layout-align=\"center start\" flex=\"auto\" style=\"background-color: rgb(240,240,240); border-radius: 4px; max-width: 800px; padding: 1em 1em 2em 1em;\">\n            <div layout=\"column\" flex=\"100\">\n                <h3 ng-if=\"vm.currentStatus == \'active\'\" class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0;\">\n                    You are on the <strong>{{vm.currentPlan.planName}}</strong> plan\n                </h3>\n                <h3 ng-if=\"vm.currentStatus == \'cancelled\'\" class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0;\">\n                    You were on the <strong>{{vm.currentPlan.planName}}</strong> plan\n                </h3>\n                <h3 ng-if=\"vm.currentStatus == \'in_trial\'\" class=\"md-title center\" style=\"font-weight: 400; margin-bottom: 0;\">\n                    You have signed up for the <strong>{{vm.currentPlan.planName}}</strong> plan\n                </h3>\n            </div>\n            <div flex=\"nogrow\" style=\"min-width: 300px; margin-top: 2em;\">\n                <p class=\"md-subhead\" style=\"margin-bottom: 0;\"><strong>Your plan includes:</strong></p>\n                <p class=\"md-subhead\" style=\"padding-left: 1em;\">\n                    - {{vm.getWorkspaceLimit(vm.currentPlan.workspaces)}} Workspaces<br>\n                    <span ng-if=\"vm.currentPlan.recurring == 0\">- Unlimited Recurring Tasks<br></span>\n                    <span ng-if=\"vm.currentPlan.recurring != 0\">- Limited Recurring Tasks<br></span>\n                    <span ng-if=\"vm.currentPlan.team >1\">- Up to {{vm.currentPlan.team}} Team Members<br></span>\n                </p>\n\n\n\n                <div ng-if=\"vm.user.limits.team > 4 && (vm.currentStatus == \'active\' || vm.currentStatus == \'in_trial\')\">\n                    <p class=\"md-subhead\"><strong>Team members</strong></p>\n                    <p class=\"md-subhead\" ng-if=\"vm.user.limits.additionalTeamMembers\">\n                        {{vm.user.limits.team}} with plan + {{vm.user.limits.additionalTeamMembers}} additional = {{vm.user.limits.team + vm.user.limits.additionalTeamMembers}}\n                    </p>\n                    <p class=\"md-subhead\" ng-if=\"!vm.user.limits.additionalTeamMembers && !vm.showAddonForm\">\n                        {{vm.user.limits.team}}\n                    </p>\n                    <a style=\"cursor: pointer;\" ng-if=\"!vm.showAddonForm\" ng-click=\"vm.toggleAddonForm()\">Add/Remove Team Members</a>\n\n                 </div>\n             </div>\n\n\n            <div flex=\"100\" flex-gt-sm=\"30\" style=\"min-width: 300px;\" layout=\"column\" layout-align=\"center fill\">\n                <div class=\"plan-status-box\" ng-class=\"{\'in-trial\':  vm.currentStatus == \'in_trial\', \'active\': vm.currentStatus == \'active\', \'cancelled\': vm.currentStatus == \'cancelled\'}\">\n\n                    <p ng-if=\"vm.currentStatus == \'in_trial\'\">\n                        Your Subscription is in trial.<br>\n                        <span>Trial ends in {{vm.remainingTrial}} days</span>\n                    </p>\n                    <p ng-if=\"vm.currentStatus == \'active\' \">\n                        <md-icon md-font-icon=\"zmdi zmdi-check\" style=\"font-size: 24px; color: green;\"></md-icon> Your Subscription is active!<br>\n                        <!-- <span>Since {{vm.activeStart | amDateFormat: \"MMM DD, YYYY\"}}</span> -->\n                        <p class=\"md-subhead center\" ng-if=\"vm.currentStatus == \'active\'\" style=\"font-size: 14px;\">You can switch to a different plan at any time below.</p>\n                    </p>\n\n\n                    <div ng-if=\"vm.currentStatus == \'cancelled\' || vm.currentStatus == \'paused\'\">\n                        <p class=\"md-subhead\">\n                            Your premium subscription<br> has been <span ng-if=\"vm.currentStatus == \'paused\'\">paused</span>\n                            <span ng-if=\"vm.currentStatus == \'cancelled\'\">cancelled</span>\n                            <!-- <br>\n                            <span ng-if=\"vm.currentStatus == \'cancelled\'\">Since {{vm.user.plan.content__subscription__cancelled_at | amDateFormat: \"MMM DD, YYYY\"}}</span> -->\n                        </p>\n                    </div>\n                        <!-- if they are on an archived plan, they can\'t simply reactivate so too different paths here-->\n                    <div ng-if=\"vm.currentStatus == \'cancelled\'\">\n                        <div ng-if=\"vm.currentPlan.status != \'archived\'\" >\n                            <md-button ng-click=\"vm.reactivatePlan(vm.currentPlan.planID)\" style=\"width: 80%\" class=\"md-raised md-primary\" palette-background=\"green:600\">Reactivate Subscription</md-button>\n                            <!-- <md-button href=\"{{vm.chargebeeSettings.customerPortalURL}}\" target=\"_blank\" ng-if=\"vm.currentPlan.status == \'archived\'\" style=\"width: 80%\" class=\"md-raised\" palette-background=\"green:600\">Visit the billing portal to select a new plan.</md-button>\n                            <p class=\"md-subhead center\" ng-if=\"vm.currentPlan.status == \'archived\'\" style=\"color: #000; font-size: 11px;\">If this is your first time accessing the billing portal, you may need to create a login first. Please use the same email you use to login to Adminja so we can find your account.</p>\n                            <p class=\"md-subhead center\" ng-if=\"vm.currentPlan.status == \'archived\'\" style=\"color: #000; font-size: 11px;\">Please <a href=\"mailto:help@getadminja.com\">Contact us</a> if you need help.</p> -->\n                            <!-- if they are cancelled, we should give them the option of downgrading -->\n                            <!-- <h3 class=\"text-center\">or</h3> -->\n                        </div>\n                        <div ng-if=\"vm.currentPlan.status == \'archived\'\" >\n                            <p class=\"md-subhead center\">Your original plan is no longer available. Please choose a new plan from the options below. </p>\n                            <!-- <md-button ng-click=\"vm.reactivatePlan(vm.currentPlan.planID)\" style=\"width: 80%\" class=\"md-raised md-primary\" palette-background=\"green:600\">Reactivate Subscription</md-button> -->\n\n                        </div>\n                        <!-- <md-button style=\"width: 80%\" ng-click=\"vm.confirmChange(\'starter-2018c\', vm.currentPlan.planID, vm.currentPlan.status)\" class=\"md-raised md-primary\">Downgrade to our Limited Free Plan</md-button> -->\n                    </div>\n                    <div ng-if=\"vm.currentStatus == \'paused\'\">\n                        <p>To resume your subscription, please let us know at <a href=\"mailto:help@getadminja.com\">help@getadminja.com</a>.\n                        <!-- if they are on an archived plan, they can\'t simply reactivate so too different paths here-->\n                    </div>\n                </div>\n\n\n                <!-- if in trial and no credit card -->\n                <div ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'no_card\' && vm.paidPlan\">\n                    <p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"font-size: 24px; color: orange;\"></md-icon> <strong>Avoid losing Workspace data!</strong> Please provide payment information <br>before your Free trial ends!</p>\n                    <p class=\"center\"><md-button ng-href=\"{{vm.functionsURL}}/checkout?key={{vm.functionsKey}}&user={{vm.userID}}&plan={{vm.currentPlan.planID}}&method=checkout\" ng-click=\"vm.checkoutPlan(plan.planID)\" palette-background=\"green:600\" class=\"md-raised\">Complete Signup</md-button></p>\n                </div>\n                <!-- if starter in trial -->\n                <div ng-if=\"vm.currentStatus == \'in_trial\' && !vm.paidPlan\">\n                    <p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"font-size: 24px; color: green;\"></md-icon>Your plan will activate at the end of your trial as a <strong>limited</strong> Free Starter plan.</p>\n                    <p class=\"center\">You can switch to a full featured plan at any time below.</p>\n                    <!-- <p class=\"center\"><md-button ng-href=\"{{vm.functionsURL}}/checkout?key={{vm.functionsKey}}&user={{vm.userID}}&plan={{vm.currentPlan.planID}}&method=checkout\" ng-click=\"vm.checkoutPlan(plan.planID)\" class=\"md-raised md-accent\">Complete Signup</md-button></p> -->\n                </div>\n                <!-- if in trial credit card -->\n                <div ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'valid\'\">\n                    <p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-check\" style=\"font-size: 24px; color: green;\"></md-icon>\n                    Your signup is complete.</p>\n                    <p class=\"md-subhead center\">Your Subscription will officially activate <br>at the end of your free trial.</p>\n\n                </div>\n                <!-- {{vm.user.plan.content__subscription__id}} -->\n            </div>\n            <p class=\"md-subhead center\" style=\"font-size: 12px;\" ng-if=\"vm.currentPlan.status == \'archived\' && vm.currentStatus != \'cancelled\'\">\n                Your version of this plan is no longer available for new accounts.\n            </p>\n            <div ng-if=\"vm.showAddonForm\">\n                <form name=\"addon-form\">\n                    <div flex=\"100\" layout=\"row\" layout-align=\"center center\" class=\"useradjust\">\n                        <h3>Adjust Team Members: </h3>\n                        <md-button class=\"md-icon-button\" ng-click=\"vm.adjustUsers(-1)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-minus-circle-outline\"></md-icon>\n                            <md-tooltip md-delay=\"500\">Decrease</md-tooltip>\n                        </md-button>\n                        <h3 class=\"usercount\" style=\"font-size: 1.25em;\">{{vm.numUsers}}</h3>\n                        <md-button class=\"md-icon-button\" ng-click=\"vm.adjustUsers(1)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n                            <md-tooltip md-delay=\"500\">Increase</md-tooltip>\n                        </md-button>\n                        <h3>\n                            &nbsp;=&nbsp;&nbsp;&nbsp;${{vm.total(vm.currentPlan.monthly, vm.addonCosts(vm.numUsers - vm.currentPlan.team))}}/mo\n                        </h3>\n\n                    </div>\n                   <!--  <md-input-container>\n                        <label>Adjust additional team members:</label>\n                        <input ng-model=\"vm.numUsers\" type=\"number\" step=\"1\" style=\"width: 50px;\">\n                    </md-input-container>\n                    <p class=\"md-subhead\" style=\"font-size: 12px;\">@ $10/mo each</p> -->\n                    <div layout=\"row\" layout-align=\"center center\">\n                        <md-button ng-click=\"vm.toggleAddonForm()\">cancel</md-button>\n                        <md-button class=\"md-accent md-raised\" ng-click=\"vm.changeAddOns(vm.numUsers-vm.currentPlan.team)\">Confirm adjustment</md-button>\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div><!-- top row -->\n\n    <!-- <md-divider style=\"margin-top: 3em;\"></md-divider> -->\n    <!-- display if they are active, or on a free trial only no need to encourage paid trials to downgrade prior to trial ending -->\n    <div class=\"md-padding\" ng-if=\"vm.currentStatus != \'cancelled\' || vm.currentStatus == \'cancelled\' && vm.currentPlan.status == \'archived\'\" >\n        <div layout=\"column\" style=\"margin-bottom: 2em;\">\n            <!-- <h3 ng-if=\"vm.currentStatus != \'in_trial\'\" class=\"center\">Change your plan</h3> -->\n            <!-- <h3 ng-if=\"vm.currentStatus == \'in_trial\'\" class=\"center\">Would a different plan fit better?</h3> -->\n\n            <p class=\"md-title center\" ng-if=\"vm.currentStatus != \'in_trial\' && vm.currentStatus != \'cancelled\'\">You can upgrade/downgrade at any time.</p>\n            <p class=\"md-title center\" ng-if=\"vm.currentStatus == \'cancelled\'\">Choose a subscription plan:</p>\n            <p class=\"md-title center\" ng-if=\"vm.currentStatus == \'in_trial\' && vm.cardStatus == \'no_card\'\">Complete your signup using a different plan:</p>\n        </div>\n        <div layout=\"row\" layout-align=\"center start\" layout-wrap >\n            <md-card flex-xs=\"100\" flex-sm=\"45\" flex-md=\"20\" flex-lg=\"20\" flex-xl=\"20\" class=\"adminja-plan md-padding md-whiteframe-3dp\" ng-if=\"plan.status == \'active\'\" ng-repeat=\"plan in vm.plans | orderBy: \'-monthly\' track by $index\" >\n                <h3 class=\"center\">{{plan.planName}}</h3>\n                <md-divider></md-divider>\n                <p class=\'md-subhead plan-detail\'><strong>{{vm.getWorkspaceLimit(plan.workspaces)}}</strong> Workspaces<br>\n                    <!-- <span ng-if=\"plan.recurring == 0\"><strong>No</strong> Recurring Task Limit<br></span>\n                    <span ng-if=\"plan.recurring != 0\"><strong>{{plan.recurring}}</strong> Recurring Tasks/Workspace<br></span> -->\n                    <span ng-if=\"plan.team == 1\">1 User<br></span>\n                    <span ng-if=\"plan.team >1\">Team manager<br></span>\n                    <span ng-if=\"plan.team >1\" style=\"font-size: .85em;\">$10/user (Minimum, 5)<br></span>\n\n                    <span ng-if=\"plan.team == 1\">&nbsp;<br></span>\n\n                    <!-- <span ng-if=\"plan.billing || plan.planID==\'lite-2018a\'\">Multi-Timer<br></span>\n                    <span ng-if=\"plan.billing\">Client Billing<br></span> -->\n                    <!-- <span ng-if=\"plan.billing\">All Premium Features</span> -->\n\n                    <!-- <span ng-if=\"!plan.billing && plan.planID != \'lite-2018a\'\"><span style=\"text-decoration: line-through;\">Multi-Timer</span><br></span>\n                    <span ng-if=\"!plan.billing\"><span style=\"text-decoration: line-through;\">Client Billing</span><br></span>\n                    <span ng-if=\"!plan.billing\"><span style=\"text-decoration: line-through;\">Premium Features</span></span> -->\n                </p>\n                <md-divider></md-divider>\n                <h3 class=\"center\">${{plan.monthly}}/mo</h3>\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.currentPlan.planID != plan.planID\">\n                    <!-- if active account with payment info, or they are changing to a starter account that doesn\'t need it\n                        - no need for checkout. just confirm and change-->\n                    <md-button  ng-if=\"vm.currentStatus != \'cancelled\'\" style=\"width: 80%\"\n                        ng-click=\"vm.confirmChange(plan.planID, vm.currentPlan.planID, vm.currentStatus)\"\n                        class=\"md-raised md-accent\">Switch to this Plan</md-button>\n                    <md-button  ng-if=\"vm.currentStatus == \'cancelled\'\" style=\"width: 80%\"\n                        ng-click=\"vm.changePlanWithCheckout(plan.planID)\"\n                        class=\"md-raised md-accent\">Activate this Plan</md-button>\n                        <!-- if on paid trial and not switching to starter plan - send to checkout prior to change -->\n                </div>\n                <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.currentPlan.planID == plan.planID\">\n                    <md-button ng-if=\"vm.currentStatus != \'cancelled\'\" style=\"width: 80%\" ng-disabled=\"true\" class=\"md-raised md-primary\">You are on this Plan</md-button>\n                    <md-button ng-click=\"vm.reactivatePlan(plan.planID)\" ng-if=\"vm.currentStatus == \'cancelled\'\" style=\"width: 80%\" class=\"md-raised md-accent\">Reactivate this Plan</md-button>\n                </div>\n\n            </md-card>\n\n        </div>\n        <div ng-if=\"vm.currentStatus == \'active\'\">\n            <p class=\"md-subhead center\" style=\"font-size: 11px;\">Note: If you change plans, you will be credited the unused portion from your current plan and a prorated charge for the new plan will be applied.</p>\n        </div>\n    </div>\n    <p ng-if=\"vm.currentStatus != \'cancelled\'\" class=\"text-center\">\n        <md-button class=\"md-raised md-primary\" ng-href=\"https://adminja.chargebeeportal.com/portal/v2/login?forward=portal_main\" target=\"_new\">View Invoices or Update Your Payment Method</md-button>\n      <!--<a href=\"{{vm.chargebeeSettings.customerPortalURL}}\" target=\"_blank\" class=\"md-button md-warn\">Billing Portal/Manage Payment Info</a>--><md-button ui-sref=\"authentication.cancel\"  class=\"md-warn\">Cancel Subscription</md-button>\n    </p>\n</div>\n");
$templateCache.put("app/app-directives/task-board/task-board.tmpl.html","<div class=\"task-board-wrapper\" style=\"background-color: {{vm.boardData.settings.color}};\">\n\n	<!-- Empty State Message -->\n	<!-- {{vm.listCount}} {{vm.userRole}} {{vm.setupComplete}} -->\n	<div ng-if=\"vm.listCount < 1 && vm.setupComplete && vm.userRole == \'client\'\" layout=\"row\" layout-align=\"center center\">\n		<md-card flex=\"100\" flex-md=\"70\" flex-lg=\"50\" flex-xl=\"40\" class=\"padding-top-40 padding-bottom-40 padding-left-20 padding-right-20 margin-top-60\" layout=\"row\" layout-align=\"center center\" style=\"border-radius: 8px;\">\n				<div flex=\"30\">\n					<p class=\"center\"><md-icon md-font-icon=\"zmdi zmdi-info\" style=\"font-size: 72px; color: #999;\"></md-icon></p>\n				</div>\n				<div flex=\"70\" class=\"padding-right-20\">\n					<h2 class=\"\">Your Virtual Assistant hasn\'t enabled any task lists for you yet.</h2>\n					<p class=\"md-subhead\"><!-- Click the plus button to the right of this board to get started. --></p>\n				</div>\n		</md-card>\n	</div>\n	<!-- task board -->\n	<div class=\"adminja-board-container small-scrollbar\" inhibit-back >\n		<!-- drag-container is used to attached drag animated objects to until they are dropped -->\n		<div class=\"drag-container\">\n		</div>\n		<!-- Muuri Board -->\n		<div class=\"board\" flex=\"nogrow\" style=\"background-color: {{vm.boardData.settings.color}};\">\n		</div><!-- board -->\n	</div><!-- /adminja-board-container-->\n\n	<!-- board/list settings panel -->\n	<md-sidenav class=\"md-sidenav-right md-whiteframe-4dp board-side-panel\"  md-component-id=\"board-panel\" layout=\"column\" layout-align=\"layout-fill center\">\n		<md-toolbar class=\"md-theme-light\" style=\"background-color: {{vm.selectedList.color}}\" layout=\"row\" layout-align=\"start center\">\n			<md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"vm.toggleSidePanel()\" class=\"md-warn\">\n				<md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n			</md-button>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'board\'\" class=\"md-toolbar-tools\"></h1>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'list\' && vm.selectedList.uid\" class=\"md-toolbar-tools\">{{vm.selectedList.label}}</h1>\n			<h1 flex=\"auto\" ng-if=\"vm.sidePanelMode == \'list\' && !vm.selectedList.uid\" class=\"md-toolbar-tools\"><span ng-if=\"!vm.selectedList.label\">New List</span> <span ng-if=\"vm.selectedList.label\">{{vm.selectedList.label}}</span></h1>\n		</md-toolbar>\n		<md-content layout=\"column\" flex=\"grow\" layout-align=\"start center\" style=\"width:100%;\">\n			<!-- List controls -->\n			<div flex=\"grow\" class=\"board-panel-settings list-settings\" ng-if=\"vm.sidePanelMode == \'list\'\" layout=\"column\" layout-align=\"start layout-fill\">\n				<form name=\"vm.forms.listForm\" style=\"\">\n					<md-input-container style=\"margin-left: 1em; margin-right: 1em; margin-top: 2em;\">\n						<label>List Name</label>\n						<input required md-autofocus=\"!vm.selectedList.uid\" ng-disabled=\"vm.userRole == \'client\'\" md-maxlength=\"28\" ng-model=\"vm.selectedList.label\">\n					</md-input-container>\n					<div ng-if=\"vm.selectedList.uid == vm.boardData.defaultList\" style=\"margin: 1em; padding: 1em; border-radius: 8px; border: 1px solid #999; background-color: #eeeeee;\">\n						<p class=\"md-subhead center\" style=\"font-size: 12px;\">This is the default incoming tasks list for this workspace. It cannot be deleted.</p>\n					</div>\n					<md-list>\n						<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.showColorPicker && vm.selectedList.uid && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = true\">\n								<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n									<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-right\"  ></md-icon>\n									<p style=\"font-size: 12px;\">List Color</p>\n								</div>\n								<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n									<div class=\"color-swatch\" style=\"background-color: {{vm.selectedList.color}};\"></div>\n								</div>\n						</md-list-item>\n						<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showColorPicker && vm.selectedList.uid && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = false\">\n								<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n									<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n									<p style=\"font-size: 12px;\">List Color</p>\n								</div>\n								<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n									<div class=\"color-swatch\" style=\"background-color: {{vm.selectedList.color}};\"></div>\n								</div>\n						</md-list-item>\n\n						<div class=\"list-color-chooser\" ng-if=\"!vm.selectedList.uid || vm.showColorPicker\" style=\"margin-top: 1em;\">\n							<lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.selectedList.color\" ng-model=\"vm.selectedList.color\" ng-click=\"vm.selectListColor();\"></lk-color-chooser>\n						</div>\n						<!-- <md-list-item>\n							<md-checkbox ng-model=\"vm.selectedList.clientEnabled\" aria-label=\"\" style=\"margin-left:  1em; margin-right: 5px;\"></md-checkbox> <span style=\"font-size: 12px;\">Visible to Client</span>\n						</md-list-item> -->\n						<div ng-if=\"vm.selectedList.uid && vm.userRole != \'client\'\">\n							<md-subheader class=\"margin-top-20\"><span translate>Task Actions</span></md-subheader>\n							<md-list-item>\n								<md-button class=\"wide\" ng-click=\"vm.listMenuNewTask(vm.thisClient.uid, vm.selectedList.uid)\">\n									<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon> New Task\n								</md-button>\n							</md-list-item>\n							<md-list-item>\n								<md-menu class=\"wide\" style=\"padding-left:0;\">\n									<md-button class=\"wide\" ng-click=\"$mdMenu.open($event);\">\n										<md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon>\n										New Task from Template\n										<md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n									</md-button>\n									<md-menu-content class=\"md-dense\" style=\"max-width: 400px;\">\n										<md-menu-item ng-repeat=\"template in vm.thisClient.taskTemplates | toArray: false | orderBy: order track by $index+template.uid\">\n											<md-button ng-click=\"vm.newTaskFromTemplate(template, \'new\')\" md-no-ink=\"true\">\n												<span md-truncate>{{template.info.description}}</span>\n											</md-button>\n										</md-menu-item>\n									</md-menu-content>\n								</md-menu>\n							</md-list-item>\n							<md-list-item ng-if=\"vm.selectedList.type != \'new\' && vm.selectedList.type != \'done\'\">\n								<md-button class=\"wide\" data-gtm-batch-tasks ng-click=\"vm.duplicateList(vm.selectedList)\">\n									<md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon> Duplicate List\n								</md-button>\n							</md-list-item>\n							<md-list-item>\n								<md-button class=\"wide\" data-gtm-batch-tasks ng-click=\"vm.batchTasks(vm.thisClient.uid, vm.selectedList.uid)\">\n									<md-icon md-font-icon=\"fa fa-tasks\"></md-icon> Batch Enter Tasks\n								</md-button>\n							</md-list-item>\n							<md-list-item>\n								<md-button class=\"wide\" data-gtm-mark-list-complete ng-click=\"vm.markAllComplete(vm.selectedList.uid)\">\n									<md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark All Tasks Complete\n								</md-button>\n							</md-list-item>\n							<md-list-item ng-if=\"admin == \'admin\'\">\n								<md-button class=\"wide\" data-gtm-delete-all-tasks-in-list ng-click=\"vm.deleteAll(\'Later\')\">\n									<md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete All Tasks\n								</md-button>\n							</md-list-item>\n							<md-list-item ng-if=\"vm.userType == \'admin\'\">\n							    <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}taskBoards/{{vm.boardID}}/lists/{{vm.selectedList.uid}}\">\n							        <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n							    </md-button>\n							</md-list-item>\n						</div>\n					</md-list>\n				</form>\n			</div>\n			<!-- Board controls -->\n			<div flex=\"grow\" class=\"board-panel-settings board-settings\" ng-if=\"vm.sidePanelMode == \'board\'\">\n\n\n				<form name=\"vm.forms.boardForm\" style=\"\">\n				<md-list class=\"board-settings-list\">\n					<md-subheader style=\"margin-bottom: .5em;\">Search, Filter &amp; Sort</md-subheader>\n					<md-list-item style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"layout-fill center\">\n						<div layout=\"row\" layout-align=\"layout-fill center\">\n						  <md-input-container flex=\"80\" class=\"task-board-search\">\n						  	<label>Search</label>\n						      <input style=\"width:  290px;\" hotkey=\"{esc: vm.resetTaskSearch}\" id=\"searchQuery\" type=\"text\" ng-model=\"vm.searchTerm\" ng-change=\"vm.filterItems()\" ng-model-options=\"{debounce: 200}\">\n						  </md-input-container>\n						    <md-button flex=\"nogrow\" style=\"margin-top:  1em; margin-left: 0px;\" class=\"md-icon-button\" ng-click=\"vm.resetTaskSearch()\">\n						    	<md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"  style=\"font-size:  14px; color: #999;\">\n						        <md-tooltip md-delay=\"1000\">\n						            Reset search\n						        </md-tooltip>\n						    </md-icon>\n						</md-button>\n						 </div>\n						<!-- <md-button ng-click=\"vm.filterItems()\">Search</md-button> -->\n					</md-list-item>\n\n					<md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Filter Priorities:</label>\n							<md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.priorityFilter\" ng-change=\"vm.filterItems()\">\n								<md-option value=\'none\'><md-icon md-font-icon=\"zmdi zmdi-flag\"></md-icon>All</md-option>\n								<md-option ng-repeat=\"priority in vm.boardData.priorities | toArray: false | orderBy: \'[priority]\' track by $index\" value=\"{{priority.priority}}\">\n									<md-icon md-font-icon=\"zmdi zmdi-flag\" class=\"{{priority.color}}\"></md-icon>\n									Priority {{priority.priority}}\n								</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.teamList\" style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Filter Users:</label>\n							<md-select class=\"task-filter-select md-no-underline\" ng-model=\"vm.userFilter\" ng-change=\"vm.filterItems()\">\n								<md-option value=\'all\'><md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>All Members</md-option>\n								<md-option ng-repeat=\"member in vm.teamList | toArray: false | orderBy: \'[fullName]\' track by $index\" value=\"{{member.uid}}\">\n									<md-icon md-font-icon=\"zmdi zmdi-account\" style=\"color:  {{member.color}}\" ></md-icon>\n									<span style=\"color:  {{member.color}}\">{{member.fullName}}</span>\n								</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item>\n					<md-list-item style=\"padding: 0 10px;\" layout=\"row\">\n						<md-input-container flex=\"100\">\n							<label>Sort by:</label>\n							<md-select class=\"md-no-underline\" ng-model=\"vm.sortBy\" ng-change=\"vm.sortItems(vm.sortBy)\">\n								<md-option value=\"order\">Manual Sort</md-option>\n								<md-option value=\"due\">Due Date</md-option>\n								<md-option value=\"priority\">Priority</md-option>\n								<md-option value=\"assignee\">Team Member</md-option>\n							</md-select>\n						</md-input-container>\n					</md-list-item>\n					<md-subheader ng-if=\"vm.userRole != \'client\'\" style=\"margin-top: 2em;\">Board Settings</md-subheader>\n					<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.showColorPicker && vm.userRole != \'client\'\" ng-click=\"vm.showColorPicker = true\">\n							<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n								<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-right\"  ></md-icon>\n								<p>Background Color</p>\n							</div>\n							<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n								<div class=\"color-swatch\" style=\"background-color: {{vm.boardData.settings.color}};\"></div>\n							</div>\n					</md-list-item>\n					<md-list-item style=\"padding: 0;\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.showColorPicker\" ng-click=\"vm.showColorPicker = false\">\n							<div flex=\"80\" layout=\"row\" layout-align=\"start center\">\n								<md-icon style=\"margin-left:  0; margin-right:  0;\" md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n								<p>Background Color</p>\n							</div>\n							<div flex=\"20\" layout=\"row\" layout-align=\"end center\">\n								<div class=\"color-swatch\" style=\"background-color: {{vm.boardData.settings.color}};\"></div>\n							</div>\n					</md-list-item>\n					<div class=\"list-color-chooser\" ng-if=\"vm.showColorPicker\" style=\"margin-top: 1em;\">\n						<lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.boardData.settings.color\" ng-model=\"vm.boardData.settings.color\" ng-click=\"vm.selectBoardColor();\"></lk-color-chooser>\n					</div>\n					<md-list-item ng-if=\"vm.userRole != \'client\'\" style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n					        <p translate>Show workspace Name</p>\n					        <md-switch ng-change=\"vm.toggleElementVisibility()\"class=\"md-secondary\" ng-model=\"vm.boardData.settings.showWorkspaceName\"></md-switch>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userRole != \'client\'\" style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n					        <p translate>Show extended Task Description</p>\n					        <md-switch ng-change=\"vm.toggleElementVisibility()\"class=\"md-secondary\" ng-model=\"vm.boardData.settings.showRestLines\"></md-switch>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userRole != \'client\'\" style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n					        <p translate>Show Files, Checklist & Comments</p>\n					        <md-switch ng-change=\"vm.toggleElementVisibility()\"class=\"md-secondary\" ng-model=\"vm.boardData.settings.showDetails\"></md-switch>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userRole != \'client\'\" style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n					        <p translate>Show Assignee</p>\n					        <md-switch ng-change=\"vm.toggleElementVisibility()\"class=\"md-secondary\" ng-model=\"vm.boardData.settings.showAssignee\"></md-switch>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userRole != \'client\'\" style=\"padding: 0 10px;\" layout=\"row\" layout-align=\"space-around center\">\n					        <p translate>Show Budget & Time </p>\n					        <md-switch ng-change=\"vm.toggleElementVisibility()\"class=\"md-secondary\" ng-model=\"vm.boardData.settings.showTimeControls\"></md-switch>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userType == \'admin\'\">\n					    <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}taskBoards/{{vm.boardID}}\">\n					        <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n					    </md-button>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userType == \'admin\'\">\n					    <md-button class=\"md-raised md-warn\" ng-click=\"vm.undoUpgrade()\">\n		    					<md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon> Reset Board\n		    				</md-button>\n					</md-list-item>\n					<md-list-item ng-if=\"vm.userType == \'admin\'\">\n					    <md-button class=\"md-raised md-warn\" ng-click=\"vm.undoAllUpgrades()\">\n		    					<md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon> <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon> Reset All Board\n		    				</md-button>\n					</md-list-item>\n				</md-list>\n				</form>\n\n			</div>\n\n		</md-content>\n		<div flex=\"nogrow\" ng-if=\"vm.sidePanelMode == \'list\'\" class=\"board-panel-actions\" layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex layout=\"row\" layout-align=\"start center\">\n\n				<md-button ng-disabled=\"vm.selectedList.items.length > 0 || vm.userRole == \'client\' || vm.selectedList.type == \'new\' || vm.selectedList.type == \'closed\'\" ng-if=\"vm.selectedList.uid\" class=\"md-warn\" ng-click=\"vm.deleteList(vm.selectedList.uid)\">\n					<md-icon md-font-icon=\"fa fa-trash\"></md-icon> Delete List\n				</md-button>\n			</div>\n			<div flex layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"vm.selectedList.uid\" class=\"md-accent md-raised\" ng-click=\"vm.updateList(vm.selectedList)\" ng-disabled=\"vm.forms.listForm.$pristine || vm.forms.listForm.$invalid\">Save Changes</md-button>\n				<md-button ng-if=\"!vm.selectedList.uid\" class=\"md-accent md-raised\" ng-click=\"vm.saveList(vm.selectedList)\" ng-disabled=\"vm.forms.listForm.$pristine || vm.forms.listForm.$invalid\">Save</md-button>\n			</div>\n		</div>\n		<!--<div flex=\"nogrow\" ng-if=\"vm.sidePanelMode == \'board\'\" class=\"board-panel-actions\" layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex layout=\"row\" layout-align=\"start center\">\n			</div>\n			<div flex layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"!vm.boardUpdating\" class=\"md-accent md-raised\" ng-click=\"vm.updateBoard(vm.boardData)\" ng-disabled=\"vm.forms.boardForm.$pristine || vm.forms.boardForm.$invalid\">Save Changes</md-button>\n				<md-button ng-if=\"vm.boardUpdating\" class=\"md-accent md-raised\" ng-disabled=\"true\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon></md-button>\n			</div>\n		</div>-->\n	</md-sidenav>\n\n	<!-- popup task menu -->\n	<task-menu ng-if=\"vm.selectedTask\" selectedtask=\"vm.selectedTask\" x=\"vm.x\" y=\"vm.y\" board=\"vm.boardData\" role=\"vm.userRole\"></task-menu>\n	<!-- task board filter bar -->\n	<div class=\"adminja-board-controls\" layout=\"column\" layout-align=\"start center\">\n			<md-icon ng-if=\"vm.userRole != \'client\'\" class=\"adminja-icon-button\" style=\"padding-left:  2px;\" ng-click=\"vm.newList(vm.boardID)\" md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n			<md-icon class=\"adminja-icon-button\" style=\"padding-left:  6px;\" ng-click=\"vm.toggleSidePanel(\'board\')\" md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n	</div><!-- /task board filter bar -->\n</div><!-- board-wrapper -->\n");
$templateCache.put("app/app-directives/task-board/task-menu.tmpl.html","<div class=\"task-menu md-whiteframe-8dp\" layout=\"column\" layout-align=\"layout-fill layout-fill\" style=\"\" ng-style=\"{\'left\': vm.x, \'top\': vm.y}\">\n	<md-content flex=\"auto\" class=\"small-scrollbar\" style=\"background-color: #fff;\" layout=\"column\" layout-align=\"start start\">\n		<md-list >\n			<div ng-if=\"!vm.selectedTask.archived\">\n				<!-- list item AS menu template\n				<md-list-item class=\"md-list-item-menu\" >\n					<md-menu  md-position-mode=\"target-right target\">\n						<md-button ng-click=\"$mdMenu.open()\">\n							<p ><md-icon class=\"\" md-font-icon=\"zmdi zmdi-play\"></md-icon>Menu Item Label</p>\n							<p class=\"right\">\n								<md-icon class=\"menu-caret\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n							</p>\n						</md-button>\n						<md-menu-content>\n							<md-menu-item>\n								<md-button ng-click=\"ctrl.redial($event)\">\n									<md-icon md-svg-icon=\"call:dialpad\" md-menu-align-target></md-icon>\n									Redial\n								</md-button>\n							</md-menu-item>\n							<md-menu-item>\n								<md-button disabled=\"disabled\" ng-click=\"ctrl.checkVoicemail()\">\n									<md-icon md-svg-icon=\"call:voicemail\"></md-icon>\n									Check voicemail\n								</md-button>\n							</md-menu-item>\n							<md-menu-divider></md-menu-divider>\n							<md-menu-item>\n								<md-button ng-click=\"ctrl.toggleNotifications()\">\n									<md-icon md-svg-icon=\"social:notifications-{{ctrl.notificationsEnabled ? \'off\' : \'on\'}}\"></md-icon>\n									{{ctrl.notificationsEnabled ? \'Disable\' : \'Enable\' }} notifications\n								</md-button>\n							</md-menu-item>\n						</md-menu-content>\n					</md-menu>\n				</md-list-item>\n				-->\n\n				<!-- due date submenu -->\n				<md-list-item class=\"md-list-item-menu\" ng-if=\"item.status != \'closed\'\">\n					<md-menu>\n					    <md-button ng-click=\"$mdMenu.open($event);\">\n					       <p>\n					       	<md-icon md-font-icon=\"zmdi zmdi-calendar-alt\"></md-icon>\n					       	Set Due Date\n					  	</p>\n					  	<p class=\"right\">\n					  		<md-icon  class=\"menu-caret\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n					  	</p>\n					    </md-button>\n\n					    <md-menu-content class=\"md-dense small-scrollbar\" style=\"height: 450px;\">\n					                <md-menu-item>\n					                    <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'0\')\" md-no-ink=\"true\">\n					                        None\n					                    </md-button>\n					                </md-menu-item>\n					                <md-menu-item>\n					                    <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'1d\')\" md-no-ink=\"true\">\n					                        In 1 Day\n					                    </md-button>\n					                </md-menu-item>\n					                <md-menu-item>\n					                    <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'2d\')\" md-no-ink=\"true\">\n					                        In 2 Days\n					                    </md-button>\n					                </md-menu-item>\n					                <md-menu-item>\n					                    <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'3d\')\" md-no-ink=\"true\">\n					                        In 3 Days\n					                    </md-button>\n					                </md-menu-item>\n					                <md-menu-item>\n					                    <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'7d\')\" md-no-ink=\"true\">\n					                        In 1 Week\n					                    </md-button>\n					                </md-menu-item>\n\n					                <md-menu-item>\n					                    <p style=\"text-align: center; margin: 0 0 1em 0; color: #999;\">\n					                        <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon> Pick a Date <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon>\n					                    </p>\n					                </md-menu-item>\n					                <md-menu-item style=\"padding:0!important;\">\n					                    <md-calendar style=\"padding-left: 0!important; padding-right:0!important;\" md-min-date=\"vm.today\" ng-change=\"vm.pickDueDate(vm.due)\" ng-model=\"vm.due\"></md-calendar>\n					                </md-menu-item>\n					    </md-menu-content>\n					</md-menu>\n				</md-list-item>\n\n\n\n				<!-- Set Task Priority -->\n				<md-list-item ng-if=\"vm.selectedTask.status != \'closed\' && !vm.isClientUser\" class=\"md-list-item-menu\" >\n					<md-menu  md-position-mode=\"target target\">\n						<md-button ng-click=\"$mdMenu.open()\">\n							<p ><md-icon class=\"\" md-font-icon=\"zmdi zmdi-flag\"></md-icon>\n								Set Priority\n							</p>\n							<p class=\"right\">\n								<md-icon class=\"menu-caret\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n							</p>\n						</md-button>\n						<md-menu-content width=\"4\">\n							<md-menu-item >\n							          <md-button ng-click=\"vm.setPriority(\'none\', $event)\">\n							          	<md-icon md-font-icon=\"zmdi zmdi-block\"></md-icon>\n							          	None\n							          </md-button>\n							</md-menu-item>\n						          <md-menu-item  ng-repeat=\"priority in vm.boardData.priorities | toArray: false | orderBy: \'[priority]\' track by $index+uid\">\n						                    <md-button ng-click=\"vm.setPriority(priority, $event)\">\n						                    	<md-icon md-font-icon=\"zmdi zmdi-flag\" class=\"{{priority.color}}\"></md-icon>\n						                    	Priority {{priority.priority}}\n						                    </md-button>\n						          </md-menu-item>\n						</md-menu-content>\n					</md-menu>\n				</md-list-item>\n\n				<!-- Snooze Task -->\n				<!-- <md-list-item ng-if=\"!vm.selectedTask.snooze && vm.selectedTask.status == \'open\' && !vm.isClientUser\" class=\"md-list-item-menu\" >\n					<md-menu  md-position-mode=\"target-right target\">\n						<md-button ng-click=\"$mdMenu.open()\">\n							<p ><md-icon class=\"\" md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon>\n							Snooze\n							</p>\n							<p class=\"right\">\n								<md-icon class=\"menu-caret\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n							</p>\n						</md-button>\n						<md-menu-content>\n						          <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 5, $event)\">\n						                              5 min\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 15, $event)\">\n						                              15 min\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 30, $event)\">\n						                              30 min\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 60, $event)\">\n						                              60 min\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 120, $event)\">\n						                              2 hr\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 480, $event)\">\n						                              8 hr\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 720, $event)\">\n						                              12 hr\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 1440, $event)\">\n						                              1 day\n						                    </md-button>\n						          </md-menu-item>\n						          <md-menu-item>\n						                    <md-button flex=\"nogrow\" ng-click=\"snoozeTask(item, 2880, $event)\">\n						                              2 days\n						                    </md-button>\n						          </md-menu-item>\n						</md-menu-content>\n					</md-menu>\n				</md-list-item>\n -->\n				<!-- <md-list-item ng-if=\"vm.selectedTask.snooze && !vm.isClientUser\" ng-click=\"vm.toggleCompleted(vm.selectedTask, $event)\">\n					<md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n					<p>Mark Complete</p>\n				</md-list-item> -->\n\n\n				<!-- <md-list-item ng-click=\"vm.unSnoozeTask(vm.selectedTask, $event)\">\n					<md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon>\n					<p>un-Snooze</p>\n				</md-list-item>\n -->\n			</div>\n			<md-divider></md-divider>\n			<!-- absolutely not avail to clientUser -->\n			<div ng-if=\"vm.role != \'client\'\">\n				<md-list-item ng-if=\"vm.selectedTask.parentTemplate\"ng-click=\"vm.editTaskTemplate(vm.selectedTask, $event)\" >\n					<md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n					<p>Edit original template</p>\n				</md-list-item>\n				<md-list-item  ng-click=\"vm.cloneTask(vm.selectedTask, $event)\">\n					<md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon>\n					<p>Clone</p>\n				</md-list-item>\n				<md-list-item  ng-if=\"!item.parentTemplate  && vm.selectedTask.status == \'open\'\" ng-click=\"vm.makeRecurring(vm.selectedTask, $event)\">\n					<md-icon md-font-icon=\"zmdi zmdi-time-interval\"></md-icon>\n					<p>Save as a Recurring Task</p>\n				</md-list-item>\n				<md-list-item  ng-click=\"vm.makeTemplate(vm.selectedTask, $event)\">\n					<md-icon md-font-icon=\"zmdi zmdi-collection-plus\"></md-icon>\n					<p>Save as a Template</p>\n				</md-list-item>\n				<md-list-item  ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}tasks/{{vm.selectedTask.uid}}\" target=\"_blank\">\n					<md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n					<p>X-ray</p>\n				</md-list-item>\n				<md-list-item  ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}clients/{{vm.selectedTask.client}}/tasks/{{vm.selectedTask.uid}}\" target=\"_blank\">\n					<md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n					<p>X-ray Client Data</p>\n				</md-list-item>\n				<md-list-item  ng-if=\"vm.userType == \'admin\'\" href=\"{{vm.fbConfig.dataURL}}taskBoards/{{vm.selectedTask.board}}/lists/{{vm.selectedTask.list}}/items/{{vm.selectedTask.uid}}\" target=\"_blank\">\n					<md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n					<p>X-ray BoardData</p>\n				</md-list-item>\n			</div>\n\n			<!-- ARCHIVED TASK MENU -->\n			<div ng-if=\"item.archived && vm.role != \'client\'\">\n				  <md-menu ng-if=\"item.archived\" md-position-mode=\"target-right target\" style=\"position: relative; top: -22px; \">\n				      <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n				      <md-menu-content class=\"md-dense\" style=\"max-height: 500px; overflow-x: hidden;\">\n				          <md-menu-item >\n				              <md-button aria-label=\"Restore\" ng-click=\"restoreArchivedTask(item, $event)\" data-gtm-task-restored>\n				                  <md-icon md-font-icon=\"zmdi zmdi-time-restore-setting\"></md-icon> Restore\n				              </md-button>\n				          </md-menu-item>\n				          <md-menu-item>\n				              <md-button aria-label=\"Clone\" ng-click=\"copyTask(item, $event)\" data-gtm-task-cloned>\n				                  <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n				              </md-button>\n				          </md-menu-item>\n\n				          <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n				              <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}tasks/{{item.refID}}\" >\n				                  <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n				              </md-button>\n				          </md-menu-item>\n				  </md-menu-content>\n				</md-menu>\n			</div>\n\n		</md-list>\n	</md-content>\n	<div class=\"task-menu-controls\" ng-if=\"vm.role != \'client\' || (vm.user.uid == vm.selectedTask.creator || vm.user.uid == vm.selectedTask.owner)\"  layout=\"row\" layout-align=\"start center\" flex=\"nogrow\">\n		<md-list>\n			<md-list-item style=\"padding-left:  0;\">\n				<md-button style=\"margin-left:  0;\" ng-disabled=\"!vm.canDelete(vm.selectedTask) || vm.selectedTask.logged > 0\" class=\"md-warn\" ng-click=\"vm.deleteTask(vm.selectedTask, $event)\">\n					<md-icon class=\"margin-right-0\" md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n					Delete\n				</md-button>\n			</md-list-item>\n		</md-list>\n	</div>\n</div>\n");
$templateCache.put("app/app-directives/task-notes/task-notes.tmpl.html","<md-content palette-background=\"white:50\" id=\"noteList\" style=\"max-height: 400px;\">\n    <md-list class=\"md-dense\">\n        <!-- Updates view -->\n        <note-entry ng-repeat=\"note in vm.notes | orderBy: \'date\' track by note.uid\" note=\"{{note}}\" client=\"{{vm.thisClient.uid}}\" task=\"{{vm.task}}\"></note-entry>\n\n    </md-list>\n</md-content>\n<!-- Add Note Form -->\n<div style=\"margin-top: 1em;\">\n    <form name=\"vm.taskNoteForm\" novalidate>\n        <div layout=\"row\" style=\"padding-left: 1em;\">\n            <md-input-container flex=\"auto\" style=\"padding: 1em;\">\n                <textarea id=\"newNoteBody\" adminja-enter=\"vm.addTaskNote(vm.newNote)\" md-autofocus md-maxlength=\"2000\"  name=\"newNotebody\" ng-model=\"vm.newNote.body\" placeholder=\"Comment\"></textarea>\n            </md-input-container>\n        </div>\n        <md-dialog-actions layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\" layout-align=\"start start\">\n            <div flex flex-gt-sm=\"30\" class=\"button-label-container\" ng-if=\"!vm.isSpace()\">\n           <!--      <md-button>\n                <md-checkbox ng-disabled=\"!vm.thisClient.profile.email\" ng-model=\"vm.newNote.notifyClient\" aria-label=\"Notify Client\">\n                            CC Client\n\n                  </md-checkbox>\n                    <md-tooltip md-direction=\"top\" md-delay=\"500\" ng-if=\"vm.thisClient.profile.email\">\n                      Send comment with a brief task status report to this client\n                    </md-tooltip>\n                    <md-tooltip md-direction=\"top\" md-delay=\"500\" ng-if=\"!vm.thisClient.profile.email\">\n                      No email address found for Client.\n                    </md-tooltip>\n                </md-button> -->\n\n            </div>\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button class=\"\" ng-click=\"vm.clearNote()\" data-gtm-cancel-task-comment>\n                        Cancel\n                    </md-button>\n\n                </div>\n              <!--   <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button class=\"\" ng-click=\"clearNote()\">\n                        Clear\n                    </md-button>\n                </div> -->\n                <div flex=\"nogrow\" class=\"button-label-container\">\n                    <md-button data-gtm-submit-task-comment ng-disabled=\"!vm.newNote.body\"  class=\"md-accent md-raised\" ng-click=\"vm.addTaskNote(vm.newNote)\">\n                        Send\n                    </md-button>\n                    <!-- <label class=\"shortcut\">ctrl + enter</label> -->\n                </div>\n            </div>\n        </md-dialog-actions>\n       <!--  <div layout=\"row\" class=\"fade\" ng-if=\"vm.newNote.body\" style=\"position:relative; top: -2em;\">\n            <div flex=\"nogrow\">\n                <md-input-container>\n                    <md-checkbox ng-disabled=\'true\' ng-model=\"checkboxes.default\" aria-label=\"Default Checkbox\">\n                        CC Client\n                    </md-checkbox>\n                </md-input-container>\n            </div>\n            <div flex=\"nogrow\">\n                <md-input-container>\n                    <md-checkbox ng-disabled=\'true\' ng-model=\"checkboxes.default\" aria-label=\"Default Checkbox\">\n                        Include Full History\n                    </md-checkbox>\n                </md-input-container>\n            </div>\n\n        </div> -->\n    </form>\n</div>\n");
$templateCache.put("app/app-directives/task-item/app-item-task.tmpl.html","<md-card ng-click=\"editTask(item,0, $event)\" class=\"app-item-task status-{{item.status}} focus-{{item.focus}} clicked-{{item.clicked}}\" >\n    <div class=\"task-badge task-handle\"  style=\"background-color: {{::getColor(item.client)}};\">\n\n    </div>\n\n    <md-card-title class=\"task-handle\" style=\"overflow-x:hidden;\">\n        <div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\">\n            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\" ng-if=\"item.status == \'closed\' || item.showComplete\" ng-click=\"toggleCompleted(item, $event)\" style=\"\">\n                <md-tooltip md-delay=\"1000\">Re-Open</md-tooltip>\n            </md-icon>\n            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\" ng-if=\"item.status != \'closed\' && !item.showComplete\" ng-click=\"toggleCompleted(item, $event)\" style=\"\">\n                <md-tooltip md-delay=\"1000\">Mark Complete</md-tooltip>\n            </md-icon>\n            <md-icon ng-if=\"item.focus === \'today\' && canFocus(item) && !vm.isClientUser\"  ng-click=\"toggleToday(item, $event)\" class=\"app-item-focused focused-on\" md-font-icon=\"zmdi zmdi-sun\" style=\"margin:0; font-size: 18px;\" >\n                <md-tooltip md-delay=\"1000\">Remove Today flag</md-tooltip>\n            </md-icon>\n            <md-icon ng-if=\"item.focus != \'today\' && canFocus(item) && !vm.isClientUser\" ng-click=\"toggleToday(item, $event)\"  class=\"app-item-focused focused-off\" md-font-icon=\"zmdi zmdi-sun\" style=\"margin:0; font-size: 18px; color: #aaa;\"  >\n                <md-tooltip md-delay=\"1000\">Flag for Today</md-tooltip>\n            </md-icon>\n        </div>\n        <md-card-title-text flex md-no-ink=\"true\" class=\"app-item-description\" style=\"padding-right: 1em;\" md-ink-ripple=\"#bbb\" layout=\"row\" layout-align=\"start start\">\n            <!-- title for all states -->\n            <div flex=\"auto\" layout=\"column\">\n                <span class=\"task-title\"> {{firstLine(item.description)}}</span>\n                <span ng-if=\"item.snooze\" style=\"color: orange;\">Zzzzzzzz</span>\n                <span class=\"md-caption task-client\" md-truncate >{{clientName(item.client)}}</span>\n            </div>\n            <!-- due date and timer controls for collapsed state -->\n            <div layout=\"column\" class=\"show-for-collapsed\">\n              <div ng-if=\"item.duedate\" flex=\"auto\" layout=\"row\" layout-align=\"end center\">\n                  <label  class=\"show-for-collapsed\" ng-class=\"{ \'close\': isNear(item.duedate, item.status) , \'over\': isDue(item.duedate, item.status) }\" style=\"font-size: 10px; white-space: nowrap; padding-left: 1em;\">\n                      {{item.duedate| amDateFormat:vm.settings.shortOrdDateFormat}}\n                  </label>\n              </div>\n            </div>\n            <!-- /due date and timer controls for collapsed state -->\n        </md-card-title-text>\n        <div class=\"card-controls\" flex=\"nogrow\" style=\"padding-right:0;\">\n          <!-- archived task card menu -->\n\n          <md-menu ng-if=\"item.archived && !vm.isClientUser\" md-position-mode=\"target-right target\" style=\"position: relative; top: -22px; \">\n              <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n              <md-menu-content class=\"md-dense\" style=\"max-height: 500px; overflow-x: hidden;\">\n                  <md-menu-item >\n                      <md-button aria-label=\"Restore\" ng-click=\"restoreArchivedTask(item, $event)\" data-gtm-task-restored>\n                          <md-icon md-font-icon=\"zmdi zmdi-time-restore-setting\"></md-icon> Restore\n                      </md-button>\n                  </md-menu-item>\n                  <md-menu-item>\n                      <md-button aria-label=\"Clone\" ng-click=\"copyTask(item, $event)\" data-gtm-task-cloned>\n                          <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n                      </md-button>\n                  </md-menu-item>\n\n                  <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                      <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}tasks/{{item.refID}}\">\n                          <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                      </md-button>\n                  </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n           <!--- default task card menu -->\n\n            <md-menu ng-if=\"!item.archived\" md-position-mode=\"target-right target\" style=\"position: relative; top: -22px; \">\n                <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n                <md-menu-content class=\"md-dense\" style=\"max-height: 500px; overflow-x: hidden;\">\n                    <md-menu-item ng-if=\"item.status != \'closed\'\">\n                        <md-button aria-label=\"Mark Complete\" ng-click=\"toggleCompleted(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Mark Complete\n                        </md-button>\n                    </md-menu-item>\n                        <md-menu class=\"reminders-menu\" ng-if=\"item.status != \'closed\'\">\n                            <md-button style=\"display:block; width:100%; margin-left:0; text-align:left; padding-left: 16px; margin-top:0; margin-bottom:0; height:36px;\" ng-click=\"$mdMenu.open($event);\" layout=\"row\" layout-align=\"layout-fill center\">\n                               <md-icon style=\"margin-right: 18px;\" flex=\"nogrow\" md-font-icon=\"zmdi zmdi-calendar-alt\"></md-icon>\n                               <span flex=\"auto\" style=\"text-align:left;display:inline-block; width:110px;\">Set Due Date</span>\n                               <span flex=\"nogrow\" style=\"text-align:right;\">\n                                <md-icon  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                               </span>\n                            </md-button>\n\n                            <md-menu-content class=\"md-dense small-scrollbar\" style=\"overflow-x: hidden; min-height: 450px; width: 340px;\">\n                                        <md-menu-item>\n                                            <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'0\')\" md-no-ink=\"true\">\n                                                None\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item>\n                                            <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'1d\')\" md-no-ink=\"true\">\n                                                In 1 Day\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item>\n                                            <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'2d\')\" md-no-ink=\"true\">\n                                                In 2 Days\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item>\n                                            <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'3d\')\" md-no-ink=\"true\">\n                                                In 3 Days\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item>\n                                            <md-button style=\"text-align: center;\" ng-click=\"vm.pickDueDate(\'7d\')\" md-no-ink=\"true\">\n                                                In 1 Week\n                                            </md-button>\n                                        </md-menu-item>\n\n                                        <md-menu-item>\n                                            <p style=\"text-align: center; margin: 0 0 1em 0; color: #999;\">\n                                                <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon> Pick a Date <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon>\n                                            </p>\n                                        </md-menu-item>\n                                        <md-menu-item style=\"padding:0!important;\">\n                                            <md-calendar style=\"padding-left: 0!important; padding-right:0!important;\" md-min-date=\"vm.today\" ng-change=\"vm.pickDueDate(vm.due)\" ng-model=\"vm.due\"></md-calendar>\n                                        </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                     <md-menu ng-if=\"!item.snooze && item.status == \'open\' && !vm.isClientUser\" style=\"margin:0;\">\n                          <md-button style=\"display:block; width:100%; margin-left:0; text-align:left; padding-left: 16px; margin-top:0; margin-bottom:0; height:36px;\" ng-click=\"$mdOpenMenu()\" layout=\"row\" layout-align=\"layout-fill center\" >\n                            <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"margin-right: 18px;\"></md-icon>\n                             <span flex=\"auto\" style=\"text-align:left;display:inline-block; width:110px;\">Snooze</span>\n                             <span flex=\"nogrow\" style=\"text-align:right;\">\n                              <md-icon  md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n                             </span>\n                          </md-button>\n                          <md-menu-content>\n                            <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                                 <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 5, $event)\">\n                                    5 min\n                                </md-button>\n                             </md-menu-item>\n                              <md-menu-item>\n                                   <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 15, $event)\">\n                                      15 min\n                                  </md-button>\n                               </md-menu-item>\n                               <md-menu-item>\n                                    <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 30, $event)\">\n                                       30 min\n                                   </md-button>\n                                </md-menu-item>\n                                <md-menu-item>\n                                     <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 60, $event)\">\n                                        60 min\n                                    </md-button>\n                                 </md-menu-item>\n                                 <md-menu-item>\n                                      <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 120, $event)\">\n                                         2 hr\n                                     </md-button>\n                                  </md-menu-item>\n                                  <md-menu-item>\n                                       <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 480, $event)\">\n                                          8 hr\n                                      </md-button>\n                                   </md-menu-item>\n                                   <md-menu-item>\n                                        <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 720, $event)\">\n                                           12 hr\n                                       </md-button>\n                                    </md-menu-item>\n                                    <md-menu-item>\n                                         <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 1440, $event)\">\n                                            1 day\n                                        </md-button>\n                                     </md-menu-item>\n                                     <md-menu-item>\n                                          <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(item, 2880, $event)\">\n                                             2 days\n                                         </md-button>\n                                      </md-menu-item>\n                        </md-menu-content>\n                    </md-menu>\n                    <md-menu-item ng-if=\"item.snooze && !vm.isClientUser\">\n                        <md-button aria-label=\"Snoozed\" ng-click=\"unSnoozeTask(item, $event)\">\n                             <md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon> un-Snooze</span>\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"item.focus != \'today\' && item.status != \'closed\' && !vm.isClientUser\">\n                        <md-button aria-label=\"Do Today\" ng-click=\"toggleToday(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon> Flag for Today\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"item.focus == \'today\' && item.status != \'closed\' && !vm.isClientUser\">\n                        <md-button aria-label=\"Do Later\" ng-click=\"toggleToday(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-sun\"></md-icon> Unflag for Today\n                        </md-button>\n                    </md-menu-item>\n                   <!--  <md-menu-item ng-if=\"item.status == \'closed\'\">\n                        <md-button aria-label=\"Re-Open\" ng-click=\"toggleCompleted(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Re-open\n                        </md-button>\n                    </md-menu-item> -->\n                    <md-menu-item>\n                        <md-button aria-label=\"Edit\" ng-if=\"item.status != \'closed\'\" ng-click=\"editTask(item,0, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"item.parentTemplate && !vm.isClientUser\">\n                        <md-button aria-label=\"Make recurring\" ng-click=\"editTaskTemplate(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit Original Task Template\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item  ng-if=\"!vm.isClientUser\">\n                        <md-button data-gtm-delete-task aria-label=\"Delete\" ng-click=\"deleteTask(item, $event)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete\n                        </md-button>\n                    </md-menu-item>\n\n\n                   <!--  <md-menu-item ng-if=\"!item.snooze\">\n                        <md-button aria-label=\"Snooze for 1 day\" ng-click=\"snoozeTask(item, $event)\">\n                             <md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon> Snooze\n                        </md-button>\n                    </md-menu-item> -->\n                    <div ng-if=\"!vm.isClientUser\">\n                      <md-divider ng-if=\"item.status == \'open\'\"></md-divider>\n                      <md-menu-item>\n                          <md-button ng-disabled=\"true\" ng-if=\"item.status == \'open\'\">\n                              Track\n                          </md-button>\n                      </md-menu-item>\n                      <md-menu-item ng-if=\"item.status != \'closed\'\">\n                          <md-button gtm-new-task-time-entry aria-label=\"Log Time\" ng-click=\"logTime(item, $event)\">\n                              <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> Enter Time\n                          </md-button>\n                      </md-menu-item>\n                      <md-menu-item ng-if=\"item.status != \'closed\' && vm.canUseTimer\">\n                          <md-button data-gtm-start-task-timer aria-label=\"Log Time\" ng-click=\"startTimer(item, $event)\">\n                              <md-icon md-font-icon=\"zmdi zmdi-play\"></md-icon> Start Timer\n                          </md-button>\n                      </md-menu-item>\n                      <md-divider></md-divider>\n\n\n\n                      <md-menu-item>\n                          <md-button ng-disabled=\"true\">\n                              Re-use\n                          </md-button>\n                      </md-menu-item>\n                      <md-menu-item>\n                          <md-button aria-label=\"Clone\" ng-click=\"copyTask(item, $event)\">\n                              <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n                          </md-button>\n                      </md-menu-item>\n\n                      <md-menu-item ng-if=\"!item.parentTemplate  && item.status == \'open\'\">\n                          <md-button data-gtm-new-recurring-template-from-task aria-label=\"Make recurring\" ng-click=\"makeRecurring(item, $event)\">\n                              <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> Setup as Recurring task\n                          </md-button>\n                      </md-menu-item>\n\n                      <md-menu-item ng-if=\"item.status == \'open\'\">\n                          <md-button  data-gtm-new-template-from-task aria-label=\"Save copy in Library\" ng-click=\"makeTemplate(item, $event)\">\n                              <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Save as a Template\n                          </md-button>\n                      </md-menu-item>\n                    </div><!-- if not client -->\n                    <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                        <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}tasks/{{item.refID}}\">\n                            <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </md-card-title>\n\n    <md-content ng-if=\"restLines(item.description).length || item.files || item.linkURL\" style=\"background-color: #fff; padding: 0px 10px 0px 10px; margin:0 0 10px 0; line-height: 1.3em;\">\n        <span class=\"dont-break-out\" ng-if=\"restLines(item.description).length\" class=\"md-subhead task-description\" style=\"white-space: pre-wrap; color: #777; font-size: .85em; \" md-no-ink=\"true\" >\n          {{restLines(item.description) | limitTo\n                    : 150 : begin}}</span>\n        <div ng-if=\"item.files\" layout=\"row\" layout-align=\"start start\" layout-wrap style=\"padding: 10px 0 10px 0;\">\n            <div flex=\"25\" ng-repeat=\"file in item.files track by $index\" ng-if=\"vm.isImage(file)\">\n                <a ng-if=\"file.source != \'pendingDropbox\' && file.source != \'pendingGoogleDrive\' && file.source != \'pendingFirebaseStorage\'\" href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"background-image: url(\'{{file.thumbnail}}\');\" style=\"border: none;\"></div></a>\n                <span ng-if=\"file.source == \'pendingDropbox\' || file.source == \'pendingGoogleDrive\' || file.source == \'pendingFirebaseStorage\'\" href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"border: none;\"><md-icon md-font-icon=\"fa fa-refresh\"></md-icon><md-tooltip md-delay=\"500\">File is currently in the copy queue. It will be available shortly.</md-tooltip></div></span>\n            </div>\n        </div>\n    </md-content>\n    <div ng-if=\"item.linkURL && item.linkLabel\" layout=\"row\" layout-align=\"center center\" style=\"margin-top: 1em;\">\n      <md-button style=\"background-color: rgba(158,158,158,0.2)\" class=\"\" ng-click=\"vm.processTaskLink(item.linkURL, item.linkTarget, $event)\"  style=\"padding-left: 1em; padding-right: 1em; border-radius: 4px; \">{{item.linkLabel}}</md-button>\n    </div>\n    <div layout=\"row\" class=\"hide-for-collapsed\" layout-align=\"end start\" ng-if=\"item.assigneeName || item.duedate\" style=\"padding:0 5px 0 5px;\">\n        <!-- ALTERNATE NEXT LINE <div flex ng-if=\"item.assignee != vm.userDataService.user.uid\" style=\"padding-left: 10px;\"> -->\n        <div ng-if=\"item.assigneeName\" flex style=\"padding-left: 6px;\">\n            <img onerror=\"this.src=\'/assets/images/avatars/generic-person-avatar.png\';\" src=\"{{item.assigneeAvatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"14\" style=\"border-radius:50%; margin-right: .5em; position: relative; top: 3px; opacity: .7;\">\n            <span class=\"md-caption\" style=\"color: #999;\">{{item.assigneeName}}</span>\n        </div>\n        <div flex=\"nogrow\">\n            <span ng-if=\"item.duedate\">\n                <label ng-click=\"editTask(item,0, $event)\" ng-class=\"{ \'close\': isNear(item.duedate, item.status) , \'over\': isDue(item.duedate, item.status) }\" style=\"font-size: 12px;\">\n                    {{item.duedate| amDateFormat:vm.settings.shortDateFormat}}\n                </label><br>\n            </span>\n            </label>\n        </div>\n    </div>\n\n    <!-- <md-divider></md-divider> -->\n    <md-card-footer class=\"md-primary\" style=\"padding-top: 0px;\">\n        <!-- <div layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\">\n                <md-icon ng-if=\"!vm.runningTimer\" md-font-icon=\"zmdi zmdi-time-interval\" ng-click=\"vm.startTimer(item.client, item.refID)\" style=\"max-width: 70px; width: 68px;\">\n                    <md-tooltip md-delay=\"500\">Start Timer</md-tooltip> Start Timer\n                </md-icon>\n            </div>\n        </div> -->\n\n\n        <div layout=\"row\" layout-align=\"start center\" class=\"item-footer-controls\" ng-if=\"!item.linkLabel\">\n            <div flex=\"nogrow\" ng-if=\"item.parentTemplate\" class=\"hide-for-collapsed\">\n                <md-button class=\"md-icon-button\" style=\"margin:0 ; padding: 4px; width: 25px; height: 36px;\">\n                <md-icon class=\"md-icon-button\"  md-font-icon=\"zmdi zmdi-refresh\" >\n                    <md-tooltip md-delay=\"1000\">Recurring task</md-tooltip>\n                </md-icon>\n            </md-button>\n            </div>\n            <div class=\"hide-for-collapsed\" flex=\"nogrow\" ng-if=\"item.numChecklistItems > 0\">\n                <md-button  ng-click=\"editTask(item, 1, $event);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-check-all\" >\n                        <md-tooltip md-delay=\"500\">Checklist items</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label ng-click=\"editTask(item, 1, $event);\" class=\"icon-label\">{{item.numCompleteItems || 0}}/{{item.numChecklistItems}}</label>\n            </div>\n\n            <div class=\"hide-for-collapsed\" flex=\"nogrow\" >\n                <md-button  ng-click=\"editTask(item, 2, $event);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-comment-outline\" >\n                        <md-tooltip md-delay=\"500\">Comments</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label ng-if=\"item.numnotes > 0\" class=\"icon-label\">{{item.numnotes}}</label>\n            </div>\n\n            <div class=\"hide-for-collapsed\" flex=\"nogrow\" ng-if=\"item.files\">\n                <md-button ng-click=\"editTask(item, 0, $event);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                <md-icon  md-font-icon=\"zmdi zmdi-attachment\">\n                    <md-tooltip md-delay=\"500\">Attachments</md-tooltip>\n                </md-icon>\n                </md-button>\n                <label class=\"icon-label\"> {{item.files.length}}</label>\n            </div>\n            <div flex  layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button hide-for-collapsed\" ng-click=\"editTask(item, 3, $event)\" flex=\"nogrow\" ng-if=\"item.logged > 0\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"  >\n                        <md-tooltip md-delay=\"500\">View Time Logs</md-tooltip>\n                    </md-icon>\n                </div>\n                <div flex=\"nogrow\"  ng-if=\"!vm.isClientUser\">\n                    <md-button data-gtm-new-task-time-entry ng-click=\"logTime(item, $event)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; cursor: pointer; height: 36px;\">\n                        <md-icon  md-font-icon=\"zmdi zmdi-plus\" >\n                            <md-tooltip md-delay=\"500\">Log Time Manually</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <!-- <md-icon md-font-icon=\"zmdi zmdi-play\" ng-click=\"startTimer(item)\" style=\"max-width: 16px; width: 16px;\">\n                        <md-tooltip md-delay=\"500\">Add Time Entry</md-tooltip>\n                    </md-icon> -->\n                </div>\n                <div  ng-if=\"!vm.isClientUser\" flex=\"nogrow\" ng-if=\"vm.canUseTimer\">\n                    <md-button  data-gtm-start-task-timer  ng-if=\"!vm.isTimerRunning(item) && !vm.hasOpenTimers(item)\" ng-click=\"startTimer(item, $event)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                        <md-icon  md-font-icon=\"zmdi zmdi-play\">\n                            <md-tooltip md-delay=\"500\">Start Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button  data-gtm-resume-task-timer ng-if=\"!vm.isTimerRunning(item) && vm.hasOpenTimers(item)\"  ng-click=\"resumeTimer(item, $event)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                        <md-icon style=\"color: orange;\" class=\"rotate-90\" md-font-icon=\"zmdi zmdi-eject\" >\n                            <md-tooltip md-delay=\"500\">Resume Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n                    <md-button  data-gtm-pause-task-timer ng-if=\"vm.isTimerRunning(item)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px; height: 36px;\">\n                        <md-icon  style=\"color: green;\" md-font-icon=\"zmdi zmdi-pause\"  ng-click=\"pauseTimer(item, $event)\" >\n                            <md-tooltip md-delay=\"500\">Pause Task Timer</md-tooltip>\n                        </md-icon>\n                    </md-button>\n\n                    <!-- <md-icon md-font-icon=\"zmdi zmdi-play\" ng-click=\"startTimer(item)\" style=\"max-width: 16px; width: 16px;\">\n                        <md-tooltip md-delay=\"500\">Add Time Entry</md-tooltip>\n                    </md-icon> -->\n                </div>\n\n\n            </div>\n\n        </div>\n\n\n    </md-card-footer>\n    <div class=\"task-progress-container hide-for-collapsed\" ng-if=\"item.budget > 0 || item.logged > 0\">\n        <div layout=\"row\" layout-align=\"start center\">\n            <div flex=\"30\" style=\"text-align: left; margin-right: 3px;\">\n                <span  class=\"task-progress-number\">\n                    <md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 10px; min-height: 25px; min-width: 12px;\"></md-icon>\n                {{item.logged| userTimeFormat}}\n                </span>\n                <span class=\"task-progress-number\" ng-if=\"item.budget\">\n                 / {{item.budget| userTimeFormat}}\n                 </span>\n            </div>\n            <div flex=\"60\">\n                <div class=\"task-progress-bar\" ng-if=\"item.budget > 0\" ng-class=\"{ \'close\': isClose(item.logged, item.budget) , \'over\': isOver(item.logged, item.budget) }\" style=\"width: {{taskProgress(item.logged, item.budget)}}%;\"></div>\n            </div>\n            <div flex=\"20\" style=\"text-align: right;\" ng-if=\"item.budget > 0\" class=\"task-progress-number\" ng-class=\"{ \'close\': isClose(item.logged, item.budget) , \'over\': isOver(item.logged, item.budget) }\">\n                {{taskProgress(item.logged, item.budget) || 0}}%\n            </div>\n        </div>\n       <!--  <div layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\" style=\"text-align: right;\">\n                <span  class=\"task-progress-number\">\n                {{item.logged| userTimeFormat}}\n                </span>\n                <span class=\"task-progress-number\" ng-if=\"item.budget\">\n                 / {{item.budget| userTimeFormat}}\n                 </span>\n            </div>\n\n        </div> -->\n        <div ng-if=\"item.private\" class=\"hide-for-collapsed\">\n            <p  style=\"text-align: center; font-size: 10px; margin:0 0 10px 0;\">Admin only</p>\n        </div>\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/task-item/app-item-template.tmpl.html","<md-card class=\"app-item app-item-task app-item-task-template status-{{item.status}} md-whiteframe-4dp\"\n        ng-class=\"{ \'focused\' : item.focused }\"\n\n  >\n     <div layout=\"row\">\n        <div flex=\"80\" layout=\"row\" style=\"padding: .5em;\">\n            <div flex=\"15\">\n              <md-icon  class=\"app-item-checkbox\"\n                        md-font-icon=\"zmdi zmdi-check-square\"\n                        ng-show=\"item.completed\"\n                        ng-click=\"toggleCompleted()\"\n                >\n              </md-icon>\n              <md-icon  class=\"app-item-checkbox\"\n                        md-font-icon=\"zmdi zmdi-square-o\"\n                        ng-show=\"!item.completed\"\n                        ng-click=\"toggleCompleted()\"\n                >\n              </md-icon>\n            </div>\n            <div flex>\n              <h3 class=\"md-title\">{{item.name}}</h3>\n            </div>\n        </div>\n        <div class=\"card-controls\" flex>\n            <md-menu md-position-mode=\"target-right target\">\n                 <!-- Trigger element is a md-button with an icon -->\n                 <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n                 <md-menu-content  class=\"md-dense\">\n                   <md-menu-item><md-icon md-font-icon=\"fa fa-edit\">&nbsp; Edit</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"zmdi zmdi-plus\">&nbsp;New task from Template</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"zmdi zmdi-copy\">&nbsp; Duplicate</md-icon></md-menu-item>\n                   <md-menu-item><md-icon md-font-icon=\"fa fa-trash\">&nbsp; Delete</md-icon></md-menu-item>\n                 </md-menu-content>\n            </md-menu>\n        </div>\n     </div>\n     <md-card-content ng-show=\"item.description\">\n        <p class=\"md-caption\">{{item.description}}<br>&nbsp;</p>\n      <!-- <md-button ng-click=\"toast(\'Hello Watson!\')\">Button</md-button> -->\n      </md-card-content>\n  <div ng-show=\"item.steps\" class=\"item-steps\">\n    <md-divider></md-divider>\n    <h3 class=\"md-caption\" style=\"padding-left: 1em;\">Task Steps</h3>\n    <md-content>\n    <div flex layout=\"row\" ng-repeat=\"step in item.steps\" ng-show=\"item.steps\" class=\"task-step\">\n      <div flex=\"15\"><p>\n              <md-icon  class=\"app-item-step-checkbox\"\n                        md-font-icon=\"zmdi zmdi-check-square\"\n                        ng-show=\"step.completed\"\n                        ng-click=\"toggleStepCompleted()\"\n                >\n              </md-icon>\n              <md-icon  class=\"app-item-step-checkbox\"\n                        md-font-icon=\"zmdi zmdi-square-o\"\n                        ng-show=\"!step.completed\"\n                        ng-click=\"toggleStepCompleted()\"\n                >\n              </md-icon></p>\n      </div>\n      <div flex><p>{{step.name}}<span ng-show=\"step.description\"><br><small>{{step.description}}</small></span></p></div>\n    </div>\n    </md-content>\n    </div>\n     <md-card-footer ng-show=\"item.schedule\" style=\"background-color: #fdd7e2;\">\n            <p class=\"text-center md-caption\">\n                <md-icon md-font-icon=\"fa fa-calendar-o\" style=\"font-size: 12px;\"></md-icon> {{item.schedule}}\n            </p>\n        </div>\n\n     </md-card-footer>\n\n</md-card>\n");
$templateCache.put("app/app-directives/task-item/app-item-time.tmpl.html","  <md-card class=\"app-item app-item-time md-whiteframe-2dp\" style=\"border-left: solid 2px {{item.clientcolor}}!important\">\n    <md-card-content>\n      <div layout=\"row\">\n        <div flex=\"80\">\n          <h3 class=\"md-title app-item-time-client\">{{item.client}}</h3>\n        </div>\n        <div class=\"card-controls\" flex>\n          <md-menu md-position-mode=\"target-right target\">\n             <!-- Trigger element is a md-button with an icon -->\n             <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n             <md-menu-content  class=\"md-dense\">\n               <md-menu-item><md-icon md-font-icon=\"fa fa-edit\">&nbsp; Edit</md-icon></md-menu-item>\n               <md-menu-item><md-icon md-font-icon=\"fa fa-trash\">&nbsp; Delete</md-icon></md-menu-item>\n             </md-menu-content>\n            </md-menu>\n          </div>\n      </div>\n      <div layout=\"row\">\n        <p flex class=\"md-caption\">\n          <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> {{item.logged}}\n        </p>\n        <p flex class=\"md-caption app-item-time-category\">\n          {{item.timetype}}\n        </p>\n        <p flex class=\"md-caption\">\n          <md-icon md-font-icon=\"fa fa-calendar-o\"></md-icon>\n          {{item.datelogged}}\n        </p>\n      </div>\n      <div layout=\"row\">\n        <div flex>\n          <p class=\"md-caption app-item-time-description\">{{item.description}}</p>\n        </div>\n      </div>\n     </md-card-content>\n  </md-card>\n");
$templateCache.put("app/app-directives/task-template-card/task-template-card.tmpl.html","<md-card ng-if=\"vm.template.uid\" class=\"app-item-task status-open focus-{{vm.template.info.focus}}\" ng-click=\"vm.editTemplate(vm.template)\">\n    <div class=\"task-badge task-handle\"  style=\"background-color: {{getColor(vm.template.info.client)}};\">\n\n    </div>\n    <md-card-title>\n\n        <md-card-title-text flex class=\"app-item-description\" style=\"padding-right: 1em;\">\n            <span class=\"task-title\" ><md-icon ng-show=\"vm.template.isRecurring && vm.template.schedule.repeatRule\" md-font-icon=\"fa fa-power-off\" style=\"font-size: 1em; color: green;\" ></md-icon><md-icon ng-show=\"!vm.template.isRecurring  && vm.template.schedule.repeatRule\" md-font-icon=\"fa fa-power-off\" style=\"font-size: 1em; color: orange;\" ></md-icon> {{firstLine(vm.template.info.description) | limitTo\n                        : 40 : begin}} </span>\n            <!-- <span class=\"md-caption task-client\">{{clientName(vm.template.info.client)}}</span> -->\n            <span class=\"md-subhead\" ng-click=\"vm.editTemplate(vm.template)\" style=\"color: #777\">{{restLines(vm.template.info.description) | limitTo\n                        : 150 : begin}}</span>\n             <div ng-show=\"vm.template.isRecurring\" class=\"hide-for-collapsed\">\n				<p class=\"md-caption\">Repeats: <span style=\"color: #888;\">{{vm.ruleInEnglish}}</span></p>\n				<p class=\"md-caption\">\n                    <span style=\"color: #888;\" ng-show=\"vm.template.schedule.limit\">Created {{vm.template.schedule.count}} of {{vm.template.schedule.limit}} times.</span>\n					<span style=\"color: #888;\" ng-show=\"!vm.template.schedule.limit\">Created {{vm.template.schedule.count}} times.</span>\n					<br>&nbsp;<br><span ng-show=\"!vm.template.schedule.complete\">Next <md-icon style=\"font-size: 12px; display:inline; margin-right: 3px;\" md-font-icon=\"zmdi zmdi-refresh\"></md-icon> <span style=\"color: #888;\">{{vm.displayNextDueDate}}</span></span>\n				</p>\n			</div>\n\n        </md-card-title-text>\n        <div class=\"card-controls\" flex=\"nogrow\" style=\"padding-right:0;\">\n            <md-menu md-position-mode=\"target-right target\">\n                <md-icon ng-click=\"$mdMenu.open($event)\" aria-label=\"Open sample menu\" md-font-icon=\"zmdi zmdi-more-vert\" class=\"app-item-more\"></md-icon>\n                <md-menu-content class=\"md-dense\">\n                    <md-menu-item>\n                        <md-button aria-label=\"Edit\" ng-click=\"vm.editTemplate(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon> Edit\n                        </md-button>\n                    </md-menu-item>\n                    <!-- <md-menu-item>\n                        <md-button aria-label=\"Clone\" ng-click=\"copyTask(item)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> Clone\n                        </md-button>\n                    </md-menu-item> -->\n                    <md-menu-item>\n                        <md-button aria-label=\"New Task from this Template\" ng-click=\"clone(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o-duplicate\"></md-icon> New Task from this Template\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button ng-if=\"!vm.template.isRecurring\" aria-label=\"Delete\" ng-click=\"deleteTemplate(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Delete\n                        </md-button>\n                        <md-button ng-if=\"vm.template.isRecurring\" ng-disabled=\"true\" aria-label=\"Delete\" ng-click=\"deleteTemplate(vm.template)\">\n                            <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon> Disable schedule first\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-if=\"vm.userType == \'admin\'\">\n                        <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}taskTemplates/{{vm.template.uid}}\">\n                            <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </md-card-title>\n    <!-- <md-divider></md-divider> -->\n    <md-card-footer class=\"md-primary\">\n\n        <div layout=\"row\" layout-align=\"start center\" class=\"item-footer-controls\" style=\"padding-left: 00px; padding-bottom: 0;\">\n            <div flex=\"nogrow\" ng-if=\"vm.template.info.numChecklistItems > 0\">\n                <md-button  ng-click=\"editTemplate(vm.template, 1);\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon md-font-icon=\"fa fa-check-square-o\" >\n                        <md-tooltip md-delay=\"500\">Checklist items</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label class=\"icon-label\">{{vm.template.info.numChecklistItems}}</label>\n\n            </div>\n            <div flex=\"nogrow\" ng-show=\"vm.template.info.files\">\n                <md-button ng-click=\"vm.editTemplate(vm.template)\" class=\"md-icon-button\" style=\"margin:0; padding:4px; width: 25px; margin-right: 6px;\">\n                    <md-icon  md-font-icon=\"zmdi zmdi-attachment\" >\n                        <md-tooltip md-delay=\"500\">Attachments</md-tooltip>\n                    </md-icon>\n                </md-button>\n                <label class=\"icon-label\"> {{vm.template.info.files.length}}</label>\n            </div>\n            <div flex=\"auto\" layout=\"row\" layout-align=\"end center\">\n                <label class=\"icon-label\">\n                    <span ng-if=\"vm.template.info.budget\">\n                     Budget: {{vm.template.info.budget| HandM}}\n                     </span>\n                </label>\n            </div>\n\n\n\n            </div>\n\n        </div>\n    </md-card-footer>\n    <div layout=\"row\" layout-align=\"start start\" layout-wrap style=\"padding-left: 10px;padding-bottom: 10px;\">\n        <div flex=\"25\" ng-repeat=\"file in vm.template.info.files track by $index\" ng-if=\"vm.isImage(file)\">\n            <a href=\"{{file.url}}\" target=\"_new\"><div class=\"attachment-thumbnail\" style=\"background-image: url(\'{{file.thumbnail}}\');\" style=\"border: none;\"></div></a>\n        </div>\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/task-time/task-time.tmpl.html","<md-content style=\"height: 400px;\">\n    <md-list class=\"md-dense\">\n        <time-entry ng-repeat=\"entry in vm.timeLogs | orderBy: [\'-logDate\'] | filter: timeEntryFilter track by $index+entry.uid\">\n         </time-entry>\n    </md-list>\n</md-content>\n<h4 class=\"right\" style=\"padding-right: 1em;\">Total: {{vm.totalLogged | HandM}}</h4>\n");
$templateCache.put("app/app-directives/team/setup-team-card.tmpl.html","<md-card  class=\"team-card\">\n    <div layout=\"column\" layout-align=\"center center\">\n        <div ng-if=\"vm.team.teamLimit > 1\" layout=\"column\"  layout-align=\"center center\">\n            <p class=\"md-subhead center\" style=\"width: 238px;\"><strong><strong>Your</strong> plan includes up to <br>{{vm.team.teamLimit}} Team Members</strong></p>\n            <p class=\"md-subhead center\" style=\"width: 238px; font-size: 12px;\">Would you like to set it up and start sending invitations?</p>\n            <md-button  class=\"md-accent md-raised\" ng-click=\"vm.setupTeam(vm.team)\">Setup your Team</md-button>\n        </div>\n        <div ng-if=\"vm.team.teamLimit == 1\" layout=\"column\"  layout-align=\"center center\">\n            <p class=\"md-subhead center\" style=\"width: 238px;\"> Your plan does not include additional members.</p>\n            <p class=\"md-subhead center\" style=\"width: 238px; font-size: 12px;\">If you would like to invite additional members, please upgrade to a team plan. </p>\n            <md-button class=\"md-accent md-raised\" ng-click=\"vm.upgrade()\">See Upgrade Options</md-button>\n        </div>\n\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/team/team-card.tmpl.html","<md-card  ng-click=\"vm.selectTeam(vm.team)\" ng-class=\"{\'active\': vm.isTeamSelected(), \'owner\': vm.member.role == \'owner\', \'md-whiteframe-20dp\' : vm.isTeamSelected(), \'selected-team-card\' : vm.isTeamSelected()}\" class=\"team-card\" style=\"position:relative;\">\n    <md-button ng-if=\"vm.team.ownerID == vm.userID\" class=\"edit-team-button md-icon-button\" ng-click=\"vm.editTeam(vm.team)\">\n        <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n    </md-button>\n    <div layout=\"row\">\n        <div flex=\"100\" layout=\"column\">\n            <div layout=\"row\" layout-align=\"start start\">\n                <span flex=\"nogrow\" ng-if=\"vm.team.ownerID == vm.userID\">\n                    <md-icon md-font-icon=\"zmdi zmdi-star\" style=\"color: orange;\"> </md-icon>\n                </span>\n                <span flex=\"nogrow\" ng-if=\"vm.team.ownerID != vm.userID\">\n                    <md-icon md-font-icon=\"fa fa-users\"> </md-icon>\n                </span>\n                <p flex class=\"md-title\" style=\"padding-left: .5em; margin-top: 0; margin-bottom:0;\">\n                    {{vm.team.name}}\n                </p>\n            </div>\n\n            <p class=\"md-subhead\" style=\"margin-top: 10px; font-size: 10px;\">\n                <strong>Team Owner:</strong> {{vm.team.ownerName}}<br>\n                <strong>Active Members:</strong> {{vm.activeMembers}}\n                <span ng-if=\"vm.disabledMembers > 0\"><br><strong>Inactive Members:</strong> {{vm.disabledMembers}}</span>\n                <br>\n                <span ng-if=\"vm.team.ownerID != vm.userID\">\n                You joined this team on {{vm.team.members[vm.userID].becameMember | amDateFormat : vm.settings.longDateFormat}}\n                </span>\n            </p>\n            <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.team.ownerID == vm.userID\">\n                <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-star\" style=\"color: orange; font-size: 10px;\"> </md-icon>\n                <p flex class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: 10px;\">\n                   You own this team<br>\n                </p>\n            </div>\n            <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.team.members[vm.userID].isTeamAdmin\">\n                <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-star\" style=\"color: green; font-size: 10px;\"> </md-icon>\n                <p flex class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: 10px;\">\n                   You administrate this team<br>\n                </p>\n            </div>\n\n            <p class=\"md-subhead\" ng-if=\"vm.userType == \'admin\'\">\n                <a target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}teams/{{vm.team.ownerID}}\"> <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray</a>\n            </p>\n        </div>\n\n\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/team-member/team-member-card.tmpl.html","<md-card  ng-click=\"vm.selectTeamMember(vm.member)\" ng-class=\"{\'active\': vm.isMemberSelected(), \'owner\': vm.member.role == \'owner\', \'archived\': vm.member.status == \'archived\', \'md-whiteframe-20dp\' : vm.isMemberSelected()}\" class=\"team-member-card\" ng-style=\"{\'border-top\':\'8px solid {{vm.member.color}}\'}\">\n    <div layout=\"row\">\n        <div flex=\"20\" layout=\"row\" layout-align=\"start start\">\n            <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" style=\"background-color: {{vm.member.color}};\" class=\"avatar\">\n        </div>\n        <div flex=\"80\" layout=\"column\">\n            <p class=\"md-title\" style=\"margin-bottom: 0; margin-top: 8px;\">\n                {{vm.member.firstName}} {{vm.member.lastName}}\n            </p>\n\n\n            <p ng-if=\"vm.member.status == \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                Invitation sent on {{vm.member.invited| amDateFormat: vm.settings.longDateFormat}}<br>\n            </p>\n            <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: 12px;\">\n                <a ng-if=\"vm.user.email\" href=\"mailto:{{vm.user.email}}\" class=\"dont-break-out\">{{vm.user.email}}</a>\n                <a ng-if=\"!vm.user.email\" href=\"mailto:{{vm.member.email}}\" class=\"dont-break-out\">{{vm.member.email}}</a>\n            </p>\n            <div ng-if=\"vm.member.uid != vm.userID\">\n                <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"margin-top: 0; font-size: 10px;\">\n                    Member since {{vm.member.becameMember | amDateFormat: vm.settings.longDateFormat}}\n                </p>\n            </div>\n            <div ng-if=\"vm.member.role == \'owner\'\">\n                <div layout=\"row\" layout-align=\"start center\">\n                    <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-star\" style=\"color: orange; font-size: 10px;\"> </md-icon>\n                    <p flex class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: 10px;\">\n                       Team Owner<br>\n                    </p>\n                </div>\n            </div>\n            <div ng-if=\"vm.member.isTeamAdmin\">\n                <div layout=\"row\" layout-align=\"start center\">\n                    <md-icon flex=\"nogrow\" md-font-icon=\"zmdi zmdi-star\" style=\"color: green; font-size: 10px;\"> </md-icon>\n                    <p flex class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0; font-size: 10px;\">\n                       Team Administrator<br>\n                    </p>\n                </div>\n            </div>\n        </div>\n\n\n    </div>\n    <div layout=\"row\" layout-align=\"end center\">\n        <div flex=\"nogrow\">\n            <p class=\"md-subhead member-{{vm.member.status}}\" style=\"font-size: 12px;\">\n                {{vm.member.status}} <span ng-if=\"vm.member.status == \'pending\'\">invitation</span>\n            </p>\n\n        </div>\n    </div>\n\n</md-card>\n");
$templateCache.put("app/app-directives/team-member/team-member-client-list-item.tmpl.html","<div layout=\"row\" layout-align=\"center center\" style=\"border-bottom: 1px solid #bbb; padding: 1em;\">\n       <div hide-xs flex=\"nogrow\" layout=\"row\" layout-align=\"start start\">\n           <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" class=\"avatar\" style=\"margin-right: 1em; border: 2px solid {{vm.member.color}}; border-radius: 50%;\">\n       </div>\n       <div flex=\"100\" flex-gt-xs=\"30\" layout=\"column\">\n           <p class=\"md-headline\" style=\"margin-bottom: 0; margin-top: 8px;\">\n               {{vm.user.profile.firstName}} {{vm.user.profile.lastName}}\n           </p>\n           <p class=\"md-subhead\" style=\"margin-top: 0; margin-bottom: 0;\">\n               <a href=\"mailto:{{vm.member.email}}\">{{vm.user.email}}</a>\n           </p>\n\n       </div>\n       <md-radio-group ng-disabled=\"vm.disableEdit\" ng-model=\"vm.clientAccess\" ng-change=\"vm.setMemberAccess(vm.member, vm.clientAccess)\">\n            <md-radio-button flex value=\"none\" class=\"md-primary\">None  </md-radio-button>\n            <md-radio-button flex value=\"member\" class=\"md-accent\">Member  </md-radio-button>\n            <md-radio-button flex value=\"admin\" class=\"md-warn\">Admin  </md-radio-button>\n        </md-radio-group>\n\n\n   </div>\n");
$templateCache.put("app/app-directives/team-member-detail/team-member-detail.tmpl.html","<div class=\"app-item-container team-member-detail hide-for-print\"\n    md-whiteframe=\"2\"\n    layout=\"column\"\n    layout-align=\"start\"\n    style=\"background-color: #fff;\"\n    >\n    <div class=\"app-item-container-header\" >\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.member.color}}; z-index: 78; cursor: default;\">\n            <div class=\"auto\">\n                <h3>Member Detail</h3>\n            </div>\n\n        </div><!-- // end app-item-container-title-bar -->\n    </div><!-- // end app-item-container-header -->\n\n    <div class=\"sub-panel-details app-item-container-items\"\n        layout=\"column\"\n        style=\"width: 700px;\"\n        resize\n        hotkey=\"{esc: vm.cancelMemberSelect}\"\n        >\n        <form name=\"vm.memberForm\" novalidate>\n        <div class=\"sub-panel-details-header\" >\n\n                <div layout=\"row\" style=\" padding-bottom: 1em; margin-bottom: 1em;\">\n                    <div flex=\"20\" style=\"min-width: 120px;\">\n                        <img src=\"{{vm.user.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" class=\"avatar\">\n                    </div>\n                    <div flex layout=\'column\' layout-align=\"start start\">\n                        <p ng-if=\"vm.user\" class=\"md-display-1\" style=\"margin-bottom:5px; margin-top: 5px;\">\n                            {{vm.member.firstName}} {{vm.member.lastName}}<br>\n                        </p>\n                        <p ng-if=\"vm.user\" class=\"md-subhead\" style=\"margin-bottom:5px; margin-top: 5px;\">\n                            <a href=\"mailto:{{vm.user.email}}\">{{vm.user.email}}</a><br>\n                        </p>\n                        <p ng-if=\"!vm.user\" class=\"md-subhead\" style=\"margin-bottom:0; margin-top: 5px;\">\n                            <a href=\"mailto:{{vm.member.email}}\">{{vm.member.email}}</a><br>\n                        </p>\n                        <p class=\"md-caption\" ng-if=\"vm.userID != vm.user.uid && vm.member.status != \'declined\'\" style=\"margin-bottom:0; margin-top: 5px;\">\n                            <span ng-if=\"vm.member.status != \'pending\'\">Member since {{vm.member.becameMember | amDateFormat: vm.settings.longDateFormat}}</span>\n                            <span ng-if=\"vm.member.status == \'pending\'\">Invited on {{vm.member.invited | amDateFormat: vm.settings.longDateFormat}}</span>\n                        </p>\n                        <p class=\"md-caption\"  style=\"margin-bottom:0; margin-top: 5px;\">\n                            <span >Hourly wage: <span ng-bind-html=\"vm.member.currency\"></span>{{vm.member.payrollRate || \'0\'}}/hour</span>\n                        </p>\n                        <p class=\"md-caption\" ng-if=\"vm.team.ownerID == vm.user.uid\">\n                            Team Owner\n                        </p>\n                        <p ng-if=\"vm.member.isTeamAdmin && vm.userID != vm.team.ownerID\" style=\"font-size: 11px; margin:0;\">\n                            Is a Team Administrator.\n                        </p>\n\n                       <!--  <p ng-if=\"vm.member.status != \'pending\'\" class=\"md-subhead\" style=\"font-size: 12px; margin-top: 1em;\">\n                            <strong>Tags?</strong><br>\n                            <md-chips ng-model=\"vm.clientBillingService.selectedPeriod.invoices\" name=\"invoices\" readonly=\"true\" md-removable=\"false\">\n                                <md-chip-template ng-click=\"vm.selectInvoice($chip.uid)\" ng-class=\"{\'selected\': vm.invoiceService.selectedInvoice.uid == $chip.uid}\"  style=\"cursor: pointer;\">\n                                     <span class=\"chip-content\"><md-icon ng-if=\"$chip.balance <= 0\" md-font-icon=\"fa fa-check-circle-o\" style=\"color: green; margin-right: -.25em;\"></md-icon> <md-icon md-font-icon=\"zmdi zmdi-receipt\" style=\"color: #fff;\"></md-icon> #{{$chip.number}}  - {{vm.currency}}{{$chip.total}}</span >\n                                </md-chip-template>\n                            </md-chips>\n\n                        </p> -->\n\n                    </div>\n\n\n                    <div flex=\'40\' layout=\'column\' layout-align=\'start layout-fill\'>\n                        <div ng-if=\"!vm.editMode\" layout=\"row\" layout-align=\"end center\">\n                            <md-button flex=\"nogrow\" ng-if=\"!vm.editMode && vm.member.status != \'pending\'\" ng-click=\"vm.editMode = true\" class=\"md-primary md-button-small\">\n                                <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n                                <md-tooltip md-delay=\"1000\">Edit Team Member</md-tooltip>\n                            </md-button>\n                        </div>\n\n                        <div ng-if=\"vm.editMode\" layout=\"column\" style=\"border-radius: 4px; background-color: #fff; border: 1px solid #bbb; padding:1em;\">\n                            <div layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.editMode = false\" class=\"md-primary md-button-small\" style=\"position:relative; top: -1em; right: -1em;\">\n                                    <md-icon md-font-icon=\"fa fa-close\"></md-icon>\n                                    <md-tooltip md-delay=\"1000\">Cancel Edit</md-tooltip>\n                                </md-button>\n                            </div>\n\n                                <div ng-if=\"vm.member.role != \'owner\'\">\n                                    <md-input-container ng-if=\"vm.member.status == \'declined\'\">\n                                        <label>Status</label>\n                                        <md-select  ng-disabled=\"true\" placeholder=\"declined\" style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.member.status\"></md-select>\n                                    </md-input-container>\n                                    <md-input-container ng-if=\"vm.member.status != \'declined\'\">\n                                        <label>Status</label>\n                                        <md-select ng-if=\"vm.member.status != \'declined\'\" ng-disabled=\"vm.member.status == \'pending\'\" placeholder=\"pending\" style=\"margin: 0;\" flex=\"nogrow\" ng-model=\"vm.member.status\" ng-change=\"vm.changeMemberStatus(vm.member)\">\n                                            <md-option value=\"active\">\n                                                <span style=\"color: green;\">Active</span>\n                                            </md-option>\n                                            <md-option value=\"disabled\">\n                                                <span style=\"color: red;\">Disabled</span>\n                                            </md-option>\n                                        </md-select>\n                                    </md-input-container>\n                                </div>\n                                <div layout=\"row\" layout-align=\"start start\">\n                                    <div flex=\"50\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.member.status != \'declined\'\" >\n                                        <div>\n                                            <label style=\"display:block; overflow:auto; width: 100%; color: rgba(0,0,0,.54); font-size: 12px; margin-bottom: 6px;\">Assigned color</label>\n                                            <div style=\"position: relative; top: 3px; width: 100px;\" layout=\"row\" layout-align=\"center center\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\"  aria-label=\"Assign Member a Color\" md-no-ink=\"true\"  >\n                                                <div flex=\"nogrow\" class=\"swatch\" style=\"background-color: {{vm.member.color || \'#999\'}}; width: 15px; height: 15px;\" >\n                                                </div>\n                                                <md-icon style=\"position: relative; top: 0px; right: -10px; margin-left: 1em;\" flex=\"nogrow\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon>\n                                            </div>\n                                        </div>\n                                        <!-- <span class=\"md-subhead\" style=\"padding-right: 1em;\">Assign a color:</span>\n                                        <div style=\"position: relative; top: 3px;\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\" flex=\"auto\" aria-label=\"Assign Member a Color\" md-no-ink=\"true\"  >\n                                            <div class=\"swatch\" style=\"background-color: {{vm.member.color || \'#999\'}}; width: 15px; height: 15px;\" >\n                                            </div>\n                                            <md-icon style=\"position: relative; top: -11px; right: -10px;\" flex=\"none\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon>\n                                        </div> -->\n                                    </div>\n                                </div>\n                                <div layout=\"row\" layout-align=\"start start\" style=\"margin-top: 1em;\">\n                                    <div flex=\"50\" >\n\n                                            <label style=\"display:block; overflow:auto; width: 100%; color: rgba(0,0,0,.54); font-size: 12px; margin-bottom: 6px;\">Hourly wage</label>\n                                            <div layout=\"row\" layout-align=\"start center\">\n                                                <span flex=\"nogrow\" style=\"margin-top:-24px;\" class=\"rateCurrency\" ng-bind-html=\"vm.member.currency\"></span>\n                                                <md-input-container ng-placeholder=\"00.00\" flex=\"grow\" style=\"margin-top:0; margin-bottom:0;\">\n                                                    <input name=\"payrollRate\" ng-model=\"vm.member.payrollRate\">\n                                                </md-input-container>\n                                            </div>\n\n                                    </div>\n                                    <div flex=\"50\">\n                                        <md-input-container>\n                                                <label>Wage currency</label>\n                                                <md-select class=\"small-select md-no-underline\" md-no-asterisk placeholder=\"Select a currency\" ng-model=\"vm.member.currencyLabel\" ng-change=\"vm.updateCurrency(vm.member.currencyLabel)\">\n                                                        <md-option ng-repeat=\"currency in vm.currencies track by $index\" value=\"{{currency.code}}\"><span style=\"font-size: 1.25em;\" ng-bind-html=\"currency.symbol\"></span>&nbsp;&nbsp; {{currency.code}}</md-option>\n                                                </md-select>\n                                        </md-input-container>\n                                    </div>\n                                </div>\n\n                                <div class=\"colorPicker\" ng-if=\"vm.colorPicker\" style=\"background-color: rgba(255,255,255,0);\">\n                                    <lk-color-chooser  ng-change=\"vm.togglePicker()\" style=\"margin:0; width:235px;\" colors=\"vm.memberColors\" selected-color=\"vm.member.color\" ng-model=\"vm.member.color\" ng-click=\"vm.colorChange(vm.memberForm);\"></lk-color-chooser>\n                                </div>\n\n                                <div ng-if=\"vm.team.ownerID == vm.userID && vm.member.uid != vm.team.ownerID\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: 1em; margin-bottom:1em;\">\n                                    <md-checkbox flex=\"nogrow\" class=\"md-secondary\" ng-disabled=\"vm.member.status != \'active\'\" ng-model=\"vm.member.isTeamAdmin\" ng-change=\"vm.toggleTeamAdmin(vm.member)\" style=\"margin-bottom:0;\"></md-checkbox>\n                                    <p flex style=\"font-size: 11px; margin: 0;\">\n                                        Can administrate entire team.\n                                    </p>\n\n                                </div>\n                                <div layout=\"row\" layout-align=\"start center\">\n                                    <md-button ng-if=\"vm.member.status != \'declined\' && vm.member.status != \'pending\' && vm.member.uid != vm.userID\" ng-click=\"vm.removeMember(vm.member)\" style=\"font-weight: normal; margin-top: 2em; margin-left: -1em; color: red;\"> <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"font-size: 1.25rem; color: red;\"></md-icon>Remove Member</md-button>\n                                </div>\n\n\n                        </div><!-- edit member block -->\n                        <div layout=\"row\" layout-align=\"end start\" ng-if=\"vm.member.status == \'pending\'\">\n\n                                    <p style=\"text-align: right;\"><span style=\"color: orange;\">Invitation Pending</span></p>\n\n\n                        </div>\n\n                    </div>\n                </div>\n                <div layout=\"column\" class=\"period-stats\" style=\"margin-top: 0\" ng-if=\"vm.member.status != \'declined\'\">\n\n                            <md-input-container style=\"margin-bottom: 0;\">\n                                <textarea ng-model=\"vm.member.notes\"\n                                    rows=\"1\"\n                                    placeholder=\"Notes\"\n                                    style=\"overflow-y: scroll; border-bottom: none;\"\n                                    class=\"no-scrollbar\"\n                                    ng-change=\"vm.editMemberNote()\"\n                                >\n                                </textarea>\n                            </md-input-container>\n                            <div ng-if=\"!vm.memberForm.$pristine\" layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.cancelNote()\">cancel</md-button> <md-button class=\"md-raised md-accent\" ng-click=\"vm.updateMember(vm.member)\" ng-disabled=\"vm.memberForm.$pristine\"   aria-label=\"save changes\"> Save Changes</md-button>\n                            </div>\n\n\n                </div>\n\n        </div>\n             </form>\n            <div class=\"sub-panel-content\" style=\"padding-bottom: 5em;\" ng-if=\"vm.member.status == \'pending\' || vm.member.status == \'declined\'\">\n\n                <div ng-if=\"vm.member.status == \'pending\'\" layout=\"column\" layout-align=\"center center\" style=\"padding-top: 1em;\">\n                    <h3 class=\"center\">Invitation Pending</h3>\n                    <p class=\"center md-subhead\">You\'ll be able to assign clients once this member has accepted your invitation.</p>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.resendInvite(vm.member, vm.team)\">\n                        <md-icon md-font-icon=\"fa fa-share\" style=\"margin-right: 1em;\"></md-icon>\n                    Re-send Invitation</md-button>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.revokeInvite(vm.member);\">\n                    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"margin-right: 1em;\"></md-icon> Revoke Invitation</md-button>\n\n                </div>\n                <div ng-if=\"vm.member.status == \'declined\'\" layout=\"column\" style=\"padding-top: 1em;\">\n                    <h3 class=\"center\">Invitation Declined</h3>\n                    <p class=\"center md-subhead\">The candidate declined your team invitation.</p>\n                    <md-button class=\"md-primary \" ng-click=\"vm.revokeInvite(vm.member);\">\n                    <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"margin-right: 1em;\"></md-icon> Discard Invitation</md-button>\n                    <md-button class=\"md-secondary \" ng-click=\"vm.resendInvite(vm.member)\">\n                        <md-icon md-font-icon=\"fa fa-share\" style=\"margin-right: 1em;\"></md-icon>\n                    Re-send Invitation</md-button>\n\n                </div>\n\n            </div>\n        <div ng-if=\"vm.member.status != \'pending\' && vm.member.status != \'declined\' && vm.member.status != \'archived\'\" class=\"sub-panel-content\" style=\"padding-bottom: 5em;\">\n\n           <md-tabs md-stretch-tabs=\"auto\" md-dynamic-height md-border-bottom>\n                <md-tab label=\"{{vm.member.firstName}}\'s Permissions\">\n                  <md-content class=\"\" style=\"background-color: #fff;\">\n                    <div ng-if=\"!vm.membersClients.length\">\n                        <h3 class=\"md-headline text-center\" style=\"font-size: 18px; margin-top: 2em;\">You don\'t have any Workspaces to share</h3>\n                        <p class=\"md-subhead text-center\">Visit the Workspace Manager to add some.</p>\n                    </div>\n                    <div class=\"team-member-permission-list\">\n                        <client-team-member-access  client=\"client\" member=\"vm.member\" team=\"vm.team\" ng-repeat=\"client in vm.membersClients |filter : {status: \'!archived\'} | orderBy: vm.userOrder track by client.uid + index\" style=\"border-bottom: 1px solid #bbb;\">\n                        </client-team-member-access>\n                    </div>\n                  </md-content>\n                </md-tab>\n                <!-- <md-tab label=\"History\">\n                  <md-content class=\"md-padding\">\n                    <h1 class=\"md-display-2\">Tab One</h1>\n                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue. Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus. In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec, feugiat ultricies mi.</p>\n                  </md-content>\n                </md-tab> -->\n            </md-tabs>\n                <!-- <div layout=\"row\" layout-align=\"end center\">\n\n                        <md-button style=\"margin-top:10px;\" class=\"md-accent\" ng-click=\"vm.printTime();\" aria-label=\"Print Time Report\">Print Time Report</md-button>\n\n                </div> -->\n\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/app-directives/time-entry/time-entry.tmpl.html","<md-list-item  ng-disabled=\"::entry.invoiced\" ng-click=\"vm.openTime(entry)\" class=\"md-3-line time-entry-list-item\" ng-class=\"{\'editing\': vm.editMode}\" style=\"border-top: 3px solid {{::vm.entry.clientColor}}; border-right: none; background-color: #fff; position: relative; cursor: pointer;\">\n\n<div class=\"card-controls\">\n    <md-menu ng-if=\"!vm.isClientUser\" md-position-mode=\"target-right target\">\n        <md-button class=\"md-button-small\"  ng-click=\"vm.loadMenu(entry); $mdMenu.open($event)\">\n         <md-icon ng-show=\"entry.invoiced || entry.locked\"  aria-label=\"Open time entry menu\"  md-font-icon=\"fa fa-lock\">\n            <md-tooltip ng-if=\"::entry.invoiced\">\n                This entry has been invoiced and cannot be modified.\n            </md-tooltip>\n            <md-tooltip ng-if=\"entry.locked && !entry.invoiced\">\n                This entry has been approved by your admin and cannot be modified.\n            </md-tooltip>\n        </md-icon>\n        <md-icon ng-show=\"!entry.invoiced && !entry.locked\" aria-label=\"Open time entry menu\" md-font-icon=\"zmdi zmdi-more-vert\" ></md-icon>\n    </md-button>\n        <md-menu-content class=\"md-dense\">\n            <md-menu-item ng-if=\"!vm.menuLoaded\">\n                <p class=\"center\" style=\"margin:0; width: 100%;\">\n                    <md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 14px; width: 14px; font-size: 14px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon>\n                </p>\n            </md-menu-item>\n            <md-menu-item ng-if=\"vm.menuLoaded\" ng-repeat=\"item in vm.entryMenu | toArray track by $index\">\n                <md-button aria-label=\"\" ng-click=\"vm[item.action](item.param)\">\n                    <md-icon md-font-icon=\"{{item.icon}}\"></md-icon> {{item.label}}\n                </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"::vm.userType == \'admin\'\">\n                <md-button aria-label=\"Delete\" target=\"_blank\" href=\"{{::vm.fbConfig.dataURL}}time/{{::item.uid}}\">\n                    <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n<div class=\"entry-card\" flex layout=\"column\" layout-align=\"start stretch\">\n    <div flex layout=\"row\" layout-align=\"start start\" >\n        <div flex=\"80\">\n            <p class=\"entry-client\">{{::vm.entry.clientName }}</p>\n            <p class=\"entry-description\">{{::vm.entry.description | limitTo : 50 : begin}}</p>\n        </div>\n        <div flex=\"20\" class=\"entry-digits\" style=\"padding-right: 1em;\">\n            <p class=\"entry-date right\">{{::vm.entry.logDate | amDateFormat:\'MM/DD/YY\'}}</p>\n            <p class=\"entry-logged right\">{{::vm.entry.logged | userTimeFormat}}</p>\n        </div>\n    </div>\n    <div flex layout=\"row\" layout-align=\"start end\">\n        <div flex=\"50\">\n            <p class=\"task-info\" style=\"cursor: pointer;\" ng-show=\"!vm.local\" ng-click=\"openTask(vm.entry.task)\">\n             <md-icon ng-show=\"::vm.entry.task\" aria-label=\"View Related Task\" md-font-icon=\"fa fa-check\" style=\"min-width: 10px; width: 10px; margin-right: 5px;\">\n                 <md-tooltip md-delay=\"1000\">View Related Task</md-tooltip>\n             </md-icon>\n             {{::vm.entry.taskName}}\n           </p>\n         </div>\n        <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n            <p class=\"creator-info right\" md-truncate>\n                <md-icon  md-font-icon=\"fa fa-check\" style=\"color: #fff;\"></md-icon>\n                <!-- <img class=\"avatar\" src=\"{{vm.entry.creatorAvatar || \'/assets/images/avatars/generic-avatar.png\'}}\" width=\"14\"> -->\n                {{::vm.entry.creatorName}}\n            </p>\n        </div>\n    </div>\n</div>\n\n\n</md-list-item>\n<md-divider></md-divider>\n\n");
$templateCache.put("app/app-directives/today-panel/all-today-panel.tmpl.html","<div class=\"app-item-container task-item-container focused-item-container\" ng-class=\"{\'collapsed-cards\': vm.collapseCards}\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\">\n    <div class=\"app-item-container-header\" style=\"margin-bottom: 12px;\">\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" >\n            <div flex=\"auto\">\n                <h3 >\n                    My Today\n                </h3>\n            </div>\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"newTask(null, \'today\')\">\n                    <md-icon aria-label=\"Create new task\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n                        <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                    </md-icon>\n                </md-button>\n                </a>\n            </div>\n        </div><!-- // end app-item-container-title-bar -->\n    </div><!-- // end app-item-container-header -->\n    <div class=\"app-item-container-items\"\n         dragula=\"\'drag-today-task\'\"\n         dragula-scope=\"$scope\"\n         ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n              layout-align=\"start start\"\n              resize=\"{{vm.suppressResize}}\"\n         layout-align=\"start start\"\n         panelid=\"today\"\n         >\n\n        <app-item\n            class=\"task-app-item\"\n            ng-repeat=\"item in filteredTasks =(vm.tasks |  toArray: true | filter: {\'status\' : \'open\'} | filter: todayFilter |  filter: snoozeFilter | limitTo: vm.limitto | orderBy:[\'todayorder\']) track by item.refID \"\n            taskid=\"{{item.refID}}\"\n            assignee=\"{{item.assignee}}\"\n            order=\"{{item.order}}\"\n            taskpanel=\"{{item.panel}}\"\n            client=\"{{item.client}}\"\n            >\n\n        </app-item>\n       <!--  <div layout=\"column\" ng-if=\"!filteredTasks.length\" flex=\"100\">\n            <p style=\"min-width: 258px; width: 100%; font-size:128px;\" class=\"center\"><md-icon md-font-icon=\"fa fa-smile-o\" style=\"font-size: 128px; color: rgba(200,200,200,.2);\"></md-icon></p>\n        </div> -->\n\n    </div>\n\n</div>\n");
$templateCache.put("app/app-directives/today-panel/today-panel.tmpl.html","<div class=\"app-item-container task-panel custom-task-panel focused-item-container\" md-whiteframe=\"2\" layout=\"column\" layout-align=\"start\" ng-class=\"{\'collapsed-cards\': vm.collapseCards}\">\n    <div class=\"app-item-container-header\" style=\"margin-bottom: 6px;\">\n        <div class=\"app-item-container-title\" layout=\"row\" layout-align=\"start center\" style=\"background-color: {{vm.client.profile.clientColor}};\">\n            <div flex=\"auto\">\n\n                <h3>\n                    <a href=\"/#/workspaces/{{vm.client.uid}}\" ng-if=\"showClientName\">\n                        <md-tooltip md-direction=\"right\" md-delay=\"2000\">\n                            View Client\n                        </md-tooltip>\n                            <md-icon class=\"heading-avatar\">\n                                <avatar ng-if=\"vm.client.status != \'personal\'\" parent=\"vm.client.profile\" upload=\"false\" border=\"vm.client.profile.clientColor\"></avatar>\n                                <avatar ng-if=\"vm.client.status == \'personal\'\" parent=\"vm.client.profile\" upload=\"false\" border=\"vm.client.profile.clientColor\" type=\"default\"></avatar>\n                            </md-icon>\n                            <span ng-if=\"!vm.client.profile.fullName\">{{vm.client.profile.firstname}} {{vm.client.profile.lastname}}</span>\n                            <span ng-if=\"vm.client.profile.fullName\">{{vm.client.profile.fullName}}</span>\n                    </a>\n                    <span ng-if=\"!showClientName\">\n                        <md-icon ng-if=\"vm.client.profile.avatar\" class=\"side-menu-icon\" style=\"max-height:20px; margin-right: 0;\"><img class=\"client-panel-avatar\" src=\"{{vm.client.profile.avatar}}\"></md-icon>\n                         My Today\n                    </span>\n                </h3>\n            </div>\n            <div class=\"app-item-container-controls\" flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n                <md-button class=\"md-icon-button\" style=\"margin-right: 10px; width: 25px;\" ng-click=\"newTask(vm.client.uid, \'today\')\">\n                    <md-icon aria-label=\"Create new task for {{vm.client.profile.fullName}}\" md-font-icon=\"zmdi zmdi-plus\" class=\"app-item-create\">\n                        <md-tooltip md-delay=\"1000\">New Task</md-tooltip>\n                    </md-icon>\n                </md-button>\n                </a>\n            </div>\n        </div><!-- // end app-item-container-title-bar -->\n        <!-- <client-summary-strip this-client=\"vm.client\" ></client-summary-strip> -->\n    </div><!-- // end app-item-container-header -->\n    <div class=\"app-item-container-items\"\n        dragula=\"\'drag-today-task\'\"\n        dragula-scope=\"$scope\"\n        ng-class=\"{\'layout-wrap\': !vm.verticalTaskPanels , \'layout-column\': !vm.verticalTaskPanels, \'vertical-scroll\': vm.verticalTaskPanels}\"\n        layout-align=\"start start\"\n        resize=\"{{vm.suppressResize}}\"\n        panelid=\"today\"\n        style=\"height: 100%;\"\n        >\n        <app-item\n            class=\"task-app-item\"\n            taskid=\"{{item.refID}}\"\n            assignee=\"{{item.assignee}}\"\n            order=\"{{item.todayorder}}\"\n            taskpanel=\"{{item.panel}}\"\n            client=\"{{item.client}}\"\n            ng-repeat=\"item in filteredTasks track by $index\"\n        >\n        </app-item>\n        <!-- <div layout=\"column\" ng-if=\"!filteredTasks.length\" flex=\"100\" style=\"width:100%;\">\n            <p style=\"min-width: 258px; width: 100%; font-size:128px;\" class=\"center\"><md-icon md-font-icon=\"fa fa-smile-o\" style=\"font-size: 128px; color: rgba(200,200,200,.2);\"></md-icon></p>\n        </div> -->\n    </div>\n\n</div>\n");
$templateCache.put("app/app-directives/timer-directives/timer-card.tmpl.html","<md-card\n    ng-class=\"{ \'active-timer md-whiteframe-6dp\': vm.timerDataService.timerData.activeTimer.uid==vm.userTimer.uid}\"\n    style=\"border-left: 6px solid {{vm.userTimer.client.clientColor}}; margin-bottom: 8px;\"\n    layout=\"column\">\n\n    <div layout=\"row\">\n        <div flex=\"70\" class=\"md-padding\" style=\"padding-bottom: 0; padding-top: 0;\">\n            <p style=\"font-size: 18px;\">{{vm.userTimer.client.name}}</p>\n            <p style=\"font-size: 12px;\" ng-if=\"vm.userTimer.task\">\n                <strong>Related Task: </strong>\n                <span ng-click=\"vm.viewTask(vm.userTimer.task.uid)\" style=\"cursor: pointer;\">{{vm.firstLine(vm.userTimer.task.title)}}</span>\n            </p>\n        </div>\n        <div flex>\n            <p class=\"md-body-1 md-padding acrrued-time\" style=\"margin:0; padding-bottom: 0; font-size: 18px;\" ng-class=\"{ \'active-accrued\': vm.timerDataService.timerData.activeTimer.uid==vm.userTimer.uid}\">\n                    <strong>{{vm.userTimer.approxAccrued | hhmmss}}</strong><br>\n            </p>\n            <p class=\"md-padding\" style=\"font-size: 10px; margin: 0; padding-top: 0; padding-right: 25px; text-align:right;\">Started {{vm.userTimer.events[0].when | amDateFormat: \'MMM DD\'}}<br>{{vm.userTimer.events[0].when | amDateFormat: \'h:mm a\'}}</p>\n        </div>\n\n    </div>\n\n    <div layout=\"column\" style=\"padding: .5em 1em 0 1em;\">\n        <form name=\"timerDescriptionForm\" ng-submit=\"vm.updateDescription(vm.userTimer)\">\n        <md-input-container style=\"margin: 0;position: relative;\" md-no-float >\n\n            <input placeholder=\"What are you working on?\" name=\"description\" class=\"timer-description\" ng-model=\"vm.userTimer.description\" ng-blur=\"vm.updateDescription(vm.userTimer)\">\n            <span style=\"position: absolute; right: 5px; top: 3px;\" ng-show=\"vm.userTimer.saving\" class=\"\"><md-icon  aria-label=\"logging-ing\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"padding-right: .5em; font-size: 11px; line-height: 25px; \"></md-icon></span>\n            <span style=\"position: absolute; right: 5px; top: 3px;\" ng-show=\"vm.userTimer.saved\" class=\"disappear\"><md-icon  aria-label=\"logging-ing\" md-font-icon=\"zmdi zmdi-check\" style=\"padding-right: .5em; min-width: 12px; width: 12px; font-size: 12px; color: green;\"></md-icon></span>\n        </md-input-container>\n        </form>\n    </div>\n    <div ng-if=\"!vm.showConfirm\" layout=\"row\" layout-align=\"center center\" class=\"md-padding timerlist-controls\"  >\n\n        <!-- use resumeSavedTimer if this isn\'t the current active timer -->\n        <md-button\n            style=\"margin-right:0px; margin-left: 0px;\"\n            ng-if=\"vm.timerDataService.timerData.activeTimer.uid != vm.userTimer.uid\"\n            ng-disabled=\"vm.userTimer.on\"\n            ng-click=\"vm.resumeSavedTimer(vm.userTimer)\"\n            class=\"  md-small \"\n            flex=\"nogrow\"\n            data-gtm-resume-saved-timer\n            >\n            <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\" >\n                <md-tooltip>Resume Timer</md-tooltip>\n            </md-icon>\n        </md-button>\n        <!-- use resumeTimer if this is the current active timer -->\n        <md-button\n            style=\"margin-right:0px; margin-left: 0px;\"\n            ng-if=\"vm.timerDataService.timerData.activeTimer.uid == vm.userTimer.uid\"\n            ng-disabled=\"vm.userTimer.on\"\n            ng-click=\"vm.resumeTimer(vm.userTimer)\"\n            class=\"  md-small \"\n            flex=\"nogrow\"\n            data-gtm-resume-timer\n            >\n            <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\" >\n                <md-tooltip>Resume Timer</md-tooltip>\n            </md-icon>\n        </md-button>\n        <md-button\n            style=\"margin-right:0px; margin-left: 0px;\"\n            ng-disabled=\"!vm.userTimer.on\"\n            ng-click=\"vm.pauseTimer(vm.userTimer)\"\n            class=\"  md-small \"\n            flex=\"nogrow\"\n            data-gtm-pause-timer\n            >\n            <md-icon md-font-icon=\"zmdi zmdi-pause\" ><md-tooltip>Pause Timer</md-tooltip></md-icon>\n\n        </md-button>\n        <md-button\n            style=\"margin-right:0px; margin-left: 0px;\"\n            ng-click=\"vm.stopTimer(vm.userTimer)\"\n            class=\"  md-small \"\n            flex=\"nogrow\"\n            data-gtm-stop-timer\n            >\n            <md-icon md-font-icon=\"zmdi zmdi-stop\" ><md-tooltip>Close and Log Timer</md-tooltip></md-icon>\n\n        </md-button>\n        <md-button\n            style=\"margin-right:0px; margin-left: 0px;\"\n            ng-click=\"vm.discardTimer(vm.userTimer)\"\n            ng-confirm-click=\"Discard this timer?\"\n            class=\" md-small\"\n            flex=\"nogrow\"\n            >\n            <md-icon\n                title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                <md-tooltip>Discard Timer</md-tooltip>\n            </md-icon>\n\n        </md-button>\n\n    </div>\n    <div ng-if=\"vm.showConfirm\" layout=\"row\" layout-align=\"end center\" class=\"md-padding timerlist-controls confirm-delete\"  >\n        <p class=\"md-subhead padding-right-20\" style=\"font-size: 12px;\">Discard timer, are you sure?</p>\n        <md-button\n            style=\"padding-left: 15px; padding-right: 15px;\"\n            ng-click=\"vm.confirmDiscardTimer(vm.userTimer)\"\n            ng-confirm-click=\"Are you sure?\"\n            class=\"md-button-small md-raised md-warn\"\n            flex=\"nogrow\"\n            data-gtm-discard-timer\n            >\n            <!-- <md-icon\n                title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                <md-tooltip>Discard Timer</md-tooltip>\n            </md-icon> -->\n            Yes\n        </md-button>\n        <md-button\n            style=\"padding-left: 15px; padding-right: 15px;\"\n            ng-click=\"vm.cancelDiscard(vm.userTimer)\"\n            ng-confirm-click=\"Are you sure?\"\n            class=\"md-button-small\"\n            flex=\"nogrow\"\n            >\n           <!--  <md-icon\n                title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                <md-tooltip>Discard Timer</md-tooltip>\n            </md-icon> -->\n            No\n        </md-button>\n    </div>\n</md-card>\n");
$templateCache.put("app/app-directives/timer-directives/timer-list.tmpl.html","<div>\n    <div ng-if=\"vm.userTimers.length > 0\">\n        <timer-card thistimer=\"userTimer\" ng-repeat=\"userTimer in vm.userTimers| orderBy : \'-uid\'\">\n        </timer-card>\n        <!-- end md-list-item-text -->\n    </div>\n\n    <div ng-if=\"vm.userTimers.length == 0\">\n        <p class=\"text-center md-heading\" style=\"padding: 1em; background-color: #efefef; margin: 1em; border-radius: 8px;\">You don\'t have any timers to switch to.<br>\n        Start one in your toolbar Timer, or click the \"Play\" button on any task card.</p>\n    </div>\n    <!-- <p ng-if=\"vm.userTimers.length > 0\" class=\"text-center\">Missing a timer? <br>\n        Please refresh your browser.\n    </p> -->\n</div>\n");
$templateCache.put("app/app-directives/timer-directives/timer.tmpl.html","<div class=\"timer-wrapper\" layout=\"row\" layout-align=\"start center\">\n<div class=\"timer-toggle\" ng-click=\"vm.toggleTimerGui()\"  flex=\"nogrow\" >\n        <md-icon ng-if=\"vm.timerDataService.showTimerGui\" md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n        <md-icon ng-if=\"!vm.timerDataService.showTimerGui\" md-font-icon=\"zmdi zmdi-caret-left\"></md-icon>\n        <md-tooltip md-delay=\"1000\">\n            Show/Hide Timer\n        </md-tooltip>\n</div>\n<div ng-if=\"vm.timerDataService.showTimerGui\" layout=\"row\" layout-align=\"start center\" style=\"position: relative;  padding:0 1em 0 2em; background-color: {{vm.timerDataService.timerData.activeTimer.displayColor}};\">\n    <!-- CLIENT -->\n        <div class=\"timer\" layout=\"row\" layout-align=\"start center\">\n\n                <!-- CLIENT -->\n                <div class=\"animate-width\" ng-if=\"!vm.timerDataService.timerData.activeTimer.on\" flex=\"nogrow\" layout=\"column\" layout-align=\"start start\">\n                  <md-input-container class=\"md-block\" style=\"padding:0;\">\n                    <!-- note ng-model-options is required for md-select to auto-select current client -->\n                     <md-select\n                        ng-disabled=\"vm.timerDataService.timerData.activeTimer.on\"\n                        class=\"timer-client-menu-container md-no-underline timer-client-select\"\n                        ng-model=\"vm.timerDataService.timerData.activeClient\"\n                        style=\"\"\n                        ng-model-options=\"{trackBy: \'$value.uid\'}\"\n                        md-no-underline\n                        placeholder=\"Choose Workspace\"\n                        ng-change=\"vm.newTimer(vm.timerDataService.timerData.activeClient)\"\n                        md-on-open=\"vm.resetTimer()\"\n                       >\n                        <md-option\n                            ng-repeat=\"client in vm.clients | orderBy: \'order\' track by $index\"\n                            ng-value={{client}}\n                            style=\"border-left: 4px solid {{client.profile.clientColor}};\"\n                            ng-if=\"!client.disabled\"\n                            >\n                            <img\n                                src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\"\n                                width=\"20\"\n                                style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}}; margin-right: .5em; position: relative; top: 5px;\" />\n                            <span style=\"position: relative; top: -3px;\" class=\"small\">{{client.profile.fullName}}</span>\n                        </md-option>\n\n                     </md-select>\n                     <div class=\"task-information\" ng-click=\"vm.viewTask(vm.timerDataService.timerData.activeTimer.task.uid)\" ng-show=\"vm.timerDataService.timerData.activeTimer.task\" style=\"font-size: 9px; padding-left: 32px;\">\n                         <!-- Link to parent task -->\n                         <p style=\"font-size: 8px; line-height: 10px; margin:0; padding:0;\"><!-- <md-icon\n                             ng-show=\"vm.timerDataService.timerData.activeTimer.task\"\n                             style=\"font-size: 8px; min-width: 10px; width: 10px;\"\n                             md-font-icon=\"zmdi zmdi-check-square\">\n                             <md-tooltip md-delay=\"1000\">\n                                 <span >View Related Task</span>\n                             </md-tooltip>\n                         </md-icon> -->\n                         {{vm.shortTaskName(vm.timerDataService.timerData.activeTimer.task.title)}}\n                         </p>\n                     </div>\n                  </md-input-container>\n\n                </div>\n                <!-- <img\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.on\"\n                    src=\"{{vm.selectedClient.avatar || \'/assets/images/avatars/generic-avatar.png\'}}\"\n                    width=\"20\"\n                    style=\"border-radius: 50%; border: 2px solid {{vm.selectedClient.clientColor}}; margin-right: 1em; position: relative;\" /> -->\n                <!-- time elapsed since timer started -->\n                <div ng-if=\"!vm.showConfirm\" class=\"timer-actual-background\" layout=\"row\" layout-align=\"start center\" style=\"margin:0; padding:0;\">\n                <span\n                    class=\"timer-actual {{vm.budgetStatus(vm.timerDataService.timerData.activeTimer)}}\"\n                    flex=\"nogrow\"\n                    style=\"margin-right: .5em; padding: 15px 0 15px 0;\"\n                    >\n                    {{vm.timerDataService.timerData.activeTimer.approxAccrued | hhmmss}}\n                </span>\n\n\n\n                <!-- START -->\n                <!-- only show if activeTimer has no events -- after that we\'ll use resume instead-->\n                <!-- only enabled if a client is selected -->\n                <md-button\n                    ng-show=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    ng-disabled=\"!vm.timerDataService.timerData.activeClient.uid || vm.timerDataService.timerData.timers.length > 9\"\n                    ng-click=\"vm.startTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"play timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\"\n                    data-gtm-start-timer\n                    md-no-ink>\n                    <md-icon md-font-icon=\"zmdi zmdi-play\">\n                        <md-tooltip md-delay=\"1000\" >\n                            <span ng-if=\"vm.selectedClient && vm.timerDataService.timerData.timers.length < 10\">Start Timer {{vm.selectedClient.name}}</span>\n                            <span ng-if=\"!vm.selectedClient\">Choose a client first</span>\n                            <span ng-if=\"vm.selectedClient && vm.timerDataService.timerData.timers.length > 9\">You have reach the maximum allowed simultaneous timers.</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n\n                <!-- PAUSE -->\n                <!-- only show if timer is running. -->\n                <md-button\n                    ng-if=\"vm.timerDataService.timerData.activeTimer.on\"\n                    ng-click=\"vm.pauseTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"pause timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\"\n                    data-gtm-pause-timer >\n                    <md-icon md-font-icon=\"zmdi zmdi-pause\">\n                        <md-tooltip md-delay=\"1000\">\n                            <span >Pause Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n                <!-- RESUME -->\n                <!-- only display if timer already has events  and if timer is not running-->\n                <md-button\n                    ng-if=\"!vm.timerDataService.timerData.activeTimer.on && vm.timerDataService.timerData.activeTimer.events.length\"\n                    ng-click=\"vm.resumeTimer(vm.timerDataService.timerData.activeTimer)\"\n                    aria-label=\"play timer\"\n                    flex=\"nogrow\"\n                    class=\"cassette-control md-icon-button\"\n                    data-gtm-resume-timer>\n                    <md-icon md-font-icon=\"zmdi zmdi-eject\" class=\"rotate-90\">\n                        <md-tooltip md-delay=\"1000\">\n                            <span >Resume Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n\n                <!-- STOP -->\n                <md-button\n                    ng-disabled=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    aria-label=\"stop timer\"\n                    flex=\"nogrow\"\n                    ng-click=\"vm.stopTimer(vm.timerDataService.timerData.activeTimer)\"\n                    class=\"cassette-control md-icon-button\"\n                    data-gtm-stop-timer >\n                    <md-icon md-font-icon=\"zmdi zmdi-stop\">\n                        <md-tooltip md-delay=\"1000\">\n                            <span>Stop &amp; Log Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n\n                <!-- Discard -->\n                <md-button\n                    ng-disabled=\"!vm.timerDataService.timerData.activeTimer.events.length\"\n                    aria-label=\"discard timer\"\n                    flex=\"nogrow\"\n                    ng-click=\"vm.discardTimer(vm.timerDataService.timerData.activeTimer)\"\n                    class=\"cassette-control md-icon-button\"\n                    data-gtm-start-discard-timer>\n                    <md-icon md-font-icon=\"zmdi zmdi-close\">\n                        <md-tooltip md-delay=\"1000\">\n                            <span>Discard Timer</span>\n                        </md-tooltip>\n                    </md-icon>\n                </md-button>\n            </div><!-- timer-actual-background -->\n        </div>\n        <div style=\"width: 270px; height: 47px;\" ng-if=\"vm.showConfirm\" class=\"timer\" layout=\"row\" layout-align=\"end center\">\n\n                Discard timer, are you sure?\n                <md-button\n                    style=\"padding-left: 10px; padding-right: 10px;\"\n                    ng-click=\"vm.confirmDiscardTimer(vm.timerDataService.timerData.activeTimer)\"\n                    ng-confirm-click=\"Are you sure?\"\n                    class=\"md-button-small\"\n                    flex=\"nogrow\"\n                    data-gtm-discard-timer\n                    >\n                    <!-- <md-icon\n                        title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                        <md-tooltip>Discard Timer</md-tooltip>\n                    </md-icon> -->\n                    Yes\n                </md-button>\n                <md-button\n                    style=\"padding-left: 10px; padding-right: 10px;\"\n                    ng-click=\"vm.cancelDiscard(vm.timerDataService.timerData.activeTimer)\"\n                    ng-confirm-click=\"Are you sure?\"\n                    class=\"md-button-small\"\n                    flex=\"nogrow\"\n                    >\n                   <!--  <md-icon\n                        title=\"delete timer from list\" class=\"icon_home\" aria-label=\"Discard\" md-font-icon=\"fa fa-close\">\n                        <md-tooltip>Discard Timer</md-tooltip>\n                    </md-icon> -->\n                    No\n                </md-button>\n\n        </div>\n\n\n</div>\n<div ng-if=\"!vm.timerDataService.showTimerGui && vm.timerDataService.timerData.activeTimer.on\" style=\"width: 4px; background-color: {{vm.timerDataService.timerData.activeTimer.displayColor}}; overflow: hide; height:48px;\">\n    &nbsp;\n</div>\n</div>\n");
$templateCache.put("app/app-services/clientDataService/dialog-client.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"100\" flex-md=\"100\" flex-lg=\"60\" flex-xl=\"50\" layout=\"column\" style=\" background-color: rgba(255,255,255,0);\" md-theme=\"grey-menu\" class=\" item-dialog client-item-dialog md-inline-form\">\n	<ng-form name=\"vm.clientDialogForm\"  novalidate>\n	<fieldset ng-disabled=\"!vm.isAdmin || vm.client.demo\">\n\n	<md-toolbar ng-if=\"vm.canOpenDialog\" class=\"md-primary\" style=\"background-color: {{vm.client.profile.clientColor}}\">\n		<div ng-if=\"!vm.client.uid\" class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"center center\" >\n			<h2 flex=\"nogrow\">New <span ng-if=\"vm.client.status == \'personal\'\">\n					Internal\n				</span>\n				<span ng-if=\"vm.client.status == \'active\'\">\n					Client\n				</span> Workspace</h2>\n		</div>\n		<div data-gtm-edit-workspace ng-if=\"vm.client.uid\" class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"center center\" >\n			<h2 flex=\"nogrow\" ng-show=\"vm.client.profile.isCompany\" class=\"center\">{{vm.client.profile.company}}\'s Profile</h2>\n			<h2 flex=\"nogrow\" ng-show=\"!vm.client.profile.isCompany\" class=\"center\">{{vm.client.profile.firstname}} {{vm.client.profile.lastname}}\'s Profile</h2>\n		</div>\n	</md-toolbar>\n	<md-dialog-content style=\"background-color:#fff;\">\n		<!-- if !canOpenDialog -->\n		<div ng-if=\"!vm.canOpenDialog\" style=\"padding: 50px; background-color: #fff;\">\n			<p class=\"text-center\"><img src=\"/assets/images/brand/adminja-bug.svg\" width=\"85\"></p>\n			<h3 class=\"text-center\">We\'re sorry, your <span ng-if=\"vm.clientLimit = 1\">Free Starter</span> plan includes {{vm.clientLimit}} <span ng-if=\"vm.clientLimit > 1\">Workspaces</span><span ng-if=\"vm.clientLimit == 1\">Workspace</span></p>\n			<p class=\"text-center\">You have already reached that limit.</p>\n			<p class=\"text-center\">You can add more Workspaces by upgrading to a larger plan.</p>\n			<p class=\"text-center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.manageSubscription()\">Upgrade Options</md-button></p>\n			<p class=\"text-center\"> Visit your <a ui-sref=\"authentication.profile\">Profile</a> to learn more about your Adminja subscription.</p>\n		</div><!-- \\!canOpenDialog -->\n\n		<div ng-if=\"vm.canOpenDialog\">\n			<div ng-if=\"vm.client.demo\" style=\"background-color: #bbb; margin:0; padding: 1em;\">\n				<p class=\"md-subhead center margin-0\">This is a sample Client Workspace. Its Client Card cannot be modified.</p>\n			</div>\n\n			<md-tabs flex md-dynamic-height class=\"\" md-selected=\"vm.selectedTabIndex\" md-stretch-tabs=\"always\" style=\"background-color: #fff;\">\n				<!-- KEY INFO -->\n				<md-tab md-on-select=\"vm.onTabChanges(0)\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-account\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Key Info</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding\" layout=\"column\">\n							<!-- avatar and color -->\n							<div layout=\"row\" ng-if=\"vm.isAdmin || vm.isOwner\" layoyut-align=\"center center\" style=\" padding-bottom: 2em;\">\n								<md-radio-group flex=\"nogrow\" style=\"margin-left: auto; margin-right: auto;\" ng-disabled=\"vm.client.demo\" ng-model=\"vm.client.status\" ng-change=\"vm.changeSpaceType(vm.client.status)\">\n		                                   <label style=\"padding-right: 1em;\">Workspace Type:</label>\n		                                   <md-radio-button  value=\"active\" aria-label=\"Client\" style=\"margin-right: 1em;\">\n		                                   	Client\n		                                   </md-radio-button>\n		                                   <md-radio-button  value=\"personal\" aria-label=\"Internal\">\n			                                 	Internal\n		                                   </md-radio-button>\n		                               </md-radio-group>\n	                          	</div>\n							<div layout=\"row\" layout-align=\"center start\">\n								<div flex=\"100\" layout=\"column\" layout-align=\"start center\" style=\"max-width: 800px;\">\n									<md-card layout=\"column\" md-padding style=\"margin-bottom: 2em; padding-top: 1em; width: 500px;\">\n										<div flex=\"100\" flex-gt-sm=\"50\" style=\"min-width: 300px; min-height:147px;\" layout=\"column\" layout-align=\"start center\">\n											<avatar ng-if=\"vm.client.status != \'personal\' && vm.showAvatar\" context=\"light\" parent=\"vm.client.profile\" border=\"true\" upload=\"true\"></avatar>\n											<avatar ng-if=\"vm.client.status == \'personal\' && vm.showAvatar\" context=\"light\" parent=\"vm.client.profile\" border=\"true\" upload=\"true\" type=\"default\"></avatar>\n										</div>\n										<div flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" style=\"min-width: 350px; margin-top: 1em; margin-bottom: 2em;\">\n											<div flex style=\"position:relative;\" ng-if=\"!vm.isClientUser\">\n											    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.client.demo\">\n											        <label flex=\"nogrow\" class=\"md-subhead\" style=\" padding-right: 1em;\">Workspace Color:</label>\n											        <div flex style=\"position: relative; top: 3px;\" class=\"toggleSwatch\" ng-click=\"vm.togglePicker()\" flex=\"nogrow\" aria-label=\"Assign Client a Color\" md-no-ink=\"true\" >\n											            <div class=\"swatch\" style=\"background-color: {{vm.client.profile.clientColor || \'#999\'}};\" >\n											                <md-tooltip md-delay=\"1000\">\n											                    Select a color\n											                </md-tooltip>\n											            </div>\n											            <!-- <md-icon style=\"position: relative; top: -11px;\" flex=\"none\" md-font-icon=\"zmdi zmdi-caret-down\" ></md-icon> -->\n											        </div class=\"toggleSwatch\">\n											    </div>\n											    <div class=\"color-picker\" ng-if=\"vm.colorPicker && vm.canEdit && !vm.client.demo\">\n											        <lk-color-chooser   ng-change=\"vm.togglePicker()\" colors=\"vm.clientColors\" selected-color=\"vm.client.profile.clientColor\" ng-model=\"vm.client.profile.clientColor\" ng-click=\"vm.colorChange(vm.clientDialogForm);\"></lk-color-chooser>\n											    </div>\n											</div>\n										</div>\n									</md-card>\n								</div>\n							</div>\n							<!-- Name, Email and Inbox -->\n							<md-card class=\"workspace-basic-info md-padding\" style=\"width: 500px; margin-left: auto; margin-right: auto;\">\n								<div ng-if=\"vm.client.status != \'personal\'\" layout=\"row\" layout-align=\"center start\" style=\"margin-top: 1em;\">\n									<div flex=\"100\" layout=\"column\" style=\"max-width: 500px;\">\n										<div layout=\"column\" layout-gt-sm=\"row\">\n											<md-input-container style=\"margin-top: 0;\" md-no-float flex>\n												<label>First name</label>\n											    <input ng-if=\"vm.client.status == \'active\'\" name=\"clientfirstname\" ng-model=\"vm.client.profile.firstname\" ng-model-options=\"vm.inputOptions\"  placeholder=\"First Name\" required>\n											</md-input-container>\n											<md-input-container style=\"margin-top: 0;\" md-no-float flex>\n												<label>Last name</label>\n											    <input ng-if=\"vm.client.status == \'active\'\"  name=\"clientlastname\" ng-model=\"vm.client.profile.lastname\" ng-model-options=\"vm.inputOptions\" placeholder=\"Last Name\" required>\n											</md-input-container>\n										</div>\n										<div layout=\"column\" >\n											<md-input-container flex=\"100\" flex-gt-sm=\"50\">\n											    <input ng-disabled=\"vm.isClientUser\" ng-if=\"vm.client.status == \'active\'\" placeholder=\"Primary Email\" name=\"clientemail\" ng-model=\"vm.client.profile.email\" type=\"email\" ng-model-options=\"vm.inputOptions\">\n											</md-input-container>\n\n										</div>\n									</div>\n								</div>\n								<div ng-if=\"vm.client.status == \'personal\'\" layout=\"row\" layout-align=\"center start\" style=\"margin-top: 1em;\">\n									<div flex=\"100\" layout=\"column\" style=\"max-width: 500px; padding: 1em;\">\n										<div layout=\"column\"  layout-align=\"center center\">\n											<md-input-container flex style=\"width: 500px;\">\n											    <label>Workspace Name</label>\n											    <input name=\"clientcompany\" ng-model=\"vm.client.profile.company\" ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n										</div>\n									</div>\n								</div>\n								<div ng-if=\"vm.client.status != \'personal\'\" layout=\"row\" layout-align=\"center start\">\n									<div flex=\"100\" layout=\"column\" style=\"max-width: 500px;\">\n										<div layout=\"row\" layout-align=\"center center\">\n										    <md-input-container flex>\n										        <label>Company</label>\n										        <input name=\"clientcompany\" ng-model=\"vm.client.profile.company\" ng-model-options=\"vm.inputOptions\" >\n										    </md-input-container>\n										    <md-input-container ng-if=\"!vm.isClientUser\" flex style=\"margin-left: 2em; margin-top: 0;\" layout=\"row\" layout-align=\"start center\">\n										        <md-checkbox class=\"md-secondary\" ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" ng-model=\"vm.client.profile.isCompany\" aria-label=\"Show as company\" style=\"font-size: 13px;\">\n										            Treat as company\n										        </md-checkbox>\n										    </md-input-container>\n										</div>\n										<div layout=\"column\">\n											<md-input-container flex=\"nogrow\">\n											    <md-datepicker ng-disabled=\"vm.isClientUser\" ng-model=\"vm.client.profile.startDate\" placeholder=\"Client Since\" name=\"startDate\"></md-datepicker>\n											</md-input-container>\n										</div>\n									</div>\n								</div>\n\n							</md-card><!-- workspace-basic-info -->\n\n							<!-- Key info -->\n\n						</div>\n					</md-tab-body>\n				</md-tab>\n				<!-- CONTACT DETAILS -->\n				<md-tab ng-if=\"vm.client.status != \'personal\'\" md-on-select=\"vm.onTabChanges(1)\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-format-list-bulleted\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Details</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding small-scrollbar\" layout=\"column\" style=\"max-height: 40vw; padding-top: 2em;\">\n							<!-- phone and address -->\n							<div layout=\"row\" layout-align=\"center start\">\n								<div flex=\"100\" layout=\"column\" style=\"max-width: 800px;\">\n									<md-card class=\"md-padding md-whiteframe-z2\">\n										<div layout=\"row\" layout-align=\"start center\">\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showPersonalInfo\" ng-click=\"vm.showPersonalInfo = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showPersonalInfo\" ng-click=\"vm.showPersonalInfo = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n											<h3 flex>Personal Contact Info</h3>\n										</div>\n										<div ng-if=\"vm.showPersonalInfo\" style=\"padding-top: 1em;\">\n											<md-input-container>\n											    <input placeholder=\"Primary Phone\" name=\"clientphone\" ng-model=\"vm.client.profile.phone\" ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<md-input-container>\n											    <input placeholder=\"Street Address\" name=\"clientaddress\" ng-model=\"vm.client.profile.address.street\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<div layout=\"column\" layout-gt-sm=\"row\">\n												<md-input-container style=\"\"  flex=\"100\">\n												    <input placeholder=\"City or Town\" type=\"text\" name=\"clientcity\" ng-model=\"vm.client.profile.address.city\" ng-model-options=\"vm.inputOptions\" >\n												</md-input-container>\n\n												<md-input-container style=\"\"  flex=\"30\">\n\n												    <input placeholder=\"State/Province/Region\" type=\"text\" name=\"clientstate\" ng-model=\"vm.client.profile.address.state\" ng-model-options=\"vm.inputOptions\" >\n												</md-input-container>\n												<md-input-container style=\"\"  flex=\"20\">\n\n												    <input placeholder=\"ZIP/Postal Code\" type=\"text\" name=\"clientzip\" ng-model=\"vm.client.profile.address.zip\" ng-model-options=\"vm.inputOptions\" >\n												</md-input-container>\n											</div>\n											<div layout=\"column\" layout-gt-sm=\"row\">\n												<md-input-container style=\"\"  flex>\n												    <label>Country</label>\n												    <md-select ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" placeholder=\"Country\" ng-model=\"vm.client.profile.address.country\">\n												        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n												    </md-select>\n												</md-input-container>\n												<md-input-container style=\"\"  flex>\n												    <label>Timezone</label>\n												    <md-select ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" placeholder=\"Client timezone\" ng-model=\"vm.client.profile.timezone\">\n												        <md-optgroup label=\"US & Canada\">\n												            <md-option value=\"America/Newfoundland - CNT\">America/Newfoundland - CNT</md-option>\n												            <md-option value=\"America/New York - EST\">America/New York - EST</md-option>\n												            <md-option value=\"America/Chicago - CST\">America/Chicago - CST</md-option>\n												            <md-option value=\"America/Indiana Eastern Standard - IET\">America/Indiana Eastern Standard - IET</md-option>\n												            <md-option value=\"America/Denver - MST\">America/Denver - MST</md-option>\n												            <md-option value=\"America/Phoenix - PNT\">America/Phoenix - PNT</md-option>\n												            <md-option value=\"America/Los Angeles-PST\">America/Los Angeles-PST</md-option>\n												            <md-option value=\"America/Juneau - AST\">America/Juneau - AST</md-option>\n												            <md-option value=\"America/Honolulu - HST\">America/Honolulu - HST</md-option>\n												            <md-option value=\"Puerto Rico and US Virgin Islands - PRT\">Puerto Rico and US Virgin Islands - PRT</md-option>\n												        </md-optgroup>\n												        <md-optgroup label=\"Europe\">\n												            <md-option value=\"Europe/London - WET\">Europe/London - WET</md-option>\n												            <md-option value=\"Europe/Paris - CET\">Europe/Paris - CET</md-option>\n												            <md-option value=\"Europe/Athens - EET\">Europe/Athens - EET</md-option>\n												            <md-option value=\"Europe/Moscow - FET\">Europe/Moscow - FET</md-option>\n												        </md-optgroup>\n												        <md-optgroup label=\"Global\">\n												            <md-option value=\"(Arabic) Egypt Standard   - ART\">(Arabic) Egypt Standard - ART</md-option>\n												            <md-option value=\"Eastern African   - EAT\">Eastern African - EAT</md-option>\n												            <md-option value=\"Middle East   - MET\">Middle East - MET</md-option>\n												            <md-option value=\"Near East - NET\">Near East - NET</md-option>\n												            <md-option value=\"Pakistan Lahore   - PLT\">Pakistan Lahore - PLT</md-option>\n												            <md-option value=\"India Standard Time - IST\">India Standard Time - IST</md-option>\n												            <md-option value=\"Bangladesh Standard   - BST\">Bangladesh Standard - BST</md-option>\n												            <md-option value=\"Vietnam Standard  - VST\">Vietnam Standard - VST</md-option>\n												            <md-option value=\"China Taiwan  - CTT\">China Taiwan - CTT</md-option>\n												            <md-option value=\"Japan Standard Time - JST\">Japan Standard Time - JST</md-option>\n												            <md-option value=\"Australia Western - AWT\">Australia Western - AWT</md-option>\n												            <md-option value=\"Australia Central - ACT\">Australia Central - ACT</md-option>\n												            <md-option value=\"Australia Eastern - AET\">Australia Eastern - AET</md-option>\n												            <md-option value=\"Solomon Standard  - SST\">Solomon Standard - SST</md-option>\n												            <md-option value=\"New Zealand Standard  - NST\">New Zealand Standard - NST</md-option>\n												            <md-option value=\"Midway Islands - MIT\">Midway Islands - MIT</md-option>\n												            <md-option value=\"Argentina Standard - AGT\">Argentina Standard - AGT</md-option>\n												            <md-option value=\"Brazil Eastern - BET\">Brazil Eastern - BET</md-option>\n												            <md-option value=\"Central African    - CAT\">Central African - CAT</md-option>\n												        </md-optgroup>\n												    </md-select>\n												</md-input-container>\n											</div>\n											<div layout=\"column\" layout-gt-sm=\"row\">\n												<md-input-container style=\"\" flex=\"nogrow\">\n												    <label>Birthmonth</label>\n												    <md-select ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" ng-model=\"vm.client.profile.birthday.month\" placeholder=\"Birthmonth\">\n												        <md-option value=\"1\">January</md-option>\n												        <md-option value=\"2\">February</md-option>\n												        <md-option value=\"3\">March</md-option>\n												        <md-option value=\"4\">April</md-option>\n												        <md-option value=\"5\">May</md-option>\n												        <md-option value=\"6\">June</md-option>\n												        <md-option value=\"7\">July</md-option>\n												        <md-option value=\"8\">August</md-option>\n												        <md-option value=\"9\">September</md-option>\n												        <md-option value=\"10\">October</md-option>\n												        <md-option value=\"11\">November</md-option>\n												        <md-option value=\"12\">December</md-option>\n												    </md-select>\n												</md-input-container>\n												<md-input-container style=\"\" flex=\"nogrow\">\n												    <label>Birth day</label>\n												    <md-select ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" ng-model=\"vm.client.profile.birthday.day\" placeholder=\"Birthday\">\n												        <md-option ng-repeat=\"day in vm.days track by $index\" value=\"{{day}}\">{{day}}</md-option>\n												    </md-select>\n												    <!-- <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.client.profile.dob\" md-placeholder=\"__/__\" md-current-view=\"year\"></md-datepicker> -->\n												</md-input-container>\n												<md-input-container style=\"\" flex=\"nogrow\">\n												    <label>Birth Year</label>\n												    <md-select ng-disabled=\"!vm.canEdit || !vm.isAdmin || vm.client.demo\" ng-model=\"vm.client.profile.birthday.year\" placeholder=\"\">\n												        <md-option value=\"\">N/A</md-option>\n												        <md-option ng-repeat=\"year in vm.years | toArray: false track by $index\" value=\"{{year}}\">{{year}}</md-option>\n												    </md-select>\n												    <!-- <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.client.profile.dob\" md-placeholder=\"__/__\" md-current-view=\"year\"></md-datepicker> -->\n												</md-input-container>\n											</div>\n										</div><!-- if vm.showPersonalInfo -->\n									</md-card>\n									<md-card class=\"md-padding md-whiteframe-z2\">\n										<div layout=\"row\" layout-align=\"start center\">\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showBusinessInfo\" ng-click=\"vm.showBusinessInfo = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showBusinessInfo\" ng-click=\"vm.showBusinessInfo = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n											<h3 flex>Business Info</h3>\n										</div>\n										<div ng-if=\"vm.showBusinessInfo\" style=\"padding-top: 1em;\">\n											 <md-input-container>\n											     <label>Company</label>\n											     <input name=\"clientcompany\" ng-model=\"vm.client.profile.company\" ng-model-options=\"vm.inputOptions\" >\n											 </md-input-container>\n											 <md-input-container>\n											     <label>Position</label>\n											     <input name=\"clientposition\" ng-model=\"vm.client.profile.position\" ng-model-options=\"vm.inputOptions\" >\n											 </md-input-container>\n											 <!-- work email and phone -->\n											 <div layout=\"column\" layout-gt-xs=\"row\">\n											     <md-input-container flex>\n											         <label>Work Email</label>\n											         <input name=\"clientcompanyemail\" ng-model=\"vm.client.profile.companyemail\" ng-model-options=\"vm.inputOptions\" >\n											     </md-input-container>\n											     <md-input-container flex>\n											         <label>Work Phone #</label>\n											         <input name=\"clientcompanyphone\" ng-model=\"vm.client.profile.companyphone\" ng-model-options=\"vm.inputOptions\" >\n											     </md-input-container>\n											 </div>\n											 <!-- fax and website -->\n											 <div layout=\"column\" layout-gt-xs=\"row\">\n											     <md-input-container flex>\n											         <label>Work Fax</label>\n											         <input name=\"clientcompanyfax\" ng-model=\"vm.client.profile.companyfax\" ng-model-options=\"vm.inputOptions\" >\n											     </md-input-container>\n											     <md-input-container flex>\n											         <label>Company Website</label>\n											         <input name=\"clientcompanyurl\" ng-model=\"vm.client.profile.companyurl\" ng-model-options=\"vm.inputOptions\" >\n											     </md-input-container>\n\n											 </div>\n											<md-input-container>\n											    <label>Street Address</label>\n											    <input name=\"clientaddress\" ng-model=\"vm.client.profile.companyAddress.street\" type=\"text\" ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											 <md-input-container>\n											     <label>City or Town</label>\n											     <input type=\"text\" name=\"clientcity\" ng-model=\"vm.client.profile.companyAddress.city\" ng-model-options=\"vm.inputOptions\" >\n											 </md-input-container>\n											 <!-- state/country/zip -->\n											 <div layout=\"column\" layout-gt-sm=\"row\">\n											 	<md-input-container flex>\n											 	    <label>State/Province/Region</label>\n											 	    <input type=\"text\" name=\"clientstate\" ng-model=\"vm.client.profile.companyAddress.state\" ng-model-options=\"vm.inputOptions\" >\n											 	</md-input-container>\n											 	<md-input-container flex>\n											 	    <label>ZIP/Postal Code</label>\n											 	    <input type=\"text\" name=\"clientzip\" ng-model=\"vm.client.profile.companyAddress.zip\" ng-model-options=\"vm.inputOptions\" >\n											 	</md-input-container>\n											 </div>\n											 <md-input-container>\n											     <label>Country</label>\n											     <md-select ng-disabled=\"!vm.canEdit|| !vm.isAdmin || vm.client.demo\" placeholder=\"Country\" ng-model=\"vm.client.profile.companyAddress.country\">\n											         <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n											     </md-select>\n											 </md-input-container>\n										</div><!-- if showBusinessInfo -->\n									</md-card>\n									<md-card class=\"md-padding md-whiteframe-z2\">\n										<div layout=\"row\" layout-align=\"start center\">\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showSocialInfo\" ng-click=\"vm.showSocialInfo = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n											<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showSocialInfo\" ng-click=\"vm.showSocialInfo = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n											<h3 flex>Social Media Accounts</h3>\n										</div>\n										<div ng-if=\"vm.showSocialInfo\">\n											<md-input-container>\n											    <label>Twitter</label>\n											    <input name=\"clienttwitter\" ng-model=\"vm.client.profile.twitter\" type=\"text\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<md-input-container>\n											    <label>Facebook</label>\n											    <input name=\"clientfacebook\" ng-model=\"vm.client.profile.facebook\" type=\"text\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<md-input-container>\n											    <label>LinkedIn</label>\n											    <input name=\"clientlinkedin\" ng-model=\"vm.client.profile.linkedin\" type=\"text\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<md-input-container>\n											    <label>Pinterest</label>\n											    <input name=\"clientpinterest\" ng-model=\"vm.client.profile.pinterest\" type=\"text\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n											<md-input-container>\n											    <label>Instagram</label>\n											    <input name=\"clientinstagram\" ng-model=\"vm.client.profile.instagram\" type=\"text\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model-options=\"vm.inputOptions\" >\n											</md-input-container>\n										</div><!-- if showSocialInfo -->\n									</md-card>\n								</div>\n							</div>\n						</div>\n					</md-tab-body>\n				</md-tab>\n				<!-- Mail to Adminja -->\n				<md-tab md-on-select=\"vm.onTabChanges(2)\" ng-if=\"(vm.isOwner || vm.isAdmin) && vm.client.uid\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-email\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Mail-to-Adminja</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding\" style=\"padding-top: 2em;\">\n							<p class=\"md-subhead center\" style=\"max-width: 500px; margin:1em auto 1em auto;\">\n								Configure a custom address for this workspace to start sending tasks and notes via email:\n							</p>\n							<md-card style=\"padding: 2em; width: 500px; margin-left: auto; margin-right: auto;\">\n							<div layout=\"row\" layout-align=\"center start\" ng-if=\"!vm.isClientUser\">\n								<div flex=\"100\" layout=\"column\" style=\"max-width: 800px;\">\n									<div layout=\"column\" layout-align=\"start center\" ng-if=\"vm.client.uid && vm.client.profile.workspaceAddress\" >\n									    <md-input-container  flex style=\"width: 400px;\">\n									        <label style=\"\">Mail-to-Adminja Address</label>\n									        <input name=\"workspaceaddress\" style=\"color: #000;\" ng-value=\"vm.workspaceAddressDisplay(vm.client.profile.workspaceAddress)\" placeholder=\"Not Set\" ng-disabled=\"true\">\n									    </md-input-container>\n									    <div flex style=\"\">\n									        <md-button class=\"md-raised md-primary\"  ng-disabled=\"!vm.isAdmin && !vm.isOwner\" ng-click=\"vm.manageAddress(vm.client)\">Change Address</md-button>\n									        <md-button href=\"https://help.getadminja.com/help/workspace-inboxes\" target=\"_blank\">Mail-to-Adminja Instructions <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon></md-button>\n									    </div>\n									</div>\n									<div ng-if=\"vm.client.uid && !vm.client.profile.workspaceAddress\" layout=\"row\" layout-align=\"center center\" style=\"padding-top: 1em;\">\n									    <md-button class=\"md-raised md-primary\"  ng-disabled=\"!vm.isAdmin && !vm.isOwner\" ng-click=\"vm.manageAddress(vm.client)\">Setup Mail-to-Adminja</md-button>\n									    <md-button href=\"https://help.getadminja.com/help/workspace-inboxes\" target=\"_blank\">What is this? <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon></md-button>\n									</div>\n								</div>\n							</div>\n							<div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.isClientUser\">\n								<label style=\"margin-right: 1em;\">Mail-to-Adminja Address: </label>\n								<a href=\"mailto: {{vm.workspaceAddressDisplay(vm.client.profile.workspaceAddress)}}\" target=\"_blank\">{{vm.workspaceAddressDisplay(vm.client.profile.workspaceAddress)}}</a>\n								<div flex=\"nogrow\" style=\"margin-left: 2em;\">\n									 <md-button href=\"https://help.getadminja.com/help/workspace-inboxes\" target=\"_blank\">What\'s this? <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon></md-button>\n								</div>\n							</div>\n							</md-card>\n						</div>\n					</md-tab-body>\n				</md-tab>\n				<!-- PACKAGE-BASED BILLING -->\n				<md-tab md-on-select=\"vm.onTabChanges(3)\" ng-if=\"vm.client.status != \'personal\' && (vm.isOwner || vm.isAdmin) && !vm.isClientUser && vm.client.billingType == \'packages\'\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Invoicing</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding\" layout=\"row\" layout-align=\"center start\">\n							<div flex=\"100\" style=\"max-width:800px;\" layout=\"column\" layout-align=\"start layout-fill\">\n								<md-card class=\"padding-20 md-padding md-whiteframe-z2\">\n									<div layout=\"row\" layout-align=\"start center\">\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showInvoiceSettings\" ng-click=\"vm.showInvoiceSettings = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showInvoiceSettings\" ng-click=\"vm.showInvoiceSettings = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n										<h3 flex>Invoice Settings</h3>\n									</div>\n									<div ng-if=\"vm.showInvoiceSettings\">\n\n										<p class=\'md-subhead small\'>Override your account branding by uploading a new logo.</p>\n										<p class=\"center\">\n										<img\n										style=\"cursor: pointer;\"\n										ngf-select=\"vm.uploadLogo($files)\"\n										ngf-multiple=\"false\"\n										aria-label=\"upload logo\"\n										ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n										ng-hide=\"vm.client.profile.settings.logo\" src=\"https://fpoimg.com/250x100?text=Your%20Logo\"   width=\"250\" />\n\n										<img\n										style=\"cursor: pointer;\"\n										ngf-select=\"vm.uploadLogo($files)\"\n										ngf-multiple=\"false\"\n										aria-label=\"upload logo\"\n										ngf-resize=\"{width: 250, height: 100, centerCrop: false}\"\n										ng-show=\"vm.client.profile.settings.logo\" src=\"{{vm.client.profile.settings.logo}}\"  width=\"250\"/>\n										</p>\n										<p class=\"md-subhead center\" style=\"font-size: 11px; margin-bottom: 3em;\">(250 X 100 max) <a ng-if=\"vm.user.profile.logo\" style=\"cursor: pointer;\" ng-click=\"vm.removeLogo()\">Remove</a></p>\n										<md-divider></md-divider>\n										<p class=\'md-subhead small\'>Set your default Invoice breakdown details.</p>\n										<div layout=\"row\" layout-align=\"center center\">\n											  <md-input-container style=\"width: 200px; max-width:200px; margin-bottom:0;\" class=\"margin-right-40\" flex=\"nogrow\">\n											    <label>Group time by:</label>\n											    <md-select flex=\"nogrow\" ng-model=\"vm.client.profile.settings.invoiceGrouping\" ng-change=\"vm.groupingChanged(vm.client.profile.settings.invoiceGrouping)\">\n											      <md-option ng-repeat=\"option in vm.groupingOptions track by $index\" ng-value=\"option.value\">\n											        {{option.label}}\n											      </md-option>\n											    </md-select>\n											</md-input-container>\n											<md-input-container flex=\"nogrow\" style=\"width: 100px; max-width: 100px; margin-bottom:0;\">\n											  <label style=\"font-size: 12px; padding-bottom: 10px; color: rgba(0,0,0,0.54);\">Show time details</label>\n											  <md-switch ng-disabled=\"vm.client.profile.settings.invoiceGrouping == \'none\'\" class=\"md-secondary\" ng-model=\"vm.client.profile.settings.showTimeDetail\"></md-switch>\n											</md-input-container>\n										</div>\n									</div>\n								</md-card>\n\n\n\n								<md-card class=\"padding-20 md-padding md-whiteframe-z2\">\n									<div layout=\"row\" layout-align=\"start center\">\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showAutoInvoicing\" ng-click=\"vm.showAutoInvoicing = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showAutoInvoicing\" ng-click=\"vm.showAutoInvoicing = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n										<h3 flex>Automatic Invoicing</h3>\n									</div>\n									<div ng-if=\"vm.showAutoInvoicing\">\n										<p ng-if=\"vm.client.uid\" class=\"md-subhead small\">Automatically create invoices containing all unbilled hours and charges on a recurring schedule.</p>\n										<div ng-if=\"!vm.client.uid\">\n											<p class=\"md-subhead center\">You can schedule automatic invoicing after you\'ve saved this Client Workspace.</p>\n										</div>\n										 <div  ng-if=\"vm.client.uid\" layout=\"row\" layout-align=\"layout-fill center\">\n										 	<div flex=\"70\" layout=\"column\" layout-align=\"start layout-fill\">\n										 		<md-input-container class=\"margin-top-0\">\n										 			<md-checkbox  ng-change=\"vm.setupInvoicing(vm.client)\" ng-model=\"vm.client.profile.settings.autoInvoice\" aria-label=\"AutoInvoice\"> Enable Auto-Invoicing</md-checkbox>\n										 		</md-input-container>\n										 		<div ng-if=\"vm.client.profile.settings.autoInvoice\" layout=\"row\" layout-align=\"layout-fill start\">\n											 		  <md-input-container class=\"margin-bottom-0\">\n											 		  	<label>Schedule</label>\n											 		    <md-select ng-change=\"vm.changeInterval(vm.client.profile.settings)\" ng-model=\"vm.client.profile.settings.invoiceInterval\" flex=\"nogrow\" >\n											 		        <md-option  value=\'month\'>\n											 		           Monthly\n											 		        </md-option>\n											 		        <md-option  value=\'week\'>\n											 		           Weekly\n											 		        </md-option>\n											 		    </md-select>\n											 		</md-input-container>\n											 		<div flex=\"nogrow\" style=\"padding: 23px 20px 0 20px;\">\n											 			every\n											 		</div>\n											 		  <md-input-container class=\"margin-bottom-0\">\n											 		    <md-select ng-change=\"vm.calcRenewal(vm.client.profile.settings)\" ng-model=\"vm.client.profile.settings.invoiceFrequency\" flex=\"nogrow\" >\n											 		        <md-option value=\'1\'>\n											 		           1\n											 		        </md-option>\n											 		        <md-option value=\'2\'>\n											 		           2\n											 		        </md-option>\n											 		        <md-option value=\'3\'>\n											 		           3\n											 		        </md-option>\n											 		        <md-option value=\'4\'>\n											 		           4\n											 		        </md-option>\n											 		        <md-option value=\'5\'>\n											 		           5\n											 		        </md-option>\n											 		        <md-option value=\'6\'>\n											 		           6\n											 		        </md-option>\n											 		        <md-option value=\'7\'>\n											 		           7\n											 		        </md-option>\n											 		        <md-option value=\'8\'>\n											 		           8\n											 		        </md-option>\n											 		        <md-option value=\'9\'>\n											 		           9\n											 		        </md-option>\n											 		        <md-option value=\'10\'>\n											 		           10\n											 		        </md-option>\n											 		        <md-option value=\'11\'>\n											 		           11\n											 		        </md-option>\n											 		        <md-option value=\'12\'>\n											 		           12\n											 		        </md-option>\n											 		    </md-select>\n											 		</md-input-container>\n											 		<div flex=\"nogrow\" style=\"padding: 23px 20px 0 20px;\">\n											 			{{vm.client.profile.settings.invoiceInterval}}(s) on <span ng-if=\"vm.client.profile.settings.invoiceInterval == \'month\'\">the</span>\n											 		</div>\n											 		  <md-input-container class=\"margin-bottom-0\">\n											 		    <md-select ng-change=\"vm.calcRenewal(vm.client.profile.settings)\" ng-model=\"vm.client.profile.settings.invoiceDay\" flex=\"nogrow\" >\n											 		        <md-option ng-selected=\"day.value == vm.client.profile.settings.invoiceDay\" ng-repeat=\"day in vm.dayOptions | orderBy: [\'id\'] track by id+$index\" ng-value=\"day.value\">\n											 		           {{day.label}}\n											 		        </md-option>\n											 		    </md-select>\n											 		</md-input-container>\n										 		</div>\n										 		<div ng-if=\"vm.client.profile.settings.autoInvoice\" layout=\"column\">\n											 		<md-input-container class=\"\">\n											 			<md-checkbox  ng-model=\"vm.client.profile.settings.autoSendInvoice\" aria-label=\"AutoSendInvoice\"> Send when created</md-checkbox>\n											 		</md-input-container>\n											 		<div ng-if=\"vm.client.profile.settings.autoSendInvoice\">\n												 		<md-input-container class=\"\" style=\"width: 100%;\">\n												 			<label>Invoice Recipients (Separate multiple addresses with a comma.) </label>\n												 		    <input placeholder=\"Recipients\" name=\"invoiceRecipients\" ng-init=\"vm.populateRecipients()\" ng-model=\"vm.client.profile.settings.invoiceRecipients\" required>\n												 		</md-input-container>\n												 	</div>\n										 		</div>\n										 	</div>\n										 	<div flex=\"30\" layout=\"column\" layout-align=\"center center\">\n										 		<div class=\"renewal-preview\" ng-if=\"vm.client.profile.settings.autoInvoice\">\n										 			<h4 class=\"bold center margin-top-0\">Invoice Schedule</h4>\n										 			<ul>\n										 				<li layout=\"column\" layout-align=\"start layout-fill\" ng-repeat=\"occurrence in vm.invoicePreview | toArray: false | limitTo: 6 | orderBy: [\'id\'] track by id + $index\">\n										 					<div flex>{{occurrence.date | amDateFormat: vm.settings.shortDayOfWeekFormat}}</div>\n										 				</li>\n										 				<li>...</li>\n										 			</ul>\n\n										 		</div>\n										 	</div>\n\n										 </div><!-- renewal interval editor-->\n										 <div ng-if=\"vm.client.profile.settings.autoInvoice\">\n										 	<p class=\"md-subhead center small\" ng-if=\"vm.client.profile.settings.autoSendInvoice\">\n										 		Invoices will be sent immediately to the client.\n										 	</p>\n										 	<p class=\"md-subhead center small\" ng-if=\"!vm.client.profile.settings.autoSendInvoice\">\n										 		You will be notified when the invoice is ready for you to review and send.\n										 	</p>\n										 </div>\n										 <div ng-if=\"vm.client.schedules && vm.userType == \'admin\'\">\n										 	<p ng-repeat=\"schedule in vm.client.schedules |toArray: false track by $index+uid\" ng-if=\"schedule.type == \'auto-invoice\' || schedule.type == \'auto-send-invoice\'\">\n										 		<a ng-href=\"{{vm.fbConfig.dataURL}}schedules/{{schedule.uid}}\" target=\"_blank\">{{schedule.when | amDateFormat: \"MM/DD/YYYY\"}}</a>\n										 	</p>\n										 	<!-- <p>Interval: {{vm.client.profile.settings.invoiceInterval}} | Frequency: {{vm.client.profile.settings.invoiceFrequency}} | Day: {{vm.client.profile.settings.invoiceDay}}</p>\n										 	<md-button ng-click=\"vm.getNextOccurence(vm.invoicePreview[1].date)\">Calculate Renewal from {{vm.invoicePreview[1].date | amDateFormat: \'MM/DD/YYYY\'}}</md-button>\n										 	<p>Next Occurence: {{vm.nextOccurence | amDateFormat: \'MM/DD/YYYY\'}}</p> -->\n										 </div>\n\n									</div>\n								</md-card>\n\n\n\n								<md-card class=\"padding-20 md-padding md-whiteframe-z2\">\n									<div layout=\"row\" layout-align=\"start center\">\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"!vm.showBillingIntegrations\" ng-click=\"vm.showBillingIntegrations = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon></md-button>\n										<md-button class=\"md-button-small\" flex=\"nogrow\" ng-if=\"vm.showBillingIntegrations\" ng-click=\"vm.showBillingIntegrations = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon></md-button>\n										<h3 flex>Default Payment Handler</h3>\n									</div>\n									<div ng-if=\"vm.showBillingIntegrations\">\n										<div ng-if=\"!vm.client.uid\">\n											<p class=\"md-subhead center\">You can configure the default payment processor after you\'ve saved this Client.</p>\n										</div>\n										<div ng-if=\"vm.client.uid\" class=\"margin-bottom-60\">\n											  <p class=\"md-subhead center margin-top-0\">Include a \"Pay Now\" link on your invoices.</p>\n											  <md-input-container ng-if=\"vm.user.profile.settings.paypalEnabled || vm.user.profile.settings.stripeEnabled\" style=\"margin-left: auto; margin-right: auto; width: 200px; max-width:200px; margin-bottom:0; margin-top: 40px;\" class=\"\" flex=\"nogrow\">\n											    <label>Default Payment Handler:</label>\n											    <md-select flex=\"nogrow\" ng-model=\"vm.selectedPaymentProcessor\" ng-change=\"vm.changePaymentProcessor(vm.selectedPaymentProcessor)\">\n											      <md-option ng-selected=\"option.value == vm.selectedPaymentProcessor\" ng-repeat=\"option in vm.paymentProcessors track by $index\" ng-value=\"option.value\">\n											        <md-icon ng-if=\"option.value == \'stripe\'\" md-svg-src=\"/assets/images/icons/stripe.svg\" style=\"margin-right: .5em;  -webkit-filter: grayscale(1); filter: grayscale(1); opacity: .7;\"></md-icon>\n											        <md-icon ng-if=\"option.value == \'paypal\'\" md-font-icon=\"zmdi zmdi-paypal\" style=\"font-size: 1.6em\"></md-icon>\n											        <md-icon ng-if=\"option.value == \'url\'\" md-font-icon=\"zmdi zmdi-link\" style=\"font-size: 1.6em\"></md-icon>\n											        {{option.label}}\n											      </md-option>\n											    </md-select>\n											</md-input-container>\n											 <p class=\'md-subhead\' ng-if=\"!vm.user.profile.settings.paypalEnabled && !vm.user.profile.settings.stripeEnabled\">Please enable and configure a payment processor in your account invoice settings.</p>\n										</div>\n									</div>\n								</md-card>\n							</div>\n						</div>\n					</md-tab-body>\n				</md-tab>\n				<!-- LEGACY BILLING PLAN -->\n				<md-tab md-on-select=\"vm.onTabChanges(3)\" ng-if=\"vm.client.status != \'personal\' && (vm.isOwner || vm.isAdmin) && !vm.isClientUser && vm.client.billingType != \'packages\'\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-money\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Billing Plan</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding\">\n							<div>\n							    <p ng-if=\"vm.client.uid\" class=\"center md-title\" style=\"margin: 1em 0 0 0;\">Client billing plan</p>\n							    <p ng-if=\"!vm.client.uid\" class=\"center md-title\" style=\"margin: 1em 0 0 0;\">How do you handle billing for this client?</p>\n							</div>\n							<div ng-if=\"vm.showCurrentPeriodInfo && vm.client.profile.plan.type != \'none\'\" style=\"background-color: #efefef; border-radius: 4px; border: 1px solid rgba(100,100,100,.5); margin-top: 1em; width: 80%; max-width: 600px; margin-left: auto; margin-right: auto;\">\n							    <p class=\"md-subhead center\" style=\"color: green;\">\n							  	  	<strong>CURRENT Billing Period:</strong>  {{vm.currentPeriod.start | amDateFormat : vm.settings.amDateFormat}} - <span ng-if=\"vm.currentPeriod.recurrenceType != \'zero\'\">{{vm.currentPeriod.end| amDateFormat : vm.settings.amDateFormat}}</span> <span ng-if=\"vm.currentPeriod.recurrenceType == \'zero\'\"> until balance is 0<!--{{vm.currentPeriod.expirationDate| amDateFormat : vm.settings.amDateFormat}}--></span>\n							    </p>\n							    <div layout=\"row\" layout-align=\"start center\'\">\n							    	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							    		<strong>Type: </strong>\n							    	</div>\n							    	<div flex=\"50\" style=\"\">\n							    		<span style=\"text-transform: capitalize;\">{{vm.currentPeriod.type}}</span>\n							    	</div>\n							    </div>\n							    <div  ng-if=\"vm.currentPeriod.type == \'retainer\'\" layout=\"row\" layout-align=\"start center\'\">\n							    	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							    		<strong>Allotment:</strong>\n							    	</div>\n							    	<div flex=\"50\" style=\"\">\n							    		{{vm.currentPeriod.allocated}}hrs\n							    	</div>\n							    </div>\n							    <div  ng-if=\"vm.currentPeriod.type == \'hourly\'\" layout=\"row\" layout-align=\"start center\'\">\n							    	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							    		<strong>Rate:</strong>\n							    	</div>\n							    	<div flex=\"50\" style=\"\">\n							    		{{vm.settings.currency}}{{vm.currentPeriod.rate}}/hour\n							    	</div>\n							    </div>\n							    <div  ng-if=\"vm.currentPeriod.type == \'retainer\'\" layout=\"row\" layout-align=\"start center\'\">\n							    	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							    		<strong>Cost:</strong>\n							    	</div>\n							    	<div flex=\"50\" style=\"\">\n							    		{{vm.settings.currency}}{{vm.currentPeriod.cost}}\n							    	</div>\n							    </div>\n							    <p class=\"md-subhead center\" style=\"font-size: 12px;\" ng-if=\"vm.client.profile.plan.type == \'hourly\' || (vm.client.profile.plan.type == \'retainer\') \">You can override the CURRENT Billing Period details in this Workspace\'s <a style=\"cursor: pointer;\" ng-click=\"vm.visitBilling(vm.client)\">Billing board</a>.</p>\n							    <md-divider style=\"margin: 1em 0 1em 0;\"></md-divider>\n							    <div ng-if=\"vm.showCurrentPeriodInfo && vm.client.profile.plan.type != \'none\'\" >\n							        <p class=\"md-subhead center\" style=\"color: green;\"><strong>Settings for FUTURE Periods:</strong></p>\n							        <div layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Type: </strong>\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		<span style=\"text-transform: capitalize;\">{{vm.client.profile.plan.type}}</span>\n							        	</div>\n							        </div>\n							        <div ng-if=\"vm.client.profile.plan.type == \'retainer\'\" layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Allotment:</strong>\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		{{vm.client.profile.plan.allocated}}hrs\n							        	</div>\n							        </div>\n							        <div  ng-if=\"vm.client.profile.plan.type == \'hourly\'\"  layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Rate:</strong>\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		{{vm.settings.currency}}{{vm.client.profile.plan.rate}}/hour\n							        	</div>\n							        </div>\n							        <div  ng-if=\"vm.client.profile.plan.type == \'retainer\'\" layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Cost:</strong>\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		{{vm.settings.currency}}{{vm.client.profile.plan.cost}}\n							        	</div>\n							        </div>\n							        <!-- <div  ng-if=\"vm.client.profile.plan.recurrenceType == \'zero\'\" layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Expires:</strong>\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		{{vm.client.profile.plan.expirationDate | amDateFormat: vm.settings.amDateFormat}}\n							        	</div>\n							        </div> -->\n							        <div layout=\"row\" layout-align=\"start center\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Renews: </strong> {{}}\n							        	</div>\n							        	<div flex=\"50\" style=\"\">\n							        		<span ng-if=\"vm.client.profile.plan.recurrenceType == \'zero\'\">\n							        			<!-- when expires or --> when balance is 0.\n							        		</span>\n							        		<span ng-if=\"vm.client.profile.plan.recurrenceType != \'zero\'\">\n							        			Every  {{vm.client.profile.plan.interval}} {{vm.client.profile.plan.recurrenceType}}(s)\n							        			<span ng-if=\"vm.client.profile.plan.recurrenceType == \'month\'\">\n							        			    on the {{vm.client.profile.plan.monthDay | ordinal}}\n							        			</span>\n							        			<span ng-if=\"vm.client.profile.plan.recurrenceType == \'week\'\">\n							        			    on\n							        			    {{vm.client.profile.plan.displayWeekDay}}\n							        			</span>\n							        		</span>\n							        	</div>\n							        </div>\n							        <div layout=\"row\" layout-align=\"start center\'\" ng-if=\"vm.client.profile.plan.recurrenceType != \'zero\'\">\n							        	<div flex=\"50\" class=\"right\" style=\"padding-right: 1em;\">\n							        		<strong>Next renewal:</strong>\n							        	</div>\n							        	<div flex=\"50\">\n							        		<span > {{vm.client.profile.plan.nextCycle | amDateFormat: vm.settings.amDateFormat}}</span>\n\n							        	</div>\n							        </div>\n\n\n							    </div>\n							    <p class=\"center\">\n							    	<md-button class=\"md-raised md-primary\" style=\"padding-left: 2em; padding-right: 2em;\" ng-click=\"vm.showCurrentPeriodInfo = false\">Modify plan for <strong>FUTURE</strong> Billing Periods</md-button>\n							    </p>\n\n							</div>\n							<!-- //////// edit form /////// -->\n							<div ng-if=\"!vm.showCurrentPeriodInfo || vm.client.profile.plan.type == \'none\'\" >\n\n								<div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" class=\"hotspot-client-dialog-one\">\n								    <md-radio-group ng-model=\"vm.client.profile.plan.type\" flex=\"nogrow\" ng-disabled=\"!vm.isAdmin || vm.client.demo\">\n								        <md-radio-button data-gtm-change-billing-type value=\"none\" style=\"margin-right: 1em;\">Don\'t track billing at this time</md-radio-button>\n								        <md-radio-button data-gtm-change-billing-type value=\"retainer\" style=\"margin-right: 1em;\">Against a block of hours</md-radio-button>\n								        <md-radio-button data-gtm-change-billing-type value=\"hourly\">Pay as they go (hourly)</md-radio-button>\n\n								    </md-radio-group>\n								</div>\n\n\n								<!-- retainer plan form -->\n								<div layout=\"column\" ng-if=\"vm.client.profile.plan.type != \'none\'\" style=\"background-color: #efefef; border-radius: 4px; border: 1px solid rgba(100,100,100,.5); margin-top: 1em; width: 80%; max-width: 600px; margin-left: auto; margin-right: auto; \" class=\"md-padding hotspot-client-dialog-two\">\n								    <!-- <p class=\"md-headline center\">Client Billing Plan</p> -->\n								    <div ng-if=\"vm.client.profile.plan.type == \'retainer\'\" style=\"margin-top: 1em;\">\n\n								        <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\" layout-align-gt-xs=\"center space-between\">\n								            <md-input-container flex=\"nogrow\" class=\"\" style=\"margin-right: 1em;\">\n								            	<!-- If this is a date-based plan, or we are changing from an existing plan type to zero, we display Next renewal date -->\n								                <label ng-if=\"vm.nextCycleLabel() == \'next\'\">The NEXT period renews on:</label>\n								                <!-- if zero based plan nextCycle is just a heartbeat check -->\n								                <label ng-if=\"vm.nextCycleLabel() == \'heartbeat\'\">Next internal heartbeat check:</label>\n\n								                <label ng-if=\"vm.nextCycleLabel() == \'new\'\">Billing plan starts on:</label>\n								                  <md-datepicker ng-disabled=\"vm.nextCycleLabel() == \'heartbeat\'\" data-gtm-change-next-renewal required flex style=\"position: relative; top: -8px; width: 100%;\"  md-date-filter=\"vm.cycleDateLimit\" ng-model=\"vm.displayNextCycle\" name=\"nextCycle\" ng-change=\"vm.cycleDateChange(vm.client, vm.displayNextCycle)\"></md-datepicker>\n								                  <div ng-messages=\"vm.displayNextCycle.$error\">\n								                           <div ng-message=\"required\">Please select a date in a valid range.</div>\n								                  </div>\n\n								            </md-input-container>\n\n								            <md-input-container flex class=\"billing-block-cost\">\n								                <label>Block cost</label>\n								                <md-icon><span ng-bind-html=\"vm.currency\"></span></md-icon>\n								                <input name=\"rate\" type=\"number\" step=\"any\" maxlength=\"7\" ng-model=\"vm.client.profile.plan.cost\" ng-change=\"vm.changeBilling()\"  placeholder=\"000.00\">\n								            </md-input-container>\n								            <md-input-container flex class=\"billing-hours-included\">\n								                <label>Hours Included</label>\n								                <input name=\"allocated\" type=\"number\" step=\"any\"  maxlength=\"5\" ng-model=\"vm.client.profile.plan.allocated\" ng-change=\"vm.changeBilling()\" placeholder=\"00\">\n								            </md-input-container>\n\n								        </div>\n\n						                  <div style=\"color: red;\" class=\"center\" ng-if=\"vm.now > vm.client.profile.plan.nextCycle\">You\'ve selected a FUTURE date for this plan\'s next renewal.<br><span style=\"color: #000;\" ng-if=\"!vm.client.uid\">Their billing will remain \"pending\" until this date.</span><span style=\"color:#000;\" ng-if=\"vm.client.uid\">It will not be created until this date.</span></div>\n\n								        <div ng-if=\"!vm.client.profile.plan.nextCycle && vm.client.uid && vm.hasBilling\" >\n								            <p class=\"md-subhead text-center\" >\n								                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: orange;\"></md-icon> <span style=\"color: orange;\">Please specify a start date for this client\'s billing plan.<br></span>\n								            </p>\n								             <p class=\"md-subhead text-center\"><strong>Suggested renewal date<br> based on client history: </strong>{{vm.suggestedRenew(vm.client.profile.plan.retainerStart)}}</p>\n								        </div>\n								        <div layout=\"row\" layout-align=\"center center\">\n								            <div flex=\"nogrow\">\n								                <div ng-if=\"vm.showRetainerWarning && vm.client.profile.plan.nextCycle && vm.client.uid && vm.hasBilling\" layout=\"row\" layout-align=\"start center\">\n								                    <div flex=\"20\" layout=\"column\" layout-align=\"start center\">\n								                        <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: red; font-size: 36px;\"></md-icon>\n								                    </div>\n								                    <div flex=\"grow\">\n								                        <!-- <p style=\"\" class=\"text-center\">Changes made to the client\'s only affect FUTURE billing periods.</p> -->\n								                        <p style=\"color: red; font-size: 13px;\" class=\"md-subhead\">This client\'s next period will renew on {{vm.client.profile.plan.nextCycle | amDateFormat: vm.settings.amDateFormat}}\n								                            <br>If necessary, the <strong>current</strong> period will be adjusted to end on {{vm.newPeriodEndDate| amDateFormat : vm.settings.amDateFormat}} to accommodate this change.</p>\n								                    </div>\n								                </div>\n\n								            </div>\n								        </div>\n\n								    </div>\n								    <div ng-if=\"vm.client.profile.plan.type == \'hourly\'\" style=\"margin-top: 1em;\">\n								        <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\" layout-align-gt-xs=\"center space-between\">\n								            <md-input-container flex=\"nogrow\" class=\"\" style=\"margin-right: 1em;\">\n								                <label ng-if=\"vm.hasBilling\">Their next period renews on:</label>\n								                <label ng-if=\"!vm.hasBilling\">Billing plan starts on:</label>\n								                  <md-datepicker data-gtm-change-next-renewal required ng-disabled=\"vm.client.profile.plan.recurrenceType == \'zero\' && vm.client.uid\"  flex style=\"position: relative; top: -8px; width: 100%;\"  md-date-filter=\"vm.cycleDateLimit\" ng-model=\"vm.displayNextCycle\" name=\"nextCycle\" ng-change=\"vm.cycleDateChange(vm.client, vm.displayNextCycle)\"></md-datepicker>\n								                 <div ng-messages=\"vm.displayNextCycle.$error\">\n								                          <div ng-message=\"required\">Please select a date in a valid range.</div>\n								                 </div>\n								            </md-input-container>\n								            <md-input-container flex=\"nogrow\" class=\"billing-hourly-rate\">\n								                <label>Hourly Rate</label>\n								                <md-icon><span ng-bind-html=\"vm.currency\"></span></md-icon>\n								                <input name=\"hourlyrate\" type=\"number\" step=\"any\" ng-model=\"vm.client.profile.plan.rate\" placeholder=\"00.00\">\n								            </md-input-container>\n\n								        </div>\n								        <div ng-if=\"!vm.client.profile.plan.nextCycle && vm.client.uid\" >\n								            <p class=\"md-subhead text-center\" >\n								                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: orange;\"></md-icon> <span style=\"color: orange;\">Please specify this client\'s current cycle date.<br></span>\n								            </p>\n								            <!-- <p class=\"md-subhead text-center\"><strong>Suggested Cycle Date: </strong><br> based on client history: {{vm.suggestedRenew(vm.client.profile.plan.retainerStart)}}</p> -->\n								        </div>\n								        <div ng-if=\"vm.showRetainerWarning && vm.client.profile.plan.nextCycle && vm.client.uid && vm.hasBilling\" layout=\"row\" layout-align=\"start center\">\n								            <div flex=\"20\" layout=\"column\" layout-align=\"start center\">\n								                <md-icon md-font-icon=\"zmdi zmdi-alert-triangle\" style=\"color: red; font-size: 36px;\"></md-icon>\n								            </div>\n								            <div flex=\"grow\">\n								                <!-- <p style=\"\" class=\"text-center\">Changes made to the client\'s only affect FUTURE billing periods.</p> -->\n								                <p style=\"color: red; font-size: 13px;\" class=\"md-subhead\">This client\'s next period will renew on {{vm.client.profile.plan.nextCycle | amDateFormat: vm.settings.amDateFormat}}\n								                    <br>The <strong>current</strong> period will be adjusted to end on {{vm.newPeriodEndDate| amDateFormat : vm.settings.amDateFormat}} to accommodate this change.</p>\n								            </div>\n\n								        </div>\n								        <!-- <div layout=\"row\" layout-align=\"center center\">\n								            <div flex=\"nogrow\">\n\n								            <div ng-if=\"vm.showRetainerWarning\">\n								                <p style=\"color: orange;\" class=\"text-center\">This client\'s billing cycle will start on the date selected and renew every month thereafter. <br><span ng-if=\"vm.client.uid\">Your current billing period will be lengthened or shortened to accommodate this change.</span></p>\n								            </div>\n								        </div>\n								        </div> -->\n								    </div>\n								    <!-- retainer rrule form -->\n								    <div ng-if=\"vm.client.profile.plan.recurrenceType && vm.client.profile.plan.nextCycle\">\n								        <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\" layout-align-gt-xs=\"center center\">\n								            <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin-right: 1em;\"><strong>Renews:</strong></p>\n								            <md-select  flex=\"nogrow\" ng-model=\"vm.client.profile.plan.recurrenceType\" ng-change=\"vm.checkRecurrenceType(vm.client.profile.plan.recurrenceType)\" ng-disabled=\"!vm.isAdmin || vm.client.demo\">\n								                <md-option value=\"week\">Weekly</md-option>\n								                <md-option value=\"month\">Monthly</md-option>\n								                <md-option value=\"zero\" ng-if=\"vm.client.profile.plan.type == \'retainer\'\">When balance is 0</md-option>\n								            </md-select>\n								            <!-- <div layout=\"row\" ng-if=\"vm.client.profile.plan.recurrenceType == \'zero\'\">\n								            	<md-input-container>\n								            		<label>Expiration date</label>\n								            		<md-datepicker  ng-model=\"vm.client.profile.plan.expirationDate\" md-placeholder=\"Expiration date\"></md-datepicker>\n								            	</md-input-container>\n								            </div> -->\n								            <div layout=\"row\" layout-align=\"start center\" flex=\"nogrow\" ng-show=\"vm.client.profile.plan.recurrenceType == \'week\' || vm.client.profile.plan.recurrenceType == \'month\'\">\n								                <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin-right: 1em;\">every </p>\n								                <md-input-container flex=\"nogrow\" style=\"margin-top:0;\">\n								                    <input data-gtm-change-renewal-frequency ng-model=\"vm.client.profile.plan.interval\" style=\"max-width: 50px;\">\n								                </md-input-container>\n								                <p flex=\"nogrow\" class=\"md-subhead\">{{vm.client.profile.plan.recurrenceType}}(s)</p>\n								            </div>\n								            <div layout=\"row\" flex=\"nogrow\" layout-align=\"start center\" ng-if=\"vm.client.profile.plan.recurrenceType == \'month\'\">\n								                <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin-left: 1em; margin-right: 1em;\">on the </p>\n								                {{vm.client.profile.plan.monthDay|ordinal}}\n								            </div>\n								            <div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.client.profile.plan.recurrenceType == \'week\'\">\n								                <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin-left: 1em; margin-right: 1em;\">on</p>\n								                {{vm.client.profile.plan.displayWeekDay}}\n								            </div>\n								        </div>\n\n								    </div>\n								    <p ng-if=\"vm.client.uid\" class=\"md-subhead center\">\n								    	<a ng-click=\"vm.showCurrentPeriodInfo = true\" style=\"cursor: pointer;\">cancel</a>\n								    </p>\n								</div>\n\n\n							</div><!-- ///////// edit form /////// -->\n							<!-- notification preferences - retainer -->\n							<div ng-if=\"vm.client.profile.plan.type == \'retainer\'\">\n							    <div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 2em;\" >\n							        <md-checkbox style=\"margin-bottom: 0; margin-top:0;\" ng-model=\"vm.client.profile.plan.notifyWhen\" aria-label=\"select\"></md-checkbox>\n							        <span class=\"md-subhead\" style=\"font-size: 12px;\">Notify me when plan reaches </span>\n							            <md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n							                <md-select data-gtm-set-retainer-threshold ng-disabled=\"!vm.client.profile.plan.notifyWhen\" ng-model=\"vm.client.profile.plan.notifyWhenLimit\" ng-value=\"10\" style=\"max-width: 85px;\">\n							                <md-option ng-value=\"10\">10%</md-option>\n							                <md-option ng-value=\"20\">20%</md-option>\n							                <md-option ng-value=\"30\">30%</md-option>\n							                <md-option ng-value=\"40\">40%</md-option>\n							                <md-option ng-value=\"50\">50%</md-option>\n							                <md-option ng-value=\"60\">60%</md-option>\n							                <md-option ng-value=\"70\">70%</md-option>\n							                <md-option ng-value=\"80\">80%</md-option>\n							                <md-option ng-value=\"90\">90%</md-option>\n							            </md-select>\n							        </md-input-container>\n							         <span class=\"md-subhead\" style=\"font-size: 12px;\" > of limit.<sup>*</sup></span>\n							    </div>\n							    <p class=\"md-subhead center\" style=\"font-size: 12px;\"><sup>*</sup> You will always receive a notification when a plan reaches it\'s limit.</p>\n							</div>\n							<!-- notification preferences - hourly -->\n							<div ng-if=\"vm.client.profile.plan.type == \'hourly\'\">\n							    <div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 2em;\" >\n							        <md-checkbox style=\"margin-bottom: 0; margin-top:0;\"  ng-model=\"vm.client.profile.plan.notifyWhen\" aria-label=\"select\"></md-checkbox>\n							        <span class=\"md-subhead\" style=\"font-size: 12px;\">Notify me when the first </span>\n							            <md-input-container style=\"margin-top:0;margin-left: .5em; margin-right: .5em;\">\n							                <input data-gtm-set-hourly-threshold ng-model=\"vm.client.profile.plan.notifyWhenLimit\" style=\"max-width: 25px;\" ng-value=\"0\">\n							            </md-input-container>\n							         <span class=\"md-subhead\" style=\"font-size: 12px;\"> hours are logged each cycle.<sup>*</sup></span>\n							    </div>\n							</div>\n						</div>\n					</md-tab-body>\n				</md-tab>\n\n				<!-- Time Categories -->\n				<md-tab md-on-select=\"vm.onTabChanges(4)\" ng-if=\"(vm.isOwner || vm.isAdmin) && !vm.isClientUser && (vm.client.billingType != \'packages\' || vm.client.status == \'personal\')\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"fa fa-tags\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Time Categories</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding\">\n							<div class=\"default-rate\"  layout=\'row\' layout-align=\"center center\" style=\"margin-top: 1em;\">\n							    <div  layout=\"row\" flex=\"50\" layout-align=\"start center\" ng-if=\"vm.client.status != \'personal\' && vm.client.profile.plan == \'hourly\'\" style=\"max-width: 600px;\">\n							        <!-- <md-button ng-click=\"vm.toggleAdminOnly(category.uid)\" flex=\"nogrow\" class=\"md-button-small drag-handle\">\n							            <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n							        </md-button> -->\n							        <p flex class=\"md-subhead\">Default Rate</p>\n							        <p flex=\"15\" ><span ng-bind-html=\"vm.currency\"></span>{{vm.client.profile.plan.rate}}/hr</p>\n							        <!-- <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\"><md-icon md-font-icon=\"fa fa-reorder\"></md-icon></md-button>\n							        <md-button ng-click=\"vm.removeCategory(vm.client.profile.categories.time, category)\" flex=\"nogrow\" class=\"md-button-small\">\n							            <md-icon md-font-icon=\"fa fa-close\"></md-icon>\n							        </md-button> -->\n							    </div>\n							</div>\n							<p class=\"md-subhead text-center\">Custom Categories</p>\n							<div layout=\"row\" layout-align=\"center start\">\n							    <div flex=\"100\" style=\"max-width: 600px;\">\n							        <!-- add category form -->\n							        <div ng-if=\"vm.showCategoryForm\" style=\"margin-bottom: 2em; padding: 1em; background-color: #efefef; border-radius: 8px;\">\n							        	<p class=\"md-subhead\" style=\"color: #888;\">New Time Category</p>\n							            <ng-form name=\"forms.clientCategoryForm\" novalidate isolate-form >\n							            	<div layout=\"column\">\n								            	<div layout=\"row\" layout-align=\"start center\">\n									                <md-input-container flex style=\"margin-right: 2em;\">\n									                    <label>Category Label</label>\n									                    <input mdInput autofocus required ng-model=\"vm.newCategory.label\">\n									                </md-input-container>\n									                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.client.status != \'personal\' && vm.client.profile.plan.type == \'hourly\'\">\n										                <div flex=\"nogrow\" >\n										                    <span style=\"position: relative; top: -2px;\"><span ng-bind-html=\"vm.currency\"></span></span>\n										                </div>\n										                <md-input-container>\n										                    <label>Rate/hr</label>\n										                    <input required type=\"number\" ng-model=\"vm.newCategory.rate\">\n										                </md-input-container>\n										           </div>\n								              	</div>\n								              	<div layout=\"row\" layout-align=\"layout-fill center\">\n								              		<div flex=\"auto\" layout=\"row\" layout-align=\"start center\">\n								              			<md-input-container flex=\"nogrow\" style=\"margin-top: 0; min-width: 100px;\" layout=\"column\" layout-align=\"start center\">\n								              			    <label style=\"font-size: 10px; display:block; margin-bottom: 22px; text-align:center;\">Admin Only</label>\n								              			    <md-switch class=\"md-accent\" ng-model=\"vm.newCategory.adminOnly\" ng-true-value=\"true\" ng-false-value=\"false\" style=\"margin-top: 0; margin-bottom: 0;\"></md-switch>\n								              			</md-input-container>\n								              		</div>\n									                <div flex=\"nogrow\">\n										                <md-button ng-click=\"vm.toggleCategoryForm(false)\" flex=\"nogrow\">Cancel</md-button>\n										                <md-button ng-disabled=\"forms.clientCategoryForm.$invalid || forms.clientCategoryForm.$pristine\" ng-click=\"vm.addCategory(vm.newCategory)\" flex=\"nogrow\" class=\"md-raised md-accent\">Add</md-button>\n										          </div>\n									           </div>\n									      </div>\n							            </ng-form>\n							        </div>\n							    </div>\n							</div>\n							<div layout=\"column\" layout-align=\"start center\">\n							    <md-button ng-if=\"!vm.showCategoryForm\" class=\"md-accent\" ng-click=\"vm.toggleCategoryForm(true)\">+ New Category</md-button>\n							    <div class=\"client-category-manager\" dragula=\"\'drag-category\'\" dragula-scope=\"$scope\" layout=\"column\" flex=\"100\" style=\"max-width: 600px; width: 100%;\">\n							    	<!-- <div class=\"small-scrollbar\" style=\"max-height: 40vh;\"> -->\n							        <div catid=\"{{category.uid}}\" ng-repeat=\"category in vm.client.profile.categories.time | toArray: false | orderBy: [\'order\'] track by uid+$index\"\n							            class=\"category-item\"\n							             layout=\"row\"\n							             layout-align=\"start center\">\n							            <md-button ng-click=\"vm.toggleAdminOnly(category)\" flex=\"nogrow\" class=\"md-button-small\">\n							                <md-icon ng-if=\"!category.adminOnly\" md-font-icon=\"zmdi zmdi-eye\"><md-tooltip md-delay=\"1000\">Available to all members</md-tooltip></md-icon>\n							                <md-icon ng-if=\"category.adminOnly\" style=\"color: orange;\" md-font-icon=\"zmdi zmdi-eye-off\"><md-tooltip md-delay=\"1000\">Available to Admins only</md-tooltip></md-icon>\n							            </md-button>\n							            <p flex class=\"md-subhead\">{{category.label}}</p>\n							            <p flex=\"15\" ng-if=\"vm.client.status != \'personal\' && vm.client.profile.plan.type == \'hourly\'\"><span ng-bind-html=\"vm.currency\"></span>{{category.rate}}/hr</p>\n							            <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\"><md-icon md-font-icon=\"fa fa-reorder\"></md-icon></md-button>\n							            <md-button ng-click=\"vm.removeCategory(vm.client.profile.categories.time, category)\" flex=\"nogrow\" class=\"md-button-small\">\n							                <md-icon md-font-icon=\"fa fa-close\"></md-icon>\n							            </md-button>\n							        </div>\n							       <!-- </div> -->\n							    </div>\n							</div>\n						</div>\n\n					</md-tab-body>\n				</md-tab>\n\n				<!-- Scheduled Reports -->\n				<md-tab md-on-select=\"vm.onTabChanges(4)\" ng-if=\"!vm.client.demo && vm.client.status != \'personal\' && (vm.isOwner || vm.isAdmin) && !vm.isClientUser && vm.client.uid\" md-on-deselect=\"\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"fa fa-paper-plane-o\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Status Reports</span>\n					</md-tab-label>\n\n					<md-tab-body>\n						<div class=\"md-padding\">\n							<div layout=\"row\" layout-align=\"center start\">\n								<div layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" class=\"md-padding\">\n									<div ng-if=\"!vm.client.uid\" layout=\"row\" layout-align=\"center center\">\n										<p class=\"md-subhead\" style=\"padding-top: 5em; padding-bottom: 10em;\">You can schedule reports after this workspace has been saved.</p>\n									</div><!-- report settings disabled until save -->\n									<div ng-if=\"!vm.client.profile.email && vm.client.uid\">\n										<h3 class=\"center\">You can schedule status reports after providing an email address for this Client.</h3>\n									</div>\n\n									<div ng-if=\"vm.client.uid && vm.client.profile.email\" layout=\"column\" layout-align=\"start stretch\">\n\n										<div  layout=\"row\" layout-align=\"start center\">\n											<div flex style=\"\">\n												<md-input-container >\n													<md-checkbox ng-model=\"vm.client.profile.weeklyStatusReportEnabled\" aria-label=\"Enable weekly status reports\" ng-change=\"vm.updateReportConfig()\">Enable Weekly Status Report</md-checkbox>\n												</md-input-container>\n											</div>\n											<p class=\"md-subhead right\" flex>\n												<md-button ng-click=\"vm.showSample()\"  style=\"font-size: 11px; color: #999;\">See sample</md-button>\n											</p>\n										</div>\n\n										<fieldset >\n											<ng-form name=\"vm.reportForm\" >\n												<md-card class=\"md-padding\" ng-if=\"vm.client.profile.weeklyStatusReportEnabled\">\n												<div layout=\"row\" layout-align=\"start center\" >\n\n													<span class=\"md-subhead\" style=\"\">Send every</span>\n													<md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n														<md-select  ng-required=\"true\" ng-model=\"vm.client.profile.weeklyStatusReport.day\" ng-change=\"vm.updateReportConfig()\" ng-value=\"friday\" placeholder=\"Set day\">\n															<md-option value=\"1\">Monday</md-option>\n															<md-option value=\"2\">Tuesday</md-option>\n															<md-option value=\"3\">Wednesday</md-option>\n															<md-option value=\"4\">Thursday</md-option>\n															<md-option value=\"5\">Friday</md-option>\n															<md-option value=\"6\">Saturday</md-option>\n															<md-option value=\"0\">Sunday</md-option>\n\n														</md-select>\n													</md-input-container>\n													<span class=\"md-subhead\" style=\"\" > at </span>\n													<md-input-container style=\"margin-top:0; margin-left: 1em; margin-right: 1em;\">\n														<md-select  ng-model=\"vm.client.profile.weeklyStatusReport.time\" ng-change=\"vm.updateReportConfig()\" placeholder=\"Set time\">\n															<md-option ng-value=\"00\">12am</md-option>\n															<md-option ng-value=\"02\">2am</md-option>\n															<md-option ng-value=\"06\">6am</md-option>\n															<md-option ng-value=\"08\">8am</md-option>\n															<md-option ng-value=\"09\">9am</md-option>\n															<md-option ng-value=\"10\">10am</md-option>\n														</md-select>\n													</md-input-container>\n												</div>\n												<div style=\"padding-left: 2em; padding-top: 2em;\" layout=\"column\" ng-if=\"vm.client.profile.weeklyStatusReportEnabled\">\n\n													<md-checkbox style=\"margin-top: 0;\"  ng-change=\"vm.updateReportConfig()\" ng-model=\"vm.client.profile.weeklyStatusReport.includeBillingPeriod\" aria-label=\"Include Billing Period Status\">Include billing period status</md-checkbox>\n\n\n													<md-checkbox style=\"margin-top: 0;\"  ng-change=\"vm.updateReportConfig()\" ng-model=\"vm.client.profile.weeklyStatusReport.includeTimeDetail\" aria-label=\"Include Time Details\">Include time report</md-checkbox>\n\n\n													<md-checkbox style=\"margin-top: 0;\"  ng-change=\"vm.updateReportConfig()\" ng-model=\"vm.client.profile.weeklyStatusReport.includeTaskStatus\" aria-label=\"Include Tasks and their status\">Include tasks and their status</md-checkbox>\n\n													<p class=\"md-subhead margin-bottom-0\"><strong>Recipient Email Addresses </strong><small>(add one address per line)</small></p>\n\n													<md-input-container>\n														<textarea style=\"margin-bottom: 0;\" ng-required=\"true\"  ng-change=\"vm.updateReportConfig()\" ng-model=\"vm.client.profile.weeklyStatusReport.recipients\" aria-label=\"Report recipients\"></textarea>\n													</md-input-container>\n													<!-- <p class=\"md-subhead center\" style=\"margin-top: .5em; font-size: 12px; color: rgba(0,0,0,.54);\">Add one address per line</p> -->\n													<p class=\"center\" ng-if=\"!vm.editWelcomeClosing\"><md-button ng-click=\"vm.editWelcomeClosing = true\">Edit Welcome/Closing Messages for this Client</md-button></p>\n													<div ng-if=\"vm.editWelcomeClosing\">\n														<h4 ><strong>Report Welcome</strong></h4>\n														<div  style=\"\" class=\"welcome-field\" froala=\"vm.froala1Options\" ng-model=\"vm.client.profile.weeklyStatusReport.clientReportWelcome\" style=\"min-height: 350px;\">\n														</div>\n														<h4 style=\"margin-top: 1em;\"><strong>Report Closing</strong></h4>\n														<div  style=\"\" class=\"closing-field\" froala=\"vm.froala2Options\" ng-model=\"vm.client.profile.weeklyStatusReport.clientReportClosing\" style=\"min-height: 350px;\">\n														</div>\n													</div>\n												</div>\n											</md-card>\n											</ng-form>\n											<p ng-if=\"vm.userType == \'admin\'\">\n												<a href=\"{{vm.fbConfig.dataURL}}schedules/{{vm.client.profile.weeklyStatusReport.scheduleID}}\" target=\"_blank\">{{vm.client.profile.weeklyStatusReport.scheduleID}}</a>\n											</p>\n										</fieldset>\n\n										<div layout=\"row\" layout-align=\"center center\">\n											<md-button  flex=\"nogrow\" class=\"md-primary md-raised\" ng-click=\"vm.sendStatusReport(vm.client)\">\n												Configure and Send a Manual Status Report\n											</md-button>\n										</div>\n									</div><!-- report settings -->\n								</div><!-- centered column -->\n							</div>\n						</div>\n\n					</md-tab-body>\n				</md-tab>\n\n				<!-- Client Access -->\n				<md-tab md-on-select=\"vm.onTabChanges(5)\" ng-if=\"!vm.client.demo && vm.canClientAccess && !vm.isClientUser && vm.client.uid && (vm.isOwner || vm.isAdmin)\">\n					<md-tab-label>\n						<md-icon style=\"font-size: 14px!important;\" md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n						<span class=\"hide-sm hide-xs\">Client Access</span>\n					</md-tab-label>\n					<md-tab-body>\n						<div class=\"md-padding small-scrollbar\" layout=\"column\" style=\"max-height: 40vw; padding-top: 2em;\">\n							<client-access-manager ng-if=\"vm.client.uid\" client=\"vm.client\"></client-access-manager>\n\n							<div class=\"md-padding\" ng-if=\"!vm.client.uid\" layout=\"row\" layout-align=\"center center\">\n								<p class=\"md-subhead\" style=\"padding-top: 5em; padding-bottom: 10em;\">You can enable client access after this workspace has been saved.</p>\n							</div>\n						</div>\n\n\n					</md-tab-body>\n				</md-tab>\n			</md-tabs>\n			<div ng-if=\"vm.debugForm\" layout=\"column\" layout-align=\"start center\" style=\"background-color: #fff;\">\n				<p><strong>vm.clientDialogForm.$invalid:</strong> {{vm.clientDialogForm.$invalid}} | <strong>vm.clientDialogForm.$pristine:</strong> {{vm.clientDialogForm.$pristine}} <br> <strong>vm.reportForm.$invalid:</strong> {{vm.reportForm.$invalid}} | <strong>vm.reportForm.$pristine:</strong> {{vm.reportForm.$pristine}}</p>\n				<hr>\n				<p><strong>Client Dialog Error: </strong> {{vm.clientDialogForm.$error}}<br>\n					<strong>Report Form Error: </strong> {{vm.reportForm.$error}}</p>\n			</div>\n			<md-dialog-actions ng-if=\"!vm.hideButtons && vm.canOpenDialog\" style=\"border-top: none; background-color:#fff;\" class=\"md-padding\" layout=\"row\" layout-align=\"start center\">\n\n				<div layout=\"row\" layout-align=\"end center\" flex=\"grow\">\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button ng-if=\"canEdit\" type=\"button\" class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n					</div>\n					<div ng-if=\"vm.isOwner || vm.canEdit\" layout=\"row\" layout-align=\"end center\">\n						<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.client.uid\">\n							<md-button ng-if=\"vm.reportForm\" ng-disabled=\"((vm.clientDialogForm.$pristine) && (vm.reportForm.$pristine)) ||  (vm.clientDialogForm.$invalid || vm.reportForm.$invalid)\" type=\"button\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveUpdatedClient(vm.client, vm.prevPlan.nextCycle)\">\n								Update\n							</md-button>\n							<md-button ng-if=\"!vm.reportForm\" ng-disabled=\"(vm.clientDialogForm.$pristine) ||  (vm.clientDialogForm.$invalid)\" type=\"button\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveUpdatedClient(vm.client, vm.prevPlan.nextCycle)\">\n								Update\n							</md-button>\n							<label class=\"shortcut\">ctrl + enter</label>\n						</div>\n						<!-- <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid\">\n							<md-button type=\"button\" ng-disabled=\"vm.clientDialogForm.$invalid || vm.clientDialogForm.$pristine \" type=\"submit\" class=\"md-adminja-shade-theme  md-raised\" ng-click=\"vm.saveNewClient(vm.client, true)\">\n								Save &amp; Visit\n							</md-button>\n						</div> -->\n						<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.client.uid\">\n							<md-button type=\"button\" ng-disabled=\"vm.clientDialogForm.$invalid || vm.clientDialogForm.$pristine \" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewClient(vm.client)\">\n								Save\n							</md-button>\n						</div>\n\n						<!-- next for remaining tabs -->\n						<div flex=\"nogrow\" class=\"\" ng-if=\"!vm.client.uid && vm.selectedTabIndex < 2 && vm.client.status == \'active\'\" layout=\"row\">\n							<md-button class=\"md-button-small\" ng-disabled=\"true\" flex=\"nogrow\">or</md-button>\n							<md-button class=\"md-adminja-shade-theme md-raised md-primary\" style=\"padding-left: 20px;\" ng-disabled=\"vm.clientDialogForm.$invalid || vm.clientDialogForm.$pristine || vm.reportForm.$invalid || vm.reportForm.$pristine\"   ng-click=\"vm.changeTab(vm.selectedTabIndex+1)\">\n								Continue <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" style=\"font-size: 12px;\"></md-icon>\n							</md-button>\n						</div>\n					</div>\n				</div>\n			</md-dialog-actions>\n		</div><!-- \\canOpenDialog -->\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/clientDataService/dialog-clientStatusReport.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" layout=\"column\" md-theme=\"grey-menu\" class=\"md-inline-form dialog-panel\"  >\n	<md-dialog-content class=\"small-scrollbar\" style=\"position:relative;\">\n		<md-button ng-click=\"vm.showSample()\"  style=\"font-size: 11px; color: #999; position: absolute; top:30px; right:10px;\">See sample</md-button>\n		<ng-form name=\"vm.manualReportForm\"  >\n			<div layout=\"column\" class=\"md-whiteframe-z2\" layout-align=\"start layout-fill\" style=\"padding:1em 2em; background-color: rgba(0,0,0,.1); border-radius: 8px;\">\n				<div ng-if=\"!vm.manualReport.sent\" layout=\"column\" layout-align=\"start layout-fill\" style=\"max-width:400px; margin-left:auto; margin-right: auto; \">\n					<h1 class=\"md-title center\">Send Workspace Status Report</h1>\n					<div layout=\"row\" layout-align=\"start center\">\n						<p class=\"md-subhead padding-right-20\" flex=\"nogrow\"><strong>Date Range:</strong></p>\n						<md-input-container class=\"margin-bottom-0\">\n							<md-datepicker  md-hide-icons=\"calendar\" md-max-date=\"vm.manualReport.maxStart\" ng-change=\"vm.updateManualReport()\" ng-model=\"vm.manualReport.start\" md-placeholder=\"Start\"></md-datepicker>\n						</md-input-container>\n						<span style=\"font-size: 18px; padding:0 1em 0 1em;\">-</span>\n						<md-input-container class=\"margin-bottom-0\">\n							<md-datepicker  md-hide-icons=\"calendar\" md-min-date=\"vm.manualReport.minEnd\" ng-change=\"vm.updateManualReport()\" ng-model=\"vm.manualReport.end\" md-placeholder=\"End\"></md-datepicker>\n						</md-input-container>\n					</div>\n					<div  layout=\"column\">\n						<h3 class=\"md-subhead\"><strong>Sections to Include</strong></h3>\n						<md-checkbox style=\"margin-top: 0;\"   ng-model=\"vm.manualReport.includeBillingPeriod\" aria-label=\"Include Billing Period Status\">Billing Package Status</md-checkbox>\n\n\n						<md-checkbox style=\"margin-top: 0;\"   ng-model=\"vm.manualReport.includeTimeDetail\" aria-label=\"Include Time Details\">Time Report</md-checkbox>\n\n\n						<md-checkbox style=\"margin-top: 0;\"   ng-model=\"vm.manualReport.includeTaskStatus\" aria-label=\"Include Tasks and their status\">Completed/Remaining Task Report</md-checkbox>\n\n						<p class=\"md-subhead margin-bottom-0\"><strong>Recipient Email Addresses </strong><small>(add one address per line)</small></p>\n\n						<md-input-container>\n							<textarea style=\"margin-bottom: 0;\" ng-required=\"true\"  ng-model=\"vm.manualReport.recipients\" aria-label=\"Report recipients\"></textarea>\n						</md-input-container>\n						<div layout=\"row\" layout-align=\"end center\">\n							<md-button  ng-if=\"!vm.manualReport.sending\" ng-click=\"vm.cancel()\">\n								Cancel\n							</md-button>\n							<md-button data-gtm-send-workspace-status-report ng-if=\"!vm.manualReport.sending\" class=\"md-raised md-accent\" ng-click=\"vm.sendManualReport(vm.manualReport)\">\n								Send Report\n							</md-button>\n							<md-button ng-if=\"vm.manualReport.sending\" class=\"md-raised md-accent\" ng-click=\"vm.sendManualReport(vm.manualReport)\">\n								<md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon>\n							</md-button>\n						</div>\n					</div><!-- if not sent -->\n					<!-- <p class=\"md-subhead center\" style=\"margin-top: .5em; font-size: 12px; color: rgba(0,0,0,.54);\">Add one address per line</p> -->\n				</div>\n				<div ng-if=\"vm.manualReport.sent\" layout=\"column\" layout-align=\"center center\">\n					<h3>Your report has been queued</h3>\n					<p>You will be notified when it has been sent. </p>\n					<md-button class=\"md-raised md-accent\" ng-click=\"vm.cancel()\">\n						Close\n					</md-button>\n				</div>\n			</div>\n		</ng-form>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/clientDataService/dialog-workspaceAddress.tmpl.html","<md-dialog md-dynamic-height flex=\"100\" flex-sm=\"90\" flex-md=\"60\" flex-lg=\"40\" flex-xl=\"30\" style=\"background-color: rgba(255,255,255,1);\" md-theme=\"grey-menu\" class=\" item-dialog md-inline-form no-scrollbar md-padding\" >\n\n\n        <!--- client space form -->\n<ng-form ng-if=\"!vm.showConfirm\" ng-disabled=\"!vm.isOwner\" name=\"vm.workspaceAddressForm\"  novalidate>\n<fieldset >\n        <md-dialog-content style=\"background-color:#fff;\">\n            <div layout=\"column\">\n                <p class=\"md-headline center\" style=\"margin-bottom: 2em;\">Mail-to-Adminja Address</p>\n            </div>\n            <div layout=\"row\" layout-align=\"center start\" ng-if=\"vm.client.uid\" class=\"address-input-container\">\n                <div flex=\"40\" layout=\"column\" layout-align=\"start end\">\n                    <md-input-container style=\"margin-top: 0;\">\n                        <input\n                        lowercase-input\n                        aria-label=\"Workspace address\"\n                        name=\"workspaceaddress\"\n                        id=\"workspaceaddress\"\n                        ng-model-options=\"{debounce: 250}\"\n                        ng-model=\"vm.workspaceAddress\"\n                        ng-change=\"vm.checkAvailability(vm.workspaceAddress)\"\n                        style=\"color: #666; border:none; text-align: right;\">\n                    </md-input-container>\n                </div>\n                <div flex=\"60\" layout=\"column\" layout-align=\"start start\">\n                    <span class=\"address-domain-label\">@inbox.adminja.co</span>\n                </div>\n            </div><!--- address-input-container -->\n            <div layout=\"row\" layout-align=\"start start\">\n                <div flex=\"40\" layout=\"column\" layout-align=\"start end\" class=\"status-box\">\n                    <span class=\"address-warn\" style=\"color: orange;\" ng-if=\"!vm.failedPass && !vm.checking && !vm.isAddressValid(vm.workspaceAddress)\"><md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: orange; font-size: 12px; width: 12px; min-width: 12px;\"></md-icon> Min 4, Max 20 characters please!</span>\n                    <span class=\"address-available\" style=\"color: green;\" ng-if=\"!vm.failedPass && !vm.checking && vm.addressVerified && vm.isAddressValid(vm.workspaceAddress)\"><md-icon md-font-icon=\"zmdi zmdi-check-circle\" style=\"color: green; font-size: 12px; width: 12px; min-width: 12px;\"></md-icon> Available!</span>\n                    <span class=\"address-taken\" style=\"color: red;\" ng-if=\"!vm.failedPass && !vm.checking && !vm.addressVerified && vm.isAddressValid(vm.workspaceAddress)\"><md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: red; font-size: 12px; width: 12px; min-width: 12px;\"></md-icon> Not available</span>\n                    <span ng-if=\"vm.checking\" style=\"color: orange;\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px; color: orange; margin: 0 auto 0 auto;\"></md-icon> checking...</span>\n                    <span class=\"address-taken\" style=\"color: red;\" ng-if=\"vm.failedPass\"><md-icon md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"color: red; font-size: 12px; width: 12px; min-width: 12px;\"></md-icon> Invalid character detected. <br>Only a-z, A-Z, 0-9, - , _ supported.</span>\n\n                </div>\n            </div>\n\n            <md-dialog-actions style=\"border-top: none; background-color:#fff;\" class=\"md-padding\">\n                <div layout=\"row\" layout-align=\"end center\">\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button type=\"button\" class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n                    </div>\n\n                    <div flex=\"nogrow\" class=\"button-label-container\">\n                        <md-button type=\"button\" ng-disabled=\"!vm.addressVerified || !vm.isAddressValid(vm.workspaceAddress)\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateWorkspaceAddress(vm.client, vm.workspaceAddress)\">\n                          Claim\n                       </md-button>\n                    </div>\n\n                </div>\n            </md-dialog-actions>\n        </md-dialog-content>\n  </fieldset>\n</ng-form>\n<div ng-if=\"vm.showConfirm\" layout=\"column\" layout-align=\"start center\">\n    <p class=\"center\">\n        <img ng-src=\"assets/images/brand/adminja-bug.svg\" width=\"75\" >\n    </p>\n    <h1 class=\"center\">You\'re All Set!</h1>\n    <h3 class=\"center\">Your dedicated Mail-to-Adminja address has been confirmed!</h3>\n\n    <p class=\"center\">You (and your client) can start adding tasks by sending emails to:</p>\n    <h2 class=\"center\"><a style=\"text-decoration:none;\" href=\"mailto:{{vm.workspaceAddress}}@inbox.adminja.co\">{{vm.workspaceAddress}}@inbox.adminja.co</a></h2>\n\n    <md-button class=\"md-raised md-accent\" ng-click=\"vm.cancelDialog()\">Got it!</md-button>\n</div>\n</md-dialog>\n");
$templateCache.put("app/app-services/clientPackageService/clientPackageDialog.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"100\" flex-md=\"90\" flex-lg=\"70\" flex-xl=\"50\" class=\"client-package-dialog\">\n	<md-dialog-content class=\"md-padding\" >\n		<!-- package type selector -->\n		<div ng-if=\"vm.clientPackage.type == \'none\' && !vm.billingPeriod\" layout=\"column\" layout-align=\"start center\" layout-wrap>\n			<h3 ng-if=\"vm.client.packages && !vm.clientPackage.isTemplate\" class=\"center\">What type of billing package would you like to setup for this client?</h3>\n			<h3 ng-if=\"!vm.client.packages  && !vm.clientPackage.isTemplate\" class=\"center\">Will you be tracking time for this Client?</h3>\n			<h3 ng-if=\"vm.clientPackage.isTemplate\" class=\"center\">Which type of package should this template be?</h3>\n			<p class=\"center md-subhead\" style=\"\" ng-if=\"!vm.client.packages\">Choose the billing package below that represents how you\'ll be tracking your time.</p>\n			<div layout=\"column\" class=\"package-type-list\" layout-align=\"start layout-fill\">\n				<div class=\"package-type\" ng-click=\"vm.selectType(packageType)\" ng-repeat=\"packageType in vm.packageService.packageTypes | orderBy: [\'id\'] track by id+$index\" layout=\"row\" layout-align=\"layout-fill start\">\n					<div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" style=\"padding-right: 10px;\">\n						<md-icon flex=\"nogrow\" md-font-icon style=\"margin:3px 0 0 0;\" ng-class=\"\n						           {\'zmdi zmdi-time-restore\': packageType.type ==\'hourly\',\n						            \'zmdi zmdi-time-interval\': packageType.type == \'retainer\',\n						            \'zmdi zmdi-hourglass-alt\': packageType.type == \'balance\',\n						            \'zmdi zmdi-dot-circle\': packageType.type ==\'fixed\',\n						            \'zmdi zmdi-gas-station\': packageType.type == \'refillable\'\n						            }\"\n						></md-icon>\n					</div>\n					<div flex=\"grow\" layout=\"column\" class=\"padding-right-40\">\n						<p class=\"md-title margin-bottom-0 margin-top-0\" style=\"\">{{packageType.label}}</p>\n						<p class=\"md-subhead package-description\" style=\"margin: 5px 0 0 0;\">\n							{{packageType.description}}\n						</p>\n					</div>\n					<!-- <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\">\n						<md-button flex=\"nogrow\" ng-click=\"vm.selectType(packageType)\" class=\"md-raised md-accent\">Select</md-button>\n					</div> -->\n				</div>\n\n				<div class=\"package-type\" ng-click=\"vm.selectType(\'none\')\" ng-if=\"!vm.client.packages && !vm.clientPackage.isTemplate\" layout=\"row\" layout-align=\"layout-fill start\">\n					<div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" style=\"padding-right: 10px;\">\n						<md-icon md-font-icon=\"zmdi zmdi-block\" style=\"margin: 3px 0 0 0;\"></md-icon>\n					</div>\n					<div flex=\"grow\" layout=\"column\" class=\"padding-right-40\">\n						<p class=\"md-title margin-bottom-0 margin-top-0\" style=\"\">None</p>\n						<p class=\"md-subhead package-description\" style=\"margin: 5px 0 0 0;\">\n							You do not want to track time for this client.<br>\n							<strong>Note:</strong> You can setup a billing package and start tracking time whenever you are ready.\n						</p>\n					</div>\n					<!-- <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\">\n						<md-button flex=\"nogrow\" ng-click=\"vm.selectType(\'none\')\" class=\"md-raised md-accent\">Select</md-button>\n					</div> -->\n				</div>\n				<!-- package template picker-->\n				<div ng-if=\"vm.user.packageTemplates && !vm.clientPackage.isTemplate\" layout=\"column\" class=\"package-type-list\" layout-align=\"start layout-fill\">\n					<md-divider class=\"padding-bottom-40\"></md-divider>\n					<h3>Or Choose a Package Template</h3>\n					<div class=\"package-type\" ng-click=\"vm.selectTemplate(template)\" ng-repeat=\"template in vm.user.packageTemplates | toArray: false | orderBy: timeStamp track by $index+uid\" layout=\"row\" layout-align=\"layout-fill start\">\n						<div flex=\"nogrow\" layout=\"column\" layout-align=\"start start\" style=\"padding-right: 10px;\">\n							<md-icon flex=\"nogrow\" md-font-icon style=\"margin:3px 0 0 0;\" ng-class=\"\n							           {\'zmdi zmdi-time-restore\': template.type ==\'hourly\',\n							            \'zmdi zmdi-time-interval\': template.type == \'retainer\',\n							            \'zmdi zmdi-hourglass-alt\': template.type == \'balance\',\n							            \'zmdi zmdi-dot-circle\': template.type ==\'fixed\',\n							            \'zmdi zmdi-gas-station\': template.type == \'refillable\'\n							            }\"\n							></md-icon>\n						</div>\n						<div flex=\"grow\" layout=\"column\" class=\"padding-right-40\">\n							<p class=\"md-title margin-bottom-0 margin-top-0\" style=\"\">{{template.label}}</p>\n						</div>\n\n					</div>\n				</div>\n			</div>\n			<p class=\"md-subhead margin-top-40\"><small>* More than one package may be used for each client to better track the different services and products that you offer.</small></p>\n		</div><!-- package type selector -->\n		<!-- package editor -->\n		<div ng-if=\"vm.clientPackage.type != \'none\' && vm.editState != \'nextSteps\' && !vm.billingPeriod\" layout=\"column\" layout-align=\"start layout-fille\">\n			<!-- <h3 class=\"center\" style=\"\" ng-if=\"vm.editState == \'package\'\">Package Details</h3>\n			<h3 class=\"center\" style=\"\" ng-if=\"vm.editState == \'categories\'\">Time Categories</h3>\n			<h3 class=\"center\" style=\"\" ng-if=\"vm.editState == \'refillable\'\">Refill Options</h3> -->\n			<div layout=\"row\" layout-align=\"center\">\n				<!-- button when creating new package -->\n				<md-button   ng-if=\"!vm.clientPackage.timeStamp\" ng-class=\"{\'md-warn\': vm.editState == \'package\'}\" class=\"\"  flex=\"nogrow\"  ng-click=\"vm.changeState(\'instance\')\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Manage Instance Details\">\n					<md-icon md-font-icon=\"fa fa-suitcase\"></md-icon>\n					Package Details\n				</md-button>\n				<!-- button when editing package -->\n				<md-button   ng-if=\"vm.clientPackage.timeStamp\" ng-class=\"{\'md-warn\': vm.editState == \'instance\'}\" class=\"\"  flex=\"nogrow\"  ng-click=\"vm.changeState(\'instance\')\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Manage Instance Details\">\n					<md-icon md-font-icon=\"fa fa-suitcase\"></md-icon>\n					Package Details\n				</md-button>\n				<md-button ng-class=\"{\'md-warn\': vm.editState == \'categories\'}\"  ng-if=\"vm.clientPackage.timeStamp\" class=\"\"  flex=\"nogrow\" ng-click=\"vm.changeState(\'categories\')\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Manage Categories\">\n					<md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n					Time Categories\n				</md-button>\n				<md-button  ng-class=\"{\'md-warn\': vm.editState == \'refillable\'}\" ng-if=\"vm.clientPackage.timeStamp && vm.clientPackage.type == \'refillable\'\"  class=\"\"  flex=\"nogrow\" ng-click=\"vm.changeState(\'refillable\')\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Manage Refillable Options\">\n					<md-icon md-font-icon=\"zmdi zmdi-gas-station\"></md-icon>\n					Refill Options\n				</md-button>\n				<!-- only when editing, not creating -->\n				<md-button  ng-if=\"vm.clientPackage.timeStamp && !vm.clientPackage.isTemplate && vm.clientPackage.type != \'fixed\' && vm.clientPackage.type != \'refillable\'\" ng-class=\"{\'md-warn\': vm.editState == \'package\'}\" class=\"\"  flex=\"nogrow\"  ng-click=\"vm.changeState(\'package\')\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Manage Package Definition\">\n					<md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon>\n					Future Renewals\n				</md-button>\n\n			</div>\n		</div>\n		<div ng-if=\"vm.billingPeriod && vm.editState == \'package\'\" layout=\"column\" layout-align=\"start center\" class=\"migration-instructions-box\">\n			<p class=\"center md-title margin-bottom-0\">Billing Upgrade</p>\n			<p class=\"center md-subhead margin-bottom-0\">Below you\'ll find a new Billing Package configuration <strong style=\"color: red; font-size: 1.15em;\">based on this client\'s current billing period</strong>.</p>\n			<p class=\"center md-subhead margin-bottom-0\">This new package <strong>replaces</strong> the current billing period.</p>\n			<p class=\"center md-subhead margin-bottom-0\">All of your time and charges will be migrated over to this new package.</p>\n\n		</div>\n		<!-- Package Editor -->\n		<div ng-show=\"vm.clientPackage.type != \'none\' && (vm.editState == \'package\' || vm.editState == \'instance\')\" class=\"md-padding\">\n			<p ng-if=\"vm.billingPeriod && vm.editState == \'package\'\" class=\"center md-subhead\">Please review the details below and make any necessary adjustments before you confirm the upgrade.</p>\n			<form name=\"vm.forms.packageForm\">\n				<!-- instance editor -->\n				<div ng-if=\"vm.editState == \'instance\'\" layout=\"column\">\n					<div class=\"labeled-data\" layout=\"column\">\n						<label>Package Name</label>\n						<span>{{vm.clientPackage.label}}</span>\n					</div>\n					<!-- hourly display -->\n					<div layout=\"column\" layout-align=\"start layout-fill\" ng-if=\"vm.clientPackage.type == \'hourly\'\">\n						<div layout=\"row\" layout-align=\"start start\">\n							<md-input-container  flex=\"nogrow\" style=\"min-width: 200px;\"class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-change=\"vm.dateChanged(vm.clientPackage)\" ng-model=\"vm.clientPackage.startDate\" placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n							</md-input-container>\n							<div flex=\"10\">\n								<div class=\"labeled-data\" layout=\"column\">\n									<label>Default Rate</label>\n									<span><span ng-bind-html=\"vm.currency\"></span>{{vm.clientPackage.rate|number: 2}}</span>\n								</div>\n							</div>\n							<div flex=\"10\" style=\" padding-left: 1em;\">\n								<md-input-container flex=\"nogrow\" class=\"margin-bottom-0\">\n									<label>Goal</label>\n									<input ng-model=\"vm.clientPackage.budgetedHours\"   ng-placeholder=\"optional\" type=\"number\" step=\".01\"></md-input-container>\n								</md-input-container>\n							</div>\n							<div flex=\"nogrow\" style=\"padding-top: 23px; padding-left: 20px; padding-right: 5px;\">\n								hrs\n							</div>\n\n						</div>\n						<div layout=\"row\" layout-align=\"start start\">\n							<div flex=\"20\">\n								<div class=\"labeled-data\" layout=\"column\">\n									<label>Next Renewal</label>\n									<span>{{vm.clientPackage.schedule.packageStart | amDateFormat: vm.settings.amDateFormat}}</span>\n								</div>\n							</div>\n						</div>\n					</div>\n					<!-- budget display -->\n					<div ng-if=\"vm.clientPackage.type != \'hourly\'\" layout=\"column\" layout-align=\"start layout-fill\" >\n						<div layout=\"row\" layout-align=\"start start\">\n							<md-input-container flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-change=\"vm.dateChanged(vm.clientPackage)\" ng-model=\"vm.clientPackage.startDate\" placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n							</md-input-container>\n							<div flex=\"10\">\n								<div class=\"labeled-data\" layout=\"column\">\n									<label>Package Cost</label>\n									<span><span ng-bind-html=\"vm.currency\"></span>{{vm.clientPackage.cost | number: 2}}</span>\n								</div>\n							</div>\n							<md-input-container  flex=\"20\" style=\"min-width:125px; max-width: 125px;\" class=\"margin-bottom-0\">\n								<label>Hours Included</label>\n								<input required ng-model=\"vm.clientPackage.budgetedHours\"  type=\"number\" step=\".01\">\n							</md-input-container>\n							<div style=\"padding: 26px 20px 0 10px;\" flex=\"nogrow\">\n								hours\n							</div>\n							<md-input-container ng-if=\"vm.clientPackage.type == \'refillable\'\" flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-model=\"vm.clientPackage.expiryDate\" placeholder=\"Expiration Date\" name=\"expiryDate\"></md-datepicker>\n							</md-input-container>\n\n						</div>\n\n						<div ng-if=\"vm.clientPackage.type != \'refillable\'\" layout=\"row\" layout-align=\"start start\">\n							<div flex=\"20\">\n								<div class=\"labeled-data\" layout=\"column\">\n									<label>Next Renewal</label>\n									<span ng-if=\"vm.clientPackage.type == \'balance\'\">When Hours Depleted</span>\n									<span ng-if=\"vm.clientPackage.type != \'balance\'\">{{vm.clientPackage.schedule.packageStart | amDateFormat: vm.settings.amDateFormat}}</span>\n								</div>\n							</div>\n						</div>\n					</div>\n					<div  layout=\"column\" layout-align=\"start layout-fill\">\n						<!-- <label>Notes</label> -->\n						<md-input-container style=\"margin-bottom: 0; margin-top:1em; padding: 1em; border-radius: 8px; background-color: #efefef; border-bottom: none;\" class=\"billing-notes-container\">\n							<textarea ng-model=\"vm.clientPackage.notes\"\n							rows=\"1\"\n							placeholder=\"Notes\"\n							style=\"overflow-y: scroll; font-size: 11px; border-bottom: none;\"\n							class=\"no-scrollbar\"\n							>\n							</textarea>\n						</md-input-container>\n					</div>\n				</div><!-- //end instance editor -->\n				<div ng-if=\"vm.editState == \'package\' && vm.clientPackage.previouslyClosed && vm.clientPackage.renewable\" layout=\"column\" layout-align=\"start layout-fill\">\n					<p class=\"md-title center\">Package was previously closed and then re-opened.</p>\n					<p class=\"md-subhead center\" ng-if=\"vm.clientPackage.schedule.nextPackage\">This package has already renewed before.</p>\n					<p class=\"md-subhead center\"><md-button ng-click=\"vm.clientPackage.previouslyClosed = false\" class=\"md-raised md-primary\">Start a New Renewal Schedule</md-button></p>\n				</div>\n				<div ng-if=\"vm.editState == \'package\' && vm.clientPackage.previouslyClosed && !vm.clientPackage.renewable\" layout=\"column\" layout-align=\"start layout-fill\">\n					<p class=\"md-title center\">Package was previously closed or expired and then re-opened.</p>\n					<p class=\"md-subhead center\"><md-button ng-click=\"vm.clientPackage.previouslyClosed = false\" class=\"md-raised md-primary\">Set new <span ng-if=\"vm.clientPackage.type == \'fixed\'\">end</span> <span ng-if=\"vm.clientPackage.type == \'refillable\'\">expiration</span> date</md-button></p>\n				</div>\n				<div ng-if=\"vm.editState == \'package\' && !vm.clientPackage.previouslyClosed\" layout=\"row\" layout-align=\"layout-fill start\">\n					<div flex=\"auto\" style=\"padding-right: 2em;\">\n						<md-input-container>\n							<label>Package Name</label>\n							<input required ng-model=\"vm.clientPackage.label\" name=\"packageLabel\" id=\"package-label\">\n						</md-input-container>\n						<md-input-container ng-if=\"vm.clientPackage.type != \'hourly\'\">\n							<label>Appear on Invoice as:</label>\n							<input required ng-model=\"vm.clientPackage.invoiceLabel\" name=\"invoiceLabel\" id=\"invoice-label\">\n						</md-input-container>\n						<!-- package type editors -->\n\n						<!-- Hourly Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'hourly\'\">\n							<div layout=\"row\" layout-align=\"start start\">\n								<md-input-container ng-if=\"!vm.clientPackage.timeStamp\" flex=\"nogrow\" style=\"min-width: 200px;\"class=\"margin-bottom-0\">\n								    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-change=\"vm.dateChanged(vm.clientPackage)\" ng-model=\"vm.clientPackage.startDate\" placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n								</md-input-container>\n								<div flex=\"nogrow\" style=\"padding-top: 23px; padding-left: 20px; padding-right: 5px;\">\n									<span ng-bind-html=\"vm.currency\"></span>\n								</div>\n								<div flex=\"nogrow\" style=\"width: 125px;\">\n									<md-input-container flex=\"nogrow\" class=\"margin-bottom-0\">\n										<label>Default Rate/hr</label>\n										<input required ng-model=\"vm.clientPackage.rate\" type=\"number\" step=\".01\"></md-input-container>\n									</md-input-container>\n								</div>\n								<div flex=\"nogrow\" style=\"width: 75px; padding-left: 1em;\">\n									<md-input-container flex=\"nogrow\" class=\"margin-bottom-0\">\n										<label>Goal</label>\n										<input ng-model=\"vm.clientPackage.defaultBudgetedHours\" ng-placeholder=\"optional\" type=\"number\" step=\".01\"></md-input-container>\n									</md-input-container>\n								</div>\n								<div flex=\"nogrow\" style=\"padding-top: 23px; padding-left: 20px; padding-right: 5px;\">\n									hrs\n								</div>\n							</div>\n						</div><!-- /Hourly Editor -->\n						<!-- retainer Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'retainer\' || vm.clientPackage.type == \'balance\'\" layout=\"row\" layout-align=\"start start\">\n							<md-input-container ng-if=\"!vm.clientPackage.timeStamp\" flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-change=\"vm.dateChanged(vm.clientPackage)\" ng-model=\"vm.clientPackage.startDate\" placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n							</md-input-container>\n							<div style=\"padding: 26px 10px 0 10px;\" flex=\"nogrow\">\n								<span ng-bind-html=\"vm.currency\"></span>\n							</div>\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"padding-right-40 margin-bottom-0\">\n								<label>Package Cost</label>\n								<input required ng-model=\"vm.clientPackage.cost\" type=\"number\" step=\".01\">\n							</md-input-container>\n\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"margin-bottom-0\">\n								<label>Hours Included</label>\n								<input required ng-model=\"vm.clientPackage.defaultBudgetedHours\"  type=\"number\" step=\".01\">\n							</md-input-container>\n							<div style=\"padding: 26px 20px 0 10px;\" flex=\"nogrow\">\n								hours\n							</div>\n						</div><!-- /retainer Editor -->\n\n						<!-- fixed Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'fixed\'\"  layout=\"row\" layout-align=\"start start\">\n							<md-input-container ng-if=\"!vm.clientPackage.timeStamp\" flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-change=\"vm.dateChanged(vm.clientPackage)\" ng-model=\"vm.clientPackage.startDate\" placeholder=\"Start Date\" name=\"startDate\"></md-datepicker>\n							</md-input-container>\n							<div style=\"padding: 26px 10px 0 10px;\" flex=\"nogrow\">\n								<span ng-bind-html=\"vm.currency\"></span>\n							</div>\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"padding-right-40 margin-bottom-0\" >\n								<label>Package Cost</label>\n								<input required ng-model=\"vm.clientPackage.cost\" type=\"number\" step=\".01\">\n							</md-input-container>\n\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"margin-bottom-0\">\n								<md-tooltip md-direction=\"top\" ng-if=\"vm.clientPackage.type ==\'fixed\'\">\n									Leave at 0 if you aren\'t managing against a budget.\n								</md-tooltip>\n								<label>Hours Included</label>\n								<input required ng-model=\"vm.clientPackage.defaultBudgetedHours\"  type=\"number\" step=\".01\">\n							</md-input-container>\n							<div style=\"padding: 26px 20px 0 10px;\" flex=\"nogrow\">\n								hours\n							</div>\n							<md-input-container flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-model=\"vm.clientPackage.expiryDate\" placeholder=\"Due Date\" name=\"dueDate\"></md-datepicker>\n							</md-input-container>\n						</div><!-- /fixed Editor -->\n\n						<!-- refillable Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'refillable\'\" layout=\"row\" layout-align=\"start start\">\n							<div style=\"padding: 26px 10px 0 10px;\" flex=\"nogrow\">\n								<span ng-bind-html=\"vm.currency\"></span>\n							</div>\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"padding-right-40 margin-bottom-0\">\n								<label>Package Cost</label>\n								<input required ng-model=\"vm.clientPackage.cost\" type=\"number\" step=\".01\">\n							</md-input-container>\n\n							<md-input-container flex style=\"min-width:125px; max-width: 125px;\" class=\"margin-bottom-0\">\n								<label>Hours Included</label>\n								<input required ng-model=\"vm.clientPackage.defaultBudgetedHours\"  type=\"number\" step=\".01\">\n							</md-input-container>\n							<div style=\"padding: 26px 20px 0 10px;\" flex=\"nogrow\">\n								hours\n							</div>\n							<md-input-container flex=\"nogrow\" style=\"min-width: 200px;\" class=\"margin-bottom-0\">\n							    <md-datepicker  required md-date-filter=\"vm.startDateFilter\" ng-model=\"vm.clientPackage.expiryDate\" placeholder=\"Expiration Date\" name=\"expiryDate\"></md-datepicker>\n							</md-input-container>\n						</div><!-- /refillable Editor -->\n						<!-- balance Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'balance\'\">\n						</div><!-- /balance Editor -->\n\n						<!-- Renewal Interval Editor -->\n						<div ng-if=\"vm.clientPackage.type == \'hourly\' || vm.clientPackage.type == \'retainer\'\" >\n							<div layout=\"row\" layout-align=\"layout-fill start\">\n								  <md-input-container class=\"margin-bottom-0\">\n								  	<label>Renews</label>\n								    <md-select ng-change=\"vm.changeInterval(vm.clientPackage)\" ng-model=\"vm.clientPackage.schedule.interval\" flex=\"nogrow\" >\n								        <md-option  value=\'month\'>\n								           Monthly\n								        </md-option>\n								        <md-option  value=\'week\'>\n								           Weekly\n								        </md-option>\n								    </md-select>\n								</md-input-container>\n								<div flex=\"nogrow\" style=\"padding: 23px 20px 0 20px;\">\n									every\n								</div>\n								  <md-input-container class=\"margin-bottom-0\">\n								    <md-select ng-change=\"vm.calcRenewal(vm.clientPackage)\" ng-model=\"vm.clientPackage.schedule.frequency\" flex=\"nogrow\" >\n								        <md-option value=\'1\'>\n								           1\n								        </md-option>\n								        <md-option value=\'2\'>\n								           2\n								        </md-option>\n								        <md-option value=\'3\'>\n								           3\n								        </md-option>\n								        <md-option value=\'4\'>\n								           4\n								        </md-option>\n								        <md-option value=\'5\'>\n								           5\n								        </md-option>\n								        <md-option value=\'6\'>\n								           6\n								        </md-option>\n								        <md-option value=\'7\'>\n								           7\n								        </md-option>\n								        <md-option value=\'8\'>\n								           8\n								        </md-option>\n								        <md-option value=\'9\'>\n								           9\n								        </md-option>\n								        <md-option value=\'10\'>\n								           10\n								        </md-option>\n								        <md-option value=\'11\'>\n								           11\n								        </md-option>\n								        <md-option value=\'12\'>\n								           12\n								        </md-option>\n								    </md-select>\n								</md-input-container>\n								<div flex=\"nogrow\" style=\"padding: 23px 20px 0 20px;\">\n									{{vm.clientPackage.schedule.interval}}(s) on <span ng-if=\"vm.clientPackage.schedule.interval == \'month\'\">the</span>\n								</div>\n								  <md-input-container class=\"margin-bottom-0\">\n								    <md-select ng-change=\"vm.calcRenewal(vm.clientPackage)\" ng-model=\"vm.clientPackage.schedule.day\" flex=\"nogrow\" >\n								        <md-option ng-repeat=\"day in vm.dayOptions | orderBy: [\'id\'] track by id+$index\" ng-value=\"day.value\">\n								           {{day.label}}\n								        </md-option>\n								    </md-select>\n								</md-input-container>\n							</div>\n						</div><!-- renewal interval editor-->\n\n						<!-- pre-create and notifyWHen controls -->\n						<div class=\"notify-when\">\n							<!-- <md-divider style=\"margin-top: 2em;\"></md-divider> -->\n							<div layout=\"row\" class=\"checkbox-row\" ng-if=\"vm.clientPackage.type == \'hourly\'\" layout-align=\"layout-fill start\" style=\"margin-top: 1em;\">\n							    <md-checkbox style=\"\"  ng-model=\"vm.clientPackage.notifyWhen\" aria-label=\"select\"></md-checkbox>\n							    <span class=\"md-subhead\" style=\"margin-top:6px;\">Notify me when the first </span>\n							        <md-input-container style=\"margin-top:-2px;margin-left: .5em; margin-right: .5em;\">\n							            <input data-gtm-set-hourly-threshold ng-model=\"vm.clientPackage.notifyWhenLimit\" style=\"max-width: 25px;\" ng-value=\"0\">\n							        </md-input-container>\n							     <span class=\"md-subhead\" style=\"margin-top: 6px;\"> hours are logged.</span>\n							</div>\n\n							<div ng-if=\"vm.clientPackage.type != \'hourly\'\" style=\"margin-top: 1em;\">\n								<div class=\"checkbox-row\" layout=\"row\" layout-align=\"layout-fill start\">\n								    <md-checkbox ng-model=\"vm.clientPackage.notifyWhen\" ng-disabled=\"vm.clientPackage.defaultBudgetedHours == 0\" aria-label=\"select\"></md-checkbox>\n								    <span class=\"md-subhead\" style=\"margin-top:6px;\">Notify me when balance drops to </span>\n								        <md-input-container style=\"margin-top:-2px; margin-left: 1em; margin-right: 1em;\">\n								            <md-select data-gtm-set-retainer-threshold ng-disabled=\"!vm.clientPackage.notifyWhen\" ng-model=\"vm.clientPackage.notifyWhenLimit\" ng-value=\"10\" style=\"max-width: 85px;\">\n								            <md-option ng-value=\"10\">10%</md-option>\n								            <md-option ng-value=\"20\">20%</md-option>\n								            <md-option ng-value=\"30\">30%</md-option>\n								            <md-option ng-value=\"40\">40%</md-option>\n								            <md-option ng-value=\"50\">50%</md-option>\n								            <md-option ng-value=\"60\">60%</md-option>\n								            <md-option ng-value=\"70\">70%</md-option>\n								            <md-option ng-value=\"80\">80%</md-option>\n								            <md-option ng-value=\"90\">90%</md-option>\n								        </md-select>\n								    </md-input-container>\n								     <!-- <span class=\"md-subhead\" style=\"font-size: 12px;\" > of limit.<sup>*</sup></span> -->\n								</div>\n							</div>\n\n							<!-- <p class=\"md-subhead\" style=\"font-size: 12px; margin-top: -12px;\"><sup>*</sup> You will always receive a notification when balance reaches zero.</p> -->\n\n						</div>\n\n						<!-- rollover settings -->\n						<div class=\"package-rollover-settings\" ng-if=\"vm.clientPackage.type != \'fixed\' && vm.clientPackage.type != \'hourly\' && vm.clientPackage.type != \'refillable\'\">\n							<div layout=\"row\" class=\"checkbox-row\" layout-align=\"layout-fill start\" style=\"margin-top: 1em;\">\n							    <md-checkbox style=\"\"  ng-model=\"vm.clientPackage.rolloverOverage\" aria-label=\"select\"></md-checkbox>\n							    <span class=\"md-subhead \">Deduct any time overage from next renewal.</span>\n							</div>\n						</div>\n						<!-- /package type editors -->\n					</div>\n					<div flex=\"40\" ng-if=\"vm.clientPackage.type == \'retainer\' || vm.clientPackage.type == \'hourly\'\" style=\"padding: 2em 1em 1em 1em;\">\n						<div class=\"renewal-preview\">\n							<h4 class=\"bold center margin-top-0\">Renewal Schedule Preview</h4>\n							<ul>\n								<li layout=\"row\" layout-align=\"layout-fill center\">\n									<div flex=\"50\">\n										<strong style=\"text-decoration: underline;\">Create on</strong>\n									</div>\n									<div flex=\"50\">\n										<strong style=\"text-decoration: underline;\">Activate on</strong>\n									</div>\n								</li>\n								<li layout=\"row\" layout-align=\"layout-fill center\" ng-repeat=\"occurrence in vm.upcomingRenewals | toArray: false | limitTo: 6 | orderBy: [\'id\'] track by id + $index\">\n									<div flex=\"50\">{{vm.getCreateDate(occurrence.date, vm.clientPackage.schedule.triggerOffset) | amDateFormat: vm.settings.shortDayOfWeekFormat}}</div>\n									<div flex=\"50\">{{occurrence.date | amDateFormat: vm.settings.shortDayOfWeekFormat}}</div>\n								</li>\n								<li>...</li>\n							</ul>\n						</div>\n						<!-- Pre-creation rules -->\n						<div flex layout=\"row\" layout-align=\"center center\" style=\"margin-top: 1em;\">\n						    <span class=\"md-subhead\" style=\"font-size: 12px;\">Create packages </span>\n						    	<md-input-container style=\"margin-left: .5em; margin-right: .5em;\">\n						    		<input type=\"number\" ng-model=\"vm.clientPackage.schedule.triggerOffset\" style=\"width: 45px;\">\n						    	</md-input-container>\n						    	<span class=\"md-subhead\" style=\"font-size: 12px;\">days before they start.</span>\n						</div>\n					</div>\n				</div><!-- end editor main row -->\n\n			</form><!-- end vm.forms.packageForm -->\n\n\n		</div><!-- /package editor -->\n\n\n		<!-- Post-save NextSteps Prompt -->\n		<div layout=\"column\" layout-align=\"center center\" style=\"min-height: 400px;\" ng-if=\"vm.editState == \'nextSteps\' && vm.clientPackage.timeStamp\" class=\"md-padding\">\n			<h3 class=\"md-title center\">Package Saved!</h3>\n			<p class=\"md-subhead center\">Customize your package further:</p>\n			<div layout=\"row\" layout-align=\"center layout-fill\">\n				<md-card flex=\"30\" md-padding>\n					<md-card-header>\n						<md-card-avatar>\n							<md-icon md-font-icon=\"zmdi zmdi-time\" class=\"adjust-left-4\"></md-icon>\n					    </md-card-avatar>\n						<md-card-header-text>\n							<md-title>\n								<p class=\"md-title margin-top-10\">Add Time Categories</p>\n							</md-title>\n						</md-card-header-text>\n					</md-card-header>\n					<md-card-content md-padding>\n						<p class=\"md-subhead\">Time categories add another layer for Time Reporting and provide multiple-rate support for Hourly packages.</p>\n					</md-card-content>\n					<md-card-actions layout=\"column\" layout-align=\"end layout-fill\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.changeState(\'categories\')\">Add Categories</md-button></md-card-actions>\n				</md-card>\n				<md-card flex=\"30\" ng-if=\"vm.clientPackage.type == \'refillable\'\">\n					<md-card-header>\n						<md-card-avatar>\n							<md-icon md-font-icon=\"zmdi zmdi-gas-station\" class=\"adjust-left-6\"></md-icon>\n					    </md-card-avatar>\n						<md-card-header-text>\n							<md-title>\n								<p class=\"md-title margin-top-10\">Add Refill Options</p>\n							</md-title>\n						</md-card-header-text>\n					</md-card-header>\n					<md-card-content md-padding>\n						<p class=\"md-subhead\">Refill options define how your clients can add time to their package.<br>&nbsp;</p>\n					</md-card-content>\n					<md-card-actions layout=\"column\" layout-align=\"end layout-fill\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.changeState(\'refillable\')\">Add Refill Options</md-button></md-card-actions>\n				</md-card>\n			</div>\n			<p class=\"center\"><md-button ng-click=\"vm.cancel()\">I\'ll add them later</md-button> </p>\n		</div>\n		<!-- Category Manager -->\n		<div ng-if=\"vm.editState == \'categories\'\" class=\"md-padding\" style=\"min-height:300px;\">\n			<div layout=\"column\" layout-align=\"start layout-fill\">\n				<div layout=\"row\" layout-align=\"center center\">\n			    		<md-button class=\"md-accent\" ng-click=\"vm.newCategory(vm.clientPackage)\">+ New Category</md-button>\n			    	</div>\n			    	<div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.categorySpinner && !vm.editingCategory\">\n			    		<md-icon  md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #efefef; margin: 0 auto 0 auto;\"><md-tooltip md-delay=\"500\">Checking existing time</md-tooltip></md-icon>\n			    	</div>\n		            <div ng-if=\"vm.editingCategory\" style=\"margin-bottom: 2em; padding: 1em; background-color: #efefef; border-radius: 8px;\">\n		            	<p class=\"md-subhead center\" style=\"color: #888;\"><span ng-if=\"!vm.editingCategory.timeStamp\">New</span><span ng-if=\"vm.editingCategory.timeStamp\">Edit</span> Time Category</p>\n		                <ng-form name=\"vm.forms.categoryForm\" >\n		                	<div layout=\"column\">\n		    	            	<div layout=\"row\" layout-align=\"start start\">\n		    		                <md-input-container flex style=\"padding-right: 2em;\">\n		    		                    <label>Category Label</label>\n		    		                    <input required ng-model=\"vm.editingCategory.label\">\n		    		                </md-input-container>\n		    		                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start start\" ng-if=\"vm.clientPackage.type == \'hourly\'\">\n		    			                <div flex=\"nogrow\" style=\"padding-top: 24px;\">\n		    			                    <span ng-bind-html=\"vm.currency\"></span>\n		    			                </div>\n		    			                <md-input-container flex=\"auto\">\n		    			                    <label>Rate/hr</label>\n		    			                    <input required type=\"number\" step=\".01\" ng-model=\"vm.editingCategory.rate\">\n		    			                </md-input-container>\n		    			           </div>\n		    	              	</div>\n		    	              	<div layout=\"row\" layout-align=\"layout-fill center\">\n		    	              		<div flex=\"auto\" layout=\"row\" layout-align=\"start center\">\n		    	              			<md-input-container flex=\"nogrow\" style=\"margin-top: 0; min-width: 100px;\" layout=\"column\" layout-align=\"start center\">\n		    	              			    <label style=\"font-size: 10px; display:block; margin-bottom: 22px; text-align:center;\">Admin Only</label>\n		    	              			    <md-switch class=\"md-accent\" ng-model=\"vm.editingCategory.adminOnly\" style=\"margin-top: 0; margin-bottom: 0;\"></md-switch>\n		    	              			</md-input-container>\n		    	              		</div>\n		    		                <div flex=\"nogrow\">\n		    			                <md-button ng-click=\"vm.editingCategory = null\" flex=\"nogrow\">Cancel</md-button>\n		    			                <md-button ng-disabled=\"vm.forms.categoryForm.$invalid || vm.forms.categoryForm.$pristine\" ng-click=\"vm.updateCategory(vm.clientPackage, vm.editingCategory)\" flex=\"nogrow\" class=\"md-raised md-accent\">\n		    			               	<span ng-if=\"!vm.editingCategory.timeStamp\">Add</span>\n		    			               	<span ng-if=\"vm.editingCategory.timeStamp\">Update</span>\n		    			           	</md-button>\n		    			          </div>\n		    		           </div>\n		    		      </div>\n		                </ng-form>\n		            </div>\n		           <div layout=\"row\" layout-align=\"center start\">\n				    <div class=\"client-category-manager\" dragula=\"\'drag-category\'\" dragula-scope=\"$scope\" layout=\"column\" flex=\"80\" style=\"max-width: 600px;\">\n				    	<!-- <div class=\"small-scrollbar\" style=\"max-height: 40vh;\"> -->\n				        <div catid=\"{{category.uid}}\" ng-repeat=\"category in vm.clientPackage.categories | toArray: false | orderBy: [\'order\'] track by uid+$index\"\n				            class=\"category-item\"\n				             ng-if=\"category.label\"\n				             layout=\"row\"\n				             layout-align=\"start center\">\n				             <div flex=\"10\">\n					            <md-button ng-if=\"category.uid != \'defaultRate\'\" ng-click=\"vm.editCategory(category)\" flex=\"nogrow\" class=\"md-button-small\">\n					                <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n					            </md-button>\n					        </div>\n				            <p flex class=\"md-subhead\">{{category.label}}</p>\n				            <p flex=\"nogrow\" ng-if=\"category.adminOnly\"><span style=\"color: blue; font-size: .65em; padding-right: 1em;\">Admin only</span></p>\n				            <p flex=\"15\" ng-if=\"vm.clientPackage.type == \'hourly\'\"><span ng-bind-html=\"vm.currency\"></span>{{category.rate}}/hr</p>\n				            <div flex=\"20\">\n					            <md-button ng-if=\"category.uid != \'defaultRate\'\" flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\"><md-icon md-font-icon=\"fa fa-reorder\"></md-icon></md-button>\n					            <md-button ng-if=\"category.uid != \'defaultRate\'\" ng-click=\"vm.deleteCategory(vm.clientPackage, category)\" flex=\"nogrow\" class=\"md-button-small\">\n					                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n					            </md-button>\n					       </div>\n				        </div>\n				    </div>\n				  </div>\n			</div>\n		</div>\n		<!-- Refillable Options Manager -->\n		<div ng-if=\"vm.editState == \'refillable\'\" class=\"md-padding\"  style=\"min-height:300px;\">\n				<div layout=\"column\" layout-align=\"start layout-fill\">\n					<div layout=\"row\" layout-align=\"center center\">\n				    		<md-button class=\"md-accent\" ng-click=\"vm.newOption(vm.clientPackage)\">+ New Option</md-button>\n				    	</div>\n\n			            <div ng-if=\"vm.editingOption\" style=\"margin-bottom: 2em; padding: 1em; background-color: #efefef; border-radius: 8px;\">\n			            	<p class=\"md-subhead center\" style=\"color: #888;\"><span ng-if=\"!vm.editingOption.timeStamp\">New</span><span ng-if=\"vm.editingOption.timeStamp\">Edit</span> Option</p>\n			                <ng-form name=\"vm.forms.optionsForm\" >\n			                	<div layout=\"column\">\n			    	            	<div layout=\"row\" layout-align=\"start start\">\n			    		                <md-input-container flex style=\"padding-right: 2em;\">\n			    		                    <label>Option Label</label>\n			    		                    <input required ng-model=\"vm.editingOption.label\">\n			    		                </md-input-container>\n			    		                <md-input-container flex=\"auto\" style=\"padding-right: 2em;\">\n			    		                    <label>Hours included</label>\n			    		                    <input required type=\"number\" step=\".01\" ng-model=\"vm.editingOption.hours\">\n			    		                </md-input-container>\n			    		                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start start\">\n			    			                <div flex=\"nogrow\" style=\"padding-top: 24px;\">\n			    			                    <span ng-bind-html=\"vm.currency\"></span>\n			    			                </div>\n			    			                <md-input-container flex=\"auto\">\n			    			                    <label>Cost</label>\n			    			                    <input required type=\"number\" step=\".01\" ng-model=\"vm.editingOption.cost\">\n			    			                </md-input-container>\n			    			           </div>\n			    	              	</div>\n			    	              	<div layout=\"row\" layout-align=\"layout-fill center\">\n			    	              		<div flex=\"auto\" layout=\"row\" layout-align=\"start center\">\n\n			    	              		</div>\n			    		                <div flex=\"nogrow\">\n			    			                <md-button ng-click=\"vm.editingOption = null\" flex=\"nogrow\">Cancel</md-button>\n			    			                <md-button ng-disabled=\"vm.forms.optionsForm.$invalid || vm.forms.optionsForm.$pristine\" ng-click=\"vm.updateOption(vm.clientPackage, vm.editingOption)\" flex=\"nogrow\" class=\"md-raised md-accent\">\n			    			               	<span ng-if=\"!vm.editingOption.timeStamp\">Add</span>\n			    			               	<span ng-if=\"vm.editingOption.timeStamp\">Update</span>\n			    			           	</md-button>\n			    			          </div>\n			    		           </div>\n			    		      </div>\n			                </ng-form>\n			            </div>\n			           <div layout=\"row\" layout-align=\"center start\">\n					    <div class=\"client-options-manager\" dragula=\"\'drag-option\'\" dragula-scope=\"$scope\" layout=\"column\" flex=\"80\" style=\"max-width: 600px;\">\n					    	<!-- <div class=\"small-scrollbar\" style=\"max-height: 40vh;\"> -->\n					        <div catid=\"{{option.uid}}\" ng-repeat=\"option in vm.clientPackage.refillOptions | toArray: false | orderBy: [\'order\'] track by uid+$index\"\n					            class=\"option-item\"\n					             layout=\"row\"\n					             ng-if=\"option.label\"\n					             layout-align=\"start center\">\n					             <div flex=\"10\">\n						            <md-button ng-click=\"vm.editOption(option)\" flex=\"nogrow\" class=\"md-button-small\">\n						                <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n						            </md-button>\n						        </div>\n					            <p flex class=\"md-subhead\">{{option.label}}</p>\n		            			  <div flex=\"30\">\n		            			  	<p class=\"md-subhead\"><span ng-bind-html=\"vm.currency\"></span>{{option.cost}} for {{option.hours}}hrs</p>\n		            			  </div>\n					            <!-- <p flex=\"15\" ng-if=\"vm.clientPackage.type == \'hourly\'\"><span ng-bind-html=\"vm.currency\"></span>{{category.rate}}/hr</p> -->\n					            <div flex=\"20\">\n						            <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\"><md-icon md-font-icon=\"fa fa-reorder\"></md-icon></md-button>\n						            <md-button ng-click=\"vm.deleteOption(vm.clientPackage, option)\" flex=\"nogrow\" class=\"md-button-small\">\n						                <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n						            </md-button>\n						       </div>\n					        </div>\n					    </div>\n					  </div>\n				</div>\n		</div>\n\n		<!-- billingPeriod Time and Charge Conversion -->\n		<div ng-if=\"vm.editState == \'converting\'\" class=\"md-padding\" style=\"min-height: 300px;\">\n			<h3 class=\"center md-title\" style=\"margin-top: 3em;\">\n				{{vm.conversionStatus}}\n			</h3>\n			<p class=\"center md-subhead\">\n				<md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"font-size: 48px; line-height: 48px;\"></md-icon>\n			</p>\n			<p class=\"center md-subhead\" style=\"font-size: .85em;\">\n				Please remain on this page until the migration is complete.\n			</p>\n\n		</div>\n\n		<!-- billingPeriod conversion complete -->\n		<div ng-if=\"vm.editState == \'conversionConfirm\'\">\n\n\n\n			<h3 class=\"center md-title\" style=\"margin-top: 3em;\"><md-icon style=\"font-size: 48px; height:48px;\" md-font-icon=\"fa fa-thumbs-o-up\"></md-icon> Client Billing Upgraded!</h3>\n\n			<p class=\"center md-subhead margin-bottom-0\">Your client has been upgraded to Adminja\'s new billing system!</p>\n			<p class=\"center md-subhead\">You can still access your historical billing periods in the new \"Legacy\" option under \"Billing\" above.</p>\n			<p class=\"center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.completeConversion()\">View Billing Package</md-button></p>\n		</div>\n\n		<div ng-if=\"vm.editState == \'conversionError\'\">\n			<h3 class=\"center md-title\" style=\"margin-top: 3em;\"> <md-icon style=\"font-size: 48px; height:48px;\" md-font-icon=\"fa fa-thumbs-o-down\"></md-icon> Oops!</h3>\n			<p class=\"md-subhead center margin-bottom-0\">There was a problem migrating this client workspace.</p>\n			<p class=\"md-subhead center margin-bottom-0\">Don\'t worry, your data is safe and these things are easy to fix.</p>\n			<p class=\"md-subhead center\">Please send an email to <a href=\"mailto: help@getadminja.com\">help@getadminja.com</a> with the name of this Workspace and we\'ll finish the migration for you.</p>\n			<p class=\"center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancel()\">Got It!</md-button></p>\n		</div>\n\n		<!-- Dialog Actions -->\n		<div layout=\"row\" ng-if=\"!vm.billingPeriod\" layout-align=\"layout-fill center\">\n			<div flex=\"70\" layout=\"row\" layout-align=\"start center\">\n				<md-button ng-if=\"vm.clientPackage.type !=\'none\' && !vm.clientPackage.timeStamp\" flex=\"nogrow\" ng-click=\"vm.startOver()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Start Over\">\n					<md-icon md-font-icon=\"fa fa-angle-left\"></md-icon> Start Over\n				</md-button>\n			</div>\n			<!-- actions for package/instance/template -->\n			<div ng-if=\"vm.editState == \'package\' || vm.editState == \'instance\'\" flex=\"30\" layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"vm.editState != \'categories\' && vm.editState != \'refillable\'\" flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel\">\n					Cancel\n				</md-button>\n				<!-- template save/update -->\n				<div ng-if=\"vm.clientPackage.type != \'none\' &&  vm.clientPackage.isTemplate\" layout=\"row\" layout-align=\"end center\">\n					<md-button ng-if=\"!vm.clientPackage.timeStamp\" class=\"md-raised md-accent\" ng-click=\"vm.savePackageTemplate(vm.clientPackage)\" ng-disabled=\"vm.forms.packageForm.$pristine || vm.forms.packageForm.$invalid || vm.editState != \'package\'  || vm.updating\" flex=\"nogrow\" aria-label=\"Save Template\">\n						Save Template\n					</md-button>\n					<md-button ng-if=\"vm.clientPackage.timeStamp && vm.editState == \'package\'\" class=\"md-raised md-accent\" ng-click=\"vm.updatePackageTemplate(vm.clientPackage)\" ng-disabled=\"vm.forms.packageForm.$pristine || vm.forms.packageForm.$invalid || vm.editState != \'package\'  || vm.updating\" flex=\"nogrow\" aria-label=\"Update Template\">\n						Update Template\n					</md-button>\n				</div>\n				<!-- package save/update -->\n				<div ng-if=\"vm.clientPackage.type != \'none\' && !vm.clientPackage.isTemplate\" layout=\"row\" layout-align=\"end center\">\n					<md-button ng-if=\"vm.clientPackage.timeStamp && !vm.updating\" class=\"md-raised md-accent md-split-button\" ng-click=\"vm.updatePackage(vm.clientPackage)\" ng-disabled=\"vm.forms.packageForm.$pristine || vm.forms.packageForm.$invalid|| (vm.editState != \'package\' && vm.editState != \'instance\')  || vm.updating\" flex=\"nogrow\" aria-label=\"Update Package\">\n						Update\n					</md-button>\n					<md-button ng-if=\"!vm.clientPackage.timeStamp\" class=\"md-raised md-accent md-split-button\" ng-click=\"vm.savePackage(vm.clientPackage)\" ng-disabled=\"vm.forms.packageForm.$pristine || vm.forms.packageForm.$invalid || (vm.editState != \'package\' && vm.editState != \'instance\') || vm.updating || (vm.clientPackage.type == \'balance\' && vm.clientPackage.defaultBudgetedHours < 1)\"  flex=\"nogrow\" aria-label=\"Update Package\">\n						Save\n					</md-button>\n\n					<!-- save as template -->\n					<md-menu ng-if=\"vm.editState == \'package\'\" md-position-mode=\"target-right bottom\" md-offset=\"0 5\">\n					    <!-- Trigger element is a md-button with an icon -->\n					    <md-button class=\"md-split-button-menu md-raised md-accent\" ng-disabled=\"vm.forms.packageForm.$pristine || vm.forms.packageForm.$invalid|| vm.editState != \'package\' || (vm.clientPackage.type == \'balance\' && vm.clientPackage.defaultBudgetedHours < 1)\">\n					    		<md-icon ng-Click=\"$mdMenu.open($event)\" aria-label=\"Save Options\" md-font-icon=\"fa fa-caret-down\" style=\"color:#fff; font-size: 12px;\">\n					   		<md-tooltip md-delay=\"1000\">Save Options</md-tooltip></md-icon>\n					   </md-button>\n					    <md-menu-content class=\"md-dense\">\n					        <md-menu-item>\n					            <md-button ng-click=\"vm.savePackageTemplate(vm.clientPackage)\" aria-label=\"Save Template\" md-no-ink=\"true\">\n					                Save as Template\n					            </md-button>\n					        </md-menu-item>\n					    </md-menu-content>\n					</md-menu>\n				</div>\n\n\n			</div>\n			<!-- actions for refillable/categories -->\n			<div ng-if=\"vm.editState == \'categories\' || vm.editState == \'refillable\'\"  flex=\"30\" layout=\"row\" layout-align=\"end center\">\n				<md-button flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"md-raised md-accent\"  aria-label=\"Done\">\n					Done\n				</md-button>\n			</div>\n		</div>\n		<!-- actions for migration from billlingPeriods -->\n		<div layout=\"row\" ng-if=\"vm.billingPeriod && vm.editState == \'package\'\" layout=\"row\" layout-align=\"center center\">\n			<md-button flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel\">\n				Cancel\n			</md-button>\n			<md-button class=\"md-raised md-accent\" ng-click=\"vm.savePackage(vm.clientPackage, true)\" ng-disabled=\"vm.forms.packageForm.$invalid\" flex=\"nogrow\" aria-label=\"Convert to Package\">\n				Confirm Upgrade\n			</md-button>\n		</div>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/clientPackageService/lineItemDialog.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"50\" flex-gt-lg=\"40\" class=\"line-item-dialog\">\n	<md-dialog-content class=\"md-padding\">\n		<h3 class=\"text-center\" style=\"padding-bottom: 1em; border-bottom: 1px dashed #ccc; margin-bottom: 2em;\">\n			<span ng-if=\"vm.lineItem.timeStamp && vm.lineItem.invoiced\">Charge applied to Invoice#{{vm.lineItem.invoiceNumber}}</span>\n			<span ng-if=\"vm.lineItem.timeStamp && !vm.lineItem.invoiced\">Edit Charge</span>\n			<span ng-if=\"!vm.lineItem.timeStamp\">New Charge</span>\n			<small ng-if=\"vm.lineItem.invoiced\" style=\"font-weight: normal;\">Charge has been invoiced and cannot be modified.</small>\n		</h3>\n		<div layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex=\"20\" class=\"padding-right-20\">\n				<md-input-container>\n					<label>Quantity</label>\n					<input ng-model=\"vm.lineItem.quantity\" ng-disabled=\"vm.lineItem.invoiced\">\n				</md-input-container>\n			</div>\n			<div flex=\"nogrow\" class=\"padding-top-20\">\n				<span ng-bind-html=\"vm.currency\"></span>\n			</div>\n			<div flex=\"20\" class=\"padding-right-20\">\n				<md-input-container>\n					<label>Amount</label>\n					<input ng-model=\"vm.lineItem.amount\" ng-disabled=\"vm.lineItem.invoiced\">\n				</md-input-container>\n			</div>\n			<div flex=\"grow\">\n				<md-input-container>\n					<label>Description</label>\n					<input ng-model=\"vm.lineItem.description\" ng-disabled=\"vm.lineItem.invoiced\">\n				</md-input-container>\n			</div>\n		</div>\n	</md-dialog-content>\n	<md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.confirmDelete\">\n		<md-button ng-if=\"vm.userType == \'admin\' && vm.lineItem.timeStamp\" target=\"_blank\"  href=\"{{vm.fbConfig.dataURL}}lineItemCharges/{{vm.lineItem.uid}}\" >X-Ray</md-button>\n		<md-button ng-if=\"vm.lineItem.timeStamp\" ng-click=\"vm.confirmDelete = true\" ng-disabled=\"vm.lineItem.invoiced\">Delete</md-button>\n		<md-button ng-click=\"vm.cancel()\" class=\"\">Cancel</md-button>\n		<md-button ng-click=\"vm.save(vm.lineItem)\" ng-disabled=\"vm.lineItem.invoiced\" class=\"md-raised md-accent\">Save</md-button>\n	</md-dialog-actions>\n	<md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.confirmDelete\" class=\"confirm-delete\">\n		<p flex=\"nogrow\" class=\'center\"\' style=\"margin:0;\">\n		           Permanently delete?\n		       </p>\n\n		       <md-button class=\"\" ng-click=\"vm.confirmDelete = false\">\n		           cancel\n		       </md-button>\n\n		       <md-button data-gtm-delete-time-log class=\"md-warn md-raised\" ng-click=\"vm.delete(vm.lineItem)\">\n		           <span >\n		                   Confirm\n		               </span>\n		       </md-button>\n	</md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-services/clientPackageService/refillPackageDialog.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"100\" flex-md=\"80\" flex-lg=\"60\" flex-xl=\"50\" class=\"client-package-dialog\">\n	<md-dialog-content class=\"md-padding\" >\n		<!-- refill selector -->\n		<div ng-if=\"!vm.refillOption\" layout=\"column\" layout-align=\"start layout-fill\" layout-wrap>\n			<h3 class=\"center\" ng-if=\"vm.clientPackage.refillOptions\">Which Refill Option do you want to apply?</h3>\n			<div ng-if=\"vm.clientPackage.refillOptions\" layout=\"row\" class=\"package-type-list\" layout-align=\"space-around start\" layout-wrap>\n				<md-card  ng-repeat=\"option in vm.clientPackage.refillOptions | toArray: false | orderBy: [\'uid\'] track by uid+$index\" class=\"package-type\" flex=\"30\">\n					<md-card-header class=\"padding-bottom-0\">\n						<md-card-header-text>\n							<md-title>\n								<p class=\"md-title center margin-top-10\">{{option.label}}</p>\n							</md-title>\n						</md-card-header-text>\n					</md-card-header>\n					<md-card-content md-padding class=\"padding-top-0\">\n						<p class=\"md-subhead center package-description\">\n							<strong>Hours included: </strong> {{option.hours}}<br>\n							<strong>Cost:</strong> <span ng-bind-html=\"vm.currency\"></span>{{option.cost}}\n						</p>\n					</md-card-content>\n					<md-card-actions>\n						<div layout=\"row\" layout-align=\"center center\" class=\"padding-bottom-20\">\n							<md-button ng-click=\"vm.selectOption(option)\" class=\"md-raised md-primary\">Select Option</md-button>\n						</div>\n					</md-card-actions>\n				</md-card>\n			</div>\n			<div ng-if=\"!vm.clientPackage.refillOptions\" layout=\"column\" layout-align=\"center center\">\n				<p class=\"center\"><md-icon style=\"font-size: 3em;\" md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon></p>\n				<p class=\"center md-subhead\">You haven\'t defined any refillable options for this package yet.</p>\n				<p class=\"center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.editPackage(vm.clientPackage)\">Edit Package</md-button>\n			</div>\n\n		</div><!-- refill selector -->\n		<div ng-if=\"vm.refillOption\">\n			<h3 class=\"center margin-bottom-40\">Add {{vm.refillOption.label}} @ <span ng-bind-html=\"vm.currency\"></span>{{vm.refillOption.cost | number: 2}} each.</h3>\n			<form name=\"vm.forms.refillForm\">\n				<div layout=\"row\" layout-align=\"start start\">\n					<div flex layout=\"column\" layout-align=\"start center\">\n						<p class=\"md-subhead margin-top-0\"><strong>Option</strong></p>\n						<p class=\"md-subhead margin-top-0\">{{vm.refillOption.label}}</p>\n					</div>\n					<div flex layout=\"column\" layout-align=\"start center\">\n						<p class=\"md-subhead margin-top-0\"><strong>Hours Included</strong></p>\n						<p class=\"md-subhead margin-top-0\">{{vm.refillOption.hours}}</p>\n					</div>\n					<div flex layout=\"column\" layout-align=\"start center\">\n						<p class=\"md-subhead margin-top-0\"><strong>Cost/Unit</strong></p>\n						<p class=\"md-subhead margin-top-0\"><span ng-bind-html=\"vm.currency\"></span>{{vm.refillOption.cost | number: 2}}</p>\n					</div>\n					<div flex layout=\"column\" layout-align=\"start center\" class=\"padding-right-20\">\n						<p class=\"md-subhead margin-top-0\"><strong>Quantity</strong></p>\n						<md-input-container class=\"margin-top-0\">\n							<md-select ng-model=\"vm.refillOption.quantity\">\n								<md-option value=\"1\">1</md-option>\n								<md-option value=\"2\">2</md-option>\n								<md-option value=\"3\">3</md-option>\n								<md-option value=\"4\">4</md-option>\n								<md-option value=\"5\">5</md-option>\n								<md-option value=\"6\">6</md-option>\n								<md-option value=\"7\">7</md-option>\n								<md-option value=\"8\">8</md-option>\n								<md-option value=\"9\">9</md-option>\n								<md-option value=\"10\">10</md-option>\n							</md-select>\n						</md-input-container>\n					</div>\n					<div flex layout=\"column\" layout-align=\"start center\">\n						<p class=\"md-subhead margin-top-0\"><strong>Total Cost</strong></p>\n						<p class=\"md-subhead margin-top-0\"><span ng-bind-html=\"vm.currency\"></span>{{vm.refillOption.cost * vm.refillOption.quantity | number: 2}}</p>\n					</div>\n					<div flex layout=\"column\" layout-align=\"start center\">\n						<p class=\"md-subhead margin-top-0\"><strong>Total Hours</strong></p>\n						<p class=\"md-subhead margin-top-0\">{{vm.refillOption.quantity * vm.refillOption.hours}}</p>\n					</div>\n				</div>\n			</form>\n		</div>\n		<div layout=\"row\" layout-align=\"layout-fill center\">\n			<div flex=\"70\" layout=\"row\" layout-align=\"start center\">\n			</div>\n			<div flex=\"30\" layout=\"row\" layout-align=\"end center\">\n				<md-button ng-if=\"vm.refillOption\" flex=\"nogrow\" ng-click=\"vm.refillOption = undefined\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel\">\n					<md-icon md-font-icon=\"fa fa-angle-left\"></md-icon> Go Back\n				</md-button>\n				<md-button flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel\">\n					Cancel\n				</md-button>\n				<div layout=\"row\" layout-align=\"end center\">\n					<md-button class=\"md-raised md-accent\" ng-click=\"vm.submitRefill(vm.clientPackage, vm.refillOption)\" ng-disabled=\"!vm.clientPackage.refillOptions || vm.forms.refillForm.$invalid\" flex=\"nogrow\" aria-label=\"Submit Refill\">\n						Submit Refill\n					</md-button>\n				</div>\n			</div>\n		</div>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/gateService/consent-dialog.tmpl.html","<md-dialog md-dynamic-height flex=\"100\" flex-sm=\"70\" flex-md=\"60\" flex-lg=\"50\" flex-xl=\"40\" md-theme=\"grey-menu\" class=\"md-inline-form privacy-dialog\" style=\"border-top: 6px solid #0091ea;\">\n    <md-dialog-content>\n        <form name=\"getConsent\" novalidate style=\"padding: 1em;\" layout=\"column\" layout-align=\"start center\">\n            <h1 class=\"md-title center\">Privacy Policy</h1>\n            <p class=\"md-subhead center\">To use Adminja, please review and accept the Privacy Policy below.</p>\n            <!-- <p class=\"md-subhead center\" style=\"font-size: 11px; max-width:70%;\">In order to full comply with the new European privacy guidelines (GDPR) we will also request your permission before collecting certain information from you.</p> -->\n            <!-- <p class=\"md-subhead center\" style=\"font-size: 12px; margin-top:0;\">Review the: &nbsp;&nbsp;&nbsp;<md-radio-group ng-model=\"vm.showVersion\"><md-radio-button value=\"simple\" class=\"md-primary\">Friendly Version</md-radio-button><md-radio-button value=\"legal\">Legal Version</md-radio-button></md-radio-group></p> -->\n            <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\" style=\"width: 100%;\">\n                <md-tab label=\"Friendly Version\">\n                    <md-content class=\"md-padding\" layout=\"column\" style=\"max-height: 300px; background-color: #fff;\">\n                        <p class=\"md-subhead\">Last Updated: May 8, 2018</p>\n\n                        <h3>How We Use Your Information</h3>\n                        <p>The only personal information that we must collect to provide Adminja to you is your email address and name.</p>\n                        <p>Our only reason for storing this personal information is to provide the Adminja service to you. Without your email address we cannot provide authentication services or communicate with you.</p>\n                        <p>We will only share information (email address and user ID) with third parties after receiving your consent, and only in the course of providing additional services to you (eg. sending email notifications via a 3rd party service.)</p>\n                        <h3>What Information Do We Collect?</h3>\n                        <p>We only store the information you choose to provide and, other than your name and email address, no other personal information is required to use Adminja.</p>\n                        <p>We will log your Adminja utilization information in order to refine Adminja and to track and resolve technical issues. When using third party analytics services, your information will be anonymized to the best of our ability.</p>\n                        <p>We use cookies to manage your log-in state, to track analytic usage of Adminja, and on our public site to monitor marketing results.</p>\n                        <h3>Our Disclosure of Your Information</h3>\n                        <p>Other than your email address (for analytics purposes), any personal information you choose to provide and store in Adminja will not be made available to anyone else without your explicit permission. Your email address will only be used securely in order to relate analytical data to your account for troubleshooting and support.</p>\n                        <p>We will not sell your personal information to any third parties.</p>\n                        <h3>Your Use of Other Persons’ Information</h3>\n                        <p>You are responsible for ensuring that you have permission to store your Client information with Adminja.</p>\n                        <p>We will NEVER reveal or share your Client\'s information with third parties other than to provide services to you and only with your explicit permission. For example, in order to send an invoice to your client, we will need to transmit the invoice content to our third party email service.</p>\n                        <h3>Security</h3>\n                        <p>Your entire Adminja experience is encrypted both in-transit (via SSL) and at-rest.</p>\n                        <p>All encryption and security facilities are managed by the Google Cloud Platform and the rotating encryption keys are not available to Adminja personnel.</p>\n\n                        <h3>Correcting and Updating Your Personal Information</h3>\n                        <p>We will correct, at any time, any information that you indicate should be changed.</p>\n                        <p>At any time you may request a full copy of all of the information we have stored for you. This information will be provided in a portable JSON document that can be parsed by most modern systems.</p>\n                        <h3>Account Deletion</h3>\n                        <p>You may choose to have your information deleted at any time. Doing so will also result in the deletion of your Adminja account.</p>\n                        <p>Should you choose to cancel Adminja in the future, we will completely delete your information 30 days after your cancellation date.</p>\n                        <h3>Data Retention</h3>\n                        <p>We will retain your information for as long as your account is active or as needed to provide you services. We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.</p>\n                        <h3>Additional Policy Information</h3>\n                        <p>Our public website is integrated with some social networks. If you use the sharing tools on our website, those companies may record your IP address, what pages you visited, and they may set cookies to track your visits to properties they own. Your interactions with these Features are governed by the privacy policy of the company providing it.</p>\n                        <h3>Notification of Privacy Statement Changes</h3>\n                        <p>We may update this privacy statement to reflect changes to our information practices. If we make any material changes we will notify you by email (sent to the email address specified in your account) or by means of a notice on this Site prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.</p>\n                        <h3>Questions?</h3>\n                        <p>It is our goal to make our privacy practices easy to understand. If you have questions, concerns or if you would like more detailed information, please email us at help@getadminja.com.</p>\n                    </md-content>\n\n                </md-tab>\n                <md-tab label=\"Legal Version\">\n                  <md-content class=\"md-padding\" layout=\"column\" style=\"max-height: 300px; background-color: #fff;\" >\n                      <p class=\"md-subhead\">Last Updated: May 8, 2018</p>\n                      <p>This is the Privacy Policy of the Adminja website: https://www.adminja.co & https://www.getadminja.com (the “Site”), operated by Openmotive Inc. (together with our affiliates and subsidiaries, “Adminja”, “we”, “us”, “our” and terms of similar meaning) and our related products and services. It describes the information that we collect from you as part of the normal operation of our Site, and how we disclose and secure this information. It also describes your choices regarding use, access and correction of your personal information.</p>\n                      <p>By accepting the Privacy Policy in registration or by visiting and using the Site, you expressly consent to our collection, use and disclosure of your personal information in accordance with this Privacy Policy. This Privacy Policy is incorporated into and subject to our Terms of Use.</p>\n                      <p>In this Privacy Policy, we use the following terms to describe different types of visitors to our Site. Our customers are called “Subscribers” and our Subscribers’ customers are called “Clients”. We use the word “staff” to describe persons to whom Subscribers give “staff” access on the Site. Together with registered users of other interactive areas of the Site, these people are collectively described in this Privacy Policy as “Users” of our Site.</p>\n                      <h3>How We Use Your Information</h3>\n                      <p>We use personal information in the file we maintain about you, and other information we obtain from your current and past activities on the Site, to provide to you the services offered by the Site; resolve service and billing disputes; troubleshoot problems; bill any amounts due from you; measure consumer interest in our products and services, inform you about online and offline offers, products, services, events and updates; deliver information to you that, in some cases, is relevant to your interests, such as product news; customize your experience; detect and protect us against error, fraud and other criminal activity; enforce our Terms of Use; provide you with system or administrative messages, and as otherwise described to you at the time of collection. On occasion we use email address or other contact information to contact our Users to ask them for their input on our services, to forward to them media opportunities, and even to invite them for a chat.</p>\n                      <p>We may also use personal information about you to improve our marketing and promotional efforts, to analyze Site usage, to improve our content and product offerings, and to customize the Site’s content, layout, and services. These uses improve the Site and better tailor it to meet your needs, so as to provide you with a smooth, efficient, safe and customized experience while using the Site.</p>\n                      <p>If you wish to subscribe to our newsletters, we will use your name and email address to send the newsletter to you. Out of respect for your privacy, we provide you a way to unsubscribe in the email. If you wish to no longer receive our newsletters you may follow the instructions located in the email, or you may contact us at help@getadminja.com.</p>\n                      <h3>What Information Do We Collect?</h3>\n                      <p>Our primary purpose in collecting personal information from you is to provide you with a safe, smooth, efficient, and customized experience. This allows us to provide services and features that most likely meet your needs, and to customize our service to make your experience safer and easier. We only collect personal information about you that we consider necessary for achieving this purpose.</p>\n                      <p>In general, you can browse some of the Site without telling us who you are or revealing any personal information about yourself. Once you become a User, we require you to provide various contact and identity information, billing information, and other personal information as indicated on the relevant forms on the Site (which vary, depending on what kind of User you are), and you are no longer anonymous to us. Where possible, on these forms we indicate which fields are required and which fields are optional.</p>\n                      <p>In addition, as you use the Site, you can from time to time enter or send to us personal information. For example, if you are a Subscriber, you can enter your own time and other billing information, and if you are a Client you may enter information about payment of any invoice submitted by a Subscriber. As you use the Site you can also from time to time enter personal information about third parties. For example, if you are a Subscriber, you can enter personal information about your Clients or your staff.</p>\n                      <p>You always have the option to not provide information by choosing not to become a User or by not using the particular feature of the Site for which the information is being collected.</p>\n                      <p>If you are a Subscriber, we collect your credit card information for billing purposes. And if you are a Client who wishes to pay amounts to a Subscriber on a recurring basis, we collect and store your credit card information for payment purposes.</p>\n                      <p>We also automatically track certain information about you based upon your behavior on our Site and store it through log files. We use this information to do internal research on our users’ demographics, feature interests, and behavior to better understand, protect and serve you and our community. This information may include the URL that you just came from, which URL you next go, your computer browser information, and your IP address. We may provide Customers’ IP addresses to payment intermediaries in the course of the payment process.</p>\n                      <p>Technologies such as: cookies and similar technologies are used by Adminja and our partners (e.g., advertising, marketing and analytics), affiliates, or other service providers. These technologies are used in analyzing trends, administering the site, tracking users’ movements around the site and to gather demographic information about our user base as a whole. We may receive reports based on the use of these technologies by these companies on an individual as well as aggregated basis.</p>\n                      <p>We use cookies to remember users’ settings, store login addresses, authenticate users, run website experiments, and store analytics data. Users can control the use of cookies at the individual browser level. If you reject cookies, you may still use our site, but your ability to use some features or areas of our site may be limited.</p>\n                      <h3>Our Disclosure of Your Information</h3>\n                      <p>We will share your personal information with third parties only in the ways that are described in this privacy policy, including as follows:</p>\n                      <p>Subscribers and Clients, Etc. In the normal operation of the Site Subscriber timesheets (including information entered by “staff” members) and invoices are disclosed to the applicable Clients, and Client information is disclosed to the applicable Subscriber. In general, information you enter on the Site is available to the other persons – whether they are Clients, Subscribers, staff members or others – to whom you give access to your account or to whom you give access to the information through the normal operation of the Site.</p>\n                      <p>Payment Information. We use credit card and other personally identifiable information you submit to us on the Site, and other information that we collect, as required, to process payments you make through the Site through our payment processor intermediaries. We do not store credit card or other payment method information. In all cases our payment processors have the sole and complete responsibility for the storage of credit card and payment information. We may also share personally identifiable information with our payment processor intermediaries for risk management and fraud prevention.</p>\n                      <p>Related third party products and services. From time to time, we may offer you opportunities to receive related products and services that integrate with, or complement, the services we offer via the Site. We will only share your information with such third parties if you choose to request their products or services (or to be assessed for eligibility to receive such products or services). If you do choose to request such products or services, we will provide your information to the relevant third party on your behalf, as required to provide the products or services you have requested. We do not control the use, storage, retention, processing, or disclosure of your information by such third parties, and this Privacy Policy will not apply to them. Your relationship with these third parties will generally be subject to their separate terms and conditions as well as privacy policies or statements, and we recommend that you carefully review these documents before requesting their products or services.</p>\n                      <p>Anonymized Aggregated Data. We aggregate and anonymize sales information including (but not limited to) industry type, number of tasks processed, number of hours logged, number of invoices sent, average invoice size, and disclose such information in a non-personally identifiable manner to Subscribers. However, in these situations, we do not disclose any information that could be used to identify you personally.</p>\n                      <p>Subsidiaries and Affiliates; Service Providers. We may from time to time use the services of affiliates, subsidiaries and unrelated service providers in the operation of the Site, and may disclose personal information to them in the course of our use of their services. For example, we may use the services of third-party hosting companies to host the operation of the Site. This may involve the hosting of data, including personal information, on servers operated by those hosting companies. We take care to use only service providers that are reputable and able to live up to our and your expectations, including about the handling of confidential information, and specifically try to only partner with companies who can verify their GDPR compliance. These companies are authorized to use your personal information only as necessary to provide these services to us.</p>\n                      <p>Legal Requests and Business Transitions; Emergencies. In certain situations, Openmotive may be required to disclose personal data in response to lawful requests by public authorities, including to meet national security or law enforcement requirements. Openmotive may disclose your personal information (a) to any governmental authority as part of an investigation to determine our compliance with any applicable law, rule, or regulation (including privacy laws, rules, and regulations), (b) in response to a court order, subpoena, discovery request, or other lawful judicial or administrative proceeding, (c) as otherwise required under any applicable law, rule, or regulation, and (d) in good faith, to protect or defend the rights or property of Openmotive and other users and (e) if Openmotive is involved in a merger, acquisition, or sale of all or a portion of its assets, you will be notified via email and/or a prominent notice on our Web site of any change in ownership or uses of your personal information, as well as any choices you may have regarding your personal information.</p>\n                      <h3>Your Use of Other Persons’ Information</h3>\n                      <p>In order to facilitate the services provided by the Site, the Site allows you in certain circumstances to give other Users limited access to the personal information of other persons. For example, if you are a Subscriber, you may use the Site to give access to a staff member to the personal information of your Clients. By entering into our Terms of Use, you agree that, with respect to the personal information of other persons that you collect, use and disclose on the Site, you have all necessary consents and rights to collect, use and disclose that information as described in this Privacy Policy from time to time, and you agree that the indemnity you give to us in the Terms of Use applies to any non-compliance by you with the foregoing.</p>\n                      <p>If you choose to use our referral service to tell a friend about our site, we will ask you for your friend’s name and email address. We will automatically send your friend a one-time email inviting him or her to visit the site. Adminja stores this information for the sole purpose of sending this one-time email and tracking the success of our referral program. Your friend may contact us at help@getadminja.com to request that we remove this information from our database.</p>\n                      <p>Adminja does not own, control, or direct the use of any of the Client Data stored or processed by a Client or Subscriber via the service. Only the Client or Subscriber are entitled to access, retrieve and direct the use of such Client Data. Adminja is largely unaware of what Client Data is actually being stored or made available by a Client or Subscriber to the Service and does not directly access such Client Data except as authorized by the Client, or as necessary to provide Services to the Subscriber or their Clients.</p>\n                      <p>Because Adminja does not collect or determine the use of any Personal Data contained in the Client Data and because it does not determine the purposes for which such Personal Data is collected, the means of collecting such Personal Data, or the uses of such Personal Data, Adminja is not acting in the capacity of a data controller in terms of the European Union\'s Directive 95/46/EC on data privacy or other European Data Protection Regulation (\"EU Law\") and does not have the associated responsibilities under EU Law. Adminja should be considered only as a processor on behalf of it\'s Subscribers and their Clients as to any Client Data containing Personal Data that is subject to the requirements of the EU Law. Except as provided in this Privacy Policy, Adminja does not independently cause Client Data containing Personal Data stored in connection with the Service to be transferred or otherwise made available to third parties, except to third party subcontractors who may process such data on behalf of Adminja in connection with Adminja\'s provision of Services to it\'s Subscribers and Clients. Such actions are performed or authorized only by the applicable Subscriber or Client.</p>\n                      <p>Adminja is not responsible for the content of the Personal Data contained in Client Data or other information stored on its servers (or its subcontractor\'s servers) at the discretion of the Subscriber or Client nor is Adminja responsible for the manner in which the Subscriber or Client collects, handles disclosure, distributes or otherwise processes such information.</p>\n                      <h3>Security</h3>\n                      <p>Adminja strives to protect your personal information. For security of transactions, we use the Secure Sockets Layer (SSL) protocol, which encrypts any information, such as credit card number and billing information, you send to us electronically. The encryption process protects your information, by scrambling it before it is sent to us from your computer. Once Adminja receives your transmission, we make commercially reasonable efforts to ensure its security on our system. </p>\n                      <p>Adminja has been built on the Google Cloud Platform. All of your data, authentication information, data storage and secure communication with Adminja is being seamlessly managed via Google\'s Cloud Platform.</p>\n                      <p>All information is encrypted at multiple levels, even at rest, to ensure that subscribers and their client\'s data are secure from unauthorized access.</p>\n                      <p>For more information about the security of your data, please see this article on Google Cloud Platform Security: https://cloud.google.com/security/</p>\n                      <p>Unfortunately, no data transmission over the Internet can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, we cannot warrant the security of any information you transmit to us. If you have any questions about the security of your personal information, you can contact us at help@getadminja.com.</p>\n                      <h3>Other Information Collectors</h3>\n                      <p>Except as otherwise expressly included in this Privacy Policy, this document only addresses the use and disclosure of information we collect from you. To the extent that you disclose your information to other parties through the Site, whether they are Subscribers or Clients or otherwise, different rules may apply to their use, collection and disclosure of the personal information you disclose to them. Since we do not control the information use, collection or disclosure policies of third parties, you are subject to their privacy policies. We encourage you to ask questions before you disclose your personal information to others.</p>\n                      <h3>Correcting and Updating Your Personal Information</h3>\n                      <p>Upon request Adminja will provide you with information about whether we hold any of your personal information as well as a copy of ALL information on you that we hold. In general, to review, delete and update your personal information to ensure it is accurate, you may login into your account to make the changes, or you may contact us at help@getadminja.com. We will respond to your request within a reasonable timeframe.</p>\n                      <h3>Account Deletion</h3>\n                      <p>Adminja manages a business eco system that brings together Virtual Assistants, and Clients. This network relies on the exchange and sharing of information that is important to others in your network. Tracked hours, sent invoices, paid invoices may be vital to other people that work with you on the same Client. These are the official history of work done and moneys paid.</p>\n                      <p>The complexity and connected nature of the system requires that this history exists for the life of the Client to accommodate proper function and accounting for the other systems via tasks, hours, invoices, and payments. If you are collaborating with other Subscribers, Adminja cannot guarantee the deletion of this particular slice of your information should you choose to delete your personal account.</p>\n                      <p>When a customer chooses to close an account we will remove your information from our marketing and billing systems. This will ensure that there are not further mailings or billings directed towards the canceled user. After 30 days, the account will be deleted along with any Client information that was owned by it and is not tied to another User account.</p>\n                      <h3>Data Retention</h3>\n                      <p>We will retain your information for as long as your account is active or as needed to provide you services. We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.</p>\n                      <h3>Additional Policy Information</h3>\n                      <p>Invitations: You have the opportunity to invite others to work with you through your Adminja account. To do that, Adminja asks you to manually enter your contacts’ email addresses. As you direct, we then send them an invitation on your behalf or other notices reflecting changes you make to their status in your account.</p>\n                      <p>If you click on a link to a third-party site, you will leave the Adminja site and go to the site you selected. If you elect to use a third-party product or service in conjunction with Adminja, you yourself enter into a license agreement with the third party for use of their product or service and their use of your data. Because we cannot control the activities of third parties, we cannot accept responsibility for any use of your personal information by such third parties, and we cannot guarantee that they will adhere to the same privacy practices as Adminja. We encourage you to review the privacy policies of any other service provider from whom you request services. If you visit a third party website that is linked to an Adminja site, you should read that site’s privacy policy before providing any personal information.</p>\n                      <p>With your consent we may post your testimonial along with your name. If you want your testimonial removed please contact us at help@getadminja.com.</p>\n                      <p>Our Web site includes some Social Media Features, such as the Facebook and Twitter buttons and Widgets, such as the Share this button or interactive mini-programs that run on our site. These Features may collect your IP address, which page you are visiting on our site, and may set a cookie to enable the Feature to function properly. Social Media Features and Widgets are either hosted by a third party or hosted directly on our Site. Your interactions with these Features are governed by the privacy policy of the company providing it.</p>\n                      <p>If you have questions or complaints regarding our privacy policy or practices, please contact us at help@getadminja.com.</p>\n                      <h3>Notification of Privacy Statement Changes</h3>\n                      <p>We may update this privacy statement to reflect changes to our information practices. If we make any material changes we will notify you by email (sent to the email address specified in your account) or by means of a notice on this Site prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.</p>\n                      <h3>Questions?</h3>\n                      <p>It is our goal to make our privacy practices easy to understand. If you have questions, concerns or if you would like more detailed information, please email us at help@getadminja.com.</p>\n                  </md-content>\n                </md-tab>\n            </md-tabs>\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-checkbox ng-model=\"vm.consent\" aria-label=\"Accept Privacy Policy\" required>\n                           I have read and agree to the Privacy Policy\n                </md-checkbox>\n                <md-button class=\"md-raised md-accent\" ng-disabled=\"getConsent.$invalid || getConsent.$pristine \" ng-click=\"vm.saveConsentAndTimeOffset()\"><span ng-if=\"!vm.settingConsent\">Save and Continue</span><md-icon ng-if=\"vm.settingConsent\" md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon></md-button>\n            </div>\n        </form>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/gateService/subscription-dialog.tmpl.html","<md-dialog md-dynamic-height flex=\"100\" flex-sm=\"70\" flex-md=\"60\" flex-lg=\"50\" flex-xl=\"40\" md-theme=\"grey-menu\" class=\"md-inline-form\" style=\"border-top: 6px solid #0091ea; border-bottom: 6px solid #0091ea; background-color: rgb(240,240,240);\">\n    <h1 class=\"md-title center\" style=\"margin-bottom: 0;\">{{vm.title}}</h1>\n    <p class=\"center md-subhead\">{{vm.message}}</p>\n    <md-dialog-content style=\"background-color: rgb(240,240,240);\">\n      <subscription-manager user=\"vm.user\"></subscription-manager>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/leadDataService/dialog-edit-contact.tmpl.html","<md-dialog flex=\"100\" flex-md=\"50\" flex-gt-md=\"40\" md-theme=\"grey-menu\" class=\"item-dialog lead-activity-dialog md-inline-form\">\n    <form name=\"vm.forms.contactForm\" novalidate>\n        <md-dialog-content>\n            <div class=\"lead-dialog-header\">\n                <h3 class=\"center margin-0\">Log Lead Activity</h3>\n            </div>\n\n            <div style=\"padding: 16px 16px 0 16px;\">\n                <div layout=\"row\" layout-align=\"fill center\">\n                    <md-input-container flex=\"50\" class=\"margin-bottom-0 margin-top-30 padding-right: 30\" >\n                        <label>Lead:</label>\n                        <md-select required ng-model=\"vm.contact.lead\" ng-disabled=\"vm.contact.uid\" ng-change=\"vm.setLead(vm.contact.lead)\">\n                            <md-option ng-value=\"lead.uid\" ng-if=\"lead.status == \'active\'\" ng-repeat=\"lead in vm.leads | toArray: false | filter: {\'status\': \'active\'} | orderBy: \'order\' track by $index+uid\">\n                                <md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{vm.stageColor(lead.leadType)}};\"></md-icon> {{lead.firstName}} {{lead.lastName}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                    <md-input-container flex=\"50\" class=\"margin-bottom-0 margin-top-30 padding-right: 30\">\n                        <label>Contact Type:</label>\n                        <md-select required ng-model=\"vm.contact.type\" ng-change=\"vm.setType(vm.contact.type)\">\n                            <md-option ng-value=\"contactType.uid\" ng-repeat=\"contactType in vm.contactTypes | toArray: false | orderBy: \'order\' track by $index+uid\">\n                                <md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{contactType.color}};\"></md-icon> {{contactType.label}}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n                </div>\n\n                <div class=\"contact-description-container\" ng-if=\"vm.showContactForm\" style=\"margin-top: 3em;\">\n                    <div style=\"\" froala=\"vm.froalaOptions\" ng-model=\"vm.contact.description\">\n                    </div>\n                    <!-- <text-angular placeholder=\"Describe the lead activity...\" name=\"description-editor\" ng-model=\"vm.contact.description\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'bold\',\'italics\',\'underline\',\'insertLink\']]\" ></text-angular> -->\n                    <file-attachment-list form=\"vm.forms.contactForm\" files=\"vm.contact.files\" removeable=\"true\"></file-attachment-list>\n                    <file-picker files=\"vm.contact.files\" form=\"vm.forms.contactForm\" counter=\"vm.contact.files.length\" filepath=\"\'/leadBoards/\' + vm.contact.leadBoard\"></file-picker>\n                </div>\n\n            </div><!-- end form container-->\n         <md-dialog-actions style=\"border-top: none; margin-top: 0; padding-top: 0;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n            <div flex=\"auto\" ng-if=\"vm.contact.uid\">\n                <p class=\"md-subhead\" style=\"font-size: 12px; color: #999;\"><strong>Created</strong> {{vm.contact.timeStamp | amDateFormat: vm.settings.longDateFormat}} {{vm.contact.timeStamp | amDateFormat: \'h:mm a\'}}\n                    <span ng-if=\"vm.contact.lastUpdate\"><br><strong>Last updated</strong> {{vm.contact.lastUpdate | amDateFormat: vm.settings.longDateFormat}} {{vm.contact.lastUpdate | amDateFormat: \'h:mm a\'}}</span>\n                </p>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.contact.uid\">\n                <md-button ng-disabled=\"vm.forms.contactForm.$invalid || vm.forms.contactForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateContact(vm.contact)\">\n                    Update\n                </md-button>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.contact.uid\" >\n                <md-button ng-disabled=\"vm.forms.contactForm.$invalid || vm.forms.contactForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewContact(vm.contact)\">\n                    Save\n                </md-button>\n\n            </div>\n         </md-dialog-actions>\n        </md-dialog-content>\n    </form>\n</md-dialog>\n");
$templateCache.put("app/app-services/leadDataService/dialog-edit-lead-task.tmpl.html","<md-dialog flex=\"100\" flex-md=\"50\" flex-gt-md=\"40\" md-theme=\"grey-menu\" class=\"item-dialog lead-activity-dialog md-inline-form\">\n    <form name=\"vm.forms.leadTaskForm\" novalidate>\n        <md-dialog-content>\n            <div class=\"lead-dialog-header\">\n                <h3 class=\"center margin-0\"><strong>Todo for:</strong> {{vm.lead.firstName}} {{vm.lead.lastName}}</h3>\n            </div>\n\n            <div style=\"padding: 16px 16px 0 16px;\">\n\n                <div class=\"contact-description-container\">\n                    <div style=\"\" froala=\"vm.froalaOptions\" ng-model=\"vm.leadTask.description\">\n                    </div>\n                    <!-- <text-angular placeholder=\"What do you need to do?\" name=\"description-editor\" ng-model=\"vm.leadTask.description\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'bold\',\'italics\',\'underline\',\'insertLink\']]\" ></text-angular> -->\n                    <file-attachment-list form=\"vm.forms.leadTaskForm\" files=\"vm.leadTask.files\" removeable=\"true\"></file-attachment-list>\n                    <file-picker files=\"vm.leadTask.files\" form=\"vm.forms.leadTaskForm\" counter=\"vm.leadTask.files.length\" filepath=\"\'/leadBoards/\' + vm.leadTask.owner + \'/leads/\' + vm.leadTask.lead + \'/tasks/\' + vm.leadTask.uid\"></file-picker>\n                </div>\n\n            </div><!-- end form container-->\n         <md-dialog-actions style=\"border-top: none; margin-top: 0; padding-top: 0;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n            <div flex=\"auto\" ng-if=\"vm.lead.uid\">\n                <p class=\"md-subhead\" style=\"font-size: 12px; color: #999;\"><strong>Created</strong> {{vm.lead.timeStamp | amDateFormat: vm.settings.longDateFormat}} {{vm.lead.timeStamp | amDateFormat: \'h:mm a\'}}\n                    <span ng-if=\"vm.lead.lastUpdate\"><br><strong>Last updated</strong> {{vm.lead.lastUpdate | amDateFormat: vm.settings.longDateFormat}} {{vm.lead.lastUpdate | amDateFormat: \'h:mm a\'}}</span>\n                </p>\n            </div>\n\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.leadTask.timeStamp\">\n                <md-button ng-disabled=\"vm.forms.leadTaskForm.$invalid || vm.forms.leadTaskForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateTask(vm.leadTask)\">\n                    Update\n                </md-button>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.leadTask.timeStamp\" >\n                <md-button ng-disabled=\"vm.forms.leadTaskForm.$invalid || vm.forms.leadTaskForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewTask(vm.leadTask)\">\n                    Save\n                </md-button>\n\n            </div>\n         </md-dialog-actions>\n        </md-dialog-content>\n    </form>\n</md-dialog>\n");
$templateCache.put("app/app-services/leadDataService/dialog-lead-form.tmpl.html","<md-dialog flex=\"100\" flex-md=\"70\" flex-gt-md=\"60\" md-theme=\"grey-menu\" style=\"max-width: 950px;\" class=\"lead-form-dialog md-inline-form padding-20\" >\n    <h3 class=\"center\"><span ng-if=\"vm.thisForm.uid\">{{vm.thisForm.name}}</span> <span ng-if=\"!vm.thisForm.uid\">New Form</span></h3>\n    <form name=\"vm.forms.leadForm\" novalidate ng-if=\"!vm.exportHTML\">\n        <md-dialog-content style=\"overflow-x: hidden;\">\n            <!-- <div class=\"form-header-container\" layout=\"row\" ng-if=\"vm.hideSave\">\n                <p flex=\"70\" class=\"md-subhead\" style=\"\"><strong>Form Name:</strong> {{vm.thisForm.name}}</p>\n                <p flex=\"30\" class=\"md-subhead\" style=\"\"><strong>Form Action:</strong>\n                    <span ng-if=\"vm.thisForm.action == \'createLead\'\">Create a Lead</span>\n                    <span ng-if=\"vm.thisForm.action == \'createTask\'\">Create a Task</span>\n                    <span ng-if=\"vm.thisForm.action == \'createNote\'\">Create a Note</span>\n                    <span ng-if=\"vm.thisForm.action == \'sendEmail\'\">Send an Email</span>\n                </p>\n\n            </div> -->\n            <md-tabs md-dynamic-height  md-stretch-tabs=\"always\" style=\"background-color: #fff; \" md-center-tabs>\n                <md-tab md-on-select=\"vm.hideSave = false\" md-on-deselect=\"vm.hideSave = true\">\n                    <md-tab-label>\n                        Form Settings\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"row\">\n                            <md-input-container flex=\"50\" class=\"margin-bottom-0 margin-right-20\">\n                                <label>Give your form a descriptive internal reference name </label>\n                                <input type=\"text\" id=\"formNameField\" ng-model=\"vm.thisForm.name\" md-autofocus=\"!vm.thisForm.uid\" required>\n                            </md-input-container>\n                            <md-input-container flex=\"50\" class=\"margin-bottom-0 margin-right-20\">\n                                <!-- Main Action -->\n                                <label>What should happen when this form is submitted?</label>\n                                <md-select flex=\"nogrow\" ng-model=\"vm.thisForm.action\"  ng-change=\"vm.changeFormType(vm.thisForm.action)\" style=\"margin-top: 0; margin-bottom: 0;\" required>\n                                    <md-option ng-repeat=\"action in vm.formActions track by $index\" ng-value=\"action.value\">\n                                        {{action.label}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                        </div>\n\n                        <div layout=\"row\" >\n                            <!-- Lead Stage -->\n                            <md-input-container flex=\"50\" ng-if=\"vm.thisForm.action == \'createLead\'\" class=\"margin-bottom-0 margin-right-20\" >\n                                <label>Which lead stage should it go in?</label>\n                                <md-select flex=\"nogrow\" ng-model=\"vm.thisForm.targetList\"  style=\"margin-top: 0; margin-bottom: 0;\" required>\n                                    <md-option value=\"new\">\n                                        New\n                                    </md-option>\n                                    <md-option ng-repeat=\"target in vm.leadDataService.leadBoard.leadTypes | toArray: false | orderBy: [\'order\'] track by $index + uid\" ng-value=\"target.uid\" style=\"border-left: 4px solid {{target.color}};\">\n                                        {{target.label}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <!-- Workspace Selector -->\n                            <md-input-container flex=\"50\" ng-if=\"vm.thisForm.action == \'createTask\' || vm.thisForm.action == \'createNote\'\" class=\"margin-bottom-0 margin-right-20\">\n                                <label>Select a target Workspace</label>\n                                <md-select flex=\"nogrow\" ng-model=\"vm.thisForm.targetWorkspace\" ng-change=\"vm.setWorkspace(vm.thisForm.targetWorkspace)\" style=\"margin-top: 0; margin-bottom: 0;\" required>\n                                    <md-option ng-if=\"workspace.owner == vm.userID\" ng-repeat=\"workspace in vm.clientDataService.clients track by $index + uid\" ng-value=\"workspace.uid\" style=\"border-left: 4px solid {{workspace.profile.clientColor}};\">\n                                        {{workspace.profile.fullName}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <!-- Task List Selector -->\n                            <md-input-container flex=\"50\" ng-if=\"vm.thisForm.action == \'createTask\' && vm.selectedWorkspace\" class=\"margin-bottom-0 margin-right-20\">\n                                <label>Which Task List should it go in?</label>\n                                <md-select flex=\"nogrow\" ng-model=\"vm.thisForm.targetList\"  style=\"margin-top: 0; margin-bottom: 0;\" required>\n                                    <md-option value=\"Later\">\n                                        New Tasks\n                                    </md-option>\n                                    <md-option ng-repeat=\"list in vm.selectedWorkspace.taskpanels | toArray: false | orderBy: [\'order\'] track by $index + uid\" ng-value=\"list.uid\" style=\"border-left: 4px solid {{list.color}};\">\n                                        {{list.label}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <!-- Detail List Selector -->\n                            <md-input-container flex=\"50\" ng-if=\"vm.thisForm.action == \'createNote\' && vm.selectedWorkspace\" class=\"margin-bottom-0 margin-right-20\">\n                                <label>Which Detail List should it go in?</label>\n                                <md-select flex=\"nogrow\" ng-model=\"vm.thisForm.targetList\"  style=\"margin-top: 0; margin-bottom: 0;\" required>\n                                    <md-option ng-repeat=\"list in vm.selectedWorkspace.panels | toArray: false | orderBy: [\'order\'] track by $index + uid\" ng-value=\"list.uid\" style=\"border-left: 4px solid {{list.color}};\">\n                                        {{list.label}}\n                                    </md-option>\n                                </md-select>\n                            </md-input-container>\n\n                            <!-- Email Field -->\n                            <md-input-container flex=\"50\" ng-if=\"vm.thisForm.action == \'sendEmail\'\" class=\"margin-bottom-0 margin-right-20\">\n                                <label>Email address</label>\n                                <input type=\"email\" name=\"email\" ng-model=\"vm.thisForm.target\" required>\n                                <div ng-messages=\"vm.thisForm.target.$error\">\n                                      <div ng-message=\"required\">Please provide a valid E-mail address!</div>\n                                </div>\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\">\n                            <md-input-container class=\"margin-bottom-0 margin-top-40 margin-right-40\">\n                                <label>Form Instructions (optional)</label>\n                                <textarea ng-model=\"vm.thisForm.instructions\"></textarea>\n                            </md-input-container>\n                        </div>\n                        <div layout=\"row\" layout-align=\"layout-fill center\">\n                            <div flex=\"50\" layout=\"column\" layout-align=\"start layout-fill\" class=\"\">\n                                <div ng-if=\"!vm.thisForm.useCustomResponse\" style=\"height: 90px;\">\n                                    <md-checkbox ng-model=\"vm.thisForm.useCustomResponse\">Use your own custom confirmation page?</md-checkbox>\n                                </div>\n                                <div layout=\"row\" layout-align=\"start center\">\n                                    <md-input-container flex=\"grow\" style=\"margin:2em 1em 0 0;\" ng-if=\"vm.thisForm.useCustomResponse\">\n                                        <label>Custom confirmation URL</label>\n                                        <input type=\"url\" required placeholder=\"https://www.yourdomain.com/confirmation-page\" ng-model=\"vm.thisForm.responseURL\">\n                                    </md-input-container>\n                                    <md-button class=\"md-icon-button\" flex=\"nogrow\" ng-if=\"vm.thisForm.useCustomResponse\" ng-click=\"vm.thisForm.responseURL = \'\'; vm.thisForm.useCustomResponse = false\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n                                </div>\n                            </div>\n\n                        </div>\n\n\n                    </md-tab-body>\n                </md-tab>\n                <md-tab ng-disabled=\"!vm.thisForm.uid\">\n                    <md-tab-label>\n                        Manage Default Fields\n                    </md-tab-label>\n                  <md-tab-body>\n                    <p class=\"md-subhead center\" style=\"font-size: .85em;\">Any default fields you enable will appear at the top of your form BEFORE any custom fields you create.</p>\n                    <div  style=\"max-height: 400px; overflow-y: scroll; padding-right: 20px;\">\n\n                        <!-- item -->\n                        <div class=\"lead-category-container default-fields-container\" dragula=\"\'drag-fields\'\" dragula-scope=\"$scope\">\n                        <div catid=\"{{field.nodeName}}\"\n                            ng-repeat=\"field in vm.thisForm.fields | orderBy:  [\'order\'] track by $index\"\n                            class=\"category-item lead-category-item\"\n                             layout=\"row\"\n                             layout-align=\"start center\">\n                            <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\">\n                                <md-icon md-font-icon=\"fa fa-reorder\"></md-icon>\n                            </md-button>\n                            <!-- <div class=\"lead-group-swatch\" style=\"background-color: {{category.color || \'#fff\'}};\">\n                            </div> -->\n                            <p flex=\"auto\" class=\"md-subhead\"><span ng-class=\"{\'weak\': !field.on}\" >{{field.label}}</span></p>\n\n                            <md-checkbox  ng-disabled=\"field.leadRequired && vm.thisForm.action == \'createLead\'\" ng-change=\"vm.updateLeadForm(vm.thisForm)\" ng-model=\"field.on\">On</md-checkbox>\n                            <!-- <md-button ng-click=\"removeCategory(category)\" flex=\"nogrow\" class=\"md-button-small\">\n                                <md-icon md-font-icon=\"fa fa-trash\"></md-icon>\n                            </md-button> -->\n\n                        </div>\n                        </div>\n                        <!-- <md-button ng-if=\"!showCategoryForm\" class=\"md-accent\" ng-click=\"toggleCategoryForm(true)\">+ Add</md-button> -->\n                    </div><!-- scrollable area -->\n                  </md-tab-body>\n                </md-tab>\n                <md-tab  ng-disabled=\"!vm.thisForm.uid\">\n                    <md-tab-label>\n                        Manage Custom Fields\n                    </md-tab-label>\n                  <md-tab-body>\n                    <div  style=\"max-height: 400px; overflow-y: scroll; padding-right: 20px;\">\n\n                        <!-- item -->\n                        <div class=\"lead-category-container custom-fields-container\" dragula=\"\'drag-custom-fields\'\" dragula-scope=\"$scope\">\n                        <div ng-if=\"!vm.showAddForm\"\n                            catid=\"{{field.nodeName}}\"\n                            ng-repeat=\"field in vm.thisForm.customFields | toArray : false | orderBy:  \'order\' track by $index\"\n                            class=\"category-item lead-category-item custom-field-item\"\n                             layout=\"row\"\n                             layout-align=\"start center\">\n                            <md-button flex=\"10\" style=\"cursor: grab;\" class=\"md-button-small drag-handle\">\n                                <md-icon md-font-icon=\"fa fa-reorder\"></md-icon>\n                            </md-button>\n                            <!-- <p flex=\"10\" style=\"font-size: .65em;\">\n                                {{field.type}}\n                            </p> -->\n                            <div ng-if=\"field.type == \'text\'\" flex=\"65\">\n                                    <label>{{field.label}}</label><br>\n                                    <input type=\"text\" ng-disabled=\"true\" name=\"{{field.nodeName}}\">\n                            </div>\n                            <div ng-if=\"field.type == \'textarea\'\" flex=\"65\">\n                                    <label>{{field.label}}</label><br>\n                                    <textarea ng-disabled=\"true\" name=\"{{field.nodeName}}\'\" style=\"min-height: 50px; max-height: 50px;\"></textarea>\n                            </div>\n                            <div ng-if=\"field.type == \'select\'\" flex=\"65\">\n                                    <label>{{field.label}}</label><br>\n                                    <select name=\"{{field.nodeName}}\" >\n                                      <option ng-repeat=\"option in vm.splitOptions(field.options) track by $index\" value=\"{{option}}\">{{option}}</option>\n                                    </select>\n                            </div>\n                            <div ng-if=\"field.type ==\'label\'\" flex=\"65\">\n                                <label>{{field.label}}</label>\n                            </div>\n                            <div ng-if=\"field.type ==\'divider\'\" flex=\"65\">\n                                <hr>\n                            </div>\n                            <div ng-if=\"field.type ==\'heading\'\" flex=\"65\">\n                                <h3 style=\"margin:0; padding:0;\">{{field.label}}</h3>\n                            </div>\n\n                            <div ng-if=\"field.type ==\'paragraph\'\" flex=\"65\">\n                                <label>{{field.label}}</label>\n                            </div>\n\n                            <div ng-if=\"field.type ==\'spacer\'\" flex=\"65\">\n                                <p style=\"color: #bbb;\">Spacer</p>\n                            </div>\n\n                            <div ng-if=\"field.type == \'checkbox\'\" flex=\"65\">\n                                <md-input-container class=\"margin-top-0 margin-bottom-0\">\n                                    <md-checkbox ng-disabled=\"true\" name=\"{{field.nodeName}}\"></md-checkbox> {{field.label}}\n                                </md-input-container>\n                            </div>\n\n                            <div flex=\"15\" style=\"font-size: .85em;\">\n                                <span ng-if=\"field.required\" style=\"color: red;\">&nbsp; required</span>\n                            </div>\n                            <div flex=\"10\">\n                                <md-button ng-click=\"vm.removeField(field)\" flex=\"nogrow\" class=\"md-button-small\">\n                                    <md-icon md-font-icon=\"fa fa-trash\"></md-icon>\n                                </md-button>\n                            </div>\n                            <div flex=\"10\">\n                                <md-button ng-click=\"vm.editField(field)\" flex=\"nogrow\" class=\"md-button-small\">\n                                    <md-icon md-font-icon=\"fa fa-edit\"></md-icon>\n                                </md-button>\n                            </div>\n\n                        </div>\n                        </div>\n                        <!-- <md-button ng-if=\"!showCategoryForm\" class=\"md-accent\" ng-click=\"toggleCategoryForm(true)\">+ Add</md-button> -->\n                    </div><!-- scrollable area -->\n\n                     <div ng-if=\"vm.customFieldLength() > 9\">\n                         <p class=\"md-subhead center\">You\'ve reached the 10 question maximum.</p>\n                     </div>\n                    <div  class=\"add-field-form\" ng-if=\"vm.showAddForm || vm.showEditForm\" layout=\"column\" style=\"margin-top: 20px;\">\n                        <h4 class=\"center\">\n                            <span ng-if=\"vm.showAddForm\">Add a</span>\n                            <span ng-if=\"vm.showEditForm\">Edit </span>\n                            <span ng-if=\"vm.newField.type == \'text\'\">Small Text Field</span>\n                            <span ng-if=\"vm.newField.type == \'textarea\'\">Large Text Field</span>\n                            <span ng-if=\"vm.newField.type == \'select\'\">Drop Down Field</span>\n                            <span ng-if=\"vm.newField.type == \'checkbox\'\">Checkbox Field</span>\n                            <span ng-if=\"vm.newField.type == \'heading\'\">Heading</span>\n                            <span ng-if=\"vm.newField.type == \'spacer\'\">Spacer</span>\n                            <span ng-if=\"vm.newField.type == \'divider\'\">Divider</span>\n                        </h4>\n                        <div layout=\"row\" layout-align=\"start start\">\n                            <div layout=\"column\" flex=\"50\">\n                                <md-input-container flex=\"50\" class=\"\" style=\"margin-right: 40px;\">\n                                    <label>Type</label>\n                                    <md-select ng-model=\"vm.newField.type\">\n                                        <md-option value=\"text\">\n                                            Small Text Field\n                                        </md-option>\n                                        <md-option value=\"textarea\">\n                                            Large Text Field\n                                        </md-option>\n                                        <md-option value=\"select\">\n                                            Select from Drop Down Field\n                                        </md-option>\n                                        <md-option value=\"checkbox\">\n                                            Checkbox Field\n                                        </md-option>\n                                        <md-option value=\"heading\">\n                                            Heading\n                                        </md-option>\n                                        <md-option value=\"label\">\n                                            Subheading\n                                        </md-option>\n                                        <md-option value=\"paragraph\">\n                                            Paragraph\n                                        </md-option>\n                                        <md-option value=\"spacer\">\n                                            Spacer\n                                        </md-option>\n                                        <md-option value=\"divider\">\n                                            Divider\n                                        </md-option>\n\n                                    </md-select>\n                                </md-input-container>\n                            </div>\n                            <div layout=\"row\" layout-align=\"start center\" flex=\"50\">\n                                <md-input-container class=\"margin-bottom-0\">\n                                    <md-checkbox flex=\"nogrow\"ng-if=\"vm.newField.type != \'heading\' && vm.newField.type != \'checkbox\' && vm.newField.type != \'label\' && vm.newField.type != \'paragraph\' && vm.newField.type != \'divider\' && vm.newField.type != \'spacer\'\" flex=\"50\" ng-model=\"vm.newField.required\">Required?</md-checkbox>\n                                </md-input-container>\n                            </div>\n                        </div>\n                         <md-input-container flex=\"auto\" class=\" margin-right: 40\" class=\"margin-bottom-0\">\n                             <label ng-if=\"vm.newField.type != \'heading\' && vm.newField.type != \'label\' && vm.newField.type != \'paragraph\' && vm.newField.type != \'divider\' && vm.newField.type != \'spacer\'\">Question</label>\n                             <label ng-if=\"vm.newField.type == \'heading\'  || vm.newField.type == \'label\' || vm.newField.type == \'paragraph\'\">Text</label>\n                             <!-- <label ng-if=\"vm.newField.type == \'spacer\'  || vm.newField.type == \'divider\'\">Unique Label</label> -->\n                             <input ng-if=\"vm.newField.type != \'spacer\' && vm.newField.type != \'divider\'\" type=\"text\" adminja-enter=\"vm.saveNewField(vm.newField)\"  id=\"focusfield\" ng-model=\"vm.newField.label\">\n                             <!-- <span style=\"font-size: .85em;\" ng-if=\"vm.newField.type == \'spacer\'  || vm.newField.type == \'divider\'\">Give each {{vm.newField.type}} a unique internal name (e.g. {{vm.newField.type}} 1, {{vm.newField.type}} 2, etc.)</span> -->\n                         </md-input-container>\n                        <md-input-container ng-if=\"vm.newField.type == \'select\'\" class=\"margin-top-0 margin-bottom-0\">\n                            <label>Options (one per line):</label>\n                            <textarea ng-model=\"vm.newField.options\"></textarea>\n                        </md-input-container>\n                        <div layout=\"row\" flex=\"auto\" layout-align=\"center end\" style=\"\">\n                            <md-button flex=\"nogrow\" ng-click=\"vm.cancelAddField()\">\n                                Cancel\n                            </md-button>\n                            <div ng-if=\"vm.showAddForm\">\n                                <md-button ng-if=\"vm.newField.type != \'divider\' && vm.newField.type != \'spacer\'\" class=\"md-raised md-accent\" flex=\"nogrow\" ng-disabled=\"vm.newField.label == \'\'\" ng-click=\"vm.saveNewField(vm.newField)\">\n                                    Add\n                                </md-button>\n                                <md-button ng-if=\"vm.newField.type == \'divider\' || vm.newField.type == \'spacer\'\" class=\"md-raised md-accent\" flex=\"nogrow\"  ng-click=\"vm.saveNewField(vm.newField)\">\n                                    Add\n                                </md-button>\n                            </div>\n                            <div ng-if=\"vm.showEditForm\">\n                                <md-button ng-if=\"vm.newField.type != \'divider\' && vm.newField.type != \'spacer\'\" class=\"md-raised md-accent\" flex=\"nogrow\" ng-disabled=\"vm.newField.label == \'\'\" ng-click=\"vm.updateField(vm.newField)\">\n                                    Update\n                                </md-button>\n                                <md-button ng-if=\"vm.newField.type == \'divider\' || vm.newField.type == \'spacer\'\" class=\"md-raised md-accent\" flex=\"nogrow\"  ng-click=\"vm.updateField(vm.newField)\">\n                                    Update\n                                </md-button>\n                            </div>\n                        </div>\n\n\n                     </div><!-- add field form -->\n\n                     <div layout=\"row\" ng-if=\"!vm.showAddForm\" layout-align=\"center center\" class=\"\">\n                         <md-button ng-click=\"vm.addField()\" class=\"md-raised md-accent\"><md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon> Add a Form Element</md-button>\n                     </div>\n\n                  </md-tab-body>\n                </md-tab>\n\n              </md-tabs>\n\n\n\n\n            <md-dialog-actions  style=\"border-top: none; margin-top: 0; padding-top: 0;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n                   <div flex=\"nogrow\" class=\"button-label-container\">\n                       <md-button class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n                   </div>\n\n                    <md-button ng-if=\"vm.thisForm.uid\" ng-disabled=\"!vm.forms.leadForm.$pristine\" class=\"\" ng-href=\"{{vm.hostingURL}}/#/form/{{vm.thisForm.owner}}/{{vm.thisForm.uid}}\" target=\"_blank\">\n                        View Hosted Form\n                        <md-icon md-font-icon=\"fa fa-external-link\" style=\"font-size: 14px;\"></md-icon>\n                    </md-button>\n                   <md-button type=\"submit\" ng-disabled=\"!vm.forms.leadForm.$pristine\" class=\"\" ng-click=\"vm.exportLeadForm(vm.thisForm)\">\n                       View Embed Code\n                       <md-icon md-font-icon=\"fa fa-code\" style=\"font-size: 14px;\"></md-icon>\n                   </md-button>\n                   <div ng-if=\"vm.thisForm.uid && !vm.hideSave\" flex=\"nogrow\" class=\"button-label-container\" >\n                       <md-button ng-disabled=\"vm.forms.leadForm.$invalid || vm.forms.leadForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateLeadForm(vm.thisForm)\">\n                           Update\n                       </md-button>\n                   </div>\n                   <div ng-if=\"!vm.thisForm.uid && !vm.hideSave\" flex=\"nogrow\" class=\"button-label-container\" >\n                       <md-button ng-disabled=\"vm.forms.leadForm.$invalid || vm.forms.leadForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveLeadForm(vm.thisForm)\">\n                           Save\n                       </md-button>\n                   </div>\n            </md-dialog-actions>\n            <p ng-if=\"vm.thisForm.uid\" style=\"font-size: .85em;\" class=\"center\"><strong>Hosted URL:</strong> {{vm.hostingURL}}/#/form/{{vm.thisForm.owner}}/{{vm.thisForm.uid}}</p>\n\n\n        </md-dialog-content>\n    </form>\n    <div ng-if=\"vm.exportHTML\">\n        <md-dialog-content>\n            <h3 class=\"center\">Embeddable Form</h3>\n            <p class=\"md-subhead\">Paste the following code anywhere in your website to host the form yourself.</p>\n            <div class=\"lead-form-code\" layout=\"row\" layout-align=\"center start\">\n                <textarea flex=\"auto\" id=\"copycode\" ng-bind=\"vm.HTML\" style=\"color: #88fb30; background-color: #000; padding: 1em; font-size: 14px;\"></textarea>\n            </div>\n            <md-dialog-actions style=\"border-top: none; margin-top: 0; padding-top: 0;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n\n               <div flex=\"nogrow\" >\n                   <md-button class=\"\" ng-click=\"vm.cancelDialog()\">Cancel</md-button>\n               </div>\n                <div flex=\"nogrow\"  >\n                    <md-button type=\"submit\" class=\"\" ng-click=\"vm.exportHTML = false\">\n                        <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n                        Return to Editor\n                    </md-button>\n                </div>\n               <div flex=\"nogrow\"  >\n                   <md-button type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.copyLeadForm()\">\n                       Copy to clipboard\n                   </md-button>\n               </div>\n\n\n            </md-dialog-actions>\n        </md-dialog-content>\n    </div>\n</md-dialog>\n");
$templateCache.put("app/app-services/leadDataService/leadBottomSheet.tmpl.html","<md-bottom-sheet class=\"no-padding lead-bottom-sheet\">\n	<form name=\"vm.forms.leadForm\" form-on-change=\"vm.updateLead(vm.lead)\">\n	        <div ng-if=\"!vm.lead.timeStamp\" class=\"lead-dialog-header\">\n	            <h3 class=\"center md-subhead margin-0\">New Lead</h3>\n	        </div>\n	        <md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\" md-stretch-tabs=\"never\" md-center-tabs=\"true\" style=\"margin-top: -10px;\">\n	            <!-- General Task Details -->\n	            <md-tab>\n	                <md-tab-label>\n	                  <span class=\"tab-label\" style=\"padding: 0 4em 0 4em;\"><md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>Key Details</span>\n	                </md-tab-label>\n	                <md-tab-body>\n	                	<div layout=\"row\" layout-align=\"center start\" class=\"margin-top-40\">\n	                		<!-- Details left column -->\n	                		<div flex=\"50\" layout=\"column\" layout-align=\"start start\" class=\"sheet-column\">\n	                			<!-- avatar & primary details -->\n	                			<div layout=\"row\">\n	                				<div flex=\"30\" style=\"padding-right: 1em;\" layout=\"column\">\n	                					<avatar parent=\"vm.lead\" upload=\"true\"></avatar>\n	                				</div>\n	                				<div flex=\"auto\" layout=\"column\" style=\"padding-left: 20px;\">\n	                					<!-- name row -->\n		                				<div flex layout=\"row\">\n		                					<md-input-container flex=\"nogrow\" class=\"margin-bottom-0 margin-top-10\" style=\"margin-right: 20px;\">\n		                					    <label>First Name</label>\n		                					    <input  md-autofocus name=\"firstname\" ng-model=\"vm.lead.firstName\" id=\"focusfield\" required>\n		                					</md-input-container>\n		                					<md-input-container   flex=\"nogrow\" class=\"margin-bottom-0 margin-top-10\">\n		                					    <label>Last Name</label>\n		                					    <input name=\"lastname\" ng-model=\"vm.lead.lastName\" required>\n		                					</md-input-container>\n		                				</div><!-- /name row -->\n\n\n									<md-input-container ng-if=\"vm.editEmail || !vm.lead.email\" flex class=\"margin-bottom-0\" style=\"margin-top: 20px!important;\">\n									    <label>Email</label>\n									    <input   ng-blur=\"vm.checkFields(vm.lead)\" name=\"email\" type=\"email\" ng-model=\"vm.lead.email\">\n									</md-input-container>\n									<div ng-if=\"vm.lead.email && !vm.editEmail\" class=\"edit-field\" style=\"margin-top: 20px; margin-bottom: 16px; margin-left: -20px;\">\n					                       	<p class=\"md-subhead margin-top-0\"><a href=\"mailto:{{vm.lead.email}}\" target=\"_blank\">{{vm.lead.email}}</a></p>\n					                       	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editEmail = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n					                     </div>\n\n									<md-input-container flex class=\"margin-bottom-0 margin-top-10\">\n									    <label>Position</label>\n									    <input name=\"position\" ng-model=\"vm.lead.position\">\n									</md-input-container>\n\n									<md-input-container flex class=\"margin-bottom-0 margin-top-10\">\n									    <label>Business name</label>\n									    <input name=\"company\" ng-model=\"vm.lead.company\">\n									</md-input-container>\n\n\n\n									<md-input-container flex class=\"margin-bottom-0 margin-top-10\">\n									    <label>Phone</label>\n									    <input name=\"phone\" ng-model=\"vm.lead.phone\">\n									</md-input-container>\n\n									<md-input-container flex>\n									    <label>Fax</label>\n									    <input name=\"companyfax\" ng-model=\"vm.lead.companyfax\">\n									</md-input-container>\n\n\n\n\n		                			</div>\n	                			</div><!-- avatar & primary details -->\n	                		</div>\n	                		<!-- Details Right column -->\n	                		<div flex=\"40\" class=\"sheet-column\" class=\"margin-left-20\" style=\"padding-left: 40px; padding-right: 10px; padding-top:0;\">\n	                			<div class=\"lead-metrics\" style=\"\">\n	                				<h3 class=\"md-title text-center margin-bottom-20\">Deal Info</h3>\n	                				<div layout=\"row\">\n		              					<md-input-container flex=\"50\" class=\"margin-top-10 margin-right-20\" style=\"margin-bottom: 32px!important;\">\n		              					    <label>Stage:</label>\n		              					    <md-select ng-change=\"vm.updateLead(vm.lead)\" ng-model=\"vm.lead.leadType\">\n		              					    			<md-option ng-value=\"\'new\'\">\n		              					    				<md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: #999;\"></md-icon> New\n		              					    			</md-option>\n		              					                <md-option ng-value=\"leadType.uid\" ng-repeat=\"leadType in vm.leadTypes | toArray: false | orderBy: \'order\' track by $index+uid\">\n		              					                	<md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{leadType.color}};\"></md-icon> {{leadType.label}}\n		              					                </md-option>\n											</md-select>\n		              					</md-input-container>\n	                					<md-input-container flex=\"50\" class=\"md-block margin-top-0 padding-top-0\"  style=\"margin-bottom: 32px; \">\n	                						<label>Potential Impact</label>\n	                						<input type=\"text\" ng-model=\"vm.lead.size\" placeholder=\"e.g. $300/month\">\n	                					</md-input-container>\n	                				</div>\n\n\n	              					    <!-- <label>Deal Description</label> -->\n	              					    <!-- <text-angular class=\"deal-description\" placeholder=\"What does this deal entail?\" name=\"lead-description-editor\" ng-model=\"vm.lead.description\" ta-min-text=\"5\" ta-toolbar=\"[]\" ></text-angular> -->\n									<div class=\"deal-description\" style=\"\" froala=\"vm.froalaOptions\" ng-model=\"vm.lead.description\">\n									</div>\n\n\n\n\n		                    		<md-input-container flex class=\"md-block\">\n		                    		    <label style=\"font-size: 12px;\">Chance of closing</label>\n		                    		    <div layout=\"row\" layout-align=\"start center\">\n			                    		    <md-slider flex ng-disabled=\"vm.lead.promotedWorkspace\" class=\"md-accent item-budget fade\" min=\"0\" max=\"100\" step=\"5\"  ng-model=\"vm.lead.chance\" ng-init=\"sliders.default=0\" aria-label=\"Chance of closing\" ng-model-options=\"{debounce: 0}\"></md-slider>\n			                    		    <p flex=\"nogrow\" class=\"md-subhead padding-20\">{{vm.lead.chance || 0}}%</p>\n		                    		    </div>\n		                    		</md-input-container>\n								<div layout=\"row\">\n								<p flex=\"50\" class=\"md-subhead small\" ng-if=\"vm.lead.timeStamp\" style=\"font-size: 12px; color: #777;\"><strong>Created</strong> on {{vm.lead.timeStamp | amDateFormat: vm.settings.longDateFormat }}\n									<span ng-if=\"vm.lead.status != \'active\'\"><br><strong style=\"text-transform: capitalize;\">{{vm.lead.status}}</strong> on {{vm.lead.closedDate | amDateFormat: vm.settings.longDateFormat}}</span>\n								</p>\n\n								</div>\n		                    	</div>\n\n	                		</div>\n	                	</div>\n	                </md-tab-body>\n	            </md-tab>\n	            <!-- Address & Links -->\n	            <md-tab>\n	                <md-tab-label>\n	                  <span class=\"tab-label\" style=\"padding: 0 4em 0 4em;\">Address &amp; Links</span>\n	                </md-tab-label>\n	                <md-tab-body>\n	                	<div layout=\"row\" layout-align=\"center start\" class=\"margin-top-40\">\n		                		<div flex=\"40\" class=\"sheet-column\" class=\"margin-left-20\" style=\"padding-left: 40px; padding-right: 40px;\">\n		                			<h3 class=\"md-subhead\" style=\"\">Address</h3>\n								<md-input-container class=\"margin-bottom-10\" style=\"margin-top: 32px!important;\">\n									<label>Street Address</label>\n								    <input placeholder=\"Street Address\" name=\"clientaddress\" ng-model=\"vm.lead.address.street\" type=\"text\" >\n								</md-input-container>\n\n								<md-input-container class=\"margin-top-0 margin-bottom-10\">\n								    <input placeholder=\"Apt/Suite/etc.\" name=\"clientaddress2\" ng-model=\"vm.lead.address.street2\" type=\"text\" >\n								</md-input-container>\n\n								<md-input-container class=\"margin-top-0 margin-bottom-10\">\n								    <input placeholder=\"City or Town\" type=\"text\" name=\"clientcity\" ng-model=\"vm.lead.address.city\" >\n								</md-input-container>\n\n								<div layout=\"row\">\n									<md-input-container flex class=\"margin-top-0 margin-bottom-10\">\n										<label>State/Province</label>\n									    <input placeholder=\"State/Province\" type=\"text\" name=\"clientstate\" ng-model=\"vm.lead.address.state\" >\n									</md-input-container>\n									<md-input-container flex class=\"margin-top-0 margin-bottom-10\"  flex=\"20\">\n										<label>Postal Code</label>\n									    <input placeholder=\"Postal Code\" type=\"text\" name=\"clientzip\" ng-model=\"vm.lead.address.zip\" >\n									</md-input-container>\n								</div>\n\n								<md-input-container class=\"margin-top-0 margin-bottom-10\">\n								    <label>Country</label>\n								    <md-select placeholder=\"Country\" ng-model=\"vm.lead.address.country\">\n								        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n								    </md-select>\n								</md-input-container>\n\n							</div>\n								<div flex=\"40\" class=\"sheet-column\">\n									<h3 class=\"md-subhead\" style=\"padding-left: 20px; margin-bottom: 32px;\">Links</h3>\n\n									<md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editWebsite || !vm.lead.website\" flex class=\"margin-bottom-0 margin-top-10\"\">\n									    <label>Website URL</label>\n									    <input  ng-blur=\"vm.checkFields(vm.lead)\" name=\"companyurl\" ng-model=\"vm.lead.website\" placeholder=\"https://\">\n									</md-input-container>\n\n									<div ng-if=\"vm.lead.website && !vm.editWebsite\" class=\"edit-field\">\n										<label>Website</label>\n										<input style=\"display:none;\" name=\"companyurl\" ng-model=\"vm.lead.website\" placeholder=\"https://\">\n										<p  class=\"md-subhead\"><a href=\"{{vm.lead.website}}\" target=\"_blank\">{{vm.lead.website}}</a></p>\n										<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editWebsite = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n									</div>\n\n								<md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editLinkedin || !vm.lead.linkedin\" flex class=\"margin-bottom-0 margin-top-10\">\n								    <label>LinkedIn Handle</label>\n								    <input ng-blur=\"vm.checkFields(vm.lead)\" name=\"linkedin\" ng-model=\"vm.lead.linkedin\" type=\"text\" placeholder=\"LinkedIn Handle\">\n								</md-input-container>\n								<div ng-if=\"vm.lead.linkedin && !vm.editLinkedin\" class=\"edit-field\">\n									<label>LinkedIn</label>\n									<input  style=\"display:none;\" name=\"linkedin\" ng-model=\"vm.lead.linkedin\" type=\"text\">\n									<p class=\"md-subhead\"><a href=\"https://www.linkedin.com/{{vm.lead.linkedin}}\" target=\"_blank\">https://www.linkedin.com/{{vm.lead.linkedin}}</a></p>\n									<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editLinkedin = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n								</div>\n\n									<md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editTwitter || !vm.lead.twitter\" flex class=\"margin-bottom-0 margin-top-10\">\n				                           <label>Twitter Handle</label>\n				                           <input ng-blur=\"vm.checkFields(vm.lead)\" name=\"twitter\" ng-model=\"vm.lead.twitter\" type=\"text\" placeholder=\"twitterID\">\n				                       </md-input-container>\n				                       <div ng-if=\"vm.lead.twitter && !vm.editTwitter\" class=\"edit-field\">\n				                       	<label>Twitter</label>\n				                       	<input ng-blur=\"vm.checkFields(vm.lead)\" style=\"display:none;\" name=\"twitter\" ng-model=\"vm.lead.twitter\" type=\"text\" placeholder=\"twitterID\">\n				                       	<p  class=\"md-subhead\"><a href=\"https://www.twitter.com/{{vm.lead.twitter}}\" target=\"_blank\">https://www.twitter.com/{{vm.lead.twitter}}</a></p>\n				                       	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editTwitter = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n				                       </div>\n				                       <md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editFacebook || !vm.lead.facebook\" flex class=\"margin-bottom-0 margin-top-10\">\n				                           <label>Facebook Page</label>\n				                           <input ng-blur=\"vm.checkFields(vm.lead)\" name=\"facebook\" ng-model=\"vm.lead.facebook\" type=\"text\" placeholder=\"Facebook ID\">\n				                       </md-input-container>\n\n				                       <div ng-if=\"vm.lead.facebook && !vm.editFacebook\" class=\"edit-field\">\n				                       	<label>Facebook</label>\n				                       	<input ng-blur=\"vm.checkFields(vm.lead)\" style=\"display:none;\" name=\"facebook\" ng-model=\"vm.lead.facebook\" type=\"text\" placeholder=\"Facebook ID\">\n				                       	<p class=\"md-subhead\"><a href=\"https://www.facebook.com/{{vm.lead.facebook}}\" target=\"_blank\">https://www.facebook.com/{{vm.lead.facebook}}</a></p>\n				                       	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editFacebook = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n				                       </div>\n\n									<md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editInstagram || !vm.lead.instagram\" flex class=\"margin-bottom-0 margin-top-10\">\n				                           <label>Instagram Handle</label>\n				                           <input ng-blur=\"vm.checkFields(vm.lead)\" name=\"instagram\" ng-model=\"vm.lead.instagram\" type=\"text\" placeholder=\"Instagram ID\">\n				                       </md-input-container>\n\n				                       <div ng-if=\"vm.lead.instagram && !vm.editInstagram\" flex class=\"edit-field\">\n				                       	<label>Instagram</label>\n				                       	<p  class=\"md-subhead\"><a href=\"https://www.instagram.com/{{vm.lead.instagram}}\" target=\"_blank\">https://www.instagram.com/{{vm.lead.instagram}}</a></p>\n				                       	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editInstagram = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n				                       </div>\n\n	                  					<md-input-container class=\"link-edit-field-input-container\" ng-if=\"vm.editPinterest || !vm.lead.pinterest\" flex class=\"margin-bottom-0 margin-top-10\">\n	                                             <label>Pinterest Handle</label>\n	                                             <input ng-blur=\"vm.checkFields(vm.lead)\" name=\"pinterest\" ng-model=\"vm.lead.pinterest\" type=\"text\" placeholder=\"Pinterest ID\">\n	                                         </md-input-container>\n	                                         <div ng-if=\"vm.lead.pinterest && !vm.editPinterest\" flex class=\"edit-field\">\n	                                         	<label>Pinterest</label>\n	                                         	<p  class=\"md-subhead\"><a href=\"https://www.pinterest.com/{{vm.lead.pinterest}}\" target=\"_blank\">https://www.pinterest.com/{{vm.lead.pinterest}}</a></p>\n	                                         	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editPinterest = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n	                                         </div>\n				                      <!--  <md-input-container ng-if=\"vm.editInstagram\" flex class=\"margin-bottom-0 margin-top-10\">\n				                           <label>Instagram</label>\n				                           <input name=\"instagram\" ng-model=\"vm.lead.instagram\" type=\"text\">\n				                       </md-input-container>\n				                       <div ng-if=\"vm.lead.isntagram && !vm.editInstagram\" class=\"edit-field\">\n				                       	<p class=\"md-subhead\">instagram/{{vm.lead.instagram}}</p>\n				                       	<div class=\"edit-toggle\"><md-icon style=\"font-size: 10px;\"  ng-click=\"vm.editInstagram = \'true\'\" md-font-icon=\"fa fa-edit\"></md-icon></div>\n				                       </div> -->\n				                       <!-- <md-button ng-click=\"vm.checkFields(vm.lead)\">Check Fields</md-button> -->\n				                  </div>\n		                		</div>\n	                	</div>\n	                </md-tab-body>\n	           </md-tab>\n	           <!-- custom fields -->\n	             <md-tab ng-if=\"vm.lead.custom\">\n	                 <md-tab-label>\n	                   <span class=\"tab-label\" style=\"padding: 0 4em 0 4em;\">Custom Questions</span>\n	                 </md-tab-label>\n	                 <md-tab-body>\n	                 	<div layout=\"row\" layout-align=\"center start\" class=\"margin-top-40\">\n 	                		<div flex=\"50\" class=\"sheet-column\" class=\"margin-left-20\" style=\"padding-left: 40px; padding-right: 40px;\">\n 	                			<md-content flex class=\"contact-list-container\">\n 	                			<div  ng-repeat=\"question in vm.lead.custom | toArray: false | orderBy: \'order\' track by $index\" layout=\"column\" class=\"activity-item\">\n 	                			        <div  layout=\"row\" layout-align=\"space-between center\" class=\"activity-header\">\n 	                			            <div flex>\n 	                			                <p class=\"md-title\" style=\"margin-bottom: 0;\">{{question.label}}</p>\n 	                			            </div>\n\n 	                			        </div>\n 	                			        <div ng-if=\"question.type != \'textarea\'\" class=\"contact-description\">\n 	                			        	<p>{{question.value}}</p>\n 	                			        </div>\n 	                			        <div ng-if=\"question.type == \'textarea\'\" class=\"contact-description\"><p style=\"font-family: RobotoDraft, Roboto, \'Helvetica Neue\', sans-serif; font-size: 16px; word-wrap: break-word;\">{{question.value}}</p></div>\n 	                			</div>\n 	                		</md-content>\n 	                		</div>\n	                	</div>\n	                </md-tab-body>\n	           </md-tab>\n\n	           <!-- Activity -->\n	            <md-tab ng-if=\"vm.lead.timeStamp\">\n	                <md-tab-label>\n	                    <span class=\"tab-label\" style=\"padding: 0 4em 0 4em;\"><md-icon md-font-icon=\"fa fa-comments-o\"></md-icon>Lead Activity</span>\n	                </md-tab-label>\n	                <md-tab-body layout-fill>\n		                	<md-content flex class=\"contact-list-container margin-top-20\" >\n		                		<md-card class=\"lead-tasks-container padding-10\" layout=\"column\">\n			                		<lead-activity ng-repeat=\"contact in vm.lead.contacts | toArray: false | orderBy: \'timeStamp\' : true track by ($index + \'-\' + uid)\">\n			                		</lead-activity>\n			                		<div ng-if=\"!vm.lead.contacts\" layout=\"column\" layout-align=\"center center\">\n			                			<p class=\"md-title center\">You haven\'t logged any activity for this lead.</p>\n			                			<md-menu>\n	           			   	            	<md-button  ng-click=\"$mdMenu.open($event)\" class=\"md-adminja-shade-theme md-accent md-raised\" >\n	           			   	            	    <md-icon md-font-icon=\"fa fa-comments-o\"></md-icon>\n	           			   	            	    Log Lead Activity&nbsp;\n	           			   	            	    <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n	           			   	            	</md-button>\n	           			   	                <!-- Trigger element is a md-button with an icon -->\n	           			   	                <md-menu-content class=\"md-dense\">\n	           			   	            	    <md-menu-item class=\"contact-type-menu-item\" ng-repeat=\"contactType in vm.contactTypes | toArray: false | orderBy: \'order\' track by $index + uid\">\n	           			       	                 <md-button ng-click=\"vm.newContact(vm.lead, contactType.uid)\">\n	           			       	                     <md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{contactType.color}};\"></md-icon> {{contactType.label}}\n	           			       	                 </md-button>\n	           			       	             </md-menu-item>\n	           			            	    </md-menu-content>\n	           			            	 </md-menu>\n			                		</div>\n			                	</md-card>\n		                    </md-content>\n	                </md-tab-body>\n	            </md-tab>\n			<!-- Todos -->\n			<md-tab ng-if=\"vm.lead.timeStamp\">\n			   <md-tab-label>\n			       <span class=\"tab-label\" style=\"padding: 0 4em 0 4em;\"><md-icon md-font-icon=\"fa fa-check-square-o\"></md-icon>Todos</span>\n			   </md-tab-label>\n			   <md-tab-body layout-fill>\n			   	<md-content flex class=\"contact-list-container lead-task-list-container margin-top-20\" >\n						<div  layout=\"row\" layout-align=\"end center\" ng-if=\"vm.hasTasks(vm.lead)\">\n							<md-button  ng-click=\"vm.newLeadTask(vm.lead)\"  class=\"md-icon-button\" >\n							    <md-icon md-font-icon=\"zmdi zmdi-plus\" style=\"color: #666; font-size: 16px;\">\n							    	<md-tooltip md-delay=\"500\">\n							    		New Todo\n							    	</md-tooltip>\n							    </md-icon>\n							</md-button>\n						</div>\n						<md-card class=\"lead-tasks-container\" dragula=\"\'drag-lead-tasks\'\" dragula-scope=\"$scope\" layout=\"column\">\n							<div catid=\"{{task.uid}}\"\n							    ng-repeat=\"task in vm.lead.tasks | toArray: false | orderBy: [\'order\'] track by uid+$index\"\n							    class=\"category-item lead-category-item padding-left-10 padding-right-10\"\n							     layout=\"row\"\n							     layout-align=\"start start\"\n							     style=\"border-bottom: 1px solid #efefef;\"\n							     >\n							     <div style=\"padding-top: 4px;\" layout=\"row\" layout-align=\"start center\">\n								     <md-button flex=\"nogrow\" style=\"cursor: grab;\" class=\"md-icon-button drag-handle\">\n								         <md-icon md-font-icon=\"fa fa-reorder\" class=\"drag-handle\"></md-icon>\n								     </md-button>\n								     <md-button flex=\"nogrow\" class=\"md-button-small\" ng-if=\"task.status == \'closed\'\" style=\"cursor: pointer;\">\n								     	<md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check\"  ng-click=\"vm.toggleTask(task, $event)\" style=\"color: green;\">\n								     	    <md-tooltip md-delay=\"1000\">Re-Open</md-tooltip>\n								     	</md-icon>\n								     </md-button>\n								     <md-button flex=\"nogrow\" class=\"md-button-small\" ng-if=\"task.status != \'closed\'\" style=\"cursor: pointer;\">\n								     	<md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\" ng-click=\"vm.toggleTask(task, $event)\" style=\"\">\n								     	    <md-tooltip md-delay=\"1000\">Mark Complete</md-tooltip>\n								     	</md-icon>\n								     </md-button>\n								</div>\n\n								<div flex layout=\"column\" layout-align=\"start start\">\n									<p ng-click=\"vm.editTask(task, vm.lead)\" froala-view=\"task.description\" style=\"cursor: pointer;\" flex=\"grow\" class=\"md-subhead margin-top-0 margin-bottom-0 padding-left-20 padding-right-20\" ></p>\n									<file-attachment-list ng-if=\"task.files\" files=\"task.files\" removeable=\"false\"></file-attachment-list>\n								</div>\n								<div flex=\"nogrow\" ng-if=\"task.status != \'open\'\"  layout=\"row\" layout-align=\"end center\" style=\"padding-right: 16px;\">\n									<p class=\"lead-reminder-date\"><md-icon  style=\"font-size: 11px;\" md-font-icon=\"zmdi zmdi-check\" ></md-icon>{{task.closedDate | amDateFormat: vm.settings.amDateFormat}}</p>\n								</div>\n\n\n								<div ng-if=\"task.status == \'open\'\" style=\"padding-top: 4px;\" layout=\"row\" layout-align=\"end center\">\n								    <reminders ng-if=\"vm.hasReminder(task)\" options=\"vm.myReminder(task)\" status=\"on\"></reminders>\n								    <reminders ng-if=\"!vm.hasReminder(task)\"  options=\"vm.reminderOptions(task, vm.lead)\" status=\"off\"></manage-reminders>\n								</div>\n								<div style=\"padding-top: 4px;\" layout=\"row\" layout-align=\"end center\">\n									<md-button ng-click=\"vm.removeTask(task)\" flex=\"nogrow\" class=\"md-icon-button lead-task-show-on-hover\">\n									    <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n									    <md-tooltip md-delay=\"500\">Delete Todo</md-tooltip>\n									</md-button>\n								</div>\n							</div>\n\n						</md-card>\n						<div ng-if=\"!vm.hasTasks(vm.lead)\" layout=\"column\" layout-align=\"center center\">\n							<p ng-if=\"!vm.lead.tasks\" class=\"md-title center\">You haven\'t created any Todos for this lead.</p>\n							<md-button  ng-click=\"vm.newLeadTask(vm.lead)\"  md-colors=\"{background: \'orange-600\', color: \'white-100\'}\"  class=\"md-raised\" ng-click=\"vm.selectedTabIndex = 3\">\n							    <md-icon md-font-icon=\"fa fa-check-square-o\" style=\"color: #fff;\"></md-icon>\n							    Add a Todo&nbsp;\n							</md-button>\n						</div>\n				</md-content>\n			   </md-tab-body>\n			</md-tab>\n	        </md-tabs>\n	     <div  style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n   	        <div flex=\"nogrow\" ng-if=\"vm.lead.timeStamp\">\n   	            <md-menu>\n   	            	<md-button  ng-click=\"$mdMenu.open($event)\" class=\"md-adminja-shade-theme md-accent md-raised\" >\n   	            	    <md-icon md-font-icon=\"fa fa-comments-o\"></md-icon>\n   	            	    Log Lead Activity&nbsp;\n   	            	    <md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon>\n   	            	</md-button>\n   	                <!-- Trigger element is a md-button with an icon -->\n   	                <md-menu-content class=\"md-dense\">\n   	            	    <md-menu-item class=\"contact-type-menu-item\" ng-repeat=\"contactType in vm.contactTypes | toArray: false | orderBy: \'order\' track by $index + uid\">\n       	                 <md-button ng-click=\"vm.newContact(vm.lead, contactType.uid)\">\n       	                     <md-icon md-font-icon=\"zmdi zmdi-circle\" style=\"color: {{contactType.color}};\"></md-icon> {{contactType.label}}\n       	                 </md-button>\n       	             </md-menu-item>\n            	    </md-menu-content>\n            	 </md-menu>\n\n   	        </div>\n   	        <div flex=\"nogrow\" ng-if=\"vm.lead.timeStamp\">\n   	            <md-button  ng-click=\"vm.newLeadTask(vm.lead)\"  md-colors=\"{background: \'orange-600\', color: \'white-100\'}\"  class=\"md-raised\" ng-click=\"vm.selectedTabIndex = 3\">\n   	                <md-icon md-font-icon=\"fa fa-check-square-o\" style=\"color: #fff;\"></md-icon>\n   	                Add a Todo&nbsp;\n   	            </md-button>\n   	        </div>\n   	        <div style=\"border-left: 1px solid #efefef; margin-left: 1em; padding-left: 1em;\" layout=\"row\" layout-align=\"end center\">\n\n		        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.lead.timeStamp\">\n\n		        	 <div ng-if=\"!vm.updatingLead\">\n		        	 		 <!-- Pristine, saved state -->\n		        	 	    <md-button ng-if=\"vm.forms.leadForm.$pristine && !vm.forms.leadForms.$invalid\" ng-disabled=\"true\"  type=\"submit\" class=\"\">\n		        	 	    	<md-icon  style=\"font-size: 12px; line-height: 25px;\" md-font-icon=\"fa fa-check\"></md-icon>\n		        	 	        Saved\n		        	 	    </md-button>\n		        	 	    <!-- Needs saved -->\n		        	 	    <md-button ng-if=\"!vm.forms.leadForm.$pristine && !vm.forms.leadForms.$invalid\"  type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.updateLead(vm.lead)\">\n		        	 	        Update\n		        	 	    </md-button>\n		        	 </div>\n		            <!-- Updating -->\n		            <md-button ng-if=\"vm.updatingLead\" ng-disabled=\"true\"  type=\"submit\" class=\"\">\n		            	<md-icon  style=\"font-size: 12px; line-height: 25px;\" md-font-icon=\"fa fa-circle-o-notch fa-spin\"></md-icon>\n		                <!-- Updating -->\n		            </md-button>\n		        </div>\n		        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.lead.timeStamp\" >\n		            <md-button ng-disabled=\"vm.forms.leadForm.$invalid || vm.forms.leadForm.$pristine\" type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.saveNewLead(vm.lead)\">\n		                Save\n		            </md-button>\n		        </div>\n		        <div flex=\"nogrow\" class=\"button-label-container\">\n		            <md-button class=\"md-button-small\" ng-click=\"vm.closeSheet()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n		        </div>\n	        </div>\n	     </div>\n\n	</form>\n\n</md-bottom-sheet>\n");
$templateCache.put("app/app-services/invoiceService/emailInvoice.html","<md-dialog flex=\"100\" flex-gt-sm=\"40\">\n	<md-dialog-content class=\"md-padding\">\n		<h3 class=\"md-title\">Email Invoice</h3>\n\n		<md-input-container>\n			<label>Recipient\'s address</label>\n			<input type=\"email\" ng-model=\"vm.recipientEmail\" required>\n		</md-input-container>\n		<md-input-container ng-if=\"!vm.isClientUser\">\n			<label>Direct Payment Link (optional)</label>\n			<input ng-model=\"vm.invoice.paymentLink\">\n		</md-input-container>\n\n		<p style=\"text-align:right;\"><md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-click=\"vm.sendPDF(vm.recipientEmail)\" class=\"md-accent md-raised\">Send Invoice</md-button></p>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/invoiceService/paymentDialog.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"50\" flex-gt-lg=\"40\" class=\"new-payment-dialog\">\n	<md-dialog-content class=\"md-padding\">\n\n		<h3 class=\"text-center\" style=\"padding-bottom: 1em; border-bottom: 1px dashed #ccc; margin-bottom: 2em;\">New Payment <br><span style=\"font-weight: 400;\">{{vm.invoice.info.recipient.name}} Invoice#{{vm.invoice.info.number}}</span></h3>\n		<md-input-container md-no-float class=\"margin-bottom-0\" style=\"margin-left: 1em;\">\n\n			<md-datepicker md-hide-icons=\"calendar\" ng-model=\"vm.newPayment.date\" md-placeholder=\"Date received\"></md-datepicker>\n		</md-input-container>\n		<div layout=\"row\" layout-align=\"start center\" >\n			<div flex=\"nogrow\" style=\"padding-right: 2em;\">\n				<md-input-container md-no-float class=\"md-icon-float\" >\n					<md-icon style=\"padding-left: 12px;\"><span ng-bind-html=\"vm.currency\"></span></md-icon>\n					<input type=\"number\" string-to-number ng-model=\"vm.newPayment.amount\" placeholder=\"Amount\" md-autofocus>\n				</md-input-container>\n			</div>\n			<div flex=\"nogrow\" style=\"padding-right: 2em;\">\n				<md-input-container md-no-float class=\"md-icon-float\">\n					<md-icon style=\"padding-left: 12px;\">#</md-icon>\n					<input type=\"text\" ng-model=\"vm.newPayment.referenceNumber\" placeholder=\"Reference Number\">\n				</md-input-container>\n			</div>\n			<div flex=\"auto\">\n				<md-input-container md-no-float>\n					<input type=\"text\" ng-model=\"vm.newPayment.notes\" placeholder=\"Method &amp; Notes\">\n				</md-input-container>\n			</div>\n\n\n		</div>\n		<div layout=\"row\" layout-align=\"end center\">\n			<md-button flex=\"nogrow\" ng-click=\"vm.cancel()\" style=\"margin-top: 0;\" class=\"\"  aria-label=\"Cancel Payment\">\n				Cancel\n			</md-button>\n			<md-button ng-if=\"!vm.newPayment.uid\" ng-disabled=\"vm.saving\" flex=\"nogrow\" data-gtm-billing-apply-payment ng-click=\"vm.saveNewPayment(vm.newPayment, vm.invoice)\" style=\"margin-top: 0;\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newPayment.notes || !vm.newPayment.amount || !vm.newPayment.date \" aria-label=\"Apply Payment\">\n				<span ng-if=\"!vm.saving\">Apply Payment</span>\n				<span ng-if=\"vm.saving\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></span>\n			</md-button>\n			<md-button ng-if=\"vm.newPayment.uid\" ng-disabled=\"vm.saving\"  flex=\"nogrow\" data-gtm-billing-apply-payment ng-click=\"vm.updatePayment(vm.payment, vm.newPayment)\" style=\"margin-top: 0;\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newPayment.notes || !vm.newPayment.amount || !vm.newPayment.date \" aria-label=\"Apply Payment\">\n				<span ng-if=\"!vm.saving\">Update Payment</span>\n				<span ng-if=\"vm.saving\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 24px; width: 24px; font-size: 24px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon></span>\n			</md-button>\n		</div>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/notificationService/adminja-toast.tmpl.html","<md-toast class=\"adminja-toast adminja-toast-notification\" style=\"margin-top: 0; padding-top: 0;\">\n    <notification-card toast=\"true\" item=\"notification\"></notification-card>\n</md-toast>\n");
$templateCache.put("app/app-services/panelDataService/dialog-profile-panel.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"md-inline-form dialog-panel\" style=\"min-height: 300px; width: 309px;\" >\n	<md-dialog-content class=\"small-scrollbar\">\n	<md-tabs md-dynamic-height class=\"\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon> <span class=\"hide-for-medium\"><span ng-if=\"!vm.panel.uid\">New</span><span ng-if=\"vm.panel.uid\">Edit</span> List</span>\n\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.panelDialogForm\">\n			<div layout=\"column\" class=\"md-padding\">\n				<md-input-container md-autofocus flex style=\"margin-bottom: 0;\">\n				       <label>List Name</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.panel.label\" required>\n				 </md-input-container>\n				 <md-input-container ng-if=\"vm.hasClientUsers\" style=\"margin-top:0;\" layout=\"row\" layout-align=\"center center\">\n				 	<md-checkbox ng-model=\"vm.panel.clientEnabled\" aria-label=\"\">Visible to Client</md-checkbox>\n				 </md-input-container>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"!vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></md-button>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color <md-icon md-font-icon=\"zmdi zmdi-caret-up\"></md-icon></md-button>\n				 <div class=\"row\" layout-align=\"center center\">\n				 <div flex=\"nogrow\" ng-if=\"vm.showColors\" style=\"width: 235px;\">\n					 <lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.panel.color\" ng-model=\"vm.panel.color\" ng-change=\"toggleColors();\"></lk-color-chooser>\n				 </div>\n				</div>\n			</div>\n\n				<!-- <md-divider></md-divider> -->\n\n				<md-dialog-actions style=\"border-top: none;\" class=\"md-padding\">\n				    <div layout=\"row\" layout-align=\"center center\">\n				        <div flex=\"nogrow\" class=\"button-label-container\">\n				        	<md-button class=\"\" ng-click=\"cancelDialog(vm.panel)\">Cancel</md-button>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"updatePanel(vm.panel)\">Save</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button data-gtm-new-detail-list ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid || !vm.panel.label\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"saveNewPanel(vm.panel)\">Add</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				    </div>\n				</md-dialog-actions>\n			</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/noteDataService/dialog-edit-note.tmpl.html"," <md-dialog flex=\"100\" flex-sm=\"90\" flex-md=\"50\" flex-lg=\"40\" flex-gt-lg=\"30\" md-theme=\"grey-menu\" class=\"item-dialog md-inline-form\">\n    <md-dialog-content>\n        <md-tabs md-dynamic-height class=\" task-tabs\" md-selected=\"vm.selectedTab\" md-stretch-tabs=\"always\">\n            <!-- General Task Details -->\n            <md-tab md-on-select=\"showTaskControls();\" md-on-deselect=\"hideTaskControls();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n                    <span class=\"hide-for-medium\" ng-if=\"vm.editedItem.uid\">Task Details</span>\n                    <span class=\"hide-for-medium\" ng-if=\"!vm.editedItem.uid\">New Task Details</span>\n                </md-tab-label>\n                <md-tab-body layout=\"column\" layout-padding>\n                    <form name=\"taskDialogForm\" novalidate>\n                        <!-- checkbox and title -->\n\n\n                            <!-- description -->\n                            <!-- if we have ID, then we don\'t autofocus the field -->\n                            <div flex md-padding>\n                            <md-input-container class=\"task-description-container\">\n                                <textarea ng-disabled=\"vm.editedItem.info.status == \'closed\'\" name=\"description\" md-autofocus=\"!vm.editedItem.uid\" md-no-asterisk ng-model=\"vm.editedItem.info.description\" placeholder=\"Task description\" required=\"required\"></textarea>\n                            </md-input-container>\n                            </div>\n\n                        <div flex layout=\"row\" layout-align=\"start center\" style=\"padding-top: .5em;\">\n                            <div flex style=\"padding-right: 2em;\" class=\"date-label-container\">\n                                <label>Due Date</label>\n                                <md-datepicker ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"\" ng-model=\"vm.editedItem.info.duedate\" md-placeholder=\"Due\"></md-datepicker>\n                            </div>\n                            <div flex>\n\n                            <md-input-container >\n                                <label>Client</label>\n                                <md-select ng-disabled=\"vm.editedItem.uid\" md-no-asterisk placeholder=\"Please select a client\" ng-model=\"vm.editedItem.info.client\" required>\n                                    <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.clientColor}};\">\n                                    <img ng-if=\"client.status ==\'personal\'\" src=\"{{client.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"30\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                    <img ng-if=\"client.status !=\'personal\'\" src=\"{{client.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"30\" style=\"border-radius: 50%; border: 2px solid {{client.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                    <span class=\"small\">{{client.name}}</span></md-option>\n                                </md-select>\n                            </md-input-container>\n                            </div>\n\n\n                        </div>\n                        <!-- autocomplete tags - not fully functional -->\n\n                        <!--<div layout=\"row\" layout-align=\"start center\" md-padding>\n                                <div flex=\"10\" class=\"center\">\n                                    <md-icon tabindex=\"-1\" md-font-icon=\"fa fa-tags\" >\n                                    </md-icon>\n                                </div>\n                                <div flex=\'80\'>\n                                    <md-chips ng-model=\"vm.editedItem.info.tags\" md-autocomplete-snap readOnly=false>\n                                          <md-autocomplete\n                                              md-items=\"item in queryTags(vm.searchText)\"\n                                              md-select-on-match = true\n                                              md-transform-chip= transformChip($chip)\n                                              md-no-cache = true\n                                              md-selected-item-change = tagSelected(vm.selectedItem)\n                                              md-selected-item=\"vm.selectedItem\"\n                                              md-search-text=\"vm.searchText\"\n                                              md-item-text=\"item.name\"\n                                              md-require-match\n                                              placeholder=\"Add tags\">\n                                            <span md-highlight-text=\"vm.searchText\">{{item.name}}</span>\n                                          </md-autocomplete>\n                                          <md-chip-template md-highlight-text=\"vm.searchText\">\n                                            {{$chip}}\n                                          </md-chip-template>\n                                        </md-chips>\n                                </div>\n                        </div>-->\n                            <!-- <md-divider class=\"md-padding\"></md-divider> -->\n                            <!-- Datepicker and Cilent -->\n\n                        <!-- budget -->\n\n\n                            <div flex style=\"padding-top: 1.5em;\">\n                                <p class=\"task-budget-label\" >\n                                    <span ng-show=\"!vm.editItem.info.budget\">Budget</span>\n                                </p>\n                             <md-slider ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"md-accent item-budget fade\" min=\"0\" max=\"240\" step=\"15\"  ng-model=\"vm.editedItem.info.budget\" ng-init=\"sliders.default=0\" aria-label=\"Task Budget\"></md-slider>\n                                <p class=\"task-budget-label right\" style=\"margin-top: -5px;\">\n                                    <span ng-show=\"vm.editedItem.info.budget\">{{vm.editedItem.info.budget /60}}hrs</span>\n                                    <span ng-show=\"vm.editedItem.info.logged\"> | Logged: {{vm.editedItem.info.logged / 60}}hrs</span>\n                                </p>\n                            </div>\n\n\n                        <div layout=\"column\"\n                        <!-- file management -->\n                        <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.isUploading && vm.numFiles < 5\"\n                                class=\"md-primary \"\n                                ngf-select=\"uploadFile($files)\"\n                                ngf-multiple=\"true\"\n                                ngf-max-files=\"3\"\n                                ngf-max-size=\"5mb\"\n                                ngf-drop=\"uploadFile($files)\"\n                                ngf-drag-over-class=\"\'dragover\'\"\n                                aria-label=\"upload\">\n                            <md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Attach Files\n                            <div class=\"dropzone\">\n                                <p class=\"center\">Drop File to Upload</p>\n                            </div>\n                         </md-button>\n                        <md-button ng-if=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n                             <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n                                Uploading\n                        </md-button>\n\n                        <md-chips ng-model=\"vm.editedItem.info.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n                            <md-chip-template >\n                                 <strong><a href=\"{{$chip.url}}\" download>{{$chip.fileName}}</a></strong>\n                            </md-chip-template>\n                        </md-chips>\n\n                        </div>\n                    </form>\n                </md-tab-body>\n\n            </md-tab>\n\n            <!-- Task Notes -->\n            <md-tab ng-if=\"vm.editedItem.uid\" md-on-select=\"hideTaskControls(); setupNotes();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"fa fa-comment-o\"></md-icon> <span class=\"hide-for-medium\">Discussion</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                       <task-notes class=\"fade\" task=\"{{vm.editedItem.uid}}\" client=\"{{vm.editedItem.info.client}}\"></task-notes>\n                </md-tab-body>\n            </md-tab>\n            <!-- Time Log -->\n    <!--         <md-tab ng-if=\"vm.editedItem.uid\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> <span class=\"hide-for-medium\">Time</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <md-content style=\"height: 400px;\">\n                        <md-list class=\"md-dense\">\n                            <div class=\"time-entry-list-item\" ng-repeat=\"entry in vm.timeLogs track by $index\">\n                                <md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{entry.clientColor}};\">\n                                    <div class=\"md-list-item-text\" layout=\"column\">\n                                        <div flex layout=\"row\">\n                                            <h3 ng-show=\"!entry.task\">\n                                                        {{entry.description}}\n                                                    </h3>\n                                            <h3 ng-show=\"entry.task\">\n                                                        <md-icon aria-label=\"View Related Task\" md-font-icon=\"fa fa-check-square\">\n                                                            <md-tooltip md-delay=\"1000\">View Related Task</md-tooltip>\n                                                        </md-icon>\n                                                        {{entry.task}}\n                                                    </h3>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p><em>{{entry.date}}</em></p>\n                                            </div>\n                                            <div flex class=\"center\">\n                                            </div>\n                                            <div flex class=\"right\">\n                                                <h3><strong>{{entry.total}} min</strong></h3>\n                                            </div>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p class=\"right\"><em>{{entry.tag}}</em></p>\n                                            </div>\n                                        </div>\n                                        <div flex layout=\"row\">\n                                            <div flex>\n                                                <p class=\"left\">by {{entry.user}}</p>\n                                            </div>\n                                            <div flex>\n                                                <p class=\"right\">{{ entry.client }}</p>\n                                            </div>\n                                        </div>\n                                    </div> -->\n                                    <!-- end md-list-item-text -->\n                               <!--  </md-list-item>\n                                <md-divider></md-divider> -->\n                            <!-- </div> -->\n                            <!-- <md-subheader class=\"md-no-sticky\">2 line item</md-subheader> -->\n                       <!--  </md-list>\n                    </md-content>\n                    <h4 class=\"right\">Total: 3hrs 35min</h4>\n                </md-tab-body>\n            </md-tab> -->\n\n            <!-- Task Activity Log -->\n            <!--<md-tab ng-if=\"vm.editedItem.uid\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-receipt\"></md-icon> <span class=\"hide-for-medium\">Activity</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                <md-content style=\"max-height: 400px;\">\n                    <md-list class=\"md-dense\">\n                        <div class=\"activity-log-item\" ng-repeat=\"item in vm.editedItem.info.activity track by $index\">\n                            <md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{vm.clientColor}};\">\n                                <div class=\"md-list-item-text\" layout=\"column\">\n                                    <div flex layout=\"row\">\n                                        <h3 >\n                                                    {{item.event}}\n                                            </h3>\n                                    </div>\n                                    <div flex layout=\"row\">\n                                        <div flex>\n                                            <p><em am-time-ago=\"item.timestamp\"></em></p>\n                                        </div>\n                                        <div flex class=\"center\">\n                                        </div>\n                                        <div flex class=\"right\">\n                                            <h3><strong>{{item.actor}}</strong></h3>\n                                        </div>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                            <md-divider></md-divider>\n                        </div>\n                    </md-list>\n                    </md-content>\n                </md-tab-body>\n            </md-tab>-->\n        </md-tabs>\n\n    </md-dialog-content>\n    <md-dialog-actions ng-show=\"vm.taskControls\" layout=\"column\" layout-gt-sm=\"row\"  style=\"padding-bottom: 1em;\">\n        <div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n            <md-button flex=\"nogrow\"  ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.uid && vm.editedItem.info.panel == \'today\' && vm.editedItem.info.status != \'completed\'\">\n                <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-on\"  class=\"today-icon\">\n                </md-icon> Doing Today\n            </md-button>\n            <md-button flex=\"nogrow\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"vm.editedItem.uid && vm.editedItem.info.panel != \'today\' && vm.editedItem.info.status != \'completed\'\">\n                <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-off\"  class=\"today-icon\">\n                </md-icon> Doing later\n            </md-button>\n            <div flex=\"nogrow\"  ng-show=\"vm.editedItem.uid\">\n            <md-button ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'closed\'\" >\n                <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\" >\n                </md-icon>\n                Re-open\n            </md-button>\n            <md-button ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'open\'\">\n                <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\">\n                </md-icon>\n                Mark Complete\n            </md-button>\n            </div>\n        </div>\n        <div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                    Cancel\n                </md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button ng-hide=\"vm.editedItem.uid\" ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" class=\"md-adminja-shade-theme md-primary\" ng-click=\"saveNewTask(vm.editedItem,\'andNew\')\">Add and New</md-button>\n                <label class=\"shortcut\">shift + ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid\">\n                <md-button   ng-disabled=\"taskDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                    Update Task\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid\">\n                <md-button  ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" type=\"submit\" class=\"md-adminja-shade-theme md-accent\" ng-click=\"saveNewTask(vm.editedItem)\">\n                    Add Task\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n        </div>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-services/presenceService/dialog-presence.tmpl.html","<md-dialog flex-xs=\"100\" flex-sm=\"90\" flex-md=\"60\" flex-lg=\"50\" flex-gt-lg=\"40\" class=\"presence-dialog md-padding\">\n	<h3>{{vm.title}}</h3>\n	<p>{{vm.message}}</p>\n\n		<md-button ng-show=\"vm.showButton\" ng-click=\"vm.cancelDialog()\">Got it</md-button>\n\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-address.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-address md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\" novalidate>\n			<div layout=\"column\">\n			<div class=\"md-block text-center\" flex>\n				<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n				<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n			</div>\n				<md-input-container md-autofocus flex>\n				       <label>Who/What is this address for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Street Address</label>\n						<input name=\"detailaddress1\" ng-model=\"vm.detail.address1\" required>\n						<div ng-messages=\"vm.detail.address.$error\">\n						      <div ng-message=\"required\">Oops! It doesn\'t look like you put in an address!</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Address2</label>\n						<input name=\"detailaddress2\" ng-model=\"vm.detail.address2\">\n					</md-input-container>\n					<div layout=\"column\" layout-gt-md=\"row\">\n						<md-input-container flex class=\"md-block\">\n							<label>City or Town</label>\n							<input name=\"detailcity\" ng-model=\"vm.detail.city\">\n						</md-input-container>\n						<md-input-container flex=\"none\" class=\"md-block\">\n							<label>State/Province/Region</label>\n							<input name=\"detailstate\" ng-model=\"vm.detail.state\">\n						</md-input-container>\n					</div>\n					<div layout=\"column\" layout-gt-md=\"row\">\n						<md-input-container flex=\"none\" class=\"md-block\">\n							<label>Zip/Postal Code</label>\n							<input name=\"detailzip\" ng-model=\"vm.detail.zip\">\n						</md-input-container>\n						<md-input-container flex=\"none\" class=\"md-block\">\n						    <label>Country</label>\n						    <md-select placeholder=\"Country\" ng-model=\"vm.detail.country\">\n						        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<md-input-container flex=\"none\" class=\"md-block\">\n						<label>Related phone</label>\n						<input name=\"detailphone\" ng-model=\"vm.detail.number\">\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n				</form>\n\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n	<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n		<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n			<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n			    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n			    </md-icon> Visible to everyone\n			    <md-tooltip md-delay=\"1000\">\n			        Toggle privacy\n			    </md-tooltip>\n			</md-button>\n			<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n			    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n			    </md-icon> Visible to Admins only\n			    <md-tooltip md-delay=\"1000\">\n			        Toggle privacy\n			    </md-tooltip>\n			</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"button-label-container\">\n			<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n		</div>\n		<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n			<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n				Save Changes\n			</md-button>\n			<label class=\"shortcut\">ctrl + enter</label>\n\n		</div>\n		<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n			<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n				Add Address\n			</md-button>\n			<label class=\"shortcut\">ctrl + enter</label>\n\n		</div>\n	</md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-contact.tmpl.html","<md-dialog flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"50\" flex-gt-lg=\"30\" md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-contact md-inline-form\">\n	<form name=\"vm.forms.detailDialogForm\" novalidate style=\"margin-right: 1em;\">\n	<md-dialog-content class=\"small-scrollbar\" style=\"padding: 0 1em;\">\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n			</md-tab-label>\n			<md-tab-body >\n			<div layout=\"column\">\n			<div class=\"md-block text-center\" flex>\n				<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n				<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n			</div>\n\n			</div>\n			<div layout=\"column\" layout-gt-md=\"row\">\n			    <div flex=\"nogrow\" flex-gt-md=\"30\" style=\"padding-right: 1em;\">\n				    	<div style=\"margin-top: 2em;\">\n				        <avatar parent=\"vm.detail\" upload=\"true\"></avatar>\n				   </div>\n			    </div>\n			    <div layout=\"column\" flex=\"auto\">\n			    		<div layout=\"row\" layout-align=\"start center\">\n			    			<md-input-container md-autofocus flex>\n			    			       <label>Contact Card Title (optional)</label>\n			    			       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n			    			 </md-input-container>\n			    		</div>\n				    <div layout=\"column\" layout-gt-md=\"row\">\n					    <md-input-container flex>\n					        <label>First Name</label>\n					        <input name=\"clientfirstname\" ng-model=\"vm.detail.firstname\" >\n					    </md-input-container>\n					    <md-input-container flex>\n					        <label>Last Name</label>\n					        <input name=\"clientlastname\" ng-model=\"vm.detail.lastname\" >\n					    </md-input-container>\n					</div>\n\n\n					<div layout=\"column\" layout-gt-md=\"row\">\n					    <md-input-container flex=\"40\">\n					        <label ng-if=\"!vm.detail.treatAsCompany\">Company</label>\n					        <label ng-if=\"vm.detail.treatAsCompany\"><strong>Company</strong></label>\n					        <input name=\"clientcompany\" ng-model=\"vm.detail.company\">\n					    </md-input-container>\n					</div>\n					<div layout=\"row\">\n						<md-input-container flex=\"60\">\n						    <label>Position</label>\n						    <input name=\"clientposition\" ng-model=\"vm.detail.position\">\n						</md-input-container>\n						<div flex=\"40\">\n							<md-checkbox ng-disabled=\"!vm.detail.company\" style=\" margin-left:  1em; margin-bottom: 0; font-size: 10px;\" ng-model=\"vm.detail.treatAsCompany\" aria-label=\"select\"><span style=\"color: #666;\">Treat as Company</span></md-checkbox>\n						</div>\n					</div>\n					<div layout=\"row\" layout-align=\"start center\">\n						<md-input-container flex=\"50\" style=\"margin-right: 1em;\">\n							<label>Date of Birth</label>\n							<md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.detail.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n						</md-input-container>\n					</div>\n				</div>\n			</div>\n			<md-input-container flex=\"none\" class=\"md-block\">\n				<label>Phone</label>\n				<input name=\"detailphone\" ng-model=\"vm.detail.number\">\n			</md-input-container>\n			<md-input-container flex=\"none\" class=\"md-block\">\n				<label>Email Address</label>\n				<input name=\"detailemail\" ng-model=\"vm.detail.email\">\n			</md-input-container>\n			<md-input-container flex=\"none\" class=\"md-block\">\n				<label>Website</label>\n				<input name=\"detailemail\" ng-model=\"vm.detail.companyurl\" placeholder=\"https://www.website.com\">\n			</md-input-container>\n\n			<div ng-if=\"vm.showAddress || vm.detail.address1\" layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 1em;\">\n				<md-subheader>Address</md-subheader>\n				<md-input-container flex class=\"md-block\">\n					<label>Street Address</label>\n					<input name=\"detailaddress1\" ng-model=\"vm.detail.address1\" >\n					<div ng-messages=\"vm.detail.address.$error\">\n					      <div ng-message=\"\">Oops! It doesn\'t look like you put in an address!</div>\n					</div>\n				</md-input-container>\n				<md-input-container flex class=\"md-block\">\n					<label>Address2</label>\n					<input name=\"detailaddress2\" ng-model=\"vm.detail.address2\">\n				</md-input-container>\n				<div layout=\"column\" layout-gt-md=\"row\">\n					<md-input-container flex class=\"md-block\">\n						<label>City or Town</label>\n						<input name=\"detailcity\" ng-model=\"vm.detail.city\">\n					</md-input-container>\n					<md-input-container flex=\"none\" class=\"md-block\">\n						<label>State/Province/Region</label>\n						<input name=\"detailstate\" ng-model=\"vm.detail.state\">\n					</md-input-container>\n				</div>\n				<div layout=\"column\" layout-gt-md=\"row\">\n					<md-input-container flex=\"none\" class=\"md-block\">\n						<label>Zip/Postal Code</label>\n						<input name=\"detailzip\" ng-model=\"vm.detail.zip\">\n					</md-input-container>\n					<md-input-container flex=\"none\" class=\"md-block\">\n					    <label>Country</label>\n					    <md-select placeholder=\"Country\" ng-model=\"vm.detail.country\">\n					        <md-option ng-repeat=\"country in vm.countries\" value=\"{{country.name}}\">{{country.name}}</md-option>\n					    </md-select>\n					</md-input-container>\n				</div>\n\n			</div>\n\n			<div ng-if=\"vm.showSM || vm.detail.facebook || vm.detail.linkedin || vm.detail.twitter || vm.detail.instagram\" style=\"margin-bottom: 1em;\">\n				<md-subheader>Social Media</md-subheader>\n				<div layout=\"row\" layout-wrap=\"\">\n					<md-input-container flex=\"50\">\n					    <label>Twitter</label>\n					    <input name=\"clienttwitter\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model=\"vm.detail.twitter\" type=\"text\">\n					</md-input-container>\n					<md-input-container flex=\"50\">\n					    <label>Facebook</label>\n					    <input name=\"clientfacebook\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model=\"vm.detail.facebook\" type=\"text\">\n					</md-input-container>\n					<md-input-container flex=\"50\">\n					    <label>linkedIn</label>\n					    <input name=\"clientlinkedin\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model=\"vm.detail.linkedin\" type=\"text\">\n					</md-input-container>\n					<md-input-container flex=\"50\">\n					    <label>Instagram</label>\n					    <input name=\"clientinstagram\" ng-pattern=\"/^((?!www|http[s]{0,1}:\\/\\/www).)*$/\"; ng-model=\"vm.detail.instagram\" type=\"text\">\n					</md-input-container>\n				</div>\n			</div>\n			<div ng-if=\"vm.detail.description || vm.showDescription\" style=\"margin-bottom: 1em;\">\n				<md-subheader>Notes</md-subheader>\n				<md-input-container flex class=\"md-block\" >\n					<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n				</md-input-container>\n			</div>\n				<!-- include our profile file upload snippet -->\n			<div ng-if=\"vm.showFiles || vm.detail.files.length > 0\" style=\"margin-bottom: 1em;\">\n				<md-subheader>Files</md-subheader>\n				<file-picker files=\"vm.detail.files\" form=\"vm.forms.detailDialogForm\" counter=\"vm.detail.files.length\" filepath=\"\'/clients/\' + vm.detail.client\"></file-picker>\n				<file-attachment-list ng-if=\"vm.detail.files.length > 0\" style=\"margin-bottom: 1em;\" files=\"vm.detail.files\" removeable=\"true\"></file-attachment-list>\n			</div>\n\n\n\n\n\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n	<md-dialog-actions style=\"border-top: none;\" layout=\"column\" layout-align=\"end layout-fill\" class=\"md-padding\">\n\n		<div flex layout=\"row\" layout-align=\"center center\">\n			<md-button  ng-if=\"!vm.detail.address1 && !vm.showAddress\" ng-click=\"vm.showAddress = true\" >+ Add Address</md-button>\n			<md-button  ng-if=\"(!vm.detail.facebook && !vm.detail.linkedin && !vm.detail.twitter && !vm.detail.instagram) && !vm.showSM\" ng-click=\"vm.showSM = true\" >+ Add Social Media</md-button>\n			<md-button  ng-if=\"!vm.detail.description && !vm.showDescription\" ng-click=\"vm.showDescription = true\" >+ Add Notes</md-button>\n			<md-button  ng-if=\"vm.detail.files.length < 1 && !vm.showFiles\" ng-click=\"vm.showFiles = true\" >+ Attach Files</md-button>\n		</div>\n		<div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n		    <div flex=\"50\">\n		        <md-input-container class=\"md-block\">\n		            <label>Workspace</label>\n		           <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.detail.client, true)\" ng-model=\"vm.detail.client\" required>\n		                    <md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n		                        <avatar parent=\"client\" border=\"client.profile.clientColor\"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n		                </md-option>\n		            </md-select>\n		        </md-input-container>\n		    </div>\n		    <div flex=\"50\">\n		        <md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n		            <label>List</label>\n		            <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n		                <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n		                    <span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n		                <span class=\"small\">{{list.label}}</span></md-option>\n		            </md-select>\n\n		        </md-input-container>\n		    </div>\n		</div>\n		<div flex layout=\"row\" layout-align=\"start center\">\n			<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n				<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n				    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n				    </md-icon> Visible to everyone\n				    <md-tooltip md-delay=\"1000\">\n				        Toggle privacy\n				    </md-tooltip>\n				</md-button>\n				<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n				    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n				    </md-icon> Visible to Admins only\n				    <md-tooltip md-delay=\"1000\">\n				        Toggle privacy\n				    </md-tooltip>\n				</md-button>\n			</div>\n			<div flex=\"nogrow\" class=\"button-label-container\">\n				<md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n			</div>\n			<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n				<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n					Save Changes\n				</md-button>\n\n			</div>\n			<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n				<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n					Add Contact\n				</md-button>\n\n			</div>\n		</div>\n	</md-dialog-actions>\n	</form>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-email.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\" novalidate=\"\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>What is this address for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Email Address</label>\n						<input name=\"detailaddress\" ng-model=\"vm.detail.address\" type=\"email\" placeholder=\"address@domain.com\" required>\n\n						<div ng-messages=\"vm.detail.email.$error\">\n						      <div ng-message=\"required\">Oops! That doesn\'t look like a valid internet address.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"vm.getUserRole(vm.detail.client) != \'member\'\">\n						<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Email\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-files.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-note md-inline-form\" flex-sm=\"100\" flex-md=\"40\" flex-lg=\"30\" flex-gt-lg=\"20\">\n<!-- note, above we are applying class of edit-note. That\'s because the files and note share same layout exactly. No need to duplicate CSS rules -->\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} Web URL</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"detailDialogForm\">\n			<div layout=\"column\">\n				<div flex class=\"md-block text-center\">\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Title (optional)</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\">\n				 </md-input-container>\n			</div>\n			<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n			<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n				<!-- include our profile file upload snippet -->\n\n				<md-input-container flex class=\"md-block\">\n					<label>Description</label>\n					<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n				</md-input-container>\n			</div>\n\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"vm.getUserRole(vm.detail.client) != \'member\'\">\n						<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-accent md-raised\" ng-click=\"updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-accent md-raised\" ng-click=\"saveNewDetail(vm.detail, clientID)\">\n							Add Files\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-note.tmpl.html","<md-dialog flex=\"100\" flex-md=\"100\" flex-lg=\"60\" flex-xl=\"50\" md-theme=\"grey-menu\" class=\"edit-note edit-detail md-inline-form\">\n	<form name=\"vm.forms.detailDialogForm\" novalidate >\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\" no-active\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab >\n			<md-tab-label>\n				<md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> {{vm.title}}\n			</md-tab-label>\n			<md-tab-body >\n			<div layout=\"column\">\n				<div flex class=\"md-block text-center\">\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.notecolor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n			</div>\n\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\" >\n					<div flex class=\"md-block\" >\n						<style>\n							.edit-note .note-editor{\n								background-color: {{vm.detail.notecolor}};\n							}\n						</style>\n					<div ng-if=\"vm.detail.client\" style=\"\" class=\"note-editor\" froala=\"vm.froalaOptions\" ng-model=\"vm.detail.note\" style=\"min-height: 350px;\">\n					    <!-- <text-angular name=\"noteEditor\" ng-model=\"vm.detail.note\" ta-min-text=\"5\" ng-required=\"true\" ta-toolbar=\"[[\'p\', \'pre\', \'bold\',\'italics\',\'underline\',\'justifyLeft\', \'justifyCenter\',\'insertLink\', \'html\']]\" ></text-angular> -->\n					</div>\n							<div class=\"task-description-tooltip\">\n							    <md-icon md-font-icon=\"zmdi zmdi-help\">\n							        <md-tooltip md-delay=\"500\" class=\"help\" md-direction=\"top\">\n							            <p class=\"text-center\">\n							            	<strong>Paste as plain text</strong><br>\n							            	<strong>Mac:</strong> Shift + Option + Command + V<br>\n							            	<strong>PC:</strong> Control + Shift + V\n							            </p>\n							        </md-tooltip>\n							    </md-icon>\n							</div>\n\n					</div>\n				</div>\n\n			<!-- <div layout=\"column\">\n				<md-input-container md-autofocus flex>\n					  <label>Note Label (optional)</label>\n					  <input name=\"detaillabel\" ng-model=\"vm.detail.label\" >\n				 </md-input-container>\n\n\n			</div> -->\n\n\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"vm.filePath\"></file-attachments>\n				<!-- <div layout=\"column\" ng-include=\"\'app/app-services/profileDataService/include-profile-detail-files.tmpl.html\'\"></div> -->\n				<div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n					<div flex=\"50\">\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.client}\" >\n						    <label>Workspace</label>\n						    <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.detail.client, true)\" ng-model=\"vm.detail.client\" required>\n						        	<md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n						        		<avatar parent=\"client\" border=\"client.profile.clientColor\"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n						   		</md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<div flex=\"50\" >\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n						    <label>List</label>\n						    <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n						        <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n						        	<span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n						        <span class=\"small\">{{list.label}}</span></md-option>\n						    </md-select>\n\n						</md-input-container>\n					</div>\n				</div>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button  ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n							Add Note\n						</md-button>\n\n\n					</div>\n				</md-dialog-actions>\n\n\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n	</form>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-person.tmpl.html","<md-dialog flex=\"100\" flex-md=\"50\" flex-gt-md=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-person md-inline-form\">\n    <form name=\"vm.forms.detailDialogForm\" novalidate>\n        <md-dialog-content>\n            <md-tabs md-dynamic-height class=\"\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n                <!-- General Task Details -->\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"column\" layout-align=\"start start\">\n                            <div class=\"md-block text-center\" flex style=\"width:100%;\">\n                                <lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n                                <!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n                            </div>\n                            <md-input-container md-autofocus flex style=\"max-width: 300px;\">\n                                   <label>Relationship to Client or Workspace</label>\n                                   <input name=\"detaillabel\" ng-model=\"vm.detail.label\" style=\"width: 300px;\">\n                             </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <div flex=\"nogrow\" style=\"max-width: 80px; margin-right: 1em;\">\n                                <avatar parent=\"vm.detail\" upload=\"true\"></avatar>\n                            </div>\n                            <md-input-container flex>\n                                <label>First Name</label>\n                                <input name=\"clientfirstname\" ng-model=\"vm.detail.firstname\" required>\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Last Name</label>\n                                <input name=\"clientlastname\" ng-model=\"vm.detail.lastname\" required>\n                            </md-input-container>\n                        </div>\n\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <div flex=\"25\" layout=\"column\" layout-align=\"center center\">\n                                <div flex>\n                                    <md-datepicker class=\"md-indigo-theme md-primary\" ng-model=\"vm.detail.dob\" md-placeholder=\"Date of Birth\"></md-datepicker>\n                                </div>\n                            </div>\n                            <div flex=\"50\">\n                                <md-input-container flex>\n                                    <label>Primary Phone</label>\n                                    <input name=\"clientphone\" ng-model=\"vm.detail.phone\">\n                                </md-input-container>\n                                <md-input-container flex>\n                                    <label>Primary Email</label>\n                                    <input name=\"clientemail\" ng-model=\"vm.detail.email\" type=\"email\">\n                                </md-input-container>\n                            </div>\n                        </div>\n\n                        <!-- include our profile file upload snippet -->\n                        <file-attachments files=\'vm.detail.files\' form=\"vm.forms.detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n                        <div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n                            <div flex=\"50\">\n                                <md-input-container class=\"md-block\">\n                                    <label>Workspace</label>\n                                   <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.loadPanels(vm.detail.client)\" ng-model=\"vm.detail.client\" required>\n                                            <md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n                                                <avatar parent=\"client\" border=\"client.profile.clientColor\" \"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n                                        </md-option>\n                                    </md-select>\n                                </md-input-container>\n                            </div>\n                            <div flex=\"50\">\n                                <md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n                                    <label>List</label>\n                                    <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n                                        <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n                                            <span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n                                        <span class=\"small\">{{list.label}}</span></md-option>\n                                    </md-select>\n\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">Company</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div layout=\"row\"  layout-sm=\"column\">\n                            <md-input-container flex>\n                                <label>Company</label>\n                                <input name=\"clientcompany\" ng-model=\"vm.detail.company\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Position</label>\n                                <input name=\"clientposition\" ng-model=\"vm.detail.position\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <md-input-container flex>\n                                <label>Work Email</label>\n                                <input name=\"clientcompanyemail\" ng-model=\"vm.detail.companyemail\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Work Phone #</label>\n                                <input name=\"clientcompanyphone\" ng-model=\"vm.detail.companyphone\">\n                            </md-input-container>\n                        </div>\n                        <div layout=\"column\" layout-gt-md=\"row\">\n                            <md-input-container flex>\n                                <label>Work Fax</label>\n                                <input name=\"clientcompanyfax\" ng-model=\"vm.detail.companyfax\">\n                            </md-input-container>\n                            <md-input-container flex>\n                                <label>Company Website</label>\n                                <input name=\"clientcompanyurl\" ng-model=\"vm.detail.companyurl\">\n                            </md-input-container>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">Social</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                       <div layout=\"column\">\n                           <md-input-container flex>\n                               <label>Twitter</label>\n                               <input name=\"clienttwitter\" ng-model=\"vm.detail.twitter\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>Facebook</label>\n                               <input name=\"clientfacebook\" ng-model=\"vm.detail.facebook\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>linkedIn</label>\n                               <input name=\"clientlinkedin\" ng-model=\"vm.detail.linkedin\" type=\"text\">\n                           </md-input-container>\n                           <md-input-container flex>\n                               <label>Instagram</label>\n                               <input name=\"clientinstagram\" ng-model=\"vm.detail.instagram\" type=\"text\">\n                           </md-input-container>\n                       </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab>\n                    <md-tab-label>\n                        <md-icon md-font-icon=\"fa fa-file-text-o\"></md-icon> <span class=\"hide-for-medium\">Notes</span>\n                    </md-tab-label>\n                    <md-tab-body>\n                        <md-input-container flex class=\"md-block\">\n                            <label>Notes</label>\n                            <textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n                        </md-input-container>\n                    </md-tab-body>\n                </md-tab>\n            </md-tabs>\n         <md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n            <div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n                <md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n                    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n                    </md-icon> Visible to everyone\n                    <md-tooltip md-delay=\"1000\">\n                        Toggle privacy\n                    </md-tooltip>\n                </md-button>\n                <md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n                    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n                    </md-icon> Visible to Admins only\n                    <md-tooltip md-delay=\"1000\">\n                        Toggle privacy\n                    </md-tooltip>\n                </md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\">\n                <md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n                <md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n                    Save Changes\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n            <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n                <md-button ng-disabled=\"detailDialogForm.$invalid || detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n                    Add Contact\n                </md-button>\n                <label class=\"shortcut\">ctrl + enter</label>\n\n            </div>\n         </md-dialog-actions>\n        </md-dialog-content>\n    </form>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-phone.tmpl.html","<md-dialog flex=\"40\" md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}} #</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.forms.detailDialogForm\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Who/What is this phone # for?</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" required>\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Phone #</label>\n						<input name=\"detailphone\" ng-model=\"vm.detail.number\" required>\n\n						<div ng-messages=\"vm.detail.number.$error\">\n						      <div ng-message=\"required\">Oops! It doesn\'t look like you included a phone number.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"vm.forms.detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n\n				<div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n									<div flex=\"50\">\n										<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.client}\" >\n										    <label>Workspace</label>\n										    <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.detail.client, true)\" ng-model=\"vm.detail.client\" required>\n										        	<md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n										        		<avatar parent=\"client\" border=\"client.profile.clientColor\"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n										   		</md-option>\n										    </md-select>\n										</md-input-container>\n									</div>\n									<div flex=\"50\" >\n										<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n										    <label>List</label>\n										    <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n										        <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n										        	<span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n										        <span class=\"small\">{{list.label}}</span></md-option>\n										    </md-select>\n\n										</md-input-container>\n									</div>\n								</div>\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"vm.getUserRole(vm.detail.client) != \'member\'\">\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n							Add Phone#\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-question.tmpl.html","<md-dialog md-theme=\"grey-menu\" flex=\"45\" class=\"item-dialog edit-detail edit-note md-inline-form\">\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon> <span class=\"hide-for-medium\">{{ vm.title }} &amp; answer</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.forms.detailDialogForm\" novalidate>\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Question</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\" required>\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<textarea ng-model=\"vm.detail.a\"></textarea>\n					</md-input-container>\n					<!-- <div froala=\"vm.froalaOptions\" ng-model=\"vm.detail.a\"></div> -->\n				</div>\n				<md-divider></md-divider>\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"vm.forms.detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n				<div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n					<div flex=\"50\">\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.client}\" >\n						    <label>Workspace</label>\n						    <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.detail.client, true)\" ng-model=\"vm.detail.client\" required>\n						        	<md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n						        		<avatar parent=\"client\" border=\"client.profile.clientColor\"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n						   		</md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<div flex=\"50\" >\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n						    <label>List</label>\n						    <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n						        <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n						        	<span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n						        <span class=\"small\">{{list.label}}</span></md-option>\n						    </md-select>\n\n						</md-input-container>\n					</div>\n				</div>\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\"  type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n							Add Q&amp;A\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/dialog-profile-detail-url.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"item-dialog edit-detail edit-note md-inline-form\" flex=\"100\" flex-gt-sm=\"40\" >\n	<md-dialog-content>\n	<md-tabs md-dynamic-height class=\"no-active\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-bookmark\"></md-icon> <span class=\"hide-for-medium\">{{vm.title}}</span>\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.forms.detailDialogForm\">\n			<div layout=\"column\">\n				<div class=\"md-block text-center\" flex>\n					<lk-color-chooser colors=\"colors\" selected-color=\"vm.detail.notecolor\" ng-model=\"vm.detail.clientColor\" ng-click=\"vm.colorChange();\"></lk-color-chooser>\n					<!-- <input type=\"hidden\" ng-model=\"vm.detail.notecolor\"> -->\n				</div>\n				<md-input-container md-autofocus flex>\n				       <label>Title (optional)</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.detail.label\">\n				 </md-input-container>\n			</div>\n				<div layout=\"column\" layout-align=\"center top\"  style=\"margin-bottom: 0;\">\n					<md-input-container flex class=\"md-block\">\n						<label>Bookmark URL</label>\n						<input type=\"url\" name=\"detailurl\" ng-model=\"vm.detail.url\" placeholder=\"https://www.yoururl.com\" required>\n						{{vm.detail.url.$error}}\n						<div ng-messages=\"vm.detail.url.$error\">\n						      <div ng-message=\"required\">Oops! That doesn\'t look like a valid internet address.</div>\n						</div>\n					</md-input-container>\n					<md-input-container flex class=\"md-block\">\n						<label>Description</label>\n						<textarea name=\"detaildescription\" ng-model=\"vm.detail.description\"></textarea>\n					</md-input-container>\n				</div>\n				<!-- <div layout=\"row\" layout-align=\"center center\">\n					<md-input-container flex>\n						<label style=\"margin-bottom: .5em;\" class=\"md-subhead\" ng-show=\"vm.detail.simpleEmbed\">Simple</label>\n						<label style=\"margin-bottom: .5em;\" class=\"md-subhead\" ng-show=\"!vm.detail.simpleEmbed\">Embedded</label>\n						<md-switch ng-true-value=\"false\" ng-false-value=\"true\" class=\"md-accent\" ng-model=\"vm.detail.simpleEmbed\" aria-label=\"Bookmark type\">\n					</md-switch>\n					<span ng-if=\"vm.detail.simpleEmbed\">Show a simple link</span>\n					<span ng-if=\"!vm.detail.simpleEmbed\">Show an embedded clip</span>\n				</div> -->\n				<!-- include our profile file upload snippet -->\n				<file-attachments files=\'vm.detail.files\' form=\"detailDialogForm\" counter=\"vm.numFiles\" client=\"vm.detail.client\" path=\"profile\"></file-attachments>\n				<div layout=\"row\" ng-if=\"vm.showPicker\" class=\"md-padding\">\n					<div flex=\"50\">\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.client}\" >\n						    <label>Workspace</label>\n						    <md-select class=\"avatar-picklist\" required md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.detail.client, true)\" ng-model=\"vm.detail.client\" required>\n						        	<md-option class=\"avatar-option\" ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n						        		<avatar parent=\"client\" border=\"client.profile.clientColor\"> </avatar><span class=\"small\">{{client.profile.fullName}}</span>\n						   		</md-option>\n						    </md-select>\n						</md-input-container>\n					</div>\n					<div flex=\"50\" >\n						<md-input-container class=\"md-block\" ng-class=\"{\'highlight-block\': !vm.detail.list}\" ng-if=\"vm.thisClient\">\n						    <label>List</label>\n						    <md-select required md-no-asterisk placeholder=\"Select a List\" ng-model=\"vm.detail.list\" required>\n						        <md-option ng-repeat=\"list in vm.thisClient.detailBoards[vm.thisClient.defaultDetailBoard].lists  |toArray: false | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{list.uid}}\'\" >\n						        	<span style=\"display:inline-block; width: 24px; height: 24px; background-color: {{list.color || \'#bbb;\'}}; border-radius: 24px;\">&nbsp;</span>\n						        <span class=\"small\">{{list.label}}</span></md-option>\n						    </md-select>\n\n						</md-input-container>\n					</div>\n				</div>\n\n				<md-dialog-actions style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding\">\n					<div flex layout=\"row\" layout-align=\"start center\" ng-if=\"(vm.getUserRole(vm.detail.client) != \'member\' && !vm.isUserClient) || (vm.getUserRole(vm.detail.client) != \'member\' && vm.hasClientUsers)\">\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && !vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n						    </md-icon> Visible to everyone\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n						<md-button flex=\"nogrow\"  ng-click=\"vm.togglePrivate(vm.detail)\" ng-if=\"vm.detail.client && vm.detail.private\">\n						    <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n						    </md-icon> Visible to Admins only\n						    <md-tooltip md-delay=\"1000\">\n						        Toggle privacy\n						    </md-tooltip>\n						</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\">\n						<md-button class=\"\" ng-click=\"vm.cancelDialog(vm.detail)\">Cancel</md-button>\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.detail.uid\">\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\"  type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.updateDetail(vm.detail)\">\n							Save Changes\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n					<div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.detail.uid\" >\n						<md-button ng-disabled=\"vm.forms.detailDialogForm.$invalid || vm.forms.detailDialogForm.$pristine\" type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.saveNewDetail(vm.detail, clientID)\">\n							Add Bookmark\n						</md-button>\n						<label class=\"shortcut\">ctrl + enter</label>\n\n					</div>\n				</md-dialog-actions>\n				</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/profileDataService/include-profile-detail-files.tmpl.html","<md-button ng-if=\"!vm.isUploading && vm.numFiles < 5\"\n		class=\"md-primary \"\n		ngf-select=\"uploadFile($files)\"\n		ngf-multiple=\"true\"\n		ngf-max-files=\"3\"\n		ngf-max-size=\"5mb\"\n		ngf-drop=\"uploadFile($files)\"\n		ngf-drag-over-class=\"\'dragover\'\"\n		aria-label=\"upload\">\n	<md-icon md-font-icon=\"zmdi zmdi-cloud-upload\"></md-icon> Attach Files\n	<div class=\"dropzone\">\n		<p class=\"center\">Drop File to Upload</p>\n	</div>\n </md-button>\n<md-button ng-if=\"vm.isUploading\" type=\"button\" class=\"md-primary \"  aria-label=\"Uploading\">\n	 <md-icon><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12px\"></md-progress-circular></md-icon>\n		Uploading\n</md-button>\n\n<md-chips ng-model=\"vm.detail.files\" name=\"files\" readonly=\"true\" md-removable=\"true\" md-on-remove=\"removeFile($chip)\">\n	<md-chip-template >\n		 <strong><a href=\"{{$chip.url}}\" download>{{$chip.fileName}}</a></strong>\n	</md-chip-template>\n</md-chips>\n");
$templateCache.put("app/app-services/taskDataService/dialog-edit-batch.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"60\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\" class=\"item-dialog batch-task-dialog md-inline-form\">\n    <md-dialog-content>\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\" layout=\"column\" style=\"padding-top: .5em;\">\n                <h2 flex=\"100\" class=\"center\">Batch Enter Tasks</h2>\n            </div>\n        </md-toolbar>\n\n\n\n                    <form name=\"batchTasksForm\" novalidate style=\"padding: 1em;\">\n                        <md-input-container style=\"margin-bottom: 2em;\">\n                            <label>Enter multiple tasks. One per line.</label>\n                        <textarea id=\"focusfield\"  ng-model=\"vm.taskText\" class=\"batch-task-field\"></textarea>\n                        </md-input-container>\n                        <!-- <P>{{vm.thisPanel}}</P> -->\n                        <div layout=\"row\" layout-align=\"end center\" layout-padding>\n                            <md-input-container flex=\"nogrow\" style=\"\">\n                                <label>Workspace</label>\n                                <md-select md-no-asterisk placeholder=\"Select a Workspace\" ng-change=\"vm.selectClient(vm.thisClient)\" ng-model=\"vm.thisClient\" ng-model-options=\"{trackBy: \'$value.uid\'}\" required>\n                                    <md-option ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by $index\" ng-value=\"{{client}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n                                        <img ng-if=\"client.status != \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                        <img ng-if=\"client.status == \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                                        <span class=\"small\">{{client.profile.fullName}}</span></md-option>\n                                </md-select>\n                            </md-input-container>\n                            <div flex layout=\"row\" layout-align=\"end center\">\n                                <md-button data-gtm-save-batch-tasks class=\"md-raised md-accent\" ng-disabled=\"!vm.taskText || !vm.thisClient\" ng-click=\"vm.saveTasks(vm.taskText)\">Save Tasks</md-button>\n                            </div>\n                        </div>\n\n                    </form>\n\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/taskDataService/dialog-edit-task.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"80\" flex-md=\"70\" flex-lg=\"50\" flex-xl=\"50\" md-theme=\"grey-menu\" class=\"item-dialog task-item-dialog md-inline-form\" style=\"max-width: 800px;\">\n    <md-dialog-content >\n        <md-tabs md-dynamic-height class=\"task-tabs\" md-selected=\"vm.selectedTab\" md-stretch-tabs=\"always\" style=\"min-height: 400px;\">\n            <!-- General Task Details -->\n            <md-tab class=\"task-details-tab\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n                    <span class=\"hide-xs\" ng-if=\"vm.editedItem.uid\" data-gtm-edit-task=\"{{vm.editedItem.uid}}\">Details</span>\n                    <span class=\"hide-xs\" ng-if=\"!vm.editedItem.uid\" data-gtm-new-task>New Task</span>\n                </md-tab-label>\n                <md-tab-body  layout-padding>\n                    <form name=\"taskDialogForm\" novalidate autocomplete=\"off\">\n                      <div layout=\"row\" class=\"task-assignments\" ng-class=\"{\'highlight-block\': vm.editedItem.clone}\" layout-align=\"space-between start\" style=\"padding: 1em 1em 1em 1em;  border-bottom: 1px solid #ddd; \">\n                              <md-input-container ng-if=\"!vm.isClientUser\" class=\"small-select\" flex ng-class=\"{\'highlight-block\': !vm.editedItem.info.client}\">\n                                  <label>Workspace</label>\n                                  <md-select class=\"avatar-picklist margin-right-40\"  ng-disabled=\"vm.editedItem.info.status == \'closed\' || vm.editedItem.info.logged > 0 \" placeholder=\"Select a Workspace for this task\" ng-model=\"vm.editedItem.info.client\" ng-change=\"vm.clientChange(vm.editedItem.info.client, true)\" required>\n                                      <md-option data-gtm-set-task-workspace class=\"avatar-option\" ng-repeat=\"client in vm.clients | orderBy: \'order\' track by client.uid + $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n                                          <div class=\"avatar-container\">\n                                              <img class=\"avatar\" ng-if=\"client.status != \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}};\">\n                                              <img class=\"avatar\" ng-if=\"client.status == \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}};\">\n                                            </div>\n                                            <span class=\"small\" style=\"position: relative; top: -2px;\">{{client.profile.fullName}}</span>\n                                      </md-option>\n                                  </md-select>\n                              </md-input-container>\n                              <!-- legacy task list picker -->\n                             <md-input-container ng-if=\"!vm.isClientUser && !vm.thisClient.defaultTaskBoard\" class=\"small-select\" flex>\n                                 <label>List</label>\n                                  <md-select class=\"avatar-picklist margin-right-40\" style=\"\" ng-disabled=\"vm.editedItem.info.status == \'closed\'\" md-no-asterisk placeholder=\"Select a list\" ng-model=\"vm.editedItem.info.panel\" ng-change=\"vm.changePanel(vm.editedItem)\"required>\n                                     <md-option data-gtm-set-task-list class=\"avatar-option\" ng-value=\"\'Later\'\" ng-selected=\"!vm.editedItem.info.panel || vm.editedItem.info.panel == \'Later\'\">\n                                      <div class=\"avatar-container\" style=\"display: inline-block;\">\n                                        <span class=\"avatar\" style=\"display:inline-block; width: 20px; height: 20px; background-color: {{panel.color || \'#bbb;\'}}; \"></span>\n                                      </div>\n                                       <span class=\"small\">New Tasks</span>\n                                     </md-option>\n                                     <md-option data-gtm-set-task-list ng-if=\"panel.label\" class=\"avatar-option\" ng-repeat=\"panel in vm.panelCandidates | toArray | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{panel.uid}}\'\">\n                                         <div class=\"avatar-container\" style=\"display: inline-block;\">\n                                          <span class=\"avatar\" style=\"display:inline-block; width: 20px; height: 20px; background-color: {{panel.color || \'#bbb;\'}}; \"></span>\n                                        </div>\n                                         <span class=\"small\">{{panel.label}}</span>\n                                     </md-option>\n                                 </md-select>\n                             </md-input-container>\n                             <!-- taskboard-list picker -->\n                             <md-input-container ng-if=\"!vm.isClientUser && vm.thisClient.defaultTaskBoard\" class=\"small-select\" flex>\n                                 <label>List</label>\n                                  <md-select class=\"avatar-picklist margin-right-40\" style=\"\" ng-disabled=\"vm.editedItem.info.status == \'closed\'\" md-no-asterisk placeholder=\"Select a list\" ng-model=\"vm.editedItem.info.list\" ng-change=\"vm.changeList(vm.editedItem)\" required>\n                                     <md-option data-gtm-set-task-list ng-if=\"(!vm.isThisClientUser || (vm.isThisClientUser && panel.clientEnabled)) && panel.label != \'Done\'\" class=\"avatar-option\" ng-repeat=\"panel in vm.activeLists | toArray | orderBy: \'order\' track by $index+panel.uid\" ng-value=\"\'{{panel.uid}}\'\">\n                                         <div class=\"avatar-container\" style=\"display: inline-block;\">\n                                          <span class=\"avatar\" style=\"display:inline-block; width: 20px; height: 20px; background-color: {{panel.color || \'#bbb;\'}}; \"></span>\n                                        </div>\n                                         <span class=\"small\">{{panel.label}}</span>\n                                     </md-option>\n                                 </md-select>\n                             </md-input-container>\n                             <div ng-if=\"vm.showAssignmentField\" flex layout=\"column\" layout-align=\"start layout-fill\">\n\n                               <md-input-container class=\"small-select\"  style=\" max-width: 300px;\"  flex>\n                                   <label>Assigned to</label>\n                                   <md-select ng-if=\"!vm.teamListLoading\" class=\"avatar-picklist margin-right-20\" ng-disabled=\"!vm.editedItem.info.client || (!vm.isAdmin && !vm.isTaskOwner) || vm.editedItem.info.status == \'closed\'\" style=\"\" ng-model=\"vm.editedItem.info.assignee\"   placeholder=\"Assign to User\">\n                                       <md-option data-gtm-delegate-task class=\"avatar-option\" ng-repeat=\"member in vm.teamList | toArray : false | filter: {\'status\': \'active\'}  | orderBy: \'profile.lastName\' track by $index+member.uid\" ng-value=\"\'{{member.uid}}\'\"  style=\"border-left: 4px solid {{member.color}};\">\n                                          <avatar parent=\"member\" upload=\"false\" border=\"member.color\"></avatar>\n                                          <span class=\"small\" style=\"position: relative; top: -2px;\">{{member.fullName}}</span>\n                                       </md-option>\n                                   </md-select>\n                               </md-input-container>\n\n                             </div><!-- if vm.showAssignmentField\" -->\n                      </div>\n                        <div class=\"primary-task-field-group\">\n                            <div class=\"main-task-field-container\">\n                                <div flex layout=\"row\" >\n                                    <!-- toggles -->\n                                    <div flex=\"nogrow\" layout=\"column\" >\n                                        <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'open\' && vm.editedItem.type !=\'template\' && !vm.editedItem.info.archived\">\n                                            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-square-o\">\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Toggle Complete\n                                            </md-tooltip>\n                                        </md-button>\n                                        <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleComplete(vm.editedItem)\" ng-show=\"vm.editedItem.info.status == \'closed\' && vm.editedItem.type !=\'template\'  && !vm.editedItem.info.archived\">\n                                            <md-icon class=\"app-item-checkbox\" md-font-icon=\"zmdi zmdi-check-square\">\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Toggle Complete\n                                            </md-tooltip>\n                                        </md-button>\n                                         <md-menu ng-if=\"!vm.isClientUser && !vm.editedItem.info.archived\">\n                                              <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"$mdMenu.open()\">\n                                                  <md-icon ng-if=\"!vm.editedItem.info.priority\" class=\"\" md-font-icon=\"zmdi zmdi-flag\"></md-icon>\n                                                  <md-icon ng-if=\"vm.editedItem.info.priority\" class=\"{{vm.editedItem.info.priority.color}}\" md-font-icon=\"zmdi zmdi-flag\"></md-icon>\n                                              </md-button>\n                                              <md-menu-content>\n                                                  <md-menu-item >\n                                                       <md-button ng-click=\"vm.setPriority(\'none\', $event)\">\n                                                            <md-icon md-font-icon=\"zmdi zmdi-block\"></md-icon>\n                                                            None\n                                                       </md-button>\n                                                  </md-menu-item>\n                                                  <md-menu-item  ng-repeat=\"priority in vm.taskBoard.priorities | toArray: false | orderBy: \'[priority]\' track by $index+uid\">\n                                                       <md-button ng-click=\"vm.setPriority(priority, $event)\">\n                                                            <md-icon md-font-icon=\"zmdi zmdi-flag\" class=\"{{priority.color}}\"></md-icon>\n                                                            Priority {{priority.priority}}\n                                                       </md-button>\n                                                  </md-menu-item>\n                                            </md-menu-content>\n                                        </md-menu>\n                                       <!--  <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"!vm.isClientUser && vm.editedItem.info.focus == \'today\' && vm.editedItem.info.status != \'completed\' && vm.editedItem.type !=\'template\'  && !vm.editedItem.info.archived\">\n                                            <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-on\" class=\"today-icon\">\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Toggle Today\n                                            </md-tooltip>\n                                        </md-button>\n                                        <md-button  flex=\"nogrow\" class=\"md-icon-button\" ng-click=\"toggleToday(vm.editedItem)\" ng-show=\"!vm.isClientUser && vm.editedItem.info.focus != \'today\' && vm.editedItem.info.status != \'completed\' && vm.editedItem.type !=\'template\'  && !vm.editedItem.info.archived\">\n                                            <md-icon md-font-icon=\"zmdi zmdi-sun\" class=\"focused-off\" class=\"today-icon\">\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Toggle Today\n                                            </md-tooltip>\n                                        </md-button> -->\n                                        <md-button  flex=\"nogrow\" class=\"md-icon-button\"  ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-click=\"togglePrivate(vm.editedItem)\" ng-if=\"(vm.editedItem.info.client && !vm.isClientUser && vm.getUserRole(vm.editedItem.info.client) != \'member\' && !vm.editedItem.info.private && !vm.editedItem.info.archived) || (vm.editedItem.info.client && !vm.isClientUser && vm.hasClientUsers && !vm.editedItem.info.private)\">\n                                            <md-icon md-font-icon=\"zmdi zmdi-eye\" >\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Everyone can see this task\n                                            </md-tooltip>\n                                        </md-button>\n                                        <md-button  flex=\"nogrow\" class=\"md-icon-button\"  ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-click=\"togglePrivate(vm.editedItem)\" ng-if=\"(vm.editedItem.info.client && !vm.isClientUser && vm.getUserRole(vm.editedItem.info.client) != \'member\' && vm.editedItem.info.private  && !vm.editedItem.info.archived) || (vm.editedItem.info.client && !vm.isClientUser && vm.hasClientUsers && vm.editedItem.info.private)\">\n                                            <md-icon md-font-icon=\"zmdi zmdi-eye-off\" style=\"color: orange;\">\n                                            </md-icon>\n                                            <md-tooltip md-delay=\"1000\">\n                                                Only Admins can see this task\n                                            </md-tooltip>\n                                        </md-button>\n                                        <!-- snooze controls - deprecated July 2021 -->\n                                       <!--  <md-menu ng-if=\"!vm.isClientUser && vm.editedItem.uid && !vm.editedItem.info.snooze && !vm.editedItem.info.archived\">\n                                             <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\"> <md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\"></md-icon>\n                                                <md-tooltip md-delay=\"1000\">Snooze Task</md-tooltip></md-button>\n                                             <md-menu-content>\n                                                 <md-menu-item>\n                                                      <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 15, $event)\">\n                                                         15 min\n                                                     </md-button>\n                                                  </md-menu-item>\n                                                  <md-menu-item>\n                                                       <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 30, $event)\">\n                                                          30 min\n                                                      </md-button>\n                                                   </md-menu-item>\n                                                   <md-menu-item>\n                                                        <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 60, $event)\">\n                                                           60 min\n                                                       </md-button>\n                                                    </md-menu-item>\n                                                    <md-menu-item>\n                                                         <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 120, $event)\">\n                                                            2 hr\n                                                        </md-button>\n                                                     </md-menu-item>\n                                                     <md-menu-item>\n                                                          <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 480, $event)\">\n                                                             8 hr\n                                                         </md-button>\n                                                      </md-menu-item>\n                                                      <md-menu-item>\n                                                           <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 720, $event)\">\n                                                              12 hr\n                                                          </md-button>\n                                                       </md-menu-item>\n                                                       <md-menu-item>\n                                                            <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 1440, $event)\">\n                                                               1 day\n                                                           </md-button>\n                                                        </md-menu-item>\n                                                        <md-menu-item>\n                                                             <md-button flex=\"nogrow\"  ng-click=\"snoozeTask(vm.editedItem.info, 2880, $event)\">\n                                                                2 days\n                                                            </md-button>\n                                                         </md-menu-item>\n\n                                           </md-menu-content>\n                                       </md-menu>\n                                       <md-button flex=\"nogrow\" class=\"md-icon-button\"  ng-click=\"unSnoozeTask(vm.editedItem.info)\" ng-if=\"!vm.isClientUser && vm.editedItem.uid && vm.editedItem.info.snooze && !vm.editedItem.info.archived\">\n                                           <md-icon md-font-icon=\"zmdi zmdi-alarm-snooze\" style=\"color: green;\">\n                                           </md-icon>\n                                           <md-tooltip md-delay=\"1000\">\n                                               Un-snooze task\n                                           </md-tooltip>\n                                       </md-button>-->\n                                       <div  ng-if=\"!vm.isClientUser && vm.canUseTimer\">\n                                           <md-button  data-gtm-start-task-timer  ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.isTimerRunning(vm.editedItem.info) && !vm.hasOpenTimers(vm.editedItem.info) && vm.editedItem.uid\" ng-click=\"vm.startTimer(vm.editedItem.info, $event)\" class=\"md-icon-button\" >\n                                               <md-icon  md-font-icon=\"zmdi zmdi-play\">\n                                                   <md-tooltip md-delay=\"500\">Start Task Timer</md-tooltip>\n                                               </md-icon>\n                                           </md-button>\n                                           <md-button  data-gtm-resume-task-timer ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.isTimerRunning(vm.editedItem.info) && vm.hasOpenTimers(vm.editedItem.info)\"  ng-click=\"vm.resumeTimer(vm.editedItem.info, $event)\" class=\"md-icon-button\" >\n                                               <md-icon style=\"color: orange;\" class=\"rotate-90\" md-font-icon=\"zmdi zmdi-eject\" >\n                                                   <md-tooltip md-delay=\"500\">Resume Task Timer</md-tooltip>\n                                               </md-icon>\n                                           </md-button>\n                                           <md-button  data-gtm-pause-task-timer ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"vm.isTimerRunning(vm.editedItem.info)\" class=\"md-icon-button\" >\n                                               <md-icon  style=\"color: green;\" md-font-icon=\"zmdi zmdi-pause\"  ng-click=\"vm.pauseTimer(vm.editedItem.info, $event)\" >\n                                                   <md-tooltip md-delay=\"500\">Pause Task Timer</md-tooltip>\n                                               </md-icon>\n                                           </md-button>\n\n                                           <!-- <md-icon md-font-icon=\"zmdi zmdi-play\" ng-click=\"startTimer(item)\" style=\"max-width: 16px; width: 16px;\">\n                                               <md-tooltip md-delay=\"500\">Add Time Entry</md-tooltip>\n                                           </md-icon> -->\n                                       </div>\n                                        <div style=\"width: 25px;\" ng-if=\"vm.editedItem.type ==\'template\'\">\n                                        </div>\n                                        <div style=\"width: 25px;\">&nbsp;</div>\n                                    </div>\n\n                                    <!-- main fields -->\n                                    <div flex=\"grow\" layout=\"column\" >\n                                        <div style=\"display:block;\">\n                                            <md-input-container class=\"task-description-container\">\n                                                <textarea\n                                                    ng-disabled=\"vm.editedItem.info.status == \'closed\'\"\n                                                    class=\"task-description\"\n                                                    name=\"description\"\n                                                    id=\"taskdescription\"\n                                                    md-autofocus=\"!vm.editedItem.uid\"\n                                                    md-no-asterisk\n                                                    ng-model=\"vm.editedItem.info.description\"\n                                                    placeholder=\"Task description\"\n                                                    required=\"required\"\n                                                    style=\"margin-bottom: 0; border: 1px solid #ddd; font-weight: 300; min-height: 185px; max-height: 300px; overflow-y: scroll;\"\n                                                    ng-model-options=\"{ updateOn: \'default blur\',\n                                                         debounce: {\n                                                           default: 300,\n                                                           blur: 0\n                                                         }\n                                                    }\"\n                                                    >\n                                                    </textarea>\n                                            </md-input-container>\n                                        </div>\n\n                                            <!-- due -->\n\n                                            <!-- start form -->\n                                            <div class=\"reveal\" ng-if=\"vm.showStartEditor && vm.editedItem.type !=\'template\'\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding: 0em 2em 0em 0;\">\n                                                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" style=\"padding-left: 8px;\">\n                                                        <p flex=\"nogrow\" class=\"md-subhead\" style=\"margin:0; font-size: 12px;\">\n                                                            <strong>Start:</strong>\n                                                            </p>\n                                                        <md-input-container flex=\"nogrow\" style=\"margin-top:0;\">\n                                                            <md-datepicker ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"input-top-adjust\" ng-change=\"vm.setDirty()\" ng-model=\"vm.editedItem.info.startdate\" md-placeholder=\"Select date\" md-max-date=\"vm.maxStartDate\"></md-datepicker>\n                                                        </md-input-container>\n                                                    <md-button flex=\"nogrow\" class=\"md-button date-timestamp\" ng-click=\"vm.displayStartTimeDialog(vm.editedItem.info.startdate)\" ng-disabled=\"!vm.editedItem.info.duedate || vm.editedItem.info.status == \'closed\' || vm.editedItem.info.archived\" style=\"color: #000; margin-left: 10px;\">\n                                                        <md-icon md-font-icon=\"fa fa-clock-o\"></md-icon>\n                                                        {{vm.editedItem.info.startdate | amDateFormat: \"h:mmA\"}}\n                                                        <md-tooltip md-delay=\"500\">Set specific time</md-tooltip>\n                                                    </md-button>\n                                                </div>\n                                                <div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\">\n                                                    <md-button data-gtm-set-task-start class=\"md-accent  md-icon-button\" ng-disabled=\"vm.areDatesSame(vm.editedItem.info.startdate, vm.editedItem.info.duedate) ||  vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\"  ng-click=\"vm.showStartEditor = false\">\n                                                        <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n                                                        <md-tooltip md-delay=\"500\">\n                                                            Save\n                                                        </md-tooltip>\n                                                    </md-button>\n\n                                                    <md-button data-gtm-remove-task-start class=\"md-icon-button\" ng-disabled=\"vm.editedItem.info.archived||vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.removeStartDate()\">\n                                                        <md-icon md-font-icon=\"fa fa-trash-o\"></md-icon>\n                                                        <md-tooltip md-delay=\"500\">\n                                                            Remove\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                    <md-button data-gtm-cancel-task-start class=\"md-icon-button\" ng-disabled=\"vm.editedItem.info.archived ||vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showStartEditor = false\">\n                                                        <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n                                                        <md-tooltip md-delay=\"500\">\n                                                            Cancel\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                </div>\n\n                                            </div>\n                                            <!-- change start / change end buttons -->\n                                            <div layout=\"row\" layout-align=\"start start\">\n                                                <div ng-if=\"vm.editedItem.info.duedate && !vm.areDatesSame(vm.editedItem.info.startdate, vm.editedItem.info.duedate) && vm.editedItem.info.startdate && !vm.showStartEditor && vm.editedItem.type !=\'template\'\"  layout=\"row\" layout-align=\"start center\" style=\"\">\n                                                    <md-button class=\"md-button-small date-timestamp\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showStartEditor = true\" style=\"\">\n                                                        <strong>Start:</strong> {{vm.editedItem.info.startdate| amDateFormat: \"LLL\"}}\n                                                        <md-tooltip>\n                                                            Change start\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                </div><!-- start label -->\n                                                <div ng-if=\"vm.editedItem.info.duedate && !vm.showDueEditor && vm.editedItem.type !=\'template\'\"  layout=\"row\" layout-align=\"start center\" style=\"\">\n                                                    <md-button class=\"button-toggle-due md-button-small date-timestamp\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showDueEditor = true\" style=\"\" ng-style=\"vm.dueStyle\">\n                                                        <strong>Due:</strong> <span style=\"{{vm.dueStyle}}\">{{vm.editedItem.info.duedate| amDateFormat: \"LLL\"}}</span>\n                                                        <md-tooltip>\n                                                            Change due\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                    <div ng-if=\"!vm.showStartEditor && vm.editedItem.info.duedate && (!vm.editedItem.info.startdate || vm.areDatesSame(vm.editedItem.info.startdate, vm.editedItem.info.duedate))\" flex=\"nogrow\"  style=\"margin-left: 0; padding-left: 0em; \">\n                                                        <md-button ng-click=\"vm.addStartDate(vm.editedItem)\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" class=\"md-button-small\" style=\"font-size: 11px; color: #bbb;\">\n                                                            <!-- <md-icon md-font-icon=\"zmdi zmdi-calendar-alt\" style=\"color: #bbb; \"></md-icon> -->\n                                                           <span style=\"text-decoration: underline;\">set start</span>\n                                                        </md-button>\n                                                    </div>\n                                                </div><!-- due label -->\n                                            </div>\n\n                                            <!-- duedate form -->\n                                            <div ng-if=\"vm.showDueEditor && vm.editedItem.type !=\'template\'\" class=\"reveal due-date-form\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding: 0em 2em 0em 0\">\n                                                 <div flex=\"100\" flex-gt-sm=\"nogrow\" layout=\"row\" layout-align=\"start start\" style=\"padding-left: 8px;\">\n                                                        <p  class=\"md-subhead\" style=\"font-size: 12px; \">\n                                                        <strong>Due:</strong>\n                                                        </p>\n\n                                                        <md-input-container flex=\"nogrow\" style=\"margin-top: 8px;\">\n                                                            <md-datepicker class=\"input-top-adjust\" md-open-on-focus=\"true\" ng-disabled=\"vm.editedItem.info.status == \'closed\'|| vm.editedItem.info.archived\" ng-change=\"vm.dueChanged()\" ng-model=\"vm.editedItem.info.duedate\" md-placeholder=\"Select date\" ></md-datepicker>\n                                                        </md-input-container>\n\n                                                        <div flex=\"nogrow\" layout=\"row\" style=\"margin-top: 11px;\">\n                                                            <md-button class=\"md-button md-button-small date-timestamp\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.displayDueTimeDialog(vm.editedItem.info.duedate)\" ng-disabled=\"!vm.editedItem.info.duedate || vm.editedItem.info.status == \'closed\'\" style=\"color: #000; margin-left: 2px; margin-top:0;\">\n                                                                <md-icon md-font-icon=\"fa fa-clock-o\" style=\"color: #777;\"></md-icon> {{vm.editedItem.info.duedate | amDateFormat: \"h:mmA\"}}\n                                                                <md-tooltip md-delay=\"500\">Change time</md-tooltip>\n                                                            </md-button>\n                                                        </div>\n                                                </div>\n                                                <div flex=\"100\" flex-gt-sm=\"nogrow\" layout=\"row\" layout-align=\"left center\" class=\"duedate-shortcuts\" style=\"padding-left: 1em;\">\n                                                    <md-button flex class=\"md-button-small\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.setDueWith(vm.duedates.today)\">Today</md-button>\n                                                    <md-button flex class=\"md-button-small\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.setDueWith(vm.duedates.tomorrow)\">1 day</md-button>\n                                                    <md-button flex class=\"md-button-small\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.setDueWith(vm.duedates.days3)\">3 days</md-button>\n                                                    <md-button flex class=\"md-button-small\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.setDueWith(vm.duedates.days7)\">7 days</md-button>\n                                                    <md-button flex class=\"md-button-small\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.setDueWith(\'none\')\">None</md-button>\n                                                    <md-button class=\"md-accent  md-icon-button\" ng-disabed=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showDueEditor = false\">\n                                                        <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n                                                        <md-tooltip md-delay=\"500\">\n                                                            Save\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                    <md-button class=\"md-icon-button\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showDueEditor = false;\">\n                                                        <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"color: #777;\"></md-icon>\n                                                        <md-tooltip md-delay=\"500\">\n                                                            Cancel\n                                                        </md-tooltip>\n                                                    </md-button>\n                                                </div>\n                                            </div>\n                                            <div flex ng-show=\"vm.editedItem.info.status==\'closed\'\">\n                                                <p style=\"font-size: .85em; margin: 1em 0 1em 3em; color: #777;\">\n                                                <md-icon md-font-icon=\"zmdi zmdi-check-circle\" style=\"color: green; \"></md-icon>\n                                                Completed: {{vm.editedItem.info.closedDate|date: \'short\'}} </p>\n                                            </div>\n\n                                            <div ng-if=\"vm.showButtonFields || vm.editedItem.info.linkURL\" flex=\"grow\" layout=\"column\" class=\"link-button-form\" style=\"padding: 0 1em; background-color: #fff; border: 1px solid #ddd; position:relative;\">\n                                              <md-button class=\"md-icon-button\" ng-click=\"vm.editedItem.info.linkURL = null; vm.editedItem.info.linkLabel = null; vm.editedItem.info.linkTarget = null; vm.showButtonFields = false; taskDialogForm.$setDirty()\" style=\"position: absolute; top: 5px; right: 5px;\">\n                                                <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon>\n                                              </md-button>\n                                                 <p class=\"md-subhead margin-bottom-0\"><strong>Link Button</strong></p>\n                                                 <!-- <p class=\"md-subhead\" style=\"font-size: .85em;\">Use Buttons to provide onboarding links for team members and clients.</p> -->\n                                                 <div layout=\"row\" layout-align=\"layout-fill center\">\n                                                    <div flex=\"50\" class=\"padding-right-40\">\n                                                      <md-input-container class=\"margin-top-10 margin-bottom-0\">\n                                                        <label>Button Label</label>\n                                                        <input type=\"text\" ng-model=\"vm.editedItem.info.linkLabel\" required>\n                                                      </md-input-container>\n                                                    </div>\n                                                    <div flex=\"50\" class=\"padding-right-40\">\n                                                      <md-input-container class=\"margin-top-10 margin-bottom-0\" ng-placeholder=\"https://\">\n                                                        <label>Button URL</label>\n                                                        <input type=\"url\" ng-model=\"vm.editedItem.info.linkURL\" required>\n                                                      </md-input-container>\n                                                    </div>\n                                                 </div>\n                                                 <md-checkbox ng-model=\"vm.editedItem.info.linkTarget\" ng-init=\"vm.editedItem.info.linkTarget = true\"> Open in new tab\n                                             </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n\n                            <!-- Task Budget -->\n                            <div ng-if=\"vm.showBudget || vm.editedItem.info.budget\" class=\"unfocused-task-controls padding-left-40 padding-right-40\" layout=\"row\" layout-align=\"layout-fill center\" style=\"position:relative;\">\n                              <md-button class=\"md-icon-button\" ng-click=\"vm.editedItem.info.budget = null; vm.showBudget = false; taskDialogForm.$setDirty()\" style=\"position: absolute; top: 10px; right: 0px;\">\n                                <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon>\n                              </md-button>\n                                <div flex layout=\"column\" flex=\"grow\">\n                                    <p class=\"task-budget-label\" flex>\n                                        <span>Task Budget</span>\n                                    </p>\n                                    <div flex layout=\"row\" class=\"tick-row\" style=\"margin: 0 0 -17px 5px!important;\">\n                                        <div flex=\"25\" class=\"text-right tick-quarter\">\n                                            <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    <span class=\"tick-number tick-number-space\">&nbsp;</span>\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">1</span>\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    <span class=\"tick-number\">2</span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div flex=\"25\" class=\"text-right tick-quarter\">\n                                            <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">3</span>\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">4</span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div flex=\"25\" class=\"text-right tick-quarter\">\n                                            <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">5</span>\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">6</span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div flex=\"25\" class=\"text-right tick-quarter\">\n                                            <div layout=\"row\" style=\"margin:0; padding:0;\">\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark tick-hour\">\n                                                    <span class=\"tick-number\">7</span>\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right tick-mark\">\n                                                    &nbsp;\n                                                </div>\n                                                <div flex=\"25\" class=\"text-right \">\n                                                    &nbsp;\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <md-slider ng-disabled=\"vm.editedItem.info.status == \'closed\'\" class=\"md-accent item-budget fade\" min=\"0\" max=\"480\" step=\"5\" ng-model=\"vm.editedItem.info.budget\" ng-change=\"vm.budgetChanged(vm.editedItem.info.budget)\" ng-init=\"sliders.default=0\" aria-label=\"Task Budget\" ng-model-options=\"{debounce: 0}\"></md-slider>\n                                    <p class=\"task-budget-label center\" style=\"margin-top: -5px; color: #000;\">\n                                        <span ng-show=\"vm.editedItem.info.budget\">Estimate: {{vm.editedItem.info.budget | HandM}}hrs  | </span>\n                                        <span ng-show=\"vm.editedItem.info.logged\">Logged:\n                                 <span  ng-class=\"{ \'close\': isClose(vm.editedItem.info) , \'over\': isOver(vm.editedItem.info) }\">{{vm.editedItem.info.logged | HandM}}hrs</span>\n                                        </span>\n                                    </p>\n                                </div>\n\n                            </div>\n                            <!-- File Attachments -->\n                            <div  ng-if=\"vm.showAttachments || vm.editedItem.info.files.length > 0\" style=\"min-height: 65px; border-top: 1px solid #ddd; position: relative;\" class=\"task-attachments padding-left-40 padding-right-40\" layout=\"row\" layout-align=\"layout-fill center\">\n                              <md-button class=\"md-icon-button\" ng-disabled=\"vm.editedItem.info.files.length > 0\" ng-click=\"vm.editedItem.info.files = []; vm.showAttachments = false; taskDialogForm.$setDirty()\" style=\"position: absolute; top: 10px; right: 0px;\">\n                                <md-icon md-font-icon=\"zmdi zmdi-close-circle-o\"></md-icon>\n                              </md-button>\n                              <file-attachments flex=\"grow\" ng-if=\"!vm.editedItem.info.archived\" files=\'vm.editedItem.info.files\' form=\"taskDialogForm\" counter=\"vm.numFiles\" status=\"vm.editedItem.info.status\" client=\"vm.editedItem.info.client\" path=\"vm.filePath\"></file-attachments>\n                            </div>\n\n                            <md-divider style=\"margin-bottom: 1em;\"></md-divider>\n                            <!-- show/hide sections -->\n\n                        </div><!-- primary task field group-->\n                        <!-- section reveal controls -->\n                        <div layout=\"row\" layout-align=\"start center\" class=\"padding-left-40\">\n                          <div ng-if=\"!vm.editedItem.info.duedate && !vm.showDueEditor && vm.editedItem.type !=\'template\'\"  layout=\"row\" layout-align=\"start center\" class=\"margin-right-20\">\n                              <md-button class=\"md-button-small date-timestamp button-toggle-due\" ng-disabled=\"vm.editedItem.info.archived || vm.editedItem.info.status == \'closed\'\" ng-click=\"vm.showDueEditor = true\">\n                                  <md-icon md-font-icon=\"zmdi zmdi-calendar-alt\" style=\"color: #bbb; \"></md-icon>\n                                  <strong>Add Due Date</strong>\n                                  <md-tooltip>\n                                      Set due date\n                                  </md-tooltip>\n                              </md-button>\n                          </div><!-- due label -->\n                          <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.showAttachments && !vm.editedItem.info.files.length\" class=\"md-button-small date-timestamp button-toggle-due margin-right-20\" ng-click=\"vm.showAttachments = true\">\n                            <md-icon md-font-icon=\"zmdi zmdi-attachment\" style=\"color: #bbb; \"></md-icon>\n                            Attach  Files\n                          </md-button>\n                          <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" ng-if=\"!vm.showBudget && !vm.editedItem.info.budget\" class=\"md-button-small date-timestamp button-toggle-due margin-right-20\" ng-click=\"vm.showBudget = true\">\n                            <md-icon md-font-icon=\"fa fa-sliders\" style=\"color: #bbb; \"></md-icon>\n                            Set Budget\n                          </md-button>\n                          <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" flex=\"nogrow\" ng-if=\"!vm.showButtonFields && !vm.editedItem.info.linkURL\"  class=\"md-button-small date-timestamp button-toggle-due margin-right-20\" ng-click=\"vm.showButtonFields = true\">\n                              <md-icon md-font-icon=\"fa fa-link\" style=\"font-size: 11px;\"></md-icon> Add Link Button\n                          </md-button>\n                        </div>\n                        <div layout=\"row\" layout-align=\"layout-fill center\" style=\"padding: 0 1em 1em 1em;\">\n                              <div flex=\"50\" layout=\"row\" layout-align=\"start center\" >\n                                   <md-button ng-if=\"vm.editedItem.uid\" flex=\"nogrow\" ng-disabled=\"!vm.isAdmin\" data-gtm-delete-task class=\"button-label-container md-warn\" ng-click=\"deleteTask(vm.editedItem)\" aria-label=\"delete\" >\n                                       <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n                                       Delete\n                                   </md-button>\n                                   <div flex=\"nogrow\" ng-if=\"vm.editedItem.info.assignee != vm.userID\">\n                                     <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" data-gtm-follow-task ng-if=\"!vm.isFollowing\" class=\"button-label-container\" ng-click=\"vm.toggleFollow(vm.isFollowing, vm.editedItem)\" aria-label=\"follow\">\n                                         + Follow\n                                         <md-tooltip md-delay=\"1000\">Receive notifications for task activity</md-tooltip>\n                                     </md-button>\n                                     <md-button ng-disabled=\"vm.editedItem.info.status == \'closed\'\" data-gtm-unfollow-task ng-if=\"vm.isFollowing\" class=\"button-label-container\" ng-click=\"vm.toggleFollow(vm.isFollowing, vm.editedItem)\" aria-label=\"unfollow\">\n                                       - Unfollow\n                                       <md-tooltip md-delay=\"1000\">Stop receiving notifications for task activity</md-tooltip>\n                                     </md-button>\n                                   </div>\n                              </div>\n                              <div flex=\"50\" layout=\"row\" layout-align=\"end center\" >\n                                        <div flex=\"nogrow\" class=\"button-label-container\">\n                                            <md-button class=\"\" ng-click=\"cancelDialog(vm.editedItem)\">\n                                                Cancel\n                                            </md-button>\n                                        </div>\n                                        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid\">\n                                            <md-button ng-if=\"vm.editedItem.info.status != \'closed\'\" ng-disabled=\"taskDialogForm.$pristine || vm.editedItem.info.archived\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                                Update\n                                            </md-button>\n                                            <md-button ng-if=\"vm.editedItem.info.status == \'closed\'\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"cancelDialog(vm.editedItem)\">\n                                                Done\n                                            </md-button>\n                                            <label class=\"shortcut\">ctrl + enter</label>\n                                        </div>\n                                        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid\">\n                                            <md-button ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client || !vm.editedItem.info.description\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewTask(vm.editedItem)\">\n                                                Save\n                                            </md-button>\n                                            <label class=\"shortcut\">ctrl + enter</label>\n                                        </div>\n                              </div>\n                        </div>\n                    </form>\n                </md-tab-body>\n            </md-tab>\n            <md-tab ng-if=\"vm.showChecklists(vm.editedItem)\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-check-all\"></md-icon> <span class=\"hide-xs\">Subtasks <span ng-show=\"vm.editedItem.type != \'template\'\">{{vm.editedItem.info.numCompleteItems || 0}}/{{vm.editedItem.info.numChecklistItems || 0}}</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body class=\"\" >\n                    <div layout=\"column\" class=\"task-checklist drag-checklist\"\n                        style=\"min-height: 300px;\"\n                        dragula=\"\'drag-checklist\'\"\n                        dragula-scope=\"$scope\">\n\n                        <div class=\"checklist-item\" uid=\"{{item.uid}}\" ng-repeat=\"item in vm.editedItem.checklist | toArray : false | orderBy: [\'order\'] track by $index + uid\" layout=\"row\" layout-align=\"start center\">\n                          <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding:0;\">\n                               <md-button md-no-ink ng-disabled=\"!vm.editedItem.uid || vm.editedItem.info.archived\" style=\"padding:0; cursor: move;\" class=\"md-button-small\"><md-icon md-font-icon=\"fa fa-reorder\" class=\"handle\"></md-icon></md-button>\n                          </div>\n                            <div flex=\"nogrow\">\n                                <md-checkbox data-gtm-toggle-subtask-complete ng-if=\"isDependencyComplete(item, $index)\" ng-disabled=\"!vm.editedItem.uid || vm.editedItem.info.archived\" flex=\"nogrow\" ng-model=\"item.complete\" aria-label=\"Mark complete\" ng-click=\"vm.updateChecklistItem(item, vm.editedItem)\" style=\"margin:0;\"></md-checkbox>\n                                <md-checkbox ng-disabled=\"true\" ng-if=\"!isDependencyComplete(item, $index)\"  ng-model=\"item.complete\" style=\"margin:0;\"></md-checkbox>\n                            </div>\n                            <div flex=\"auto\" ng-bind-html=\"item.body | linky:\'_blank\'\">\n                            </div>\n\n                            <div ng-if=\"vm.editedItem.type != \'template\' && !item.complete\" flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding:0;\">\n                              <reminders ng-if=\"vm.hasReminder(item)\" options=\"vm.myReminder(item)\" status=\"on\"></reminders>\n                              <reminders ng-if=\"!vm.hasReminder(item)\"  options=\"vm.reminderOptions(item, vm.editedItem)\" status=\"off\"></reminders>\n                            </div>\n                            <!-- <div ng-if=\"vm.editedItem.type == \'template\'\" flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding:0;\">\n                              <md-button class=\"md-icon-button\" ng-disabled=\"true\">\n                                  <md-icon   md-font-icon=\"fa fa-bell-o\">\n                                      <md-tooltip md-delay=\"1000\">You can set reminders on any tasks that this template is used to create.</md-tooltip>\n                                  </md-icon>\n                              </md-button>\n                            </div> -->\n                            <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding:0;\">\n                                 <md-button style=\"padding:0;\" ng-disabled=\"!vm.isAdmin || vm.editedItem.info.archived\" class=\"md-button-small\" ng-click=\"vm.editChecklistItem(item, vm.editedItem)\"><md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon></md-button>\n                            </div>\n                            <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding:0;\">\n                                 <md-button data-gtm-delete-subtask ng-disabled=\"(!vm.editedItem.uid && !vm.isAdmin) || vm.editedItem.info.archived\" style=\"padding:0;\" class=\"md-button-small\" ng-click=\"vm.deleteChecklistItem(item, vm.editedItem)\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n                            </div>\n\n\n                        </div>\n                    </div>\n                    <div layout=\"column\" class=\"task-checklist-controls md-padding\" style=\"margin-top: 0;\" >\n                        <div ng-show=\"!vm.editedItem.uid\">\n                            <p style=\"text-align:center;\">\n                                Subtasks can be modified after the task is saved.\n                            </p>\n                        </div>\n                         <div class=\"add-checklist-item\" ng-show=\"vm.editedItem.uid\">\n                             <form name=\"forms.addCheckListItemForm\">\n                                 <md-input-container >\n                                     <label>Add a subtask...</label>\n                                     <input adminja-enter=\"vm.addChecklistItem(vm.newChecklistItem, vm.editedItem)\" id=\"focusfield\" type=\"text\" ng-model=\"vm.newChecklistItem.body\">\n                                 </md-input-container>\n\n                                 <md-button ng-if=\"!vm.newChecklistItem.uid\"  ng-click=\"vm.addChecklistItem(vm.newChecklistItem, vm.editedItem)\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newChecklistItem.body || vm.editedItem.info.archived\" aria-label=\"Add\" md-no-ink=\"true\" >\n                                    <span >Add</span>\n                                  </md-button>\n                                 <md-button ng-if=\"vm.newChecklistItem.uid\"  ng-click=\"vm.addChecklistItem(vm.newChecklistItem, vm.editedItem)\" class=\"md-raised md-accent\" ng-disabled=\"!vm.newChecklistItem.body || vm.editedItem.info.archived\" aria-label=\"Add\" md-no-ink=\"true\" >\n                                    <span>Update</span>\n                                 </md-button>\n                                 <md-button ng-disabled=\"vm.editedItem.info.archived\" ng-click=\"vm.cancelEditChecklistItem()\" class=\"md-button-small\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button>\n                             </form>\n\n                         </div>\n                          <div layout=\"row\" layout-align=\"end center\">\n                             <md-input-container flex=\"auto\" ng-if=\"vm.editedItem.checklist && (vm.isAdmin || vm.isTaskOwner)\">\n                                 <!-- <label>Subtasks must be completed in order</label> -->\n                                 <md-switch class=\"md-accent\" ng-model=\"vm.editedItem.orderedChecklist\" ng-change=\"vm.updateForcedOrder(vm.editedItem)\" ng-true-value=\"true\" ng-false-value=\"false\">\n                                     Force subtasks to be completed in order.\n                                     <md-tooltip md-delay=\"1000\">\n                                         Items must be completed in order.\n                                     </md-tooltip>\n                                 </md-switch>\n                             </md-input-container>\n                             <!-- <md-button class=\"md-raised\" palette-background=\"green:500\" ng-click=\"vm.showChecklistForm()\" ng-if=\"!vm.shouldShowForm\">+ Add items</md-button> -->\n                         </div>\n                    </div>\n                </md-tab-body>\n            </md-tab>\n            <!-- Comments/Task Notes -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.editedItem.type !=\'template\'\" md-on-select=\"setupNotes();\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"fa fa-comment-o\"></md-icon> <span class=\"hide-xs\">Discussion</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <div  style=\"min-height: 300px;\">\n                        <task-notes class=\"fade\" task=\"{{vm.editedItem}}\" client=\"{{vm.thisClient}}\" ></task-notes>\n                    </div>\n                </md-tab-body>\n            </md-tab>\n            <!-- Time Log -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.canLogTime && vm.editedItem.type !=\'template\'\">\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon> <span class=\"hide-xs\">Time</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                    <div style=\"min-height: 300px;\">\n                        <task-time class=\"fade\" local=\"true\" task=\"{{vm.editedItem.uid}}\" client=\"{{vm.editedItem.info.client}}\" ></task-time>\n                        <div ng-if=\"!vm.isClientUser\" layout=\"row\" layout-align=\"start center\">\n                            <md-button ng-disabled=\"vm.editedItem.info.archived\" ng-click=\"vm.addTime(vm.editedItem)\" class=\"md-primary\">+ Log Time</md-button>\n                        </div>\n                    </div>\n                </md-tab-body>\n            </md-tab>\n\n            <!-- Recurrence Settings Log -->\n            <md-tab ng-if=\"vm.editedItem.type==\'template\'\">\n\n                <md-tab-label>\n                    <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon> <span class=\"hide-xs\">Recurring Schedule</span></md-tab-label>\n                </md-tab-label>\n                <md-tab-body>\n                <form name=\"recurringForm\" style=\"min-height: 300px;\">\n                    <div layout=\"row\" layout-padding>\n                        <md-switch style=\"margin:0;\" flex=\"nogrow\" class=\"md-secondary\" ng-model=\"vm.editedItem.isRecurring\" ng-change=\"vm.setDirty()\"></md-switch>\n                        <p flex=\"nogrow\" style=\"margin:0;\">Enable repeating schedule</p>\n\n                    </div>\n                    <div layout-fill layout-padding layout=\"column\">\n\n                        <div layout=\"row\" layout-align=\"start center\">\n                            <div flex>\n                                <md-input-container>\n                                    <label>When should this task repeat?</label>\n                                    <input type=\"text\" ng-disabled=\"!vm.editedItem.isRecurring\" class=\"ruletext\" name=\"ruletext\" ng-model=\"vm.editedItem.schedule.ruleText\"  placeholder=\"e.g. Every 2 weeks on Monday\"  ng-change=\"vm.resetValidity()\">\n                                    <div class=\"task-repeating-tooltip\">\n                                        <md-icon md-font-icon=\"zmdi zmdi-help\">\n                                            <p style=\"margin:0; display:inline; font-size: 10px;\">Examples</p>\n                                            <md-tooltip md-delay=\"500\" class=\"help\" md-direction=\"top\">\n                                                <p class=\"text-center\"><strong>Examples</strong></p>\n                                                <p class=\"text-center\">Every 2 weeks on Tuesday<br>\n                                                        Every week on Monday, Wednesday<br>\n                                                        Every Saturday and Sunday<br>\n                                                        Every month on the 1st and 15th<br>\n                                                        Every month on the 15th and last day<br>\n                                                        Every Monday for 6 times<br>\n                                                        Every 6 weeks on Monday<br>\n                                                        Every month on the 2nd last Friday for 7 times<br>\n                                                        Every 6 months<br>\n                                                        Every year</p>\n                                            </md-tooltip>\n                                        </md-icon>\n                                    </div>\n                                </md-input-container>\n\n                            </div>\n\n                        </div>\n                        <div layout=\"row\" layout-align=\"start center\">\n\n                            <div flex=\"nogrow\">\n                                <md-input-container>\n                                    <md-datepicker class=\"input-top-adjust\" md-open-on-focus=\"true\" ng-disabled=\"!vm.editedItem.isRecurring\" ng-model=\"vm.startOn\" md-placeholder=\"Start on\" ng-change=\"vm.resetValidity()\" md-min-date=\"vm.minDate\" placeholder=\"Start on\"></md-datepicker>\n                                </md-input-container>\n                            </div>\n                                <div flex=\"nogrow\" style=\"margin-top: 18px;\">\n                                    <md-button ng-disabled=\"!vm.editedItem.isRecurring || vm.editedItem.info.archived\" class=\"md-button md-button-small date-timestamp\" ng-click=\"vm.displayTemplateTimeDialog(vm.startOn)\" style=\"margin-left: 2px; margin-top:0;\">\n                                        <md-icon md-font-icon=\"fa fa-clock-o\" ></md-icon> {{vm.startOn | amDateFormat: \"h:mmA\"}}\n                                        <md-tooltip md-delay=\"500\">Set time</md-tooltip>\n                                    </md-button>\n                                </div>\n                        </div>\n                        <div layout=\"row\">\n                            <div layout=\"column\" layout-align=\"start start\" flex=\"100\" flex-gt-md=\"40\">\n                                <md-button ng-disabled=\"!vm.editedItem.isRecurring\" class=\"md-raised md-accent\" ng-if=\"!vm.validRule\" ng-disabled=\"!vm.editedItem.schedule.ruleText || vm.editedItem.info.archived\" aria-label=\"Repeating rule\" ng-click=\"vm.calcRule(vm.editedItem.schedule.ruleText)\">Test</md-button>\n\n                                <ul>\n                                    <li ng-if=\"vm.validRule\"><strong>Schedule Preview</strong></li>\n                                    <li style=\"font-size: 11px;\" ng-repeat=\"(key, value) in vm.rulePreview\">\n                                        {{value}}\n                                    </li>\n                                </ul>\n                                <md-button ng-if=\"vm.validRule\" ng-disabled=\"!vm.editedItem.description || !vm.validRule\" aria-label=\"Repeating rule\" style=\"color:green;\"><md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon> Valid Schedule!</md-button>\n\n                            </div>\n                        </div>\n                        <div layout=\"row\">\n                           <!--  <div flex>\n                                <md-checkbox flex=\"nogrow\" ng-model=\"vm.editedItem.schedule.hasDue\" aria-label=\"Copies have due dates\">\n                                        Copies have a due date.\n                                  </md-checkbox>\n                            </div> -->\n                            <div flex >\n                                <p>Create <input ng-disabled=\"!vm.editedItem.isRecurring\" type=\"text\" ng-model=\"vm.editedItem.schedule.dueDays\" style=\"width: 25px;\" ng-change=\"vm.calcRule(vm.editedItem.schedule.ruleText)\"> days before they are due.</p>\n                            </div>\n\n                        </div>\n\n\n                    </div>\n                    <div layout=\"row\" layout-align=\"end center\">\n                        <div flex=\"40\" layout=\"row\" layout-align=\"end center\">\n                            <div flex=\"nogrow\" class=\"button-label-container\">\n                                <md-button class=\"\" ng-click=\"cancelDialog(editedItem)\">\n                                    Cancel\n                                </md-button>\n                            </div>\n                            <!--<div flex=\"nogrow\" class=\"button-label-container\">\n                                                <md-button ng-hide=\"vm.editedItem.uid\" ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client\" class=\"md-adminja-shade-theme md-primary\" ng-click=\"saveNewTask(vm.editedItem,\'andNew\')\">Add and New</md-button>\n                                                <label class=\"shortcut\">shift + ctrl + enter</label>\n                              </div>-->\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid && vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.isRecurring || vm.editedItem.info.archived\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                    Schedule\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.editedItem.uid && !vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine || vm.editedItem.info.archived\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveUpdatedTask(vm.editedItem)\">\n                                    Save Changes\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                            <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.editedItem.uid && vm.editedItem.isRecurring\">\n                                <md-button ng-disabled=\"taskDialogForm.$pristine || !vm.editedItem.info.client || !vm.editedItem.info.description || !vm.validRule || !vm.editedItem.isRecurring\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveNewTask(vm.editedItem)\">\n                                    Save &amp; Schedule\n                                </md-button>\n                                <label class=\"shortcut\">ctrl + enter</label>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                </md-tab-body>\n            </md-tab>\n            <!-- Task Activity Log -->\n            <md-tab ng-if=\"vm.editedItem.uid && vm.isAdmin && vm.showAssignmentField && !vm.isClientUser\">\n	<md-tab-label>\n	<md-icon md-font-icon=\"zmdi zmdi-receipt\"></md-icon> <span class=\"hide-xs\">Activity</span></md-tab-label>\n	</md-tab-label>\n	<md-tab-body>\n	<md-content style=\"min-height: 300px;\">\n	<md-list class=\"md-dense\">\n	<div class=\"activity-log-item\" ng-repeat=\"item in vm.editedItem.activity | toArray: false | orderBy: [\'-timestamp\'] track by $index\">\n					<md-list-item class=\"md-3-line\" style=\"border-left: 6px solid {{vm.clientColor}};\">\n					<div class=\"md-list-item-text\" layout=\"column\">\n									<div flex layout=\"row\">\n													<h3 >\n													{{item.event}}\n													</h3>\n									</div>\n									<div flex layout=\"row\">\n													<div flex>\n																	<p><em am-time-ago=\"item.timestamp\"></em></p>\n													</div>\n													<div flex class=\"center\">\n													</div>\n													<div flex class=\"right\">\n																	<h3><strong>{{item.actor}}</strong></h3>\n													</div>\n									</div>\n					</div>\n					</md-list-item>\n					<md-divider></md-divider>\n	</div>\n	</md-list>\n	</md-content>\n	</md-tab-body>\n</md-tab>\n        </md-tabs>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/taskPanelDataService/dialog-task-panel.tmpl.html","<md-dialog md-theme=\"grey-menu\" class=\"md-inline-form dialog-panel\" style=\"width:309px; min-height: 300px;\" >\n	<md-dialog-content class=\"small-scrollbar\">\n	<md-tabs md-dynamic-height class=\"\" md-selected=\"selectedTabIndex\" md-stretch-tabs=\"always\">\n		<!-- General Task Details -->\n		<md-tab>\n			<md-tab-label>\n				<md-icon md-font-icon=\"zmdi zmdi-view-column\"></md-icon> <span class=\"hide-for-medium\"><span ng-if=\"!vm.panel.uid\">New</span><span ng-if=\"vm.panel.uid\">Edit</span> List</span>\n\n			</md-tab-label>\n			<md-tab-body>\n			<form name=\"vm.panelDialogForm\">\n			<div layout=\"column\" class=\"md-padding\">\n				<md-input-container md-autofocus flex style=\"margin-bottom: 0;\">\n				       <label>Task List Name</label>\n				       <input name=\"detaillabel\" ng-model=\"vm.panel.label\" required>\n				 </md-input-container>\n				 <md-input-container ng-if=\"vm.hasClientUser\" style=\"margin-top:0;\" layout=\"row\" layout-align=\"center center\">\n				 	<md-checkbox ng-model=\"vm.panel.clientEnabled\" aria-label=\"\">Visible to Client</md-checkbox>\n				 </md-input-container>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"!vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></md-button>\n				 <md-button style=\"margin-top: -20px; border-top: 20px solid {{vm.panel.color|| \'#fff\'}};\" ng-if=\"vm.showColors\" ng-click=\"vm.toggleColors()\">Set Color <md-icon md-font-icon=\"zmdi zmdi-caret-up\"></md-icon></md-button>\n				 <div class=\"row\" layout-align=\"center center\">\n				 <div flex=\"nogrow\" ng-if=\"vm.showColors\" style=\"width: 235px;\">\n					 <lk-color-chooser colors=\"vm.colors\" selected-color=\"vm.panel.color\" ng-model=\"vm.panel.color\" ng-change=\"toggleColors();\"></lk-color-chooser>\n				 </div>\n				</div>\n			</div>\n\n				<!-- <md-divider></md-divider> -->\n\n				<md-dialog-actions style=\"border-top: none;\" class=\"md-padding\">\n				    <div layout=\"row\" layout-align=\"center center\">\n					    <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.hasCards && vm.panel.uid\">\n					    	 <md-button class=\"\" ng-click=\"removePanel(vm.panel)\">Delete </md-button>\n					    </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\">\n				        	<md-button class=\"\" ng-click=\"cancelDialog(vm.panel)\">Cancel</md-button>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"updatePanel(vm.panel)\">Save</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				        <div flex=\"nogrow\" class=\"button-label-container\" ng-show=\"!vm.panel.uid && !panelDialogForm.$pristine\">\n				        	  <md-button  data-gtm-new-task-list  ng-disabled=\"panelDialogForm.$pristine || panelDialogForm.$invalid || !vm.panel.label\" class=\"md-adminja-shade-theme md-raised md-accent\" ng-click=\"saveNewPanel(vm.panel)\">Add</md-button>\n				            <label class=\"shortcut\">ctrl + enter</label>\n				        </div>\n				    </div>\n				</md-dialog-actions>\n			</form>\n			</md-tab-body>\n		</md-tab>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/taskPanelDataService/duplicate-list-picker.tmpl.html","<md-dialog flex=\"100\" flex-md=\"40\" flex-lg=\"30\" flex-xl=\"20\"  >\n	<md-dialog-content style=\"background-color: #fff; padding-left:2em; padding-right: 2em; padding-top: 2em; padding-bottom: 1em;\" layout=\"column\" layout-align=\"start center\">\n		<h3>Select Destination Workspace</h3>\n		<md-select flex ng-model=\"vm.selectedClientID\" ng-change=\"\" >\n			<md-option ng-if=\"status != \'archived\' && client.defaultTaskBoard\" ng-repeat=\"client in vm.clients | toArray: false | orderBy: [\'order\'] track by $index + uid\" ng-value=\"client.uid\">\n				{{client.profile.fullName}}\n			</md-option>\n		</md-select>\n		<div layout=\'row\' layout-align=\'center center\' style=\"padding-bottom: 2em;\">\n			<md-button ng-click=\"vm.cancel()\">Cancel</md-button> <md-button ng-click=\"vm.confirm(vm.selectedClientID)\" class=\"md-raised md-accent\" ng-disabled=\"!vm.selectedClientID\">Duplicate List</md-button>\n		</div>\n		<p class=\"md-subhead center\" style=\"font-size: .85em;\">Note: For security reasons, file attachments are not duplicated.</p>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/teamDataService/dialog-edit-team.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"60\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\" class=\"md-inline-form\" >\n    <md-dialog-content >\n        <md-tabs class=\"md-primary no-active\" md-stretch-tabs=\"always\">\n            <md-tab >\n                <md-tab-label>\n                    <span ng-if=\"vm.team.needsSetup\">Setup Team</span>\n                    <span ng-if=\"!vm.team.needsSetup\">Modify Team</span>\n                </md-tab-label>\n                <md-tab-body >\n\n                    <form name=\"teamsetup\" novalidate style=\"padding: 1em;\">\n\n\n                        <md-input-container style=\"margin-bottom: .5em;\">\n                            <label ng-if=\"vm.team.needsSetup\">Give your team a name</label>\n                            <label ng-if=\"!vm.team.needsSetup\">Change Team Name</label>\n                            <input id=\"focusfield\" ng-model=\"vm.teamName\" required minlength=\"5\" maxlength=\"100\" >\n                        </md-input-container>\n                            <div flex layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.cancelDialog()\">cancel</md-button>\n                                <md-button ng-if=\"!vm.team.needsSetup\" class=\"md-raised md-accent\"  ng-click=\"vm.updateTeam(vm.team.ownerID, vm.teamName)\" ng-disabled=\"!vm.teamName\">Update Team Name</md-button>\n                                <md-button ng-if=\"vm.team.needsSetup\" class=\"md-raised md-accent\"  ng-click=\"vm.setupTeam(vm.teamName)\" ng-disabled=\"teamsetup.$invalid || vm.setup\"><span ng-if=\"!vm.setup\">Setup Team</span><span ng-if=\"vm.setup\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 17px; width: 17px; font-size: 24px; color: #fff; margin: 0 auto 0 auto;\"></md-icon></span></md-button>\n                            </div>\n\n                        </div>\n\n                    </form>\n\n                </md-tab-body>\n            </md-tab>\n        </md-tabs>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/teamDataService/dialog-invite-team-member.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"60\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\" class=\"md-inline-form\" >\n    <md-dialog-content >\n        <md-tabs class=\"md-primary no-active\" md-stretch-tabs=\"always\">\n            <md-tab >\n                <md-tab-label>\n                    <span>Inviting member #{{vm.numMembers}} of {{vm.teamLimit}}</span>\n                </md-tab-label>\n                <md-tab-body >\n\n                    <form name=\"inviteTeamMemberForm\" novalidate style=\"padding: 1em;\">\n                        <p class=\"md-subhead\">Enter an email address and we\'ll send that person a link to join your team.</p>\n\n                        <md-input-container style=\"margin-bottom: .5em;\">\n                            <label>Enter an Email Address</label>\n                            <input id=\"focusfield\" ng-model=\"vm.inviteEmail\" required type=\"email\"  minlength=\"10\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"vm.inviteEmail=vm.inviteEmail.toLowerCase();\">\n                        </md-input-container>\n                            <div flex layout=\"row\" layout-align=\"end center\">\n                                <md-button ng-click=\"vm.cancelDialog()\">cancel</md-button>\n                                <md-button data-gtm-invite-team-member class=\"md-raised md-accent\" ng-disabled=\"!vm.inviteEmail\" ng-click=\"vm.saveInvite(vm.inviteEmail)\">Send Invitation</md-button>\n                            </div>\n\n                        </div>\n\n                    </form>\n\n                </md-tab-body>\n            </md-tab>\n        </md-tabs>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/timeDataService/dialog-edit-time-entry.tmpl.html","<md-dialog flex=\"100\" flex-sm=\"100\" flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" md-theme=\"grey-menu\"  class=\"edit-time md-inline-form\">\n    <md-toolbar style=\"background-color: #fff;\">\n         <div class=\"md-toolbar-tools\" layout=\"column\" layout-align=\"center center\">\n           <h2 class=\"center\" style=\"color: #000;\"><md-icon style=\"color: #000;\" md-font-icon=\"zmdi zmdi-time\"></md-icon> <span ng-if=\"!vm.timeEntry.uid\" data-gtm-new-time-log >New Time Log</span><span ng-if=\"vm.timeEntry.uid\" data-gtm-edit-time-log>Edit Time Log</span> </h2>\n         </div>\n       </md-toolbar>\n    <md-dialog-content ng-if=\"vm.canLogTime\" class=\"md-padding\">\n        <form name=\"forms.timeDialogForm\" novalidate=\"\" autocomplete=\"off\">\n        <div flex md-padding layout=\"column\">\n            <p class=\"md-subhead center margin-top-0 margin-bottom-40 entry-invoiced-alert\" ng-if=\"vm.timeEntry.invoiceNumber\" style=\"font-size: .85em;\">Invoiced on #{{vm.timeEntry.invoiceNumber}}</p>\n            <div layout=\"row\" layout-align=\"space-between center\" md-padding>\n                <md-input-container class=\"workspace-select\" flex=\"auto\"  ng-class=\"{\'highlight-block\': !vm.timeEntry.client}\">\n                    <label>Workspace</label>\n                    <md-select ng-disabled=\"vm.timeEntry.invoiced || (vm.timeEntry.uid && vm.previousEntry.task) || vm.user.type == \'client\'\" placeholder=\"Select a Workspace\" ng-change=\"vm.changeClient(vm.timeEntry.client)\" ng-model=\"vm.timeEntry.client\" required>\n                        <md-option  ng-repeat=\"client in vm.assignedClients | orderBy: \'order\' track by client.uid + $index\" value=\"{{client.uid}}\" style=\"border-left: 4px solid {{client.profile.clientColor}};\">\n                            <img ng-if=\"client.status != \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-person-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                            <img ng-if=\"client.status == \'personal\'\" src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"20\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; background-color: {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\">\n                        <!-- <img src=\"{{client.profile.avatar || \'/assets/images/avatars/generic-default-avatar.png\'}}\" width=\"30\" style=\"border-radius: 50%; border: 2px solid {{client.profile.clientColor}}; margin-right: 1em; position: relative; top: 5px;\"> -->\n                        <span class=\"small\">{{client.profile.fullName}}</span></md-option>\n                    </md-select>\n                </md-input-container>\n                <md-input-container  ng-if=\"vm.billingType == \'packages\' && vm.client.status != \'personal\' && !vm.packageNotAvailable\" ng-class=\"{\'highlight-block\': !vm.timeEntry.packageID}\" class=\"category-select margin-left-20\" flex=\"50\">\n                    <label>Client Billing Package</label>\n                    <md-select ng-if=\"vm.showPackageSelector\" ng-disabled=\"!vm.client.packages || vm.timeEntry.invoiced\" placeholder=\"Select a Billing Package\" ng-model=\"vm.timeEntry.packageID\" ng-change=\"setPackage(vm.timeEntry.packageID)\" required>\n                        <!-- <md-option value=\"none\" >None</md-option> -->\n                        <md-option\n                            ng-repeat=\"package in vm.client.packages | toArray: false | orderBy: \'-timeStamp\' track by $index+uid\"\n                            value=\"{{package.uid}}\"\n                            ng-if=\"vm.showPackageSelector && package.status != \'archived\'\"\n                            class=\"time-package-option\"\n                            layout=\"column\"\n                            layout-align=\"center layout-fill\"\n                            >\n                            <div layout=\"row\" layout-align=\"layout-fill center\">\n                                <div flex=\"10\" layout=\"column\" layout-align=\"center center\">\n                                    <md-icon style=\"font-size: 13px; color: #888;\" md-font-icon ng-class=\"\n                                               {\'zmdi zmdi-time-restore\': package.type ==\'hourly\',\n                                                \'zmdi zmdi-time-interval\': package.type == \'retainer\',\n                                                \'zmdi zmdi-hourglass-alt\': package.type == \'balance\',\n                                                \'zmdi zmdi-dot-circle\': package.type ==\'fixed\',\n                                                \'zmdi zmdi-gas-station\': package.type == \'refillable\'\n                                                }\"\n                                    ></md-icon>\n                                </div>\n                                <div flex=\"grow\">\n                                    <p style=\"width: 100%; font-size: 12px;\" md-truncate>{{package.label}}</p>\n                                </div>\n                                <div flex=\"nogrow\" class=\"package-date\"\">\n                                    <p style=\"font-size: 12px;\">{{package.startDate | amDateFormat: vm.settings.shortDateFormat}}</p>\n                                </div>\n                                <div flex=\"15\" class=\"package-status\" style=\"padding-left: 10px;\">\n                                    <p ng-if=\"package.status == \'open\'\"><span style=\"color: green;\" ng-if=\"!package.expired\">{{package.status}}</span> <span ng-if=\"package.expired\" style=\"color: red;\">Expired!</span></span></p>\n                                    <p ng-if=\"package.status == \'closed\'\"><span style=\"color: red;\" ng-if=\"!package.expired\">{{package.status}}</span> <span ng-if=\"package.expired\" style=\"color: red;\">Expired!</span></span></p>\n                                    <p ng-if=\"package.status == \'pending\'\"><span style=\"color: orange;\" ng-if=\"!package.expired\">{{package.status}}</span> <span ng-if=\"package.expired\" style=\"color: red;\">Expired!</span></span></p>\n                                </div>\n                            </div>\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n                <div class=\"category-select margin-left-20\" flex=\"50\" ng-if=\"vm.packageNotAvailable && vm.billingType == \'packages\'\">\n\n                            <div layout=\"row\" layout-align=\"layout-fill center\">\n                                <div flex=\"10\" layout=\"column\" layout-align=\"center center\">\n                                    <md-icon style=\"font-size: 13px; color: #888;\" md-font-icon ng-class=\"\n                                               {\'zmdi zmdi-time-restore\': vm.timeEntry.packageType ==\'hourly\',\n                                                \'zmdi zmdi-time-interval\': vm.timeEntry.packageType == \'retainer\',\n                                                \'zmdi zmdi-hourglass-alt\': vm.timeEntry.packageType == \'balance\',\n                                                \'zmdi zmdi-dot-circle\': vm.timeEntry.packageType ==\'fixed\',\n                                                \'zmdi zmdi-gas-station\': vm.timeEntry.packageType == \'refillable\'\n                                                }\"\n                                    ></md-icon>\n                                </div>\n                                <div flex=\"45\">\n                                    <p style=\"width: 100%;\" md-truncate>{{vm.timeEntry.packageLabel}}</p>\n                                </div>\n                                <div flex=\"10\">&nbsp;\n                                </div>\n                                <div flex=\"auto\" class=\"package-status\">\n                                    <p><span style=\"color: red;\">archived</span></p>\n                                </div>\n                            </div>\n\n\n                </div>\n                <md-input-container ng-if=\"vm.client.profile.categories.time && (vm.billingType != \'packages\' || vm.client.status == \'personal\')\" class=\"category-select margin-left-20\" flex=\"50\" >\n                    <label>Category</label>\n                    <md-select ng-disabled=\"!vm.client.profile.categories.time || vm.timeEntry.invoiced || vm.user.type == \'client\'\" md-no-asterisk placeholder=\"Select a Time Category\" ng-change=\"setRate(vm.timeEntry.rateID)\" ng-model=\"vm.timeEntry.rateID\">\n                        <md-option value=\"default\" >Default</md-option>\n                        <md-option\n                            ng-repeat=\"category in vm.client.profile.categories.time | toArray: false | orderBy: \'order\' track by $index+uid\"\n                            value=\"{{category.uid}}\"\n                            ng-if=\"!category.adminOnly || vm.isClientAdmin\"\n                            >\n                        <span class=\"small\">{{category.label}}</span></md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <div flex layout=\"row\" class=\"margin-top-20\" ng-if=\"vm.selectedPackage\" layout-align=\"layout-fill center\">\n                <md-input-container ng-class=\"{\'highlight-block\': !vm.timeEntry.rateID}\" ng-if=\"vm.timeCategories\" class=\"category-select\" flex=\"100\" >\n                    <label>Package Category</label>\n                    <md-select ng-if=\"vm.timeCategories\" ng-disabled=\"vm.packageNotAvailable || vm.timeEntry.invoiced || vm.user.type == \'client\'\" md-no-asterisk placeholder=\"Select a Time Category\" ng-change=\"setPackageRate(vm.timeEntry.rateID)\" ng-model=\"vm.timeEntry.rateID\">\n                        <!-- <md-option value=\"default\" ng-value=\"{{vm.defaultRateOption | json}}\">Default</md-option> -->\n                        <md-option\n                            ng-repeat=\"category in vm.timeCategories | toArray: false | orderBy: \'order\' track by $index+uid\"\n                            value=\"{{category.uid}}\"\n                            ng-selected=\"category.uid == vm.timeEntry.rateID\"\n                            ng-if=\"!category.adminOnly || vm.isClientAdmin\"\n                            >\n                        <span class=\"small\">{{category.label}} <span ng-if=\"vm.selectedPackage.type == \'hourly\'\">@ {{category.rate}}/hr</span></span></md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n            <div flex ng-if=\"vm.billingNeedsSetup\" layout=\"column\" layout-align=\"center center\">\n                <div style=\"border-radius: 8px; background-color:#efefef; padding: 1em; margin: 1em;\">\n                    <p class=\"md-title center\"><md-icon style=\"font-size: 24px; height: 24px; width: 24px;\" md-font-icon=\"zmdi zmdi-alert-triangle\"></md-icon> No Active Billing Packages!</p>\n                    <p classs=\"md-subhead center\">This client needs a billing package in order to log time.</p>\n                    <p class=\"center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.visitBilling(vm.client.uid)\">Manage Packages</md-button>\n\n                </div>\n            </div>\n\n            <div ng-if=\"!vm.billingNeedsSetup\">\n                <div flex  layout=\"column\" layout-align=\"center layout-fill\" class=\"h-and-m-field\">\n                    <div flex=\"nogrow\" layout=\"row\" layout-align=\"center center\">\n                        <div flex=\"nogrow\" class=\"time-value-changer\">\n                            <md-button md-no-ink ng-disabled=\"!vm.timeEntry.client || vm.timeEntry.invoiced || vm.user.type == \'client\'\" class=\"md-icon-button\" style=\"margin-bottom: 15px;\" ng-click=\"vm.decreaseTime(vm.roundUpTo)\"><md-icon md-font-icon=\"zmdi zmdi-minus-circle-outline\"></md-icon></md-button>\n                        </div>\n                        <md-input-container class=\"md-no-underline time-input\">\n                            <label>Hours</label>\n                            <input class=\"time-input\" ng-disabled=\"!vm.timeEntry.client || vm.timeEntry.invoiced || vm.user.type == \'client\'\" only-digits select-on-click ng-maxlength=\"vm.maxLength\" ng-change=\"vm.formatHours(vm.timeEntry.hours)\" style=\"text-align: right;\" name=\"hours\" type=\"text\" ng-model=\"vm.timeEntry.hours\" ng-model-options=\"vm.inputOptions\">\n                        </md-input-container>\n                        <span style=\"font-size: 72px; position: relative; top: -15px;\">:</span>\n                        <md-input-container class=\"md-no-underline time-input\">\n                            <label>Minutes</label>\n                            <input class=\"time-input\" ng-disabled=\"!vm.timeEntry.client || vm.timeEntry.invoiced || vm.user.type == \'client\'\" only-digits select-on-click ng-maxlength=\"vm.maxLength\" ng-change=\"vm.formatMinutes(vm.timeEntry.minutes)\" name=\"minutes\" type=\"text\"  ng-model=\"vm.timeEntry.minutes\" ng-model-options=\"vm.inputOptions\">\n                        </md-input-container>\n                        <div flex=\"nogrow\" class=\"time-value-changer\">\n                            <md-button md-no-ink ng-disabled=\"!vm.timeEntry.client || vm.timeEntry.invoiced || vm.user.type == \'client\'\" class=\"md-icon-button\" style=\"margin-bottom: 15px;\" ng-click=\"vm.increaseTime(vm.roundUpTo)\"><md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon></md-button>\n                        </div>\n                    </div>\n                    <div layout=\"row\" ng-if=\"vm.billingType == \'packages\' && vm.client.status != \'personal\'\" layout-align=\"center start\">\n                        <md-checkbox ng-disabled=\"!vm.timeEntry.packageID\" style=\"margin-top: 0; height: 11px; width: 11px;\" ng-model=\"vm.timeEntry.exempt\" aria-label=\"Exempt\"></md-checkbox> <span style=\"font-size: 11px; padding: 0 0 0 11px; margin-top: 2px;\">Do not count against package budget.</span>\n                    </div>\n                </div>\n                <div layout=\"row\" layout-align=\"center center\" class=\"margin-top-10\">\n                        <md-input-container flex=\"nogrow\" style=\"\">\n                            <md-datepicker ng-disabled=\"vm.timeEntry.invoiced || vm.user.type == \'client\'\" ng-model=\"vm.timeEntry.logDate\" md-max-date=\"vm.maxDate\"  required=\"required\"></md-datepicker>\n                            <div ng-messages=\"vm.timeEntry.logDate.$error\">\n                                <div ng-message=\"required\">Please make sure you\'ve entered a valid date. (mm/dd/yyyy)</div>\n                            </div>\n                        </md-input-container>\n                        <md-button flex=\"nogrow\" class=\"md-button date-timestamp\" ng-click=\"displayStartTimeDialog(vm.timeEntry.logDate)\" ng-disabled=\"vm.timeEntry.invoiced || vm.user.type == \'client\'\" style=\"color: #000; margin-left: 10px; margin-top: -13px;\">\n                            <md-icon style=\"font-size: 16px;\" md-font-icon=\"fa fa-clock-o\"></md-icon>\n                            {{vm.timeEntry.logDate | amDateFormat: \"h:mmA\"}}\n                            <md-tooltip md-delay=\"500\">Set specific time</md-tooltip>\n                        </md-button>\n                </div>\n\n\n                <div layout=\"row\" layout-align=\"start center\" ng-if=\"(!vm.timeEntry.description || vm.timeEntry.description == \'No description\' || vm.timeEntry.description == \'Time entry\') && !vm.timeEntry.task\">\n                    <md-button ng-if=\"!vm.showMeta\" ng-click=\"vm.showMeta = true\"><md-icon md-font-icon=\"fa fa-caret-right\"></md-icon> Description &amp; Related Task</md-button>\n                    <md-button ng-if=\"vm.showMeta\" ng-click=\"vm.showMeta = false\"><md-icon md-font-icon=\"fa fa-caret-down\"></md-icon> Description &amp; Related Task</md-button>\n                </div>\n                <div class=\"time-description\" ng-if=\"vm.showMeta || vm.timeEntry.task || (vm.timeEntry.description && vm.timeEntry.description != \'No description\' && vm.timeEntry.description != \'Time entry\')\">\n                    <md-input-container flex class=\"time-description-container\" ng-if=\"!vm.requireWorkDescription\" >\n                        <textarea ng-disabled=\"vm.timeEntry.invoiced || vm.user.type == \'client\'\" class=\"time-description\" name=\"description\" ng-model=\"vm.timeEntry.description\" placeholder=\"What were you working on?\" ng-model-options=\"vm.inputOptions\"></textarea>\n                    </md-input-container>\n\n                    <md-input-container flex class=\"time-description-container\" ng-if=\"vm.requireWorkDescription\" required>\n                        <textarea ng-disabled=\"vm.timeEntry.invoiced || vm.user.type == \'client\'\" class=\"time-description\" name=\"description\" md-no-asterisk ng-model=\"vm.timeEntry.description\" placeholder=\"What were you working on?\" ng-required=\"true\"  ng-model-options=\"vm.inputOptions\"></textarea>\n                        <div ng-messages=\"vm.timeEntry.description.$error\">\n                            <div ng-message=\"required\">Your time log needs a description</div>\n                        </div>\n                    </md-input-container>\n                    <div layout=\"row\" layout-align=\"layout-fill center\" style=\"margin-bottom: 2em;\">\n                        <!-- <div flex=\"nogrow\" layout=\"column\" layout-align=\"center center\" style=\"padding-right: 1em;\">\n                            <md-icon md-font-icon=\"fa fa-check\"></md-icon>\n                        </div> -->\n                        <md-input-container flex=\"grow\">\n                            <label>Related Task:</label>\n                            <!-- note how we are dealing with the compressed tags\n                                from our initially resolved clientData,\n                                thus we use the refID, not uid -->\n                            <md-select ng-disabled=\"!vm.taskCandidates || vm.timeEntry.invoiced || vm.user.type == \'client\' || (vm.timeEntry.uid && vm.previousEntry.task)\" md-no-asterisk placeholder=\"Related Task\"  ng-change=\"vm.setTask(vm.timeEntry)\" ng-model=\"vm.timeEntry.task\" class=\"client-start-date\">\n                                <md-option md-option-empty></md-option>\n                                <md-option\n                                    ng-repeat=\"task in vm.taskCandidates | toArray: false | filter: {\'status\' : \'open\'} track by $index+task.refID\"\n                                    value=\"{{task.refID}}\"\n                                    ng-selected=\"vm.timeEntry.task == task.refID\"\n                                    ng-if=\"!task.private || vm.client.access.admins[vm.user.uid] && task.description\"\n                                    >\n                                    <span class=\"small\">{{task.description | limitTo : 50 : begin}}</span><br><span class=\"small\" style=\"font-size: .65em; color: #aaa\">{{task.assigneeName}}</span>\n                                </md-option>\n                            </md-select>\n                        </md-input-container>\n                    </div>\n                </div>\n                <div class=\"time-error confirm-delete\" ng-if=\"vm.errorMessage\" >\n                    <p class=\"md-subhead center\"><strong>There was a problem committing your time. Please try again.</strong></p>\n                    <p class=\"md-subhead center\">If this message continues and this entry was based off of a timer, please start a new entry and enter the time manually.</p>\n                    <!-- comment -->\n                </div>\n            </div>\n        </div>\n        </form>\n    </md-dialog-content>\n    <md-dialog-actions ng-if=\"vm.canLogTime && !vm.confirmDelete\" layout=\"column\" class=\"md-padding\">\n    <div style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" >\n        <div ng-if=\"canLock(vm.timeEntry) && vm.user.type != \'client\' && !vm.timeEntry.invoiced\" flex=\"nogrow\" class=\"button-label-container\">\n            <md-button class=\"md-icon-button\" ng-click=\"vm.timeEntry.locked = false\" ng-if=\"vm.timeEntry.locked\">\n                <md-icon  md-font-icon=\"fa fa-lock\" >\n                </md-icon>\n                <md-tooltip md-delay=\"500\">\n                     Allow non-Admins to edit.\n                 </md-tooltip>\n            </md-button>\n            <md-button class=\"md-icon-button\" ng-click=\"vm.timeEntry.locked = true\" ng-if=\"!vm.timeEntry.locked\">\n                <md-icon md-font-icon=\"fa fa-unlock\" >\n                </md-icon>\n                <md-tooltip md-delay=\"500\">\n                     Lock non-admins from changing\n                 </md-tooltip>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.userType == \'admin\'\" >\n            <md-button  aria-label=\"X-ray\" target=\"_blank\" href=\"{{vm.fbConfig.dataURL}}time/{{vm.timeEntry.uid}}\">\n                <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon> X-ray\n            </md-button>\n        </div>\n        <div ng-if=\"vm.user.type != \'client\'\" flex=\"nogrow\" class=\"button-label-container\">\n            <md-button  aria-label=\"Delete Time Log\" ng-if=\"vm.timeEntry.uid\" ng-click=\"startDelete(vm.timeEntry);\" ng-disabled=\"vm.timeEntry.invoiced\">\n                Delete\n            </md-button>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\">\n            <md-button class=\"\" ng-click=\"cancelDialog(vm.timeEntry)\">Cancel</md-button>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"vm.timeEntry.uid && vm.user.type != \'client\'\">\n            <md-button data-gtm-update-time-log ng-disabled=\"vm.packageNotAvailable || forms.timeDialogForm.$invalid || forms.timeDialogForm.$pristine || vm.timeEntry.invoiced || (vm.billingType == \'packages\' && !vm.timeEntry.packageID)\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"updateEntry(vm.timeEntry, vm.previousEntry)\">\n                Update\n            </md-button>\n            <label class=\"shortcut\">ctrl + enter</label>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.timeEntry.uid && vm.user.type != \'client\'\">\n            <md-button data-gtm-log-time ng-disabled=\"forms.timeDialogForm.$invalid || !vm.timeEntry.client || (vm.timeEntry.logged == 0) || vm.timeEntry.invoiced || (vm.billingType == \'packages\' && !vm.timeEntry.packageID)\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveEntry(vm.timeEntry, true)\">\n                Save &amp; Start new\n            </md-button>\n        </div>\n        <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.timeEntry.uid && vm.user.type != \'client\'\">\n            <md-button data-gtm-log-time ng-disabled=\"forms.timeDialogForm.$invalid || !vm.timeEntry.client || (vm.timeEntry.logged == 0) || vm.timeEntry.invoiced || (vm.billingType == \'packages\' && !vm.timeEntry.packageID && vm.client.status != \'personal\')\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"saveEntry(vm.timeEntry)\">\n                Save\n            </md-button>\n            <label class=\"shortcut\">ctrl + enter</label>\n        </div>\n    </div>\n    <div ng-if=\"vm.timeEntry.uid\" layout=\"row\" layout-align=\"center center\">\n            <p  style=\"font-size: 9px; margin:1em 0 0 0; padding:0; color: #888;\">\n                Created at: {{vm.timeEntry.timestamp |amDateFormat: \'lll\'}}\n            </p>\n        </div>\n    </md-dialog-actions>\n\n    <md-dialog-actions ng-if=\"vm.confirmDelete\" style=\"border-top: none;\" layout=\"row\" layout-align=\"end center\" class=\"md-padding confirm-delete\">\n        <p flex=\"nogrow\" class=\'center\"\' style=\"margin:0;\">\n            Permanently delete?\n        </p>\n\n        <md-button class=\"\" ng-click=\"cancelDelete()\">\n            cancel\n        </md-button>\n\n        <md-button data-gtm-delete-time-log class=\"md-warn md-raised\" ng-click=\"deleteTime(vm.timeEntry)\">\n            <span >\n                    Confirm\n                </span>\n        </md-button>\n    </md-dialog-actions>\n    <md-content ng-if=\"!vm.canLogTime\">\n        <h3 class=\"text-center\">Your subscription plan does not include Time logging.</h3>\n    </md-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/timeDataService/dialog-payroll-report.tmpl.html","<md-dialog style=\"width: 850px;\" aria-label=\"Time Report\" class=\"time-report-modal\">\n    <md-dialog-content>\n        <div layout-fill ng-if=\"!vm.showReport\" layout=\"row\" layout-align=\"center center\" style=\"width: 100%; background-color:#fff; min-height: 300px;\">\n            <md-icon flex=\"nogrow\" md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 18px; width: 18px; min-height: 18px; height: 18px; font-size: 18px; line-height: 18px; padding: 0; color: #000; margin: 0 1em 0 1em;\"></md-icon>\n            <h3 flex=\"nogrow\" class=\"center md-title\">Preparing Report</h3>\n        </div>\n        <div class=\"print-time-report\" style=\"width: 100%;\" ng-if=\"vm.showReport\" print-section>\n            <!-- https://github.com/samwiseduzer/angularPrint -->\n\n            <div style=\"padding: 1em 2em 1em 1em; margin-bottom: 5em; width: 96%; overflow-y: scroll; overflow-x: hidden;\" >\n                <div class=\"invoice-header\" layout=\"column\" layout-align=\"start start\">\n\n                    <h3 class=\"center\">Payroll Report<h3>\n                        <p class=\"md-subhead recipient-address\" style=\"font-size: .85em;\">\n                            <strong>Report Period:</strong> {{vm.locals.report.start | amDateFormat: \"dddd, MMM Do\"}} - {{vm.locals.report.end | amDateFormat: \"dddd, MMM Do\"}}<br>\n                            <span >\n                                <strong>Total Logged:</strong> {{::vm.used(vm.locals.report.data) | userTimeFormat}}<br>\n                                <strong>Total Earned:</strong> {{::vm.currency}}{{vm.results.totalPayroll | number: 2}}<sup>*</sup><br>\n                                <span style=\"font-size: 10px;\">* Total may include multiple currencies!</span>\n                            </span>\n                        </p>\n                        <p class=\"md-subhead\" ></p>\n\n            </div><!-- // header -->\n\n\n\n            <!-- column headings -->\n            <div layout=\'row\' layout-align=\"start start\" style=\"background-color: #eee; margin-bottom: 1em;\">\n                <div flex=\"30\">\n                    Name\n                </div>\n                <div flex=\"15\">\n                    Currency\n                </div>\n                <div flex=\"15\">\n                    Rate\n                </div>\n                <div flex=\"10\" >\n                    Logged\n                </div>\n                <div flex=\"30\"  style=\"text-align: right; padding-right: 1em;\">\n                    Total\n                </div>\n            </div>\n\n            <!-- default report - time in date order -->\n            <div class=\"payroll-report-grid\">\n                <div layout=\'row\' layout-align=\"start start\" class=\"entry-line-item\"\n                ng-repeat=\"member in vm.results.members| toArray: false | orderBy: [\'email\'] track by $index\">\n                    <div flex=\"30\">\n                        {{::member.name}}\n                    </div>\n                    <div flex=\"15\">\n                        {{::member.currencyLabel}}\n                    </div>\n                    <div flex=\"15\" >\n                        <span ng-bind-html=\"::member.currency\"></span>{{::member.payrollRate}}\n                    </div>\n                    <div flex=\"10\" style=\"\">\n                        {{::member.logged | HandM}}\n                    </div>\n                    <div flex=\"30\" style=\"text-align: right; padding-right: 1em;\">\n                        <span ng-bind-html=\"::member.currency\"></span>{{::member.total |  number: 2}}\n                    </div>\n                </div>\n\n\n            </div>\n            <!-- // default report -->\n        </div>\n\n        <div class=\"invoice-controls\" layout=\"row\" style=\"width: 100%; background-color: rgba(240,240,240,1);\" layout-align=\"center center\">\n            <md-button flex=\"nogrow\" class=\"\" ng-click=\"vm.cancelDialog()\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>Close</md-button>\n            <!-- <md-divider class=\"vertical-divider\"></md-divider> -->\n            <md-button data-gtm-print-payroll-report print-btn flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon> Print</md-button>\n            <md-button data-gtm-export-payroll-csv ng-click=\"vm.downloadCSV(vm.results)\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-download\"></md-icon> CSV</md-button>\n            <md-button data-gtm-export-payroll-txt ng-click=\"vm.downloadTXT(vm.results)\" flex=\"nogrow\"><md-icon md-font-icon=\"zmdi zmdi-download\"></md-icon> TXT</md-button>\n        </div>\n\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/timeDataService/emailReportDialog.html","<md-dialog flex=\"100\" flex-gt-sm=\"40\">\n	<md-dialog-content class=\"md-padding\">\n		<h3 class=\"md-title\">Email Report</h3>\n		<ng-form name=\"vm.emailForm\">\n		<md-input-container>\n			<label>Recipient\'s address</label>\n			<input  name=\"email\" multiple-emails ng-model=\"vm.recipientEmail\"  ng-required=\"true\" >\n			<span style=\"font-size: .65em;\">Separate multiple emails with a comma.</span>\n		</md-input-container>\n\n<!-- 		<textarea name=\"myEmails\" ng-model=\"vm.recipientEmail\" multiple-emails></textarea>\n		   <pre>vm.emailForm.myEmails.$error: {{vm.emailForm.myEmails.$error}}</pre>\n		   <pre>vm.recipientEmail:<br />{{vm.recipientEmail}}</pre> -->\n\n		<p style=\"text-align:right;\"><md-button ng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-click=\"vm.sendPDF(vm.recipientEmail)\" class=\"md-accent md-raised\" ng-disabled=\"!vm.emailForm.$valid || vm.emailForm.$pristine\">Send Report</md-button></p>\n	</ng-form>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/timeDataService/timeReportModal.tmpl.html","<md-dialog style=\"width: 850px;\" aria-label=\"Time Report\" class=\"time-report-modal\">\n	<md-dialog-content>\n		<print-time-report report=\"vm.report\"></print-time-report>\n	</md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/app-services/userDataService/dialog-user-profile.tmpl.html"," <md-dialog flex-xs=\"100\" flex-sm=\"90\" flex-md=\"60\" flex-lg=\"50\" flex-gt-lg=\"40\" class=\"item-dialog edit-user md-inline-form\" >\n     <form name=\"userDialogForm\" novalidate>\n     <md-toolbar class=\"md-warn\">\n           <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"center center\">\n             <h2 ng-if=\"!vm.loading\" flex class=\"center\" ng-show=\"vm.user.profile.firstName\">Please confirm your Country &amp; Time Zone are correct.</h2>\n             <h2 ng-if=\"vm.loading\" class=\"center\" style=\"text-align: center;\">Update User: Fetching Geo Data</h2>\n           </div>\n         </md-toolbar>\n     <md-dialog-content style=\"min-height: 400px;\">\n        <div layout=\"column\" layout-align=\"center center\" style=\"height: 100%; padding-top:3em;\" ng-if=\"vm.loading\">\n            <p class=\"md-subhead center\">Please wait while we detect your location and compare settings.</p>\n            <p class=\"center\"><md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 100px; width: 100px; font-size: 100px; line-height: 100px; color: #bbb; margin: 0; padding:0;\"></md-icon></p>\n\n        </div>\n         <div layout=\"row\" layout-align=\"center start\" ng-if=\"!vm.loading\">\n             <div flex=\"70\" class=\"padding-top-40\">\n                <div style=\"padding: 1em; border-radius: 4px; background-color: #efefef; margin: 1em 1em 2em 1em;\" layout=\"column\" layout-align=\"start center\">\n                    <h3 style=\"font-weight: normal;\"><strong>Your Country:</strong> {{vm.user.profile.address.country || \"Not Detected\"}}</h3>\n                    <h3 style=\"font-weight: normal;\"><strong>Your Timezone:</strong> {{vm.user.profile.timeZone || \"Not Detected\"}}</h3>\n                </div>\n                <div layout=\"row\" layoyut-align=\"center center\">\n                     <md-input-container class=\"padding-right-20\" flex=\"50\" style=\"margin-top: 2em;\">\n                         <label translate>Change your country:</label>\n                         <md-select name=\"country\" ng-model=\"vm.user.profile.address.country\" required>\n                             <md-option ng-value=\"country.name\" ng-repeat=\"country in vm.countries track by $index+code\">{{country.name}}</md-option>\n                         </md-select>\n                     </md-input-container>\n                     <md-input-container flex=\"50\" class=\"padding-right-20\" style=\"margin-top: 2em;\">\n                       <label >Change your Timezone </label>\n                        <md-select ng-model=\"vm.user.profile.timeZone\" required>\n                            <md-option ng-if=\"!zone.name.includes(\'Etc\')\" ng-repeat=\"zone in vm.timeZones track by $index + id\" ng-value=\"zone.value\">{{zone.name}}</md-option>\n                        </md-select>\n                     </md-input-container>\n                </div>\n            </div>\n        </div>\n     </md-dialog-content>\n     <md-dialog-actions style=\"border-top: none;\" class=\"md-padding\" layout=\"row\" layout-align=\"center center\">\n                 <md-button flex type=\"button\" ng-disabled=\"vm.loading || userDialogForm.$invalid || !vm.user.profile.address.country || !vm.user.profile.timeZone\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.updateUser(vm.user)\">Confirm &amp; Save</md-button>\n             <!-- <div flex=\"nogrow\" class=\"button-label-container\" ng-if=\"!vm.user.uid\">\n                 <md-button type=\"button\" ng-disabled=\"userDialogForm.$invalid || userDialogForm.$pristine\" type=\"submit\" class=\"md-adminja-shade-theme md-accent md-raised\" ng-click=\"vm.saveNewUser(vm.user)\">Complete Your Registration</md-button>\n             </div> -->\n     </md-dialog-actions>\n\n     </form>\n </md-dialog>\n");
$templateCache.put("app/app-services/userDataService/needs-checkout-dialog.tmpl.html","<md-dialog md-dynamic-height flex=\"100\" flex-sm=\"70\" flex-md=\"60\" flex-lg=\"50\" flex-xl=\"40\" md-theme=\"grey-menu\" class=\"md-inline-form\" style=\"border-top: 6px solid #0091ea; border-bottom: 6px solid #0091ea; background-color: rgb(240,240,240);\">\n    <h1 class=\"md-title center\" style=\"margin-bottom: 0;\">{{vm.title}}</h1>\n    <p class=\"center md-subhead\" ng-bind-html=\"vm.message\"></p>\n    <md-dialog-content style=\"background-color: rgb(240,240,240);\">\n      <p class=\"center\"><md-button ng-click=\"vm.completeCheckout()\">Complete Registration</md-button></p>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/layouts/leftsidenav/leftsidenav.tmpl.html","<md-toolbar class=\"sidebar-left-toolbar\" md-theme=\"{{::triSkin.elements.logo}}\">\n    <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\">\n\n        <div class=\"sidebar-left-logo\">\n            <img ng-src=\"{{::vm.sidebarInfo.appLogo}}\" alt=\"{{::vm.sidebarInfo.appName}}\">\n        </div>\n\n        <h2 flex class=\"sidebar-left-title\">{{::vm.sidebarInfo.appName}}</h2>\n\n        <md-button class=\"md-icon-button sidebar-left-icon\" ng-click=\"vm.toggleIconMenu()\" aria-label=\"Open side menu\">\n            <md-icon md-font-icon ng-class=\"{ \'zmdi zmdi-chevron-right\' : vm.layout.sideMenuSize == \'icon\', \'zmdi zmdi-chevron-left\' : vm.layout.sideMenuSize == \'full\' }\"></md-icon>\n        </md-button>\n\n    </div>\n</md-toolbar>\n\n<tri-menu md-theme=\"{{triSkin.elements.sidebar}}\" flex layout=\"column\"></tri-menu>\n");
$templateCache.put("app/layouts/leftsidenav/onboardingBottomSheet.tmpl.html","\n\n<md-bottom-sheet class=\"onboarding-bottomsheet\" layout=\"column\">\n	<div layout=\"column\" layout-align=\"center center\" ng-cloak style=\"padding: 24px 0 24px 0;\">\n\n	  	<h3 class=\"md-title center\" flex>Adminja Setup &amp; Onboarding</h4>\n	  		<!-- <p class=\"md-subhead center\" style=\"margin:0; font-size: 11px;\">\n	  			Click on any topic for a quick tutorial.\n	  		</p> -->\n	  	<md-button style=\"position: absolute; right:10px; top: 25px;\" ng-click=\"completeOnboarding()\"><md-icon md-font-icon=\"zmdi zmdi-check\" ></md-icon> Mark all Complete</md-button>\n\n	</div>\n	<div ng-cloak>\n	  <div layout=\"row\" layout-align=\"center center\" layout-align-gt-xs=\"start center\" layout-wrap>\n	  	<!-- each item -->\n	    <md-button ng-click=\"startFlow(item)\" md-no-ink flex=\"40\" flex-gt-xs=\"20\" ng-repeat=\"item in onboardingItems track by $index\" ng-disabled=\"!isDependencyResolved(item)\" layout=\"column\" layout-align=\"center center\" style=\"margin:0 0 1em 0; padding: 1em;\">\n		    	<div layout=\"column\">\n		   		<md-icon ng-if=\"item.icon && !item.complete\" style=\"font-size: 36px; margin-bottom: 10px;\" md-font-icon=\"{{item.icon}}\"></md-icon>\n		   		<p ng-if=\"item.complete\" class=\"margin-0\"><md-icon  style=\"font-size: 36px; color: green;\" md-font-icon=\"zmdi zmdi-check\" ></md-icon></p>\n		          <p class=\"margin-0\" style=\"font-size: 11px;\">{{item.name}}</p>\n		   </div>\n		   <md-tooltip md-delay=\"1000\" md-direction=\"top\">\n		   	Start tutorial\n		   </md-tooltip>\n	    </md-button>\n	  </div>\n	</div>\n</md-bottom-sheet>\n");
$templateCache.put("app/layouts/footer/footer.tmpl.html","<div flex=\"noshrink\" layout=\"column\" layout-align=\"end none\">\n    <md-toolbar ng-controller=\"AppFooterController as footer\" md-theme=\"{{triSkin.elements.toolbar}}\">\n        <div class=\"md-toolbar-tools md-body-1\" layout=\"row\" layout-align=\"space-between center\">\n            <h2>{{footer.settings.name}}</h2>\n            <h2 hide-xs ng-bind-html=\"footer.settings.copyright\"></h2>\n            <h2>v{{footer.settings.version}}</h2>\n        </div>\n    </md-toolbar>\n</div>\n");
$templateCache.put("app/layouts/loader/loader.tmpl.html","<div class=\"app-loader\" flex layout=\"column\" layout-fill layout-align=\"center center\">\n	<p style=\"margin:0;  text-align: center;  font-size: 36px; font-weight: 400;\">\n		<!-- <div class=\"spinner\">\n		  <div class=\"bounce1\"></div>\n		  <div class=\"bounce2\"></div>\n		  <div class=\"bounce3\"></div>\n		</div> -->\n		<div class=\"spinner\">\n		  <div class=\"bounce2\"></div>\n		  <div class=\"double-bounce-2\"></div>\n		  <div class=\"bounce2\"></div>\n		</div>\n		<!-- <img src=\"/assets/images/icons/ajax-loader.gif\"> -->\n		<!-- {{loaderMessage}} -->\n	</p>\n\n</div>\n");
$templateCache.put("app/layouts/rightsidenav/rightsidenav.tmpl.html","<md-content flex layout class=\"admin-notifications\">\n		<md-tabs class=\"md-secondary\" flex md-stretch-tabs=\"always\" md-selected=\"currentTab\">\n			<md-tab md-on-select=\"close()\">\n				<md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n			</md-tab>\n			<md-tab class=\"sidebar-timers-tab\" ng-if=\"user.type != \'client\'\">\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"zmdi zmdi-timer\"></md-icon>\n					</md-tab-label>\n					<md-tab-body layout=\"column\">\n						<md-content layout-fill layout=\"column\">\n							<div class=\"timer-container\" hide-gt-sm ng-show=\"canUseTimer\" layout=\"column\" layout-align=\"start center\">\n									<timer></timer>\n									<!-- <div layout=\"row\" flex=\"100\" style=\"padding:0; margin:0;\" layout-align=\"start center\"> <timer ></timer></div> -->\n							 </div>\n\n							<h3 flex=\"nogrow\" class=\"text-center\">Open Timers</h3>\n\n							<div class=\"small-scrollbar\" flex=\"grow\">\n								 <timer-list ng-if=\"canUseTimer\"></timer-list>\n							</div>\n						</md-content>\n\n					</md-tab-body>\n\n			</md-tab>\n			<!-- notifications tab -->\n			<md-tab >\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"fa fa-bell-o\"></md-icon>\n					</md-tab-label>\n					<md-tab-body>\n						<md-content layout-fill layout=\"column\">\n								<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\">\n									<span flex=\"nogrow\" style=\"margin-right: 2em; color: #bbb; font-size: 12px;\">\n										<md-button data-gtm-discard-all-notifications class=\"\" ng-click=\"discardAllNotifications()\" style=\"margin-right: -17px;\">\n											<md-icon  aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-close-circle\" class=\"\" style=\"font-size: 1.5rem; color: #bbb; cursor: pointer; min-width: 15px; margin-right: 1em;\"></md-icon>All\n										</md-button>\n									</span>\n								</div>\n								<div flex=\"grow\" class=\"notification-list small-scrollbar\">\n									<notification-card class=\"fade\" ng-if=\"item.uid && item.type == \'reminder\'\" ng-repeat=\"item in user.notifications | toArray |  orderBy:[\'-date\'] track by $index\" item=\"item\"></notification-card>\n									<notification-card class=\"fade\" ng-if=\"item.uid && item.type != \'reminder\'\" ng-repeat=\"item in user.notifications | toArray |  orderBy:[\'-date\'] | limitTo: 50 track by $index\" item=\"item\"></notification-card>\n								</div>\n\n						</md-content>\n					</md-tab-body>\n			</md-tab>\n			<!-- Reminders tab -->\n			<md-tab>\n					<md-tab-label>\n						<md-icon md-svg-src=\"/assets/images/icons/reminder.svg\" style=\"position: relative; top: 9px;\"></md-icon>\n					</md-tab-label>\n					<md-tab-body>\n						<md-content layout-fill layout=\"column\" class=\"reminder-panel\">\n							<!-- <p class=\"md-subhead center\">New Reminder</p> -->\n							<div flex=\"nogrow\" class=\"new-reminder-form\" layout=\"column\" layout-align=\"start layout-fill\" style=\" padding: 1em 1em 1em 1em; background-color: #efefef;\">\n								<p flex=\"nogrow\" class=\"md-subhead center\" style=\"font-size: 12px; color: #999; margin-bottom:1.5em; margin-top: 0;\"><span ng-if=\"!newReminder.uid\">NEW</span> <span ng-if=\"newReminder.uid\">MODIFY</span> REMINDER</p>\n								<md-input-container ng-if=\"!newReminder.uid\" class=\"margin-bottom-0 margin-top-10\">\n									<label>What do you need to remember?</label>\n									<textarea md-autofocus adminja-enter=\"saveNewReminder(newReminder)\" type=\"text\" class=\"reminder-message\" ng-model=\"newReminder.message\"></textarea>\n								</md-input-container>\n								<md-input-container ng-if=\"newReminder.uid\" class=\"margin-bottom-0 margin-top-10\">\n									<label>What do you need to remember?</label>\n									<textarea md-autofocus adminja-enter=\"updateReminder(newReminder)\" type=\"text\" class=\"reminder-message\" ng-model=\"newReminder.message\"></textarea>\n								</md-input-container>\n								<div flex=\'grow\' layout=\"row\" layout-align=\"center center\">\n									<md-menu flex=\"auto\" layout=\"row\" layout-align=\"center center\" ng-if=\"!newReminder.when\" class=\"reminders-menu\" md-position-mode=\"target-right target\">\n										<md-button ng-Click=\"$mdMenu.open($event);\">\n										     <span style=\"color: #999; font-size: 11px;\">Remind me: Never</span>\n										</md-button>\n										<md-menu-content class=\"md-dense small-scrollbar\" style=\"overflow-x: hidden; min-height: 450px; width: 340px;\">\n								                <md-menu-item ng-if=\"userType == \'admin\'\">\n								                    <md-button  style=\"text-align: center;\" ng-click=\"prepReminder(\'-1m\')\" md-no-ink=\"true\">\n								                        1 minute ago\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button  style=\"text-align: center;\" ng-click=\"prepReminder(\'5m\')\" md-no-ink=\"true\">\n								                        In 5 Minutes\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button  style=\"text-align: center;\" ng-click=\"prepReminder(\'10m\')\" md-no-ink=\"true\">\n								                        In 10 Minutes\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button  style=\"text-align: center;\" ng-click=\"prepReminder(\'15m\')\" md-no-ink=\"true\">\n								                        In 15 Minutes\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'30m\')\" md-no-ink=\"true\">\n								                        In 30 Minutes\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'1h\')\" md-no-ink=\"true\">\n								                        In 1 Hour\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'2h\')\" md-no-ink=\"true\">\n								                        In 2 Hours\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'4h\')\" md-no-ink=\"true\">\n								                        In 4 Hours\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'8h\')\" md-no-ink=\"true\">\n								                        In 8 Hours\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'1d\')\" md-no-ink=\"true\">\n								                        In 1 Day\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'2d\')\" md-no-ink=\"true\">\n								                        In 2 Days\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'3d\')\" md-no-ink=\"true\">\n								                        In 3 Days\n								                    </md-button>\n								                </md-menu-item>\n								                <md-menu-item>\n								                    <md-button style=\"text-align: center;\" ng-click=\"prepReminder(\'7d\')\" md-no-ink=\"true\">\n								                        In 1 Week\n								                    </md-button>\n								                </md-menu-item>\n											<!-- <md-menu-item>\n											    <p style=\"text-align: center; margin: 1em 0 0 0;\">\n											    	or\n											    </p>\n											</md-menu-item> -->\n								                <md-menu-item>\n								                    <p style=\"text-align: center; margin: 0 0 1em 0; color: #999;\">\n								                        <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon> Pick a Date <md-icon md-font-icon=\"zmdi zmdi-chevron-down\"></md-icon>\n								                    </p>\n								                </md-menu-item>\n								                <md-menu-item style=\"padding:0!important;\">\n								                    <md-calendar style=\"padding-left: 0!important; padding-right:0!important;\" md-min-date=\"minDate\" ng-change=\"prepReminder(newReminder.when)\" ng-model=\"newReminder.when\"></md-calendar>\n								                </md-menu-item>\n								    		</md-menu-content>\n							    		</md-menu>\n							    		<md-button ng-if=\"newReminder.when\" style=\"font-size: 11px; color: #999;\">\n							    			<md-icon ng-click=\"removeReminderWhen(newReminder)\" md-font-icon=\"zmdi zmdi-close-circle-o\" style=\"font-size: 13px; color:#999; cursor: pointer;\">\n							    				<md-tooltip md-delay=\"1000\">Remove notification</md-tooltip>\n							    			</md-icon>\n\n							    			<span ng-if=\"showLongWhen\">You\'ll be reminded  on {{newReminder.when |amDateFormat : userSettings.longDateFormat}} at <a ng-click=\"displayTimeDialog(newReminder)\"><md-tooltip md-delay=\"500\">Change time</md-tooltip>{{newReminder.when | amDateFormat: \'h:mm a\'}}</a></span>\n							    			<span ng-if=\"!showLongWhen\">You\'ll be reminded in </span><span  ng-if=\"!showLongWhen\" am-time-ago=\"newReminder.when\"></span>\n							    		</md-button>\n								</div>\n\n								<div layout=\"row\" layout-align=\"end center\">\n\n									<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\" ng-if=\"!newReminder.uid\">\n										<md-button ng-if=\"!isSaving\" layout-fill class=\"md-raised md-accent\" ng-click=\"saveNewReminder(newReminder)\" ng-disabled=\"!newReminder.message\">\n											Save\n										</md-button>\n										<md-button ng-if=\"isSaving\" layout-fill class=\"md-raised md-accent\"  ng-disabled=\"true\">\n											<md-icon md-font-icon=\"fa fa-circle-o-notch fa-spin\" style=\"min-width: 12px; width: 12px; font-size: 12px; color: #bbb; margin: 0 auto 0 auto;\"></md-icon> Saving\n										</md-button>\n									</div>\n									<div flex=\"nogrow\" layout=\"row\" layout-align=\"end center\" ng-if=\"newReminder.uid\">\n										<md-button layout-fill class=\"\" ng-click=\"cancelReminderEdit()\">\n											Cancel\n										</md-button>\n										<md-button layout-fill class=\"md-raised md-accent\" ng-click=\"updateReminder(newReminder)\" ng-disabled=\"!newReminder.message\">\n											Update\n										</md-button>\n									</div>\n								</div>\n								<!-- <div layout=\"row\" layout-align=\"end center\">\n									<div flex=\"grow\">\n										<md-button layout-fill class=\"md-raised md-accent\" ng-click=\"saveNewReminder(newReminder)\" ng-disabled=\"!newReminder.message\">\n											Save Reminder\n										</md-button>\n									</div>\n								</div> -->\n							</div>\n\n							<div flex=\"nogrow\"  layout=\"row\" layout-align=\"start center\" style=\"padding: 0 .5em 0 1em;\">\n								<p flex=\"auto\" class=\"md-subhead\" style=\"font-size: 12px; color: #999; margin-bottom: 2px;\">REMINDERS</p>\n								<md-button flex=\"nogrow\" class=\"md-subhead discard-reminder-button fade\" ng-click=\"clearComplete()\" style=\"font-size: 12px; color: #999; margin: 0 0 -10px 0;\">\n									<md-icon class=\"button-discard-reminder\" aria-label=\"Discard\" md-font-icon=\"zmdi zmdi-check-circle\" class=\"\" style=\"font-size: 13px; color: #bbb;\">\n							        </md-icon>\n							        Discard completed\n							        <md-tooltip md-delay=\"1000\">Clear All</md-tooltip>\n							   	</md-button>\n							</div>\n							<div class=\"reminders-list small-scrollbar\" flex=\"grow\" style=\"border-top: 1px solid #bbb;\" style=\"margin-top: -2px;\">\n								<reminder-card  ng-repeat=\"item in user.reminders | toArray |  orderBy: \'-when\' track by item.uid+$index\" item=\"item\"></reminder-card>\n							</div>\n\n						</md-content>\n					</md-tab-body>\n			</md-tab>\n			<md-tab>\n					<md-tab-label>\n							<md-icon class=\"md-primary\" md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n					</md-tab-label>\n					<md-tab-body>\n							<md-content layout-fill class=\"small-scrollbar\">\n								<div ng-if=\"!user.lastCaptureLogin && !user.profile.onboardingFlags.hideCapturePromoInSettings\" layout=\"column\" layout-align=\"start center\" style=\"margin-bottom: 1em; padding: 2em 1em 1em 1em; border-bottom: 1px solid #bbb; position: relative;\">\n									<md-button style=\"position: absolute; top: 1em; right: 1em; font-size: 10px;\" class=\"md-button-small\" ng-click=\"changeOnboardingFlag(\'hideCapturePromoInSettings\', true)\">\n										<!-- <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon> -->\n										dismiss\n										<md-tooltip md-delay=\"1000\">\n											Hide this tip forever\n										</md-tooltip>\n									</md-button>\n									<p class=\"center margin-bottom-0\">\n										Kickstart your workflow with Adminja\'s<br><strong>Capture</strong> Chrome Extension!\n									</p>\n									<p class=\"center margin-top-20\">\n										<a href=\"https://chrome.google.com/webstore/detail/capture-extension-for-adm/ggjpbogelaidbfgppfgkmppakgdnkbha\" target=\"_blank\"><img flex=\"nogrow\"  style=\"width: 150px;\" src=\"/assets/images/elements/chrome-webstore-icon-with-border.png\"></a><br>\n										<a href=\"https://www.getadminja.com/capture-extension\" target=\"_blank\" style=\"font-size: 10px;\">learn more</a>\n									</p>\n								</div>\n									<h3 class=\"text-center\">Settings</h3>\n\n									<p class=\"text-center\" style=\"padding: 2em 2em 2em 2em;\"><small>NOTE: Some settings may require a refresh for the change to take effect.</small></p>\n									<!-- <p class=\"md-subhead center\" style=\"font-size: 11px;\">Customize your Adminja experience by changing the units, defaults, and display settings below.</p> -->\n									<settings-panel ng-if=\"ready\"></settings-panel>\n							</md-content>\n					</md-tab-body>\n			</md-tab>\n		</md-tabs>\n</md-content>\n");
$templateCache.put("app/layouts/toolbar/adminja-tasks-toolbar.tmpl.html","<!-- // default toolbar -->\n<div class=\"md-toolbar-tools all-tasks-toolbar\" layout=\"row\" layout-align=\"start center\"  style=\"background-color: {{backgroundColor}};\">\n\n    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n    <div flex=\"auto\" layout=\"row\" layout-align=\"start start\" class=\"scrollable-toolbar-container\">\n        <div flex=\"none\">\n            <h3 ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" style=\"padding-right: .5em!important;\">\n                <span ng-repeat=\"crumb in breadcrumbs.crumbs\">\n                    <span >{{label}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n            </h3>\n        </div>\n        <!-- <md-button flex=\"nogrow\" ng-click=\"setAllTaskView(\'today\')\" ng-disabled=\"kanbanService.allTasksView == \'today\'\">Today</md-button> -->\n        <!-- <md-button flex=\"nogrow\" ng-click=\"setAllTaskView(\'all\')\" ng-disabled=\"kanbanService.allTasksView == \'all\'\">All</md-button> -->\n\n        <div flex></div>\n    </div><!-- // scrollable-toolbar-container -->\n    <sidebar-controls></sidebar-controls>\n</div>\n");
$templateCache.put("app/layouts/toolbar/adminja-toolbar.tmpl.html","<!-- // default toolbar -->\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"start center\">\n\n    <md-button flex=\"nogrow\" class=\"md-icon-button\" ng-if=\"!hideMenuButton()\" ng-click=\"openSideNav(\'left\')\" aria-label=\"Main Menu\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n    <div flex=\"auto\" layout=\"row\" layout-align=\"start start\" class=\"scrollable-toolbar-container\">\n        <div flex=\"none\">\n            <h3 ng-class-on-mobile class-to-add=\"mobile-toolbar-title\" class=\"toolbar-title\" style=\"padding-right: .5em!important;\">\n                <span ng-if=\"!overRideBreadcrumb\" ng-repeat=\"crumb in breadcrumbs.crumbs\">\n                    <span translate>{{crumb.name}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n                <span ng-if=\"overRideBreadcrumb\">\n                    <span translate>{{overRideBreadcrumb}}</span>\n                    <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n                </span>\n            </h3>\n        </div>\n        <div flex></div>\n    </div><!-- // scrollable-toolbar-container -->\n    <sidebar-controls></sidebar-controls>\n</div>\n");
$templateCache.put("app/layouts/toolbar/toolbar.tmpl.html","<div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" ng-if=\"!vm.hideMenuButton()\" ng-click=\"vm.openSideNav(\'left\')\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n\n    <h2 hide-xs flex>\n        <span ng-repeat=\"crumb in vm.breadcrumbs.crumbs\">\n            <span translate>{{crumb.name}}</span>\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n        </span>\n    </h2>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleFullScreen()\" aria-label=\"toggle fullscreen\">\n        <md-icon md-font-icon ng-class=\"vm.fullScreenIcon\"></md-icon>\n    </md-button>\n\n    <md-menu ng-show=\"vm.languages.length > 0\">\n        <md-button class=\"md-icon-button\" aria-label=\"language\" ng-click=\"$mdMenu.open()\" aria-label=\"change language\">\n            <md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon>\n        </md-button>\n        <md-menu-content  class=\"md-dense\" width=\"3\">\n            <md-menu-item ng-repeat=\"language in ::vm.languages\">\n                <md-button ng-click=\"vm.switchLanguage(language.key)\" translate=\"{{::language.name}}\" aria-label=\"{{::language.name}}\"></md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n\n    <md-button class=\"md-icon-button toolbar-button animated\" ng-click=\"vm.toggleNotificationsTab(0)\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n        <span class=\"toolbar-button-badge animated\" theme-background=\"accent\" ng-class=\"{ \'toolbar-button-badge-new\' : vm.emailNew }\">5</span>\n    </md-button>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleNotificationsTab(1)\">\n        <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n        <span class=\"toolbar-button-badge\" theme-background=\"accent\">2</span>\n    </md-button>\n\n    <md-menu>\n        <md-button aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"side navigation\">\n            <img class=\"toolbar-user-avatar\" ng-src=\"{{vm.currentUser.avatar}}\">\n            {{vm.currentUser.displayName}}\n        </md-button>\n        <md-menu-content width=\"4\">\n            <md-menu-item>\n                <md-button ng-click=\"vm.toggleNotificationsTab(2)\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n                    <span translate=\"Settings\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button href=\"/profile\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n                    <span translate=\"Profile\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n            <md-menu-item>\n                <md-button href=\"/login\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-sign-in\"></md-icon>\n                    <span translate=\"Logout\"></span>\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n");
$templateCache.put("app/permission/pages/permission-define.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Defining Roles & Permissions</h2>\n\n    <p>To get started we recommend looking at the example app and how the roles and permissions are defined there.</p>\n\n    <p>Take a look at the file <code>permission/permission.run.js</code> to see how the apps roles & permissions.</p>\n    <p>For example</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>permission/permission.run.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    // create roles for app\n    RoleStore\n    .defineRole(\'SUPERADMIN\', [\'viewEmail\', \'viewGitHub\', \'viewCalendar\', \'viewLayouts\', \'viewTodo\', \'viewElements\', \'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'ADMIN\', [\'viewLayouts\', \'viewTodo\', \'viewElements\', \'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'USER\', [\'viewAuthentication\', \'viewCharts\', \'viewMaps\'], checkRole);\n    RoleStore\n    .defineRole(\'ANONYMOUS\', [], checkRole);\n\n    // function that calls user service to check if permission is allowed\n    function checkRole(permission, transitionProperties) {\n        return UserService.hasPermission(permission, transitionProperties);\n    }\n        </div>\n    </div>\n\n    <p>In the first lines we define the roles SUPERADMIN, ADMIN, USER, and ANONYMOUS.  These roles each have their own permissions except for ANONYMOUS which doesn\'t have any permissions set.</p>\n\n    <p>We also tell angular permission to use a function called checkRole to verify that the current user has a permission.</p>\n\n    <p>This function calls the main UserService to check the users permissions.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission-routes.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Route Permissions</h2>\n\n    <h3 class=\"md-subheading\">Blocking Routes</h3>\n    <p>In order to block routes from being accessed when a usre doesn\'t have permission just add the following code to your <code>$stateProvider</code> declaration inside your config file.</p>\n\n    <p>For example</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-module.config.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    $stateProvider\n    .state(\'triangular.my-page\', {\n        url: \'/mypage\',\n        templateUrl: \'app/my-module/my-page.tmpl.html\',\n        data: {\n            permissions: {\n                only: [\'viewMyPage\']\n            }\n        }\n    });\n        </div>\n    </div>\n\n    <p>So now if any user that doesn\'t have the permission <code>viewMyPage</code> tries to access <code>/mypage</code> in the browser they will be redirected to the <a href=\"/401\">401 Page</a></p>\n\n    <h3 class=\"md-subheading\">Hiding menus</h3>\n    <p>As well as blocking the route you will also want to hide the menu item.  This is also easy, just add a permission to the menu item when you add it in your config file.</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-module.config.js</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"js\">\n    triMenuProvider.addMenu({\n        name: \'My Page\',\n        type: \'link\',\n        permission: \'viewMyPage\',\n    });\n        </div>\n    </div>\n\n    <p>Now unless the user has the <code>viewMyPage</code> permission they will not see the menu item in the left sidebar.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission-views.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">View Permissions</h2>\n\n    <h3 class=\"md-subheading\">Hiding view elements</h3>\n\n    <p>You can also use angular permission to hide elements on the page.</p>\n\n    <p>For example to a button on your app unless the user has a <code>canDelete</code> permission you would do the following.</p>\n\n    <div class=\"md-whiteframe-1dp\" layout=\"column\">\n        <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <h2>my-page.tmpl.html</h2>\n            </div>\n        </md-toolbar>\n        <div flex hljs language=\"html\">\n<md-button permission permission-only=\"\'canDelete\'\">Delete</md-button></div>\n    </div>\n\n    <p>So now if any user that doesn\'t have the permission <code>canDelete</code> they wont see this button.</p>\n</div>\n");
$templateCache.put("app/permission/pages/permission.tmpl.html","<div class=\"md-padding\">\n    <h2 class=\"md-display-1\">Permissions</h2>\n\n    <p>Many people have requested a way to restrict access to pages inside triangular.</p>\n\n    <p>So for that reason we have added an optional module that works with the <a href=\"https://github.com/Narzerus/angular-permission\">Angular Permission Module</a></p>\n\n    <p>To show how this works we have created some mock users, roles and permissions for triangular.</p>\n\n    <p>This will show you how they can be used to restrict user access to routes / pages and HTML elements in your app.</p>\n\n    <p>In the demo app we have 4 users with different roles assigned to each.  Each role has a set of permissions that we will use to show and hide menu items on the left as well as disable the routes to those pages.</p>\n\n    <div layout=\"row\" layout-xs=\"column\" layout-margin layout-align=\"space-between stretch\">\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Users</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item class=\"md-primary\" ng-repeat=\"user in vm.userList\" ng-click=\"vm.selectUser(user)\">\n                        <img ng-src=\"{{user.avatar}}\" class=\"md-avatar\" alt=\"{{user.displayName}}\" />\n                        <p>{{user.displayName}}</p>\n                        <md-icon md-font-icon=\"zmdi zmdi-circle\" ng-show=\"vm.selectedUser == user\"></md-icon>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Roles</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item ng-repeat=\"role in vm.roleList\">\n                        <p>{{role.roleName}}</p>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n        <div class=\"md-whiteframe-1dp\" flex layout=\"column\">\n            <md-toolbar>\n                <div class=\"md-toolbar-tools\">\n                    <span translate>Permissions</span>\n                </div>\n            </md-toolbar>\n            <md-content>\n                <md-list flex>\n                    <md-list-item ng-repeat=\"permission in vm.permissionList\">\n                        <p>{{permission}}</p>\n                    </md-list-item>\n                </md-list>\n            </md-content>\n        </div>\n    </div>\n\n    <md-button class=\"md-primary md-raised\" ng-click=\"vm.loginClick()\">Login as {{vm.selectedUser.displayName}}</md-button>\n\n    <p>Go ahead and log in as one of the users to see it\'s effect on the side menu items and routes</p>\n\n    <p>For more details on how to set this up read about permissions for routes and permissions for views.</p>\n</div>\n");
$templateCache.put("app/triangular/components/footer/footer.tmpl.html","<md-toolbar id=\"footer\" md-theme=\"{{triSkin.elements.toolbar}}\" ng-controller=\"FooterController as vm\" ng-show=\"vm.layout.footer\">\n    <div class=\"md-toolbar-tools md-body-1\" layout=\"row\" layout-align=\"space-between center\">\n        <h2>{{vm.name}}</h2>\n        <h2 hide-xs ng-bind-html=\"vm.copyright\"></h2>\n        <h2>v{{vm.version}}</h2>\n    </div>\n</md-toolbar>\n");
$templateCache.put("app/triangular/components/notifications-panel/notifications-panel.tmpl.html","<md-content flex layout class=\"admin-notifications\">\n    <md-tabs flex md-stretch-tabs=\"always\" md-selected=\"vm.currentTab\">\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list class=\"md-dense\">\n                        <md-list-item class=\"md-2-line\" ng-repeat=\"email in ::vm.emails\" ng-click=\"vm.openMail(email)\">\n                            <img class=\"md-avatar\" ng-src=\"{{::email.from.image}}\" alt=\"{{::email.from.name}}\">\n                            <div class=\"md-list-item-text\">\n                                <h3>{{::email.from.name}}</h3>\n                                <h4>{{::email.subject}}</h4>\n                                <p class=\"md-caption\" am-time-ago=\"::email.date\"></p>\n                            </div>\n                            <md-divider ng-hide=\"$last\"></md-divider>\n                        </md-list-item>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.notificationGroups\">\n                            <md-subheader class=\"md-primary\">{{::group.name}}</md-subheader>\n                            <md-list-item ng-repeat=\"notification in ::group.notifications\" layout=\"row\" layout-align=\"space-between center\">\n                                <md-icon md-font-icon=\"{{::notification.icon}}\" ng-style=\"{ color: notification.iconColor }\"></md-icon>\n                                <p>{{::notification.title}}</p>\n                                <span class=\"md-caption\" am-time-ago=\"::notification.date\"></span>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n        <md-tab>\n            <md-tab-label>\n                <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n            </md-tab-label>\n            <md-tab-body>\n                <md-content>\n                    <md-list>\n                        <div ng-repeat=\"group in ::vm.settingsGroups\">\n                            <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader>\n                            <md-list-item ng-repeat=\"setting in ::group.settings\" layout=\"row\" layout-align=\"space-around center\">\n                                <md-icon md-font-icon=\"{{::setting.icon}}\"></md-icon>\n                                <p translate>{{::setting.title}}</p>\n                                <md-switch class=\"md-secondary\" ng-model=\"setting.enabled\"></md-switch>\n                            </md-list-item>\n                        </div>\n                        <div ng-repeat=\"group in ::vm.statisticsGroups\">\n                            <md-subheader class=\"md-primary\"><span translate>{{::group.name}}</span></md-subheader>\n                            <md-list-item ng-repeat=\"stat in ::group.stats\" layout=\"column\" layout-align=\"space-around start\">\n                                <md-progress-linear class=\"margin-top-20 ng-class=\"::stat.mdClass\" md-mode=\"determinate\" ng-value=\"::stat.value\"></md-progress-linear>\n                                <p translate>{{::stat.title}}</p>\n                            </md-list-item>\n                        </div>\n                    </md-list>\n                </md-content>\n            </md-tab-body>\n        </md-tab>\n    </md-tabs>\n</md-content>\n");
$templateCache.put("app/triangular/components/menu/menu-item-client.tmpl.html","<md-button ng-if=\"::triMenuItem.item.status != \'archived\'\" md-no-ink ng-disabled=\"{{::triMenuItem.item.disabled}}\"  permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active , \'hide\': triMenuItem.item.hide}\" >\n    <img ng-if=\"::triMenuItem.item.icon != \'none\'\" style=\"border-color: {{::triMenuItem.item.color}}; background-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\" src=\"{{::triMenuItem.item.icon}}\">\n    <div ng-if=\"::triMenuItem.item.icon == \'none\'\" style=\"background-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\"></div>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    	<!-- <small ng-if=\"::triMenuItem.item.clientType == \'delegated\'\" class=\"side-menu-badge\" style=\"padding-top: 0; position: relative; left: 10px;\"><md-icon style=\"font-size: 12px; color: #FFF;\" md-font-icon=\"zmdi zmdi-accounts-outline-box\"></md-icon></small> -->\n    <small ng-if=\"triMenuItem.item.clientType == \'delegated\'\" class=\"side-menu-badge\"><md-icon md-font-icon=\"zmdi zmdi-share\"></md-icon></small>\n   <!-- <a class=\"clientlink\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon>Edit</a> -->\n\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-divider.tmpl.html","<md-divider style=\"border-top-color: rgba(255,255,255,0.1);\"></md-divider>\n");
$templateCache.put("app/triangular/components/menu/menu-item-dropdown.tmpl.html","<md-button ng-click=\"triMenuItem.toggleDropdownMenu()\" class=\"md-raised md-primary side-menu-link\" id=\"side-menu-link-{{::triMenuItem.item.idName}}\" md-no-ink=\"true\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined && triMenu.item.svgicon == undefined)\"  class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <md-icon style=\"position: relative;  top: -3px;\" ng-if=\"::(triMenuItem.item.svgicon !== undefined && triMenu.item.icon == undefined)\"  class=\"side-menu-icon\" md-svg-src=\"{{::triMenuItem.item.svgicon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <md-icon class=\"menu-toggle-icon\" md-font-icon=\"zmdi zmdi-chevron-right\" ng-class=\"{ open: triMenuItem.item.open }\"></md-icon>\n</md-button>\n<ul class=\"drop-down-list\" ng-show=\"triMenuItem.item.open\">\n    <li ng-repeat=\"child in triMenuItem.item.children\">\n        <tri-menu-item item=\"::child\"></tri-menu-item>\n    </li>\n</ul>\n");
$templateCache.put("app/triangular/components/menu/menu-item-guide-link.tmpl.html","<md-button md-no-ink permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"accent\" class=\"side-menu-badge\">{{triMenuItem.item.badge}}</small>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-help.tmpl.html","<md-button md-no-ink permission permission-only=\"triMenuItem.item.permission\"  class=\"md-primary md-raised side-menu-link menu-item-help\" id=\"side-menu-link-{{::triMenuItem.item.idName}}\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon style=\"color: {{::triMenuItem.item.color}};\" ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <md-icon style=\"position: relative; top: -3px; color: {{::triMenuItem.item.color}}; \" ng-if=\"::(triMenuItem.item.svgicon !== undefined)\"  class=\"side-menu-icon\" md-svg-src=\"{{::triMenuItem.item.svgicon}}\"></md-icon>\n    <span style=\"color: {{::triMenuItem.item.color}};\" translate>{{::triMenuItem.item.name}}</span>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-highlighted-dropdown.tmpl.html","<md-button palette-background=\"{{::triMenuItem.item.color}}\" ng-click=\"triMenuItem.toggleDropdownMenu()\" class=\"side-menu-link\">\n    <md-icon style=\"color: {{::triMenuItem.item.color}};\" ng-if=\"::(triMenuItem.item.icon !== undefined)\"  class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate style=\"color: {{::triMenuItem.item.color}};\">{{::triMenuItem.item.name}}</span>\n    <md-icon style=\"color: {{::triMenuItem.item.color}};\" class=\"menu-toggle-icon\" md-font-icon=\"zmdi zmdi-chevron-right\" ng-class=\"{ open: triMenuItem.item.open }\"></md-icon>\n</md-button>\n<ul class=\"drop-down-list\" ng-show=\"triMenuItem.item.open\">\n    <li ng-repeat=\"child in triMenuItem.item.children\">\n        <tri-menu-item item=\"::child\"></tri-menu-item>\n    </li>\n</ul>\n");
$templateCache.put("app/triangular/components/menu/menu-item-label.tmpl.html","<div class=\"menu-item-label\">\n	<md-icon style=\"color: {{::triMenuItem.item.color}};\" ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n	<strong><span translate>{{::triMenuItem.item.name}}</span></strong>\n</div>\n");
$templateCache.put("app/triangular/components/menu/menu-item-link-w-no-params.tmpl.html","<md-button permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <span translate>{{::triMenuItem.item.name}}</span>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"accent\" class=\"side-menu-badge\">{{::triMenuItem.item.badge}}</small>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-link.tmpl.html","<md-button md-no-ink permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" id=\"side-menu-link-{{::triMenuItem.item.idName}}\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\">\n    <md-icon style=\"color: {{::triMenuItem.item.color}};\" ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n    <md-icon style=\"position: relative; top: -3px; color: {{::triMenuItem.item.color}}; \" ng-if=\"::(triMenuItem.item.svgicon !== undefined)\"  class=\"side-menu-icon\" md-svg-src=\"{{::triMenuItem.item.svgicon}}\"></md-icon>\n    <span style=\"color: {{::triMenuItem.item.color}};\" translate>{{::triMenuItem.item.name}}</span>\n    <md-icon  ng-if=\"::(triMenuItem.item.badgeIcon !== undefined)\" class=\"side-menu-icon side-menu-badge-icon\" md-font-icon=\"{{::triMenuItem.item.badgeIcon}}\"></md-icon>\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"accent\" class=\"side-menu-badge\">{{triMenuItem.item.badge}}</small>\n</md-button>\n");
$templateCache.put("app/triangular/components/menu/menu-item-logout.tmpl.html","<md-button permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active }\" >\n    <md-icon ng-if=\"::(triMenuItem.item.icon !== undefined)\" class=\"side-menu-icon\" md-font-icon=\"{{::triMenuItem.item.icon}}\"></md-icon>\n\n    <span translate>{{::triMenuItem.item.name}}</span>\n</md-button>\n\n");
$templateCache.put("app/triangular/components/menu/menu-item-search.tmpl.html","<div ng-controller=\"menuSearchController\" class=\"menu-search\">\n	<input ng-model-options=\"{debounce: 200}\"ng-model=\"query\" placeholder=\"Filter Workspaces\" ng-change=\"search(query)\">\n	<md-icon class=\"menu-search-reset\" ng-click=\"resetSearch()\" md-font-icon=\"zmdi zmdi-close\"></md-icon>\n</div>\n");
$templateCache.put("app/triangular/components/menu/menu-item-timer.tmpl.html","<global-timer></global-timer>\n");
$templateCache.put("app/triangular/components/menu/menu-item-va.tmpl.html","<md-button ng-if=\"::triMenuItem.item.status != \'archived\'\" md-no-ink ng-disabled=\"{{::triMenuItem.item.disabled}}\"  permission permission-only=\"triMenuItem.item.permission\" ng-click=\"triMenuItem.openLink(triMenuItem.item)\" class=\"md-primary md-raised side-menu-link\" ng-class=\"{ \'md-hue-1\': triMenuItem.item.active , \'hide\': triMenuItem.item.hide}\" style=\"padding-left: 2em;\">\n    <img ng-if=\"::triMenuItem.item.icon != \'none\'\" style=\"border-color: {{::triMenuItem.item.color}}; background-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\" src=\"{{::triMenuItem.item.icon}}\">\n    <div ng-if=\"::triMenuItem.item.icon == \'none\'\" style=\"background-color: {{::triMenuItem.item.color}};\" class=\"client-menu-avatar\"></div>\n    <span translate>{{::triMenuItem.item.name}} </span>\n    	<!-- <small ng-if=\"::triMenuItem.item.clientType == \'delegated\'\" class=\"side-menu-badge\" style=\"padding-top: 0; position: relative; left: 10px;\"><md-icon style=\"font-size: 12px; color: #FFF;\" md-font-icon=\"zmdi zmdi-account-box\"></md-icon></small> -->\n    <small ng-if=\"triMenuItem.item.badge\" theme-background=\"warn\" class=\"side-menu-badge\">{{::triMenuItem.item.badge}}</small>\n   <!-- <a class=\"clientlink\"><md-icon md-font-icon=\"fa fa-edit\"></md-icon>Edit</a> -->\n\n</md-button>\n");
$templateCache.put("app/triangular/components/table/table-directive.tmpl.html","<table class=\"md-table\">\n    <thead>\n        <tr>\n            <th ng-repeat=\"column in columns\" ng-click=\"sortClick(column.field)\" ng-class=\"headerClass(column.field)\">\n                <md-icon ng-show=\"showSortOrder(column.field, true)\" class=\"zmdi-hc-rotate-90\" md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n                <md-icon ng-show=\"showSortOrder(column.field, false)\" class=\"zmdi-hc-rotate-270\" md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon>\n                <span>\n                    {{column.title | triTranslate}}\n                </span>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"content in contents | filter:filters | startFrom:page * pageSize | limitTo: pageSize\">\n            <td ng-repeat=\"column in columns\" ng-bind-html=\"cellContents(column, content)\" ng-class=\"column.field + \'-cell\'\"></td>\n        </tr>\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan=\"{{columns.length}}\">\n                <div class=\"md-table-footer\" layout=\"row\" layout-align=\"end center\">\n                    <div class=\"md-table-page-select\" layout=\"row\" layout-align=\"center center\">\n                        <span translate>Rows per page:</span>\n                        <md-select ng-model=\"pageSize\" ng-change=\"refresh(true)\">\n                            <md-option value=\"5\">5</md-option>\n                            <md-option value=\"10\">10</md-option>\n                            <md-option value=\"25\">25</md-option>\n                            <md-option value=\"50\">50</md-option>\n                            <md-option value=\"100\">100</md-option>\n                        </md-select>\n                    </div>\n                    <span class=\"md-table-info\">\n                        {{pageStart()}}\n                        -\n                        {{pageEnd()}}\n                        <span translate>of</span>\n                        {{totalItems()}}\n                    </span>\n                    <div class=\"md-table-page-nav\">\n                        <md-button ng-disabled=\"page == 0\" ng-click=\"page = page - 1\" aria-label=\"{{\'Previous Page\' | triTranslate}}\" class=\"md-primary md-icon-button\">\n                            <md-icon md-font-icon=\"zmdi zmdi-chevron-left\"></md-icon>\n                        </md-button>\n                        <md-button ng-disabled=\"page == numberOfPages() - 1\" ng-click=\"page = page + 1\" aria-label=\"{{\'Next Page\' | triTranslate}}\" class=\"md-primary md-icon-button\">\n                            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n                        </md-button>\n                    </div>\n                </div>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n");
$templateCache.put("app/triangular/components/widget/widget.tmpl.html","<div class=\"widget md-whiteframe-z2\" ng-class=\"::{\'widget-overlay-title\': vm.overlayTitle}\" flex layout=\"{{vm.widgetLayout}}\">\n\n    <div class=\"widget-title\" ng-if=\"::(vm.title || vm.subtitle)\" layout=\"row\" layout-padding layout-align=\"start center\" flex-order=\"{{vm.titleOrder}}\">\n        <div ng-if=\"::vm.avatar\">\n            <img ng-src=\"{{::vm.avatar}}\" class=\"widget-avatar\"/>\n        </div>\n        <div flex layout=\"column\">\n            <h3 class=\"md-subhead\" ng-if=\"::vm.title\" translate>{{::vm.title}}</h3>\n            <p class=\"md-body-1\" ng-if=\"::vm.subtitle\" translate>{{::vm.subtitle}}</p>\n        </div>\n        <md-menu ng-if=\"::vm.menu\">\n            <md-button class=\"widget-button md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"open menu\">\n                <md-icon md-font-icon=\"{{::vm.menu.icon}}\"></md-icon>\n            </md-button>\n            <md-menu-content  class=\"md-dense\">\n                <md-menu-item ng-repeat=\"item in ::vm.menu.items\">\n                    <md-button ng-click=\"item.click($event)\">\n                        <md-icon ng-if=\"::item.icon\" md-font-icon=\"{{::item.icon}}\"></md-icon>\n                        <span translate>{{::item.title}}</span>\n                    </md-button>\n                </md-menu-item>\n            </md-menu-content>\n        </md-menu>\n    </div>\n\n    <div class=\"widget-content\" layout=\"{{vm.contentLayout}}\" layout-align=\"{{vm.contentLayoutAlign}}\" ng-class=\"{\'layout-padding\': vm.contentPadding}\" ng-transclude flex-order=\"{{vm.contentOrder}}\"></div>\n\n    <div class=\"widget-loading ng-hide\" ng-show=\"vm.loading\" layout layout-fill layout-align=\"center center\">\n        <div class=\"widget-loading-inner\" ng-show=\"vm.loading\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/triangular/components/toolbars/toolbar.tmpl.html","<div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" ng-if=\"!vm.hideMenuButton()\" ng-click=\"vm.openSideNav(\'left\')\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n    </md-button>\n\n    <h2 hide-xs flex>\n        <span ng-repeat=\"crumb in vm.breadcrumbs.crumbs\">\n            <span translate>{{crumb.name}}</span>\n            <md-icon md-font-icon=\"zmdi zmdi-chevron-right\" ng-if=\"!$last\"></md-icon>\n        </span>\n    </h2>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleFullScreen()\" aria-label=\"toggle fullscreen\">\n        <md-icon md-font-icon ng-class=\"vm.fullScreenIcon\"></md-icon>\n    </md-button>\n\n    <md-menu ng-show=\"vm.languages.length > 0\">\n        <md-button class=\"md-icon-button\" aria-label=\"language\" ng-click=\"$mdMenu.open()\" aria-label=\"change language\">\n            <md-icon md-font-icon=\"zmdi zmdi-globe-alt\"></md-icon>\n        </md-button>\n        <md-menu-content  class=\"md-dense\" width=\"3\">\n            <md-menu-item ng-repeat=\"language in ::vm.languages\">\n                <md-button ng-click=\"vm.switchLanguage(language.key)\" translate=\"{{::language.name}}\" aria-label=\"{{::language.name}}\"></md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n\n    <md-button class=\"md-icon-button toolbar-button animated\" ng-click=\"vm.toggleNotificationsTab(0)\" aria-label=\"side navigation\">\n        <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n        <span class=\"toolbar-button-badge animated\" theme-background=\"accent\" ng-class=\"{ \'toolbar-button-badge-new\' : vm.emailNew }\">5</span>\n    </md-button>\n\n    <md-button class=\"md-icon-button toolbar-button\" ng-click=\"vm.toggleNotificationsTab(1)\">\n        <md-icon md-font-icon=\"fa fa-bell-o\"></md-icon>\n        <span class=\"toolbar-button-badge\" theme-background=\"accent\">2</span>\n    </md-button>\n\n    <md-menu>\n        <md-button aria-label=\"Open user menu\" ng-click=\"$mdMenu.open()\" aria-label=\"side navigation\">\n            <img class=\"toolbar-user-avatar\" src=\"assets/images/avatars/avatar-5.png\">\n            Christos\n        </md-button>\n        <md-menu-content  class=\"md-dense\" width=\"4\">\n            <md-menu-item>\n                <md-button ng-click=\"vm.toggleNotificationsTab(2)\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-settings\"></md-icon>\n                    <span translate=\"Settings\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-item>\n                <md-button href=\"/profile\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n                    <span translate=\"Profile\"></span>\n                </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n            <md-menu-item>\n                <md-button href=\"/login\" aria-label=\"side navigation\">\n                    <md-icon md-font-icon=\"zmdi zmdi-sign-in\"></md-icon>\n                    <span translate=\"Logout\"></span>\n                </md-button>\n            </md-menu-item>\n        </md-menu-content>\n    </md-menu>\n</div>\n");
$templateCache.put("app/triangular/layouts/default/default-content.tmpl.html","<div id=\"admin-panel-content-view\" class=\"{{layout.innerContentClass}}\" flex ui-view></div>\n");
$templateCache.put("app/triangular/layouts/default/default-no-scroll.tmpl.html","<div layout=\"row\" class=\"full-height\">\n    <!-- left sidebar -->\n\n    <md-sidenav class=\"admin-sidebar-left md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"layoutController.activateHover()\" ng-mouseleave=\"layoutController.removeHover()\"></md-sidenav>\n\n    <!-- main content -->\n    <div id=\"admin-panel\" layout=\"column\" flex>\n        <!-- loading animation -->\n        <tri-loader></tri-loader>\n\n        <!-- top toolbar -->\n        <md-toolbar class=\"admin-toolbar\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\"></md-toolbar>\n\n        <!-- scrollable content -->\n        <div ui-view=\"content\" layout=\"column\" flex class=\"overflow-hidden\"></div>\n\n        <div ui-view=\"belowContent\"></div>\n    </div>\n\n    <!-- right sidebar -->\n    <md-sidenav layout layout-fill class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"notifications\" ui-view=\"sidebarRight\"></md-sidenav>\n\n</div>\n");
$templateCache.put("app/triangular/layouts/default/default.tmpl.html","<div layout=\"row\" class=\"full-height\">\n    <!-- left sidebar -->\n\n    <md-sidenav class=\"admin-sidebar-left md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"layoutController.activateHover()\" ng-mouseleave=\"layoutController.removeHover()\"></md-sidenav>\n\n    <!-- main content -->\n    <div id=\"admin-panel\" layout=\"column\" flex>\n        <!-- loading animation -->\n        <tri-loader></tri-loader>\n\n        <!-- top toolbar -->\n        <md-toolbar class=\"admin-toolbar\" ng-if=\"layout.showToolbar\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\"></md-toolbar>\n\n        <!-- scrollable content -->\n        <md-content ng-class=\"layout.contentClass\" flex tri-default-content ui-view=\"content\"></md-content>\n\n        <div ui-view=\"belowContent\"></div>\n    </div>\n\n    <!-- right sidebar -->\n    <md-sidenav layout layout-fill class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"notifications\" ui-view=\"sidebarRight\"></md-sidenav>\n</div>\n");
$templateCache.put("app/triangular/layouts/states/triangular/triangular.tmpl.html","<!-- left sidebar -->\n<md-sidenav md-theme=\"{{::triSkin.elements.logo}}\"  class=\"triangular-sidenav-left md-sidenav-left md-whiteframe-z2 no-scrollbar\" ng-if=\"layout.sideMenuSize !== \'off\'\" md-component-id=\"left\" md-is-locked-open=\"layout.sideMenuSize !== \'hidden\' && $mdMedia(\'gt-sm\')\" ui-view=\"sidebarLeft\" ng-class=\"{ \'admin-sidebar-collapsed\': layout.sideMenuSize == \'icon\' }\" ng-mouseover=\"stateController.activateHover()\" ng-mouseleave=\"stateController.removeHover()\" style=\"overflow: hidden;\"></md-sidenav>\n\n<!-- main content -->\n<div class=\"triangular-toolbar-and-content\" layout=\"column\" flex style=\"overflow-y: hidden;\">\n    <!-- loading animation -->\n    <!-- <tri-loader></tri-loader> -->\n\n    <!-- top toolbar -->\n    <md-toolbar class=\"triangular-toolbar md-whiteframe-z1\" ng-if=\"layout.showToolbar\" ng-class=\"[layout.toolbarSize,layout.toolbarClass]\" md-theme=\"{{triSkin.elements.toolbar}}\" ui-view=\"toolbar\"></md-toolbar>\n\n    <!-- scrollable content -->\n    <md-content class=\"triangular-content\" ng-class=\"layout.contentClass\" flex ui-view></md-content>\n\n    <div ui-view=\"belowContent\"></div>\n\n    <div class=\"triangular-loader\" ng-show=\"stateController.showLoader\" layout=\"column\" ui-view=\"loader\"></div>\n</div>\n\n<!-- right sidebar -->\n<md-sidenav layout layout-fill class=\"triangular-sidenav-right md-sidenav-right md-whiteframe-z2\" md-component-id=\"right\" ui-view=\"sidebarRight\"></md-sidenav>\n<fab-button ng-if=\"showNinjaMenu\"></fab-button>\n");}]);